/**
 * Code generated by qudtlib-java:qudtlib-js-gen.
 */
import { Decimal } from "decimal.js";
import {
  config,
  Unit,
  QuantityKind,
  Prefix,
  LangString,
  FactorUnits,
  FactorUnit,
  SystemOfUnits,
  Qudt,
} from "@qudtlib/core";

export * from "@qudtlib/core";
// Units
{
  let unit: Unit;
  unit = new Unit(
    "http://qudt.org/vocab/unit/100KiloCount",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    true
  );
  unit.addLabel(new LangString("100KiloCount", undefined));
  config.units.set("http://qudt.org/vocab/unit/100KiloCount", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/10KiloCount",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    true
  );
  unit.addLabel(new LangString("10KiloCount", undefined));
  config.units.set("http://qudt.org/vocab/unit/10KiloCount", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/2PiRAD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    [],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("2pirad", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PlaneAngle");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Angle");
  config.units.set("http://qudt.org/vocab/unit/2PiRAD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "A",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    159,
    false,
    false
  );
  unit.addLabel(new LangString("Ampere", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/CurrentLinkage");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagnetomotiveForce"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MagneticTension");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCurrent");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/TotalCurrent");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DisplacementCurrent"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentPhasor"
  );
  config.units.set("http://qudt.org/vocab/unit/A", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("3600.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "A·h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ampere Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/BatteryCapacity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  config.units.set("http://qudt.org/vocab/unit/A-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A-HR-PER-DEG_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H-1T1D0",
    new Decimal("3600.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "A·h/°C",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ampere Hour per Degree Celsius", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/A-HR-PER-DEG_C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A-HR-PER-DeciM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-3I0M0H0T1D0",
    new Decimal("3600000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "A·h/dm³",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ampere Hour per Cubic Decimeter", "en-US"));
  unit.addLabel(new LangString("Ampere Hour per Cubic Decimetre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargeDensity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargeVolumeDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/A-HR-PER-DeciM3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A-HR-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M-1H0T1D0",
    new Decimal("3600.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "A·h/kg",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ampere Hour per Kilogram", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerMass"
  );
  config.units.set("http://qudt.org/vocab/unit/A-HR-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A-HR-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H0T1D0",
    new Decimal("3600.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "A·h/m²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ampere Hour per Square Meter", "en-US"));
  unit.addLabel(new LangString("Ampere Hour per Square Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerArea"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPolarization"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargeSurfaceDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/A-HR-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A-HR-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-3I0M0H0T1D0",
    new Decimal("3600.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "A·h/m³",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ampere Hour per Cubic Metre", "en"));
  unit.addLabel(new LangString("Ampere Hour per Cubic Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargeDensity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargeVolumeDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/A-HR-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L2I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "A·m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ampere Square Metre", "en"));
  unit.addLabel(new LangString("Ampere Square Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MagneticMoment");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticAreaMoment"
  );
  config.units.set("http://qudt.org/vocab/unit/A-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A-M2-PER-J-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M-1H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "A·m²/(J·s)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Ampere Square Meter per Joule Second", "en-US")
  );
  unit.addLabel(new LangString("Ampere Square Metre per Joule Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerMass"
  );
  config.units.set("http://qudt.org/vocab/unit/A-M2-PER-J-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("60.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "A·min",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ampere Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/BatteryCapacity");
  config.units.set("http://qudt.org/vocab/unit/A-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A-PER-A-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("0.0002777777777777777777777777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "A/(A·h)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ampere per Ampere Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/A-PER-A-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A-PER-CentiM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-1I0M0H0T0D0",
    new Decimal("100.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "A/cm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ampere per Centimeter", "en-US"));
  unit.addLabel(new LangString("Ampere per Centimetre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearElectricCurrentDensity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticFieldStrength"
  );
  config.units.set("http://qudt.org/vocab/unit/A-PER-CentiM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A-PER-CentiM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H0T0D0",
    new Decimal("10000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "A/cm²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ampere per Square Centimeter", "en-US"));
  unit.addLabel(new LangString("Ampere per Square Centimetre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/A-PER-CentiM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A-PER-DEG_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H-1T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "A/°C",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI", "http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ampere per Degree Celsius", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentPerTemperature"
  );
  config.units.set("http://qudt.org/vocab/unit/A-PER-DEG_C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A-PER-GM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M-1H0T0D0",
    new Decimal("1000.0"),
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    "A/g",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ampere per Gram", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificElectricCurrent"
  );
  config.units.set("http://qudt.org/vocab/unit/A-PER-GM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A-PER-J",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M-1H0T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "A/J",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ampere per Joule", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentPerEnergy"
  );
  config.units.set("http://qudt.org/vocab/unit/A-PER-J", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H-1T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "A/K",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ampere per Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentPerTemperature"
  );
  config.units.set("http://qudt.org/vocab/unit/A-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M-1H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "A/kg",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ampere per Kilogram", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassicElectricCurrent"
  );
  config.units.set("http://qudt.org/vocab/unit/A-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-1I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "A/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Ampere per Metre", "en"));
  unit.addLabel(new LangString("Ampere per Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearElectricCurrentDensity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Coercivity");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticFieldStrength"
  );
  config.units.set("http://qudt.org/vocab/unit/A-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "A/m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Ampere per Square Meter", "en-US"));
  unit.addLabel(new LangString("Ampere per Square Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TotalCurrentDensity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentDensity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DisplacementCurrentDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/A-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A-PER-M2-K2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H-2T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "A/(m²·K²)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Ampere per Square Meter Square Kelvin", "en-US")
  );
  unit.addLabel(new LangString("Ampere per Square Metre Square Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/RichardsonConstant"
  );
  config.units.set("http://qudt.org/vocab/unit/A-PER-M2-K2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A-PER-MilliM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-1I0M0H0T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "A/mm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ampere per Millimeter", "en-US"));
  unit.addLabel(new LangString("Ampere per Millimetre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearElectricCurrentDensity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticFieldStrength"
  );
  config.units.set("http://qudt.org/vocab/unit/A-PER-MilliM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A-PER-MilliM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H0T0D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "A/mm²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ampere per Square Millimeter", "en-US"));
  unit.addLabel(new LangString("Ampere per Square Millimetre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/A-PER-MilliM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A-PER-PA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L1I0M-1H0T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "A/Pa",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ampere per Pascal", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/A-PER-PA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A-PER-RAD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "A/rad",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ampere per Radian", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentPerAngle"
  );
  config.units.set("http://qudt.org/vocab/unit/A-PER-RAD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "A·s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    4,
    false,
    false
  );
  unit.addLabel(new LangString("Ampere Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/BatteryCapacity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  config.units.set("http://qudt.org/vocab/unit/A-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A-SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "A·s²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ampere Square Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/A-SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A2-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L0I0M0H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "A²·s",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Ampere Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/A2-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/AC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    new Decimal("4046.8564224"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M2",
    undefined,
    "acre",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    3,
    false,
    false
  );
  unit.addLabel(new LangString("Acre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Area");
  config.units.set("http://qudt.org/vocab/unit/AC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/AC-FT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("1233.48183754752"),
    undefined,
    undefined,
    undefined,
    undefined,
    "acre·ft",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Acre Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/AC-FT_US");
  config.units.set("http://qudt.org/vocab/unit/AC-FT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/AC-FT_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("1233.48426566137344"),
    undefined,
    undefined,
    undefined,
    undefined,
    "acre·ft{US Survey}",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Acre Us Survey Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/AC-FT");
  config.units.set("http://qudt.org/vocab/unit/AC-FT_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/AMU",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("1.66053878283E-27"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "amu",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Atomic Mass Unit", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/DA");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/U");
  config.units.set("http://qudt.org/vocab/unit/AMU", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ANGSTROM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("1E-10"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M",
    undefined,
    "Å",
    undefined,
    undefined,
    undefined,
    [],
    3,
    false,
    false
  );
  unit.addLabel(new LangString("Angstrom", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/ANGSTROM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ANGSTROM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("1E-30"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Å³",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-GAUSS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Angstrom", "en-US"));
  unit.addLabel(new LangString("Cubic Angstrom", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/ANGSTROM3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ARCMIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.000290888209"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/RAD",
    undefined,
    "'",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Arcminute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PlaneAngle");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Angle");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/MIN_Angle");
  config.units.set("http://qudt.org/vocab/unit/ARCMIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ARCSEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.00000484813681"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/RAD",
    undefined,
    '"',
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Arcsecond", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PlaneAngle");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Angle");
  config.units.set("http://qudt.org/vocab/unit/ARCSEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ARE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    new Decimal("100.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M2",
    undefined,
    "a",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Are", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Area");
  config.units.set("http://qudt.org/vocab/unit/ARE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/AT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/A",
    undefined,
    "AT",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    2,
    false,
    false
  );
  unit.addLabel(new LangString("Ampere Turn", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagnetomotiveForce"
  );
  config.units.set("http://qudt.org/vocab/unit/AT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/AT-PER-IN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-1I0M0H0T0D0",
    new Decimal("39.37007874015748031496062992125984"),
    undefined,
    undefined,
    undefined,
    undefined,
    "AT/in",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ampere Turn per Inch", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticFieldStrength"
  );
  config.units.set("http://qudt.org/vocab/unit/AT-PER-IN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/AT-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-1I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "AT/m",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ampere Turn per Meter", "en-US"));
  unit.addLabel(new LangString("Ampere Turn per Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticFieldStrength"
  );
  config.units.set("http://qudt.org/vocab/unit/AT-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ATM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("101325.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/PA",
    undefined,
    "atm",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    3,
    false,
    false
  );
  unit.addLabel(new LangString("Standard Atmosphere", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/ATM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ATM-M3-PER-MOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A-1E0L2I0M1H0T-2D0",
    new Decimal("101325.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "atm·m³/mol",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Standard Atmosphere Cubic Meter per Mole", "en-US")
  );
  unit.addLabel(
    new LangString("Standard Atmosphere Cubic Metre per Mole", "en")
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/HenrysLawVolatilityConstant"
  );
  config.units.set("http://qudt.org/vocab/unit/ATM-M3-PER-MOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ATM-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-2D0",
    new Decimal("101325.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "atm/m",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Standard Atmosphere per Metre", "en"));
  unit.addLabel(new LangString("Standard Atmosphere per Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PressureGradient"
  );
  config.units.set("http://qudt.org/vocab/unit/ATM-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ATM_T",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("98066.5"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/PA",
    undefined,
    "at",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Technical Atmosphere", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/ATM_T", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ATM_T-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-2D0",
    new Decimal("98066.5"),
    undefined,
    undefined,
    undefined,
    undefined,
    "at/m",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Technical Atmosphere per Metre", "en"));
  unit.addLabel(new LangString("Technical Atmosphere per Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PressureGradient"
  );
  config.units.set("http://qudt.org/vocab/unit/ATM_T-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/AU",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("149597870691.6"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M",
    undefined,
    "AU",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Astronomical-unit", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/AU", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/AWG",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "AWG",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("American Wire Gage", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/AWG", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A_Ab",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T0D0",
    new Decimal("10.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/A",
    undefined,
    "abA",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-EMU", "http://qudt.org/vocab/sou/CGS"],
    2,
    false,
    false
  );
  unit.addLabel(new LangString("Abampere", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCurrent");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/BIOT");
  config.units.set("http://qudt.org/vocab/unit/A_Ab", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A_Ab-CentiM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L2I0M0H0T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "abA·cm²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-EMU", "http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Abampere Square Centimeter", "en-US"));
  unit.addLabel(new LangString("Abampere Square Centimetre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MagneticMoment");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticAreaMoment"
  );
  config.units.set("http://qudt.org/vocab/unit/A_Ab-CentiM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A_Ab-PER-CentiM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H0T0D0",
    new Decimal("100000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "abA/cm²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-EMU", "http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Abampere per Square Centimeter", "en-US"));
  unit.addLabel(new LangString("Abampere per Square Centimetre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/A_Ab-PER-CentiM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A_Reactive",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    [],
    16,
    false,
    true
  );
  unit.addLabel(new LangString("A_Reactive", undefined));
  config.units.set("http://qudt.org/vocab/unit/A_Reactive", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A_Stat",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T0D0",
    new Decimal("3.335641E-10"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/A",
    undefined,
    "statA",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS", "http://qudt.org/vocab/sou/CGS-ESU"],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Statampere", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCurrent");
  config.units.set("http://qudt.org/vocab/unit/A_Stat", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A_Stat-PER-CentiM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H0T0D0",
    new Decimal("0.000003335641"),
    undefined,
    undefined,
    undefined,
    undefined,
    "statA/cm²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS", "http://qudt.org/vocab/sou/CGS-ESU"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Statampere per Square Centimetre", "en"));
  unit.addLabel(new LangString("Statampere per Square Centimeter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/A_Stat-PER-CentiM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/AttoA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T0D0",
    new Decimal("1E-18"),
    undefined,
    "http://qudt.org/vocab/prefix/Atto",
    "http://qudt.org/vocab/unit/A",
    undefined,
    "aA",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Attoampere", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/CurrentLinkage");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagnetomotiveForce"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MagneticTension");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCurrent");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/TotalCurrent");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DisplacementCurrent"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentPhasor"
  );
  config.units.set("http://qudt.org/vocab/unit/AttoA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/AttoC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("1E-18"),
    undefined,
    "http://qudt.org/vocab/prefix/Atto",
    "http://qudt.org/vocab/unit/C",
    undefined,
    "aC",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Attocoulomb", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  config.units.set("http://qudt.org/vocab/unit/AttoC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/AttoFARAD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-2I0M-1H0T4D0",
    new Decimal("1E-18"),
    undefined,
    "http://qudt.org/vocab/prefix/Atto",
    "http://qudt.org/vocab/unit/FARAD",
    undefined,
    "aF",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Attofarad", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Capacitance");
  config.units.set("http://qudt.org/vocab/unit/AttoFARAD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/AttoJ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1E-18"),
    undefined,
    "http://qudt.org/vocab/prefix/Atto",
    "http://qudt.org/vocab/unit/J",
    undefined,
    "aJ",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Attojoule", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/AttoJ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/AttoJ-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-1D0",
    new Decimal("1E-18"),
    undefined,
    undefined,
    undefined,
    undefined,
    "aJ·s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Attojoule Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Action");
  config.units.set("http://qudt.org/vocab/unit/AttoJ-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/AttoSEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("1E-18"),
    undefined,
    "http://qudt.org/vocab/prefix/Atto",
    "http://qudt.org/vocab/unit/SEC",
    undefined,
    "as",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Attosecond", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/AttoSEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/B",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "B",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Bel", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoundExposureLevel"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoundReductionIndex"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoundPressureLevel"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SoundPowerLevel");
  config.units.set("http://qudt.org/vocab/unit/B", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/B-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "B/m",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Bel per Metre", "en"));
  unit.addLabel(new LangString("Bel per Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearLogarithmicRatio"
  );
  config.units.set("http://qudt.org/vocab/unit/B-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BAN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("2.30258509"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/NUM",
    undefined,
    "ban",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ban", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InformationEntropy"
  );
  config.units.set("http://qudt.org/vocab/unit/BAN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("100000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/PA",
    undefined,
    "bar",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    103,
    false,
    false
  );
  unit.addLabel(new LangString("Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BAR-L-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("100.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "bar·L/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Bar Litre per Second", "en"));
  unit.addLabel(new LangString("Bar Liter per Second", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/BAR-L-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BAR-M3-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("100000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "bar·m³/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Bar Cubic Meter per Second", "en-US"));
  unit.addLabel(new LangString("Bar Cubic Metre per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/BAR-M3-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BAR-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "bar/bar",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Bar per Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PressureRatio");
  config.units.set("http://qudt.org/vocab/unit/BAR-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BAR-PER-DEG_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H-1T-2D0",
    new Decimal("100000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "bar/°C",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Bar per Degree Celsius", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PressureCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/BAR-PER-DEG_C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BAR-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H-1T-2D0",
    new Decimal("100000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "bar/K",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Bar per Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PressureCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/BAR-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BARAD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("0.1"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Ba",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Barad", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/BARYE");
  config.units.set("http://qudt.org/vocab/unit/BARAD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BARN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    new Decimal("1E-28"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M2",
    undefined,
    "b",
    undefined,
    undefined,
    undefined,
    [],
    3,
    false,
    false
  );
  unit.addLabel(new LangString("Barn", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Area");
  config.units.set("http://qudt.org/vocab/unit/BARN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BARN-PER-EV",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T2D0",
    new Decimal("6.241509074460762607776240980930446E-10"),
    undefined,
    undefined,
    undefined,
    undefined,
    "b/eV",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Barn per Electron Volt", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/BARN-PER-EV", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BARN-PER-SR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    new Decimal("1E-28"),
    undefined,
    undefined,
    undefined,
    undefined,
    "b/sr",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Barn per Steradian", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/BARN-PER-SR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BARN-PER-SR-EV",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T2D0",
    new Decimal("6.241509074460762607776240980930446E-10"),
    undefined,
    undefined,
    undefined,
    undefined,
    "b/(sr·eV)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Barn per Steradian Electron Volt", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/BARN-PER-SR-EV", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BARYE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("0.1"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Ba",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Barye", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/BARAD");
  config.units.set("http://qudt.org/vocab/unit/BARYE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BAR_A",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("100000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/PA",
    undefined,
    "bar abs",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Bar Absolute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/BAR_A", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BAUD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Bd",
    undefined,
    undefined,
    undefined,
    [],
    2,
    false,
    false
  );
  unit.addLabel(new LangString("Baud", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DigitRate");
  config.units.set("http://qudt.org/vocab/unit/BAUD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BBL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.1589873"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M3",
    undefined,
    "bbl",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Barrel", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/BBL_US");
  config.units.set("http://qudt.org/vocab/unit/BBL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BBL_UK_PET",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.1591132"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M3",
    undefined,
    "bbl{UK petroleum}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"],
    4,
    false,
    false
  );
  unit.addLabel(new LangString("Barrel (UK Petroleum)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/BBL_UK_PET", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BBL_UK_PET-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.000001841587962962962962962962962962962"),
    undefined,
    undefined,
    undefined,
    undefined,
    "bbl{UK petroleum}/d",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Barrel (UK Petroleum) per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/BBL_UK_PET-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BBL_UK_PET-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.00004419811111111111111111111111111111"),
    undefined,
    undefined,
    undefined,
    undefined,
    "bbl{UK petroleum}/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Barrel (UK Petroleum) per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/BBL_UK_PET-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BBL_UK_PET-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.002651886666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "bbl{UK petroleum}/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Barrel (UK Petroleum) per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/BBL_UK_PET-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BBL_UK_PET-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.1591132"),
    undefined,
    undefined,
    undefined,
    undefined,
    "bbl{UK petroleum}/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Barrel (UK Petroleum) per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/BBL_UK_PET-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BBL_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.1589873"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M3",
    undefined,
    "bbl{US petroleum}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    2,
    false,
    false
  );
  unit.addLabel(new LangString("Barrel (US)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LiquidVolume");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/BBL");
  config.units.set("http://qudt.org/vocab/unit/BBL_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BBL_US-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.000001840130787037037037037037037037036"),
    undefined,
    undefined,
    undefined,
    undefined,
    "bbl{US petroleum}/d",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Barrel (US) per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/BBL_US-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BBL_US-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.002649788333333333333333333333333334"),
    undefined,
    undefined,
    undefined,
    undefined,
    "bbl{US petroleum}/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Barrel (US) per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/BBL_US-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BBL_US_DRY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.1156281989625"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M3",
    undefined,
    "bbl{US dry}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Dry Barrel (US)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DryVolume");
  config.units.set("http://qudt.org/vocab/unit/BBL_US_DRY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BBL_US_PET",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.1589873"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M3",
    undefined,
    "bbl{US petroleum}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    2,
    false,
    false
  );
  unit.addLabel(new LangString("Barrel (us Petroleum)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LiquidVolume");
  config.units.set("http://qudt.org/vocab/unit/BBL_US_PET", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BBL_US_PET-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.00004416313888888888888888888888888889"),
    undefined,
    undefined,
    undefined,
    undefined,
    "bbl{US petroleum}/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Barrel (us Petroleum) per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/BBL_US_PET-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BBL_US_PET-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.1589873"),
    undefined,
    undefined,
    undefined,
    undefined,
    "bbl{US petroleum}/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Barrel (us Petroleum) per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/BBL_US_PET-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BEAT",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    true
  );
  unit.addLabel(new LangString("BEAT", undefined));
  config.units.set("http://qudt.org/vocab/unit/BEAT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BEAT-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("0.01666666666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "BPM",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Heart Beats per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/HeartRate");
  config.units.set("http://qudt.org/vocab/unit/BEAT-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BFT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Bft",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Beaufort", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Speed");
  config.units.set("http://qudt.org/vocab/unit/BFT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BILLION_Long",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1000000000000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/ONE",
    undefined,
    "1000000000000",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Billion (Long Scale)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Count");
  config.units.set("http://qudt.org/vocab/unit/BILLION_Long", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BILLION_Short",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1000000000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/ONE",
    undefined,
    "1000000000",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Billion (Short Scale)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Count");
  config.units.set("http://qudt.org/vocab/unit/BILLION_Short", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BIOT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T0D0",
    new Decimal("10.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/A",
    undefined,
    "Bi",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-EMU", "http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Biot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCurrent");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/A_Ab");
  config.units.set("http://qudt.org/vocab/unit/BIOT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BIT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.69314718055994530941723212145818"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/NUM",
    undefined,
    "b",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    20,
    false,
    false
  );
  unit.addLabel(new LangString("Bit", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InformationEntropy"
  );
  config.units.set("http://qudt.org/vocab/unit/BIT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BIT-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("0.69314718055994530941723212145818"),
    undefined,
    undefined,
    undefined,
    undefined,
    "b/m",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Bit per Metre", "en"));
  unit.addLabel(new LangString("Bit per Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearBitDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/BIT-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BIT-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T0D0",
    new Decimal("0.69314718055994530941723212145818"),
    undefined,
    undefined,
    undefined,
    undefined,
    "b/m²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Bit per Square Metre", "en"));
  unit.addLabel(new LangString("Bit per Square Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AreaBitDensity");
  config.units.set("http://qudt.org/vocab/unit/BIT-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BIT-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    new Decimal("0.69314718055994530941723212145818"),
    undefined,
    undefined,
    undefined,
    undefined,
    "b/m³",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Bit per Cubic Meter", "en-US"));
  unit.addLabel(new LangString("Bit per Cubic Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/VolumetricBitDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/BIT-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BIT-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("0.69314718055994530941723212145818"),
    undefined,
    undefined,
    undefined,
    undefined,
    "b/s",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Bit per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DataRate");
  config.units.set("http://qudt.org/vocab/unit/BIT-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BQ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Bq",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    17,
    false,
    false
  );
  unit.addLabel(new LangString("Becquerel", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Activity");
  config.units.set("http://qudt.org/vocab/unit/BQ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BQ-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Bq/kg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Becquerel per Kilogram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassicActivity");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificActivity"
  );
  config.units.set("http://qudt.org/vocab/unit/BQ-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BQ-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T-1D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Bq/L",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Becquerel per Liter", "en-US"));
  unit.addLabel(new LangString("Becquerel per Litre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ActivityConcentration"
  );
  config.units.set("http://qudt.org/vocab/unit/BQ-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BQ-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Bq/m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Becquerel per Square Meter", "en-US"));
  unit.addLabel(new LangString("Becquerel per Square Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SurfaceActivityDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/BQ-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BQ-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Bq/m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Becquerel per Cubic Metre", "en"));
  unit.addLabel(new LangString("Becquerel per Cubic Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ActivityConcentration"
  );
  config.units.set("http://qudt.org/vocab/unit/BQ-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BQ-SEC-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Bq·s/m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Becquerel Second per Cubic Meter", "en-US"));
  unit.addLabel(new LangString("Becquerel Second per Cubic Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AbsoluteActivity"
  );
  config.units.set("http://qudt.org/vocab/unit/BQ-SEC-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BREATH",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    true
  );
  unit.addLabel(new LangString("BREATH", undefined));
  config.units.set("http://qudt.org/vocab/unit/BREATH", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BREATH-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("0.01666666666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "breath/min",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Breath per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/RespiratoryRate");
  config.units.set("http://qudt.org/vocab/unit/BREATH-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BREWSTER",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H0T2D0",
    new Decimal("1E-12"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M2-PER-N",
    undefined,
    "B",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Brewster", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/StressOpticCoefficient"
  );
  unit.addExactMatchIri("http://qudt.org/vocab/unit/NanoM-PER-MilliM-MegaPA");
  config.units.set("http://qudt.org/vocab/unit/BREWSTER", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_39DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1059.67"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/J",
    undefined,
    "Btu (39 °F)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("British Thermal Unit (39 °F)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ThermalEnergy");
  config.units.set("http://qudt.org/vocab/unit/BTU_39DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_59DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1054.8"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/J",
    undefined,
    "Btu (59 °F)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("British Thermal Unit (59 °F)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ThermalEnergy");
  config.units.set("http://qudt.org/vocab/unit/BTU_59DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_60DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1054.68"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/J",
    undefined,
    "Btu (60 °F)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("British Thermal Unit (60 °F)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ThermalEnergy");
  config.units.set("http://qudt.org/vocab/unit/BTU_60DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1055.05585262"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/J",
    undefined,
    "Btu{IT}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    42,
    false,
    false
  );
  unit.addLabel(
    new LangString("British Thermal Unit (international Definition)", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ThermalEnergy");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/BTU_IT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-FT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M1H0T-2D0",
    new Decimal("321.581023878576"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}·ft",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("British Thermal Unit (international Definition) Foot", "en")
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalEnergyLength"
  );
  config.units.set("http://qudt.org/vocab/unit/BTU_IT-FT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-FT-PER-FT2-HR-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H-1T-3D0",
    new Decimal("1.730734666371391076115485564304462"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}·ft/(ft²·h·°F)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (international Definition) Foot per Square Foot Hour Degree Fahrenheit",
      "en"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalConductivity"
  );
  config.units.set(
    "http://qudt.org/vocab/unit/BTU_IT-FT-PER-FT2-HR-DEG_F",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-IN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M1H0T-2D0",
    new Decimal("26.798418656548"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}·in",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("British Thermal Unit (international Definition) Inch", "en")
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalEnergyLength"
  );
  config.units.set("http://qudt.org/vocab/unit/BTU_IT-IN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-IN-PER-FT2-HR-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H-1T-3D0",
    new Decimal("0.1442278888642825896762904636920385"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}·in/(ft²·h·°F)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (international Definition) Inch per Square Foot Hour Degree Fahrenheit",
      "en"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalConductivity"
  );
  unit.addExactMatchIri(
    "http://qudt.org/vocab/unit/BTU_IT-IN-PER-HR-FT2-DEG_F"
  );
  config.units.set(
    "http://qudt.org/vocab/unit/BTU_IT-IN-PER-FT2-HR-DEG_F",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-IN-PER-FT2-SEC-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H-1T-3D0",
    new Decimal("519.2203999114173228346456692913385"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}·in/(ft²·s·°F)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (international Definition) Inch per Square Foot Second Degree Fahrenheit",
      "en"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalConductivity"
  );
  unit.addExactMatchIri(
    "http://qudt.org/vocab/unit/BTU_IT-IN-PER-SEC-FT2-DEG_F"
  );
  config.units.set(
    "http://qudt.org/vocab/unit/BTU_IT-IN-PER-FT2-SEC-DEG_F",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-IN-PER-HR-FT2-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H-1T-3D0",
    new Decimal("0.1442278888642825896762904636920385"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}·in/(h·ft²·°F)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (international Definition) Inch per Hour Square Foot Degree Fahrenheit",
      "en"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalConductivity"
  );
  unit.addExactMatchIri(
    "http://qudt.org/vocab/unit/BTU_IT-IN-PER-FT2-HR-DEG_F"
  );
  config.units.set(
    "http://qudt.org/vocab/unit/BTU_IT-IN-PER-HR-FT2-DEG_F",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-IN-PER-SEC-FT2-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H-1T-3D0",
    new Decimal("519.2203999114173228346456692913385"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}·in/(s·ft²·°F)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (international Definition) Inch per Second Square Foot Degree Fahrenheit",
      "en"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalConductivity"
  );
  unit.addExactMatchIri(
    "http://qudt.org/vocab/unit/BTU_IT-IN-PER-FT2-SEC-DEG_F"
  );
  config.units.set(
    "http://qudt.org/vocab/unit/BTU_IT-IN-PER-SEC-FT2-DEG_F",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-PER-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H-1T-2D0",
    new Decimal("1899.100534716"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}/°F",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (international Definition) per Degree Fahrenheit",
      "en"
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/HeatCapacity");
  config.units.set("http://qudt.org/vocab/unit/BTU_IT-PER-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-PER-DEG_R",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H-1T-2D0",
    new Decimal("1899.100534715999848071957222720013"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}/°R",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (international Definition) per Degree Rankine",
      "en"
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/HeatCapacity");
  config.units.set("http://qudt.org/vocab/unit/BTU_IT-PER-DEG_R", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("11356.52668222697556506224123559358"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}/ft²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (international Definition) per Square Foot",
      "en"
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyPerArea");
  config.units.set("http://qudt.org/vocab/unit/BTU_IT-PER-FT2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    new Decimal("3.154590745063048768072844787664884"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}/(ft²·h)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (international Definition) per Square Foot Hour",
      "en"
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PowerPerArea");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/BTU_IT-PER-HR-FT2");
  config.units.set("http://qudt.org/vocab/unit/BTU_IT-PER-FT2-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-HR-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-3D0",
    new Decimal("5.678263341113487782531120617796791"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}/(ft²·h·°F)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (international Definition) per Square Foot Hour Degree Fahrenheit",
      "en"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CoefficientOfHeatTransfer"
  );
  config.units.set("http://qudt.org/vocab/unit/BTU_IT-PER-FT2-HR-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    new Decimal("11356.52668222697556506224123559358"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}/(ft²·s)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (international Definition) per Square Foot Second",
      "en"
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PowerPerArea");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/BTU_IT-PER-SEC-FT2");
  config.units.set("http://qudt.org/vocab/unit/BTU_IT-PER-FT2-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-SEC-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-3D0",
    new Decimal("20441.74802800855601711203422406845"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}/(ft²·s·°F)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (international Definition) per Square Foot Second Degree Fahrenheit",
      "en"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CoefficientOfHeatTransfer"
  );
  config.units.set("http://qudt.org/vocab/unit/BTU_IT-PER-FT2-SEC-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("37258.94580783128466227769434249863"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}/ft³",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (international Definition) per Cubic Foot",
      "en"
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyDensity");
  config.units.set("http://qudt.org/vocab/unit/BTU_IT-PER-FT3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("0.2930710701722222222222222222222222"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (international Definition) per Hour",
      "en"
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/HeatFlowRate");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/BTU_IT-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-PER-HR-FT2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    new Decimal("3.154590745063048768072844787664884"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}/(h·ft²)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (international Definition) per Hour Square Foot",
      "en"
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PowerPerArea");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/BTU_IT-PER-FT2-HR");
  config.units.set("http://qudt.org/vocab/unit/BTU_IT-PER-HR-FT2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-PER-HR-FT2-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-3D0",
    new Decimal("5.678263341113487782531120617796791"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}/(h·ft²·°F)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (international Definition) per Hour Square Foot Degree Fahrenheit",
      "en"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CoefficientOfHeatTransfer"
  );
  config.units.set("http://qudt.org/vocab/unit/BTU_IT-PER-HR-FT2-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-PER-HR-FT2-DEG_R",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-3D0",
    new Decimal("5.678263341113487328270053328717806"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}/(h·ft²·°R)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (international Definition) per Hour Square Foot Degree Rankine",
      "en"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CoefficientOfHeatTransfer"
  );
  config.units.set("http://qudt.org/vocab/unit/BTU_IT-PER-HR-FT2-DEG_R", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-PER-IN2-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    new Decimal("1635339.842240684481368962737925476"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}/(in²·s)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (international Definition) per Square Inch Second",
      "en"
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PowerPerArea");
  config.units.set("http://qudt.org/vocab/unit/BTU_IT-PER-IN2-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("2326.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}/lbm",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (international Definition) per Pound Mass",
      "en"
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificEnergy");
  config.units.set("http://qudt.org/vocab/unit/BTU_IT-PER-LB", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H-1T-2D0",
    new Decimal("4186.799999999999999999999999999999"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}/(lbm·°F)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (international Definition) per Pound Mass Degree Fahrenheit",
      "en"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtConstantVolume"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtConstantPressure"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtSaturation"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificEntropy");
  config.units.set("http://qudt.org/vocab/unit/BTU_IT-PER-LB-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB-DEG_R",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H-1T-2D0",
    new Decimal("4186.799999999999665056000000000027"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}/(lbm·°R)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (international Definition) per Pound Mass Degree Rankine",
      "en"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacity"
  );
  config.units.set("http://qudt.org/vocab/unit/BTU_IT-PER-LB-DEG_R", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("237.1859804967209578645896957248943"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}/lbf",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (international Definition) per Pound Force",
      "en"
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/BTU_IT-PER-LB_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H-1T0D0",
    new Decimal("426.9347648940977241562614523048097"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}/(lbf·°F)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (international Definition) per Pound Force Degree Fahrenheit",
      "en"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearThermalExpansion"
  );
  config.units.set("http://qudt.org/vocab/unit/BTU_IT-PER-LB_F-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F-DEG_R",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H-1T0D0",
    new Decimal("426.9347648940976900014802607769946"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}/(lbf·°R)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (international Definition) per Pound Force Degree Rankine",
      "en"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearThermalExpansion"
  );
  config.units.set("http://qudt.org/vocab/unit/BTU_IT-PER-LB_F-DEG_R", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("17.58426421033333333333333333333334"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (international Definition) per Minute",
      "en"
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/HeatFlowRate");
  config.units.set("http://qudt.org/vocab/unit/BTU_IT-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-PER-MOL_LB",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A-1E0L2I0M1H0T-2D0",
    new Decimal("2.326"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}/lb-mol",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (international Definition) per Pound Mole",
      "en"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EnergyPerMassAmountOfSubstance"
  );
  config.units.set("http://qudt.org/vocab/unit/BTU_IT-PER-MOL_LB", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-PER-MOL_LB-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A-1E0L2I0M1H-1T-2D0",
    new Decimal("4.186799999999999999999999999999999"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}/(lb-mol·°F)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (international Definition) per Pound Mole Degree Fahrenheit",
      "en"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MolarHeatCapacity"
  );
  config.units.set("http://qudt.org/vocab/unit/BTU_IT-PER-MOL_LB-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1055.05585262"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (international Definition) per Second",
      "en"
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/HeatFlowRate");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/BTU_IT-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC-FT-DEG_R",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H-1T-3D0",
    new Decimal("6230.644798937007375564164116535474"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}/(s·ft·°R)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (international Definition) per Second Foot Degree Rankine",
      "en"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalConductivity"
  );
  config.units.set("http://qudt.org/vocab/unit/BTU_IT-PER-SEC-FT-DEG_R", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC-FT2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    new Decimal("11356.52668222697556506224123559358"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}/(s·ft²)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (international Definition) per Second Square Foot",
      "en"
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PowerPerArea");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/BTU_IT-PER-FT2-SEC");
  config.units.set("http://qudt.org/vocab/unit/BTU_IT-PER-SEC-FT2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC-FT2-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-3D0",
    new Decimal("20441.74802800855601711203422406845"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}/(s·ft²·°F)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (international Definition) per Second Square Foot Degree Fahrenheit",
      "en"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CoefficientOfHeatTransfer"
  );
  config.units.set("http://qudt.org/vocab/unit/BTU_IT-PER-SEC-FT2-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC-FT2-DEG_R",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-3D0",
    new Decimal("20441.7480280085543817721919833841"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}/(s·ft²·°R)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (international Definition) per Second Square Foot Degree Rankine",
      "en"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CoefficientOfHeatTransfer"
  );
  config.units.set("http://qudt.org/vocab/unit/BTU_IT-PER-SEC-FT2-DEG_R", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_MEAN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1055.05585262"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/J",
    undefined,
    "BTU{mean}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("British Thermal Unit (mean)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ThermalEnergy");
  config.units.set("http://qudt.org/vocab/unit/BTU_MEAN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_TH",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1054.3502645"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/J",
    undefined,
    "Btu{th}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    24,
    false,
    false
  );
  unit.addLabel(
    new LangString("British Thermal Unit (thermochemical Definition)", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ThermalEnergy");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/BTU_TH", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_TH-FT-PER-FT2-HR-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H-1T-3D0",
    new Decimal("1.729577205544619422572178477690289"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{th}·ft/(ft²·h·°F)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (thermochemical Definition) Foot per Square Foot Hour Degree Fahrenheit",
      "en"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalConductivity"
  );
  config.units.set(
    "http://qudt.org/vocab/unit/BTU_TH-FT-PER-FT2-HR-DEG_F",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_TH-FT-PER-HR-FT2-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H-1T-3D0",
    new Decimal("1.729577205544619422572178477690289"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{th}·ft/(h·ft²·°F)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (thermochemical Definition) Foot per Hour Square Foot Degree Fahrenheit",
      "en"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalConductivity"
  );
  config.units.set(
    "http://qudt.org/vocab/unit/BTU_TH-FT-PER-HR-FT2-DEG_F",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_TH-IN-PER-FT2-HR-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H-1T-3D0",
    new Decimal("0.1441314337953849518810148731408574"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{th}·in/(ft²·h·°F)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (thermochemical Definition) Inch per Square Foot Hour Degree Fahrenheit",
      "en"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalConductivity"
  );
  config.units.set(
    "http://qudt.org/vocab/unit/BTU_TH-IN-PER-FT2-HR-DEG_F",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_TH-IN-PER-FT2-SEC-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H-1T-3D0",
    new Decimal("518.8731616633858267716535433070866"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{th}·in/(ft²·s·°F)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (thermochemical Definition) Inch per Square Foot Second Degree Fahrenheit",
      "en"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalConductivity"
  );
  config.units.set(
    "http://qudt.org/vocab/unit/BTU_TH-IN-PER-FT2-SEC-DEG_F",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_TH-PER-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H-1T-2D0",
    new Decimal("1897.8304761"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{th}/°F",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (thermochemical Definition) per Degree Fahrenheit",
      "en"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalCapacitance"
  );
  config.units.set("http://qudt.org/vocab/unit/BTU_TH-PER-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_TH-PER-DEG_R",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H-1T-2D0",
    new Decimal("1897.830476099999848173561912000013"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{th}/°R",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (thermochemical Definition) per Degree Rankine",
      "en"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalCapacitance"
  );
  config.units.set("http://qudt.org/vocab/unit/BTU_TH-PER-DEG_R", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("11348.93179491220093551298213707538"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{th}/ft²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (thermochemical Definition) per Square Foot",
      "en"
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyPerArea");
  config.units.set("http://qudt.org/vocab/unit/BTU_TH-PER-FT2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    new Decimal("3.152481054142278037642495038076496"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{th}/(ft²·h)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (thermochemical Definition) per Square Foot Hour",
      "en"
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PowerPerArea");
  config.units.set("http://qudt.org/vocab/unit/BTU_TH-PER-FT2-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    new Decimal("189.1488632485366822585497022845898"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{th}/(ft²·min)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (thermochemical Definition) per Square Foot Minute",
      "en"
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PowerPerArea");
  config.units.set("http://qudt.org/vocab/unit/BTU_TH-PER-FT2-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    new Decimal("11348.93179491220093551298213707538"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{th}/(ft²·s)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (thermochemical Definition) per Square Foot Second",
      "en"
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PowerPerArea");
  config.units.set("http://qudt.org/vocab/unit/BTU_TH-PER-FT2-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("37234.02819853084296428143745759641"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{th}/ft³",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (thermochemical Definition) per Cubic Foot",
      "en"
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyDensity");
  config.units.set("http://qudt.org/vocab/unit/BTU_TH-PER-FT3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_TH-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("0.2928750734722222222222222222222222"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{th}/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (thermochemical Definition) per Hour",
      "en"
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/HeatFlowRate");
  config.units.set("http://qudt.org/vocab/unit/BTU_TH-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_TH-PER-HR-FT2-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-3D0",
    new Decimal("5.674465897456100467756491068537693"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{th}/(h·ft²·°F)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (thermochemical Definition) per Hour Square Foot Degree Fahrenheit",
      "en"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CoefficientOfHeatTransfer"
  );
  config.units.set("http://qudt.org/vocab/unit/BTU_TH-PER-HR-FT2-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_TH-PER-LB",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("2324.444444468940251353875286746997"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{th}/lbm",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (thermochemical Definition) per Pound Mass",
      "en"
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificEnergy");
  config.units.set("http://qudt.org/vocab/unit/BTU_TH-PER-LB", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_TH-PER-LB-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H-1T-2D0",
    new Decimal("4184.000000044092452436975516144594"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{th}/(lbm·°F)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (thermochemical Definition) per Pound Mass Degree Fahrenheit",
      "en"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtConstantVolume"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtConstantPressure"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtSaturation"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificEntropy");
  config.units.set("http://qudt.org/vocab/unit/BTU_TH-PER-LB-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_TH-PER-LB-DEG_R",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H-1T-2D0",
    new Decimal("4184.000000044092117716975512617226"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{th}/(lbm·°R)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (thermochemical Definition) per Pound Mass Degree Rankine",
      "en"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassicHeatCapacity"
  );
  config.units.set("http://qudt.org/vocab/unit/BTU_TH-PER-LB-DEG_R", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_TH-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("17.57250440833333333333333333333334"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{th}/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (thermochemical Definition) per Minute",
      "en"
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/HeatFlowRate");
  config.units.set("http://qudt.org/vocab/unit/BTU_TH-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_TH-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1054.3502645"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{th}/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (thermochemical Definition) per Second",
      "en"
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/HeatFlowRate");
  config.units.set("http://qudt.org/vocab/unit/BTU_TH-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_TH-PER-SEC-FT2-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-3D0",
    new Decimal("20428.07723084196168392336784673569"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{th}/(s·ft²·°F)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (thermochemical Definition) per Second Square Foot Degree Fahrenheit",
      "en"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CoefficientOfHeatTransfer"
  );
  config.units.set("http://qudt.org/vocab/unit/BTU_TH-PER-SEC-FT2-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BU_UK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.03636872"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M3",
    undefined,
    "bsh{UK}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    4,
    false,
    false
  );
  unit.addLabel(new LangString("Bushel (UK)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DryVolume");
  config.units.set("http://qudt.org/vocab/unit/BU_UK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BU_UK-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("4.209342592592592592592592592592591E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "bsh{UK}/d",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Bushel (UK) per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/BU_UK-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BU_UK-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.00001010242222222222222222222222222222"),
    undefined,
    undefined,
    undefined,
    undefined,
    "bsh{UK}/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Bushel (UK) per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/BU_UK-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BU_UK-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.0006061453333333333333333333333333335"),
    undefined,
    undefined,
    undefined,
    undefined,
    "bsh{UK}/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Bushel (UK) per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/BU_UK-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BU_UK-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.03636872"),
    undefined,
    undefined,
    undefined,
    undefined,
    "bsh{UK}/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Bushel (UK) per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/BU_UK-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BU_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.03523907016688"),
    undefined,
    undefined,
    undefined,
    undefined,
    "bu{US}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Bushel (US)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DryVolume");
  config.units.set("http://qudt.org/vocab/unit/BU_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BU_US_DRY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.03523907"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M3",
    undefined,
    "bsh{US}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    4,
    false,
    false
  );
  unit.addLabel(new LangString("Bushel (US Dry)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/BU_US_DRY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BU_US_DRY-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("4.078596064814814814814814814814813E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "bsh{US}/d",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Bushel (US Dry) per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/BU_US_DRY-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BU_US_DRY-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.000009788630555555555555555555555555556"),
    undefined,
    undefined,
    undefined,
    undefined,
    "bsh{US}/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Bushel (US Dry) per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/BU_US_DRY-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BU_US_DRY-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.0005873178333333333333333333333333335"),
    undefined,
    undefined,
    undefined,
    undefined,
    "bsh{US}/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Bushel (US Dry) per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/BU_US_DRY-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BU_US_DRY-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.03523907"),
    undefined,
    undefined,
    undefined,
    undefined,
    "bsh{US}/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Bushel (US Dry) per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/BU_US_DRY-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BYTE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("5.54517744447956247533785697166544"),
    undefined,
    undefined,
    undefined,
    undefined,
    "B",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    13,
    false,
    false
  );
  unit.addLabel(new LangString("Byte", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InformationEntropy"
  );
  unit.addExactMatchIri("http://qudt.org/vocab/unit/OCTET");
  config.units.set("http://qudt.org/vocab/unit/BYTE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BYTE-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("5.54517744447956247533785697166544"),
    undefined,
    undefined,
    undefined,
    undefined,
    "B/s",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Byte per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ByteRate");
  config.units.set("http://qudt.org/vocab/unit/BYTE-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BasePair",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "bp",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Base Pair", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Dimensionless");
  config.units.set("http://qudt.org/vocab/unit/BasePair", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "C",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    48,
    false,
    false
  );
  unit.addLabel(new LangString("Coulomb", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  config.units.set("http://qudt.org/vocab/unit/C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/C-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L1I0M0H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "C·m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    2,
    false,
    false
  );
  unit.addLabel(new LangString("Coulomb Metre", "en"));
  unit.addLabel(new LangString("Coulomb Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricDipoleMoment"
  );
  config.units.set("http://qudt.org/vocab/unit/C-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/C-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L2I0M0H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "C·m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Coulomb Square Meter", "en-US"));
  unit.addLabel(new LangString("Coulomb Square Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricQuadrupoleMoment"
  );
  config.units.set("http://qudt.org/vocab/unit/C-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/C-M2-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L2I0M-1H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "C·m²/kg",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Coulomb Square Meter per Kilogram", "en-US"));
  unit.addLabel(new LangString("Coulomb Square Metre per Kilogram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/C-M2-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/C-M2-PER-V",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L0I0M-1H0T4D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "C·m²/V",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Coulomb Square Metre per Volt", "en"));
  unit.addLabel(new LangString("Coulomb Square Meter per Volt", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Polarizability");
  config.units.set("http://qudt.org/vocab/unit/C-M2-PER-V", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/C-PER-CentiM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H0T1D0",
    new Decimal("10000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "C/cm²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Coulomb per Square Centimeter", "en-US"));
  unit.addLabel(new LangString("Coulomb per Square Centimetre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerArea"
  );
  config.units.set("http://qudt.org/vocab/unit/C-PER-CentiM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/C-PER-CentiM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-3I0M0H0T1D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "C/cm³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Coulomb per Cubic Centimetre", "en"));
  unit.addLabel(new LangString("Coulomb per Cubic Centimeter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargeVolumeDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/C-PER-CentiM3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/C-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M-1H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "C/kg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Coulomb per Kilogram", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerMass"
  );
  config.units.set("http://qudt.org/vocab/unit/C-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/C-PER-KiloGM-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M-1H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "C/(kg·s)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Coulomb per Kilogram Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ExposureRate");
  config.units.set("http://qudt.org/vocab/unit/C-PER-KiloGM-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/C-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-1I0M0H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "C/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Coulomb per Meter", "en-US"));
  unit.addLabel(new LangString("Coulomb per Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargeLineDensity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargeLinearDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/C-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/C-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "C/m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Coulomb per Square Metre", "en"));
  unit.addLabel(new LangString("Coulomb per Square Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerArea"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPolarization"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargeSurfaceDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/C-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/C-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-3I0M0H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "C/m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Coulomb per Cubic Metre", "en"));
  unit.addLabel(new LangString("Coulomb per Cubic Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargeDensity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargeVolumeDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/C-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/C-PER-MOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A-1E1L0I0M0H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "C/mol",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Coulomb per Mole", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerAmountOfSubstance"
  );
  config.units.set("http://qudt.org/vocab/unit/C-PER-MOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/C-PER-MilliM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H0T1D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "C/mm²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Coulomb per Square Millimeter", "en-US"));
  unit.addLabel(new LangString("Coulomb per Square Millimetre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerArea"
  );
  config.units.set("http://qudt.org/vocab/unit/C-PER-MilliM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/C-PER-MilliM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-3I0M0H0T1D0",
    new Decimal("1000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "C/mm³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Coulomb per Cubic Millimeter", "en-US"));
  unit.addLabel(new LangString("Coulomb per Cubic Millimetre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargeVolumeDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/C-PER-MilliM3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/C2-M2-PER-J",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L0I0M-1H0T4D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "C²·m²/J",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Coulomb Square Metre per Joule", "en"));
  unit.addLabel(
    new LangString("Square Coulomb Square Meter per Joule", "en-US")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Polarizability");
  config.units.set("http://qudt.org/vocab/unit/C2-M2-PER-J", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/C3-M-PER-J2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E3L-3I0M-2H0T7D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "C³·m/J²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Coulomb Metre per Square Joule", "en"));
  unit.addLabel(
    new LangString("Cubic Coulomb Meter per Square Joule", "en-US")
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CubicElectricDipoleMomentPerSquareEnergy"
  );
  config.units.set("http://qudt.org/vocab/unit/C3-M-PER-J2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/C4-M4-PER-J3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E4L-2I0M-3H0T10D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "C⁴·m⁴/J³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Quartic Coulomb Quartic Metre per Cubic Joule", "en")
  );
  unit.addLabel(
    new LangString("Quartic Coulomb Quartic Meter per Cubic Joule", "en-US")
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/QuarticElectricDipoleMomentPerCubicEnergy"
  );
  config.units.set("http://qudt.org/vocab/unit/C4-M4-PER-J3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CAL_15DEG_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("4.1858"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/J",
    undefined,
    "cal{15 °C}",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Calorie (15 Degrees C)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ThermalEnergy");
  config.units.set("http://qudt.org/vocab/unit/CAL_15DEG_C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CAL_15_DEG_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("4.1858"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/J",
    undefined,
    "cal{15 °C}",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("Calorie (15 Degrees C)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ThermalEnergy");
  config.units.set("http://qudt.org/vocab/unit/CAL_15_DEG_C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CAL_20DEG_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("4.1819"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/J",
    undefined,
    "cal₂₀",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Calorie (20 °C)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ThermalEnergy");
  config.units.set("http://qudt.org/vocab/unit/CAL_20DEG_C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CAL_IT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("4.1868"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/J",
    undefined,
    "cal{IT}",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    6,
    false,
    false
  );
  unit.addLabel(new LangString("International Table Calorie", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ThermalEnergy");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/CAL_IT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CAL_IT-PER-GM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("4186.8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cal{IT}/g",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("International Table Calorie per Gram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificEnergy");
  config.units.set("http://qudt.org/vocab/unit/CAL_IT-PER-GM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CAL_IT-PER-GM-DEG_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H-1T-2D0",
    new Decimal("4186.8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cal{IT}/(g·°C)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("International Table Calorie per Gram Degree Celsius", "en")
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtConstantVolume"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtConstantPressure"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtSaturation"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificEntropy");
  config.units.set("http://qudt.org/vocab/unit/CAL_IT-PER-GM-DEG_C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CAL_IT-PER-GM-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H-1T-2D0",
    new Decimal("4186.8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cal{IT}/(g·K)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("International Table Calorie per Gram Kelvin", "en")
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtConstantVolume"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtConstantPressure"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtSaturation"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificEntropy");
  config.units.set("http://qudt.org/vocab/unit/CAL_IT-PER-GM-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CAL_IT-PER-SEC-CentiM-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H-1T-3D0",
    new Decimal("418.68"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cal{IT}/(s·cm·K)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "International Table Calorie per Second Centimetre Kelvin",
      "en"
    )
  );
  unit.addLabel(
    new LangString(
      "International Table Calorie per Second Centimeter Kelvin",
      "en-US"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalConductivity"
  );
  config.units.set("http://qudt.org/vocab/unit/CAL_IT-PER-SEC-CentiM-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CAL_IT-PER-SEC-CentiM2-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-3D0",
    new Decimal("41868.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cal{IT}/(s·cm²·K)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "International Table Calorie per Second Square Centimetre Kelvin",
      "en"
    )
  );
  unit.addLabel(
    new LangString(
      "International Table Calorie per Second Square Centimeter Kelvin",
      "en-US"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CoefficientOfHeatTransfer"
  );
  config.units.set("http://qudt.org/vocab/unit/CAL_IT-PER-SEC-CentiM2-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CAL_MEAN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("4.19"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/J",
    undefined,
    "cal{mean}",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Calorie (Mean)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ThermalEnergy");
  config.units.set("http://qudt.org/vocab/unit/CAL_MEAN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CAL_TH",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("4.184"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/J",
    undefined,
    "cal",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    13,
    false,
    false
  );
  unit.addLabel(new LangString("Thermochemical Calorie", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ThermalEnergy");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/CAL_TH", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM-SEC-DEG_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H-1T-3D0",
    new Decimal("418.4"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cal/(cm·s·°C)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "Thermochemical Calorie per Centimetre Second Degree Celsius",
      "en"
    )
  );
  unit.addLabel(
    new LangString(
      "Thermochemical Calorie per Centimeter Second Degree Celsius",
      "en-US"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalConductivity"
  );
  config.units.set(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM-SEC-DEG_C",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("41840.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cal/cm²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Thermochemical Calorie per Square Centimeter", "en-US")
  );
  unit.addLabel(
    new LangString("Thermochemical Calorie per Square Centimetre", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyPerArea");
  config.units.set("http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    new Decimal("697.3333333333333333333333333333335"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cal/(cm²·min)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Thermochemical Calorie per Square Centimetre Minute", "en")
  );
  unit.addLabel(
    new LangString(
      "Thermochemical Calorie per Square Centimeter Minute",
      "en-US"
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PowerPerArea");
  config.units.set("http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    new Decimal("41840.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cal/(cm²·s)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Thermochemical Calorie per Square Centimetre Second", "en")
  );
  unit.addLabel(
    new LangString(
      "Thermochemical Calorie per Square Centimeter Second",
      "en-US"
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PowerPerArea");
  config.units.set("http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM3-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H-1T-2D0",
    new Decimal("4184000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cal/(cm³·K)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "Thermochemical Calorie per Cubic Centimeter Kelvin",
      "en-US"
    )
  );
  unit.addLabel(
    new LangString("Thermochemical Calorie per Cubic Centimetre Kelvin", "en")
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/VolumetricHeatCapacity"
  );
  config.units.set("http://qudt.org/vocab/unit/CAL_TH-PER-CentiM3-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CAL_TH-PER-GM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("4184.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cal/g",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Thermochemical Calorie per Gram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificEnergy");
  config.units.set("http://qudt.org/vocab/unit/CAL_TH-PER-GM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CAL_TH-PER-GM-DEG_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H-1T-2D0",
    new Decimal("4184.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cal/(g·°C)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Thermochemical Calorie per Gram Degree Celsius", "en")
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtConstantVolume"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtConstantPressure"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtSaturation"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificEntropy");
  config.units.set("http://qudt.org/vocab/unit/CAL_TH-PER-GM-DEG_C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CAL_TH-PER-GM-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H-1T-2D0",
    new Decimal("4184.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cal/(g·K)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Thermochemical Calorie per Gram Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtConstantVolume"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtConstantPressure"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtSaturation"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificEntropy");
  config.units.set("http://qudt.org/vocab/unit/CAL_TH-PER-GM-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CAL_TH-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("0.06973333333333333333333333333333335"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cal/min",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Thermochemical Calorie per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/HeatFlowRate");
  config.units.set("http://qudt.org/vocab/unit/CAL_TH-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CAL_TH-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("4.184"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cal/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Thermochemical Calorie per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/HeatFlowRate");
  config.units.set("http://qudt.org/vocab/unit/CAL_TH-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CAL_TH-PER-SEC-CentiM-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H-1T-3D0",
    new Decimal("418.4"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cal/(s·cm·K)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Thermochemical Calorie per Second Centimetre Kelvin", "en")
  );
  unit.addLabel(
    new LangString(
      "Thermochemical Calorie per Second Centimeter Kelvin",
      "en-US"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalConductivity"
  );
  config.units.set("http://qudt.org/vocab/unit/CAL_TH-PER-SEC-CentiM-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CAL_TH-PER-SEC-CentiM2-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-3D0",
    new Decimal("41840.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cal/(s·cm²·K)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "Thermochemical Calorie per Second Square Centimeter Kelvin",
      "en-US"
    )
  );
  unit.addLabel(
    new LangString(
      "Thermochemical Calorie per Second Square Centimetre Kelvin",
      "en"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CoefficientOfHeatTransfer"
  );
  config.units.set("http://qudt.org/vocab/unit/CAL_TH-PER-SEC-CentiM2-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CARAT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("0.0002"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "ct",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Carat", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  config.units.set("http://qudt.org/vocab/unit/CARAT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CASES",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    true
  );
  unit.addLabel(new LangString("CASES", undefined));
  config.units.set("http://qudt.org/vocab/unit/CASES", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CASES-PER-KiloINDIV-YR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Cases/1000 individuals/year",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cases per 1000 Individuals Year", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MorbidityRate");
  config.units.set("http://qudt.org/vocab/unit/CASES-PER-KiloINDIV-YR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_AED",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "د.إ",
    undefined,
    "AED",
    784,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("United Arab Emirates Dirham", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_AED", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_AFN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "AFN",
    971,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Afghani", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_AFN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_ALL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "L",
    undefined,
    "ALL",
    8,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Lek", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_ALL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_AMD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "֏",
    undefined,
    "AMD",
    51,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Armenian Dram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_AMD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_ANG",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "ANG",
    532,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Netherlands Antillian Guilder", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_ANG", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_AOA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "AOA",
    973,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kwanza", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_AOA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_ARS",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "ARS",
    32,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Argentine Peso", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_ARS", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_AUD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "$",
    undefined,
    "AUD",
    36,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Australian Dollar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_AUD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_AWG",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "AWG",
    533,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Aruban Guilder", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_AWG", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_AZN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "₼",
    undefined,
    "AZN",
    944,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Azerbaijanian Manat", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_AZN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_BAM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "KM",
    undefined,
    "BAM",
    977,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Convertible Marks", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_BAM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_BBD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "BBD",
    52,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Barbados Dollar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_BBD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_BDT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "BDT",
    50,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Bangladeshi Taka", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_BDT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_BGN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "лв.",
    undefined,
    "BGN",
    975,
    [],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Bulgarian Lev", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_BGN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_BGN-PER-KiloW-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M-1H0T2D0",
    new Decimal("2.777777777777777777777777777777778E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "лв./(kW·h)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Bulgarian Lev per Kilowatt Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/CostPerEnergy");
  config.units.set("http://qudt.org/vocab/unit/CCY_BGN-PER-KiloW-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_BHD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "BHD",
    48,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Bahraini Dinar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_BHD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_BIF",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "BIF",
    108,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Burundian Franc", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_BIF", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_BMD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "BMD",
    60,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Bermuda Dollar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_BMD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_BND",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "BND",
    96,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Brunei Dollar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_BND", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_BOB",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "BOB",
    68,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Boliviano", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_BOB", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_BOV",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "BOV",
    984,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Bolivian Mvdol (funds Code)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_BOV", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_BRL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "$",
    undefined,
    "BRL",
    986,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Brazilian Real", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_BRL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_BSD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "BSD",
    44,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Bahamian Dollar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_BSD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_BTN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "BTN",
    64,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ngultrum", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_BTN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_BWP",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "BWP",
    72,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pula", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_BWP", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_BYN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Rbl",
    undefined,
    "BYN",
    933,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Belarussian Ruble", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_BYN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_BZD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "BZD",
    84,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Belize Dollar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_BZD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_CAD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "$",
    undefined,
    "CAD",
    124,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Canadian Dollar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_CAD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_CDF",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "CDF",
    976,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Franc Congolais", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_CDF", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_CHE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "CHE",
    947,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Wir Euro (complementary Currency)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_CHE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_CHF",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "CHF",
    undefined,
    "CHF",
    756,
    [],
    3,
    false,
    false
  );
  unit.addLabel(new LangString("Swiss Franc", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_CHF", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_CHF-PER-HA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T0D0",
    new Decimal("0.0001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "CHF/ha",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Swiss Franc per Hectare", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/CostPerArea");
  config.units.set("http://qudt.org/vocab/unit/CCY_CHF-PER-HA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_CHF-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "CHF/kg",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Swiss Franc per Kilogram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/CostPerMass");
  config.units.set("http://qudt.org/vocab/unit/CCY_CHF-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_CHF-PER-KiloW-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M-1H0T2D0",
    new Decimal("2.777777777777777777777777777777778E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "CHF/(kW·h)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Swiss Franc per Kilowatt Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/CostPerEnergy");
  config.units.set("http://qudt.org/vocab/unit/CCY_CHF-PER-KiloW-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_CHW",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "CHW",
    948,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Wir Franc (complementary Currency)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_CHW", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_CLF",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "CLF",
    990,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Unidades De Formento (funds Code)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_CLF", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_CLP",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "$",
    undefined,
    "CLP",
    152,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Chilean Peso", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_CLP", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_CNY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "¥",
    undefined,
    "CNY",
    156,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Yuan Renminbi", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_CNY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_COP",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "$",
    undefined,
    "COP",
    170,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Colombian Peso", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_COP", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_COU",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "COU",
    970,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Unidad De Valor Real", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_COU", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_CRC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "CRC",
    188,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Costa Rican Colon", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_CRC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_CUP",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "CUP",
    192,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cuban Peso", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_CUP", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_CVE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "CVE",
    132,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cape Verde Escudo", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_CVE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_CYP",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "CYP",
    196,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cyprus Pound", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_CYP", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_CZK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Kč",
    undefined,
    "CZK",
    203,
    [],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Czech Koruna", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_CZK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_CZK-PER-KiloW-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M-1H0T2D0",
    new Decimal("2.777777777777777777777777777777778E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Kč/(kW·h)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Czech Koruna per Kilowatt Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/CostPerEnergy");
  config.units.set("http://qudt.org/vocab/unit/CCY_CZK-PER-KiloW-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_DJF",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "DJF",
    262,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Djibouti Franc", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_DJF", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_DKK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kr",
    undefined,
    "DKK",
    208,
    [],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Danish Krone", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_DKK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_DKK-PER-KiloW-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M-1H0T2D0",
    new Decimal("2.777777777777777777777777777777778E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kr/(kW·h)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Danish Krone per Kilowatt Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/CostPerEnergy");
  config.units.set("http://qudt.org/vocab/unit/CCY_DKK-PER-KiloW-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_DOP",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "DOP",
    214,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Dominican Peso", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_DOP", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_DZD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "DZD",
    12,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Algerian Dinar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_DZD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_EEK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "EEK",
    233,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kroon", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_EEK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_EGP",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "EGP",
    818,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Egyptian Pound", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_EGP", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_ERN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "ERN",
    232,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Nakfa", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_ERN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_ETB",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "ETB",
    230,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ethiopian Birr", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_ETB", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_EUR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "€",
    undefined,
    "EUR",
    978,
    [],
    6,
    false,
    false
  );
  unit.addLabel(new LangString("Euro", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_EUR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_EUR-PER-KiloW",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M-1H0T3D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "€/kW",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Euro per Kilowatt", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/CostPerPower");
  config.units.set("http://qudt.org/vocab/unit/CCY_EUR-PER-KiloW", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_EUR-PER-KiloW-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M-1H0T2D0",
    new Decimal("2.777777777777777777777777777777778E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "€/(kW·h)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Euro per Kilowatt Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/CostPerEnergy");
  config.units.set("http://qudt.org/vocab/unit/CCY_EUR-PER-KiloW-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_EUR-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "€/m²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Euro per Square Metre", "en"));
  unit.addLabel(new LangString("Euro per Square Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/CostPerArea");
  config.units.set("http://qudt.org/vocab/unit/CCY_EUR-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_EUR-PER-W",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M-1H0T3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "€/W",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Euro per Watt", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/CostPerPower");
  config.units.set("http://qudt.org/vocab/unit/CCY_EUR-PER-W", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_EUR-PER-W-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M-1H0T2D0",
    new Decimal("0.0002777777777777777777777777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "€/(W·h)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Euro per Watt Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/CostPerEnergy");
  config.units.set("http://qudt.org/vocab/unit/CCY_EUR-PER-W-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_EUR-PER-W-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M-1H0T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "€/(W·s)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Euro per Watt Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/CostPerEnergy");
  config.units.set("http://qudt.org/vocab/unit/CCY_EUR-PER-W-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_FJD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "FJD",
    242,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Fiji Dollar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_FJD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_FKP",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "FKP",
    238,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Falkland Islands Pound", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_FKP", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_GBP",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "£",
    undefined,
    "GBP",
    826,
    [],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Sterling", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_GBP", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_GBP-PER-KiloW-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M-1H0T2D0",
    new Decimal("2.777777777777777777777777777777778E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "£/(kW·h)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Sterling per Kilowatt Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/CostPerEnergy");
  config.units.set("http://qudt.org/vocab/unit/CCY_GBP-PER-KiloW-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_GEL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "₾",
    undefined,
    "GEL",
    981,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Lari", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_GEL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_GHS",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "GHS",
    936,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cedi", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_GHS", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_GIP",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "GIP",
    292,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gibraltar Pound", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_GIP", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_GMD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "GMD",
    270,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Dalasi", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_GMD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_GNF",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "GNF",
    324,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Guinea Franc", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_GNF", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_GTQ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "GTQ",
    320,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Quetzal", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_GTQ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_GYD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "GYD",
    328,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Guyana Dollar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_GYD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_HKD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "$",
    undefined,
    "HKD",
    344,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Hong Kong Dollar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_HKD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_HNL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "HNL",
    340,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Lempira", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_HNL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_HRK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "HRK",
    191,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Croatian Kuna", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_HRK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_HTG",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "HTG",
    332,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Haiti Gourde", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_HTG", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_HUF",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Ft",
    undefined,
    "HUF",
    348,
    [],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Forint", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_HUF", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_HUF-PER-KiloW-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M-1H0T2D0",
    new Decimal("2.777777777777777777777777777777778E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Ft/(kW·h)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Forint per Kilowatt Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/CostPerEnergy");
  config.units.set("http://qudt.org/vocab/unit/CCY_HUF-PER-KiloW-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_IDR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Rp",
    undefined,
    "IDR",
    360,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Rupiah", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_IDR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_ILS",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "₪",
    undefined,
    "ILS",
    376,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("New Israeli Shekel", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_ILS", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_INR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "₹",
    undefined,
    "INR",
    356,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Indian Rupee", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_INR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_IQD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "IQD",
    368,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Iraqi Dinar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_IQD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_IRR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "IRR",
    364,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Iranian Rial", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_IRR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_ISK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kr",
    undefined,
    "ISK",
    352,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Iceland Krona", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_ISK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_JMD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "JMD",
    388,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Jamaican Dollar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_JMD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_JOD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "JOD",
    400,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Jordanian Dinar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_JOD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_JPY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "¥",
    undefined,
    "JPY",
    392,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Japanese Yen", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_JPY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_KES",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "KES",
    404,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kenyan Shilling", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_KES", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_KGS",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "KGS",
    417,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Som", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_KGS", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_KHR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "KHR",
    116,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Riel", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_KHR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_KMF",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "KMF",
    174,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Comoro Franc", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_KMF", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_KPW",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "KPW",
    408,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("North Korean Won", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_KPW", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_KRW",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "₩",
    undefined,
    "KRW",
    410,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("South Korean Won", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_KRW", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_KWD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "KWD",
    414,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kuwaiti Dinar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_KWD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_KYD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "KYD",
    136,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cayman Islands Dollar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_KYD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_KZT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "KZT",
    398,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Tenge", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_KZT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_LAK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    " ₭",
    undefined,
    "LAK",
    418,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Lao Kip", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_LAK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_LBP",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "LBP",
    422,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Lebanese Pound", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_LBP", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_LKR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "LKR",
    144,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Sri Lanka Rupee", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_LKR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_LRD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "LRD",
    430,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Liberian Dollar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_LRD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_LSL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "LSL",
    426,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Loti", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_LSL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_LTL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "LTL",
    440,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Lithuanian Litas", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_LTL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_LVL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "LVL",
    428,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Latvian Lats", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_LVL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_LYD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "LYD",
    434,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Libyan Dinar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_LYD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_MAD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "MAD",
    504,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Moroccan Dirham", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_MAD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_MDL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "L",
    undefined,
    "MDL",
    498,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Moldovan Leu", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_MDL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_MGA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "MGA",
    969,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Malagasy Ariary", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_MGA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_MKD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ден",
    undefined,
    "MKD",
    807,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Denar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_MKD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_MMK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "MMK",
    104,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kyat", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_MMK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_MNT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Mongolian Tugrik", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_MNT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_MOP",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "MOP",
    446,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pataca", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_MOP", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_MRU",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "MRU",
    929,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ouguiya", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_MRU", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_MTL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "MTL",
    470,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Maltese Lira", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_MTL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_MUR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "MUR",
    480,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Mauritius Rupee", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_MUR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_MVR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "MVR",
    462,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Rufiyaa", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_MVR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_MWK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "MWK",
    454,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Malawi Kwacha", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_MWK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_MXN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "$",
    undefined,
    "MXN",
    484,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Mexican Peso", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_MXN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_MXV",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "MXV",
    979,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Mexican Unidad De Inversion (udi) (funds Code)", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_MXV", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_MYR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "RM",
    undefined,
    "MYR",
    458,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Malaysian Ringgit", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_MYR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_MZN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "MZN",
    943,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Metical", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_MZN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_NAD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "NAD",
    516,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Namibian Dollar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_NAD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_NGN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "NGN",
    566,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Naira", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_NGN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_NIO",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "NIO",
    558,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cordoba Oro", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_NIO", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_NOK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kr",
    undefined,
    "NOK",
    578,
    [],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Norwegian Krone", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_NOK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_NOK-PER-KiloW-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M-1H0T2D0",
    new Decimal("2.777777777777777777777777777777778E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kr/(kW·h)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Norwegian Krone per Kilowatt Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/CostPerEnergy");
  config.units.set("http://qudt.org/vocab/unit/CCY_NOK-PER-KiloW-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_NPR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "NPR",
    524,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Nepalese Rupee", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_NPR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_NZD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "$",
    undefined,
    "NZD",
    554,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("New Zealand Dollar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_NZD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_OMR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "OMR",
    512,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Rial Omani", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_OMR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_PAB",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "PAB",
    590,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Balboa", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_PAB", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_PEN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "PEN",
    604,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Nuevo Sol", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_PEN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_PGK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "PGK",
    598,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kina", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_PGK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_PHP",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "₱",
    undefined,
    "PHP",
    608,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Philippine Peso", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_PHP", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_PKR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "PKR",
    586,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pakistan Rupee", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_PKR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_PLN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "zł",
    undefined,
    "PLN",
    985,
    [],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Zloty", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_PLN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_PLN-PER-KiloW-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M-1H0T2D0",
    new Decimal("2.777777777777777777777777777777778E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "zł/(kW·h)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Zloty per Kilowatt Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/CostPerEnergy");
  config.units.set("http://qudt.org/vocab/unit/CCY_PLN-PER-KiloW-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_PYG",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "PYG",
    600,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Guarani", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_PYG", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_QAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "QAR",
    634,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Qatari Rial", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_QAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_RON",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "L",
    undefined,
    "RON",
    946,
    [],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Romanian New Leu", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_RON", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_RON-PER-KiloW-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M-1H0T2D0",
    new Decimal("2.777777777777777777777777777777778E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "L/(kW·h)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Romanian New Leu per Kilowatt Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/CostPerEnergy");
  config.units.set("http://qudt.org/vocab/unit/CCY_RON-PER-KiloW-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_RSD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "дин",
    undefined,
    "RSD",
    941,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Serbian Dinar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_RSD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_RUB",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "₽",
    undefined,
    "RUB",
    643,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Russian Ruble", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_RUB", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_RWF",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "RWF",
    646,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Rwanda Franc", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_RWF", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_SAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "﷼",
    undefined,
    "SAR",
    682,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Saudi Riyal", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_SAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_SBD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "SBD",
    90,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Solomon Islands Dollar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_SBD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_SCR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "SCR",
    690,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Seychelles Rupee", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_SCR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_SDG",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "SDG",
    938,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Sudanese Pound", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_SDG", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_SEK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kr",
    undefined,
    "SEK",
    752,
    [],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Swedish Krona", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_SEK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_SEK-PER-KiloW-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M-1H0T2D0",
    new Decimal("2.777777777777777777777777777777778E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kr/(kW·h)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Swedish Krona per Kilowatt Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/CostPerEnergy");
  config.units.set("http://qudt.org/vocab/unit/CCY_SEK-PER-KiloW-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_SGD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "$",
    undefined,
    "SGD",
    702,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Singapore Dollar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_SGD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_SHP",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "SHP",
    654,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Saint Helena Pound", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_SHP", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_SKK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Sk",
    undefined,
    "SKK",
    703,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Slovak Koruna", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_SKK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_SLE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "SLE",
    925,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Leone", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_SLE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_SOS",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "SOS",
    706,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Somali Shilling", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_SOS", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_SRD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "SRD",
    968,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Surinam Dollar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_SRD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_STN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "STN",
    930,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Dobra", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_STN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_SYP",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "SYP",
    760,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Syrian Pound", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_SYP", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_SZL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "SZL",
    748,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Lilangeni", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_SZL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_THB",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "฿",
    undefined,
    "THB",
    764,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Baht", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_THB", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_TJS",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "TJS",
    972,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Somoni", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_TJS", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_TMT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "TMT",
    934,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Manat", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_TMT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_TND",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "TND",
    788,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Tunisian Dinar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_TND", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_TOP",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "TOP",
    776,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pa'anga", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_TOP", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_TRY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "₺",
    undefined,
    "TRY",
    949,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("New Turkish Lira", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_TRY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_TTD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "TTD",
    780,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Trinidad and Tobago Dollar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_TTD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_TWD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "$",
    undefined,
    "TWD",
    901,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("New Taiwan Dollar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_TWD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_TZS",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "TZS",
    834,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Tanzanian Shilling", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_TZS", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_UAH",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "₴",
    undefined,
    "UAH",
    980,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Hryvnia", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_UAH", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_UGX",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "UGX",
    800,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Uganda Shilling", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_UGX", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_USD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "$",
    undefined,
    "USD",
    840,
    [],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Us Dollar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_USD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_USN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "USN",
    997,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("United States Dollar (next Day) (funds Code)", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_USN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_USS",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "USS",
    998,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("United States Dollar (same Day) (funds Code)", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_USS", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_UYU",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "UYU",
    858,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Peso Uruguayo", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_UYU", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_UZS",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "UZS",
    860,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Uzbekistan Som", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_UZS", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_VES",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "VES",
    928,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Venezuelan Bolvar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_VES", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_VND",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "VND",
    704,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Vietnamese ??ng", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_VND", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_VUV",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "VUV",
    548,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Vatu", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_VUV", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_WST",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "WST",
    882,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Samoan Tala", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_WST", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_XAF",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "XAF",
    950,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cfa Franc Beac", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_XAF", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_XAG",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "XAG",
    961,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Silver (one Troy Ounce)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_XAG", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_XAU",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "XAU",
    959,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gold (one Troy Ounce)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_XAU", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_XBA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "XBA",
    955,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("European Composite Unit (eurco) (bonds Market Unit)", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_XBA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_XBB",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "XBB",
    956,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "European Monetary Unit (e.m.u.-6) (bonds Market Unit)",
      "en"
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_XBB", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_XBC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "XBC",
    957,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "European Unit of Account 9 (e.u.a.-9) (bonds Market Unit)",
      "en"
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_XBC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_XBD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "XBD",
    958,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "European Unit of Account 17 (e.u.a.-17) (bonds Market Unit)",
      "en"
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_XBD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_XCD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "XCD",
    951,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("East Caribbean Dollar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_XCD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_XDR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "XDR",
    960,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Special Drawing Rights", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_XDR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_XFO",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "XFO",
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Gold Franc (special Settlement Currency)", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_XFO", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_XFU",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "XFU",
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Uic Franc (special Settlement Currency)", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_XFU", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_XOF",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "XOF",
    952,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cfa Franc Bceao", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_XOF", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_XPD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "XPD",
    964,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Palladium (one Troy Ounce)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_XPD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_XPF",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "XPF",
    953,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cfp Franc", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_XPF", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_XPT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "XPT",
    962,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Platinum (one Troy Ounce)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_XPT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_YER",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "YER",
    886,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Yemeni Rial", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_YER", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_ZAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "R",
    undefined,
    "ZAR",
    710,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("South African Rand", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_ZAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_ZMW",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "ZMW",
    967,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Zambian Kwacha", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_ZMW", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CCY_ZWL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "ZWL",
    932,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Zimbabwe Dollar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/CCY_ZWL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I1M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cd",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    21,
    false,
    false
  );
  unit.addLabel(new LangString("Candela", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LuminousIntensity"
  );
  config.units.set("http://qudt.org/vocab/unit/CD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CD-PER-FT2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I1M0H0T0D0",
    new Decimal("10.7639104167097223083335055559"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cd/ft²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Candela per Square Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Luminance");
  config.units.set("http://qudt.org/vocab/unit/CD-PER-FT2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CD-PER-IN2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I1M0H0T0D0",
    new Decimal("1550.0031000062000124000248000496"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cd/in²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Candela per Square Inch", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Luminance");
  config.units.set("http://qudt.org/vocab/unit/CD-PER-IN2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CD-PER-KiloLM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cd/klm",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Candela per Kilolumen", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LuminousIntensityDistribution"
  );
  config.units.set("http://qudt.org/vocab/unit/CD-PER-KiloLM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CD-PER-LM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cd/lm",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Candela per Lumen", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LuminousIntensityDistribution"
  );
  config.units.set("http://qudt.org/vocab/unit/CD-PER-LM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CD-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I1M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cd/m²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    3,
    false,
    false
  );
  unit.addLabel(new LangString("Candela per Square Meter", "en-US"));
  unit.addLabel(new LangString("Candela per Square Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Luminance");
  config.units.set("http://qudt.org/vocab/unit/CD-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CD_IN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I1M0H0T0D0",
    new Decimal("0.92"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/CD",
    undefined,
    "international candle",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("International Candle", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LuminousIntensity"
  );
  config.units.set("http://qudt.org/vocab/unit/CD_IN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CH",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("20.1168"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M",
    undefined,
    "ch",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Chain", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/CH", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CHAIN_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("20.1168"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M",
    undefined,
    "ch (US survey)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Chain (based on U.s. Survey Foot)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/CHAIN_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CHF",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    true
  );
  unit.addLabel(new LangString("CHF", undefined));
  config.units.set("http://qudt.org/vocab/unit/CHF", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CHF-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "CHF/kg",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("Swiss Francs per KiloGram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/CostPerMass");
  config.units.set("http://qudt.org/vocab/unit/CHF-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CI",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("37000000000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/BQ",
    undefined,
    "Ci",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    7,
    false,
    false
  );
  unit.addLabel(new LangString("Curie", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Activity");
  config.units.set("http://qudt.org/vocab/unit/CI", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CI-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T-1D0",
    new Decimal("37000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Ci/kg",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Curie per Kilogram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassicActivity");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificActivity"
  );
  config.units.set("http://qudt.org/vocab/unit/CI-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CLO",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H1T3D0",
    new Decimal("0.155"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M2-K-PER-W",
    undefined,
    "clo",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Clo", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalInsulance"
  );
  config.units.set("http://qudt.org/vocab/unit/CLO", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CM_H2O",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    undefined,
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/PA",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    true
  );
  unit.addLabel(new LangString("CM_H2O", undefined));
  config.units.set("http://qudt.org/vocab/unit/CM_H2O", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CORD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("3.62"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M3",
    undefined,
    "cord",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cord", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DryVolume");
  config.units.set("http://qudt.org/vocab/unit/CORD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/COUNT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Count", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Count");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Dimensionless");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/NUM");
  config.units.set("http://qudt.org/vocab/unit/COUNT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CP",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I1M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/CD",
    undefined,
    "cp",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Candlepower", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LuminousIntensity"
  );
  config.units.set("http://qudt.org/vocab/unit/CP", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CUP",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.00023658825"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M3",
    undefined,
    "cup",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Us Liquid Cup", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LiquidVolume");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/CUP_US");
  config.units.set("http://qudt.org/vocab/unit/CUP", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CUP_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.00023658825"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M3",
    undefined,
    "cup{US}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cup (US)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LiquidVolume");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/CUP");
  config.units.set("http://qudt.org/vocab/unit/CUP_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CWT_LONG",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("50.80235"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "cwt{long}",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Long Hundred Weight", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/Hundredweight_UK");
  config.units.set("http://qudt.org/vocab/unit/CWT_LONG", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CWT_SHORT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("45.359237"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "cwt{short}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Hundred Weight - Short", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/Hundredweight_US");
  config.units.set("http://qudt.org/vocab/unit/CWT_SHORT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CYC",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    true
  );
  unit.addLabel(new LangString("CYC", undefined));
  config.units.set("http://qudt.org/vocab/unit/CYC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CYC-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "c/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cycles per Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/RotationalFrequency"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/RotationalVelocity"
  );
  unit.addExactMatchIri("http://qudt.org/vocab/unit/HZ");
  config.units.set("http://qudt.org/vocab/unit/CYC-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/C_Ab",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("10.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/A-SEC",
    undefined,
    "abC",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-EMU", "http://qudt.org/vocab/sou/CGS"],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Abcoulomb", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  config.units.set("http://qudt.org/vocab/unit/C_Ab", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/C_Ab-PER-CentiM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H0T1D0",
    new Decimal("100000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "abC/cm²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-EMU", "http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Abcoulomb per Square Centimetre", "en"));
  unit.addLabel(new LangString("Abcoulomb per Square Centimeter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerArea"
  );
  config.units.set("http://qudt.org/vocab/unit/C_Ab-PER-CentiM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/C_Stat",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("3.3356409519815204957557671447492E-10"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/C",
    undefined,
    "statC",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS", "http://qudt.org/vocab/sou/CGS-ESU"],
    2,
    false,
    false
  );
  unit.addLabel(new LangString("Statcoulomb", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/FR");
  config.units.set("http://qudt.org/vocab/unit/C_Stat", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/C_Stat-PER-CentiM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H0T1D0",
    new Decimal("0.0000033356409519815204957557671447492"),
    undefined,
    undefined,
    undefined,
    undefined,
    "statC/cm²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS", "http://qudt.org/vocab/sou/CGS-ESU"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Statcoulomb per Square Centimeter", "en-US"));
  unit.addLabel(new LangString("Statcoulomb per Square Centimetre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerArea"
  );
  config.units.set("http://qudt.org/vocab/unit/C_Stat-PER-CentiM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/C_Stat-PER-MOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A-1E1L0I0M0H0T1D0",
    new Decimal("3.3356409519815204957557671447492E-10"),
    undefined,
    undefined,
    undefined,
    undefined,
    "statC/mol",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Statcoulomb per Mole", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerAmountOfSubstance"
  );
  config.units.set("http://qudt.org/vocab/unit/C_Stat-PER-MOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiBAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("1000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Centi",
    "http://qudt.org/vocab/unit/BAR",
    undefined,
    "cbar",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Centibar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/CentiBAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("0.01"),
    undefined,
    "http://qudt.org/vocab/prefix/Centi",
    "http://qudt.org/vocab/unit/C",
    undefined,
    "cC",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Centicoulomb", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  config.units.set("http://qudt.org/vocab/unit/CentiC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("0.00001"),
    undefined,
    "http://qudt.org/vocab/prefix/Centi",
    "http://qudt.org/vocab/unit/GM",
    undefined,
    "cg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Centigram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  config.units.set("http://qudt.org/vocab/unit/CentiGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiGRAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("0.01"),
    undefined,
    "http://qudt.org/vocab/prefix/Centi",
    "http://qudt.org/vocab/unit/GRAY",
    undefined,
    "cGy",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Centigray", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AbsorbedDose");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Kerma");
  config.units.set("http://qudt.org/vocab/unit/CentiGRAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.00001"),
    undefined,
    "http://qudt.org/vocab/prefix/Centi",
    "http://qudt.org/vocab/unit/L",
    undefined,
    "cL",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Centilitre", "en"));
  unit.addLabel(new LangString("Centiliter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LiquidVolume");
  config.units.set("http://qudt.org/vocab/unit/CentiL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("0.01"),
    undefined,
    "http://qudt.org/vocab/prefix/Centi",
    "http://qudt.org/vocab/unit/M",
    undefined,
    "cm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    156,
    false,
    false
  );
  unit.addLabel(new LangString("Centimeter", "en-US"));
  unit.addLabel(new LangString("Centimetre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/CentiM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M-1H0T2D0",
    new Decimal("1E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm/bar",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Centimetre per Bar", "en"));
  unit.addLabel(new LangString("Centimeter per Bar", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/CentiM-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("0.000002777777777777777777777777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm/h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Centimetre per Hour", "en"));
  unit.addLabel(new LangString("Centimeter per Hour", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/CentiM-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H-1T0D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm/K",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Centimetre per Kelvin", "en"));
  unit.addLabel(new LangString("Centimeter per Kelvin", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearThermalExpansion"
  );
  config.units.set("http://qudt.org/vocab/unit/CentiM-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM-PER-KiloYR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("3.168808781402895023702689684893655E-13"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm/ka",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Centimeter per Kiloyear", "en-US"));
  unit.addLabel(new LangString("Centimetre per Kiloyear", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/CentiM-PER-KiloYR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Centimeter per Second", "en-US"));
  unit.addLabel(new LangString("Centimetre per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/CentiM-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM-PER-SEC-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M-1H0T1D0",
    new Decimal("1E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm/(s·bar)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Centimetre per Second Bar", "en"));
  unit.addLabel(new LangString("Centimeter per Second Bar", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/CentiM-PER-SEC-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM-PER-SEC-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H-1T-1D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm/(s·K)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Centimetre per Second Kelvin", "en"));
  unit.addLabel(new LangString("Centimeter per Second Kelvin", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/CentiM-PER-SEC-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM-PER-SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-2D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm/s²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Centimeter per Square Second", "en-US"));
  unit.addLabel(new LangString("Centimetre per Square Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Acceleration");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearAcceleration"
  );
  config.units.set("http://qudt.org/vocab/unit/CentiM-PER-SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM-PER-YR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("3.168808781402895023702689684893655E-10"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm/a",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Centimetre per Year", "en"));
  unit.addLabel(new LangString("Centimeter per Year", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/CentiM-PER-YR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM-SEC-DEG_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H1T1D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm·s·°C",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI", "http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Centimetre Second Degree Celsius", "en"));
  unit.addLabel(new LangString("Centimeter Second Degree Celsius", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LengthTemperatureTime"
  );
  config.units.set("http://qudt.org/vocab/unit/CentiM-SEC-DEG_C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    new Decimal("0.0001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Centimeter", "en-US"));
  unit.addLabel(new LangString("Square Centimetre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/HydraulicPermeability"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Area");
  config.units.set("http://qudt.org/vocab/unit/CentiM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM2-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T1D0",
    new Decimal("0.006"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm²·min",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Centimetre Minute", "en"));
  unit.addLabel(new LangString("Square Centimeter Minute", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AreaTime");
  config.units.set("http://qudt.org/vocab/unit/CentiM2-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM2-PER-CentiM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("100.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm²/cm³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Square Centimeter per Cubic Centimeter", "en-US")
  );
  unit.addLabel(new LangString("Square Centimetre per Cubic Centimetre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/CentiM2-PER-CentiM3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM2-PER-ERG",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T2D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm²/erg",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Centimeter per Erg", "en-US"));
  unit.addLabel(new LangString("Square Centimetre per Erg", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpectralCrossSection"
  );
  config.units.set("http://qudt.org/vocab/unit/CentiM2-PER-ERG", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM2-PER-GM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M-1H0T0D0",
    new Decimal("0.1"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm²/g",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Centimeter per Gram", "en-US"));
  unit.addLabel(new LangString("Square Centimetre per Gram", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassAttenuationCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificSurfaceArea"
  );
  config.units.set("http://qudt.org/vocab/unit/CentiM2-PER-GM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM2-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-1D0",
    new Decimal("0.0001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm²/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Centimetre per Second", "en"));
  unit.addLabel(new LangString("Square Centimeter per Second", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AreaPerTime");
  config.units.set("http://qudt.org/vocab/unit/CentiM2-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM2-PER-SR-ERG",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T2D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm²/(sr·erg)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Centimetre per Steradian Erg", "en"));
  unit.addLabel(new LangString("Square Centimeter per Steradian Erg", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpectralAngularCrossSection"
  );
  config.units.set("http://qudt.org/vocab/unit/CentiM2-PER-SR-ERG", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM2-PER-V-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M-1H0T2D0",
    new Decimal("0.0001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm²/(V·s)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Centimetre per Volt Second", "en"));
  unit.addLabel(new LangString("Square Centimeter per Volt Second", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mobility");
  config.units.set("http://qudt.org/vocab/unit/CentiM2-PER-V-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM2-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T1D0",
    new Decimal("0.0001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm²·s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Centimetre Second", "en"));
  unit.addLabel(new LangString("Square Centimeter Second", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AreaTime");
  config.units.set("http://qudt.org/vocab/unit/CentiM2-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Centimeter", "en-US"));
  unit.addLabel(new LangString("Cubic Centimetre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/CentiM3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM3-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M-1H0T2D0",
    new Decimal("1E-11"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm³/bar",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Centimetre per Bar", "en"));
  unit.addLabel(new LangString("Cubic Centimeter per Bar", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/CentiM3-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM3-PER-CentiM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm³/cm³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Centimetre per Cubic Centimetre", "en"));
  unit.addLabel(
    new LangString("Cubic Centimeter per Cubic Centimeter", "en-US")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFraction");
  config.units.set("http://qudt.org/vocab/unit/CentiM3-PER-CentiM3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM3-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("1.157407407407407407407407407407407E-11"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm³/d",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Centimeter per Day", "en-US"));
  unit.addLabel(new LangString("Cubic Centimetre per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/CentiM3-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM3-PER-DAY-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M-1H0T1D0",
    new Decimal("1.157407407407407407407407407407407E-16"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm³/(d·bar)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Centimetre per Day Bar", "en"));
  unit.addLabel(new LangString("Cubic Centimeter per Day Bar", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/CentiM3-PER-DAY-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM3-PER-DAY-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H-1T-1D0",
    new Decimal("1.157407407407407407407407407407407E-11"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm³/(d·K)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Centimeter per Day Kelvin", "en-US"));
  unit.addLabel(new LangString("Cubic Centimetre per Day Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/CentiM3-PER-DAY-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM3-PER-GM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M-1H0T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm³/g",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Centimetre per Gram", "en"));
  unit.addLabel(new LangString("Cubic Centimeter per Gram", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoilAdsorptionCoefficient"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificVolume");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/MilliL-PER-GM");
  config.units.set("http://qudt.org/vocab/unit/CentiM3-PER-GM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM3-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("2.777777777777777777777777777777778E-10"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm³/h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Centimetre per Hour", "en"));
  unit.addLabel(new LangString("Cubic Centimeter per Hour", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/CentiM3-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM3-PER-HR-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M-1H0T1D0",
    new Decimal("2.777777777777777777777777777777778E-15"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm³/(h·bar)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Centimeter per Hour Bar", "en-US"));
  unit.addLabel(new LangString("Cubic Centimetre per Hour Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/CentiM3-PER-HR-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM3-PER-HR-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H-1T-1D0",
    new Decimal("2.777777777777777777777777777777778E-10"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm³/(h·K)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Centimeter per Hour Kelvin", "en-US"));
  unit.addLabel(new LangString("Cubic Centimetre per Hour Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/CentiM3-PER-HR-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM3-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H-1T0D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm³/K",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Centimetre per Kelvin", "en"));
  unit.addLabel(new LangString("Cubic Centimeter per Kelvin", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/VolumeThermalExpansion"
  );
  config.units.set("http://qudt.org/vocab/unit/CentiM3-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM3-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm³/m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Centimeter per Cubic Meter", "en-US"));
  unit.addLabel(new LangString("Cubic Centimetre per Cubic Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFraction");
  config.units.set("http://qudt.org/vocab/unit/CentiM3-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM3-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("1.666666666666666666666666666666667E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm³/min",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Centimeter per Minute", "en-US"));
  unit.addLabel(new LangString("Cubic Centimetre per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/CentiM3-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM3-PER-MIN-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M-1H0T1D0",
    new Decimal("1.666666666666666666666666666666667E-13"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm³/(min·bar)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Centimetre per Minute Bar", "en"));
  unit.addLabel(new LangString("Cubic Centimeter per Minute Bar", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/CentiM3-PER-MIN-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM3-PER-MIN-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H-1T-1D0",
    new Decimal("1.666666666666666666666666666666667E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm³/(min·K)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Centimeter per Minute Kelvin", "en-US"));
  unit.addLabel(new LangString("Cubic Centimetre per Minute Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/CentiM3-PER-MIN-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM3-PER-MOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A-1E0L3I0M0H0T0D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm³/mol",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Centimetre per Mole", "en"));
  unit.addLabel(new LangString("Cubic Centimeter per Mole", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MolarVolume");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MolarRefractivity"
  );
  config.units.set("http://qudt.org/vocab/unit/CentiM3-PER-MOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM3-PER-MOL-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A-1E0L3I0M0H0T-1D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm³/(mol·s)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Centimeter per Mole Second", "en-US"));
  unit.addLabel(new LangString("Cubic Centimetre per Mole Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SecondOrderReactionRateConstant"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AtmosphericHydroxylationRate"
  );
  config.units.set("http://qudt.org/vocab/unit/CentiM3-PER-MOL-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM3-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm³/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Centimetre per Second", "en"));
  unit.addLabel(new LangString("Cubic Centimeter per Second", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/CentiM3-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM3-PER-SEC-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M-1H0T1D0",
    new Decimal("1E-11"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm³/(s·bar)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Centimetre per Second Bar", "en"));
  unit.addLabel(new LangString("Cubic Centimeter per Second Bar", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/CentiM3-PER-SEC-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM3-PER-SEC-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H-1T-1D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm³/(s·K)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Centimetre per Second Kelvin", "en"));
  unit.addLabel(new LangString("Cubic Centimeter per Second Kelvin", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/CentiM3-PER-SEC-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM4",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M0H0T0D0",
    new Decimal("1E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm⁴",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Quartic Centimeter", "en-US"));
  unit.addLabel(new LangString("Quartic Centimetre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SecondMomentOfArea"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SecondAxialMomentOfArea"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SecondPolarMomentOfArea"
  );
  config.units.set("http://qudt.org/vocab/unit/CentiM4", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM6",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L6I0M0H0T0D0",
    new Decimal("1E-12"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm⁶",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Sextic Centimetre", "en"));
  unit.addLabel(new LangString("Sextic Centimeter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/WarpingConstant");
  config.units.set("http://qudt.org/vocab/unit/CentiM6", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiMOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T0D0",
    new Decimal("0.01"),
    undefined,
    "http://qudt.org/vocab/prefix/Centi",
    "http://qudt.org/vocab/unit/MOL",
    undefined,
    "cmol",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    2,
    false,
    false
  );
  unit.addLabel(new LangString("Centimole", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstance"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ExtentOfReaction"
  );
  config.units.set("http://qudt.org/vocab/unit/CentiMOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiMOL-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M-1H0T0D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cmol/kg",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Centimole per Kilogram", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstancePerMass"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/IonicStrength");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MolalityOfSolute"
  );
  config.units.set("http://qudt.org/vocab/unit/CentiMOL-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiMOL-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T0D0",
    new Decimal("10.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cmol/L",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Centimole per Litre", "en"));
  unit.addLabel(new LangString("Centimole per Liter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Concentration");
  config.units.set("http://qudt.org/vocab/unit/CentiMOL-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM_H2O",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("98.0665"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/PA",
    undefined,
    "cmH₂0",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Conventional Centimeter of Water", "en-US"));
  unit.addLabel(new LangString("Conventional Centimetre of Water", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/CentiM_H2O_4DEG_C");
  config.units.set("http://qudt.org/vocab/unit/CentiM_H2O", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM_H2O_4DEG_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("98.0665"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/PA",
    undefined,
    "cmH₂O (4 °C)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Centimetre of Water (4 °C)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/CentiM_H2O");
  config.units.set("http://qudt.org/vocab/unit/CentiM_H2O_4DEG_C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM_HG",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("1333.224"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/PA",
    undefined,
    "cmHg",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Centimetre of Mercury", "en"));
  unit.addLabel(new LangString("Centimeter of Mercury", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/CentiM_HG_0DEG_C");
  config.units.set("http://qudt.org/vocab/unit/CentiM_HG", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM_HG_0DEG_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("1333.224"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/PA",
    undefined,
    "cmHg (0 °C)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Centimetre of Mercury (0 °C)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/CentiM_HG");
  config.units.set("http://qudt.org/vocab/unit/CentiM_HG_0DEG_C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("0.01"),
    undefined,
    "http://qudt.org/vocab/prefix/Centi",
    "http://qudt.org/vocab/unit/N",
    undefined,
    "cN",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    2,
    false,
    false
  );
  unit.addLabel(new LangString("Centinewton", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Force");
  config.units.set("http://qudt.org/vocab/unit/CentiN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiN-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cN·m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Centinewton Meter", "en-US"));
  unit.addLabel(new LangString("Centinewton Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MomentOfForce");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Torque");
  config.units.set("http://qudt.org/vocab/unit/CentiN-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiN-M-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cN·m/m²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Centinewton Metre per Square Metre", "en"));
  unit.addLabel(new LangString("Centinewton Meter per Square Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerLength");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyPerArea");
  config.units.set("http://qudt.org/vocab/unit/CentiN-M-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiPOISE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-1D0",
    new Decimal("0.001"),
    undefined,
    "http://qudt.org/vocab/prefix/Centi",
    "http://qudt.org/vocab/unit/POISE",
    undefined,
    "cP",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-GAUSS", "http://qudt.org/vocab/sou/CGS"],
    7,
    false,
    false
  );
  unit.addLabel(new LangString("Centipoise", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DynamicViscosity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Viscosity");
  config.units.set("http://qudt.org/vocab/unit/CentiPOISE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiPOISE-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("1E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cP/bar",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Centipoise per Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/CentiPOISE-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiPOISE-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H-1T-1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cP/K",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Centipoise per Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/CentiPOISE-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiST",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-1D0",
    new Decimal("0.000001"),
    undefined,
    "http://qudt.org/vocab/prefix/Centi",
    "http://qudt.org/vocab/unit/ST",
    undefined,
    "cSt",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Centistokes", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/KinematicViscosity"
  );
  config.units.set("http://qudt.org/vocab/unit/CentiST", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/Ci",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("37000000000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/BQ",
    undefined,
    "Ci",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("Curie", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Activity");
  config.units.set("http://qudt.org/vocab/unit/Ci", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("1.66053878283E-27"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "Da",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Dalton", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MolecularMass");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/AMU");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/U");
  config.units.set("http://qudt.org/vocab/unit/DA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DARCY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    new Decimal("9.869233E-13"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M2",
    undefined,
    "d",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI", "http://qudt.org/vocab/sou/CGS"],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Darcy", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/HydraulicPermeability"
  );
  config.units.set("http://qudt.org/vocab/unit/DARCY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("86400.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/SEC",
    undefined,
    "d",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    94,
    false,
    false
  );
  unit.addLabel(new LangString("Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/BiodegredationHalfLife"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/FishBiotransformationHalfLife"
  );
  config.units.set("http://qudt.org/vocab/unit/DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DAY-PER-NUM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("86400.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "d/#",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Day per Number", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/TimePerCount");
  config.units.set("http://qudt.org/vocab/unit/DAY-PER-NUM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DAY_Sidereal",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("86164.099"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/SEC",
    undefined,
    "day{sidereal}",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Sidereal Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/DAY_Sidereal", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEATHS",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    [],
    2,
    false,
    true
  );
  unit.addLabel(new LangString("DEATHS", undefined));
  config.units.set("http://qudt.org/vocab/unit/DEATHS", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEATHS-PER-KiloINDIV-YR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("3.1688E-11"),
    undefined,
    undefined,
    undefined,
    undefined,
    "deaths/1000 individuals/a",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Deaths per 1000 Individuals Year", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MortalityRate");
  config.units.set("http://qudt.org/vocab/unit/DEATHS-PER-KiloINDIV-YR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEATHS-PER-MegaINDIV-YR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("3.1688E-14"),
    undefined,
    undefined,
    undefined,
    undefined,
    "deaths/million individuals/a",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Deaths per Million Individuals Year", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MortalityRate");
  config.units.set("http://qudt.org/vocab/unit/DEATHS-PER-MegaINDIV-YR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEBYE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L1I0M0H0T1D0",
    new Decimal("3.33564E-30"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/C-M",
    undefined,
    "D",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Debye", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricDipoleMoment"
  );
  config.units.set("http://qudt.org/vocab/unit/DEBYE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DECADE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "dec",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Dec", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Dimensionless");
  config.units.set("http://qudt.org/vocab/unit/DECADE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.0174532925"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/RAD",
    undefined,
    "°",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    12,
    false,
    false
  );
  unit.addLabel(new LangString("Degree", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PlaneAngle");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Angle");
  config.units.set("http://qudt.org/vocab/unit/DEG", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("0.000004848136805555555555555555555555556"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Degree per Hour", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AngularFrequency"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AngularVelocity");
  config.units.set("http://qudt.org/vocab/unit/DEG-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("0.0174532925"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°/m",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Degree per Meter", "en-US"));
  unit.addLabel(new LangString("Degree per Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/FermiAngularWavenumber"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DebyeAngularWavenumber"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AngularWavenumber"
  );
  config.units.set("http://qudt.org/vocab/unit/DEG-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("0.0002908882083333333333333333333333334"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°/min",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Degree per Minute", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AngularFrequency"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AngularVelocity");
  config.units.set("http://qudt.org/vocab/unit/DEG-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("0.0174532925"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Degree per Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AngularFrequency"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AngularVelocity");
  config.units.set("http://qudt.org/vocab/unit/DEG-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG-PER-SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-2D0",
    new Decimal("0.0174532925"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°/s²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Degree per Square Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AngularAcceleration"
  );
  config.units.set("http://qudt.org/vocab/unit/DEG-PER-SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.00030461741909055625"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Degree", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SolidAngle");
  config.units.set("http://qudt.org/vocab/unit/DEG2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEGREE_API",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°API",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Degree Api", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/APIGravity");
  config.units.set("http://qudt.org/vocab/unit/DEGREE_API", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEGREE_BALLING",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°Balling",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Degree Balling", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  config.units.set("http://qudt.org/vocab/unit/DEGREE_BALLING", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEGREE_BAUME",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°Bé{origin}",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Degree Baume (origin Scale)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  config.units.set("http://qudt.org/vocab/unit/DEGREE_BAUME", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEGREE_BAUME_US_HEAVY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°Bé{US Heavy}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Degree Baume (us Heavy)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  config.units.set("http://qudt.org/vocab/unit/DEGREE_BAUME_US_HEAVY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEGREE_BAUME_US_LIGHT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°Bé{US Light}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Degree Baume (us Light)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  config.units.set("http://qudt.org/vocab/unit/DEGREE_BAUME_US_LIGHT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEGREE_BRIX",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°Bx",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Degree Brix", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  config.units.set("http://qudt.org/vocab/unit/DEGREE_BRIX", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEGREE_OECHSLE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°Oe",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Degree Oechsle", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  config.units.set("http://qudt.org/vocab/unit/DEGREE_OECHSLE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEGREE_PLATO",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°P",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Degree Plato", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  config.units.set("http://qudt.org/vocab/unit/DEGREE_PLATO", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEGREE_TWADDELL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°Tw",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Degree Twaddell", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  config.units.set("http://qudt.org/vocab/unit/DEGREE_TWADDELL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T0D0",
    new Decimal("1.0"),
    new Decimal("273.15"),
    undefined,
    "http://qudt.org/vocab/unit/K",
    undefined,
    "°C",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI", "http://qudt.org/vocab/sou/CGS"],
    38,
    false,
    false
  );
  unit.addLabel(new LangString("Degree Celsius", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MeltingPoint");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/BoilingPoint");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Temperature");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/FlashPoint");
  config.units.set("http://qudt.org/vocab/unit/DEG_C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_C-CentiM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H1T0D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°C·cm",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI", "http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Degree Celsius Centimetre", "en"));
  unit.addLabel(new LangString("Degree Celsius Centimeter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LengthTemperature"
  );
  config.units.set("http://qudt.org/vocab/unit/DEG_C-CentiM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_C-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T1D0",
    new Decimal("86400.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°C·d",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI", "http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Degree Celsius Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/TimeTemperature");
  config.units.set("http://qudt.org/vocab/unit/DEG_C-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_C-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T1D0",
    new Decimal("3600.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°C·h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI", "http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Degree Celsius Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/TimeTemperature");
  config.units.set("http://qudt.org/vocab/unit/DEG_C-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_C-KiloGM-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H1T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°C·kg/m²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI", "http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Degree Celsius Kilogram per Square Metre", "en")
  );
  unit.addLabel(
    new LangString("Degree Celsius Kilogram per Square Meter", "en-US")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/DEG_C-KiloGM-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_C-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H1T2D0",
    new Decimal("0.00001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°C/bar",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Degree Celsius per Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/DEG_C-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_C-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T-1D0",
    new Decimal("0.0002777777777777777777777777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°C/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI", "http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Degree Celsius per Hour", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TemperaturePerTime"
  );
  config.units.set("http://qudt.org/vocab/unit/DEG_C-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_C-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°C/K",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Degree Celsius per Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TemperatureRatio"
  );
  config.units.set("http://qudt.org/vocab/unit/DEG_C-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_C-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H1T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°C/m",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI", "http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Degree Celsius per Metre", "en"));
  unit.addLabel(new LangString("Degree Celsius per Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TemperatureGradient"
  );
  config.units.set("http://qudt.org/vocab/unit/DEG_C-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_C-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T-1D0",
    new Decimal("0.01666666666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°C/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI", "http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Degree Celsius per Minute", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TemperaturePerTime"
  );
  config.units.set("http://qudt.org/vocab/unit/DEG_C-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_C-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°C/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI", "http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Degree Celsius per Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TemperaturePerTime"
  );
  config.units.set("http://qudt.org/vocab/unit/DEG_C-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_C-PER-YR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T-1D0",
    new Decimal("3.168808781402895023702689684893655E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°C/a",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI", "http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Degree Celsius per Year", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TemperaturePerTime"
  );
  config.units.set("http://qudt.org/vocab/unit/DEG_C-PER-YR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_C-WK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T1D0",
    new Decimal("604800.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°C·wk",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI", "http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Degree Celsius Week", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/TimeTemperature");
  config.units.set("http://qudt.org/vocab/unit/DEG_C-WK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_C2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H2T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°C²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI", "http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Degree Celsius", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TemperatureVariance"
  );
  config.units.set("http://qudt.org/vocab/unit/DEG_C2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_C2-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H2T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°C²/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI", "http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Degree Celsius per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/DEG_C2-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_C_GROWING_CEREAL",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    true
  );
  unit.addLabel(new LangString("DEG_C_GROWING_CEREAL", undefined));
  config.units.set("http://qudt.org/vocab/unit/DEG_C_GROWING_CEREAL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_C_GROWING_CEREAL-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T1D0",
    new Decimal("86400.0"),
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    "GDD",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Growing Degree Days (cereals)", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/GrowingDegreeDay"
  );
  config.units.set("http://qudt.org/vocab/unit/DEG_C_GROWING_CEREAL-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T0D0",
    new Decimal("0.5555555555555555555555555555555556"),
    new Decimal("459.67"),
    undefined,
    "http://qudt.org/vocab/unit/K",
    undefined,
    "°F",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    60,
    false,
    false
  );
  unit.addLabel(new LangString("Degree Fahrenheit", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MeltingPoint");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/BoilingPoint");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Temperature");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/FlashPoint");
  config.units.set("http://qudt.org/vocab/unit/DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_F-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T1D0",
    new Decimal("48000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°F·d",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Degree Fahrenheit Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/TimeTemperature");
  config.units.set("http://qudt.org/vocab/unit/DEG_F-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_F-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T1D0",
    new Decimal("2000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°F·h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Degree Fahrenheit Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/TimeTemperature");
  config.units.set("http://qudt.org/vocab/unit/DEG_F-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_F-HR-FT2-PER-BTU_IT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H1T3D0",
    new Decimal("0.1761101836823058407309515389966389"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°F·h·ft²/Btu{IT}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "Degree Fahrenheit Hour Square Foot per British Thermal Unit (international Definition)",
      "en"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalInsulance"
  );
  config.units.set("http://qudt.org/vocab/unit/DEG_F-HR-FT2-PER-BTU_IT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_F-HR-FT2-PER-BTU_IT-IN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M-1H1T3D0",
    new Decimal("6.933471798515977981533525157347987"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°F·h·ft²/(Btu{IT}·in)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "Degree Fahrenheit Hour Square Foot per British Thermal Unit (international Definition) Inch",
      "en"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalResistivity"
  );
  config.units.set(
    "http://qudt.org/vocab/unit/DEG_F-HR-FT2-PER-BTU_IT-IN",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_F-HR-FT2-PER-BTU_TH",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H1T3D0",
    new Decimal("0.1762280394439072102115454062182767"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°F·h·ft²/Btu{th}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "Degree Fahrenheit Hour Square Foot per British Thermal Unit (thermochemical Definition)",
      "en"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalInsulance"
  );
  config.units.set("http://qudt.org/vocab/unit/DEG_F-HR-FT2-PER-BTU_TH", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_F-HR-FT2-PER-BTU_TH-IN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M-1H1T3D0",
    new Decimal("6.938111789130205126438795520404595"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°F·h·ft²/(Btu{th}·in)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "Degree Fahrenheit Hour Square Foot per British Thermal Unit (thermochemical Definition) Inch",
      "en"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalResistivity"
  );
  config.units.set(
    "http://qudt.org/vocab/unit/DEG_F-HR-FT2-PER-BTU_TH-IN",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_F-HR-PER-BTU_IT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M-1H1T3D0",
    new Decimal("1.895634240626634400025570088951221"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°F·h/Btu{IT}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "Degree Fahrenheit Hour per British Thermal Unit (international Definition)",
      "en"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalResistance"
  );
  config.units.set("http://qudt.org/vocab/unit/DEG_F-HR-PER-BTU_IT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_F-HR-PER-BTU_TH",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M-1H1T3D0",
    new Decimal("1.896902829486604638680773053478947"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°F·h/Btu{th}",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "Degree Fahrenheit Hour per British Thermal Unit (thermochemical Definition)",
      "en"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalResistance"
  );
  config.units.set("http://qudt.org/vocab/unit/DEG_F-HR-PER-BTU_TH", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_F-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H1T2D0",
    new Decimal("0.000005555555555555555555555555555555556"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°F/bar",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Degree Fahrenheit per Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/DEG_F-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_F-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T-1D0",
    new Decimal("0.000154320987654320987654320987654321"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°F/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Degree Fahrenheit per Hour", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TemperaturePerTime"
  );
  config.units.set("http://qudt.org/vocab/unit/DEG_F-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_F-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.5555555555555555555555555555555556"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°F/K",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Degree Fahrenheit per Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TemperatureRatio"
  );
  config.units.set("http://qudt.org/vocab/unit/DEG_F-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_F-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T-1D0",
    new Decimal("0.009259259259259259259259259259259262"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°F/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Degree Fahrenheit per Minute", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TemperaturePerTime"
  );
  config.units.set("http://qudt.org/vocab/unit/DEG_F-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_F-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T-1D0",
    new Decimal("0.5555555555555555555555555555555556"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°F/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Degree Fahrenheit per Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TemperaturePerTime"
  );
  config.units.set("http://qudt.org/vocab/unit/DEG_F-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_F-PER-SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T-2D0",
    new Decimal("0.5555555555555555555555555555555556"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°F/s²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Degree Fahrenheit per Square Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TemperaturePerSquareTime"
  );
  config.units.set("http://qudt.org/vocab/unit/DEG_F-PER-SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_F-SEC-PER-BTU_IT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M-1H1T3D0",
    new Decimal("0.0005265650668407317777848805802642282"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°F·s/Btu{IT}",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "Degree Fahrenheit Second per British Thermal Unit (international Definition)",
      "en"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalResistance"
  );
  config.units.set("http://qudt.org/vocab/unit/DEG_F-SEC-PER-BTU_IT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_F-SEC-PER-BTU_TH",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M-1H1T3D0",
    new Decimal("0.0005269174526351679551891036259663741"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°F·s/Btu{th}",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "Degree Fahrenheit Second per British Thermal Unit (thermochemical Definition)",
      "en"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalResistance"
  );
  config.units.set("http://qudt.org/vocab/unit/DEG_F-SEC-PER-BTU_TH", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_R",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T0D0",
    new Decimal("0.5555555555555556"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/K",
    undefined,
    "°R",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    12,
    false,
    false
  );
  unit.addLabel(new LangString("Degree Rankine", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MeltingPoint");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermodynamicTemperature"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/BoilingPoint");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Temperature");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/FlashPoint");
  config.units.set("http://qudt.org/vocab/unit/DEG_R", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_R-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T-1D0",
    new Decimal("0.000154320987654321"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°R/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Degree Rankine per Hour", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TemperaturePerTime"
  );
  config.units.set("http://qudt.org/vocab/unit/DEG_R-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_R-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T-1D0",
    new Decimal("0.009259259259259260000000000000000002"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°R/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Degree Rankine per Minute", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TemperaturePerTime"
  );
  config.units.set("http://qudt.org/vocab/unit/DEG_R-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_R-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T-1D0",
    new Decimal("0.5555555555555556"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°R/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Degree Rankine per Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TemperaturePerTime"
  );
  config.units.set("http://qudt.org/vocab/unit/DEG_R-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DENIER",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T0D0",
    new Decimal("1.1E-7"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/GM-PER-MilliM",
    undefined,
    "D",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Denier", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerLength");
  config.units.set("http://qudt.org/vocab/unit/DENIER", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DIOPTER",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/PER-M",
    undefined,
    "D",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Diopter", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Curvature");
  config.units.set("http://qudt.org/vocab/unit/DIOPTER", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DPI",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("39.37007874015748031496062992125984"),
    undefined,
    undefined,
    undefined,
    undefined,
    "DPI",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Dots per Inch", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LineicResolution"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DotsPerInch");
  config.units.set("http://qudt.org/vocab/unit/DPI", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DRAM_UK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("0.0017718451953125"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "dr{UK}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Dram (UK)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  config.units.set("http://qudt.org/vocab/unit/DRAM_UK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DRAM_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("0.0038879346"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "dr{US}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Dram (US)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  config.units.set("http://qudt.org/vocab/unit/DRAM_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DWT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("0.00155517384"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "dwt",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Penny Weight", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/PENNYWEIGHT");
  config.units.set("http://qudt.org/vocab/unit/DWT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DYN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("0.00001"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/N",
    undefined,
    "dyn",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-GAUSS", "http://qudt.org/vocab/sou/CGS"],
    9,
    false,
    false
  );
  unit.addLabel(new LangString("Dyne", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Force");
  config.units.set("http://qudt.org/vocab/unit/DYN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DYN-CentiM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "dyn·cm",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-GAUSS", "http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Dyne Centimeter", "en-US"));
  unit.addLabel(new LangString("Dyne Centimetre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MomentOfForce");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Torque");
  config.units.set("http://qudt.org/vocab/unit/DYN-CentiM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DYN-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("0.00001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "dyn·m",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Dyne Meter", "en-US"));
  unit.addLabel(new LangString("Dyne Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MomentOfForce");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Torque");
  config.units.set("http://qudt.org/vocab/unit/DYN-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DYN-PER-CentiM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "dyn/cm",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-GAUSS", "http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Dyne per Centimetre", "en"));
  unit.addLabel(new LangString("Dyne per Centimeter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerLength");
  config.units.set("http://qudt.org/vocab/unit/DYN-PER-CentiM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DYN-PER-CentiM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("0.1"),
    undefined,
    undefined,
    undefined,
    undefined,
    "dyn/cm²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-GAUSS", "http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Dyne per Square Centimetre", "en"));
  unit.addLabel(new LangString("Dyne per Square Centimeter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/DYN-PER-CentiM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DYN-SEC-PER-CentiM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "dyn·s/cm",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-GAUSS", "http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Dyne Second per Centimetre", "en"));
  unit.addLabel(new LangString("Dyne Second per Centimeter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/DYN-SEC-PER-CentiM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DYN-SEC-PER-CentiM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-1D0",
    new Decimal("10.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "dyn·s/cm³",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-GAUSS", "http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Dyne Second per Cubic Centimeter", "en-US"));
  unit.addLabel(new LangString("Dyne Second per Cubic Centimetre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerAreaTime");
  config.units.set("http://qudt.org/vocab/unit/DYN-SEC-PER-CentiM3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DYN-SEC-PER-CentiM5",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-4I0M1H0T-1D0",
    new Decimal("100000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "dyn·s/cm⁵",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Dyne Second per Quintic Centimeter", "en-US"));
  unit.addLabel(new LangString("Dyne Second per Quintic Centimetre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PressureInRelationToVolumeFlowRate"
  );
  config.units.set("http://qudt.org/vocab/unit/DYN-SEC-PER-CentiM5", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/Da",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("1.66053878283E-27"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "Da",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("Dalton", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MolecularMass");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/AMU");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/U");
  config.units.set("http://qudt.org/vocab/unit/Da", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/Debye",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L1I0M0H0T1D0",
    new Decimal("3.33564E-30"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/C-M",
    undefined,
    "D",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("Debye", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricDipoleMoment"
  );
  config.units.set("http://qudt.org/vocab/unit/Debye", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DecaARE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    new Decimal("1000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Deca",
    "http://qudt.org/vocab/unit/ARE",
    undefined,
    "daa",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Decaare", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Area");
  config.units.set("http://qudt.org/vocab/unit/DecaARE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DecaC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("10.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Deca",
    "http://qudt.org/vocab/unit/C",
    undefined,
    "daC",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Decacoulomb", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  config.units.set("http://qudt.org/vocab/unit/DecaC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DecaGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("0.01"),
    undefined,
    "http://qudt.org/vocab/prefix/Deca",
    "http://qudt.org/vocab/unit/GM",
    undefined,
    "dag",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Decagram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  config.units.set("http://qudt.org/vocab/unit/DecaGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DecaK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T0D0",
    new Decimal("10.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Deca",
    "http://qudt.org/vocab/unit/K",
    undefined,
    "daK",
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Decakelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MeltingPoint");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermodynamicTemperature"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/BoilingPoint");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Temperature");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CorrelatedColorTemperature"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/FlashPoint");
  config.units.set("http://qudt.org/vocab/unit/DecaK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DecaKiloCOUNT",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    true
  );
  unit.addLabel(new LangString("DecaKiloCOUNT", undefined));
  config.units.set("http://qudt.org/vocab/unit/DecaKiloCOUNT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DecaL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.01"),
    undefined,
    "http://qudt.org/vocab/prefix/Deca",
    "http://qudt.org/vocab/unit/L",
    undefined,
    "daL",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Decaliter", "en-US"));
  unit.addLabel(new LangString("Decalitre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/DecaL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DecaM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("10.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Deca",
    "http://qudt.org/vocab/unit/M",
    undefined,
    "dam",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Decametre", "en"));
  unit.addLabel(new LangString("Decameter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/DecaM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DecaM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "dam³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Decameter", "en-US"));
  unit.addLabel(new LangString("Cubic Decametre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/DecaM3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DecaPA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("10.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Deca",
    "http://qudt.org/vocab/unit/PA",
    undefined,
    "daPa",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Decapascal", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ModulusOfElasticity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ShearModulus");
  config.units.set("http://qudt.org/vocab/unit/DecaPA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DecaPOISE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-1D0",
    new Decimal("1.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Deca",
    "http://qudt.org/vocab/unit/POISE",
    undefined,
    "daP",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-GAUSS", "http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Decapoise", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DynamicViscosity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Viscosity");
  config.units.set("http://qudt.org/vocab/unit/DecaPOISE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciB",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "dB",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    5,
    false,
    false
  );
  unit.addLabel(new LangString("Decibel", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoundExposureLevel"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoundReductionIndex"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoundPressureLevel"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SoundPowerLevel");
  config.units.set("http://qudt.org/vocab/unit/DeciB", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciB-MilliW",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "dB·mW",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Decibel Milliwatt", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/DeciB-MilliW", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciB-MilliW-PER-MegaHZ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "dB·mW/MHz",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Decibel Milliwatt per Megahertz", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/DeciB-MilliW-PER-MegaHZ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciB-PER-KiloM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "dB/km",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Decibel per Kilometre", "en"));
  unit.addLabel(new LangString("Decibel per Kilometer", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearLogarithmicRatio"
  );
  config.units.set("http://qudt.org/vocab/unit/DeciB-PER-KiloM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciB-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "dB/m",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Decibel per Meter", "en-US"));
  unit.addLabel(new LangString("Decibel per Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearLogarithmicRatio"
  );
  config.units.set("http://qudt.org/vocab/unit/DeciB-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciB-W",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "dB·W",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Decibel Watt", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/DeciB-W", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciBAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("10000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/PA",
    undefined,
    "dbar",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Decibar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/DeciBAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciBAR-PER-YR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-3D0",
    new Decimal("0.0003168808781402895023702689684893655"),
    undefined,
    undefined,
    undefined,
    undefined,
    "dbar/a",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Decibar per Year", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ForcePerAreaTime"
  );
  config.units.set("http://qudt.org/vocab/unit/DeciBAR-PER-YR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciB_A",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "dB(A)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Decibel with A-weighting", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoundExposureLevel"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoundReductionIndex"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoundPressureLevel"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SoundPowerLevel");
  config.units.set("http://qudt.org/vocab/unit/DeciB_A", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciB_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "dBc",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Decibel Carrier Unit", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SignalDetectionThreshold"
  );
  config.units.set("http://qudt.org/vocab/unit/DeciB_C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciB_ISO",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "dBi",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Decibel Isotropic", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoundExposureLevel"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoundReductionIndex"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoundPressureLevel"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SoundPowerLevel");
  config.units.set("http://qudt.org/vocab/unit/DeciB_ISO", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciB_M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "dBmW",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Decibel Referred to 1mw", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoundExposureLevel"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoundReductionIndex"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoundPressureLevel"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SoundPowerLevel");
  config.units.set("http://qudt.org/vocab/unit/DeciB_M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciB_Z",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "dB(Z)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Decibel with Z-weighting", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoundExposureLevel"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoundReductionIndex"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoundPressureLevel"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SoundPowerLevel");
  config.units.set("http://qudt.org/vocab/unit/DeciB_Z", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("0.1"),
    undefined,
    "http://qudt.org/vocab/prefix/Deci",
    "http://qudt.org/vocab/unit/C",
    undefined,
    "dC",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Decicoulomb", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  config.units.set("http://qudt.org/vocab/unit/DeciC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("0.0001"),
    undefined,
    "http://qudt.org/vocab/prefix/Deci",
    "http://qudt.org/vocab/unit/GM",
    undefined,
    "dg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Decigram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  config.units.set("http://qudt.org/vocab/unit/DeciGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.0001"),
    undefined,
    "http://qudt.org/vocab/prefix/Deci",
    "http://qudt.org/vocab/unit/L",
    undefined,
    "dL",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    5,
    false,
    false
  );
  unit.addLabel(new LangString("Deciliter", "en-US"));
  unit.addLabel(new LangString("Decilitre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/DeciL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciL-PER-GM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M-1H0T0D0",
    new Decimal("0.1"),
    undefined,
    undefined,
    undefined,
    undefined,
    "dL/g",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Decilitre per Gram", "en"));
  unit.addLabel(new LangString("Deciliter per Gram", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificVolume");
  config.units.set("http://qudt.org/vocab/unit/DeciL-PER-GM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("0.1"),
    undefined,
    "http://qudt.org/vocab/prefix/Deci",
    "http://qudt.org/vocab/unit/M",
    undefined,
    "dm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    175,
    false,
    false
  );
  unit.addLabel(new LangString("Decimetre", "en"));
  unit.addLabel(new LangString("Decimeter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/DeciM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "dm²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Decimetre", "en"));
  unit.addLabel(new LangString("Square Decimeter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/HydraulicPermeability"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Area");
  config.units.set("http://qudt.org/vocab/unit/DeciM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "dm³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    157,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Decimetre", "en"));
  unit.addLabel(new LangString("Cubic Decimeter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/DeciM3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciM3-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("1.157407407407407407407407407407407E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "dm³/d",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Decimeter per Day", "en-US"));
  unit.addLabel(new LangString("Cubic Decimetre per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/DeciM3-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciM3-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("2.777777777777777777777777777777778E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "dm³/h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Decimeter per Hour", "en-US"));
  unit.addLabel(new LangString("Cubic Decimetre per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/DeciM3-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciM3-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M-1H0T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "dm³/kg",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Decimeter per Kilogram", "en-US"));
  unit.addLabel(new LangString("Cubic Decimetre per Kilogram", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoilAdsorptionCoefficient"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificVolume");
  config.units.set("http://qudt.org/vocab/unit/DeciM3-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciM3-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "dm³/m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Decimeter per Cubic Meter", "en-US"));
  unit.addLabel(new LangString("Cubic Decimetre per Cubic Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFraction");
  config.units.set("http://qudt.org/vocab/unit/DeciM3-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciM3-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.00001666666666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "dm³/min",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Decimetre per Minute", "en"));
  unit.addLabel(new LangString("Cubic Decimeter per Minute", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/DeciM3-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciM3-PER-MOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A-1E0L3I0M0H0T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "dm³/mol",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Decimeter per Mole", "en-US"));
  unit.addLabel(new LangString("Cubic Decimetre per Mole", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MolarVolume");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MolarRefractivity"
  );
  config.units.set("http://qudt.org/vocab/unit/DeciM3-PER-MOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciM3-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "dm³/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Decimeter per Second", "en-US"));
  unit.addLabel(new LangString("Cubic Decimetre per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/DeciM3-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("0.1"),
    undefined,
    "http://qudt.org/vocab/prefix/Deci",
    "http://qudt.org/vocab/unit/N",
    undefined,
    "dN",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Decinewton", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Force");
  config.units.set("http://qudt.org/vocab/unit/DeciN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciN-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("0.1"),
    undefined,
    undefined,
    undefined,
    undefined,
    "dN·m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Decinewton Metre", "en"));
  unit.addLabel(new LangString("Decinewton Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MomentOfForce");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Torque");
  config.units.set("http://qudt.org/vocab/unit/DeciN-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciS",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-2I0M-1H0T3D0",
    new Decimal("0.1"),
    undefined,
    "http://qudt.org/vocab/prefix/Deci",
    "http://qudt.org/vocab/unit/S",
    undefined,
    "dS",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Decisiemens", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Conductance");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Admittance");
  config.units.set("http://qudt.org/vocab/unit/DeciS", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciS-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-3I0M-1H0T3D0",
    new Decimal("0.1"),
    undefined,
    undefined,
    undefined,
    undefined,
    "dS/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Decisiemens per Metre", "en"));
  unit.addLabel(new LangString("Decisiemens per Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Conductivity");
  config.units.set("http://qudt.org/vocab/unit/DeciS-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciSEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("0.1"),
    undefined,
    "http://qudt.org/vocab/prefix/Deci",
    "http://qudt.org/vocab/unit/SEC",
    undefined,
    "ds",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Decisecond", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/DeciSEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciTONNE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("100.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Deci",
    "http://qudt.org/vocab/unit/TONNE",
    undefined,
    "dt",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Decitonne", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/DeciTON_Metric");
  config.units.set("http://qudt.org/vocab/unit/DeciTONNE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciTON_Metric",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("100.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Deci",
    "http://qudt.org/vocab/unit/TON_Metric",
    undefined,
    "dt",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Deci Metric Ton", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/DeciTONNE");
  config.units.set("http://qudt.org/vocab/unit/DeciTON_Metric", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/Denier",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T0D0",
    new Decimal("1.1E-7"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/GM-PER-MilliM",
    undefined,
    "D",
    undefined,
    undefined,
    undefined,
    [],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("Denier", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerLength");
  config.units.set("http://qudt.org/vocab/unit/Denier", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/E",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("1.602176634E-19"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/A-SEC",
    undefined,
    "e",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Elementary Charge", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/ElementaryCharge");
  config.units.set("http://qudt.org/vocab/unit/E", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ENZ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T-1D0",
    new Decimal("1.6667E-8"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KAT",
    undefined,
    "U",
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Enzyme Unit", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CatalyticActivity"
  );
  config.units.set("http://qudt.org/vocab/unit/ENZ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ENZ-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T-1D0",
    new Decimal("0.000016667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "U/L",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Enzyme Unit per Liter", "en-US"));
  unit.addLabel(new LangString("Enzyme Unit per Litre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CatalyticActivityConcentration"
  );
  config.units.set("http://qudt.org/vocab/unit/ENZ-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ERG",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "erg",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-GAUSS", "http://qudt.org/vocab/sou/CGS"],
    12,
    false,
    false
  );
  unit.addLabel(new LangString("Erg", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/ERG", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ERG-CentiM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M1H0T-2D0",
    new Decimal("1E-11"),
    undefined,
    undefined,
    undefined,
    undefined,
    "erg·cm²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Erg Square Centimeter", "en-US"));
  unit.addLabel(new LangString("Erg Square Centimetre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassStoppingPower"
  );
  config.units.set("http://qudt.org/vocab/unit/ERG-CentiM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ERG-CentiM2-PER-GM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M0H0T-2D0",
    new Decimal("1E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "erg·cm²/g",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Erg Square Centimeter per Gram", "en-US"));
  unit.addLabel(new LangString("Erg Square Centimetre per Gram", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TotalMassStoppingPower"
  );
  config.units.set("http://qudt.org/vocab/unit/ERG-CentiM2-PER-GM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ERG-PER-CentiM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("0.00001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "erg/cm",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-GAUSS", "http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Erg per Centimeter", "en-US"));
  unit.addLabel(new LangString("Erg per Centimetre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TotalLinearStoppingPower"
  );
  config.units.set("http://qudt.org/vocab/unit/ERG-PER-CentiM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ERG-PER-CentiM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "erg/cm²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Erg per Square Centimeter", "en-US"));
  unit.addLabel(new LangString("Erg per Square Centimetre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyPerArea");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/StrainEnergyReleaseRate"
  );
  config.units.set("http://qudt.org/vocab/unit/ERG-PER-CentiM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ERG-PER-CentiM2-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "erg/(cm²·s)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-GAUSS", "http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Erg per Square Centimeter Second", "en-US"));
  unit.addLabel(new LangString("Erg per Square Centimetre Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PowerPerArea");
  config.units.set("http://qudt.org/vocab/unit/ERG-PER-CentiM2-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ERG-PER-CentiM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("0.1"),
    undefined,
    undefined,
    undefined,
    undefined,
    "erg/cm³",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-GAUSS", "http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Erg per Cubic Centimetre", "en"));
  unit.addLabel(new LangString("Erg per Cubic Centimeter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyDensity");
  config.units.set("http://qudt.org/vocab/unit/ERG-PER-CentiM3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ERG-PER-GM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("0.0001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "erg/g",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-GAUSS", "http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Erg per Gram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificEnergy");
  config.units.set("http://qudt.org/vocab/unit/ERG-PER-GM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ERG-PER-GM-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    new Decimal("0.0001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "erg/(g·s)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-GAUSS", "http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Erg per Gram Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificPower");
  config.units.set("http://qudt.org/vocab/unit/ERG-PER-GM-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ERG-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "erg/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-GAUSS", "http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Erg per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/ERG-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ERG-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-1D0",
    new Decimal("1E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "erg·s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-GAUSS", "http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Erg Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AngularImpulse");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AngularMomentum");
  config.units.set("http://qudt.org/vocab/unit/ERG-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ERLANG",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "E",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Erlang", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InformationEntropy"
  );
  config.units.set("http://qudt.org/vocab/unit/ERLANG", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/EV",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1.602176634E-19"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/J",
    undefined,
    "eV",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    14,
    false,
    false
  );
  unit.addLabel(new LangString("Electron Volt", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/EV", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/EV-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M1H0T-2D0",
    new Decimal("1.602176634E-19"),
    undefined,
    undefined,
    undefined,
    undefined,
    "eV·m²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Electron Volt Square Metre", "en"));
  unit.addLabel(new LangString("Electron Volt Square Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TotalAtomicStoppingPower"
  );
  config.units.set("http://qudt.org/vocab/unit/EV-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/EV-M2-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M0H0T-2D0",
    new Decimal("1.602176634E-19"),
    undefined,
    undefined,
    undefined,
    undefined,
    "eV·m²/kg",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Electron Volt Square Metre per Kilogram", "en")
  );
  unit.addLabel(
    new LangString("Electron Volt Square Meter per Kilogram", "en-US")
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TotalMassStoppingPower"
  );
  config.units.set("http://qudt.org/vocab/unit/EV-M2-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/EV-PER-ANGSTROM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("1.602176634E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "eV/Å",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Electron Volt per Angstrom", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TotalLinearStoppingPower"
  );
  config.units.set("http://qudt.org/vocab/unit/EV-PER-ANGSTROM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/EV-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H-1T-2D0",
    new Decimal("1.602176634E-19"),
    undefined,
    undefined,
    undefined,
    undefined,
    "eV/K",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Electron Volt per Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/HeatCapacity");
  config.units.set("http://qudt.org/vocab/unit/EV-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/EV-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("1.602176634E-19"),
    undefined,
    undefined,
    undefined,
    undefined,
    "eV/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Electron Volt per Meter", "en-US"));
  unit.addLabel(new LangString("Electron Volt per Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TotalLinearStoppingPower"
  );
  config.units.set("http://qudt.org/vocab/unit/EV-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/EV-PER-T",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L2I0M0H0T0D0",
    new Decimal("1.602176634E-19"),
    undefined,
    undefined,
    undefined,
    undefined,
    "eV/T",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Electron Volt per Tesla", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MagneticMoment");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticAreaMoment"
  );
  config.units.set("http://qudt.org/vocab/unit/EV-PER-T", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/EV-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-1D0",
    new Decimal("1.602176634E-19"),
    undefined,
    undefined,
    undefined,
    undefined,
    "eV·s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Electron Volt Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AngularImpulse");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AngularMomentum");
  config.units.set("http://qudt.org/vocab/unit/EV-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/E_h",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("4.35974394E-18"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/J",
    undefined,
    "Ha",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Hartree", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/E_h", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/EarthMass",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("5972190000000000000000000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "M⊕",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Earth Mass", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  config.units.set("http://qudt.org/vocab/unit/EarthMass", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ElementaryCharge",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("1.602176634E-19"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/C",
    undefined,
    "e",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Elementary Charge", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/E");
  config.units.set("http://qudt.org/vocab/unit/ElementaryCharge", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ExaBIT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("693147180559945309.41723212145818"),
    undefined,
    "http://qudt.org/vocab/prefix/Exa",
    "http://qudt.org/vocab/unit/BIT",
    undefined,
    "Eb",
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Exabit", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InformationEntropy"
  );
  config.units.set("http://qudt.org/vocab/unit/ExaBIT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ExaBIT-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("693147180559945309.41723212145818"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Eb/s",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Exabit per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DataRate");
  config.units.set("http://qudt.org/vocab/unit/ExaBIT-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ExaBYTE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("5545177444479562475.33785697166544"),
    undefined,
    "http://qudt.org/vocab/prefix/Exa",
    "http://qudt.org/vocab/unit/BYTE",
    undefined,
    "EB",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Exabyte", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InformationEntropy"
  );
  config.units.set("http://qudt.org/vocab/unit/ExaBYTE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ExaC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("1000000000000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Exa",
    "http://qudt.org/vocab/unit/C",
    undefined,
    "EC",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Exacoulomb", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  config.units.set("http://qudt.org/vocab/unit/ExaC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ExaJ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1000000000000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Exa",
    "http://qudt.org/vocab/unit/J",
    undefined,
    "EJ",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Exajoule", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/ExaJ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ExaJ-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1000000000000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "EJ/s",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Exajoule per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/ExaJ-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ExaV",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-3D0",
    new Decimal("1000000000000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Exa",
    "http://qudt.org/vocab/unit/V",
    undefined,
    "EV",
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Exavolt", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotential"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Voltage");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EnergyPerElectricCharge"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotentialDifference"
  );
  config.units.set("http://qudt.org/vocab/unit/ExaV", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ExaV-A",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1000000000000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "EV·A",
    undefined,
    undefined,
    undefined,
    [],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("Exavolt Ampere", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ApparentPower");
  config.units.set("http://qudt.org/vocab/unit/ExaV-A", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ExaVA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1000000000000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Exa",
    "http://qudt.org/vocab/unit/VA",
    undefined,
    "EVA",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Exa Volt Ampere", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ApparentPower");
  config.units.set("http://qudt.org/vocab/unit/ExaVA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ExaW",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1000000000000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Exa",
    "http://qudt.org/vocab/unit/W",
    undefined,
    "EW",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Exawatt", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/ExaW", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ExbiBIT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("105997109765220669.3195572972757272"),
    undefined,
    "http://qudt.org/vocab/prefix/Exbi",
    "http://qudt.org/vocab/unit/BIT",
    undefined,
    "Eib",
    undefined,
    undefined,
    undefined,
    [],
    3,
    false,
    false
  );
  unit.addLabel(new LangString("Exbibit", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InformationEntropy"
  );
  config.units.set("http://qudt.org/vocab/unit/ExbiBIT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ExbiBIT-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("105997109765220669.3195572972757272"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Eib/m",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Exbibit per Metre", "en"));
  unit.addLabel(new LangString("Exbibit per Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearBitDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/ExbiBIT-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ExbiBIT-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T0D0",
    new Decimal("105997109765220669.3195572972757272"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Eib/m²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Exbibit per Square Meter", "en-US"));
  unit.addLabel(new LangString("Exbibit per Square Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AreaBitDensity");
  config.units.set("http://qudt.org/vocab/unit/ExbiBIT-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ExbiBIT-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    new Decimal("105997109765220669.3195572972757272"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Eib/m³",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Exbibit per Cubic Metre", "en"));
  unit.addLabel(new LangString("Exbibit per Cubic Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/VolumetricBitDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/ExbiBIT-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ExbiBYTE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("847976878121765354.5564583782058176"),
    undefined,
    "http://qudt.org/vocab/prefix/Exbi",
    "http://qudt.org/vocab/unit/BYTE",
    undefined,
    "EiB",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Exbibyte", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InformationEntropy"
  );
  config.units.set("http://qudt.org/vocab/unit/ExbiBYTE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("96485.3399"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/C",
    undefined,
    "F",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Faraday", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  config.units.set("http://qudt.org/vocab/unit/F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("12.5663706"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/SR",
    undefined,
    "fa",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Fractional Area", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SolidAngle");
  config.units.set("http://qudt.org/vocab/unit/FA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FARAD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-2I0M-1H0T4D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "F",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    12,
    false,
    false
  );
  unit.addLabel(new LangString("Farad", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Capacitance");
  config.units.set("http://qudt.org/vocab/unit/FARAD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FARAD-PER-KiloM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-3I0M-1H0T4D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "F/km",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Farad per Kilometre", "en"));
  unit.addLabel(new LangString("Farad per Kilometer", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Permittivity");
  config.units.set("http://qudt.org/vocab/unit/FARAD-PER-KiloM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FARAD-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-3I0M-1H0T4D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "F/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Farad per Meter", "en-US"));
  unit.addLabel(new LangString("Farad per Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Permittivity");
  config.units.set("http://qudt.org/vocab/unit/FARAD-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FARAD_Ab",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-2I0M-1H0T4D0",
    new Decimal("1000000000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/FARAD",
    undefined,
    "abF",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-EMU", "http://qudt.org/vocab/sou/CGS"],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Abfarad", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Capacitance");
  config.units.set("http://qudt.org/vocab/unit/FARAD_Ab", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FARAD_Ab-PER-CentiM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-3I0M-1H0T4D0",
    new Decimal("100000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "abF/cm",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-EMU", "http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Abfarad per Centimeter", "en-US"));
  unit.addLabel(new LangString("Abfarad per Centimetre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Permittivity");
  config.units.set("http://qudt.org/vocab/unit/FARAD_Ab-PER-CentiM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FARAD_Stat",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-2I0M-1H0T4D0",
    new Decimal("1.112650056053618432174089964848E-18"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/FARAD",
    undefined,
    "statF",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS", "http://qudt.org/vocab/sou/CGS-ESU"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Statfarad", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Capacitance");
  config.units.set("http://qudt.org/vocab/unit/FARAD_Stat", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FATH",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("1.8288"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M",
    undefined,
    "fathom",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Fathom", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/FATH", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FBM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.00236"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M3",
    undefined,
    "BDFT",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Board Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/FBM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I1M0H0T0D0",
    new Decimal("10.764"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/CD-PER-M2",
    undefined,
    "fc",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Foot Candle", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LuminousFluxPerArea"
  );
  config.units.set("http://qudt.org/vocab/unit/FC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FLIGHT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "flight",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    2,
    false,
    false
  );
  unit.addLabel(new LangString("Flight", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Dimensionless");
  config.units.set("http://qudt.org/vocab/unit/FLIGHT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FLOPS",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "FLOPS",
    undefined,
    undefined,
    undefined,
    [],
    4,
    false,
    false
  );
  unit.addLabel(new LangString("Floating Point Operations per Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/FloatingPointCalculationCapability"
  );
  config.units.set("http://qudt.org/vocab/unit/FLOPS", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("1E-15"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M",
    undefined,
    "fm",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Fermi", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/FemtoM");
  config.units.set("http://qudt.org/vocab/unit/FM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("3.3356409519815204957557671447492E-10"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/A-SEC",
    undefined,
    "Fr",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Franklin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/C_Stat");
  config.units.set("http://qudt.org/vocab/unit/FR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FRACTION",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    "÷",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Fraction", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/StateOfCharge");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DutyCycle");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/OpeningRatio");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Reflectance");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ServiceFactor");
  config.units.set("http://qudt.org/vocab/unit/FRACTION", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FRAME",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    true
  );
  unit.addLabel(new LangString("FRAME", undefined));
  config.units.set("http://qudt.org/vocab/unit/FRAME", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FRAME-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "fps",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Frame per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VideoFrameRate");
  config.units.set("http://qudt.org/vocab/unit/FRAME-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("0.3048"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    240,
    false,
    false
  );
  unit.addLabel(new LangString("Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/FT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT-HR-PER-GAL_UK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal("241367.856773623047497959785222026"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft·h/gal{UK}",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Foot Hour per Gallon (UK)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/FT-HR-PER-GAL_UK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT-HR-PER-GAL_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal("289870.7096115490932280565859833018"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft·h/gal{US}",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Foot Hour per Us Gallon", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/FT-HR-PER-GAL_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT-HR-PER-IN3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal("66960133.92026784053568107136214273"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft·h/in³",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Foot Hour per Cubic Inch", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/FT-HR-PER-IN3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT-LB_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1.35581800916358032544"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft·lbf",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Foot Pound Force", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MomentOfForce");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Torque");
  config.units.set("http://qudt.org/vocab/unit/FT-LB_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-FT2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("14.5939035919985"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft·lbf/ft²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Foot Pound Force per Square Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyPerArea");
  config.units.set("http://qudt.org/vocab/unit/FT-LB_F-PER-FT2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-FT2-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    new Decimal("14.5939035919985"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft·lbf/(ft²·s)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Foot Pound Force per Square Foot Second", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PowerPerArea");
  config.units.set("http://qudt.org/vocab/unit/FT-LB_F-PER-FT2-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("0.0003766161136565500904"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft·lbf/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Foot Pound Force per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/FT-LB_F-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("1.35581800916358032544"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft·lbf/m²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Foot Pound Force per Square Meter", "en-US"));
  unit.addLabel(new LangString("Foot Pound Force per Square Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyPerArea");
  config.units.set("http://qudt.org/vocab/unit/FT-LB_F-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("0.022596966819393005424"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft·lbf/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Foot Pound Force per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/FT-LB_F-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1.35581800916358032544"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft·lbf/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Foot Pound Force per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/FT-LB_F-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT-LB_F-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-1D0",
    new Decimal("1.35581800916358032544"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft·lbf·s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Foot Pound Force Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AngularImpulse");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AngularMomentum");
  config.units.set("http://qudt.org/vocab/unit/FT-LB_F-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT-PDL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("0.0421401100938048"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft·pdl",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Foot Poundal", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/FT-PDL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("0.000003527777777777777777777777777777777"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft/d",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Foot per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/FT-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT-PER-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H-1T0D0",
    new Decimal("0.54864"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft/°F",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Foot per Degree Fahrenheit", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearThermalExpansion"
  );
  config.units.set("http://qudt.org/vocab/unit/FT-PER-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("0.00008466666666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Foot per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/FT-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("0.005080000000000000000000000000000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Foot per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/FT-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT-PER-PSI",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M-1H0T2D0",
    new Decimal("0.00004420750047668715004148802456506335"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft/psi",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Foot per Psi", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/FT-PER-PSI", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("0.3048"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Foot per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/FT-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT-PER-SEC-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H-1T-1D0",
    new Decimal("0.54864"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft/(s·°F)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Foot per Second Degree Fahrenheit", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/FT-PER-SEC-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT-PER-SEC-PSI",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M-1H0T1D0",
    new Decimal("0.00004420750047668715004148802456506335"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft/(s·psi)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Foot per Second Psi", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/FT-PER-SEC-PSI", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT-PER-SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-2D0",
    new Decimal("0.3048"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft/s²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Foot per Square Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Acceleration");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearAcceleration"
  );
  config.units.set("http://qudt.org/vocab/unit/FT-PER-SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT-SEC-PER-GAL_UK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal("67.04662688156195763832216256167389"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft·s/gal{UK}",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Foot Second per Gallon (UK)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/FT-SEC-PER-GAL_UK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT-SEC-PER-GAL_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal("80.51964155876363700779349610647273"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft·s/gal{US}",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Foot Second per Us Gallon", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/FT-SEC-PER-GAL_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT-SEC-PER-IN3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal("18600.0372000744001488002976005952"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft·s/in³",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Foot Second per Cubic Inch", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/FT-SEC-PER-IN3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    new Decimal("0.09290304"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Foot", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/HydraulicPermeability"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Area");
  config.units.set("http://qudt.org/vocab/unit/FT2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT2-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H1T0D0",
    new Decimal("0.0516128"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft²·°F",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Foot Degree Fahrenheit", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AreaTemperature");
  config.units.set("http://qudt.org/vocab/unit/FT2-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT2-HR-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H1T1D0",
    new Decimal("185.80608"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft²·h·°F",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Foot Hour Degree Fahrenheit", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AreaTimeTemperature"
  );
  config.units.set("http://qudt.org/vocab/unit/FT2-HR-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT2-HR-DEG_F-PER-BTU_IT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H1T3D0",
    new Decimal("0.1761101836823058407309515389966389"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft²·h·°F/Btu{IT}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "Square Foot Hour Degree Fahrenheit per British Thermal Unit (international Definition)",
      "en"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalInsulance"
  );
  config.units.set("http://qudt.org/vocab/unit/FT2-HR-DEG_F-PER-BTU_IT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT2-PER-BTU_IT-IN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M-1H0T2D0",
    new Decimal("0.003466735899257988990766762578673993"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft²/(Btu{IT}·in)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "Square Foot per British Thermal Unit (international Definition) Inch",
      "en"
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/FT2-PER-BTU_IT-IN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT2-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-1D0",
    new Decimal("0.0000258064"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft²/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Foot per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AreaPerTime");
  config.units.set("http://qudt.org/vocab/unit/FT2-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT2-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-1D0",
    new Decimal("0.09290304"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft²/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Foot per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AreaPerTime");
  config.units.set("http://qudt.org/vocab/unit/FT2-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT2-SEC-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H1T1D0",
    new Decimal("0.0516128"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft²·s·°F",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Foot Second Degree Fahrenheit", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AreaTimeTemperature"
  );
  config.units.set("http://qudt.org/vocab/unit/FT2-SEC-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.028316846592"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft³",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/FT3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT3-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("3.277412799999999999999999999999999E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft³/d",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Foot per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/FT3-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT3-PER-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H-1T0D0",
    new Decimal("0.0509703238656"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft³/°F",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Foot per Degree Fahrenheit", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/VolumeThermalExpansion"
  );
  config.units.set("http://qudt.org/vocab/unit/FT3-PER-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT3-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.000007865790720000000000000000000000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft³/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Foot per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/FT3-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT3-PER-LB",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M-1H0T0D0",
    new Decimal("0.06242796057614461195632545582722213"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft³/lbm",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Foot per Pound Mass", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoilAdsorptionCoefficient"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificVolume");
  config.units.set("http://qudt.org/vocab/unit/FT3-PER-LB", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT3-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.0004719474432000000000000000000000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft³/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Foot per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/FT3-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT3-PER-MIN-FT2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("0.005080000000000000000000000000000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft³/(min·ft²)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Foot per Minute Square Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Speed");
  config.units.set("http://qudt.org/vocab/unit/FT3-PER-MIN-FT2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT3-PER-PSI",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M-1H0T2D0",
    new Decimal("0.000004107011185085685367790363605689063"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft³/psi",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Foot per Psi", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/FT3-PER-PSI", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT3-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.028316846592"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft³/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Foot per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/FT3-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT4",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M0H0T0D0",
    new Decimal("0.0086309748412416"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft⁴",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Quartic Foot", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SecondMomentOfArea"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SecondAxialMomentOfArea"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SecondPolarMomentOfArea"
  );
  config.units.set("http://qudt.org/vocab/unit/FT4", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT_H2O",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("2989.067"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/PA",
    undefined,
    "ftH₂0",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Foot of Water", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/FT_H2O_39dot2DEG_F");
  config.units.set("http://qudt.org/vocab/unit/FT_H2O", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT_H2O_39dot2DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("2989.067"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/PA",
    undefined,
    "ftH₂O (39.2 °F)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Foot of Water (39.2 °F)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/FT_H2O");
  config.units.set("http://qudt.org/vocab/unit/FT_H2O_39dot2DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT_HG",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("40636.66"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/PA",
    undefined,
    "ftHg",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Foot of Mercury", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/FT_HG", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("0.3048006"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M",
    undefined,
    "ft{US Survey}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Us Survey Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/FT_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FUR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("201.168"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M",
    undefined,
    "furlong",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Furlong", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/FUR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FUR_Long",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "furlong{long}",
    undefined,
    undefined,
    undefined,
    [],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("Long Furlong", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/FUR_Long", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FemtoA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T0D0",
    new Decimal("1E-15"),
    undefined,
    "http://qudt.org/vocab/prefix/Femto",
    "http://qudt.org/vocab/unit/A",
    undefined,
    "fA",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Femtoampere", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/CurrentLinkage");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagnetomotiveForce"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MagneticTension");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCurrent");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/TotalCurrent");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DisplacementCurrent"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentPhasor"
  );
  config.units.set("http://qudt.org/vocab/unit/FemtoA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FemtoC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("1E-15"),
    undefined,
    "http://qudt.org/vocab/prefix/Femto",
    "http://qudt.org/vocab/unit/C",
    undefined,
    "fC",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Femtocoulomb", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  config.units.set("http://qudt.org/vocab/unit/FemtoC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FemtoFARAD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-2I0M-1H0T4D0",
    new Decimal("1E-15"),
    undefined,
    "http://qudt.org/vocab/prefix/Femto",
    "http://qudt.org/vocab/unit/FARAD",
    undefined,
    "fF",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Femtofarad", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Capacitance");
  config.units.set("http://qudt.org/vocab/unit/FemtoFARAD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FemtoGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("1E-18"),
    undefined,
    "http://qudt.org/vocab/prefix/Femto",
    "http://qudt.org/vocab/unit/GM",
    undefined,
    "fg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    2,
    false,
    false
  );
  unit.addLabel(new LangString("Femtogram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  config.units.set("http://qudt.org/vocab/unit/FemtoGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FemtoGM-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1E-18"),
    undefined,
    undefined,
    undefined,
    undefined,
    "fg/kg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Femtogram per Kilogram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassRatio");
  config.units.set("http://qudt.org/vocab/unit/FemtoGM-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FemtoGM-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("1E-15"),
    undefined,
    undefined,
    undefined,
    undefined,
    "fg/L",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Femtogram per Liter", "en-US"));
  unit.addLabel(new LangString("Femtogram per Litre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  config.units.set("http://qudt.org/vocab/unit/FemtoGM-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FemtoJ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1E-15"),
    undefined,
    "http://qudt.org/vocab/prefix/Femto",
    "http://qudt.org/vocab/unit/J",
    undefined,
    "fJ",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Femtojoule", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/FemtoJ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FemtoL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("1E-18"),
    undefined,
    "http://qudt.org/vocab/prefix/Femto",
    "http://qudt.org/vocab/unit/L",
    undefined,
    "fL",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Femtolitre", "en"));
  unit.addLabel(new LangString("Femtoliter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/FemtoL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FemtoM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("1E-15"),
    undefined,
    "http://qudt.org/vocab/prefix/Femto",
    "http://qudt.org/vocab/unit/M",
    undefined,
    "fm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Femtometre", "en"));
  unit.addLabel(new LangString("Femtometer", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/FM");
  config.units.set("http://qudt.org/vocab/unit/FemtoM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FemtoMOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T0D0",
    new Decimal("1E-15"),
    undefined,
    "http://qudt.org/vocab/prefix/Femto",
    "http://qudt.org/vocab/unit/MOL",
    undefined,
    "fmol",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    2,
    false,
    false
  );
  unit.addLabel(new LangString("Femtomole", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstance"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ExtentOfReaction"
  );
  config.units.set("http://qudt.org/vocab/unit/FemtoMOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FemtoMOL-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M-1H0T0D0",
    new Decimal("1E-15"),
    undefined,
    undefined,
    undefined,
    undefined,
    "fmol/kg",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Femtomole per Kilogram", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstancePerMass"
  );
  config.units.set("http://qudt.org/vocab/unit/FemtoMOL-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FemtoMOL-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T0D0",
    new Decimal("1E-12"),
    undefined,
    undefined,
    undefined,
    undefined,
    "fmol/L",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Femtomole per Liter", "en-US"));
  unit.addLabel(new LangString("Femtomole per Litre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Concentration");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/WaterSolubility");
  config.units.set("http://qudt.org/vocab/unit/FemtoMOL-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FemtoSEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("1E-15"),
    undefined,
    "http://qudt.org/vocab/prefix/Femto",
    "http://qudt.org/vocab/unit/SEC",
    undefined,
    "fs",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Femtosecond", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/FemtoSEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FemtoV",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-3D0",
    new Decimal("1E-15"),
    undefined,
    "http://qudt.org/vocab/prefix/Femto",
    "http://qudt.org/vocab/unit/V",
    undefined,
    "fV",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Femtovolt", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotential"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Voltage");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EnergyPerElectricCharge"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotentialDifference"
  );
  config.units.set("http://qudt.org/vocab/unit/FemtoV", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/G",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-2D0",
    new Decimal("9.80665"),
    undefined,
    undefined,
    undefined,
    undefined,
    "G",
    undefined,
    undefined,
    undefined,
    [],
    2,
    false,
    false
  );
  unit.addLabel(new LangString("Gravity", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Acceleration");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearAcceleration"
  );
  config.units.set("http://qudt.org/vocab/unit/G", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GAL",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    true
  );
  unit.addLabel(new LangString("GAL", undefined));
  config.units.set("http://qudt.org/vocab/unit/GAL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GALILEO",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-2D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Gal",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-GAUSS", "http://qudt.org/vocab/sou/CGS"],
    2,
    false,
    false
  );
  unit.addLabel(new LangString("Galileo", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Acceleration");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearAcceleration"
  );
  config.units.set("http://qudt.org/vocab/unit/GALILEO", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GAL_IMP",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.00454609"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M3",
    undefined,
    "gal{Imp}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"],
    3,
    false,
    false
  );
  unit.addLabel(new LangString("Imperial Gallon", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LiquidVolume");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/GAL_UK");
  config.units.set("http://qudt.org/vocab/unit/GAL_IMP", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GAL_UK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.00454609"),
    undefined,
    undefined,
    undefined,
    undefined,
    "gal{UK}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"],
    44,
    false,
    false
  );
  unit.addLabel(new LangString("Gallon (UK)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LiquidVolume");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/GAL_IMP");
  config.units.set("http://qudt.org/vocab/unit/GAL_UK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GAL_UK-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("5.261678240740740740740740740740739E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "gal{UK}/d",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gallon (UK) per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/GAL_UK-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GAL_UK-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.000001262802777777777777777777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "gal{UK}/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gallon (UK) per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/GAL_UK-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GAL_UK-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.00007576816666666666666666666666666668"),
    undefined,
    undefined,
    undefined,
    undefined,
    "gal{UK}/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gallon (UK) per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/GAL_UK-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GAL_UK-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.00454609"),
    undefined,
    undefined,
    undefined,
    undefined,
    "gal{UK}/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gallon (UK) per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/GAL_UK-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GAL_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.003785411784"),
    undefined,
    undefined,
    undefined,
    undefined,
    "gal{US}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    45,
    false,
    false
  );
  unit.addLabel(new LangString("Us Gallon", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LiquidVolume");
  config.units.set("http://qudt.org/vocab/unit/GAL_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GAL_US-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("4.381263638888888888888888888888887E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "gal{US}/d",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Us Gallon per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/GAL_US-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GAL_US-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.000001051503273333333333333333333333333"),
    undefined,
    undefined,
    undefined,
    undefined,
    "gal{US}/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Us Gallon per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/GAL_US-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GAL_US-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.00006309019640000000000000000000000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "gal{US}/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Us Gallon per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/GAL_US-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GAL_US-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.003785411784"),
    undefined,
    undefined,
    undefined,
    undefined,
    "gal{US}/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Us Gallon per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/GAL_US-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GAL_US_DRY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.00440488377086"),
    undefined,
    undefined,
    undefined,
    undefined,
    "gal{US Dry}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Dry Gallon Us", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DryVolume");
  config.units.set("http://qudt.org/vocab/unit/GAL_US_DRY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GAMMA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L0I0M1H0T-2D0",
    new Decimal("1E-9"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/T",
    undefined,
    "γ",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gamma", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticFluxDensity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MagneticField");
  config.units.set("http://qudt.org/vocab/unit/GAMMA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GAUGE_FR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("0.0003333333"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M",
    undefined,
    "French gauge",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("French Gauge", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/GAUGE_FR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GAUSS",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L0I0M1H0T-2D0",
    new Decimal("0.0001"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/T",
    undefined,
    "Gs",
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Gauss", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticFluxDensity"
  );
  unit.addExactMatchIri("http://qudt.org/vocab/unit/T_Ab");
  config.units.set("http://qudt.org/vocab/unit/GAUSS", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GA_Charriere",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("0.0003333333"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M",
    undefined,
    "Ch",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Charrière Gauge", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/GA_Charriere", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GI",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T0D0",
    new Decimal("0.795774715"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/A",
    undefined,
    "Gb",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-EMU", "http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gilbert", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagnetomotiveForce"
  );
  config.units.set("http://qudt.org/vocab/unit/GI", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GI_UK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.0001420653"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M3",
    undefined,
    "gill{UK}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"],
    4,
    false,
    false
  );
  unit.addLabel(new LangString("Gill (UK)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/GI_UK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GI_UK-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("1.644274305555555555555555555555555E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "gill{UK}/d",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gill (UK) per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/GI_UK-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GI_UK-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("3.946258333333333333333333333333334E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "gill{UK}/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gill (UK) per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/GI_UK-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GI_UK-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.000002367755"),
    undefined,
    undefined,
    undefined,
    undefined,
    "gill{UK}/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gill (UK) per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/GI_UK-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GI_UK-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.0001420653"),
    undefined,
    undefined,
    undefined,
    undefined,
    "gill{UK}/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gill (UK) per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/GI_UK-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GI_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.000118294125"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M3",
    undefined,
    "gill{US}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    4,
    false,
    false
  );
  unit.addLabel(new LangString("Gill (US)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/GI_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GI_US-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("1.369144965277777777777777777777777E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "gill{US}/d",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gill (US) per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/GI_US-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GI_US-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("3.285947916666666666666666666666667E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "gill{US}/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gill (US) per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/GI_US-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GI_US-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.00000197156875"),
    undefined,
    undefined,
    undefined,
    undefined,
    "gill{US}/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gill (US) per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/GI_US-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GI_US-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.000118294125"),
    undefined,
    undefined,
    undefined,
    undefined,
    "gill{US}/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gill (US) per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/GI_US-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "g",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    142,
    false,
    false
  );
  unit.addLabel(new LangString("Gram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  config.units.set("http://qudt.org/vocab/unit/GM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-CentiM-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-1D0",
    new Decimal("0.00001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g·cm/s",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram Centimetre per Second", "en"));
  unit.addLabel(new LangString("Gram Centimeter per Second", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Impulse");
  config.units.set("http://qudt.org/vocab/unit/GM-CentiM-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-HR-PER-L-CentiM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("3600000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g·h/(L·cm³)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Gram Hour per Liter Cubic Centimeter", "en-US")
  );
  unit.addLabel(new LangString("Gram Hour per Litre Cubic Centimetre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-HR-PER-L-CentiM3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-HR-PER-L-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("3600.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g·h/(L·m³)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram Hour per Litre Cubic Metre", "en"));
  unit.addLabel(new LangString("Gram Hour per Liter Cubic Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-HR-PER-L-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-HR-PER-L2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("3600000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g·h/L²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram Hour per Square Litre", "en"));
  unit.addLabel(new LangString("Gram Hour per Square Liter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-HR-PER-L2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-HR-PER-M3-CentiM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("3600000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g·h/(m³·cm³)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Gram Hour per Cubic Meter Cubic Centimeter", "en-US")
  );
  unit.addLabel(
    new LangString("Gram Hour per Cubic Metre Cubic Centimetre", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-HR-PER-M3-CentiM3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-HR-PER-M3-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("3600.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g·h/(m³·L)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram Hour per Cubic Metre Litre", "en"));
  unit.addLabel(new LangString("Gram Hour per Cubic Meter Liter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-HR-PER-M3-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-HR-PER-M6",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("3.6"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g·h/m⁶",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram Hour per Sextic Metre", "en"));
  unit.addLabel(new LangString("Gram Hour per Sextic Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-HR-PER-M6", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-MIN-PER-L-CentiM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("60000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g·min/(L·cm³)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Gram Minute per Liter Cubic Centimeter", "en-US")
  );
  unit.addLabel(new LangString("Gram Minute per Litre Cubic Centimetre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-MIN-PER-L-CentiM3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-MIN-PER-L-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("60.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g·min/(L·m³)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram Minute per Liter Cubic Meter", "en-US"));
  unit.addLabel(new LangString("Gram Minute per Litre Cubic Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-MIN-PER-L-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-MIN-PER-L2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("60000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g·min/L²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram Minute per Square Liter", "en-US"));
  unit.addLabel(new LangString("Gram Minute per Square Litre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-MIN-PER-L2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-MIN-PER-M3-CentiM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("60000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g·min/(m³·cm³)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Gram Minute per Cubic Metre Cubic Centimetre", "en")
  );
  unit.addLabel(
    new LangString("Gram Minute per Cubic Meter Cubic Centimeter", "en-US")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-MIN-PER-M3-CentiM3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-MIN-PER-M3-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("60.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g·min/(m³·L)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram Minute per Cubic Metre Litre", "en"));
  unit.addLabel(new LangString("Gram Minute per Cubic Meter Liter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-MIN-PER-M3-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-MIN-PER-M6",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("0.06"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g·min/m⁶",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram Minute per Sextic Meter", "en-US"));
  unit.addLabel(new LangString("Gram Minute per Sextic Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-MIN-PER-M6", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-MilliM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T0D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g·mm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram Millimeter", "en-US"));
  unit.addLabel(new LangString("Gram Millimetre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LengthMass");
  config.units.set("http://qudt.org/vocab/unit/GM-MilliM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T2D0",
    new Decimal("1E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/bar",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram per Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-CentiM-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T2D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/(cm·bar)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram per Centimetre Bar", "en"));
  unit.addLabel(new LangString("Gram per Centimeter Bar", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SquareTime");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-CentiM-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-CentiM-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-1D0",
    new Decimal("0.1"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/(cm·s)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram per Centimeter Second", "en-US"));
  unit.addLabel(new LangString("Gram per Centimetre Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DynamicViscosity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Viscosity");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-CentiM-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-CentiM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    new Decimal("10.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/cm²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram per Square Centimetre", "en"));
  unit.addLabel(new LangString("Gram per Square Centimeter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerArea");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-CentiM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-CentiM2-YR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-1D0",
    new Decimal("3.168808781402895023702689684893655E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/(cm²·a)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram per Square Centimetre Year", "en"));
  unit.addLabel(new LangString("Gram per Square Centimeter Year", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerAreaTime");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-CentiM2-YR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-CentiM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/cm³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram per Cubic Centimetre", "en"));
  unit.addLabel(new LangString("Gram per Cubic Centimeter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-CentiM3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-CentiM3-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T2D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/(cm³·bar)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram per Cubic Centimetre Bar", "en"));
  unit.addLabel(new LangString("Gram per Cubic Centimeter Bar", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerEnergy");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-CentiM3-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-CentiM3-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H-1T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/(cm³·K)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram per Cubic Centimeter Kelvin", "en-US"));
  unit.addLabel(new LangString("Gram per Cubic Centimetre Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-CentiM3-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("1.157407407407407407407407407407407E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/d",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-DAY-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T1D0",
    new Decimal("1.157407407407407407407407407407407E-13"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/(d·bar)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram per Day Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-DAY-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-DAY-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-1D0",
    new Decimal("1.157407407407407407407407407407407E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/(d·K)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram per Day Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-DAY-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-DEG_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/°C",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI", "http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram per Degree Celsius", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-DEG_C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-DeciL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("10.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/dL",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram per Decilitre", "en"));
  unit.addLabel(new LangString("Gram per Deciliter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-DeciL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-DeciM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/dm³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Gram per Cubic Decimetre", "en"));
  unit.addLabel(new LangString("Gram per Cubic Decimeter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-DeciM3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-DeciM3-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T2D0",
    new Decimal("0.00001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/(dm³·bar)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram per Cubic Decimeter Bar", "en-US"));
  unit.addLabel(new LangString("Gram per Cubic Decimetre Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerEnergy");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-DeciM3-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-DeciM3-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H-1T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/(dm³·K)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram per Cubic Decimeter Kelvin", "en-US"));
  unit.addLabel(new LangString("Gram per Cubic Decimetre Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-DeciM3-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-GM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/g",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram per Gram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassRatio");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-GM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-HA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    new Decimal("1E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/ha",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram per Hectare", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerArea");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-HA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("2.777777777777777777777777777777778E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-HR-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T1D0",
    new Decimal("2.777777777777777777777777777777778E-12"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/(h·bar)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram per Hour Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-HR-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-HR-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-1D0",
    new Decimal("2.777777777777777777777777777777778E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/(h·K)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram per Hour Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-HR-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-HZ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/Hz",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram per Hertz", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-HZ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-HectoGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/hg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram per Hectogram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassRatio");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-HectoGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/K",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram per Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/kg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram per Kilogram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassRatio");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-KiloM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T0D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/km",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram per Kilometer", "en-US"));
  unit.addLabel(new LangString("Gram per Kilometre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerLength");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-KiloM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/L",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram per Litre", "en"));
  unit.addLabel(new LangString("Gram per Liter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-L-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T2D0",
    new Decimal("0.00001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/(L·bar)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram per Litre Bar", "en"));
  unit.addLabel(new LangString("Gram per Liter Bar", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerEnergy");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-L-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-L-CentiPOISE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/(L·cP)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram per Litre Centipoise", "en"));
  unit.addLabel(new LangString("Gram per Liter Centipoise", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-L-CentiPOISE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-L-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H-1T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/(L·K)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram per Litre Kelvin", "en"));
  unit.addLabel(new LangString("Gram per Liter Kelvin", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-L-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-L-MilliPA-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/(L·mPa·s)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram per Litre Millipascal Second", "en"));
  unit.addLabel(new LangString("Gram per Liter Millipascal Second", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-L-MilliPA-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-L-PA-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/(L·Pa·s)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram per Liter Pascal Second", "en-US"));
  unit.addLabel(new LangString("Gram per Litre Pascal Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-L-PA-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-L-POISE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal("10.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/(L·P)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram per Liter Poise", "en-US"));
  unit.addLabel(new LangString("Gram per Litre Poise", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-L-POISE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram per Metre", "en"));
  unit.addLabel(new LangString("Gram per Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerLength");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram per Square Metre", "en"));
  unit.addLabel(new LangString("Gram per Square Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerArea");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-M2-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-1D0",
    new Decimal("1.157407407407407407407407407407407E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/(m²·d)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram per Square Meter Day", "en-US"));
  unit.addLabel(new LangString("Gram per Square Metre Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerAreaTime");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-M2-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-M2-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-1D0",
    new Decimal("2.777777777777777777777777777777778E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/(m²·h)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram per Square Metre Hour", "en"));
  unit.addLabel(new LangString("Gram per Square Meter Hour", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerAreaTime");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-M2-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-M2-YR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-1D0",
    new Decimal("3.168808781402895023702689684893655E-11"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/(m²·a)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram per Square Metre Year", "en"));
  unit.addLabel(new LangString("Gram per Square Meter Year", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerAreaTime");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-M2-YR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram per Cubic Metre", "en"));
  unit.addLabel(new LangString("Gram per Cubic Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-M3-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T2D0",
    new Decimal("1E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/(m³·bar)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram per Cubic Metre Bar", "en"));
  unit.addLabel(new LangString("Gram per Cubic Meter Bar", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerEnergy");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-M3-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-M3-CentiPOISE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/(m³·cP)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram per Cubic Meter Centipoise", "en-US"));
  unit.addLabel(new LangString("Gram per Cubic Metre Centipoise", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-M3-CentiPOISE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-M3-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H-1T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/(m³·K)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram per Cubic Metre Kelvin", "en"));
  unit.addLabel(new LangString("Gram per Cubic Meter Kelvin", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-M3-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-M3-MilliPA-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/(m³·mPa·s)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Gram per Cubic Metre Millipascal Second", "en")
  );
  unit.addLabel(
    new LangString("Gram per Cubic Meter Millipascal Second", "en-US")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-M3-MilliPA-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-M3-PA-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/(m³·Pa·s)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram per Cubic Metre Pascal Second", "en"));
  unit.addLabel(new LangString("Gram per Cubic Meter Pascal Second", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-M3-PA-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-M3-POISE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/(m³·P)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram per Cubic Meter Poise", "en-US"));
  unit.addLabel(new LangString("Gram per Cubic Metre Poise", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-M3-POISE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("0.00001666666666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/min",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-MIN-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T1D0",
    new Decimal("1.666666666666666666666666666666667E-10"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/(min·bar)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram per Minute Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-MIN-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-MIN-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-1D0",
    new Decimal("0.00001666666666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/(min·K)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram per Minute Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-MIN-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-MOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A-1E0L0I0M1H0T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/mol",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram per Mole", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MolarMass");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-MOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-MilliL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/mL",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram per Millilitre", "en"));
  unit.addLabel(new LangString("Gram per Milliliter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-MilliL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-MilliL-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T2D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/(mL·bar)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram per Milliliter Bar", "en-US"));
  unit.addLabel(new LangString("Gram per Millilitre Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerEnergy");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-MilliL-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-MilliL-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H-1T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/(mL·K)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram per Millilitre Kelvin", "en"));
  unit.addLabel(new LangString("Gram per Milliliter Kelvin", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-MilliL-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-MilliM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/mm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    3,
    false,
    false
  );
  unit.addLabel(new LangString("Gram per Millimetre", "en"));
  unit.addLabel(new LangString("Gram per Millimeter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerLength");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-MilliM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-MilliM-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T2D0",
    new Decimal("0.00001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/(mm·bar)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram per Millimetre Bar", "en"));
  unit.addLabel(new LangString("Gram per Millimeter Bar", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SquareTime");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-MilliM-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-MilliM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/mm²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram per Square Millimeter", "en-US"));
  unit.addLabel(new LangString("Gram per Square Millimetre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MeanMassRange");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/BodyMassIndex");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SurfaceDensity");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-MilliM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-SEC-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T1D0",
    new Decimal("1E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/(s·bar)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram per Second Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-SEC-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-SEC-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/(s·K)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram per Second Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-SEC-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-SEC-PER-L-CentiM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g·s/(L·cm³)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Gram Second per Liter Cubic Centimeter", "en-US")
  );
  unit.addLabel(new LangString("Gram Second per Litre Cubic Centimetre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-SEC-PER-L-CentiM3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-SEC-PER-L-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g·s/(L·m³)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram Second per Litre Cubic Metre", "en"));
  unit.addLabel(new LangString("Gram Second per Liter Cubic Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-SEC-PER-L-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-SEC-PER-L2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g·s/L²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram Second per Square Litre", "en"));
  unit.addLabel(new LangString("Gram Second per Square Liter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-SEC-PER-L2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-SEC-PER-M3-CentiM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g·s/(m³·cm³)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Gram Second per Cubic Metre Cubic Centimetre", "en")
  );
  unit.addLabel(
    new LangString("Gram Second per Cubic Meter Cubic Centimeter", "en-US")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-SEC-PER-M3-CentiM3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-SEC-PER-M3-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g·s/(m³·L)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram Second per Cubic Meter Liter", "en-US"));
  unit.addLabel(new LangString("Gram Second per Cubic Metre Litre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-SEC-PER-M3-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-SEC-PER-M6",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g·s/m⁶",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram Second per Sextic Metre", "en"));
  unit.addLabel(new LangString("Gram Second per Sextic Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-SEC-PER-M6", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM_Carbon",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    true
  );
  unit.addLabel(new LangString("GM_Carbon", undefined));
  config.units.set("http://qudt.org/vocab/unit/GM_Carbon", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM_Carbon-PER-M2-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-1D0",
    new Decimal("1.1574073E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g{carbon}/(m²·day)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Grams Carbon per Square Meter Day", "en-US"));
  unit.addLabel(new LangString("Grams Carbon per Square Metre Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerAreaTime");
  config.units.set("http://qudt.org/vocab/unit/GM_Carbon-PER-M2-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM_DRY",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    true
  );
  unit.addLabel(new LangString("GM_DRY", undefined));
  config.units.set("http://qudt.org/vocab/unit/GM_DRY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("0.00980665"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/N",
    undefined,
    "gf",
    undefined,
    undefined,
    undefined,
    [],
    2,
    false,
    false
  );
  unit.addLabel(new LangString("Gram Force", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Force");
  config.units.set("http://qudt.org/vocab/unit/GM_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM_F-PER-CentiM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("98.0665"),
    undefined,
    undefined,
    undefined,
    undefined,
    "gf/cm²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gram Force per Square Centimetre", "en"));
  unit.addLabel(new LangString("Gram Force per Square Centimeter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/GM_F-PER-CentiM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM_Nitrogen",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    true
  );
  unit.addLabel(new LangString("GM_Nitrogen", undefined));
  config.units.set("http://qudt.org/vocab/unit/GM_Nitrogen", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM_Nitrogen-PER-M2-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-1D0",
    new Decimal("1.1574073E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g{nitrogen}/(m²·day)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Grams Nitrogen per Square Metre Day", "en"));
  unit.addLabel(new LangString("Grams Nitrogen per Square Meter Day", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerAreaTime");
  config.units.set("http://qudt.org/vocab/unit/GM_Nitrogen-PER-M2-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GON",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.015707963267949"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/RAD",
    undefined,
    "gon",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gon", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PlaneAngle");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Angle");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/GRAD");
  config.units.set("http://qudt.org/vocab/unit/GON", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "gr",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Grade", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.units.set("http://qudt.org/vocab/unit/GR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GRAD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.015707963267949"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/RAD",
    undefined,
    "grad",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Grad", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PlaneAngle");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Angle");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/GON");
  config.units.set("http://qudt.org/vocab/unit/GRAD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GRAIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("0.00006479891"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "gr{UK}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    3,
    false,
    false
  );
  unit.addLabel(new LangString("Grain", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  config.units.set("http://qudt.org/vocab/unit/GRAIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GRAIN-PER-GAL_IMP",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("0.01425376752330024262608087389382964"),
    undefined,
    undefined,
    undefined,
    undefined,
    "gr{UK}/gal{Imp}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Grain per Imperial Gallon", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  config.units.set("http://qudt.org/vocab/unit/GRAIN-PER-GAL_IMP", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GRAIN-PER-GAL_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("0.01711806104527094693484475082935918"),
    undefined,
    undefined,
    undefined,
    undefined,
    "gr{UK}/gal{US}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Grain per Us Gallon", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  config.units.set("http://qudt.org/vocab/unit/GRAIN-PER-GAL_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GRAIN-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("0.00006479891"),
    undefined,
    undefined,
    undefined,
    undefined,
    "gr{UK}/m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Grain per Cubic Metre", "en"));
  unit.addLabel(new LangString("Grain per Cubic Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  config.units.set("http://qudt.org/vocab/unit/GRAIN-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GRAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Gy",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    9,
    false,
    false
  );
  unit.addLabel(new LangString("Gray", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AbsorbedDose");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Kerma");
  config.units.set("http://qudt.org/vocab/unit/GRAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GRAY-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    new Decimal("0.0002777777777777777777777777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Gy/h",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gray per Hour", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/KermaRate");
  config.units.set("http://qudt.org/vocab/unit/GRAY-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GRAY-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    new Decimal("0.01666666666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Gy/min",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gray per Minute", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/KermaRate");
  config.units.set("http://qudt.org/vocab/unit/GRAY-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GRAY-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Gy/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gray per Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/KermaRate");
  config.units.set("http://qudt.org/vocab/unit/GRAY-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M3",
    undefined,
    "G.T.",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gross Tonnage", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/GT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/Gamma",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L0I0M1H0T-2D0",
    new Decimal("1E-9"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/T",
    undefined,
    "γ",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("Gamma", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticFluxDensity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MagneticField");
  config.units.set("http://qudt.org/vocab/unit/Gamma", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GibiBIT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("744261117.9548930178739031951258957"),
    undefined,
    "http://qudt.org/vocab/prefix/Gibi",
    "http://qudt.org/vocab/unit/BIT",
    undefined,
    "Gib",
    undefined,
    undefined,
    undefined,
    [],
    3,
    false,
    false
  );
  unit.addLabel(new LangString("Gibibit", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DatasetOfBits");
  config.units.set("http://qudt.org/vocab/unit/GibiBIT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GibiBIT-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("744261117.9548930178739031951258957"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Gib/m",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gibibit per Metre", "en"));
  unit.addLabel(new LangString("Gibibit per Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearBitDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/GibiBIT-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GibiBIT-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T0D0",
    new Decimal("744261117.9548930178739031951258957"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Gib/m²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gibibit per Square Meter", "en-US"));
  unit.addLabel(new LangString("Gibibit per Square Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AreaBitDensity");
  config.units.set("http://qudt.org/vocab/unit/GibiBIT-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GibiBIT-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    new Decimal("744261117.9548930178739031951258957"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Gib/m³",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gibibit per Cubic Metre", "en"));
  unit.addLabel(new LangString("Gibibit per Cubic Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/VolumetricBitDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/GibiBIT-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GibiBYTE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("5954088943.639144142991225561007166"),
    undefined,
    "http://qudt.org/vocab/prefix/Gibi",
    "http://qudt.org/vocab/unit/BYTE",
    undefined,
    "GiB",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gibibyte", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InformationEntropy"
  );
  config.units.set("http://qudt.org/vocab/unit/GibiBYTE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GigaA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T0D0",
    new Decimal("1000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Giga",
    "http://qudt.org/vocab/unit/A",
    undefined,
    "GA",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gigaampere", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/CurrentLinkage");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagnetomotiveForce"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MagneticTension");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCurrent");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/TotalCurrent");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DisplacementCurrent"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentPhasor"
  );
  config.units.set("http://qudt.org/vocab/unit/GigaA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GigaBIT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("693147180.55994530941723212145818"),
    undefined,
    "http://qudt.org/vocab/prefix/Giga",
    "http://qudt.org/vocab/unit/BIT",
    undefined,
    "Gb",
    undefined,
    undefined,
    undefined,
    [],
    2,
    false,
    false
  );
  unit.addLabel(new LangString("Gigabit", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DatasetOfBits");
  config.units.set("http://qudt.org/vocab/unit/GigaBIT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GigaBIT-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("693147180.55994530941723212145818"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Gb/m",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gigabit per Metre", "en"));
  unit.addLabel(new LangString("Gigabit per Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearBitDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/GigaBIT-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GigaBIT-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("693147180.55994530941723212145818"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Gb/s",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gigabit per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DataRate");
  config.units.set("http://qudt.org/vocab/unit/GigaBIT-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GigaBQ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("1000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Giga",
    "http://qudt.org/vocab/unit/BQ",
    undefined,
    "GBq",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gigabecquerel", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Activity");
  config.units.set("http://qudt.org/vocab/unit/GigaBQ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GigaBYTE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("5545177444.47956247533785697166544"),
    undefined,
    "http://qudt.org/vocab/prefix/Giga",
    "http://qudt.org/vocab/unit/BYTE",
    undefined,
    "GB",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Gigabyte", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InformationEntropy"
  );
  config.units.set("http://qudt.org/vocab/unit/GigaBYTE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GigaBYTE-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("5545177444.47956247533785697166544"),
    undefined,
    undefined,
    undefined,
    undefined,
    "GB/s",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gigabyte per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ByteRate");
  config.units.set("http://qudt.org/vocab/unit/GigaBYTE-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GigaBasePair",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Giga",
    "http://qudt.org/vocab/unit/BasePair",
    undefined,
    "Gbp",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Giga Base Pair", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Dimensionless");
  config.units.set("http://qudt.org/vocab/unit/GigaBasePair", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GigaC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("1000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Giga",
    "http://qudt.org/vocab/unit/C",
    undefined,
    "GC",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Gigacoulomb", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  config.units.set("http://qudt.org/vocab/unit/GigaC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GigaC-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-3I0M0H0T1D0",
    new Decimal("1000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "GC/m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gigacoulomb per Cubic Meter", "en-US"));
  unit.addLabel(new LangString("Gigacoulomb per Cubic Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargeVolumeDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/GigaC-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GigaEV",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1.602176634E-10"),
    undefined,
    "http://qudt.org/vocab/prefix/Giga",
    "http://qudt.org/vocab/unit/EV",
    undefined,
    "GeV",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Giga Electron Volt", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/GigaEV", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GigaFLOPS",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("1000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Giga",
    "http://qudt.org/vocab/unit/FLOPS",
    undefined,
    "GFLOPS",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Giga Floating Point Operations per Second", "en")
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/FloatingPointCalculationCapability"
  );
  config.units.set("http://qudt.org/vocab/unit/GigaFLOPS", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GigaHZ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("1000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Giga",
    "http://qudt.org/vocab/unit/HZ",
    undefined,
    "GHz",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Gigahertz", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Frequency");
  config.units.set("http://qudt.org/vocab/unit/GigaHZ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GigaHZ-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("1000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "GHz·m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gigahertz Metre", "en"));
  unit.addLabel(new LangString("Gigahertz Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoundParticleVelocity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/GroupSpeedOfSound"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Speed");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ConductionSpeed");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PhaseSpeedOfSound"
  );
  config.units.set("http://qudt.org/vocab/unit/GigaHZ-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GigaJ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Giga",
    "http://qudt.org/vocab/unit/J",
    undefined,
    "GJ",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    4,
    false,
    false
  );
  unit.addLabel(new LangString("Gigajoule", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ThermalEnergy");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/GigaJ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GigaJ-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("277777.7777777777777777777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "GJ/h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gigajoule per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/GigaJ-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GigaJ-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("1000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "GJ/m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gigajoule per Square Metre", "en"));
  unit.addLabel(new LangString("Gigajoule per Square Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyPerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/RadiantFluence");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/StrainEnergyReleaseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyFluence");
  config.units.set("http://qudt.org/vocab/unit/GigaJ-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GigaJ-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "GJ/s",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gigajoule per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/GigaJ-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GigaN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("1000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Giga",
    "http://qudt.org/vocab/unit/N",
    undefined,
    "GN",
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Giganewton", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Force");
  config.units.set("http://qudt.org/vocab/unit/GigaN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GigaN-M-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("1000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "GN·m/m²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Giganewton Meter per Square Meter", "en-US"));
  unit.addLabel(new LangString("Giganewton Metre per Square Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerLength");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyPerArea");
  config.units.set("http://qudt.org/vocab/unit/GigaN-M-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GigaOHM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H0T-3D0",
    new Decimal("1000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Giga",
    "http://qudt.org/vocab/unit/OHM",
    undefined,
    "GΩ",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    2,
    false,
    false
  );
  unit.addLabel(new LangString("Gigaohm", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Resistance");
  config.units.set("http://qudt.org/vocab/unit/GigaOHM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GigaOHM-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L3I0M1H0T-3D0",
    new Decimal("1000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "GΩ·m",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gigaohm Meter", "en-US"));
  unit.addLabel(new LangString("Gigaohm Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Resistivity");
  config.units.set("http://qudt.org/vocab/unit/GigaOHM-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GigaOHM-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L1I0M1H0T-3D0",
    new Decimal("1000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "GΩ/m",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gigaohm per Meter", "en-US"));
  unit.addLabel(new LangString("Gigaohm per Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearResistance"
  );
  config.units.set("http://qudt.org/vocab/unit/GigaOHM-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GigaPA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("1000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Giga",
    "http://qudt.org/vocab/unit/PA",
    undefined,
    "GPa",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Gigapascal", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ModulusOfElasticity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ShearModulus");
  config.units.set("http://qudt.org/vocab/unit/GigaPA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GigaPA-CentiM3-PER-GM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "GPa·cm³/g",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Gigapascal Cubic Centimeter per Gram", "en-US")
  );
  unit.addLabel(new LangString("Gigapascal Cubic Centimetre per Gram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificModulus");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/KiloM2-PER-SEC2");
  config.units.set("http://qudt.org/vocab/unit/GigaPA-CentiM3-PER-GM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GigaV",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-3D0",
    new Decimal("1000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Giga",
    "http://qudt.org/vocab/unit/V",
    undefined,
    "GV",
    undefined,
    undefined,
    undefined,
    [],
    2,
    false,
    false
  );
  unit.addLabel(new LangString("Gigavolt", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotential"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Voltage");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EnergyPerElectricCharge"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotentialDifference"
  );
  config.units.set("http://qudt.org/vocab/unit/GigaV", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GigaV-A",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "GV·A",
    undefined,
    undefined,
    undefined,
    [],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("Gigavolt Ampere", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ApparentPower");
  config.units.set("http://qudt.org/vocab/unit/GigaV-A", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GigaV-A_Reactive",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "GV·A{Reactive}",
    undefined,
    undefined,
    undefined,
    [],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("GigaVolt Ampere Reactive", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ReactivePower");
  config.units.set("http://qudt.org/vocab/unit/GigaV-A_Reactive", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GigaVA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Giga",
    "http://qudt.org/vocab/unit/VA",
    undefined,
    "GVA",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Giga Volt Ampere", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ApparentPower");
  config.units.set("http://qudt.org/vocab/unit/GigaVA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GigaVAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Giga",
    "http://qudt.org/vocab/unit/VAR",
    undefined,
    "GVA{Reactive}",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Giga Volt Ampere Reactive", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ReactivePower");
  config.units.set("http://qudt.org/vocab/unit/GigaVAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GigaW",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Giga",
    "http://qudt.org/vocab/unit/W",
    undefined,
    "GW",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Gigawatt", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/GigaW", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GigaW-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("3600000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "GW·h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Gigawatt Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/GigaW-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/Gs",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L0I0M1H0T-2D0",
    new Decimal("0.0001"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/T",
    undefined,
    "G",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-EMU", "http://qudt.org/vocab/sou/CGS"],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("Gs", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticFluxDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/Gs", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/H",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "H",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    11,
    false,
    false
  );
  unit.addLabel(new LangString("Henry", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Inductance");
  config.units.set("http://qudt.org/vocab/unit/H", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/H-PER-KiloOHM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "H/kΩ",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Henry per Kiloohm", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/H-PER-KiloOHM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/H-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L1I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "H/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Henry per Meter", "en-US"));
  unit.addLabel(new LangString("Henry per Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Permeability");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectromagneticPermeability"
  );
  config.units.set("http://qudt.org/vocab/unit/H-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/H-PER-OHM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "H/Ω",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Henry per Ohm", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/H-PER-OHM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    new Decimal("10000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M2",
    undefined,
    "ha",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    17,
    false,
    false
  );
  unit.addLabel(new LangString("Hectare", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Area");
  config.units.set("http://qudt.org/vocab/unit/HA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HART",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("2.3025850929940456840179914546844"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/NUM",
    undefined,
    "Hart",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Hartley", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InformationEntropy"
  );
  config.units.set("http://qudt.org/vocab/unit/HART", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HART-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("2.3025850929940456840179914546844"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Hart/s",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Hartley per Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InformationFlowRate"
  );
  config.units.set("http://qudt.org/vocab/unit/HART-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I1M0H0T0D0",
    new Decimal("0.92"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/CD",
    undefined,
    "HK",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Hefner-kerze", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LuminousIntensity"
  );
  config.units.set("http://qudt.org/vocab/unit/HK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HP",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("745.6999"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/J-PER-SEC",
    undefined,
    "HP",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Horsepower", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/HP", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HP_Boiler",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("9809.5"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/J-PER-SEC",
    undefined,
    "HP{boiler}",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Boiler Horsepower", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/HP_Boiler", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HP_Brake",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("9809.5"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/J-PER-SEC",
    undefined,
    "HP{brake}",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Horsepower (brake)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/HP_Brake", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HP_Electric",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("746.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/J-PER-SEC",
    undefined,
    "HP{electric}",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Horsepower (electric)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/HP_Electric", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HP_H2O",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("746.043"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/J-PER-SEC",
    undefined,
    "water hp",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Horsepower (water)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/HP_H2O", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HP_Metric",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("735.4988"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/J-PER-SEC",
    undefined,
    "HP{metric}",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Horsepower (metric)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/HP_Metric", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("3600.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/SEC",
    undefined,
    "h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    254,
    false,
    false
  );
  unit.addLabel(new LangString("Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HR-FT2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T1D0",
    new Decimal("334.450944"),
    undefined,
    undefined,
    undefined,
    undefined,
    "h·ft²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Hour Square Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AreaTime");
  config.units.set("http://qudt.org/vocab/unit/HR-FT2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HR-PER-FT2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal("38750.07750015500031000062000124"),
    undefined,
    undefined,
    undefined,
    undefined,
    "h/ft²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Hour per Square Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/HR-PER-FT2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HR-PER-NUM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("3600.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "h/#",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Hour per Number", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/TimePerCount");
  config.units.set("http://qudt.org/vocab/unit/HR-PER-NUM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HR-PER-YR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.0001140771161305042208532968286561716"),
    undefined,
    undefined,
    undefined,
    undefined,
    "h/a",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Hour per Year", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/TimeRatio");
  config.units.set("http://qudt.org/vocab/unit/HR-PER-YR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HR_Sidereal",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("3590.17"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/SEC",
    undefined,
    "h{sidereal}",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Sidereal Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/HR_Sidereal", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HUNDRED",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("100.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/ONE",
    undefined,
    "100",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    2,
    false,
    false
  );
  unit.addLabel(new LangString("Hundred", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Count");
  config.units.set("http://qudt.org/vocab/unit/HUNDRED", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HZ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Hz",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    18,
    false,
    false
  );
  unit.addLabel(new LangString("Hertz", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/RotationalFrequency"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Frequency");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/RotationalVelocity"
  );
  unit.addExactMatchIri("http://qudt.org/vocab/unit/PER-SEC");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/CYC-PER-SEC");
  config.units.set("http://qudt.org/vocab/unit/HZ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HZ-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Hz·m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Hertz Meter", "en-US"));
  unit.addLabel(new LangString("Hertz Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Speed");
  config.units.set("http://qudt.org/vocab/unit/HZ-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HZ-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H-1T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Hz/K",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Hertz per Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InverseTimeTemperature"
  );
  config.units.set("http://qudt.org/vocab/unit/HZ-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HZ-PER-T",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M-1H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Hz/T",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Hertz per Tesla", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerMass"
  );
  config.units.set("http://qudt.org/vocab/unit/HZ-PER-T", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HZ-PER-V",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M-1H0T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Hz/V",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Hertz per Volt", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InverseMagneticFlux"
  );
  config.units.set("http://qudt.org/vocab/unit/HZ-PER-V", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/H_Ab",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H0T-2D0",
    new Decimal("1E-9"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/H",
    undefined,
    "abH",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-EMU", "http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Abhenry", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Inductance");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/NanoH");
  config.units.set("http://qudt.org/vocab/unit/H_Ab", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/H_Stat",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H0T-2D0",
    new Decimal("898760000000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/H",
    undefined,
    "statH",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS", "http://qudt.org/vocab/sou/CGS-ESU"],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Stathenry", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Inductance");
  config.units.set("http://qudt.org/vocab/unit/H_Stat", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/H_Stat-PER-CentiM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L1I0M1H0T-2D0",
    new Decimal("89876000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "statH/cm",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS", "http://qudt.org/vocab/sou/CGS-ESU"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Stathenry per Centimeter", "en-US"));
  unit.addLabel(new LangString("Stathenry per Centimetre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Permeability");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectromagneticPermeability"
  );
  config.units.set("http://qudt.org/vocab/unit/H_Stat-PER-CentiM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HeartBeat",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "heartbeat",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Heart Beat", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Dimensionless");
  config.units.set("http://qudt.org/vocab/unit/HeartBeat", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HectoBAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("10000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Hecto",
    "http://qudt.org/vocab/unit/BAR",
    undefined,
    "hbar",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Hectobar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/HectoBAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HectoC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("100.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Hecto",
    "http://qudt.org/vocab/unit/C",
    undefined,
    "hC",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Hectocoulomb", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  config.units.set("http://qudt.org/vocab/unit/HectoC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HectoCOUNT",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    true
  );
  unit.addLabel(new LangString("HectoCOUNT", undefined));
  config.units.set("http://qudt.org/vocab/unit/HectoCOUNT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HectoGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("0.1"),
    undefined,
    "http://qudt.org/vocab/prefix/Hecto",
    "http://qudt.org/vocab/unit/GM",
    undefined,
    "hg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    2,
    false,
    false
  );
  unit.addLabel(new LangString("Hectogram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  config.units.set("http://qudt.org/vocab/unit/HectoGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HectoKiloCOUNT",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    true
  );
  unit.addLabel(new LangString("HectoKiloCOUNT", undefined));
  config.units.set("http://qudt.org/vocab/unit/HectoKiloCOUNT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HectoL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.1"),
    undefined,
    "http://qudt.org/vocab/prefix/Hecto",
    "http://qudt.org/vocab/unit/L",
    undefined,
    "hL",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Hectolitre", "en"));
  unit.addLabel(new LangString("Hectoliter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/HectoL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HectoM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("100.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Hecto",
    "http://qudt.org/vocab/unit/M",
    undefined,
    "hm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Hectometre", "en"));
  unit.addLabel(new LangString("Hectometer", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/HectoM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HectoPA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("100.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Hecto",
    "http://qudt.org/vocab/unit/PA",
    undefined,
    "hPa",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    7,
    false,
    false
  );
  unit.addLabel(new LangString("Hectopascal", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ModulusOfElasticity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ShearModulus");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/MilliBAR");
  config.units.set("http://qudt.org/vocab/unit/HectoPA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HectoPA-L-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("0.1"),
    undefined,
    undefined,
    undefined,
    undefined,
    "hPa·L/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Hectopascal Litre per Second", "en"));
  unit.addLabel(new LangString("Hectopascal Liter per Second", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/HectoPA-L-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HectoPA-M3-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("100.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "hPa·m³/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Hectopascal Cubic Meter per Second", "en-US"));
  unit.addLabel(new LangString("Hectopascal Cubic Metre per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/HectoPA-M3-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HectoPA-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "hPa/bar",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Hectopascal per Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PressureRatio");
  config.units.set("http://qudt.org/vocab/unit/HectoPA-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HectoPA-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-3D0",
    new Decimal("0.02777777777777777777777777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "hPa/h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Hectopascal per Hour", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ForcePerAreaTime"
  );
  config.units.set("http://qudt.org/vocab/unit/HectoPA-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HectoPA-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H-1T-2D0",
    new Decimal("100.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "hPa/K",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Hectopascal per Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PressureCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/HectoPA-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HectoPA-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-2D0",
    new Decimal("100.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "hPa/m",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Hectopascal per Metre", "en"));
  unit.addLabel(new LangString("Hectopascal per Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PressureGradient"
  );
  config.units.set("http://qudt.org/vocab/unit/HectoPA-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/Hundredweight_UK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("50.80235"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "cwt{long}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Hundredweight (UK)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/CWT_LONG");
  config.units.set("http://qudt.org/vocab/unit/Hundredweight_UK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/Hundredweight_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("45.359237"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "cwt{short}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Hundredweight (US)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/CWT_SHORT");
  config.units.set("http://qudt.org/vocab/unit/Hundredweight_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/IN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("0.0254"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M",
    undefined,
    "in",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    343,
    false,
    false
  );
  unit.addLabel(new LangString("Inch", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/ZOLL");
  config.units.set("http://qudt.org/vocab/unit/IN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/IN-PDL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("0.0035116758411504"),
    undefined,
    undefined,
    undefined,
    undefined,
    "in·pdl",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Inch Poundal", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MomentOfForce");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Torque");
  config.units.set("http://qudt.org/vocab/unit/IN-PDL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/IN-PER-2PiRAD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "in/revolution",
    undefined,
    undefined,
    undefined,
    [],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("Inch per 2pirad", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Rotary-TranslatoryMotionConversion"
  );
  config.units.set("http://qudt.org/vocab/unit/IN-PER-2PiRAD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/IN-PER-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H-1T0D0",
    new Decimal("0.04572"),
    undefined,
    undefined,
    undefined,
    undefined,
    "in/°F",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Inch per Degree Fahrenheit", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearThermalExpansion"
  );
  config.units.set("http://qudt.org/vocab/unit/IN-PER-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/IN-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("0.0004233333333333333333333333333333334"),
    undefined,
    undefined,
    undefined,
    undefined,
    "in/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Inch per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/IN-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/IN-PER-PSI",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M-1H0T2D0",
    new Decimal("0.000003683958373057262503457335380421946"),
    undefined,
    undefined,
    undefined,
    undefined,
    "in/psi",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Inch per Psi", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/IN-PER-PSI", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/IN-PER-REV",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("0.004042535552719517037449910895593179"),
    undefined,
    undefined,
    undefined,
    undefined,
    "in/rev",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Inch per Revolution", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Rotary-TranslatoryMotionConversion"
  );
  config.units.set("http://qudt.org/vocab/unit/IN-PER-REV", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/IN-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("0.0254"),
    undefined,
    undefined,
    undefined,
    undefined,
    "in/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Inch per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PropellantBurnRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/IN-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/IN-PER-SEC-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H-1T-1D0",
    new Decimal("0.04572"),
    undefined,
    undefined,
    undefined,
    undefined,
    "in/(s·°F)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Inch per Second Degree Fahrenheit", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/IN-PER-SEC-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/IN-PER-SEC-PSI",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M-1H0T1D0",
    new Decimal("0.000003683958373057262503457335380421946"),
    undefined,
    undefined,
    undefined,
    undefined,
    "in/(s·psi)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Inch per Second Psi", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/IN-PER-SEC-PSI", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/IN-PER-SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-2D0",
    new Decimal("0.0254"),
    undefined,
    undefined,
    undefined,
    undefined,
    "in/s²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Inch per Square Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Acceleration");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearAcceleration"
  );
  config.units.set("http://qudt.org/vocab/unit/IN-PER-SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/IN-PER-YR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("8.048774304763353360204831799629884E-10"),
    undefined,
    undefined,
    undefined,
    undefined,
    "in/a",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Inch per Year", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Speed");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectromagneticWavePhaseSpeed"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/IN-PER-YR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/IN2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    new Decimal("0.00064516"),
    undefined,
    undefined,
    undefined,
    undefined,
    "in²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Inch", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/HydraulicPermeability"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Area");
  config.units.set("http://qudt.org/vocab/unit/IN2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/IN2-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-1D0",
    new Decimal("0.00064516"),
    undefined,
    undefined,
    undefined,
    undefined,
    "in²/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Inch per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AreaPerTime");
  config.units.set("http://qudt.org/vocab/unit/IN2-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/IN3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.000016387064"),
    undefined,
    undefined,
    undefined,
    undefined,
    "in³",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Inch", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/IN3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/IN3-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("4.551962222222222222222222222222223E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "in³/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Inch per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/IN3-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/IN3-PER-LB",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M-1H0T0D0",
    new Decimal("0.00003612729200008368747472537952964244"),
    undefined,
    undefined,
    undefined,
    undefined,
    "in³/lbm",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Inch per Pound Mass", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoilAdsorptionCoefficient"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificVolume");
  config.units.set("http://qudt.org/vocab/unit/IN3-PER-LB", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/IN3-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("2.731177333333333333333333333333334E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "in³/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Inch per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/IN3-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/IN3-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.000016387064"),
    undefined,
    undefined,
    undefined,
    undefined,
    "in³/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Inch per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/IN3-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/IN4",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M0H0T0D0",
    new Decimal("4.162314256E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "in⁴",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Quartic Inch", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SecondMomentOfArea"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SecondAxialMomentOfArea"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SecondPolarMomentOfArea"
  );
  config.units.set("http://qudt.org/vocab/unit/IN4", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/IN_H2O",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("249.0889"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/PA",
    undefined,
    "inH₂O",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Inch of Water", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/IN_H2O", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/IN_H2O_39dot2DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("249.082"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/PA",
    undefined,
    "inH₂O (39.2 °F)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Inch of Water (39.2 °F)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/IN_H2O_39dot2DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/IN_H2O_60DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("248.84"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/PA",
    undefined,
    "inH₂O (60 °F)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Inch of Water (60 °F)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/IN_H2O_60DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/IN_HG",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("3386.389"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/PA",
    undefined,
    "inHg",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Inch of Mercury", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/IN_HG", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/IN_HG_32DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("3386.38"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/PA",
    undefined,
    "inHg (32 °F)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Inch of Mercury (32 °F)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/IN_HG_32DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/IN_HG_60DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("3376.85"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/PA",
    undefined,
    "inHg (60 °F)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Inch of Mercury (60 °F)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/IN_HG_60DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/IU",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T0D0",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "IU",
    undefined,
    undefined,
    undefined,
    [],
    3,
    false,
    false
  );
  unit.addLabel(new LangString("International Unit", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstance"
  );
  config.units.set("http://qudt.org/vocab/unit/IU", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/IU-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T0D0",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "IU/L",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("International Unit per Litre", "en"));
  unit.addLabel(new LangString("International Unit per Liter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PlasmaLevel");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SerumLevel");
  config.units.set("http://qudt.org/vocab/unit/IU-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/IU-PER-MilliGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M-1H0T0D0",
    new Decimal("0.0"),
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    "IU/mg",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("International Unit per Milligram", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstancePerMass"
  );
  config.units.set("http://qudt.org/vocab/unit/IU-PER-MilliGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/IU-PER-MilliL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T0D0",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "IU/mL",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("International Unit per Milliliter", "en-US"));
  unit.addLabel(new LangString("International Unit per Millilitre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PlasmaLevel");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SerumLevel");
  config.units.set("http://qudt.org/vocab/unit/IU-PER-MilliL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/J",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    204,
    false,
    false
  );
  unit.addLabel(new LangString("Joule", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LagrangeFunction"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LevelWidth");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ThermalEnergy");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/HamiltonFunction"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ExchangeIntegral"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/N-M");
  config.units.set("http://qudt.org/vocab/unit/J", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/J-M-PER-MOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A-1E0L3I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J·m/mol",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Joule Meter per Mole", "en-US"));
  unit.addLabel(new LangString("Joule Metre per Mole", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LengthMolarEnergy"
  );
  config.units.set("http://qudt.org/vocab/unit/J-M-PER-MOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/J-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J·m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Joule Square Meter", "en-US"));
  unit.addLabel(new LangString("Joule Square Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TotalAtomicStoppingPower"
  );
  config.units.set("http://qudt.org/vocab/unit/J-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/J-M2-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M0H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J·m²/kg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Joule Square Metre per Kilogram", "en"));
  unit.addLabel(new LangString("Joule Square Meter per Kilogram", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TotalMassStoppingPower"
  );
  config.units.set("http://qudt.org/vocab/unit/J-M2-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/J-PER-CentiM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("10000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J/cm²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Joule per Square Centimetre", "en"));
  unit.addLabel(new LangString("Joule per Square Centimeter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyPerArea");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/StrainEnergyReleaseRate"
  );
  config.units.set("http://qudt.org/vocab/unit/J-PER-CentiM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/J-PER-CentiM2-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    new Decimal("0.1157407407407407407407407407407407"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J/(cm²·d)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Joule per Square Centimetre Day", "en"));
  unit.addLabel(new LangString("Joule per Square Centimeter Day", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PowerPerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Radiosity");
  config.units.set("http://qudt.org/vocab/unit/J-PER-CentiM2-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/J-PER-CentiM3-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H-1T-2D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J/(cm³·K)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Joule per Cubic Centimetre Kelvin", "en"));
  unit.addLabel(new LangString("Joule per Cubic Centimeter Kelvin", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/VolumetricHeatCapacity"
  );
  config.units.set("http://qudt.org/vocab/unit/J-PER-CentiM3-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/J-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("0.00001157407407407407407407407407407407"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J/d",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Joule per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/J-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/J-PER-GM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J/g",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Joule per Gram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificEnergy");
  config.units.set("http://qudt.org/vocab/unit/J-PER-GM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/J-PER-GM-DEG_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H-1T-2D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J/(g·°C)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Joule per Gram Degree Celsius", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtConstantVolume"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtConstantPressure"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtSaturation"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificEntropy");
  config.units.set("http://qudt.org/vocab/unit/J-PER-GM-DEG_C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/J-PER-GM-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H-1T-2D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J/(g·K)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Joule per Gram Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtConstantVolume"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtConstantPressure"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtSaturation"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificEntropy");
  config.units.set("http://qudt.org/vocab/unit/J-PER-GM-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/J-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("0.0002777777777777777777777777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J/h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Joule per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/J-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/J-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H-1T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J/K",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Joule per Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/HeatCapacity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Entropy");
  config.units.set("http://qudt.org/vocab/unit/J-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/J-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J/kg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Joule per Kilogram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificEnergy");
  config.units.set("http://qudt.org/vocab/unit/J-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/J-PER-KiloGM-DEG_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H-1T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J/(kg·°C)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Joule per Kilogram Degree Celsius", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtConstantVolume"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtConstantPressure"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtSaturation"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificEntropy");
  config.units.set("http://qudt.org/vocab/unit/J-PER-KiloGM-DEG_C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/J-PER-KiloGM-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H-1T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J/(kg·K)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Joule per Kilogram Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtConstantVolume"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtConstantPressure"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtSaturation"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificEntropy");
  config.units.set("http://qudt.org/vocab/unit/J-PER-KiloGM-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/J-PER-KiloGM-K-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H-1T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J/(kg·K·m³)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Joule per Kilogram Kelvin Cubic Metre", "en"));
  unit.addLabel(
    new LangString("Joule per Kilogram Kelvin Cubic Meter", "en-US")
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatVolume"
  );
  config.units.set("http://qudt.org/vocab/unit/J-PER-KiloGM-K-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/J-PER-KiloGM-K-PA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M-1H-1T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J/(kg·K·Pa)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Joule per Kilogram Kelvin Pascal", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatPressure"
  );
  config.units.set("http://qudt.org/vocab/unit/J-PER-KiloGM-K-PA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/J-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Joule per Metre", "en"));
  unit.addLabel(new LangString("Joule per Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearEnergyTransfer"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TotalLinearStoppingPower"
  );
  config.units.set("http://qudt.org/vocab/unit/J-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/J-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J/m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Joule per Square Meter", "en-US"));
  unit.addLabel(new LangString("Joule per Square Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyPerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/RadiantFluence");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/StrainEnergyReleaseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyFluence");
  config.units.set("http://qudt.org/vocab/unit/J-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/J-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J/m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Joule per Cubic Meter", "en-US"));
  unit.addLabel(new LangString("Joule per Cubic Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/RadiantEnergyDensity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyDensity");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectromagneticEnergyDensity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/VolumicElectromagneticEnergy"
  );
  config.units.set("http://qudt.org/vocab/unit/J-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/J-PER-M3-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H-1T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J/(m³·K)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Joule per Cubic Meter Kelvin", "en-US"));
  unit.addLabel(new LangString("Joule per Cubic Metre Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/VolumetricHeatCapacity"
  );
  config.units.set("http://qudt.org/vocab/unit/J-PER-M3-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/J-PER-M4",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J/m⁴",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Joule per Quartic Metre", "en"));
  unit.addLabel(new LangString("Joule per Quartic Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpectralRadiantEnergyDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/J-PER-M4", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/J-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("0.01666666666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J/min",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Joule per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/J-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/J-PER-MOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A-1E0L2I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J/mol",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Joule per Mole", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ChemicalAffinity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPolarizability"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MolarEnergy");
  config.units.set("http://qudt.org/vocab/unit/J-PER-MOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/J-PER-MOL-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A-1E0L2I0M1H-1T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J/(mol·K)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Joule per Mole Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MolarHeatCapacity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MolarEntropy");
  config.units.set("http://qudt.org/vocab/unit/J-PER-MOL-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/J-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    8,
    false,
    false
  );
  unit.addLabel(new LangString("Joule per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/J-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/J-PER-T",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L2I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J/T",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Joule per Tesla", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MagneticMoment");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticAreaMoment"
  );
  config.units.set("http://qudt.org/vocab/unit/J-PER-T", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/J-PER-T2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L2I0M-1H0T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J/T²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Joule per Square Tesla", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EnergyPerSquareMagneticFluxDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/J-PER-T2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/J-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J·s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Joule Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Action");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AngularImpulse");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AngularMomentum");
  config.units.set("http://qudt.org/vocab/unit/J-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/J-SEC-PER-MOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A-1E0L2I0M1H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J·s/mol",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Joule Second per Mole", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MolarAngularMomentum"
  );
  config.units.set("http://qudt.org/vocab/unit/J-SEC-PER-MOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "K",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    177,
    false,
    false
  );
  unit.addLabel(new LangString("Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MeltingPoint");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermodynamicTemperature"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/BoilingPoint");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Temperature");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CorrelatedColorTemperature"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/FlashPoint");
  config.units.set("http://qudt.org/vocab/unit/K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/K-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T1D0",
    new Decimal("86400.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "K·d",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kelvin Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/TimeTemperature");
  config.units.set("http://qudt.org/vocab/unit/K-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/K-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H1T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "K·m",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kelvin Metre", "en"));
  unit.addLabel(new LangString("Kelvin Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LengthTemperature"
  );
  config.units.set("http://qudt.org/vocab/unit/K-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/K-M-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H1T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "K·m/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kelvin Metre per Second", "en"));
  unit.addLabel(new LangString("Kelvin Meter per Second", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/K-M-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/K-M-PER-W",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M-1H1T3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "K·m/W",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kelvin Meter per Watt", "en-US"));
  unit.addLabel(new LangString("Kelvin Metre per Watt", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalResistivity"
  );
  config.units.set("http://qudt.org/vocab/unit/K-M-PER-W", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/K-M2-PER-KiloGM-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M-1H1T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "K·m²/(kg·s)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Kelvin Square Meter per Kilogram Second", "en-US")
  );
  unit.addLabel(
    new LangString("Kelvin Square Metre per Kilogram Second", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/K-M2-PER-KiloGM-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/K-PA-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H1T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "K·Pa/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kelvin Pascal per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/K-PA-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/K-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H1T2D0",
    new Decimal("0.00001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "K/bar",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kelvin per Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/K-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/K-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T-1D0",
    new Decimal("0.0002777777777777777777777777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "K/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kelvin per Hour", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TemperaturePerTime"
  );
  config.units.set("http://qudt.org/vocab/unit/K-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/K-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "K/K",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kelvin per Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TemperatureRatio"
  );
  config.units.set("http://qudt.org/vocab/unit/K-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/K-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H1T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "K/m",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kelvin per Meter", "en-US"));
  unit.addLabel(new LangString("Kelvin per Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TemperatureGradient"
  );
  config.units.set("http://qudt.org/vocab/unit/K-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/K-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T-1D0",
    new Decimal("0.01666666666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "K/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kelvin per Minute", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TemperaturePerTime"
  );
  config.units.set("http://qudt.org/vocab/unit/K-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/K-PER-PA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H1T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "K/Pa",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kelvin per Pascal", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/K-PER-PA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/K-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "K/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kelvin per Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TemperaturePerTime"
  );
  config.units.set("http://qudt.org/vocab/unit/K-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/K-PER-SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "K/s²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kelvin per Square Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TemperaturePerSquareTime"
  );
  config.units.set("http://qudt.org/vocab/unit/K-PER-SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/K-PER-T",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M-1H1T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "K/T",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kelvin per Tesla", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TemperaturePerMagneticFluxDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/K-PER-T", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/K-PER-W",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M-1H1T3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "K/W",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kelvin per Watt", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalResistance"
  );
  config.units.set("http://qudt.org/vocab/unit/K-PER-W", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/K-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "K·s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kelvin Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/TimeTemperature");
  config.units.set("http://qudt.org/vocab/unit/K-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/K2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H2T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "K²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/K2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KAT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kat",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    8,
    false,
    false
  );
  unit.addLabel(new LangString("Katal", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CatalyticActivity"
  );
  config.units.set("http://qudt.org/vocab/unit/KAT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KAT-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T-1D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kat/L",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Katal per Liter", "en-US"));
  unit.addLabel(new LangString("Katal per Litre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CatalyticActivityConcentration"
  );
  config.units.set("http://qudt.org/vocab/unit/KAT-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KAT-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kat/m³",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Katal per Cubic Meter", "en-US"));
  unit.addLabel(new LangString("Katal per Cubic Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CatalyticActivityConcentration"
  );
  config.units.set("http://qudt.org/vocab/unit/KAT-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KAT-PER-MicroL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T-1D0",
    new Decimal("1000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kat/μL",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Katal per Microlitre", "en"));
  unit.addLabel(new LangString("Katal per Microliter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CatalyticActivityConcentration"
  );
  config.units.set("http://qudt.org/vocab/unit/KAT-PER-MicroL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KIP_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("4448.2218148411428"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kip",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Kip", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Force");
  config.units.set("http://qudt.org/vocab/unit/KIP_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KIP_F-PER-IN2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("6894757.602518976377952755905511811"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kip/in²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kip per Square Inch", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ModulusOfElasticity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ShearModulus");
  config.units.set("http://qudt.org/vocab/unit/KIP_F-PER-IN2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("0.5144444444444444444444444444444445"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kn",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Knot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/MI_N-PER-HR");
  config.units.set("http://qudt.org/vocab/unit/KN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KN-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-2D0",
    new Decimal("0.5144444444444444444444444444444445"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kn/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Knot per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Acceleration");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearAcceleration"
  );
  config.units.set("http://qudt.org/vocab/unit/KN-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("100.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "K",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-GAUSS", "http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kayser", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseLength");
  config.units.set("http://qudt.org/vocab/unit/KY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KibiBIT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("709.7827128933839968432456923731763"),
    undefined,
    "http://qudt.org/vocab/prefix/Kibi",
    "http://qudt.org/vocab/unit/BIT",
    undefined,
    "Kib",
    undefined,
    undefined,
    undefined,
    [],
    3,
    false,
    false
  );
  unit.addLabel(new LangString("Kibibit", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DatasetOfBits");
  config.units.set("http://qudt.org/vocab/unit/KibiBIT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KibiBIT-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("709.7827128933839968432456923731763"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Kib/m",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kibibit per Meter", "en-US"));
  unit.addLabel(new LangString("Kibibit per Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearBitDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/KibiBIT-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KibiBIT-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T0D0",
    new Decimal("709.7827128933839968432456923731763"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Kib/m²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kibibit per Square Meter", "en-US"));
  unit.addLabel(new LangString("Kibibit per Square Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AreaBitDensity");
  config.units.set("http://qudt.org/vocab/unit/KibiBIT-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KibiBIT-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    new Decimal("709.7827128933839968432456923731763"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Kib/m³",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kibibit per Cubic Meter", "en-US"));
  unit.addLabel(new LangString("Kibibit per Cubic Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/VolumetricBitDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/KibiBIT-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KibiBYTE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("5678.261703147071974745965538985411"),
    undefined,
    "http://qudt.org/vocab/prefix/Kibi",
    "http://qudt.org/vocab/unit/BYTE",
    undefined,
    "KiB",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kibibyte", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InformationEntropy"
  );
  config.units.set("http://qudt.org/vocab/unit/KibiBYTE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/Kilo-FT3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    undefined,
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M3",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    true
  );
  unit.addLabel(new LangString("Kilo-FT3", undefined));
  config.units.set("http://qudt.org/vocab/unit/Kilo-FT3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T0D0",
    new Decimal("1000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/A",
    undefined,
    "kA",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    4,
    false,
    false
  );
  unit.addLabel(new LangString("Kiloampere", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCurrent");
  config.units.set("http://qudt.org/vocab/unit/KiloA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloA-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("3600000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kA·h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kiloampere Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/BatteryCapacity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  config.units.set("http://qudt.org/vocab/unit/KiloA-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloA-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H-1T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kA/K",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kiloampere per Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentPerTemperature"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloA-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloA-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-1I0M0H0T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kA/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kiloampere per Metre", "en"));
  unit.addLabel(new LangString("Kiloampere per Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearElectricCurrentDensity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticFieldStrength"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloA-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloA-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H0T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kA/m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kiloampere per Square Metre", "en"));
  unit.addLabel(new LangString("Kiloampere per Square Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloA-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloBAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("100000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/BAR",
    undefined,
    "kbar",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilobar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/KiloBAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloBAUD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/BAUD",
    undefined,
    "kBd",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilobaud", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DigitRate");
  config.units.set("http://qudt.org/vocab/unit/KiloBAUD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloBIT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("693.14718055994530941723212145818"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/BIT",
    undefined,
    "kb",
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Kilobit", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DatasetOfBits");
  config.units.set("http://qudt.org/vocab/unit/KiloBIT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloBIT-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("693.14718055994530941723212145818"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kb/s",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilobit per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DataRate");
  config.units.set("http://qudt.org/vocab/unit/KiloBIT-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloBQ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("1000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/BQ",
    undefined,
    "kBq",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Kilobecquerel", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Activity");
  config.units.set("http://qudt.org/vocab/unit/KiloBQ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloBQ-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T-1D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kBq/kg",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilobecquerel per Kilogram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassicActivity");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificActivity"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloBQ-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloBTU_IT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1055055.85262"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/BTU_IT",
    undefined,
    "kBtu{IT}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    2,
    false,
    false
  );
  unit.addLabel(
    new LangString("Kilo British Thermal Unit (international Definition)", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ThermalEnergy");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/KiloBTU_IT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloBTU_IT-PER-FT2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("11356526.68222697556506224123559358"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kBtu{IT}/ft²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "Kilo British Thermal Unit (international Definition) per Square Foot",
      "en"
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyPerArea");
  config.units.set("http://qudt.org/vocab/unit/KiloBTU_IT-PER-FT2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloBTU_IT-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("293.0710701722222222222222222222222"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kBtu{IT}/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "Kilo British Thermal Unit (international Definition) per Hour",
      "en"
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/HeatFlowRate");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/KiloBTU_IT-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloBTU_TH",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1054350.2645"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/BTU_TH",
    undefined,
    "kBtu{th}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    1,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "Kilo British Thermal Unit (thermochemical Definition)",
      "en"
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ThermalEnergy");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/KiloBTU_TH", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloBTU_TH-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("292.8750734722222222222222222222222"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kBtu{th}/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "Kilo British Thermal Unit (thermochemical Definition) per Hour",
      "en"
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/HeatFlowRate");
  config.units.set("http://qudt.org/vocab/unit/KiloBTU_TH-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloBYTE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("5545.17744447956247533785697166544"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/BYTE",
    undefined,
    "kB",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Kilobyte", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InformationEntropy"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloBYTE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloBYTE-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("5545.17744447956247533785697166544"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kB/s",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilobyte per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DataRate");
  config.units.set("http://qudt.org/vocab/unit/KiloBYTE-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("1000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/C",
    undefined,
    "kC",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    2,
    false,
    false
  );
  unit.addLabel(new LangString("Kilocoulomb", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  config.units.set("http://qudt.org/vocab/unit/KiloC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloC-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H0T1D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kC/m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilocoulomb per Square Meter", "en-US"));
  unit.addLabel(new LangString("Kilocoulomb per Square Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerArea"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPolarization"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloC-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloC-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-3I0M0H0T1D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kC/m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilocoulomb per Cubic Meter", "en-US"));
  unit.addLabel(new LangString("Kilocoulomb per Cubic Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargeVolumeDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloC-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloCAL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("4184.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/J",
    undefined,
    "kcal",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    10,
    false,
    false
  );
  unit.addLabel(new LangString("Kilocalorie", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ThermalEnergy");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/KiloCAL_TH");
  config.units.set("http://qudt.org/vocab/unit/KiloCAL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloCAL-PER-CentiM-SEC-DEG_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H-1T-3D0",
    new Decimal("418400.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kcal/(cm·s·°C)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Kilocalorie per Centimeter Second Degree Celsius", "en-US")
  );
  unit.addLabel(
    new LangString("Kilocalorie per Centimetre Second Degree Celsius", "en")
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalConductivity"
  );
  config.units.set(
    "http://qudt.org/vocab/unit/KiloCAL-PER-CentiM-SEC-DEG_C",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("41840000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kcal/cm²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilocalorie per Square Centimeter", "en-US"));
  unit.addLabel(new LangString("Kilocalorie per Square Centimetre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyPerArea");
  config.units.set("http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    new Decimal("697333.3333333333333333333333333335"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kcal/(cm²·min)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Kilocalorie per Square Centimetre Minute", "en")
  );
  unit.addLabel(
    new LangString("Kilocalorie per Square Centimeter Minute", "en-US")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PowerPerArea");
  config.units.set("http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    new Decimal("41840000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kcal/(cm²·s)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Kilocalorie per Square Centimetre Second", "en")
  );
  unit.addLabel(
    new LangString("Kilocalorie per Square Centimeter Second", "en-US")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PowerPerArea");
  config.units.set("http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloCAL-PER-GM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("4184000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kcal/g",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilocalorie per Gram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificEnergy");
  config.units.set("http://qudt.org/vocab/unit/KiloCAL-PER-GM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloCAL-PER-GM-DEG_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H-1T-2D0",
    new Decimal("4184000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kcal/(g·°C)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilocalorie per Gram Degree Celsius", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtConstantVolume"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtConstantPressure"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtSaturation"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificEntropy");
  config.units.set("http://qudt.org/vocab/unit/KiloCAL-PER-GM-DEG_C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloCAL-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("69.73333333333333333333333333333335"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kcal/min",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilocalorie per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/HeatFlowRate");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/KiloCAL-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloCAL-PER-MOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A-1E0L2I0M1H0T-2D0",
    new Decimal("4184.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kcal/mol",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilocalorie per Mole", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MolarEnergy");
  config.units.set("http://qudt.org/vocab/unit/KiloCAL-PER-MOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloCAL-PER-MOL-DEG_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A-1E0L2I0M1H-1T-2D0",
    new Decimal("4184.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kcal/(mol·°C)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilocalorie per Mole Degree Celsius", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MolarHeatCapacity"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloCAL-PER-MOL-DEG_C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloCAL-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("4184.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kcal/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilocalorie per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/HeatFlowRate");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/KiloCAL-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloCAL_IT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("4186.8"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/CAL_IT",
    undefined,
    "kcal{IT}",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    3,
    false,
    false
  );
  unit.addLabel(new LangString("Kilo International Table Calorie", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ThermalEnergy");
  config.units.set("http://qudt.org/vocab/unit/KiloCAL_IT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloCAL_IT-PER-GM-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H-1T-2D0",
    new Decimal("4186800.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kcal{IT}/(g·K)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Kilo International Table Calorie per Gram Kelvin", "en")
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassicHeatCapacity"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloCAL_IT-PER-GM-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloCAL_IT-PER-HR-M-DEG_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H-1T-3D0",
    new Decimal("1.163"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kcal{IT}/(h·m·°C)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "Kilo International Table Calorie per Hour Metre Degree Celsius",
      "en"
    )
  );
  unit.addLabel(
    new LangString(
      "Kilo International Table Calorie per Hour Meter Degree Celsius",
      "en-US"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalConductivity"
  );
  config.units.set(
    "http://qudt.org/vocab/unit/KiloCAL_IT-PER-HR-M-DEG_C",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloCAL_Mean",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("4190.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/J",
    undefined,
    "kcal{mean}",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilocalorie (Mean)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ThermalEnergy");
  config.units.set("http://qudt.org/vocab/unit/KiloCAL_Mean", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloCAL_TH",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("4184.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/CAL_TH",
    undefined,
    "kcal",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    3,
    false,
    false
  );
  unit.addLabel(new LangString("Kilo Thermochemical Calorie", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ThermalEnergy");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/KiloCAL");
  config.units.set("http://qudt.org/vocab/unit/KiloCAL_TH", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloCAL_TH-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1.162222222222222222222222222222222"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kcal/h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilo Thermochemical Calorie per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/HeatFlowRate");
  config.units.set("http://qudt.org/vocab/unit/KiloCAL_TH-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloCAL_TH-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("69.73333333333333333333333333333335"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kcal/min",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilo Thermochemical Calorie per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/HeatFlowRate");
  config.units.set("http://qudt.org/vocab/unit/KiloCAL_TH-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloCAL_TH-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("4184.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kcal/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilo Thermochemical Calorie per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/HeatFlowRate");
  config.units.set("http://qudt.org/vocab/unit/KiloCAL_TH-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloCD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I1M0H0T0D0",
    new Decimal("1000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/CD",
    undefined,
    "kcd",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilocandela", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LuminousIntensity"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloCD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloCI",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("37000000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/CI",
    undefined,
    "kCi",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilocurie", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Activity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DecayConstant");
  config.units.set("http://qudt.org/vocab/unit/KiloCI", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloCOUNT",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    true
  );
  unit.addLabel(new LangString("KiloCOUNT", undefined));
  config.units.set("http://qudt.org/vocab/unit/KiloCOUNT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloCi",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("37000000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/CI",
    undefined,
    "kCi",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("Kilocurie", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Activity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DecayConstant");
  config.units.set("http://qudt.org/vocab/unit/KiloCi", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloCubicFT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("28.316846592"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/FT3",
    undefined,
    "k(ft³)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilo Cubic Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LiquidVolume");
  config.units.set("http://qudt.org/vocab/unit/KiloCubicFT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloEV",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1.602176634E-16"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/EV",
    undefined,
    "keV",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Kilo Electron Volt", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/KiloEV", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloEV-PER-MicroM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("1.602176634E-10"),
    undefined,
    undefined,
    undefined,
    undefined,
    "keV/μm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilo Electron Volt per Micrometre", "en"));
  unit.addLabel(new LangString("Kilo Electron Volt per Micrometer", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearEnergyTransfer"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloEV-PER-MicroM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloFARAD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-2I0M-1H0T4D0",
    new Decimal("1000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/FARAD",
    undefined,
    "kF",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilofarad", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Capacitance");
  config.units.set("http://qudt.org/vocab/unit/KiloFARAD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGAUSS",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L0I0M1H0T-2D0",
    new Decimal("0.1"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/GAUSS",
    undefined,
    "kGs",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogauss", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticFluxDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloGAUSS", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    413,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/CO2Equivalent");
  config.units.set("http://qudt.org/vocab/unit/KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-CentiM-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-1D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg·cm/s",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram Centimetre per Second", "en"));
  unit.addLabel(new LangString("Kilogram Centimeter per Second", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Impulse");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-CentiM-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-CentiM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T0D0",
    new Decimal("0.0001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg·cm²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram Square Centimetre", "en"));
  unit.addLabel(new LangString("Kilogram Square Centimeter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/RotationalMass");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MomentOfInertia");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-CentiM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H1T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg·K",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassTemperature");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg·m",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram Meter", "en-US"));
  unit.addLabel(new LangString("Kilogram Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unbalance");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-M-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg·m/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram Meter per Second", "en-US"));
  unit.addLabel(new LangString("Kilogram Metre per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Momentum");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearMomentum");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-M-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-M-PER-SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg·m/s²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram Meter per Square Second", "en-US"));
  unit.addLabel(new LangString("Kilogram Metre per Square Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Force");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/N");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-M-PER-SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg·m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram Square Meter", "en-US"));
  unit.addLabel(new LangString("Kilogram Square Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/RotationalMass");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MomentOfInertia");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-M2-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg·m²/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram Square Meter per Second", "en-US"));
  unit.addLabel(new LangString("Kilogram Square Metre per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AngularImpulse");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AngularMomentum");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-M2-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-MilliM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T0D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg·mm²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram Square Millimetre", "en"));
  unit.addLabel(new LangString("Kilogram Square Millimeter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/RotationalMass");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MomentOfInertia");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-MilliM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T2D0",
    new Decimal("0.00001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/bar",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram per Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-CentiM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    new Decimal("10000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/cm²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram per Square Centimetre", "en"));
  unit.addLabel(new LangString("Kilogram per Square Centimeter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerArea");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-CentiM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-CentiM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/cm³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram per Cubic Centimetre", "en"));
  unit.addLabel(new LangString("Kilogram per Cubic Centimeter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-CentiM3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-CentiM3-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T2D0",
    new Decimal("10.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(cm³·bar)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram per Cubic Centimeter Bar", "en-US"));
  unit.addLabel(new LangString("Kilogram per Cubic Centimetre Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerEnergy");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-CentiM3-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-CentiM3-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H-1T0D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(cm³·K)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Kilogram per Cubic Centimeter Kelvin", "en-US")
  );
  unit.addLabel(new LangString("Kilogram per Cubic Centimetre Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-CentiM3-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("0.00001157407407407407407407407407407407"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/d",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-DAY-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T1D0",
    new Decimal("1.157407407407407407407407407407407E-10"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(d·bar)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram per Day Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-DAY-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-DAY-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-1D0",
    new Decimal("0.00001157407407407407407407407407407407"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(d·K)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram per Day Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-DAY-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-DeciM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/dm³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram per Cubic Decimetre", "en"));
  unit.addLabel(new LangString("Kilogram per Cubic Decimeter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-DeciM3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-DeciM3-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T2D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(dm³·bar)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram per Cubic Decimeter Bar", "en-US"));
  unit.addLabel(new LangString("Kilogram per Cubic Decimetre Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerEnergy");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-DeciM3-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-DeciM3-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H-1T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(dm³·K)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram per Cubic Decimeter Kelvin", "en-US"));
  unit.addLabel(new LangString("Kilogram per Cubic Decimetre Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-DeciM3-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-FT2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    new Decimal("10.7639104167097223083335055559"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/ft²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram per Square Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerArea");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-FT2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-GigaJ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T2D0",
    new Decimal("1E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/GJ",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram per Gigajoule", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerEnergy");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-GigaJ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-HA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    new Decimal("0.0001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/ha",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram per Hectare", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerArea");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-HA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-HA-YR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-1D0",
    new Decimal("3.168808781402895023702689684893655E-12"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(ha·a)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram per Hectare Year", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerAreaTime");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-HA-YR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("0.0002777777777777777777777777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-HR-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T1D0",
    new Decimal("2.777777777777777777777777777777778E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(h·bar)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram per Hour Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-HR-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-HR-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-1D0",
    new Decimal("0.0002777777777777777777777777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(h·K)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram per Hour Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-HR-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-J",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/J",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram per Joule", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerEnergy");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-J", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/K",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram per Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/kg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram per Kilogram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassRatio");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-KiloM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/km",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram per Kilometer", "en-US"));
  unit.addLabel(new LangString("Kilogram per Kilometre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearMass");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-KiloM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-KiloM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/km²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram per Square Kilometer", "en-US"));
  unit.addLabel(new LangString("Kilogram per Square Kilometre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SurfaceDensity");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-KiloM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-KiloMOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A-1E0L0I0M1H0T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/kmol",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram per Kilomole", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MolarMass");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-KiloMOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/L",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram per Liter", "en-US"));
  unit.addLabel(new LangString("Kilogram per Litre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-L-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T2D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(L·bar)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram per Liter Bar", "en-US"));
  unit.addLabel(new LangString("Kilogram per Litre Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerEnergy");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-L-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-L-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H-1T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(L·K)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram per Liter Kelvin", "en-US"));
  unit.addLabel(new LangString("Kilogram per Litre Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-L-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram per Meter", "en-US"));
  unit.addLabel(new LangString("Kilogram per Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerLength");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearDensity");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-1D0",
    new Decimal("0.00001157407407407407407407407407407407"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(m·d)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram per Meter Day", "en-US"));
  unit.addLabel(new LangString("Kilogram per Metre Day", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DynamicViscosity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Viscosity");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-M-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-1D0",
    new Decimal("0.0002777777777777777777777777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(m·h)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram per Metre Hour", "en"));
  unit.addLabel(new LangString("Kilogram per Meter Hour", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DynamicViscosity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Viscosity");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-M-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-1D0",
    new Decimal("0.01666666666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(m·min)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram per Metre Minute", "en"));
  unit.addLabel(new LangString("Kilogram per Meter Minute", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DynamicViscosity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Viscosity");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-M-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(m·s)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram per Meter Second", "en-US"));
  unit.addLabel(new LangString("Kilogram per Metre Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DynamicViscosity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Viscosity");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-M-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(m·s²)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram per Meter Square Second", "en-US"));
  unit.addLabel(new LangString("Kilogram per Metre Square Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/PA");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/N-PER-M2");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram per Square Metre", "en"));
  unit.addLabel(new LangString("Kilogram per Square Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MeanMassRange");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/BodyMassIndex");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SurfaceDensity");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-M2-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-1D0",
    new Decimal("0.00001157407407407407407407407407407407"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(m²·d)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram per Square Metre Day", "en"));
  unit.addLabel(new LangString("Kilogram per Square Meter Day", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerAreaTime");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-M2-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-M2-PA-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(m²·Pa·s)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Kilogram per Square Meter Pascal Second", "en-US")
  );
  unit.addLabel(
    new LangString("Kilogram per Square Metre Pascal Second", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VapourPermeance");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/S-PER-M");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-M2-PA-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-M2-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(m²·s)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram per Square Meter Second", "en-US"));
  unit.addLabel(new LangString("Kilogram per Square Metre Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerAreaTime");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/KiloGM-PER-SEC-M2");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-M2-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-M2-SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(m²·s²)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Kilogram per Square Meter Square Second", "en-US")
  );
  unit.addLabel(
    new LangString("Kilogram per Square Metre Square Second", "en")
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PressureLossPerLength"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-M2-SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram per Cubic Meter", "en-US"));
  unit.addLabel(new LangString("Kilogram per Cubic Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassConcentration"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassConcentrationOfWater"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassConcentrationOfWaterVapour"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-M3-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T2D0",
    new Decimal("0.00001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(m³·bar)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram per Cubic Metre Bar", "en"));
  unit.addLabel(new LangString("Kilogram per Cubic Meter Bar", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerEnergy");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-M3-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-M3-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H-1T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(m³·K)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram per Cubic Metre Kelvin", "en"));
  unit.addLabel(new LangString("Kilogram per Cubic Meter Kelvin", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-M3-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-M3-PA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(m³·Pa)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram per Cubic Meter Pascal", "en-US"));
  unit.addLabel(new LangString("Kilogram per Cubic Metre Pascal", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerEnergy");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-M3-PA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-M3-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(m³·s)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram per Cubic Metre Second", "en"));
  unit.addLabel(new LangString("Kilogram per Cubic Meter Second", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-M3-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("0.01666666666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/min",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-MIN-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T1D0",
    new Decimal("1.666666666666666666666666666666667E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(min·bar)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram per Minute Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-MIN-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-MIN-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-1D0",
    new Decimal("0.01666666666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(min·K)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram per Minute Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-MIN-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-MOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A-1E0L0I0M1H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/mol",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram per Mole", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MolarMass");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-MOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-MegaBTU_IT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T2D0",
    new Decimal("9.478171203133172000127850444756106E-10"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/MBtu{IT}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "Kilogram per Mega British Thermal Unit (international Definition)",
      "en"
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerEnergy");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-MegaBTU_IT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-MilliM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/mm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram per Millimetre", "en"));
  unit.addLabel(new LangString("Kilogram per Millimeter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerLength");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearDensity");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-MilliM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-PA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/Pa",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram per Pascal", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-PA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-PA-SEC-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(Pa·s·m)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram per Pascal Second Meter", "en-US"));
  unit.addLabel(new LangString("Kilogram per Pascal Second Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/WaterVaporDiffusionCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/VapourPermeability"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-PA-SEC-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-SEC-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T1D0",
    new Decimal("0.00001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(s·bar)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram per Second Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-SEC-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-SEC-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(s·K)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram per Second Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-SEC-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-SEC-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(s·m²)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram per Second Square Metre", "en"));
  unit.addLabel(new LangString("Kilogram per Second Square Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerAreaTime");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/KiloGM-PER-M2-SEC");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-SEC-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-SEC-PA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(s·Pa)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram per Second Pascal", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-SEC-PA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/s²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram per Square Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyPerArea");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-SEC3-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(s³·K)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram per Cubic Second Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CoefficientOfHeatTransfer"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-SEC3-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-YR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("3.168808781402895023702689684893655E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/a",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram per Year", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-YR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg·s²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogram Square Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM2-PER-SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M2H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg²/s²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Kilogram per Square Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/KiloGM2-PER-SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("9.80665"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/GM_F",
    undefined,
    "kgf",
    undefined,
    undefined,
    undefined,
    [],
    6,
    false,
    false
  );
  unit.addLabel(new LangString("Kilo Gram Force", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Force");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/KiloPOND");
  config.units.set("http://qudt.org/vocab/unit/KiloGM_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM_F-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("9.80665"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kgf·m",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilo Gram Force Metre", "en"));
  unit.addLabel(new LangString("Kilo Gram Force Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MomentOfForce");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Torque");
  config.units.set("http://qudt.org/vocab/unit/KiloGM_F-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM_F-M-PER-CentiM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("98066.5"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kgf·m/cm²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Kilo Gram Force Meter per Square Centimeter", "en-US")
  );
  unit.addLabel(
    new LangString("Kilo Gram Force Metre per Square Centimetre", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerLength");
  config.units.set("http://qudt.org/vocab/unit/KiloGM_F-M-PER-CentiM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM_F-M-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("9.80665"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kgf·m/s",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilo Gram Force Metre per Second", "en"));
  unit.addLabel(new LangString("Kilo Gram Force Meter per Second", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/KiloGM_F-M-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-CentiM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("98066.5"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kgf/cm²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilo Gram Force per Square Centimetre", "en"));
  unit.addLabel(
    new LangString("Kilo Gram Force per Square Centimeter", "en-US")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/KiloGM_F-PER-CentiM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("9.80665"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kgf/m²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilo Gram Force per Square Metre", "en"));
  unit.addLabel(new LangString("Kilo Gram Force per Square Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/KiloGM_F-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-MilliM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("9806650.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kgf/mm²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Kilo Gram Force per Square Millimeter", "en-US")
  );
  unit.addLabel(new LangString("Kilo Gram Force per Square Millimetre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/KiloGM_F-PER-MilliM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGRAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("1000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/GRAY",
    undefined,
    "kGy",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilogray", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AbsorbedDose");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Kerma");
  config.units.set("http://qudt.org/vocab/unit/KiloGRAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloH",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H0T-2D0",
    new Decimal("1000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/H",
    undefined,
    "kH",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilohenry", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Inductance");
  config.units.set("http://qudt.org/vocab/unit/KiloH", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloHZ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("1000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/HZ",
    undefined,
    "kHz",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Kilohertz", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Frequency");
  config.units.set("http://qudt.org/vocab/unit/KiloHZ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloHZ-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kHz·m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilohertz Metre", "en"));
  unit.addLabel(new LangString("Kilohertz Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoundParticleVelocity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/GroupSpeedOfSound"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ConductionSpeed");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PhaseSpeedOfSound"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloHZ-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloINDIV",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    [],
    2,
    false,
    true
  );
  unit.addLabel(new LangString("KiloINDIV", undefined));
  config.units.set("http://qudt.org/vocab/unit/KiloINDIV", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloJ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/J",
    undefined,
    "kJ",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    9,
    false,
    false
  );
  unit.addLabel(new LangString("Kilojoule", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ThermalEnergy");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/KiloJ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloJ-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("0.01157407407407407407407407407407407"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kJ/d",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilojoule per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/KiloJ-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloJ-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("0.2777777777777777777777777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kJ/h",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilojoule per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/KiloJ-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloJ-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H-1T-2D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kJ/K",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilojoule per Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EnergyPerTemperature"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloJ-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloJ-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kJ/kg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilojoule per Kilogram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificEnergy");
  config.units.set("http://qudt.org/vocab/unit/KiloJ-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloJ-PER-KiloGM-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H-1T-2D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kJ/(kg·K)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilojoule per Kilogram Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtConstantVolume"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtConstantPressure"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtSaturation"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificEntropy");
  config.units.set("http://qudt.org/vocab/unit/KiloJ-PER-KiloGM-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloJ-PER-KiloV",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kJ/kV",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilojoule per Kilovolt", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  config.units.set("http://qudt.org/vocab/unit/KiloJ-PER-KiloV", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloJ-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("16.66666666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kJ/min",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilojoule per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/KiloJ-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloJ-PER-MOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A-1E0L2I0M1H0T-2D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kJ/mol",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilojoule per Mole", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MolarEnergy");
  config.units.set("http://qudt.org/vocab/unit/KiloJ-PER-MOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloJ-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kJ/s",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilojoule per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/KiloJ-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/L",
    undefined,
    "kL",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Kilolitre", "en"));
  unit.addLabel(new LangString("Kiloliter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/KiloL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloL-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.0002777777777777777777777777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kL/h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilolitre per Hour", "en"));
  unit.addLabel(new LangString("Kiloliter per Hour", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/KiloL-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloLB",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("453.59237"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/LB",
    undefined,
    "klbm",
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Kilo Pound Mass", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  config.units.set("http://qudt.org/vocab/unit/KiloLB", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloLB-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("0.1259978805555555555555555555555556"),
    undefined,
    undefined,
    undefined,
    undefined,
    "klbm/h",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilo Pound Mass per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/KiloLB-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloLB_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("4448.2218148411428"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/LB_F",
    undefined,
    "klbf",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    4,
    false,
    false
  );
  unit.addLabel(new LangString("Kilo Pound Force", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Force");
  config.units.set("http://qudt.org/vocab/unit/KiloLB_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloLB_F-FT-PER-A",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-2D0",
    new Decimal("1355.81800916358032544"),
    undefined,
    undefined,
    undefined,
    undefined,
    "klbf·ft/A",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilo Pound Force Foot per Ampere", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MagneticFlux");
  config.units.set("http://qudt.org/vocab/unit/KiloLB_F-FT-PER-A", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloLB_F-FT-PER-LB",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("2989.067054112"),
    undefined,
    undefined,
    undefined,
    undefined,
    "klbf·ft/lbm",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilo Pound Force Foot per Pound Mass", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificEnergy");
  config.units.set("http://qudt.org/vocab/unit/KiloLB_F-FT-PER-LB", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-FT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("14593.9035919985"),
    undefined,
    undefined,
    undefined,
    undefined,
    "klbf/ft",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilo Pound Force per Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerLength");
  config.units.set("http://qudt.org/vocab/unit/KiloLB_F-PER-FT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-IN2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("6894757.602518976377952755905511811"),
    undefined,
    undefined,
    undefined,
    undefined,
    "klbf/in²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilo Pound Force per Square Inch", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ModulusOfElasticity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ShearModulus");
  config.units.set("http://qudt.org/vocab/unit/KiloLB_F-PER-IN2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloLM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I1M0H0T0D0",
    new Decimal("1000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/LM",
    undefined,
    "klm",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Kilolumen", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LuminousFlux");
  config.units.set("http://qudt.org/vocab/unit/KiloLM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("1000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/M",
    undefined,
    "km",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    23,
    false,
    false
  );
  unit.addLabel(new LangString("Kilometre", "en"));
  unit.addLabel(new LangString("Kilometer", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/KiloM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloM-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("0.01157407407407407407407407407407407"),
    undefined,
    undefined,
    undefined,
    undefined,
    "km/d",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilometer per Day", "en-US"));
  unit.addLabel(new LangString("Kilometre per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/KiloM-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloM-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("0.2777777777777777777777777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "km/h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilometer per Hour", "en-US"));
  unit.addLabel(new LangString("Kilometre per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/KiloM-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloM-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "km/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilometre per Second", "en"));
  unit.addLabel(new LangString("Kilometer per Second", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/KiloM-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloM-PER-SEC-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M-1H0T1D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "km/(s·bar)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilometer per Second Bar", "en-US"));
  unit.addLabel(new LangString("Kilometre per Second Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/KiloM-PER-SEC-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloM-PER-SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-2D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "km/s²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilometre per Square Second", "en"));
  unit.addLabel(new LangString("Kilometer per Square Second", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Acceleration");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearAcceleration"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloM-PER-SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "km²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Kilometer", "en-US"));
  unit.addLabel(new LangString("Square Kilometre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/HydraulicPermeability"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/NuclearQuadrupoleMoment"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Area");
  config.units.set("http://qudt.org/vocab/unit/KiloM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloM2-PER-SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "km²/s²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Kilometer per Square Second", "en-US"));
  unit.addLabel(new LangString("Square Kilometre per Square Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificModulus");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/GigaPA-CentiM3-PER-GM");
  config.units.set("http://qudt.org/vocab/unit/KiloM2-PER-SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloM3-PER-SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-2D0",
    new Decimal("1000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "km³/s²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Kilometer per Square Second", "en-US"));
  unit.addLabel(new LangString("Cubic Kilometre per Square Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/StandardGravitationalParameter"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloM3-PER-SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloMIL_Circ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    new Decimal("5.067075E-7"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/MIL_Circ",
    undefined,
    "kcmil",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilo Circular Mil", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Area");
  config.units.set("http://qudt.org/vocab/unit/KiloMIL_Circ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloMOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T0D0",
    new Decimal("1000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/MOL",
    undefined,
    "kmol",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    8,
    false,
    false
  );
  unit.addLabel(new LangString("Kilomole", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstance"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloMOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloMOL-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T-1D0",
    new Decimal("0.2777777777777777777777777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kmol/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilomole per Hour", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CatalyticActivity"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloMOL-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloMOL-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M-1H0T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kmol/kg",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilomole per Kilogram", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstancePerMass"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/IonicStrength");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MolalityOfSolute"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloMOL-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloMOL-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kmol/m³",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilomole per Cubic Metre", "en"));
  unit.addLabel(new LangString("Kilomole per Cubic Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Concentration");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/WaterSolubility");
  config.units.set("http://qudt.org/vocab/unit/KiloMOL-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloMOL-PER-M3-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-2I0M-1H0T2D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kmol/(m³·bar)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilomole per Cubic Meter Bar", "en-US"));
  unit.addLabel(new LangString("Kilomole per Cubic Metre Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/KiloMOL-PER-M3-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloMOL-PER-M3-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H-1T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kmol/(m³·K)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilomole per Cubic Meter Kelvin", "en-US"));
  unit.addLabel(new LangString("Kilomole per Cubic Metre Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/KiloMOL-PER-M3-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloMOL-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T-1D0",
    new Decimal("16.66666666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kmol/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilomole per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MolarFlowRate");
  config.units.set("http://qudt.org/vocab/unit/KiloMOL-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloMOL-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T-1D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kmol/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilomole per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MolarFlowRate");
  config.units.set("http://qudt.org/vocab/unit/KiloMOL-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("1000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/N",
    undefined,
    "kN",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    11,
    false,
    false
  );
  unit.addLabel(new LangString("Kilonewton", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Force");
  config.units.set("http://qudt.org/vocab/unit/KiloN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloN-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kN·m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilonewton Meter", "en-US"));
  unit.addLabel(new LangString("Kilonewton Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MomentOfForce");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Torque");
  config.units.set("http://qudt.org/vocab/unit/KiloN-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloN-M-PER-DEG",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("57295.77957855229894302178227976183"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kN·m/°",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilonewton Metre per Degree", "en"));
  unit.addLabel(new LangString("Kilonewton Meter per Degree", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TorsionalSpringConstant"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloN-M-PER-DEG", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloN-M-PER-DEG-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("57295.77957855229894302178227976183"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kN·m/(°·m)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilonewton Meter per Degree Meter", "en-US"));
  unit.addLabel(new LangString("Kilonewton Metre per Degree Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ModulusOfRotationalSubgradeReaction"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloN-M-PER-DEG-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloN-M-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("1000.0"),
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    "kN·m/m",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilonewton Metre per Metre", "en"));
  unit.addLabel(new LangString("Kilonewton Meter per Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/TorquePerLength");
  config.units.set("http://qudt.org/vocab/unit/KiloN-M-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloN-M-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kN·m/m²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilonewton Metre per Square Metre", "en"));
  unit.addLabel(new LangString("Kilonewton Meter per Square Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerLength");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyPerArea");
  config.units.set("http://qudt.org/vocab/unit/KiloN-M-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloN-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M1H0T-2D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kN·m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilonewton Square Metre", "en"));
  unit.addLabel(new LangString("Kilonewton Square Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/WarpingMoment");
  config.units.set("http://qudt.org/vocab/unit/KiloN-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloN-PER-CentiM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("10000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kN/cm²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilonewton per Square Centimeter", "en-US"));
  unit.addLabel(new LangString("Kilonewton per Square Centimetre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ModulusOfElasticity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  config.units.set("http://qudt.org/vocab/unit/KiloN-PER-CentiM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloN-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kN/m",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilonewton per Metre", "en"));
  unit.addLabel(new LangString("Kilonewton per Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerLength");
  config.units.set("http://qudt.org/vocab/unit/KiloN-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloN-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kN/m²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilonewton per Square Metre", "en"));
  unit.addLabel(new LangString("Kilonewton per Square Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ModulusOfElasticity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  config.units.set("http://qudt.org/vocab/unit/KiloN-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloN-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-2D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kN/m³",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilonewton per Cubic Meter", "en-US"));
  unit.addLabel(new LangString("Kilonewton per Cubic Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ModulusOfSubgradeReaction"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificWeight");
  config.units.set("http://qudt.org/vocab/unit/KiloN-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloN-PER-MilliM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("1000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kN/mm²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilonewton per Square Millimeter", "en-US"));
  unit.addLabel(new LangString("Kilonewton per Square Millimetre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ModulusOfElasticity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  config.units.set("http://qudt.org/vocab/unit/KiloN-PER-MilliM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloOHM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H0T-3D0",
    new Decimal("1000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/OHM",
    undefined,
    "kΩ",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    7,
    false,
    false
  );
  unit.addLabel(new LangString("Kiloohm", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Resistance");
  config.units.set("http://qudt.org/vocab/unit/KiloOHM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloOHM-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L3I0M1H0T-3D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kΩ·m",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kiloohm Metre", "en"));
  unit.addLabel(new LangString("Kiloohm Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Resistivity");
  config.units.set("http://qudt.org/vocab/unit/KiloOHM-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloOHM-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L3I0M0H0T-1D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kΩ/bar",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kiloohm per Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/KiloOHM-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloOHM-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H-1T-3D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kΩ/K",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kiloohm per Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/KiloOHM-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloOHM-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L1I0M1H0T-3D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kΩ/m",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kiloohm per Metre", "en"));
  unit.addLabel(new LangString("Kiloohm per Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearResistance"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloOHM-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloPA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("1000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/PA",
    undefined,
    "kPa",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    5,
    false,
    false
  );
  unit.addLabel(new LangString("Kilopascal", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ModulusOfElasticity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ShearModulus");
  config.units.set("http://qudt.org/vocab/unit/KiloPA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloPA-M2-PER-GM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-2D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kPa·m²/g",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilopascal Square Metre per Gram", "en"));
  unit.addLabel(new LangString("Kilopascal Square Meter per Gram", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Acceleration");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearAcceleration"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloPA-M2-PER-GM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloPA-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kPa/bar",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilopascal per Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PressureRatio");
  config.units.set("http://qudt.org/vocab/unit/KiloPA-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloPA-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H-1T-2D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kPa/K",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilopascal per Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PressureCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloPA-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloPA-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-2D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kPa/m",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilopascal per Meter", "en-US"));
  unit.addLabel(new LangString("Kilopascal per Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PressureGradient"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloPA-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloPA-PER-MilliM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-2D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kPa/mm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilopascal per Millimetre", "en"));
  unit.addLabel(new LangString("Kilopascal per Millimeter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpectralRadiantEnergyDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloPA-PER-MilliM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloPA_A",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/PA",
    undefined,
    "KPaA",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilopascal Absolute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/KiloPA_A", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloPOISE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-1D0",
    new Decimal("100.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/POISE",
    undefined,
    "kP",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-GAUSS", "http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilopoise", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DynamicViscosity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Viscosity");
  config.units.set("http://qudt.org/vocab/unit/KiloPOISE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloPOND",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("9.80665"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/POND",
    undefined,
    "kp",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilopond", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Force");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/KiloGM_F");
  config.units.set("http://qudt.org/vocab/unit/KiloPOND", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M-1H0T1D0",
    new Decimal("0.258"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/R",
    undefined,
    "kR",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kiloroentgen", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerMass"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloS",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-2I0M-1H0T3D0",
    new Decimal("1000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/S",
    undefined,
    "kS",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Kilosiemens", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Conductance");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Admittance");
  config.units.set("http://qudt.org/vocab/unit/KiloS", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloS-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-3I0M-1H0T3D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kS/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilosiemens per Meter", "en-US"));
  unit.addLabel(new LangString("Kilosiemens per Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Conductivity");
  config.units.set("http://qudt.org/vocab/unit/KiloS-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloSEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("1000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/SEC",
    undefined,
    "ks",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilosecond", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/KiloSEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L0I0M1H0T-2D0",
    new Decimal("1000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/T",
    undefined,
    "kT",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilotesla", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticFluxDensity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MagneticField");
  config.units.set("http://qudt.org/vocab/unit/KiloT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloTONNE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("1000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/TONNE",
    undefined,
    "kt",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Kilotonne", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/KiloTON_Metric");
  config.units.set("http://qudt.org/vocab/unit/KiloTONNE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloTONNE-PER-YR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("0.03168808781402895023702689684893655"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kt/a",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilotonne per Year", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/KiloTONNE-PER-YR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloTON_Metric",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("1000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/TON_Metric",
    undefined,
    "kt",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilo Metric Ton", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/KiloTONNE");
  config.units.set("http://qudt.org/vocab/unit/KiloTON_Metric", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloV",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-3D0",
    new Decimal("1000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/V",
    undefined,
    "kV",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    9,
    false,
    false
  );
  unit.addLabel(new LangString("Kilovolt", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotential"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Voltage");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EnergyPerElectricCharge"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotentialDifference"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloV", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloV-A",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kV·A",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("Kilovolt Ampere", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ApparentPower");
  config.units.set("http://qudt.org/vocab/unit/KiloV-A", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloV-A-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("3600000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kV·A·h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("Kilovolt Ampere Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/KiloV-A-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloV-A-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H-1T-3D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kV·A/K",
    undefined,
    undefined,
    undefined,
    [],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("Kilovolt Ampere per Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalConductance"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloV-A-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloV-A_Reactive",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kV·A{Reactive}",
    undefined,
    undefined,
    undefined,
    [],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("KiloVolt Ampere Reactive", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ReactivePower");
  config.units.set("http://qudt.org/vocab/unit/KiloV-A_Reactive", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloV-A_Reactive-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("3600000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kV·A{Reactive}·h",
    undefined,
    undefined,
    undefined,
    [],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("KiloVolt Ampere Reactive Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/KiloV-A_Reactive-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloV-A_Reactive-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L-2I0M1H-1T-3D0",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kvar/K",
    undefined,
    undefined,
    undefined,
    [],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("KiloVolt Ampere Reactive per Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/KiloV-A_Reactive-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloV-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L1I0M1H0T-3D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kV/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilovolt per Metre", "en"));
  unit.addLabel(new LangString("Kilovolt per Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricFieldStrength"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloV-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloVA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/VA",
    undefined,
    "kVA",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    3,
    false,
    false
  );
  unit.addLabel(new LangString("Kilo Volt Ampere", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ApparentPower");
  config.units.set("http://qudt.org/vocab/unit/KiloVA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloVA-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("3600000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kVA·h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilo Volt Ampere Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/KiloVA-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloVA-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H-1T-3D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kVA/K",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilo Volt Ampere per Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalConductance"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloVA-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloVAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/VAR",
    undefined,
    "kVA{Reactive}",
    undefined,
    undefined,
    undefined,
    [],
    2,
    false,
    false
  );
  unit.addLabel(new LangString("Kilo Volt Ampere Reactive", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ReactivePower");
  config.units.set("http://qudt.org/vocab/unit/KiloVAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloVAR-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("3600000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kVA{Reactive}·h",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilo Volt Ampere Reactive Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/KiloVAR-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloVAR-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H-1T-3D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kVA{Reactive}/K",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilo Volt Ampere Reactive per Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/KiloVAR-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloW",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/W",
    undefined,
    "kW",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    19,
    false,
    false
  );
  unit.addLabel(new LangString("Kilowatt", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/KiloW", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloW-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("3600000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kW·h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilowatt Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/KiloW-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloW-HR-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("3600000.0"),
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    "kW·h/m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilowatt Hour per Square Metre", "en"));
  unit.addLabel(new LangString("Kilowatt Hour per Square Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyPerArea");
  config.units.set("http://qudt.org/vocab/unit/KiloW-HR-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloW-PER-M-DEG_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H-1T-3D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kW/(m·°C)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilowatt per Meter Degree Celsius", "en-US"));
  unit.addLabel(new LangString("Kilowatt per Metre Degree Celsius", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalConductivity"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloW-PER-M-DEG_C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloW-PER-M-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H-1T-3D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kW/(m·K)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilowatt per Meter Kelvin", "en-US"));
  unit.addLabel(new LangString("Kilowatt per Metre Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalConductivity"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloW-PER-M-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloW-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kW/m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilowatt per Square Metre", "en"));
  unit.addLabel(new LangString("Kilowatt per Square Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PowerPerArea");
  config.units.set("http://qudt.org/vocab/unit/KiloW-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloW-PER-M2-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-3D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kW/(m²·K)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kilowatt per Square Meter Kelvin", "en-US"));
  unit.addLabel(new LangString("Kilowatt per Square Metre Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SurfaceCoefficientOfHeatTransfer"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CombinedNonEvaporativeHeatTransferCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CoefficientOfHeatTransfer"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloW-PER-M2-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloWB",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-2D0",
    new Decimal("1000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/WB",
    undefined,
    "kWb",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Kiloweber", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MagneticFlux");
  config.units.set("http://qudt.org/vocab/unit/KiloWB", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloWB-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L1I0M1H0T-2D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kWb/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Kiloweber per Meter", "en-US"));
  unit.addLabel(new LangString("Kiloweber per Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticVectorPotential"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloWB-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloYR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("31557600000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/YR",
    undefined,
    "ka",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    2,
    false,
    false
  );
  unit.addLabel(new LangString("Kiloyear", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/KiloYR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "L",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    167,
    false,
    false
  );
  unit.addLabel(new LangString("Litre", "en"));
  unit.addLabel(new LangString("Liter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LiquidVolume");
  config.units.set("http://qudt.org/vocab/unit/L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/L-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M-1H0T2D0",
    new Decimal("1E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "L/bar",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Litre per Bar", "en"));
  unit.addLabel(new LangString("Liter per Bar", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/L-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/L-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("1.157407407407407407407407407407407E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "L/d",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Liter per Day", "en-US"));
  unit.addLabel(new LangString("Litre per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/L-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/L-PER-DAY-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M-1H0T1D0",
    new Decimal("1.157407407407407407407407407407407E-13"),
    undefined,
    undefined,
    undefined,
    undefined,
    "L/(d·bar)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Liter per Day Bar", "en-US"));
  unit.addLabel(new LangString("Litre per Day Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/L-PER-DAY-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/L-PER-DAY-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H-1T-1D0",
    new Decimal("1.157407407407407407407407407407407E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "L/(d·K)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Liter per Day Kelvin", "en-US"));
  unit.addLabel(new LangString("Litre per Day Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/L-PER-DAY-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/L-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("2.777777777777777777777777777777778E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "L/h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Liter per Hour", "en-US"));
  unit.addLabel(new LangString("Litre per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/L-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/L-PER-HR-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M-1H0T1D0",
    new Decimal("2.777777777777777777777777777777778E-12"),
    undefined,
    undefined,
    undefined,
    undefined,
    "L/(h·bar)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Liter per Hour Bar", "en-US"));
  unit.addLabel(new LangString("Litre per Hour Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/L-PER-HR-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/L-PER-HR-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H-1T-1D0",
    new Decimal("2.777777777777777777777777777777778E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "L/(h·K)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Liter per Hour Kelvin", "en-US"));
  unit.addLabel(new LangString("Litre per Hour Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/L-PER-HR-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/L-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H-1T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "L/K",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Liter per Kelvin", "en-US"));
  unit.addLabel(new LangString("Litre per Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/VolumeThermalExpansion"
  );
  config.units.set("http://qudt.org/vocab/unit/L-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/L-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M-1H0T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "L/kg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Litre per Kilogram", "en"));
  unit.addLabel(new LangString("Liter per Kilogram", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoilAdsorptionCoefficient"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificVolume");
  config.units.set("http://qudt.org/vocab/unit/L-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/L-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "L/L",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Liter per Liter", "en-US"));
  unit.addLabel(new LangString("Litre per Litre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFraction");
  config.units.set("http://qudt.org/vocab/unit/L-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/L-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.00001666666666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "L/min",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Liter per Minute", "en-US"));
  unit.addLabel(new LangString("Litre per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/L-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/L-PER-MIN-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M-1H0T1D0",
    new Decimal("1.666666666666666666666666666666667E-10"),
    undefined,
    undefined,
    undefined,
    undefined,
    "L/(min·bar)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Litre per Minute Bar", "en"));
  unit.addLabel(new LangString("Liter per Minute Bar", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/L-PER-MIN-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/L-PER-MIN-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H-1T-1D0",
    new Decimal("0.00001666666666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "L/(min·K)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Liter per Minute Kelvin", "en-US"));
  unit.addLabel(new LangString("Litre per Minute Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/L-PER-MIN-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/L-PER-MOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A-1E0L3I0M0H0T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "L/mol",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Liter per Mole", "en-US"));
  unit.addLabel(new LangString("Litre per Mole", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MolarVolume");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MolarRefractivity"
  );
  config.units.set("http://qudt.org/vocab/unit/L-PER-MOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/L-PER-MOL-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A-1E0L3I0M0H0T-1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "L/(mol·s)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Liter per Mole Second", "en-US"));
  unit.addLabel(new LangString("Litre per Mole Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SecondOrderReactionRateConstant"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AtmosphericHydroxylationRate"
  );
  config.units.set("http://qudt.org/vocab/unit/L-PER-MOL-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/L-PER-MicroMOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A-1E0L3I0M0H0T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "L/μmol",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Litre per Micromole", "en"));
  unit.addLabel(new LangString("Liter per Micromole", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MolarVolume");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MolarRefractivity"
  );
  config.units.set("http://qudt.org/vocab/unit/L-PER-MicroMOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/L-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "L/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Litre per Second", "en"));
  unit.addLabel(new LangString("Liter per Second", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/L-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/L-PER-SEC-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M-1H0T1D0",
    new Decimal("1E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "L/(s·bar)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Liter per Second Bar", "en-US"));
  unit.addLabel(new LangString("Litre per Second Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/L-PER-SEC-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/L-PER-SEC-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H-1T-1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "L/(s·K)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Litre per Second Kelvin", "en"));
  unit.addLabel(new LangString("Liter per Second Kelvin", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/L-PER-SEC-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/L-PER-SEC-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "L/(s·m²)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Litre per Second Square Metre", "en"));
  unit.addLabel(new LangString("Liter per Second Square Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/VentilationRatePerFloorArea"
  );
  config.units.set("http://qudt.org/vocab/unit/L-PER-SEC-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I1M0H0T0D0",
    new Decimal("0.31830988618"),
    undefined,
    undefined,
    undefined,
    undefined,
    "L",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Lambert", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Luminance");
  config.units.set("http://qudt.org/vocab/unit/LA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LANGLEY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("41840.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/J-PER-M2",
    undefined,
    "Ly",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Langley", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyPerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/RadiantFluence");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyFluence");
  config.units.set("http://qudt.org/vocab/unit/LANGLEY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LA_FT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I1M0H0T0D0",
    new Decimal("3.426259099594588078065045018978927"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft-L",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Foot Lambert", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Luminance");
  config.units.set("http://qudt.org/vocab/unit/LA_FT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("0.45359237"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "lbm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    215,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Mass", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/LB_M");
  config.units.set("http://qudt.org/vocab/unit/LB", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H1T0D0",
    new Decimal("0.2519957611111111111111111111111111"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·°F",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Mass Degree Fahrenheit", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassTemperature");
  config.units.set("http://qudt.org/vocab/unit/LB-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-DEG_R",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H1T0D0",
    new Decimal("0.251995761111111131270772"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·°R",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Mass Degree Rankine", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassTemperature");
  config.units.set("http://qudt.org/vocab/unit/LB-DEG_R", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-FT-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-1D0",
    new Decimal("0.138254954376"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·ft/s",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Mass Foot per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Impulse");
  config.units.set("http://qudt.org/vocab/unit/LB-FT-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-FT2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T0D0",
    new Decimal("0.0421401100938048"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·ft²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Mass Square Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/RotationalMass");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MomentOfInertia");
  config.units.set("http://qudt.org/vocab/unit/LB-FT2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-FT2-PER-GAL_UK-LB_F-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal("2.083872775779299082282838578347267"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·ft²/(gal{UK}·lbf·s)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "Pound Mass Square Foot per Gallon (UK) Pound Force Second",
      "en"
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set(
    "http://qudt.org/vocab/unit/LB-FT2-PER-GAL_UK-LB_F-SEC",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-FT2-PER-GAL_US-LB_F-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal("2.502626854833744493086617821084779"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·ft²/(gal{US}·lbf·s)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "Pound Mass Square Foot per Us Gallon Pound Force Second",
      "en"
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set(
    "http://qudt.org/vocab/unit/LB-FT2-PER-GAL_US-LB_F-SEC",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-FT2-PER-IN3-LB_F-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal("578.106803466594977903008716670584"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·ft²/(in³·lbf·s)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "Pound Mass Square Foot per Cubic Inch Pound Force Second",
      "en"
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-FT2-PER-IN3-LB_F-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-HR-PER-FT3-GAL_UK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("12684849.65019533323949993386765412"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·h/(ft³·gal{UK})",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Pound Mass Hour per Cubic Foot Gallon (UK)", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-HR-PER-FT3-GAL_UK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-HR-PER-FT3-GAL_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("15233869.24244237056740727215858525"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·h/(ft³·gal{US})",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Pound Mass Hour per Cubic Foot Us Gallon", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-HR-PER-FT3-GAL_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-HR-PER-FT3-IN3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("3519023795.004187601071079868633193"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·h/(ft³·in³)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Pound Mass Hour per Cubic Foot Cubic Inch", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-HR-PER-FT3-IN3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-HR-PER-FT3-YD3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("75424.89272556986456342335109381842"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·h/(ft³·yd³)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Pound Mass Hour per Cubic Foot Cubic Yard", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-HR-PER-FT3-YD3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-HR-PER-FT6",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("2036472.103590386343212430479533098"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·h/ft⁶",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Mass Hour per Sextic Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-HR-PER-FT6", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-HR-PER-GAL_UK-FT3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("12684849.65019533323949993386765412"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·h/(gal{UK}·ft³)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Pound Mass Hour per Gallon (UK) Cubic Foot", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-HR-PER-GAL_UK-FT3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-HR-PER-GAL_UK-IN3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("21919420195.53753583785588572330633"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·h/(gal{UK}·in³)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Pound Mass Hour per Gallon (UK) Cubic Inch", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-HR-PER-GAL_UK-IN3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-HR-PER-GAL_UK-YD3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("469809.2463035308607222197728760785"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·h/(gal{UK}·yd³)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Pound Mass Hour per Gallon (UK) Cubic Yard", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-HR-PER-GAL_UK-YD3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-HR-PER-GAL_UK2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("79011841.29376367695695378272856609"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·h/gal{UK}²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Mass Hour per Square Gallon (UK)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-HR-PER-GAL_UK2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-HR-PER-GAL_US-FT3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("15233869.24244237056740727215858525"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·h/(gal{US}·ft³)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Pound Mass Hour per Us Gallon Cubic Foot", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-HR-PER-GAL_US-FT3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-HR-PER-GAL_US-IN3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("26324126050.94041634047976629003531"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·h/(gal{US}·in³)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Pound Mass Hour per Us Gallon Cubic Inch", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-HR-PER-GAL_US-IN3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-HR-PER-GAL_US-YD3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("564217.3793497174284224915614290831"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·h/(gal{US}·yd³)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Pound Mass Hour per Us Gallon Cubic Yard", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-HR-PER-GAL_US-YD3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-HR-PER-GAL_US2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("113957255.6317766941146310229005858"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·h/gal{US}²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Mass Hour per Square Us Gallon", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-HR-PER-GAL_US2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-HR-PER-IN3-FT3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("3519023795.004187601071079868633193"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·h/(in³·ft³)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Pound Mass Hour per Cubic Inch Cubic Foot", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-HR-PER-IN3-FT3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-HR-PER-IN3-GAL_UK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("21919420195.53753583785588572330633"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·h/(in³·gal{UK})",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Pound Mass Hour per Cubic Inch Gallon (UK)", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-HR-PER-IN3-GAL_UK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-HR-PER-IN3-GAL_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("26324126050.94041634047976629003531"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·h/(in³·gal{US})",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Pound Mass Hour per Cubic Inch Us Gallon", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-HR-PER-IN3-GAL_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-HR-PER-IN3-YD3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("130334214.6297847259655955506901182"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·h/(in³·yd³)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Pound Mass Hour per Cubic Inch Cubic Yard", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-HR-PER-IN3-YD3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-HR-PER-IN6",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("6080873117767.236174650826012998158"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·h/in⁶",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Mass Hour per Sextic Inch", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-HR-PER-IN6", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-IN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T0D0",
    new Decimal("0.011521246198"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·in",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Mass Inch", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LengthMass");
  config.units.set("http://qudt.org/vocab/unit/LB-IN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-IN-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-1D0",
    new Decimal("0.011521246198"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·in/s",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Mass Inch per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Impulse");
  config.units.set("http://qudt.org/vocab/unit/LB-IN-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-IN2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T0D0",
    new Decimal("0.0002926396534292"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·in²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Mass Square Inch", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/RotationalMass");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MomentOfInertia");
  config.units.set("http://qudt.org/vocab/unit/LB-IN2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-IN2-PER-FT3-LB_F-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal("0.002323281585433525342009905143512828"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·in²/(ft³·lbf·s)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "Pound Mass Square Inch per Cubic Foot Pound Force Second",
      "en"
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-IN2-PER-FT3-LB_F-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-IN2-PER-GAL_UK-LB_F-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal("0.01447133872068957696029749012741158"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·in²/(gal{UK}·lbf·s)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "Pound Mass Square Inch per Gallon (UK) Pound Force Second",
      "en"
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set(
    "http://qudt.org/vocab/unit/LB-IN2-PER-GAL_UK-LB_F-SEC",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-IN2-PER-GAL_US-LB_F-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal("0.01737935315856767009087929042419986"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·in²/(gal{US}·lbf·s)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "Pound Mass Square Inch per Us Gallon Pound Force Second",
      "en"
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set(
    "http://qudt.org/vocab/unit/LB-IN2-PER-GAL_US-LB_F-SEC",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-IN2-PER-IN3-LB_F-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal("4.014630579629131790993116087990167"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·in²/(in³·lbf·s)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "Pound Mass Square Inch per Cubic Inch Pound Force Second",
      "en"
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-IN2-PER-IN3-LB_F-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-MIN-PER-FT3-GAL_UK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("211414.1608365888873249988977942354"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·min/(ft³·gal{UK})",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Pound Mass Minute per Cubic Foot Gallon (UK)", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-MIN-PER-FT3-GAL_UK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-MIN-PER-FT3-GAL_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("253897.8207073728427901212026430875"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·min/(ft³·gal{US})",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Pound Mass Minute per Cubic Foot Us Gallon", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-MIN-PER-FT3-GAL_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-MIN-PER-FT3-IN3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("58650396.58340312668451799781055322"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·min/(ft³·in³)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Pound Mass Minute per Cubic Foot Cubic Inch", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-MIN-PER-FT3-IN3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-MIN-PER-FT3-YD3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("1257.081545426164409390389184896974"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·min/(ft³·yd³)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Pound Mass Minute per Cubic Foot Cubic Yard", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-MIN-PER-FT3-YD3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-MIN-PER-FT6",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("33941.20172650643905354050799221829"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·min/ft⁶",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Mass Minute per Sextic Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-MIN-PER-FT6", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-MIN-PER-GAL_UK-FT3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("211414.1608365888873249988977942354"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·min/(gal{UK}·ft³)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Pound Mass Minute per Gallon (UK) Cubic Foot", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-MIN-PER-GAL_UK-FT3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-MIN-PER-GAL_UK-IN3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("365323669.9256255972975980953884388"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·min/(gal{UK}·in³)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Pound Mass Minute per Gallon (UK) Cubic Inch", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-MIN-PER-GAL_UK-IN3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-MIN-PER-GAL_UK-YD3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("7830.154105058847678703662881267974"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·min/(gal{UK}·yd³)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Pound Mass Minute per Gallon (UK) Cubic Yard", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-MIN-PER-GAL_UK-YD3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-MIN-PER-GAL_UK2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("1316864.021562727949282563045476102"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·min/gal{UK}²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Pound Mass Minute per Square Gallon (UK)", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-MIN-PER-GAL_UK2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-MIN-PER-GAL_US-FT3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("253897.8207073728427901212026430875"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·min/(gal{US}·ft³)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Pound Mass Minute per Us Gallon Cubic Foot", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-MIN-PER-GAL_US-FT3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-MIN-PER-GAL_US-IN3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("438735434.1823402723413294381672552"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·min/(gal{US}·in³)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Pound Mass Minute per Us Gallon Cubic Inch", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-MIN-PER-GAL_US-IN3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-MIN-PER-GAL_US-YD3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("9403.622989161957140374859357151386"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·min/(gal{US}·yd³)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Pound Mass Minute per Us Gallon Cubic Yard", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-MIN-PER-GAL_US-YD3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-MIN-PER-GAL_US2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("1899287.593862944901910517048343096"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·min/gal{US}²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Mass Minute per Square Us Gallon", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-MIN-PER-GAL_US2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-MIN-PER-IN3-FT3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("58650396.58340312668451799781055322"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·min/(in³·ft³)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Pound Mass Minute per Cubic Inch Cubic Foot", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-MIN-PER-IN3-FT3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-MIN-PER-IN3-GAL_UK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("365323669.9256255972975980953884388"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·min/(in³·gal{UK})",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Pound Mass Minute per Cubic Inch Gallon (UK)", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-MIN-PER-IN3-GAL_UK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-MIN-PER-IN3-GAL_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("438735434.1823402723413294381672552"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·min/(in³·gal{US})",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Pound Mass Minute per Cubic Inch Us Gallon", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-MIN-PER-IN3-GAL_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-MIN-PER-IN3-YD3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("2172236.91049641209942659251150197"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·min/(in³·yd³)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Pound Mass Minute per Cubic Inch Cubic Yard", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-MIN-PER-IN3-YD3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-MIN-PER-IN6",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("101347885296.120602910847100216636"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·min/in⁶",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Mass Minute per Sextic Inch", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-MIN-PER-IN6", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-AC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    new Decimal("0.0001120851156194456047722420921833988"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm/acre",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Mass per Acre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerArea");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-AC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("0.000005249911689814814814814814814814813"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm/d",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Mass per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T0D0",
    new Decimal("0.816466266"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm/°F",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Mass per Degree Fahrenheit", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-FT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T0D0",
    new Decimal("1.488163943569553805774278215223097"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm/ft",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Mass per Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerLength");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-FT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-FT-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-1D0",
    new Decimal("0.00001722411971724020608535044230582288"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm/(ft·d)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Mass per Foot Day", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DynamicViscosity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Viscosity");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-FT-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-FT-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-1D0",
    new Decimal("0.0004133788732137649460484106153397492"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm/(ft·h)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Mass per Foot Hour", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DynamicViscosity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Viscosity");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-FT-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-FT-LB_F-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal("0.3345525483024276492494263406658472"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm/(ft·lbf·s)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Mass per Foot Pound Force Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-FT-LB_F-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-FT-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-1D0",
    new Decimal("0.02480273239282589676290463692038496"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm/(ft·min)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Mass per Foot Minute", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DynamicViscosity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Viscosity");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-FT-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-FT-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-1D0",
    new Decimal("1.488163943569553805774278215223097"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm/(ft·s)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Mass per Foot Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DynamicViscosity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Viscosity");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-FT-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-FT2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    new Decimal("4.882427636383050543878865535508848"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm/ft²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Mass per Square Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerArea");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-FT2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-FT3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("16.01846337396013957965507065455659"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm/ft³",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Mass per Cubic Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-FT3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-FT3-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H-1T0D0",
    new Decimal("28.83323407312825124337912717820187"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm/(ft³·°F)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Pound Mass per Cubic Foot Degree Fahrenheit", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-FT3-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-FT3-PSI",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T2D0",
    new Decimal("0.002323281585433525342009905143512828"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm/(ft³·psi)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Mass per Cubic Foot Psi", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerEnergy");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-FT3-PSI", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-GAL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("99.7763727"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lb/gal",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("Pound per Gallon", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/LB-PER-GAL_IMP");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/LB-PER-GAL_UK");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-GAL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-GAL_IMP",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("99.77637266310169838256611725680751"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm/gal{Imp}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Mass per Imperial Gallon", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/LB-PER-GAL_IMP");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/LB-PER-GAL_UK");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-GAL_IMP", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-GAL_UK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("99.77637266310169838256611725680751"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm/gal{UK}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Mass per Gallon (UK)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/LB-PER-GAL_IMP");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-GAL_UK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-GAL_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("119.8264273168966285439132558055142"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm/gal{US}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Mass per Us Gallon", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-GAL_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("0.0001259978805555555555555555555555556"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm/h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Mass per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-HR-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-1D0",
    new Decimal("0.000226796185"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm/(h·°F)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Mass per Hour Degree Fahrenheit", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-HR-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-HR-PSI",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T1D0",
    new Decimal("1.827444673464991081206633802592347E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm/(h·psi)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Mass per Hour Psi", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThrusterPowerToThrustEfficiency"
  );
  config.units.set("http://qudt.org/vocab/unit/LB-PER-HR-PSI", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-IN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T0D0",
    new Decimal("17.85796732283464566929133858267716"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm/in",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Mass per Inch", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerLength");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-IN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-IN2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    new Decimal("703.0695796391592783185566371132742"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm/in²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Mass per Square Inch", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MeanMassRange");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SurfaceDensity");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-IN2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-IN3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("27679.90471020312119364396209107379"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm/in³",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Mass per Cubic Inch", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-IN3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-IN3-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H-1T0D0",
    new Decimal("49823.82847836561814855913176393282"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm/(in³·°F)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Pound Mass per Cubic Inch Degree Fahrenheit", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-IN3-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-IN3-PSI",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T2D0",
    new Decimal("4.014630579629131790993116087990167"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm/(in³·psi)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Mass per Cubic Inch Psi", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerEnergy");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-IN3-PSI", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-LB",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.9999999999999999999999999999999998"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm/lbm",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Mass per Pound Mass", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassRatio");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-LB", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("0.45359237"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm/m³",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Mass per Cubic Meter", "en-US"));
  unit.addLabel(new LangString("Pound Mass per Cubic Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("0.007559872833333333333333333333333335"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm/min",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Mass per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-MIN-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-1D0",
    new Decimal("0.0136077711"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm/(min·°F)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Pound Mass per Minute Degree Fahrenheit", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-MIN-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-MIN-PSI",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T1D0",
    new Decimal("0.000001096466804078994648723980281555408"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm/(min·psi)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Mass per Minute Psi", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThrusterPowerToThrustEfficiency"
  );
  config.units.set("http://qudt.org/vocab/unit/LB-PER-MIN-PSI", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-PSI",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T2D0",
    new Decimal("0.0000657880082447396789234388168933245"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm/psi",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Mass per Psi", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-PSI", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("0.45359237"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Mass per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-SEC-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-1D0",
    new Decimal("0.816466266"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm/(s·°F)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Pound Mass per Second Degree Fahrenheit", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-SEC-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-SEC-PSI",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T1D0",
    new Decimal("0.0000657880082447396789234388168933245"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm/(s·psi)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Mass per Second Psi", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThrusterPowerToThrustEfficiency"
  );
  config.units.set("http://qudt.org/vocab/unit/LB-PER-SEC-PSI", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-YD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T0D0",
    new Decimal("0.496054647856517935258092738407699"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm/yd",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Mass per Yard", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearMass");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-YD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-YD2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    new Decimal("0.5424919595981167270976517261676497"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm/yd²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Mass per Square Yard", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MeanMassRange");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/BodyMassIndex");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SurfaceDensity");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-YD2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-YD3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("0.5932764212577829473946322464650587"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm/yd³",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Mass per Cubic Yard", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-YD3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-SEC-PER-FT3-GAL_UK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("3523.56934727648145541664829657059"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·s/(ft³·gal{UK})",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Pound Mass Second per Cubic Foot Gallon (UK)", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-SEC-PER-FT3-GAL_UK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-SEC-PER-FT3-GAL_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("4231.630345122880713168686710718126"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·s/(ft³·gal{US})",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Pound Mass Second per Cubic Foot Us Gallon", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-SEC-PER-FT3-GAL_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-SEC-PER-FT3-IN3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("977506.609723385444741966630175887"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·s/(ft³·in³)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Pound Mass Second per Cubic Foot Cubic Inch", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-SEC-PER-FT3-IN3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-SEC-PER-FT3-YD3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("20.95135909043607348983981974828289"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·s/(ft³·yd³)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Pound Mass Second per Cubic Foot Cubic Yard", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-SEC-PER-FT3-YD3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-SEC-PER-FT6",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("565.6866954417739842256751332036382"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·s/ft⁶",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Mass Second per Sextic Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-SEC-PER-FT6", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-SEC-PER-GAL_UK-FT3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("3523.56934727648145541664829657059"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·s/(gal{UK}·ft³)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Pound Mass Second per Gallon (UK) Cubic Foot", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-SEC-PER-GAL_UK-FT3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-SEC-PER-GAL_UK-IN3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("6088727.832093759954959968256473979"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·s/(gal{UK}·in³)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Pound Mass Second per Gallon (UK) Cubic Inch", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-SEC-PER-GAL_UK-IN3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-SEC-PER-GAL_UK-YD3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("130.5025684176474613117277146877996"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·s/(gal{UK}·yd³)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Pound Mass Second per Gallon (UK) Cubic Yard", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-SEC-PER-GAL_UK-YD3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-SEC-PER-GAL_UK2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("21947.73369271213248804271742460169"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·s/gal{UK}²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Pound Mass Second per Square Gallon (UK)", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-SEC-PER-GAL_UK2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-SEC-PER-GAL_US-FT3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("4231.630345122880713168686710718126"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·s/(gal{US}·ft³)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Pound Mass Second per Us Gallon Cubic Foot", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-SEC-PER-GAL_US-FT3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-SEC-PER-GAL_US-IN3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("7312257.23637233787235549063612092"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·s/(gal{US}·in³)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Pound Mass Second per Us Gallon Cubic Inch", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-SEC-PER-GAL_US-IN3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-SEC-PER-GAL_US-YD3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("156.7270498193659523395809892858564"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·s/(gal{US}·yd³)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Pound Mass Second per Us Gallon Cubic Yard", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-SEC-PER-GAL_US-YD3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-SEC-PER-GAL_US2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("31654.79323104908169850861747238494"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·s/gal{US}²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Mass Second per Square Us Gallon", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-SEC-PER-GAL_US2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-SEC-PER-IN3-FT3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("977506.609723385444741966630175887"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·s/(in³·ft³)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Pound Mass Second per Cubic Inch Cubic Foot", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-SEC-PER-IN3-FT3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-SEC-PER-IN3-GAL_UK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("6088727.832093759954959968256473979"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·s/(in³·gal{UK})",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Pound Mass Second per Cubic Inch Gallon (UK)", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-SEC-PER-IN3-GAL_UK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-SEC-PER-IN3-GAL_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("7312257.23637233787235549063612092"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·s/(in³·gal{US})",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Pound Mass Second per Cubic Inch Us Gallon", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-SEC-PER-IN3-GAL_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-SEC-PER-IN3-YD3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("36203.94850827353499044320852503284"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·s/(in³·yd³)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Pound Mass Second per Cubic Inch Cubic Yard", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-SEC-PER-IN3-YD3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-SEC-PER-IN6",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("1689131421.602010048514118336943933"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·s/in⁶",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Mass Second per Sextic Inch", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-SEC-PER-IN6", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("4.4482218148411428"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbf",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    69,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Force", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Force");
  config.units.set("http://qudt.org/vocab/unit/LB_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB_F-FT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1.35581800916358032544"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbf·ft",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Force Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MomentOfForce");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Torque");
  config.units.set("http://qudt.org/vocab/unit/LB_F-FT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB_F-FT-PER-IN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("53.3786617780937136"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbf·ft/in",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Force Foot per Inch", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearTorque");
  config.units.set("http://qudt.org/vocab/unit/LB_F-FT-PER-IN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB_F-IN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("0.11298483409696502712"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbf·in",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Force Inch", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MomentOfForce");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Torque");
  config.units.set("http://qudt.org/vocab/unit/LB_F-IN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB_F-IN-PER-IN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("4.4482218148411428"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbf·in/in",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Force Inch per Inch", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearTorque");
  config.units.set("http://qudt.org/vocab/unit/LB_F-IN-PER-IN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB_F-PER-FT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("14.5939035919985"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbf/ft",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Force per Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerLength");
  config.units.set("http://qudt.org/vocab/unit/LB_F-PER-FT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB_F-PER-FT2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("47.88026112860400262467191601049868"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbf/ft²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Force per Square Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/LB_F-PER-FT2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB_F-PER-IN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("175.126843103982"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbf/in",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Force per Inch", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerLength");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyPerArea");
  config.units.set("http://qudt.org/vocab/unit/LB_F-PER-IN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB_F-PER-IN2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("6894.757602518976377952755905511811"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbf/in²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Force per Square Inch", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ModulusOfElasticity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ShearModulus");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/PSI");
  config.units.set("http://qudt.org/vocab/unit/LB_F-PER-IN2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB_F-PER-IN2-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H-1T-2D0",
    new Decimal("12410.56368453415748031496062992126"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbf/(in²·°F)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Pound Force per Square Inch Degree Fahrenheit", "en")
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/VolumetricHeatCapacity"
  );
  config.units.set("http://qudt.org/vocab/unit/LB_F-PER-IN2-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB_F-PER-IN2-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-3D0",
    new Decimal("6894.757602518976377952755905511811"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbf/(in²·s)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Force per Square Inch Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ForcePerAreaTime"
  );
  config.units.set("http://qudt.org/vocab/unit/LB_F-PER-IN2-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB_F-PER-LB",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-2D0",
    new Decimal("9.806650439999999999999999999999998"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbf/lbm",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Force per Pound Mass", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThrustToMassRatio"
  );
  config.units.set("http://qudt.org/vocab/unit/LB_F-PER-LB", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB_F-PER-YD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("4.864634530666166666666666666666666"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbf/yd",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Force per Yard", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerLength");
  config.units.set("http://qudt.org/vocab/unit/LB_F-PER-YD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB_F-SEC-PER-FT2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-1D0",
    new Decimal("47.88026112860400262467191601049868"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbf·s/ft²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Force Second per Square Foot", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DynamicViscosity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Viscosity");
  config.units.set("http://qudt.org/vocab/unit/LB_F-SEC-PER-FT2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB_F-SEC-PER-IN2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-1D0",
    new Decimal("6894.757602518976377952755905511811"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbf·s/in²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Force Second per Square Inch", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DynamicViscosity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Viscosity");
  config.units.set("http://qudt.org/vocab/unit/LB_F-SEC-PER-IN2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB_M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("0.45359237"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "lbm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Mass", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/LB");
  config.units.set("http://qudt.org/vocab/unit/LB_M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB_T",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("0.3732417216"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "lbt",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Troy", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  config.units.set("http://qudt.org/vocab/unit/LB_T", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I1M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lm",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    10,
    false,
    false
  );
  unit.addLabel(new LangString("Lumen", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LuminousFlux");
  config.units.set("http://qudt.org/vocab/unit/LM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LM-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I1M0H0T1D0",
    new Decimal("3600.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lm·h",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Lumen Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LuminousEnergy");
  config.units.set("http://qudt.org/vocab/unit/LM-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LM-PER-FT2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I1M0H0T0D0",
    new Decimal("10.7639104167097223083335055559"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lm/ft²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Lumen per Square Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Luminance");
  config.units.set("http://qudt.org/vocab/unit/LM-PER-FT2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LM-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I1M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lm/m²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Lumen per Square Meter", "en-US"));
  unit.addLabel(new LangString("Lumen per Square Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Luminance");
  config.units.set("http://qudt.org/vocab/unit/LM-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LM-PER-W",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I1M-1H0T3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lm/W",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Lumen per Watt", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LuminousEfficacy"
  );
  config.units.set("http://qudt.org/vocab/unit/LM-PER-W", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LM-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I1M0H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lm·s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Lumen Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LuminousEnergy");
  config.units.set("http://qudt.org/vocab/unit/LM-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LUX",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I1M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lx",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    2,
    false,
    false
  );
  unit.addLabel(new LangString("Lux", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LuminousFluxPerArea"
  );
  config.units.set("http://qudt.org/vocab/unit/LUX", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LUX-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I1M0H0T1D0",
    new Decimal("3600.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lx·h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Lux Hour", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LuminousExposure"
  );
  config.units.set("http://qudt.org/vocab/unit/LUX-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LUX-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I1M0H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lx·s",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Lux Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LuminousExposure"
  );
  config.units.set("http://qudt.org/vocab/unit/LUX-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("9460730472580800.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M",
    undefined,
    "ly",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Light Year", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/LY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LunarMass",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("73460000000000000000000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "M☾",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Lunar Mass", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  config.units.set("http://qudt.org/vocab/unit/LunarMass", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    710,
    false,
    false
  );
  unit.addLabel(new LangString("Metre", "en"));
  unit.addLabel(new LangString("Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElevationRelativeToNAP"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H1T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m·K",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Metre Kelvin", "en"));
  unit.addLabel(new LangString("Meter Kelvin", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LengthTemperature"
  );
  config.units.set("http://qudt.org/vocab/unit/M-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M-K-PER-W",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M-1H1T3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m·K/W",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Meter Kelvin per Watt", "en-US"));
  unit.addLabel(new LangString("Metre Kelvin per Watt", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalResistivity"
  );
  config.units.set("http://qudt.org/vocab/unit/M-K-PER-W", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m·kg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Meter Kilogram", "en-US"));
  unit.addLabel(new LangString("Metre Kilogram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LengthMass");
  config.units.set("http://qudt.org/vocab/unit/M-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M-PA-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m·Pa/s",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Metre Pascal per Second", "en"));
  unit.addLabel(new LangString("Meter Pascal per Second", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PowerPerArea");
  config.units.set("http://qudt.org/vocab/unit/M-PA-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M-1H0T2D0",
    new Decimal("0.00001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m/bar",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Meter per Bar", "en-US"));
  unit.addLabel(new LangString("Metre per Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/M-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("0.00001157407407407407407407407407407407"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m/d",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Meter per Day", "en-US"));
  unit.addLabel(new LangString("Metre per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/M-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M-PER-DEG_C-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H-1T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m/(°C·m)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Metre per Degree Celsius Metre", "en"));
  unit.addLabel(new LangString("Meter per Degree Celsius Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalExpansionCoefficient"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ExpansionRatio");
  config.units.set("http://qudt.org/vocab/unit/M-PER-DEG_C-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M-PER-FARAD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L3I0M1H0T-4D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m/F",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Meter per Farad", "en-US"));
  unit.addLabel(new LangString("Metre per Farad", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InversePermittivity"
  );
  config.units.set("http://qudt.org/vocab/unit/M-PER-FARAD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M-PER-HA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("0.0001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m/ha",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Meter per Hectare", "en-US"));
  unit.addLabel(new LangString("Metre per Hectare", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseLength");
  config.units.set("http://qudt.org/vocab/unit/M-PER-HA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("0.0002777777777777777777777777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m/h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Metre per Hour", "en"));
  unit.addLabel(new LangString("Meter per Hour", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/M-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H-1T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m/K",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Metre per Kelvin", "en"));
  unit.addLabel(new LangString("Meter per Kelvin", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearThermalExpansion"
  );
  config.units.set("http://qudt.org/vocab/unit/M-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m/m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Meter per Square Meter", "en-US"));
  unit.addLabel(new LangString("Metre per Square Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseLength");
  config.units.set("http://qudt.org/vocab/unit/M-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("0.01666666666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m/min",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Metre per Minute", "en"));
  unit.addLabel(new LangString("Meter per Minute", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/M-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M-PER-PA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M-1H0T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m/Pa",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Metre per Pascal", "en"));
  unit.addLabel(new LangString("Meter per Pascal", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/M-PER-PA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M-PER-RAD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m/rad",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Meter per Radian", "en-US"));
  unit.addLabel(new LangString("Metre per Radian", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Rotary-TranslatoryMotionConversion"
  );
  config.units.set("http://qudt.org/vocab/unit/M-PER-RAD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Metre per Second", "en"));
  unit.addLabel(new LangString("Meter per Second", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Speed");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectromagneticWavePhaseSpeed"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/M-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M-PER-SEC-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M-1H0T1D0",
    new Decimal("0.00001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m/(s·bar)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Meter per Second Bar", "en-US"));
  unit.addLabel(new LangString("Metre per Second Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/M-PER-SEC-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M-PER-SEC-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H-1T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m/(s·K)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Metre per Second Kelvin", "en"));
  unit.addLabel(new LangString("Meter per Second Kelvin", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/M-PER-SEC-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M-PER-SEC-PA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M-1H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m/(s·Pa)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Meter per Second Pascal", "en-US"));
  unit.addLabel(new LangString("Metre per Second Pascal", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/M-PER-SEC-PA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M-PER-SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m/s²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Metre per Square Second", "en"));
  unit.addLabel(new LangString("Meter per Square Second", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Acceleration");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearAcceleration"
  );
  config.units.set("http://qudt.org/vocab/unit/M-PER-SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M-PER-V-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-1I0M-1H0T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m/(V·s)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Meter per Volt Second", "en-US"));
  unit.addLabel(new LangString("Metre per Volt Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticReluctivity"
  );
  config.units.set("http://qudt.org/vocab/unit/M-PER-V-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M-PER-YR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("3.168808781402895023702689684893655E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m/a",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Meter per Year", "en-US"));
  unit.addLabel(new LangString("Metre per Year", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/M-PER-YR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m·s",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Meter Second", "en-US"));
  unit.addLabel(new LangString("Metre Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/M-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M-SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m·s²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Metre Square Second", "en"));
  unit.addLabel(new LangString("Meter Square Second", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/M-SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M0dot",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    [],
    2,
    false,
    true
  );
  unit.addLabel(new LangString("M0dot", undefined));
  config.units.set("http://qudt.org/vocab/unit/M0dot", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    7,
    false,
    false
  );
  unit.addLabel(new LangString("Square Meter", "en-US"));
  unit.addLabel(new LangString("Square Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/HydraulicPermeability"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/NuclearQuadrupoleMoment"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Area");
  config.units.set("http://qudt.org/vocab/unit/M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-HR-DEG_C-PER-KiloCAL_IT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H1T3D0",
    new Decimal("0.8598452278589853826311263972484954"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²·h·°C/kcal{IT}",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "Square Metre Hour Degree Celsius per Kilo International Table Calorie",
      "en"
    )
  );
  unit.addLabel(
    new LangString(
      "Square Meter Hour Degree Celsius per Kilo International Table Calorie",
      "en-US"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalInsulance"
  );
  config.units.set(
    "http://qudt.org/vocab/unit/M2-HR-DEG_C-PER-KiloCAL_IT",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-HZ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²·Hz",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Meter Hertz", "en-US"));
  unit.addLabel(new LangString("Square Metre Hertz", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AreaPerTime");
  config.units.set("http://qudt.org/vocab/unit/M2-HZ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-HZ2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²·Hz²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Meter Square Hertz", "en-US"));
  unit.addLabel(new LangString("Square Metre Square Hertz", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/M2-HZ2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-HZ3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²·Hz³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Meter Cubic Hertz", "en-US"));
  unit.addLabel(new LangString("Square Metre Cubic Hertz", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/M2-HZ3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-HZ4",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-4D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²·Hz⁴",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Meter Quartic Hertz", "en-US"));
  unit.addLabel(new LangString("Square Metre Quartic Hertz", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/M2-HZ4", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H1T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²·K",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Meter Kelvin", "en-US"));
  unit.addLabel(new LangString("Square Metre Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AreaTemperature");
  config.units.set("http://qudt.org/vocab/unit/M2-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-K-PER-W",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H1T3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²·K/W",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Square Meter Kelvin per Watt", "en-US"));
  unit.addLabel(new LangString("Square Metre Kelvin per Watt", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalInsulance"
  );
  config.units.set("http://qudt.org/vocab/unit/M2-K-PER-W", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-PER-GM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M-1H0T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²/g",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Meter per Gram", "en-US"));
  unit.addLabel(new LangString("Square Metre per Gram", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassAttenuationCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificSurfaceArea"
  );
  config.units.set("http://qudt.org/vocab/unit/M2-PER-GM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-PER-GM_DRY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M-1H0T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²/g{dry sediment}",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Metres per Gram of Dry Sediment", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassAttenuationCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/M2-PER-GM_DRY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-PER-HA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.0001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²/ha",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Metre per Hectare", "en"));
  unit.addLabel(new LangString("Square Meter per Hectare", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AreaRatio");
  config.units.set("http://qudt.org/vocab/unit/M2-PER-HA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-PER-HA-YR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("3.168808781402895023702689684893655E-12"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²/(ha·a)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Metre per Hectare Year", "en"));
  unit.addLabel(new LangString("Square Meter per Hectare Year", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/M2-PER-HA-YR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-1D0",
    new Decimal("0.0002777777777777777777777777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Metre per Hour", "en"));
  unit.addLabel(new LangString("Square Meter per Hour", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AreaPerTime");
  config.units.set("http://qudt.org/vocab/unit/M2-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-PER-HZ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²/Hz",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Meter per Hertz", "en-US"));
  unit.addLabel(new LangString("Square Metre per Hertz", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/M2-PER-HZ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-PER-HZ-DEG",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T1D0",
    new Decimal("57.29577957855229894302178227976183"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²/(Hz·°)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Metre per Hertz Degree", "en"));
  unit.addLabel(new LangString("Square Meter per Hertz Degree", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/M2-PER-HZ-DEG", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-PER-HZ2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²/Hz²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Meter per Square Hertz", "en-US"));
  unit.addLabel(new LangString("Square Metre per Square Hertz", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/M2-PER-HZ2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-PER-J",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²/J",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Metre per Joule", "en"));
  unit.addLabel(new LangString("Square Meter per Joule", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpectralCrossSection"
  );
  config.units.set("http://qudt.org/vocab/unit/M2-PER-J", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H-1T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²/K",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Meter per Kelvin", "en-US"));
  unit.addLabel(new LangString("Square Metre per Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AreaThermalExpansion"
  );
  config.units.set("http://qudt.org/vocab/unit/M2-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M-1H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²/kg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Meter per Kilogram", "en-US"));
  unit.addLabel(new LangString("Square Metre per Kilogram", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassAttenuationCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassAbsorptionCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassEnergyTransferCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificSurfaceArea"
  );
  config.units.set("http://qudt.org/vocab/unit/M2-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-PER-KiloW",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T3D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²/kW",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Meter per Kilowatt", "en-US"));
  unit.addLabel(new LangString("Square Metre per Kilowatt", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AreaPerPower");
  config.units.set("http://qudt.org/vocab/unit/M2-PER-KiloW", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²/m",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Meter per Meter", "en-US"));
  unit.addLabel(new LangString("Square Metre per Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AreaPerLength");
  config.units.set("http://qudt.org/vocab/unit/M2-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    "m²/m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Metre per Square Metre", "en"));
  unit.addLabel(new LangString("Square Meter per Square Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AreaRatio");
  config.units.set("http://qudt.org/vocab/unit/M2-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-PER-MOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A-1E0L2I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²/mol",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Metre per Mole", "en"));
  unit.addLabel(new LangString("Square Meter per Mole", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MolarAttenuationCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MolarAbsorptionCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/M2-PER-MOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-PER-N",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H0T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²/N",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Square Metre per Newton", "en"));
  unit.addLabel(new LangString("Square Meter per Newton", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Compressibility");
  config.units.set("http://qudt.org/vocab/unit/M2-PER-N", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Metre per Second", "en"));
  unit.addLabel(new LangString("Square Meter per Second", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalDiffusionRatioCoefficient"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AreaPerTime");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/NeutronDiffusionCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DiffusionCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/M2-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-PER-SEC-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M-1H0T1D0",
    new Decimal("0.00001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²/(s·bar)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Metre per Second Bar", "en"));
  unit.addLabel(new LangString("Square Meter per Second Bar", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/M2-PER-SEC-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-PER-SEC-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H-1T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²/(s·K)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Meter per Second Kelvin", "en-US"));
  unit.addLabel(new LangString("Square Metre per Second Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/M2-PER-SEC-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-PER-SEC-PA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M-1H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²/(s·Pa)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Metre per Second Pascal", "en"));
  unit.addLabel(new LangString("Square Meter per Second Pascal", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/M2-PER-SEC-PA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-PER-SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²/s²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    2,
    false,
    false
  );
  unit.addLabel(new LangString("Square Metre per Square Second", "en"));
  unit.addLabel(new LangString("Square Meter per Square Second", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificModulus");
  config.units.set("http://qudt.org/vocab/unit/M2-PER-SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-PER-SEC2-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H-1T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²/(s²·K)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Square Meter per Square Second Kelvin", "en-US")
  );
  unit.addLabel(new LangString("Square Metre per Square Second Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacity"
  );
  config.units.set("http://qudt.org/vocab/unit/M2-PER-SEC2-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-PER-SR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²/sr",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Metre per Steradian", "en"));
  unit.addLabel(new LangString("Square Meter per Steradian", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AngularCrossSection"
  );
  config.units.set("http://qudt.org/vocab/unit/M2-PER-SR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-PER-SR-J",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²/(sr·J)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Metre per Steradian Joule", "en"));
  unit.addLabel(new LangString("Square Meter per Steradian Joule", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpectralAngularCrossSection"
  );
  config.units.set("http://qudt.org/vocab/unit/M2-PER-SR-J", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-PER-V-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M-1H0T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²/(V·s)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Meter per Volt Second", "en-US"));
  unit.addLabel(new LangString("Square Metre per Volt Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mobility");
  config.units.set("http://qudt.org/vocab/unit/M2-PER-V-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-PER-W",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²/W",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Meter per Watt", "en-US"));
  unit.addLabel(new LangString("Square Metre per Watt", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AreaPerPower");
  config.units.set("http://qudt.org/vocab/unit/M2-PER-W", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-SEC-PER-RAD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²·s/rad",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Meter Second per Radian", "en-US"));
  unit.addLabel(new LangString("Square Metre Second per Radian", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/M2-SEC-PER-RAD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-SR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²·sr",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Metre Steradian", "en"));
  unit.addLabel(new LangString("Square Meter Steradian", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AreaAngle");
  config.units.set("http://qudt.org/vocab/unit/M2-SR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    34,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Metre", "en"));
  unit.addLabel(new LangString("Cubic Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SectionModulus");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M3-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M-1H0T2D0",
    new Decimal("0.00001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m³/bar",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Metre per Bar", "en"));
  unit.addLabel(new LangString("Cubic Meter per Bar", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/M3-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M3-PER-C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L3I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m³/C",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Metre per Coulomb", "en"));
  unit.addLabel(new LangString("Cubic Meter per Coulomb", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/HallCoefficient");
  config.units.set("http://qudt.org/vocab/unit/M3-PER-C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M3-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.00001157407407407407407407407407407407"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m³/d",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Metre per Day", "en"));
  unit.addLabel(new LangString("Cubic Meter per Day", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/M3-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M3-PER-DAY-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M-1H0T1D0",
    new Decimal("1.157407407407407407407407407407407E-10"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m³/(d·bar)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Meter per Day Bar", "en-US"));
  unit.addLabel(new LangString("Cubic Metre per Day Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/M3-PER-DAY-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M3-PER-DAY-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H-1T-1D0",
    new Decimal("0.00001157407407407407407407407407407407"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m³/(d·K)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Meter per Day Kelvin", "en-US"));
  unit.addLabel(new LangString("Cubic Metre per Day Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/M3-PER-DAY-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M3-PER-HA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("0.0001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m³/ha",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Meter per Hectare", "en-US"));
  unit.addLabel(new LangString("Cubic Metre per Hectare", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerArea");
  config.units.set("http://qudt.org/vocab/unit/M3-PER-HA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M3-PER-HA-YR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("3.168808781402895023702689684893655E-12"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m³/(ha·a)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Meter per Hectare Year", "en-US"));
  unit.addLabel(new LangString("Cubic Metre per Hectare Year", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SurfaceRelatedVolumeFlow"
  );
  config.units.set("http://qudt.org/vocab/unit/M3-PER-HA-YR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M3-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.0002777777777777777777777777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m³/h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Meter per Hour", "en-US"));
  unit.addLabel(new LangString("Cubic Metre per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/M3-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M3-PER-HR-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M-1H0T1D0",
    new Decimal("2.777777777777777777777777777777778E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m³/(h·bar)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Metre per Hour Bar", "en"));
  unit.addLabel(new LangString("Cubic Meter per Hour Bar", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/M3-PER-HR-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M3-PER-HR-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H-1T-1D0",
    new Decimal("0.0002777777777777777777777777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m³/(h·K)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Metre per Hour Kelvin", "en"));
  unit.addLabel(new LangString("Cubic Meter per Hour Kelvin", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/M3-PER-HR-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M3-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H-1T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m³/K",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Metre per Kelvin", "en"));
  unit.addLabel(new LangString("Cubic Meter per Kelvin", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/VolumeThermalExpansion"
  );
  config.units.set("http://qudt.org/vocab/unit/M3-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M3-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M-1H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m³/kg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Metre per Kilogram", "en"));
  unit.addLabel(new LangString("Cubic Meter per Kilogram", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoilAdsorptionCoefficient"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificVolume");
  config.units.set("http://qudt.org/vocab/unit/M3-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M3-PER-KiloGM-SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M-1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m³/(kg·s²)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Cubic Meter per Kilogram Square Second", "en-US")
  );
  unit.addLabel(new LangString("Cubic Metre per Kilogram Square Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/M3-PER-KiloGM-SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M3-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m³/m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Meter per Square Meter", "en-US"));
  unit.addLabel(new LangString("Cubic Metre per Square Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerArea");
  config.units.set("http://qudt.org/vocab/unit/M3-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M3-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m³/m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Meter per Cubic Meter", "en-US"));
  unit.addLabel(new LangString("Cubic Metre per Cubic Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFraction");
  config.units.set("http://qudt.org/vocab/unit/M3-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M3-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.01666666666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m³/min",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Metre per Minute", "en"));
  unit.addLabel(new LangString("Cubic Meter per Minute", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/M3-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M3-PER-MIN-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M-1H0T1D0",
    new Decimal("1.666666666666666666666666666666667E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m³/(min·bar)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Metre per Minute Bar", "en"));
  unit.addLabel(new LangString("Cubic Meter per Minute Bar", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/M3-PER-MIN-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M3-PER-MIN-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H-1T-1D0",
    new Decimal("0.01666666666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m³/(min·K)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Metre per Minute Kelvin", "en"));
  unit.addLabel(new LangString("Cubic Meter per Minute Kelvin", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/M3-PER-MIN-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M3-PER-MOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A-1E0L3I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m³/mol",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Metre per Mole", "en"));
  unit.addLabel(new LangString("Cubic Meter per Mole", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MolarVolume");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MolarRefractivity"
  );
  config.units.set("http://qudt.org/vocab/unit/M3-PER-MOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M3-PER-MOL-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A-1E0L3I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m³/(mol·s)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Meter per Mole Second", "en-US"));
  unit.addLabel(new LangString("Cubic Metre per Mole Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SecondOrderReactionRateConstant"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AtmosphericHydroxylationRate"
  );
  config.units.set("http://qudt.org/vocab/unit/M3-PER-MOL-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M3-PER-PA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M-1H0T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m³/Pa",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Metre per Pascal", "en"));
  unit.addLabel(new LangString("Cubic Meter per Pascal", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/M3-PER-PA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M3-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m³/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Metre per Second", "en"));
  unit.addLabel(new LangString("Cubic Meter per Second", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoundVolumeVelocity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/RecombinationCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/M3-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M3-PER-SEC-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M-1H0T1D0",
    new Decimal("0.00001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m³/(s·bar)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Meter per Second Bar", "en-US"));
  unit.addLabel(new LangString("Cubic Metre per Second Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/M3-PER-SEC-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M3-PER-SEC-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H-1T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m³/(s·K)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Meter per Second Kelvin", "en-US"));
  unit.addLabel(new LangString("Cubic Metre per Second Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/M3-PER-SEC-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M3-PER-SEC-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m³/(s·m²)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Metre per Second Square Metre", "en"));
  unit.addLabel(new LangString("Cubic Meter per Second Square Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SurfaceRelatedVolumeFlowRate"
  );
  config.units.set("http://qudt.org/vocab/unit/M3-PER-SEC-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M3-PER-SEC-PA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M-1H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m³/(s·Pa)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Metre per Second Pascal", "en"));
  unit.addLabel(new LangString("Cubic Meter per Second Pascal", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/M3-PER-SEC-PA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M3-PER-SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m³/s²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Meter per Square Second", "en-US"));
  unit.addLabel(new LangString("Cubic Metre per Square Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/StandardGravitationalParameter"
  );
  config.units.set("http://qudt.org/vocab/unit/M3-PER-SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M3-PER-YR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("3.168808781402895023702689684893655E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m³/a",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Meter per Year", "en-US"));
  unit.addLabel(new LangString("Cubic Metre per Year", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/M3-PER-YR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M4",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m⁴",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Quartic Meter", "en-US"));
  unit.addLabel(new LangString("Quartic Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SecondMomentOfArea"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SecondAxialMomentOfArea"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SecondPolarMomentOfArea"
  );
  config.units.set("http://qudt.org/vocab/unit/M4", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M4-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m⁴/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Quartic Metre per Second", "en"));
  unit.addLabel(new LangString("Quartic Meter per Second", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/M4-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M5",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L5I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m⁵",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Quintic Meter", "en-US"));
  unit.addLabel(new LangString("Quintic Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SectionAreaIntegral"
  );
  config.units.set("http://qudt.org/vocab/unit/M5", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M6",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L6I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m⁶",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Sextic Meter", "en-US"));
  unit.addLabel(new LangString("Sextic Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/WarpingConstant");
  config.units.set("http://qudt.org/vocab/unit/M6", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MACH",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Mach",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Mach", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MachNumber");
  config.units.set("http://qudt.org/vocab/unit/MACH", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MESH",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mesh",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Mesh", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseLength");
  config.units.set("http://qudt.org/vocab/unit/MESH", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MHO",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-2I0M-1H0T3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/S",
    undefined,
    "℧",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Mho", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Conductance");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Admittance");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/S");
  config.units.set("http://qudt.org/vocab/unit/MHO", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MHO_Stat",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-3I0M-1H0T3D0",
    new Decimal("1.1126500561E-12"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/S-PER-M",
    undefined,
    "stat℧",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI", "http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Statmho", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricConductivity"
  );
  unit.addExactMatchIri("http://qudt.org/vocab/unit/S_Stat");
  config.units.set("http://qudt.org/vocab/unit/MHO_Stat", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MI",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("1609.344"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M",
    undefined,
    "mi",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    7,
    false,
    false
  );
  unit.addLabel(new LangString("International Mile", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Distance");
  config.units.set("http://qudt.org/vocab/unit/MI", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MI-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("0.44704"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mi/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("International Mile per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/MI-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MI-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("26.82240000000000000000000000000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mi/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("International Mile per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/MI-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MI-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("1609.344"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mi/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("International Mile per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/MI-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MI2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    new Decimal("2589988.110336"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mi²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square International Mile", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Area");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/MI_US2");
  config.units.set("http://qudt.org/vocab/unit/MI2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MI3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("4168181825.440579584"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mi³",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic International Mile", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/MI3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MIL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.00098174770424681038701957605727484"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/RAD",
    undefined,
    "mil{NATO}",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Mil Angle (nato)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PlaneAngle");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Angle");
  config.units.set("http://qudt.org/vocab/unit/MIL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MILLE",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    true
  );
  unit.addLabel(new LangString("MILLE", undefined));
  config.units.set("http://qudt.org/vocab/unit/MILLE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MILLION",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/ONE",
    undefined,
    "1000000",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Million", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Count");
  config.units.set("http://qudt.org/vocab/unit/MILLION", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MIL_Circ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    new Decimal("5.067075E-10"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M2",
    undefined,
    "cmil",
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Circular Mil", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/HydraulicPermeability"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Area");
  config.units.set("http://qudt.org/vocab/unit/MIL_Circ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("60.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/SEC",
    undefined,
    "min",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    152,
    false,
    false
  );
  unit.addLabel(new LangString("Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MIN-PER-KiloM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T1D0",
    new Decimal("0.06"),
    undefined,
    undefined,
    undefined,
    undefined,
    "min/km",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Minute per Kilometer", "en-US"));
  unit.addLabel(new LangString("Minute per Kilometre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Pace");
  config.units.set("http://qudt.org/vocab/unit/MIN-PER-KiloM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MIN-PER-MI",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T1D0",
    new Decimal("0.03728227153424003817704605106179909"),
    undefined,
    undefined,
    undefined,
    undefined,
    "min/mi",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Minute per International Mile", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Pace");
  config.units.set("http://qudt.org/vocab/unit/MIN-PER-MI", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MIN-PER-NUM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("60.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "min/#",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Minute per Number", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/TimePerCount");
  config.units.set("http://qudt.org/vocab/unit/MIN-PER-NUM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MIN_Angle",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.000290888209"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/RAD",
    undefined,
    "'",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Minute Angle", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PlaneAngle");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Angle");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/ARCMIN");
  config.units.set("http://qudt.org/vocab/unit/MIN_Angle", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MIN_Sidereal",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("59.83617"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/SEC",
    undefined,
    "min{sidereal}",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Sidereal Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/MIN_Sidereal", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MI_N",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("1852.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M",
    undefined,
    "nmi",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    4,
    false,
    false
  );
  unit.addLabel(new LangString("Nautical Mile", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/MI_N", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MI_N-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("0.5144444444444444444444444444444445"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nmi/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Nautical Mile per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/KN");
  config.units.set("http://qudt.org/vocab/unit/MI_N-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MI_N-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("30.86666666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nmi/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Nautical Mile per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/MI_N-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MI_UK",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    true
  );
  unit.addLabel(new LangString("MI_UK", undefined));
  config.units.set("http://qudt.org/vocab/unit/MI_UK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MI_UK3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("4168181825.44057958"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mi³",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Mile (uk Statute)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SectionModulus");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/MI_UK3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MI_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("1609.347"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M",
    undefined,
    "mi{US}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    2,
    false,
    false
  );
  unit.addLabel(new LangString("Mile Us Statute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/MI_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MI_US-PER-SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-2D0",
    new Decimal("1609.347"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mi{US}/s²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Mile Us Statute per Square Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Acceleration");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearAcceleration"
  );
  config.units.set("http://qudt.org/vocab/unit/MI_US-PER-SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MI_US2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    new Decimal("2589997.766409"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mi{US}²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Mile Us Statute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Area");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/MI2");
  config.units.set("http://qudt.org/vocab/unit/MI_US2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MO",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("2551442.976"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/SEC",
    undefined,
    "mo",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    6,
    false,
    false
  );
  unit.addLabel(new LangString("Month", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/MO_Synodic");
  config.units.set("http://qudt.org/vocab/unit/MO", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MO-PER-NUM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("2551442.976"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mo/#",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Month per Number", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/TimePerCount");
  config.units.set("http://qudt.org/vocab/unit/MO-PER-NUM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOHM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T1D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/SEC-PER-KiloGM",
    undefined,
    "mohm",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Mohm", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MechanicalMobility"
  );
  config.units.set("http://qudt.org/vocab/unit/MOHM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mol",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    71,
    false,
    false
  );
  unit.addLabel(new LangString("Mole", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstance"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ExtentOfReaction"
  );
  config.units.set("http://qudt.org/vocab/unit/MOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL-DEG_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H1T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mol·°C",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI", "http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Mole Degree Celsius", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TemperatureAmountOfSubstance"
  );
  config.units.set("http://qudt.org/vocab/unit/MOL-DEG_C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H1T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mol·K",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Mole Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TemperatureAmountOfSubstance"
  );
  config.units.set("http://qudt.org/vocab/unit/MOL-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL-PER-DeciM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mol/dm³",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Mole per Cubic Decimeter", "en-US"));
  unit.addLabel(new LangString("Mole per Cubic Decimetre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Concentration");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/WaterSolubility");
  config.units.set("http://qudt.org/vocab/unit/MOL-PER-DeciM3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL-PER-GM-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M-1H0T-1D0",
    new Decimal("0.2777777777777777777777777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mol/(g·h)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Mole per Gram Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MOL-PER-GM-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T-1D0",
    new Decimal("0.0002777777777777777777777777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mol/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Mole per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MolarFlowRate");
  config.units.set("http://qudt.org/vocab/unit/MOL-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M-1H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mol/kg",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Mole per Kilogram", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstancePerMass"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/IonicStrength");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MolalityOfSolute"
  );
  config.units.set("http://qudt.org/vocab/unit/MOL-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL-PER-KiloGM-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L1I0M-2H0T2D0",
    new Decimal("0.00001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mol/(kg·bar)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Mole per Kilogram Bar", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstancePerMassPressure"
  );
  config.units.set("http://qudt.org/vocab/unit/MOL-PER-KiloGM-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL-PER-KiloGM-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M-1H-1T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mol/(kg·K)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Mole per Kilogram Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MOL-PER-KiloGM-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL-PER-KiloGM-PA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L1I0M-2H0T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mol/(kg·Pa)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Mole per Kilogram Pascal", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstancePerMassPressure"
  );
  config.units.set("http://qudt.org/vocab/unit/MOL-PER-KiloGM-PA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mol/L",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Mole per Litre", "en"));
  unit.addLabel(new LangString("Mole per Liter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Concentration");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/WaterSolubility");
  config.units.set("http://qudt.org/vocab/unit/MOL-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL-PER-L-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-2I0M-1H0T2D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mol/(L·bar)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Mole per Litre Bar", "en"));
  unit.addLabel(new LangString("Mole per Liter Bar", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MOL-PER-L-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL-PER-L-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H-1T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mol/(L·K)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Mole per Liter Kelvin", "en-US"));
  unit.addLabel(new LangString("Mole per Litre Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MOL-PER-L-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-2I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mol/m²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Mole per Square Meter", "en-US"));
  unit.addLabel(new LangString("Mole per Square Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MOL-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL-PER-M2-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-2I0M0H0T-1D0",
    new Decimal("0.00001157407407407407407407407407407407"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mol/(m²·d)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Mole per Square Metre Day", "en"));
  unit.addLabel(new LangString("Mole per Square Meter Day", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PhotosyntheticPhotonFluxDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/MOL-PER-M2-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL-PER-M2-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-2I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mol/(m²·s)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Mole per Square Meter Second", "en-US"));
  unit.addLabel(new LangString("Mole per Square Metre Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PhotosyntheticPhotonFluxDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/MOL-PER-M2-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL-PER-M2-SEC-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mol/(m²·s·m)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Mole per Square Metre Second Metre", "en"));
  unit.addLabel(new LangString("Mole per Square Meter Second Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CatalyticActivityConcentration"
  );
  config.units.set("http://qudt.org/vocab/unit/MOL-PER-M2-SEC-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL-PER-M2-SEC-M-SR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mol/(m²·s·m·sr)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Mole per Square Meter Second Meter Steradian", "en-US")
  );
  unit.addLabel(
    new LangString("Mole per Square Metre Second Metre Steradian", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MOL-PER-M2-SEC-M-SR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL-PER-M2-SEC-SR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-2I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mol/(m²·s·sr)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Mole per Square Meter Second Steradian", "en-US")
  );
  unit.addLabel(new LangString("Mole per Square Metre Second Steradian", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MOL-PER-M2-SEC-SR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mol/m³",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Mole per Cubic Metre", "en"));
  unit.addLabel(new LangString("Mole per Cubic Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Concentration");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/WaterSolubility");
  config.units.set("http://qudt.org/vocab/unit/MOL-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL-PER-M3-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-2I0M-1H0T2D0",
    new Decimal("0.00001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mol/(m³·bar)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Mole per Cubic Metre Bar", "en"));
  unit.addLabel(new LangString("Mole per Cubic Meter Bar", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MOL-PER-M3-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL-PER-M3-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H-1T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mol/(m³·K)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Mole per Cubic Meter Kelvin", "en-US"));
  unit.addLabel(new LangString("Mole per Cubic Metre Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MOL-PER-M3-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL-PER-M3-PA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-2I0M-1H0T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mol/(m³·Pa)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Mole per Cubic Metre Pascal", "en"));
  unit.addLabel(new LangString("Mole per Cubic Meter Pascal", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MOL-PER-M3-PA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL-PER-M3-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mol/(m³·s)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Mole per Cubic Metre Second", "en"));
  unit.addLabel(new LangString("Mole per Cubic Meter Second", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CatalyticActivityConcentration"
  );
  config.units.set("http://qudt.org/vocab/unit/MOL-PER-M3-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T-1D0",
    new Decimal("0.01666666666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mol/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Mole per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MolarFlowRate");
  config.units.set("http://qudt.org/vocab/unit/MOL-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL-PER-MOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mol/mol",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Mole per Mole", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MOL-PER-MOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mol/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Mole per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MolarFlowRate");
  config.units.set("http://qudt.org/vocab/unit/MOL-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL-PER-TONNE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M-1H0T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mol/t",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Mole per Tonne", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstancePerMass"
  );
  config.units.set("http://qudt.org/vocab/unit/MOL-PER-TONNE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL_LB",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T0D0",
    new Decimal("453.59237"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/MOL",
    undefined,
    "lb-mol",
    undefined,
    undefined,
    undefined,
    [],
    6,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Mole", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstance"
  );
  config.units.set("http://qudt.org/vocab/unit/MOL_LB", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL_LB-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H1T0D0",
    new Decimal("251.9957611111111111111111111111111"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lb-mol·°F",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Mole Degree Fahrenheit", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassAmountOfSubstanceTemperature"
  );
  config.units.set("http://qudt.org/vocab/unit/MOL_LB-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL_LB-PER-LB",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M-1H0T0D0",
    new Decimal("999.9999999999999999999999999999998"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lb-mol/lbm",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Mole per Pound Mass", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstancePerMass"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/IonicStrength");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MolalityOfSolute"
  );
  config.units.set("http://qudt.org/vocab/unit/MOL_LB-PER-LB", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL_LB-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T-1D0",
    new Decimal("7.559872833333333333333333333333335"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lb-mol/min",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Mole per Minute", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CatalyticActivity"
  );
  config.units.set("http://qudt.org/vocab/unit/MOL_LB-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL_LB-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T-1D0",
    new Decimal("453.59237"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lb-mol/s",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pound Mole per Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CatalyticActivity"
  );
  config.units.set("http://qudt.org/vocab/unit/MOL_LB-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOMME_Pearl",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("3.75"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "momme (pearl)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Momme (pearl)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  config.units.set("http://qudt.org/vocab/unit/MOMME_Pearl", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOMME_Textile",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("0.00434"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "momme (textile)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Momme (textile)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  config.units.set("http://qudt.org/vocab/unit/MOMME_Textile", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MO_MeanGREGORIAN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("2629746.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/SEC",
    undefined,
    "mo{Gregorian}",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Mean Gregorian Month", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/MO_MeanGREGORIAN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MO_MeanJulian",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("2629800.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/SEC",
    undefined,
    "mo{mean Julian}",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Mean Julian Month", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/MO_MeanJulian", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MO_Synodic",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("2551442.976"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/SEC",
    undefined,
    "mo{synodic}",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Synodic Month", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/MO");
  config.units.set("http://qudt.org/vocab/unit/MO_Synodic", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MX",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-2D0",
    new Decimal("1E-8"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/WB",
    undefined,
    "Mx",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Maxwell", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MagneticFlux");
  config.units.set("http://qudt.org/vocab/unit/MX", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M_H2O",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("9806.65"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/PA",
    undefined,
    "mH₂0",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Conventional Metre of Water", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/M_H2O", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MebiBIT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("726817.4980028252127674835889901326"),
    undefined,
    "http://qudt.org/vocab/prefix/Mebi",
    "http://qudt.org/vocab/unit/BIT",
    undefined,
    "Mib",
    undefined,
    undefined,
    undefined,
    [],
    3,
    false,
    false
  );
  unit.addLabel(new LangString("Mebibit", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DatasetOfBits");
  config.units.set("http://qudt.org/vocab/unit/MebiBIT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MebiBIT-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("726817.4980028252127674835889901326"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Mib/m",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Mebibit per Metre", "en"));
  unit.addLabel(new LangString("Mebibit per Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearBitDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/MebiBIT-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MebiBIT-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T0D0",
    new Decimal("726817.4980028252127674835889901326"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Mib/m²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Mebibit per Square Meter", "en-US"));
  unit.addLabel(new LangString("Mebibit per Square Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AreaBitDensity");
  config.units.set("http://qudt.org/vocab/unit/MebiBIT-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MebiBIT-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    new Decimal("726817.4980028252127674835889901326"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Mib/m³",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Mebibit per Cubic Meter", "en-US"));
  unit.addLabel(new LangString("Mebibit per Cubic Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/VolumetricBitDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/MebiBIT-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MebiBYTE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("5814539.98402260170213986871192106"),
    undefined,
    "http://qudt.org/vocab/prefix/Mebi",
    "http://qudt.org/vocab/unit/BYTE",
    undefined,
    "MiB",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Mebibyte", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InformationEntropy"
  );
  config.units.set("http://qudt.org/vocab/unit/MebiBYTE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T0D0",
    new Decimal("1000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Mega",
    "http://qudt.org/vocab/unit/A",
    undefined,
    "MA",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Megaampere", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCurrent");
  config.units.set("http://qudt.org/vocab/unit/MegaA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaA-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H0T0D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MA/m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Megaampere per Square Metre", "en"));
  unit.addLabel(new LangString("Megaampere per Square Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/MegaA-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaBAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("100000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Mega",
    "http://qudt.org/vocab/unit/BAR",
    undefined,
    "Mbar",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Megabar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/MegaBAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaBAUD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Mega",
    "http://qudt.org/vocab/unit/BAUD",
    undefined,
    "MBd",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Megabaud", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DigitRate");
  config.units.set("http://qudt.org/vocab/unit/MegaBAUD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaBIT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("693147.18055994530941723212145818"),
    undefined,
    "http://qudt.org/vocab/prefix/Mega",
    "http://qudt.org/vocab/unit/BIT",
    undefined,
    "Mb",
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Megabit", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DatasetOfBits");
  config.units.set("http://qudt.org/vocab/unit/MegaBIT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaBIT-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("693147.18055994530941723212145818"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Mb/s",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Megabit per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DataRate");
  config.units.set("http://qudt.org/vocab/unit/MegaBIT-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaBQ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("1000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Mega",
    "http://qudt.org/vocab/unit/BQ",
    undefined,
    "MBq",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Megabecquerel", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Activity");
  config.units.set("http://qudt.org/vocab/unit/MegaBQ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaBQ-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T-1D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MBq/kg",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Megabecquerel per Kilogram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassicActivity");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificActivity"
  );
  config.units.set("http://qudt.org/vocab/unit/MegaBQ-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaBTU_IT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1055055852.62"),
    undefined,
    "http://qudt.org/vocab/prefix/Mega",
    "http://qudt.org/vocab/unit/BTU_IT",
    undefined,
    "MBtu{IT}",
    undefined,
    undefined,
    undefined,
    [],
    2,
    false,
    false
  );
  unit.addLabel(
    new LangString("Mega British Thermal Unit (international Definition)", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ThermalEnergy");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/MegaBTU_IT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaBTU_IT-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("293071.0701722222222222222222222222"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MBtu{IT}/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "Mega British Thermal Unit (international Definition) per Hour",
      "en"
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/HeatFlowRate");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/MegaBTU_IT-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaBYTE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("5545177.44447956247533785697166544"),
    undefined,
    "http://qudt.org/vocab/prefix/Mega",
    "http://qudt.org/vocab/unit/BYTE",
    undefined,
    "MB",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Megabyte", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InformationEntropy"
  );
  config.units.set("http://qudt.org/vocab/unit/MegaBYTE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaBYTE-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("5545177.44447956247533785697166544"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MB/s",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Megabyte per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ByteRate");
  config.units.set("http://qudt.org/vocab/unit/MegaBYTE-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("1000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Mega",
    "http://qudt.org/vocab/unit/C",
    undefined,
    "MC",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    2,
    false,
    false
  );
  unit.addLabel(new LangString("Megacoulomb", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  config.units.set("http://qudt.org/vocab/unit/MegaC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaC-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H0T1D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MC/m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Megacoulomb per Square Meter", "en-US"));
  unit.addLabel(new LangString("Megacoulomb per Square Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerArea"
  );
  config.units.set("http://qudt.org/vocab/unit/MegaC-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaC-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-3I0M0H0T1D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MC/m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Megacoulomb per Cubic Metre", "en"));
  unit.addLabel(new LangString("Megacoulomb per Cubic Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargeDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/MegaC-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaCCY_USD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Mega",
    "http://qudt.org/vocab/unit/CCY_USD",
    undefined,
    "M$",
    undefined,
    undefined,
    undefined,
    [],
    2,
    false,
    false
  );
  unit.addLabel(new LangString("Mega Us Dollar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/unit/MegaCCY_USD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaCCY_USD-PER-FLIGHT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "M$/flight",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Mega Us Dollar per Flight", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CurrencyPerFlight"
  );
  config.units.set("http://qudt.org/vocab/unit/MegaCCY_USD-PER-FLIGHT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaCCY_USD-PER-YR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("0.03168808781402895023702689684893655"),
    undefined,
    undefined,
    undefined,
    undefined,
    "M$/a",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Mega Us Dollar per Year", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MegaCCY_USD-PER-YR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaDOLLAR_US",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    true
  );
  unit.addLabel(new LangString("MegaDOLLAR_US", undefined));
  config.units.set("http://qudt.org/vocab/unit/MegaDOLLAR_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaDOLLAR_US-PER-FLIGHT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "$M/flight",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("Million Us Dollars per Flight", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CurrencyPerFlight"
  );
  config.units.set("http://qudt.org/vocab/unit/MegaDOLLAR_US-PER-FLIGHT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaEV",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1.602176634E-13"),
    undefined,
    "http://qudt.org/vocab/prefix/Mega",
    "http://qudt.org/vocab/unit/EV",
    undefined,
    "MeV",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    3,
    false,
    false
  );
  unit.addLabel(new LangString("Mega Electron Volt", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/MegaEV", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaEV-FemtoM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M1H0T-2D0",
    new Decimal("1.602176634E-28"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MeV·fm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Mega Electron Volt Femtometer", "en-US"));
  unit.addLabel(new LangString("Mega Electron Volt Femtometre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LengthEnergy");
  config.units.set("http://qudt.org/vocab/unit/MegaEV-FemtoM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaEV-PER-CentiM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("1.602176634E-11"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MeV/cm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Mega Electron Volt per Centimetre", "en"));
  unit.addLabel(new LangString("Mega Electron Volt per Centimeter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearEnergyTransfer"
  );
  config.units.set("http://qudt.org/vocab/unit/MegaEV-PER-CentiM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaEV-PER-SpeedOfLight",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-1D0",
    new Decimal("5.34369681E-22"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MeV/c",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Mega Electron Volt per Speed of Light", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Momentum");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearMomentum");
  config.units.set("http://qudt.org/vocab/unit/MegaEV-PER-SpeedOfLight", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaFLOPS",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("1000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Mega",
    "http://qudt.org/vocab/unit/FLOPS",
    undefined,
    "MFLOPS",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Mega Floating Point Operations per Second", "en")
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/FloatingPointCalculationCapability"
  );
  config.units.set("http://qudt.org/vocab/unit/MegaFLOPS", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("1000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Mega",
    "http://qudt.org/vocab/unit/GM",
    undefined,
    "Mg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    3,
    false,
    false
  );
  unit.addLabel(new LangString("Megagram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  config.units.set("http://qudt.org/vocab/unit/MegaGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaGM-PER-HA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    new Decimal("0.1"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Mg/ha",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Megagram per Hectare", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerArea");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TONNE-PER-HA");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON_Metric-PER-HA");
  config.units.set("http://qudt.org/vocab/unit/MegaGM-PER-HA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaGM-PER-HA-YR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-1D0",
    new Decimal("3.168808781402895023702689684893655E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Mg/(ha·a)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Megagram per Hectare Year", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerAreaTime");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TONNE-PER-HA-YR");
  config.units.set("http://qudt.org/vocab/unit/MegaGM-PER-HA-YR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaGM-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Mg/m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Megagram per Cubic Meter", "en-US"));
  unit.addLabel(new LangString("Megagram per Cubic Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  config.units.set("http://qudt.org/vocab/unit/MegaGM-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaGRAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("1000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Mega",
    "http://qudt.org/vocab/unit/GRAY",
    undefined,
    "MGy",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Megagray", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AbsorbedDose");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Kerma");
  config.units.set("http://qudt.org/vocab/unit/MegaGRAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaHZ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("1000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Mega",
    "http://qudt.org/vocab/unit/HZ",
    undefined,
    "MHz",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    5,
    false,
    false
  );
  unit.addLabel(new LangString("Megahertz", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Frequency");
  config.units.set("http://qudt.org/vocab/unit/MegaHZ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaHZ-KiloM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("1000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MHz·km",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Megahertz Kilometer", "en-US"));
  unit.addLabel(new LangString("Megahertz Kilometre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MegaHZ-KiloM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaHZ-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MHz·m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Megahertz Metre", "en"));
  unit.addLabel(new LangString("Megahertz Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Speed");
  config.units.set("http://qudt.org/vocab/unit/MegaHZ-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaHZ-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H-1T-1D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MHz/K",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Megahertz per Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InverseTimeTemperature"
  );
  config.units.set("http://qudt.org/vocab/unit/MegaHZ-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaHZ-PER-T",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M-1H0T1D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MHz/T",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Megahertz per Tesla", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerMass"
  );
  config.units.set("http://qudt.org/vocab/unit/MegaHZ-PER-T", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaINDIV",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    true
  );
  unit.addLabel(new LangString("MegaINDIV", undefined));
  config.units.set("http://qudt.org/vocab/unit/MegaINDIV", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaJ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Mega",
    "http://qudt.org/vocab/unit/J",
    undefined,
    "MJ",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    7,
    false,
    false
  );
  unit.addLabel(new LangString("Megajoule", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ThermalEnergy");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/MegaJ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaJ-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("277.7777777777777777777777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MJ/h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Megajoule per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/MegaJ-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaJ-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H-1T-2D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MJ/K",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Megajoule per Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/HeatCapacity");
  config.units.set("http://qudt.org/vocab/unit/MegaJ-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaJ-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MJ/kg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Megajoule per Kilogram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificEnergy");
  config.units.set("http://qudt.org/vocab/unit/MegaJ-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaJ-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MJ/m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Megajoule per Square Meter", "en-US"));
  unit.addLabel(new LangString("Megajoule per Square Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyPerArea");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/StrainEnergyReleaseRate"
  );
  config.units.set("http://qudt.org/vocab/unit/MegaJ-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaJ-PER-M2-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    new Decimal("11.57407407407407407407407407407407"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MJ/(m²·d)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Megajoule per Square Meter Day", "en-US"));
  unit.addLabel(new LangString("Megajoule per Square Metre Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Irradiance");
  config.units.set("http://qudt.org/vocab/unit/MegaJ-PER-M2-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaJ-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MJ/m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Megajoule per Cubic Meter", "en-US"));
  unit.addLabel(new LangString("Megajoule per Cubic Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyDensity");
  config.units.set("http://qudt.org/vocab/unit/MegaJ-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaJ-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MJ/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Megajoule per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/MegaJ-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T0D0",
    new Decimal("1000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Mega",
    "http://qudt.org/vocab/unit/K",
    undefined,
    "MK",
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Megakelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MeltingPoint");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermodynamicTemperature"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/BoilingPoint");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Temperature");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CorrelatedColorTemperature"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/FlashPoint");
  config.units.set("http://qudt.org/vocab/unit/MegaK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("1000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Mega",
    "http://qudt.org/vocab/unit/L",
    undefined,
    "ML",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Megaliter", "en-US"));
  unit.addLabel(new LangString("Megalitre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/MegaL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaLB_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("4448221.8148411428"),
    undefined,
    "http://qudt.org/vocab/prefix/Mega",
    "http://qudt.org/vocab/unit/LB_F",
    undefined,
    "Mlbf",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Mega Pound Force", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Force");
  config.units.set("http://qudt.org/vocab/unit/MegaLB_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("1000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Mega",
    "http://qudt.org/vocab/unit/N",
    undefined,
    "MN",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    4,
    false,
    false
  );
  unit.addLabel(new LangString("Meganewton", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Force");
  config.units.set("http://qudt.org/vocab/unit/MegaN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaN-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MN·m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Meganewton Meter", "en-US"));
  unit.addLabel(new LangString("Meganewton Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MomentOfForce");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Torque");
  config.units.set("http://qudt.org/vocab/unit/MegaN-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaN-M-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MN·m/m²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Meganewton Metre per Square Metre", "en"));
  unit.addLabel(new LangString("Meganewton Meter per Square Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerLength");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyPerArea");
  config.units.set("http://qudt.org/vocab/unit/MegaN-M-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaN-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MN/m²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Meganewton per Square Meter", "en-US"));
  unit.addLabel(new LangString("Meganewton per Square Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  config.units.set("http://qudt.org/vocab/unit/MegaN-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaN-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-2D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MN/m³",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Meganewton per Cubic Meter", "en-US"));
  unit.addLabel(new LangString("Meganewton per Cubic Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ModulusOfSubgradeReaction"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificWeight");
  config.units.set("http://qudt.org/vocab/unit/MegaN-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaOHM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H0T-3D0",
    new Decimal("1000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Mega",
    "http://qudt.org/vocab/unit/OHM",
    undefined,
    "MΩ",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    6,
    false,
    false
  );
  unit.addLabel(new LangString("Megaohm", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Resistance");
  config.units.set("http://qudt.org/vocab/unit/MegaOHM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaOHM-KiloM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L3I0M1H0T-3D0",
    new Decimal("1000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MΩ·km",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Megaohm Kilometer", "en-US"));
  unit.addLabel(new LangString("Megaohm Kilometre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ResidualResistivity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Resistivity");
  config.units.set("http://qudt.org/vocab/unit/MegaOHM-KiloM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaOHM-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L3I0M1H0T-3D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MΩ·m",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Megaohm Meter", "en-US"));
  unit.addLabel(new LangString("Megaohm Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Resistivity");
  config.units.set("http://qudt.org/vocab/unit/MegaOHM-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaOHM-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L3I0M0H0T-1D0",
    new Decimal("10.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MΩ/bar",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Megaohm per Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MegaOHM-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaOHM-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H-1T-3D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MΩ/K",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Megaohm per Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MegaOHM-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaOHM-PER-KiloM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L1I0M1H0T-3D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MΩ/km",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Megaohm per Kilometre", "en"));
  unit.addLabel(new LangString("Megaohm per Kilometer", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearResistance"
  );
  config.units.set("http://qudt.org/vocab/unit/MegaOHM-PER-KiloM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaOHM-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L1I0M1H0T-3D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MΩ/m",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Megaohm per Meter", "en-US"));
  unit.addLabel(new LangString("Megaohm per Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearResistance"
  );
  config.units.set("http://qudt.org/vocab/unit/MegaOHM-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaPA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("1000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Mega",
    "http://qudt.org/vocab/unit/PA",
    undefined,
    "MPa",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    8,
    false,
    false
  );
  unit.addLabel(new LangString("Megapascal", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ModulusOfElasticity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ShearModulus");
  config.units.set("http://qudt.org/vocab/unit/MegaPA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaPA-L-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MPa·L/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Megapascal Liter per Second", "en-US"));
  unit.addLabel(new LangString("Megapascal Litre per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/MegaPA-L-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaPA-M0dot5",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-0dot5I0M1H0T-2D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MPa√m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Megapascal Square Root Meter", "en-US"));
  unit.addLabel(new LangString("Megapascal Square Root Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/StressIntensityFactor"
  );
  config.units.set("http://qudt.org/vocab/unit/MegaPA-M0dot5", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaPA-M3-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MPa·m³/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Megapascal Cubic Meter per Second", "en-US"));
  unit.addLabel(new LangString("Megapascal Cubic Metre per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/MegaPA-M3-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaPA-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("10.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MPa/bar",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Megapascal per Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PressureRatio");
  config.units.set("http://qudt.org/vocab/unit/MegaPA-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaPA-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H-1T-2D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MPa/K",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Megapascal per Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PressureCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/MegaPA-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaPSI",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("6894757602.518976377952755905511811"),
    undefined,
    "http://qudt.org/vocab/prefix/Mega",
    "http://qudt.org/vocab/unit/PSI",
    undefined,
    "Mpsi",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Megapsi", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ModulusOfElasticity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ShearModulus");
  config.units.set("http://qudt.org/vocab/unit/MegaPSI", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaS",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-2I0M-1H0T3D0",
    new Decimal("1000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Mega",
    "http://qudt.org/vocab/unit/S",
    undefined,
    "MS",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Megasiemens", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Conductance");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Admittance");
  config.units.set("http://qudt.org/vocab/unit/MegaS", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaS-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-3I0M-1H0T3D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MS/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Megasiemens per Metre", "en"));
  unit.addLabel(new LangString("Megasiemens per Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Conductivity");
  config.units.set("http://qudt.org/vocab/unit/MegaS-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaSEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("1000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Mega",
    "http://qudt.org/vocab/unit/SEC",
    undefined,
    "Ms",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Megasecond", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Period");
  config.units.set("http://qudt.org/vocab/unit/MegaSEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaTOE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("41868000000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Mega",
    "http://qudt.org/vocab/unit/TOE",
    undefined,
    "Mtoe",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Mega Ton of Oil Equivalent", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/MegaTOE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaTON",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("907184740.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Mega",
    "http://qudt.org/vocab/unit/TON",
    undefined,
    "Mtn",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Megaton", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  config.units.set("http://qudt.org/vocab/unit/MegaTON", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaTONNE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("1000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Mega",
    "http://qudt.org/vocab/unit/TONNE",
    undefined,
    "Mt",
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Megatonne", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  config.units.set("http://qudt.org/vocab/unit/MegaTONNE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaTONNE-PER-YR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("31.68808781402895023702689684893655"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Mt/a",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Megatonne per Year", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/MegaTONNE-PER-YR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaV",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-3D0",
    new Decimal("1000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Mega",
    "http://qudt.org/vocab/unit/V",
    undefined,
    "MV",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    5,
    false,
    false
  );
  unit.addLabel(new LangString("Megavolt", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotential"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Voltage");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EnergyPerElectricCharge"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotentialDifference"
  );
  config.units.set("http://qudt.org/vocab/unit/MegaV", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaV-A",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MV·A",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("Megavolt Ampere", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ApparentPower");
  config.units.set("http://qudt.org/vocab/unit/MegaV-A", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaV-A-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("3600000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MV·A·h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("Megavolt Ampere Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/MegaV-A-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaV-A_Reactive",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MV·A{Reactive}",
    undefined,
    undefined,
    undefined,
    [],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("MegaVolt Ampere Reactive", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ReactivePower");
  config.units.set("http://qudt.org/vocab/unit/MegaV-A_Reactive", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaV-A_Reactive-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("3600000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MV·A{Reactive}·h",
    undefined,
    undefined,
    undefined,
    [],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("MegaVolt Ampere Reactive Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/MegaV-A_Reactive-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaV-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L1I0M1H0T-3D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MV/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Megavolt per Meter", "en-US"));
  unit.addLabel(new LangString("Megavolt per Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricFieldStrength"
  );
  config.units.set("http://qudt.org/vocab/unit/MegaV-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaVA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Mega",
    "http://qudt.org/vocab/unit/VA",
    undefined,
    "MVA",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Mega Volt Ampere", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ApparentPower");
  config.units.set("http://qudt.org/vocab/unit/MegaVA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaVA-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("3600000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MVA·h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Mega Volt Ampere Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/MegaVA-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaVAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Mega",
    "http://qudt.org/vocab/unit/VAR",
    undefined,
    "MVA{Reactive}",
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Mega Volt Ampere Reactive", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ReactivePower");
  config.units.set("http://qudt.org/vocab/unit/MegaVAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaVAR-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("3600000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MVA{Reactive}·h",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Mega Volt Ampere Reactive Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/MegaVAR-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaW",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Mega",
    "http://qudt.org/vocab/unit/W",
    undefined,
    "MW",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Megawatt", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/MegaW", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaW-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("3600000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MW·h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Megawatt Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/MegaW-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaYR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("31557600000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Mega",
    "http://qudt.org/vocab/unit/YR",
    undefined,
    "Ma",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Megayear", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/MegaYR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T0D0",
    new Decimal("0.000001"),
    undefined,
    "http://qudt.org/vocab/prefix/Micro",
    "http://qudt.org/vocab/unit/A",
    undefined,
    "μA",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Microampere", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCurrent");
  config.units.set("http://qudt.org/vocab/unit/MicroA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroA-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H-1T0D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μA/K",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Microampere per Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentPerTemperature"
  );
  config.units.set("http://qudt.org/vocab/unit/MicroA-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroATM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("0.101325"),
    undefined,
    "http://qudt.org/vocab/prefix/Micro",
    "http://qudt.org/vocab/unit/ATM",
    undefined,
    "μatm",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Micro Standard Atmosphere", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/MicroATM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroBAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("0.1"),
    undefined,
    "http://qudt.org/vocab/prefix/Micro",
    "http://qudt.org/vocab/unit/BAR",
    undefined,
    "μbar",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Microbar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/MicroBAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroBQ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("0.000001"),
    undefined,
    "http://qudt.org/vocab/prefix/Micro",
    "http://qudt.org/vocab/unit/BQ",
    undefined,
    "μBq",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    2,
    false,
    false
  );
  unit.addLabel(new LangString("Microbecquerel", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Activity");
  config.units.set("http://qudt.org/vocab/unit/MicroBQ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroBQ-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T-1D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μBq/kg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Microbecquerel per Kilogram", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificActivity"
  );
  config.units.set("http://qudt.org/vocab/unit/MicroBQ-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroBQ-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T-1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μBq/L",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Microbecquerel per Liter", "en-US"));
  unit.addLabel(new LangString("Microbecquerel per Litre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ActivityConcentration"
  );
  config.units.set("http://qudt.org/vocab/unit/MicroBQ-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("0.000001"),
    undefined,
    "http://qudt.org/vocab/prefix/Micro",
    "http://qudt.org/vocab/unit/C",
    undefined,
    "μC",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    2,
    false,
    false
  );
  unit.addLabel(new LangString("Microcoulomb", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  config.units.set("http://qudt.org/vocab/unit/MicroC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroC-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H0T1D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μC/m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Microcoulomb per Square Metre", "en"));
  unit.addLabel(new LangString("Microcoulomb per Square Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerArea"
  );
  config.units.set("http://qudt.org/vocab/unit/MicroC-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroC-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-3I0M0H0T1D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μC/m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Microcoulomb per Cubic Meter", "en-US"));
  unit.addLabel(new LangString("Microcoulomb per Cubic Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargeDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/MicroC-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroCI",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("37000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Micro",
    "http://qudt.org/vocab/unit/CI",
    undefined,
    "μCi",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Microcurie", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Activity");
  config.units.set("http://qudt.org/vocab/unit/MicroCI", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroCi",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("37000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Micro",
    "http://qudt.org/vocab/unit/CI",
    undefined,
    "μCi",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("Microcurie", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Activity");
  config.units.set("http://qudt.org/vocab/unit/MicroCi", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroFARAD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-2I0M-1H0T4D0",
    new Decimal("0.000001"),
    undefined,
    "http://qudt.org/vocab/prefix/Micro",
    "http://qudt.org/vocab/unit/FARAD",
    undefined,
    "μF",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    2,
    false,
    false
  );
  unit.addLabel(new LangString("Microfarad", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Capacitance");
  config.units.set("http://qudt.org/vocab/unit/MicroFARAD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroFARAD-PER-KiloM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-3I0M-1H0T4D0",
    new Decimal("1E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μF/km",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Microfarad per Kilometre", "en"));
  unit.addLabel(new LangString("Microfarad per Kilometer", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Permittivity");
  config.units.set("http://qudt.org/vocab/unit/MicroFARAD-PER-KiloM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroFARAD-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-3I0M-1H0T4D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μF/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Microfarad per Meter", "en-US"));
  unit.addLabel(new LangString("Microfarad per Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Permittivity");
  config.units.set("http://qudt.org/vocab/unit/MicroFARAD-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroG",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-2D0",
    new Decimal("0.00000980665"),
    undefined,
    "http://qudt.org/vocab/prefix/Micro",
    "http://qudt.org/vocab/unit/G",
    undefined,
    "μG",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Microgravity", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Acceleration");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearAcceleration"
  );
  config.units.set("http://qudt.org/vocab/unit/MicroG", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroGAL",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    true
  );
  unit.addLabel(new LangString("MicroGAL", undefined));
  config.units.set("http://qudt.org/vocab/unit/MicroGAL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroGAL-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-2D0",
    new Decimal("1E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "µGal/m",
    undefined,
    undefined,
    undefined,
    [],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("MicroGals per Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MicroGAL-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroGALILEO",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    true
  );
  unit.addLabel(new LangString("MicroGALILEO", undefined));
  config.units.set("http://qudt.org/vocab/unit/MicroGALILEO", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroGALILEO-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-2D0",
    new Decimal("1E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "µGal/m",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Microgalileo per metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MicroGALILEO-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("1E-9"),
    undefined,
    "http://qudt.org/vocab/prefix/Micro",
    "http://qudt.org/vocab/unit/GM",
    undefined,
    "μg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    19,
    false,
    false
  );
  unit.addLabel(new LangString("Microgram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  config.units.set("http://qudt.org/vocab/unit/MicroGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroGM-PER-CentiM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    new Decimal("0.00001"),
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    "μg/cm²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Microgram per Square Centimetre", "en"));
  unit.addLabel(new LangString("Microgram per Square Centimeter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerArea");
  config.units.set("http://qudt.org/vocab/unit/MicroGM-PER-CentiM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroGM-PER-CentiM2-WK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-1D0",
    new Decimal("1.653439153439153439153439153439153E-11"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μg/(cm²·wk)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Microgram per Square Centimetre Week", "en"));
  unit.addLabel(
    new LangString("Microgram per Square Centimeter Week", "en-US")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerAreaTime");
  config.units.set("http://qudt.org/vocab/unit/MicroGM-PER-CentiM2-WK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroGM-PER-DeciL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("0.00001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μg/dL",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Microgram per Deciliter", "en-US"));
  unit.addLabel(new LangString("Microgram per Decilitre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  config.units.set("http://qudt.org/vocab/unit/MicroGM-PER-DeciL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroGM-PER-GM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μg/g",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Microgram per Gram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassRatio");
  config.units.set("http://qudt.org/vocab/unit/MicroGM-PER-GM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroGM-PER-GM-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("1.157407407407407407407407407407407E-11"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μg/(g·d)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Microgram per Gram Day", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassSpecificBiogeochemicalRate"
  );
  config.units.set("http://qudt.org/vocab/unit/MicroGM-PER-GM-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroGM-PER-GM-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("2.777777777777777777777777777777778E-10"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μg/(g·h)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Microgram per Gram Hour", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassSpecificBiogeochemicalRate"
  );
  config.units.set("http://qudt.org/vocab/unit/MicroGM-PER-GM-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroGM-PER-IN2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    new Decimal("0.0000015500031000062000124000248000496"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μg/in²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Microgram per Square Inch", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SurfaceDensity");
  config.units.set("http://qudt.org/vocab/unit/MicroGM-PER-IN2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroGM-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μg/kg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Microgram per Kilogram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassRatio");
  config.units.set("http://qudt.org/vocab/unit/MicroGM-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroGM-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μg/L",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Microgram per Liter", "en-US"));
  unit.addLabel(new LangString("Microgram per Litre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassConcentration"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  config.units.set("http://qudt.org/vocab/unit/MicroGM-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroGM-PER-L-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T-1D0",
    new Decimal("1.157407407407407407407407407407407E-11"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μg/(L·d)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Microgram per Liter Day", "en-US"));
  unit.addLabel(new LangString("Microgram per Litre Day", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassConcentrationRateOfChange"
  );
  config.units.set("http://qudt.org/vocab/unit/MicroGM-PER-L-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroGM-PER-L-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T-1D0",
    new Decimal("2.777777777777777777777777777777778E-10"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μg/(L·h)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Microgram per Liter Hour", "en-US"));
  unit.addLabel(new LangString("Microgram per Litre Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MicroGM-PER-L-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroGM-PER-M2-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-1D0",
    new Decimal("1.157407407407407407407407407407407E-14"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μg/(m²·d)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Microgram per Square Metre Day", "en"));
  unit.addLabel(new LangString("Microgram per Square Meter Day", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerAreaTime");
  config.units.set("http://qudt.org/vocab/unit/MicroGM-PER-M2-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroGM-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("1E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μg/m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Microgram per Cubic Metre", "en"));
  unit.addLabel(new LangString("Microgram per Cubic Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  config.units.set("http://qudt.org/vocab/unit/MicroGM-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroGM-PER-M3-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T2D0",
    new Decimal("1E-14"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μg/(m³·bar)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Microgram per Cubic Metre Bar", "en"));
  unit.addLabel(new LangString("Microgram per Cubic Meter Bar", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerEnergy");
  config.units.set("http://qudt.org/vocab/unit/MicroGM-PER-M3-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroGM-PER-M3-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T-1D0",
    new Decimal("2.777777777777777777777777777777778E-13"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μg/(m³·h)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Microgram per Cubic Meter Hour", "en-US"));
  unit.addLabel(new LangString("Microgram per Cubic Metre Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MicroGM-PER-M3-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroGM-PER-M3-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H-1T0D0",
    new Decimal("1E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μg/(m³·K)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Microgram per Cubic Metre Kelvin", "en"));
  unit.addLabel(new LangString("Microgram per Cubic Meter Kelvin", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MicroGM-PER-M3-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroGM-PER-MilliGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μg/mg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Microgram per Milligram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassRatio");
  config.units.set("http://qudt.org/vocab/unit/MicroGM-PER-MilliGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroGM-PER-MilliL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μg/mL",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Microgram per Millilitre", "en"));
  unit.addLabel(new LangString("Microgram per Milliliter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassConcentration"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  config.units.set("http://qudt.org/vocab/unit/MicroGM-PER-MilliL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroGRAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("0.000001"),
    undefined,
    "http://qudt.org/vocab/prefix/Micro",
    "http://qudt.org/vocab/unit/GRAY",
    undefined,
    "μGy",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    3,
    false,
    false
  );
  unit.addLabel(new LangString("Microgray", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AbsorbedDose");
  config.units.set("http://qudt.org/vocab/unit/MicroGRAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroGRAY-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    new Decimal("2.777777777777777777777777777777778E-10"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μGy/h",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Microgray per Hour", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/KermaRate");
  config.units.set("http://qudt.org/vocab/unit/MicroGRAY-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroGRAY-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    new Decimal("1.666666666666666666666666666666667E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μGy/min",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Microgray per Minute", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/KermaRate");
  config.units.set("http://qudt.org/vocab/unit/MicroGRAY-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroGRAY-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μGy/s",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Microgray per Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/KermaRate");
  config.units.set("http://qudt.org/vocab/unit/MicroGRAY-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroH",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H0T-2D0",
    new Decimal("0.000001"),
    undefined,
    "http://qudt.org/vocab/prefix/Micro",
    "http://qudt.org/vocab/unit/H",
    undefined,
    "μH",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    3,
    false,
    false
  );
  unit.addLabel(new LangString("Microhenry", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Inductance");
  config.units.set("http://qudt.org/vocab/unit/MicroH", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroH-PER-KiloOHM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("1E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μH/kΩ",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Microhenry per Kiloohm", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/MicroH-PER-KiloOHM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroH-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L1I0M1H0T-2D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μH/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Microhenry per Meter", "en-US"));
  unit.addLabel(new LangString("Microhenry per Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Permeability");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectromagneticPermeability"
  );
  config.units.set("http://qudt.org/vocab/unit/MicroH-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroH-PER-OHM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μH/Ω",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Microhenry per Ohm", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/MicroH-PER-OHM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("2.54E-8"),
    undefined,
    "http://qudt.org/vocab/prefix/Micro",
    "http://qudt.org/vocab/unit/IN",
    undefined,
    "μin",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Microinch", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Distance");
  config.units.set("http://qudt.org/vocab/unit/MicroIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroJ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("0.000001"),
    new Decimal("0.0"),
    "http://qudt.org/vocab/prefix/Micro",
    "http://qudt.org/vocab/unit/J",
    undefined,
    "μJ",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Micro Joule", "en-US"));
  unit.addLabel(new LangString("Microjoule", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/MicroJ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroJ-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μJ/s",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Microjoule per Second", "en"));
  unit.addLabel(new LangString("Micro Joule per Second", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/MicroJ-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroKAT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T-1D0",
    new Decimal("0.000001"),
    undefined,
    "http://qudt.org/vocab/prefix/Micro",
    "http://qudt.org/vocab/unit/KAT",
    undefined,
    "μkat",
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Microkatal", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CatalyticActivity"
  );
  config.units.set("http://qudt.org/vocab/unit/MicroKAT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroKAT-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T-1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μkat/L",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Microkatal per Liter", "en-US"));
  unit.addLabel(new LangString("Microkatal per Litre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CatalyticActivityConcentration"
  );
  config.units.set("http://qudt.org/vocab/unit/MicroKAT-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("1E-9"),
    undefined,
    "http://qudt.org/vocab/prefix/Micro",
    "http://qudt.org/vocab/unit/L",
    undefined,
    "μL",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    4,
    false,
    false
  );
  unit.addLabel(new LangString("Microliter", "en-US"));
  unit.addLabel(new LangString("Microlitre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/MicroL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroL-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μL/L",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Microlitre per Litre", "en"));
  unit.addLabel(new LangString("Microliter per Liter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFraction");
  config.units.set("http://qudt.org/vocab/unit/MicroL-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("0.000001"),
    undefined,
    "http://qudt.org/vocab/prefix/Micro",
    "http://qudt.org/vocab/unit/M",
    undefined,
    "μm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    18,
    false,
    false
  );
  unit.addLabel(new LangString("Micrometre", "en"));
  unit.addLabel(new LangString("Micrometer", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/MicroM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroM-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H-1T0D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μm/K",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Micrometre per Kelvin", "en"));
  unit.addLabel(new LangString("Micrometer per Kelvin", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearThermalExpansion"
  );
  config.units.set("http://qudt.org/vocab/unit/MicroM-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroM-PER-L-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T-1D0",
    new Decimal("1.157407407407407407407407407407407E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μm/(L·d)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Micrometer per Liter Day", "en-US"));
  unit.addLabel(new LangString("Micrometre per Litre Day", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ParticleFluenceRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Flux");
  config.units.set("http://qudt.org/vocab/unit/MicroM-PER-L-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroM-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μm/m",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Micrometer per Meter", "en-US"));
  unit.addLabel(new LangString("Micrometre per Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Gradient");
  config.units.set("http://qudt.org/vocab/unit/MicroM-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroM-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("1.666666666666666666666666666666667E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μm/min",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Micrometer per Minute", "en-US"));
  unit.addLabel(new LangString("Micrometre per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Speed");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectromagneticWavePhaseSpeed"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/MicroM-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroM-PER-MilliL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μm/mL",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Micrometer per Milliliter", "en-US"));
  unit.addLabel(new LangString("Micrometre per Millilitre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MicroM-PER-MilliL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroM-PER-N",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T2D0",
    new Decimal("0.000001"),
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    "μm/N",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Micrometer per Newton", "en-US"));
  unit.addLabel(new LangString("Micrometre per Newton", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearCompressibility"
  );
  config.units.set("http://qudt.org/vocab/unit/MicroM-PER-N", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroM-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μm/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Micrometre per Second", "en"));
  unit.addLabel(new LangString("Micrometer per Second", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Speed");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectromagneticWavePhaseSpeed"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/MicroM-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroM-PER-SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-2D0",
    new Decimal("0.000001"),
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    "μm/s²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Micrometre per Square Second", "en"));
  unit.addLabel(new LangString("Micrometer per Square Second", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Acceleration");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearAcceleration"
  );
  config.units.set("http://qudt.org/vocab/unit/MicroM-PER-SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    new Decimal("1E-12"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μm²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Micrometre", "en"));
  unit.addLabel(new LangString("Square Micrometer", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/HydraulicPermeability"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Area");
  config.units.set("http://qudt.org/vocab/unit/MicroM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("1E-18"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μm³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Micrometre", "en"));
  unit.addLabel(new LangString("Cubic Micrometer", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/MicroM3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroM3-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1E-18"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μm³/m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Micrometer per Cubic Meter", "en-US"));
  unit.addLabel(new LangString("Cubic Micrometre per Cubic Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFraction");
  config.units.set("http://qudt.org/vocab/unit/MicroM3-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroM3-PER-MilliL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1E-12"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μm³/mL",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Micrometer per Milliliter", "en-US"));
  unit.addLabel(new LangString("Cubic Micrometre per Millilitre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFraction");
  config.units.set("http://qudt.org/vocab/unit/MicroM3-PER-MilliL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroMHO",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-2I0M-1H0T3D0",
    new Decimal("0.000001"),
    undefined,
    "http://qudt.org/vocab/prefix/Micro",
    "http://qudt.org/vocab/unit/MHO",
    undefined,
    "μ℧",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Micromho", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Conductance");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Admittance");
  config.units.set("http://qudt.org/vocab/unit/MicroMHO", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroMOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T0D0",
    new Decimal("0.000001"),
    undefined,
    "http://qudt.org/vocab/prefix/Micro",
    "http://qudt.org/vocab/unit/MOL",
    undefined,
    "μmol",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    20,
    false,
    false
  );
  unit.addLabel(new LangString("Micromole", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstance"
  );
  config.units.set("http://qudt.org/vocab/unit/MicroMOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroMOL-PER-GM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M-1H0T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μmol/g",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Micromole per Gram", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstancePerMass"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/IonicStrength");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MolalityOfSolute"
  );
  config.units.set("http://qudt.org/vocab/unit/MicroMOL-PER-GM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroMOL-PER-GM-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M-1H0T-1D0",
    new Decimal("2.777777777777777777777777777777778E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μmol/(g·h)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Micromole per Gram Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MicroMOL-PER-GM-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroMOL-PER-GM-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M-1H0T-1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μmol/(g·s)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Micromole per Gram Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MicroMOL-PER-GM-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroMOL-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M-1H0T0D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μmol/kg",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Micromole per Kilogram", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstancePerMass"
  );
  config.units.set("http://qudt.org/vocab/unit/MicroMOL-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroMOL-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μmol/L",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Micromole per Litre", "en"));
  unit.addLabel(new LangString("Micromole per Liter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Concentration");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/WaterSolubility");
  config.units.set("http://qudt.org/vocab/unit/MicroMOL-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroMOL-PER-L-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T-1D0",
    new Decimal("2.777777777777777777777777777777778E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μmol/(L·h)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Micromole per Liter Hour", "en-US"));
  unit.addLabel(new LangString("Micromole per Litre Hour", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CatalyticActivityConcentration"
  );
  config.units.set("http://qudt.org/vocab/unit/MicroMOL-PER-L-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroMOL-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-2I0M0H0T0D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μmol/m²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Micromole per Square Meter", "en-US"));
  unit.addLabel(new LangString("Micromole per Square Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MicroMOL-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroMOL-PER-M2-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-2I0M0H0T-1D0",
    new Decimal("1.157407407407407407407407407407407E-11"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μmol/(m²·d)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Micromole per Square Meter Day", "en-US"));
  unit.addLabel(new LangString("Micromole per Square Metre Day", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PhotosyntheticPhotonFluxDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/MicroMOL-PER-M2-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroMOL-PER-M2-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-2I0M0H0T-1D0",
    new Decimal("2.777777777777777777777777777777778E-10"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μmol/(m²·h)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Micromole per Square Meter Hour", "en-US"));
  unit.addLabel(new LangString("Micromole per Square Metre Hour", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PhotosyntheticPhotonFluxDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/MicroMOL-PER-M2-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroMOL-PER-M2-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-2I0M0H0T-1D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μmol/(m²·s)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Micromole per Square Meter Second", "en-US"));
  unit.addLabel(new LangString("Micromole per Square Metre Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PhotosyntheticPhotonFluxDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/MicroMOL-PER-M2-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroMOL-PER-M2-SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-2I0M0H0T-2D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μmol/(m²·s²)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Micromole per Square Meter Square Second", "en-US")
  );
  unit.addLabel(
    new LangString("Micromole per Square Metre Square Second", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MicroMOL-PER-M2-SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroMOL-PER-MOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μmol/mol",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Micromole per Mole", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MicroMOL-PER-MOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroMOL-PER-MicroMOL-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("0.00001157407407407407407407407407407407"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μmol/(μmol·d)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Micromole per Micromole Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set(
    "http://qudt.org/vocab/unit/MicroMOL-PER-MicroMOL-DAY",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroMOL-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T-1D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μmol/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Micromole per Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PhotosyntheticPhotonFlux"
  );
  config.units.set("http://qudt.org/vocab/unit/MicroMOL-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroMOL2-PER-M4-SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A2E0L-4I0M0H0T-2D0",
    new Decimal("1E-12"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μmol²/(m⁴·s²)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Square Micromole per Quartic Metre Square Second", "en")
  );
  unit.addLabel(
    new LangString("Square Micromole per Quartic Meter Square Second", "en-US")
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MolarFluxDensityVariance"
  );
  config.units.set("http://qudt.org/vocab/unit/MicroMOL2-PER-M4-SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("0.000001"),
    undefined,
    "http://qudt.org/vocab/prefix/Micro",
    "http://qudt.org/vocab/unit/N",
    undefined,
    "μN",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    2,
    false,
    false
  );
  unit.addLabel(new LangString("Micronewton", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Force");
  config.units.set("http://qudt.org/vocab/unit/MicroN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroN-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μN·m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Micronewton Meter", "en-US"));
  unit.addLabel(new LangString("Micronewton Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MomentOfForce");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Torque");
  config.units.set("http://qudt.org/vocab/unit/MicroN-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroN-M-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μN·m/m²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Micronewton Meter per Square Meter", "en-US"));
  unit.addLabel(new LangString("Micronewton Metre per Square Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerLength");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyPerArea");
  config.units.set("http://qudt.org/vocab/unit/MicroN-M-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroOHM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H0T-3D0",
    new Decimal("0.000001"),
    undefined,
    "http://qudt.org/vocab/prefix/Micro",
    "http://qudt.org/vocab/unit/OHM",
    undefined,
    "μΩ",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Microohm", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Resistance");
  config.units.set("http://qudt.org/vocab/unit/MicroOHM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroOHM-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L3I0M1H0T-3D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μΩ·m",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Microohm Metre", "en"));
  unit.addLabel(new LangString("Microohm Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Resistivity");
  config.units.set("http://qudt.org/vocab/unit/MicroOHM-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroPA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("0.000001"),
    undefined,
    "http://qudt.org/vocab/prefix/Micro",
    "http://qudt.org/vocab/unit/PA",
    undefined,
    "μPa",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Micropascal", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ModulusOfElasticity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ShearModulus");
  config.units.set("http://qudt.org/vocab/unit/MicroPA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroPOISE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-1D0",
    new Decimal("1E-7"),
    undefined,
    "http://qudt.org/vocab/prefix/Micro",
    "http://qudt.org/vocab/unit/POISE",
    undefined,
    "μP",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-GAUSS", "http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Micropoise", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DynamicViscosity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Viscosity");
  config.units.set("http://qudt.org/vocab/unit/MicroPOISE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroRAD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.000001"),
    undefined,
    "http://qudt.org/vocab/prefix/Micro",
    "http://qudt.org/vocab/unit/RAD",
    undefined,
    "μrad",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Microradian", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PlaneAngle");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Angle");
  config.units.set("http://qudt.org/vocab/unit/MicroRAD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroS",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-2I0M-1H0T3D0",
    new Decimal("0.000001"),
    undefined,
    "http://qudt.org/vocab/prefix/Micro",
    "http://qudt.org/vocab/unit/S",
    undefined,
    "μS",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    3,
    false,
    false
  );
  unit.addLabel(new LangString("Microsiemens", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Conductance");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Admittance");
  config.units.set("http://qudt.org/vocab/unit/MicroS", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroS-PER-CentiM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-3I0M-1H0T3D0",
    new Decimal("0.0001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μS/cm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Microsiemens per Centimetre", "en"));
  unit.addLabel(new LangString("Microsiemens per Centimeter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectrolyticConductivity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Conductivity");
  config.units.set("http://qudt.org/vocab/unit/MicroS-PER-CentiM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroS-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-3I0M-1H0T3D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μS/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Microsiemens per Meter", "en-US"));
  unit.addLabel(new LangString("Microsiemens per Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Conductivity");
  config.units.set("http://qudt.org/vocab/unit/MicroS-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroS2-PER-CentiM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E4L-6I0M-2H0T6D0",
    new Decimal("1E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μS²/cm²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Square Microsiemens per Square Centimetre", "en")
  );
  unit.addLabel(
    new LangString("Square Microsiemens per Square Centimeter", "en-US")
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ConductivityVariance"
  );
  config.units.set("http://qudt.org/vocab/unit/MicroS2-PER-CentiM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroSEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("0.000001"),
    undefined,
    "http://qudt.org/vocab/prefix/Micro",
    "http://qudt.org/vocab/unit/SEC",
    undefined,
    "μs",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Microsecond", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/MicroSEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroSV",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("0.000001"),
    undefined,
    "http://qudt.org/vocab/prefix/Micro",
    "http://qudt.org/vocab/unit/SV",
    undefined,
    "μSv",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    3,
    false,
    false
  );
  unit.addLabel(new LangString("Microsievert", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DoseEquivalent");
  config.units.set("http://qudt.org/vocab/unit/MicroSV", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroSV-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    new Decimal("2.777777777777777777777777777777778E-10"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μSv/h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Microsievert per Hour", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate"
  );
  config.units.set("http://qudt.org/vocab/unit/MicroSV-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroSV-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    new Decimal("1.666666666666666666666666666666667E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μSv/min",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Microsievert per Minute", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/KermaRate");
  config.units.set("http://qudt.org/vocab/unit/MicroSV-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroSV-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μSv/s",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Microsievert per Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/KermaRate");
  config.units.set("http://qudt.org/vocab/unit/MicroSV-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L0I0M1H0T-2D0",
    new Decimal("0.000001"),
    undefined,
    "http://qudt.org/vocab/prefix/Micro",
    "http://qudt.org/vocab/unit/T",
    undefined,
    "μT",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Microtesla", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticFluxDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/MicroT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroTORR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("0.000133322"),
    undefined,
    "http://qudt.org/vocab/prefix/Micro",
    "http://qudt.org/vocab/unit/TORR",
    undefined,
    "μTorr",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Microtorr", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/MicroTORR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroV",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-3D0",
    new Decimal("0.000001"),
    undefined,
    "http://qudt.org/vocab/prefix/Micro",
    "http://qudt.org/vocab/unit/V",
    undefined,
    "μV",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    5,
    false,
    false
  );
  unit.addLabel(new LangString("Microvolt", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotential"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Voltage");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EnergyPerElectricCharge"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotentialDifference"
  );
  config.units.set("http://qudt.org/vocab/unit/MicroV", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroV-A",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μV·A",
    undefined,
    undefined,
    undefined,
    [],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("Microvolt Ampere", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ApparentPower");
  config.units.set("http://qudt.org/vocab/unit/MicroV-A", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroV-A-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H-1T-3D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μV·A/K",
    undefined,
    undefined,
    undefined,
    [],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("Microvolt Ampere per Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalConductance"
  );
  config.units.set("http://qudt.org/vocab/unit/MicroV-A-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroV-A_Reactive",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "µV·A{Reactive}",
    undefined,
    undefined,
    undefined,
    [],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("MicroVolt Ampere Reactive", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ReactivePower");
  config.units.set("http://qudt.org/vocab/unit/MicroV-A_Reactive", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroV-A_Reactive-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L-2I0M1H-1T-3D0",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "µvar/K",
    undefined,
    undefined,
    undefined,
    [],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("MicroVolt Ampere Reactive per Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MicroV-A_Reactive-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroV-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L1I0M1H0T-3D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μV/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Microvolt per Metre", "en"));
  unit.addLabel(new LangString("Microvolt per Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricFieldStrength"
  );
  config.units.set("http://qudt.org/vocab/unit/MicroV-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroVA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("0.000001"),
    undefined,
    "http://qudt.org/vocab/prefix/Micro",
    "http://qudt.org/vocab/unit/VA",
    undefined,
    "μVA",
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Micro Volt Ampere", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ApparentPower");
  config.units.set("http://qudt.org/vocab/unit/MicroVA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroVA-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H-1T-3D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μVA/K",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Micro Volt Ampere per Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalConductance"
  );
  config.units.set("http://qudt.org/vocab/unit/MicroVA-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroVAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("0.000001"),
    undefined,
    "http://qudt.org/vocab/prefix/Micro",
    "http://qudt.org/vocab/unit/VAR",
    undefined,
    "μVA{Reactive}",
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Micro Volt Ampere Reactive", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ReactivePower");
  config.units.set("http://qudt.org/vocab/unit/MicroVAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroVAR-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H-1T-3D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μVA{Reactive}/K",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Micro Volt Ampere Reactive per Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MicroVAR-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroW",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("0.000001"),
    undefined,
    "http://qudt.org/vocab/prefix/Micro",
    "http://qudt.org/vocab/unit/W",
    undefined,
    "μW",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    2,
    false,
    false
  );
  unit.addLabel(new LangString("Microwatt", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/MicroW", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroW-PER-CentiM2-MicroM-SR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-3D0",
    new Decimal("10000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μW/(cm²·μm·sr)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Microwatt per Square Centimetre Micrometre Steradian", "en")
  );
  unit.addLabel(
    new LangString(
      "Microwatt per Square Centimeter Micrometer Steradian",
      "en-US"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpectralRadiance"
  );
  config.units.set(
    "http://qudt.org/vocab/unit/MicroW-PER-CentiM2-MicroM-SR",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroW-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μW/m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Microwatt per Square Meter", "en-US"));
  unit.addLabel(new LangString("Microwatt per Square Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PowerPerArea");
  config.units.set("http://qudt.org/vocab/unit/MicroW-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilLength",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("0.0000254"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M",
    undefined,
    "mil",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Mil Length", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/MilLength", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T0D0",
    new Decimal("0.001"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/A",
    undefined,
    "mA",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    10,
    false,
    false
  );
  unit.addLabel(new LangString("Milliampere", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCurrent");
  config.units.set("http://qudt.org/vocab/unit/MilliA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliA-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("3.6"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mA·h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milliampere Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/BatteryCapacity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  config.units.set("http://qudt.org/vocab/unit/MilliA-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliA-HR-PER-GM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M-1H0T1D0",
    new Decimal("3600.0"),
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    "mA·h/g",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milliampere Hour per Gram", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificElectricCharge"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliA-HR-PER-GM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliA-IN2-PER-LB_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L1I0M-1H0T2D0",
    new Decimal("1.450377312227268702148557236386593E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mA·in²/lbf",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Milliampere Square Inch per Pound Force", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliA-IN2-PER-LB_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliA-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L1I0M-1H0T2D0",
    new Decimal("1E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mA/bar",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milliampere per Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliA-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliA-PER-IN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-1I0M0H0T0D0",
    new Decimal("0.03937007874015748031496062992125984"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mA/in",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milliampere per Inch", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearElectricCurrentDensity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticFieldStrength"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliA-PER-IN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliA-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H-1T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mA/K",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milliampere per Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentPerTemperature"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliA-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliA-PER-L-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-3I0M0H0T-1D0",
    new Decimal("0.01666666666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mA/(L·min)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milliampere per Liter Minute", "en-US"));
  unit.addLabel(new LangString("Milliampere per Litre Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliA-PER-L-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliA-PER-LB_F-IN2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-3I0M-1H0T2D0",
    new Decimal("0.3484545430793798050380935091957634"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mA/(lbf·in²)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Milliampere per Pound Force Square Inch", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliA-PER-LB_F-IN2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliA-PER-MilliM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-1I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mA/mm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milliampere per Millimetre", "en"));
  unit.addLabel(new LangString("Milliampere per Millimeter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearElectricCurrentDensity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticFieldStrength"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliA-PER-MilliM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliA-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mA·s",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milliampere Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  config.units.set("http://qudt.org/vocab/unit/MilliA-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliARCSEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("4.84813681E-9"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/ARCSEC",
    undefined,
    "mas",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milliarcsecond", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PlaneAngle");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Angle");
  config.units.set("http://qudt.org/vocab/unit/MilliARCSEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliBAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("100.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/BAR",
    undefined,
    "mbar",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    4,
    false,
    false
  );
  unit.addLabel(new LangString("Millibar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/MilliBAR_A");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/HectoPA");
  config.units.set("http://qudt.org/vocab/unit/MilliBAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliBAR-L-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("0.1"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mbar·L/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millibar Liter per Second", "en-US"));
  unit.addLabel(new LangString("Millibar Litre per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/MilliBAR-L-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliBAR-M3-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("100.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mbar·m³/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millibar Cubic Meter per Second", "en-US"));
  unit.addLabel(new LangString("Millibar Cubic Metre per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/MilliBAR-M3-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliBAR-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mbar/bar",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millibar per Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PressureRatio");
  config.units.set("http://qudt.org/vocab/unit/MilliBAR-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliBAR-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H-1T-2D0",
    new Decimal("100.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mbar/K",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millibar per Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/VolumetricHeatCapacity"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliBAR-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliBAR_A",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("100.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/BAR_A",
    undefined,
    "mbar abs",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milli Bar Absolute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/MilliBAR");
  config.units.set("http://qudt.org/vocab/unit/MilliBAR_A", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliBQ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("0.001"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/BQ",
    undefined,
    "mBq",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    4,
    false,
    false
  );
  unit.addLabel(new LangString("Millibecquerel", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Activity");
  config.units.set("http://qudt.org/vocab/unit/MilliBQ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliBQ-PER-GM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mBq/g",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millibecquerel per Gram", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificActivity"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliBQ-PER-GM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliBQ-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T-1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mBq/kg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millibecquerel per Kilogram", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificActivity"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliBQ-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliBQ-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mBq/L",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millibecquerel per Litre", "en"));
  unit.addLabel(new LangString("Millibecquerel per Liter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ActivityConcentration"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliBQ-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliBQ-PER-M2-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T-2D0",
    new Decimal("1.157407407407407407407407407407407E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mBq/(m²·d)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millibecquerel per Square Metre Day", "en"));
  unit.addLabel(new LangString("Millibecquerel per Square Meter Day", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliBQ-PER-M2-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("0.001"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/C",
    undefined,
    "mC",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    3,
    false,
    false
  );
  unit.addLabel(new LangString("Millicoulomb", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  config.units.set("http://qudt.org/vocab/unit/MilliC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliC-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M-1H0T1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mC/kg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millicoulomb per Kilogram", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerMass"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliC-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliC-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H0T1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mC/m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millicoulomb per Square Meter", "en-US"));
  unit.addLabel(new LangString("Millicoulomb per Square Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerArea"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliC-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliC-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-3I0M0H0T1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mC/m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millicoulomb per Cubic Metre", "en"));
  unit.addLabel(new LangString("Millicoulomb per Cubic Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargeVolumeDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliC-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliCD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I1M0H0T0D0",
    new Decimal("0.001"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/CD",
    undefined,
    "mcd",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millicandela", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LuminousIntensity"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliCD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliCI",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("37000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/CI",
    undefined,
    "mCi",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millicurie", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Activity");
  config.units.set("http://qudt.org/vocab/unit/MilliCI", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliCi",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("37000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/CI",
    undefined,
    "mCi",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("Millicurie", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Activity");
  config.units.set("http://qudt.org/vocab/unit/MilliCi", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliDARCY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    new Decimal("9.869233E-16"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/DARCY",
    undefined,
    "md",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI", "http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millidarcy", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/HydraulicPermeability"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliDARCY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliDEG_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T0D0",
    new Decimal("0.001"),
    new Decimal("273150.0"),
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/DEG_C",
    undefined,
    "m°C",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI", "http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milli Degree Celsius", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MeltingPoint");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/BoilingPoint");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Temperature");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/FlashPoint");
  config.units.set("http://qudt.org/vocab/unit/MilliDEG_C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliFARAD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-2I0M-1H0T4D0",
    new Decimal("0.001"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/FARAD",
    undefined,
    "mF",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millifarad", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Capacitance");
  config.units.set("http://qudt.org/vocab/unit/MilliFARAD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliG",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-2D0",
    new Decimal("0.00980665"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/G",
    undefined,
    "mG",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milligravity", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Acceleration");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearAcceleration"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliG", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGAL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-2D0",
    new Decimal("0.00001"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/GALILEO",
    undefined,
    "mgal",
    undefined,
    undefined,
    undefined,
    [],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("Milligalileo", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Acceleration");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearAcceleration"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliGAL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGAL-PER-MO",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-3D0",
    new Decimal("3.919350772901616281311709002114104E-12"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mgal/mo",
    undefined,
    undefined,
    undefined,
    [],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("Milligalileo per Month", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGAL-PER-MO", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGALILEO",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-2D0",
    new Decimal("0.00001"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/GALILEO",
    undefined,
    "mGal",
    undefined,
    undefined,
    undefined,
    [],
    2,
    false,
    false
  );
  unit.addLabel(new LangString("Milligalileo", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Acceleration");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearAcceleration"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliGALILEO", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGALILEO-PER-MO",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-3D0",
    new Decimal("3.919350772901616281311709002114104E-12"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mGal/mo",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milligalileo per Month", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGALILEO-PER-MO", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("0.000001"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/GM",
    undefined,
    "mg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    68,
    false,
    false
  );
  unit.addLabel(new LangString("Milligram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  config.units.set("http://qudt.org/vocab/unit/MilliGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-HR-PER-L-CentiM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("3600000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg·h/(L·cm³)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Milligram Hour per Litre Cubic Centimetre", "en")
  );
  unit.addLabel(
    new LangString("Milligram Hour per Liter Cubic Centimeter", "en-US")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-HR-PER-L-CentiM3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-HR-PER-L-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("3.6"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg·h/(L·m³)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Milligram Hour per Liter Cubic Meter", "en-US")
  );
  unit.addLabel(new LangString("Milligram Hour per Litre Cubic Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-HR-PER-L-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-HR-PER-L2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("3600.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg·h/L²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milligram Hour per Square Liter", "en-US"));
  unit.addLabel(new LangString("Milligram Hour per Square Litre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-HR-PER-L2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-HR-PER-M3-CentiM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("3600.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg·h/(m³·cm³)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Milligram Hour per Cubic Meter Cubic Centimeter", "en-US")
  );
  unit.addLabel(
    new LangString("Milligram Hour per Cubic Metre Cubic Centimetre", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set(
    "http://qudt.org/vocab/unit/MilliGM-HR-PER-M3-CentiM3",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-HR-PER-M3-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("3.6"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg·h/(m³·L)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milligram Hour per Cubic Metre Litre", "en"));
  unit.addLabel(
    new LangString("Milligram Hour per Cubic Meter Liter", "en-US")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-HR-PER-M3-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-HR-PER-M6",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("0.0036"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg·h/m⁶",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milligram Hour per Sextic Meter", "en-US"));
  unit.addLabel(new LangString("Milligram Hour per Sextic Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-HR-PER-M6", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-MIN-PER-L-CentiM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("60000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg·min/(L·cm³)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Milligram Minute per Liter Cubic Centimeter", "en-US")
  );
  unit.addLabel(
    new LangString("Milligram Minute per Litre Cubic Centimetre", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set(
    "http://qudt.org/vocab/unit/MilliGM-MIN-PER-L-CentiM3",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-MIN-PER-L-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("0.06"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg·min/(L·m³)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Milligram Minute per Liter Cubic Meter", "en-US")
  );
  unit.addLabel(new LangString("Milligram Minute per Litre Cubic Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-MIN-PER-L-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-MIN-PER-L2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("60.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg·min/L²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milligram Minute per Square Liter", "en-US"));
  unit.addLabel(new LangString("Milligram Minute per Square Litre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-MIN-PER-L2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-MIN-PER-M3-CentiM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("60.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg·min/(m³·cm³)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Milligram Minute per Cubic Meter Cubic Centimeter", "en-US")
  );
  unit.addLabel(
    new LangString("Milligram Minute per Cubic Metre Cubic Centimetre", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set(
    "http://qudt.org/vocab/unit/MilliGM-MIN-PER-M3-CentiM3",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-MIN-PER-M3-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("0.06"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg·min/(m³·L)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milligram Minute per Cubic Metre Litre", "en"));
  unit.addLabel(
    new LangString("Milligram Minute per Cubic Meter Liter", "en-US")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-MIN-PER-M3-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-MIN-PER-M6",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("0.00006"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg·min/m⁶",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milligram Minute per Sextic Meter", "en-US"));
  unit.addLabel(new LangString("Milligram Minute per Sextic Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-MIN-PER-M6", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T2D0",
    new Decimal("1E-11"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/bar",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milligram per Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-CentiM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/cm²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milligram per Square Centimeter", "en-US"));
  unit.addLabel(new LangString("Milligram per Square Centimetre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerArea");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-CentiM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("1.157407407407407407407407407407407E-11"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/d",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milligram per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-DAY-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T1D0",
    new Decimal("1.157407407407407407407407407407407E-16"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/(d·bar)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milligram per Day Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-DAY-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-DAY-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-1D0",
    new Decimal("1.157407407407407407407407407407407E-11"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/(d·K)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milligram per Day Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-DAY-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-DeciL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/dL",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milligram per Decilitre", "en"));
  unit.addLabel(new LangString("Milligram per Deciliter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassBasedBloodGlucoseLevel"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-DeciL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-DeciM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    new Decimal("0.0001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/dm²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milligram per Square Decimeter", "en-US"));
  unit.addLabel(new LangString("Milligram per Square Decimetre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerArea");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-DeciM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-GM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/g",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milligram per Gram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassRatio");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-GM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-GM-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("2.777777777777777777777777777777778E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/(g·h)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milligram per Gram Hour", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassSpecificBiogeochemicalRate"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-GM-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-HA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    new Decimal("1E-10"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/ha",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milligram per Hectare", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerArea");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-HA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("2.777777777777777777777777777777778E-10"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milligram per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-HR-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T1D0",
    new Decimal("2.777777777777777777777777777777778E-15"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/(h·bar)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milligram per Hour Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-HR-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-HR-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-1D0",
    new Decimal("2.777777777777777777777777777777778E-10"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/(h·K)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milligram per Hour Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-HR-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T0D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/K",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milligram per Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/kg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milligram per Kilogram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassRatio");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-KiloGM-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("1.157407407407407407407407407407407E-11"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/(kg·d)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milligram per Kilogram Day", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassSpecificBiogeochemicalRate"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-KiloGM-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/L",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milligram per Liter", "en-US"));
  unit.addLabel(new LangString("Milligram per Litre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassConcentration"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-L-CentiPOISE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/(L·cP)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milligram per Liter Centipoise", "en-US"));
  unit.addLabel(new LangString("Milligram per Litre Centipoise", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-L-CentiPOISE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-L-MilliPA-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/(L·mPa·s)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milligram per Litre Millipascal Second", "en"));
  unit.addLabel(
    new LangString("Milligram per Liter Millipascal Second", "en-US")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set(
    "http://qudt.org/vocab/unit/MilliGM-PER-L-MilliPA-SEC",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-L-PA-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/(L·Pa·s)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milligram per Litre Pascal Second", "en"));
  unit.addLabel(new LangString("Milligram per Liter Pascal Second", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-L-PA-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-L-POISE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/(L·P)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milligram per Litre Poise", "en"));
  unit.addLabel(new LangString("Milligram per Liter Poise", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-L-POISE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T0D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milligram per Metre", "en"));
  unit.addLabel(new LangString("Milligram per Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerLength");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milligram per Square Meter", "en-US"));
  unit.addLabel(new LangString("Milligram per Square Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerArea");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-M2-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-1D0",
    new Decimal("1.157407407407407407407407407407407E-11"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/(m²·d)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milligram per Square Meter Day", "en-US"));
  unit.addLabel(new LangString("Milligram per Square Metre Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerAreaTime");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-M2-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-M2-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-1D0",
    new Decimal("2.777777777777777777777777777777778E-10"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/(m²·h)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milligram per Square Meter Hour", "en-US"));
  unit.addLabel(new LangString("Milligram per Square Metre Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerAreaTime");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-M2-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-M2-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-1D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/(m²·s)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milligram per Square Metre Second", "en"));
  unit.addLabel(new LangString("Milligram per Square Meter Second", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerAreaTime");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-M2-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milligram per Cubic Metre", "en"));
  unit.addLabel(new LangString("Milligram per Cubic Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassConcentration"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-M3-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T2D0",
    new Decimal("1E-11"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/(m³·bar)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milligram per Cubic Metre Bar", "en"));
  unit.addLabel(new LangString("Milligram per Cubic Meter Bar", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerEnergy");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-M3-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-M3-CentiPOISE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/(m³·cP)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milligram per Cubic Metre Centipoise", "en"));
  unit.addLabel(
    new LangString("Milligram per Cubic Meter Centipoise", "en-US")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set(
    "http://qudt.org/vocab/unit/MilliGM-PER-M3-CentiPOISE",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-M3-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T-1D0",
    new Decimal("1.157407407407407407407407407407407E-11"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/(m³·d)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milligram per Cubic Meter Day", "en-US"));
  unit.addLabel(new LangString("Milligram per Cubic Metre Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-M3-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-M3-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T-1D0",
    new Decimal("2.777777777777777777777777777777778E-10"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/(m³·h)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milligram per Cubic Metre Hour", "en"));
  unit.addLabel(new LangString("Milligram per Cubic Meter Hour", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-M3-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-M3-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H-1T0D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/(m³·K)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milligram per Cubic Meter Kelvin", "en-US"));
  unit.addLabel(new LangString("Milligram per Cubic Metre Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-M3-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-M3-MilliPA-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/(m³·mPa·s)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Milligram per Cubic Meter Millipascal Second", "en-US")
  );
  unit.addLabel(
    new LangString("Milligram per Cubic Metre Millipascal Second", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set(
    "http://qudt.org/vocab/unit/MilliGM-PER-M3-MilliPA-SEC",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-M3-PA-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/(m³·Pa·s)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Milligram per Cubic Meter Pascal Second", "en-US")
  );
  unit.addLabel(
    new LangString("Milligram per Cubic Metre Pascal Second", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-M3-PA-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-M3-POISE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal("0.00001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/(m³·P)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milligram per Cubic Metre Poise", "en"));
  unit.addLabel(new LangString("Milligram per Cubic Meter Poise", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-M3-POISE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-M3-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T-1D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/(m³·s)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milligram per Cubic Meter Second", "en-US"));
  unit.addLabel(new LangString("Milligram per Cubic Metre Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-M3-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("1.666666666666666666666666666666667E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/min",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milligram per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-MIN-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T1D0",
    new Decimal("1.666666666666666666666666666666667E-13"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/(min·bar)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milligram per Minute Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-MIN-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-MIN-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-1D0",
    new Decimal("1.666666666666666666666666666666667E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/(min·K)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milligram per Minute Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-MIN-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-MilliL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/mL",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milligram per Millilitre", "en"));
  unit.addLabel(new LangString("Milligram per Milliliter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassConcentration"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-MilliL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milligram per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-SEC-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T1D0",
    new Decimal("1E-11"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/(s·bar)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milligram per Second Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-SEC-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-SEC-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-1D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/(s·K)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milligram per Second Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-SEC-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-SEC-PER-L-CentiM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg·s/(L·cm³)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Milligram Second per Litre Cubic Centimetre", "en")
  );
  unit.addLabel(
    new LangString("Milligram Second per Liter Cubic Centimeter", "en-US")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set(
    "http://qudt.org/vocab/unit/MilliGM-SEC-PER-L-CentiM3",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-SEC-PER-L-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg·s/(L·m³)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milligram Second per Litre Cubic Metre", "en"));
  unit.addLabel(
    new LangString("Milligram Second per Liter Cubic Meter", "en-US")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-SEC-PER-L-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-SEC-PER-L2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg·s/L²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milligram Second per Square Litre", "en"));
  unit.addLabel(new LangString("Milligram Second per Square Liter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-SEC-PER-L2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-SEC-PER-M3-CentiM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg·s/(m³·cm³)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Milligram Second per Cubic Meter Cubic Centimeter", "en-US")
  );
  unit.addLabel(
    new LangString("Milligram Second per Cubic Metre Cubic Centimetre", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set(
    "http://qudt.org/vocab/unit/MilliGM-SEC-PER-M3-CentiM3",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-SEC-PER-M3-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg·s/(m³·L)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milligram Second per Cubic Metre Litre", "en"));
  unit.addLabel(
    new LangString("Milligram Second per Cubic Meter Liter", "en-US")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-SEC-PER-M3-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-SEC-PER-M6",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg·s/m⁶",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milligram Second per Sextic Metre", "en"));
  unit.addLabel(new LangString("Milligram Second per Sextic Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-SEC-PER-M6", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGRAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("0.001"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/GRAY",
    undefined,
    "mGy",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    3,
    false,
    false
  );
  unit.addLabel(new LangString("Milligray", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AbsorbedDose");
  config.units.set("http://qudt.org/vocab/unit/MilliGRAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGRAY-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    new Decimal("2.777777777777777777777777777777778E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mGy/h",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milligray per Hour", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/KermaRate");
  config.units.set("http://qudt.org/vocab/unit/MilliGRAY-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGRAY-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    new Decimal("0.00001666666666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mGy/min",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milligray per Minute", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/KermaRate");
  config.units.set("http://qudt.org/vocab/unit/MilliGRAY-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGRAY-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mGy/s",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milligray per Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/KermaRate");
  config.units.set("http://qudt.org/vocab/unit/MilliGRAY-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliH",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H0T-2D0",
    new Decimal("0.001"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/H",
    undefined,
    "mH",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    2,
    false,
    false
  );
  unit.addLabel(new LangString("Millihenry", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Inductance");
  config.units.set("http://qudt.org/vocab/unit/MilliH", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliH-PER-KiloOHM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mH/kΩ",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millihenry per Kiloohm", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/MilliH-PER-KiloOHM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliH-PER-OHM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mH/Ω",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millihenry per Ohm", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/MilliH-PER-OHM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliHZ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("0.001"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/HZ",
    undefined,
    "mHz",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millihertz", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Frequency");
  config.units.set("http://qudt.org/vocab/unit/MilliHZ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("0.0000254"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/IN",
    undefined,
    "mil",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milliinch", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/MilliIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliJ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("0.001"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/J",
    undefined,
    "mJ",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    3,
    false,
    false
  );
  unit.addLabel(new LangString("Millijoule", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/MilliJ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliJ-PER-GM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mJ/g",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millijoule per Gram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificEnergy");
  config.units.set("http://qudt.org/vocab/unit/MilliJ-PER-GM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliJ-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mJ/m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millijoule per Square Meter", "en-US"));
  unit.addLabel(new LangString("Millijoule per Square Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyPerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/RadiantFluence");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/StrainEnergyReleaseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyFluence");
  config.units.set("http://qudt.org/vocab/unit/MilliJ-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliJ-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mJ/s",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millijoule per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/MilliJ-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T0D0",
    new Decimal("0.001"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/K",
    undefined,
    "mK",
    undefined,
    undefined,
    undefined,
    [],
    2,
    false,
    false
  );
  unit.addLabel(new LangString("Millikelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MeltingPoint");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermodynamicTemperature"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/BoilingPoint");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Temperature");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CorrelatedColorTemperature"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/FlashPoint");
  config.units.set("http://qudt.org/vocab/unit/MilliK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliK-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H1T2D0",
    new Decimal("1E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mK/bar",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millikelvin per Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliK-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliK-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mK/K",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millikelvin per Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TemperatureRatio"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliK-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliKAT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T-1D0",
    new Decimal("0.001"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/KAT",
    undefined,
    "mkat",
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Millikatal", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CatalyticActivity"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliKAT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliKAT-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mkat/L",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millikatal per Liter", "en-US"));
  unit.addLabel(new LangString("Millikatal per Litre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CatalyticActivityConcentration"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliKAT-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.000001"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/L",
    undefined,
    "mL",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    33,
    false,
    false
  );
  unit.addLabel(new LangString("Millilitre", "en"));
  unit.addLabel(new LangString("Milliliter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/MilliL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliL-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M-1H0T2D0",
    new Decimal("1E-11"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mL/bar",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millilitre per Bar", "en"));
  unit.addLabel(new LangString("Milliliter per Bar", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliL-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliL-PER-CentiM2-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("0.0001666666666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mL/(cm²·min)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Millilitre per Square Centimetre Minute", "en")
  );
  unit.addLabel(
    new LangString("Milliliter per Square Centimeter Minute", "en-US")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumetricFlux");
  config.units.set("http://qudt.org/vocab/unit/MilliL-PER-CentiM2-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliL-PER-CentiM2-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mL/(cm²·s)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Millilitre per Square Centimetre Second", "en")
  );
  unit.addLabel(
    new LangString("Milliliter per Square Centimeter Second", "en-US")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumetricFlux");
  config.units.set("http://qudt.org/vocab/unit/MilliL-PER-CentiM2-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliL-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("1.157407407407407407407407407407407E-11"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mL/d",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milliliter per Day", "en-US"));
  unit.addLabel(new LangString("Millilitre per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/MilliL-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliL-PER-DAY-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M-1H0T1D0",
    new Decimal("1.157407407407407407407407407407407E-16"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mL/(d·bar)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millilitre per Day Bar", "en"));
  unit.addLabel(new LangString("Milliliter per Day Bar", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliL-PER-DAY-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliL-PER-DAY-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H-1T-1D0",
    new Decimal("1.157407407407407407407407407407407E-11"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mL/(d·K)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millilitre per Day Kelvin", "en"));
  unit.addLabel(new LangString("Milliliter per Day Kelvin", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliL-PER-DAY-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliL-PER-GM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M-1H0T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mL/g",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milliliter per Gram", "en-US"));
  unit.addLabel(new LangString("Millilitre per Gram", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoilAdsorptionCoefficient"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificVolume");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/CentiM3-PER-GM");
  config.units.set("http://qudt.org/vocab/unit/MilliL-PER-GM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliL-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("2.777777777777777777777777777777778E-10"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mL/h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milliliter per Hour", "en-US"));
  unit.addLabel(new LangString("Millilitre per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/MilliL-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliL-PER-HR-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M-1H0T1D0",
    new Decimal("2.777777777777777777777777777777778E-15"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mL/(h·bar)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milliliter per Hour Bar", "en-US"));
  unit.addLabel(new LangString("Millilitre per Hour Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliL-PER-HR-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliL-PER-HR-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H-1T-1D0",
    new Decimal("2.777777777777777777777777777777778E-10"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mL/(h·K)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milliliter per Hour Kelvin", "en-US"));
  unit.addLabel(new LangString("Millilitre per Hour Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliL-PER-HR-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliL-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H-1T0D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mL/K",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milliliter per Kelvin", "en-US"));
  unit.addLabel(new LangString("Millilitre per Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/VolumeThermalExpansion"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliL-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliL-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M-1H0T0D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mL/kg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millilitre per Kilogram", "en"));
  unit.addLabel(new LangString("Milliliter per Kilogram", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificVolume");
  config.units.set("http://qudt.org/vocab/unit/MilliL-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliL-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mL/L",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millilitre per Litre", "en"));
  unit.addLabel(new LangString("Milliliter per Liter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFraction");
  config.units.set("http://qudt.org/vocab/unit/MilliL-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliL-PER-M2-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("1.157407407407407407407407407407407E-11"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mL/(m²·d)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millilitre per Square Metre Day", "en"));
  unit.addLabel(new LangString("Milliliter per Square Meter Day", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliL-PER-M2-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliL-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mL/m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milliliter per Cubic Meter", "en-US"));
  unit.addLabel(new LangString("Millilitre per Cubic Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFraction");
  config.units.set("http://qudt.org/vocab/unit/MilliL-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliL-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("1.666666666666666666666666666666667E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mL/min",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milliliter per Minute", "en-US"));
  unit.addLabel(new LangString("Millilitre per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/MilliL-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliL-PER-MIN-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M-1H0T1D0",
    new Decimal("1.666666666666666666666666666666667E-13"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mL/(min·bar)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millilitre per Minute Bar", "en"));
  unit.addLabel(new LangString("Milliliter per Minute Bar", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliL-PER-MIN-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliL-PER-MIN-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H-1T-1D0",
    new Decimal("1.666666666666666666666666666666667E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mL/(min·K)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millilitre per Minute Kelvin", "en"));
  unit.addLabel(new LangString("Milliliter per Minute Kelvin", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliL-PER-MIN-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliL-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mL/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millilitre per Second", "en"));
  unit.addLabel(new LangString("Milliliter per Second", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/MilliL-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliL-PER-SEC-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M-1H0T1D0",
    new Decimal("1E-11"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mL/(s·bar)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milliliter per Second Bar", "en-US"));
  unit.addLabel(new LangString("Millilitre per Second Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliL-PER-SEC-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliL-PER-SEC-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H-1T-1D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mL/(s·K)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milliliter per Second Kelvin", "en-US"));
  unit.addLabel(new LangString("Millilitre per Second Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliL-PER-SEC-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("0.001"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/M",
    undefined,
    "mm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    41,
    false,
    false
  );
  unit.addLabel(new LangString("Millimetre", "en"));
  unit.addLabel(new LangString("Millimeter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/MilliM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliM-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M-1H0T2D0",
    new Decimal("1E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mm/bar",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millimetre per Bar", "en"));
  unit.addLabel(new LangString("Millimeter per Bar", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliM-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliM-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("1.157407407407407407407407407407407E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mm/d",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millimetre per Day", "en"));
  unit.addLabel(new LangString("Millimeter per Day", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/MilliM-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliM-PER-DEG_C-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H-1T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mm/(°C·m)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millimeter per Degree Celsius Meter", "en-US"));
  unit.addLabel(new LangString("Millimetre per Degree Celsius Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalExpansionCoefficient"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ExpansionRatio");
  config.units.set("http://qudt.org/vocab/unit/MilliM-PER-DEG_C-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliM-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("2.777777777777777777777777777777778E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mm/h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millimetre per Hour", "en"));
  unit.addLabel(new LangString("Millimeter per Hour", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/MilliM-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliM-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H-1T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mm/K",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millimetre per Kelvin", "en"));
  unit.addLabel(new LangString("Millimeter per Kelvin", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearThermalExpansion"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliM-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliM-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mm/m",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millimeter per Meter", "en-US"));
  unit.addLabel(new LangString("Millimetre per Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Gradient");
  config.units.set("http://qudt.org/vocab/unit/MilliM-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliM-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mm/m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millimeter per Square Meter", "en-US"));
  unit.addLabel(new LangString("Millimetre per Square Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliM-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliM-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("0.00001666666666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mm/min",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millimeter per Minute", "en-US"));
  unit.addLabel(new LangString("Millimetre per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/MilliM-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliM-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mm/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millimetre per Second", "en"));
  unit.addLabel(new LangString("Millimeter per Second", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/MilliM-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliM-PER-SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-2D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mm/s²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millimeter per Square Second", "en-US"));
  unit.addLabel(new LangString("Millimetre per Square Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Acceleration");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearAcceleration"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliM-PER-SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliM-PER-YR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("3.168808781402895023702689684893655E-11"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mm/a",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millimetre per Year", "en"));
  unit.addLabel(new LangString("Millimeter per Year", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/MilliM-PER-YR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mm²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Millimeter", "en-US"));
  unit.addLabel(new LangString("Square Millimetre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/HydraulicPermeability"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Area");
  config.units.set("http://qudt.org/vocab/unit/MilliM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliM2-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-1D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mm²/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Millimetre per Second", "en"));
  unit.addLabel(new LangString("Square Millimeter per Second", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AreaPerTime");
  config.units.set("http://qudt.org/vocab/unit/MilliM2-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("1E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mm³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Millimeter", "en-US"));
  unit.addLabel(new LangString("Cubic Millimetre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/MilliM3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliM3-PER-GM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M-1H0T0D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mm³/g",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Millimetre per Gram", "en"));
  unit.addLabel(new LangString("Cubic Millimeter per Gram", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoilAdsorptionCoefficient"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificVolume");
  config.units.set("http://qudt.org/vocab/unit/MilliM3-PER-GM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliM3-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M-1H0T0D0",
    new Decimal("1E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mm³/kg",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Millimetre per Kilogram", "en"));
  unit.addLabel(new LangString("Cubic Millimeter per Kilogram", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoilAdsorptionCoefficient"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificVolume");
  config.units.set("http://qudt.org/vocab/unit/MilliM3-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliM3-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mm³/m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Millimeter per Cubic Meter", "en-US"));
  unit.addLabel(new LangString("Cubic Millimetre per Cubic Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFraction");
  config.units.set("http://qudt.org/vocab/unit/MilliM3-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliM4",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M0H0T0D0",
    new Decimal("1E-12"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mm⁴",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Quartic Millimetre", "en"));
  unit.addLabel(new LangString("Quartic Millimeter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SecondMomentOfArea"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SecondAxialMomentOfArea"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SecondPolarMomentOfArea"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliM4", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliMOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T0D0",
    new Decimal("0.001"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/MOL",
    undefined,
    "mmol",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    10,
    false,
    false
  );
  unit.addLabel(new LangString("Millimole", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstance"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliMOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliMOL-PER-GM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M-1H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mmol/g",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millimole per Gram", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstancePerMass"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/IonicStrength");
  config.units.set("http://qudt.org/vocab/unit/MilliMOL-PER-GM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliMOL-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M-1H0T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mmol/kg",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millimole per Kilogram", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstancePerMass"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/IonicStrength");
  config.units.set("http://qudt.org/vocab/unit/MilliMOL-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliMOL-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mmol/L",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millimole per Litre", "en"));
  unit.addLabel(new LangString("Millimole per Liter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/BloodGlucoseLevel"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Concentration");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/WaterSolubility");
  config.units.set("http://qudt.org/vocab/unit/MilliMOL-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliMOL-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-2I0M0H0T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mmol/m²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millimole per Square Meter", "en-US"));
  unit.addLabel(new LangString("Millimole per Square Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliMOL-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliMOL-PER-M2-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-2I0M0H0T-1D0",
    new Decimal("1.157407407407407407407407407407407E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mmol/(m²·d)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millimole per Square Meter Day", "en-US"));
  unit.addLabel(new LangString("Millimole per Square Metre Day", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PhotosyntheticPhotonFluxDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliMOL-PER-M2-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliMOL-PER-M2-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-2I0M0H0T-1D0",
    new Decimal("2.777777777777777777777777777777778E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mmol/(m²·h)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millimole per Square Meter Hour", "en-US"));
  unit.addLabel(new LangString("Millimole per Square Metre Hour", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MolarFluxDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliMOL-PER-M2-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliMOL-PER-M2-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-2I0M0H0T-1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mmol/(m²·s)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millimole per Square Metre Second", "en"));
  unit.addLabel(new LangString("Millimole per Square Meter Second", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PhotosyntheticPhotonFluxDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliMOL-PER-M2-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliMOL-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mmol/m³",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millimole per Cubic Meter", "en-US"));
  unit.addLabel(new LangString("Millimole per Cubic Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Concentration");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/WaterSolubility");
  config.units.set("http://qudt.org/vocab/unit/MilliMOL-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliMOL-PER-M3-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T-1D0",
    new Decimal("1.157407407407407407407407407407407E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mmol/(m³·d)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millimole per Cubic Metre Day", "en"));
  unit.addLabel(new LangString("Millimole per Cubic Meter Day", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CatalyticActivityConcentration"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliMOL-PER-M3-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliMOL-PER-MOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mmol/mol",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millimole per Mole", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliMOL-PER-MOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliM_H2O",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("9.80665"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/PA",
    undefined,
    "mmH₂0",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Conventional Millimeter of Water", "en-US"));
  unit.addLabel(new LangString("Conventional Millimetre of Water", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/MilliM_H2O", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliM_HG",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("133.322387415"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/PA",
    undefined,
    "mmHg",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millimetre of Mercury", "en"));
  unit.addLabel(new LangString("Millimeter of Mercury", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/MilliM_HG", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliM_HGA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("133.322387415"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/PA",
    undefined,
    "mmHgA",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millimetre of Mercury - Absolute", "en"));
  unit.addLabel(new LangString("Millimeter of Mercury - Absolute", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/MilliM_HGA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("0.001"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/N",
    undefined,
    "mN",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    3,
    false,
    false
  );
  unit.addLabel(new LangString("Millinewton", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Force");
  config.units.set("http://qudt.org/vocab/unit/MilliN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliN-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mN·m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millinewton Meter", "en-US"));
  unit.addLabel(new LangString("Millinewton Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MomentOfForce");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Torque");
  config.units.set("http://qudt.org/vocab/unit/MilliN-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliN-M-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mN·m/m²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millinewton Metre per Square Metre", "en"));
  unit.addLabel(new LangString("Millinewton Meter per Square Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerLength");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyPerArea");
  config.units.set("http://qudt.org/vocab/unit/MilliN-M-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliN-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mN/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millinewton per Metre", "en"));
  unit.addLabel(new LangString("Millinewton per Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerLength");
  config.units.set("http://qudt.org/vocab/unit/MilliN-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliOHM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H0T-3D0",
    new Decimal("0.001"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/OHM",
    undefined,
    "mΩ",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    4,
    false,
    false
  );
  unit.addLabel(new LangString("Milliohm", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Resistance");
  config.units.set("http://qudt.org/vocab/unit/MilliOHM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliOHM-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L3I0M1H0T-3D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mΩ·m",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milliohm Metre", "en"));
  unit.addLabel(new LangString("Milliohm Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Resistivity");
  config.units.set("http://qudt.org/vocab/unit/MilliOHM-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliOHM-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L3I0M0H0T-1D0",
    new Decimal("1E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mΩ/bar",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milliohm per Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliOHM-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliOHM-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H-1T-3D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mΩ/K",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milliohm per Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliOHM-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliOHM-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L1I0M1H0T-3D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mΩ/m",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milliohm per Meter", "en-US"));
  unit.addLabel(new LangString("Milliohm per Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearResistance"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliOHM-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliOSM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T0D0",
    new Decimal("0.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/OSM",
    undefined,
    "mOsmol",
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Milliosmole", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstance"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliOSM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliOSM-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M-1H0T0D0",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mOsmol/kg",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milliosmole per Kilogram", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstancePerMass"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliOSM-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliPA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("0.001"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/PA",
    undefined,
    "mPa",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    9,
    false,
    false
  );
  unit.addLabel(new LangString("Millipascal", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ModulusOfElasticity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ShearModulus");
  config.units.set("http://qudt.org/vocab/unit/MilliPA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliPA-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-2D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mPa/m",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millipascal per Metre", "en"));
  unit.addLabel(new LangString("Millipascal per Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PressureGradient"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliPA-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliPA-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mPa·s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millipascal Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DynamicViscosity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Viscosity");
  config.units.set("http://qudt.org/vocab/unit/MilliPA-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliPA-SEC-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("1E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mPa·s/bar",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millipascal Second per Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/MilliPA-SEC-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliPA-SEC-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H-1T-1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mPa·s/K",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millipascal Second per Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliPA-SEC-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M-1H0T1D0",
    new Decimal("2.58E-7"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/R",
    undefined,
    "mR",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milliroentgen", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerMass"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliRAD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.001"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/RAD",
    undefined,
    "mrad",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milliradian", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PlaneAngle");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Angle");
  config.units.set("http://qudt.org/vocab/unit/MilliRAD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliRAD_R",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("0.00001"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/RAD_R",
    undefined,
    "mrad",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Millirad", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AbsorbedDose");
  config.units.set("http://qudt.org/vocab/unit/MilliRAD_R", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliRAD_R-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    new Decimal("2.777777777777777777777777777777778E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mrad/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millirad per Hour", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/KermaRate");
  config.units.set("http://qudt.org/vocab/unit/MilliRAD_R-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliR_man",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("0.00001"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/R_man",
    undefined,
    "mrem",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milli Roentgen Equivalent Man", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DoseEquivalent");
  config.units.set("http://qudt.org/vocab/unit/MilliR_man", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliS",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-2I0M-1H0T3D0",
    new Decimal("0.001"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/S",
    undefined,
    "mS",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    2,
    false,
    false
  );
  unit.addLabel(new LangString("Millisiemens", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Conductance");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Admittance");
  config.units.set("http://qudt.org/vocab/unit/MilliS", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliS-PER-CentiM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-3I0M-1H0T3D0",
    new Decimal("0.1"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mS/cm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millisiemens per Centimetre", "en"));
  unit.addLabel(new LangString("Millisiemens per Centimeter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Conductivity");
  config.units.set("http://qudt.org/vocab/unit/MilliS-PER-CentiM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliS-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-3I0M-1H0T3D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mS/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millisiemens per Meter", "en-US"));
  unit.addLabel(new LangString("Millisiemens per Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Conductivity");
  config.units.set("http://qudt.org/vocab/unit/MilliS-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliSEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("0.001"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/SEC",
    undefined,
    "ms",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Millisecond", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/MilliSEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliSV",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("0.001"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/SV",
    undefined,
    "mSv",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    3,
    false,
    false
  );
  unit.addLabel(new LangString("Millisievert", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DoseEquivalent");
  config.units.set("http://qudt.org/vocab/unit/MilliSV", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliSV-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    new Decimal("2.777777777777777777777777777777778E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mSv/h",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millisievert per Hour", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/KermaRate");
  config.units.set("http://qudt.org/vocab/unit/MilliSV-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliSV-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    new Decimal("0.00001666666666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mSv/min",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millisievert per Minute", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/KermaRate");
  config.units.set("http://qudt.org/vocab/unit/MilliSV-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliSV-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mSv/s",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millisievert per Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/KermaRate");
  config.units.set("http://qudt.org/vocab/unit/MilliSV-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L0I0M1H0T-2D0",
    new Decimal("0.001"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/T",
    undefined,
    "mT",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millitesla", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticFluxDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliTORR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("0.133322"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/TORR",
    undefined,
    "mTorr",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millitorr", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/MilliTORR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliV",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-3D0",
    new Decimal("0.001"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/V",
    undefined,
    "mV",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    7,
    false,
    false
  );
  unit.addLabel(new LangString("Millivolt", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotential"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Voltage");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EnergyPerElectricCharge"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotentialDifference"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliV", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliV-A",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mV·A",
    undefined,
    undefined,
    undefined,
    [],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("Millivolt Ampere", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ApparentPower");
  config.units.set("http://qudt.org/vocab/unit/MilliV-A", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliV-A-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H-1T-3D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mV·A/K",
    undefined,
    undefined,
    undefined,
    [],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("Millivolt Ampere per Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalConductance"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliV-A-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliV-A_Reactive",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mV·A{Reactive}",
    undefined,
    undefined,
    undefined,
    [],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("MilliVolt Ampere Reactive", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ReactivePower");
  config.units.set("http://qudt.org/vocab/unit/MilliV-A_Reactive", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliV-A_Reactive-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L-2I0M1H-1T-3D0",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mvar/K",
    undefined,
    undefined,
    undefined,
    [],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("MilliVolt Ampere Reactive per Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliV-A_Reactive-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliV-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L1I0M1H0T-3D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mV/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millivolt per Meter", "en-US"));
  unit.addLabel(new LangString("Millivolt per Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricFieldStrength"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliV-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliV-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-4D0",
    new Decimal("0.00001666666666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mV/min",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millivolt per Minute", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PowerPerElectricCharge"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliV-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliV-PER-V",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mV/V",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Millivolt per Volt", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliV-PER-V", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliVA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("0.001"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/VA",
    undefined,
    "mVA",
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Milli Volt Ampere", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ApparentPower");
  config.units.set("http://qudt.org/vocab/unit/MilliVA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliVA-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H-1T-3D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mVA/K",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milli Volt Ampere per Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalConductance"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliVA-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliVAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("0.001"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/VAR",
    undefined,
    "mVA{Reactive}",
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Milli Volt Ampere Reactive", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ReactivePower");
  config.units.set("http://qudt.org/vocab/unit/MilliVAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliVAR-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H-1T-3D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mVA{Reactive}/K",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milli Volt Ampere Reactive per Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliVAR-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliW",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("0.001"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/W",
    undefined,
    "mW",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    7,
    false,
    false
  );
  unit.addLabel(new LangString("Milliwatt", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/MilliW", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliW-PER-CentiM2-MicroM-SR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-3D0",
    new Decimal("10000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mW/(cm²·μm·sr)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Milliwatt per Square Centimetre Micrometre Steradian", "en")
  );
  unit.addLabel(
    new LangString(
      "Milliwatt per Square Centimeter Micrometer Steradian",
      "en-US"
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set(
    "http://qudt.org/vocab/unit/MilliW-PER-CentiM2-MicroM-SR",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliW-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mW/m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milliwatt per Square Metre", "en"));
  unit.addLabel(new LangString("Milliwatt per Square Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PowerPerArea");
  config.units.set("http://qudt.org/vocab/unit/MilliW-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliW-PER-M2-NanoM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-3D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mW/(m²·nm)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Milliwatt per Square Meter Nanometer", "en-US")
  );
  unit.addLabel(new LangString("Milliwatt per Square Metre Nanometre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ForcePerAreaTime"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliW-PER-M2-NanoM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliW-PER-M2-NanoM-SR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-3D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mW/(m²·nm·sr)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Milliwatt per Square Meter Nanometer Steradian", "en-US")
  );
  unit.addLabel(
    new LangString("Milliwatt per Square Metre Nanometre Steradian", "en")
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpectralRadiance"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliW-PER-M2-NanoM-SR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliW-PER-MilliGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mW/mg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milliwatt per Milligram", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificPower");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/W-PER-GM");
  config.units.set("http://qudt.org/vocab/unit/MilliW-PER-MilliGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliWB",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-2D0",
    new Decimal("0.001"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/WB",
    undefined,
    "mWb",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Milliweber", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MagneticFlux");
  config.units.set("http://qudt.org/vocab/unit/MilliWB", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MillionUSD",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    true
  );
  unit.addLabel(new LangString("MillionUSD", undefined));
  config.units.set("http://qudt.org/vocab/unit/MillionUSD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MillionUSD-PER-YR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "$M/a",
    undefined,
    undefined,
    undefined,
    [],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("Million Us Dollars per Year", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MillionUSD-PER-YR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "N",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    270,
    false,
    false
  );
  unit.addLabel(new LangString("Newton", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Force");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/KiloGM-M-PER-SEC2");
  config.units.set("http://qudt.org/vocab/unit/N", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-CentiM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "N·cm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Newton Centimeter", "en-US"));
  unit.addLabel(new LangString("Newton Centimetre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MomentOfForce");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Torque");
  config.units.set("http://qudt.org/vocab/unit/N-CentiM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "N·m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Newton Metre", "en"));
  unit.addLabel(new LangString("Newton Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MomentOfForce");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Torque");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/J");
  config.units.set("http://qudt.org/vocab/unit/N-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-M-PER-A",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "N·m/A",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Newton Meter per Ampere", "en-US"));
  unit.addLabel(new LangString("Newton Metre per Ampere", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MagneticFlux");
  config.units.set("http://qudt.org/vocab/unit/N-M-PER-A", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-M-PER-ARCMIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("3437.746766834402696604316471280553"),
    undefined,
    undefined,
    undefined,
    undefined,
    "N·m/'",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Newton Metre per Arcminute", "en"));
  unit.addLabel(new LangString("Newton Meter per Arcminute", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TorsionalSpringConstant"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/TorquePerAngle");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/N-M-PER-MIN_Angle");
  config.units.set("http://qudt.org/vocab/unit/N-M-PER-ARCMIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-M-PER-DEG",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("57.29577957855229894302178227976183"),
    undefined,
    undefined,
    undefined,
    undefined,
    "N·m/°",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Newton Metre per Degree", "en"));
  unit.addLabel(new LangString("Newton Meter per Degree", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TorsionalSpringConstant"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/TorquePerAngle");
  config.units.set("http://qudt.org/vocab/unit/N-M-PER-DEG", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-M-PER-DEG-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("57.29577957855229894302178227976183"),
    undefined,
    undefined,
    undefined,
    undefined,
    "N·m/(°·m)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Newton Metre per Degree Metre", "en"));
  unit.addLabel(new LangString("Newton Meter per Degree Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ModulusOfRotationalSubgradeReaction"
  );
  config.units.set("http://qudt.org/vocab/unit/N-M-PER-DEG-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-M-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "N·m/kg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Newton Metre per Kilogram", "en"));
  unit.addLabel(new LangString("Newton Meter per Kilogram", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificEnergy");
  config.units.set("http://qudt.org/vocab/unit/N-M-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-M-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("1.0"),
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    "N·m/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Newton Metre per Metre", "en"));
  unit.addLabel(new LangString("Newton Meter per Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/TorquePerLength");
  config.units.set("http://qudt.org/vocab/unit/N-M-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-M-PER-M-RAD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "N·m/(m·rad)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Newton Metre per Metre Radian", "en"));
  unit.addLabel(new LangString("Newton Meter per Meter Radian", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ModulusOfRotationalSubgradeReaction"
  );
  unit.addExactMatchIri("http://qudt.org/vocab/unit/N-PER-RAD");
  config.units.set("http://qudt.org/vocab/unit/N-M-PER-M-RAD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-M-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "N·m/m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Newton Meter per Square Meter", "en-US"));
  unit.addLabel(new LangString("Newton Metre per Square Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerLength");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyPerArea");
  config.units.set("http://qudt.org/vocab/unit/N-M-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-M-PER-MIN_Angle",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("3437.746766834402696604316471280553"),
    undefined,
    undefined,
    undefined,
    undefined,
    "N·m/'",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Newton Metre per Minute Angle", "en"));
  unit.addLabel(new LangString("Newton Meter per Minute Angle", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TorsionalSpringConstant"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/TorquePerAngle");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/N-M-PER-ARCMIN");
  config.units.set("http://qudt.org/vocab/unit/N-M-PER-MIN_Angle", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-M-PER-RAD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1.0"),
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    "N·m/rad",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Newton Metre per Radian", "en"));
  unit.addLabel(new LangString("Newton Meter per Radian", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TorsionalSpringConstant"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/TorquePerAngle");
  config.units.set("http://qudt.org/vocab/unit/N-M-PER-RAD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-M-PER-W0dot5",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "N·m/√W",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Newton Metre Watt to the Power Minus 0.5", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/N-M-PER-W0dot5", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-M-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "N·m·s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Newton Metre Second", "en"));
  unit.addLabel(new LangString("Newton Meter Second", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AngularImpulse");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AngularMomentum");
  config.units.set("http://qudt.org/vocab/unit/N-M-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-M-SEC-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-1D0",
    new Decimal("1.0"),
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    "N·m·s/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Newton Metre Second per Metre", "en"));
  unit.addLabel(new LangString("Newton Meter Second per Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Momentum");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearMomentum");
  config.units.set("http://qudt.org/vocab/unit/N-M-SEC-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-M-SEC-PER-RAD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-1D0",
    new Decimal("1.0"),
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    "N·m·s/rad",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Newton Metre Second per Radian", "en"));
  unit.addLabel(new LangString("Newton Meter Second per Radian", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AngularMomentumPerAngle"
  );
  config.units.set("http://qudt.org/vocab/unit/N-M-SEC-PER-RAD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "N·m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Newton Square Metre", "en"));
  unit.addLabel(new LangString("Newton Square Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/WarpingMoment");
  config.units.set("http://qudt.org/vocab/unit/N-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-M2-PER-A",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L3I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "N·m²/A",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Newton Square Meter per Ampere", "en-US"));
  unit.addLabel(new LangString("Newton Square Metre per Ampere", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticDipoleMoment"
  );
  unit.addExactMatchIri("http://qudt.org/vocab/unit/WB-M");
  config.units.set("http://qudt.org/vocab/unit/N-M2-PER-A", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-M2-PER-KiloGM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M-1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "N·m²/kg²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Newton Square Meter per Square Kilogram", "en-US")
  );
  unit.addLabel(
    new LangString("Newton Square Metre per Square Kilogram", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/N-M2-PER-KiloGM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-PER-A",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L1I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "N/A",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Newton per Ampere", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticFluxPerLength"
  );
  config.units.set("http://qudt.org/vocab/unit/N-PER-A", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-PER-C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L1I0M1H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "N/C",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Newton per Coulomb", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ForcePerElectricCharge"
  );
  config.units.set("http://qudt.org/vocab/unit/N-PER-C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-PER-CentiM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("100.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "N/cm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Newton per Centimetre", "en"));
  unit.addLabel(new LangString("Newton per Centimeter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerLength");
  config.units.set("http://qudt.org/vocab/unit/N-PER-CentiM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-PER-CentiM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("10000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "N/cm²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Newton per Square Centimeter", "en-US"));
  unit.addLabel(new LangString("Newton per Square Centimetre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/N-PER-CentiM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "N/kg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Newton per Kilogram", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThrustToMassRatio"
  );
  config.units.set("http://qudt.org/vocab/unit/N-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "N/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Newton per Meter", "en-US"));
  unit.addLabel(new LangString("Newton per Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerLength");
  config.units.set("http://qudt.org/vocab/unit/N-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "N/m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Newton per Square Metre", "en"));
  unit.addLabel(new LangString("Newton per Square Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ModulusOfLinearSubgradeReaction"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/PA");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2");
  config.units.set("http://qudt.org/vocab/unit/N-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "N/m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Newton per Cubic Metre", "en"));
  unit.addLabel(new LangString("Newton per Cubic Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ModulusOfSubgradeReaction"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificWeight");
  config.units.set("http://qudt.org/vocab/unit/N-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-PER-MilliM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "N/mm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Newton per Millimetre", "en"));
  unit.addLabel(new LangString("Newton per Millimeter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerLength");
  config.units.set("http://qudt.org/vocab/unit/N-PER-MilliM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-PER-MilliM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "N/mm²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Newton per Square Millimeter", "en-US"));
  unit.addLabel(new LangString("Newton per Square Millimetre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/N-PER-MilliM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-PER-RAD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("1.0"),
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    "N/rad",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Newton per Radian", "en"));
  unit.addLabel(new LangString("Newton per Radian", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerAngle");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/N-M-PER-M-RAD");
  config.units.set("http://qudt.org/vocab/unit/N-PER-RAD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "N·s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Newton Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Momentum");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearMomentum");
  config.units.set("http://qudt.org/vocab/unit/N-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-SEC-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("1.0"),
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    "N·s/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Newton Second per Meter", "en-US"));
  unit.addLabel(new LangString("Newton Second per Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerTime");
  config.units.set("http://qudt.org/vocab/unit/N-SEC-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-SEC-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "N·s/m²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Newton Second per Square Meter", "en-US"));
  unit.addLabel(new LangString("Newton Second per Square Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DynamicViscosity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Viscosity");
  config.units.set("http://qudt.org/vocab/unit/N-SEC-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-SEC-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "N·s/m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Newton Second per Cubic Meter", "en-US"));
  unit.addLabel(new LangString("Newton Second per Cubic Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificAcousticImpedance"
  );
  config.units.set("http://qudt.org/vocab/unit/N-SEC-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-SEC-PER-RAD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-1D0",
    new Decimal("1.0"),
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    "N·s/rad",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Newton Seconds per Radian", "en-US"));
  unit.addLabel(new LangString("Newton Second per Radian", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MomentumPerAngle"
  );
  config.units.set("http://qudt.org/vocab/unit/N-SEC-PER-RAD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NAT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nat",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Nat", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InformationEntropy"
  );
  config.units.set("http://qudt.org/vocab/unit/NAT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NAT-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nat/s",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Nat per Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InformationFlowRate"
  );
  config.units.set("http://qudt.org/vocab/unit/NAT-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NCM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T0D0",
    new Decimal("0.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/MOL",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Normal Cubic Meter", "en-US"));
  unit.addLabel(new LangString("Normal Cubic Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstance"
  );
  config.units.set("http://qudt.org/vocab/unit/NCM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NCM_1ATM_0DEG_C_NL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T0D0",
    new Decimal("0.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/MOL",
    undefined,
    "Nm³",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Normal Cubic Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstance"
  );
  config.units.set("http://qudt.org/vocab/unit/NCM_1ATM_0DEG_C_NL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NP",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Np",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Neper", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Dimensionless");
  config.units.set("http://qudt.org/vocab/unit/NP", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NP-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Np/s",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Neper per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/NP-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M3",
    undefined,
    "NT",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Net Tonnage", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/NT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NTU",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "NTU",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Nephelometry Turbidity Unit", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Turbidity");
  config.units.set("http://qudt.org/vocab/unit/NTU", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NUM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "#",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    45,
    false,
    false
  );
  unit.addLabel(new LangString("Number", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ChargeNumber");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CoefficientOfPerformance"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/NucleonNumber");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassNumber");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/HyperfineStructureQuantumNumber"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpinQuantumNumber"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ReynoldsNumber");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticQuantumNumber"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Landau-GinzburgNumber"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/FrictionCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/NeutronNumber");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Population");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/StoichiometricNumber"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Count");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/OpeningRatio");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PrincipalQuantumNumber"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/NuclearSpinQuantumNumber"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/IonTransportNumber"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Dimensionless");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TotalAngularMomentumQuantumNumber"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/QuantumNumber");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/OrbitalAngularMomentumQuantumNumber"
  );
  unit.addExactMatchIri("http://qudt.org/vocab/unit/COUNT");
  config.units.set("http://qudt.org/vocab/unit/NUM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NUM-PER-CentiM-KiloYR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T-1D0",
    new Decimal("3.168808781402895023702689684893655E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "#/(cm·ka)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Number per Centimetre Kiloyear", "en"));
  unit.addLabel(new LangString("Number per Centimeter Kiloyear", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/NUM-PER-CentiM-KiloYR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NUM-PER-GM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "#/g",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Number per Gram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/PER-GM");
  config.units.set("http://qudt.org/vocab/unit/NUM-PER-GM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NUM-PER-HA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T0D0",
    new Decimal("0.0001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "#/ha",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Number per Hectare", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ParticleFluence");
  config.units.set("http://qudt.org/vocab/unit/NUM-PER-HA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NUM-PER-HA-YR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T-1D0",
    new Decimal("3.168808781402895023702689684893655E-12"),
    undefined,
    undefined,
    undefined,
    undefined,
    "#/(ha·a)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Number per Hectare Year", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Flux");
  config.units.set("http://qudt.org/vocab/unit/NUM-PER-HA-YR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NUM-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("0.0002777777777777777777777777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "#/h",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Number per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Frequency");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/CountRate");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/PER-HR");
  config.units.set("http://qudt.org/vocab/unit/NUM-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NUM-PER-HectoGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T0D0",
    new Decimal("10.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "#/hg",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Number per Hectogram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/NUM-PER-HectoGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NUM-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "#/kg",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Number per Kilogram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/NUM-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NUM-PER-KiloM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T0D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "#/km²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Number per Square Kilometre", "en"));
  unit.addLabel(new LangString("Number per Square Kilometer", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ParticleFluence");
  config.units.set("http://qudt.org/vocab/unit/NUM-PER-KiloM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NUM-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "#/L",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Number per Liter", "en-US"));
  unit.addLabel(new LangString("Number per Litre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/NumberDensity");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/PER-L");
  config.units.set("http://qudt.org/vocab/unit/NUM-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NUM-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "#/m",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Number per Metre", "en"));
  unit.addLabel(new LangString("Number per Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseLength");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/PER-M");
  config.units.set("http://qudt.org/vocab/unit/NUM-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NUM-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "#/m²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Number per Square Metre", "en"));
  unit.addLabel(new LangString("Number per Square Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ParticleFluence");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/PER-M2");
  config.units.set("http://qudt.org/vocab/unit/NUM-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NUM-PER-M2-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T-1D0",
    new Decimal("0.00001157407407407407407407407407407407"),
    undefined,
    undefined,
    undefined,
    undefined,
    "#/(m²·d)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Number per Square Metre Day", "en"));
  unit.addLabel(new LangString("Number per Square Meter Day", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Flux");
  config.units.set("http://qudt.org/vocab/unit/NUM-PER-M2-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NUM-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "#/m³",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Number per Cubic Metre", "en"));
  unit.addLabel(new LangString("Number per Cubic Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/NumberDensity");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/PER-M3");
  config.units.set("http://qudt.org/vocab/unit/NUM-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NUM-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("0.01666666666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "#/min",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Number per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/CountRate");
  config.units.set("http://qudt.org/vocab/unit/NUM-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NUM-PER-MicroL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    new Decimal("1000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "#/μL",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Number per Microliter", "en-US"));
  unit.addLabel(new LangString("Number per Microlitre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/NumberDensity");
  config.units.set("http://qudt.org/vocab/unit/NUM-PER-MicroL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NUM-PER-MilliGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T0D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "#/mg",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Number per Milligram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/PER-MilliGM");
  config.units.set("http://qudt.org/vocab/unit/NUM-PER-MilliGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NUM-PER-MilliL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "#/mL",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Number per Millilitre", "en"));
  unit.addLabel(new LangString("Number per Milliliter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/NumberDensity");
  config.units.set("http://qudt.org/vocab/unit/NUM-PER-MilliL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NUM-PER-MilliM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    new Decimal("1000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "#/mm³",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Number per Cubic Millimeter", "en-US"));
  unit.addLabel(new LangString("Number per Cubic Millimetre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/NumberDensity");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/PER-MilliM3");
  config.units.set("http://qudt.org/vocab/unit/NUM-PER-MilliM3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NUM-PER-NanoL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    new Decimal("1000000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "#/nL",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Number per Nanoliter", "en-US"));
  unit.addLabel(new LangString("Number per Nanolitre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/NumberDensity");
  config.units.set("http://qudt.org/vocab/unit/NUM-PER-NanoL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NUM-PER-PicoL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    new Decimal("1000000000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "#/pL",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Number per Picolitre", "en"));
  unit.addLabel(new LangString("Number per Picoliter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/NumberDensity");
  config.units.set("http://qudt.org/vocab/unit/NUM-PER-PicoL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NUM-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "#/s",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Number per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Frequency");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/CountRate");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/PER-SEC");
  config.units.set("http://qudt.org/vocab/unit/NUM-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NUM-PER-YR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("3.168808781402895023702689684893655E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "#/a",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Number per Year", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Frequency");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/CountRate");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/PER-YR");
  config.units.set("http://qudt.org/vocab/unit/NUM-PER-YR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T0D0",
    new Decimal("1E-9"),
    undefined,
    "http://qudt.org/vocab/prefix/Nano",
    "http://qudt.org/vocab/unit/A",
    undefined,
    "nA",
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Nanoampere", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCurrent");
  config.units.set("http://qudt.org/vocab/unit/NanoA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoA-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H-1T0D0",
    new Decimal("1E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nA/K",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Nanoampere per Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentPerTemperature"
  );
  config.units.set("http://qudt.org/vocab/unit/NanoA-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoBQ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("1E-9"),
    undefined,
    "http://qudt.org/vocab/prefix/Nano",
    "http://qudt.org/vocab/unit/BQ",
    undefined,
    "nBq",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Nanobecquerel", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Activity");
  config.units.set("http://qudt.org/vocab/unit/NanoBQ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoBQ-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T-1D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nBq/L",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Nanobecquerel per Liter", "en-US"));
  unit.addLabel(new LangString("Nanobecquerel per Litre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ActivityConcentration"
  );
  config.units.set("http://qudt.org/vocab/unit/NanoBQ-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("1E-9"),
    undefined,
    "http://qudt.org/vocab/prefix/Nano",
    "http://qudt.org/vocab/unit/C",
    undefined,
    "nC",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Nanocoulomb", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  config.units.set("http://qudt.org/vocab/unit/NanoC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoFARAD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-2I0M-1H0T4D0",
    new Decimal("1E-9"),
    undefined,
    "http://qudt.org/vocab/prefix/Nano",
    "http://qudt.org/vocab/unit/FARAD",
    undefined,
    "nF",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Nanofarad", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Capacitance");
  config.units.set("http://qudt.org/vocab/unit/NanoFARAD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoFARAD-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-3I0M-1H0T4D0",
    new Decimal("1E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nF/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Nanofarad per Meter", "en-US"));
  unit.addLabel(new LangString("Nanofarad per Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Permittivity");
  config.units.set("http://qudt.org/vocab/unit/NanoFARAD-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("1E-12"),
    undefined,
    "http://qudt.org/vocab/prefix/Nano",
    "http://qudt.org/vocab/unit/GM",
    undefined,
    "ng",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    11,
    false,
    false
  );
  unit.addLabel(new LangString("Nanogram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  config.units.set("http://qudt.org/vocab/unit/NanoGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoGM-PER-CentiM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    new Decimal("1E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ng/cm²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Nanogram per Square Centimeter", "en-US"));
  unit.addLabel(new LangString("Nanogram per Square Centimetre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerArea");
  config.units.set("http://qudt.org/vocab/unit/NanoGM-PER-CentiM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoGM-PER-CentiM2-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-1D0",
    new Decimal("1.157407407407407407407407407407407E-13"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ng/(cm²·d)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Nanogram per Square Centimeter Day", "en-US"));
  unit.addLabel(new LangString("Nanogram per Square Centimetre Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerAreaTime");
  config.units.set("http://qudt.org/vocab/unit/NanoGM-PER-CentiM2-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoGM-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("1.157407407407407407407407407407407E-17"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ng/d",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Nanogram per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerTime");
  config.units.set("http://qudt.org/vocab/unit/NanoGM-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoGM-PER-DeciL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("1E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ng/dL",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Nanogram per Deciliter", "en-US"));
  unit.addLabel(new LangString("Nanogram per Decilitre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  config.units.set("http://qudt.org/vocab/unit/NanoGM-PER-DeciL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoGM-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1E-12"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ng/kg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Nanogram per Kilogram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassRatio");
  config.units.set("http://qudt.org/vocab/unit/NanoGM-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoGM-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("1E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ng/L",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Nanogram per Liter", "en-US"));
  unit.addLabel(new LangString("Nanogram per Litre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassConcentration"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  config.units.set("http://qudt.org/vocab/unit/NanoGM-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoGM-PER-M2-PA-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T1D0",
    new Decimal("1E-12"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ng/(m²·Pa·s)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Nanogram per Square Metre Pascal Second", "en")
  );
  unit.addLabel(
    new LangString("Nanogram per Square Meter Pascal Second", "en-US")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VapourPermeance");
  config.units.set("http://qudt.org/vocab/unit/NanoGM-PER-M2-PA-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoGM-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("1E-12"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ng/m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Nanogram per Cubic Metre", "en"));
  unit.addLabel(new LangString("Nanogram per Cubic Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  config.units.set("http://qudt.org/vocab/unit/NanoGM-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoGM-PER-MicroL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ng/μL",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Nanogram per Microlitre", "en"));
  unit.addLabel(new LangString("Nanogram per Microliter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  config.units.set("http://qudt.org/vocab/unit/NanoGM-PER-MicroL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoGM-PER-MilliGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ng/mg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Nanogram per Milligram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassRatio");
  config.units.set("http://qudt.org/vocab/unit/NanoGM-PER-MilliGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoGM-PER-MilliL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ng/mL",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Nanogram per Milliliter", "en-US"));
  unit.addLabel(new LangString("Nanogram per Millilitre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassConcentration"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  config.units.set("http://qudt.org/vocab/unit/NanoGM-PER-MilliL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoGRAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("1E-9"),
    undefined,
    "http://qudt.org/vocab/prefix/Nano",
    "http://qudt.org/vocab/unit/GRAY",
    undefined,
    "nGy",
    undefined,
    undefined,
    undefined,
    [],
    3,
    false,
    false
  );
  unit.addLabel(new LangString("Nanogray", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AbsorbedDose");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Kerma");
  config.units.set("http://qudt.org/vocab/unit/NanoGRAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoGRAY-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    new Decimal("2.777777777777777777777777777777778E-13"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nGy/h",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Nanogray per Hour", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/KermaRate");
  config.units.set("http://qudt.org/vocab/unit/NanoGRAY-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoGRAY-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    new Decimal("1.666666666666666666666666666666667E-11"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nGy/min",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Nanogray per Minute", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/KermaRate");
  config.units.set("http://qudt.org/vocab/unit/NanoGRAY-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoGRAY-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    new Decimal("1E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nGy/s",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Nanogray per Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/KermaRate");
  config.units.set("http://qudt.org/vocab/unit/NanoGRAY-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoH",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H0T-2D0",
    new Decimal("1E-9"),
    undefined,
    "http://qudt.org/vocab/prefix/Nano",
    "http://qudt.org/vocab/unit/H",
    undefined,
    "nH",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Nanohenry", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Permeance");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Inductance");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/H_Ab");
  config.units.set("http://qudt.org/vocab/unit/NanoH", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoH-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L1I0M1H0T-2D0",
    new Decimal("1E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nH/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Nanohenry per Metre", "en"));
  unit.addLabel(new LangString("Nanohenry per Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Permeability");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectromagneticPermeability"
  );
  config.units.set("http://qudt.org/vocab/unit/NanoH-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoJ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1E-9"),
    undefined,
    "http://qudt.org/vocab/prefix/Nano",
    "http://qudt.org/vocab/unit/J",
    undefined,
    "nJ",
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Nanojoule", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LagrangeFunction"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LevelWidth");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ThermalEnergy");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/HamiltonFunction"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ExchangeIntegral"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/NanoJ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoJ-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nJ/s",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Nanojoule per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/NanoJ-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoKAT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T-1D0",
    new Decimal("1E-9"),
    undefined,
    "http://qudt.org/vocab/prefix/Nano",
    "http://qudt.org/vocab/unit/KAT",
    undefined,
    "nkat",
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Nanokatal", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CatalyticActivity"
  );
  config.units.set("http://qudt.org/vocab/unit/NanoKAT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoKAT-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T-1D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nkat/L",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Nanokatal per Liter", "en-US"));
  unit.addLabel(new LangString("Nanokatal per Litre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CatalyticActivityConcentration"
  );
  config.units.set("http://qudt.org/vocab/unit/NanoKAT-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("1E-12"),
    undefined,
    "http://qudt.org/vocab/prefix/Nano",
    "http://qudt.org/vocab/unit/L",
    undefined,
    "nL",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Nanolitre", "en"));
  unit.addLabel(new LangString("Nanoliter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/NanoL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("1E-9"),
    undefined,
    "http://qudt.org/vocab/prefix/Nano",
    "http://qudt.org/vocab/unit/M",
    undefined,
    "nm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    11,
    false,
    false
  );
  unit.addLabel(new LangString("Nanometer", "en-US"));
  unit.addLabel(new LangString("Nanometre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/NanoM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoM-PER-CentiM-MegaPA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H0T2D0",
    new Decimal("1E-13"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nm/(cm·MPa)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Nanometer per Centimeter Megapascal", "en-US"));
  unit.addLabel(new LangString("Nanometre per Centimetre Megapascal", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/StressOpticCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/NanoM-PER-CentiM-MegaPA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoM-PER-CentiM-PSI",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H0T2D0",
    new Decimal("1.450377312227268702148557236386593E-11"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nm/(cm·psi)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Nanometer per Centimeter Psi", "en-US"));
  unit.addLabel(new LangString("Nanometre per Centimetre Psi", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/StressOpticCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/NanoM-PER-CentiM-PSI", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoM-PER-MilliM-MegaPA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H0T2D0",
    new Decimal("1E-12"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nm/(mm·MPa)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Nanometre per Millimetre Megapascal", "en"));
  unit.addLabel(new LangString("Nanometer per Millimeter Megapascal", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/StressOpticCoefficient"
  );
  unit.addExactMatchIri("http://qudt.org/vocab/unit/BREWSTER");
  config.units.set("http://qudt.org/vocab/unit/NanoM-PER-MilliM-MegaPA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    new Decimal("1E-18"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nm²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Nanometer", "en-US"));
  unit.addLabel(new LangString("Square Nanometre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/HydraulicPermeability"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/NuclearQuadrupoleMoment"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Area");
  config.units.set("http://qudt.org/vocab/unit/NanoM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoMOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T0D0",
    new Decimal("1E-9"),
    undefined,
    "http://qudt.org/vocab/prefix/Nano",
    "http://qudt.org/vocab/unit/MOL",
    undefined,
    "nmol",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    13,
    false,
    false
  );
  unit.addLabel(new LangString("Nanomole", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstance"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ExtentOfReaction"
  );
  config.units.set("http://qudt.org/vocab/unit/NanoMOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoMOL-PER-CentiM3-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T-1D0",
    new Decimal("2.777777777777777777777777777777778E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nmol/(cm³·h)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Nanomole per Cubic Centimetre Hour", "en"));
  unit.addLabel(new LangString("Nanomole per Cubic Centimeter Hour", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CatalyticActivityConcentration"
  );
  config.units.set("http://qudt.org/vocab/unit/NanoMOL-PER-CentiM3-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoMOL-PER-GM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M-1H0T0D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nmol/g",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Nanomole per Gram", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstancePerMass"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/IonicStrength");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MolalityOfSolute"
  );
  config.units.set("http://qudt.org/vocab/unit/NanoMOL-PER-GM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoMOL-PER-GM-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M-1H0T-1D0",
    new Decimal("2.777777777777777777777777777777778E-10"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nmol/(g·h)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Nanomole per Gram Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/NanoMOL-PER-GM-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoMOL-PER-GM-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M-1H0T-1D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nmol/(g·s)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Nanomole per Gram Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/NanoMOL-PER-GM-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoMOL-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M-1H0T0D0",
    new Decimal("1E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nmol/kg",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Nanomole per Kilogram", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstancePerMass"
  );
  config.units.set("http://qudt.org/vocab/unit/NanoMOL-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoMOL-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T0D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nmol/L",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Nanomole per Litre", "en"));
  unit.addLabel(new LangString("Nanomole per Liter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Concentration");
  config.units.set("http://qudt.org/vocab/unit/NanoMOL-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoMOL-PER-L-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T-1D0",
    new Decimal("1.157407407407407407407407407407407E-11"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nmol/(L·d)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Nanomole per Liter Day", "en-US"));
  unit.addLabel(new LangString("Nanomole per Litre Day", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CatalyticActivityConcentration"
  );
  config.units.set("http://qudt.org/vocab/unit/NanoMOL-PER-L-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoMOL-PER-L-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T-1D0",
    new Decimal("2.777777777777777777777777777777778E-10"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nmol/(L·h)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Nanomole per Liter Hour", "en-US"));
  unit.addLabel(new LangString("Nanomole per Litre Hour", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CatalyticActivityConcentration"
  );
  config.units.set("http://qudt.org/vocab/unit/NanoMOL-PER-L-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoMOL-PER-M2-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-2I0M0H0T-1D0",
    new Decimal("1.157407407407407407407407407407407E-14"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nmol/(m²·d)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Nanomole per Square Metre Day", "en"));
  unit.addLabel(new LangString("Nanomole per Square Meter Day", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PhotosyntheticPhotonFluxDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/NanoMOL-PER-M2-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoMOL-PER-M2-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-2I0M0H0T-1D0",
    new Decimal("1E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nmol/(m²·s)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Nanomole per Square Meter Second", "en-US"));
  unit.addLabel(new LangString("Nanomole per Square Metre Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MolarFluxDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/NanoMOL-PER-M2-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoMOL-PER-MicroGM-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M-1H0T-1D0",
    new Decimal("0.0002777777777777777777777777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nmol/(μg·h)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Nanomole per Microgram Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/NanoMOL-PER-MicroGM-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoMOL-PER-MicroMOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nmol/μmol",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Nanomole per Micromole", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/NanoMOL-PER-MicroMOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoMOL-PER-MicroMOL-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("1.157407407407407407407407407407407E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nmol/(μmol·d)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Nanomole per Micromole Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/NanoMOL-PER-MicroMOL-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("1E-9"),
    undefined,
    "http://qudt.org/vocab/prefix/Nano",
    "http://qudt.org/vocab/unit/N",
    undefined,
    "nN",
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Nanonewton", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Force");
  config.units.set("http://qudt.org/vocab/unit/NanoN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoN-M-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("1E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nN·m/m²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Nanonewton Metre per Square Metre", "en"));
  unit.addLabel(new LangString("Nanonewton Meter per Square Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerLength");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyPerArea");
  config.units.set("http://qudt.org/vocab/unit/NanoN-M-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoOHM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H0T-3D0",
    new Decimal("1E-9"),
    undefined,
    "http://qudt.org/vocab/prefix/Nano",
    "http://qudt.org/vocab/unit/OHM",
    undefined,
    "nΩ",
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Nanoohm", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricalResistance"
  );
  config.units.set("http://qudt.org/vocab/unit/NanoOHM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoOHM-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L3I0M1H0T-3D0",
    new Decimal("1E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nΩ·m",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Nanoohm Metre", "en"));
  unit.addLabel(new LangString("Nanoohm Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Resistivity");
  config.units.set("http://qudt.org/vocab/unit/NanoOHM-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoS",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-2I0M-1H0T3D0",
    new Decimal("1E-9"),
    undefined,
    "http://qudt.org/vocab/prefix/Nano",
    "http://qudt.org/vocab/unit/S",
    undefined,
    "nS",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    2,
    false,
    false
  );
  unit.addLabel(new LangString("Nanosiemens", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Conductance");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Admittance");
  config.units.set("http://qudt.org/vocab/unit/NanoS", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoS-PER-CentiM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-3I0M-1H0T3D0",
    new Decimal("1E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nS/cm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Nanosiemens per Centimetre", "en"));
  unit.addLabel(new LangString("Nanosiemens per Centimeter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Conductivity");
  config.units.set("http://qudt.org/vocab/unit/NanoS-PER-CentiM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoS-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-3I0M-1H0T3D0",
    new Decimal("1E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nS/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Nanosiemens per Metre", "en"));
  unit.addLabel(new LangString("Nanosiemens per Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Conductivity");
  config.units.set("http://qudt.org/vocab/unit/NanoS-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoSEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("1E-9"),
    undefined,
    "http://qudt.org/vocab/prefix/Nano",
    "http://qudt.org/vocab/unit/SEC",
    undefined,
    "ns",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Nanosecond", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/NanoSEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoSV",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("1E-9"),
    undefined,
    "http://qudt.org/vocab/prefix/Nano",
    "http://qudt.org/vocab/unit/SV",
    undefined,
    "nSv",
    undefined,
    undefined,
    undefined,
    [],
    3,
    false,
    false
  );
  unit.addLabel(new LangString("Nanosievert", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DoseEquivalent");
  config.units.set("http://qudt.org/vocab/unit/NanoSV", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoSV-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    new Decimal("2.777777777777777777777777777777778E-13"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nSv/h",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Nanosievert per Hour", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/KermaRate");
  config.units.set("http://qudt.org/vocab/unit/NanoSV-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoSV-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    new Decimal("1.666666666666666666666666666666667E-11"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nSv/min",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Nanosievert per Minute", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/KermaRate");
  config.units.set("http://qudt.org/vocab/unit/NanoSV-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoSV-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    new Decimal("1E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nSv/s",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Nanosievert per Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/KermaRate");
  config.units.set("http://qudt.org/vocab/unit/NanoSV-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L0I0M1H0T-2D0",
    new Decimal("1E-9"),
    undefined,
    "http://qudt.org/vocab/prefix/Nano",
    "http://qudt.org/vocab/unit/T",
    undefined,
    "nT",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Nanotesla", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticFluxDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/NanoT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoV",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-3D0",
    new Decimal("1E-9"),
    undefined,
    "http://qudt.org/vocab/prefix/Nano",
    "http://qudt.org/vocab/unit/V",
    undefined,
    "nV",
    undefined,
    undefined,
    undefined,
    [],
    2,
    false,
    false
  );
  unit.addLabel(new LangString("Nanovolt", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotential"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Voltage");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EnergyPerElectricCharge"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotentialDifference"
  );
  config.units.set("http://qudt.org/vocab/unit/NanoV", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoV-A",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nV·A",
    undefined,
    undefined,
    undefined,
    [],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("Nanovolt Ampere", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ApparentPower");
  config.units.set("http://qudt.org/vocab/unit/NanoV-A", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoV-A_Reactive",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nV·A{Reactive}",
    undefined,
    undefined,
    undefined,
    [],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("NanoVolt Ampere Reactive", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ReactivePower");
  config.units.set("http://qudt.org/vocab/unit/NanoV-A_Reactive", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoVA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1E-9"),
    undefined,
    "http://qudt.org/vocab/prefix/Nano",
    "http://qudt.org/vocab/unit/VA",
    undefined,
    "nVA",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Nano Volt Ampere", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ApparentPower");
  config.units.set("http://qudt.org/vocab/unit/NanoVA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoVAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1E-9"),
    undefined,
    "http://qudt.org/vocab/prefix/Nano",
    "http://qudt.org/vocab/unit/VAR",
    undefined,
    "nVA{Reactive}",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Nano Volt Ampere Reactive", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ReactivePower");
  config.units.set("http://qudt.org/vocab/unit/NanoVAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoW",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1E-9"),
    undefined,
    "http://qudt.org/vocab/prefix/Nano",
    "http://qudt.org/vocab/unit/W",
    undefined,
    "nW",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Nanowatt", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/NanoW", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoW-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    new Decimal("1E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nW/m²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Nanowatt per Square Metre", "en"));
  unit.addLabel(new LangString("Nanowatt per Square Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PowerPerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PoyntingVector");
  config.units.set("http://qudt.org/vocab/unit/NanoW-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OCT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "octave",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Oct", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Dimensionless");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LogarithmicFrequencyInterval"
  );
  config.units.set("http://qudt.org/vocab/unit/OCT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OCTET",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("5.54517744447956247533785697166544"),
    undefined,
    undefined,
    undefined,
    undefined,
    "o",
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Octet", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DatasetOfBits");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/BYTE");
  config.units.set("http://qudt.org/vocab/unit/OCTET", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OCTET-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("5.54517744447956247533785697166544"),
    undefined,
    undefined,
    undefined,
    undefined,
    "o/s",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Octet per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/BitRate");
  config.units.set("http://qudt.org/vocab/unit/OCTET-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OERSTED",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-1I0M0H0T0D0",
    new Decimal("79.5774715"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/A-PER-M",
    undefined,
    "Oe",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Oersted", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticFieldStrength"
  );
  config.units.set("http://qudt.org/vocab/unit/OERSTED", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OERSTED-CentiM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T0D0",
    new Decimal("0.795774715"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Oe·cm",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Oersted Centimetre", "en"));
  unit.addLabel(new LangString("Oersted Centimeter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagnetomotiveForce"
  );
  config.units.set("http://qudt.org/vocab/unit/OERSTED-CentiM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OHM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Ω",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    23,
    false,
    false
  );
  unit.addLabel(new LangString("Ohm", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Impedance");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Resistance");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Reactance");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ModulusOfImpedance"
  );
  config.units.set("http://qudt.org/vocab/unit/OHM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OHM-CentiM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L3I0M1H0T-3D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Ω·cm",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ohm Centimetre", "en"));
  unit.addLabel(new LangString("Ohm Centimeter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Resistivity");
  config.units.set("http://qudt.org/vocab/unit/OHM-CentiM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OHM-KiloM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L3I0M1H0T-3D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Ω·km",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ohm Kilometer", "en-US"));
  unit.addLabel(new LangString("Ohm Kilometre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ResidualResistivity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Resistivity");
  config.units.set("http://qudt.org/vocab/unit/OHM-KiloM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OHM-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L3I0M1H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Ω·m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ohm Meter", "en-US"));
  unit.addLabel(new LangString("Ohm Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ResidualResistivity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Resistivity");
  config.units.set("http://qudt.org/vocab/unit/OHM-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OHM-M2-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L3I0M1H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Ω·m²/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ohm Square Meter per Meter", "en-US"));
  unit.addLabel(new LangString("Ohm Square Metre per Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Resistivity");
  config.units.set("http://qudt.org/vocab/unit/OHM-M2-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OHM-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L3I0M0H0T-1D0",
    new Decimal("0.00001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Ω/bar",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ohm per Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/OHM-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OHM-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H-1T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Ω/K",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ohm per Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/OHM-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OHM-PER-KiloM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L1I0M1H0T-3D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Ω/km",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ohm per Kilometer", "en-US"));
  unit.addLabel(new LangString("Ohm per Kilometre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearResistance"
  );
  config.units.set("http://qudt.org/vocab/unit/OHM-PER-KiloM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OHM-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L1I0M1H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Ω/m",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ohm per Metre", "en"));
  unit.addLabel(new LangString("Ohm per Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearResistance"
  );
  config.units.set("http://qudt.org/vocab/unit/OHM-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OHM-PER-MI",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L1I0M1H0T-3D0",
    new Decimal("0.0006213711922373339696174341843633182"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Ω/mi",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ohm per International Mile", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearResistance"
  );
  config.units.set("http://qudt.org/vocab/unit/OHM-PER-MI", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OHM_Ab",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H0T-3D0",
    new Decimal("1E-9"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/OHM",
    undefined,
    "abΩ",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-EMU", "http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Abohm", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Resistance");
  config.units.set("http://qudt.org/vocab/unit/OHM_Ab", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OHM_CIRC",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    true
  );
  unit.addLabel(new LangString("OHM_CIRC", undefined));
  config.units.set("http://qudt.org/vocab/unit/OHM_CIRC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OHM_CIRC-MIL-PER-FT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L3I0M1H0T-3D0",
    new Decimal("1.662426113E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Ω·cmil/ft",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ohm Circular Mil per Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Resistivity");
  config.units.set("http://qudt.org/vocab/unit/OHM_CIRC-MIL-PER-FT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OHM_Stat",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H0T-3D0",
    new Decimal("898760000000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/OHM",
    undefined,
    "statΩ",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS", "http://qudt.org/vocab/sou/CGS-ESU"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Statohm", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Resistance");
  config.units.set("http://qudt.org/vocab/unit/OHM_Stat", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OKTA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Okta", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfCloudCover"
  );
  config.units.set("http://qudt.org/vocab/unit/OKTA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ONE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "one",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    8,
    false,
    false
  );
  unit.addLabel(new LangString("One", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Count");
  config.units.set("http://qudt.org/vocab/unit/ONE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ONE-PER-ONE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "one/one",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("One per One", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Ratio");
  config.units.set("http://qudt.org/vocab/unit/ONE-PER-ONE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OSM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T0D0",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Osmol",
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Osmole", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstance"
  );
  config.units.set("http://qudt.org/vocab/unit/OSM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("0.028349523125"),
    undefined,
    undefined,
    undefined,
    undefined,
    "oz",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    34,
    false,
    false
  );
  unit.addLabel(new LangString("Ounce Mass", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/OZ_M");
  config.units.set("http://qudt.org/vocab/unit/OZ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-FT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T0D0",
    new Decimal("0.0086409346485"),
    undefined,
    undefined,
    undefined,
    undefined,
    "oz·ft",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ounce Mass Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LengthMass");
  config.units.set("http://qudt.org/vocab/unit/OZ-FT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-FT-HR-PER-IN3-LB",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal("4185008.37001674003348006696013392"),
    undefined,
    undefined,
    undefined,
    undefined,
    "oz·ft·h/(in³·lbm)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Ounce Mass Foot Hour per Cubic Inch Pound Mass", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/OZ-FT-HR-PER-IN3-LB", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-FT-SEC-PER-IN3-LB",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal("1162.5023250046500093000186000372"),
    undefined,
    undefined,
    undefined,
    undefined,
    "oz·ft·s/(in³·lbm)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Ounce Mass Foot Second per Cubic Inch Pound Mass", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/OZ-FT-SEC-PER-IN3-LB", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-FT2-PER-IN3-LB_F-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal("36.1316752166621861189380447919115"),
    undefined,
    undefined,
    undefined,
    undefined,
    "oz·ft²/(in³·lbf·s)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "Ounce Mass Square Foot per Cubic Inch Pound Force Second",
      "en"
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/OZ-FT2-PER-IN3-LB_F-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-HR-PER-IN3-FT3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("219938987.1877617250669424917895746"),
    undefined,
    undefined,
    undefined,
    undefined,
    "oz·h/(in³·ft³)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Ounce Mass Hour per Cubic Inch Cubic Foot", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/OZ-HR-PER-IN3-FT3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-HR-PER-IN3-GAL_UK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("1369963762.221095989865992857706645"),
    undefined,
    undefined,
    undefined,
    undefined,
    "oz·h/(in³·gal{UK})",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Ounce Mass Hour per Cubic Inch Gallon (UK)", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/OZ-HR-PER-IN3-GAL_UK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-HR-PER-IN3-GAL_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("1645257878.183776021279985393127207"),
    undefined,
    undefined,
    undefined,
    undefined,
    "oz·h/(in³·gal{US})",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Ounce Mass Hour per Cubic Inch Us Gallon", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/OZ-HR-PER-IN3-GAL_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-HR-PER-IN3-YD3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("8145888.414361545372849721918132388"),
    undefined,
    undefined,
    undefined,
    undefined,
    "oz·h/(in³·yd³)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Ounce Mass Hour per Cubic Inch Cubic Yard", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/OZ-HR-PER-IN3-YD3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-HR-PER-IN6",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("380054569860.4522609156766258123849"),
    undefined,
    undefined,
    undefined,
    undefined,
    "oz·h/in⁶",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ounce Mass Hour per Sextic Inch", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/OZ-HR-PER-IN6", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-IN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T0D0",
    new Decimal("0.000720077887375"),
    undefined,
    undefined,
    undefined,
    undefined,
    "oz·in",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ounce Mass Inch", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LengthMass");
  config.units.set("http://qudt.org/vocab/unit/OZ-IN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-IN2-PER-IN3-LB_F-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal("0.2509144112268207369370697554993854"),
    undefined,
    undefined,
    undefined,
    undefined,
    "oz·in²/(in³·lbf·s)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString(
      "Ounce Mass Square Inch per Cubic Inch Pound Force Second",
      "en"
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/OZ-IN2-PER-IN3-LB_F-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-MIN-PER-IN3-FT3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("3665649.786462695417782374863159576"),
    undefined,
    undefined,
    undefined,
    undefined,
    "oz·min/(in³·ft³)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Ounce Mass Minute per Cubic Inch Cubic Foot", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/OZ-MIN-PER-IN3-FT3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-MIN-PER-IN3-GAL_UK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("22832729.37035159983109988096177742"),
    undefined,
    undefined,
    undefined,
    undefined,
    "oz·min/(in³·gal{UK})",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Ounce Mass Minute per Cubic Inch Gallon (UK)", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/OZ-MIN-PER-IN3-GAL_UK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-MIN-PER-IN3-GAL_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("27420964.63639626702133308988545345"),
    undefined,
    undefined,
    undefined,
    undefined,
    "oz·min/(in³·gal{US})",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Ounce Mass Minute per Cubic Inch Us Gallon", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/OZ-MIN-PER-IN3-GAL_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-MIN-PER-IN3-YD3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("135764.8069060257562141620319688731"),
    undefined,
    undefined,
    undefined,
    undefined,
    "oz·min/(in³·yd³)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Ounce Mass Minute per Cubic Inch Cubic Yard", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/OZ-MIN-PER-IN3-YD3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-MIN-PER-IN6",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("6334242831.007537681927943763539748"),
    undefined,
    undefined,
    undefined,
    undefined,
    "oz·min/in⁶",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ounce Mass Minute per Sextic Inch", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/OZ-MIN-PER-IN6", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("3.281194806134259259259259259259258E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "oz/d",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ounce Mass per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/OZ-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-PER-FT2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    new Decimal("0.305151727273940658992429095969303"),
    undefined,
    undefined,
    undefined,
    undefined,
    "oz/ft²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ounce Mass per Square Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerArea");
  config.units.set("http://qudt.org/vocab/unit/OZ-PER-FT2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-PER-GAL_IMP",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("6.236023291443856148910382328550469"),
    undefined,
    undefined,
    undefined,
    undefined,
    "oz/gal{Imp}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ounce Mass per Imperial Gallon", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/OZ-PER-GAL_UK");
  config.units.set("http://qudt.org/vocab/unit/OZ-PER-GAL_IMP", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-PER-GAL_UK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("6.236023291443856148910382328550469"),
    undefined,
    undefined,
    undefined,
    undefined,
    "oz/gal{UK}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ounce Mass per Gallon (UK)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/OZ-PER-GAL_IMP");
  config.units.set("http://qudt.org/vocab/unit/OZ-PER-GAL_UK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-PER-GAL_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("7.48915170730603928399457848784464"),
    undefined,
    undefined,
    undefined,
    undefined,
    "oz/gal{US}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ounce Mass per Us Gallon", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  config.units.set("http://qudt.org/vocab/unit/OZ-PER-GAL_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("0.000007874867534722222222222222222222223"),
    undefined,
    undefined,
    undefined,
    undefined,
    "oz/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ounce Mass per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/OZ-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-PER-IN2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    new Decimal("43.94184872744745489490978981957964"),
    undefined,
    undefined,
    undefined,
    undefined,
    "oz/in²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ounce Mass per Square Inch", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MeanMassRange");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/BodyMassIndex");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SurfaceDensity");
  config.units.set("http://qudt.org/vocab/unit/OZ-PER-IN2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-PER-IN3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("1729.994044387695074602747630692112"),
    undefined,
    undefined,
    undefined,
    undefined,
    "oz/in³",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ounce Mass per Cubic Inch", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  config.units.set("http://qudt.org/vocab/unit/OZ-PER-IN3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("0.0004724920520833333333333333333333334"),
    undefined,
    undefined,
    undefined,
    undefined,
    "oz/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ounce Mass per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/OZ-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("0.028349523125"),
    undefined,
    undefined,
    undefined,
    undefined,
    "oz/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ounce Mass per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/OZ-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-PER-YD2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    new Decimal("0.03390574747488229544360323288547811"),
    undefined,
    undefined,
    undefined,
    undefined,
    "oz/yd²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ounce Mass per Square Yard", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerArea");
  config.units.set("http://qudt.org/vocab/unit/OZ-PER-YD2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-PER-YD3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("0.03707977632861143421216451540406617"),
    undefined,
    undefined,
    undefined,
    undefined,
    "oz/yd³",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ounce Mass per Cubic Yard", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  config.units.set("http://qudt.org/vocab/unit/OZ-PER-YD3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-SEC-PER-IN3-FT3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("61094.16310771159029637291438599294"),
    undefined,
    undefined,
    undefined,
    undefined,
    "oz·s/(in³·ft³)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Ounce Mass Second per Cubic Inch Cubic Foot", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/OZ-SEC-PER-IN3-FT3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-SEC-PER-IN3-GAL_UK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("380545.4895058599971849980160296237"),
    undefined,
    undefined,
    undefined,
    undefined,
    "oz·s/(in³·gal{UK})",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Ounce Mass Second per Cubic Inch Gallon (UK)", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/OZ-SEC-PER-IN3-GAL_UK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-SEC-PER-IN3-GAL_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("457016.0772732711170222181647575575"),
    undefined,
    undefined,
    undefined,
    undefined,
    "oz·s/(in³·gal{US})",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Ounce Mass Second per Cubic Inch Us Gallon", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/OZ-SEC-PER-IN3-GAL_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-SEC-PER-IN3-YD3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("2262.746781767095936902700532814552"),
    undefined,
    undefined,
    undefined,
    undefined,
    "oz·s/(in³·yd³)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Ounce Mass Second per Cubic Inch Cubic Yard", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/OZ-SEC-PER-IN3-YD3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-SEC-PER-IN6",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("105570713.8501256280321323960589958"),
    undefined,
    undefined,
    undefined,
    undefined,
    "oz·s/in⁶",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ounce Mass Second per Sextic Inch", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/OZ-SEC-PER-IN6", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("0.278013875"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/N",
    undefined,
    "ozf",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    2,
    false,
    false
  );
  unit.addLabel(new LangString("Imperial Ounce Force", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Force");
  config.units.set("http://qudt.org/vocab/unit/OZ_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ_F-IN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("0.007061552425"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ozf·in",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Imperial Ounce Force Inch", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MomentOfForce");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Torque");
  config.units.set("http://qudt.org/vocab/unit/OZ_F-IN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ_F-PER-IN3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-2D0",
    new Decimal("16965.44756278488934930625766763345"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ozf/in³",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Imperial Ounce Force per Cubic Inch", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificWeight");
  config.units.set("http://qudt.org/vocab/unit/OZ_F-PER-IN3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ_M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("0.028349523125"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "oz",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ounce Mass", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/OZ");
  config.units.set("http://qudt.org/vocab/unit/OZ_M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ_TROY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("0.0311034768"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "oz{Troy}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS", "http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ounce Troy", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  config.units.set("http://qudt.org/vocab/unit/OZ_TROY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ_VOL_UK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.0000284130625"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M3",
    undefined,
    "oz{UK}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"],
    4,
    false,
    false
  );
  unit.addLabel(new LangString("Fluid Ounce (UK)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/OZ_VOL_UK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ_VOL_UK-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("3.288548900462962962962962962962962E-10"),
    undefined,
    undefined,
    undefined,
    undefined,
    "oz{UK}/d",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Fluid Ounce (UK) per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/OZ_VOL_UK-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ_VOL_UK-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("7.892517361111111111111111111111112E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "oz{UK}/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Fluid Ounce (UK) per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/OZ_VOL_UK-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ_VOL_UK-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("4.735510416666666666666666666666668E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "oz{UK}/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Fluid Ounce (UK) per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/OZ_VOL_UK-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ_VOL_UK-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.0000284130625"),
    undefined,
    undefined,
    undefined,
    undefined,
    "oz{UK}/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Fluid Ounce (UK) per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/OZ_VOL_UK-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ_VOL_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.0000295735296"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M3",
    undefined,
    "fl oz{US}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    4,
    false,
    false
  );
  unit.addLabel(new LangString("Us Liquid Ounce", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LiquidVolume");
  config.units.set("http://qudt.org/vocab/unit/OZ_VOL_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ_VOL_US-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("3.422862222222222222222222222222221E-10"),
    undefined,
    undefined,
    undefined,
    undefined,
    "fl oz{US}/d",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Us Liquid Ounce per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/OZ_VOL_US-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ_VOL_US-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("8.214869333333333333333333333333334E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "fl oz{US}/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Us Liquid Ounce per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/OZ_VOL_US-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ_VOL_US-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("4.928921600000000000000000000000001E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "fl oz{US}/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Us Liquid Ounce per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/OZ_VOL_US-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ_VOL_US-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.0000295735296"),
    undefined,
    undefined,
    undefined,
    undefined,
    "fl oz{US}/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Us Liquid Ounce per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/OZ_VOL_US-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/P",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    true
  );
  unit.addLabel(new LangString("P", undefined));
  config.units.set("http://qudt.org/vocab/unit/P", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Pa",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    83,
    false,
    false
  );
  unit.addLabel(new LangString("Pascal", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ModulusOfElasticity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/BulkModulus");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Fugacity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ShearModulus");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/N-PER-M2");
  config.units.set("http://qudt.org/vocab/unit/PA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PA-L-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Pa·L/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pascal Liter per Second", "en-US"));
  unit.addLabel(new LangString("Pascal Litre per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/PA-L-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PA-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Pa·m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pascal Meter", "en-US"));
  unit.addLabel(new LangString("Pascal Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PA-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PA-M-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Pa·m/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pascal Metre per Second", "en"));
  unit.addLabel(new LangString("Pascal Meter per Second", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PA-M-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PA-M-PER-SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-4D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Pa·m/s²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pascal Metre per Square Second", "en"));
  unit.addLabel(new LangString("Pascal Meter per Square Second", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PA-M-PER-SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PA-M0dot5",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-0dot5I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Pa√m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pascal Square Root Meter", "en-US"));
  unit.addLabel(new LangString("Pascal Square Root Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/StressIntensityFactor"
  );
  config.units.set("http://qudt.org/vocab/unit/PA-M0dot5", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PA-M2-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Pa·m²/kg",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pascal Square Meter per Kilogram", "en-US"));
  unit.addLabel(new LangString("Pascal Square Metre per Kilogram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/BurstFactor");
  config.units.set("http://qudt.org/vocab/unit/PA-M2-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PA-M3-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Pa·m³/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pascal Cubic Meter per Second", "en-US"));
  unit.addLabel(new LangString("Pascal Cubic Metre per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/PA-M3-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PA-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.00001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Pa/bar",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pascal per Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PressureRatio");
  config.units.set("http://qudt.org/vocab/unit/PA-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PA-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-3D0",
    new Decimal("0.0002777777777777777777777777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Pa/h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pascal per Hour", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ForcePerAreaTime"
  );
  config.units.set("http://qudt.org/vocab/unit/PA-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PA-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H-1T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Pa/K",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pascal per Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PressureCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/PA-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PA-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Pa/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pascal per Metre", "en"));
  unit.addLabel(new LangString("Pascal per Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpectralRadiantEnergyDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/PA-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PA-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-3D0",
    new Decimal("0.01666666666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Pa/min",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pascal per Minute", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ForcePerAreaTime"
  );
  config.units.set("http://qudt.org/vocab/unit/PA-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PA-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Pa/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pascal per Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ForcePerAreaTime"
  );
  config.units.set("http://qudt.org/vocab/unit/PA-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PA-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Pa·s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pascal Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DynamicViscosity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Viscosity");
  config.units.set("http://qudt.org/vocab/unit/PA-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PA-SEC-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("0.00001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Pa·s/bar",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pascal Second per Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/PA-SEC-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PA-SEC-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H-1T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Pa·s/K",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pascal Second per Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PA-SEC-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PA-SEC-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-4I0M1H0T-1D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Pa·s/L",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pascal Second per Liter", "en-US"));
  unit.addLabel(new LangString("Pascal Second per Litre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PressureInRelationToVolumeFlowRate"
  );
  config.units.set("http://qudt.org/vocab/unit/PA-SEC-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PA-SEC-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Pa·s/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pascal Second per Metre", "en"));
  unit.addLabel(new LangString("Pascal Second per Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AcousticImpedance"
  );
  config.units.set("http://qudt.org/vocab/unit/PA-SEC-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PA-SEC-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-4I0M1H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Pa·s/m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pascal Second per Cubic Metre", "en"));
  unit.addLabel(new LangString("Pascal Second per Cubic Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PressureInRelationToVolumeFlowRate"
  );
  config.units.set("http://qudt.org/vocab/unit/PA-SEC-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PA2-PER-SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M2H0T-6D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Pa²/s²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Pascal per Square Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PA2-PER-SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PA2-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M2H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Pa²·s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Pascal Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SoundExposure");
  config.units.set("http://qudt.org/vocab/unit/PA2-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PARSEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("30856780000000000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M",
    undefined,
    "pc",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Parsec", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/PARSEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PCA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("0.0042333"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M",
    undefined,
    "pc",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pica", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/PCA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PDL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("0.138254954376"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/N",
    undefined,
    "pdl",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    9,
    false,
    false
  );
  unit.addLabel(new LangString("Poundal", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Force");
  config.units.set("http://qudt.org/vocab/unit/PDL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PDL-FT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("0.0421401100938048"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pdl·ft",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Poundal Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MomentOfForce");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Torque");
  config.units.set("http://qudt.org/vocab/unit/PDL-FT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PDL-IN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("0.0035116758411504"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pdl·in",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Poundal Inch", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MomentOfForce");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Torque");
  config.units.set("http://qudt.org/vocab/unit/PDL-IN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PDL-PER-FT2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("1.488163943569553805774278215223097"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pdl/ft²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Poundal per Square Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/PDL-PER-FT2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PDL-PER-IN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("5.44310844"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pdl/in",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Poundal per Inch", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerLength");
  config.units.set("http://qudt.org/vocab/unit/PDL-PER-IN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PDL-PER-IN2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("214.295607874015748031496062992126"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pdl/in²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Poundal per Square Inch", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ModulusOfLinearSubgradeReaction"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/PDL-PER-IN2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PDL-SEC-PER-FT2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-1D0",
    new Decimal("1.488163943569553805774278215223097"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pdl·s/ft²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Poundal Second per Square Foot", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DynamicViscosity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Viscosity");
  config.units.set("http://qudt.org/vocab/unit/PDL-SEC-PER-FT2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PDL-SEC-PER-IN2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-1D0",
    new Decimal("214.295607874015748031496062992126"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pdl·s/in²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Poundal Second per Square Inch", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DynamicViscosity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Viscosity");
  config.units.set("http://qudt.org/vocab/unit/PDL-SEC-PER-IN2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PENNYWEIGHT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("0.00155517384"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "dwt",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pennyweight", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/DWT");
  config.units.set("http://qudt.org/vocab/unit/PENNYWEIGHT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-ANGSTROM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("10000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/Å",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Angstrom", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseLength");
  config.units.set("http://qudt.org/vocab/unit/PER-ANGSTROM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H0T2D0",
    new Decimal("0.00001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/bar",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Bar", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/IsothermalCompressibility"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InversePressure");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Compressibility");
  config.units.set("http://qudt.org/vocab/unit/PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-CentiM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("100.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/cm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Centimeter", "en-US"));
  unit.addLabel(new LangString("Reciprocal Centimetre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseLength");
  config.units.set("http://qudt.org/vocab/unit/PER-CentiM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-CentiM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/cm³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Cubic Centimetre", "en"));
  unit.addLabel(new LangString("Reciprocal Cubic Centimeter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseVolume");
  config.units.set("http://qudt.org/vocab/unit/PER-CentiM3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("0.00001157407407407407407407407407407407"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/d",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Frequency");
  config.units.set("http://qudt.org/vocab/unit/PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-DEG_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H-1T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/°C",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Degree Celsius", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalExpansionCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/PER-DEG_C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H-1T0D0",
    new Decimal("1.8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/°F",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Degree Fahrenheit", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearExpansionCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalExpansionCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InverseTemperature"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ExpansionRatio");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/RelativePressureCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/PER-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-EV-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-5I0M-1H0T2D0",
    new Decimal("6241509074460762607.776240980930446"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/(eV·m³)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Reciprocal Electron Volt Cubic Meter", "en-US")
  );
  unit.addLabel(new LangString("Reciprocal Electron Volt Cubic Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EnergyDensityOfStates"
  );
  config.units.set("http://qudt.org/vocab/unit/PER-EV-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-EV2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-4I0M-2H0T4D0",
    new Decimal("38956435526576045471002924268900840000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/eV²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Square Electron Volt", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InverseSquareEnergy"
  );
  config.units.set("http://qudt.org/vocab/unit/PER-EV2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-FT3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    new Decimal("35.31466672148859025043801035400263"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/ft³",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Cubic Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseVolume");
  config.units.set("http://qudt.org/vocab/unit/PER-FT3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-GM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/g",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Gram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseMass");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/NUM-PER-GM");
  config.units.set("http://qudt.org/vocab/unit/PER-GM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-GigaEV2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-4I0M-2H0T4D0",
    new Decimal("38956435526576045471.00292426890084"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/GeV²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Square Giga Electron Volt", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InverseSquareEnergy"
  );
  config.units.set("http://qudt.org/vocab/unit/PER-GigaEV2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-H",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-2I0M-1H0T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/H",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Henry", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Reluctance");
  config.units.set("http://qudt.org/vocab/unit/PER-H", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("0.0002777777777777777777777777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Frequency");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/NUM-PER-HR");
  config.units.set("http://qudt.org/vocab/unit/PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-IN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("39.37007874015748031496062992125984"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/in",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Inch", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Repetency");
  config.units.set("http://qudt.org/vocab/unit/PER-IN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-IN2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T0D0",
    new Decimal("1550.0031000062000124000248000496"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/in²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Square Inch", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ParticleFluence");
  config.units.set("http://qudt.org/vocab/unit/PER-IN2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-IN3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    new Decimal("61023.74409473228395275688189171654"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/in³",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Cubic Inch", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseVolume");
  config.units.set("http://qudt.org/vocab/unit/PER-IN3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-J",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M-1H0T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/J",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Joule", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseEnergy");
  config.units.set("http://qudt.org/vocab/unit/PER-J", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-J-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-5I0M-1H0T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/(J·m³)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Joule Cubic Meter", "en-US"));
  unit.addLabel(new LangString("Reciprocal Joule Cubic Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EnergyDensityOfStates"
  );
  config.units.set("http://qudt.org/vocab/unit/PER-J-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-J2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-4I0M-2H0T4D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/J²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Square Joule", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InverseSquareEnergy"
  );
  config.units.set("http://qudt.org/vocab/unit/PER-J2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H-1T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/K",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearExpansionCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ApparentThermalInertia"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalExpansionCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InverseTemperature"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ExpansionRatio");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/RelativePressureCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/kg",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Kilogram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseMass");
  config.units.set("http://qudt.org/vocab/unit/PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-KiloGM-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/(kg·s)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Kilogram Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PER-KiloGM-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-KiloGM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-2H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/kg²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Square Kilogram", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InverseSquareMass"
  );
  config.units.set("http://qudt.org/vocab/unit/PER-KiloGM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-KiloM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/km",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Kilometre", "en"));
  unit.addLabel(new LangString("Reciprocal Kilometer", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CurvatureFromRadius"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearAttenuationCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearAbsorptionCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearIonization"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AngularReciprocalLatticeVector"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PhaseCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AttenuationCoefficient"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseLength");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PropagationCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/PER-KiloM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-KiloV-A-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M-1H0T2D0",
    new Decimal("2.777777777777777777777777777777778E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/(kV·A·h)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("Reciprocal Kilovolt Ampere Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseEnergy");
  config.units.set("http://qudt.org/vocab/unit/PER-KiloV-A-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-KiloVA-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M-1H0T2D0",
    new Decimal("2.777777777777777777777777777777778E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/(kVA·h)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Kilo Volt Ampere Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseEnergy");
  config.units.set("http://qudt.org/vocab/unit/PER-KiloVA-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/L",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Liter", "en-US"));
  unit.addLabel(new LangString("Reciprocal Litre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseVolume");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/NUM-PER-L");
  config.units.set("http://qudt.org/vocab/unit/PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-LB",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T0D0",
    new Decimal("2.20462262184877580722973801345027"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/lbm",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Pound Mass", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseMass");
  config.units.set("http://qudt.org/vocab/unit/PER-LB", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Metre", "en"));
  unit.addLabel(new LangString("Reciprocal Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CurvatureFromRadius"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearAttenuationCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearAbsorptionCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearIonization"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AngularReciprocalLatticeVector"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PhaseCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AttenuationCoefficient"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseLength");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PropagationCoefficient"
  );
  unit.addExactMatchIri("http://qudt.org/vocab/unit/NUM-PER-M");
  config.units.set("http://qudt.org/vocab/unit/PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-M-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H-1T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/(m·K)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Meter Kelvin", "en-US"));
  unit.addLabel(new LangString("Reciprocal Metre Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InverseLengthTemperature"
  );
  config.units.set("http://qudt.org/vocab/unit/PER-M-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-M-NanoM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T0D0",
    new Decimal("1000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/(m·nm)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Metre Nanometre", "en"));
  unit.addLabel(new LangString("Reciprocal Meter Nanometer", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ParticleFluence");
  config.units.set("http://qudt.org/vocab/unit/PER-M-NanoM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-M-NanoM-SR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T0D0",
    new Decimal("1000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/(m·nm·sr)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Reciprocal Meter Nanometer Steradian", "en-US")
  );
  unit.addLabel(new LangString("Reciprocal Metre Nanometre Steradian", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PER-M-NanoM-SR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-M-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/(m·s)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Meter Second", "en-US"));
  unit.addLabel(new LangString("Reciprocal Metre Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PER-M-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-M-SR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/(m·sr)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Meter Steradian", "en-US"));
  unit.addLabel(new LangString("Reciprocal Metre Steradian", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PER-M-SR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Square Meter", "en-US"));
  unit.addLabel(new LangString("Reciprocal Square Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ParticleFluence");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/NUM-PER-M2");
  config.units.set("http://qudt.org/vocab/unit/PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-M2-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/(m²·s)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Square Meter Second", "en-US"));
  unit.addLabel(new LangString("Reciprocal Square Metre Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ParticleFluenceRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Flux");
  config.units.set("http://qudt.org/vocab/unit/PER-M2-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Cubic Meter", "en-US"));
  unit.addLabel(new LangString("Reciprocal Cubic Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseVolume");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/NUM-PER-M3");
  config.units.set("http://qudt.org/vocab/unit/PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-M3-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/(m³·s)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Cubic Meter Second", "en-US"));
  unit.addLabel(new LangString("Reciprocal Cubic Metre Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Slowing-DownDensity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ParticleSourceDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/PER-M3-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-MILLE-PSI",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H0T2D0",
    new Decimal("1.450377E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/ksi",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Mille Psi", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/IsothermalCompressibility"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InversePressure");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Compressibility");
  config.units.set("http://qudt.org/vocab/unit/PER-MILLE-PSI", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("0.01666666666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/min",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Frequency");
  config.units.set("http://qudt.org/vocab/unit/PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-MO",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("3.919350772901616281311709002114104E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/mo",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Month", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Frequency");
  config.units.set("http://qudt.org/vocab/unit/PER-MO", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-MOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A-1E0L0I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/mol",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Mole", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InverseAmountOfSubstance"
  );
  config.units.set("http://qudt.org/vocab/unit/PER-MOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-MegaK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H-1T0D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/MK",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Megakelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearExpansionCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalExpansionCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InverseTemperature"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ExpansionRatio");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/RelativePressureCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/PER-MegaK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-MegaPA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H0T2D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/MPa",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Megapascal", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/IsothermalCompressibility"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/StressOpticCoefficient"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InversePressure");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/IsentropicCompressibility"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Compressibility");
  config.units.set("http://qudt.org/vocab/unit/PER-MegaPA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-MicroM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/μm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Micrometre", "en"));
  unit.addLabel(new LangString("Reciprocal Micrometer", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CurvatureFromRadius"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearAttenuationCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearAbsorptionCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearIonization"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AngularReciprocalLatticeVector"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PhaseCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AttenuationCoefficient"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseLength");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PropagationCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/PER-MicroM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-MicroMOL-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A-1E0L-3I0M0H0T0D0",
    new Decimal("1000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/(μmol·L)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Micromole Liter", "en-US"));
  unit.addLabel(new LangString("Reciprocal Micromole Litre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PER-MicroMOL-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-MilliGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T0D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/mg",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Milligram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseMass");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/NUM-PER-MilliGM");
  config.units.set("http://qudt.org/vocab/unit/PER-MilliGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-MilliL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/mL",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Milliliter", "en-US"));
  unit.addLabel(new LangString("Reciprocal Millilitre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseVolume");
  config.units.set("http://qudt.org/vocab/unit/PER-MilliL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-MilliM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/mm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Millimetre", "en"));
  unit.addLabel(new LangString("Reciprocal Millimeter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CurvatureFromRadius"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearAttenuationCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearAbsorptionCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearIonization"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AngularReciprocalLatticeVector"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PhaseCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AttenuationCoefficient"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseLength");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PropagationCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/PER-MilliM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-MilliM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    new Decimal("1000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/mm³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Cubic Millimeter", "en-US"));
  unit.addLabel(new LangString("Reciprocal Cubic Millimetre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseVolume");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/NUM-PER-MilliM3");
  config.units.set("http://qudt.org/vocab/unit/PER-MilliM3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-MilliSEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/ms",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Millisecond", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Frequency");
  config.units.set("http://qudt.org/vocab/unit/PER-MilliSEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-NanoM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("1000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/nm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Nanometre", "en"));
  unit.addLabel(new LangString("Reciprocal Nanometer", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CurvatureFromRadius"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearAttenuationCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearAbsorptionCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearIonization"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AngularReciprocalLatticeVector"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PhaseCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AttenuationCoefficient"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseLength");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PropagationCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/PER-NanoM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-OZ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T0D0",
    new Decimal("35.27396194958041291567580821520433"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/oz",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Ounce Mass", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseMass");
  config.units.set("http://qudt.org/vocab/unit/PER-OZ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-PA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H0T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/Pa",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Pascal", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/IsothermalCompressibility"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/StressOpticCoefficient"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InversePressure");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/IsentropicCompressibility"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Compressibility");
  config.units.set("http://qudt.org/vocab/unit/PER-PA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-PA-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/(Pa·s)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Pascal Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PER-PA-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-PERCENT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("100.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/%",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Percent", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PER-PERCENT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-PSI",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H0T2D0",
    new Decimal("0.0001450377312227268702148557236386593"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/psi",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Psi", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/IsothermalCompressibility"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/StressOpticCoefficient"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InversePressure");
  config.units.set("http://qudt.org/vocab/unit/PER-PSI", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-PicoM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("1000000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/pm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Picometer", "en-US"));
  unit.addLabel(new LangString("Reciprocal Picometre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CurvatureFromRadius"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearAttenuationCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearAbsorptionCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearIonization"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AngularReciprocalLatticeVector"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PhaseCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AttenuationCoefficient"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseLength");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PropagationCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/PER-PicoM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-PlanckMass2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-2H0T0D0",
    new Decimal("2111089287176721.707084516481080014"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/planckmass²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/PLANCK"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Square Planck Mass", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InverseSquareMass"
  );
  config.units.set("http://qudt.org/vocab/unit/PER-PlanckMass2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-RAD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/rad",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Radian", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PER-RAD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/RotationalFrequency"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Frequency");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/RotationalVelocity"
  );
  unit.addExactMatchIri("http://qudt.org/vocab/unit/HZ");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/SAMPLE-PER-SEC");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/NUM-PER-SEC");
  config.units.set("http://qudt.org/vocab/unit/PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-SEC-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/(s·m²)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Second Square Meter", "en-US"));
  unit.addLabel(new LangString("Reciprocal Second Square Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Flux");
  config.units.set("http://qudt.org/vocab/unit/PER-SEC-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-SEC-M2-SR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/(s·m²·sr)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Reciprocal Second Square Metre Steradian", "en")
  );
  unit.addLabel(
    new LangString("Reciprocal Second Square Meter Steradian", "en-US")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PhotonRadiance");
  config.units.set("http://qudt.org/vocab/unit/PER-SEC-M2-SR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-SEC-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/(s·m³)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Second Cubic Meter", "en-US"));
  unit.addLabel(new LangString("Reciprocal Second Cubic Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Slowing-DownDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/PER-SEC-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-SEC-SR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/(s·sr)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Second Steradian", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TemporalSummationFunction"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PhotonIntensity");
  config.units.set("http://qudt.org/vocab/unit/PER-SEC-SR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-SEC-SR-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/(s·sr·m²)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Reciprocal Second Steradian Square Meter", "en-US")
  );
  unit.addLabel(
    new LangString("Reciprocal Second Steradian Square Metre", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PER-SEC-SR-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/s²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Square Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InverseSquareTime"
  );
  config.units.set("http://qudt.org/vocab/unit/PER-SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-SR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/sr",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Steradian", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PER-SR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-T-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-1I0M-1H0T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/(T·m)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Tesla Metre", "en"));
  unit.addLabel(new LangString("Reciprocal Tesla Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticReluctivity"
  );
  config.units.set("http://qudt.org/vocab/unit/PER-T-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-T-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M-1H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/(T·s)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Tesla Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerMass"
  );
  config.units.set("http://qudt.org/vocab/unit/PER-T-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-TON",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T0D0",
    new Decimal("0.001102311310924387903614869006725135"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/tn",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Ton", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseMass");
  config.units.set("http://qudt.org/vocab/unit/PER-TON", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-TONNE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/t",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Tonne", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseMass");
  config.units.set("http://qudt.org/vocab/unit/PER-TONNE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-V",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M-1H0T3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/V",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Volt", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ReciprocalVoltage"
  );
  config.units.set("http://qudt.org/vocab/unit/PER-V", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-V-A-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M-1H0T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/(V·A·s)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("Reciprocal Volt Ampere Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseEnergy");
  config.units.set("http://qudt.org/vocab/unit/PER-V-A-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-VA-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M-1H0T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/(VA·s)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Volt Ampere Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseEnergy");
  config.units.set("http://qudt.org/vocab/unit/PER-VA-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-WB",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M-1H0T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/Wb",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Weber", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InverseMagneticFlux"
  );
  config.units.set("http://qudt.org/vocab/unit/PER-WB", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-WK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("0.000001653439153439153439153439153439153"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/wk",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Week", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Frequency");
  config.units.set("http://qudt.org/vocab/unit/PER-WK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-YD3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    new Decimal("1.307950619314392231497704087185282"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/yd³",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Cubic Yard", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseVolume");
  config.units.set("http://qudt.org/vocab/unit/PER-YD3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-YR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("3.168808781402895023702689684893655E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/a",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reciprocal Year", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Frequency");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/NUM-PER-YR");
  config.units.set("http://qudt.org/vocab/unit/PER-YR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.01"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/NUM",
    undefined,
    "%",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    60,
    false,
    false
  );
  unit.addLabel(new LangString("Percent", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ResistanceRatio");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VoltageRatio");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/StateOfCharge");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/RelativeHumidity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/TimeRatio");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DutyCycle");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Reflectance");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ServiceFactor");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/RelativePartialPressure"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LuminousFluxRatio"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Emissivity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LengthRatio");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Prevalence");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PressureRatio");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/OpeningRatio");
  config.units.set("http://qudt.org/vocab/unit/PERCENT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-FT-HR-PER-LB",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H0T1D0",
    new Decimal("24.19088310502224717757046927398712"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%·ft·h/lbm",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Percent Foot Hour per Pound Mass", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-FT-HR-PER-LB", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-FT-SEC-PER-LB",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H0T1D0",
    new Decimal("0.006719689751395068660436241464996423"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%·ft·s/lbm",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Percent Foot Second per Pound Mass", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-FT-SEC-PER-LB", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-FT2-PER-LB_F-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H0T1D0",
    new Decimal("0.0002088543329607266931093922420396694"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%·ft²/(lbf·s)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Percent Square Foot per Pound Force Second", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Fluidity");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-FT2-PER-LB_F-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-HR-PER-CentiM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T1D0",
    new Decimal("36000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%·h/cm³",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Percent Hour per Cubic Centimeter", "en-US"));
  unit.addLabel(new LangString("Percent Hour per Cubic Centimetre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-HR-PER-CentiM3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-HR-PER-FT3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T1D0",
    new Decimal("1271.328001973589249015768372744095"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%·h/ft³",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Percent Hour per Cubic Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-HR-PER-FT3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-HR-PER-GAL_UK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T1D0",
    new Decimal("7918.892938767160350982932586024475"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%·h/gal{UK}",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Percent Hour per Gallon (UK)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-HR-PER-GAL_UK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-HR-PER-GAL_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T1D0",
    new Decimal("9510.19388489334295367639717792985"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%·h/gal{US}",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Percent Hour per Us Gallon", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-HR-PER-GAL_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-HR-PER-IN3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T1D0",
    new Decimal("2196854.787410362222299247748101795"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%·h/in³",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Percent Hour per Cubic Inch", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-HR-PER-IN3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-HR-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T1D0",
    new Decimal("36000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%·h/L",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Percent Hour per Liter", "en-US"));
  unit.addLabel(new LangString("Percent Hour per Litre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-HR-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-HR-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T1D0",
    new Decimal("36.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%·h/m³",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Percent Hour per Cubic Metre", "en"));
  unit.addLabel(new LangString("Percent Hour per Cubic Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-HR-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-HR-PER-YD3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T1D0",
    new Decimal("47.08622229531812033391734713867015"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%·h/yd³",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Percent Hour per Cubic Yard", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-HR-PER-YD3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-IN2-PER-LB_F-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H0T1D0",
    new Decimal("0.000001450377312227268702148557236386593"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%·in²/(lbf·s)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Percent Square Inch per Pound Force Second", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Fluidity");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-IN2-PER-LB_F-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-MIN-PER-CentiM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T1D0",
    new Decimal("600000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%·min/cm³",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Percent Minute per Cubic Centimetre", "en"));
  unit.addLabel(new LangString("Percent Minute per Cubic Centimeter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-MIN-PER-CentiM3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-MIN-PER-FT3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T1D0",
    new Decimal("21.18880003289315415026280621240158"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%·min/ft³",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Percent Minute per Cubic Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-MIN-PER-FT3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-MIN-PER-GAL_UK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T1D0",
    new Decimal("131.9815489794526725163822097670746"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%·min/gal{UK}",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Percent Minute per Gallon (UK)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-MIN-PER-GAL_UK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-MIN-PER-GAL_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T1D0",
    new Decimal("158.5032314148890492279399529654975"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%·min/gal{US}",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Percent Minute per Us Gallon", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-MIN-PER-GAL_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-MIN-PER-IN3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T1D0",
    new Decimal("36614.24645683937037165412913502992"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%·min/in³",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Percent Minute per Cubic Inch", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-MIN-PER-IN3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-MIN-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T1D0",
    new Decimal("600.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%·min/L",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Percent Minute per Liter", "en-US"));
  unit.addLabel(new LangString("Percent Minute per Litre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-MIN-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-MIN-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T1D0",
    new Decimal("0.6"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%·min/m³",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Percent Minute per Cubic Metre", "en"));
  unit.addLabel(new LangString("Percent Minute per Cubic Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-MIN-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-MIN-PER-YD3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T1D0",
    new Decimal("0.7847703715886353388986224523111692"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%·min/yd³",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Percent Minute per Cubic Yard", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-MIN-PER-YD3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-PER-100KiloCount",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/100k",
    undefined,
    undefined,
    undefined,
    [],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("Percent per One Hundred Thousand", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-PER-100KiloCount", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-PER-10KiloCount",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/10k",
    undefined,
    undefined,
    undefined,
    [],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("Percent per Ten Thousand", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-PER-10KiloCount", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H0T2D0",
    new Decimal("1E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/bar",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Percent per Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Compressibility");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-PER-CentiPOISE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H0T1D0",
    new Decimal("10.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/cP",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Percent per Centipoise", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-PER-CentiPOISE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("1.157407407407407407407407407407407E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/d",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Percent per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Frequency");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-PER-DEG",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.5729577957855229894302178227976183"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/°",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Percent per Degree", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-PER-DEG", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-PER-DEG_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H-1T0D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/°C",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Percent per Degree Celsius", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalExpansionCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/PERCENT-PER-DEG_C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-PER-DecaK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H-1T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/daK",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Percent per Decakelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearExpansionCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/PERCENT-PER-DecaK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-PER-DecaKiloCOUNT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/10000",
    undefined,
    undefined,
    undefined,
    [],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("Percent per Ten Thousand", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set(
    "http://qudt.org/vocab/unit/PERCENT-PER-DecaKiloCOUNT",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("0.000002777777777777777777777777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/h",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Percent per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Frequency");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-PER-HUNDRED",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.0001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/100",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Percent per Hundred", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-PER-HUNDRED", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-PER-HUNDRED-THOUSAND",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/100k",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Percent per Hundred Thousand", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set(
    "http://qudt.org/vocab/unit/PERCENT-PER-HUNDRED-THOUSAND",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-PER-HectoBAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H0T2D0",
    new Decimal("1E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/hbar",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Percent per Hectobar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Compressibility");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-PER-HectoBAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-PER-HectoCOUNT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.0001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/100",
    undefined,
    undefined,
    undefined,
    [],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("Percent per Hundred", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-PER-HectoCOUNT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-PER-HectoKiloCOUNT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/100k",
    undefined,
    undefined,
    undefined,
    [],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("Percent per One Hundred Thousand", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set(
    "http://qudt.org/vocab/unit/PERCENT-PER-HectoKiloCOUNT",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-PER-IN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("0.3937007874015748031496062992125984"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/in",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Percent per Inch", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Repetency");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-PER-IN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H-1T0D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/K",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Percent per Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearExpansionCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/PERCENT-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-PER-KiloCOUNT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.00001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/1000",
    undefined,
    undefined,
    undefined,
    [],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("Percent per Thousand", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-PER-KiloCOUNT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/m",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Percent per Meter", "en-US"));
  unit.addLabel(new LangString("Percent per Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AttenuationCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/PERCENT-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-PER-MO",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("3.919350772901616281311709002114104E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/mo",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Percent per Month", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Frequency");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-PER-MO", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-PER-MilliM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("10.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/mm",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Percent per Millimeter", "en-US"));
  unit.addLabel(new LangString("Percent per Millimetre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Repetency");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-PER-MilliM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-PER-MilliPA-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H0T1D0",
    new Decimal("10.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/(mPa·s)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Percent per Millipascal Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-PER-MilliPA-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-PER-OHM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-2I0M-1H0T3D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/Ω",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Percent per Ohm", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-PER-OHM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-PER-PA-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H0T1D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/(Pa·s)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Percent per Pascal Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-PER-PA-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-PER-PERCENT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/%",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Percent per Percent", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-PER-PERCENT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-PER-POISE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H0T1D0",
    new Decimal("0.1"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/P",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Percent per Poise", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-PER-POISE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-PER-TEN-THOUSAND",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/10000",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Percent per Ten Thousand", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-PER-TEN-THOUSAND", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-PER-THOUSAND",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.00001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/1000",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Percent per Thousand", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-PER-THOUSAND", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-PER-V",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M-1H0T3D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/V",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Percent per Volt", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-PER-V", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-PER-WK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("1.653439153439153439153439153439153E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/wk",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Percent per Week", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Frequency");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-PER-WK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-PER-YR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("3.168808781402895023702689684893655E-10"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/a",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Percent per Year", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Frequency");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-PER-YR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-SEC-PER-CentiM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T1D0",
    new Decimal("10000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%·s/cm³",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Percent Second per Cubic Centimeter", "en-US"));
  unit.addLabel(new LangString("Percent Second per Cubic Centimetre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-SEC-PER-CentiM3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-SEC-PER-FT3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T1D0",
    new Decimal("0.3531466672148859025043801035400263"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%·s/ft³",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Percent Second per Cubic Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-SEC-PER-FT3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-SEC-PER-GAL_UK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T1D0",
    new Decimal("2.199692482990877875273036829451243"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%·s/gal{UK}",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Percent Second per Gallon (UK)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-SEC-PER-GAL_UK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-SEC-PER-GAL_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T1D0",
    new Decimal("2.641720523581484153798999216091625"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%·s/gal{US}",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Percent Second per Us Gallon", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-SEC-PER-GAL_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-SEC-PER-IN3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T1D0",
    new Decimal("610.2374409473228395275688189171654"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%·s/in³",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Percent Second per Cubic Inch", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-SEC-PER-IN3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-SEC-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T1D0",
    new Decimal("10.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%·s/L",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Percent Second per Liter", "en-US"));
  unit.addLabel(new LangString("Percent Second per Litre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-SEC-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-SEC-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T1D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%·s/m³",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Percent Second per Cubic Meter", "en-US"));
  unit.addLabel(new LangString("Percent Second per Cubic Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-SEC-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-SEC-PER-YD3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T1D0",
    new Decimal("0.01307950619314392231497704087185282"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%·s/yd³",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Percent Second per Cubic Yard", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-SEC-PER-YD3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT_RH",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.01"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/NUM",
    undefined,
    "%RH",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Percent Relative Humidity", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/RelativeHumidity"
  );
  config.units.set("http://qudt.org/vocab/unit/PERCENT_RH", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERMEABILITY_EM_REL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μₜ",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-EMU"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Relative Electromagnetic Permeability", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectromagneticPermeabilityRatio"
  );
  config.units.set("http://qudt.org/vocab/unit/PERMEABILITY_EM_REL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERMEABILITY_REL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.00000125663706"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/NUM",
    undefined,
    "kᵣ",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-EMU"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Relative Permeability", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PermeabilityRatio"
  );
  config.units.set("http://qudt.org/vocab/unit/PERMEABILITY_REL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERMITTIVITY_REL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("8.854187817E-12"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/NUM",
    undefined,
    "εᵣ",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Relative Permittivity", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.units.set("http://qudt.org/vocab/unit/PERMITTIVITY_REL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERM_0DEG_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T1D0",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "perm (0 °C)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("Perm (0 °C)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VapourPermeance");
  config.units.set("http://qudt.org/vocab/unit/PERM_0DEG_C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERM_23DEG_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T1D0",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "perm (23 °C)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("Perm (23 °C)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VapourPermeance");
  config.units.set("http://qudt.org/vocab/unit/PERM_23DEG_C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERM_Metric",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T1D0",
    new Decimal("1E-12"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/SEC-PER-M",
    undefined,
    "perm{Metric}",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Metric Perm", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VapourPermeance");
  config.units.set("http://qudt.org/vocab/unit/PERM_Metric", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERM_Metric_0DEG_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T1D0",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "perm (0 °C)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("Perm (0 °C)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VapourPermeance");
  config.units.set("http://qudt.org/vocab/unit/PERM_Metric_0DEG_C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERM_Metric_23DEG_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T1D0",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "perm (23 °C)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("Perm (23 °C)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VapourPermeance");
  config.units.set("http://qudt.org/vocab/unit/PERM_Metric_23DEG_C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERM_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T1D0",
    new Decimal("5.72135E-11"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/SEC-PER-M",
    undefined,
    "perm{US}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("U.s. Perm", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VapourPermeance");
  config.units.set("http://qudt.org/vocab/unit/PERM_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PFERDESTAERKE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("735.49875"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/W",
    undefined,
    "PS",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pferdestaerke", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/PFERDESTAERKE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PFUND",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("0.5"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "pfd",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pfund", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  config.units.set("http://qudt.org/vocab/unit/PFUND", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PH",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pH",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Acidity", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Basicity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Acidity");
  config.units.set("http://qudt.org/vocab/unit/PH", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PHON",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "phon",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Phon", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoundPressureLevel"
  );
  config.units.set("http://qudt.org/vocab/unit/PHON", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PHOT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I1M0H0T0D0",
    new Decimal("10000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/CD-PER-M2",
    undefined,
    "ph",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Phot", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LuminousFluxPerArea"
  );
  config.units.set("http://qudt.org/vocab/unit/PHOT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PINT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.00056826125"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M3",
    undefined,
    "pt",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Imperial Pint", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/PINT_UK");
  config.units.set("http://qudt.org/vocab/unit/PINT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PINT_UK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.00056826125"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pt{UK}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"],
    4,
    false,
    false
  );
  unit.addLabel(new LangString("Pint (UK)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/PINT");
  config.units.set("http://qudt.org/vocab/unit/PINT_UK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PINT_UK-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("6.577097800925925925925925925925924E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pt{UK}/d",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pint (UK) per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/PINT_UK-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PINT_UK-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("1.578503472222222222222222222222222E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pt{UK}/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pint (UK) per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/PINT_UK-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PINT_UK-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.000009471020833333333333333333333333335"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pt{UK}/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pint (UK) per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/PINT_UK-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PINT_UK-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.00056826125"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pt{UK}/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pint (UK) per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/PINT_UK-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PINT_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.000473176473"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pt{US}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    4,
    false,
    false
  );
  unit.addLabel(new LangString("Us Liquid Pint", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LiquidVolume");
  config.units.set("http://qudt.org/vocab/unit/PINT_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PINT_US-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("5.476579548611111111111111111111109E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pt{US}/d",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Us Liquid Pint per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/PINT_US-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PINT_US-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("1.314379091666666666666666666666667E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pt{US}/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Us Liquid Pint per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/PINT_US-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PINT_US-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.000007886274550000000000000000000000002"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pt{US}/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Us Liquid Pint per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/PINT_US-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PINT_US-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.000473176473"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pt{US}/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Us Liquid Pint per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/PINT_US-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PINT_US_DRY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.000550610471"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M3",
    undefined,
    "pt{US Dry}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Us Dry Pint", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DryVolume");
  config.units.set("http://qudt.org/vocab/unit/PINT_US_DRY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PIXEL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pixel",
    undefined,
    undefined,
    undefined,
    [],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("Pixel", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PictureElement");
  config.units.set("http://qudt.org/vocab/unit/PIXEL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PIXEL_AREA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pixel (area)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Area");
  config.units.set("http://qudt.org/vocab/unit/PIXEL_AREA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PIXEL_COUNT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pixel (count)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Count");
  config.units.set("http://qudt.org/vocab/unit/PIXEL_COUNT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PK_UK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.009092181"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M3",
    undefined,
    "peck{UK}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"],
    4,
    false,
    false
  );
  unit.addLabel(new LangString("Peck (UK)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/PK_UK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PK_UK-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("1.052335763888888888888888888888889E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "peck{UK}/d",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Peck (UK) per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/PK_UK-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PK_UK-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.000002525605833333333333333333333333334"),
    undefined,
    undefined,
    undefined,
    undefined,
    "peck{UK}/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Peck (UK) per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/PK_UK-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PK_UK-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.00015153635"),
    undefined,
    undefined,
    undefined,
    undefined,
    "peck{UK}/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Peck (UK) per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/PK_UK-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PK_UK-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.009092181"),
    undefined,
    undefined,
    undefined,
    undefined,
    "peck{UK}/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Peck (UK) per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/PK_UK-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PK_US_DRY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.00880976754"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M3",
    undefined,
    "peck{US Dry}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    4,
    false,
    false
  );
  unit.addLabel(new LangString("Us Peck", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DryVolume");
  config.units.set("http://qudt.org/vocab/unit/PK_US_DRY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PK_US_DRY-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("1.019649020833333333333333333333333E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "peck{US Dry}/d",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Us Peck per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/PK_US_DRY-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PK_US_DRY-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.00000244715765"),
    undefined,
    undefined,
    undefined,
    undefined,
    "peck{US Dry}/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Us Peck per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/PK_US_DRY-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PK_US_DRY-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.000146829459"),
    undefined,
    undefined,
    undefined,
    undefined,
    "peck{US Dry}/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Us Peck per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/PK_US_DRY-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PK_US_DRY-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.00880976754"),
    undefined,
    undefined,
    undefined,
    undefined,
    "peck{US Dry}/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Us Peck per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/PK_US_DRY-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/POISE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-1D0",
    new Decimal("0.1"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC",
    undefined,
    "P",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-GAUSS", "http://qudt.org/vocab/sou/CGS"],
    12,
    false,
    false
  );
  unit.addLabel(new LangString("Poise", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DynamicViscosity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Viscosity");
  config.units.set("http://qudt.org/vocab/unit/POISE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/POISE-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "P/bar",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Poise per Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/POISE-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/POISE-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H-1T-1D0",
    new Decimal("0.1"),
    undefined,
    undefined,
    undefined,
    undefined,
    "P/K",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Poise per Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/POISE-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/POISE-PER-PA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("0.1"),
    undefined,
    undefined,
    undefined,
    undefined,
    "P/Pa",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Poise per Pascal", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/POISE-PER-PA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/POND",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("0.00980665"),
    undefined,
    undefined,
    undefined,
    undefined,
    "p",
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Pond", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Force");
  config.units.set("http://qudt.org/vocab/unit/POND", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PPB",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1E-9"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/NUM",
    undefined,
    "PPB",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Parts per Billion", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstanceFraction"
  );
  config.units.set("http://qudt.org/vocab/unit/PPB", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PPM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.000001"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/NUM",
    undefined,
    "PPM",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Parts per Million", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstanceFraction"
  );
  config.units.set("http://qudt.org/vocab/unit/PPM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PPM-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H-1T0D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "PPM/K",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Parts per Million per Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalExpansionCoefficient"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ExpansionRatio");
  config.units.set("http://qudt.org/vocab/unit/PPM-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PPQ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1E-16"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/NUM",
    undefined,
    "ppq",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Part per Quadrillion", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstanceFraction"
  );
  config.units.set("http://qudt.org/vocab/unit/PPQ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PPT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1E-12"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/NUM",
    undefined,
    "ppt",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Part per Trillion", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstanceFraction"
  );
  config.units.set("http://qudt.org/vocab/unit/PPT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PPTH",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.001"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/NUM",
    undefined,
    "‰",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Parts per Thousand", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstanceFraction"
  );
  config.units.set("http://qudt.org/vocab/unit/PPTH", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PPTH-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("2.777777777777777777777777777777778E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "‰/h",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Parts per Thousand per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Frequency");
  config.units.set("http://qudt.org/vocab/unit/PPTH-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PPTM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1E-7"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/NUM",
    undefined,
    "PPTM",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Parts per Ten Million", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstanceFraction"
  );
  config.units.set("http://qudt.org/vocab/unit/PPTM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PPTM-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H-1T0D0",
    new Decimal("1E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "PPTM/K",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Parts per Ten Million per Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalExpansionCoefficient"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ExpansionRatio");
  config.units.set("http://qudt.org/vocab/unit/PPTM-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PPTR_VOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1E-12"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/NUM",
    undefined,
    "pptr",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("Parts per Trillion by Volume", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PPTR_VOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PPT_VOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1E-12"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/NUM",
    undefined,
    "ppt (volume)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Parts per Trillion by Volume", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PPT_VOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PSI",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("6894.757602518976377952755905511811"),
    undefined,
    undefined,
    undefined,
    undefined,
    "psi",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    25,
    false,
    false
  );
  unit.addLabel(new LangString("Psi", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ModulusOfElasticity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ShearModulus");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/LB_F-PER-IN2");
  config.units.set("http://qudt.org/vocab/unit/PSI", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PSI-IN3-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("0.11298483409696502712"),
    undefined,
    undefined,
    undefined,
    undefined,
    "psi·in³/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Psi Cubic Inch per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/PSI-IN3-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PSI-L-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("6.894757602518976377952755905511811"),
    undefined,
    undefined,
    undefined,
    undefined,
    "psi·L/s",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Psi Litre per Second", "en"));
  unit.addLabel(new LangString("Psi Liter per Second", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/PSI-L-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PSI-M3-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("6894.757602518976377952755905511811"),
    undefined,
    undefined,
    undefined,
    undefined,
    "psi·m³/s",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Psi Cubic Metre per Second", "en"));
  unit.addLabel(new LangString("Psi Cubic Meter per Second", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/PSI-M3-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PSI-PER-IN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-2D0",
    new Decimal("271447.1497054715109430218860437721"),
    undefined,
    undefined,
    undefined,
    undefined,
    "psi/in",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Psi per Inch", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PressureGradient"
  );
  config.units.set("http://qudt.org/vocab/unit/PSI-PER-IN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PSI-PER-PSI",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "psi/psi",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Psi per Psi", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PressureRatio");
  config.units.set("http://qudt.org/vocab/unit/PSI-PER-PSI", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PSI-YD3-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("5271.42041962800030531072"),
    undefined,
    undefined,
    undefined,
    undefined,
    "psi·yd³/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Psi Cubic Yard per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/PSI-YD3-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PSU",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "PSU",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Practical Salinity Unit", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.units.set("http://qudt.org/vocab/unit/PSU", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("0.0000254"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M",
    undefined,
    "pt",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Point", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/PT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PT_BIG",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("0.0003527778"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M",
    undefined,
    "pb",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Big Point", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Distance");
  config.units.set("http://qudt.org/vocab/unit/PT_BIG", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PebiBIT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("87267165460724.59169291379527415124"),
    undefined,
    "http://qudt.org/vocab/prefix/Pebi",
    "http://qudt.org/vocab/unit/BIT",
    undefined,
    "Pib",
    undefined,
    undefined,
    undefined,
    [],
    3,
    false,
    false
  );
  unit.addLabel(new LangString("Pebibit", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InformationEntropy"
  );
  config.units.set("http://qudt.org/vocab/unit/PebiBIT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PebiBIT-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("87267165460724.59169291379527415124"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Pib/m",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pebibit per Metre", "en"));
  unit.addLabel(new LangString("Pebibit per Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearBitDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/PebiBIT-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PebiBIT-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T0D0",
    new Decimal("87267165460724.59169291379527415124"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Pib/m²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pebibit per Square Meter", "en-US"));
  unit.addLabel(new LangString("Pebibit per Square Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AreaBitDensity");
  config.units.set("http://qudt.org/vocab/unit/PebiBIT-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PebiBIT-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    new Decimal("87267165460724.59169291379527415124"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Pib/m³",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pebibit per Cubic Meter", "en-US"));
  unit.addLabel(new LangString("Pebibit per Cubic Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/VolumetricBitDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/PebiBIT-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PebiBYTE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("698137323685796.73354331036219321"),
    undefined,
    "http://qudt.org/vocab/prefix/Pebi",
    "http://qudt.org/vocab/unit/BYTE",
    undefined,
    "PiB",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pebibyte", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InformationEntropy"
  );
  config.units.set("http://qudt.org/vocab/unit/PebiBYTE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/Pennyweight",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("0.00155517384"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "dwt",
    undefined,
    undefined,
    undefined,
    [],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("Pennyweight", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/DWT");
  config.units.set("http://qudt.org/vocab/unit/Pennyweight", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PetaA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T0D0",
    new Decimal("1000000000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Peta",
    "http://qudt.org/vocab/unit/A",
    undefined,
    "PA",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Petaampere", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/CurrentLinkage");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagnetomotiveForce"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MagneticTension");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCurrent");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/TotalCurrent");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DisplacementCurrent"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentPhasor"
  );
  config.units.set("http://qudt.org/vocab/unit/PetaA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PetaBIT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("693147180559945.30941723212145818"),
    undefined,
    "http://qudt.org/vocab/prefix/Peta",
    "http://qudt.org/vocab/unit/BIT",
    undefined,
    "Pb",
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Petabit", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DatasetOfBits");
  config.units.set("http://qudt.org/vocab/unit/PetaBIT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PetaBIT-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("693147180559945.30941723212145818"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Pb/s",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Petabit per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DataRate");
  config.units.set("http://qudt.org/vocab/unit/PetaBIT-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PetaBQ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("1000000000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Peta",
    "http://qudt.org/vocab/unit/BQ",
    undefined,
    "PBq",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Petabecquerel", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Activity");
  config.units.set("http://qudt.org/vocab/unit/PetaBQ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PetaBYTE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("5545177444479562.47533785697166544"),
    undefined,
    "http://qudt.org/vocab/prefix/Peta",
    "http://qudt.org/vocab/unit/BYTE",
    undefined,
    "PB",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Petabyte", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InformationEntropy"
  );
  config.units.set("http://qudt.org/vocab/unit/PetaBYTE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PetaC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("1000000000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Peta",
    "http://qudt.org/vocab/unit/C",
    undefined,
    "PC",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Petacoulomb", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  config.units.set("http://qudt.org/vocab/unit/PetaC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PetaFLOPS",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("1000000000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Peta",
    "http://qudt.org/vocab/unit/FLOPS",
    undefined,
    "PFLOPS",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Peta Floating Point Operations per Second", "en")
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/FloatingPointCalculationCapability"
  );
  config.units.set("http://qudt.org/vocab/unit/PetaFLOPS", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PetaHZ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("1000000000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Peta",
    "http://qudt.org/vocab/unit/HZ",
    undefined,
    "PHz",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Petahertz", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Frequency");
  config.units.set("http://qudt.org/vocab/unit/PetaHZ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PetaJ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1000000000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Peta",
    "http://qudt.org/vocab/unit/J",
    undefined,
    "PJ",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Petajoule", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/PetaJ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PetaJ-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1000000000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "PJ/s",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Petajoule per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/PetaJ-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PetaV",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-3D0",
    new Decimal("1000000000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Peta",
    "http://qudt.org/vocab/unit/V",
    undefined,
    "PV",
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Petavolt", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotential"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Voltage");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EnergyPerElectricCharge"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotentialDifference"
  );
  config.units.set("http://qudt.org/vocab/unit/PetaV", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PetaV-A",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1000000000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "PV·A",
    undefined,
    undefined,
    undefined,
    [],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("Petavolt Ampere", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ApparentPower");
  config.units.set("http://qudt.org/vocab/unit/PetaV-A", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PetaVA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1000000000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Peta",
    "http://qudt.org/vocab/unit/VA",
    undefined,
    "PVA",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Peta Volt Ampere", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ApparentPower");
  config.units.set("http://qudt.org/vocab/unit/PetaVA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PetaW",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1000000000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Peta",
    "http://qudt.org/vocab/unit/W",
    undefined,
    "PW",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Petawatt", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/PetaW", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T0D0",
    new Decimal("1E-12"),
    undefined,
    "http://qudt.org/vocab/prefix/Pico",
    "http://qudt.org/vocab/unit/A",
    undefined,
    "pA",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    2,
    false,
    false
  );
  unit.addLabel(new LangString("Picoampere", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCurrent");
  config.units.set("http://qudt.org/vocab/unit/PicoA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoA-PER-HectoPA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L1I0M-1H0T2D0",
    new Decimal("1E-14"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pA/hPa",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Picoampere per Hectopascal", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PicoA-PER-HectoPA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoA-PER-MicroMOL-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A-1E1L-3I0M0H0T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pA/(μmol·L)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Picoampere per Micromole Liter", "en-US"));
  unit.addLabel(new LangString("Picoampere per Micromole Litre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PicoA-PER-MicroMOL-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("1E-12"),
    undefined,
    "http://qudt.org/vocab/prefix/Pico",
    "http://qudt.org/vocab/unit/C",
    undefined,
    "pC",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Picocoulomb", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  config.units.set("http://qudt.org/vocab/unit/PicoC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoFARAD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-2I0M-1H0T4D0",
    new Decimal("1E-12"),
    undefined,
    "http://qudt.org/vocab/prefix/Pico",
    "http://qudt.org/vocab/unit/FARAD",
    undefined,
    "pF",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Picofarad", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Capacitance");
  config.units.set("http://qudt.org/vocab/unit/PicoFARAD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoFARAD-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-3I0M-1H0T4D0",
    new Decimal("1E-12"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pF/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Picofarad per Meter", "en-US"));
  unit.addLabel(new LangString("Picofarad per Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Permittivity");
  config.units.set("http://qudt.org/vocab/unit/PicoFARAD-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("1E-15"),
    undefined,
    "http://qudt.org/vocab/prefix/Pico",
    "http://qudt.org/vocab/unit/GM",
    undefined,
    "pg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    5,
    false,
    false
  );
  unit.addLabel(new LangString("Picogram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  config.units.set("http://qudt.org/vocab/unit/PicoGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoGM-PER-GM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1E-12"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pg/g",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Picogram per Gram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassRatio");
  config.units.set("http://qudt.org/vocab/unit/PicoGM-PER-GM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoGM-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1E-15"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pg/kg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Picogram per Kilogram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassRatio");
  config.units.set("http://qudt.org/vocab/unit/PicoGM-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoGM-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("1E-12"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pg/L",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Picogram per Liter", "en-US"));
  unit.addLabel(new LangString("Picogram per Litre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  config.units.set("http://qudt.org/vocab/unit/PicoGM-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoGM-PER-MilliGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pg/mg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Picogram per Milligram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassRatio");
  config.units.set("http://qudt.org/vocab/unit/PicoGM-PER-MilliGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoGM-PER-MilliL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("1E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pg/mL",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Picogram per Milliliter", "en-US"));
  unit.addLabel(new LangString("Picogram per Millilitre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassConcentration"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  config.units.set("http://qudt.org/vocab/unit/PicoGM-PER-MilliL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoH",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H0T-2D0",
    new Decimal("1E-12"),
    undefined,
    "http://qudt.org/vocab/prefix/Pico",
    "http://qudt.org/vocab/unit/H",
    undefined,
    "pH",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Picohenry", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Inductance");
  config.units.set("http://qudt.org/vocab/unit/PicoH", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoJ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1E-12"),
    undefined,
    "http://qudt.org/vocab/prefix/Pico",
    "http://qudt.org/vocab/unit/J",
    undefined,
    "pJ",
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Picojoule", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LagrangeFunction"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LevelWidth");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ThermalEnergy");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/HamiltonFunction"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ExchangeIntegral"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/PicoJ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoJ-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1E-12"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pJ/s",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Picojoule per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/PicoJ-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoKAT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T-1D0",
    new Decimal("1E-12"),
    undefined,
    "http://qudt.org/vocab/prefix/Pico",
    "http://qudt.org/vocab/unit/KAT",
    undefined,
    "pkat",
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Picokatal", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CatalyticActivity"
  );
  config.units.set("http://qudt.org/vocab/unit/PicoKAT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoKAT-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T-1D0",
    new Decimal("1E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pkat/L",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Picokatal per Liter", "en-US"));
  unit.addLabel(new LangString("Picokatal per Litre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CatalyticActivityConcentration"
  );
  config.units.set("http://qudt.org/vocab/unit/PicoKAT-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("1E-15"),
    undefined,
    "http://qudt.org/vocab/prefix/Pico",
    "http://qudt.org/vocab/unit/L",
    undefined,
    "pL",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Picolitre", "en"));
  unit.addLabel(new LangString("Picoliter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/PicoL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("1E-12"),
    undefined,
    "http://qudt.org/vocab/prefix/Pico",
    "http://qudt.org/vocab/unit/M",
    undefined,
    "pm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Picometre", "en"));
  unit.addLabel(new LangString("Picometer", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/PicoM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoMOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T0D0",
    new Decimal("1E-12"),
    undefined,
    "http://qudt.org/vocab/prefix/Pico",
    "http://qudt.org/vocab/unit/MOL",
    undefined,
    "pmol",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    8,
    false,
    false
  );
  unit.addLabel(new LangString("Picomole", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstance"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ExtentOfReaction"
  );
  config.units.set("http://qudt.org/vocab/unit/PicoMOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoMOL-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M-1H0T0D0",
    new Decimal("1E-12"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pmol/kg",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Picomole per Kilogram", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstancePerMass"
  );
  config.units.set("http://qudt.org/vocab/unit/PicoMOL-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoMOL-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T0D0",
    new Decimal("1E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pmol/L",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Picomole per Litre", "en"));
  unit.addLabel(new LangString("Picomole per Liter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Concentration");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/WaterSolubility");
  config.units.set("http://qudt.org/vocab/unit/PicoMOL-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoMOL-PER-L-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T-1D0",
    new Decimal("1.157407407407407407407407407407407E-14"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pmol/(L·d)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Picomole per Liter Day", "en-US"));
  unit.addLabel(new LangString("Picomole per Litre Day", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CatalyticActivityConcentration"
  );
  config.units.set("http://qudt.org/vocab/unit/PicoMOL-PER-L-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoMOL-PER-L-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T-1D0",
    new Decimal("2.777777777777777777777777777777778E-13"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pmol/(L·h)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Picomole per Liter Hour", "en-US"));
  unit.addLabel(new LangString("Picomole per Litre Hour", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CatalyticActivityConcentration"
  );
  config.units.set("http://qudt.org/vocab/unit/PicoMOL-PER-L-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoMOL-PER-M-W-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M-1H0T2D0",
    new Decimal("1E-12"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pmol/(m·W·s)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Picomole per Meter Watt Second", "en-US"));
  unit.addLabel(new LangString("Picomole per Metre Watt Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PicoMOL-PER-M-W-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoMOL-PER-M2-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-2I0M0H0T-1D0",
    new Decimal("1.157407407407407407407407407407407E-17"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pmol/(m²·d)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Picomole per Square Meter Day", "en-US"));
  unit.addLabel(new LangString("Picomole per Square Metre Day", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PhotosyntheticPhotonFluxDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/PicoMOL-PER-M2-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoMOL-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T0D0",
    new Decimal("1E-12"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pmol/m³",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Picomole per Cubic Metre", "en"));
  unit.addLabel(new LangString("Picomole per Cubic Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Concentration");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/WaterSolubility");
  config.units.set("http://qudt.org/vocab/unit/PicoMOL-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoMOL-PER-M3-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T-1D0",
    new Decimal("1E-12"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pmol/(m³·s)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Picomole per Cubic Meter Second", "en-US"));
  unit.addLabel(new LangString("Picomole per Cubic Metre Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CatalyticActivityConcentration"
  );
  config.units.set("http://qudt.org/vocab/unit/PicoMOL-PER-M3-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoPA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("1E-12"),
    undefined,
    "http://qudt.org/vocab/prefix/Pico",
    "http://qudt.org/vocab/unit/PA",
    undefined,
    "pPa",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Picopascal", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ModulusOfElasticity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/BulkModulus");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Fugacity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ShearModulus");
  config.units.set("http://qudt.org/vocab/unit/PicoPA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoPA-PER-KiloM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-2D0",
    new Decimal("1E-15"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pPa/km",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Picopascal per Kilometer", "en-US"));
  unit.addLabel(new LangString("Picopascal per Kilometre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpectralRadiantEnergyDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/PicoPA-PER-KiloM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoS",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-2I0M-1H0T3D0",
    new Decimal("1E-12"),
    undefined,
    "http://qudt.org/vocab/prefix/Pico",
    "http://qudt.org/vocab/unit/S",
    undefined,
    "pS",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Picosiemens", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Conductance");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricalConductance"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Admittance");
  config.units.set("http://qudt.org/vocab/unit/PicoS", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoS-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-3I0M-1H0T3D0",
    new Decimal("1E-12"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pS/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Picosiemens per Meter", "en-US"));
  unit.addLabel(new LangString("Picosiemens per Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Conductivity");
  config.units.set("http://qudt.org/vocab/unit/PicoS-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoSEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("1E-12"),
    undefined,
    "http://qudt.org/vocab/prefix/Pico",
    "http://qudt.org/vocab/unit/SEC",
    undefined,
    "ps",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Picosecond", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/PicoSEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoV",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-3D0",
    new Decimal("1E-12"),
    undefined,
    "http://qudt.org/vocab/prefix/Pico",
    "http://qudt.org/vocab/unit/V",
    undefined,
    "pV",
    undefined,
    undefined,
    undefined,
    [],
    2,
    false,
    false
  );
  unit.addLabel(new LangString("Picovolt", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotential"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Voltage");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EnergyPerElectricCharge"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotentialDifference"
  );
  config.units.set("http://qudt.org/vocab/unit/PicoV", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoV-A",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1E-12"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pV·A",
    undefined,
    undefined,
    undefined,
    [],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("Picovolt Ampere", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ApparentPower");
  config.units.set("http://qudt.org/vocab/unit/PicoV-A", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoV-A_Reactive",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pV·A{Reactive}",
    undefined,
    undefined,
    undefined,
    [],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("PicoVolt Ampere Reactive", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ReactivePower");
  config.units.set("http://qudt.org/vocab/unit/PicoV-A_Reactive", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoVA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1E-12"),
    undefined,
    "http://qudt.org/vocab/prefix/Pico",
    "http://qudt.org/vocab/unit/VA",
    undefined,
    "pVA",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pico Volt Ampere", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ApparentPower");
  config.units.set("http://qudt.org/vocab/unit/PicoVA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoVAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1E-12"),
    undefined,
    "http://qudt.org/vocab/prefix/Pico",
    "http://qudt.org/vocab/unit/VAR",
    undefined,
    "pVA{Reactive}",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Pico Volt Ampere Reactive", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ReactivePower");
  config.units.set("http://qudt.org/vocab/unit/PicoVAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoW",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1E-12"),
    undefined,
    "http://qudt.org/vocab/prefix/Pico",
    "http://qudt.org/vocab/unit/W",
    undefined,
    "pW",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    2,
    false,
    false
  );
  unit.addLabel(new LangString("Picowatt", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/PicoW", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoW-PER-CentiM2-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T-3D0",
    new Decimal("0.00001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pW/(cm²·L)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Picowatt per Square Centimetre Litre", "en"));
  unit.addLabel(
    new LangString("Picowatt per Square Centimeter Liter", "en-US")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PicoW-PER-CentiM2-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoW-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    new Decimal("1E-12"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pW/m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Picowatt per Square Meter", "en-US"));
  unit.addLabel(new LangString("Picowatt per Square Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PowerPerArea");
  config.units.set("http://qudt.org/vocab/unit/PicoW-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PlanckArea",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    new Decimal("2.61223E-71"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M2",
    undefined,
    "planckarea",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/PLANCK"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Planck Area", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Area");
  config.units.set("http://qudt.org/vocab/unit/PlanckArea", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PlanckCharge",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("1.87554587E-18"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/A-SEC",
    undefined,
    "planckcharge",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/PLANCK"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Planck Charge", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  config.units.set("http://qudt.org/vocab/unit/PlanckCharge", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PlanckCurrent",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T0D0",
    new Decimal("34789000000000000000000000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/A",
    undefined,
    "planckcurrent",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/PLANCK"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Planck Current", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCurrent");
  config.units.set("http://qudt.org/vocab/unit/PlanckCurrent", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PlanckCurrentDensity",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H0T0D0",
    new Decimal(
      "133177400000000000000000000000000000000000000000000000000000000000000000000000000000000000000000.0"
    ),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/A-PER-M2",
    undefined,
    "planckcurrentdensity",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/PLANCK"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Planck Current Density", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/PlanckCurrentDensity", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PlanckDensity",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal(
      "5155000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000.0"
    ),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/GM-PER-DeciM3",
    undefined,
    "planckdensity",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/PLANCK"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Planck Density", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  config.units.set("http://qudt.org/vocab/unit/PlanckDensity", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PlanckEnergy",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1956100000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/J",
    undefined,
    "Eᵨ",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/PLANCK"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Planck Energy", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/PlanckEnergy", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PlanckForce",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("121027000000000000000000000000000000000000000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/N",
    undefined,
    "planckforce",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/PLANCK"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Planck Force", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Force");
  config.units.set("http://qudt.org/vocab/unit/PlanckForce", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PlanckFrequency",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("18548700000000000000000000000000000000000000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/BQ",
    undefined,
    "planckfrequency",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/PLANCK"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Planck Frequency", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Frequency");
  config.units.set("http://qudt.org/vocab/unit/PlanckFrequency", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PlanckFrequency_Ang",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("18548000000000000000000000000000000000000000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/BQ",
    undefined,
    "planckangularfrequency",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Planck Angular Frequency", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AngularFrequency"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AngularVelocity");
  config.units.set("http://qudt.org/vocab/unit/PlanckFrequency_Ang", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PlanckImpedance",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H0T-3D0",
    new Decimal("29.9792458"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/OHM",
    undefined,
    "Zₚ",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/PLANCK"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Planck Impedance", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Resistance");
  config.units.set("http://qudt.org/vocab/unit/PlanckImpedance", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PlanckLength",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("1.616252E-35"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M",
    undefined,
    "plancklength",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/PLANCK"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Planck Length", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/PlanckLength", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PlanckMass",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("2.17644E-8"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "planckmass",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/PLANCK"],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Planck Mass", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  config.units.set("http://qudt.org/vocab/unit/PlanckMass", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PlanckMomentum",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-1D0",
    new Decimal("6.52485"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM-M-PER-SEC",
    undefined,
    "planckmomentum",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/PLANCK"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Planck Momentum", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Momentum");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearMomentum");
  config.units.set("http://qudt.org/vocab/unit/PlanckMomentum", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PlanckPower",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("36283100000000000000000000000000000000000000000000000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/J-PER-SEC",
    undefined,
    "planckpower",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/PLANCK"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Planck Power", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/PlanckPower", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PlanckPressure",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal(
      "463309000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000.0"
    ),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2",
    undefined,
    "planckpressure",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/PLANCK"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Planck Pressure", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/PlanckPressure", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PlanckTemperature",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T0D0",
    new Decimal("141678400000000000000000000000000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/DEG_C",
    undefined,
    "plancktemperature",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/PLANCK"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Plancktemperature", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MeltingPoint");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermodynamicTemperature"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/BoilingPoint");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Temperature");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/FlashPoint");
  config.units.set("http://qudt.org/vocab/unit/PlanckTemperature", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PlanckTime",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("5.39124E-49"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/SEC",
    undefined,
    "tₚ",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/PLANCK"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Planck Time", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/PlanckTime", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PlanckVolt",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-3D0",
    new Decimal("1042950000000000000000000000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/V",
    undefined,
    "Vₚ",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/PLANCK"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Planck Volt", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotential"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Voltage");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EnergyPerElectricCharge"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotentialDifference"
  );
  config.units.set("http://qudt.org/vocab/unit/PlanckVolt", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PlanckVolume",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("4.22419E-105"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M3",
    undefined,
    "l³ₚ",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/PLANCK"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Planck Volume", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/PlanckVolume", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/QT_UK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.0011365225"),
    undefined,
    undefined,
    undefined,
    undefined,
    "qt{UK}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"],
    9,
    false,
    false
  );
  unit.addLabel(new LangString("Quart (UK)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/QT_UK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/QT_UK-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("1.315419560185185185185185185185185E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "qt{UK}/d",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Quart (UK) per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/QT_UK-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/QT_UK-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("3.157006944444444444444444444444445E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "qt{UK}/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Quart (UK) per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/QT_UK-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/QT_UK-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.00001894204166666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "qt{UK}/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Quart (UK) per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/QT_UK-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/QT_UK-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.0011365225"),
    undefined,
    undefined,
    undefined,
    undefined,
    "qt{UK}/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Quart (UK) per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/QT_UK-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/QT_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.000946352946"),
    undefined,
    undefined,
    undefined,
    undefined,
    "qt{US liq}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    9,
    false,
    false
  );
  unit.addLabel(new LangString("Us Liquid Quart", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LiquidVolume");
  config.units.set("http://qudt.org/vocab/unit/QT_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/QT_US-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("1.095315909722222222222222222222222E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "qt{US liq}/d",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Us Liquid Quart per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/QT_US-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/QT_US-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("2.628758183333333333333333333333334E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "qt{US liq}/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Us Liquid Quart per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/QT_US-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/QT_US-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.0000157725491"),
    undefined,
    undefined,
    undefined,
    undefined,
    "qt{US liq}/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Us Liquid Quart per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/QT_US-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/QT_US-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.000946352946"),
    undefined,
    undefined,
    undefined,
    undefined,
    "qt{US liq}/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Us Liquid Quart per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/QT_US-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/QT_US_DRY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.001101220942715"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M3",
    undefined,
    "qt{US Dry}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Us Dry Quart", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DryVolume");
  config.units.set("http://qudt.org/vocab/unit/QT_US_DRY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/QUAD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1055000000000000000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/J",
    undefined,
    "quad",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Quad", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/QUAD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/Quarter_UK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("12.70058636"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "quarter",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Quarter (UK)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  config.units.set("http://qudt.org/vocab/unit/Quarter_UK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/R",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M-1H0T1D0",
    new Decimal("0.000258"),
    undefined,
    undefined,
    undefined,
    undefined,
    "R",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    3,
    false,
    false
  );
  unit.addLabel(new LangString("Roentgen", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerMass"
  );
  config.units.set("http://qudt.org/vocab/unit/R", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/R-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M-1H0T0D0",
    new Decimal("0.000258"),
    undefined,
    undefined,
    undefined,
    undefined,
    "R/s",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Roentgen per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ExposureRate");
  config.units.set("http://qudt.org/vocab/unit/R-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/RAD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "rad",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    28,
    false,
    false
  );
  unit.addLabel(new LangString("Radian", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PlaneAngle");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Angle");
  config.units.set("http://qudt.org/vocab/unit/RAD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/RAD-M2-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M-1H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "rad·m²/kg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Radian Square Meter per Kilogram", "en-US"));
  unit.addLabel(new LangString("Radian Square Metre per Kilogram", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificOpticalRotatoryPower"
  );
  config.units.set("http://qudt.org/vocab/unit/RAD-M2-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/RAD-M2-PER-MOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A-1E0L2I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "rad·m²/mol",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Radian Square Metre per Mole", "en"));
  unit.addLabel(new LangString("Radian Square Meter per Mole", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MolarOpticalRotatoryPower"
  );
  config.units.set("http://qudt.org/vocab/unit/RAD-M2-PER-MOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/RAD-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("0.0002777777777777777777777777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "rad/h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Radian per Hour", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AngularFrequency"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AngularVelocity");
  config.units.set("http://qudt.org/vocab/unit/RAD-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/RAD-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "rad/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Radian per Metre", "en"));
  unit.addLabel(new LangString("Radian per Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/FermiAngularWavenumber"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DebyeAngularWavenumber"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AngularWavenumber"
  );
  config.units.set("http://qudt.org/vocab/unit/RAD-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/RAD-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("0.01666666666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "rad/min",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Radian per Minute", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AngularFrequency"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AngularVelocity");
  config.units.set("http://qudt.org/vocab/unit/RAD-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/RAD-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "rad/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Radian per Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AngularFrequency"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AngularVelocity");
  config.units.set("http://qudt.org/vocab/unit/RAD-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/RAD-PER-SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "rad/s²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Radian per Square Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AngularAcceleration"
  );
  config.units.set("http://qudt.org/vocab/unit/RAD-PER-SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/RAD_R",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M2-PER-SEC2",
    undefined,
    "rad",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Rad", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AbsorbedDose");
  config.units.set("http://qudt.org/vocab/unit/RAD_R", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/RAYL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM-PER-M2-SEC",
    undefined,
    "rayl",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Rayl", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificAcousticImpedance"
  );
  config.units.set("http://qudt.org/vocab/unit/RAYL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/REM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M2-PER-SEC2",
    undefined,
    "rem",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Rem", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DoseEquivalent");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/R_man");
  config.units.set("http://qudt.org/vocab/unit/REM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/REM-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "rem/s",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Rem per Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/KermaRate");
  config.units.set("http://qudt.org/vocab/unit/REM-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/REV",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("6.28318531"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/RAD",
    undefined,
    "rev",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    7,
    false,
    false
  );
  unit.addLabel(new LangString("Revolution", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PlaneAngle");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Angle");
  config.units.set("http://qudt.org/vocab/unit/REV", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/REV-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("0.001745329252777777777777777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "rev/h",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Revolution per Hour", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/RotationalFrequency"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/RotationalVelocity"
  );
  config.units.set("http://qudt.org/vocab/unit/REV-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/REV-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("0.1047197551666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "rev/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Revolution per Minute", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/RotationalFrequency"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/RotationalVelocity"
  );
  config.units.set("http://qudt.org/vocab/unit/REV-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/REV-PER-MIN-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-2D0",
    new Decimal("0.1047197551666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "rev/(min·s)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Revolution per Minute Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AngularAcceleration"
  );
  config.units.set("http://qudt.org/vocab/unit/REV-PER-MIN-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/REV-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("6.28318531"),
    undefined,
    undefined,
    undefined,
    undefined,
    "rev/s",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Revolution per Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/RotationalFrequency"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/RotationalVelocity"
  );
  config.units.set("http://qudt.org/vocab/unit/REV-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/REV-PER-SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-2D0",
    new Decimal("6.28318531"),
    undefined,
    undefined,
    undefined,
    undefined,
    "rev/s²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Revolution per Square Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AngularAcceleration"
  );
  config.units.set("http://qudt.org/vocab/unit/REV-PER-SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/RHE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H0T1D0",
    new Decimal("10.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/PER-PA-SEC",
    undefined,
    "rhe",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Rhe", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Fluidity");
  config.units.set("http://qudt.org/vocab/unit/RHE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ROD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("5.02921"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M",
    undefined,
    "rod",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Rod", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/ROD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/RPK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "RPK",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Reads per Kilobase", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/GeneFamilyAbundance"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Dimensionless");
  config.units.set("http://qudt.org/vocab/unit/RPK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/RT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    undefined,
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M3",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    true
  );
  unit.addLabel(new LangString("RT", undefined));
  config.units.set("http://qudt.org/vocab/unit/RT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/R_man",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/SV",
    undefined,
    "rem",
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Roentgen Equivalent Man", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DoseEquivalent");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/REM");
  config.units.set("http://qudt.org/vocab/unit/R_man", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/RichterMagnitude",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mag",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Richter Magnitude", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EarthquakeMagnitude"
  );
  config.units.set("http://qudt.org/vocab/unit/RichterMagnitude", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/S",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-2I0M-1H0T3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "S",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    11,
    false,
    false
  );
  unit.addLabel(new LangString("Siemens", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Conductance");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Admittance");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/MHO");
  config.units.set("http://qudt.org/vocab/unit/S", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/S-M2-PER-MOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A-1E2L0I0M-1H0T3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "S·m²/mol",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Siemens Square Metre per Mole", "en"));
  unit.addLabel(new LangString("Siemens Square Meter per Mole", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MolarConductivity"
  );
  config.units.set("http://qudt.org/vocab/unit/S-M2-PER-MOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/S-PER-CentiM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-3I0M-1H0T3D0",
    new Decimal("100.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "S/cm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Siemens per Centimetre", "en"));
  unit.addLabel(new LangString("Siemens per Centimeter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Conductivity");
  config.units.set("http://qudt.org/vocab/unit/S-PER-CentiM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/S-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-3I0M-1H0T3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "S/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    3,
    false,
    false
  );
  unit.addLabel(new LangString("Siemens per Metre", "en"));
  unit.addLabel(new LangString("Siemens per Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectrolyticConductivity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Conductivity");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/KiloGM-PER-M2-PA-SEC");
  config.units.set("http://qudt.org/vocab/unit/S-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SAMPLE",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    true
  );
  unit.addLabel(new LangString("SAMPLE", undefined));
  config.units.set("http://qudt.org/vocab/unit/SAMPLE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SAMPLE-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "sample/s",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Sample per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Frequency");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/PER-SEC");
  config.units.set("http://qudt.org/vocab/unit/SAMPLE-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SCF",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T0D0",
    new Decimal("1.1981"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/MOL",
    undefined,
    "scf",
    undefined,
    undefined,
    undefined,
    [],
    2,
    false,
    false
  );
  unit.addLabel(new LangString("Standard Cubic Foot", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstance"
  );
  config.units.set("http://qudt.org/vocab/unit/SCF", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SCF-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T-1D0",
    new Decimal("0.0003328055555555555555555555555555556"),
    undefined,
    undefined,
    undefined,
    undefined,
    "scf/h",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Standard Cubic Foot per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MolarFlowRate");
  config.units.set("http://qudt.org/vocab/unit/SCF-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SCF-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T-1D0",
    new Decimal("0.01996833333333333333333333333333334"),
    undefined,
    undefined,
    undefined,
    undefined,
    "scf/min",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Standard Cubic Foot per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MolarFlowRate");
  config.units.set("http://qudt.org/vocab/unit/SCF-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SCM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T0D0",
    new Decimal("42.3105"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/MOL",
    undefined,
    "scm",
    undefined,
    undefined,
    undefined,
    [],
    2,
    false,
    false
  );
  unit.addLabel(new LangString("Standard Cubic Metre", "en"));
  unit.addLabel(new LangString("Standard Cubic Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstance"
  );
  unit.addExactMatchIri("http://qudt.org/vocab/unit/SCM_1ATM_0DEG_C");
  config.units.set("http://qudt.org/vocab/unit/SCM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SCM-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T-1D0",
    new Decimal("0.01175291666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "scm/h",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Standard Cubic Meter per Hour", "en-US"));
  unit.addLabel(new LangString("Standard Cubic Metre per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MolarFlowRate");
  config.units.set("http://qudt.org/vocab/unit/SCM-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SCM-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T-1D0",
    new Decimal("0.7051750000000000000000000000000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "scm/min",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Standard Cubic Metre per Minute", "en"));
  unit.addLabel(new LangString("Standard Cubic Meter per Minute", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MolarFlowRate");
  config.units.set("http://qudt.org/vocab/unit/SCM-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SCM_1ATM_0DEG_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T0D0",
    new Decimal("42.3105"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/MOL",
    undefined,
    "scm",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Standard Cubic Metre", "en"));
  unit.addLabel(new LangString("Standard Cubic Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstance"
  );
  unit.addExactMatchIri("http://qudt.org/vocab/unit/SCM");
  config.units.set("http://qudt.org/vocab/unit/SCM_1ATM_0DEG_C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SCM_1ATM_15DEG_C_ISO",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T0D0",
    new Decimal("0.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/MOL",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Standard Cubic Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstance"
  );
  unit.addExactMatchIri("http://qudt.org/vocab/unit/SCM_1ATM_15DEG_C_NL");
  config.units.set("http://qudt.org/vocab/unit/SCM_1ATM_15DEG_C_ISO", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SCM_1ATM_15DEG_C_NL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T0D0",
    new Decimal("0.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/MOL",
    undefined,
    "Sm³",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Standard Cubic Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstance"
  );
  unit.addExactMatchIri("http://qudt.org/vocab/unit/SCM_1ATM_15DEG_C_ISO");
  config.units.set("http://qudt.org/vocab/unit/SCM_1ATM_15DEG_C_NL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    729,
    false,
    false
  );
  unit.addLabel(new LangString("Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Period");
  config.units.set("http://qudt.org/vocab/unit/SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SEC-FT2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T1D0",
    new Decimal("0.09290304"),
    undefined,
    undefined,
    undefined,
    undefined,
    "s·ft²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Second Square Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AreaTime");
  config.units.set("http://qudt.org/vocab/unit/SEC-FT2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SEC-PER-FT2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal("10.7639104167097223083335055559"),
    undefined,
    undefined,
    undefined,
    undefined,
    "s/ft²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Second per Square Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/SEC-PER-FT2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SEC-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "s/kg",
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Second per Kilogram", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EinsteinCoefficients"
  );
  config.units.set("http://qudt.org/vocab/unit/SEC-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SEC-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "s/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    2,
    false,
    false
  );
  unit.addLabel(new LangString("Second per Meter", "en-US"));
  unit.addLabel(new LangString("Second per Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/SEC-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SEC-PER-M3-RAD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "s/(m³·rad)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Second per Cubic Metre Radian", "en"));
  unit.addLabel(new LangString("Second per Cubic Meter Radian", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpectralDensityOfVibrationalModes"
  );
  config.units.set("http://qudt.org/vocab/unit/SEC-PER-M3-RAD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SEC-PER-NUM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "s/#",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Second per Number", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/TimePerCount");
  config.units.set("http://qudt.org/vocab/unit/SEC-PER-NUM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SEC-PER-RAD-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "s/(rad·m³)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Second per Radian Cubic Meter", "en-US"));
  unit.addLabel(new LangString("Second per Radian Cubic Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/VibrationalDensityOfStates"
  );
  config.units.set("http://qudt.org/vocab/unit/SEC-PER-RAD-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "s²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SquareTime");
  config.units.set("http://qudt.org/vocab/unit/SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SH",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("1E-8"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/SEC",
    undefined,
    "shake",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Shake", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/SH", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SHANNON",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.69314718055994530941723212145818"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/NUM",
    undefined,
    "Sh",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Shannon", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InformationEntropy"
  );
  config.units.set("http://qudt.org/vocab/unit/SHANNON", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SHANNON-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("0.69314718055994530941723212145818"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Sh/s",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Shannon per Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InformationFlowRate"
  );
  config.units.set("http://qudt.org/vocab/unit/SHANNON-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SLUG",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("14.5939035919985"),
    undefined,
    undefined,
    undefined,
    undefined,
    "slug",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"],
    76,
    false,
    false
  );
  unit.addLabel(new LangString("Slug", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  config.units.set("http://qudt.org/vocab/unit/SLUG", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SLUG-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("0.0001689109212036863425925925925925925"),
    undefined,
    undefined,
    undefined,
    undefined,
    "slug/d",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Slug per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/SLUG-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SLUG-PER-FT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T0D0",
    new Decimal("47.88026112860400262467191601049868"),
    undefined,
    undefined,
    undefined,
    undefined,
    "slug/ft",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Slug per Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerLength");
  config.units.set("http://qudt.org/vocab/unit/SLUG-PER-FT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SLUG-PER-FT-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-1D0",
    new Decimal("47.88026112860400262467191601049868"),
    undefined,
    undefined,
    undefined,
    undefined,
    "slug/(ft·s)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Slug per Foot Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DynamicViscosity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Viscosity");
  config.units.set("http://qudt.org/vocab/unit/SLUG-PER-FT-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SLUG-PER-FT2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    new Decimal("157.0874708943700873512858136827385"),
    undefined,
    undefined,
    undefined,
    undefined,
    "slug/ft²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Slug per Square Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerArea");
  config.units.set("http://qudt.org/vocab/unit/SLUG-PER-FT2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SLUG-PER-FT3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("515.3788415169622288428012259932365"),
    undefined,
    undefined,
    undefined,
    undefined,
    "slug/ft³",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Slug per Cubic Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  config.units.set("http://qudt.org/vocab/unit/SLUG-PER-FT3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SLUG-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("0.004053862108888472222222222222222223"),
    undefined,
    undefined,
    undefined,
    undefined,
    "slug/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Slug per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/SLUG-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SLUG-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("0.2432317265333083333333333333333334"),
    undefined,
    undefined,
    undefined,
    undefined,
    "slug/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Slug per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/SLUG-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SLUG-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("14.5939035919985"),
    undefined,
    undefined,
    undefined,
    undefined,
    "slug/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Slug per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/SLUG-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SON",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "sone",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Sone", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/SON", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SPF",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "SPF",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Sun Protection Factor", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SunProtectionFactorOfAProduct"
  );
  config.units.set("http://qudt.org/vocab/unit/SPF", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SPIN_QUANTUM_NUMBER",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Q",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Spin Quantum Number", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/SPIN_QUANTUM_NUMBER", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "sr",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    35,
    false,
    false
  );
  unit.addLabel(new LangString("Steradian", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SolidAngle");
  config.units.set("http://qudt.org/vocab/unit/SR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ST",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-1D0",
    new Decimal("0.0001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "St",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    4,
    false,
    false
  );
  unit.addLabel(new LangString("Stokes", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/KinematicViscosity"
  );
  config.units.set("http://qudt.org/vocab/unit/ST", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ST-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M-1H0T1D0",
    new Decimal("1E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "St/bar",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Stokes per Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/ST-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ST-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H-1T-1D0",
    new Decimal("0.0001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "St/K",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Stokes per Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/ST-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ST-PER-PA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M-1H0T1D0",
    new Decimal("0.0001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "St/Pa",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Stokes per Pascal", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/ST-PER-PA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/STANDARD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("4.672"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M3",
    undefined,
    "standard",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Standard", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/STANDARD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/STILB",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I1M0H0T0D0",
    new Decimal("10000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/CD-PER-M2",
    undefined,
    "sb",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Stilb", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Luminance");
  config.units.set("http://qudt.org/vocab/unit/STILB", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/STR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M3",
    undefined,
    "st",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Stere", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/STR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_ELEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "χ",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Electric Susceptibility Unit", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Dimensionless");
  config.units.set("http://qudt.org/vocab/unit/SUSCEPTIBILITY_ELEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_MAG",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "χ",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Magnetic Susceptibility Unit", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Dimensionless");
  config.units.set("http://qudt.org/vocab/unit/SUSCEPTIBILITY_MAG", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SV",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Sv",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    7,
    false,
    false
  );
  unit.addLabel(new LangString("Sievert", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DoseEquivalent");
  config.units.set("http://qudt.org/vocab/unit/SV", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SV-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    new Decimal("0.0002777777777777777777777777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Sv/h",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Sievert per Hour", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/KermaRate");
  config.units.set("http://qudt.org/vocab/unit/SV-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SV-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    new Decimal("0.01666666666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Sv/min",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Sievert per Minute", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/KermaRate");
  config.units.set("http://qudt.org/vocab/unit/SV-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SV-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Sv/s",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Sievert per Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/KermaRate");
  config.units.set("http://qudt.org/vocab/unit/SV-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/S_Ab",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-3I0M-1H0T3D0",
    new Decimal("1000000000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/S-PER-M",
    undefined,
    "aS",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-EMU", "http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Absiemen", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricConductivity"
  );
  config.units.set("http://qudt.org/vocab/unit/S_Ab", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/S_Stat",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-3I0M-1H0T3D0",
    new Decimal("1.1126500561E-12"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/S-PER-M",
    undefined,
    "statS",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-ESU"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Statsiemens", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricConductivity"
  );
  unit.addExactMatchIri("http://qudt.org/vocab/unit/MHO_Stat");
  config.units.set("http://qudt.org/vocab/unit/S_Stat", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SolarMass",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("1988435000000000000000000000000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "S",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Solar Mass", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  config.units.set("http://qudt.org/vocab/unit/SolarMass", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SpeedOfLight",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    true
  );
  unit.addLabel(new LangString("SpeedOfLight", undefined));
  config.units.set("http://qudt.org/vocab/unit/SpeedOfLight", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/Standard",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("4.672"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M3",
    undefined,
    "standard",
    undefined,
    undefined,
    undefined,
    [],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("Standard", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/Standard", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/Stone_UK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("6.35029318"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "st{UK}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Stone (UK)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  config.units.set("http://qudt.org/vocab/unit/Stone_UK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/T",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L0I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "T",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    19,
    false,
    false
  );
  unit.addLabel(new LangString("Tesla", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticFluxDensity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MagneticField");
  config.units.set("http://qudt.org/vocab/unit/T", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/T-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L1I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "T·m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Tesla Metre", "en"));
  unit.addLabel(new LangString("Tesla Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticFluxPerLength"
  );
  config.units.set("http://qudt.org/vocab/unit/T-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/T-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L0I0M1H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "T·s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Tesla Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassPerElectricCharge"
  );
  config.units.set("http://qudt.org/vocab/unit/T-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TBSP",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.0000147867656"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M3",
    undefined,
    "tbsp",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Tablespoon", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/TBSP", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TEN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("10.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/ONE",
    undefined,
    "10",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Ten", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Count");
  config.units.set("http://qudt.org/vocab/unit/TEN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TEX",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T0D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/GM-PER-MilliM",
    undefined,
    "tex",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Tex", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerLength");
  config.units.set("http://qudt.org/vocab/unit/TEX", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/THERM_EC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1055055852.62"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/J",
    undefined,
    "thm{EC}",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Therm (ec)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ThermalEnergy");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/THM_EEC");
  config.units.set("http://qudt.org/vocab/unit/THERM_EC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/THERM_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("105480400.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/J",
    undefined,
    "thm{US}",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Therm (u.s.)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ThermalEnergy");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/THM_US");
  config.units.set("http://qudt.org/vocab/unit/THERM_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/THM_EEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1055055852.62"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/J",
    undefined,
    "thm{EEC}",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Thm_eec", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ThermalEnergy");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/THERM_EC");
  config.units.set("http://qudt.org/vocab/unit/THM_EEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/THM_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("105480400.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/J",
    undefined,
    "thm{US}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Therm Us", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ThermalEnergy");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/THERM_US");
  config.units.set("http://qudt.org/vocab/unit/THM_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/THM_US-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("29300.11111111111111111111111111111"),
    undefined,
    undefined,
    undefined,
    undefined,
    "thm{US}/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Therm Us per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/HeatFlowRate");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/THM_US-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/THOUSAND",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/ONE",
    undefined,
    "1000",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    3,
    false,
    false
  );
  unit.addLabel(new LangString("Thousand", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Count");
  config.units.set("http://qudt.org/vocab/unit/THOUSAND", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TOE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("41868000000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/J",
    undefined,
    "toe",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Ton of Oil Equivalent", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/TOE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("907.18474"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "tn",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    2,
    false,
    false
  );
  unit.addLabel(new LangString("Ton", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON_SHORT");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON_US");
  config.units.set("http://qudt.org/vocab/unit/TON", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TONNE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "t",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    26,
    false,
    false
  );
  unit.addLabel(new LangString("Tonne", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/CO2Equivalent");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON_Metric");
  config.units.set("http://qudt.org/vocab/unit/TONNE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TONNE-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T2D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/bar",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Tonne per Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON_Metric-PER-BAR");
  config.units.set("http://qudt.org/vocab/unit/TONNE-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TONNE-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("0.01157407407407407407407407407407407"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/d",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Tonne per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON_Metric-PER-DAY");
  config.units.set("http://qudt.org/vocab/unit/TONNE-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TONNE-PER-DAY-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T1D0",
    new Decimal("1.157407407407407407407407407407407E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/(d·bar)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Tonne per Day Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON_Metric-PER-DAY-BAR");
  config.units.set("http://qudt.org/vocab/unit/TONNE-PER-DAY-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TONNE-PER-DAY-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-1D0",
    new Decimal("0.01157407407407407407407407407407407"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/(d·K)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Tonne per Day Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON_Metric-PER-DAY-K");
  config.units.set("http://qudt.org/vocab/unit/TONNE-PER-DAY-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TONNE-PER-HA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    new Decimal("0.1"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/ha",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Tonne per Hectare", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerArea");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/MegaGM-PER-HA");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON_Metric-PER-HA");
  config.units.set("http://qudt.org/vocab/unit/TONNE-PER-HA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TONNE-PER-HA-YR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-1D0",
    new Decimal("3.168808781402895023702689684893655E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/(ha·a)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Tonne per Hectare Year", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerAreaTime");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/MegaGM-PER-HA-YR");
  config.units.set("http://qudt.org/vocab/unit/TONNE-PER-HA-YR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TONNE-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("0.2777777777777777777777777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Tonne per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON_Metric-PER-HR");
  config.units.set("http://qudt.org/vocab/unit/TONNE-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TONNE-PER-HR-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T1D0",
    new Decimal("0.000002777777777777777777777777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/(h·bar)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Tonne per Hour Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON_Metric-PER-HR-BAR");
  config.units.set("http://qudt.org/vocab/unit/TONNE-PER-HR-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TONNE-PER-HR-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-1D0",
    new Decimal("0.2777777777777777777777777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/(h·K)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Tonne per Hour Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON_Metric-PER-HR-K");
  config.units.set("http://qudt.org/vocab/unit/TONNE-PER-HR-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TONNE-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/K",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Tonne per Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON_Metric-PER-K");
  config.units.set("http://qudt.org/vocab/unit/TONNE-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TONNE-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Tonne per Cubic Meter", "en-US"));
  unit.addLabel(new LangString("Tonne per Cubic Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON_Metric-PER-M3");
  config.units.set("http://qudt.org/vocab/unit/TONNE-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TONNE-PER-M3-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T2D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/(m³·bar)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Tonne per Cubic Meter Bar", "en-US"));
  unit.addLabel(new LangString("Tonne per Cubic Metre Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerEnergy");
  config.units.set("http://qudt.org/vocab/unit/TONNE-PER-M3-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TONNE-PER-M3-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H-1T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/(m³·K)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Tonne per Cubic Metre Kelvin", "en"));
  unit.addLabel(new LangString("Tonne per Cubic Meter Kelvin", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON_Metric-PER-M3-K");
  config.units.set("http://qudt.org/vocab/unit/TONNE-PER-M3-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TONNE-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("16.66666666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/min",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Tonne per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON_Metric-PER-MIN");
  config.units.set("http://qudt.org/vocab/unit/TONNE-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TONNE-PER-MIN-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T1D0",
    new Decimal("0.0001666666666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/(min·bar)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Tonne per Minute Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON_Metric-PER-MIN-BAR");
  config.units.set("http://qudt.org/vocab/unit/TONNE-PER-MIN-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TONNE-PER-MIN-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-1D0",
    new Decimal("16.66666666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/(min·K)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Tonne per Minute Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON_Metric-PER-MIN-K");
  config.units.set("http://qudt.org/vocab/unit/TONNE-PER-MIN-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TONNE-PER-MO",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("0.0003919350772901616281311709002114104"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/mo",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Tonne per Month", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/TONNE-PER-MO", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TONNE-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Tonne per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON_Metric-PER-SEC");
  config.units.set("http://qudt.org/vocab/unit/TONNE-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TONNE-PER-SEC-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T1D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/(s·bar)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Tonne per Second Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON_Metric-PER-SEC-BAR");
  config.units.set("http://qudt.org/vocab/unit/TONNE-PER-SEC-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TONNE-PER-SEC-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-1D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/(s·K)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Tonne per Second Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON_Metric-PER-SEC-K");
  config.units.set("http://qudt.org/vocab/unit/TONNE-PER-SEC-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TONNE-PER-YR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("0.00003168808781402895023702689684893655"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/a",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Tonne per Year", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/TONNE-PER-YR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_Assay",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("0.02916667"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "AT",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Assay Ton", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  config.units.set("http://qudt.org/vocab/unit/TON_Assay", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_FG",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("3516.853"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/J-PER-SEC",
    undefined,
    "TOR",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Ton of Refrigeration", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/HeatFlowRate");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/TON_FG", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_FG-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("12660670.8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "TOR·h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ton of Refrigeration Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ThermalEnergy");
  config.units.set("http://qudt.org/vocab/unit/TON_FG-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_F_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("8896.443230521"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/N",
    undefined,
    "tonf{us}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ton Force (us Short)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Force");
  config.units.set("http://qudt.org/vocab/unit/TON_F_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_LONG",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("1016.0469088"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "t{long}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Long Ton", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON_UK");
  config.units.set("http://qudt.org/vocab/unit/TON_LONG", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_LONG-PER-YD3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("1328.939183617433802163976232081731"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t{long}/yd³",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Long Ton per Cubic Yard", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON_UK-PER-YD3");
  config.units.set("http://qudt.org/vocab/unit/TON_LONG-PER-YD3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_Metric",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "t",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    19,
    false,
    false
  );
  unit.addLabel(new LangString("Metric Ton", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TONNE");
  config.units.set("http://qudt.org/vocab/unit/TON_Metric", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_Metric-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T2D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/bar",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Metric Ton per Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TONNE-PER-BAR");
  config.units.set("http://qudt.org/vocab/unit/TON_Metric-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_Metric-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("0.01157407407407407407407407407407407"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/d",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Metric Ton per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TONNE-PER-DAY");
  config.units.set("http://qudt.org/vocab/unit/TON_Metric-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_Metric-PER-DAY-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T1D0",
    new Decimal("1.157407407407407407407407407407407E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/(d·bar)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Metric Ton per Day Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TONNE-PER-DAY-BAR");
  config.units.set("http://qudt.org/vocab/unit/TON_Metric-PER-DAY-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_Metric-PER-DAY-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-1D0",
    new Decimal("0.01157407407407407407407407407407407"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/(d·K)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Metric Ton per Day Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TONNE-PER-DAY-K");
  config.units.set("http://qudt.org/vocab/unit/TON_Metric-PER-DAY-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_Metric-PER-HA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    new Decimal("0.1"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/ha",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Metric Ton per Hectare", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerArea");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/MegaGM-PER-HA");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TONNE-PER-HA");
  config.units.set("http://qudt.org/vocab/unit/TON_Metric-PER-HA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_Metric-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("0.2777777777777777777777777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Metric Ton per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TONNE-PER-HR");
  config.units.set("http://qudt.org/vocab/unit/TON_Metric-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_Metric-PER-HR-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T1D0",
    new Decimal("0.000002777777777777777777777777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/(h·bar)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Metric Ton per Hour Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TONNE-PER-HR-BAR");
  config.units.set("http://qudt.org/vocab/unit/TON_Metric-PER-HR-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_Metric-PER-HR-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-1D0",
    new Decimal("0.2777777777777777777777777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/(h·K)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Metric Ton per Hour Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TONNE-PER-HR-K");
  config.units.set("http://qudt.org/vocab/unit/TON_Metric-PER-HR-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_Metric-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/K",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Metric Ton per Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TONNE-PER-K");
  config.units.set("http://qudt.org/vocab/unit/TON_Metric-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_Metric-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Metric Ton per Cubic Metre", "en"));
  unit.addLabel(new LangString("Metric Ton per Cubic Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TONNE-PER-M3");
  config.units.set("http://qudt.org/vocab/unit/TON_Metric-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_Metric-PER-M3-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H-1T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/(m³·K)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Metric Ton per Cubic Metre Kelvin", "en"));
  unit.addLabel(new LangString("Metric Ton per Cubic Meter Kelvin", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TONNE-PER-M3-K");
  config.units.set("http://qudt.org/vocab/unit/TON_Metric-PER-M3-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_Metric-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("16.66666666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/min",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Metric Ton per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TONNE-PER-MIN");
  config.units.set("http://qudt.org/vocab/unit/TON_Metric-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_Metric-PER-MIN-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T1D0",
    new Decimal("0.0001666666666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/(min·bar)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Metric Ton per Minute Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TONNE-PER-MIN-BAR");
  config.units.set("http://qudt.org/vocab/unit/TON_Metric-PER-MIN-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_Metric-PER-MIN-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-1D0",
    new Decimal("16.66666666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/(min·K)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Metric Ton per Minute Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TONNE-PER-MIN-K");
  config.units.set("http://qudt.org/vocab/unit/TON_Metric-PER-MIN-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_Metric-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Metric Ton per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TONNE-PER-SEC");
  config.units.set("http://qudt.org/vocab/unit/TON_Metric-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_Metric-PER-SEC-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T1D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/(s·bar)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Metric Ton per Second Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TONNE-PER-SEC-BAR");
  config.units.set("http://qudt.org/vocab/unit/TON_Metric-PER-SEC-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_Metric-PER-SEC-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-1D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/(s·K)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Metric Ton per Second Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TONNE-PER-SEC-K");
  config.units.set("http://qudt.org/vocab/unit/TON_Metric-PER-SEC-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_Register",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("2.83"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M3",
    undefined,
    "RT",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ton, Register", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SectionModulus");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/TON_Register", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_SHIPPING_UK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("1.1326"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M3",
    undefined,
    "MTON",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ton (uk Shipping)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/TON_SHIPPING_UK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_SHIPPING_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("1.1326"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M3",
    undefined,
    "MTON",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ton (us Shipping)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/TON_SHIPPING_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_SHORT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("907.18474"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "ton{short}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS", "http://qudt.org/vocab/sou/USCS"],
    6,
    false,
    false
  );
  unit.addLabel(new LangString("Short Ton", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON_US");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON");
  config.units.set("http://qudt.org/vocab/unit/TON_SHORT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_SHORT-PER-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T0D0",
    new Decimal("1632.932532"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ton{short}/°F",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Short Ton per Degree Fahrenheit", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/TON_SHORT-PER-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_SHORT-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("0.2519957611111111111111111111111111"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ton{short}/h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Short Ton per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON_US-PER-HR");
  config.units.set("http://qudt.org/vocab/unit/TON_SHORT-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_SHORT-PER-HR-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-1D0",
    new Decimal("0.45359237"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ton{short}/(h·°F)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Short Ton per Hour Degree Fahrenheit", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/TON_SHORT-PER-HR-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_SHORT-PER-HR-PSI",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T1D0",
    new Decimal("0.00003654889346929982162413267605184694"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ton{short}/(h·psi)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Short Ton per Hour Psi", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/TON_SHORT-PER-HR-PSI", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_SHORT-PER-PSI",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T2D0",
    new Decimal("0.131576016489479357846877633786649"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ton{short}/psi",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Short Ton per Psi", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/TON_SHORT-PER-PSI", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_SHORT-PER-YD3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("1186.552842515565894789264492930117"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ton{short}/yd³",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Short Ton per Cubic Yard", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON_US-PER-YD3");
  config.units.set("http://qudt.org/vocab/unit/TON_SHORT-PER-YD3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_UK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("1016.0469088"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "ton{UK}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"],
    2,
    false,
    false
  );
  unit.addLabel(new LangString("Ton (UK)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON_LONG");
  config.units.set("http://qudt.org/vocab/unit/TON_UK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_UK-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("0.01175980218518518518518518518518518"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ton{UK}/d",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ton (UK) per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/TON_UK-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_UK-PER-YD3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("1328.939183617433802163976232081731"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ton{UK}/yd³",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ton (UK) per Cubic Yard", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON_LONG-PER-YD3");
  config.units.set("http://qudt.org/vocab/unit/TON_UK-PER-YD3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("907.18474"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "ton{US}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    3,
    false,
    false
  );
  unit.addLabel(new LangString("Ton (US)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON_SHORT");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON");
  config.units.set("http://qudt.org/vocab/unit/TON_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_US-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("0.01049982337962962962962962962962963"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ton{US}/d",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ton (US) per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/TON_US-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_US-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("0.2519957611111111111111111111111111"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ton{US}/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ton (US) per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON_SHORT-PER-HR");
  config.units.set("http://qudt.org/vocab/unit/TON_US-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_US-PER-YD3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("1186.552842515565894789264492930117"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ton{US}/yd³",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ton (US) per Cubic Yard", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON_SHORT-PER-YD3");
  config.units.set("http://qudt.org/vocab/unit/TON_US-PER-YD3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TORR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("133.322"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/PA",
    undefined,
    "Torr",
    undefined,
    undefined,
    undefined,
    [],
    3,
    false,
    false
  );
  unit.addLabel(new LangString("Torr", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/TORR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TORR-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-2D0",
    new Decimal("133.322"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Torr/m",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Torr per Meter", "en-US"));
  unit.addLabel(new LangString("Torr per Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PressureGradient"
  );
  config.units.set("http://qudt.org/vocab/unit/TORR-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TSP",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.00000492892187"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M3",
    undefined,
    "tsp",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Teaspoon", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/TSP", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/T_Ab",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L0I0M1H0T-2D0",
    new Decimal("0.0001"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/T",
    undefined,
    "abT",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-EMU", "http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Abtesla", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticFluxDensity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MagneticField");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/GAUSS");
  config.units.set("http://qudt.org/vocab/unit/T_Ab", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TebiBIT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("762123384785.8104503028768718089172"),
    undefined,
    "http://qudt.org/vocab/prefix/Tebi",
    "http://qudt.org/vocab/unit/BIT",
    undefined,
    "Tib",
    undefined,
    undefined,
    undefined,
    [],
    3,
    false,
    false
  );
  unit.addLabel(new LangString("Tebibit", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InformationEntropy"
  );
  config.units.set("http://qudt.org/vocab/unit/TebiBIT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TebiBIT-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("762123384785.8104503028768718089172"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Tib/m",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Tebibit per Meter", "en-US"));
  unit.addLabel(new LangString("Tebibit per Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearBitDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/TebiBIT-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TebiBIT-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T0D0",
    new Decimal("762123384785.8104503028768718089172"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Tib/m²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Tebibit per Square Meter", "en-US"));
  unit.addLabel(new LangString("Tebibit per Square Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AreaBitDensity");
  config.units.set("http://qudt.org/vocab/unit/TebiBIT-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TebiBIT-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    new Decimal("762123384785.8104503028768718089172"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Tib/m³",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Tebibit per Cubic Metre", "en"));
  unit.addLabel(new LangString("Tebibit per Cubic Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/VolumetricBitDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/TebiBIT-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TebiBYTE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("6096987078286.483602423014974471338"),
    undefined,
    "http://qudt.org/vocab/prefix/Tebi",
    "http://qudt.org/vocab/unit/BYTE",
    undefined,
    "TiB",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Tebibyte", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InformationEntropy"
  );
  config.units.set("http://qudt.org/vocab/unit/TebiBYTE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TeraA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T0D0",
    new Decimal("1000000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Tera",
    "http://qudt.org/vocab/unit/A",
    undefined,
    "TA",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Teraampere", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/CurrentLinkage");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagnetomotiveForce"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MagneticTension");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCurrent");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/TotalCurrent");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DisplacementCurrent"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentPhasor"
  );
  config.units.set("http://qudt.org/vocab/unit/TeraA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TeraBIT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("693147180559.94530941723212145818"),
    undefined,
    "http://qudt.org/vocab/prefix/Tera",
    "http://qudt.org/vocab/unit/BIT",
    undefined,
    "Tb",
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Terabit", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DatasetOfBits");
  config.units.set("http://qudt.org/vocab/unit/TeraBIT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TeraBIT-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("693147180559.94530941723212145818"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Tb/s",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Terabit per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DataRate");
  config.units.set("http://qudt.org/vocab/unit/TeraBIT-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TeraBQ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("1000000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Tera",
    "http://qudt.org/vocab/unit/BQ",
    undefined,
    "TBq",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Terabecquerel", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Activity");
  config.units.set("http://qudt.org/vocab/unit/TeraBQ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TeraBYTE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("5545177444479.56247533785697166544"),
    undefined,
    "http://qudt.org/vocab/prefix/Tera",
    "http://qudt.org/vocab/unit/BYTE",
    undefined,
    "TB",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Terabyte", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InformationEntropy"
  );
  config.units.set("http://qudt.org/vocab/unit/TeraBYTE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TeraC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("1000000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Tera",
    "http://qudt.org/vocab/unit/C",
    undefined,
    "TC",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Teracoulomb", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  config.units.set("http://qudt.org/vocab/unit/TeraC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TeraFLOPS",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("1000000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Tera",
    "http://qudt.org/vocab/unit/FLOPS",
    undefined,
    "TFLOPS",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Tera Floating Point Operations per Second", "en")
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/FloatingPointCalculationCapability"
  );
  config.units.set("http://qudt.org/vocab/unit/TeraFLOPS", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TeraHZ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("1000000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Tera",
    "http://qudt.org/vocab/unit/HZ",
    undefined,
    "THz",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Terahertz", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Frequency");
  config.units.set("http://qudt.org/vocab/unit/TeraHZ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TeraJ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1000000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Tera",
    "http://qudt.org/vocab/unit/J",
    undefined,
    "TJ",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    1,
    false,
    false
  );
  unit.addLabel(new LangString("Terajoule", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/TeraJ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TeraJ-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1000000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "TJ/s",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Terajoule per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/TeraJ-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TeraOHM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H0T-3D0",
    new Decimal("1000000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Tera",
    "http://qudt.org/vocab/unit/OHM",
    undefined,
    "TΩ",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Teraohm", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Resistance");
  config.units.set("http://qudt.org/vocab/unit/TeraOHM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TeraV",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-3D0",
    new Decimal("1000000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Tera",
    "http://qudt.org/vocab/unit/V",
    undefined,
    "TV",
    undefined,
    undefined,
    undefined,
    [],
    2,
    false,
    false
  );
  unit.addLabel(new LangString("Teravolt", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotential"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Voltage");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EnergyPerElectricCharge"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotentialDifference"
  );
  config.units.set("http://qudt.org/vocab/unit/TeraV", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TeraV-A",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1000000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "TV·A",
    undefined,
    undefined,
    undefined,
    [],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("Teravolt Ampere", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ApparentPower");
  config.units.set("http://qudt.org/vocab/unit/TeraV-A", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TeraV-A_Reactive",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "TV·A{Reactive}",
    undefined,
    undefined,
    undefined,
    [],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("TeraVolt Ampere Reactive", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ReactivePower");
  config.units.set("http://qudt.org/vocab/unit/TeraV-A_Reactive", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TeraVA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1000000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Tera",
    "http://qudt.org/vocab/unit/VA",
    undefined,
    "TVA",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Tera Volt Ampere", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ApparentPower");
  config.units.set("http://qudt.org/vocab/unit/TeraVA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TeraVAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1000000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Tera",
    "http://qudt.org/vocab/unit/VAR",
    undefined,
    "TVA{Reactive}",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Tera Volt Ampere Reactive", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ReactivePower");
  config.units.set("http://qudt.org/vocab/unit/TeraVAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TeraW",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1000000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Tera",
    "http://qudt.org/vocab/unit/W",
    undefined,
    "TW",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    2,
    false,
    false
  );
  unit.addLabel(new LangString("Terawatt", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/TeraW", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TeraW-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("3600000000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "TW·h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Terawatt Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/TeraW-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TeraW-HR-PER-YR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("114077116.1305042208532968286561716"),
    undefined,
    undefined,
    undefined,
    undefined,
    "TW·h/a",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Terawatt Hour per Year", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/TeraW-HR-PER-YR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TonEnergy",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("4184000000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/J",
    undefined,
    "t/lbf",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Ton Energy", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/TonEnergy", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/U",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("1.66053878283E-27"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "u",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Unified Atomic Mass Unit", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/AMU");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/DA");
  config.units.set("http://qudt.org/vocab/unit/U", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/UNITLESS",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "一",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Unitless", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MobilityRatio");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Dissipance");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Duv");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LogOctanolWaterPartitionCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CanonicalPartitionFunction"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/NeutronYieldPerAbsorption"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/RelativeMassRatioOfVapour"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/GruneisenParameter"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DegreeOfDissociation"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Reflectance");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricSusceptibility"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalDiffusionFactor"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DoseEquivalentQualityFactor"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/BioconcentrationFactor"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/GeneralizedForce"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/StructureFactor");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/RelativeMassConcentrationOfVapour"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/RadianceFactor");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/StatisticalWeight"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Lethargy");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PackingFraction");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AverageLogarithmicEnergyDecrement"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EquilibriumConstant"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Short-RangeOrderParameter"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DutyCycle");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/GeneralizedVelocity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/NeutronYieldPerFission"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LandeGFactor");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticSusceptability"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Non-LeakageProbability"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/StandardAbsoluteActivity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Emissivity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFraction");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LeakageFactor");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/FastFissionFactor"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ActivityCoefficient"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Reactivity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Absorptance");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MultiplicationFactor"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ResonanceEscapeProbability"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalDiffusionRatio"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EinsteinTransitionProbability"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassFractionOfWater"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/TotalIonization");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LogOctanolAirPartitionCoefficient"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ServiceFactor");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/FrictionCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalUtilizationFactor"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassRatioOfWaterVapourToDryGas"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InternalConversionFactor"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LossFactor");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/NumberOfParticles"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/OsmoticCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/NapierianAbsorbance"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AtomScatteringFactor"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Chromaticity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Constringence");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/GeneralizedMomentum"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PoissonRatio");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Debye-WallerFactor"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Turns");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/RelativeMassDensity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassFractionOfDryMatter"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/RelativeMassExcess"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PowerFactor");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Long-RangeOrderParameter"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TransmittanceDensity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/CouplingFactor");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/GFactorOfNucleus"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/RefractiveIndex");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/BindingFraction");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/OrderOfReflection"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Count");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/GeneralizedCoordinate"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PermittivityRatio"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MadelungConstant"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassRatioOfWaterToDryMatter"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/RatioOfSpecificHeatCapacities"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Dimensionless");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/QualityFactor");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/IsentropicExponent"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LogarithmicFrequencyInterval"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ReflectanceFactor"
  );
  config.units.set("http://qudt.org/vocab/unit/UNITLESS", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/UNKNOWN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Unknown",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Unknown", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/UNKNOWN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/UnitPole",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-2D0",
    new Decimal("1.256637E-7"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/WB",
    undefined,
    "pole",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Unit Pole", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MagneticFlux");
  config.units.set("http://qudt.org/vocab/unit/UnitPole", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/V",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "V",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    67,
    false,
    false
  );
  unit.addLabel(new LangString("Volt", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotential"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Voltage");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EnergyPerElectricCharge"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotentialDifference"
  );
  config.units.set("http://qudt.org/vocab/unit/V", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/V-A",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "V·A",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("Volt Ampere", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ApparentPower");
  config.units.set("http://qudt.org/vocab/unit/V-A", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/V-A-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("3600.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "V·A·h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("Volt Ampere Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/V-A-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/V-A-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H-1T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "V·A/K",
    undefined,
    undefined,
    undefined,
    [],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("Volt Ampere per Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalConductance"
  );
  config.units.set("http://qudt.org/vocab/unit/V-A-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/V-A_Reactive",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "V·A{Reactive}",
    undefined,
    undefined,
    undefined,
    [],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("Volt Ampere Reactive", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ReactivePower");
  config.units.set("http://qudt.org/vocab/unit/V-A_Reactive", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/V-A_Reactive-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("3600.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "V·A{reactive}·h",
    undefined,
    undefined,
    undefined,
    [],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("Volt Ampere Reactive Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/V-A_Reactive-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/V-A_Reactive-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L-2I0M1H-1T-3D0",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "var/K",
    undefined,
    undefined,
    undefined,
    [],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("Volt Ampere Reactive per Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/V-A_Reactive-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/V-IN2-PER-LB_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L3I0M0H0T-1D0",
    new Decimal("0.0001450377312227268702148557236386593"),
    undefined,
    undefined,
    undefined,
    undefined,
    "V·in²/lbf",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Volt Square Inch per Pound Force", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/HallCoefficient");
  config.units.set("http://qudt.org/vocab/unit/V-IN2-PER-LB_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/V-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L3I0M1H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "V·m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Volt Meter", "en-US"));
  unit.addLabel(new LangString("Volt Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricFlux");
  config.units.set("http://qudt.org/vocab/unit/V-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/V-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L3I0M0H0T-1D0",
    new Decimal("0.00001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "V/bar",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Volt per Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/HallCoefficient");
  config.units.set("http://qudt.org/vocab/unit/V-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/V-PER-CentiM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L1I0M1H0T-3D0",
    new Decimal("100.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "V/cm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Volt per Centimetre", "en"));
  unit.addLabel(new LangString("Volt per Centimeter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricFieldStrength"
  );
  config.units.set("http://qudt.org/vocab/unit/V-PER-CentiM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/V-PER-IN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L1I0M1H0T-3D0",
    new Decimal("39.37007874015748031496062992125984"),
    undefined,
    undefined,
    undefined,
    undefined,
    "V/in",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Volt per Inch", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricFieldStrength"
  );
  config.units.set("http://qudt.org/vocab/unit/V-PER-IN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/V-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H-1T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "V/K",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Volt per Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SeebeckCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThomsonCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/V-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/V-PER-L-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L-1I0M1H0T-4D0",
    new Decimal("16.66666666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "V/(L·min)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Volt per Liter Minute", "en-US"));
  unit.addLabel(new LangString("Volt per Litre Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/V-PER-L-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/V-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L1I0M1H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "V/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Volt per Metre", "en"));
  unit.addLabel(new LangString("Volt per Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricFieldStrength"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricField");
  config.units.set("http://qudt.org/vocab/unit/V-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/V-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L0I0M1H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "V/m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Volt per Square Meter", "en-US"));
  unit.addLabel(new LangString("Volt per Square Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EnergyPerAreaElectricCharge"
  );
  config.units.set("http://qudt.org/vocab/unit/V-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/V-PER-MicroSEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-4D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "V/μs",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Volt per Microsecond", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PowerPerElectricCharge"
  );
  config.units.set("http://qudt.org/vocab/unit/V-PER-MicroSEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/V-PER-MilliM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L1I0M1H0T-3D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "V/mm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Volt per Millimeter", "en-US"));
  unit.addLabel(new LangString("Volt per Millimetre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricFieldStrength"
  );
  config.units.set("http://qudt.org/vocab/unit/V-PER-MilliM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/V-PER-PA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L3I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "V/Pa",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Volt per Pascal", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/HallCoefficient");
  config.units.set("http://qudt.org/vocab/unit/V-PER-PA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/V-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-4D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "V/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Volt per Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PowerPerElectricCharge"
  );
  config.units.set("http://qudt.org/vocab/unit/V-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/V-PER-V",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "V/V",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Volt per Volt", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/V-PER-V", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/V-SEC-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L1I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "V·s/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Volt Second per Metre", "en"));
  unit.addLabel(new LangString("Volt Second per Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticVectorPotential"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticFluxPerLength"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ScalarMagneticPotential"
  );
  config.units.set("http://qudt.org/vocab/unit/V-SEC-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/V2-PER-K2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L4I0M2H-2T-6D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "V²/K²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Volt per Square Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LorenzCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/V2-PER-K2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/VA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "VA",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    13,
    false,
    false
  );
  unit.addLabel(new LangString("Volt Ampere", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ApparentPower");
  config.units.set("http://qudt.org/vocab/unit/VA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/VA-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("3600.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "VA·h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Volt Ampere Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/VA-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/VA-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H-1T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "VA/K",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Volt Ampere per Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalConductance"
  );
  config.units.set("http://qudt.org/vocab/unit/VA-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/VAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "VA{Reactive}",
    undefined,
    undefined,
    undefined,
    [],
    10,
    false,
    false
  );
  unit.addLabel(new LangString("Volt Ampere Reactive", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ReactivePower");
  config.units.set("http://qudt.org/vocab/unit/VAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/VAR-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("3600.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "VA{Reactive}·h",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Volt Ampere Reactive Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/VAR-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/VAR-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H-1T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "VA{Reactive}/K",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Volt Ampere Reactive per Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/VAR-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/V_Ab",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-3D0",
    new Decimal("1E-8"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/V",
    undefined,
    "abV",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-EMU", "http://qudt.org/vocab/sou/CGS"],
    2,
    false,
    false
  );
  unit.addLabel(new LangString("Abvolt", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotential"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Voltage");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EnergyPerElectricCharge"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotentialDifference"
  );
  config.units.set("http://qudt.org/vocab/unit/V_Ab", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/V_Ab-PER-CentiM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L1I0M1H0T-3D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "abV/cm",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-EMU", "http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Abvolt per Centimeter", "en-US"));
  unit.addLabel(new LangString("Abvolt per Centimetre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricFieldStrength"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricField");
  config.units.set("http://qudt.org/vocab/unit/V_Ab-PER-CentiM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/V_Ab-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-2D0",
    new Decimal("1E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "abV·s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-EMU", "http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Abvolt Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MagneticFlux");
  config.units.set("http://qudt.org/vocab/unit/V_Ab-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/V_Stat",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-3D0",
    new Decimal("299.792458"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/V",
    undefined,
    "statV",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS", "http://qudt.org/vocab/sou/CGS-ESU"],
    2,
    false,
    false
  );
  unit.addLabel(new LangString("Statvolt", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotential"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Voltage");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EnergyPerElectricCharge"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotentialDifference"
  );
  config.units.set("http://qudt.org/vocab/unit/V_Stat", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/V_Stat-CentiM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L3I0M1H0T-3D0",
    new Decimal("2.99792458"),
    undefined,
    undefined,
    undefined,
    undefined,
    "statV·cm",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Statvolt Centimetre", "en"));
  unit.addLabel(new LangString("Statvolt Centimeter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricFlux");
  config.units.set("http://qudt.org/vocab/unit/V_Stat-CentiM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/V_Stat-PER-CentiM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L1I0M1H0T-3D0",
    new Decimal("29979.2458"),
    undefined,
    undefined,
    undefined,
    undefined,
    "statV/cm",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Statvolt per Centimeter", "en-US"));
  unit.addLabel(new LangString("Statvolt per Centimetre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricFieldStrength"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricField");
  config.units.set("http://qudt.org/vocab/unit/V_Stat-PER-CentiM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    108,
    false,
    false
  );
  unit.addLabel(new LangString("Watt", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/W", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("3600.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W·h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Watt Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/W-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-HR-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("3600.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W·h/kg",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Watt Hour per Kilogram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificEnergy");
  config.units.set("http://qudt.org/vocab/unit/W-HR-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-HR-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("3600000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W·h/L",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Watt Hour per Litre", "en"));
  unit.addLabel(new LangString("Watt Hour per Liter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/W-HR-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-HR-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("3600.0"),
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    "W·h/m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Watt Hour per Square Meter", "en-US"));
  unit.addLabel(new LangString("Watt Hour per Square Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyPerArea");
  config.units.set("http://qudt.org/vocab/unit/W-HR-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-HR-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("3600.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W·h/m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Watt Hour per Cubic Meter", "en-US"));
  unit.addLabel(new LangString("Watt Hour per Cubic Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyDensity");
  config.units.set("http://qudt.org/vocab/unit/W-HR-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-M-PER-M2-SR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W·m/(m²·sr)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Watt Metre per Square Metre Steradian", "en"));
  unit.addLabel(
    new LangString("Watt Meter per Square Meter Steradian", "en-US")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/W-M-PER-M2-SR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M1H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W·m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Watt Square Meter", "en-US"));
  unit.addLabel(new LangString("Watt Square Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PowerArea");
  config.units.set("http://qudt.org/vocab/unit/W-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-M2-PER-SR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M1H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W·m²/sr",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Watt Square Metre per Steradian", "en"));
  unit.addLabel(new LangString("Watt Square Meter per Steradian", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PowerAreaPerSolidAngle"
  );
  config.units.set("http://qudt.org/vocab/unit/W-M2-PER-SR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-PER-CentiM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    new Decimal("10000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W/cm²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Watt per Square Centimeter", "en-US"));
  unit.addLabel(new LangString("Watt per Square Centimetre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PowerPerArea");
  config.units.set("http://qudt.org/vocab/unit/W-PER-CentiM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-PER-FT2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    new Decimal("10.7639104167097223083335055559"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W/ft²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Watt per Square Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PowerPerArea");
  config.units.set("http://qudt.org/vocab/unit/W-PER-FT2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-PER-GM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W/g",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Watt per Gram", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificPower");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/MilliW-PER-MilliGM");
  config.units.set("http://qudt.org/vocab/unit/W-PER-GM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-PER-IN2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    new Decimal("1550.0031000062000124000248000496"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W/in²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Watt per Square Inch", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PowerPerArea");
  config.units.set("http://qudt.org/vocab/unit/W-PER-IN2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H-1T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W/K",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Watt per Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalConductance"
  );
  config.units.set("http://qudt.org/vocab/unit/W-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W/kg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Watt per Kilogram", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificPower");
  config.units.set("http://qudt.org/vocab/unit/W-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Watt per Meter", "en-US"));
  unit.addLabel(new LangString("Watt per Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LineicPower");
  config.units.set("http://qudt.org/vocab/unit/W-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-PER-M-DEG_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H-1T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W/(m·°C)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Watt per Meter Degree Celsius", "en-US"));
  unit.addLabel(new LangString("Watt per Metre Degree Celsius", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalConductivity"
  );
  config.units.set("http://qudt.org/vocab/unit/W-PER-M-DEG_C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-PER-M-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H-1T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W/(m·K)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Watt per Meter Kelvin", "en-US"));
  unit.addLabel(new LangString("Watt per Metre Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalConductivity"
  );
  config.units.set("http://qudt.org/vocab/unit/W-PER-M-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W/m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Watt per Square Meter", "en-US"));
  unit.addLabel(new LangString("Watt per Square Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PowerPerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PoyntingVector");
  config.units.set("http://qudt.org/vocab/unit/W-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-PER-M2-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W/(m²·K)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Watt per Square Meter Kelvin", "en-US"));
  unit.addLabel(new LangString("Watt per Square Metre Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SurfaceCoefficientOfHeatTransfer"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CombinedNonEvaporativeHeatTransferCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CoefficientOfHeatTransfer"
  );
  config.units.set("http://qudt.org/vocab/unit/W-PER-M2-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-PER-M2-K4",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-4T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W/(m²·K⁴)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Watt per Square Meter Quartic Kelvin", "en-US")
  );
  unit.addLabel(new LangString("Watt per Square Metre Quartic Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PowerPerAreaQuarticTemperature"
  );
  config.units.set("http://qudt.org/vocab/unit/W-PER-M2-K4", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-PER-M2-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W/(m²·m)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Watt per Square Meter Meter", "en-US"));
  unit.addLabel(new LangString("Watt per Square Metre Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/W-PER-M2-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-PER-M2-M-SR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W/(m²·m·sr)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Watt per Square Metre Metre Steradian", "en"));
  unit.addLabel(
    new LangString("Watt per Square Meter Meter Steradian", "en-US")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/W-PER-M2-M-SR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-PER-M2-MicroM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-3D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W/(m²·μm)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Watt per Square Meter Micrometer", "en-US"));
  unit.addLabel(new LangString("Watt per Square Metre Micrometre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpectralRadiance"
  );
  config.units.set("http://qudt.org/vocab/unit/W-PER-M2-MicroM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-PER-M2-MicroM-SR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-3D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W/(m²·μm·sr)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Watt per Square Metre Micrometre Steradian", "en")
  );
  unit.addLabel(
    new LangString("Watt per Square Meter Micrometer Steradian", "en-US")
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpectralRadiance"
  );
  config.units.set("http://qudt.org/vocab/unit/W-PER-M2-MicroM-SR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-PER-M2-NanoM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-3D0",
    new Decimal("1000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W/(m²·nm)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Watt per Square Meter Nanometer", "en-US"));
  unit.addLabel(new LangString("Watt per Square Metre Nanometre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/W-PER-M2-NanoM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-PER-M2-NanoM-SR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-3D0",
    new Decimal("1000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W/(m²·nm·sr)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(
    new LangString("Watt per Square Meter Nanometer Steradian", "en-US")
  );
  unit.addLabel(
    new LangString("Watt per Square Metre Nanometre Steradian", "en")
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpectralRadiance"
  );
  config.units.set("http://qudt.org/vocab/unit/W-PER-M2-NanoM-SR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-PER-M2-PA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W/(m²·Pa)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Watt per Square Metre Pascal", "en"));
  unit.addLabel(new LangString("Watt per Square Meter Pascal", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EvaporativeHeatTransferCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/W-PER-M2-PA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-PER-M2-SR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W/(m²·sr)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Watt per Square Metre Steradian", "en"));
  unit.addLabel(new LangString("Watt per Square Meter Steradian", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Radiance");
  config.units.set("http://qudt.org/vocab/unit/W-PER-M2-SR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W/m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Watt per Cubic Metre", "en"));
  unit.addLabel(new LangString("Watt per Cubic Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PowerDensity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PowerPerVolume");
  config.units.set("http://qudt.org/vocab/unit/W-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-PER-SR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W/sr",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Watt per Steradian", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/RadiantIntensity"
  );
  config.units.set("http://qudt.org/vocab/unit/W-PER-SR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W·s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Watt Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/W-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-SEC-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W·s/m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Watt Second per Square Metre", "en"));
  unit.addLabel(new LangString("Watt Second per Square Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyPerArea");
  config.units.set("http://qudt.org/vocab/unit/W-SEC-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W0dot",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    [],
    1,
    false,
    true
  );
  unit.addLabel(new LangString("W0dot", undefined));
  config.units.set("http://qudt.org/vocab/unit/W0dot", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/WB",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Wb",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    24,
    false,
    false
  );
  unit.addLabel(new LangString("Weber", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MagneticFlux");
  config.units.set("http://qudt.org/vocab/unit/WB", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/WB-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L3I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Wb·m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Weber Metre", "en"));
  unit.addLabel(new LangString("Weber Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticDipoleMoment"
  );
  unit.addExactMatchIri("http://qudt.org/vocab/unit/N-M2-PER-A");
  config.units.set("http://qudt.org/vocab/unit/WB-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/WB-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L1I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Wb/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Weber per Meter", "en-US"));
  unit.addLabel(new LangString("Weber per Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticVectorPotential"
  );
  config.units.set("http://qudt.org/vocab/unit/WB-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/WB-PER-MilliM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L1I0M1H0T-2D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Wb/mm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Weber per Millimeter", "en-US"));
  unit.addLabel(new LangString("Weber per Millimetre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticVectorPotential"
  );
  config.units.set("http://qudt.org/vocab/unit/WB-PER-MilliM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/WK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("604800.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/SEC",
    undefined,
    "wk",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    5,
    false,
    false
  );
  unit.addLabel(new LangString("Week", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/WK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/WK-PER-NUM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("604800.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "wk/#",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Week per Number", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/TimePerCount");
  config.units.set("http://qudt.org/vocab/unit/WK-PER-NUM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/YD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("0.9144"),
    undefined,
    undefined,
    undefined,
    undefined,
    "yd",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    44,
    false,
    false
  );
  unit.addLabel(new LangString("Yard", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/YD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/YD-PER-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H-1T0D0",
    new Decimal("1.64592"),
    undefined,
    undefined,
    undefined,
    undefined,
    "yd/°F",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Yard per Degree Fahrenheit", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearThermalExpansion"
  );
  config.units.set("http://qudt.org/vocab/unit/YD-PER-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/YD-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("0.000254"),
    undefined,
    undefined,
    undefined,
    undefined,
    "yd/h",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Yard per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Speed");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectromagneticWavePhaseSpeed"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/YD-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/YD-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("0.01524"),
    undefined,
    undefined,
    undefined,
    undefined,
    "yd/min",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Yard per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Speed");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectromagneticWavePhaseSpeed"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/YD-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/YD-PER-PSI",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M-1H0T2D0",
    new Decimal("0.0001326225014300614501244640736951901"),
    undefined,
    undefined,
    undefined,
    undefined,
    "yd/psi",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Yard per Psi", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/YD-PER-PSI", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/YD-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("0.9144"),
    undefined,
    undefined,
    undefined,
    undefined,
    "yd/s",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Yard per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Speed");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectromagneticWavePhaseSpeed"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/YD-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/YD-PER-SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-2D0",
    new Decimal("0.9144"),
    undefined,
    undefined,
    undefined,
    undefined,
    "yd/s²",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Yard per Square Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Acceleration");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearAcceleration"
  );
  config.units.set("http://qudt.org/vocab/unit/YD-PER-SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/YD2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    new Decimal("0.83612736"),
    undefined,
    undefined,
    undefined,
    undefined,
    "yd²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Square Yard", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Area");
  config.units.set("http://qudt.org/vocab/unit/YD2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/YD3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.764554857984"),
    undefined,
    undefined,
    undefined,
    undefined,
    "yd³",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Yard", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/YD3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/YD3-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.000008849014559999999999999999999999997"),
    undefined,
    undefined,
    undefined,
    undefined,
    "yd³/d",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Yard per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/YD3-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/YD3-PER-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H-1T0D0",
    new Decimal("1.3761987443712"),
    undefined,
    undefined,
    undefined,
    undefined,
    "yd³/°F",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Yard per Degree Fahrenheit", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/VolumeThermalExpansion"
  );
  config.units.set("http://qudt.org/vocab/unit/YD3-PER-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/YD3-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.00021237634944"),
    undefined,
    undefined,
    undefined,
    undefined,
    "yd³/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Yard per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/YD3-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/YD3-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.0127425809664"),
    undefined,
    undefined,
    undefined,
    undefined,
    "yd³/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Yard per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/YD3-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/YD3-PER-PSI",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M-1H0T2D0",
    new Decimal("0.0001108893019973135049303398173536047"),
    undefined,
    undefined,
    undefined,
    undefined,
    "yd³/psi",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Yard per Psi", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/YD3-PER-PSI", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/YD3-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.764554857984"),
    undefined,
    undefined,
    undefined,
    undefined,
    "yd³/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Cubic Yard per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/YD3-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/YR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("31557600.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/SEC",
    undefined,
    "a",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    32,
    false,
    false
  );
  unit.addLabel(new LangString("Year", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/YR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/YR-PER-NUM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("31557600.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "a/#",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Year per Number", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/TimePerCount");
  config.units.set("http://qudt.org/vocab/unit/YR-PER-NUM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/YR_Common",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("31536000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/SEC",
    undefined,
    "a",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Common Year", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/YR_Common", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/YR_Metrology",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("31557600.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/SEC",
    undefined,
    "y (metrology)",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Metrology Year", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/YR_Metrology", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/YR_Sidereal",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("31558149.7632"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/SEC",
    undefined,
    "a{sidereal}",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Sidereal Year", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/YR_Sidereal", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/YR_TROPICAL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("31556925.216"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/SEC",
    undefined,
    "a{tropical}",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Tropical Year", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/YR_TROPICAL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/YoctoC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("1E-24"),
    undefined,
    "http://qudt.org/vocab/prefix/Yocto",
    "http://qudt.org/vocab/unit/C",
    undefined,
    "yC",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Yoctocoulomb", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  config.units.set("http://qudt.org/vocab/unit/YoctoC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/YottaC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("1000000000000000000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Yotta",
    "http://qudt.org/vocab/unit/C",
    undefined,
    "YC",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Yottacoulomb", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  config.units.set("http://qudt.org/vocab/unit/YottaC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/Z",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Z",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Atomic-number", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AtomicNumber");
  config.units.set("http://qudt.org/vocab/unit/Z", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ZOLL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("0.0254"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M",
    undefined,
    "“",
    undefined,
    undefined,
    undefined,
    [],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Inch", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/IN");
  config.units.set("http://qudt.org/vocab/unit/ZOLL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ZeptoC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("1E-21"),
    undefined,
    "http://qudt.org/vocab/prefix/Zepto",
    "http://qudt.org/vocab/unit/C",
    undefined,
    "zC",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Zeptocoulomb", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  config.units.set("http://qudt.org/vocab/unit/ZeptoC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ZettaC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("1000000000000000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Zetta",
    "http://qudt.org/vocab/unit/C",
    undefined,
    "ZC",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ],
    0,
    false,
    false
  );
  unit.addLabel(new LangString("Zettacoulomb", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  config.units.set("http://qudt.org/vocab/unit/ZettaC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/failures-in-time",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "failures/s",
    undefined,
    undefined,
    undefined,
    [],
    0,
    true,
    false
  );
  unit.addLabel(new LangString("Failures in Time", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Frequency");
  config.units.set("http://qudt.org/vocab/unit/failures-in-time", unit);
}

export const Units = {
  // Femtogram per Liter
  FemtoGM__PER__L: Qudt.unitFromLocalnameRequired("FemtoGM-PER-L"),
  // Kroon
  CCY_EEK_Currency: Qudt.unitFromLocalnameRequired("CCY_EEK"),
  // Microgram per Liter
  MicroGM__PER__L: Qudt.unitFromLocalnameRequired("MicroGM-PER-L"),
  // Kilogram per Day Bar
  KiloGM__PER__DAY__BAR: Qudt.unitFromLocalnameRequired("KiloGM-PER-DAY-BAR"),
  // Microgray
  MicroGRAY: Qudt.unitFromLocalnameRequired("MicroGRAY"),
  // Kiloyear
  KiloYR: Qudt.unitFromLocalnameRequired("KiloYR"),
  // Degree per Hour
  DEG__PER__HR: Qudt.unitFromLocalnameRequired("DEG-PER-HR"),
  // Reciprocal Degree Celsius
  PER__DEG_C: Qudt.unitFromLocalnameRequired("PER-DEG_C"),
  // Katal per Cubic Meter
  KAT__PER__M3: Qudt.unitFromLocalnameRequired("KAT-PER-M3"),
  // Becquerel per Cubic Metre
  BQ__PER__M3: Qudt.unitFromLocalnameRequired("BQ-PER-M3"),
  // Electron Volt Square Metre per Kilogram
  EV__M2__PER__KiloGM: Qudt.unitFromLocalnameRequired("EV-M2-PER-KiloGM"),
  // Lumen per Watt
  LM__PER__W: Qudt.unitFromLocalnameRequired("LM-PER-W"),
  // Joule per Minute
  J__PER__MIN: Qudt.unitFromLocalnameRequired("J-PER-MIN"),
  // Kilopascal per Bar
  KiloPA__PER__BAR: Qudt.unitFromLocalnameRequired("KiloPA-PER-BAR"),
  // Cubic Yard per Degree Fahrenheit
  YD3__PER__DEG_F: Qudt.unitFromLocalnameRequired("YD3-PER-DEG_F"),
  // Femtomole per Kilogram
  FemtoMOL__PER__KiloGM: Qudt.unitFromLocalnameRequired("FemtoMOL-PER-KiloGM"),
  // Terawatt
  TeraW: Qudt.unitFromLocalnameRequired("TeraW"),
  // Guyana Dollar
  CCY_GYD: Qudt.unitFromLocalnameRequired("CCY_GYD"),
  // Siemens per Centimetre
  S__PER__CentiM: Qudt.unitFromLocalnameRequired("S-PER-CentiM"),
  // Joule per Hour
  J__PER__HR: Qudt.unitFromLocalnameRequired("J-PER-HR"),
  // Meter per Radian
  M__PER__RAD: Qudt.unitFromLocalnameRequired("M-PER-RAD"),
  // Number per Year
  NUM__PER__YR: Qudt.unitFromLocalnameRequired("NUM-PER-YR"),
  // Bar Litre per Second
  BAR__L__PER__SEC: Qudt.unitFromLocalnameRequired("BAR-L-PER-SEC"),
  // Percent Minute per Cubic Inch
  PERCENT__MIN__PER__IN3: Qudt.unitFromLocalnameRequired("PERCENT-MIN-PER-IN3"),
  // Pound Force Second per Square Foot
  LB_F__SEC__PER__FT2: Qudt.unitFromLocalnameRequired("LB_F-SEC-PER-FT2"),
  // Loti
  CCY_LSL_Currency: Qudt.unitFromLocalnameRequired("CCY_LSL"),
  // Singapore Dollar
  CCY_SGD_Currency: Qudt.unitFromLocalnameRequired("CCY_SGD"),
  // Square Metre per Hectare
  M2__PER__HA: Qudt.unitFromLocalnameRequired("M2-PER-HA"),
  // Number per Hectare
  NUM__PER__HA: Qudt.unitFromLocalnameRequired("NUM-PER-HA"),
  // Ohm Centimetre
  OHM__CentiM: Qudt.unitFromLocalnameRequired("OHM-CentiM"),
  // Octet per Second
  OCTET__PER__SEC: Qudt.unitFromLocalnameRequired("OCTET-PER-SEC"),
  // Argentine Peso
  CCY_ARS: Qudt.unitFromLocalnameRequired("CCY_ARS"),
  // European Monetary Unit (e.m.u.-6) (bonds Market Unit)
  CCY_XBB: Qudt.unitFromLocalnameRequired("CCY_XBB"),
  // Cubic Decimeter per Kilogram
  DeciM3__PER__KiloGM: Qudt.unitFromLocalnameRequired("DeciM3-PER-KiloGM"),
  // Degree Celsius Centimetre
  DEG_C__CentiM: Qudt.unitFromLocalnameRequired("DEG_C-CentiM"),
  // Statvolt per Centimeter
  V_Stat__PER__CentiM: Qudt.unitFromLocalnameRequired("V_Stat-PER-CentiM"),
  // Microgram per Kilogram
  MicroGM__PER__KiloGM: Qudt.unitFromLocalnameRequired("MicroGM-PER-KiloGM"),
  // Square Foot per Hour
  FT2__PER__HR: Qudt.unitFromLocalnameRequired("FT2-PER-HR"),
  // Millinewton Meter
  MilliN__M: Qudt.unitFromLocalnameRequired("MilliN-M"),
  // Pound Mass Minute per Gallon (UK) Cubic Foot
  LB__MIN__PER__GAL_UK__FT3: Qudt.unitFromLocalnameRequired(
    "LB-MIN-PER-GAL_UK-FT3"
  ),
  // Nanometre per Millimetre Megapascal
  NanoM__PER__MilliM__MegaPA: Qudt.unitFromLocalnameRequired(
    "NanoM-PER-MilliM-MegaPA"
  ),
  // Mega Electron Volt per Centimetre
  MegaEV__PER__CentiM: Qudt.unitFromLocalnameRequired("MegaEV-PER-CentiM"),
  // Coulomb per Square Centimeter
  C__PER__CentiM2: Qudt.unitFromLocalnameRequired("C-PER-CentiM2"),
  // Us Liquid Ounce per Minute
  OZ_VOL_US__PER__MIN: Qudt.unitFromLocalnameRequired("OZ_VOL_US-PER-MIN"),
  // Acre
  AC: Qudt.unitFromLocalnameRequired("AC"),
  // Maltese Lira
  CCY_MTL_Currency: Qudt.unitFromLocalnameRequired("CCY_MTL"),
  // Millimole per Square Meter Hour
  MilliMOL__PER__M2__HR: Qudt.unitFromLocalnameRequired("MilliMOL-PER-M2-HR"),
  // Saint Helena Pound
  CCY_SHP_Currency: Qudt.unitFromLocalnameRequired("CCY_SHP"),
  // Ounce Mass Foot
  OZ__FT: Qudt.unitFromLocalnameRequired("OZ-FT"),
  // Metre
  M: Qudt.unitFromLocalnameRequired("M"),
  // Nanometer
  NanoM: Qudt.unitFromLocalnameRequired("NanoM"),
  // Baud
  BAUD: Qudt.unitFromLocalnameRequired("BAUD"),
  // International Table Calorie
  CAL_IT: Qudt.unitFromLocalnameRequired("CAL_IT"),
  // Milligray per Second
  MilliGRAY__PER__SEC: Qudt.unitFromLocalnameRequired("MilliGRAY-PER-SEC"),
  // Milligalileo per Month
  MilliGAL__PER__MO: Qudt.unitFromLocalnameRequired("MilliGAL-PER-MO"),
  // Milligram per Liter Centipoise
  MilliGM__PER__L__CentiPOISE: Qudt.unitFromLocalnameRequired(
    "MilliGM-PER-L-CentiPOISE"
  ),
  // Percent Minute per Cubic Centimetre
  PERCENT__MIN__PER__CentiM3: Qudt.unitFromLocalnameRequired(
    "PERCENT-MIN-PER-CentiM3"
  ),
  // Reciprocal Second Square Metre Steradian
  PER__SEC__M2__SR: Qudt.unitFromLocalnameRequired("PER-SEC-M2-SR"),
  // Metric Ton
  TON_Metric: Qudt.unitFromLocalnameRequired("TON_Metric"),
  // Growing Degree Days (cereals)
  DEG_C_GROWING_CEREAL__DAY: Qudt.unitFromLocalnameRequired(
    "DEG_C_GROWING_CEREAL-DAY"
  ),
  // Volt per Second
  V__PER__SEC: Qudt.unitFromLocalnameRequired("V-PER-SEC"),
  // Ounce Mass per Square Inch
  OZ__PER__IN2: Qudt.unitFromLocalnameRequired("OZ-PER-IN2"),
  // Cubic Metre per Mole
  M3__PER__MOL: Qudt.unitFromLocalnameRequired("M3-PER-MOL"),
  // Russian Ruble
  CCY_RUB: Qudt.unitFromLocalnameRequired("CCY_RUB"),
  // Siemens
  S: Qudt.unitFromLocalnameRequired("S"),
  // Inch
  ZOLL: Qudt.unitFromLocalnameRequired("ZOLL"),
  // Kilogram per Hour
  KiloGM__PER__HR: Qudt.unitFromLocalnameRequired("KiloGM-PER-HR"),
  // Microbecquerel per Kilogram
  MicroBQ__PER__KiloGM: Qudt.unitFromLocalnameRequired("MicroBQ-PER-KiloGM"),
  // Millimetre per Bar
  MilliM__PER__BAR: Qudt.unitFromLocalnameRequired("MilliM-PER-BAR"),
  // Tonne per Second Bar
  TONNE__PER__SEC__BAR: Qudt.unitFromLocalnameRequired("TONNE-PER-SEC-BAR"),
  // DecaKiloCOUNT
  DecaKiloCOUNT: Qudt.unitFromLocalnameRequired("DecaKiloCOUNT"),
  // Kilonewton
  KiloN: Qudt.unitFromLocalnameRequired("KiloN"),
  // Milligram per Second Kelvin
  MilliGM__PER__SEC__K: Qudt.unitFromLocalnameRequired("MilliGM-PER-SEC-K"),
  // Millivolt Ampere
  MilliV__A: Qudt.unitFromLocalnameRequired("MilliV-A"),
  // British Thermal Unit (international Definition) per Square Foot Second Degree Fahrenheit
  BTU_IT__PER__FT2__SEC__DEG_F: Qudt.unitFromLocalnameRequired(
    "BTU_IT-PER-FT2-SEC-DEG_F"
  ),
  // Kilobaud
  KiloBAUD: Qudt.unitFromLocalnameRequired("KiloBAUD"),
  // Metric Ton per Bar
  TON_Metric__PER__BAR: Qudt.unitFromLocalnameRequired("TON_Metric-PER-BAR"),
  // Kilopascal per Meter
  KiloPA__PER__M: Qudt.unitFromLocalnameRequired("KiloPA-PER-M"),
  // Mega Us Dollar
  MegaCCY_USD: Qudt.unitFromLocalnameRequired("MegaCCY_USD"),
  // Gibibyte
  GibiBYTE: Qudt.unitFromLocalnameRequired("GibiBYTE"),
  // Joule per Kilogram Kelvin
  J__PER__KiloGM__K: Qudt.unitFromLocalnameRequired("J-PER-KiloGM-K"),
  // Revolution per Second
  REV__PER__SEC: Qudt.unitFromLocalnameRequired("REV-PER-SEC"),
  // Pound Mass Second per Square Us Gallon
  LB__SEC__PER__GAL_US2: Qudt.unitFromLocalnameRequired("LB-SEC-PER-GAL_US2"),
  // Square Kilometer per Square Second
  KiloM2__PER__SEC2: Qudt.unitFromLocalnameRequired("KiloM2-PER-SEC2"),
  // Nuevo Sol
  CCY_PEN: Qudt.unitFromLocalnameRequired("CCY_PEN"),
  // Milligram per Cubic Meter Kelvin
  MilliGM__PER__M3__K: Qudt.unitFromLocalnameRequired("MilliGM-PER-M3-K"),
  // Ounce Mass Minute per Cubic Inch Cubic Foot
  OZ__MIN__PER__IN3__FT3: Qudt.unitFromLocalnameRequired("OZ-MIN-PER-IN3-FT3"),
  // Microfarad per Meter
  MicroFARAD__PER__M: Qudt.unitFromLocalnameRequired("MicroFARAD-PER-M"),
  // Yard per Psi
  YD__PER__PSI: Qudt.unitFromLocalnameRequired("YD-PER-PSI"),
  // Kilotonne per Year
  KiloTONNE__PER__YR: Qudt.unitFromLocalnameRequired("KiloTONNE-PER-YR"),
  // International Table Calorie per Gram Kelvin
  CAL_IT__PER__GM__K: Qudt.unitFromLocalnameRequired("CAL_IT-PER-GM-K"),
  // Electron Volt per Tesla
  EV__PER__T: Qudt.unitFromLocalnameRequired("EV-PER-T"),
  // Hectopascal per Metre
  HectoPA__PER__M: Qudt.unitFromLocalnameRequired("HectoPA-PER-M"),
  // Planck Charge
  PlanckCharge: Qudt.unitFromLocalnameRequired("PlanckCharge"),
  // Millibecquerel per Kilogram
  MilliBQ__PER__KiloGM: Qudt.unitFromLocalnameRequired("MilliBQ-PER-KiloGM"),
  // Tropical Year
  YR_TROPICAL: Qudt.unitFromLocalnameRequired("YR_TROPICAL"),
  // Joule per Cubic Meter Kelvin
  J__PER__M3__K: Qudt.unitFromLocalnameRequired("J-PER-M3-K"),
  // Us Liquid Quart per Second
  QT_US__PER__SEC: Qudt.unitFromLocalnameRequired("QT_US-PER-SEC"),
  // Percent Second per Liter
  PERCENT__SEC__PER__L: Qudt.unitFromLocalnameRequired("PERCENT-SEC-PER-L"),
  // Second per Number
  SEC__PER__NUM: Qudt.unitFromLocalnameRequired("SEC-PER-NUM"),
  // Colombian Peso
  CCY_COP_Currency: Qudt.unitFromLocalnameRequired("CCY_COP"),
  // Percent Hour per Cubic Yard
  PERCENT__HR__PER__YD3: Qudt.unitFromLocalnameRequired("PERCENT-HR-PER-YD3"),
  // Cfa Franc Bceao
  CCY_XOF_Currency: Qudt.unitFromLocalnameRequired("CCY_XOF"),
  // Tonne per Hectare Year
  TONNE__PER__HA__YR: Qudt.unitFromLocalnameRequired("TONNE-PER-HA-YR"),
  // Kilo Electron Volt per Micrometre
  KiloEV__PER__MicroM: Qudt.unitFromLocalnameRequired("KiloEV-PER-MicroM"),
  // Milliliter per Cubic Meter
  MilliL__PER__M3: Qudt.unitFromLocalnameRequired("MilliL-PER-M3"),
  // Picomole per Cubic Metre
  PicoMOL__PER__M3: Qudt.unitFromLocalnameRequired("PicoMOL-PER-M3"),
  // Cubic Coulomb Metre per Square Joule
  C3__M__PER__J2: Qudt.unitFromLocalnameRequired("C3-M-PER-J2"),
  // Milligram per Cubic Meter Second
  MilliGM__PER__M3__SEC: Qudt.unitFromLocalnameRequired("MilliGM-PER-M3-SEC"),
  // Kyat
  CCY_MMK_Currency: Qudt.unitFromLocalnameRequired("CCY_MMK"),
  // Cubic Decimetre
  DeciM3: Qudt.unitFromLocalnameRequired("DeciM3"),
  // Psi Cubic Yard per Second
  PSI__YD3__PER__SEC: Qudt.unitFromLocalnameRequired("PSI-YD3-PER-SEC"),
  // East Caribbean Dollar
  CCY_XCD_Currency: Qudt.unitFromLocalnameRequired("CCY_XCD"),
  // American Wire Gage
  AWG: Qudt.unitFromLocalnameRequired("AWG"),
  // Us Dollar
  CCY_USD_Currency: Qudt.unitFromLocalnameRequired("CCY_USD"),
  // Abampere Square Centimeter
  A_Ab__CentiM2: Qudt.unitFromLocalnameRequired("A_Ab-CentiM2"),
  // Somoni
  CCY_TJS: Qudt.unitFromLocalnameRequired("CCY_TJS"),
  // Mebibit
  MebiBIT: Qudt.unitFromLocalnameRequired("MebiBIT"),
  // Unitless
  UNITLESS: Qudt.unitFromLocalnameRequired("UNITLESS"),
  // Standard Cubic Metre per Minute
  SCM__PER__MIN: Qudt.unitFromLocalnameRequired("SCM-PER-MIN"),
  // Gill (US)
  GI_US: Qudt.unitFromLocalnameRequired("GI_US"),
  // Pound Mole Degree Fahrenheit
  MOL_LB__DEG_F: Qudt.unitFromLocalnameRequired("MOL_LB-DEG_F"),
  // Thermochemical Calorie per Square Centimeter
  CAL_TH__PER__CentiM2: Qudt.unitFromLocalnameRequired("CAL_TH-PER-CentiM2"),
  // Chain
  CH: Qudt.unitFromLocalnameRequired("CH"),
  // Square Foot
  FT2: Qudt.unitFromLocalnameRequired("FT2"),
  // Swiss Francs per KiloGram
  CHF__PER__KiloGM: Qudt.unitFromLocalnameRequired("CHF-PER-KiloGM"),
  // Pound Mass per Us Gallon
  LB__PER__GAL_US: Qudt.unitFromLocalnameRequired("LB-PER-GAL_US"),
  // Swiss Franc
  CCY_CHF: Qudt.unitFromLocalnameRequired("CCY_CHF"),
  // Mean Julian Month
  MO_MeanJulian: Qudt.unitFromLocalnameRequired("MO_MeanJulian"),
  // Euro per Kilowatt Hour
  CCY_EUR__PER__KiloW__HR: Qudt.unitFromLocalnameRequired(
    "CCY_EUR-PER-KiloW-HR"
  ),
  // Pound Mass per Acre
  LB__PER__AC: Qudt.unitFromLocalnameRequired("LB-PER-AC"),
  // Joule per Square Tesla
  J__PER__T2: Qudt.unitFromLocalnameRequired("J-PER-T2"),
  // Cubic Metre
  M3: Qudt.unitFromLocalnameRequired("M3"),
  // Square Meter per Kilogram
  M2__PER__KiloGM: Qudt.unitFromLocalnameRequired("M2-PER-KiloGM"),
  // Pound Mass Hour per Gallon (UK) Cubic Inch
  LB__HR__PER__GAL_UK__IN3: Qudt.unitFromLocalnameRequired(
    "LB-HR-PER-GAL_UK-IN3"
  ),
  // Micro Volt Ampere Reactive per Kelvin
  MicroVAR__PER__K: Qudt.unitFromLocalnameRequired("MicroVAR-PER-K"),
  // Gamma
  GAMMA: Qudt.unitFromLocalnameRequired("GAMMA"),
  // Revolution per Hour
  REV__PER__HR: Qudt.unitFromLocalnameRequired("REV-PER-HR"),
  // New Turkish Lira
  CCY_TRY: Qudt.unitFromLocalnameRequired("CCY_TRY"),
  // United States Dollar (same Day) (funds Code)
  CCY_USS_Currency: Qudt.unitFromLocalnameRequired("CCY_USS"),
  // Statfarad
  FARAD_Stat: Qudt.unitFromLocalnameRequired("FARAD_Stat"),
  // Millibar
  MilliBAR: Qudt.unitFromLocalnameRequired("MilliBAR"),
  // Egyptian Pound
  CCY_EGP_Currency: Qudt.unitFromLocalnameRequired("CCY_EGP"),
  // Point
  PT: Qudt.unitFromLocalnameRequired("PT"),
  // Milligram per Minute Kelvin
  MilliGM__PER__MIN__K: Qudt.unitFromLocalnameRequired("MilliGM-PER-MIN-K"),
  // Decibel per Meter
  DeciB__PER__M: Qudt.unitFromLocalnameRequired("DeciB-PER-M"),
  // Rwanda Franc
  CCY_RWF_Currency: Qudt.unitFromLocalnameRequired("CCY_RWF"),
  // Nanogram per Square Metre Pascal Second
  NanoGM__PER__M2__PA__SEC: Qudt.unitFromLocalnameRequired(
    "NanoGM-PER-M2-PA-SEC"
  ),
  // Megabit
  MegaBIT: Qudt.unitFromLocalnameRequired("MegaBIT"),
  // Neper
  NP: Qudt.unitFromLocalnameRequired("NP"),
  // Milliliter per Minute
  MilliL__PER__MIN: Qudt.unitFromLocalnameRequired("MilliL-PER-MIN"),
  // Diopter
  DIOPTER: Qudt.unitFromLocalnameRequired("DIOPTER"),
  // Degree Rankine per Second
  DEG_R__PER__SEC: Qudt.unitFromLocalnameRequired("DEG_R-PER-SEC"),
  // Megajoule per Kilogram
  MegaJ__PER__KiloGM: Qudt.unitFromLocalnameRequired("MegaJ-PER-KiloGM"),
  // Barn
  BARN: Qudt.unitFromLocalnameRequired("BARN"),
  // Volt Ampere Reactive
  VAR: Qudt.unitFromLocalnameRequired("VAR"),
  // Pascal Second per Cubic Metre
  PA__SEC__PER__M3: Qudt.unitFromLocalnameRequired("PA-SEC-PER-M3"),
  // Pound Force Inch
  LB_F__IN: Qudt.unitFromLocalnameRequired("LB_F-IN"),
  // Gigajoule
  GigaJ: Qudt.unitFromLocalnameRequired("GigaJ"),
  // Picovolt Ampere
  PicoV__A: Qudt.unitFromLocalnameRequired("PicoV-A"),
  // Reciprocal Centimeter
  PER__CentiM: Qudt.unitFromLocalnameRequired("PER-CentiM"),
  // Terajoule per Second
  TeraJ__PER__SEC: Qudt.unitFromLocalnameRequired("TeraJ-PER-SEC"),
  // International Table Calorie per Gram Degree Celsius
  CAL_IT__PER__GM__DEG_C: Qudt.unitFromLocalnameRequired("CAL_IT-PER-GM-DEG_C"),
  // Gibibit per Cubic Metre
  GibiBIT__PER__M3: Qudt.unitFromLocalnameRequired("GibiBIT-PER-M3"),
  // Cubic Metre per Minute Kelvin
  M3__PER__MIN__K: Qudt.unitFromLocalnameRequired("M3-PER-MIN-K"),
  // Pound Mass Square Inch
  LB__IN2: Qudt.unitFromLocalnameRequired("LB-IN2"),
  // Mole per Litre
  MOL__PER__L: Qudt.unitFromLocalnameRequired("MOL-PER-L"),
  // Megawatt Hour
  MegaW__HR: Qudt.unitFromLocalnameRequired("MegaW-HR"),
  // Djibouti Franc
  CCY_DJF: Qudt.unitFromLocalnameRequired("CCY_DJF"),
  // Slug per Square Foot
  SLUG__PER__FT2: Qudt.unitFromLocalnameRequired("SLUG-PER-FT2"),
  // British Thermal Unit (international Definition) per Second Square Foot Degree Rankine
  BTU_IT__PER__SEC__FT2__DEG_R: Qudt.unitFromLocalnameRequired(
    "BTU_IT-PER-SEC-FT2-DEG_R"
  ),
  // Abcoulomb per Square Centimetre
  C_Ab__PER__CentiM2: Qudt.unitFromLocalnameRequired("C_Ab-PER-CentiM2"),
  // Kilogram per Cubic Centimeter Kelvin
  KiloGM__PER__CentiM3__K: Qudt.unitFromLocalnameRequired(
    "KiloGM-PER-CentiM3-K"
  ),
  // Atomic Mass Unit
  AMU: Qudt.unitFromLocalnameRequired("AMU"),
  // Kilowatt per Meter Degree Celsius
  KiloW__PER__M__DEG_C: Qudt.unitFromLocalnameRequired("KiloW-PER-M-DEG_C"),
  // Megaohm per Bar
  MegaOHM__PER__BAR: Qudt.unitFromLocalnameRequired("MegaOHM-PER-BAR"),
  // Sidereal Minute
  MIN_Sidereal: Qudt.unitFromLocalnameRequired("MIN_Sidereal"),
  // One per One
  ONE__PER__ONE: Qudt.unitFromLocalnameRequired("ONE-PER-ONE"),
  // Hertz per Tesla
  HZ__PER__T: Qudt.unitFromLocalnameRequired("HZ-PER-T"),
  // Stilb
  STILB: Qudt.unitFromLocalnameRequired("STILB"),
  // Kilomole per Kilogram
  KiloMOL__PER__KiloGM: Qudt.unitFromLocalnameRequired("KiloMOL-PER-KiloGM"),
  // KiloCOUNT
  KiloCOUNT: Qudt.unitFromLocalnameRequired("KiloCOUNT"),
  // Newton Metre per Degree Metre
  N__M__PER__DEG__M: Qudt.unitFromLocalnameRequired("N-M-PER-DEG-M"),
  // Nanogray per Minute
  NanoGRAY__PER__MIN: Qudt.unitFromLocalnameRequired("NanoGRAY-PER-MIN"),
  // Degree Plato
  DEGREE_PLATO: Qudt.unitFromLocalnameRequired("DEGREE_PLATO"),
  // British Thermal Unit (international Definition) per Degree Fahrenheit
  BTU_IT__PER__DEG_F: Qudt.unitFromLocalnameRequired("BTU_IT-PER-DEG_F"),
  // Henry per Ohm
  H__PER__OHM: Qudt.unitFromLocalnameRequired("H-PER-OHM"),
  // Kilopascal per Millimetre
  KiloPA__PER__MilliM: Qudt.unitFromLocalnameRequired("KiloPA-PER-MilliM"),
  // Stere
  STR: Qudt.unitFromLocalnameRequired("STR"),
  // Nanometer per Centimeter Megapascal
  NanoM__PER__CentiM__MegaPA: Qudt.unitFromLocalnameRequired(
    "NanoM-PER-CentiM-MegaPA"
  ),
  // Ampere per Metre
  A__PER__M: Qudt.unitFromLocalnameRequired("A-PER-M"),
  // Kilocalorie per Gram
  KiloCAL__PER__GM: Qudt.unitFromLocalnameRequired("KiloCAL-PER-GM"),
  // Pound Troy
  LB_T: Qudt.unitFromLocalnameRequired("LB_T"),
  // Hundred
  HUNDRED: Qudt.unitFromLocalnameRequired("HUNDRED"),
  // Petacoulomb
  PetaC: Qudt.unitFromLocalnameRequired("PetaC"),
  // Decibar
  DeciBAR: Qudt.unitFromLocalnameRequired("DeciBAR"),
  // Hundred Weight - Short
  CWT_SHORT: Qudt.unitFromLocalnameRequired("CWT_SHORT"),
  // Fiji Dollar
  CCY_FJD: Qudt.unitFromLocalnameRequired("CCY_FJD"),
  // Samoan Tala
  CCY_WST: Qudt.unitFromLocalnameRequired("CCY_WST"),
  // Mega Volt Ampere Hour
  MegaVA__HR: Qudt.unitFromLocalnameRequired("MegaVA-HR"),
  // Reciprocal Liter
  PER__L: Qudt.unitFromLocalnameRequired("PER-L"),
  // Terabit
  TeraBIT: Qudt.unitFromLocalnameRequired("TeraBIT"),
  // British Thermal Unit (international Definition) per Square Inch Second
  BTU_IT__PER__IN2__SEC: Qudt.unitFromLocalnameRequired("BTU_IT-PER-IN2-SEC"),
  // Tenge
  CCY_KZT_Currency: Qudt.unitFromLocalnameRequired("CCY_KZT"),
  // Foot of Mercury
  FT_HG: Qudt.unitFromLocalnameRequired("FT_HG"),
  // Unidades De Formento (funds Code)
  CCY_CLF: Qudt.unitFromLocalnameRequired("CCY_CLF"),
  // Henry
  H: Qudt.unitFromLocalnameRequired("H"),
  // Hectare
  HA: Qudt.unitFromLocalnameRequired("HA"),
  // Bit per Second
  BIT__PER__SEC: Qudt.unitFromLocalnameRequired("BIT-PER-SEC"),
  // Pascal Second per Kelvin
  PA__SEC__PER__K: Qudt.unitFromLocalnameRequired("PA-SEC-PER-K"),
  // Quart (UK) per Hour
  QT_UK__PER__HR: Qudt.unitFromLocalnameRequired("QT_UK-PER-HR"),
  // Foot per Hour
  FT__PER__HR: Qudt.unitFromLocalnameRequired("FT-PER-HR"),
  // Pound Mass Square Inch per Cubic Inch Pound Force Second
  LB__IN2__PER__IN3__LB_F__SEC: Qudt.unitFromLocalnameRequired(
    "LB-IN2-PER-IN3-LB_F-SEC"
  ),
  // Us Liquid Quart per Hour
  QT_US__PER__HR: Qudt.unitFromLocalnameRequired("QT_US-PER-HR"),
  // Millilitre per Square Centimetre Minute
  MilliL__PER__CentiM2__MIN: Qudt.unitFromLocalnameRequired(
    "MilliL-PER-CentiM2-MIN"
  ),
  // Megapascal
  MegaPA: Qudt.unitFromLocalnameRequired("MegaPA"),
  // Solomon Islands Dollar
  CCY_SBD: Qudt.unitFromLocalnameRequired("CCY_SBD"),
  // Milligalileo
  MilliGALILEO: Qudt.unitFromLocalnameRequired("MilliGALILEO"),
  // Percent
  PERCENT: Qudt.unitFromLocalnameRequired("PERCENT"),
  // Coulomb per Meter
  C__PER__M: Qudt.unitFromLocalnameRequired("C-PER-M"),
  // Euro
  CCY_EUR: Qudt.unitFromLocalnameRequired("CCY_EUR"),
  // Electron Volt per Angstrom
  EV__PER__ANGSTROM: Qudt.unitFromLocalnameRequired("EV-PER-ANGSTROM"),
  // DEATHS
  DEATHS: Qudt.unitFromLocalnameRequired("DEATHS"),
  // Kelvin per Meter
  K__PER__M: Qudt.unitFromLocalnameRequired("K-PER-M"),
  // British Thermal Unit (international Definition) per Degree Rankine
  BTU_IT__PER__DEG_R: Qudt.unitFromLocalnameRequired("BTU_IT-PER-DEG_R"),
  // Thermochemical Calorie per Minute
  CAL_TH__PER__MIN: Qudt.unitFromLocalnameRequired("CAL_TH-PER-MIN"),
  // Millimole per Cubic Meter
  MilliMOL__PER__M3: Qudt.unitFromLocalnameRequired("MilliMOL-PER-M3"),
  // Euro per Watt
  CCY_EUR__PER__W: Qudt.unitFromLocalnameRequired("CCY_EUR-PER-W"),
  // Milligram per Cubic Metre Poise
  MilliGM__PER__M3__POISE: Qudt.unitFromLocalnameRequired(
    "MilliGM-PER-M3-POISE"
  ),
  // Candela per Square Meter
  CD__PER__M2: Qudt.unitFromLocalnameRequired("CD-PER-M2"),
  // Percent per Thousand
  PERCENT__PER__KiloCOUNT: Qudt.unitFromLocalnameRequired(
    "PERCENT-PER-KiloCOUNT"
  ),
  // Pound Mass Inch per Second
  LB__IN__PER__SEC: Qudt.unitFromLocalnameRequired("LB-IN-PER-SEC"),
  // Metre per Second Kelvin
  M__PER__SEC__K: Qudt.unitFromLocalnameRequired("M-PER-SEC-K"),
  // Mole per Square Meter Second Meter Steradian
  MOL__PER__M2__SEC__M__SR: Qudt.unitFromLocalnameRequired(
    "MOL-PER-M2-SEC-M-SR"
  ),
  // Candela per Lumen
  CD__PER__LM: Qudt.unitFromLocalnameRequired("CD-PER-LM"),
  // Barn per Steradian
  BARN__PER__SR: Qudt.unitFromLocalnameRequired("BARN-PER-SR"),
  // Pascal Second
  PA__SEC: Qudt.unitFromLocalnameRequired("PA-SEC"),
  // Lumen per Square Meter
  LM__PER__M2: Qudt.unitFromLocalnameRequired("LM-PER-M2"),
  // Watt
  W: Qudt.unitFromLocalnameRequired("W"),
  // Tonne per Minute Bar
  TONNE__PER__MIN__BAR: Qudt.unitFromLocalnameRequired("TONNE-PER-MIN-BAR"),
  // Quartic Foot
  FT4: Qudt.unitFromLocalnameRequired("FT4"),
  // Kilogram per Second Kelvin
  KiloGM__PER__SEC__K: Qudt.unitFromLocalnameRequired("KiloGM-PER-SEC-K"),
  // Hour per Number
  HR__PER__NUM: Qudt.unitFromLocalnameRequired("HR-PER-NUM"),
  // Microohm
  MicroOHM: Qudt.unitFromLocalnameRequired("MicroOHM"),
  // Gram per Minute Bar
  GM__PER__MIN__BAR: Qudt.unitFromLocalnameRequired("GM-PER-MIN-BAR"),
  // Nanomole per Square Metre Day
  NanoMOL__PER__M2__DAY: Qudt.unitFromLocalnameRequired("NanoMOL-PER-M2-DAY"),
  // Pound Mass Square Inch per Cubic Foot Pound Force Second
  LB__IN2__PER__FT3__LB_F__SEC: Qudt.unitFromLocalnameRequired(
    "LB-IN2-PER-FT3-LB_F-SEC"
  ),
  // Croatian Kuna
  CCY_HRK_Currency: Qudt.unitFromLocalnameRequired("CCY_HRK"),
  // Elementary Charge
  E: Qudt.unitFromLocalnameRequired("E"),
  // Milligram per Kilogram Day
  MilliGM__PER__KiloGM__DAY: Qudt.unitFromLocalnameRequired(
    "MilliGM-PER-KiloGM-DAY"
  ),
  // Somoni
  CCY_TJS_Currency: Qudt.unitFromLocalnameRequired("CCY_TJS"),
  // Degree Rankine
  DEG_R: Qudt.unitFromLocalnameRequired("DEG_R"),
  // Percent per Hectobar
  PERCENT__PER__HectoBAR: Qudt.unitFromLocalnameRequired(
    "PERCENT-PER-HectoBAR"
  ),
  // Hectopascal Cubic Meter per Second
  HectoPA__M3__PER__SEC: Qudt.unitFromLocalnameRequired("HectoPA-M3-PER-SEC"),
  // Pascal per Hour
  PA__PER__HR: Qudt.unitFromLocalnameRequired("PA-PER-HR"),
  // Centinewton Metre per Square Metre
  CentiN__M__PER__M2: Qudt.unitFromLocalnameRequired("CentiN-M-PER-M2"),
  // Microcoulomb per Cubic Meter
  MicroC__PER__M3: Qudt.unitFromLocalnameRequired("MicroC-PER-M3"),
  // Percent per Percent
  PERCENT__PER__PERCENT: Qudt.unitFromLocalnameRequired("PERCENT-PER-PERCENT"),
  // International Mile per Second
  MI__PER__SEC: Qudt.unitFromLocalnameRequired("MI-PER-SEC"),
  // New Turkish Lira
  CCY_TRY_Currency: Qudt.unitFromLocalnameRequired("CCY_TRY"),
  // Milliliter per Second Kelvin
  MilliL__PER__SEC__K: Qudt.unitFromLocalnameRequired("MilliL-PER-SEC-K"),
  // Unified Atomic Mass Unit
  U: Qudt.unitFromLocalnameRequired("U"),
  // Inch per Second Psi
  IN__PER__SEC__PSI: Qudt.unitFromLocalnameRequired("IN-PER-SEC-PSI"),
  // Kelvin per Second
  K__PER__SEC: Qudt.unitFromLocalnameRequired("K-PER-SEC"),
  // Danish Krone per Kilowatt Hour
  CCY_DKK__PER__KiloW__HR: Qudt.unitFromLocalnameRequired(
    "CCY_DKK-PER-KiloW-HR"
  ),
  // Kilogram per Minute Kelvin
  KiloGM__PER__MIN__K: Qudt.unitFromLocalnameRequired("KiloGM-PER-MIN-K"),
  // Picokatal per Liter
  PicoKAT__PER__L: Qudt.unitFromLocalnameRequired("PicoKAT-PER-L"),
  // Cubic Centimeter per Day
  CentiM3__PER__DAY: Qudt.unitFromLocalnameRequired("CentiM3-PER-DAY"),
  // Barrel (US) per Day
  BBL_US__PER__DAY: Qudt.unitFromLocalnameRequired("BBL_US-PER-DAY"),
  // Us Dollar
  CCY_USD: Qudt.unitFromLocalnameRequired("CCY_USD"),
  // Volt Ampere Reactive
  V__A_Reactive: Qudt.unitFromLocalnameRequired("V-A_Reactive"),
  // Milligram per Liter
  MilliGM__PER__L: Qudt.unitFromLocalnameRequired("MilliGM-PER-L"),
  // Bar
  BAR: Qudt.unitFromLocalnameRequired("BAR"),
  // Percent Second per Cubic Meter
  PERCENT__SEC__PER__M3: Qudt.unitFromLocalnameRequired("PERCENT-SEC-PER-M3"),
  // Kilo Gram Force Metre
  KiloGM_F__M: Qudt.unitFromLocalnameRequired("KiloGM_F-M"),
  // Kelvin Square Meter per Kilogram Second
  K__M2__PER__KiloGM__SEC: Qudt.unitFromLocalnameRequired(
    "K-M2-PER-KiloGM-SEC"
  ),
  // Watt per Square Metre Steradian
  W__PER__M2__SR: Qudt.unitFromLocalnameRequired("W-PER-M2-SR"),
  // Quarter (UK)
  Quarter_UK: Qudt.unitFromLocalnameRequired("Quarter_UK"),
  // Picosiemens per Meter
  PicoS__PER__M: Qudt.unitFromLocalnameRequired("PicoS-PER-M"),
  // Microbecquerel
  MicroBQ: Qudt.unitFromLocalnameRequired("MicroBQ"),
  // Degree per Square Second
  DEG__PER__SEC2: Qudt.unitFromLocalnameRequired("DEG-PER-SEC2"),
  // Peck (UK)
  PK_UK: Qudt.unitFromLocalnameRequired("PK_UK"),
  // Us Gallon
  GAL_US: Qudt.unitFromLocalnameRequired("GAL_US"),
  // Pound Mass Second per Us Gallon Cubic Inch
  LB__SEC__PER__GAL_US__IN3: Qudt.unitFromLocalnameRequired(
    "LB-SEC-PER-GAL_US-IN3"
  ),
  // Milligram per Millilitre
  MilliGM__PER__MilliL: Qudt.unitFromLocalnameRequired("MilliGM-PER-MilliL"),
  // Tesla Second
  T__SEC: Qudt.unitFromLocalnameRequired("T-SEC"),
  // Attosecond
  AttoSEC: Qudt.unitFromLocalnameRequired("AttoSEC"),
  // Microgram per Cubic Metre Kelvin
  MicroGM__PER__M3__K: Qudt.unitFromLocalnameRequired("MicroGM-PER-M3-K"),
  // Pebibit
  PebiBIT: Qudt.unitFromLocalnameRequired("PebiBIT"),
  // Peso Uruguayo
  CCY_UYU: Qudt.unitFromLocalnameRequired("CCY_UYU"),
  // Kilopascal Square Metre per Gram
  KiloPA__M2__PER__GM: Qudt.unitFromLocalnameRequired("KiloPA-M2-PER-GM"),
  // Number per Cubic Metre
  NUM__PER__M3: Qudt.unitFromLocalnameRequired("NUM-PER-M3"),
  // Ton (US) per Cubic Yard
  TON_US__PER__YD3: Qudt.unitFromLocalnameRequired("TON_US-PER-YD3"),
  // Gigaampere
  GigaA: Qudt.unitFromLocalnameRequired("GigaA"),
  // Pound Mass Hour per Sextic Foot
  LB__HR__PER__FT6: Qudt.unitFromLocalnameRequired("LB-HR-PER-FT6"),
  // Liter per Day Kelvin
  L__PER__DAY__K: Qudt.unitFromLocalnameRequired("L-PER-DAY-K"),
  // Bushel (US Dry)
  BU_US_DRY: Qudt.unitFromLocalnameRequired("BU_US_DRY"),
  // Pound Mass
  LB_M: Qudt.unitFromLocalnameRequired("LB_M"),
  // Milligram per Square Meter Day
  MilliGM__PER__M2__DAY: Qudt.unitFromLocalnameRequired("MilliGM-PER-M2-DAY"),
  // Pa'anga
  CCY_TOP: Qudt.unitFromLocalnameRequired("CCY_TOP"),
  // Megaohm per Meter
  MegaOHM__PER__M: Qudt.unitFromLocalnameRequired("MegaOHM-PER-M"),
  // Kilogram per Hour Bar
  KiloGM__PER__HR__BAR: Qudt.unitFromLocalnameRequired("KiloGM-PER-HR-BAR"),
  // Newton Meter per Square Meter
  N__M__PER__M2: Qudt.unitFromLocalnameRequired("N-M-PER-M2"),
  // Barn per Steradian Electron Volt
  BARN__PER__SR__EV: Qudt.unitFromLocalnameRequired("BARN-PER-SR-EV"),
  // Litre per Bar
  L__PER__BAR: Qudt.unitFromLocalnameRequired("L-PER-BAR"),
  // Balboa
  CCY_PAB: Qudt.unitFromLocalnameRequired("CCY_PAB"),
  // Petabit
  PetaBIT: Qudt.unitFromLocalnameRequired("PetaBIT"),
  // Cubic Metre per Kelvin
  M3__PER__K: Qudt.unitFromLocalnameRequired("M3-PER-K"),
  // International Unit per Litre
  IU__PER__L: Qudt.unitFromLocalnameRequired("IU-PER-L"),
  // Lilangeni
  CCY_SZL: Qudt.unitFromLocalnameRequired("CCY_SZL"),
  // Pint (UK) per Second
  PINT_UK__PER__SEC: Qudt.unitFromLocalnameRequired("PINT_UK-PER-SEC"),
  // Milligram per Day Kelvin
  MilliGM__PER__DAY__K: Qudt.unitFromLocalnameRequired("MilliGM-PER-DAY-K"),
  // Foot Candle
  FC: Qudt.unitFromLocalnameRequired("FC"),
  // Cubic Millimeter
  MilliM3: Qudt.unitFromLocalnameRequired("MilliM3"),
  // Joule
  J: Qudt.unitFromLocalnameRequired("J"),
  // Inch per Second
  IN__PER__SEC: Qudt.unitFromLocalnameRequired("IN-PER-SEC"),
  // Kilobit
  KiloBIT: Qudt.unitFromLocalnameRequired("KiloBIT"),
  // Pound Mass Square Foot per Cubic Inch Pound Force Second
  LB__FT2__PER__IN3__LB_F__SEC: Qudt.unitFromLocalnameRequired(
    "LB-FT2-PER-IN3-LB_F-SEC"
  ),
  // Micromole
  MicroMOL: Qudt.unitFromLocalnameRequired("MicroMOL"),
  // Cubic Meter per Mole Second
  M3__PER__MOL__SEC: Qudt.unitFromLocalnameRequired("M3-PER-MOL-SEC"),
  // KiloVolt Ampere Reactive per Kelvin
  KiloV__A_Reactive__PER__K: Qudt.unitFromLocalnameRequired(
    "KiloV-A_Reactive-PER-K"
  ),
  // Picogram per Gram
  PicoGM__PER__GM: Qudt.unitFromLocalnameRequired("PicoGM-PER-GM"),
  // Us Gallon per Minute
  GAL_US__PER__MIN: Qudt.unitFromLocalnameRequired("GAL_US-PER-MIN"),
  // Square Meter per Watt
  M2__PER__W: Qudt.unitFromLocalnameRequired("M2-PER-W"),
  // Gram per Mole
  GM__PER__MOL: Qudt.unitFromLocalnameRequired("GM-PER-MOL"),
  // Picomole
  PicoMOL: Qudt.unitFromLocalnameRequired("PicoMOL"),
  // Litre per Kilogram
  L__PER__KiloGM: Qudt.unitFromLocalnameRequired("L-PER-KiloGM"),
  // Russian Ruble
  CCY_RUB_Currency: Qudt.unitFromLocalnameRequired("CCY_RUB"),
  // Volt Second per Metre
  V__SEC__PER__M: Qudt.unitFromLocalnameRequired("V-SEC-PER-M"),
  // Atomic-number
  Z: Qudt.unitFromLocalnameRequired("Z"),
  // Kilo Gram Force per Square Millimeter
  KiloGM_F__PER__MilliM2: Qudt.unitFromLocalnameRequired(
    "KiloGM_F-PER-MilliM2"
  ),
  // Reciprocal Weber
  PER__WB: Qudt.unitFromLocalnameRequired("PER-WB"),
  // Kilo Thermochemical Calorie per Minute
  KiloCAL_TH__PER__MIN: Qudt.unitFromLocalnameRequired("KiloCAL_TH-PER-MIN"),
  // Centimole per Litre
  CentiMOL__PER__L: Qudt.unitFromLocalnameRequired("CentiMOL-PER-L"),
  // Pound Force per Square Inch
  LB_F__PER__IN2: Qudt.unitFromLocalnameRequired("LB_F-PER-IN2"),
  // Cubic Meter per Kilogram Square Second
  M3__PER__KiloGM__SEC2: Qudt.unitFromLocalnameRequired("M3-PER-KiloGM-SEC2"),
  // Microvolt
  MicroV: Qudt.unitFromLocalnameRequired("MicroV"),
  // Radian per Second
  RAD__PER__SEC: Qudt.unitFromLocalnameRequired("RAD-PER-SEC"),
  // Square Centimeter
  CentiM2: Qudt.unitFromLocalnameRequired("CentiM2"),
  // Cubic Decimeter per Second
  DeciM3__PER__SEC: Qudt.unitFromLocalnameRequired("DeciM3-PER-SEC"),
  // Unit Pole
  UnitPole: Qudt.unitFromLocalnameRequired("UnitPole"),
  // Gram per Litre Centipoise
  GM__PER__L__CentiPOISE: Qudt.unitFromLocalnameRequired("GM-PER-L-CentiPOISE"),
  // Volt per Kelvin
  V__PER__K: Qudt.unitFromLocalnameRequired("V-PER-K"),
  // Us Gallon per Hour
  GAL_US__PER__HR: Qudt.unitFromLocalnameRequired("GAL_US-PER-HR"),
  // Nanomole per Microgram Hour
  NanoMOL__PER__MicroGM__HR: Qudt.unitFromLocalnameRequired(
    "NanoMOL-PER-MicroGM-HR"
  ),
  // Gram per Day Kelvin
  GM__PER__DAY__K: Qudt.unitFromLocalnameRequired("GM-PER-DAY-K"),
  // Joule per Mole
  J__PER__MOL: Qudt.unitFromLocalnameRequired("J-PER-MOL"),
  // Us Liquid Quart per Minute
  QT_US__PER__MIN: Qudt.unitFromLocalnameRequired("QT_US-PER-MIN"),
  // Megacoulomb per Cubic Metre
  MegaC__PER__M3: Qudt.unitFromLocalnameRequired("MegaC-PER-M3"),
  // Dyne Centimeter
  DYN__CentiM: Qudt.unitFromLocalnameRequired("DYN-CentiM"),
  // Centimetre Second Degree Celsius
  CentiM__SEC__DEG_C: Qudt.unitFromLocalnameRequired("CentiM-SEC-DEG_C"),
  // Kilo Circular Mil
  KiloMIL_Circ: Qudt.unitFromLocalnameRequired("KiloMIL_Circ"),
  // Millivolt
  MilliV: Qudt.unitFromLocalnameRequired("MilliV"),
  // Millipascal Second per Bar
  MilliPA__SEC__PER__BAR: Qudt.unitFromLocalnameRequired("MilliPA-SEC-PER-BAR"),
  // Us Liquid Ounce
  OZ_VOL_US: Qudt.unitFromLocalnameRequired("OZ_VOL_US"),
  // Kilogram per Second
  KiloGM__PER__SEC: Qudt.unitFromLocalnameRequired("KiloGM-PER-SEC"),
  // Osmole
  OSM: Qudt.unitFromLocalnameRequired("OSM"),
  // Hectopascal Litre per Second
  HectoPA__L__PER__SEC: Qudt.unitFromLocalnameRequired("HectoPA-L-PER-SEC"),
  // Coulomb Metre
  C__M: Qudt.unitFromLocalnameRequired("C-M"),
  // Decibel Referred to 1mw
  DeciB_M: Qudt.unitFromLocalnameRequired("DeciB_M"),
  // Algerian Dinar
  CCY_DZD_Currency: Qudt.unitFromLocalnameRequired("CCY_DZD"),
  // Long Ton per Cubic Yard
  TON_LONG__PER__YD3: Qudt.unitFromLocalnameRequired("TON_LONG-PER-YD3"),
  // Megaton
  MegaTON: Qudt.unitFromLocalnameRequired("MegaTON"),
  // Belarussian Ruble
  CCY_BYN_Currency: Qudt.unitFromLocalnameRequired("CCY_BYN"),
  // Micrometre per Second
  MicroM__PER__SEC: Qudt.unitFromLocalnameRequired("MicroM-PER-SEC"),
  // Nanogram per Day
  NanoGM__PER__DAY: Qudt.unitFromLocalnameRequired("NanoGM-PER-DAY"),
  // Hectolitre
  HectoL: Qudt.unitFromLocalnameRequired("HectoL"),
  // Attojoule Second
  AttoJ__SEC: Qudt.unitFromLocalnameRequired("AttoJ-SEC"),
  // Kilo International Table Calorie per Hour Metre Degree Celsius
  KiloCAL_IT__PER__HR__M__DEG_C: Qudt.unitFromLocalnameRequired(
    "KiloCAL_IT-PER-HR-M-DEG_C"
  ),
  // Millisecond
  MilliSEC: Qudt.unitFromLocalnameRequired("MilliSEC"),
  // Kilogram per Square Metre Day
  KiloGM__PER__M2__DAY: Qudt.unitFromLocalnameRequired("KiloGM-PER-M2-DAY"),
  // Rupiah
  CCY_IDR: Qudt.unitFromLocalnameRequired("CCY_IDR"),
  // Kilogram Square Centimetre
  KiloGM__CentiM2: Qudt.unitFromLocalnameRequired("KiloGM-CentiM2"),
  // Megajoule per Second
  MegaJ__PER__SEC: Qudt.unitFromLocalnameRequired("MegaJ-PER-SEC"),
  // Quartic Meter
  M4: Qudt.unitFromLocalnameRequired("M4"),
  // Percent Hour per Us Gallon
  PERCENT__HR__PER__GAL_US: Qudt.unitFromLocalnameRequired(
    "PERCENT-HR-PER-GAL_US"
  ),
  // Rhe
  RHE: Qudt.unitFromLocalnameRequired("RHE"),
  // Gigacoulomb per Cubic Meter
  GigaC__PER__M3: Qudt.unitFromLocalnameRequired("GigaC-PER-M3"),
  // Cubic Centimeter per Hour Kelvin
  CentiM3__PER__HR__K: Qudt.unitFromLocalnameRequired("CentiM3-PER-HR-K"),
  // Femtocoulomb
  FemtoC: Qudt.unitFromLocalnameRequired("FemtoC"),
  // Earth Mass
  EarthMass: Qudt.unitFromLocalnameRequired("EarthMass"),
  // British Thermal Unit (39 °F)
  BTU_39DEG_F: Qudt.unitFromLocalnameRequired("BTU_39DEG_F"),
  // Micromole per Square Meter Hour
  MicroMOL__PER__M2__HR: Qudt.unitFromLocalnameRequired("MicroMOL-PER-M2-HR"),
  // Kilo International Table Calorie per Gram Kelvin
  KiloCAL_IT__PER__GM__K: Qudt.unitFromLocalnameRequired("KiloCAL_IT-PER-GM-K"),
  // Ampere Hour per Cubic Metre
  A__HR__PER__M3: Qudt.unitFromLocalnameRequired("A-HR-PER-M3"),
  // Hundredweight (US)
  Hundredweight_US: Qudt.unitFromLocalnameRequired("Hundredweight_US"),
  // Percent Hour per Cubic Metre
  PERCENT__HR__PER__M3: Qudt.unitFromLocalnameRequired("PERCENT-HR-PER-M3"),
  // Part per Quadrillion
  PPQ: Qudt.unitFromLocalnameRequired("PPQ"),
  // Plancktemperature
  PlanckTemperature: Qudt.unitFromLocalnameRequired("PlanckTemperature"),
  // Degree Api
  DEGREE_API: Qudt.unitFromLocalnameRequired("DEGREE_API"),
  // Milli Volt Ampere Reactive
  MilliVAR: Qudt.unitFromLocalnameRequired("MilliVAR"),
  // Grams Carbon per Square Meter Day
  GM_Carbon__PER__M2__DAY: Qudt.unitFromLocalnameRequired(
    "GM_Carbon-PER-M2-DAY"
  ),
  // Cubic Millimeter per Cubic Meter
  MilliM3__PER__M3: Qudt.unitFromLocalnameRequired("MilliM3-PER-M3"),
  // Megacoulomb
  MegaC: Qudt.unitFromLocalnameRequired("MegaC"),
  // Picoampere per Micromole Liter
  PicoA__PER__MicroMOL__L: Qudt.unitFromLocalnameRequired(
    "PicoA-PER-MicroMOL-L"
  ),
  // Cubic Foot per Psi
  FT3__PER__PSI: Qudt.unitFromLocalnameRequired("FT3-PER-PSI"),
  // Us Survey Foot
  FT_US: Qudt.unitFromLocalnameRequired("FT_US"),
  // Number per Cubic Millimeter
  NUM__PER__MilliM3: Qudt.unitFromLocalnameRequired("NUM-PER-MilliM3"),
  // Volt Square Inch per Pound Force
  V__IN2__PER__LB_F: Qudt.unitFromLocalnameRequired("V-IN2-PER-LB_F"),
  // Bushel (US Dry) per Second
  BU_US_DRY__PER__SEC: Qudt.unitFromLocalnameRequired("BU_US_DRY-PER-SEC"),
  // Pound Force Foot
  LB_F__FT: Qudt.unitFromLocalnameRequired("LB_F-FT"),
  // Planck Area
  PlanckArea: Qudt.unitFromLocalnameRequired("PlanckArea"),
  // Short Ton per Cubic Yard
  TON_SHORT__PER__YD3: Qudt.unitFromLocalnameRequired("TON_SHORT-PER-YD3"),
  // Picogram per Milliliter
  PicoGM__PER__MilliL: Qudt.unitFromLocalnameRequired("PicoGM-PER-MilliL"),
  // Millilitre per Square Centimetre Second
  MilliL__PER__CentiM2__SEC: Qudt.unitFromLocalnameRequired(
    "MilliL-PER-CentiM2-SEC"
  ),
  // Newton per Meter
  N__PER__M: Qudt.unitFromLocalnameRequired("N-PER-M"),
  // Ounce Mass Second per Cubic Inch Gallon (UK)
  OZ__SEC__PER__IN3__GAL_UK: Qudt.unitFromLocalnameRequired(
    "OZ-SEC-PER-IN3-GAL_UK"
  ),
  // Fluid Ounce (UK) per Minute
  OZ_VOL_UK__PER__MIN: Qudt.unitFromLocalnameRequired("OZ_VOL_UK-PER-MIN"),
  // Gill (US) per Second
  GI_US__PER__SEC: Qudt.unitFromLocalnameRequired("GI_US-PER-SEC"),
  // Inch per Square Second
  IN__PER__SEC2: Qudt.unitFromLocalnameRequired("IN-PER-SEC2"),
  // Hefner-kerze
  HK: Qudt.unitFromLocalnameRequired("HK"),
  // Mole per Square Meter
  MOL__PER__M2: Qudt.unitFromLocalnameRequired("MOL-PER-M2"),
  // Nanogram
  NanoGM: Qudt.unitFromLocalnameRequired("NanoGM"),
  // Degree Baume (us Light)
  DEGREE_BAUME_US_LIGHT: Qudt.unitFromLocalnameRequired(
    "DEGREE_BAUME_US_LIGHT"
  ),
  // Ounce Mass per Cubic Inch
  OZ__PER__IN3: Qudt.unitFromLocalnameRequired("OZ-PER-IN3"),
  // Centimole per Kilogram
  CentiMOL__PER__KiloGM: Qudt.unitFromLocalnameRequired("CentiMOL-PER-KiloGM"),
  // Gibibit
  GibiBIT: Qudt.unitFromLocalnameRequired("GibiBIT"),
  // Milliradian
  MilliRAD: Qudt.unitFromLocalnameRequired("MilliRAD"),
  // Megawatt
  MegaW: Qudt.unitFromLocalnameRequired("MegaW"),
  // Tonne
  TONNE: Qudt.unitFromLocalnameRequired("TONNE"),
  // Foot Pound Force per Square Meter
  FT__LB_F__PER__M2: Qudt.unitFromLocalnameRequired("FT-LB_F-PER-M2"),
  // CM_H2O
  CM_H2O: Qudt.unitFromLocalnameRequired("CM_H2O"),
  // Pound Mass Hour per Cubic Foot Gallon (UK)
  LB__HR__PER__FT3__GAL_UK: Qudt.unitFromLocalnameRequired(
    "LB-HR-PER-FT3-GAL_UK"
  ),
  // Sidereal Hour
  HR_Sidereal: Qudt.unitFromLocalnameRequired("HR_Sidereal"),
  // Pebibit per Cubic Meter
  PebiBIT__PER__M3: Qudt.unitFromLocalnameRequired("PebiBIT-PER-M3"),
  // Microgram per Gram Hour
  MicroGM__PER__GM__HR: Qudt.unitFromLocalnameRequired("MicroGM-PER-GM-HR"),
  // British Thermal Unit (thermochemical Definition) per Hour
  BTU_TH__PER__HR: Qudt.unitFromLocalnameRequired("BTU_TH-PER-HR"),
  // Square Kilogram per Square Second
  KiloGM2__PER__SEC2: Qudt.unitFromLocalnameRequired("KiloGM2-PER-SEC2"),
  // Nanomole per Gram
  NanoMOL__PER__GM: Qudt.unitFromLocalnameRequired("NanoMOL-PER-GM"),
  // Gram per Cubic Metre Pascal Second
  GM__PER__M3__PA__SEC: Qudt.unitFromLocalnameRequired("GM-PER-M3-PA-SEC"),
  // Gigahertz Metre
  GigaHZ__M: Qudt.unitFromLocalnameRequired("GigaHZ-M"),
  // Microbar
  MicroBAR: Qudt.unitFromLocalnameRequired("MicroBAR"),
  // Farad
  FARAD: Qudt.unitFromLocalnameRequired("FARAD"),
  // Latvian Lats
  CCY_LVL_Currency: Qudt.unitFromLocalnameRequired("CCY_LVL"),
  // Ampere Square Metre
  A__M2: Qudt.unitFromLocalnameRequired("A-M2"),
  // Pound Mass per Pound Mass
  LB__PER__LB: Qudt.unitFromLocalnameRequired("LB-PER-LB"),
  // Micropascal
  MicroPA: Qudt.unitFromLocalnameRequired("MicroPA"),
  // British Thermal Unit (international Definition) per Square Foot Hour
  BTU_IT__PER__FT2__HR: Qudt.unitFromLocalnameRequired("BTU_IT-PER-FT2-HR"),
  // Microhenry
  MicroH: Qudt.unitFromLocalnameRequired("MicroH"),
  // Stathenry
  H_Stat: Qudt.unitFromLocalnameRequired("H_Stat"),
  // Guinea Franc
  CCY_GNF_Currency: Qudt.unitFromLocalnameRequired("CCY_GNF"),
  // MicroGAL
  MicroGAL: Qudt.unitFromLocalnameRequired("MicroGAL"),
  // Perm (0 °C)
  PERM_Metric_0DEG_C: Qudt.unitFromLocalnameRequired("PERM_Metric_0DEG_C"),
  // Tunisian Dinar
  CCY_TND: Qudt.unitFromLocalnameRequired("CCY_TND"),
  // Degree Celsius per Bar
  DEG_C__PER__BAR: Qudt.unitFromLocalnameRequired("DEG_C-PER-BAR"),
  // Lebanese Pound
  CCY_LBP: Qudt.unitFromLocalnameRequired("CCY_LBP"),
  // Megaampere
  MegaA: Qudt.unitFromLocalnameRequired("MegaA"),
  // Electron Volt per Kelvin
  EV__PER__K: Qudt.unitFromLocalnameRequired("EV-PER-K"),
  // Riel
  CCY_KHR: Qudt.unitFromLocalnameRequired("CCY_KHR"),
  // Gram Hour per Sextic Metre
  GM__HR__PER__M6: Qudt.unitFromLocalnameRequired("GM-HR-PER-M6"),
  // Pound Mass per Foot Second
  LB__PER__FT__SEC: Qudt.unitFromLocalnameRequired("LB-PER-FT-SEC"),
  // Percent per Pascal Second
  PERCENT__PER__PA__SEC: Qudt.unitFromLocalnameRequired("PERCENT-PER-PA-SEC"),
  // Pound Mass per Cubic Meter
  LB__PER__M3: Qudt.unitFromLocalnameRequired("LB-PER-M3"),
  // Ampere per Degree Celsius
  A__PER__DEG_C: Qudt.unitFromLocalnameRequired("A-PER-DEG_C"),
  // Microgram per Millilitre
  MicroGM__PER__MilliL: Qudt.unitFromLocalnameRequired("MicroGM-PER-MilliL"),
  // Ohm Meter
  OHM__M: Qudt.unitFromLocalnameRequired("OHM-M"),
  // Erg per Square Centimeter
  ERG__PER__CentiM2: Qudt.unitFromLocalnameRequired("ERG-PER-CentiM2"),
  // Dominican Peso
  CCY_DOP_Currency: Qudt.unitFromLocalnameRequired("CCY_DOP"),
  // Percent per One Hundred Thousand
  PERCENT__PER__HectoKiloCOUNT: Qudt.unitFromLocalnameRequired(
    "PERCENT-PER-HectoKiloCOUNT"
  ),
  // Degree Rankine per Minute
  DEG_R__PER__MIN: Qudt.unitFromLocalnameRequired("DEG_R-PER-MIN"),
  // Femtofarad
  FemtoFARAD: Qudt.unitFromLocalnameRequired("FemtoFARAD"),
  // Haiti Gourde
  CCY_HTG: Qudt.unitFromLocalnameRequired("CCY_HTG"),
  // Decibel Milliwatt
  DeciB__MilliW: Qudt.unitFromLocalnameRequired("DeciB-MilliW"),
  // Mole per Cubic Metre Pascal
  MOL__PER__M3__PA: Qudt.unitFromLocalnameRequired("MOL-PER-M3-PA"),
  // Imperial Ounce Force per Cubic Inch
  OZ_F__PER__IN3: Qudt.unitFromLocalnameRequired("OZ_F-PER-IN3"),
  // Cup (US)
  CUP_US: Qudt.unitFromLocalnameRequired("CUP_US"),
  // Gram per Milliliter Bar
  GM__PER__MilliL__BAR: Qudt.unitFromLocalnameRequired("GM-PER-MilliL-BAR"),
  // Normal Cubic Metre
  NCM_1ATM_0DEG_C_NL: Qudt.unitFromLocalnameRequired("NCM_1ATM_0DEG_C_NL"),
  // Pascal Square Meter per Kilogram
  PA__M2__PER__KiloGM: Qudt.unitFromLocalnameRequired("PA-M2-PER-KiloGM"),
  // Kilocoulomb per Square Meter
  KiloC__PER__M2: Qudt.unitFromLocalnameRequired("KiloC-PER-M2"),
  // Rem
  REM: Qudt.unitFromLocalnameRequired("REM"),
  // Degree Fahrenheit
  DEG_F: Qudt.unitFromLocalnameRequired("DEG_F"),
  // Square Micromole per Quartic Metre Square Second
  MicroMOL2__PER__M4__SEC2: Qudt.unitFromLocalnameRequired(
    "MicroMOL2-PER-M4-SEC2"
  ),
  // British Thermal Unit (international Definition) per Second
  BTU_IT__PER__SEC: Qudt.unitFromLocalnameRequired("BTU_IT-PER-SEC"),
  // Centinewton
  CentiN: Qudt.unitFromLocalnameRequired("CentiN"),
  // Kibibit
  KibiBIT: Qudt.unitFromLocalnameRequired("KibiBIT"),
  // Cubic Centimetre per Minute Bar
  CentiM3__PER__MIN__BAR: Qudt.unitFromLocalnameRequired("CentiM3-PER-MIN-BAR"),
  // Percent Hour per Cubic Centimeter
  PERCENT__HR__PER__CentiM3: Qudt.unitFromLocalnameRequired(
    "PERCENT-HR-PER-CentiM3"
  ),
  // Million Us Dollars per Flight
  MegaDOLLAR_US__PER__FLIGHT: Qudt.unitFromLocalnameRequired(
    "MegaDOLLAR_US-PER-FLIGHT"
  ),
  // Micro Volt Ampere
  MicroVA: Qudt.unitFromLocalnameRequired("MicroVA"),
  // Cubic Centimetre per Bar
  CentiM3__PER__BAR: Qudt.unitFromLocalnameRequired("CentiM3-PER-BAR"),
  // Cubic Metre per Second Pascal
  M3__PER__SEC__PA: Qudt.unitFromLocalnameRequired("M3-PER-SEC-PA"),
  // Mauritius Rupee
  CCY_MUR_Currency: Qudt.unitFromLocalnameRequired("CCY_MUR"),
  // Us Gallon per Day
  GAL_US__PER__DAY: Qudt.unitFromLocalnameRequired("GAL_US-PER-DAY"),
  // Reciprocal Tesla Metre
  PER__T__M: Qudt.unitFromLocalnameRequired("PER-T-M"),
  // Kilogram per Square Meter Square Second
  KiloGM__PER__M2__SEC2: Qudt.unitFromLocalnameRequired("KiloGM-PER-M2-SEC2"),
  // Reciprocal Electron Volt Cubic Meter
  PER__EV__M3: Qudt.unitFromLocalnameRequired("PER-EV-M3"),
  // Number
  NUM: Qudt.unitFromLocalnameRequired("NUM"),
  // Sudanese Pound
  CCY_SDG_Currency: Qudt.unitFromLocalnameRequired("CCY_SDG"),
  // Nanohenry per Metre
  NanoH__PER__M: Qudt.unitFromLocalnameRequired("NanoH-PER-M"),
  // Pound Mass per Degree Fahrenheit
  LB__PER__DEG_F: Qudt.unitFromLocalnameRequired("LB-PER-DEG_F"),
  // Kiloampere per Metre
  KiloA__PER__M: Qudt.unitFromLocalnameRequired("KiloA-PER-M"),
  // Kilogram per Kelvin
  KiloGM__PER__K: Qudt.unitFromLocalnameRequired("KiloGM-PER-K"),
  // Centimetre per Bar
  CentiM__PER__BAR: Qudt.unitFromLocalnameRequired("CentiM-PER-BAR"),
  // Pound Mass Degree Rankine
  LB__DEG_R: Qudt.unitFromLocalnameRequired("LB-DEG_R"),
  // Micromole per Gram Hour
  MicroMOL__PER__GM__HR: Qudt.unitFromLocalnameRequired("MicroMOL-PER-GM-HR"),
  // Ampere Hour per Kilogram
  A__HR__PER__KiloGM: Qudt.unitFromLocalnameRequired("A-HR-PER-KiloGM"),
  // Percent per Degree Celsius
  PERCENT__PER__DEG_C: Qudt.unitFromLocalnameRequired("PERCENT-PER-DEG_C"),
  // Candela
  CD: Qudt.unitFromLocalnameRequired("CD"),
  // Microgray per Minute
  MicroGRAY__PER__MIN: Qudt.unitFromLocalnameRequired("MicroGRAY-PER-MIN"),
  // Nanotesla
  NanoT: Qudt.unitFromLocalnameRequired("NanoT"),
  // Cubic Kilometer per Square Second
  KiloM3__PER__SEC2: Qudt.unitFromLocalnameRequired("KiloM3-PER-SEC2"),
  // Tonne per Day Bar
  TONNE__PER__DAY__BAR: Qudt.unitFromLocalnameRequired("TONNE-PER-DAY-BAR"),
  // Peta Volt Ampere
  PetaVA: Qudt.unitFromLocalnameRequired("PetaVA"),
  // Picofarad
  PicoFARAD: Qudt.unitFromLocalnameRequired("PicoFARAD"),
  // Degree Fahrenheit Second per British Thermal Unit (thermochemical Definition)
  DEG_F__SEC__PER__BTU_TH: Qudt.unitFromLocalnameRequired(
    "DEG_F-SEC-PER-BTU_TH"
  ),
  // Netherlands Antillian Guilder
  CCY_ANG: Qudt.unitFromLocalnameRequired("CCY_ANG"),
  // Giga Volt Ampere
  GigaVA: Qudt.unitFromLocalnameRequired("GigaVA"),
  // Centimole
  CentiMOL: Qudt.unitFromLocalnameRequired("CentiMOL"),
  // Foot Pound Force per Second
  FT__LB_F__PER__SEC: Qudt.unitFromLocalnameRequired("FT-LB_F-PER-SEC"),
  // Us Peck per Second
  PK_US_DRY__PER__SEC: Qudt.unitFromLocalnameRequired("PK_US_DRY-PER-SEC"),
  // Gram per Litre Bar
  GM__PER__L__BAR: Qudt.unitFromLocalnameRequired("GM-PER-L-BAR"),
  // Cedi
  CCY_GHS: Qudt.unitFromLocalnameRequired("CCY_GHS"),
  // Astronomical-unit
  AU: Qudt.unitFromLocalnameRequired("AU"),
  // Tonne per Month
  TONNE__PER__MO: Qudt.unitFromLocalnameRequired("TONNE-PER-MO"),
  // Nanomole per Micromole
  NanoMOL__PER__MicroMOL: Qudt.unitFromLocalnameRequired(
    "NanoMOL-PER-MicroMOL"
  ),
  // Zambian Kwacha
  CCY_ZMW_Currency: Qudt.unitFromLocalnameRequired("CCY_ZMW"),
  // Franc Congolais
  CCY_CDF: Qudt.unitFromLocalnameRequired("CCY_CDF"),
  // Norwegian Krone
  CCY_NOK: Qudt.unitFromLocalnameRequired("CCY_NOK"),
  // Reciprocal Square Inch
  PER__IN2: Qudt.unitFromLocalnameRequired("PER-IN2"),
  // Kilometer per Hour
  KiloM__PER__HR: Qudt.unitFromLocalnameRequired("KiloM-PER-HR"),
  // Meter Kilogram
  M__KiloGM: Qudt.unitFromLocalnameRequired("M-KiloGM"),
  // British Thermal Unit (mean)
  BTU_MEAN: Qudt.unitFromLocalnameRequired("BTU_MEAN"),
  // Milliarcsecond
  MilliARCSEC: Qudt.unitFromLocalnameRequired("MilliARCSEC"),
  // Nanogray per Second
  NanoGRAY__PER__SEC: Qudt.unitFromLocalnameRequired("NanoGRAY-PER-SEC"),
  // Megacoulomb per Square Meter
  MegaC__PER__M2: Qudt.unitFromLocalnameRequired("MegaC-PER-M2"),
  // Gigapascal
  GigaPA: Qudt.unitFromLocalnameRequired("GigaPA"),
  // Number per Square Metre
  NUM__PER__M2: Qudt.unitFromLocalnameRequired("NUM-PER-M2"),
  // Sievert per Hour
  SV__PER__HR: Qudt.unitFromLocalnameRequired("SV-PER-HR"),
  // Yard per Degree Fahrenheit
  YD__PER__DEG_F: Qudt.unitFromLocalnameRequired("YD-PER-DEG_F"),
  // Reciprocal Nanometre
  PER__NanoM: Qudt.unitFromLocalnameRequired("PER-NanoM"),
  // Erg per Square Centimeter Second
  ERG__PER__CentiM2__SEC: Qudt.unitFromLocalnameRequired("ERG-PER-CentiM2-SEC"),
  // Kilo Thermochemical Calorie
  KiloCAL_TH: Qudt.unitFromLocalnameRequired("KiloCAL_TH"),
  // Gram Force per Square Centimetre
  GM_F__PER__CentiM2: Qudt.unitFromLocalnameRequired("GM_F-PER-CentiM2"),
  // Pound Mass per Foot Minute
  LB__PER__FT__MIN: Qudt.unitFromLocalnameRequired("LB-PER-FT-MIN"),
  // Milliohm per Bar
  MilliOHM__PER__BAR: Qudt.unitFromLocalnameRequired("MilliOHM-PER-BAR"),
  // Foot Pound Force per Hour
  FT__LB_F__PER__HR: Qudt.unitFromLocalnameRequired("FT-LB_F-PER-HR"),
  // Number per Nanoliter
  NUM__PER__NanoL: Qudt.unitFromLocalnameRequired("NUM-PER-NanoL"),
  // Milligram per Metre
  MilliGM__PER__M: Qudt.unitFromLocalnameRequired("MilliGM-PER-M"),
  // Horsepower (electric)
  HP_Electric: Qudt.unitFromLocalnameRequired("HP_Electric"),
  // Euro
  CCY_EUR_Currency: Qudt.unitFromLocalnameRequired("CCY_EUR"),
  // Nanovolt Ampere
  NanoV__A: Qudt.unitFromLocalnameRequired("NanoV-A"),
  // Watt per Cubic Metre
  W__PER__M3: Qudt.unitFromLocalnameRequired("W-PER-M3"),
  // British Thermal Unit (international Definition) per Pound Mass
  BTU_IT__PER__LB: Qudt.unitFromLocalnameRequired("BTU_IT-PER-LB"),
  // Reciprocal Square Second
  PER__SEC2: Qudt.unitFromLocalnameRequired("PER-SEC2"),
  // Barrel (UK Petroleum) per Hour
  BBL_UK_PET__PER__HR: Qudt.unitFromLocalnameRequired("BBL_UK_PET-PER-HR"),
  // Kenyan Shilling
  CCY_KES: Qudt.unitFromLocalnameRequired("CCY_KES"),
  // Weber per Meter
  WB__PER__M: Qudt.unitFromLocalnameRequired("WB-PER-M"),
  // Second per Meter
  SEC__PER__M: Qudt.unitFromLocalnameRequired("SEC-PER-M"),
  // Nanogram per Microlitre
  NanoGM__PER__MicroL: Qudt.unitFromLocalnameRequired("NanoGM-PER-MicroL"),
  // Australian Dollar
  CCY_AUD_Currency: Qudt.unitFromLocalnameRequired("CCY_AUD"),
  // Volt
  V: Qudt.unitFromLocalnameRequired("V"),
  // Square Meter per Square Hertz
  M2__PER__HZ2: Qudt.unitFromLocalnameRequired("M2-PER-HZ2"),
  // Nanosievert per Hour
  NanoSV__PER__HR: Qudt.unitFromLocalnameRequired("NanoSV-PER-HR"),
  // Month per Number
  MO__PER__NUM: Qudt.unitFromLocalnameRequired("MO-PER-NUM"),
  // Nanogray per Hour
  NanoGRAY__PER__HR: Qudt.unitFromLocalnameRequired("NanoGRAY-PER-HR"),
  // Kilometer per Second Bar
  KiloM__PER__SEC__BAR: Qudt.unitFromLocalnameRequired("KiloM-PER-SEC-BAR"),
  // Platinum (one Troy Ounce)
  CCY_XPT: Qudt.unitFromLocalnameRequired("CCY_XPT"),
  // Milligram per Kilogram
  MilliGM__PER__KiloGM: Qudt.unitFromLocalnameRequired("MilliGM-PER-KiloGM"),
  // Mega Us Dollar per Year
  MegaCCY_USD__PER__YR: Qudt.unitFromLocalnameRequired("MegaCCY_USD-PER-YR"),
  // Milligram per Minute Bar
  MilliGM__PER__MIN__BAR: Qudt.unitFromLocalnameRequired("MilliGM-PER-MIN-BAR"),
  // Barrel (UK Petroleum) per Second
  BBL_UK_PET__PER__SEC: Qudt.unitFromLocalnameRequired("BBL_UK_PET-PER-SEC"),
  // MicroGALILEO
  MicroGALILEO: Qudt.unitFromLocalnameRequired("MicroGALILEO"),
  // Furlong
  FUR: Qudt.unitFromLocalnameRequired("FUR"),
  // Inch
  IN: Qudt.unitFromLocalnameRequired("IN"),
  // Milliwatt per Square Centimetre Micrometre Steradian
  MilliW__PER__CentiM2__MicroM__SR: Qudt.unitFromLocalnameRequired(
    "MilliW-PER-CentiM2-MicroM-SR"
  ),
  // Centimeter per Square Second
  CentiM__PER__SEC2: Qudt.unitFromLocalnameRequired("CentiM-PER-SEC2"),
  // Mole per Square Meter Second Steradian
  MOL__PER__M2__SEC__SR: Qudt.unitFromLocalnameRequired("MOL-PER-M2-SEC-SR"),
  // Nanosievert
  NanoSV: Qudt.unitFromLocalnameRequired("NanoSV"),
  // Psi per Psi
  PSI__PER__PSI: Qudt.unitFromLocalnameRequired("PSI-PER-PSI"),
  // Kiloohm
  KiloOHM: Qudt.unitFromLocalnameRequired("KiloOHM"),
  // Millimetre of Mercury
  MilliM_HG: Qudt.unitFromLocalnameRequired("MilliM_HG"),
  // Picojoule
  PicoJ: Qudt.unitFromLocalnameRequired("PicoJ"),
  // Kilotesla
  KiloT: Qudt.unitFromLocalnameRequired("KiloT"),
  // Mexican Unidad De Inversion (udi) (funds Code)
  CCY_MXV_Currency: Qudt.unitFromLocalnameRequired("CCY_MXV"),
  // Volt per Liter Minute
  V__PER__L__MIN: Qudt.unitFromLocalnameRequired("V-PER-L-MIN"),
  // Pound Mass per Cubic Inch Degree Fahrenheit
  LB__PER__IN3__DEG_F: Qudt.unitFromLocalnameRequired("LB-PER-IN3-DEG_F"),
  // Therm (u.s.)
  THERM_US: Qudt.unitFromLocalnameRequired("THERM_US"),
  // Watt per Kilogram
  W__PER__KiloGM: Qudt.unitFromLocalnameRequired("W-PER-KiloGM"),
  // Tebibit
  TebiBIT: Qudt.unitFromLocalnameRequired("TebiBIT"),
  // Microgram per Cubic Meter Hour
  MicroGM__PER__M3__HR: Qudt.unitFromLocalnameRequired("MicroGM-PER-M3-HR"),
  // Micromole per Square Meter Square Second
  MicroMOL__PER__M2__SEC2: Qudt.unitFromLocalnameRequired(
    "MicroMOL-PER-M2-SEC2"
  ),
  // Watt Hour per Cubic Meter
  W__HR__PER__M3: Qudt.unitFromLocalnameRequired("W-HR-PER-M3"),
  // Number per Liter
  NUM__PER__L: Qudt.unitFromLocalnameRequired("NUM-PER-L"),
  // Standard Cubic Foot per Hour
  SCF__PER__HR: Qudt.unitFromLocalnameRequired("SCF-PER-HR"),
  // Petabit per Second
  PetaBIT__PER__SEC: Qudt.unitFromLocalnameRequired("PetaBIT-PER-SEC"),
  // Cfa Franc Bceao
  CCY_XOF: Qudt.unitFromLocalnameRequired("CCY_XOF"),
  // Electron Volt
  EV: Qudt.unitFromLocalnameRequired("EV"),
  // Henry per Kiloohm
  H__PER__KiloOHM: Qudt.unitFromLocalnameRequired("H-PER-KiloOHM"),
  // Shake
  SH: Qudt.unitFromLocalnameRequired("SH"),
  // Pound Mass Minute per Us Gallon Cubic Yard
  LB__MIN__PER__GAL_US__YD3: Qudt.unitFromLocalnameRequired(
    "LB-MIN-PER-GAL_US-YD3"
  ),
  // Kilo Volt Ampere per Kelvin
  KiloVA__PER__K: Qudt.unitFromLocalnameRequired("KiloVA-PER-K"),
  // Micromole per Kilogram
  MicroMOL__PER__KiloGM: Qudt.unitFromLocalnameRequired("MicroMOL-PER-KiloGM"),
  // Milligram per Square Metre Second
  MilliGM__PER__M2__SEC: Qudt.unitFromLocalnameRequired("MilliGM-PER-M2-SEC"),
  // Mega Us Dollar per Flight
  MegaCCY_USD__PER__FLIGHT: Qudt.unitFromLocalnameRequired(
    "MegaCCY_USD-PER-FLIGHT"
  ),
  // Planck Volume
  PlanckVolume: Qudt.unitFromLocalnameRequired("PlanckVolume"),
  // Square Meter per Gram
  M2__PER__GM: Qudt.unitFromLocalnameRequired("M2-PER-GM"),
  // Thermochemical Calorie per Gram Degree Celsius
  CAL_TH__PER__GM__DEG_C: Qudt.unitFromLocalnameRequired("CAL_TH-PER-GM-DEG_C"),
  // Mole per Cubic Metre Bar
  MOL__PER__M3__BAR: Qudt.unitFromLocalnameRequired("MOL-PER-M3-BAR"),
  // Radian per Square Second
  RAD__PER__SEC2: Qudt.unitFromLocalnameRequired("RAD-PER-SEC2"),
  // Cubic Inch per Hour
  IN3__PER__HR: Qudt.unitFromLocalnameRequired("IN3-PER-HR"),
  // Mean Gregorian Month
  MO_MeanGREGORIAN: Qudt.unitFromLocalnameRequired("MO_MeanGREGORIAN"),
  // Square Meter per Meter
  M2__PER__M: Qudt.unitFromLocalnameRequired("M2-PER-M"),
  // Gamma
  Gamma: Qudt.unitFromLocalnameRequired("Gamma"),
  // Deaths per Million Individuals Year
  DEATHS__PER__MegaINDIV__YR: Qudt.unitFromLocalnameRequired(
    "DEATHS-PER-MegaINDIV-YR"
  ),
  // Milliohm per Meter
  MilliOHM__PER__M: Qudt.unitFromLocalnameRequired("MilliOHM-PER-M"),
  // Microcoulomb per Square Metre
  MicroC__PER__M2: Qudt.unitFromLocalnameRequired("MicroC-PER-M2"),
  // Reciprocal Metre Nanometre
  PER__M__NanoM: Qudt.unitFromLocalnameRequired("PER-M-NanoM"),
  // Kilogram per Cubic Metre Bar
  KiloGM__PER__M3__BAR: Qudt.unitFromLocalnameRequired("KiloGM-PER-M3-BAR"),
  // Coulomb per Cubic Centimetre
  C__PER__CentiM3: Qudt.unitFromLocalnameRequired("C-PER-CentiM3"),
  // Kilonewton Square Metre
  KiloN__M2: Qudt.unitFromLocalnameRequired("KiloN-M2"),
  // Nat per Second
  NAT__PER__SEC: Qudt.unitFromLocalnameRequired("NAT-PER-SEC"),
  // Pound Mass per Cubic Yard
  LB__PER__YD3: Qudt.unitFromLocalnameRequired("LB-PER-YD3"),
  // Bel per Metre
  B__PER__M: Qudt.unitFromLocalnameRequired("B-PER-M"),
  // Ton (US) per Hour
  TON_US__PER__HR: Qudt.unitFromLocalnameRequired("TON_US-PER-HR"),
  // Slug per Cubic Foot
  SLUG__PER__FT3: Qudt.unitFromLocalnameRequired("SLUG-PER-FT3"),
  // Unidad De Valor Real
  CCY_COU: Qudt.unitFromLocalnameRequired("CCY_COU"),
  // Kilo Gram Force
  KiloGM_F: Qudt.unitFromLocalnameRequired("KiloGM_F"),
  // Megahertz
  MegaHZ: Qudt.unitFromLocalnameRequired("MegaHZ"),
  // Microcoulomb
  MicroC: Qudt.unitFromLocalnameRequired("MicroC"),
  // Bahamian Dollar
  CCY_BSD: Qudt.unitFromLocalnameRequired("CCY_BSD"),
  // Mole per Cubic Meter Kelvin
  MOL__PER__M3__K: Qudt.unitFromLocalnameRequired("MOL-PER-M3-K"),
  // Latvian Lats
  CCY_LVL: Qudt.unitFromLocalnameRequired("CCY_LVL"),
  // Cubic Meter per Square Second
  M3__PER__SEC2: Qudt.unitFromLocalnameRequired("M3-PER-SEC2"),
  // Algerian Dinar
  CCY_DZD: Qudt.unitFromLocalnameRequired("CCY_DZD"),
  // Reciprocal Pascal Second
  PER__PA__SEC: Qudt.unitFromLocalnameRequired("PER-PA-SEC"),
  // Parts per Trillion by Volume
  PPT_VOL: Qudt.unitFromLocalnameRequired("PPT_VOL"),
  // Pound Mass Second per Us Gallon Cubic Foot
  LB__SEC__PER__GAL_US__FT3: Qudt.unitFromLocalnameRequired(
    "LB-SEC-PER-GAL_US-FT3"
  ),
  // Ngultrum
  CCY_BTN_Currency: Qudt.unitFromLocalnameRequired("CCY_BTN"),
  // Megahertz per Kelvin
  MegaHZ__PER__K: Qudt.unitFromLocalnameRequired("MegaHZ-PER-K"),
  // Statcoulomb
  C_Stat: Qudt.unitFromLocalnameRequired("C_Stat"),
  // Cycles per Second
  CYC__PER__SEC: Qudt.unitFromLocalnameRequired("CYC-PER-SEC"),
  // Kelvin per Kelvin
  K__PER__K: Qudt.unitFromLocalnameRequired("K-PER-K"),
  // Centipoise
  CentiPOISE: Qudt.unitFromLocalnameRequired("CentiPOISE"),
  // Second per Square Foot
  SEC__PER__FT2: Qudt.unitFromLocalnameRequired("SEC-PER-FT2"),
  // Hectopascal per Kelvin
  HectoPA__PER__K: Qudt.unitFromLocalnameRequired("HectoPA-PER-K"),
  // Percent per Hour
  PERCENT__PER__HR: Qudt.unitFromLocalnameRequired("PERCENT-PER-HR"),
  // Sextic Centimetre
  CentiM6: Qudt.unitFromLocalnameRequired("CentiM6"),
  // Foot per Second Degree Fahrenheit
  FT__PER__SEC__DEG_F: Qudt.unitFromLocalnameRequired("FT-PER-SEC-DEG_F"),
  // Millinewton per Metre
  MilliN__PER__M: Qudt.unitFromLocalnameRequired("MilliN-PER-M"),
  // Ampere per Joule
  A__PER__J: Qudt.unitFromLocalnameRequired("A-PER-J"),
  // Barye
  BARYE: Qudt.unitFromLocalnameRequired("BARYE"),
  // Reciprocal Tonne
  PER__TONNE: Qudt.unitFromLocalnameRequired("PER-TONNE"),
  // Nanofarad
  NanoFARAD: Qudt.unitFromLocalnameRequired("NanoFARAD"),
  // Pound Mass Second per Cubic Inch Cubic Yard
  LB__SEC__PER__IN3__YD3: Qudt.unitFromLocalnameRequired("LB-SEC-PER-IN3-YD3"),
  // Percent Minute per Cubic Yard
  PERCENT__MIN__PER__YD3: Qudt.unitFromLocalnameRequired("PERCENT-MIN-PER-YD3"),
  // New Israeli Shekel
  CCY_ILS: Qudt.unitFromLocalnameRequired("CCY_ILS"),
  // Fluid Ounce (UK) per Hour
  OZ_VOL_UK__PER__HR: Qudt.unitFromLocalnameRequired("OZ_VOL_UK-PER-HR"),
  // Dyne
  DYN: Qudt.unitFromLocalnameRequired("DYN"),
  // Statmho
  MHO_Stat: Qudt.unitFromLocalnameRequired("MHO_Stat"),
  // Candlepower
  CP: Qudt.unitFromLocalnameRequired("CP"),
  // Watt Hour per Litre
  W__HR__PER__L: Qudt.unitFromLocalnameRequired("W-HR-PER-L"),
  // Samoan Tala
  CCY_WST_Currency: Qudt.unitFromLocalnameRequired("CCY_WST"),
  // Conventional Metre of Water
  M_H2O: Qudt.unitFromLocalnameRequired("M_H2O"),
  // Decilitre per Gram
  DeciL__PER__GM: Qudt.unitFromLocalnameRequired("DeciL-PER-GM"),
  // Metric Ton per Second
  TON_Metric__PER__SEC: Qudt.unitFromLocalnameRequired("TON_Metric-PER-SEC"),
  // SpeedOfLight
  SpeedOfLight: Qudt.unitFromLocalnameRequired("SpeedOfLight"),
  // Dyne Second per Cubic Centimeter
  DYN__SEC__PER__CentiM3: Qudt.unitFromLocalnameRequired("DYN-SEC-PER-CentiM3"),
  // Pound Sterling
  CCY_GBP_Currency: Qudt.unitFromLocalnameRequired("CCY_GBP"),
  // Cubic Angstrom
  ANGSTROM3: Qudt.unitFromLocalnameRequired("ANGSTROM3"),
  // Statampere per Square Centimetre
  A_Stat__PER__CentiM2: Qudt.unitFromLocalnameRequired("A_Stat-PER-CentiM2"),
  // Pound Mass Hour per Sextic Inch
  LB__HR__PER__IN6: Qudt.unitFromLocalnameRequired("LB-HR-PER-IN6"),
  // Dobra
  CCY_STN: Qudt.unitFromLocalnameRequired("CCY_STN"),
  // Pound Mass Second per Cubic Foot Cubic Yard
  LB__SEC__PER__FT3__YD3: Qudt.unitFromLocalnameRequired("LB-SEC-PER-FT3-YD3"),
  // Lumen
  LM: Qudt.unitFromLocalnameRequired("LM"),
  // Kilolumen
  KiloLM: Qudt.unitFromLocalnameRequired("KiloLM"),
  // Microvolt Ampere per Kelvin
  MicroV__A__PER__K: Qudt.unitFromLocalnameRequired("MicroV-A-PER-K"),
  // Pound Mass Hour per Gallon (UK) Cubic Foot
  LB__HR__PER__GAL_UK__FT3: Qudt.unitFromLocalnameRequired(
    "LB-HR-PER-GAL_UK-FT3"
  ),
  // Millilitre per Kilogram
  MilliL__PER__KiloGM: Qudt.unitFromLocalnameRequired("MilliL-PER-KiloGM"),
  // Percent per Ohm
  PERCENT__PER__OHM: Qudt.unitFromLocalnameRequired("PERCENT-PER-OHM"),
  // Gill (UK) per Day
  GI_UK__PER__DAY: Qudt.unitFromLocalnameRequired("GI_UK-PER-DAY"),
  // Microbecquerel per Liter
  MicroBQ__PER__L: Qudt.unitFromLocalnameRequired("MicroBQ-PER-L"),
  // Newton per Ampere
  N__PER__A: Qudt.unitFromLocalnameRequired("N-PER-A"),
  // Pound Mass per Imperial Gallon
  LB__PER__GAL_IMP: Qudt.unitFromLocalnameRequired("LB-PER-GAL_IMP"),
  // Standard
  Standard: Qudt.unitFromLocalnameRequired("Standard"),
  // International Table Calorie per Second Square Centimetre Kelvin
  CAL_IT__PER__SEC__CentiM2__K: Qudt.unitFromLocalnameRequired(
    "CAL_IT-PER-SEC-CentiM2-K"
  ),
  // Calorie (15 Degrees C)
  CAL_15_DEG_C: Qudt.unitFromLocalnameRequired("CAL_15_DEG_C"),
  // Mole per Square Meter Second
  MOL__PER__M2__SEC: Qudt.unitFromLocalnameRequired("MOL-PER-M2-SEC"),
  // Denier
  DENIER: Qudt.unitFromLocalnameRequired("DENIER"),
  // Gram per Bar
  GM__PER__BAR: Qudt.unitFromLocalnameRequired("GM-PER-BAR"),
  // Revolution
  REV: Qudt.unitFromLocalnameRequired("REV"),
  // Swiss Franc
  CCY_CHF_Currency: Qudt.unitFromLocalnameRequired("CCY_CHF"),
  // Kilocalorie per Gram Degree Celsius
  KiloCAL__PER__GM__DEG_C: Qudt.unitFromLocalnameRequired(
    "KiloCAL-PER-GM-DEG_C"
  ),
  // Gram Minute per Liter Cubic Centimeter
  GM__MIN__PER__L__CentiM3: Qudt.unitFromLocalnameRequired(
    "GM-MIN-PER-L-CentiM3"
  ),
  // Meganewton Metre per Square Metre
  MegaN__M__PER__M2: Qudt.unitFromLocalnameRequired("MegaN-M-PER-M2"),
  // Planck Current
  PlanckCurrent: Qudt.unitFromLocalnameRequired("PlanckCurrent"),
  // Femtogram
  FemtoGM: Qudt.unitFromLocalnameRequired("FemtoGM"),
  // Gram per Second Kelvin
  GM__PER__SEC__K: Qudt.unitFromLocalnameRequired("GM-PER-SEC-K"),
  // Nanomole per Cubic Centimetre Hour
  NanoMOL__PER__CentiM3__HR: Qudt.unitFromLocalnameRequired(
    "NanoMOL-PER-CentiM3-HR"
  ),
  // Cubic Centimeter per Minute Kelvin
  CentiM3__PER__MIN__K: Qudt.unitFromLocalnameRequired("CentiM3-PER-MIN-K"),
  // Hertz per Volt
  HZ__PER__V: Qudt.unitFromLocalnameRequired("HZ-PER-V"),
  // Iraqi Dinar
  CCY_IQD: Qudt.unitFromLocalnameRequired("CCY_IQD"),
  // Pound Mass per Foot Hour
  LB__PER__FT__HR: Qudt.unitFromLocalnameRequired("LB-PER-FT-HR"),
  // Nanogray
  NanoGRAY: Qudt.unitFromLocalnameRequired("NanoGRAY"),
  // Thermochemical Calorie per Second Centimetre Kelvin
  CAL_TH__PER__SEC__CentiM__K: Qudt.unitFromLocalnameRequired(
    "CAL_TH-PER-SEC-CentiM-K"
  ),
  // Danish Krone
  CCY_DKK: Qudt.unitFromLocalnameRequired("CCY_DKK"),
  // M0dot
  M0dot: Qudt.unitFromLocalnameRequired("M0dot"),
  // Millimeter per Square Second
  MilliM__PER__SEC2: Qudt.unitFromLocalnameRequired("MilliM-PER-SEC2"),
  // Nat
  NAT: Qudt.unitFromLocalnameRequired("NAT"),
  // Kilohenry
  KiloH: Qudt.unitFromLocalnameRequired("KiloH"),
  // Tonne per Hour Kelvin
  TONNE__PER__HR__K: Qudt.unitFromLocalnameRequired("TONNE-PER-HR-K"),
  // Metric Ton per Hectare
  TON_Metric__PER__HA: Qudt.unitFromLocalnameRequired("TON_Metric-PER-HA"),
  // Foot Hour per Us Gallon
  FT__HR__PER__GAL_US: Qudt.unitFromLocalnameRequired("FT-HR-PER-GAL_US"),
  // Decametre
  DecaM: Qudt.unitFromLocalnameRequired("DecaM"),
  // Newton Metre per Metre
  N__M__PER__M: Qudt.unitFromLocalnameRequired("N-M-PER-M"),
  // Kilogram per Cubic Meter Pascal
  KiloGM__PER__M3__PA: Qudt.unitFromLocalnameRequired("KiloGM-PER-M3-PA"),
  // Reciprocal Joule Cubic Meter
  PER__J__M3: Qudt.unitFromLocalnameRequired("PER-J-M3"),
  // Square Degree
  DEG2: Qudt.unitFromLocalnameRequired("DEG2"),
  // Square Centimetre Minute
  CentiM2__MIN: Qudt.unitFromLocalnameRequired("CentiM2-MIN"),
  // Gallon (UK) per Second
  GAL_UK__PER__SEC: Qudt.unitFromLocalnameRequired("GAL_UK-PER-SEC"),
  // Reciprocal Volt Ampere Second
  PER__V__A__SEC: Qudt.unitFromLocalnameRequired("PER-V-A-SEC"),
  // Abcoulomb
  C_Ab: Qudt.unitFromLocalnameRequired("C_Ab"),
  // Pound Mass Hour per Cubic Inch Cubic Foot
  LB__HR__PER__IN3__FT3: Qudt.unitFromLocalnameRequired("LB-HR-PER-IN3-FT3"),
  // Reciprocal Meter Nanometer Steradian
  PER__M__NanoM__SR: Qudt.unitFromLocalnameRequired("PER-M-NanoM-SR"),
  // Solomon Islands Dollar
  CCY_SBD_Currency: Qudt.unitFromLocalnameRequired("CCY_SBD"),
  // North Korean Won
  CCY_KPW_Currency: Qudt.unitFromLocalnameRequired("CCY_KPW"),
  // Reciprocal Meter Second
  PER__M__SEC: Qudt.unitFromLocalnameRequired("PER-M-SEC"),
  // Picopascal
  PicoPA: Qudt.unitFromLocalnameRequired("PicoPA"),
  // Sextic Meter
  M6: Qudt.unitFromLocalnameRequired("M6"),
  // Guarani
  CCY_PYG_Currency: Qudt.unitFromLocalnameRequired("CCY_PYG"),
  // Metric Ton per Day
  TON_Metric__PER__DAY: Qudt.unitFromLocalnameRequired("TON_Metric-PER-DAY"),
  // Petaampere
  PetaA: Qudt.unitFromLocalnameRequired("PetaA"),
  // Torr
  TORR: Qudt.unitFromLocalnameRequired("TORR"),
  // Million Us Dollars per Year
  MillionUSD__PER__YR: Qudt.unitFromLocalnameRequired("MillionUSD-PER-YR"),
  // Cubic Centimeter per Mole Second
  CentiM3__PER__MOL__SEC: Qudt.unitFromLocalnameRequired("CentiM3-PER-MOL-SEC"),
  // French Gauge
  GAUGE_FR: Qudt.unitFromLocalnameRequired("GAUGE_FR"),
  // Horsepower (metric)
  HP_Metric: Qudt.unitFromLocalnameRequired("HP_Metric"),
  // Ohm per Kelvin
  OHM__PER__K: Qudt.unitFromLocalnameRequired("OHM-PER-K"),
  // Poundal per Square Inch
  PDL__PER__IN2: Qudt.unitFromLocalnameRequired("PDL-PER-IN2"),
  // Hectopascal per Bar
  HectoPA__PER__BAR: Qudt.unitFromLocalnameRequired("HectoPA-PER-BAR"),
  // Centimetre per Year
  CentiM__PER__YR: Qudt.unitFromLocalnameRequired("CentiM-PER-YR"),
  // Millilitre per Day Kelvin
  MilliL__PER__DAY__K: Qudt.unitFromLocalnameRequired("MilliL-PER-DAY-K"),
  // Watt per Square Inch
  W__PER__IN2: Qudt.unitFromLocalnameRequired("W-PER-IN2"),
  // Meter per Year
  M__PER__YR: Qudt.unitFromLocalnameRequired("M-PER-YR"),
  // Momme (textile)
  MOMME_Textile: Qudt.unitFromLocalnameRequired("MOMME_Textile"),
  // Megabecquerel
  MegaBQ: Qudt.unitFromLocalnameRequired("MegaBQ"),
  // Ampere per Millimeter
  A__PER__MilliM: Qudt.unitFromLocalnameRequired("A-PER-MilliM"),
  // Mega Volt Ampere Reactive Hour
  MegaVAR__HR: Qudt.unitFromLocalnameRequired("MegaVAR-HR"),
  // Lux Second
  LUX__SEC: Qudt.unitFromLocalnameRequired("LUX-SEC"),
  // Degree Celsius per Minute
  DEG_C__PER__MIN: Qudt.unitFromLocalnameRequired("DEG_C-PER-MIN"),
  // Centimetre of Mercury (0 °C)
  CentiM_HG_0DEG_C: Qudt.unitFromLocalnameRequired("CentiM_HG_0DEG_C"),
  // Ounce Mass Minute per Cubic Inch Gallon (UK)
  OZ__MIN__PER__IN3__GAL_UK: Qudt.unitFromLocalnameRequired(
    "OZ-MIN-PER-IN3-GAL_UK"
  ),
  // Cyprus Pound
  CCY_CYP: Qudt.unitFromLocalnameRequired("CCY_CYP"),
  // Square Foot Degree Fahrenheit
  FT2__DEG_F: Qudt.unitFromLocalnameRequired("FT2-DEG_F"),
  // Iceland Krona
  CCY_ISK: Qudt.unitFromLocalnameRequired("CCY_ISK"),
  // Year per Number
  YR__PER__NUM: Qudt.unitFromLocalnameRequired("YR-PER-NUM"),
  // Mole per Gram Hour
  MOL__PER__GM__HR: Qudt.unitFromLocalnameRequired("MOL-PER-GM-HR"),
  // Percent Foot Second per Pound Mass
  PERCENT__FT__SEC__PER__LB: Qudt.unitFromLocalnameRequired(
    "PERCENT-FT-SEC-PER-LB"
  ),
  // British Thermal Unit (thermochemical Definition)
  BTU_TH: Qudt.unitFromLocalnameRequired("BTU_TH"),
  // Gigabyte per Second
  GigaBYTE__PER__SEC: Qudt.unitFromLocalnameRequired("GigaBYTE-PER-SEC"),
  // Ounce Mass Square Inch per Cubic Inch Pound Force Second
  OZ__IN2__PER__IN3__LB_F__SEC: Qudt.unitFromLocalnameRequired(
    "OZ-IN2-PER-IN3-LB_F-SEC"
  ),
  // Planck Length
  PlanckLength: Qudt.unitFromLocalnameRequired("PlanckLength"),
  // Kiloampere per Square Metre
  KiloA__PER__M2: Qudt.unitFromLocalnameRequired("KiloA-PER-M2"),
  // European Unit of Account 17 (e.u.a.-17) (bonds Market Unit)
  CCY_XBD_Currency: Qudt.unitFromLocalnameRequired("CCY_XBD"),
  // Micrometer per Meter
  MicroM__PER__M: Qudt.unitFromLocalnameRequired("MicroM-PER-M"),
  // Milligram Hour per Sextic Meter
  MilliGM__HR__PER__M6: Qudt.unitFromLocalnameRequired("MilliGM-HR-PER-M6"),
  // Ounce Mass per Gallon (UK)
  OZ__PER__GAL_UK: Qudt.unitFromLocalnameRequired("OZ-PER-GAL_UK"),
  // Gram per Hectare
  GM__PER__HA: Qudt.unitFromLocalnameRequired("GM-PER-HA"),
  // Mesh
  MESH: Qudt.unitFromLocalnameRequired("MESH"),
  // Reciprocal Mole
  PER__MOL: Qudt.unitFromLocalnameRequired("PER-MOL"),
  // Square Degree Celsius per Second
  DEG_C2__PER__SEC: Qudt.unitFromLocalnameRequired("DEG_C2-PER-SEC"),
  // Attojoule
  AttoJ: Qudt.unitFromLocalnameRequired("AttoJ"),
  // Percent Second per Cubic Yard
  PERCENT__SEC__PER__YD3: Qudt.unitFromLocalnameRequired("PERCENT-SEC-PER-YD3"),
  // Cfa Franc Beac
  CCY_XAF_Currency: Qudt.unitFromLocalnameRequired("CCY_XAF"),
  // Siemens Square Metre per Mole
  S__M2__PER__MOL: Qudt.unitFromLocalnameRequired("S-M2-PER-MOL"),
  // Us Liquid Quart per Day
  QT_US__PER__DAY: Qudt.unitFromLocalnameRequired("QT_US-PER-DAY"),
  // Perm (23 °C)
  PERM_23DEG_C: Qudt.unitFromLocalnameRequired("PERM_23DEG_C"),
  // Kilobecquerel per Kilogram
  KiloBQ__PER__KiloGM: Qudt.unitFromLocalnameRequired("KiloBQ-PER-KiloGM"),
  // Poise
  POISE: Qudt.unitFromLocalnameRequired("POISE"),
  // Pound Sterling
  CCY_GBP: Qudt.unitFromLocalnameRequired("CCY_GBP"),
  // Cubic Yard per Minute
  YD3__PER__MIN: Qudt.unitFromLocalnameRequired("YD3-PER-MIN"),
  // Kilogram per Kilogram
  KiloGM__PER__KiloGM: Qudt.unitFromLocalnameRequired("KiloGM-PER-KiloGM"),
  // Megakelvin
  MegaK: Qudt.unitFromLocalnameRequired("MegaK"),
  // Tonne per Day
  TONNE__PER__DAY: Qudt.unitFromLocalnameRequired("TONNE-PER-DAY"),
  // Kilonewton per Metre
  KiloN__PER__M: Qudt.unitFromLocalnameRequired("KiloN-PER-M"),
  // Millicandela
  MilliCD: Qudt.unitFromLocalnameRequired("MilliCD"),
  // 100KiloCount
  _100KiloCount: Qudt.unitFromLocalnameRequired("100KiloCount"),
  // Kilovolt per Metre
  KiloV__PER__M: Qudt.unitFromLocalnameRequired("KiloV-PER-M"),
  // Aruban Guilder
  CCY_AWG_Currency: Qudt.unitFromLocalnameRequired("CCY_AWG"),
  // Planck Power
  PlanckPower: Qudt.unitFromLocalnameRequired("PlanckPower"),
  // Centicoulomb
  CentiC: Qudt.unitFromLocalnameRequired("CentiC"),
  // Reciprocal Volt
  PER__V: Qudt.unitFromLocalnameRequired("PER-V"),
  // Milliampere per Millimetre
  MilliA__PER__MilliM: Qudt.unitFromLocalnameRequired("MilliA-PER-MilliM"),
  // Megajoule per Cubic Meter
  MegaJ__PER__M3: Qudt.unitFromLocalnameRequired("MegaJ-PER-M3"),
  // Day per Number
  DAY__PER__NUM: Qudt.unitFromLocalnameRequired("DAY-PER-NUM"),
  // British Thermal Unit (thermochemical Definition) per Square Foot Minute
  BTU_TH__PER__FT2__MIN: Qudt.unitFromLocalnameRequired("BTU_TH-PER-FT2-MIN"),
  // Watt per Square Meter Meter
  W__PER__M2__M: Qudt.unitFromLocalnameRequired("W-PER-M2-M"),
  // Maxwell
  MX: Qudt.unitFromLocalnameRequired("MX"),
  // Pound Mass Hour per Cubic Inch Gallon (UK)
  LB__HR__PER__IN3__GAL_UK: Qudt.unitFromLocalnameRequired(
    "LB-HR-PER-IN3-GAL_UK"
  ),
  // Square Metre per Mole
  M2__PER__MOL: Qudt.unitFromLocalnameRequired("M2-PER-MOL"),
  // Volt per Inch
  V__PER__IN: Qudt.unitFromLocalnameRequired("V-PER-IN"),
  // Degree per Second
  DEG__PER__SEC: Qudt.unitFromLocalnameRequired("DEG-PER-SEC"),
  // Degree Fahrenheit per Hour
  DEG_F__PER__HR: Qudt.unitFromLocalnameRequired("DEG_F-PER-HR"),
  // Qatari Rial
  CCY_QAR_Currency: Qudt.unitFromLocalnameRequired("CCY_QAR"),
  // Newton per Kilogram
  N__PER__KiloGM: Qudt.unitFromLocalnameRequired("N-PER-KiloGM"),
  // Megapascal per Bar
  MegaPA__PER__BAR: Qudt.unitFromLocalnameRequired("MegaPA-PER-BAR"),
  // Candela per Square Inch
  CD__PER__IN2: Qudt.unitFromLocalnameRequired("CD-PER-IN2"),
  // Centipoise per Kelvin
  CentiPOISE__PER__K: Qudt.unitFromLocalnameRequired("CentiPOISE-PER-K"),
  // Kilogram per Minute Bar
  KiloGM__PER__MIN__BAR: Qudt.unitFromLocalnameRequired("KiloGM-PER-MIN-BAR"),
  // Us Dry Quart
  QT_US_DRY: Qudt.unitFromLocalnameRequired("QT_US_DRY"),
  // Pint (UK) per Day
  PINT_UK__PER__DAY: Qudt.unitFromLocalnameRequired("PINT_UK-PER-DAY"),
  // Nepalese Rupee
  CCY_NPR: Qudt.unitFromLocalnameRequired("CCY_NPR"),
  // Gold Franc (special Settlement Currency)
  CCY_XFO_Currency: Qudt.unitFromLocalnameRequired("CCY_XFO"),
  // Venezuelan Bolvar
  CCY_VES: Qudt.unitFromLocalnameRequired("CCY_VES"),
  // Microinch
  MicroIN: Qudt.unitFromLocalnameRequired("MicroIN"),
  // Microlitre per Litre
  MicroL__PER__L: Qudt.unitFromLocalnameRequired("MicroL-PER-L"),
  // Square Metre per Second Pascal
  M2__PER__SEC__PA: Qudt.unitFromLocalnameRequired("M2-PER-SEC-PA"),
  // Percent Relative Humidity
  PERCENT_RH: Qudt.unitFromLocalnameRequired("PERCENT_RH"),
  // Pound Mass Second per Cubic Foot Us Gallon
  LB__SEC__PER__FT3__GAL_US: Qudt.unitFromLocalnameRequired(
    "LB-SEC-PER-FT3-GAL_US"
  ),
  // Electron Volt Square Metre
  EV__M2: Qudt.unitFromLocalnameRequired("EV-M2"),
  // Cubic Centimetre per Kelvin
  CentiM3__PER__K: Qudt.unitFromLocalnameRequired("CentiM3-PER-K"),
  // Gram per Day
  GM__PER__DAY: Qudt.unitFromLocalnameRequired("GM-PER-DAY"),
  // Reads per Kilobase
  RPK: Qudt.unitFromLocalnameRequired("RPK"),
  // Microgram per Square Metre Day
  MicroGM__PER__M2__DAY: Qudt.unitFromLocalnameRequired("MicroGM-PER-M2-DAY"),
  // Percent Second per Cubic Centimeter
  PERCENT__SEC__PER__CentiM3: Qudt.unitFromLocalnameRequired(
    "PERCENT-SEC-PER-CentiM3"
  ),
  // Cubic Centimeter per Minute
  CentiM3__PER__MIN: Qudt.unitFromLocalnameRequired("CentiM3-PER-MIN"),
  // Kilonewton per Cubic Meter
  KiloN__PER__M3: Qudt.unitFromLocalnameRequired("KiloN-PER-M3"),
  // Degree Celsius Kilogram per Square Metre
  DEG_C__KiloGM__PER__M2: Qudt.unitFromLocalnameRequired("DEG_C-KiloGM-PER-M2"),
  // British Thermal Unit (international Definition) per Second Foot Degree Rankine
  BTU_IT__PER__SEC__FT__DEG_R: Qudt.unitFromLocalnameRequired(
    "BTU_IT-PER-SEC-FT-DEG_R"
  ),
  // Pound Mass Minute per Us Gallon Cubic Foot
  LB__MIN__PER__GAL_US__FT3: Qudt.unitFromLocalnameRequired(
    "LB-MIN-PER-GAL_US-FT3"
  ),
  // Microsievert per Minute
  MicroSV__PER__MIN: Qudt.unitFromLocalnameRequired("MicroSV-PER-MIN"),
  // Indian Rupee
  CCY_INR: Qudt.unitFromLocalnameRequired("CCY_INR"),
  // Microgram per Liter Hour
  MicroGM__PER__L__HR: Qudt.unitFromLocalnameRequired("MicroGM-PER-L-HR"),
  // Reciprocal Gram
  PER__GM: Qudt.unitFromLocalnameRequired("PER-GM"),
  // Mebibit per Metre
  MebiBIT__PER__M: Qudt.unitFromLocalnameRequired("MebiBIT-PER-M"),
  // Hryvnia
  CCY_UAH: Qudt.unitFromLocalnameRequired("CCY_UAH"),
  // Foot per Second Psi
  FT__PER__SEC__PSI: Qudt.unitFromLocalnameRequired("FT-PER-SEC-PSI"),
  // Nanogram per Milligram
  NanoGM__PER__MilliGM: Qudt.unitFromLocalnameRequired("NanoGM-PER-MilliGM"),
  // Square Meter Cubic Hertz
  M2__HZ3: Qudt.unitFromLocalnameRequired("M2-HZ3"),
  // Liter per Minute
  L__PER__MIN: Qudt.unitFromLocalnameRequired("L-PER-MIN"),
  // Gram Minute per Cubic Metre Cubic Centimetre
  GM__MIN__PER__M3__CentiM3: Qudt.unitFromLocalnameRequired(
    "GM-MIN-PER-M3-CentiM3"
  ),
  // Microvolt per Metre
  MicroV__PER__M: Qudt.unitFromLocalnameRequired("MicroV-PER-M"),
  // Foot of Water
  FT_H2O: Qudt.unitFromLocalnameRequired("FT_H2O"),
  // Richter Magnitude
  RichterMagnitude: Qudt.unitFromLocalnameRequired("RichterMagnitude"),
  // Kilo Gram Force per Square Centimetre
  KiloGM_F__PER__CentiM2: Qudt.unitFromLocalnameRequired(
    "KiloGM_F-PER-CentiM2"
  ),
  // Watt Second per Square Metre
  W__SEC__PER__M2: Qudt.unitFromLocalnameRequired("W-SEC-PER-M2"),
  // Number per Milligram
  NUM__PER__MilliGM: Qudt.unitFromLocalnameRequired("NUM-PER-MilliGM"),
  // Percent per Meter
  PERCENT__PER__M: Qudt.unitFromLocalnameRequired("PERCENT-PER-M"),
  // Croatian Kuna
  CCY_HRK: Qudt.unitFromLocalnameRequired("CCY_HRK"),
  // Microhenry per Meter
  MicroH__PER__M: Qudt.unitFromLocalnameRequired("MicroH-PER-M"),
  // Millibar Liter per Second
  MilliBAR__L__PER__SEC: Qudt.unitFromLocalnameRequired("MilliBAR-L-PER-SEC"),
  // Reciprocal Meter Steradian
  PER__M__SR: Qudt.unitFromLocalnameRequired("PER-M-SR"),
  // Micrometer per Minute
  MicroM__PER__MIN: Qudt.unitFromLocalnameRequired("MicroM-PER-MIN"),
  // Gram per Second Bar
  GM__PER__SEC__BAR: Qudt.unitFromLocalnameRequired("GM-PER-SEC-BAR"),
  // Percent Minute per Liter
  PERCENT__MIN__PER__L: Qudt.unitFromLocalnameRequired("PERCENT-MIN-PER-L"),
  // Ton, Register
  TON_Register: Qudt.unitFromLocalnameRequired("TON_Register"),
  // Conventional Millimeter of Water
  MilliM_H2O: Qudt.unitFromLocalnameRequired("MilliM_H2O"),
  // Enzyme Unit
  ENZ: Qudt.unitFromLocalnameRequired("ENZ"),
  // Canadian Dollar
  CCY_CAD_Currency: Qudt.unitFromLocalnameRequired("CCY_CAD"),
  // Kelvin per Tesla
  K__PER__T: Qudt.unitFromLocalnameRequired("K-PER-T"),
  // Litre per Second Kelvin
  L__PER__SEC__K: Qudt.unitFromLocalnameRequired("L-PER-SEC-K"),
  // Number per Millilitre
  NUM__PER__MilliL: Qudt.unitFromLocalnameRequired("NUM-PER-MilliL"),
  // Gram per Decilitre
  GM__PER__DeciL: Qudt.unitFromLocalnameRequired("GM-PER-DeciL"),
  // Microliter
  MicroL: Qudt.unitFromLocalnameRequired("MicroL"),
  // Gray per Second
  GRAY__PER__SEC: Qudt.unitFromLocalnameRequired("GRAY-PER-SEC"),
  // Month
  MO: Qudt.unitFromLocalnameRequired("MO"),
  // Watt per Square Metre Metre Steradian
  W__PER__M2__M__SR: Qudt.unitFromLocalnameRequired("W-PER-M2-M-SR"),
  // British Thermal Unit (thermochemical Definition) per Cubic Foot
  BTU_TH__PER__FT3: Qudt.unitFromLocalnameRequired("BTU_TH-PER-FT3"),
  // Lumen per Square Foot
  LM__PER__FT2: Qudt.unitFromLocalnameRequired("LM-PER-FT2"),
  // Pound Mass Second per Sextic Foot
  LB__SEC__PER__FT6: Qudt.unitFromLocalnameRequired("LB-SEC-PER-FT6"),
  // Newton Metre per Arcminute
  N__M__PER__ARCMIN: Qudt.unitFromLocalnameRequired("N-M-PER-ARCMIN"),
  // Meter per Square Meter
  M__PER__M2: Qudt.unitFromLocalnameRequired("M-PER-M2"),
  // Quartic Millimetre
  MilliM4: Qudt.unitFromLocalnameRequired("MilliM4"),
  // Ounce Mass per Cubic Yard
  OZ__PER__YD3: Qudt.unitFromLocalnameRequired("OZ-PER-YD3"),
  // Millilitre per Minute Bar
  MilliL__PER__MIN__BAR: Qudt.unitFromLocalnameRequired("MilliL-PER-MIN-BAR"),
  // Foot Pound Force Second
  FT__LB_F__SEC: Qudt.unitFromLocalnameRequired("FT-LB_F-SEC"),
  // Gs
  Gs: Qudt.unitFromLocalnameRequired("Gs"),
  // Ounce Mass Hour per Cubic Inch Cubic Foot
  OZ__HR__PER__IN3__FT3: Qudt.unitFromLocalnameRequired("OZ-HR-PER-IN3-FT3"),
  // Millisievert per Minute
  MilliSV__PER__MIN: Qudt.unitFromLocalnameRequired("MilliSV-PER-MIN"),
  // Milligram per Cubic Meter Millipascal Second
  MilliGM__PER__M3__MilliPA__SEC: Qudt.unitFromLocalnameRequired(
    "MilliGM-PER-M3-MilliPA-SEC"
  ),
  // Pound Mole per Minute
  MOL_LB__PER__MIN: Qudt.unitFromLocalnameRequired("MOL_LB-PER-MIN"),
  // Volt Meter
  V__M: Qudt.unitFromLocalnameRequired("V-M"),
  // Pound Mass Hour per Cubic Foot Cubic Yard
  LB__HR__PER__FT3__YD3: Qudt.unitFromLocalnameRequired("LB-HR-PER-FT3-YD3"),
  // Kilomole per Minute
  KiloMOL__PER__MIN: Qudt.unitFromLocalnameRequired("KiloMOL-PER-MIN"),
  // Radian Square Metre per Mole
  RAD__M2__PER__MOL: Qudt.unitFromLocalnameRequired("RAD-M2-PER-MOL"),
  // Som
  CCY_KGS_Currency: Qudt.unitFromLocalnameRequired("CCY_KGS"),
  // Pascal
  PA: Qudt.unitFromLocalnameRequired("PA"),
  // Radian per Metre
  RAD__PER__M: Qudt.unitFromLocalnameRequired("RAD-PER-M"),
  // Nanoampere per Kelvin
  NanoA__PER__K: Qudt.unitFromLocalnameRequired("NanoA-PER-K"),
  // Inch per Psi
  IN__PER__PSI: Qudt.unitFromLocalnameRequired("IN-PER-PSI"),
  // Us Dry Pint
  PINT_US_DRY: Qudt.unitFromLocalnameRequired("PINT_US_DRY"),
  // Millisievert per Second
  MilliSV__PER__SEC: Qudt.unitFromLocalnameRequired("MilliSV-PER-SEC"),
  // Centigray
  CentiGRAY: Qudt.unitFromLocalnameRequired("CentiGRAY"),
  // Milligray
  MilliGRAY: Qudt.unitFromLocalnameRequired("MilliGRAY"),
  // Milliohm Metre
  MilliOHM__M: Qudt.unitFromLocalnameRequired("MilliOHM-M"),
  // Bushel (US)
  BU_US: Qudt.unitFromLocalnameRequired("BU_US"),
  // Stokes per Kelvin
  ST__PER__K: Qudt.unitFromLocalnameRequired("ST-PER-K"),
  // Pakistan Rupee
  CCY_PKR_Currency: Qudt.unitFromLocalnameRequired("CCY_PKR"),
  // Dyne Second per Centimetre
  DYN__SEC__PER__CentiM: Qudt.unitFromLocalnameRequired("DYN-SEC-PER-CentiM"),
  // Megasiemens per Metre
  MegaS__PER__M: Qudt.unitFromLocalnameRequired("MegaS-PER-M"),
  // Yard per Square Second
  YD__PER__SEC2: Qudt.unitFromLocalnameRequired("YD-PER-SEC2"),
  // Joule per Kilogram Degree Celsius
  J__PER__KiloGM__DEG_C: Qudt.unitFromLocalnameRequired("J-PER-KiloGM-DEG_C"),
  // South African Rand
  CCY_ZAR: Qudt.unitFromLocalnameRequired("CCY_ZAR"),
  // MegaDOLLAR_US
  MegaDOLLAR_US: Qudt.unitFromLocalnameRequired("MegaDOLLAR_US"),
  // Petajoule
  PetaJ: Qudt.unitFromLocalnameRequired("PetaJ"),
  // Degree Balling
  DEGREE_BALLING: Qudt.unitFromLocalnameRequired("DEGREE_BALLING"),
  // Thermochemical Calorie per Square Centimetre Second
  CAL_TH__PER__CentiM2__SEC: Qudt.unitFromLocalnameRequired(
    "CAL_TH-PER-CentiM2-SEC"
  ),
  // Iranian Rial
  CCY_IRR: Qudt.unitFromLocalnameRequired("CCY_IRR"),
  // Exbibit per Square Meter
  ExbiBIT__PER__M2: Qudt.unitFromLocalnameRequired("ExbiBIT-PER-M2"),
  // Meter per Bar
  M__PER__BAR: Qudt.unitFromLocalnameRequired("M-PER-BAR"),
  // Tesla Metre
  T__M: Qudt.unitFromLocalnameRequired("T-M"),
  // Barrel (UK Petroleum) per Minute
  BBL_UK_PET__PER__MIN: Qudt.unitFromLocalnameRequired("BBL_UK_PET-PER-MIN"),
  // Mole per Hour
  MOL__PER__HR: Qudt.unitFromLocalnameRequired("MOL-PER-HR"),
  // Milliampere Hour per Gram
  MilliA__HR__PER__GM: Qudt.unitFromLocalnameRequired("MilliA-HR-PER-GM"),
  // British Thermal Unit (international Definition) per Square Foot Second
  BTU_IT__PER__FT2__SEC: Qudt.unitFromLocalnameRequired("BTU_IT-PER-FT2-SEC"),
  // Newton per Coulomb
  N__PER__C: Qudt.unitFromLocalnameRequired("N-PER-C"),
  // Pascal Liter per Second
  PA__L__PER__SEC: Qudt.unitFromLocalnameRequired("PA-L-PER-SEC"),
  // Pound Mole per Second
  MOL_LB__PER__SEC: Qudt.unitFromLocalnameRequired("MOL_LB-PER-SEC"),
  // Decibel
  DeciB: Qudt.unitFromLocalnameRequired("DeciB"),
  // Palladium (one Troy Ounce)
  CCY_XPD: Qudt.unitFromLocalnameRequired("CCY_XPD"),
  // Gray per Minute
  GRAY__PER__MIN: Qudt.unitFromLocalnameRequired("GRAY-PER-MIN"),
  // Decibel Isotropic
  DeciB_ISO: Qudt.unitFromLocalnameRequired("DeciB_ISO"),
  // Square Foot Second Degree Fahrenheit
  FT2__SEC__DEG_F: Qudt.unitFromLocalnameRequired("FT2-SEC-DEG_F"),
  // Gon
  GON: Qudt.unitFromLocalnameRequired("GON"),
  // Slovak Koruna
  CCY_SKK: Qudt.unitFromLocalnameRequired("CCY_SKK"),
  // P
  P: Qudt.unitFromLocalnameRequired("P"),
  // Clo
  CLO: Qudt.unitFromLocalnameRequired("CLO"),
  // Long Hundred Weight
  CWT_LONG: Qudt.unitFromLocalnameRequired("CWT_LONG"),
  // Relative Permittivity
  PERMITTIVITY_REL: Qudt.unitFromLocalnameRequired("PERMITTIVITY_REL"),
  // Gigajoule per Second
  GigaJ__PER__SEC: Qudt.unitFromLocalnameRequired("GigaJ-PER-SEC"),
  // Horsepower
  HP: Qudt.unitFromLocalnameRequired("HP"),
  // Zloty
  CCY_PLN: Qudt.unitFromLocalnameRequired("CCY_PLN"),
  // Kelvin Metre per Second
  K__M__PER__SEC: Qudt.unitFromLocalnameRequired("K-M-PER-SEC"),
  // Quetzal
  CCY_GTQ: Qudt.unitFromLocalnameRequired("CCY_GTQ"),
  // Meter per Day
  M__PER__DAY: Qudt.unitFromLocalnameRequired("M-PER-DAY"),
  // Microwatt
  MicroW: Qudt.unitFromLocalnameRequired("MicroW"),
  // Tonne per Bar
  TONNE__PER__BAR: Qudt.unitFromLocalnameRequired("TONNE-PER-BAR"),
  // Falkland Islands Pound
  CCY_FKP: Qudt.unitFromLocalnameRequired("CCY_FKP"),
  // Decapoise
  DecaPOISE: Qudt.unitFromLocalnameRequired("DecaPOISE"),
  // Reciprocal Degree Fahrenheit
  PER__DEG_F: Qudt.unitFromLocalnameRequired("PER-DEG_F"),
  // South Korean Won
  CCY_KRW: Qudt.unitFromLocalnameRequired("CCY_KRW"),
  // Pound Mass Second per Gallon (UK) Cubic Foot
  LB__SEC__PER__GAL_UK__FT3: Qudt.unitFromLocalnameRequired(
    "LB-SEC-PER-GAL_UK-FT3"
  ),
  // Milligram per Gram Hour
  MilliGM__PER__GM__HR: Qudt.unitFromLocalnameRequired("MilliGM-PER-GM-HR"),
  // Belize Dollar
  CCY_BZD: Qudt.unitFromLocalnameRequired("CCY_BZD"),
  // Stokes per Bar
  ST__PER__BAR: Qudt.unitFromLocalnameRequired("ST-PER-BAR"),
  // Cubic Foot
  FT3: Qudt.unitFromLocalnameRequired("FT3"),
  // Revolution per Minute
  REV__PER__MIN: Qudt.unitFromLocalnameRequired("REV-PER-MIN"),
  // Millijoule per Second
  MilliJ__PER__SEC: Qudt.unitFromLocalnameRequired("MilliJ-PER-SEC"),
  // Kilonewton per Square Metre
  KiloN__PER__M2: Qudt.unitFromLocalnameRequired("KiloN-PER-M2"),
  // MicroVolt Ampere Reactive
  MicroV__A_Reactive: Qudt.unitFromLocalnameRequired("MicroV-A_Reactive"),
  // Millikatal per Liter
  MilliKAT__PER__L: Qudt.unitFromLocalnameRequired("MilliKAT-PER-L"),
  // Short Ton
  TON_SHORT: Qudt.unitFromLocalnameRequired("TON_SHORT"),
  // Terahertz
  TeraHZ: Qudt.unitFromLocalnameRequired("TeraHZ"),
  // Percent per Kelvin
  PERCENT__PER__K: Qudt.unitFromLocalnameRequired("PERCENT-PER-K"),
  // Micromho
  MicroMHO: Qudt.unitFromLocalnameRequired("MicroMHO"),
  // Somali Shilling
  CCY_SOS: Qudt.unitFromLocalnameRequired("CCY_SOS"),
  // Pula
  CCY_BWP_Currency: Qudt.unitFromLocalnameRequired("CCY_BWP"),
  // Pound Mass per Hour Psi
  LB__PER__HR__PSI: Qudt.unitFromLocalnameRequired("LB-PER-HR-PSI"),
  // Pound Mass per Second
  LB__PER__SEC: Qudt.unitFromLocalnameRequired("LB-PER-SEC"),
  // Pica
  PCA: Qudt.unitFromLocalnameRequired("PCA"),
  // Inch per Year
  IN__PER__YR: Qudt.unitFromLocalnameRequired("IN-PER-YR"),
  // Kilo Pound Force per Foot
  KiloLB_F__PER__FT: Qudt.unitFromLocalnameRequired("KiloLB_F-PER-FT"),
  // Decisiemens per Metre
  DeciS__PER__M: Qudt.unitFromLocalnameRequired("DeciS-PER-M"),
  // Metric Ton per Minute Bar
  TON_Metric__PER__MIN__BAR: Qudt.unitFromLocalnameRequired(
    "TON_Metric-PER-MIN-BAR"
  ),
  // Microfarad per Kilometre
  MicroFARAD__PER__KiloM: Qudt.unitFromLocalnameRequired(
    "MicroFARAD-PER-KiloM"
  ),
  // Microohm Metre
  MicroOHM__M: Qudt.unitFromLocalnameRequired("MicroOHM-M"),
  // Kilogram per Pascal
  KiloGM__PER__PA: Qudt.unitFromLocalnameRequired("KiloGM-PER-PA"),
  // Decakelvin
  DecaK: Qudt.unitFromLocalnameRequired("DecaK"),
  // Millihenry per Ohm
  MilliH__PER__OHM: Qudt.unitFromLocalnameRequired("MilliH-PER-OHM"),
  // Ounce Mass Foot Second per Cubic Inch Pound Mass
  OZ__FT__SEC__PER__IN3__LB: Qudt.unitFromLocalnameRequired(
    "OZ-FT-SEC-PER-IN3-LB"
  ),
  // Percent per Hundred
  PERCENT__PER__HectoCOUNT: Qudt.unitFromLocalnameRequired(
    "PERCENT-PER-HectoCOUNT"
  ),
  // Darcy
  DARCY: Qudt.unitFromLocalnameRequired("DARCY"),
  // British Thermal Unit (international Definition) Inch
  BTU_IT__IN: Qudt.unitFromLocalnameRequired("BTU_IT-IN"),
  // Kilocalorie per Square Centimetre Minute
  KiloCAL__PER__CentiM2__MIN: Qudt.unitFromLocalnameRequired(
    "KiloCAL-PER-CentiM2-MIN"
  ),
  // Bit
  BIT: Qudt.unitFromLocalnameRequired("BIT"),
  // Thermochemical Calorie per Cubic Centimeter Kelvin
  CAL_TH__PER__CentiM3__K: Qudt.unitFromLocalnameRequired(
    "CAL_TH-PER-CentiM3-K"
  ),
  // Millibar Cubic Meter per Second
  MilliBAR__M3__PER__SEC: Qudt.unitFromLocalnameRequired("MilliBAR-M3-PER-SEC"),
  // Number per Kilogram
  NUM__PER__KiloGM: Qudt.unitFromLocalnameRequired("NUM-PER-KiloGM"),
  // Foot
  FT: Qudt.unitFromLocalnameRequired("FT"),
  // Hong Kong Dollar
  CCY_HKD: Qudt.unitFromLocalnameRequired("CCY_HKD"),
  // Floating Point Operations per Second
  FLOPS: Qudt.unitFromLocalnameRequired("FLOPS"),
  // Reciprocal Steradian
  PER__SR: Qudt.unitFromLocalnameRequired("PER-SR"),
  // Nanogram per Square Centimeter
  NanoGM__PER__CentiM2: Qudt.unitFromLocalnameRequired("NanoGM-PER-CentiM2"),
  // Erg Square Centimeter
  ERG__CentiM2: Qudt.unitFromLocalnameRequired("ERG-CentiM2"),
  // SAMPLE
  SAMPLE: Qudt.unitFromLocalnameRequired("SAMPLE"),
  // Number per Hectogram
  NUM__PER__HectoGM: Qudt.unitFromLocalnameRequired("NUM-PER-HectoGM"),
  // Picosecond
  PicoSEC: Qudt.unitFromLocalnameRequired("PicoSEC"),
  // Pound Mass Minute per Gallon (UK) Cubic Inch
  LB__MIN__PER__GAL_UK__IN3: Qudt.unitFromLocalnameRequired(
    "LB-MIN-PER-GAL_UK-IN3"
  ),
  // British Thermal Unit (international Definition) per Hour Square Foot
  BTU_IT__PER__HR__FT2: Qudt.unitFromLocalnameRequired("BTU_IT-PER-HR-FT2"),
  // Bushel (UK) per Second
  BU_UK__PER__SEC: Qudt.unitFromLocalnameRequired("BU_UK-PER-SEC"),
  // Fluid Ounce (UK) per Second
  OZ_VOL_UK__PER__SEC: Qudt.unitFromLocalnameRequired("OZ_VOL_UK-PER-SEC"),
  // Metre per Second
  M__PER__SEC: Qudt.unitFromLocalnameRequired("M-PER-SEC"),
  // Gram per Minute Kelvin
  GM__PER__MIN__K: Qudt.unitFromLocalnameRequired("GM-PER-MIN-K"),
  // Reciprocal Tesla Second
  PER__T__SEC: Qudt.unitFromLocalnameRequired("PER-T-SEC"),
  // Gram Second per Cubic Metre Cubic Centimetre
  GM__SEC__PER__M3__CentiM3: Qudt.unitFromLocalnameRequired(
    "GM-SEC-PER-M3-CentiM3"
  ),
  // Gram Hour per Square Litre
  GM__HR__PER__L2: Qudt.unitFromLocalnameRequired("GM-HR-PER-L2"),
  // Kilojoule per Kelvin
  KiloJ__PER__K: Qudt.unitFromLocalnameRequired("KiloJ-PER-K"),
  // Litre
  L: Qudt.unitFromLocalnameRequired("L"),
  // Rufiyaa
  CCY_MVR_Currency: Qudt.unitFromLocalnameRequired("CCY_MVR"),
  // Cubic Centimetre per Cubic Centimetre
  CentiM3__PER__CentiM3: Qudt.unitFromLocalnameRequired("CentiM3-PER-CentiM3"),
  // Reciprocal Inch
  PER__IN: Qudt.unitFromLocalnameRequired("PER-IN"),
  // Erg per Gram Second
  ERG__PER__GM__SEC: Qudt.unitFromLocalnameRequired("ERG-PER-GM-SEC"),
  // Pataca
  CCY_MOP_Currency: Qudt.unitFromLocalnameRequired("CCY_MOP"),
  // Azerbaijanian Manat
  CCY_AZN: Qudt.unitFromLocalnameRequired("CCY_AZN"),
  // Square Meter Kelvin
  M2__K: Qudt.unitFromLocalnameRequired("M2-K"),
  // Reciprocal Cubic Yard
  PER__YD3: Qudt.unitFromLocalnameRequired("PER-YD3"),
  // Micrometre per Square Second
  MicroM__PER__SEC2: Qudt.unitFromLocalnameRequired("MicroM-PER-SEC2"),
  // Reciprocal Joule
  PER__J: Qudt.unitFromLocalnameRequired("PER-J"),
  // Cases per 1000 Individuals Year
  CASES__PER__KiloINDIV__YR: Qudt.unitFromLocalnameRequired(
    "CASES-PER-KiloINDIV-YR"
  ),
  // Stokes
  ST: Qudt.unitFromLocalnameRequired("ST"),
  // Kwanza
  CCY_AOA: Qudt.unitFromLocalnameRequired("CCY_AOA"),
  // Decaare
  DecaARE: Qudt.unitFromLocalnameRequired("DecaARE"),
  // Nanogram per Liter
  NanoGM__PER__L: Qudt.unitFromLocalnameRequired("NanoGM-PER-L"),
  // Oersted Centimetre
  OERSTED__CentiM: Qudt.unitFromLocalnameRequired("OERSTED-CentiM"),
  // Year
  YR: Qudt.unitFromLocalnameRequired("YR"),
  // Enzyme Unit per Liter
  ENZ__PER__L: Qudt.unitFromLocalnameRequired("ENZ-PER-L"),
  // Kilocoulomb
  KiloC: Qudt.unitFromLocalnameRequired("KiloC"),
  // Farad per Meter
  FARAD__PER__M: Qudt.unitFromLocalnameRequired("FARAD-PER-M"),
  // Somali Shilling
  CCY_SOS_Currency: Qudt.unitFromLocalnameRequired("CCY_SOS"),
  // Cubic Centimetre per Hour
  CentiM3__PER__HR: Qudt.unitFromLocalnameRequired("CentiM3-PER-HR"),
  // Gram per Square Metre Hour
  GM__PER__M2__HR: Qudt.unitFromLocalnameRequired("GM-PER-M2-HR"),
  // Horsepower (water)
  HP_H2O: Qudt.unitFromLocalnameRequired("HP_H2O"),
  // MILLE
  MILLE: Qudt.unitFromLocalnameRequired("MILLE"),
  // Coulomb Square Meter
  C__M2: Qudt.unitFromLocalnameRequired("C-M2"),
  // Gram per Kilogram
  GM__PER__KiloGM: Qudt.unitFromLocalnameRequired("GM-PER-KiloGM"),
  // Kilonewton per Square Centimeter
  KiloN__PER__CentiM2: Qudt.unitFromLocalnameRequired("KiloN-PER-CentiM2"),
  // Ampere per Square Millimeter
  A__PER__MilliM2: Qudt.unitFromLocalnameRequired("A-PER-MilliM2"),
  // Degree per Minute
  DEG__PER__MIN: Qudt.unitFromLocalnameRequired("DEG-PER-MIN"),
  // Teraampere
  TeraA: Qudt.unitFromLocalnameRequired("TeraA"),
  // Milli Volt Ampere Reactive per Kelvin
  MilliVAR__PER__K: Qudt.unitFromLocalnameRequired("MilliVAR-PER-K"),
  // BEAT
  BEAT: Qudt.unitFromLocalnameRequired("BEAT"),
  // Special Drawing Rights
  CCY_XDR_Currency: Qudt.unitFromLocalnameRequired("CCY_XDR"),
  // Liter per Minute Kelvin
  L__PER__MIN__K: Qudt.unitFromLocalnameRequired("L-PER-MIN-K"),
  // One
  ONE: Qudt.unitFromLocalnameRequired("ONE"),
  // Kilogray
  KiloGRAY: Qudt.unitFromLocalnameRequired("KiloGRAY"),
  // Barrel (us Petroleum) per Hour
  BBL_US_PET__PER__HR: Qudt.unitFromLocalnameRequired("BBL_US_PET-PER-HR"),
  // Circular Mil
  MIL_Circ: Qudt.unitFromLocalnameRequired("MIL_Circ"),
  // Newton Seconds per Radian
  N__SEC__PER__RAD: Qudt.unitFromLocalnameRequired("N-SEC-PER-RAD"),
  // Decaliter
  DecaL: Qudt.unitFromLocalnameRequired("DecaL"),
  // Nanomole per Liter Hour
  NanoMOL__PER__L__HR: Qudt.unitFromLocalnameRequired("NanoMOL-PER-L-HR"),
  // Percent per Bar
  PERCENT__PER__BAR: Qudt.unitFromLocalnameRequired("PERCENT-PER-BAR"),
  // Kilogram Square Meter
  KiloGM__M2: Qudt.unitFromLocalnameRequired("KiloGM-M2"),
  // Attoampere
  AttoA: Qudt.unitFromLocalnameRequired("AttoA"),
  // Micro Volt Ampere Reactive
  MicroVAR: Qudt.unitFromLocalnameRequired("MicroVAR"),
  // Meganewton per Square Meter
  MegaN__PER__M2: Qudt.unitFromLocalnameRequired("MegaN-PER-M2"),
  // Cubic Centimeter
  CentiM3: Qudt.unitFromLocalnameRequired("CentiM3"),
  // Kelvin per Hour
  K__PER__HR: Qudt.unitFromLocalnameRequired("K-PER-HR"),
  // Joule per Tesla
  J__PER__T: Qudt.unitFromLocalnameRequired("J-PER-T"),
  // Katal per Liter
  KAT__PER__L: Qudt.unitFromLocalnameRequired("KAT-PER-L"),
  // Newton per Cubic Metre
  N__PER__M3: Qudt.unitFromLocalnameRequired("N-PER-M3"),
  // Are
  ARE: Qudt.unitFromLocalnameRequired("ARE"),
  // Nanokatal per Liter
  NanoKAT__PER__L: Qudt.unitFromLocalnameRequired("NanoKAT-PER-L"),
  // Ounce Mass Foot Hour per Cubic Inch Pound Mass
  OZ__FT__HR__PER__IN3__LB: Qudt.unitFromLocalnameRequired(
    "OZ-FT-HR-PER-IN3-LB"
  ),
  // British Thermal Unit (international Definition) per Pound Mass Degree Rankine
  BTU_IT__PER__LB__DEG_R: Qudt.unitFromLocalnameRequired("BTU_IT-PER-LB-DEG_R"),
  // Parts per Million
  PPM: Qudt.unitFromLocalnameRequired("PPM"),
  // Volt per Volt
  V__PER__V: Qudt.unitFromLocalnameRequired("V-PER-V"),
  // Wir Euro (complementary Currency)
  CCY_CHE_Currency: Qudt.unitFromLocalnameRequired("CCY_CHE"),
  // Metric Ton per Cubic Metre Kelvin
  TON_Metric__PER__M3__K: Qudt.unitFromLocalnameRequired("TON_Metric-PER-M3-K"),
  // Shannon per Second
  SHANNON__PER__SEC: Qudt.unitFromLocalnameRequired("SHANNON-PER-SEC"),
  // Cubic Inch per Pound Mass
  IN3__PER__LB: Qudt.unitFromLocalnameRequired("IN3-PER-LB"),
  // Bolivian Mvdol (funds Code)
  CCY_BOV_Currency: Qudt.unitFromLocalnameRequired("CCY_BOV"),
  // European Unit of Account 9 (e.u.a.-9) (bonds Market Unit)
  CCY_XBC: Qudt.unitFromLocalnameRequired("CCY_XBC"),
  // Foot Second per Us Gallon
  FT__SEC__PER__GAL_US: Qudt.unitFromLocalnameRequired("FT-SEC-PER-GAL_US"),
  // Slug per Hour
  SLUG__PER__HR: Qudt.unitFromLocalnameRequired("SLUG-PER-HR"),
  // Metical
  CCY_MZN: Qudt.unitFromLocalnameRequired("CCY_MZN"),
  // Reciprocal Percent
  PER__PERCENT: Qudt.unitFromLocalnameRequired("PER-PERCENT"),
  // Slug per Foot Second
  SLUG__PER__FT__SEC: Qudt.unitFromLocalnameRequired("SLUG-PER-FT-SEC"),
  // Slug per Second
  SLUG__PER__SEC: Qudt.unitFromLocalnameRequired("SLUG-PER-SEC"),
  // Milligram per Hectare
  MilliGM__PER__HA: Qudt.unitFromLocalnameRequired("MilliGM-PER-HA"),
  // Pound Mass per Yard
  LB__PER__YD: Qudt.unitFromLocalnameRequired("LB-PER-YD"),
  // Watt per Square Metre Pascal
  W__PER__M2__PA: Qudt.unitFromLocalnameRequired("W-PER-M2-PA"),
  // Milligram per Square Centimeter
  MilliGM__PER__CentiM2: Qudt.unitFromLocalnameRequired("MilliGM-PER-CentiM2"),
  // Gigavolt Ampere
  GigaV__A: Qudt.unitFromLocalnameRequired("GigaV-A"),
  // Mega Pound Force
  MegaLB_F: Qudt.unitFromLocalnameRequired("MegaLB_F"),
  // Ampere per Radian
  A__PER__RAD: Qudt.unitFromLocalnameRequired("A-PER-RAD"),
  // Kilovolt Ampere Hour
  KiloV__A__HR: Qudt.unitFromLocalnameRequired("KiloV-A-HR"),
  // Cubic Micrometer per Cubic Meter
  MicroM3__PER__M3: Qudt.unitFromLocalnameRequired("MicroM3-PER-M3"),
  // Joule Square Meter
  J__M2: Qudt.unitFromLocalnameRequired("J-M2"),
  // Square Foot per British Thermal Unit (international Definition) Inch
  FT2__PER__BTU_IT__IN: Qudt.unitFromLocalnameRequired("FT2-PER-BTU_IT-IN"),
  // Rod
  ROD: Qudt.unitFromLocalnameRequired("ROD"),
  // Moldovan Leu
  CCY_MDL_Currency: Qudt.unitFromLocalnameRequired("CCY_MDL"),
  // Kilogram per Liter
  KiloGM__PER__L: Qudt.unitFromLocalnameRequired("KiloGM-PER-L"),
  // Dalasi
  CCY_GMD: Qudt.unitFromLocalnameRequired("CCY_GMD"),
  // Milligram Hour per Cubic Meter Cubic Centimeter
  MilliGM__HR__PER__M3__CentiM3: Qudt.unitFromLocalnameRequired(
    "MilliGM-HR-PER-M3-CentiM3"
  ),
  // Millimole per Mole
  MilliMOL__PER__MOL: Qudt.unitFromLocalnameRequired("MilliMOL-PER-MOL"),
  // Milligram per Second Bar
  MilliGM__PER__SEC__BAR: Qudt.unitFromLocalnameRequired("MilliGM-PER-SEC-BAR"),
  // Hartree
  E_h: Qudt.unitFromLocalnameRequired("E_h"),
  // Pound Mass per Foot Pound Force Second
  LB__PER__FT__LB_F__SEC: Qudt.unitFromLocalnameRequired("LB-PER-FT-LB_F-SEC"),
  // Volt Ampere Reactive per Kelvin
  VAR__PER__K: Qudt.unitFromLocalnameRequired("VAR-PER-K"),
  // Meter per Hectare
  M__PER__HA: Qudt.unitFromLocalnameRequired("M-PER-HA"),
  // Millilitre per Day Bar
  MilliL__PER__DAY__BAR: Qudt.unitFromLocalnameRequired("MilliL-PER-DAY-BAR"),
  // Thermochemical Calorie per Square Centimetre Minute
  CAL_TH__PER__CentiM2__MIN: Qudt.unitFromLocalnameRequired(
    "CAL_TH-PER-CentiM2-MIN"
  ),
  // Ounce Mass
  OZ: Qudt.unitFromLocalnameRequired("OZ"),
  // Mongolian Tugrik
  CCY_MNT_Currency: Qudt.unitFromLocalnameRequired("CCY_MNT"),
  // Uic Franc (special Settlement Currency)
  CCY_XFU: Qudt.unitFromLocalnameRequired("CCY_XFU"),
  // Reciprocal Cubic Meter Second
  PER__M3__SEC: Qudt.unitFromLocalnameRequired("PER-M3-SEC"),
  // Bolivian Mvdol (funds Code)
  CCY_BOV: Qudt.unitFromLocalnameRequired("CCY_BOV"),
  // Kelvin Pascal per Second
  K__PA__PER__SEC: Qudt.unitFromLocalnameRequired("K-PA-PER-SEC"),
  // Reciprocal Micromole Liter
  PER__MicroMOL__L: Qudt.unitFromLocalnameRequired("PER-MicroMOL-L"),
  // Short Ton per Psi
  TON_SHORT__PER__PSI: Qudt.unitFromLocalnameRequired("TON_SHORT-PER-PSI"),
  // Pound Mass per Minute
  LB__PER__MIN: Qudt.unitFromLocalnameRequired("LB-PER-MIN"),
  // Cubic Foot per Minute Square Foot
  FT3__PER__MIN__FT2: Qudt.unitFromLocalnameRequired("FT3-PER-MIN-FT2"),
  // Hundredweight (UK)
  Hundredweight_UK: Qudt.unitFromLocalnameRequired("Hundredweight_UK"),
  // Pound Mass per Square Yard
  LB__PER__YD2: Qudt.unitFromLocalnameRequired("LB-PER-YD2"),
  // Pound Mass Minute per Sextic Inch
  LB__MIN__PER__IN6: Qudt.unitFromLocalnameRequired("LB-MIN-PER-IN6"),
  // European Unit of Account 17 (e.u.a.-17) (bonds Market Unit)
  CCY_XBD: Qudt.unitFromLocalnameRequired("CCY_XBD"),
  // Kilogram per Metre Minute
  KiloGM__PER__M__MIN: Qudt.unitFromLocalnameRequired("KiloGM-PER-M-MIN"),
  // Reciprocal Meter Kelvin
  PER__M__K: Qudt.unitFromLocalnameRequired("PER-M-K"),
  // Micro Joule
  MicroJ: Qudt.unitFromLocalnameRequired("MicroJ"),
  // New Zealand Dollar
  CCY_NZD_Currency: Qudt.unitFromLocalnameRequired("CCY_NZD"),
  // Fiji Dollar
  CCY_FJD_Currency: Qudt.unitFromLocalnameRequired("CCY_FJD"),
  // Millihenry per Kiloohm
  MilliH__PER__KiloOHM: Qudt.unitFromLocalnameRequired("MilliH-PER-KiloOHM"),
  // Coulomb per Cubic Millimeter
  C__PER__MilliM3: Qudt.unitFromLocalnameRequired("C-PER-MilliM3"),
  // Millicoulomb per Kilogram
  MilliC__PER__KiloGM: Qudt.unitFromLocalnameRequired("MilliC-PER-KiloGM"),
  // Second per Kilogram
  SEC__PER__KiloGM: Qudt.unitFromLocalnameRequired("SEC-PER-KiloGM"),
  // Teracoulomb
  TeraC: Qudt.unitFromLocalnameRequired("TeraC"),
  // Watt per Meter Degree Celsius
  W__PER__M__DEG_C: Qudt.unitFromLocalnameRequired("W-PER-M-DEG_C"),
  // Ampere Hour per Square Meter
  A__HR__PER__M2: Qudt.unitFromLocalnameRequired("A-HR-PER-M2"),
  // Metric Ton per Second Bar
  TON_Metric__PER__SEC__BAR: Qudt.unitFromLocalnameRequired(
    "TON_Metric-PER-SEC-BAR"
  ),
  // Ohm per Kilometer
  OHM__PER__KiloM: Qudt.unitFromLocalnameRequired("OHM-PER-KiloM"),
  // Ampere Turn
  AT: Qudt.unitFromLocalnameRequired("AT"),
  // British Thermal Unit (international Definition) per Pound Mass Degree Fahrenheit
  BTU_IT__PER__LB__DEG_F: Qudt.unitFromLocalnameRequired("BTU_IT-PER-LB-DEG_F"),
  // Arcsecond
  ARCSEC: Qudt.unitFromLocalnameRequired("ARCSEC"),
  // Ounce Mass Minute per Cubic Inch Cubic Yard
  OZ__MIN__PER__IN3__YD3: Qudt.unitFromLocalnameRequired("OZ-MIN-PER-IN3-YD3"),
  // Quartic Metre per Second
  M4__PER__SEC: Qudt.unitFromLocalnameRequired("M4-PER-SEC"),
  // Ton (UK) per Cubic Yard
  TON_UK__PER__YD3: Qudt.unitFromLocalnameRequired("TON_UK-PER-YD3"),
  // Newton per Square Centimeter
  N__PER__CentiM2: Qudt.unitFromLocalnameRequired("N-PER-CentiM2"),
  // Kuwaiti Dinar
  CCY_KWD_Currency: Qudt.unitFromLocalnameRequired("CCY_KWD"),
  // Gram Centimetre per Second
  GM__CentiM__PER__SEC: Qudt.unitFromLocalnameRequired("GM-CentiM-PER-SEC"),
  // Psi Cubic Metre per Second
  PSI__M3__PER__SEC: Qudt.unitFromLocalnameRequired("PSI-M3-PER-SEC"),
  // Milliampere per Bar
  MilliA__PER__BAR: Qudt.unitFromLocalnameRequired("MilliA-PER-BAR"),
  // Ohm
  OHM: Qudt.unitFromLocalnameRequired("OHM"),
  // Nanosiemens per Centimetre
  NanoS__PER__CentiM: Qudt.unitFromLocalnameRequired("NanoS-PER-CentiM"),
  // Bar per Degree Celsius
  BAR__PER__DEG_C: Qudt.unitFromLocalnameRequired("BAR-PER-DEG_C"),
  // Picovolt
  PicoV: Qudt.unitFromLocalnameRequired("PicoV"),
  // Square Centimeter per Erg
  CentiM2__PER__ERG: Qudt.unitFromLocalnameRequired("CentiM2-PER-ERG"),
  // Micropoise
  MicroPOISE: Qudt.unitFromLocalnameRequired("MicroPOISE"),
  // Pascal Meter
  PA__M: Qudt.unitFromLocalnameRequired("PA-M"),
  // Femtovolt
  FemtoV: Qudt.unitFromLocalnameRequired("FemtoV"),
  // United States Dollar (next Day) (funds Code)
  CCY_USN: Qudt.unitFromLocalnameRequired("CCY_USN"),
  // Newton per Square Metre
  N__PER__M2: Qudt.unitFromLocalnameRequired("N-PER-M2"),
  // Pound Force per Pound Mass
  LB_F__PER__LB: Qudt.unitFromLocalnameRequired("LB_F-PER-LB"),
  // Net Tonnage
  NT: Qudt.unitFromLocalnameRequired("NT"),
  // Milligram Minute per Liter Cubic Meter
  MilliGM__MIN__PER__L__M3: Qudt.unitFromLocalnameRequired(
    "MilliGM-MIN-PER-L-M3"
  ),
  // CHF
  CHF: Qudt.unitFromLocalnameRequired("CHF"),
  // Kilomole per Second
  KiloMOL__PER__SEC: Qudt.unitFromLocalnameRequired("KiloMOL-PER-SEC"),
  // Light Year
  LY: Qudt.unitFromLocalnameRequired("LY"),
  // Watt per Gram
  W__PER__GM: Qudt.unitFromLocalnameRequired("W-PER-GM"),
  // Thm_eec
  THM_EEC: Qudt.unitFromLocalnameRequired("THM_EEC"),
  // Kilopascal per Kelvin
  KiloPA__PER__K: Qudt.unitFromLocalnameRequired("KiloPA-PER-K"),
  // Bushel (UK) per Minute
  BU_UK__PER__MIN: Qudt.unitFromLocalnameRequired("BU_UK-PER-MIN"),
  // British Thermal Unit (international Definition) per Hour Square Foot Degree Rankine
  BTU_IT__PER__HR__FT2__DEG_R: Qudt.unitFromLocalnameRequired(
    "BTU_IT-PER-HR-FT2-DEG_R"
  ),
  // Poise per Kelvin
  POISE__PER__K: Qudt.unitFromLocalnameRequired("POISE-PER-K"),
  // Ban
  BAN: Qudt.unitFromLocalnameRequired("BAN"),
  // Zambian Kwacha
  CCY_ZMW: Qudt.unitFromLocalnameRequired("CCY_ZMW"),
  // British Thermal Unit (thermochemical Definition) per Minute
  BTU_TH__PER__MIN: Qudt.unitFromLocalnameRequired("BTU_TH-PER-MIN"),
  // Tanzanian Shilling
  CCY_TZS: Qudt.unitFromLocalnameRequired("CCY_TZS"),
  // Square Metre Hour Degree Celsius per Kilo International Table Calorie
  M2__HR__DEG_C__PER__KiloCAL_IT: Qudt.unitFromLocalnameRequired(
    "M2-HR-DEG_C-PER-KiloCAL_IT"
  ),
  // Foot Pound Force per Square Foot Second
  FT__LB_F__PER__FT2__SEC: Qudt.unitFromLocalnameRequired(
    "FT-LB_F-PER-FT2-SEC"
  ),
  // Syrian Pound
  CCY_SYP_Currency: Qudt.unitFromLocalnameRequired("CCY_SYP"),
  // British Thermal Unit (international Definition)
  BTU_IT: Qudt.unitFromLocalnameRequired("BTU_IT"),
  // Cubic Centimetre per Gram
  CentiM3__PER__GM: Qudt.unitFromLocalnameRequired("CentiM3-PER-GM"),
  // Nanolitre
  NanoL: Qudt.unitFromLocalnameRequired("NanoL"),
  // Teravolt Ampere
  TeraV__A: Qudt.unitFromLocalnameRequired("TeraV-A"),
  // Zloty per Kilowatt Hour
  CCY_PLN__PER__KiloW__HR: Qudt.unitFromLocalnameRequired(
    "CCY_PLN-PER-KiloW-HR"
  ),
  // Minute per International Mile
  MIN__PER__MI: Qudt.unitFromLocalnameRequired("MIN-PER-MI"),
  // Nano Volt Ampere
  NanoVA: Qudt.unitFromLocalnameRequired("NanoVA"),
  // Millinewton
  MilliN: Qudt.unitFromLocalnameRequired("MilliN"),
  // Dominican Peso
  CCY_DOP: Qudt.unitFromLocalnameRequired("CCY_DOP"),
  // Pound Mass Second per Cubic Inch Gallon (UK)
  LB__SEC__PER__IN3__GAL_UK: Qudt.unitFromLocalnameRequired(
    "LB-SEC-PER-IN3-GAL_UK"
  ),
  // Nanonewton Metre per Square Metre
  NanoN__M__PER__M2: Qudt.unitFromLocalnameRequired("NanoN-M-PER-M2"),
  // Degree Oechsle
  DEGREE_OECHSLE: Qudt.unitFromLocalnameRequired("DEGREE_OECHSLE"),
  // Square Metre per Square Metre
  M2__PER__M2: Qudt.unitFromLocalnameRequired("M2-PER-M2"),
  // Kilojoule per Kilovolt
  KiloJ__PER__KiloV: Qudt.unitFromLocalnameRequired("KiloJ-PER-KiloV"),
  // Cubic Metre per Kilogram
  M3__PER__KiloGM: Qudt.unitFromLocalnameRequired("M3-PER-KiloGM"),
  // Mole per Square Metre Day
  MOL__PER__M2__DAY: Qudt.unitFromLocalnameRequired("MOL-PER-M2-DAY"),
  // Microradian
  MicroRAD: Qudt.unitFromLocalnameRequired("MicroRAD"),
  // Liter per Day Bar
  L__PER__DAY__BAR: Qudt.unitFromLocalnameRequired("L-PER-DAY-BAR"),
  // Square Metre per Steradian
  M2__PER__SR: Qudt.unitFromLocalnameRequired("M2-PER-SR"),
  // Percent per Week
  PERCENT__PER__WK: Qudt.unitFromLocalnameRequired("PERCENT-PER-WK"),
  // Megajoule per Hour
  MegaJ__PER__HR: Qudt.unitFromLocalnameRequired("MegaJ-PER-HR"),
  // Uganda Shilling
  CCY_UGX_Currency: Qudt.unitFromLocalnameRequired("CCY_UGX"),
  // Pound Mass Minute per Cubic Foot Cubic Inch
  LB__MIN__PER__FT3__IN3: Qudt.unitFromLocalnameRequired("LB-MIN-PER-FT3-IN3"),
  // Megagram per Hectare Year
  MegaGM__PER__HA__YR: Qudt.unitFromLocalnameRequired("MegaGM-PER-HA-YR"),
  // Kilogram Meter per Square Second
  KiloGM__M__PER__SEC2: Qudt.unitFromLocalnameRequired("KiloGM-M-PER-SEC2"),
  // Ouguiya
  CCY_MRU_Currency: Qudt.unitFromLocalnameRequired("CCY_MRU"),
  // Psi per Inch
  PSI__PER__IN: Qudt.unitFromLocalnameRequired("PSI-PER-IN"),
  // Mega British Thermal Unit (international Definition) per Hour
  MegaBTU_IT__PER__HR: Qudt.unitFromLocalnameRequired("MegaBTU_IT-PER-HR"),
  // Ohm per Bar
  OHM__PER__BAR: Qudt.unitFromLocalnameRequired("OHM-PER-BAR"),
  // Abfarad
  FARAD_Ab: Qudt.unitFromLocalnameRequired("FARAD_Ab"),
  // Kyat
  CCY_MMK: Qudt.unitFromLocalnameRequired("CCY_MMK"),
  // Gray
  GRAY: Qudt.unitFromLocalnameRequired("GRAY"),
  // Riel
  CCY_KHR_Currency: Qudt.unitFromLocalnameRequired("CCY_KHR"),
  // Pound Mass Second per Square Gallon (UK)
  LB__SEC__PER__GAL_UK2: Qudt.unitFromLocalnameRequired("LB-SEC-PER-GAL_UK2"),
  // Inch of Mercury
  IN_HG: Qudt.unitFromLocalnameRequired("IN_HG"),
  // Beaufort
  BFT: Qudt.unitFromLocalnameRequired("BFT"),
  // British Thermal Unit (international Definition) per Second Square Foot Degree Fahrenheit
  BTU_IT__PER__SEC__FT2__DEG_F: Qudt.unitFromLocalnameRequired(
    "BTU_IT-PER-SEC-FT2-DEG_F"
  ),
  // Shannon
  SHANNON: Qudt.unitFromLocalnameRequired("SHANNON"),
  // Decimetre
  DeciM: Qudt.unitFromLocalnameRequired("DeciM"),
  // Nanowatt
  NanoW: Qudt.unitFromLocalnameRequired("NanoW"),
  // Zeptocoulomb
  ZeptoC: Qudt.unitFromLocalnameRequired("ZeptoC"),
  // Degree Celsius per Metre
  DEG_C__PER__M: Qudt.unitFromLocalnameRequired("DEG_C-PER-M"),
  // Kelvin Second
  K__SEC: Qudt.unitFromLocalnameRequired("K-SEC"),
  // Degree Celsius per Kelvin
  DEG_C__PER__K: Qudt.unitFromLocalnameRequired("DEG_C-PER-K"),
  // Square Foot per Second
  FT2__PER__SEC: Qudt.unitFromLocalnameRequired("FT2-PER-SEC"),
  // Charrière Gauge
  GA_Charriere: Qudt.unitFromLocalnameRequired("GA_Charriere"),
  // Technical Atmosphere per Metre
  ATM_T__PER__M: Qudt.unitFromLocalnameRequired("ATM_T-PER-M"),
  // British Thermal Unit (international Definition) Foot
  BTU_IT__FT: Qudt.unitFromLocalnameRequired("BTU_IT-FT"),
  // Microsievert
  MicroSV: Qudt.unitFromLocalnameRequired("MicroSV"),
  // Gram Hour per Cubic Metre Litre
  GM__HR__PER__M3__L: Qudt.unitFromLocalnameRequired("GM-HR-PER-M3-L"),
  // Tonne per Second
  TONNE__PER__SEC: Qudt.unitFromLocalnameRequired("TONNE-PER-SEC"),
  // Knot per Second
  KN__PER__SEC: Qudt.unitFromLocalnameRequired("KN-PER-SEC"),
  // Quart (UK) per Minute
  QT_UK__PER__MIN: Qudt.unitFromLocalnameRequired("QT_UK-PER-MIN"),
  // Gigabit
  GigaBIT: Qudt.unitFromLocalnameRequired("GigaBIT"),
  // Newton Metre per Radian
  N__M__PER__RAD: Qudt.unitFromLocalnameRequired("N-M-PER-RAD"),
  // Saint Helena Pound
  CCY_SHP: Qudt.unitFromLocalnameRequired("CCY_SHP"),
  // Gram Minute per Cubic Metre Litre
  GM__MIN__PER__M3__L: Qudt.unitFromLocalnameRequired("GM-MIN-PER-M3-L"),
  // Jamaican Dollar
  CCY_JMD_Currency: Qudt.unitFromLocalnameRequired("CCY_JMD"),
  // Gram per Millilitre
  GM__PER__MilliL: Qudt.unitFromLocalnameRequired("GM-PER-MilliL"),
  // Sidereal Day
  DAY_Sidereal: Qudt.unitFromLocalnameRequired("DAY_Sidereal"),
  // Kilobyte per Second
  KiloBYTE__PER__SEC: Qudt.unitFromLocalnameRequired("KiloBYTE-PER-SEC"),
  // International Mile per Minute
  MI__PER__MIN: Qudt.unitFromLocalnameRequired("MI-PER-MIN"),
  // Pound Mass Second per Gallon (UK) Cubic Inch
  LB__SEC__PER__GAL_UK__IN3: Qudt.unitFromLocalnameRequired(
    "LB-SEC-PER-GAL_UK-IN3"
  ),
  // Square Millimetre per Second
  MilliM2__PER__SEC: Qudt.unitFromLocalnameRequired("MilliM2-PER-SEC"),
  // Erg Second
  ERG__SEC: Qudt.unitFromLocalnameRequired("ERG-SEC"),
  // Bushel (UK)
  BU_UK: Qudt.unitFromLocalnameRequired("BU_UK"),
  // Milligram Minute per Sextic Meter
  MilliGM__MIN__PER__M6: Qudt.unitFromLocalnameRequired("MilliGM-MIN-PER-M6"),
  // Pound Mass per Second Degree Fahrenheit
  LB__PER__SEC__DEG_F: Qudt.unitFromLocalnameRequired("LB-PER-SEC-DEG_F"),
  // Pfund
  PFUND: Qudt.unitFromLocalnameRequired("PFUND"),
  // Kilo British Thermal Unit (thermochemical Definition) per Hour
  KiloBTU_TH__PER__HR: Qudt.unitFromLocalnameRequired("KiloBTU_TH-PER-HR"),
  // Microsiemens
  MicroS: Qudt.unitFromLocalnameRequired("MicroS"),
  // Gram per Litre Kelvin
  GM__PER__L__K: Qudt.unitFromLocalnameRequired("GM-PER-L-K"),
  // Metre Square Second
  M__SEC2: Qudt.unitFromLocalnameRequired("M-SEC2"),
  // Momme (pearl)
  MOMME_Pearl: Qudt.unitFromLocalnameRequired("MOMME_Pearl"),
  // Gill (UK)
  GI_UK: Qudt.unitFromLocalnameRequired("GI_UK"),
  // CASES
  CASES: Qudt.unitFromLocalnameRequired("CASES"),
  // Phot
  PHOT: Qudt.unitFromLocalnameRequired("PHOT"),
  // Gram Force
  GM_F: Qudt.unitFromLocalnameRequired("GM_F"),
  // Mole per Minute
  MOL__PER__MIN: Qudt.unitFromLocalnameRequired("MOL-PER-MIN"),
  // Pascal Second per Metre
  PA__SEC__PER__M: Qudt.unitFromLocalnameRequired("PA-SEC-PER-M"),
  // Kilowatt per Meter Kelvin
  KiloW__PER__M__K: Qudt.unitFromLocalnameRequired("KiloW-PER-M-K"),
  // Micrometer per Milliliter
  MicroM__PER__MilliL: Qudt.unitFromLocalnameRequired("MicroM-PER-MilliL"),
  // Mole per Kilogram Bar
  MOL__PER__KiloGM__BAR: Qudt.unitFromLocalnameRequired("MOL-PER-KiloGM-BAR"),
  // Degree Fahrenheit Hour Square Foot per British Thermal Unit (thermochemical Definition) Inch
  DEG_F__HR__FT2__PER__BTU_TH__IN: Qudt.unitFromLocalnameRequired(
    "DEG_F-HR-FT2-PER-BTU_TH-IN"
  ),
  // New Taiwan Dollar
  CCY_TWD_Currency: Qudt.unitFromLocalnameRequired("CCY_TWD"),
  // Percent Second per Us Gallon
  PERCENT__SEC__PER__GAL_US: Qudt.unitFromLocalnameRequired(
    "PERCENT-SEC-PER-GAL_US"
  ),
  // Milliohm
  MilliOHM: Qudt.unitFromLocalnameRequired("MilliOHM"),
  // Yoctocoulomb
  YoctoC: Qudt.unitFromLocalnameRequired("YoctoC"),
  // Pebibit per Metre
  PebiBIT__PER__M: Qudt.unitFromLocalnameRequired("PebiBIT-PER-M"),
  // Volt Ampere Reactive Hour
  V__A_Reactive__HR: Qudt.unitFromLocalnameRequired("V-A_Reactive-HR"),
  // Femtomole
  FemtoMOL: Qudt.unitFromLocalnameRequired("FemtoMOL"),
  // Tonne per Cubic Meter Bar
  TONNE__PER__M3__BAR: Qudt.unitFromLocalnameRequired("TONNE-PER-M3-BAR"),
  // Barrel
  BBL: Qudt.unitFromLocalnameRequired("BBL"),
  // Pa'anga
  CCY_TOP_Currency: Qudt.unitFromLocalnameRequired("CCY_TOP"),
  // Pound Mass per Cubic Foot
  LB__PER__FT3: Qudt.unitFromLocalnameRequired("LB-PER-FT3"),
  // Pound Mass Second per Us Gallon Cubic Yard
  LB__SEC__PER__GAL_US__YD3: Qudt.unitFromLocalnameRequired(
    "LB-SEC-PER-GAL_US-YD3"
  ),
  // Reciprocal Pascal
  PER__PA: Qudt.unitFromLocalnameRequired("PER-PA"),
  // Billion (Short Scale)
  BILLION_Short: Qudt.unitFromLocalnameRequired("BILLION_Short"),
  // Us Liquid Pint per Minute
  PINT_US__PER__MIN: Qudt.unitFromLocalnameRequired("PINT_US-PER-MIN"),
  // Pound Mass Hour per Square Gallon (UK)
  LB__HR__PER__GAL_UK2: Qudt.unitFromLocalnameRequired("LB-HR-PER-GAL_UK2"),
  // Newton Metre Second per Radian
  N__M__SEC__PER__RAD: Qudt.unitFromLocalnameRequired("N-M-SEC-PER-RAD"),
  // Kilosecond
  KiloSEC: Qudt.unitFromLocalnameRequired("KiloSEC"),
  // Coulomb Square Meter per Kilogram
  C__M2__PER__KiloGM: Qudt.unitFromLocalnameRequired("C-M2-PER-KiloGM"),
  // Square Metres per Gram of Dry Sediment
  M2__PER__GM_DRY: Qudt.unitFromLocalnameRequired("M2-PER-GM_DRY"),
  // Euro per Watt Hour
  CCY_EUR__PER__W__HR: Qudt.unitFromLocalnameRequired("CCY_EUR-PER-W-HR"),
  // Yard
  YD: Qudt.unitFromLocalnameRequired("YD"),
  // Planck Impedance
  PlanckImpedance: Qudt.unitFromLocalnameRequired("PlanckImpedance"),
  // Millimetre
  MilliM: Qudt.unitFromLocalnameRequired("MilliM"),
  // Planck Density
  PlanckDensity: Qudt.unitFromLocalnameRequired("PlanckDensity"),
  // Dots per Inch
  DPI: Qudt.unitFromLocalnameRequired("DPI"),
  // Square Meter Kelvin per Watt
  M2__K__PER__W: Qudt.unitFromLocalnameRequired("M2-K-PER-W"),
  // Pound Mass Minute per Cubic Foot Us Gallon
  LB__MIN__PER__FT3__GAL_US: Qudt.unitFromLocalnameRequired(
    "LB-MIN-PER-FT3-GAL_US"
  ),
  // Pound Force per Square Inch Second
  LB_F__PER__IN2__SEC: Qudt.unitFromLocalnameRequired("LB_F-PER-IN2-SEC"),
  // Steradian
  SR: Qudt.unitFromLocalnameRequired("SR"),
  // Exbibit per Cubic Metre
  ExbiBIT__PER__M3: Qudt.unitFromLocalnameRequired("ExbiBIT-PER-M3"),
  // Tonne per Hectare
  TONNE__PER__HA: Qudt.unitFromLocalnameRequired("TONNE-PER-HA"),
  // Millimetre per Year
  MilliM__PER__YR: Qudt.unitFromLocalnameRequired("MilliM-PER-YR"),
  // Microgram per Square Centimetre Week
  MicroGM__PER__CentiM2__WK: Qudt.unitFromLocalnameRequired(
    "MicroGM-PER-CentiM2-WK"
  ),
  // Abhenry
  H_Ab: Qudt.unitFromLocalnameRequired("H_Ab"),
  // Pascal Cubic Meter per Second
  PA__M3__PER__SEC: Qudt.unitFromLocalnameRequired("PA-M3-PER-SEC"),
  // Millicurie
  MilliCi: Qudt.unitFromLocalnameRequired("MilliCi"),
  // Petawatt
  PetaW: Qudt.unitFromLocalnameRequired("PetaW"),
  // Tex
  TEX: Qudt.unitFromLocalnameRequired("TEX"),
  // Convertible Marks
  CCY_BAM_Currency: Qudt.unitFromLocalnameRequired("CCY_BAM"),
  // Planck Current Density
  PlanckCurrentDensity: Qudt.unitFromLocalnameRequired("PlanckCurrentDensity"),
  // Newton Second per Square Meter
  N__SEC__PER__M2: Qudt.unitFromLocalnameRequired("N-SEC-PER-M2"),
  // Millimole
  MilliMOL: Qudt.unitFromLocalnameRequired("MilliMOL"),
  // Dec
  DECADE: Qudt.unitFromLocalnameRequired("DECADE"),
  // Micrometer per Liter Day
  MicroM__PER__L__DAY: Qudt.unitFromLocalnameRequired("MicroM-PER-L-DAY"),
  // Normal Cubic Meter
  NCM: Qudt.unitFromLocalnameRequired("NCM"),
  // Kelvin per Watt
  K__PER__W: Qudt.unitFromLocalnameRequired("K-PER-W"),
  // Megaohm Meter
  MegaOHM__M: Qudt.unitFromLocalnameRequired("MegaOHM-M"),
  // Reciprocal Year
  PER__YR: Qudt.unitFromLocalnameRequired("PER-YR"),
  // Peck (UK) per Second
  PK_UK__PER__SEC: Qudt.unitFromLocalnameRequired("PK_UK-PER-SEC"),
  // Surinam Dollar
  CCY_SRD: Qudt.unitFromLocalnameRequired("CCY_SRD"),
  // Picogram
  PicoGM: Qudt.unitFromLocalnameRequired("PicoGM"),
  // Newton per Radian
  N__PER__RAD: Qudt.unitFromLocalnameRequired("N-PER-RAD"),
  // Brazilian Real
  CCY_BRL_Currency: Qudt.unitFromLocalnameRequired("CCY_BRL"),
  // Pound Mass Square Foot per Gallon (UK) Pound Force Second
  LB__FT2__PER__GAL_UK__LB_F__SEC: Qudt.unitFromLocalnameRequired(
    "LB-FT2-PER-GAL_UK-LB_F-SEC"
  ),
  // Reciprocal Millisecond
  PER__MilliSEC: Qudt.unitFromLocalnameRequired("PER-MilliSEC"),
  // Inch of Mercury (32 °F)
  IN_HG_32DEG_F: Qudt.unitFromLocalnameRequired("IN_HG_32DEG_F"),
  // Pixel
  PIXEL: Qudt.unitFromLocalnameRequired("PIXEL"),
  // Inch per Second Degree Fahrenheit
  IN__PER__SEC__DEG_F: Qudt.unitFromLocalnameRequired("IN-PER-SEC-DEG_F"),
  // Swedish Krona
  CCY_SEK_Currency: Qudt.unitFromLocalnameRequired("CCY_SEK"),
  // Us Liquid Pint per Second
  PINT_US__PER__SEC: Qudt.unitFromLocalnameRequired("PINT_US-PER-SEC"),
  // Romanian New Leu
  CCY_RON: Qudt.unitFromLocalnameRequired("CCY_RON"),
  // Millikelvin
  MilliK: Qudt.unitFromLocalnameRequired("MilliK"),
  // Ton Energy
  TonEnergy: Qudt.unitFromLocalnameRequired("TonEnergy"),
  // Standard Cubic Metre
  SCM_1ATM_0DEG_C: Qudt.unitFromLocalnameRequired("SCM_1ATM_0DEG_C"),
  // Kilofarad
  KiloFARAD: Qudt.unitFromLocalnameRequired("KiloFARAD"),
  // Pound Mass Minute per Cubic Foot Gallon (UK)
  LB__MIN__PER__FT3__GAL_UK: Qudt.unitFromLocalnameRequired(
    "LB-MIN-PER-FT3-GAL_UK"
  ),
  // Megajoule
  MegaJ: Qudt.unitFromLocalnameRequired("MegaJ"),
  // Quart (UK) per Second
  QT_UK__PER__SEC: Qudt.unitFromLocalnameRequired("QT_UK-PER-SEC"),
  // Centimeter per Kiloyear
  CentiM__PER__KiloYR: Qudt.unitFromLocalnameRequired("CentiM-PER-KiloYR"),
  // Newton Metre per Degree
  N__M__PER__DEG: Qudt.unitFromLocalnameRequired("N-M-PER-DEG"),
  // Iranian Rial
  CCY_IRR_Currency: Qudt.unitFromLocalnameRequired("CCY_IRR"),
  // Metric Ton per Cubic Metre
  TON_Metric__PER__M3: Qudt.unitFromLocalnameRequired("TON_Metric-PER-M3"),
  // Giga Electron Volt
  GigaEV: Qudt.unitFromLocalnameRequired("GigaEV"),
  // Bermuda Dollar
  CCY_BMD: Qudt.unitFromLocalnameRequired("CCY_BMD"),
  // Yard per Hour
  YD__PER__HR: Qudt.unitFromLocalnameRequired("YD-PER-HR"),
  // Minute per Kilometer
  MIN__PER__KiloM: Qudt.unitFromLocalnameRequired("MIN-PER-KiloM"),
  // Gram per Minute
  GM__PER__MIN: Qudt.unitFromLocalnameRequired("GM-PER-MIN"),
  // Microhenry per Ohm
  MicroH__PER__OHM: Qudt.unitFromLocalnameRequired("MicroH-PER-OHM"),
  // Kilo Gram Force Metre per Second
  KiloGM_F__M__PER__SEC: Qudt.unitFromLocalnameRequired("KiloGM_F-M-PER-SEC"),
  // Degree Rankine per Hour
  DEG_R__PER__HR: Qudt.unitFromLocalnameRequired("DEG_R-PER-HR"),
  // Percent Hour per Liter
  PERCENT__HR__PER__L: Qudt.unitFromLocalnameRequired("PERCENT-HR-PER-L"),
  // Kilogram per Square Metre
  KiloGM__PER__M2: Qudt.unitFromLocalnameRequired("KiloGM-PER-M2"),
  // Kilogram per Cubic Centimeter Bar
  KiloGM__PER__CentiM3__BAR: Qudt.unitFromLocalnameRequired(
    "KiloGM-PER-CentiM3-BAR"
  ),
  // Millijoule per Square Meter
  MilliJ__PER__M2: Qudt.unitFromLocalnameRequired("MilliJ-PER-M2"),
  // Kilogram per Cubic Decimetre
  KiloGM__PER__DeciM3: Qudt.unitFromLocalnameRequired("KiloGM-PER-DeciM3"),
  // MegaINDIV
  MegaINDIV: Qudt.unitFromLocalnameRequired("MegaINDIV"),
  // Ohm Kilometer
  OHM__KiloM: Qudt.unitFromLocalnameRequired("OHM-KiloM"),
  // Femtometre
  FemtoM: Qudt.unitFromLocalnameRequired("FemtoM"),
  // Picoampere per Hectopascal
  PicoA__PER__HectoPA: Qudt.unitFromLocalnameRequired("PicoA-PER-HectoPA"),
  // Millihertz
  MilliHZ: Qudt.unitFromLocalnameRequired("MilliHZ"),
  // Litre per Minute Bar
  L__PER__MIN__BAR: Qudt.unitFromLocalnameRequired("L-PER-MIN-BAR"),
  // Kilogram per Hectare
  KiloGM__PER__HA: Qudt.unitFromLocalnameRequired("KiloGM-PER-HA"),
  // International Candle
  CD_IN: Qudt.unitFromLocalnameRequired("CD_IN"),
  // Kilogram per Meter
  KiloGM__PER__M: Qudt.unitFromLocalnameRequired("KiloGM-PER-M"),
  // Millibecquerel per Litre
  MilliBQ__PER__L: Qudt.unitFromLocalnameRequired("MilliBQ-PER-L"),
  // Zimbabwe Dollar
  CCY_ZWL: Qudt.unitFromLocalnameRequired("CCY_ZWL"),
  // Decibel Watt
  DeciB__W: Qudt.unitFromLocalnameRequired("DeciB-W"),
  // Metre per Square Second
  M__PER__SEC2: Qudt.unitFromLocalnameRequired("M-PER-SEC2"),
  // Radian
  RAD: Qudt.unitFromLocalnameRequired("RAD"),
  // Kilotonne
  KiloTONNE: Qudt.unitFromLocalnameRequired("KiloTONNE"),
  // Ampere per Square Meter
  A__PER__M2: Qudt.unitFromLocalnameRequired("A-PER-M2"),
  // Square Meter per Kelvin
  M2__PER__K: Qudt.unitFromLocalnameRequired("M2-PER-K"),
  // Kiloohm per Bar
  KiloOHM__PER__BAR: Qudt.unitFromLocalnameRequired("KiloOHM-PER-BAR"),
  // Cord
  CORD: Qudt.unitFromLocalnameRequired("CORD"),
  // Square Metre per Square Second
  M2__PER__SEC2: Qudt.unitFromLocalnameRequired("M2-PER-SEC2"),
  // Pennyweight
  Pennyweight: Qudt.unitFromLocalnameRequired("Pennyweight"),
  // Ampere Minute
  A__MIN: Qudt.unitFromLocalnameRequired("A-MIN"),
  // Gram Second per Litre Cubic Metre
  GM__SEC__PER__L__M3: Qudt.unitFromLocalnameRequired("GM-SEC-PER-L-M3"),
  // Milligalileo per Month
  MilliGALILEO__PER__MO: Qudt.unitFromLocalnameRequired("MilliGALILEO-PER-MO"),
  // Bushel (UK) per Day
  BU_UK__PER__DAY: Qudt.unitFromLocalnameRequired("BU_UK-PER-DAY"),
  // Gigapascal Cubic Centimeter per Gram
  GigaPA__CentiM3__PER__GM: Qudt.unitFromLocalnameRequired(
    "GigaPA-CentiM3-PER-GM"
  ),
  // Parts per Trillion by Volume
  PPTR_VOL: Qudt.unitFromLocalnameRequired("PPTR_VOL"),
  // Second
  SEC: Qudt.unitFromLocalnameRequired("SEC"),
  // Number per Picolitre
  NUM__PER__PicoL: Qudt.unitFromLocalnameRequired("NUM-PER-PicoL"),
  // Volt per Millimeter
  V__PER__MilliM: Qudt.unitFromLocalnameRequired("V-PER-MilliM"),
  // Gigabit per Second
  GigaBIT__PER__SEC: Qudt.unitFromLocalnameRequired("GigaBIT-PER-SEC"),
  // Percent Square Foot per Pound Force Second
  PERCENT__FT2__PER__LB_F__SEC: Qudt.unitFromLocalnameRequired(
    "PERCENT-FT2-PER-LB_F-SEC"
  ),
  // Milligram Hour per Cubic Metre Litre
  MilliGM__HR__PER__M3__L: Qudt.unitFromLocalnameRequired(
    "MilliGM-HR-PER-M3-L"
  ),
  // Kilocurie
  KiloCi: Qudt.unitFromLocalnameRequired("KiloCi"),
  // British Thermal Unit (thermochemical Definition) per Degree Rankine
  BTU_TH__PER__DEG_R: Qudt.unitFromLocalnameRequired("BTU_TH-PER-DEG_R"),
  // Ampere per Ampere Hour
  A__PER__A__HR: Qudt.unitFromLocalnameRequired("A-PER-A-HR"),
  // Megapascal Square Root Meter
  MegaPA__M0dot5: Qudt.unitFromLocalnameRequired("MegaPA-M0dot5"),
  // Norwegian Krone
  CCY_NOK_Currency: Qudt.unitFromLocalnameRequired("CCY_NOK"),
  // Mole per Cubic Metre Second
  MOL__PER__M3__SEC: Qudt.unitFromLocalnameRequired("MOL-PER-M3-SEC"),
  // British Thermal Unit (international Definition) Foot per Square Foot Hour Degree Fahrenheit
  BTU_IT__FT__PER__FT2__HR__DEG_F: Qudt.unitFromLocalnameRequired(
    "BTU_IT-FT-PER-FT2-HR-DEG_F"
  ),
  // Thousand
  THOUSAND: Qudt.unitFromLocalnameRequired("THOUSAND"),
  // Picomole per Litre
  PicoMOL__PER__L: Qudt.unitFromLocalnameRequired("PicoMOL-PER-L"),
  // Pula
  CCY_BWP: Qudt.unitFromLocalnameRequired("CCY_BWP"),
  // Milligram Second per Litre Cubic Centimetre
  MilliGM__SEC__PER__L__CentiM3: Qudt.unitFromLocalnameRequired(
    "MilliGM-SEC-PER-L-CentiM3"
  ),
  // Slug
  SLUG: Qudt.unitFromLocalnameRequired("SLUG"),
  // Square Centimetre per Steradian Erg
  CentiM2__PER__SR__ERG: Qudt.unitFromLocalnameRequired("CentiM2-PER-SR-ERG"),
  // Square Metre per Joule
  M2__PER__J: Qudt.unitFromLocalnameRequired("M2-PER-J"),
  // Dyne per Square Centimetre
  DYN__PER__CentiM2: Qudt.unitFromLocalnameRequired("DYN-PER-CentiM2"),
  // Kilobar
  KiloBAR: Qudt.unitFromLocalnameRequired("KiloBAR"),
  // Pascal per Minute
  PA__PER__MIN: Qudt.unitFromLocalnameRequired("PA-PER-MIN"),
  // Gram per Litre
  GM__PER__L: Qudt.unitFromLocalnameRequired("GM-PER-L"),
  // Liberian Dollar
  CCY_LRD: Qudt.unitFromLocalnameRequired("CCY_LRD"),
  // Joule per Square Centimetre Day
  J__PER__CentiM2__DAY: Qudt.unitFromLocalnameRequired("J-PER-CentiM2-DAY"),
  // Teraohm
  TeraOHM: Qudt.unitFromLocalnameRequired("TeraOHM"),
  // Slug per Day
  SLUG__PER__DAY: Qudt.unitFromLocalnameRequired("SLUG-PER-DAY"),
  // Milligram per Litre Poise
  MilliGM__PER__L__POISE: Qudt.unitFromLocalnameRequired("MilliGM-PER-L-POISE"),
  // Poundal per Inch
  PDL__PER__IN: Qudt.unitFromLocalnameRequired("PDL-PER-IN"),
  // Standard Cubic Foot per Minute
  SCF__PER__MIN: Qudt.unitFromLocalnameRequired("SCF-PER-MIN"),
  // Sievert
  SV: Qudt.unitFromLocalnameRequired("SV"),
  // Therm Us per Hour
  THM_US__PER__HR: Qudt.unitFromLocalnameRequired("THM_US-PER-HR"),
  // Kilo Pound Force
  KiloLB_F: Qudt.unitFromLocalnameRequired("KiloLB_F"),
  // Breath per Minute
  BREATH__PER__MIN: Qudt.unitFromLocalnameRequired("BREATH-PER-MIN"),
  // Barrel (us Petroleum)
  BBL_US_PET: Qudt.unitFromLocalnameRequired("BBL_US_PET"),
  // Micronewton Meter per Square Meter
  MicroN__M__PER__M2: Qudt.unitFromLocalnameRequired("MicroN-M-PER-M2"),
  // Milligram per Day
  MilliGM__PER__DAY: Qudt.unitFromLocalnameRequired("MilliGM-PER-DAY"),
  // Parts per Ten Million
  PPTM: Qudt.unitFromLocalnameRequired("PPTM"),
  // Joule per Day
  J__PER__DAY: Qudt.unitFromLocalnameRequired("J-PER-DAY"),
  // Cubic Decimeter per Day
  DeciM3__PER__DAY: Qudt.unitFromLocalnameRequired("DeciM3-PER-DAY"),
  // Decinewton
  DeciN: Qudt.unitFromLocalnameRequired("DeciN"),
  // Parsec
  PARSEC: Qudt.unitFromLocalnameRequired("PARSEC"),
  // Percent Second per Gallon (UK)
  PERCENT__SEC__PER__GAL_UK: Qudt.unitFromLocalnameRequired(
    "PERCENT-SEC-PER-GAL_UK"
  ),
  // Gram Hour per Litre Cubic Metre
  GM__HR__PER__L__M3: Qudt.unitFromLocalnameRequired("GM-HR-PER-L-M3"),
  // Nanojoule per Second
  NanoJ__PER__SEC: Qudt.unitFromLocalnameRequired("NanoJ-PER-SEC"),
  // Planck Frequency
  PlanckFrequency: Qudt.unitFromLocalnameRequired("PlanckFrequency"),
  // Tonne per Hour Bar
  TONNE__PER__HR__BAR: Qudt.unitFromLocalnameRequired("TONNE-PER-HR-BAR"),
  // Bangladeshi Taka
  CCY_BDT_Currency: Qudt.unitFromLocalnameRequired("CCY_BDT"),
  // Pound Mass per Foot Day
  LB__PER__FT__DAY: Qudt.unitFromLocalnameRequired("LB-PER-FT-DAY"),
  // Picohenry
  PicoH: Qudt.unitFromLocalnameRequired("PicoH"),
  // Kilopond
  KiloPOND: Qudt.unitFromLocalnameRequired("KiloPOND"),
  // Kilogram per Cubic Second Kelvin
  KiloGM__PER__SEC3__K: Qudt.unitFromLocalnameRequired("KiloGM-PER-SEC3-K"),
  // Cubic Meter per Second Bar
  M3__PER__SEC__BAR: Qudt.unitFromLocalnameRequired("M3-PER-SEC-BAR"),
  // Picowatt per Square Centimetre Litre
  PicoW__PER__CentiM2__L: Qudt.unitFromLocalnameRequired("PicoW-PER-CentiM2-L"),
  // Gram per Hectogram
  GM__PER__HectoGM: Qudt.unitFromLocalnameRequired("GM-PER-HectoGM"),
  // Langley
  LANGLEY: Qudt.unitFromLocalnameRequired("LANGLEY"),
  // Angstrom
  ANGSTROM: Qudt.unitFromLocalnameRequired("ANGSTROM"),
  // Kilomole per Hour
  KiloMOL__PER__HR: Qudt.unitFromLocalnameRequired("KiloMOL-PER-HR"),
  // Baht
  CCY_THB_Currency: Qudt.unitFromLocalnameRequired("CCY_THB"),
  // Cubic Yard per Psi
  YD3__PER__PSI: Qudt.unitFromLocalnameRequired("YD3-PER-PSI"),
  // Microampere
  MicroA: Qudt.unitFromLocalnameRequired("MicroA"),
  // International Unit per Milliliter
  IU__PER__MilliL: Qudt.unitFromLocalnameRequired("IU-PER-MilliL"),
  // Uzbekistan Som
  CCY_UZS_Currency: Qudt.unitFromLocalnameRequired("CCY_UZS"),
  // Foot Pound Force
  FT__LB_F: Qudt.unitFromLocalnameRequired("FT-LB_F"),
  // British Thermal Unit (thermochemical Definition) per Pound Mass Degree Fahrenheit
  BTU_TH__PER__LB__DEG_F: Qudt.unitFromLocalnameRequired("BTU_TH-PER-LB-DEG_F"),
  // Gill (US) per Day
  GI_US__PER__DAY: Qudt.unitFromLocalnameRequired("GI_US-PER-DAY"),
  // Millikelvin per Bar
  MilliK__PER__BAR: Qudt.unitFromLocalnameRequired("MilliK-PER-BAR"),
  // Inch per Revolution
  IN__PER__REV: Qudt.unitFromLocalnameRequired("IN-PER-REV"),
  // Inch of Mercury (60 °F)
  IN_HG_60DEG_F: Qudt.unitFromLocalnameRequired("IN_HG_60DEG_F"),
  // Falkland Islands Pound
  CCY_FKP_Currency: Qudt.unitFromLocalnameRequired("CCY_FKP"),
  // Kilogram per Liter Kelvin
  KiloGM__PER__L__K: Qudt.unitFromLocalnameRequired("KiloGM-PER-L-K"),
  // Milligram per Cubic Meter Pascal Second
  MilliGM__PER__M3__PA__SEC: Qudt.unitFromLocalnameRequired(
    "MilliGM-PER-M3-PA-SEC"
  ),
  // Reciprocal Ounce Mass
  PER__OZ: Qudt.unitFromLocalnameRequired("PER-OZ"),
  // Percent Second per Cubic Foot
  PERCENT__SEC__PER__FT3: Qudt.unitFromLocalnameRequired("PERCENT-SEC-PER-FT3"),
  // Milligravity
  MilliG: Qudt.unitFromLocalnameRequired("MilliG"),
  // Psi
  PSI: Qudt.unitFromLocalnameRequired("PSI"),
  // Kilogram Square Meter per Second
  KiloGM__M2__PER__SEC: Qudt.unitFromLocalnameRequired("KiloGM-M2-PER-SEC"),
  // Micromole per Square Meter Second
  MicroMOL__PER__M2__SEC: Qudt.unitFromLocalnameRequired("MicroMOL-PER-M2-SEC"),
  // Electric Susceptibility Unit
  SUSCEPTIBILITY_ELEC: Qudt.unitFromLocalnameRequired("SUSCEPTIBILITY_ELEC"),
  // Flight
  FLIGHT: Qudt.unitFromLocalnameRequired("FLIGHT"),
  // Ton of Oil Equivalent
  TOE: Qudt.unitFromLocalnameRequired("TOE"),
  // Newton Metre per Kilogram
  N__M__PER__KiloGM: Qudt.unitFromLocalnameRequired("N-M-PER-KiloGM"),
  // Grams Nitrogen per Square Metre Day
  GM_Nitrogen__PER__M2__DAY: Qudt.unitFromLocalnameRequired(
    "GM_Nitrogen-PER-M2-DAY"
  ),
  // Joule per Second
  J__PER__SEC: Qudt.unitFromLocalnameRequired("J-PER-SEC"),
  // Volt Ampere Hour
  VA__HR: Qudt.unitFromLocalnameRequired("VA-HR"),
  // Milligram per Kelvin
  MilliGM__PER__K: Qudt.unitFromLocalnameRequired("MilliGM-PER-K"),
  // Tonne per Cubic Metre Kelvin
  TONNE__PER__M3__K: Qudt.unitFromLocalnameRequired("TONNE-PER-M3-K"),
  // Oersted
  OERSTED: Qudt.unitFromLocalnameRequired("OERSTED"),
  // Revolution per Square Second
  REV__PER__SEC2: Qudt.unitFromLocalnameRequired("REV-PER-SEC2"),
  // Pascal Second per Liter
  PA__SEC__PER__L: Qudt.unitFromLocalnameRequired("PA-SEC-PER-L"),
  // Millimetre per Day
  MilliM__PER__DAY: Qudt.unitFromLocalnameRequired("MilliM-PER-DAY"),
  // Ounce Mass Inch
  OZ__IN: Qudt.unitFromLocalnameRequired("OZ-IN"),
  // Nanojoule
  NanoJ: Qudt.unitFromLocalnameRequired("NanoJ"),
  // British Thermal Unit (thermochemical Definition) per Square Foot Second
  BTU_TH__PER__FT2__SEC: Qudt.unitFromLocalnameRequired("BTU_TH-PER-FT2-SEC"),
  // Newton per Centimetre
  N__PER__CentiM: Qudt.unitFromLocalnameRequired("N-PER-CentiM"),
  // British Thermal Unit (thermochemical Definition) per Pound Mass
  BTU_TH__PER__LB: Qudt.unitFromLocalnameRequired("BTU_TH-PER-LB"),
  // Liter per Mole
  L__PER__MOL: Qudt.unitFromLocalnameRequired("L-PER-MOL"),
  // MI_UK
  MI_UK: Qudt.unitFromLocalnameRequired("MI_UK"),
  // Joule per Gram Kelvin
  J__PER__GM__K: Qudt.unitFromLocalnameRequired("J-PER-GM-K"),
  // Kilogram per Second Square Metre
  KiloGM__PER__SEC__M2: Qudt.unitFromLocalnameRequired("KiloGM-PER-SEC-M2"),
  // Malaysian Ringgit
  CCY_MYR: Qudt.unitFromLocalnameRequired("CCY_MYR"),
  // Degree Celsius per Year
  DEG_C__PER__YR: Qudt.unitFromLocalnameRequired("DEG_C-PER-YR"),
  // Brewster
  BREWSTER: Qudt.unitFromLocalnameRequired("BREWSTER"),
  // Cubic Foot per Day
  FT3__PER__DAY: Qudt.unitFromLocalnameRequired("FT3-PER-DAY"),
  // Mega Electron Volt Femtometer
  MegaEV__FemtoM: Qudt.unitFromLocalnameRequired("MegaEV-FemtoM"),
  // Square Meter Quartic Hertz
  M2__HZ4: Qudt.unitFromLocalnameRequired("M2-HZ4"),
  // Cubic Meter per Second Kelvin
  M3__PER__SEC__K: Qudt.unitFromLocalnameRequired("M3-PER-SEC-K"),
  // Square Centimeter per Cubic Centimeter
  CentiM2__PER__CentiM3: Qudt.unitFromLocalnameRequired("CentiM2-PER-CentiM3"),
  // Percent per Ten Thousand
  PERCENT__PER__TEN__THOUSAND: Qudt.unitFromLocalnameRequired(
    "PERCENT-PER-TEN-THOUSAND"
  ),
  // Micromole per Gram
  MicroMOL__PER__GM: Qudt.unitFromLocalnameRequired("MicroMOL-PER-GM"),
  // British Thermal Unit (international Definition) per Pound Mole Degree Fahrenheit
  BTU_IT__PER__MOL_LB__DEG_F: Qudt.unitFromLocalnameRequired(
    "BTU_IT-PER-MOL_LB-DEG_F"
  ),
  // Gram per Square Meter Day
  GM__PER__M2__DAY: Qudt.unitFromLocalnameRequired("GM-PER-M2-DAY"),
  // Kilo Metric Ton
  KiloTON_Metric: Qudt.unitFromLocalnameRequired("KiloTON_Metric"),
  // Micromole per Liter Hour
  MicroMOL__PER__L__HR: Qudt.unitFromLocalnameRequired("MicroMOL-PER-L-HR"),
  // Barrel (US) per Minute
  BBL_US__PER__MIN: Qudt.unitFromLocalnameRequired("BBL_US-PER-MIN"),
  // Kilojoule
  KiloJ: Qudt.unitFromLocalnameRequired("KiloJ"),
  // Metric Ton per Second Kelvin
  TON_Metric__PER__SEC__K: Qudt.unitFromLocalnameRequired(
    "TON_Metric-PER-SEC-K"
  ),
  // Cubic Yard per Hour
  YD3__PER__HR: Qudt.unitFromLocalnameRequired("YD3-PER-HR"),
  // Gold (one Troy Ounce)
  CCY_XAU_Currency: Qudt.unitFromLocalnameRequired("CCY_XAU"),
  // Reciprocal Second Cubic Meter
  PER__SEC__M3: Qudt.unitFromLocalnameRequired("PER-SEC-M3"),
  // Kilogram per Millimetre
  KiloGM__PER__MilliM: Qudt.unitFromLocalnameRequired("KiloGM-PER-MilliM"),
  // Pound Mass Foot per Second
  LB__FT__PER__SEC: Qudt.unitFromLocalnameRequired("LB-FT-PER-SEC"),
  // Siemens per Metre
  S__PER__M: Qudt.unitFromLocalnameRequired("S-PER-M"),
  // Yard per Second
  YD__PER__SEC: Qudt.unitFromLocalnameRequired("YD-PER-SEC"),
  // Number per Square Metre Day
  NUM__PER__M2__DAY: Qudt.unitFromLocalnameRequired("NUM-PER-M2-DAY"),
  // Nanofarad per Meter
  NanoFARAD__PER__M: Qudt.unitFromLocalnameRequired("NanoFARAD-PER-M"),
  // Square Metre Steradian
  M2__SR: Qudt.unitFromLocalnameRequired("M2-SR"),
  // Millibar per Kelvin
  MilliBAR__PER__K: Qudt.unitFromLocalnameRequired("MilliBAR-PER-K"),
  // Cubic Centimeter per Hour Bar
  CentiM3__PER__HR__BAR: Qudt.unitFromLocalnameRequired("CentiM3-PER-HR-BAR"),
  // Foot per Degree Fahrenheit
  FT__PER__DEG_F: Qudt.unitFromLocalnameRequired("FT-PER-DEG_F"),
  // Wir Franc (complementary Currency)
  CCY_CHW: Qudt.unitFromLocalnameRequired("CCY_CHW"),
  // Chilean Peso
  CCY_CLP: Qudt.unitFromLocalnameRequired("CCY_CLP"),
  // Assay Ton
  TON_Assay: Qudt.unitFromLocalnameRequired("TON_Assay"),
  // Picomole per Liter Hour
  PicoMOL__PER__L__HR: Qudt.unitFromLocalnameRequired("PicoMOL-PER-L-HR"),
  // Pint (UK)
  PINT_UK: Qudt.unitFromLocalnameRequired("PINT_UK"),
  // Femtosecond
  FemtoSEC: Qudt.unitFromLocalnameRequired("FemtoSEC"),
  // Milligram
  MilliGM: Qudt.unitFromLocalnameRequired("MilliGM"),
  // Micro Volt Ampere per Kelvin
  MicroVA__PER__K: Qudt.unitFromLocalnameRequired("MicroVA-PER-K"),
  // Kilo Cubic Foot
  KiloCubicFT: Qudt.unitFromLocalnameRequired("KiloCubicFT"),
  // Poundal Foot
  PDL__FT: Qudt.unitFromLocalnameRequired("PDL-FT"),
  // Pascal per Second
  PA__PER__SEC: Qudt.unitFromLocalnameRequired("PA-PER-SEC"),
  // Microwatt per Square Centimetre Micrometre Steradian
  MicroW__PER__CentiM2__MicroM__SR: Qudt.unitFromLocalnameRequired(
    "MicroW-PER-CentiM2-MicroM-SR"
  ),
  // Count
  COUNT: Qudt.unitFromLocalnameRequired("COUNT"),
  // Lilangeni
  CCY_SZL_Currency: Qudt.unitFromLocalnameRequired("CCY_SZL"),
  // Ampere
  A: Qudt.unitFromLocalnameRequired("A"),
  // Jordanian Dinar
  CCY_JOD_Currency: Qudt.unitFromLocalnameRequired("CCY_JOD"),
  // Meter per Second Bar
  M__PER__SEC__BAR: Qudt.unitFromLocalnameRequired("M-PER-SEC-BAR"),
  // Volt per Bar
  V__PER__BAR: Qudt.unitFromLocalnameRequired("V-PER-BAR"),
  // Us Peck
  PK_US_DRY: Qudt.unitFromLocalnameRequired("PK_US_DRY"),
  // Square Meter per Hertz
  M2__PER__HZ: Qudt.unitFromLocalnameRequired("M2-PER-HZ"),
  // Swiss Franc per Hectare
  CCY_CHF__PER__HA: Qudt.unitFromLocalnameRequired("CCY_CHF-PER-HA"),
  // Malagasy Ariary
  CCY_MGA: Qudt.unitFromLocalnameRequired("CCY_MGA"),
  // United States Dollar (next Day) (funds Code)
  CCY_USN_Currency: Qudt.unitFromLocalnameRequired("CCY_USN"),
  // Kilobecquerel
  KiloBQ: Qudt.unitFromLocalnameRequired("KiloBQ"),
  // Megavolt Ampere Hour
  MegaV__A__HR: Qudt.unitFromLocalnameRequired("MegaV-A-HR"),
  // Gram
  GM: Qudt.unitFromLocalnameRequired("GM"),
  // Volt per Centimetre
  V__PER__CentiM: Qudt.unitFromLocalnameRequired("V-PER-CentiM"),
  // Percent per Millipascal Second
  PERCENT__PER__MilliPA__SEC: Qudt.unitFromLocalnameRequired(
    "PERCENT-PER-MilliPA-SEC"
  ),
  // Trinidad and Tobago Dollar
  CCY_TTD: Qudt.unitFromLocalnameRequired("CCY_TTD"),
  // Pascal Square Root Meter
  PA__M0dot5: Qudt.unitFromLocalnameRequired("PA-M0dot5"),
  // Ohm per Metre
  OHM__PER__M: Qudt.unitFromLocalnameRequired("OHM-PER-M"),
  // Gigabecquerel
  GigaBQ: Qudt.unitFromLocalnameRequired("GigaBQ"),
  // Gram per Metre
  GM__PER__M: Qudt.unitFromLocalnameRequired("GM-PER-M"),
  // Mile Us Statute per Square Second
  MI_US__PER__SEC2: Qudt.unitFromLocalnameRequired("MI_US-PER-SEC2"),
  // Gram Hour per Liter Cubic Centimeter
  GM__HR__PER__L__CentiM3: Qudt.unitFromLocalnameRequired(
    "GM-HR-PER-L-CentiM3"
  ),
  // Watt Hour per Square Meter
  W__HR__PER__M2: Qudt.unitFromLocalnameRequired("W-HR-PER-M2"),
  // Pound Mass per Psi
  LB__PER__PSI: Qudt.unitFromLocalnameRequired("LB-PER-PSI"),
  // Gilbert
  GI: Qudt.unitFromLocalnameRequired("GI"),
  // Square Meter Hertz
  M2__HZ: Qudt.unitFromLocalnameRequired("M2-HZ"),
  // Quart (UK) per Day
  QT_UK__PER__DAY: Qudt.unitFromLocalnameRequired("QT_UK-PER-DAY"),
  // Second Square Foot
  SEC__FT2: Qudt.unitFromLocalnameRequired("SEC-FT2"),
  // Picosiemens
  PicoS: Qudt.unitFromLocalnameRequired("PicoS"),
  // Percent per Volt
  PERCENT__PER__V: Qudt.unitFromLocalnameRequired("PERCENT-PER-V"),
  // Meter Kelvin per Watt
  M__K__PER__W: Qudt.unitFromLocalnameRequired("M-K-PER-W"),
  // Micrometer per Newton
  MicroM__PER__N: Qudt.unitFromLocalnameRequired("MicroM-PER-N"),
  // Gram per Square Metre Year
  GM__PER__M2__YR: Qudt.unitFromLocalnameRequired("GM-PER-M2-YR"),
  // Hour per Square Foot
  HR__PER__FT2: Qudt.unitFromLocalnameRequired("HR-PER-FT2"),
  // Dalasi
  CCY_GMD_Currency: Qudt.unitFromLocalnameRequired("CCY_GMD"),
  // Milliliter per Day
  MilliL__PER__DAY: Qudt.unitFromLocalnameRequired("MilliL-PER-DAY"),
  // Lari
  CCY_GEL_Currency: Qudt.unitFromLocalnameRequired("CCY_GEL"),
  // Milligram per Square Meter
  MilliGM__PER__M2: Qudt.unitFromLocalnameRequired("MilliGM-PER-M2"),
  // Newton Metre
  N__M: Qudt.unitFromLocalnameRequired("N-M"),
  // Exajoule per Second
  ExaJ__PER__SEC: Qudt.unitFromLocalnameRequired("ExaJ-PER-SEC"),
  // Ampere per Kilogram
  A__PER__KiloGM: Qudt.unitFromLocalnameRequired("A-PER-KiloGM"),
  // Percent Second per Cubic Inch
  PERCENT__SEC__PER__IN3: Qudt.unitFromLocalnameRequired("PERCENT-SEC-PER-IN3"),
  // PicoVolt Ampere Reactive
  PicoV__A_Reactive: Qudt.unitFromLocalnameRequired("PicoV-A_Reactive"),
  // Cedi
  CCY_GHS_Currency: Qudt.unitFromLocalnameRequired("CCY_GHS"),
  // Milligram per Cubic Meter Day
  MilliGM__PER__M3__DAY: Qudt.unitFromLocalnameRequired("MilliGM-PER-M3-DAY"),
  // GM_Carbon
  GM_Carbon: Qudt.unitFromLocalnameRequired("GM_Carbon"),
  // NanoVolt Ampere Reactive
  NanoV__A_Reactive: Qudt.unitFromLocalnameRequired("NanoV-A_Reactive"),
  // Brunei Dollar
  CCY_BND_Currency: Qudt.unitFromLocalnameRequired("CCY_BND"),
  // Milli Volt Ampere
  MilliVA: Qudt.unitFromLocalnameRequired("MilliVA"),
  // Reciprocal Cubic Centimetre
  PER__CentiM3: Qudt.unitFromLocalnameRequired("PER-CentiM3"),
  // South African Rand
  CCY_ZAR_Currency: Qudt.unitFromLocalnameRequired("CCY_ZAR"),
  // Newton Second per Cubic Meter
  N__SEC__PER__M3: Qudt.unitFromLocalnameRequired("N-SEC-PER-M3"),
  // Metre per Kelvin
  M__PER__K: Qudt.unitFromLocalnameRequired("M-PER-K"),
  // Millidarcy
  MilliDARCY: Qudt.unitFromLocalnameRequired("MilliDARCY"),
  // Kilogram per Square Second
  KiloGM__PER__SEC2: Qudt.unitFromLocalnameRequired("KiloGM-PER-SEC2"),
  // Standard Cubic Metre
  SCM_1ATM_15DEG_C_ISO: Qudt.unitFromLocalnameRequired("SCM_1ATM_15DEG_C_ISO"),
  // Milliliter per Hour Bar
  MilliL__PER__HR__BAR: Qudt.unitFromLocalnameRequired("MilliL-PER-HR-BAR"),
  // Reciprocal Cubic Meter
  PER__M3: Qudt.unitFromLocalnameRequired("PER-M3"),
  // Nanobecquerel per Liter
  NanoBQ__PER__L: Qudt.unitFromLocalnameRequired("NanoBQ-PER-L"),
  // Conventional Centimeter of Water
  CentiM_H2O: Qudt.unitFromLocalnameRequired("CentiM_H2O"),
  // Milliosmole
  MilliOSM: Qudt.unitFromLocalnameRequired("MilliOSM"),
  // Phon
  PHON: Qudt.unitFromLocalnameRequired("PHON"),
  // Poise per Pascal
  POISE__PER__PA: Qudt.unitFromLocalnameRequired("POISE-PER-PA"),
  // Pound Mass Minute per Cubic Inch Cubic Foot
  LB__MIN__PER__IN3__FT3: Qudt.unitFromLocalnameRequired("LB-MIN-PER-IN3-FT3"),
  // Decibel Milliwatt per Megahertz
  DeciB__MilliW__PER__MegaHZ: Qudt.unitFromLocalnameRequired(
    "DeciB-MilliW-PER-MegaHZ"
  ),
  // Cubic Micrometre
  MicroM3: Qudt.unitFromLocalnameRequired("MicroM3"),
  // Number per Centimetre Kiloyear
  NUM__PER__CentiM__KiloYR: Qudt.unitFromLocalnameRequired(
    "NUM-PER-CentiM-KiloYR"
  ),
  // Pound Mass per Square Foot
  LB__PER__FT2: Qudt.unitFromLocalnameRequired("LB-PER-FT2"),
  // Gram per Square Centimetre
  GM__PER__CentiM2: Qudt.unitFromLocalnameRequired("GM-PER-CentiM2"),
  // Bit per Square Metre
  BIT__PER__M2: Qudt.unitFromLocalnameRequired("BIT-PER-M2"),
  // Inch of Water (39.2 °F)
  IN_H2O_39dot2DEG_F: Qudt.unitFromLocalnameRequired("IN_H2O_39dot2DEG_F"),
  // Microgram per Square Centimetre
  MicroGM__PER__CentiM2: Qudt.unitFromLocalnameRequired("MicroGM-PER-CentiM2"),
  // Kilojoule per Day
  KiloJ__PER__DAY: Qudt.unitFromLocalnameRequired("KiloJ-PER-DAY"),
  // Hour Square Foot
  HR__FT2: Qudt.unitFromLocalnameRequired("HR-FT2"),
  // Foot per Square Second
  FT__PER__SEC2: Qudt.unitFromLocalnameRequired("FT-PER-SEC2"),
  // Ampere per Square Centimeter
  A__PER__CentiM2: Qudt.unitFromLocalnameRequired("A-PER-CentiM2"),
  // Picoampere
  PicoA: Qudt.unitFromLocalnameRequired("PicoA"),
  // Kilocalorie per Minute
  KiloCAL__PER__MIN: Qudt.unitFromLocalnameRequired("KiloCAL-PER-MIN"),
  // Degree Fahrenheit per Bar
  DEG_F__PER__BAR: Qudt.unitFromLocalnameRequired("DEG_F-PER-BAR"),
  // Cubic Metre per Bar
  M3__PER__BAR: Qudt.unitFromLocalnameRequired("M3-PER-BAR"),
  // Centipoise per Bar
  CentiPOISE__PER__BAR: Qudt.unitFromLocalnameRequired("CentiPOISE-PER-BAR"),
  // Watt Square Metre per Steradian
  W__M2__PER__SR: Qudt.unitFromLocalnameRequired("W-M2-PER-SR"),
  // U.s. Perm
  PERM_US: Qudt.unitFromLocalnameRequired("PERM_US"),
  // Rufiyaa
  CCY_MVR: Qudt.unitFromLocalnameRequired("CCY_MVR"),
  // Cubic Centimetre per Second Bar
  CentiM3__PER__SEC__BAR: Qudt.unitFromLocalnameRequired("CentiM3-PER-SEC-BAR"),
  // Kilocoulomb per Cubic Meter
  KiloC__PER__M3: Qudt.unitFromLocalnameRequired("KiloC-PER-M3"),
  // Bulgarian Lev per Kilowatt Hour
  CCY_BGN__PER__KiloW__HR: Qudt.unitFromLocalnameRequired(
    "CCY_BGN-PER-KiloW-HR"
  ),
  // Square Meter Second per Radian
  M2__SEC__PER__RAD: Qudt.unitFromLocalnameRequired("M2-SEC-PER-RAD"),
  // Pound Mass Square Foot
  LB__FT2: Qudt.unitFromLocalnameRequired("LB-FT2"),
  // Electron Volt Second
  EV__SEC: Qudt.unitFromLocalnameRequired("EV-SEC"),
  // Foot per Day
  FT__PER__DAY: Qudt.unitFromLocalnameRequired("FT-PER-DAY"),
  // Tonne per Cubic Meter
  TONNE__PER__M3: Qudt.unitFromLocalnameRequired("TONNE-PER-M3"),
  // Abfarad per Centimeter
  FARAD_Ab__PER__CentiM: Qudt.unitFromLocalnameRequired("FARAD_Ab-PER-CentiM"),
  // Kilopoise
  KiloPOISE: Qudt.unitFromLocalnameRequired("KiloPOISE"),
  // Heart Beats per Minute
  BEAT__PER__MIN: Qudt.unitFromLocalnameRequired("BEAT-PER-MIN"),
  // Thermochemical Calorie per Second
  CAL_TH__PER__SEC: Qudt.unitFromLocalnameRequired("CAL_TH-PER-SEC"),
  // Liberian Dollar
  CCY_LRD_Currency: Qudt.unitFromLocalnameRequired("CCY_LRD"),
  // Square Yard
  YD2: Qudt.unitFromLocalnameRequired("YD2"),
  // Namibian Dollar
  CCY_NAD_Currency: Qudt.unitFromLocalnameRequired("CCY_NAD"),
  // Reciprocal Kilo Volt Ampere Hour
  PER__KiloVA__HR: Qudt.unitFromLocalnameRequired("PER-KiloVA-HR"),
  // Mole Degree Celsius
  MOL__DEG_C: Qudt.unitFromLocalnameRequired("MOL-DEG_C"),
  // Fathom
  FATH: Qudt.unitFromLocalnameRequired("FATH"),
  // Kibibit per Square Meter
  KibiBIT__PER__M2: Qudt.unitFromLocalnameRequired("KibiBIT-PER-M2"),
  // Petabyte
  PetaBYTE: Qudt.unitFromLocalnameRequired("PetaBYTE"),
  // Milligram Minute per Liter Cubic Centimeter
  MilliGM__MIN__PER__L__CentiM3: Qudt.unitFromLocalnameRequired(
    "MilliGM-MIN-PER-L-CentiM3"
  ),
  // Cubic Metre per Pascal
  M3__PER__PA: Qudt.unitFromLocalnameRequired("M3-PER-PA"),
  // Megavolt
  MegaV: Qudt.unitFromLocalnameRequired("MegaV"),
  // Metre Kelvin
  M__K: Qudt.unitFromLocalnameRequired("M-K"),
  // Kilomole per Cubic Metre
  KiloMOL__PER__M3: Qudt.unitFromLocalnameRequired("KiloMOL-PER-M3"),
  // Megapascal Cubic Meter per Second
  MegaPA__M3__PER__SEC: Qudt.unitFromLocalnameRequired("MegaPA-M3-PER-SEC"),
  // Slug per Minute
  SLUG__PER__MIN: Qudt.unitFromLocalnameRequired("SLUG-PER-MIN"),
  // Mexican Peso
  CCY_MXN: Qudt.unitFromLocalnameRequired("CCY_MXN"),
  // Pebibit per Square Meter
  PebiBIT__PER__M2: Qudt.unitFromLocalnameRequired("PebiBIT-PER-M2"),
  // Electron Volt per Meter
  EV__PER__M: Qudt.unitFromLocalnameRequired("EV-PER-M"),
  // Joule per Cubic Meter
  J__PER__M3: Qudt.unitFromLocalnameRequired("J-PER-M3"),
  // Nanogram per Kilogram
  NanoGM__PER__KiloGM: Qudt.unitFromLocalnameRequired("NanoGM-PER-KiloGM"),
  // Pound Mass Minute per Cubic Foot Cubic Yard
  LB__MIN__PER__FT3__YD3: Qudt.unitFromLocalnameRequired("LB-MIN-PER-FT3-YD3"),
  // Decibel with Z-weighting
  DeciB_Z: Qudt.unitFromLocalnameRequired("DeciB_Z"),
  // Picometre
  PicoM: Qudt.unitFromLocalnameRequired("PicoM"),
  // Hartley per Second
  HART__PER__SEC: Qudt.unitFromLocalnameRequired("HART-PER-SEC"),
  // Kilo British Thermal Unit (thermochemical Definition)
  KiloBTU_TH: Qudt.unitFromLocalnameRequired("KiloBTU_TH"),
  // Cubic Meter per Cubic Meter
  M3__PER__M3: Qudt.unitFromLocalnameRequired("M3-PER-M3"),
  // Forint
  CCY_HUF_Currency: Qudt.unitFromLocalnameRequired("CCY_HUF"),
  // Millivolt per Volt
  MilliV__PER__V: Qudt.unitFromLocalnameRequired("MilliV-PER-V"),
  // Kilogram per Square Foot
  KiloGM__PER__FT2: Qudt.unitFromLocalnameRequired("KiloGM-PER-FT2"),
  // Gigabyte
  GigaBYTE: Qudt.unitFromLocalnameRequired("GigaBYTE"),
  // Kilojoule per Mole
  KiloJ__PER__MOL: Qudt.unitFromLocalnameRequired("KiloJ-PER-MOL"),
  // Gram per Cubic Meter Poise
  GM__PER__M3__POISE: Qudt.unitFromLocalnameRequired("GM-PER-M3-POISE"),
  // Parts per Billion
  PPB: Qudt.unitFromLocalnameRequired("PPB"),
  // Seychelles Rupee
  CCY_SCR_Currency: Qudt.unitFromLocalnameRequired("CCY_SCR"),
  // Octet
  OCTET: Qudt.unitFromLocalnameRequired("OCTET"),
  // International Table Calorie per Gram
  CAL_IT__PER__GM: Qudt.unitFromLocalnameRequired("CAL_IT-PER-GM"),
  // Reciprocal Square Giga Electron Volt
  PER__GigaEV2: Qudt.unitFromLocalnameRequired("PER-GigaEV2"),
  // Solar Mass
  SolarMass: Qudt.unitFromLocalnameRequired("SolarMass"),
  // Gram per Second
  GM__PER__SEC: Qudt.unitFromLocalnameRequired("GM-PER-SEC"),
  // Lumen Second
  LM__SEC: Qudt.unitFromLocalnameRequired("LM-SEC"),
  // Milli Degree Celsius
  MilliDEG_C: Qudt.unitFromLocalnameRequired("MilliDEG_C"),
  // Roentgen
  R: Qudt.unitFromLocalnameRequired("R"),
  // Pound Mass per Gallon (UK)
  LB__PER__GAL_UK: Qudt.unitFromLocalnameRequired("LB-PER-GAL_UK"),
  // Number per Metre
  NUM__PER__M: Qudt.unitFromLocalnameRequired("NUM-PER-M"),
  // HectoKiloCOUNT
  HectoKiloCOUNT: Qudt.unitFromLocalnameRequired("HectoKiloCOUNT"),
  // MillionUSD
  MillionUSD: Qudt.unitFromLocalnameRequired("MillionUSD"),
  // Nanoampere
  NanoA: Qudt.unitFromLocalnameRequired("NanoA"),
  // Pascal per Bar
  PA__PER__BAR: Qudt.unitFromLocalnameRequired("PA-PER-BAR"),
  // Metric Ton per Day Kelvin
  TON_Metric__PER__DAY__K: Qudt.unitFromLocalnameRequired(
    "TON_Metric-PER-DAY-K"
  ),
  // Kilo Gram Force Meter per Square Centimeter
  KiloGM_F__M__PER__CentiM2: Qudt.unitFromLocalnameRequired(
    "KiloGM_F-M-PER-CentiM2"
  ),
  // Gibibit per Metre
  GibiBIT__PER__M: Qudt.unitFromLocalnameRequired("GibiBIT-PER-M"),
  // Pound Mass Second per Cubic Foot Cubic Inch
  LB__SEC__PER__FT3__IN3: Qudt.unitFromLocalnameRequired("LB-SEC-PER-FT3-IN3"),
  // Reciprocal Angstrom
  PER__ANGSTROM: Qudt.unitFromLocalnameRequired("PER-ANGSTROM"),
  // Giga Base Pair
  GigaBasePair: Qudt.unitFromLocalnameRequired("GigaBasePair"),
  // Millilitre per Second
  MilliL__PER__SEC: Qudt.unitFromLocalnameRequired("MilliL-PER-SEC"),
  // Millisievert per Hour
  MilliSV__PER__HR: Qudt.unitFromLocalnameRequired("MilliSV-PER-HR"),
  // Belize Dollar
  CCY_BZD_Currency: Qudt.unitFromLocalnameRequired("CCY_BZD"),
  // Standard Cubic Meter per Hour
  SCM__PER__HR: Qudt.unitFromLocalnameRequired("SCM-PER-HR"),
  // Ohm per International Mile
  OHM__PER__MI: Qudt.unitFromLocalnameRequired("OHM-PER-MI"),
  // MicroGals per Metre
  MicroGAL__PER__M: Qudt.unitFromLocalnameRequired("MicroGAL-PER-M"),
  // Gram Minute per Liter Cubic Meter
  GM__MIN__PER__L__M3: Qudt.unitFromLocalnameRequired("GM-MIN-PER-L-M3"),
  // Kiloweber
  KiloWB: Qudt.unitFromLocalnameRequired("KiloWB"),
  // Mile Us Statute
  MI_US: Qudt.unitFromLocalnameRequired("MI_US"),
  // Fraction
  FRACTION: Qudt.unitFromLocalnameRequired("FRACTION"),
  // Million
  MILLION: Qudt.unitFromLocalnameRequired("MILLION"),
  // Armenian Dram
  CCY_AMD: Qudt.unitFromLocalnameRequired("CCY_AMD"),
  // Kilo International Table Calorie
  KiloCAL_IT: Qudt.unitFromLocalnameRequired("KiloCAL_IT"),
  // Milligram Minute per Cubic Meter Cubic Centimeter
  MilliGM__MIN__PER__M3__CentiM3: Qudt.unitFromLocalnameRequired(
    "MilliGM-MIN-PER-M3-CentiM3"
  ),
  // Coulomb per Kilogram Second
  C__PER__KiloGM__SEC: Qudt.unitFromLocalnameRequired("C-PER-KiloGM-SEC"),
  // Foot Second per Cubic Inch
  FT__SEC__PER__IN3: Qudt.unitFromLocalnameRequired("FT-SEC-PER-IN3"),
  // Quartic Coulomb Quartic Metre per Cubic Joule
  C4__M4__PER__J3: Qudt.unitFromLocalnameRequired("C4-M4-PER-J3"),
  // Kip per Square Inch
  KIP_F__PER__IN2: Qudt.unitFromLocalnameRequired("KIP_F-PER-IN2"),
  // Milligram Second per Square Litre
  MilliGM__SEC__PER__L2: Qudt.unitFromLocalnameRequired("MilliGM-SEC-PER-L2"),
  // Watt per Square Meter
  W__PER__M2: Qudt.unitFromLocalnameRequired("W-PER-M2"),
  // Millitorr
  MilliTORR: Qudt.unitFromLocalnameRequired("MilliTORR"),
  // Litre per Micromole
  L__PER__MicroMOL: Qudt.unitFromLocalnameRequired("L-PER-MicroMOL"),
  // Square Meter Square Hertz
  M2__HZ2: Qudt.unitFromLocalnameRequired("M2-HZ2"),
  // Bermuda Dollar
  CCY_BMD_Currency: Qudt.unitFromLocalnameRequired("CCY_BMD"),
  // Gram per Litre Millipascal Second
  GM__PER__L__MilliPA__SEC: Qudt.unitFromLocalnameRequired(
    "GM-PER-L-MilliPA-SEC"
  ),
  // Joule per Kelvin
  J__PER__K: Qudt.unitFromLocalnameRequired("J-PER-K"),
  // Abampere per Square Centimeter
  A_Ab__PER__CentiM2: Qudt.unitFromLocalnameRequired("A_Ab-PER-CentiM2"),
  // Mole per Mole
  MOL__PER__MOL: Qudt.unitFromLocalnameRequired("MOL-PER-MOL"),
  // Erg per Gram
  ERG__PER__GM: Qudt.unitFromLocalnameRequired("ERG-PER-GM"),
  // Metre per Degree Celsius Metre
  M__PER__DEG_C__M: Qudt.unitFromLocalnameRequired("M-PER-DEG_C-M"),
  // Reciprocal Picometer
  PER__PicoM: Qudt.unitFromLocalnameRequired("PER-PicoM"),
  // Liter per Kelvin
  L__PER__K: Qudt.unitFromLocalnameRequired("L-PER-K"),
  // Gram per Cubic Metre Bar
  GM__PER__M3__BAR: Qudt.unitFromLocalnameRequired("GM-PER-M3-BAR"),
  // Kelvin Metre
  K__M: Qudt.unitFromLocalnameRequired("K-M"),
  // Pennyweight
  PENNYWEIGHT: Qudt.unitFromLocalnameRequired("PENNYWEIGHT"),
  // Us Liquid Pint per Day
  PINT_US__PER__DAY: Qudt.unitFromLocalnameRequired("PINT_US-PER-DAY"),
  // European Composite Unit (eurco) (bonds Market Unit)
  CCY_XBA_Currency: Qudt.unitFromLocalnameRequired("CCY_XBA"),
  // Weber per Millimeter
  WB__PER__MilliM: Qudt.unitFromLocalnameRequired("WB-PER-MilliM"),
  // Millinewton Metre per Square Metre
  MilliN__M__PER__M2: Qudt.unitFromLocalnameRequired("MilliN-M-PER-M2"),
  // Gram per Square Millimeter
  GM__PER__MilliM2: Qudt.unitFromLocalnameRequired("GM-PER-MilliM2"),
  // Milliwatt
  MilliW: Qudt.unitFromLocalnameRequired("MilliW"),
  // Calorie (Mean)
  CAL_MEAN: Qudt.unitFromLocalnameRequired("CAL_MEAN"),
  // Mole per Litre Bar
  MOL__PER__L__BAR: Qudt.unitFromLocalnameRequired("MOL-PER-L-BAR"),
  // Percent per Hundred Thousand
  PERCENT__PER__HUNDRED__THOUSAND: Qudt.unitFromLocalnameRequired(
    "PERCENT-PER-HUNDRED-THOUSAND"
  ),
  // Megabar
  MegaBAR: Qudt.unitFromLocalnameRequired("MegaBAR"),
  // Palladium (one Troy Ounce)
  CCY_XPD_Currency: Qudt.unitFromLocalnameRequired("CCY_XPD"),
  // Deci Metric Ton
  DeciTON_Metric: Qudt.unitFromLocalnameRequired("DeciTON_Metric"),
  // Gill (UK) per Second
  GI_UK__PER__SEC: Qudt.unitFromLocalnameRequired("GI_UK-PER-SEC"),
  // Mole per Tonne
  MOL__PER__TONNE: Qudt.unitFromLocalnameRequired("MOL-PER-TONNE"),
  // Wir Franc (complementary Currency)
  CCY_CHW_Currency: Qudt.unitFromLocalnameRequired("CCY_CHW"),
  // Forint per Kilowatt Hour
  CCY_HUF__PER__KiloW__HR: Qudt.unitFromLocalnameRequired(
    "CCY_HUF-PER-KiloW-HR"
  ),
  // Femtolitre
  FemtoL: Qudt.unitFromLocalnameRequired("FemtoL"),
  // Yuan Renminbi
  CCY_CNY: Qudt.unitFromLocalnameRequired("CCY_CNY"),
  // Guinea Franc
  CCY_GNF: Qudt.unitFromLocalnameRequired("CCY_GNF"),
  // Tonne per Hour
  TONNE__PER__HR: Qudt.unitFromLocalnameRequired("TONNE-PER-HR"),
  // Grain
  GRAIN: Qudt.unitFromLocalnameRequired("GRAIN"),
  // Milliliter per Hour Kelvin
  MilliL__PER__HR__K: Qudt.unitFromLocalnameRequired("MilliL-PER-HR-K"),
  // Gram per Cubic Metre Kelvin
  GM__PER__M3__K: Qudt.unitFromLocalnameRequired("GM-PER-M3-K"),
  // Pound Force Second per Square Inch
  LB_F__SEC__PER__IN2: Qudt.unitFromLocalnameRequired("LB_F-SEC-PER-IN2"),
  // Czech Koruna
  CCY_CZK_Currency: Qudt.unitFromLocalnameRequired("CCY_CZK"),
  // Millimeter per Minute
  MilliM__PER__MIN: Qudt.unitFromLocalnameRequired("MilliM-PER-MIN"),
  // Cordoba Oro
  CCY_NIO_Currency: Qudt.unitFromLocalnameRequired("CCY_NIO"),
  // Mole per Cubic Metre
  MOL__PER__M3: Qudt.unitFromLocalnameRequired("MOL-PER-M3"),
  // Jordanian Dinar
  CCY_JOD: Qudt.unitFromLocalnameRequired("CCY_JOD"),
  // Megajoule per Kelvin
  MegaJ__PER__K: Qudt.unitFromLocalnameRequired("MegaJ-PER-K"),
  // Reciprocal Milligram
  PER__MilliGM: Qudt.unitFromLocalnameRequired("PER-MilliGM"),
  // Newton per Square Millimeter
  N__PER__MilliM2: Qudt.unitFromLocalnameRequired("N-PER-MilliM2"),
  // Statsiemens
  S_Stat: Qudt.unitFromLocalnameRequired("S_Stat"),
  // Cubic Centimetre per Day Bar
  CentiM3__PER__DAY__BAR: Qudt.unitFromLocalnameRequired("CentiM3-PER-DAY-BAR"),
  // Pound Mass per Square Inch
  LB__PER__IN2: Qudt.unitFromLocalnameRequired("LB-PER-IN2"),
  // Microgram per Cubic Metre
  MicroGM__PER__M3: Qudt.unitFromLocalnameRequired("MicroGM-PER-M3"),
  // Bit per Metre
  BIT__PER__M: Qudt.unitFromLocalnameRequired("BIT-PER-M"),
  // Metre Pascal per Second
  M__PA__PER__SEC: Qudt.unitFromLocalnameRequired("M-PA-PER-SEC"),
  // Kilogram per Second Bar
  KiloGM__PER__SEC__BAR: Qudt.unitFromLocalnameRequired("KiloGM-PER-SEC-BAR"),
  // Watt per Square Centimeter
  W__PER__CentiM2: Qudt.unitFromLocalnameRequired("W-PER-CentiM2"),
  // Thermochemical Calorie per Gram Kelvin
  CAL_TH__PER__GM__K: Qudt.unitFromLocalnameRequired("CAL_TH-PER-GM-K"),
  // Meter per Volt Second
  M__PER__V__SEC: Qudt.unitFromLocalnameRequired("M-PER-V-SEC"),
  // Gill (US) per Hour
  GI_US__PER__HR: Qudt.unitFromLocalnameRequired("GI_US-PER-HR"),
  // Becquerel Second per Cubic Meter
  BQ__SEC__PER__M3: Qudt.unitFromLocalnameRequired("BQ-SEC-PER-M3"),
  // Iraqi Dinar
  CCY_IQD_Currency: Qudt.unitFromLocalnameRequired("CCY_IQD"),
  // Ampere Turn per Inch
  AT__PER__IN: Qudt.unitFromLocalnameRequired("AT-PER-IN"),
  // Milligalileo
  MilliGAL: Qudt.unitFromLocalnameRequired("MilliGAL"),
  // Cuban Peso
  CCY_CUP: Qudt.unitFromLocalnameRequired("CCY_CUP"),
  // Joule per Cubic Centimetre Kelvin
  J__PER__CentiM3__K: Qudt.unitFromLocalnameRequired("J-PER-CentiM3-K"),
  // Curie per Kilogram
  CI__PER__KiloGM: Qudt.unitFromLocalnameRequired("CI-PER-KiloGM"),
  // Dalton
  DA: Qudt.unitFromLocalnameRequired("DA"),
  // Belarussian Ruble
  CCY_BYN: Qudt.unitFromLocalnameRequired("CCY_BYN"),
  // Ounce Mass per Hour
  OZ__PER__HR: Qudt.unitFromLocalnameRequired("OZ-PER-HR"),
  // Hectopascal per Hour
  HectoPA__PER__HR: Qudt.unitFromLocalnameRequired("HectoPA-PER-HR"),
  // Nakfa
  CCY_ERN_Currency: Qudt.unitFromLocalnameRequired("CCY_ERN"),
  // Azerbaijanian Manat
  CCY_AZN_Currency: Qudt.unitFromLocalnameRequired("CCY_AZN"),
  // Mole
  MOL: Qudt.unitFromLocalnameRequired("MOL"),
  // Terabecquerel
  TeraBQ: Qudt.unitFromLocalnameRequired("TeraBQ"),
  // Watt Hour per Kilogram
  W__HR__PER__KiloGM: Qudt.unitFromLocalnameRequired("W-HR-PER-KiloGM"),
  // Square Foot Hour Degree Fahrenheit
  FT2__HR__DEG_F: Qudt.unitFromLocalnameRequired("FT2-HR-DEG_F"),
  // Gauss
  GAUSS: Qudt.unitFromLocalnameRequired("GAUSS"),
  // Pound Mass Second per Cubic Inch Us Gallon
  LB__SEC__PER__IN3__GAL_US: Qudt.unitFromLocalnameRequired(
    "LB-SEC-PER-IN3-GAL_US"
  ),
  // Metric Ton per Day Bar
  TON_Metric__PER__DAY__BAR: Qudt.unitFromLocalnameRequired(
    "TON_Metric-PER-DAY-BAR"
  ),
  // Us Liquid Pint per Hour
  PINT_US__PER__HR: Qudt.unitFromLocalnameRequired("PINT_US-PER-HR"),
  // Grain per Us Gallon
  GRAIN__PER__GAL_US: Qudt.unitFromLocalnameRequired("GRAIN-PER-GAL_US"),
  // Kilogram per Day Kelvin
  KiloGM__PER__DAY__K: Qudt.unitFromLocalnameRequired("KiloGM-PER-DAY-K"),
  // Fluid Ounce (UK) per Day
  OZ_VOL_UK__PER__DAY: Qudt.unitFromLocalnameRequired("OZ_VOL_UK-PER-DAY"),
  // Square Kelvin
  K2: Qudt.unitFromLocalnameRequired("K2"),
  // Gigaohm per Meter
  GigaOHM__PER__M: Qudt.unitFromLocalnameRequired("GigaOHM-PER-M"),
  // Cubic Meter per Day Bar
  M3__PER__DAY__BAR: Qudt.unitFromLocalnameRequired("M3-PER-DAY-BAR"),
  // Nanomole per Litre
  NanoMOL__PER__L: Qudt.unitFromLocalnameRequired("NanoMOL-PER-L"),
  // Ampere Square Meter per Joule Second
  A__M2__PER__J__SEC: Qudt.unitFromLocalnameRequired("A-M2-PER-J-SEC"),
  // Egyptian Pound
  CCY_EGP: Qudt.unitFromLocalnameRequired("CCY_EGP"),
  // Microkatal per Liter
  MicroKAT__PER__L: Qudt.unitFromLocalnameRequired("MicroKAT-PER-L"),
  // Hectogram
  HectoGM: Qudt.unitFromLocalnameRequired("HectoGM"),
  // Decinewton Metre
  DeciN__M: Qudt.unitFromLocalnameRequired("DeciN-M"),
  // Milligram per Square Decimeter
  MilliGM__PER__DeciM2: Qudt.unitFromLocalnameRequired("MilliGM-PER-DeciM2"),
  // Ounce Mass per Imperial Gallon
  OZ__PER__GAL_IMP: Qudt.unitFromLocalnameRequired("OZ-PER-GAL_IMP"),
  // Kilogram per Hectare Year
  KiloGM__PER__HA__YR: Qudt.unitFromLocalnameRequired("KiloGM-PER-HA-YR"),
  // Millicoulomb
  MilliC: Qudt.unitFromLocalnameRequired("MilliC"),
  // British Thermal Unit (60 °F)
  BTU_60DEG_F: Qudt.unitFromLocalnameRequired("BTU_60DEG_F"),
  // Percent per Thousand
  PERCENT__PER__THOUSAND: Qudt.unitFromLocalnameRequired(
    "PERCENT-PER-THOUSAND"
  ),
  // British Thermal Unit (international Definition) per Second Square Foot
  BTU_IT__PER__SEC__FT2: Qudt.unitFromLocalnameRequired("BTU_IT-PER-SEC-FT2"),
  // Kilogram per Meter Square Second
  KiloGM__PER__M__SEC2: Qudt.unitFromLocalnameRequired("KiloGM-PER-M-SEC2"),
  // Kilosiemens per Meter
  KiloS__PER__M: Qudt.unitFromLocalnameRequired("KiloS-PER-M"),
  // Milliampere per Pound Force Square Inch
  MilliA__PER__LB_F__IN2: Qudt.unitFromLocalnameRequired("MilliA-PER-LB_F-IN2"),
  // Nautical Mile
  MI_N: Qudt.unitFromLocalnameRequired("MI_N"),
  // Metric Ton per Kelvin
  TON_Metric__PER__K: Qudt.unitFromLocalnameRequired("TON_Metric-PER-K"),
  // Decacoulomb
  DecaC: Qudt.unitFromLocalnameRequired("DecaC"),
  // Sri Lanka Rupee
  CCY_LKR: Qudt.unitFromLocalnameRequired("CCY_LKR"),
  // Kiloohm Metre
  KiloOHM__M: Qudt.unitFromLocalnameRequired("KiloOHM-M"),
  // British Thermal Unit (thermochemical Definition) Foot per Square Foot Hour Degree Fahrenheit
  BTU_TH__FT__PER__FT2__HR__DEG_F: Qudt.unitFromLocalnameRequired(
    "BTU_TH-FT-PER-FT2-HR-DEG_F"
  ),
  // Naira
  CCY_NGN: Qudt.unitFromLocalnameRequired("CCY_NGN"),
  // Gram per Millilitre Kelvin
  GM__PER__MilliL__K: Qudt.unitFromLocalnameRequired("GM-PER-MilliL-K"),
  // Mach
  MACH: Qudt.unitFromLocalnameRequired("MACH"),
  // Weber Metre
  WB__M: Qudt.unitFromLocalnameRequired("WB-M"),
  // Platinum (one Troy Ounce)
  CCY_XPT_Currency: Qudt.unitFromLocalnameRequired("CCY_XPT"),
  // Exawatt
  ExaW: Qudt.unitFromLocalnameRequired("ExaW"),
  // Megaohm
  MegaOHM: Qudt.unitFromLocalnameRequired("MegaOHM"),
  // Milligram per Litre Millipascal Second
  MilliGM__PER__L__MilliPA__SEC: Qudt.unitFromLocalnameRequired(
    "MilliGM-PER-L-MilliPA-SEC"
  ),
  // Picomole per Liter Day
  PicoMOL__PER__L__DAY: Qudt.unitFromLocalnameRequired("PicoMOL-PER-L-DAY"),
  // Microvolt Ampere
  MicroV__A: Qudt.unitFromLocalnameRequired("MicroV-A"),
  // Number per Minute
  NUM__PER__MIN: Qudt.unitFromLocalnameRequired("NUM-PER-MIN"),
  // Tonne per Minute
  TONNE__PER__MIN: Qudt.unitFromLocalnameRequired("TONNE-PER-MIN"),
  // Watt Second
  W__SEC: Qudt.unitFromLocalnameRequired("W-SEC"),
  // Deaths per 1000 Individuals Year
  DEATHS__PER__KiloINDIV__YR: Qudt.unitFromLocalnameRequired(
    "DEATHS-PER-KiloINDIV-YR"
  ),
  // Pound Mass Minute per Cubic Inch Cubic Yard
  LB__MIN__PER__IN3__YD3: Qudt.unitFromLocalnameRequired("LB-MIN-PER-IN3-YD3"),
  // Ampere per Kelvin
  A__PER__K: Qudt.unitFromLocalnameRequired("A-PER-K"),
  // Afghani
  CCY_AFN_Currency: Qudt.unitFromLocalnameRequired("CCY_AFN"),
  // Planck Time
  PlanckTime: Qudt.unitFromLocalnameRequired("PlanckTime"),
  // BREATH
  BREATH: Qudt.unitFromLocalnameRequired("BREATH"),
  // Microgram per Gram
  MicroGM__PER__GM: Qudt.unitFromLocalnameRequired("MicroGM-PER-GM"),
  // Gram Hour per Cubic Meter Cubic Centimeter
  GM__HR__PER__M3__CentiM3: Qudt.unitFromLocalnameRequired(
    "GM-HR-PER-M3-CentiM3"
  ),
  // Grain per Cubic Metre
  GRAIN__PER__M3: Qudt.unitFromLocalnameRequired("GRAIN-PER-M3"),
  // Gigawatt
  GigaW: Qudt.unitFromLocalnameRequired("GigaW"),
  // Ton (uk Shipping)
  TON_SHIPPING_UK: Qudt.unitFromLocalnameRequired("TON_SHIPPING_UK"),
  // Technical Atmosphere
  ATM_T: Qudt.unitFromLocalnameRequired("ATM_T"),
  // Metric Ton per Minute
  TON_Metric__PER__MIN: Qudt.unitFromLocalnameRequired("TON_Metric-PER-MIN"),
  // Micro Standard Atmosphere
  MicroATM: Qudt.unitFromLocalnameRequired("MicroATM"),
  // Milliwatt per Square Meter Nanometer Steradian
  MilliW__PER__M2__NanoM__SR: Qudt.unitFromLocalnameRequired(
    "MilliW-PER-M2-NanoM-SR"
  ),
  // Kilonewton Meter per Degree Meter
  KiloN__M__PER__DEG__M: Qudt.unitFromLocalnameRequired("KiloN-M-PER-DEG-M"),
  // Nanonewton
  NanoN: Qudt.unitFromLocalnameRequired("NanoN"),
  // Kilomole per Cubic Meter Kelvin
  KiloMOL__PER__M3__K: Qudt.unitFromLocalnameRequired("KiloMOL-PER-M3-K"),
  // Pound Mass Second per Gallon (UK) Cubic Yard
  LB__SEC__PER__GAL_UK__YD3: Qudt.unitFromLocalnameRequired(
    "LB-SEC-PER-GAL_UK-YD3"
  ),
  // Microsecond
  MicroSEC: Qudt.unitFromLocalnameRequired("MicroSEC"),
  // Kilowatt per Square Metre
  KiloW__PER__M2: Qudt.unitFromLocalnameRequired("KiloW-PER-M2"),
  // Special Drawing Rights
  CCY_XDR: Qudt.unitFromLocalnameRequired("CCY_XDR"),
  // Zimbabwe Dollar
  CCY_ZWL_Currency: Qudt.unitFromLocalnameRequired("CCY_ZWL"),
  // Cubic Decimeter per Hour
  DeciM3__PER__HR: Qudt.unitFromLocalnameRequired("DeciM3-PER-HR"),
  // Kilometer per Day
  KiloM__PER__DAY: Qudt.unitFromLocalnameRequired("KiloM-PER-DAY"),
  // Nanogram per Deciliter
  NanoGM__PER__DeciL: Qudt.unitFromLocalnameRequired("NanoGM-PER-DeciL"),
  // Reciprocal Megapascal
  PER__MegaPA: Qudt.unitFromLocalnameRequired("PER-MegaPA"),
  // Mebibit per Square Meter
  MebiBIT__PER__M2: Qudt.unitFromLocalnameRequired("MebiBIT-PER-M2"),
  // Millimole per Square Meter
  MilliMOL__PER__M2: Qudt.unitFromLocalnameRequired("MilliMOL-PER-M2"),
  // Terawatt Hour
  TeraW__HR: Qudt.unitFromLocalnameRequired("TeraW-HR"),
  // Picojoule per Second
  PicoJ__PER__SEC: Qudt.unitFromLocalnameRequired("PicoJ-PER-SEC"),
  // Bar Cubic Meter per Second
  BAR__M3__PER__SEC: Qudt.unitFromLocalnameRequired("BAR-M3-PER-SEC"),
  // Tebibit per Meter
  TebiBIT__PER__M: Qudt.unitFromLocalnameRequired("TebiBIT-PER-M"),
  // Nanomole per Micromole Day
  NanoMOL__PER__MicroMOL__DAY: Qudt.unitFromLocalnameRequired(
    "NanoMOL-PER-MicroMOL-DAY"
  ),
  // Hertz Meter
  HZ__M: Qudt.unitFromLocalnameRequired("HZ-M"),
  // Calorie (20 °C)
  CAL_20DEG_C: Qudt.unitFromLocalnameRequired("CAL_20DEG_C"),
  // Philippine Peso
  CCY_PHP_Currency: Qudt.unitFromLocalnameRequired("CCY_PHP"),
  // Kelvin per Bar
  K__PER__BAR: Qudt.unitFromLocalnameRequired("K-PER-BAR"),
  // Nautical Mile per Minute
  MI_N__PER__MIN: Qudt.unitFromLocalnameRequired("MI_N-PER-MIN"),
  // Kilowatt Hour
  KiloW__HR: Qudt.unitFromLocalnameRequired("KiloW-HR"),
  // Pond
  POND: Qudt.unitFromLocalnameRequired("POND"),
  // RT
  RT: Qudt.unitFromLocalnameRequired("RT"),
  // British Thermal Unit (thermochemical Definition) Foot per Hour Square Foot Degree Fahrenheit
  BTU_TH__FT__PER__HR__FT2__DEG_F: Qudt.unitFromLocalnameRequired(
    "BTU_TH-FT-PER-HR-FT2-DEG_F"
  ),
  // Haiti Gourde
  CCY_HTG_Currency: Qudt.unitFromLocalnameRequired("CCY_HTG"),
  // Kilomole
  KiloMOL: Qudt.unitFromLocalnameRequired("KiloMOL"),
  // Quartic Centimeter
  CentiM4: Qudt.unitFromLocalnameRequired("CentiM4"),
  // Kilojoule per Second
  KiloJ__PER__SEC: Qudt.unitFromLocalnameRequired("KiloJ-PER-SEC"),
  // Pound Force per Yard
  LB_F__PER__YD: Qudt.unitFromLocalnameRequired("LB_F-PER-YD"),
  // Kilometre per Second
  KiloM__PER__SEC: Qudt.unitFromLocalnameRequired("KiloM-PER-SEC"),
  // Imperial Gallon
  GAL_IMP: Qudt.unitFromLocalnameRequired("GAL_IMP"),
  // Ton
  TON: Qudt.unitFromLocalnameRequired("TON"),
  // Millicoulomb per Cubic Metre
  MilliC__PER__M3: Qudt.unitFromLocalnameRequired("MilliC-PER-M3"),
  // Planck Angular Frequency
  PlanckFrequency_Ang: Qudt.unitFromLocalnameRequired("PlanckFrequency_Ang"),
  // Japanese Yen
  CCY_JPY: Qudt.unitFromLocalnameRequired("CCY_JPY"),
  // Reciprocal Day
  PER__DAY: Qudt.unitFromLocalnameRequired("PER-DAY"),
  // Nanokatal
  NanoKAT: Qudt.unitFromLocalnameRequired("NanoKAT"),
  // Tonne per Second Kelvin
  TONNE__PER__SEC__K: Qudt.unitFromLocalnameRequired("TONNE-PER-SEC-K"),
  // Erg Square Centimeter per Gram
  ERG__CentiM2__PER__GM: Qudt.unitFromLocalnameRequired("ERG-CentiM2-PER-GM"),
  // Gram per Cubic Metre Millipascal Second
  GM__PER__M3__MilliPA__SEC: Qudt.unitFromLocalnameRequired(
    "GM-PER-M3-MilliPA-SEC"
  ),
  // Square International Mile
  MI2: Qudt.unitFromLocalnameRequired("MI2"),
  // Square Meter per Second Kelvin
  M2__PER__SEC__K: Qudt.unitFromLocalnameRequired("M2-PER-SEC-K"),
  // Megapascal Liter per Second
  MegaPA__L__PER__SEC: Qudt.unitFromLocalnameRequired("MegaPA-L-PER-SEC"),
  // Standard Atmosphere
  ATM: Qudt.unitFromLocalnameRequired("ATM"),
  // Reciprocal Second
  PER__SEC: Qudt.unitFromLocalnameRequired("PER-SEC"),
  // Milligram Hour per Liter Cubic Meter
  MilliGM__HR__PER__L__M3: Qudt.unitFromLocalnameRequired(
    "MilliGM-HR-PER-L-M3"
  ),
  // Centimetre per Second Bar
  CentiM__PER__SEC__BAR: Qudt.unitFromLocalnameRequired("CentiM-PER-SEC-BAR"),
  // Pound Mass per Hour Degree Fahrenheit
  LB__PER__HR__DEG_F: Qudt.unitFromLocalnameRequired("LB-PER-HR-DEG_F"),
  // Decitonne
  DeciTONNE: Qudt.unitFromLocalnameRequired("DeciTONNE"),
  // Moroccan Dirham
  CCY_MAD_Currency: Qudt.unitFromLocalnameRequired("CCY_MAD"),
  // Microfarad
  MicroFARAD: Qudt.unitFromLocalnameRequired("MicroFARAD"),
  // Milligram per Hour Bar
  MilliGM__PER__HR__BAR: Qudt.unitFromLocalnameRequired("MilliGM-PER-HR-BAR"),
  // Micromole per Second
  MicroMOL__PER__SEC: Qudt.unitFromLocalnameRequired("MicroMOL-PER-SEC"),
  // Milliwatt per Square Meter Nanometer
  MilliW__PER__M2__NanoM: Qudt.unitFromLocalnameRequired("MilliW-PER-M2-NanoM"),
  // Watt per Meter
  W__PER__M: Qudt.unitFromLocalnameRequired("W-PER-M"),
  // Qatari Rial
  CCY_QAR: Qudt.unitFromLocalnameRequired("CCY_QAR"),
  // Cubic Decameter
  DecaM3: Qudt.unitFromLocalnameRequired("DecaM3"),
  // Kilojoule per Hour
  KiloJ__PER__HR: Qudt.unitFromLocalnameRequired("KiloJ-PER-HR"),
  // Galileo
  GALILEO: Qudt.unitFromLocalnameRequired("GALILEO"),
  // Spin Quantum Number
  SPIN_QUANTUM_NUMBER: Qudt.unitFromLocalnameRequired("SPIN_QUANTUM_NUMBER"),
  // Gallon (UK) per Day
  GAL_UK__PER__DAY: Qudt.unitFromLocalnameRequired("GAL_UK-PER-DAY"),
  // Thermochemical Calorie per Second Square Centimeter Kelvin
  CAL_TH__PER__SEC__CentiM2__K: Qudt.unitFromLocalnameRequired(
    "CAL_TH-PER-SEC-CentiM2-K"
  ),
  // Yemeni Rial
  CCY_YER_Currency: Qudt.unitFromLocalnameRequired("CCY_YER"),
  // Microgravity
  MicroG: Qudt.unitFromLocalnameRequired("MicroG"),
  // Common Year
  YR_Common: Qudt.unitFromLocalnameRequired("YR_Common"),
  // Kibibit per Meter
  KibiBIT__PER__M: Qudt.unitFromLocalnameRequired("KibiBIT-PER-M"),
  // Megagram
  MegaGM: Qudt.unitFromLocalnameRequired("MegaGM"),
  // Gray per Hour
  GRAY__PER__HR: Qudt.unitFromLocalnameRequired("GRAY-PER-HR"),
  // Statvolt
  V_Stat: Qudt.unitFromLocalnameRequired("V_Stat"),
  // Newton Square Meter per Square Kilogram
  N__M2__PER__KiloGM2: Qudt.unitFromLocalnameRequired("N-M2-PER-KiloGM2"),
  // Mexican Unidad De Inversion (udi) (funds Code)
  CCY_MXV: Qudt.unitFromLocalnameRequired("CCY_MXV"),
  // Second per Radian Cubic Meter
  SEC__PER__RAD__M3: Qudt.unitFromLocalnameRequired("SEC-PER-RAD-M3"),
  // Pound Mass Minute per Square Us Gallon
  LB__MIN__PER__GAL_US2: Qudt.unitFromLocalnameRequired("LB-MIN-PER-GAL_US2"),
  // Millitesla
  MilliT: Qudt.unitFromLocalnameRequired("MilliT"),
  // Nanomole per Liter Day
  NanoMOL__PER__L__DAY: Qudt.unitFromLocalnameRequired("NanoMOL-PER-L-DAY"),
  // Gibraltar Pound
  CCY_GIP_Currency: Qudt.unitFromLocalnameRequired("CCY_GIP"),
  // Wir Euro (complementary Currency)
  CCY_CHE: Qudt.unitFromLocalnameRequired("CCY_CHE"),
  // Cape Verde Escudo
  CCY_CVE_Currency: Qudt.unitFromLocalnameRequired("CCY_CVE"),
  // Foot per Second
  FT__PER__SEC: Qudt.unitFromLocalnameRequired("FT-PER-SEC"),
  // Megagray
  MegaGRAY: Qudt.unitFromLocalnameRequired("MegaGRAY"),
  // Nuevo Sol
  CCY_PEN_Currency: Qudt.unitFromLocalnameRequired("CCY_PEN"),
  // Microwatt per Square Meter
  MicroW__PER__M2: Qudt.unitFromLocalnameRequired("MicroW-PER-M2"),
  // Mega Volt Ampere Reactive
  MegaVAR: Qudt.unitFromLocalnameRequired("MegaVAR"),
  // British Thermal Unit (international Definition) Inch per Square Foot Second Degree Fahrenheit
  BTU_IT__IN__PER__FT2__SEC__DEG_F: Qudt.unitFromLocalnameRequired(
    "BTU_IT-IN-PER-FT2-SEC-DEG_F"
  ),
  // Milliweber
  MilliWB: Qudt.unitFromLocalnameRequired("MilliWB"),
  // British Thermal Unit (thermochemical Definition) per Square Foot
  BTU_TH__PER__FT2: Qudt.unitFromLocalnameRequired("BTU_TH-PER-FT2"),
  // Metre per Minute
  M__PER__MIN: Qudt.unitFromLocalnameRequired("M-PER-MIN"),
  // Tanzanian Shilling
  CCY_TZS_Currency: Qudt.unitFromLocalnameRequired("CCY_TZS"),
  // Heart Beat
  HeartBeat: Qudt.unitFromLocalnameRequired("HeartBeat"),
  // Kibibyte
  KibiBYTE: Qudt.unitFromLocalnameRequired("KibiBYTE"),
  // Erg per Second
  ERG__PER__SEC: Qudt.unitFromLocalnameRequired("ERG-PER-SEC"),
  // Perm (23 °C)
  PERM_Metric_23DEG_C: Qudt.unitFromLocalnameRequired("PERM_Metric_23DEG_C"),
  // British Thermal Unit (thermochemical Definition) Inch per Square Foot Hour Degree Fahrenheit
  BTU_TH__IN__PER__FT2__HR__DEG_F: Qudt.unitFromLocalnameRequired(
    "BTU_TH-IN-PER-FT2-HR-DEG_F"
  ),
  // Millimole per Gram
  MilliMOL__PER__GM: Qudt.unitFromLocalnameRequired("MilliMOL-PER-GM"),
  // Sone
  SON: Qudt.unitFromLocalnameRequired("SON"),
  // Malaysian Ringgit
  CCY_MYR_Currency: Qudt.unitFromLocalnameRequired("CCY_MYR"),
  // Gram per Liter Pascal Second
  GM__PER__L__PA__SEC: Qudt.unitFromLocalnameRequired("GM-PER-L-PA-SEC"),
  // Milliwatt per Milligram
  MilliW__PER__MilliGM: Qudt.unitFromLocalnameRequired("MilliW-PER-MilliGM"),
  // Tonne per Kelvin
  TONNE__PER__K: Qudt.unitFromLocalnameRequired("TONNE-PER-K"),
  // Pound Mass Square Inch per Us Gallon Pound Force Second
  LB__IN2__PER__GAL_US__LB_F__SEC: Qudt.unitFromLocalnameRequired(
    "LB-IN2-PER-GAL_US-LB_F-SEC"
  ),
  // Joule per Square Centimetre
  J__PER__CentiM2: Qudt.unitFromLocalnameRequired("J-PER-CentiM2"),
  // Statohm
  OHM_Stat: Qudt.unitFromLocalnameRequired("OHM_Stat"),
  // Petahertz
  PetaHZ: Qudt.unitFromLocalnameRequired("PetaHZ"),
  // Micromole per Litre
  MicroMOL__PER__L: Qudt.unitFromLocalnameRequired("MicroMOL-PER-L"),
  // Gram per Cubic Decimetre
  GM__PER__DeciM3: Qudt.unitFromLocalnameRequired("GM-PER-DeciM3"),
  // Franklin
  FR: Qudt.unitFromLocalnameRequired("FR"),
  // Mohm
  MOHM: Qudt.unitFromLocalnameRequired("MOHM"),
  // Degree Celsius
  DEG_C: Qudt.unitFromLocalnameRequired("DEG_C"),
  // Kiloroentgen
  KiloR: Qudt.unitFromLocalnameRequired("KiloR"),
  // Square Meter
  M2: Qudt.unitFromLocalnameRequired("M2"),
  // Nephelometry Turbidity Unit
  NTU: Qudt.unitFromLocalnameRequired("NTU"),
  // Exajoule
  ExaJ: Qudt.unitFromLocalnameRequired("ExaJ"),
  // Cubic Mile (uk Statute)
  MI_UK3: Qudt.unitFromLocalnameRequired("MI_UK3"),
  // Planck Pressure
  PlanckPressure: Qudt.unitFromLocalnameRequired("PlanckPressure"),
  // Megabyte per Second
  MegaBYTE__PER__SEC: Qudt.unitFromLocalnameRequired("MegaBYTE-PER-SEC"),
  // Kilogram Meter per Second
  KiloGM__M__PER__SEC: Qudt.unitFromLocalnameRequired("KiloGM-M-PER-SEC"),
  // Kilogram per Joule
  KiloGM__PER__J: Qudt.unitFromLocalnameRequired("KiloGM-PER-J"),
  // Cubic International Mile
  MI3: Qudt.unitFromLocalnameRequired("MI3"),
  // Pascal Metre per Square Second
  PA__M__PER__SEC2: Qudt.unitFromLocalnameRequired("PA-M-PER-SEC2"),
  // Pound Mass Second per Cubic Inch Cubic Foot
  LB__SEC__PER__IN3__FT3: Qudt.unitFromLocalnameRequired("LB-SEC-PER-IN3-FT3"),
  // Serbian Dinar
  CCY_RSD: Qudt.unitFromLocalnameRequired("CCY_RSD"),
  // Kayser
  KY: Qudt.unitFromLocalnameRequired("KY"),
  // British Thermal Unit (international Definition) per Hour
  BTU_IT__PER__HR: Qudt.unitFromLocalnameRequired("BTU_IT-PER-HR"),
  // Bel
  B: Qudt.unitFromLocalnameRequired("B"),
  // Milligram per Hour Kelvin
  MilliGM__PER__HR__K: Qudt.unitFromLocalnameRequired("MilliGM-PER-HR-K"),
  // Newton Metre Watt to the Power Minus 0.5
  N__M__PER__W0dot5: Qudt.unitFromLocalnameRequired("N-M-PER-W0dot5"),
  // Megavolt Ampere
  MegaV__A: Qudt.unitFromLocalnameRequired("MegaV-A"),
  // Picolitre
  PicoL: Qudt.unitFromLocalnameRequired("PicoL"),
  // Pound Mass Square Inch per Gallon (UK) Pound Force Second
  LB__IN2__PER__GAL_UK__LB_F__SEC: Qudt.unitFromLocalnameRequired(
    "LB-IN2-PER-GAL_UK-LB_F-SEC"
  ),
  // Square Centimetre per Volt Second
  CentiM2__PER__V__SEC: Qudt.unitFromLocalnameRequired("CentiM2-PER-V-SEC"),
  // Nanomole per Gram Hour
  NanoMOL__PER__GM__HR: Qudt.unitFromLocalnameRequired("NanoMOL-PER-GM-HR"),
  // Mega Electron Volt per Speed of Light
  MegaEV__PER__SpeedOfLight: Qudt.unitFromLocalnameRequired(
    "MegaEV-PER-SpeedOfLight"
  ),
  // Standard Cubic Metre
  SCM: Qudt.unitFromLocalnameRequired("SCM"),
  // British Thermal Unit (thermochemical Definition) per Second Square Foot Degree Fahrenheit
  BTU_TH__PER__SEC__FT2__DEG_F: Qudt.unitFromLocalnameRequired(
    "BTU_TH-PER-SEC-FT2-DEG_F"
  ),
  // Kelvin per Square Second
  K__PER__SEC2: Qudt.unitFromLocalnameRequired("K-PER-SEC2"),
  // Cubic Metre per Second
  M3__PER__SEC: Qudt.unitFromLocalnameRequired("M3-PER-SEC"),
  // Centimetre per Kelvin
  CentiM__PER__K: Qudt.unitFromLocalnameRequired("CentiM-PER-K"),
  // Grade
  GR: Qudt.unitFromLocalnameRequired("GR"),
  // Fluid Ounce (UK)
  OZ_VOL_UK: Qudt.unitFromLocalnameRequired("OZ_VOL_UK"),
  // South Korean Won
  CCY_KRW_Currency: Qudt.unitFromLocalnameRequired("CCY_KRW"),
  // Centimetre of Mercury
  CentiM_HG: Qudt.unitFromLocalnameRequired("CentiM_HG"),
  // Lari
  CCY_GEL: Qudt.unitFromLocalnameRequired("CCY_GEL"),
  // Watt Metre per Square Metre Steradian
  W__M__PER__M2__SR: Qudt.unitFromLocalnameRequired("W-M-PER-M2-SR"),
  // Mebibyte
  MebiBYTE: Qudt.unitFromLocalnameRequired("MebiBYTE"),
  // Megatonne
  MegaTONNE: Qudt.unitFromLocalnameRequired("MegaTONNE"),
  // Kilo British Thermal Unit (international Definition) per Hour
  KiloBTU_IT__PER__HR: Qudt.unitFromLocalnameRequired("KiloBTU_IT-PER-HR"),
  // Bar Absolute
  BAR_A: Qudt.unitFromLocalnameRequired("BAR_A"),
  // Volt per Pascal
  V__PER__PA: Qudt.unitFromLocalnameRequired("V-PER-PA"),
  // Micromole per Square Meter
  MicroMOL__PER__M2: Qudt.unitFromLocalnameRequired("MicroMOL-PER-M2"),
  // Rayl
  RAYL: Qudt.unitFromLocalnameRequired("RAYL"),
  // Megaohm per Kilometre
  MegaOHM__PER__KiloM: Qudt.unitFromLocalnameRequired("MegaOHM-PER-KiloM"),
  // Kilogram per Meter Second
  KiloGM__PER__M__SEC: Qudt.unitFromLocalnameRequired("KiloGM-PER-M-SEC"),
  // Hryvnia
  CCY_UAH_Currency: Qudt.unitFromLocalnameRequired("CCY_UAH"),
  // Gram per Hour Bar
  GM__PER__HR__BAR: Qudt.unitFromLocalnameRequired("GM-PER-HR-BAR"),
  // Bushel (US Dry) per Day
  BU_US_DRY__PER__DAY: Qudt.unitFromLocalnameRequired("BU_US_DRY-PER-DAY"),
  // Peck (UK) per Minute
  PK_UK__PER__MIN: Qudt.unitFromLocalnameRequired("PK_UK-PER-MIN"),
  // Gram per Liter Poise
  GM__PER__L__POISE: Qudt.unitFromLocalnameRequired("GM-PER-L-POISE"),
  // Guyana Dollar
  CCY_GYD_Currency: Qudt.unitFromLocalnameRequired("CCY_GYD"),
  // Kwanza
  CCY_AOA_Currency: Qudt.unitFromLocalnameRequired("CCY_AOA"),
  // Radian Square Meter per Kilogram
  RAD__M2__PER__KiloGM: Qudt.unitFromLocalnameRequired("RAD-M2-PER-KiloGM"),
  // KiloVolt Ampere Reactive
  KiloV__A_Reactive: Qudt.unitFromLocalnameRequired("KiloV-A_Reactive"),
  // Biot
  BIOT: Qudt.unitFromLocalnameRequired("BIOT"),
  // Kilogram per Cubic Decimeter Bar
  KiloGM__PER__DeciM3__BAR: Qudt.unitFromLocalnameRequired(
    "KiloGM-PER-DeciM3-BAR"
  ),
  // Microgram per Milligram
  MicroGM__PER__MilliGM: Qudt.unitFromLocalnameRequired("MicroGM-PER-MilliGM"),
  // Billion (Long Scale)
  BILLION_Long: Qudt.unitFromLocalnameRequired("BILLION_Long"),
  // Microtorr
  MicroTORR: Qudt.unitFromLocalnameRequired("MicroTORR"),
  // Megabaud
  MegaBAUD: Qudt.unitFromLocalnameRequired("MegaBAUD"),
  // Us Peck per Day
  PK_US_DRY__PER__DAY: Qudt.unitFromLocalnameRequired("PK_US_DRY-PER-DAY"),
  // Reciprocal Mille Psi
  PER__MILLE__PSI: Qudt.unitFromLocalnameRequired("PER-MILLE-PSI"),
  // Millilitre per Square Metre Day
  MilliL__PER__M2__DAY: Qudt.unitFromLocalnameRequired("MilliL-PER-M2-DAY"),
  // Tebibit per Square Meter
  TebiBIT__PER__M2: Qudt.unitFromLocalnameRequired("TebiBIT-PER-M2"),
  // Leone
  CCY_SLE_Currency: Qudt.unitFromLocalnameRequired("CCY_SLE"),
  // Kroon
  CCY_EEK: Qudt.unitFromLocalnameRequired("CCY_EEK"),
  // British Thermal Unit (international Definition) Inch per Square Foot Hour Degree Fahrenheit
  BTU_IT__IN__PER__FT2__HR__DEG_F: Qudt.unitFromLocalnameRequired(
    "BTU_IT-IN-PER-FT2-HR-DEG_F"
  ),
  // Bangladeshi Taka
  CCY_BDT: Qudt.unitFromLocalnameRequired("CCY_BDT"),
  // Foot Poundal
  FT__PDL: Qudt.unitFromLocalnameRequired("FT-PDL"),
  // Fermi
  FM: Qudt.unitFromLocalnameRequired("FM"),
  // Microkatal
  MicroKAT: Qudt.unitFromLocalnameRequired("MicroKAT"),
  // Degree Fahrenheit per Kelvin
  DEG_F__PER__K: Qudt.unitFromLocalnameRequired("DEG_F-PER-K"),
  // Gigawatt Hour
  GigaW__HR: Qudt.unitFromLocalnameRequired("GigaW-HR"),
  // Millimetre of Mercury - Absolute
  MilliM_HGA: Qudt.unitFromLocalnameRequired("MilliM_HGA"),
  // Picofarad per Meter
  PicoFARAD__PER__M: Qudt.unitFromLocalnameRequired("PicoFARAD-PER-M"),
  // FRAME
  FRAME: Qudt.unitFromLocalnameRequired("FRAME"),
  // Gold (one Troy Ounce)
  CCY_XAU: Qudt.unitFromLocalnameRequired("CCY_XAU"),
  // Pound Force per Inch
  LB_F__PER__IN: Qudt.unitFromLocalnameRequired("LB_F-PER-IN"),
  // Milligram Minute per Cubic Metre Litre
  MilliGM__MIN__PER__M3__L: Qudt.unitFromLocalnameRequired(
    "MilliGM-MIN-PER-M3-L"
  ),
  // Millipascal per Metre
  MilliPA__PER__M: Qudt.unitFromLocalnameRequired("MilliPA-PER-M"),
  // Milliwatt per Square Metre
  MilliW__PER__M2: Qudt.unitFromLocalnameRequired("MilliW-PER-M2"),
  // Micromole per Mole
  MicroMOL__PER__MOL: Qudt.unitFromLocalnameRequired("MicroMOL-PER-MOL"),
  // Kilojoule per Kilogram
  KiloJ__PER__KiloGM: Qudt.unitFromLocalnameRequired("KiloJ-PER-KiloGM"),
  // European Monetary Unit (e.m.u.-6) (bonds Market Unit)
  CCY_XBB_Currency: Qudt.unitFromLocalnameRequired("CCY_XBB"),
  // Millimole per Kilogram
  MilliMOL__PER__KiloGM: Qudt.unitFromLocalnameRequired("MilliMOL-PER-KiloGM"),
  // Kilogram per Pascal Second Meter
  KiloGM__PER__PA__SEC__M: Qudt.unitFromLocalnameRequired(
    "KiloGM-PER-PA-SEC-M"
  ),
  // Acre Us Survey Foot
  AC__FT_US: Qudt.unitFromLocalnameRequired("AC-FT_US"),
  // Mole per Square Metre Second Metre
  MOL__PER__M2__SEC__M: Qudt.unitFromLocalnameRequired("MOL-PER-M2-SEC-M"),
  // Degree Fahrenheit Hour per British Thermal Unit (thermochemical Definition)
  DEG_F__HR__PER__BTU_TH: Qudt.unitFromLocalnameRequired("DEG_F-HR-PER-BTU_TH"),
  // Mil Angle (nato)
  MIL: Qudt.unitFromLocalnameRequired("MIL"),
  // Milligram Second per Cubic Metre Litre
  MilliGM__SEC__PER__M3__L: Qudt.unitFromLocalnameRequired(
    "MilliGM-SEC-PER-M3-L"
  ),
  // Degree Baume (origin Scale)
  DEGREE_BAUME: Qudt.unitFromLocalnameRequired("DEGREE_BAUME"),
  // Exavolt
  ExaV: Qudt.unitFromLocalnameRequired("ExaV"),
  // Pound Mass per Minute Degree Fahrenheit
  LB__PER__MIN__DEG_F: Qudt.unitFromLocalnameRequired("LB-PER-MIN-DEG_F"),
  // Volt Ampere Hour
  V__A__HR: Qudt.unitFromLocalnameRequired("V-A-HR"),
  // Moldovan Leu
  CCY_MDL: Qudt.unitFromLocalnameRequired("CCY_MDL"),
  // Tonne per Day Kelvin
  TONNE__PER__DAY__K: Qudt.unitFromLocalnameRequired("TONNE-PER-DAY-K"),
  // Reciprocal Milliliter
  PER__MilliL: Qudt.unitFromLocalnameRequired("PER-MilliL"),
  // Coulomb per Cubic Metre
  C__PER__M3: Qudt.unitFromLocalnameRequired("C-PER-M3"),
  // Gram per Hertz
  GM__PER__HZ: Qudt.unitFromLocalnameRequired("GM-PER-HZ"),
  // Leone
  CCY_SLE: Qudt.unitFromLocalnameRequired("CCY_SLE"),
  // Curie
  CI: Qudt.unitFromLocalnameRequired("CI"),
  // Poundal Second per Square Inch
  PDL__SEC__PER__IN2: Qudt.unitFromLocalnameRequired("PDL-SEC-PER-IN2"),
  // Reciprocal Second Steradian Square Meter
  PER__SEC__SR__M2: Qudt.unitFromLocalnameRequired("PER-SEC-SR-M2"),
  // Deciliter
  DeciL: Qudt.unitFromLocalnameRequired("DeciL"),
  // Lao Kip
  CCY_LAK_Currency: Qudt.unitFromLocalnameRequired("CCY_LAK"),
  // Micronewton
  MicroN: Qudt.unitFromLocalnameRequired("MicroN"),
  // Cubic Metre per Minute
  M3__PER__MIN: Qudt.unitFromLocalnameRequired("M3-PER-MIN"),
  // Ampere per Pascal
  A__PER__PA: Qudt.unitFromLocalnameRequired("A-PER-PA"),
  // Liter per Hour Bar
  L__PER__HR__BAR: Qudt.unitFromLocalnameRequired("L-PER-HR-BAR"),
  // Microsiemens per Centimetre
  MicroS__PER__CentiM: Qudt.unitFromLocalnameRequired("MicroS-PER-CentiM"),
  // Millisiemens
  MilliS: Qudt.unitFromLocalnameRequired("MilliS"),
  // Percent per Poise
  PERCENT__PER__POISE: Qudt.unitFromLocalnameRequired("PERCENT-PER-POISE"),
  // Malawi Kwacha
  CCY_MWK_Currency: Qudt.unitFromLocalnameRequired("CCY_MWK"),
  // Cubic Inch per Minute
  IN3__PER__MIN: Qudt.unitFromLocalnameRequired("IN3-PER-MIN"),
  // Femtoampere
  FemtoA: Qudt.unitFromLocalnameRequired("FemtoA"),
  // Cubic Decimetre per Minute
  DeciM3__PER__MIN: Qudt.unitFromLocalnameRequired("DeciM3-PER-MIN"),
  // Vietnamese ??ng
  CCY_VND_Currency: Qudt.unitFromLocalnameRequired("CCY_VND"),
  // Cfp Franc
  CCY_XPF: Qudt.unitFromLocalnameRequired("CCY_XPF"),
  // Cubic Metre per Hour Kelvin
  M3__PER__HR__K: Qudt.unitFromLocalnameRequired("M3-PER-HR-K"),
  // Gallon (UK) per Minute
  GAL_UK__PER__MIN: Qudt.unitFromLocalnameRequired("GAL_UK-PER-MIN"),
  // Kilogram Square Millimetre
  KiloGM__MilliM2: Qudt.unitFromLocalnameRequired("KiloGM-MilliM2"),
  // Square Second
  SEC2: Qudt.unitFromLocalnameRequired("SEC2"),
  // Ton (UK)
  TON_UK: Qudt.unitFromLocalnameRequired("TON_UK"),
  // Barrel (US)
  BBL_US: Qudt.unitFromLocalnameRequired("BBL_US"),
  // Cubic Millimetre per Kilogram
  MilliM3__PER__KiloGM: Qudt.unitFromLocalnameRequired("MilliM3-PER-KiloGM"),
  // Percent per Year
  PERCENT__PER__YR: Qudt.unitFromLocalnameRequired("PERCENT-PER-YR"),
  // Candela per Kilolumen
  CD__PER__KiloLM: Qudt.unitFromLocalnameRequired("CD-PER-KiloLM"),
  // Percent Minute per Us Gallon
  PERCENT__MIN__PER__GAL_US: Qudt.unitFromLocalnameRequired(
    "PERCENT-MIN-PER-GAL_US"
  ),
  // Pound Force per Foot
  LB_F__PER__FT: Qudt.unitFromLocalnameRequired("LB_F-PER-FT"),
  // Peck (UK) per Hour
  PK_UK__PER__HR: Qudt.unitFromLocalnameRequired("PK_UK-PER-HR"),
  // Kilocalorie per Square Centimetre Second
  KiloCAL__PER__CentiM2__SEC: Qudt.unitFromLocalnameRequired(
    "KiloCAL-PER-CentiM2-SEC"
  ),
  // Ton (UK) per Day
  TON_UK__PER__DAY: Qudt.unitFromLocalnameRequired("TON_UK-PER-DAY"),
  // Nanoohm
  NanoOHM: Qudt.unitFromLocalnameRequired("NanoOHM"),
  // Ton (US)
  TON_US: Qudt.unitFromLocalnameRequired("TON_US"),
  // Mho
  MHO: Qudt.unitFromLocalnameRequired("MHO"),
  // Megasecond
  MegaSEC: Qudt.unitFromLocalnameRequired("MegaSEC"),
  // Millikelvin per Kelvin
  MilliK__PER__K: Qudt.unitFromLocalnameRequired("MilliK-PER-K"),
  // Number per Second
  NUM__PER__SEC: Qudt.unitFromLocalnameRequired("NUM-PER-SEC"),
  // Pound Mass Hour per Gallon (UK) Cubic Yard
  LB__HR__PER__GAL_UK__YD3: Qudt.unitFromLocalnameRequired(
    "LB-HR-PER-GAL_UK-YD3"
  ),
  // Kina
  CCY_PGK_Currency: Qudt.unitFromLocalnameRequired("CCY_PGK"),
  // Percent Minute per Cubic Metre
  PERCENT__MIN__PER__M3: Qudt.unitFromLocalnameRequired("PERCENT-MIN-PER-M3"),
  // Teaspoon
  TSP: Qudt.unitFromLocalnameRequired("TSP"),
  // Dyne Meter
  DYN__M: Qudt.unitFromLocalnameRequired("DYN-M"),
  // Milliliter per Gram
  MilliL__PER__GM: Qudt.unitFromLocalnameRequired("MilliL-PER-GM"),
  // Rupiah
  CCY_IDR_Currency: Qudt.unitFromLocalnameRequired("CCY_IDR"),
  // Rwanda Franc
  CCY_RWF: Qudt.unitFromLocalnameRequired("CCY_RWF"),
  // Degree Fahrenheit Hour per British Thermal Unit (international Definition)
  DEG_F__HR__PER__BTU_IT: Qudt.unitFromLocalnameRequired("DEG_F-HR-PER-BTU_IT"),
  // Meter Second
  M__SEC: Qudt.unitFromLocalnameRequired("M-SEC"),
  // Nano Volt Ampere Reactive
  NanoVAR: Qudt.unitFromLocalnameRequired("NanoVAR"),
  // British Thermal Unit (international Definition) per Pound Mole
  BTU_IT__PER__MOL_LB: Qudt.unitFromLocalnameRequired("BTU_IT-PER-MOL_LB"),
  // Megaliter
  MegaL: Qudt.unitFromLocalnameRequired("MegaL"),
  // Square Microsiemens per Square Centimetre
  MicroS2__PER__CentiM2: Qudt.unitFromLocalnameRequired("MicroS2-PER-CentiM2"),
  // Reciprocal Kilogram Second
  PER__KiloGM__SEC: Qudt.unitFromLocalnameRequired("PER-KiloGM-SEC"),
  // Milligram per Gram
  MilliGM__PER__GM: Qudt.unitFromLocalnameRequired("MilliGM-PER-GM"),
  // Square Metre per Hertz Degree
  M2__PER__HZ__DEG: Qudt.unitFromLocalnameRequired("M2-PER-HZ-DEG"),
  // Pakistan Rupee
  CCY_PKR: Qudt.unitFromLocalnameRequired("CCY_PKR"),
  // Planck Volt
  PlanckVolt: Qudt.unitFromLocalnameRequired("PlanckVolt"),
  // Grain per Imperial Gallon
  GRAIN__PER__GAL_IMP: Qudt.unitFromLocalnameRequired("GRAIN-PER-GAL_IMP"),
  // Gram per Cubic Centimetre
  GM__PER__CentiM3: Qudt.unitFromLocalnameRequired("GM-PER-CentiM3"),
  // Cubic Inch
  IN3: Qudt.unitFromLocalnameRequired("IN3"),
  // Pound Mass Second per Sextic Inch
  LB__SEC__PER__IN6: Qudt.unitFromLocalnameRequired("LB-SEC-PER-IN6"),
  // Pound Mole per Pound Mass
  MOL_LB__PER__LB: Qudt.unitFromLocalnameRequired("MOL_LB-PER-LB"),
  // Bar per Bar
  BAR__PER__BAR: Qudt.unitFromLocalnameRequired("BAR-PER-BAR"),
  // Mega Ton of Oil Equivalent
  MegaTOE: Qudt.unitFromLocalnameRequired("MegaTOE"),
  // Petabecquerel
  PetaBQ: Qudt.unitFromLocalnameRequired("PetaBQ"),
  // Moroccan Dirham
  CCY_MAD: Qudt.unitFromLocalnameRequired("CCY_MAD"),
  // Minute Angle
  MIN_Angle: Qudt.unitFromLocalnameRequired("MIN_Angle"),
  // Percent per Centipoise
  PERCENT__PER__CentiPOISE: Qudt.unitFromLocalnameRequired(
    "PERCENT-PER-CentiPOISE"
  ),
  // Square Metre per Second Bar
  M2__PER__SEC__BAR: Qudt.unitFromLocalnameRequired("M2-PER-SEC-BAR"),
  // Tera Volt Ampere Reactive
  TeraVAR: Qudt.unitFromLocalnameRequired("TeraVAR"),
  // Reciprocal Pound Mass
  PER__LB: Qudt.unitFromLocalnameRequired("PER-LB"),
  // Boliviano
  CCY_BOB: Qudt.unitFromLocalnameRequired("CCY_BOB"),
  // Tenge
  CCY_KZT: Qudt.unitFromLocalnameRequired("CCY_KZT"),
  // Tonne per Minute Kelvin
  TONNE__PER__MIN__K: Qudt.unitFromLocalnameRequired("TONNE-PER-MIN-K"),
  // Picogram per Milligram
  PicoGM__PER__MilliGM: Qudt.unitFromLocalnameRequired("PicoGM-PER-MilliGM"),
  // Armenian Dram
  CCY_AMD_Currency: Qudt.unitFromLocalnameRequired("CCY_AMD"),
  // Brazilian Real
  CCY_BRL: Qudt.unitFromLocalnameRequired("CCY_BRL"),
  // Kilo Electron Volt
  KiloEV: Qudt.unitFromLocalnameRequired("KiloEV"),
  // British Thermal Unit (thermochemical Definition) per Second
  BTU_TH__PER__SEC: Qudt.unitFromLocalnameRequired("BTU_TH-PER-SEC"),
  // Reciprocal Psi
  PER__PSI: Qudt.unitFromLocalnameRequired("PER-PSI"),
  // Dyne Second per Quintic Centimeter
  DYN__SEC__PER__CentiM5: Qudt.unitFromLocalnameRequired("DYN-SEC-PER-CentiM5"),
  // Centimeter per Second
  CentiM__PER__SEC: Qudt.unitFromLocalnameRequired("CentiM-PER-SEC"),
  // Ohm Square Meter per Meter
  OHM__M2__PER__M: Qudt.unitFromLocalnameRequired("OHM-M2-PER-M"),
  // Volt per Square Meter
  V__PER__M2: Qudt.unitFromLocalnameRequired("V-PER-M2"),
  // Bushel (US Dry) per Hour
  BU_US_DRY__PER__HR: Qudt.unitFromLocalnameRequired("BU_US_DRY-PER-HR"),
  // United Arab Emirates Dirham
  CCY_AED: Qudt.unitFromLocalnameRequired("CCY_AED"),
  // Mole per Kilogram Pascal
  MOL__PER__KiloGM__PA: Qudt.unitFromLocalnameRequired("MOL-PER-KiloGM-PA"),
  // Quad
  QUAD: Qudt.unitFromLocalnameRequired("QUAD"),
  // International Unit per Milligram
  IU__PER__MilliGM: Qudt.unitFromLocalnameRequired("IU-PER-MilliGM"),
  // Unknown
  UNKNOWN: Qudt.unitFromLocalnameRequired("UNKNOWN"),
  // Som
  CCY_KGS: Qudt.unitFromLocalnameRequired("CCY_KGS"),
  // Terabyte
  TeraBYTE: Qudt.unitFromLocalnameRequired("TeraBYTE"),
  // Newton per Millimetre
  N__PER__MilliM: Qudt.unitFromLocalnameRequired("N-PER-MilliM"),
  // Watt per Steradian
  W__PER__SR: Qudt.unitFromLocalnameRequired("W-PER-SR"),
  // Uic Franc (special Settlement Currency)
  CCY_XFU_Currency: Qudt.unitFromLocalnameRequired("CCY_XFU"),
  // Litre per Second Square Metre
  L__PER__SEC__M2: Qudt.unitFromLocalnameRequired("L-PER-SEC-M2"),
  // Nanogram per Cubic Metre
  NanoGM__PER__M3: Qudt.unitFromLocalnameRequired("NanoGM-PER-M3"),
  // Kilosiemens
  KiloS: Qudt.unitFromLocalnameRequired("KiloS"),
  // New Taiwan Dollar
  CCY_TWD: Qudt.unitFromLocalnameRequired("CCY_TWD"),
  // Romanian New Leu
  CCY_RON_Currency: Qudt.unitFromLocalnameRequired("CCY_RON"),
  // Yemeni Rial
  CCY_YER: Qudt.unitFromLocalnameRequired("CCY_YER"),
  // Degree per Meter
  DEG__PER__M: Qudt.unitFromLocalnameRequired("DEG-PER-M"),
  // Swiss Franc per Kilowatt Hour
  CCY_CHF__PER__KiloW__HR: Qudt.unitFromLocalnameRequired(
    "CCY_CHF-PER-KiloW-HR"
  ),
  // British Thermal Unit (international Definition) per Square Foot Hour Degree Fahrenheit
  BTU_IT__PER__FT2__HR__DEG_F: Qudt.unitFromLocalnameRequired(
    "BTU_IT-PER-FT2-HR-DEG_F"
  ),
  // Elementary Charge
  ElementaryCharge: Qudt.unitFromLocalnameRequired("ElementaryCharge"),
  // Second per Cubic Metre Radian
  SEC__PER__M3__RAD: Qudt.unitFromLocalnameRequired("SEC-PER-M3-RAD"),
  // Watt per Square Meter Nanometer Steradian
  W__PER__M2__NanoM__SR: Qudt.unitFromLocalnameRequired("W-PER-M2-NanoM-SR"),
  // Loti
  CCY_LSL: Qudt.unitFromLocalnameRequired("CCY_LSL"),
  // Gigaohm
  GigaOHM: Qudt.unitFromLocalnameRequired("GigaOHM"),
  // Cubic Metre per Minute Bar
  M3__PER__MIN__BAR: Qudt.unitFromLocalnameRequired("M3-PER-MIN-BAR"),
  // Nanosiemens per Metre
  NanoS__PER__M: Qudt.unitFromLocalnameRequired("NanoS-PER-M"),
  // Percent per Month
  PERCENT__PER__MO: Qudt.unitFromLocalnameRequired("PERCENT-PER-MO"),
  // Kilogram per Hour Kelvin
  KiloGM__PER__HR__K: Qudt.unitFromLocalnameRequired("KiloGM-PER-HR-K"),
  // Square Degree Celsius
  DEG_C2: Qudt.unitFromLocalnameRequired("DEG_C2"),
  // Reciprocal Week
  PER__WK: Qudt.unitFromLocalnameRequired("PER-WK"),
  // Milligram per Cubic Metre Centipoise
  MilliGM__PER__M3__CentiPOISE: Qudt.unitFromLocalnameRequired(
    "MilliGM-PER-M3-CentiPOISE"
  ),
  // Microtesla
  MicroT: Qudt.unitFromLocalnameRequired("MicroT"),
  // Millilitre
  MilliL: Qudt.unitFromLocalnameRequired("MilliL"),
  // Pferdestaerke
  PFERDESTAERKE: Qudt.unitFromLocalnameRequired("PFERDESTAERKE"),
  // Picomole per Kilogram
  PicoMOL__PER__KiloGM: Qudt.unitFromLocalnameRequired("PicoMOL-PER-KiloGM"),
  // Horsepower (brake)
  HP_Brake: Qudt.unitFromLocalnameRequired("HP_Brake"),
  // Ounce Mass per Square Yard
  OZ__PER__YD2: Qudt.unitFromLocalnameRequired("OZ-PER-YD2"),
  // Dalton
  Da: Qudt.unitFromLocalnameRequired("Da"),
  // Kilogram per Cubic Decimeter Kelvin
  KiloGM__PER__DeciM3__K: Qudt.unitFromLocalnameRequired("KiloGM-PER-DeciM3-K"),
  // Microgalileo per metre
  MicroGALILEO__PER__M: Qudt.unitFromLocalnameRequired("MicroGALILEO-PER-M"),
  // CYC
  CYC: Qudt.unitFromLocalnameRequired("CYC"),
  // Square Decimetre
  DeciM2: Qudt.unitFromLocalnameRequired("DeciM2"),
  // Reciprocal Cubic Foot
  PER__FT3: Qudt.unitFromLocalnameRequired("PER-FT3"),
  // Reciprocal Ton
  PER__TON: Qudt.unitFromLocalnameRequired("PER-TON"),
  // Rial Omani
  CCY_OMR_Currency: Qudt.unitFromLocalnameRequired("CCY_OMR"),
  // Giga Floating Point Operations per Second
  GigaFLOPS: Qudt.unitFromLocalnameRequired("GigaFLOPS"),
  // Cubic Centimetre per Mole
  CentiM3__PER__MOL: Qudt.unitFromLocalnameRequired("CentiM3-PER-MOL"),
  // Centigram
  CentiGM: Qudt.unitFromLocalnameRequired("CentiGM"),
  // Parts per Million per Kelvin
  PPM__PER__K: Qudt.unitFromLocalnameRequired("PPM-PER-K"),
  // Curie
  Ci: Qudt.unitFromLocalnameRequired("Ci"),
  // Mexican Peso
  CCY_MXN_Currency: Qudt.unitFromLocalnameRequired("CCY_MXN"),
  // Megaohm per Kelvin
  MegaOHM__PER__K: Qudt.unitFromLocalnameRequired("MegaOHM-PER-K"),
  // Micrometre per Kelvin
  MicroM__PER__K: Qudt.unitFromLocalnameRequired("MicroM-PER-K"),
  // Millivolt Ampere per Kelvin
  MilliV__A__PER__K: Qudt.unitFromLocalnameRequired("MilliV-A-PER-K"),
  // Percent per Hundred
  PERCENT__PER__HUNDRED: Qudt.unitFromLocalnameRequired("PERCENT-PER-HUNDRED"),
  // Slovak Koruna
  CCY_SKK_Currency: Qudt.unitFromLocalnameRequired("CCY_SKK"),
  // MilliVolt Ampere Reactive
  MilliV__A_Reactive: Qudt.unitFromLocalnameRequired("MilliV-A_Reactive"),
  // Centilitre
  CentiL: Qudt.unitFromLocalnameRequired("CentiL"),
  // Pound Mass Minute per Cubic Inch Us Gallon
  LB__MIN__PER__IN3__GAL_US: Qudt.unitFromLocalnameRequired(
    "LB-MIN-PER-IN3-GAL_US"
  ),
  // Sudanese Pound
  CCY_SDG: Qudt.unitFromLocalnameRequired("CCY_SDG"),
  // Meter per Second Pascal
  M__PER__SEC__PA: Qudt.unitFromLocalnameRequired("M-PER-SEC-PA"),
  // Millibecquerel per Gram
  MilliBQ__PER__GM: Qudt.unitFromLocalnameRequired("MilliBQ-PER-GM"),
  // Slug per Foot
  SLUG__PER__FT: Qudt.unitFromLocalnameRequired("SLUG-PER-FT"),
  // Cubic Yard per Day
  YD3__PER__DAY: Qudt.unitFromLocalnameRequired("YD3-PER-DAY"),
  // Milliroentgen
  MilliR: Qudt.unitFromLocalnameRequired("MilliR"),
  // Hour per Year
  HR__PER__YR: Qudt.unitFromLocalnameRequired("HR-PER-YR"),
  // Pound Mass Hour per Cubic Foot Us Gallon
  LB__HR__PER__FT3__GAL_US: Qudt.unitFromLocalnameRequired(
    "LB-HR-PER-FT3-GAL_US"
  ),
  // Percent Square Inch per Pound Force Second
  PERCENT__IN2__PER__LB_F__SEC: Qudt.unitFromLocalnameRequired(
    "PERCENT-IN2-PER-LB_F-SEC"
  ),
  // Ton (US) per Day
  TON_US__PER__DAY: Qudt.unitFromLocalnameRequired("TON_US-PER-DAY"),
  // Minute per Number
  MIN__PER__NUM: Qudt.unitFromLocalnameRequired("MIN-PER-NUM"),
  // Zloty
  CCY_PLN_Currency: Qudt.unitFromLocalnameRequired("CCY_PLN"),
  // Brunei Dollar
  CCY_BND: Qudt.unitFromLocalnameRequired("CCY_BND"),
  // Newton Square Meter per Ampere
  N__M2__PER__A: Qudt.unitFromLocalnameRequired("N-M2-PER-A"),
  // Liter per Hour
  L__PER__HR: Qudt.unitFromLocalnameRequired("L-PER-HR"),
  // Byte per Second
  BYTE__PER__SEC: Qudt.unitFromLocalnameRequired("BYTE-PER-SEC"),
  // Exabit
  ExaBIT: Qudt.unitFromLocalnameRequired("ExaBIT"),
  // Megagram per Hectare
  MegaGM__PER__HA: Qudt.unitFromLocalnameRequired("MegaGM-PER-HA"),
  // Hong Kong Dollar
  CCY_HKD_Currency: Qudt.unitFromLocalnameRequired("CCY_HKD"),
  // Petavolt Ampere
  PetaV__A: Qudt.unitFromLocalnameRequired("PetaV-A"),
  // Microjoule per Second
  MicroJ__PER__SEC: Qudt.unitFromLocalnameRequired("MicroJ-PER-SEC"),
  // Percent per Decakelvin
  PERCENT__PER__DecaK: Qudt.unitFromLocalnameRequired("PERCENT-PER-DecaK"),
  // Cubic Centimetre per Second
  CentiM3__PER__SEC: Qudt.unitFromLocalnameRequired("CentiM3-PER-SEC"),
  // Kilo Pound Force per Square Inch
  KiloLB_F__PER__IN2: Qudt.unitFromLocalnameRequired("KiloLB_F-PER-IN2"),
  // Revolution per Minute Second
  REV__PER__MIN__SEC: Qudt.unitFromLocalnameRequired("REV-PER-MIN-SEC"),
  // Degree Celsius Day
  DEG_C__DAY: Qudt.unitFromLocalnameRequired("DEG_C-DAY"),
  // Kilogram per Metre Hour
  KiloGM__PER__M__HR: Qudt.unitFromLocalnameRequired("KiloGM-PER-M-HR"),
  // Milliinch
  MilliIN: Qudt.unitFromLocalnameRequired("MilliIN"),
  // Ounce Mass Hour per Cubic Inch Cubic Yard
  OZ__HR__PER__IN3__YD3: Qudt.unitFromLocalnameRequired("OZ-HR-PER-IN3-YD3"),
  // Joule per Gram Degree Celsius
  J__PER__GM__DEG_C: Qudt.unitFromLocalnameRequired("J-PER-GM-DEG_C"),
  // Reciprocal Metre
  PER__M: Qudt.unitFromLocalnameRequired("PER-M"),
  // Kilogram Kelvin
  KiloGM__K: Qudt.unitFromLocalnameRequired("KiloGM-K"),
  // Micrometre
  MicroM: Qudt.unitFromLocalnameRequired("MicroM"),
  // Megabit per Second
  MegaBIT__PER__SEC: Qudt.unitFromLocalnameRequired("MegaBIT-PER-SEC"),
  // Square Micrometre
  MicroM2: Qudt.unitFromLocalnameRequired("MicroM2"),
  // Hectobar
  HectoBAR: Qudt.unitFromLocalnameRequired("HectoBAR"),
  // Centinewton Meter
  CentiN__M: Qudt.unitFromLocalnameRequired("CentiN-M"),
  // Reciprocal Hour
  PER__HR: Qudt.unitFromLocalnameRequired("PER-HR"),
  // Perm (0 °C)
  PERM_0DEG_C: Qudt.unitFromLocalnameRequired("PERM_0DEG_C"),
  // Libyan Dinar
  CCY_LYD: Qudt.unitFromLocalnameRequired("CCY_LYD"),
  // Therm (ec)
  THERM_EC: Qudt.unitFromLocalnameRequired("THERM_EC"),
  // Millikatal
  MilliKAT: Qudt.unitFromLocalnameRequired("MilliKAT"),
  // Abampere
  A_Ab: Qudt.unitFromLocalnameRequired("A_Ab"),
  // Unidad De Valor Real
  CCY_COU_Currency: Qudt.unitFromLocalnameRequired("CCY_COU"),
  // Gram per Millimetre Bar
  GM__PER__MilliM__BAR: Qudt.unitFromLocalnameRequired("GM-PER-MilliM-BAR"),
  // Vietnamese ??ng
  CCY_VND: Qudt.unitFromLocalnameRequired("CCY_VND"),
  // Cape Verde Escudo
  CCY_CVE: Qudt.unitFromLocalnameRequired("CCY_CVE"),
  // Relative Permeability
  PERMEABILITY_REL: Qudt.unitFromLocalnameRequired("PERMEABILITY_REL"),
  // Milligram per Decilitre
  MilliGM__PER__DeciL: Qudt.unitFromLocalnameRequired("MilliGM-PER-DeciL"),
  // Terawatt Hour per Year
  TeraW__HR__PER__YR: Qudt.unitFromLocalnameRequired("TeraW-HR-PER-YR"),
  // Pound Mass Degree Fahrenheit
  LB__DEG_F: Qudt.unitFromLocalnameRequired("LB-DEG_F"),
  // Percent Minute per Gallon (UK)
  PERCENT__MIN__PER__GAL_UK: Qudt.unitFromLocalnameRequired(
    "PERCENT-MIN-PER-GAL_UK"
  ),
  // Millibar per Bar
  MilliBAR__PER__BAR: Qudt.unitFromLocalnameRequired("MilliBAR-PER-BAR"),
  // Ounce Mass per Day
  OZ__PER__DAY: Qudt.unitFromLocalnameRequired("OZ-PER-DAY"),
  // Standard
  STANDARD: Qudt.unitFromLocalnameRequired("STANDARD"),
  // Picowatt
  PicoW: Qudt.unitFromLocalnameRequired("PicoW"),
  // Volt Ampere Reactive per Kelvin
  V__A_Reactive__PER__K: Qudt.unitFromLocalnameRequired("V-A_Reactive-PER-K"),
  // Namibian Dollar
  CCY_NAD: Qudt.unitFromLocalnameRequired("CCY_NAD"),
  // Gallon (UK)
  GAL_UK: Qudt.unitFromLocalnameRequired("GAL_UK"),
  // Coulomb per Mole
  C__PER__MOL: Qudt.unitFromLocalnameRequired("C-PER-MOL"),
  // Becquerel per Square Meter
  BQ__PER__M2: Qudt.unitFromLocalnameRequired("BQ-PER-M2"),
  // Chilean Peso
  CCY_CLP_Currency: Qudt.unitFromLocalnameRequired("CCY_CLP"),
  // Mil Length
  MilLength: Qudt.unitFromLocalnameRequired("MilLength"),
  // European Unit of Account 9 (e.u.a.-9) (bonds Market Unit)
  CCY_XBC_Currency: Qudt.unitFromLocalnameRequired("CCY_XBC"),
  // Erg
  ERG: Qudt.unitFromLocalnameRequired("ERG"),
  // Hour
  HR: Qudt.unitFromLocalnameRequired("HR"),
  // Metre per Hour
  M__PER__HR: Qudt.unitFromLocalnameRequired("M-PER-HR"),
  // Barn per Electron Volt
  BARN__PER__EV: Qudt.unitFromLocalnameRequired("BARN-PER-EV"),
  // British Thermal Unit (international Definition) per Pound Force
  BTU_IT__PER__LB_F: Qudt.unitFromLocalnameRequired("BTU_IT-PER-LB_F"),
  // Gram per Hour
  GM__PER__HR: Qudt.unitFromLocalnameRequired("GM-PER-HR"),
  // Kilonewton Metre per Metre
  KiloN__M__PER__M: Qudt.unitFromLocalnameRequired("KiloN-M-PER-M"),
  // Watt per Square Meter Micrometer
  W__PER__M2__MicroM: Qudt.unitFromLocalnameRequired("W-PER-M2-MicroM"),
  // Djibouti Franc
  CCY_DJF_Currency: Qudt.unitFromLocalnameRequired("CCY_DJF"),
  // Tesla
  T: Qudt.unitFromLocalnameRequired("T"),
  // Kilo Volt Ampere
  KiloVA: Qudt.unitFromLocalnameRequired("KiloVA"),
  // Pound Mass Hour per Cubic Inch Cubic Yard
  LB__HR__PER__IN3__YD3: Qudt.unitFromLocalnameRequired("LB-HR-PER-IN3-YD3"),
  // Mega Floating Point Operations per Second
  MegaFLOPS: Qudt.unitFromLocalnameRequired("MegaFLOPS"),
  // Silver (one Troy Ounce)
  CCY_XAG_Currency: Qudt.unitFromLocalnameRequired("CCY_XAG"),
  // Kilovolt Ampere per Kelvin
  KiloV__A__PER__K: Qudt.unitFromLocalnameRequired("KiloV-A-PER-K"),
  // Dry Barrel (US)
  BBL_US_DRY: Qudt.unitFromLocalnameRequired("BBL_US_DRY"),
  // Pound Mass Square Foot per Us Gallon Pound Force Second
  LB__FT2__PER__GAL_US__LB_F__SEC: Qudt.unitFromLocalnameRequired(
    "LB-FT2-PER-GAL_US-LB_F-SEC"
  ),
  // Square Metre per Steradian Joule
  M2__PER__SR__J: Qudt.unitFromLocalnameRequired("M2-PER-SR-J"),
  // Gram per Square Centimetre Year
  GM__PER__CentiM2__YR: Qudt.unitFromLocalnameRequired("GM-PER-CentiM2-YR"),
  // Millijoule
  MilliJ: Qudt.unitFromLocalnameRequired("MilliJ"),
  // Becquerel per Liter
  BQ__PER__L: Qudt.unitFromLocalnameRequired("BQ-PER-L"),
  // Dram (UK)
  DRAM_UK: Qudt.unitFromLocalnameRequired("DRAM_UK"),
  // Mega Us Dollar
  MegaCCY_USD_Currency: Qudt.unitFromLocalnameRequired("MegaCCY_USD"),
  // Megasiemens
  MegaS: Qudt.unitFromLocalnameRequired("MegaS"),
  // Ounce Mass Second per Cubic Inch Cubic Yard
  OZ__SEC__PER__IN3__YD3: Qudt.unitFromLocalnameRequired("OZ-SEC-PER-IN3-YD3"),
  // Peck (UK) per Day
  PK_UK__PER__DAY: Qudt.unitFromLocalnameRequired("PK_UK-PER-DAY"),
  // Pico Volt Ampere Reactive
  PicoVAR: Qudt.unitFromLocalnameRequired("PicoVAR"),
  // Liter per Day
  L__PER__DAY: Qudt.unitFromLocalnameRequired("L-PER-DAY"),
  // Cubic Centimeter per Day Kelvin
  CentiM3__PER__DAY__K: Qudt.unitFromLocalnameRequired("CentiM3-PER-DAY-K"),
  // Acidity
  PH: Qudt.unitFromLocalnameRequired("PH"),
  // Gram per Cubic Meter Centipoise
  GM__PER__M3__CentiPOISE: Qudt.unitFromLocalnameRequired(
    "GM-PER-M3-CentiPOISE"
  ),
  // Microsiemens per Meter
  MicroS__PER__M: Qudt.unitFromLocalnameRequired("MicroS-PER-M"),
  // Milligram per Second
  MilliGM__PER__SEC: Qudt.unitFromLocalnameRequired("MilliGM-PER-SEC"),
  // Kilowatt Hour per Square Metre
  KiloW__HR__PER__M2: Qudt.unitFromLocalnameRequired("KiloW-HR-PER-M2"),
  // Venezuelan Bolvar
  CCY_VES_Currency: Qudt.unitFromLocalnameRequired("CCY_VES"),
  // Decibel per Kilometre
  DeciB__PER__KiloM: Qudt.unitFromLocalnameRequired("DeciB-PER-KiloM"),
  // Kilopascal
  KiloPA: Qudt.unitFromLocalnameRequired("KiloPA"),
  // Pound Mass per Foot
  LB__PER__FT: Qudt.unitFromLocalnameRequired("LB-PER-FT"),
  // Microgram per Deciliter
  MicroGM__PER__DeciL: Qudt.unitFromLocalnameRequired("MicroGM-PER-DeciL"),
  // Nanomole per Square Meter Second
  NanoMOL__PER__M2__SEC: Qudt.unitFromLocalnameRequired("NanoMOL-PER-M2-SEC"),
  // Reciprocal Minute
  PER__MIN: Qudt.unitFromLocalnameRequired("PER-MIN"),
  // MicroVolt Ampere Reactive per Kelvin
  MicroV__A_Reactive__PER__K: Qudt.unitFromLocalnameRequired(
    "MicroV-A_Reactive-PER-K"
  ),
  // Hectocoulomb
  HectoC: Qudt.unitFromLocalnameRequired("HectoC"),
  // Cubic Foot per Minute
  FT3__PER__MIN: Qudt.unitFromLocalnameRequired("FT3-PER-MIN"),
  // Square Pascal Second
  PA2__SEC: Qudt.unitFromLocalnameRequired("PA2-SEC"),
  // Naira
  CCY_NGN_Currency: Qudt.unitFromLocalnameRequired("CCY_NGN"),
  // Millimole per Square Meter Day
  MilliMOL__PER__M2__DAY: Qudt.unitFromLocalnameRequired("MilliMOL-PER-M2-DAY"),
  // Seychelles Rupee
  CCY_SCR: Qudt.unitFromLocalnameRequired("CCY_SCR"),
  // Katal per Microlitre
  KAT__PER__MicroL: Qudt.unitFromLocalnameRequired("KAT-PER-MicroL"),
  // Ounce Mass Minute per Sextic Inch
  OZ__MIN__PER__IN6: Qudt.unitFromLocalnameRequired("OZ-MIN-PER-IN6"),
  // Kilocandela
  KiloCD: Qudt.unitFromLocalnameRequired("KiloCD"),
  // Tera Volt Ampere
  TeraVA: Qudt.unitFromLocalnameRequired("TeraVA"),
  // Euro per Watt Second
  CCY_EUR__PER__W__SEC: Qudt.unitFromLocalnameRequired("CCY_EUR-PER-W-SEC"),
  // GM_DRY
  GM_DRY: Qudt.unitFromLocalnameRequired("GM_DRY"),
  // Inch per 2pirad
  IN__PER__2PiRAD: Qudt.unitFromLocalnameRequired("IN-PER-2PiRAD"),
  // Volt Ampere per Kelvin
  V__A__PER__K: Qudt.unitFromLocalnameRequired("V-A-PER-K"),
  // Watt per Square Meter Kelvin
  W__PER__M2__K: Qudt.unitFromLocalnameRequired("W-PER-M2-K"),
  // Cubic Centimetre per Second Kelvin
  CentiM3__PER__SEC__K: Qudt.unitFromLocalnameRequired("CentiM3-PER-SEC-K"),
  // Cubic Decimeter per Cubic Meter
  DeciM3__PER__M3: Qudt.unitFromLocalnameRequired("DeciM3-PER-M3"),
  // Pound Mass per Cubic Inch Psi
  LB__PER__IN3__PSI: Qudt.unitFromLocalnameRequired("LB-PER-IN3-PSI"),
  // W0dot
  W0dot: Qudt.unitFromLocalnameRequired("W0dot"),
  // Dobra
  CCY_STN_Currency: Qudt.unitFromLocalnameRequired("CCY_STN"),
  // Kilogram per Cubic Metre Second
  KiloGM__PER__M3__SEC: Qudt.unitFromLocalnameRequired("KiloGM-PER-M3-SEC"),
  // Joule Meter per Mole
  J__M__PER__MOL: Qudt.unitFromLocalnameRequired("J-M-PER-MOL"),
  // Kilo British Thermal Unit (international Definition)
  KiloBTU_IT: Qudt.unitFromLocalnameRequired("KiloBTU_IT"),
  // Foot Hour per Cubic Inch
  FT__HR__PER__IN3: Qudt.unitFromLocalnameRequired("FT-HR-PER-IN3"),
  // Czech Koruna
  CCY_CZK: Qudt.unitFromLocalnameRequired("CCY_CZK"),
  // Us Peck per Hour
  PK_US_DRY__PER__HR: Qudt.unitFromLocalnameRequired("PK_US_DRY-PER-HR"),
  // Tunisian Dinar
  CCY_TND_Currency: Qudt.unitFromLocalnameRequired("CCY_TND"),
  // 10KiloCount
  _10KiloCount: Qudt.unitFromLocalnameRequired("10KiloCount"),
  // Cubic Metre per Hour Bar
  M3__PER__HR__BAR: Qudt.unitFromLocalnameRequired("M3-PER-HR-BAR"),
  // Micronewton Meter
  MicroN__M: Qudt.unitFromLocalnameRequired("MicroN-M"),
  // Kilovolt
  KiloV: Qudt.unitFromLocalnameRequired("KiloV"),
  // Nanogram per Milliliter
  NanoGM__PER__MilliL: Qudt.unitFromLocalnameRequired("NanoGM-PER-MilliL"),
  // Zettacoulomb
  ZettaC: Qudt.unitFromLocalnameRequired("ZettaC"),
  // Kelvin per Minute
  K__PER__MIN: Qudt.unitFromLocalnameRequired("K-PER-MIN"),
  // Poundal per Square Foot
  PDL__PER__FT2: Qudt.unitFromLocalnameRequired("PDL-PER-FT2"),
  // Cubic Centimeter per Cubic Meter
  CentiM3__PER__M3: Qudt.unitFromLocalnameRequired("CentiM3-PER-M3"),
  // Unidades De Formento (funds Code)
  CCY_CLF_Currency: Qudt.unitFromLocalnameRequired("CCY_CLF"),
  // Week
  WK: Qudt.unitFromLocalnameRequired("WK"),
  // Millimeter per Degree Celsius Meter
  MilliM__PER__DEG_C__M: Qudt.unitFromLocalnameRequired("MilliM-PER-DEG_C-M"),
  // Exavolt Ampere
  ExaV__A: Qudt.unitFromLocalnameRequired("ExaV-A"),
  // Centimetre per Second Kelvin
  CentiM__PER__SEC__K: Qudt.unitFromLocalnameRequired("CentiM-PER-SEC-K"),
  // Kilocalorie per Mole Degree Celsius
  KiloCAL__PER__MOL__DEG_C: Qudt.unitFromLocalnameRequired(
    "KiloCAL-PER-MOL-DEG_C"
  ),
  // Guarani
  CCY_PYG: Qudt.unitFromLocalnameRequired("CCY_PYG"),
  // Kilo Pound Mass
  KiloLB: Qudt.unitFromLocalnameRequired("KiloLB"),
  // Manat
  CCY_TMT: Qudt.unitFromLocalnameRequired("CCY_TMT"),
  // Kilonewton Meter
  KiloN__M: Qudt.unitFromLocalnameRequired("KiloN-M"),
  // Cubic Meter per Year
  M3__PER__YR: Qudt.unitFromLocalnameRequired("M3-PER-YR"),
  // Milligram per Cubic Metre Bar
  MilliGM__PER__M3__BAR: Qudt.unitFromLocalnameRequired("MilliGM-PER-M3-BAR"),
  // Megaohm Kilometer
  MegaOHM__KiloM: Qudt.unitFromLocalnameRequired("MegaOHM-KiloM"),
  // Gram Second per Sextic Metre
  GM__SEC__PER__M6: Qudt.unitFromLocalnameRequired("GM-SEC-PER-M6"),
  // Chain (based on U.s. Survey Foot)
  CHAIN_US: Qudt.unitFromLocalnameRequired("CHAIN_US"),
  // Millilitre per Minute Kelvin
  MilliL__PER__MIN__K: Qudt.unitFromLocalnameRequired("MilliL-PER-MIN-K"),
  // Standard Atmosphere Cubic Meter per Mole
  ATM__M3__PER__MOL: Qudt.unitFromLocalnameRequired("ATM-M3-PER-MOL"),
  // Watt per Kelvin
  W__PER__K: Qudt.unitFromLocalnameRequired("W-PER-K"),
  // Stokes per Pascal
  ST__PER__PA: Qudt.unitFromLocalnameRequired("ST-PER-PA"),
  // Gigahertz
  GigaHZ: Qudt.unitFromLocalnameRequired("GigaHZ"),
  // Percent per One Hundred Thousand
  PERCENT__PER__100KiloCount: Qudt.unitFromLocalnameRequired(
    "PERCENT-PER-100KiloCount"
  ),
  // Terabit per Second
  TeraBIT__PER__SEC: Qudt.unitFromLocalnameRequired("TeraBIT-PER-SEC"),
  // Tera Floating Point Operations per Second
  TeraFLOPS: Qudt.unitFromLocalnameRequired("TeraFLOPS"),
  // Microcurie
  MicroCI: Qudt.unitFromLocalnameRequired("MicroCI"),
  // Milligram per Minute
  MilliGM__PER__MIN: Qudt.unitFromLocalnameRequired("MilliGM-PER-MIN"),
  // Decibel with A-weighting
  DeciB_A: Qudt.unitFromLocalnameRequired("DeciB_A"),
  // Kilogauss
  KiloGAUSS: Qudt.unitFromLocalnameRequired("KiloGAUSS"),
  // Degree Fahrenheit Hour
  DEG_F__HR: Qudt.unitFromLocalnameRequired("DEG_F-HR"),
  // Degree
  DEG: Qudt.unitFromLocalnameRequired("DEG"),
  // Dyne per Centimetre
  DYN__PER__CentiM: Qudt.unitFromLocalnameRequired("DYN-PER-CentiM"),
  // Argentine Peso
  CCY_ARS_Currency: Qudt.unitFromLocalnameRequired("CCY_ARS"),
  // Kilogram per Second Pascal
  KiloGM__PER__SEC__PA: Qudt.unitFromLocalnameRequired("KiloGM-PER-SEC-PA"),
  // Bit per Cubic Meter
  BIT__PER__M3: Qudt.unitFromLocalnameRequired("BIT-PER-M3"),
  // KiloVolt Ampere Reactive Hour
  KiloV__A_Reactive__HR: Qudt.unitFromLocalnameRequired("KiloV-A_Reactive-HR"),
  // Ton of Refrigeration Hour
  TON_FG__HR: Qudt.unitFromLocalnameRequired("TON_FG-HR"),
  // Femtojoule
  FemtoJ: Qudt.unitFromLocalnameRequired("FemtoJ"),
  // Pound Mass Minute per Cubic Inch Gallon (UK)
  LB__MIN__PER__IN3__GAL_UK: Qudt.unitFromLocalnameRequired(
    "LB-MIN-PER-IN3-GAL_UK"
  ),
  // Short Ton per Degree Fahrenheit
  TON_SHORT__PER__DEG_F: Qudt.unitFromLocalnameRequired("TON_SHORT-PER-DEG_F"),
  // Joule Second per Mole
  J__SEC__PER__MOL: Qudt.unitFromLocalnameRequired("J-SEC-PER-MOL"),
  // Degree Fahrenheit per Minute
  DEG_F__PER__MIN: Qudt.unitFromLocalnameRequired("DEG_F-PER-MIN"),
  // Rial Omani
  CCY_OMR: Qudt.unitFromLocalnameRequired("CCY_OMR"),
  // Lux
  LUX: Qudt.unitFromLocalnameRequired("LUX"),
  // TeraVolt Ampere Reactive
  TeraV__A_Reactive: Qudt.unitFromLocalnameRequired("TeraV-A_Reactive"),
  // Picowatt per Square Meter
  PicoW__PER__M2: Qudt.unitFromLocalnameRequired("PicoW-PER-M2"),
  // Degree Brix
  DEGREE_BRIX: Qudt.unitFromLocalnameRequired("DEGREE_BRIX"),
  // Square Centimetre Second
  CentiM2__SEC: Qudt.unitFromLocalnameRequired("CentiM2-SEC"),
  // Gram per Square Metre
  GM__PER__M2: Qudt.unitFromLocalnameRequired("GM-PER-M2"),
  // Forint
  CCY_HUF: Qudt.unitFromLocalnameRequired("CCY_HUF"),
  // Ngultrum
  CCY_BTN: Qudt.unitFromLocalnameRequired("CCY_BTN"),
  // Henry per Meter
  H__PER__M: Qudt.unitFromLocalnameRequired("H-PER-M"),
  // Microsievert per Hour
  MicroSV__PER__HR: Qudt.unitFromLocalnameRequired("MicroSV-PER-HR"),
  // Milligram Second per Sextic Metre
  MilliGM__SEC__PER__M6: Qudt.unitFromLocalnameRequired("MilliGM-SEC-PER-M6"),
  // Tebibit per Cubic Metre
  TebiBIT__PER__M3: Qudt.unitFromLocalnameRequired("TebiBIT-PER-M3"),
  // Pound Mass Minute per Gallon (UK) Cubic Yard
  LB__MIN__PER__GAL_UK__YD3: Qudt.unitFromLocalnameRequired(
    "LB-MIN-PER-GAL_UK-YD3"
  ),
  // Number per Hectare Year
  NUM__PER__HA__YR: Qudt.unitFromLocalnameRequired("NUM-PER-HA-YR"),
  // Erlang
  ERLANG: Qudt.unitFromLocalnameRequired("ERLANG"),
  // Kilocalorie
  KiloCAL: Qudt.unitFromLocalnameRequired("KiloCAL"),
  // Gigajoule per Square Metre
  GigaJ__PER__M2: Qudt.unitFromLocalnameRequired("GigaJ-PER-M2"),
  // Nanosievert per Minute
  NanoSV__PER__MIN: Qudt.unitFromLocalnameRequired("NanoSV-PER-MIN"),
  // Gram per Cubic Decimeter Kelvin
  GM__PER__DeciM3__K: Qudt.unitFromLocalnameRequired("GM-PER-DeciM3-K"),
  // Square Meter per Volt Second
  M2__PER__V__SEC: Qudt.unitFromLocalnameRequired("M2-PER-V-SEC"),
  // Watt per Square Metre Micrometre Steradian
  W__PER__M2__MicroM__SR: Qudt.unitFromLocalnameRequired("W-PER-M2-MicroM-SR"),
  // Ampere Square Second
  A__SEC2: Qudt.unitFromLocalnameRequired("A-SEC2"),
  // Surinam Dollar
  CCY_SRD_Currency: Qudt.unitFromLocalnameRequired("CCY_SRD"),
  // Reciprocal Square Meter
  PER__M2: Qudt.unitFromLocalnameRequired("PER-M2"),
  // Bar per Kelvin
  BAR__PER__K: Qudt.unitFromLocalnameRequired("BAR-PER-K"),
  // Statampere
  A_Stat: Qudt.unitFromLocalnameRequired("A_Stat"),
  // Reciprocal Kilovolt Ampere Hour
  PER__KiloV__A__HR: Qudt.unitFromLocalnameRequired("PER-KiloV-A-HR"),
  // British Thermal Unit (thermochemical Definition) Inch per Square Foot Second Degree Fahrenheit
  BTU_TH__IN__PER__FT2__SEC__DEG_F: Qudt.unitFromLocalnameRequired(
    "BTU_TH-IN-PER-FT2-SEC-DEG_F"
  ),
  // Pound per Gallon
  LB__PER__GAL: Qudt.unitFromLocalnameRequired("LB-PER-GAL"),
  // Microgray per Second
  MicroGRAY__PER__SEC: Qudt.unitFromLocalnameRequired("MicroGRAY-PER-SEC"),
  // Foot Pound Force per Square Foot
  FT__LB_F__PER__FT2: Qudt.unitFromLocalnameRequired("FT-LB_F-PER-FT2"),
  // Millivolt per Meter
  MilliV__PER__M: Qudt.unitFromLocalnameRequired("MilliV-PER-M"),
  // Us Gallon per Second
  GAL_US__PER__SEC: Qudt.unitFromLocalnameRequired("GAL_US-PER-SEC"),
  // Canadian Dollar
  CCY_CAD: Qudt.unitFromLocalnameRequired("CCY_CAD"),
  // Pound Sterling per Kilowatt Hour
  CCY_GBP__PER__KiloW__HR: Qudt.unitFromLocalnameRequired(
    "CCY_GBP-PER-KiloW-HR"
  ),
  // Lunar Mass
  LunarMass: Qudt.unitFromLocalnameRequired("LunarMass"),
  // Reciprocal Square Kilogram
  PER__KiloGM2: Qudt.unitFromLocalnameRequired("PER-KiloGM2"),
  // Stathenry per Centimeter
  H_Stat__PER__CentiM: Qudt.unitFromLocalnameRequired("H_Stat-PER-CentiM"),
  // Milliosmole per Kilogram
  MilliOSM__PER__KiloGM: Qudt.unitFromLocalnameRequired("MilliOSM-PER-KiloGM"),
  // Kiloohm per Kelvin
  KiloOHM__PER__K: Qudt.unitFromLocalnameRequired("KiloOHM-PER-K"),
  // British Thermal Unit (international Definition) per Hour Square Foot Degree Fahrenheit
  BTU_IT__PER__HR__FT2__DEG_F: Qudt.unitFromLocalnameRequired(
    "BTU_IT-PER-HR-FT2-DEG_F"
  ),
  // Microampere per Kelvin
  MicroA__PER__K: Qudt.unitFromLocalnameRequired("MicroA-PER-K"),
  // Metric Perm
  PERM_Metric: Qudt.unitFromLocalnameRequired("PERM_Metric"),
  // Syrian Pound
  CCY_SYP: Qudt.unitFromLocalnameRequired("CCY_SYP"),
  // Norwegian Krone per Kilowatt Hour
  CCY_NOK__PER__KiloW__HR: Qudt.unitFromLocalnameRequired(
    "CCY_NOK-PER-KiloW-HR"
  ),
  // Square Centimetre per Second
  CentiM2__PER__SEC: Qudt.unitFromLocalnameRequired("CentiM2-PER-SEC"),
  // Centistokes
  CentiST: Qudt.unitFromLocalnameRequired("CentiST"),
  // Millicurie
  MilliCI: Qudt.unitFromLocalnameRequired("MilliCI"),
  // Sievert per Second
  SV__PER__SEC: Qudt.unitFromLocalnameRequired("SV-PER-SEC"),
  // Nanomole
  NanoMOL: Qudt.unitFromLocalnameRequired("NanoMOL"),
  // Percent Foot Hour per Pound Mass
  PERCENT__FT__HR__PER__LB: Qudt.unitFromLocalnameRequired(
    "PERCENT-FT-HR-PER-LB"
  ),
  // Pixel (count)
  PIXEL_COUNT: Qudt.unitFromLocalnameRequired("PIXEL_COUNT"),
  // British Thermal Unit (international Definition) per Square Foot
  BTU_IT__PER__FT2: Qudt.unitFromLocalnameRequired("BTU_IT-PER-FT2"),
  // Degree Celsius Hour
  DEG_C__HR: Qudt.unitFromLocalnameRequired("DEG_C-HR"),
  // Degree Celsius Week
  DEG_C__WK: Qudt.unitFromLocalnameRequired("DEG_C-WK"),
  // Milligram per Day Bar
  MilliGM__PER__DAY__BAR: Qudt.unitFromLocalnameRequired("MilliGM-PER-DAY-BAR"),
  // Micromole per Micromole Day
  MicroMOL__PER__MicroMOL__DAY: Qudt.unitFromLocalnameRequired(
    "MicroMOL-PER-MicroMOL-DAY"
  ),
  // Kilocurie
  KiloCI: Qudt.unitFromLocalnameRequired("KiloCI"),
  // Parts per Thousand
  PPTH: Qudt.unitFromLocalnameRequired("PPTH"),
  // Ampere Hour per Degree Celsius
  A__HR__PER__DEG_C: Qudt.unitFromLocalnameRequired("A-HR-PER-DEG_C"),
  // Kilocalorie per Square Centimeter
  KiloCAL__PER__CentiM2: Qudt.unitFromLocalnameRequired("KiloCAL-PER-CentiM2"),
  // Practical Salinity Unit
  PSU: Qudt.unitFromLocalnameRequired("PSU"),
  // Foot Second per Gallon (UK)
  FT__SEC__PER__GAL_UK: Qudt.unitFromLocalnameRequired("FT-SEC-PER-GAL_UK"),
  // Cayman Islands Dollar
  CCY_KYD_Currency: Qudt.unitFromLocalnameRequired("CCY_KYD"),
  // Nautical Mile per Hour
  MI_N__PER__HR: Qudt.unitFromLocalnameRequired("MI_N-PER-HR"),
  // Quartic Inch
  IN4: Qudt.unitFromLocalnameRequired("IN4"),
  // Pound Force Foot per Inch
  LB_F__FT__PER__IN: Qudt.unitFromLocalnameRequired("LB_F-FT-PER-IN"),
  // Newton Metre per Minute Angle
  N__M__PER__MIN_Angle: Qudt.unitFromLocalnameRequired("N-M-PER-MIN_Angle"),
  // Gigavolt
  GigaV: Qudt.unitFromLocalnameRequired("GigaV"),
  // Kibibit per Cubic Meter
  KibiBIT__PER__M3: Qudt.unitFromLocalnameRequired("KibiBIT-PER-M3"),
  // Ounce Mass Hour per Cubic Inch Us Gallon
  OZ__HR__PER__IN3__GAL_US: Qudt.unitFromLocalnameRequired(
    "OZ-HR-PER-IN3-GAL_US"
  ),
  // Silver (one Troy Ounce)
  CCY_XAG: Qudt.unitFromLocalnameRequired("CCY_XAG"),
  // Kilocalorie (Mean)
  KiloCAL_Mean: Qudt.unitFromLocalnameRequired("KiloCAL_Mean"),
  // Parts per Thousand per Hour
  PPTH__PER__HR: Qudt.unitFromLocalnameRequired("PPTH-PER-HR"),
  // Kilowatt
  KiloW: Qudt.unitFromLocalnameRequired("KiloW"),
  // Gram Second per Liter Cubic Centimeter
  GM__SEC__PER__L__CentiM3: Qudt.unitFromLocalnameRequired(
    "GM-SEC-PER-L-CentiM3"
  ),
  // Exacoulomb
  ExaC: Qudt.unitFromLocalnameRequired("ExaC"),
  // Kilocalorie per Second
  KiloCAL__PER__SEC: Qudt.unitFromLocalnameRequired("KiloCAL-PER-SEC"),
  // Sri Lanka Rupee
  CCY_LKR_Currency: Qudt.unitFromLocalnameRequired("CCY_LKR"),
  // Cubic Meter per Hectare
  M3__PER__HA: Qudt.unitFromLocalnameRequired("M3-PER-HA"),
  // Coulomb per Square Millimeter
  C__PER__MilliM2: Qudt.unitFromLocalnameRequired("C-PER-MilliM2"),
  // Saudi Riyal
  CCY_SAR_Currency: Qudt.unitFromLocalnameRequired("CCY_SAR"),
  // Kiloampere per Kelvin
  KiloA__PER__K: Qudt.unitFromLocalnameRequired("KiloA-PER-K"),
  // Percent per Ten Thousand
  PERCENT__PER__DecaKiloCOUNT: Qudt.unitFromLocalnameRequired(
    "PERCENT-PER-DecaKiloCOUNT"
  ),
  // Nakfa
  CCY_ERN: Qudt.unitFromLocalnameRequired("CCY_ERN"),
  // Milliampere Hour
  MilliA__HR: Qudt.unitFromLocalnameRequired("MilliA-HR"),
  // British Thermal Unit (59 °F)
  BTU_59DEG_F: Qudt.unitFromLocalnameRequired("BTU_59DEG_F"),
  // Comoro Franc
  CCY_KMF: Qudt.unitFromLocalnameRequired("CCY_KMF"),
  // Coulomb per Square Metre
  C__PER__M2: Qudt.unitFromLocalnameRequired("C-PER-M2"),
  // Kilojoule per Kilogram Kelvin
  KiloJ__PER__KiloGM__K: Qudt.unitFromLocalnameRequired("KiloJ-PER-KiloGM-K"),
  // Barrel (UK Petroleum)
  BBL_UK_PET: Qudt.unitFromLocalnameRequired("BBL_UK_PET"),
  // Hertz
  HZ: Qudt.unitFromLocalnameRequired("HZ"),
  // Kina
  CCY_PGK: Qudt.unitFromLocalnameRequired("CCY_PGK"),
  // Inch of Water (60 °F)
  IN_H2O_60DEG_F: Qudt.unitFromLocalnameRequired("IN_H2O_60DEG_F"),
  // Watt Hour
  W__HR: Qudt.unitFromLocalnameRequired("W-HR"),
  // Quintic Meter
  M5: Qudt.unitFromLocalnameRequired("M5"),
  // Ton Force (us Short)
  TON_F_US: Qudt.unitFromLocalnameRequired("TON_F_US"),
  // Ounce Mass Hour per Cubic Inch Gallon (UK)
  OZ__HR__PER__IN3__GAL_UK: Qudt.unitFromLocalnameRequired(
    "OZ-HR-PER-IN3-GAL_UK"
  ),
  // Swedish Krona
  CCY_SEK: Qudt.unitFromLocalnameRequired("CCY_SEK"),
  // Tebibyte
  TebiBYTE: Qudt.unitFromLocalnameRequired("TebiBYTE"),
  // Lebanese Pound
  CCY_LBP_Currency: Qudt.unitFromLocalnameRequired("CCY_LBP"),
  // Franc Congolais
  CCY_CDF_Currency: Qudt.unitFromLocalnameRequired("CCY_CDF"),
  // Hartley
  HART: Qudt.unitFromLocalnameRequired("HART"),
  // Megajoule per Square Meter Day
  MegaJ__PER__M2__DAY: Qudt.unitFromLocalnameRequired("MegaJ-PER-M2-DAY"),
  // Joule per Gram
  J__PER__GM: Qudt.unitFromLocalnameRequired("J-PER-GM"),
  // Abohm
  OHM_Ab: Qudt.unitFromLocalnameRequired("OHM_Ab"),
  // Meganewton
  MegaN: Qudt.unitFromLocalnameRequired("MegaN"),
  // Kilolitre per Hour
  KiloL__PER__HR: Qudt.unitFromLocalnameRequired("KiloL-PER-HR"),
  // Trinidad and Tobago Dollar
  CCY_TTD_Currency: Qudt.unitFromLocalnameRequired("CCY_TTD"),
  // Millijoule per Gram
  MilliJ__PER__GM: Qudt.unitFromLocalnameRequired("MilliJ-PER-GM"),
  // Gram per Gram
  GM__PER__GM: Qudt.unitFromLocalnameRequired("GM-PER-GM"),
  // Knot
  KN: Qudt.unitFromLocalnameRequired("KN"),
  // Coulomb Square Metre per Volt
  C__M2__PER__V: Qudt.unitFromLocalnameRequired("C-M2-PER-V"),
  // Singapore Dollar
  CCY_SGD: Qudt.unitFromLocalnameRequired("CCY_SGD"),
  // Millipascal Second
  MilliPA__SEC: Qudt.unitFromLocalnameRequired("MilliPA-SEC"),
  // Imperial Ounce Force
  OZ_F: Qudt.unitFromLocalnameRequired("OZ_F"),
  // Milligram per Bar
  MilliGM__PER__BAR: Qudt.unitFromLocalnameRequired("MilliGM-PER-BAR"),
  // Millimole per Cubic Metre Day
  MilliMOL__PER__M3__DAY: Qudt.unitFromLocalnameRequired("MilliMOL-PER-M3-DAY"),
  // Pound Mass Hour per Us Gallon Cubic Yard
  LB__HR__PER__GAL_US__YD3: Qudt.unitFromLocalnameRequired(
    "LB-HR-PER-GAL_US-YD3"
  ),
  // Peso Uruguayo
  CCY_UYU_Currency: Qudt.unitFromLocalnameRequired("CCY_UYU"),
  // Pascal per Metre
  PA__PER__M: Qudt.unitFromLocalnameRequired("PA-PER-M"),
  // Pound Mass Minute per Us Gallon Cubic Inch
  LB__MIN__PER__GAL_US__IN3: Qudt.unitFromLocalnameRequired(
    "LB-MIN-PER-GAL_US-IN3"
  ),
  // Planck Mass
  PlanckMass: Qudt.unitFromLocalnameRequired("PlanckMass"),
  // Nanometer per Centimeter Psi
  NanoM__PER__CentiM__PSI: Qudt.unitFromLocalnameRequired(
    "NanoM-PER-CentiM-PSI"
  ),
  // Bulgarian Lev
  CCY_BGN: Qudt.unitFromLocalnameRequired("CCY_BGN"),
  // Denar
  CCY_MKD_Currency: Qudt.unitFromLocalnameRequired("CCY_MKD"),
  // Milliliter per Second Bar
  MilliL__PER__SEC__BAR: Qudt.unitFromLocalnameRequired("MilliL-PER-SEC-BAR"),
  // Megahertz Metre
  MegaHZ__M: Qudt.unitFromLocalnameRequired("MegaHZ-M"),
  // Decisiemens
  DeciS: Qudt.unitFromLocalnameRequired("DeciS"),
  // Millimole per Square Metre Second
  MilliMOL__PER__M2__SEC: Qudt.unitFromLocalnameRequired("MilliMOL-PER-M2-SEC"),
  // Week per Number
  WK__PER__NUM: Qudt.unitFromLocalnameRequired("WK-PER-NUM"),
  // Imperial Pint
  PINT: Qudt.unitFromLocalnameRequired("PINT"),
  // Milligray per Hour
  MilliGRAY__PER__HR: Qudt.unitFromLocalnameRequired("MilliGRAY-PER-HR"),
  // Sidereal Year
  YR_Sidereal: Qudt.unitFromLocalnameRequired("YR_Sidereal"),
  // Foot per Minute
  FT__PER__MIN: Qudt.unitFromLocalnameRequired("FT-PER-MIN"),
  // Hectopascal
  HectoPA: Qudt.unitFromLocalnameRequired("HectoPA"),
  // Kilogram per Mole
  KiloGM__PER__MOL: Qudt.unitFromLocalnameRequired("KiloGM-PER-MOL"),
  // Ton (us Shipping)
  TON_SHIPPING_US: Qudt.unitFromLocalnameRequired("TON_SHIPPING_US"),
  // Ounce Mass Square Foot per Cubic Inch Pound Force Second
  OZ__FT2__PER__IN3__LB_F__SEC: Qudt.unitFromLocalnameRequired(
    "OZ-FT2-PER-IN3-LB_F-SEC"
  ),
  // Czech Koruna per Kilowatt Hour
  CCY_CZK__PER__KiloW__HR: Qudt.unitFromLocalnameRequired(
    "CCY_CZK-PER-KiloW-HR"
  ),
  // Picogram per Kilogram
  PicoGM__PER__KiloGM: Qudt.unitFromLocalnameRequired("PicoGM-PER-KiloGM"),
  // Coulomb per Kilogram
  C__PER__KiloGM: Qudt.unitFromLocalnameRequired("C-PER-KiloGM"),
  // Kiloampere
  KiloA: Qudt.unitFromLocalnameRequired("KiloA"),
  // Millilitre per Litre
  MilliL__PER__L: Qudt.unitFromLocalnameRequired("MilliL-PER-L"),
  // Bahraini Dinar
  CCY_BHD: Qudt.unitFromLocalnameRequired("CCY_BHD"),
  // Mega British Thermal Unit (international Definition)
  MegaBTU_IT: Qudt.unitFromLocalnameRequired("MegaBTU_IT"),
  // Yuan Renminbi
  CCY_CNY_Currency: Qudt.unitFromLocalnameRequired("CCY_CNY"),
  // Colombian Peso
  CCY_COP: Qudt.unitFromLocalnameRequired("CCY_COP"),
  // Cubic Metre per Coulomb
  M3__PER__C: Qudt.unitFromLocalnameRequired("M3-PER-C"),
  // Pascal per Kelvin
  PA__PER__K: Qudt.unitFromLocalnameRequired("PA-PER-K"),
  // Part per Trillion
  PPT: Qudt.unitFromLocalnameRequired("PPT"),
  // Ounce Mass Second per Cubic Inch Cubic Foot
  OZ__SEC__PER__IN3__FT3: Qudt.unitFromLocalnameRequired("OZ-SEC-PER-IN3-FT3"),
  // Ampere Hour per Cubic Decimeter
  A__HR__PER__DeciM3: Qudt.unitFromLocalnameRequired("A-HR-PER-DeciM3"),
  // Kilogram per Square Centimetre
  KiloGM__PER__CentiM2: Qudt.unitFromLocalnameRequired("KiloGM-PER-CentiM2"),
  // Watt per Square Meter Nanometer
  W__PER__M2__NanoM: Qudt.unitFromLocalnameRequired("W-PER-M2-NanoM"),
  // Watt per Square Meter Quartic Kelvin
  W__PER__M2__K4: Qudt.unitFromLocalnameRequired("W-PER-M2-K4"),
  // Costa Rican Colon
  CCY_CRC: Qudt.unitFromLocalnameRequired("CCY_CRC"),
  // Giganewton Meter per Square Meter
  GigaN__M__PER__M2: Qudt.unitFromLocalnameRequired("GigaN-M-PER-M2"),
  // Kilogram per Cubic Metre Kelvin
  KiloGM__PER__M3__K: Qudt.unitFromLocalnameRequired("KiloGM-PER-M3-K"),
  // Hertz per Kelvin
  HZ__PER__K: Qudt.unitFromLocalnameRequired("HZ-PER-K"),
  // Kilocalorie per Mole
  KiloCAL__PER__MOL: Qudt.unitFromLocalnameRequired("KiloCAL-PER-MOL"),
  // Gallon (UK) per Hour
  GAL_UK__PER__HR: Qudt.unitFromLocalnameRequired("GAL_UK-PER-HR"),
  // Burundian Franc
  CCY_BIF: Qudt.unitFromLocalnameRequired("CCY_BIF"),
  // Gram Minute per Square Liter
  GM__MIN__PER__L2: Qudt.unitFromLocalnameRequired("GM-MIN-PER-L2"),
  // Newton Metre per Metre Radian
  N__M__PER__M__RAD: Qudt.unitFromLocalnameRequired("N-M-PER-M-RAD"),
  // Newton Square Metre
  N__M2: Qudt.unitFromLocalnameRequired("N-M2"),
  // Nanomole per Gram Second
  NanoMOL__PER__GM__SEC: Qudt.unitFromLocalnameRequired("NanoMOL-PER-GM-SEC"),
  // Joule Second
  J__SEC: Qudt.unitFromLocalnameRequired("J-SEC"),
  // Ampere Turn per Meter
  AT__PER__M: Qudt.unitFromLocalnameRequired("AT-PER-M"),
  // Gram per Kelvin
  GM__PER__K: Qudt.unitFromLocalnameRequired("GM-PER-K"),
  // Percent Hour per Cubic Foot
  PERCENT__HR__PER__FT3: Qudt.unitFromLocalnameRequired("PERCENT-HR-PER-FT3"),
  // Megabyte
  MegaBYTE: Qudt.unitFromLocalnameRequired("MegaBYTE"),
  // Inch per Degree Fahrenheit
  IN__PER__DEG_F: Qudt.unitFromLocalnameRequired("IN-PER-DEG_F"),
  // British Thermal Unit (international Definition) Inch per Hour Square Foot Degree Fahrenheit
  BTU_IT__IN__PER__HR__FT2__DEG_F: Qudt.unitFromLocalnameRequired(
    "BTU_IT-IN-PER-HR-FT2-DEG_F"
  ),
  // Volt per Metre
  V__PER__M: Qudt.unitFromLocalnameRequired("V-PER-M"),
  // Cubic Foot per Second
  FT3__PER__SEC: Qudt.unitFromLocalnameRequired("FT3-PER-SEC"),
  // Nanobecquerel
  NanoBQ: Qudt.unitFromLocalnameRequired("NanoBQ"),
  // Gram per Millimetre
  GM__PER__MilliM: Qudt.unitFromLocalnameRequired("GM-PER-MilliM"),
  // Bushel (UK) per Hour
  BU_UK__PER__HR: Qudt.unitFromLocalnameRequired("BU_UK-PER-HR"),
  // Megatonne per Year
  MegaTONNE__PER__YR: Qudt.unitFromLocalnameRequired("MegaTONNE-PER-YR"),
  // Microgram per Gram Day
  MicroGM__PER__GM__DAY: Qudt.unitFromLocalnameRequired("MicroGM-PER-GM-DAY"),
  // Malagasy Ariary
  CCY_MGA_Currency: Qudt.unitFromLocalnameRequired("CCY_MGA"),
  // British Thermal Unit (international Definition) per Minute
  BTU_IT__PER__MIN: Qudt.unitFromLocalnameRequired("BTU_IT-PER-MIN"),
  // Kiloweber per Meter
  KiloWB__PER__M: Qudt.unitFromLocalnameRequired("KiloWB-PER-M"),
  // Attocoulomb
  AttoC: Qudt.unitFromLocalnameRequired("AttoC"),
  // Femtogram per Kilogram
  FemtoGM__PER__KiloGM: Qudt.unitFromLocalnameRequired("FemtoGM-PER-KiloGM"),
  // Milliampere per Liter Minute
  MilliA__PER__L__MIN: Qudt.unitFromLocalnameRequired("MilliA-PER-L-MIN"),
  // Convertible Marks
  CCY_BAM: Qudt.unitFromLocalnameRequired("CCY_BAM"),
  // Kelvin
  K: Qudt.unitFromLocalnameRequired("K"),
  // Kilobit per Second
  KiloBIT__PER__SEC: Qudt.unitFromLocalnameRequired("KiloBIT-PER-SEC"),
  // International Table Calorie per Second Centimetre Kelvin
  CAL_IT__PER__SEC__CentiM__K: Qudt.unitFromLocalnameRequired(
    "CAL_IT-PER-SEC-CentiM-K"
  ),
  // Nanowatt per Square Metre
  NanoW__PER__M2: Qudt.unitFromLocalnameRequired("NanoW-PER-M2"),
  // Bahraini Dinar
  CCY_BHD_Currency: Qudt.unitFromLocalnameRequired("CCY_BHD"),
  // Dram (US)
  DRAM_US: Qudt.unitFromLocalnameRequired("DRAM_US"),
  // Joule per Kilogram Kelvin Pascal
  J__PER__KiloGM__K__PA: Qudt.unitFromLocalnameRequired("J-PER-KiloGM-K-PA"),
  // Gram per Centimeter Second
  GM__PER__CentiM__SEC: Qudt.unitFromLocalnameRequired("GM-PER-CentiM-SEC"),
  // Kelvin per Pascal
  K__PER__PA: Qudt.unitFromLocalnameRequired("K-PER-PA"),
  // Millicoulomb per Square Meter
  MilliC__PER__M2: Qudt.unitFromLocalnameRequired("MilliC-PER-M2"),
  // Pound Mass Minute per Square Gallon (UK)
  LB__MIN__PER__GAL_UK2: Qudt.unitFromLocalnameRequired("LB-MIN-PER-GAL_UK2"),
  // Inch per Minute
  IN__PER__MIN: Qudt.unitFromLocalnameRequired("IN-PER-MIN"),
  // Baht
  CCY_THB: Qudt.unitFromLocalnameRequired("CCY_THB"),
  // British Thermal Unit (thermochemical Definition) per Pound Mass Degree Rankine
  BTU_TH__PER__LB__DEG_R: Qudt.unitFromLocalnameRequired("BTU_TH-PER-LB-DEG_R"),
  // Tonne per Year
  TONNE__PER__YR: Qudt.unitFromLocalnameRequired("TONNE-PER-YR"),
  // Abvolt Second
  V_Ab__SEC: Qudt.unitFromLocalnameRequired("V_Ab-SEC"),
  // Lambert
  LA: Qudt.unitFromLocalnameRequired("LA"),
  // Cubic Micrometer per Milliliter
  MicroM3__PER__MilliL: Qudt.unitFromLocalnameRequired("MicroM3-PER-MilliL"),
  // Ounce Mass per Us Gallon
  OZ__PER__GAL_US: Qudt.unitFromLocalnameRequired("OZ-PER-GAL_US"),
  // Malawi Kwacha
  CCY_MWK: Qudt.unitFromLocalnameRequired("CCY_MWK"),
  // Gram per Cubic Centimetre Bar
  GM__PER__CentiM3__BAR: Qudt.unitFromLocalnameRequired("GM-PER-CentiM3-BAR"),
  // Liter per Hour Kelvin
  L__PER__HR__K: Qudt.unitFromLocalnameRequired("L-PER-HR-K"),
  // Square Millimeter
  MilliM2: Qudt.unitFromLocalnameRequired("MilliM2"),
  // Watt per Square Foot
  W__PER__FT2: Qudt.unitFromLocalnameRequired("W-PER-FT2"),
  // Kilo Volt Ampere Hour
  KiloVA__HR: Qudt.unitFromLocalnameRequired("KiloVA-HR"),
  // Picopascal per Kilometer
  PicoPA__PER__KiloM: Qudt.unitFromLocalnameRequired("PicoPA-PER-KiloM"),
  // Short Ton per Hour Degree Fahrenheit
  TON_SHORT__PER__HR__DEG_F: Qudt.unitFromLocalnameRequired(
    "TON_SHORT-PER-HR-DEG_F"
  ),
  // Lek
  CCY_ALL: Qudt.unitFromLocalnameRequired("CCY_ALL"),
  // Pound Mass per Cubic Foot Degree Fahrenheit
  LB__PER__FT3__DEG_F: Qudt.unitFromLocalnameRequired("LB-PER-FT3-DEG_F"),
  // Gram per Kilometer
  GM__PER__KiloM: Qudt.unitFromLocalnameRequired("GM-PER-KiloM"),
  // Decagram
  DecaGM: Qudt.unitFromLocalnameRequired("DecaGM"),
  // Cordoba Oro
  CCY_NIO: Qudt.unitFromLocalnameRequired("CCY_NIO"),
  // Square Meter per Kilowatt
  M2__PER__KiloW: Qudt.unitFromLocalnameRequired("M2-PER-KiloW"),
  // Joule per Square Meter
  J__PER__M2: Qudt.unitFromLocalnameRequired("J-PER-M2"),
  // Number per Hour
  NUM__PER__HR: Qudt.unitFromLocalnameRequired("NUM-PER-HR"),
  // Square Kilometer
  KiloM2: Qudt.unitFromLocalnameRequired("KiloM2"),
  // Australian Dollar
  CCY_AUD: Qudt.unitFromLocalnameRequired("CCY_AUD"),
  // Lempira
  CCY_HNL_Currency: Qudt.unitFromLocalnameRequired("CCY_HNL"),
  // Square Metre per Newton
  M2__PER__N: Qudt.unitFromLocalnameRequired("M2-PER-N"),
  // Giganewton
  GigaN: Qudt.unitFromLocalnameRequired("GigaN"),
  // Candela per Square Foot
  CD__PER__FT2: Qudt.unitFromLocalnameRequired("CD-PER-FT2"),
  // MilliVolt Ampere Reactive per Kelvin
  MilliV__A_Reactive__PER__K: Qudt.unitFromLocalnameRequired(
    "MilliV-A_Reactive-PER-K"
  ),
  // Milliliter per Kelvin
  MilliL__PER__K: Qudt.unitFromLocalnameRequired("MilliL-PER-K"),
  // Debye
  DEBYE: Qudt.unitFromLocalnameRequired("DEBYE"),
  // United Arab Emirates Dirham
  CCY_AED_Currency: Qudt.unitFromLocalnameRequired("CCY_AED"),
  // Katal
  KAT: Qudt.unitFromLocalnameRequired("KAT"),
  // Mauritius Rupee
  CCY_MUR: Qudt.unitFromLocalnameRequired("CCY_MUR"),
  // Kilo Volt Ampere Reactive Hour
  KiloVAR__HR: Qudt.unitFromLocalnameRequired("KiloVAR-HR"),
  // Millilitre per Bar
  MilliL__PER__BAR: Qudt.unitFromLocalnameRequired("MilliL-PER-BAR"),
  // Reciprocal Cubic Inch
  PER__IN3: Qudt.unitFromLocalnameRequired("PER-IN3"),
  // Bulgarian Lev
  CCY_BGN_Currency: Qudt.unitFromLocalnameRequired("CCY_BGN"),
  // Minute
  MIN: Qudt.unitFromLocalnameRequired("MIN"),
  // Short Ton per Hour
  TON_SHORT__PER__HR: Qudt.unitFromLocalnameRequired("TON_SHORT-PER-HR"),
  // Percent per Ten Thousand
  PERCENT__PER__10KiloCount: Qudt.unitFromLocalnameRequired(
    "PERCENT-PER-10KiloCount"
  ),
  // Kilogram per Year
  KiloGM__PER__YR: Qudt.unitFromLocalnameRequired("KiloGM-PER-YR"),
  // Cubic Meter per Hectare Year
  M3__PER__HA__YR: Qudt.unitFromLocalnameRequired("M3-PER-HA-YR"),
  // Ampere Second
  A__SEC: Qudt.unitFromLocalnameRequired("A-SEC"),
  // International Unit
  IU: Qudt.unitFromLocalnameRequired("IU"),
  // Centimeter
  CentiM: Qudt.unitFromLocalnameRequired("CentiM"),
  // Kilogram per Square Meter Pascal Second
  KiloGM__PER__M2__PA__SEC: Qudt.unitFromLocalnameRequired(
    "KiloGM-PER-M2-PA-SEC"
  ),
  // OHM_CIRC
  OHM_CIRC: Qudt.unitFromLocalnameRequired("OHM_CIRC"),
  // Standard Cubic Metre
  SCM_1ATM_15DEG_C_NL: Qudt.unitFromLocalnameRequired("SCM_1ATM_15DEG_C_NL"),
  // MegaVolt Ampere Reactive Hour
  MegaV__A_Reactive__HR: Qudt.unitFromLocalnameRequired("MegaV-A_Reactive-HR"),
  // Percent per Degree
  PERCENT__PER__DEG: Qudt.unitFromLocalnameRequired("PERCENT-PER-DEG"),
  // Litre per Second
  L__PER__SEC: Qudt.unitFromLocalnameRequired("L-PER-SEC"),
  // British Thermal Unit (international Definition) per Pound Force Degree Rankine
  BTU_IT__PER__LB_F__DEG_R: Qudt.unitFromLocalnameRequired(
    "BTU_IT-PER-LB_F-DEG_R"
  ),
  // Afghani
  CCY_AFN: Qudt.unitFromLocalnameRequired("CCY_AFN"),
  // Kip
  KIP_F: Qudt.unitFromLocalnameRequired("KIP_F"),
  // Reciprocal Radian
  PER__RAD: Qudt.unitFromLocalnameRequired("PER-RAD"),
  // Parts per Ten Million per Kelvin
  PPTM__PER__K: Qudt.unitFromLocalnameRequired("PPTM-PER-K"),
  // Indian Rupee
  CCY_INR_Currency: Qudt.unitFromLocalnameRequired("CCY_INR"),
  // Millimetre per Kelvin
  MilliM__PER__K: Qudt.unitFromLocalnameRequired("MilliM-PER-K"),
  // Kilo Pound Mass per Hour
  KiloLB__PER__HR: Qudt.unitFromLocalnameRequired("KiloLB-PER-HR"),
  // Maltese Lira
  CCY_MTL: Qudt.unitFromLocalnameRequired("CCY_MTL"),
  // Gigabit per Metre
  GigaBIT__PER__M: Qudt.unitFromLocalnameRequired("GigaBIT-PER-M"),
  // Kilogram per Day
  KiloGM__PER__DAY: Qudt.unitFromLocalnameRequired("KiloGM-PER-DAY"),
  // Reciprocal Cubic Millimeter
  PER__MilliM3: Qudt.unitFromLocalnameRequired("PER-MilliM3"),
  // Kilogram per Bar
  KiloGM__PER__BAR: Qudt.unitFromLocalnameRequired("KiloGM-PER-BAR"),
  // Pint (UK) per Hour
  PINT_UK__PER__HR: Qudt.unitFromLocalnameRequired("PINT_UK-PER-HR"),
  // Millifarad
  MilliFARAD: Qudt.unitFromLocalnameRequired("MilliFARAD"),
  // Serbian Dinar
  CCY_RSD_Currency: Qudt.unitFromLocalnameRequired("CCY_RSD"),
  // Square Inch
  IN2: Qudt.unitFromLocalnameRequired("IN2"),
  // Liter per Second Bar
  L__PER__SEC__BAR: Qudt.unitFromLocalnameRequired("L-PER-SEC-BAR"),
  // Reciprocal Month
  PER__MO: Qudt.unitFromLocalnameRequired("PER-MO"),
  // Ten
  TEN: Qudt.unitFromLocalnameRequired("TEN"),
  // Barad
  BARAD: Qudt.unitFromLocalnameRequired("BARAD"),
  // Kilo Gram Force per Square Metre
  KiloGM_F__PER__M2: Qudt.unitFromLocalnameRequired("KiloGM_F-PER-M2"),
  // Exa Volt Ampere
  ExaVA: Qudt.unitFromLocalnameRequired("ExaVA"),
  // Ounce Mass Minute per Cubic Inch Us Gallon
  OZ__MIN__PER__IN3__GAL_US: Qudt.unitFromLocalnameRequired(
    "OZ-MIN-PER-IN3-GAL_US"
  ),
  // Metric Ton per Hour
  TON_Metric__PER__HR: Qudt.unitFromLocalnameRequired("TON_Metric-PER-HR"),
  // Pound Mass per Cubic Foot Psi
  LB__PER__FT3__PSI: Qudt.unitFromLocalnameRequired("LB-PER-FT3-PSI"),
  // Gigaohm Meter
  GigaOHM__M: Qudt.unitFromLocalnameRequired("GigaOHM-M"),
  // Milliliter per Hour
  MilliL__PER__HR: Qudt.unitFromLocalnameRequired("MilliL-PER-HR"),
  // Newton Metre Second per Metre
  N__M__SEC__PER__M: Qudt.unitFromLocalnameRequired("N-M-SEC-PER-M"),
  // Cubic Foot per Degree Fahrenheit
  FT3__PER__DEG_F: Qudt.unitFromLocalnameRequired("FT3-PER-DEG_F"),
  // United States Dollar (same Day) (funds Code)
  CCY_USS: Qudt.unitFromLocalnameRequired("CCY_USS"),
  // Petavolt
  PetaV: Qudt.unitFromLocalnameRequired("PetaV"),
  // Statvolt Centimetre
  V_Stat__CentiM: Qudt.unitFromLocalnameRequired("V_Stat-CentiM"),
  // Inch of Water
  IN_H2O: Qudt.unitFromLocalnameRequired("IN_H2O"),
  // Pound Mass Minute per Sextic Foot
  LB__MIN__PER__FT6: Qudt.unitFromLocalnameRequired("LB-MIN-PER-FT6"),
  // Metrology Year
  YR_Metrology: Qudt.unitFromLocalnameRequired("YR_Metrology"),
  // Pataca
  CCY_MOP: Qudt.unitFromLocalnameRequired("CCY_MOP"),
  // Kilovolt Ampere
  KiloV__A: Qudt.unitFromLocalnameRequired("KiloV-A"),
  // Square Nanometer
  NanoM2: Qudt.unitFromLocalnameRequired("NanoM2"),
  // Microgram per Liter Day
  MicroGM__PER__L__DAY: Qudt.unitFromLocalnameRequired("MicroGM-PER-L-DAY"),
  // Euro per Square Metre
  CCY_EUR__PER__M2: Qudt.unitFromLocalnameRequired("CCY_EUR-PER-M2"),
  // Exbibyte
  ExbiBYTE: Qudt.unitFromLocalnameRequired("ExbiBYTE"),
  // Newton Second
  N__SEC: Qudt.unitFromLocalnameRequired("N-SEC"),
  // Synodic Month
  MO_Synodic: Qudt.unitFromLocalnameRequired("MO_Synodic"),
  // Day
  DAY: Qudt.unitFromLocalnameRequired("DAY"),
  // Pound Force per Square Foot
  LB_F__PER__FT2: Qudt.unitFromLocalnameRequired("LB_F-PER-FT2"),
  // Kilo British Thermal Unit (international Definition) per Square Foot
  KiloBTU_IT__PER__FT2: Qudt.unitFromLocalnameRequired("KiloBTU_IT-PER-FT2"),
  // Nanosecond
  NanoSEC: Qudt.unitFromLocalnameRequired("NanoSEC"),
  // Ampere per Square Meter Square Kelvin
  A__PER__M2__K2: Qudt.unitFromLocalnameRequired("A-PER-M2-K2"),
  // Kilocalorie per Centimeter Second Degree Celsius
  KiloCAL__PER__CentiM__SEC__DEG_C: Qudt.unitFromLocalnameRequired(
    "KiloCAL-PER-CentiM-SEC-DEG_C"
  ),
  // Statcoulomb per Square Centimeter
  C_Stat__PER__CentiM2: Qudt.unitFromLocalnameRequired("C_Stat-PER-CentiM2"),
  // Square Coulomb Square Metre per Joule
  C2__M2__PER__J: Qudt.unitFromLocalnameRequired("C2-M2-PER-J"),
  // Us Liquid Quart
  QT_US: Qudt.unitFromLocalnameRequired("QT_US"),
  // Reciprocal Micrometre
  PER__MicroM: Qudt.unitFromLocalnameRequired("PER-MicroM"),
  // Rad
  RAD_R: Qudt.unitFromLocalnameRequired("RAD_R"),
  // Kilo Volt Ampere Reactive
  KiloVAR: Qudt.unitFromLocalnameRequired("KiloVAR"),
  // Watt Square Meter
  W__M2: Qudt.unitFromLocalnameRequired("W-M2"),
  // Faraday
  F: Qudt.unitFromLocalnameRequired("F"),
  // Volt Ampere
  V__A: Qudt.unitFromLocalnameRequired("V-A"),
  // Magnetic Susceptibility Unit
  SUSCEPTIBILITY_MAG: Qudt.unitFromLocalnameRequired("SUSCEPTIBILITY_MAG"),
  // Dry Gallon Us
  GAL_US_DRY: Qudt.unitFromLocalnameRequired("GAL_US_DRY"),
  // Milligram per Square Meter Hour
  MilliGM__PER__M2__HR: Qudt.unitFromLocalnameRequired("MilliGM-PER-M2-HR"),
  // Joule per Metre
  J__PER__M: Qudt.unitFromLocalnameRequired("J-PER-M"),
  // Kilonewton Metre per Degree
  KiloN__M__PER__DEG: Qudt.unitFromLocalnameRequired("KiloN-M-PER-DEG"),
  // Acre Foot
  AC__FT: Qudt.unitFromLocalnameRequired("AC-FT"),
  // Exabit per Second
  ExaBIT__PER__SEC: Qudt.unitFromLocalnameRequired("ExaBIT-PER-SEC"),
  // Foot Hour per Gallon (UK)
  FT__HR__PER__GAL_UK: Qudt.unitFromLocalnameRequired("FT-HR-PER-GAL_UK"),
  // Square Ampere Second
  A2__SEC: Qudt.unitFromLocalnameRequired("A2-SEC"),
  // Microsievert per Second
  MicroSV__PER__SEC: Qudt.unitFromLocalnameRequired("MicroSV-PER-SEC"),
  // KiloINDIV
  KiloINDIV: Qudt.unitFromLocalnameRequired("KiloINDIV"),
  // Millisiemens per Centimetre
  MilliS__PER__CentiM: Qudt.unitFromLocalnameRequired("MilliS-PER-CentiM"),
  // Milligram per Litre Pascal Second
  MilliGM__PER__L__PA__SEC: Qudt.unitFromLocalnameRequired(
    "MilliGM-PER-L-PA-SEC"
  ),
  // Ounce Mass Second per Cubic Inch Us Gallon
  OZ__SEC__PER__IN3__GAL_US: Qudt.unitFromLocalnameRequired(
    "OZ-SEC-PER-IN3-GAL_US"
  ),
  // Pico Volt Ampere
  PicoVA: Qudt.unitFromLocalnameRequired("PicoVA"),
  // Square Pascal per Square Second
  PA2__PER__SEC2: Qudt.unitFromLocalnameRequired("PA2-PER-SEC2"),
  // Pascal Second per Bar
  PA__SEC__PER__BAR: Qudt.unitFromLocalnameRequired("PA-SEC-PER-BAR"),
  // Kiloampere Hour
  KiloA__HR: Qudt.unitFromLocalnameRequired("KiloA-HR"),
  // Pound Mass
  LB: Qudt.unitFromLocalnameRequired("LB"),
  // Millirad
  MilliRAD_R: Qudt.unitFromLocalnameRequired("MilliRAD_R"),
  // Erg per Cubic Centimetre
  ERG__PER__CentiM3: Qudt.unitFromLocalnameRequired("ERG-PER-CentiM3"),
  // Milliampere per Inch
  MilliA__PER__IN: Qudt.unitFromLocalnameRequired("MilliA-PER-IN"),
  // Millimole per Litre
  MilliMOL__PER__L: Qudt.unitFromLocalnameRequired("MilliMOL-PER-L"),
  // Us Peck per Minute
  PK_US_DRY__PER__MIN: Qudt.unitFromLocalnameRequired("PK_US_DRY-PER-MIN"),
  // Kilo-FT3
  Kilo__FT3: Qudt.unitFromLocalnameRequired("Kilo-FT3"),
  // Carat
  CARAT: Qudt.unitFromLocalnameRequired("CARAT"),
  // Metric Ton per Hour Bar
  TON_Metric__PER__HR__BAR: Qudt.unitFromLocalnameRequired(
    "TON_Metric-PER-HR-BAR"
  ),
  // Nanovolt
  NanoV: Qudt.unitFromLocalnameRequired("NanoV"),
  // Planck Momentum
  PlanckMomentum: Qudt.unitFromLocalnameRequired("PlanckMomentum"),
  // Kilo Thermochemical Calorie per Second
  KiloCAL_TH__PER__SEC: Qudt.unitFromLocalnameRequired("KiloCAL_TH-PER-SEC"),
  // Cayman Islands Dollar
  CCY_KYD: Qudt.unitFromLocalnameRequired("CCY_KYD"),
  // Square Centimeter per Gram
  CentiM2__PER__GM: Qudt.unitFromLocalnameRequired("CentiM2-PER-GM"),
  // Millibecquerel per Square Metre Day
  MilliBQ__PER__M2__DAY: Qudt.unitFromLocalnameRequired("MilliBQ-PER-M2-DAY"),
  // Grad
  GRAD: Qudt.unitFromLocalnameRequired("GRAD"),
  // Millimetre per Hour
  MilliM__PER__HR: Qudt.unitFromLocalnameRequired("MilliM-PER-HR"),
  // Quart (UK)
  QT_UK: Qudt.unitFromLocalnameRequired("QT_UK"),
  // Degree Baume (us Heavy)
  DEGREE_BAUME_US_HEAVY: Qudt.unitFromLocalnameRequired(
    "DEGREE_BAUME_US_HEAVY"
  ),
  // Microgram per Square Inch
  MicroGM__PER__IN2: Qudt.unitFromLocalnameRequired("MicroGM-PER-IN2"),
  // Cubic Yard per Second
  YD3__PER__SEC: Qudt.unitFromLocalnameRequired("YD3-PER-SEC"),
  // Thermochemical Calorie per Gram
  CAL_TH__PER__GM: Qudt.unitFromLocalnameRequired("CAL_TH-PER-GM"),
  // Byte
  BYTE: Qudt.unitFromLocalnameRequired("BYTE"),
  // Saudi Riyal
  CCY_SAR: Qudt.unitFromLocalnameRequired("CCY_SAR"),
  // Milligram per Cubic Metre
  MilliGM__PER__M3: Qudt.unitFromLocalnameRequired("MilliGM-PER-M3"),
  // Thermochemical Calorie per Centimetre Second Degree Celsius
  CAL_TH__PER__CentiM__SEC__DEG_C: Qudt.unitFromLocalnameRequired(
    "CAL_TH-PER-CentiM-SEC-DEG_C"
  ),
  // Square Meter per Square Second Kelvin
  M2__PER__SEC2__K: Qudt.unitFromLocalnameRequired("M2-PER-SEC2-K"),
  // Kilogram per Mega British Thermal Unit (international Definition)
  KiloGM__PER__MegaBTU_IT: Qudt.unitFromLocalnameRequired(
    "KiloGM-PER-MegaBTU_IT"
  ),
  // Us Liquid Ounce per Second
  OZ_VOL_US__PER__SEC: Qudt.unitFromLocalnameRequired("OZ_VOL_US-PER-SEC"),
  // Kilopascal Absolute
  KiloPA_A: Qudt.unitFromLocalnameRequired("KiloPA_A"),
  // Kilowatt per Square Meter Kelvin
  KiloW__PER__M2__K: Qudt.unitFromLocalnameRequired("KiloW-PER-M2-K"),
  // Decibar per Year
  DeciBAR__PER__YR: Qudt.unitFromLocalnameRequired("DeciBAR-PER-YR"),
  // Ampere Hour
  A__HR: Qudt.unitFromLocalnameRequired("A-HR"),
  // Nepalese Rupee
  CCY_NPR_Currency: Qudt.unitFromLocalnameRequired("CCY_NPR"),
  // Kilohertz
  KiloHZ: Qudt.unitFromLocalnameRequired("KiloHZ"),
  // Failures in Time
  failures__in__time: Qudt.unitFromLocalnameRequired("failures-in-time"),
  // Megagram per Cubic Meter
  MegaGM__PER__M3: Qudt.unitFromLocalnameRequired("MegaGM-PER-M3"),
  // Cubic Yard
  YD3: Qudt.unitFromLocalnameRequired("YD3"),
  // Picogram per Liter
  PicoGM__PER__L: Qudt.unitFromLocalnameRequired("PicoGM-PER-L"),
  // Ampere per Centimeter
  A__PER__CentiM: Qudt.unitFromLocalnameRequired("A-PER-CentiM"),
  // Mega Electron Volt
  MegaEV: Qudt.unitFromLocalnameRequired("MegaEV"),
  // Pound Mass Second per Cubic Foot Gallon (UK)
  LB__SEC__PER__FT3__GAL_UK: Qudt.unitFromLocalnameRequired(
    "LB-SEC-PER-FT3-GAL_UK"
  ),
  // Board Foot
  FBM: Qudt.unitFromLocalnameRequired("FBM"),
  // Ounce Mass
  OZ_M: Qudt.unitFromLocalnameRequired("OZ_M"),
  // Giga Volt Ampere Reactive
  GigaVAR: Qudt.unitFromLocalnameRequired("GigaVAR"),
  // Milliampere
  MilliA: Qudt.unitFromLocalnameRequired("MilliA"),
  // East Caribbean Dollar
  CCY_XCD: Qudt.unitFromLocalnameRequired("CCY_XCD"),
  // Statcoulomb per Mole
  C_Stat__PER__MOL: Qudt.unitFromLocalnameRequired("C_Stat-PER-MOL"),
  // Debye
  Debye: Qudt.unitFromLocalnameRequired("Debye"),
  // Picomole per Meter Watt Second
  PicoMOL__PER__M__W__SEC: Qudt.unitFromLocalnameRequired(
    "PicoMOL-PER-M-W-SEC"
  ),
  // Gram Second per Square Litre
  GM__SEC__PER__L2: Qudt.unitFromLocalnameRequired("GM-SEC-PER-L2"),
  // Imperial Ounce Force Inch
  OZ_F__IN: Qudt.unitFromLocalnameRequired("OZ_F-IN"),
  // Kilo Thermochemical Calorie per Hour
  KiloCAL_TH__PER__HR: Qudt.unitFromLocalnameRequired("KiloCAL_TH-PER-HR"),
  // Gram Millimeter
  GM__MilliM: Qudt.unitFromLocalnameRequired("GM-MilliM"),
  // Mole Kelvin
  MOL__K: Qudt.unitFromLocalnameRequired("MOL-K"),
  // Kilonewton Metre per Square Metre
  KiloN__M__PER__M2: Qudt.unitFromLocalnameRequired("KiloN-M-PER-M2"),
  // Nanoohm Metre
  NanoOHM__M: Qudt.unitFromLocalnameRequired("NanoOHM-M"),
  // Inch Poundal
  IN__PDL: Qudt.unitFromLocalnameRequired("IN-PDL"),
  // Poundal Second per Square Foot
  PDL__SEC__PER__FT2: Qudt.unitFromLocalnameRequired("PDL-SEC-PER-FT2"),
  // Picokatal
  PicoKAT: Qudt.unitFromLocalnameRequired("PicoKAT"),
  // Tablespoon
  TBSP: Qudt.unitFromLocalnameRequired("TBSP"),
  // Iceland Krona
  CCY_ISK_Currency: Qudt.unitFromLocalnameRequired("CCY_ISK"),
  // Gibraltar Pound
  CCY_GIP: Qudt.unitFromLocalnameRequired("CCY_GIP"),
  // Reciprocal Volt Ampere Second
  PER__VA__SEC: Qudt.unitFromLocalnameRequired("PER-VA-SEC"),
  // Microhenry per Kiloohm
  MicroH__PER__KiloOHM: Qudt.unitFromLocalnameRequired("MicroH-PER-KiloOHM"),
  // Pound Mass Hour per Cubic Inch Us Gallon
  LB__HR__PER__IN3__GAL_US: Qudt.unitFromLocalnameRequired(
    "LB-HR-PER-IN3-GAL_US"
  ),
  // Millirad per Hour
  MilliRAD_R__PER__HR: Qudt.unitFromLocalnameRequired("MilliRAD_R-PER-HR"),
  // Base Pair
  BasePair: Qudt.unitFromLocalnameRequired("BasePair"),
  // Gram per Hour Kelvin
  GM__PER__HR__K: Qudt.unitFromLocalnameRequired("GM-PER-HR-K"),
  // Okta
  OKTA: Qudt.unitFromLocalnameRequired("OKTA"),
  // Aruban Guilder
  CCY_AWG: Qudt.unitFromLocalnameRequired("CCY_AWG"),
  // Joule Square Metre per Kilogram
  J__M2__PER__KiloGM: Qudt.unitFromLocalnameRequired("J-M2-PER-KiloGM"),
  // Cubic Meter per Square Meter
  M3__PER__M2: Qudt.unitFromLocalnameRequired("M3-PER-M2"),
  // Degree Fahrenheit per Square Second
  DEG_F__PER__SEC2: Qudt.unitFromLocalnameRequired("DEG_F-PER-SEC2"),
  // Decisecond
  DeciSEC: Qudt.unitFromLocalnameRequired("DeciSEC"),
  // Rem per Second
  REM__PER__SEC: Qudt.unitFromLocalnameRequired("REM-PER-SEC"),
  // Roentgen Equivalent Man
  R_man: Qudt.unitFromLocalnameRequired("R_man"),
  // Lumen Hour
  LM__HR: Qudt.unitFromLocalnameRequired("LM-HR"),
  // Costa Rican Colon
  CCY_CRC_Currency: Qudt.unitFromLocalnameRequired("CCY_CRC"),
  // Reciprocal Kilometre
  PER__KiloM: Qudt.unitFromLocalnameRequired("PER-KiloM"),
  // Pebibyte
  PebiBYTE: Qudt.unitFromLocalnameRequired("PebiBYTE"),
  // Long Ton
  TON_LONG: Qudt.unitFromLocalnameRequired("TON_LONG"),
  // Percent per Millimeter
  PERCENT__PER__MilliM: Qudt.unitFromLocalnameRequired("PERCENT-PER-MilliM"),
  // Roentgen per Second
  R__PER__SEC: Qudt.unitFromLocalnameRequired("R-PER-SEC"),
  // Megapsi
  MegaPSI: Qudt.unitFromLocalnameRequired("MegaPSI"),
  // Uzbekistan Som
  CCY_UZS: Qudt.unitFromLocalnameRequired("CCY_UZS"),
  // Us Liquid Ounce per Hour
  OZ_VOL_US__PER__HR: Qudt.unitFromLocalnameRequired("OZ_VOL_US-PER-HR"),
  // Metric Ton per Hour Kelvin
  TON_Metric__PER__HR__K: Qudt.unitFromLocalnameRequired("TON_Metric-PER-HR-K"),
  // Picocoulomb
  PicoC: Qudt.unitFromLocalnameRequired("PicoC"),
  // Standard Cubic Foot
  SCF: Qudt.unitFromLocalnameRequired("SCF"),
  // Sample per Second
  SAMPLE__PER__SEC: Qudt.unitFromLocalnameRequired("SAMPLE-PER-SEC"),
  // Pound Mole
  MOL_LB: Qudt.unitFromLocalnameRequired("MOL_LB"),
  // Kilogram per Gigajoule
  KiloGM__PER__GigaJ: Qudt.unitFromLocalnameRequired("KiloGM-PER-GigaJ"),
  // Millipascal Second per Kelvin
  MilliPA__SEC__PER__K: Qudt.unitFromLocalnameRequired("MilliPA-SEC-PER-K"),
  // Meter per Farad
  M__PER__FARAD: Qudt.unitFromLocalnameRequired("M-PER-FARAD"),
  // Thermochemical Calorie
  CAL_TH: Qudt.unitFromLocalnameRequired("CAL_TH"),
  // Kilo Volt Ampere Reactive per Kelvin
  KiloVAR__PER__K: Qudt.unitFromLocalnameRequired("KiloVAR-PER-K"),
  // Reciprocal Square Planck Mass
  PER__PlanckMass2: Qudt.unitFromLocalnameRequired("PER-PlanckMass2"),
  // Pound Mass Hour per Cubic Foot Cubic Inch
  LB__HR__PER__FT3__IN3: Qudt.unitFromLocalnameRequired("LB-HR-PER-FT3-IN3"),
  // Newton Meter per Ampere
  N__M__PER__A: Qudt.unitFromLocalnameRequired("N-M-PER-A"),
  // GM_Nitrogen
  GM_Nitrogen: Qudt.unitFromLocalnameRequired("GM_Nitrogen"),
  // Meganewton per Cubic Meter
  MegaN__PER__M3: Qudt.unitFromLocalnameRequired("MegaN-PER-M3"),
  // Us Liquid Pint
  PINT_US: Qudt.unitFromLocalnameRequired("PINT_US"),
  // Lempira
  CCY_HNL: Qudt.unitFromLocalnameRequired("CCY_HNL"),
  // Microcurie
  MicroCi: Qudt.unitFromLocalnameRequired("MicroCi"),
  // Pound Mass per Day
  LB__PER__DAY: Qudt.unitFromLocalnameRequired("LB-PER-DAY"),
  // Psi Litre per Second
  PSI__L__PER__SEC: Qudt.unitFromLocalnameRequired("PSI-L-PER-SEC"),
  // Kilogram per Liter Bar
  KiloGM__PER__L__BAR: Qudt.unitFromLocalnameRequired("KiloGM-PER-L-BAR"),
  // Micromole per Square Meter Day
  MicroMOL__PER__M2__DAY: Qudt.unitFromLocalnameRequired("MicroMOL-PER-M2-DAY"),
  // GAL
  GAL: Qudt.unitFromLocalnameRequired("GAL"),
  // Microgram per Cubic Metre Bar
  MicroGM__PER__M3__BAR: Qudt.unitFromLocalnameRequired("MicroGM-PER-M3-BAR"),
  // Centibar
  CentiBAR: Qudt.unitFromLocalnameRequired("CentiBAR"),
  // Millisievert
  MilliSV: Qudt.unitFromLocalnameRequired("MilliSV"),
  // Pound Mass Hour per Us Gallon Cubic Foot
  LB__HR__PER__GAL_US__FT3: Qudt.unitFromLocalnameRequired(
    "LB-HR-PER-GAL_US-FT3"
  ),
  // Kilogram per Square Meter Second
  KiloGM__PER__M2__SEC: Qudt.unitFromLocalnameRequired("KiloGM-PER-M2-SEC"),
  // Micromole per Gram Second
  MicroMOL__PER__GM__SEC: Qudt.unitFromLocalnameRequired("MicroMOL-PER-GM-SEC"),
  // Calorie (15 Degrees C)
  CAL_15DEG_C: Qudt.unitFromLocalnameRequired("CAL_15DEG_C"),
  // Ampere per Gram
  A__PER__GM: Qudt.unitFromLocalnameRequired("A-PER-GM"),
  // Gill (UK) per Hour
  GI_UK__PER__HR: Qudt.unitFromLocalnameRequired("GI_UK-PER-HR"),
  // Vatu
  CCY_VUV_Currency: Qudt.unitFromLocalnameRequired("CCY_VUV"),
  // Kilolitre
  KiloL: Qudt.unitFromLocalnameRequired("KiloL"),
  // Percent Hour per Cubic Inch
  PERCENT__HR__PER__IN3: Qudt.unitFromLocalnameRequired("PERCENT-HR-PER-IN3"),
  // Metre per Pascal
  M__PER__PA: Qudt.unitFromLocalnameRequired("M-PER-PA"),
  // Microgray per Hour
  MicroGRAY__PER__HR: Qudt.unitFromLocalnameRequired("MicroGRAY-PER-HR"),
  // Milligray per Minute
  MilliGRAY__PER__MIN: Qudt.unitFromLocalnameRequired("MilliGRAY-PER-MIN"),
  // Decibel Carrier Unit
  DeciB_C: Qudt.unitFromLocalnameRequired("DeciB_C"),
  // British Thermal Unit (thermochemical Definition) per Degree Fahrenheit
  BTU_TH__PER__DEG_F: Qudt.unitFromLocalnameRequired("BTU_TH-PER-DEG_F"),
  // Quetzal
  CCY_GTQ_Currency: Qudt.unitFromLocalnameRequired("CCY_GTQ"),
  // Degree Fahrenheit Second per British Thermal Unit (international Definition)
  DEG_F__SEC__PER__BTU_IT: Qudt.unitFromLocalnameRequired(
    "DEG_F-SEC-PER-BTU_IT"
  ),
  // GigaVolt Ampere Reactive
  GigaV__A_Reactive: Qudt.unitFromLocalnameRequired("GigaV-A_Reactive"),
  // Standard Atmosphere per Metre
  ATM__PER__M: Qudt.unitFromLocalnameRequired("ATM-PER-M"),
  // Millihenry
  MilliH: Qudt.unitFromLocalnameRequired("MilliH"),
  // Microgram
  MicroGM: Qudt.unitFromLocalnameRequired("MicroGM"),
  // Frame per Second
  FRAME__PER__SEC: Qudt.unitFromLocalnameRequired("FRAME-PER-SEC"),
  // Percent Hour per Gallon (UK)
  PERCENT__HR__PER__GAL_UK: Qudt.unitFromLocalnameRequired(
    "PERCENT-HR-PER-GAL_UK"
  ),
  // Gigacoulomb
  GigaC: Qudt.unitFromLocalnameRequired("GigaC"),
  // Long Furlong
  FUR_Long: Qudt.unitFromLocalnameRequired("FUR_Long"),
  // Milliampere Second
  MilliA__SEC: Qudt.unitFromLocalnameRequired("MilliA-SEC"),
  // Kilogram Square Second
  KiloGM__SEC2: Qudt.unitFromLocalnameRequired("KiloGM-SEC2"),
  // Picomole per Cubic Meter Second
  PicoMOL__PER__M3__SEC: Qudt.unitFromLocalnameRequired("PicoMOL-PER-M3-SEC"),
  // Kilojoule per Minute
  KiloJ__PER__MIN: Qudt.unitFromLocalnameRequired("KiloJ-PER-MIN"),
  // British Thermal Unit (thermochemical Definition) per Square Foot Hour
  BTU_TH__PER__FT2__HR: Qudt.unitFromLocalnameRequired("BTU_TH-PER-FT2-HR"),
  // Kilo Pound Force Foot per Ampere
  KiloLB_F__FT__PER__A: Qudt.unitFromLocalnameRequired("KiloLB_F-FT-PER-A"),
  // Exbibit
  ExbiBIT: Qudt.unitFromLocalnameRequired("ExbiBIT"),
  // Megayear
  MegaYR: Qudt.unitFromLocalnameRequired("MegaYR"),
  // Barbados Dollar
  CCY_BBD: Qudt.unitFromLocalnameRequired("CCY_BBD"),
  // Mongolian Tugrik
  CCY_MNT: Qudt.unitFromLocalnameRequired("CCY_MNT"),
  // Gigajoule per Hour
  GigaJ__PER__HR: Qudt.unitFromLocalnameRequired("GigaJ-PER-HR"),
  // Euro per Kilowatt
  CCY_EUR__PER__KiloW: Qudt.unitFromLocalnameRequired("CCY_EUR-PER-KiloW"),
  // Attofarad
  AttoFARAD: Qudt.unitFromLocalnameRequired("AttoFARAD"),
  // Metical
  CCY_MZN_Currency: Qudt.unitFromLocalnameRequired("CCY_MZN"),
  // Megahertz per Tesla
  MegaHZ__PER__T: Qudt.unitFromLocalnameRequired("MegaHZ-PER-T"),
  // Reciprocal Square Electron Volt
  PER__EV2: Qudt.unitFromLocalnameRequired("PER-EV2"),
  // Sievert per Minute
  SV__PER__MIN: Qudt.unitFromLocalnameRequired("SV-PER-MIN"),
  // International Mile
  MI: Qudt.unitFromLocalnameRequired("MI"),
  // Foot Pound Force per Minute
  FT__LB_F__PER__MIN: Qudt.unitFromLocalnameRequired("FT-LB_F-PER-MIN"),
  // Reciprocal Kilogram
  PER__KiloGM: Qudt.unitFromLocalnameRequired("PER-KiloGM"),
  // DEG_C_GROWING_CEREAL
  DEG_C_GROWING_CEREAL: Qudt.unitFromLocalnameRequired("DEG_C_GROWING_CEREAL"),
  // British Thermal Unit (thermochemical Definition) per Hour Square Foot Degree Fahrenheit
  BTU_TH__PER__HR__FT2__DEG_F: Qudt.unitFromLocalnameRequired(
    "BTU_TH-PER-HR-FT2-DEG_F"
  ),
  // Us Liquid Cup
  CUP: Qudt.unitFromLocalnameRequired("CUP"),
  // Foot Lambert
  LA_FT: Qudt.unitFromLocalnameRequired("LA_FT"),
  // Mole per Cubic Decimeter
  MOL__PER__DeciM3: Qudt.unitFromLocalnameRequired("MOL-PER-DeciM3"),
  // Cubic Millimetre per Gram
  MilliM3__PER__GM: Qudt.unitFromLocalnameRequired("MilliM3-PER-GM"),
  // Swedish Krona per Kilowatt Hour
  CCY_SEK__PER__KiloW__HR: Qudt.unitFromLocalnameRequired(
    "CCY_SEK-PER-KiloW-HR"
  ),
  // Kelvin Day
  K__DAY: Qudt.unitFromLocalnameRequired("K-DAY"),
  // Megahertz Kilometer
  MegaHZ__KiloM: Qudt.unitFromLocalnameRequired("MegaHZ-KiloM"),
  // Kilo Pound Force Foot per Pound Mass
  KiloLB_F__FT__PER__LB: Qudt.unitFromLocalnameRequired("KiloLB_F-FT-PER-LB"),
  // Newton Metre Second
  N__M__SEC: Qudt.unitFromLocalnameRequired("N-M-SEC"),
  // Oct
  OCT: Qudt.unitFromLocalnameRequired("OCT"),
  // Milliampere Square Inch per Pound Force
  MilliA__IN2__PER__LB_F: Qudt.unitFromLocalnameRequired("MilliA-IN2-PER-LB_F"),
  // Square Inch per Second
  IN2__PER__SEC: Qudt.unitFromLocalnameRequired("IN2-PER-SEC"),
  // Millibecquerel
  MilliBQ: Qudt.unitFromLocalnameRequired("MilliBQ"),
  // Millimeter per Square Meter
  MilliM__PER__M2: Qudt.unitFromLocalnameRequired("MilliM-PER-M2"),
  // Poundal
  PDL: Qudt.unitFromLocalnameRequired("PDL"),
  // Pound Mass per Cubic Inch
  LB__PER__IN3: Qudt.unitFromLocalnameRequired("LB-PER-IN3"),
  // Pound Mass per Second Psi
  LB__PER__SEC__PSI: Qudt.unitFromLocalnameRequired("LB-PER-SEC-PSI"),
  // Lao Kip
  CCY_LAK: Qudt.unitFromLocalnameRequired("CCY_LAK"),
  // Percent Minute per Cubic Foot
  PERCENT__MIN__PER__FT3: Qudt.unitFromLocalnameRequired("PERCENT-MIN-PER-FT3"),
  // Volt Ampere Reactive Hour
  VAR__HR: Qudt.unitFromLocalnameRequired("VAR-HR"),
  // Gram per Cubic Decimeter Bar
  GM__PER__DeciM3__BAR: Qudt.unitFromLocalnameRequired("GM-PER-DeciM3-BAR"),
  // Ounce Troy
  OZ_TROY: Qudt.unitFromLocalnameRequired("OZ_TROY"),
  // Reciprocal Square Joule
  PER__J2: Qudt.unitFromLocalnameRequired("PER-J2"),
  // Decapascal
  DecaPA: Qudt.unitFromLocalnameRequired("DecaPA"),
  // Bahamian Dollar
  CCY_BSD_Currency: Qudt.unitFromLocalnameRequired("CCY_BSD"),
  // Gill (US) per Minute
  GI_US__PER__MIN: Qudt.unitFromLocalnameRequired("GI_US-PER-MIN"),
  // Mole per Liter Kelvin
  MOL__PER__L__K: Qudt.unitFromLocalnameRequired("MOL-PER-L-K"),
  // Megajoule per Square Meter
  MegaJ__PER__M2: Qudt.unitFromLocalnameRequired("MegaJ-PER-M2"),
  // Gravity
  G: Qudt.unitFromLocalnameRequired("G"),
  // Erg per Centimeter
  ERG__PER__CentiM: Qudt.unitFromLocalnameRequired("ERG-PER-CentiM"),
  // Pixel (area)
  PIXEL_AREA: Qudt.unitFromLocalnameRequired("PIXEL_AREA"),
  // Joule per Quartic Metre
  J__PER__M4: Qudt.unitFromLocalnameRequired("J-PER-M4"),
  // Reciprocal Bar
  PER__BAR: Qudt.unitFromLocalnameRequired("PER-BAR"),
  // Metric Ton per Minute Kelvin
  TON_Metric__PER__MIN__K: Qudt.unitFromLocalnameRequired(
    "TON_Metric-PER-MIN-K"
  ),
  // Cfp Franc
  CCY_XPF_Currency: Qudt.unitFromLocalnameRequired("CCY_XPF"),
  // Milli Volt Ampere per Kelvin
  MilliVA__PER__K: Qudt.unitFromLocalnameRequired("MilliVA-PER-K"),
  // Mebibit per Cubic Meter
  MebiBIT__PER__M3: Qudt.unitFromLocalnameRequired("MebiBIT-PER-M3"),
  // Millisiemens per Meter
  MilliS__PER__M: Qudt.unitFromLocalnameRequired("MilliS-PER-M"),
  // Cubic Foot per Pound Mass
  FT3__PER__LB: Qudt.unitFromLocalnameRequired("FT3-PER-LB"),
  // A_Reactive
  A_Reactive: Qudt.unitFromLocalnameRequired("A_Reactive"),
  // Kilohertz Metre
  KiloHZ__M: Qudt.unitFromLocalnameRequired("KiloHZ-M"),
  // Reciprocal Megakelvin
  PER__MegaK: Qudt.unitFromLocalnameRequired("PER-MegaK"),
  // Peta Floating Point Operations per Second
  PetaFLOPS: Qudt.unitFromLocalnameRequired("PetaFLOPS"),
  // Decicoulomb
  DeciC: Qudt.unitFromLocalnameRequired("DeciC"),
  // Kilobyte
  KiloBYTE: Qudt.unitFromLocalnameRequired("KiloBYTE"),
  // Square Volt per Square Kelvin
  V2__PER__K2: Qudt.unitFromLocalnameRequired("V2-PER-K2"),
  // Sun Protection Factor
  SPF: Qudt.unitFromLocalnameRequired("SPF"),
  // Pascal Metre per Second
  PA__M__PER__SEC: Qudt.unitFromLocalnameRequired("PA-M-PER-SEC"),
  // Jamaican Dollar
  CCY_JMD: Qudt.unitFromLocalnameRequired("CCY_JMD"),
  // Kilogram
  KiloGM: Qudt.unitFromLocalnameRequired("KiloGM"),
  // Nanosievert per Second
  NanoSV__PER__SEC: Qudt.unitFromLocalnameRequired("NanoSV-PER-SEC"),
  // Lithuanian Litas
  CCY_LTL_Currency: Qudt.unitFromLocalnameRequired("CCY_LTL"),
  // Ounce Mass Hour per Sextic Inch
  OZ__HR__PER__IN6: Qudt.unitFromLocalnameRequired("OZ-HR-PER-IN6"),
  // Milligram per Cubic Metre Hour
  MilliGM__PER__M3__HR: Qudt.unitFromLocalnameRequired("MilliGM-PER-M3-HR"),
  // Gram Second per Cubic Meter Liter
  GM__SEC__PER__M3__L: Qudt.unitFromLocalnameRequired("GM-SEC-PER-M3-L"),
  // Nanosiemens
  NanoS: Qudt.unitFromLocalnameRequired("NanoS"),
  // Boiler Horsepower
  HP_Boiler: Qudt.unitFromLocalnameRequired("HP_Boiler"),
  // Millimeter per Meter
  MilliM__PER__M: Qudt.unitFromLocalnameRequired("MilliM-PER-M"),
  // Ounce Mass per Square Foot
  OZ__PER__FT2: Qudt.unitFromLocalnameRequired("OZ-PER-FT2"),
  // Manat
  CCY_TMT_Currency: Qudt.unitFromLocalnameRequired("CCY_TMT"),
  // Liter per Mole Second
  L__PER__MOL__SEC: Qudt.unitFromLocalnameRequired("L-PER-MOL-SEC"),
  // Barbados Dollar
  CCY_BBD_Currency: Qudt.unitFromLocalnameRequired("CCY_BBD"),
  // Pound Mass Hour per Square Us Gallon
  LB__HR__PER__GAL_US2: Qudt.unitFromLocalnameRequired("LB-HR-PER-GAL_US2"),
  // Centimetre per Hour
  CentiM__PER__HR: Qudt.unitFromLocalnameRequired("CentiM-PER-HR"),
  // Milligram per Hour
  MilliGM__PER__HR: Qudt.unitFromLocalnameRequired("MilliGM-PER-HR"),
  // Cyprus Pound
  CCY_CYP_Currency: Qudt.unitFromLocalnameRequired("CCY_CYP"),
  // New Israeli Shekel
  CCY_ILS_Currency: Qudt.unitFromLocalnameRequired("CCY_ILS"),
  // Joule per Kilogram
  J__PER__KiloGM: Qudt.unitFromLocalnameRequired("J-PER-KiloGM"),
  // Kilogram Meter
  KiloGM__M: Qudt.unitFromLocalnameRequired("KiloGM-M"),
  // Barrel (us Petroleum) per Second
  BBL_US_PET__PER__SEC: Qudt.unitFromLocalnameRequired("BBL_US_PET-PER-SEC"),
  // Mega Volt Ampere
  MegaVA: Qudt.unitFromLocalnameRequired("MegaVA"),
  // British Thermal Unit (international Definition) per Cubic Foot
  BTU_IT__PER__FT3: Qudt.unitFromLocalnameRequired("BTU_IT-PER-FT3"),
  // Newton Second per Meter
  N__SEC__PER__M: Qudt.unitFromLocalnameRequired("N-SEC-PER-M"),
  // Degree Fahrenheit Hour Square Foot per British Thermal Unit (thermochemical Definition)
  DEG_F__HR__FT2__PER__BTU_TH: Qudt.unitFromLocalnameRequired(
    "DEG_F-HR-FT2-PER-BTU_TH"
  ),
  // Balboa
  CCY_PAB_Currency: Qudt.unitFromLocalnameRequired("CCY_PAB"),
  // Torr per Meter
  TORR__PER__M: Qudt.unitFromLocalnameRequired("TORR-PER-M"),
  // MegaVolt Ampere Reactive
  MegaV__A_Reactive: Qudt.unitFromLocalnameRequired("MegaV-A_Reactive"),
  // Danish Krone
  CCY_DKK_Currency: Qudt.unitFromLocalnameRequired("CCY_DKK"),
  // Square Metre per Hour
  M2__PER__HR: Qudt.unitFromLocalnameRequired("M2-PER-HR"),
  // Megaampere per Square Metre
  MegaA__PER__M2: Qudt.unitFromLocalnameRequired("MegaA-PER-M2"),
  // Boliviano
  CCY_BOB_Currency: Qudt.unitFromLocalnameRequired("CCY_BOB"),
  // Cubic Decimeter per Mole
  DeciM3__PER__MOL: Qudt.unitFromLocalnameRequired("DeciM3-PER-MOL"),
  // Number per Gram
  NUM__PER__GM: Qudt.unitFromLocalnameRequired("NUM-PER-GM"),
  // Volt Ampere
  VA: Qudt.unitFromLocalnameRequired("VA"),
  // Poundal Inch
  PDL__IN: Qudt.unitFromLocalnameRequired("PDL-IN"),
  // Kilomole per Cubic Meter Bar
  KiloMOL__PER__M3__BAR: Qudt.unitFromLocalnameRequired("KiloMOL-PER-M3-BAR"),
  // Uganda Shilling
  CCY_UGX: Qudt.unitFromLocalnameRequired("CCY_UGX"),
  // Becquerel per Kilogram
  BQ__PER__KiloGM: Qudt.unitFromLocalnameRequired("BQ-PER-KiloGM"),
  // Foot of Water (39.2 °F)
  FT_H2O_39dot2DEG_F: Qudt.unitFromLocalnameRequired("FT_H2O_39dot2DEG_F"),
  // Petajoule per Second
  PetaJ__PER__SEC: Qudt.unitFromLocalnameRequired("PetaJ-PER-SEC"),
  // Centimetre of Water (4 °C)
  CentiM_H2O_4DEG_C: Qudt.unitFromLocalnameRequired("CentiM_H2O_4DEG_C"),
  // Abtesla
  T_Ab: Qudt.unitFromLocalnameRequired("T_Ab"),
  // British Thermal Unit (international Definition) Inch per Second Square Foot Degree Fahrenheit
  BTU_IT__IN__PER__SEC__FT2__DEG_F: Qudt.unitFromLocalnameRequired(
    "BTU_IT-IN-PER-SEC-FT2-DEG_F"
  ),
  // Joule per Kilogram Kelvin Cubic Metre
  J__PER__KiloGM__K__M3: Qudt.unitFromLocalnameRequired("J-PER-KiloGM-K-M3"),
  // Pound Force Inch per Inch
  LB_F__IN__PER__IN: Qudt.unitFromLocalnameRequired("LB_F-IN-PER-IN"),
  // Weber
  WB: Qudt.unitFromLocalnameRequired("WB"),
  // Ounce Mass Second per Sextic Inch
  OZ__SEC__PER__IN6: Qudt.unitFromLocalnameRequired("OZ-SEC-PER-IN6"),
  // Ton of Refrigeration
  TON_FG: Qudt.unitFromLocalnameRequired("TON_FG"),
  // Degree Fahrenheit Day
  DEG_F__DAY: Qudt.unitFromLocalnameRequired("DEG_F-DAY"),
  // Yard per Minute
  YD__PER__MIN: Qudt.unitFromLocalnameRequired("YD-PER-MIN"),
  // Cubic Meter per Day Kelvin
  M3__PER__DAY__K: Qudt.unitFromLocalnameRequired("M3-PER-DAY-K"),
  // Megabecquerel per Kilogram
  MegaBQ__PER__KiloGM: Qudt.unitFromLocalnameRequired("MegaBQ-PER-KiloGM"),
  // Volt per Microsecond
  V__PER__MicroSEC: Qudt.unitFromLocalnameRequired("V-PER-MicroSEC"),
  // Square Foot Hour Degree Fahrenheit per British Thermal Unit (international Definition)
  FT2__HR__DEG_F__PER__BTU_IT: Qudt.unitFromLocalnameRequired(
    "FT2-HR-DEG_F-PER-BTU_IT"
  ),
  // Degree Celsius per Second
  DEG_C__PER__SEC: Qudt.unitFromLocalnameRequired("DEG_C-PER-SEC"),
  // Kilonewton per Square Millimeter
  KiloN__PER__MilliM2: Qudt.unitFromLocalnameRequired("KiloN-PER-MilliM2"),
  // Lux Hour
  LUX__HR: Qudt.unitFromLocalnameRequired("LUX-HR"),
  // Milli Roentgen Equivalent Man
  MilliR_man: Qudt.unitFromLocalnameRequired("MilliR_man"),
  // Barrel (UK Petroleum) per Day
  BBL_UK_PET__PER__DAY: Qudt.unitFromLocalnameRequired("BBL_UK_PET-PER-DAY"),
  // Cubic Metre per Second Square Metre
  M3__PER__SEC__M2: Qudt.unitFromLocalnameRequired("M3-PER-SEC-M2"),
  // Milliampere per Kelvin
  MilliA__PER__K: Qudt.unitFromLocalnameRequired("MilliA-PER-K"),
  // Ohm Circular Mil per Foot
  OHM_CIRC__MIL__PER__FT: Qudt.unitFromLocalnameRequired("OHM_CIRC-MIL-PER-FT"),
  // Degree Celsius per Hour
  DEG_C__PER__HR: Qudt.unitFromLocalnameRequired("DEG_C-PER-HR"),
  // Abvolt per Centimeter
  V_Ab__PER__CentiM: Qudt.unitFromLocalnameRequired("V_Ab-PER-CentiM"),
  // Pound Force per Square Inch Degree Fahrenheit
  LB_F__PER__IN2__DEG_F: Qudt.unitFromLocalnameRequired("LB_F-PER-IN2-DEG_F"),
  // Planck Force
  PlanckForce: Qudt.unitFromLocalnameRequired("PlanckForce"),
  // Planck Energy
  PlanckEnergy: Qudt.unitFromLocalnameRequired("PlanckEnergy"),
  // Liter per Liter
  L__PER__L: Qudt.unitFromLocalnameRequired("L-PER-L"),
  // Fractional Area
  FA: Qudt.unitFromLocalnameRequired("FA"),
  // Milligram Hour per Square Liter
  MilliGM__HR__PER__L2: Qudt.unitFromLocalnameRequired("MilliGM-HR-PER-L2"),
  // Ounce Mass per Second
  OZ__PER__SEC: Qudt.unitFromLocalnameRequired("OZ-PER-SEC"),
  // Hectometre
  HectoM: Qudt.unitFromLocalnameRequired("HectoM"),
  // Gross Tonnage
  GT: Qudt.unitFromLocalnameRequired("GT"),
  // Gram per Day Bar
  GM__PER__DAY__BAR: Qudt.unitFromLocalnameRequired("GM-PER-DAY-BAR"),
  // Cubic Foot per Hour
  FT3__PER__HR: Qudt.unitFromLocalnameRequired("FT3-PER-HR"),
  // Radian per Hour
  RAD__PER__HR: Qudt.unitFromLocalnameRequired("RAD-PER-HR"),
  // Therm Us
  THM_US: Qudt.unitFromLocalnameRequired("THM_US"),
  // Milligram Hour per Litre Cubic Centimetre
  MilliGM__HR__PER__L__CentiM3: Qudt.unitFromLocalnameRequired(
    "MilliGM-HR-PER-L-CentiM3"
  ),
  // Gram Minute per Sextic Meter
  GM__MIN__PER__M6: Qudt.unitFromLocalnameRequired("GM-MIN-PER-M6"),
  // Us Liquid Ounce per Day
  OZ_VOL_US__PER__DAY: Qudt.unitFromLocalnameRequired("OZ_VOL_US-PER-DAY"),
  // Picomole per Square Meter Day
  PicoMOL__PER__M2__DAY: Qudt.unitFromLocalnameRequired("PicoMOL-PER-M2-DAY"),
  // Kelvin Meter per Watt
  K__M__PER__W: Qudt.unitFromLocalnameRequired("K-M-PER-W"),
  // Square Metre per Hectare Year
  M2__PER__HA__YR: Qudt.unitFromLocalnameRequired("M2-PER-HA-YR"),
  // Short Ton per Hour Psi
  TON_SHORT__PER__HR__PSI: Qudt.unitFromLocalnameRequired(
    "TON_SHORT-PER-HR-PSI"
  ),
  // Penny Weight
  DWT: Qudt.unitFromLocalnameRequired("DWT"),
  // Kilogram per Square Kilometer
  KiloGM__PER__KiloM2: Qudt.unitFromLocalnameRequired("KiloGM-PER-KiloM2"),
  // Milligram Second per Litre Cubic Metre
  MilliGM__SEC__PER__L__M3: Qudt.unitFromLocalnameRequired(
    "MilliGM-SEC-PER-L-M3"
  ),
  // Absiemen
  S_Ab: Qudt.unitFromLocalnameRequired("S_Ab"),
  // Relative Electromagnetic Permeability
  PERMEABILITY_EM_REL: Qudt.unitFromLocalnameRequired("PERMEABILITY_EM_REL"),
  // Pound Mass per Hour
  LB__PER__HR: Qudt.unitFromLocalnameRequired("LB-PER-HR"),
  // Radian per Minute
  RAD__PER__MIN: Qudt.unitFromLocalnameRequired("RAD-PER-MIN"),
  // Romanian New Leu per Kilowatt Hour
  CCY_RON__PER__KiloW__HR: Qudt.unitFromLocalnameRequired(
    "CCY_RON-PER-KiloW-HR"
  ),
  // Pound Mass Inch
  LB__IN: Qudt.unitFromLocalnameRequired("LB-IN"),
  // Ouguiya
  CCY_MRU: Qudt.unitFromLocalnameRequired("CCY_MRU"),
  // Megavolt per Meter
  MegaV__PER__M: Qudt.unitFromLocalnameRequired("MegaV-PER-M"),
  // Netherlands Antillian Guilder
  CCY_ANG_Currency: Qudt.unitFromLocalnameRequired("CCY_ANG"),
  // Joule per Mole Kelvin
  J__PER__MOL__K: Qudt.unitFromLocalnameRequired("J-PER-MOL-K"),
  // New Zealand Dollar
  CCY_NZD: Qudt.unitFromLocalnameRequired("CCY_NZD"),
  // Big Point
  PT_BIG: Qudt.unitFromLocalnameRequired("PT_BIG"),
  // Kilogram per Kilometer
  KiloGM__PER__KiloM: Qudt.unitFromLocalnameRequired("KiloGM-PER-KiloM"),
  // Pound Force
  LB_F: Qudt.unitFromLocalnameRequired("LB_F"),
  // Mole per Second
  MOL__PER__SEC: Qudt.unitFromLocalnameRequired("MOL-PER-SEC"),
  // Kilogram per Meter Day
  KiloGM__PER__M__DAY: Qudt.unitFromLocalnameRequired("KiloGM-PER-M-DAY"),
  // Poise per Bar
  POISE__PER__BAR: Qudt.unitFromLocalnameRequired("POISE-PER-BAR"),
  // Cubic Inch per Second
  IN3__PER__SEC: Qudt.unitFromLocalnameRequired("IN3-PER-SEC"),
  // Kilometre
  KiloM: Qudt.unitFromLocalnameRequired("KiloM"),
  // Pound Mass per Minute Psi
  LB__PER__MIN__PSI: Qudt.unitFromLocalnameRequired("LB-PER-MIN-PSI"),
  // Degree Fahrenheit Hour Square Foot per British Thermal Unit (international Definition)
  DEG_F__HR__FT2__PER__BTU_IT: Qudt.unitFromLocalnameRequired(
    "DEG_F-HR-FT2-PER-BTU_IT"
  ),
  // Gibibit per Square Meter
  GibiBIT__PER__M2: Qudt.unitFromLocalnameRequired("GibiBIT-PER-M2"),
  // HectoCOUNT
  HectoCOUNT: Qudt.unitFromLocalnameRequired("HectoCOUNT"),
  // Number per Microliter
  NUM__PER__MicroL: Qudt.unitFromLocalnameRequired("NUM-PER-MicroL"),
  // Mole per Kilogram Kelvin
  MOL__PER__KiloGM__K: Qudt.unitFromLocalnameRequired("MOL-PER-KiloGM-K"),
  // Reciprocal Henry
  PER__H: Qudt.unitFromLocalnameRequired("PER-H"),
  // Denier
  Denier: Qudt.unitFromLocalnameRequired("Denier"),
  // Femtomole per Liter
  FemtoMOL__PER__L: Qudt.unitFromLocalnameRequired("FemtoMOL-PER-L"),
  // Decigram
  DeciGM: Qudt.unitFromLocalnameRequired("DeciGM"),
  // Square Metre per Second
  M2__PER__SEC: Qudt.unitFromLocalnameRequired("M2-PER-SEC"),
  // Denar
  CCY_MKD: Qudt.unitFromLocalnameRequired("CCY_MKD"),
  // Becquerel
  BQ: Qudt.unitFromLocalnameRequired("BQ"),
  // Gold Franc (special Settlement Currency)
  CCY_XFO: Qudt.unitFromLocalnameRequired("CCY_XFO"),
  // Pound Mass Hour per Us Gallon Cubic Inch
  LB__HR__PER__GAL_US__IN3: Qudt.unitFromLocalnameRequired(
    "LB-HR-PER-GAL_US-IN3"
  ),
  // Lek
  CCY_ALL_Currency: Qudt.unitFromLocalnameRequired("CCY_ALL"),
  // Yottacoulomb
  YottaC: Qudt.unitFromLocalnameRequired("YottaC"),
  // Nanohenry
  NanoH: Qudt.unitFromLocalnameRequired("NanoH"),
  // Stone (UK)
  Stone_UK: Qudt.unitFromLocalnameRequired("Stone_UK"),
  // Neper per Second
  NP__PER__SEC: Qudt.unitFromLocalnameRequired("NP-PER-SEC"),
  // Nanomole per Kilogram
  NanoMOL__PER__KiloGM: Qudt.unitFromLocalnameRequired("NanoMOL-PER-KiloGM"),
  // Kilogram per Cubic Meter
  KiloGM__PER__M3: Qudt.unitFromLocalnameRequired("KiloGM-PER-M3"),
  // Reciprocal Kelvin
  PER__K: Qudt.unitFromLocalnameRequired("PER-K"),
  // Foot per Psi
  FT__PER__PSI: Qudt.unitFromLocalnameRequired("FT-PER-PSI"),
  // Kenyan Shilling
  CCY_KES_Currency: Qudt.unitFromLocalnameRequired("CCY_KES"),
  // Millipascal
  MilliPA: Qudt.unitFromLocalnameRequired("MilliPA"),
  // North Korean Won
  CCY_KPW: Qudt.unitFromLocalnameRequired("CCY_KPW"),
  // Milligram Minute per Square Liter
  MilliGM__MIN__PER__L2: Qudt.unitFromLocalnameRequired("MilliGM-MIN-PER-L2"),
  // Ethiopian Birr
  CCY_ETB_Currency: Qudt.unitFromLocalnameRequired("CCY_ETB"),
  // Terajoule
  TeraJ: Qudt.unitFromLocalnameRequired("TeraJ"),
  // Watt per Meter Kelvin
  W__PER__M__K: Qudt.unitFromLocalnameRequired("W-PER-M-K"),
  // Japanese Yen
  CCY_JPY_Currency: Qudt.unitFromLocalnameRequired("CCY_JPY"),
  // Ounce Mass per Minute
  OZ__PER__MIN: Qudt.unitFromLocalnameRequired("OZ-PER-MIN"),
  // Reciprocal Second Square Meter
  PER__SEC__M2: Qudt.unitFromLocalnameRequired("PER-SEC-M2"),
  // Kuwaiti Dinar
  CCY_KWD: Qudt.unitFromLocalnameRequired("CCY_KWD"),
  // Pint (UK) per Minute
  PINT_UK__PER__MIN: Qudt.unitFromLocalnameRequired("PINT_UK-PER-MIN"),
  // Mole per Kilogram
  MOL__PER__KiloGM: Qudt.unitFromLocalnameRequired("MOL-PER-KiloGM"),
  // Kilogram Centimetre per Second
  KiloGM__CentiM__PER__SEC: Qudt.unitFromLocalnameRequired(
    "KiloGM-CentiM-PER-SEC"
  ),
  // Degree Fahrenheit Hour Square Foot per British Thermal Unit (international Definition) Inch
  DEG_F__HR__FT2__PER__BTU_IT__IN: Qudt.unitFromLocalnameRequired(
    "DEG_F-HR-FT2-PER-BTU_IT-IN"
  ),
  // Kilogram per Minute
  KiloGM__PER__MIN: Qudt.unitFromLocalnameRequired("KiloGM-PER-MIN"),
  // Newton
  N: Qudt.unitFromLocalnameRequired("N"),
  // Square Mile Us Statute
  MI_US2: Qudt.unitFromLocalnameRequired("MI_US2"),
  // Percent per Inch
  PERCENT__PER__IN: Qudt.unitFromLocalnameRequired("PERCENT-PER-IN"),
  // Reciprocal Second Steradian
  PER__SEC__SR: Qudt.unitFromLocalnameRequired("PER-SEC-SR"),
  // 2pirad
  _2PiRAD: Qudt.unitFromLocalnameRequired("2PiRAD"),
  // Volt Ampere per Kelvin
  VA__PER__K: Qudt.unitFromLocalnameRequired("VA-PER-K"),
  // Degree Twaddell
  DEGREE_TWADDELL: Qudt.unitFromLocalnameRequired("DEGREE_TWADDELL"),
  // Milligram Second per Cubic Meter Cubic Centimeter
  MilliGM__SEC__PER__M3__CentiM3: Qudt.unitFromLocalnameRequired(
    "MilliGM-SEC-PER-M3-CentiM3"
  ),
  // Burundian Franc
  CCY_BIF_Currency: Qudt.unitFromLocalnameRequired("CCY_BIF"),
  // Comoro Franc
  CCY_KMF_Currency: Qudt.unitFromLocalnameRequired("CCY_KMF"),
  // Megapascal per Kelvin
  MegaPA__PER__K: Qudt.unitFromLocalnameRequired("MegaPA-PER-K"),
  // Degree Fahrenheit per Second
  DEG_F__PER__SEC: Qudt.unitFromLocalnameRequired("DEG_F-PER-SEC"),
  // Milliohm per Kelvin
  MilliOHM__PER__K: Qudt.unitFromLocalnameRequired("MilliOHM-PER-K"),
  // Number per Square Kilometre
  NUM__PER__KiloM2: Qudt.unitFromLocalnameRequired("NUM-PER-KiloM2"),
  // Libyan Dinar
  CCY_LYD_Currency: Qudt.unitFromLocalnameRequired("CCY_LYD"),
  // Pound Mass per Inch
  LB__PER__IN: Qudt.unitFromLocalnameRequired("LB-PER-IN"),
  // Millivolt per Minute
  MilliV__PER__MIN: Qudt.unitFromLocalnameRequired("MilliV-PER-MIN"),
  // Ethiopian Birr
  CCY_ETB: Qudt.unitFromLocalnameRequired("CCY_ETB"),
  // British Thermal Unit (international Definition) per Pound Force Degree Fahrenheit
  BTU_IT__PER__LB_F__DEG_F: Qudt.unitFromLocalnameRequired(
    "BTU_IT-PER-LB_F-DEG_F"
  ),
  // Coulomb
  C: Qudt.unitFromLocalnameRequired("C"),
  // Kiloohm per Metre
  KiloOHM__PER__M: Qudt.unitFromLocalnameRequired("KiloOHM-PER-M"),
  // Kilogram per Cubic Centimetre
  KiloGM__PER__CentiM3: Qudt.unitFromLocalnameRequired("KiloGM-PER-CentiM3"),
  // Reciprocal Millimetre
  PER__MilliM: Qudt.unitFromLocalnameRequired("PER-MilliM"),
  // Exabyte
  ExaBYTE: Qudt.unitFromLocalnameRequired("ExaBYTE"),
  // Newton Centimeter
  N__CentiM: Qudt.unitFromLocalnameRequired("N-CentiM"),
  // Percent per Day
  PERCENT__PER__DAY: Qudt.unitFromLocalnameRequired("PERCENT-PER-DAY"),
  // Psi Cubic Inch per Second
  PSI__IN3__PER__SEC: Qudt.unitFromLocalnameRequired("PSI-IN3-PER-SEC"),
  // Swiss Franc per Kilogram
  CCY_CHF__PER__KiloGM: Qudt.unitFromLocalnameRequired("CCY_CHF-PER-KiloGM"),
  // Nanogram per Square Centimeter Day
  NanoGM__PER__CentiM2__DAY: Qudt.unitFromLocalnameRequired(
    "NanoGM-PER-CentiM2-DAY"
  ),
  // Reciprocal Square Meter Second
  PER__M2__SEC: Qudt.unitFromLocalnameRequired("PER-M2-SEC"),
  // Farad per Kilometre
  FARAD__PER__KiloM: Qudt.unitFromLocalnameRequired("FARAD-PER-KiloM"),
  // Kilogram per Kilomole
  KiloGM__PER__KiloMOL: Qudt.unitFromLocalnameRequired("KiloGM-PER-KiloMOL"),
  // Cuban Peso
  CCY_CUP_Currency: Qudt.unitFromLocalnameRequired("CCY_CUP"),
  // International Mile per Hour
  MI__PER__HR: Qudt.unitFromLocalnameRequired("MI-PER-HR"),
  // Abvolt
  V_Ab: Qudt.unitFromLocalnameRequired("V_Ab"),
  // Millimetre per Second
  MilliM__PER__SEC: Qudt.unitFromLocalnameRequired("MilliM-PER-SEC"),
  // Gram per Degree Celsius
  GM__PER__DEG_C: Qudt.unitFromLocalnameRequired("GM-PER-DEG_C"),
  // Bushel (US Dry) per Minute
  BU_US_DRY__PER__MIN: Qudt.unitFromLocalnameRequired("BU_US_DRY-PER-MIN"),
  // Philippine Peso
  CCY_PHP: Qudt.unitFromLocalnameRequired("CCY_PHP"),
  // Teravolt
  TeraV: Qudt.unitFromLocalnameRequired("TeraV"),
  // European Composite Unit (eurco) (bonds Market Unit)
  CCY_XBA: Qudt.unitFromLocalnameRequired("CCY_XBA"),
  // Lithuanian Litas
  CCY_LTL: Qudt.unitFromLocalnameRequired("CCY_LTL"),
  // Vatu
  CCY_VUV: Qudt.unitFromLocalnameRequired("CCY_VUV"),
  // Exbibit per Metre
  ExbiBIT__PER__M: Qudt.unitFromLocalnameRequired("ExbiBIT-PER-M"),
  // Cfa Franc Beac
  CCY_XAF: Qudt.unitFromLocalnameRequired("CCY_XAF"),
  // Gram per Cubic Centimeter Kelvin
  GM__PER__CentiM3__K: Qudt.unitFromLocalnameRequired("GM-PER-CentiM3-K"),
  // Nanocoulomb
  NanoC: Qudt.unitFromLocalnameRequired("NanoC"),
  // Gram per Cubic Metre
  GM__PER__M3: Qudt.unitFromLocalnameRequired("GM-PER-M3"),
  // Meganewton Meter
  MegaN__M: Qudt.unitFromLocalnameRequired("MegaN-M"),
  // Gill (UK) per Minute
  GI_UK__PER__MIN: Qudt.unitFromLocalnameRequired("GI_UK-PER-MIN"),
  // Cubic Metre per Day
  M3__PER__DAY: Qudt.unitFromLocalnameRequired("M3-PER-DAY"),
  // Milli Bar Absolute
  MilliBAR_A: Qudt.unitFromLocalnameRequired("MilliBAR_A"),
  // Cubic Meter per Hour
  M3__PER__HR: Qudt.unitFromLocalnameRequired("M3-PER-HR"),
  // Gram per Centimetre Bar
  GM__PER__CentiM__BAR: Qudt.unitFromLocalnameRequired("GM-PER-CentiM-BAR"),
  // Arcminute
  ARCMIN: Qudt.unitFromLocalnameRequired("ARCMIN"),
  // Kilometre per Square Second
  KiloM__PER__SEC2: Qudt.unitFromLocalnameRequired("KiloM-PER-SEC2"),
};

// QuantityKinds
{
  let quantityKind: QuantityKind;
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/APIGravity",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("API Gravity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEGREE_API");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/APIGravity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AbsoluteActivity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Absolute Activity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BQ-SEC-PER-M3");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InverseVolume"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AbsoluteActivity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AbsoluteHumidity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    "AH",
    undefined
  );
  quantityKind.addLabel(new LangString("Absolute Humidity", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-CentiM3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-MicroL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-PER-GAL_IMP"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_LONG-PER-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_Metric-PER-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-IN3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG-PER-FT3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-DeciL");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GRAIN-PER-GAL_IMP"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-MilliL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-DeciL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEGREE_BAUME");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-IN3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-FT3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEGREE_BAUME_US_HEAVY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GRAIN-PER-GAL_US"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-DeciM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-DeciL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEGREE_BAUME_US_LIGHT"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_US-PER-YD3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-YD3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEGREE_BRIX");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-DeciM3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-CentiM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-GAL_US");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-DeciL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoGM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-GAL_UK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEGREE_TWADDELL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckDensity");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ-PER-GAL_IMP"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_UK-PER-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_SHORT-PER-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEGREE_BALLING"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-YD3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEGREE_PLATO");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-GAL_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-GAL_UK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEGREE_OECHSLE"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-M3");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Density"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AbsoluteHumidity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AbsoluteTypographicMeasurement",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("absolute typographic measurement", undefined)
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AbsoluteTypographicMeasurement",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AbsorbedDose",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    "D",
    undefined
  );
  quantityKind.addLabel(new LangString("Absorbed Dose", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGRAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGRAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGRAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGRAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGRAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGRAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliRAD_R");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD_R");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificEnergy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AbsorbedDose",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Absorbed Dose Rate", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroSV-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroSV-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliSV-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliSV-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliW-PER-MilliGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGRAY-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SV-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/REM-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SV-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/ERG-PER-GM-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliSV-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-KiloGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliRAD_R-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAY-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGRAY-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGRAY-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGRAY-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAY-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAY-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroSV-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGRAY-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGRAY-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGRAY-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGRAY-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoSV-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SV-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGRAY-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoSV-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoSV-PER-HR");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Absorptance",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Absorptance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Absorptance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Acceleration",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Ускоре́ние", "ru"));
  quantityKind.addLabel(new LangString("aceleración", "es"));
  quantityKind.addLabel(new LangString("accelerație", "ro"));
  quantityKind.addLabel(new LangString("Όγκος", "el"));
  quantityKind.addLabel(new LangString("ivme", "tr"));
  quantityKind.addLabel(new LangString("加速度", "ja"));
  quantityKind.addLabel(new LangString("Pecutan", "ms"));
  quantityKind.addLabel(new LangString("Zrychlení", "cs"));
  quantityKind.addLabel(new LangString("accelerazione", "it"));
  quantityKind.addLabel(new LangString("شتاب", "fa"));
  quantityKind.addLabel(new LangString("त्वरण", "hi"));
  quantityKind.addLabel(new LangString("التسارع", "ar"));
  quantityKind.addLabel(new LangString("Beschleunigung", "de"));
  quantityKind.addLabel(new LangString("aceleração", "pt"));
  quantityKind.addLabel(new LangString("acceleration", "en"));
  quantityKind.addLabel(new LangString("pospešek", "sl"));
  quantityKind.addLabel(new LangString("accélération", "fr"));
  quantityKind.addLabel(new LangString("przyspieszenie", "pl"));
  quantityKind.addLabel(new LangString("acceleratio", "la"));
  quantityKind.addLabel(new LangString("加速度", "zh"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-SEC2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloPA-M2-PER-GM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GALILEO");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KN-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-SEC2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloM-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-SEC2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGALILEO");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MI_US-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-SEC2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/G");
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/LinearAcceleration"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Acceleration",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AccelerationOfGravity",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-2D0",
    "g",
    undefined
  );
  quantityKind.addLabel(new LangString("Acceleration Of Gravity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-SEC2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloPA-M2-PER-GM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GALILEO");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KN-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-SEC2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloM-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-SEC2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGALILEO");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MI_US-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-SEC2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/G");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Acceleration"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AccelerationOfGravity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AcceptorDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    "n_a",
    undefined
  );
  quantityKind.addLabel(new LangString("Acceptor Density", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-MicroL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-NanoL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-MilliM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-PicoL");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/NumberDensity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AcceptorDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AcceptorIonizationEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "E_a",
    undefined
  );
  quantityKind.addLabel(new LangString("Acceptor Ionization Energy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/IonizationEnergy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AcceptorIonizationEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Acidity",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Acidity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PH");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Acidity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AcousticImpedance",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-1D0",
    "Z",
    undefined
  );
  quantityKind.addLabel(new LangString("Acoustic Impediance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA-SEC-PER-M");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassPerAreaTime"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AcousticImpedance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Action",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-1D0",
    "S",
    undefined
  );
  quantityKind.addLabel(new LangString("Action", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ-SEC");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Action",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ActionTime",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Action Time", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliH-PER-KiloOHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/WK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckTime");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Common");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MO_MeanGREGORIAN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HR_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoSEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroH-PER-KiloOHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H-PER-OHM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroH-PER-OHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DAY_Sidereal");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliPA-SEC-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO_Synodic");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POISE-PER-BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiPOISE-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POISE-PER-PA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliH-PER-OHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_TROPICAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H-PER-KiloOHM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Metrology");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PA-SEC-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloYR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaYR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO_MeanJulian");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Time"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ActionTime",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ActiveEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "W",
    undefined
  );
  quantityKind.addLabel(new LangString("Active Energy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ActiveEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ActivePower",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    "P",
    undefined
  );
  quantityKind.addLabel(new LangString("Active Power", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliW");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPower"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ActivePower",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Activity",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    "A",
    undefined
  );
  quantityKind.addLabel(new LangString("Activity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaBQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoBQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroBQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliCI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaBQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraBQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroCI");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/StochasticProcess"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Activity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ActivityCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "f_B",
    undefined
  );
  quantityKind.addLabel(new LangString("Activity Coefficient", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ActivityCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ActivityConcentration",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T-1D0",
    "c_A",
    undefined
  );
  quantityKind.addLabel(new LangString("Activity Concentration", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BQ-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BQ-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoBQ-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBQ-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroBQ-PER-L");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ActivityConcentration",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ActivityRelatedByMass",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T-1D0",
    "0173-1#Z4-BAJ342#002",
    undefined
  );
  quantityKind.addLabel(new LangString("activity related by mass", "en-US"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloBQ-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CI-PER-KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BQ-PER-KiloGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaBQ-PER-KiloGM"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassicActivity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ActivityRelatedByMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ActivityThresholds",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Activity Thresholds", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ActivityThresholds",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Adaptation",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Adaptation", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliH-PER-KiloOHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/WK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckTime");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Common");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MO_MeanGREGORIAN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HR_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoSEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroH-PER-KiloOHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H-PER-OHM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroH-PER-OHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DAY_Sidereal");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliPA-SEC-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO_Synodic");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POISE-PER-BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiPOISE-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POISE-PER-PA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliH-PER-OHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_TROPICAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H-PER-KiloOHM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Metrology");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PA-SEC-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloYR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaYR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO_MeanJulian");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Time"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Adaptation",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Admittance",
    "http://qudt.org/vocab/dimensionvector/A0E2L-2I0M-1H0T3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Admittance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/S");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroMHO");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MHO");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Admittance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AlphaDisintegrationEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Alpha Disintegration Energy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AlphaDisintegrationEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Altitude",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Altitude", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Altitude",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AmbientPressure",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    "p_a",
    undefined
  );
  quantityKind.addLabel(new LangString("Ambient Pressure", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-IN2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_32DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroTORR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_60DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARYE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA_A");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroATM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliTORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_60DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR_A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR_A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckPressure"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_H2O_4DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_HG_0DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HGA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Pressure"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AmbientPressure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AmountOfBiologicallyActiveSubstance",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("amount of biologically active substance", undefined)
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AmountOfBiologicallyActiveSubstance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AmountOfCloudCover",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Amount of cloud cover", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OKTA");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AmountOfCloudCover",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstance",
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T0D0",
    "n",
    undefined
  );
  quantityKind.addLabel(new LangString("كمية المادة", "ar"));
  quantityKind.addLabel(new LangString("množina snovi", "sl"));
  quantityKind.addLabel(new LangString("quantità di sostanza", "it"));
  quantityKind.addLabel(new LangString("مقدار ماده", "fa"));
  quantityKind.addLabel(new LangString("quantité de matière", "fr"));
  quantityKind.addLabel(new LangString("anyagmennyiség", "hu"));
  quantityKind.addLabel(new LangString("כמות חומר", "he"));
  quantityKind.addLabel(new LangString("Количество вещества", "ru"));
  quantityKind.addLabel(new LangString("cantitate de substanță", "ro"));
  quantityKind.addLabel(new LangString("cantidad de sustancia", "es"));
  quantityKind.addLabel(new LangString("物質量", "ja"));
  quantityKind.addLabel(new LangString("Ποσότητα Ουσίας", "el"));
  quantityKind.addLabel(new LangString("Stoffmenge", "de"));
  quantityKind.addLabel(new LangString("पदार्थ की मात्रा", "hi"));
  quantityKind.addLabel(new LangString("quantitas substantiae", "la"));
  quantityKind.addLabel(new LangString("amount of substance", "en"));
  quantityKind.addLabel(new LangString("madde miktarı", "tr"));
  quantityKind.addLabel(new LangString("Количество вещество", "bg"));
  quantityKind.addLabel(new LangString("Látkové množství", "cs"));
  quantityKind.addLabel(new LangString("quantidade de substância", "pt"));
  quantityKind.addLabel(new LangString("物质的量", "zh"));
  quantityKind.addLabel(new LangString("Jumlah bahan", "ms"));
  quantityKind.addLabel(new LangString("liczność materii", "pl"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoMOL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OSM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiMOL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoMOL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliOSM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloMOL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SCF");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SCM_1ATM_15DEG_C_ISO"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NCM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SCM_1ATM_0DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliMOL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoMOL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SCM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroMOL");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NCM_1ATM_0DEG_C_NL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL_LB");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SCM_1ATM_15DEG_C_NL"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstanceConcentration",
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Amount of Substance of Concentration", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoMOL-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FemtoMOL-PER-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoMOL-PER-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoMOL-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MOL-PER-DeciM3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliMOL-PER-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloMOL-PER-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliMOL-PER-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiMOL-PER-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroMOL-PER-L"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Concentration"
  );
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstancePerVolume"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstanceConcentration",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstanceFraction",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "X_B",
    undefined
  );
  quantityKind.addLabel(new LangString("Fractional Amount of Substance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPT");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstanceFraction",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstanceIonConcentration",
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Ion Concentration", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoMOL-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FemtoMOL-PER-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoMOL-PER-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoMOL-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MOL-PER-DeciM3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliMOL-PER-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloMOL-PER-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliMOL-PER-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiMOL-PER-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroMOL-PER-L"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Concentration"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstanceIonConcentration",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstancePerMass",
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M-1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Amount of Substance per Mass", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MOL-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL_LB-PER-LB");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FemtoMOL-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IU-PER-MilliGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloMOL-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliOSM-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL-PER-TONNE");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoMOL-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoMOL-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliMOL-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiMOL-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoMOL-PER-GM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliMOL-PER-GM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroMOL-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroMOL-PER-GM"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstancePerMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstancePerMassPressure",
    "http://qudt.org/vocab/dimensionvector/A1E0L1I0M-2H0T2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Molar Mass variation due to Pressure", "en")
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MOL-PER-KiloGM-PA"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MOL-PER-KiloGM-BAR"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstancePerMassPressure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstancePerVolume",
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Amount of Substance per Volume", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoMOL-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FemtoMOL-PER-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoMOL-PER-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoMOL-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MOL-PER-DeciM3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliMOL-PER-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloMOL-PER-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliMOL-PER-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiMOL-PER-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroMOL-PER-L"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Concentration"
  );
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstanceConcentration"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstancePerVolume",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Angle",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Angle", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARCSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARCMIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN_Angle");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliARCSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/REV");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/PlaneAngle"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Angle",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AngleOfAttack",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Angle Of Attack", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARCSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARCMIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN_Angle");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliARCSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/REV");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Angle"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AngleOfAttack",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AngleOfOpticalRotation",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Angle of Optical Rotation", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARCSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARCMIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN_Angle");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliARCSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/REV");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Angle"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AngleOfOpticalRotation",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AngularAcceleration",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Угловое ускорение", "ru"));
  quantityKind.addLabel(new LangString("角加速度", "zh"));
  quantityKind.addLabel(new LangString("angular acceleration", "en"));
  quantityKind.addLabel(new LangString("Pecutan bersudut", "ms"));
  quantityKind.addLabel(new LangString("شتاب زاویه‌ای", "fa"));
  quantityKind.addLabel(new LangString("Açısal ivme", "tr"));
  quantityKind.addLabel(new LangString("Winkelbeschleunigung", "de"));
  quantityKind.addLabel(new LangString("Accelerație unghiulară", "ro"));
  quantityKind.addLabel(new LangString("कोणीय त्वरण", "hi"));
  quantityKind.addLabel(new LangString("Przyspieszenie kątowe", "pl"));
  quantityKind.addLabel(new LangString("accelerazione angolare", "it"));
  quantityKind.addLabel(new LangString("Úhlové zrychlení", "cs"));
  quantityKind.addLabel(new LangString("aceleración angular", "es"));
  quantityKind.addLabel(new LangString("角加速度", "ja"));
  quantityKind.addLabel(new LangString("accélération angulaire", "fr"));
  quantityKind.addLabel(new LangString("تسارع زاوي", "ar"));
  quantityKind.addLabel(new LangString("aceleração angular", "pt"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/REV-PER-MIN-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD-PER-SEC2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG-PER-SEC2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/REV-PER-SEC2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InverseSquareTime"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AngularAcceleration",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AngularCrossSection",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Angular Cross-section", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-SR");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AngularCrossSection",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AngularDistance",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Angular Distance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARCSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARCMIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN_Angle");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliARCSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/REV");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Angle"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AngularDistance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AngularFrequency",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Kreisfrequenz", "de"));
  quantityKind.addLabel(new LangString("تردد زاوى", "ar"));
  quantityKind.addLabel(new LangString("frequenza angolare", "it"));
  quantityKind.addLabel(new LangString("Pulsación", "fr"));
  quantityKind.addLabel(new LangString("pulsacja", "pl"));
  quantityKind.addLabel(new LangString("角频率", "zh"));
  quantityKind.addLabel(new LangString("pulsación", "es"));
  quantityKind.addLabel(new LangString("角振動数", "ja"));
  quantityKind.addLabel(new LangString("angular frequency", "en"));
  quantityKind.addLabel(new LangString("frequência angular", "pt"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckFrequency_Ang"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG-PER-SEC");
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/AngularVelocity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AngularFrequency",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AngularImpulse",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-1D0",
    "L",
    undefined
  );
  quantityKind.addLabel(new LangString("impulso angolare", "it"));
  quantityKind.addLabel(new LangString("نبضة دفعية زاوية", "ar"));
  quantityKind.addLabel(new LangString("angular impulse", "en"));
  quantityKind.addLabel(new LangString("impulsion angulaire", "fr"));
  quantityKind.addLabel(new LangString("impulsão angular", "pt"));
  quantityKind.addLabel(new LangString("popęd kątowy", "pl"));
  quantityKind.addLabel(new LangString("impulso angular", "es"));
  quantityKind.addLabel(new LangString("Drehstoß", "de"));
  quantityKind.addLabel(new LangString("角力積", "ja"));
  quantityKind.addLabel(new LangString("角冲量;冲量矩", "zh"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-M-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-M2-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F-SEC");
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/AngularMomentum"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AngularImpulse",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AngularMomentum",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-1D0",
    "H",
    undefined
  );
  quantityKind.addLabel(new LangString("Angular Momentum", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-M-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-M2-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F-SEC");
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/AngularImpulse"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AngularMomentum",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AngularMomentumPerAngle",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Angular Momentum per Angle", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/N-M-SEC-PER-RAD"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AngularMomentumPerAngle",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AngularReciprocalLatticeVector",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    "G",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Angular Reciprocal Lattice Vector", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-NanoM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AngularReciprocalLatticeVector",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AngularVelocity",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Halaju bersudut", "ms"));
  quantityKind.addLabel(new LangString("Winkelgeschwindigkeit", "de"));
  quantityKind.addLabel(new LangString("velocità angolare", "it"));
  quantityKind.addLabel(new LangString("Viteză unghiulară", "ro"));
  quantityKind.addLabel(new LangString("Úhlová rychlost", "cs"));
  quantityKind.addLabel(new LangString("Угловая скорость", "ru"));
  quantityKind.addLabel(new LangString("سرعة زاوية", "ar"));
  quantityKind.addLabel(new LangString("角速度", "ja"));
  quantityKind.addLabel(new LangString("angular velocity", "en"));
  quantityKind.addLabel(new LangString("سرعت زاویه‌ای", "fa"));
  quantityKind.addLabel(new LangString("角速度", "zh"));
  quantityKind.addLabel(new LangString("kotna hitrost", "sl"));
  quantityKind.addLabel(new LangString("velocidad angular", "es"));
  quantityKind.addLabel(new LangString("Prędkość kątowa", "pl"));
  quantityKind.addLabel(new LangString("कोणीय वेग", "hi"));
  quantityKind.addLabel(new LangString("velocidade angular", "pt"));
  quantityKind.addLabel(new LangString("vitesse angulaire", "fr"));
  quantityKind.addLabel(new LangString("Açısal hız", "tr"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckFrequency_Ang"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG-PER-SEC");
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/AngularFrequency"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AngularVelocity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AngularWavenumber",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    "k",
    undefined
  );
  quantityKind.addLabel(new LangString("número de onda angular", "pt"));
  quantityKind.addLabel(new LangString("角波数", "ja"));
  quantityKind.addLabel(new LangString("número de onda angular", "es"));
  quantityKind.addLabel(new LangString("角波数", "zh"));
  quantityKind.addLabel(new LangString("nombre d'onde angulaire", "fr"));
  quantityKind.addLabel(new LangString("liczba falowa kątowa", "pl"));
  quantityKind.addLabel(new LangString("angular wavenumber", "en"));
  quantityKind.addLabel(new LangString("عدد موجى زاوى", "ar"));
  quantityKind.addLabel(new LangString("numero d'onda angolare", "it"));
  quantityKind.addLabel(new LangString("Kreisrepetenz", "de"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG-PER-M");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InverseLength"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AngularWavenumber",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ApogeeRadius",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "r_2",
    undefined
  );
  quantityKind.addLabel(new LangString("Apogee Radius", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Radius"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ApogeeRadius",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ApparentPower",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("皮相電力", "ja"));
  quantityKind.addLabel(new LangString("puissance apparente", "fr"));
  quantityKind.addLabel(new LangString("moc pozorna", "pl"));
  quantityKind.addLabel(new LangString("apparent power", "en"));
  quantityKind.addLabel(new LangString("视在功率", "zh"));
  quantityKind.addLabel(new LangString("potencia aparente", "es"));
  quantityKind.addLabel(new LangString("potência aparente", "pt"));
  quantityKind.addLabel(new LangString("Scheinleistung", "de"));
  quantityKind.addLabel(new LangString("potenza apparente", "it"));
  quantityKind.addLabel(new LangString("القدرة الظاهرية", "ar"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraVA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroVA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoVA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliVA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaVA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaVA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaVA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoVA");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPower"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ApparentPower",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ApparentThermalInertia",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H-1T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString(
      "Measurement Unit for a quantity approximately proportional to Thermal Inertia",
      undefined
    )
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-K");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ApparentThermalInertia",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Area",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("área", "pt"));
  quantityKind.addLabel(new LangString("pole powierzchni", "pl"));
  quantityKind.addLabel(new LangString("面积", "zh"));
  quantityKind.addLabel(new LangString("面積", "ja"));
  quantityKind.addLabel(new LangString("مساحة", "ar"));
  quantityKind.addLabel(new LangString("alan", "tr"));
  quantityKind.addLabel(new LangString("Площ", "bg"));
  quantityKind.addLabel(new LangString("שטח", "he"));
  quantityKind.addLabel(new LangString("area", "en"));
  quantityKind.addLabel(new LangString("क्षेत्रफल", "hi"));
  quantityKind.addLabel(new LangString("Keluasan", "ms"));
  quantityKind.addLabel(new LangString("area", "it"));
  quantityKind.addLabel(new LangString("مساحت", "fa"));
  quantityKind.addLabel(new LangString("plocha", "cs"));
  quantityKind.addLabel(new LangString("Ταχύτητα", "el"));
  quantityKind.addLabel(new LangString("aire", "fr"));
  quantityKind.addLabel(new LangString("área", "es"));
  quantityKind.addLabel(new LangString("Fläche", "de"));
  quantityKind.addLabel(new LangString("arie", "ro"));
  quantityKind.addLabel(new LangString("Площадь", "ru"));
  quantityKind.addLabel(new LangString("površina", "sl"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckArea");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloMIL_Circ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIL_Circ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaARE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PIXEL_AREA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Area",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AreaAngle",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Area Angle", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-SR");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AreaAngle",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AreaBitDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("areic bit density", undefined));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PebiBIT-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KibiBIT-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GibiBIT-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BIT-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/ExbiBIT-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MebiBIT-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TebiBIT-PER-M2"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AreaBitDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AreaChargeDensity",
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("areic charge density", undefined));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/C_Ab-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-HR-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroC-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/C_Stat-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliC-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaC-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloC-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerArea"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AreaChargeDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AreaMass",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("areic mass", undefined));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-FT2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-HA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-YD2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG-PER-FT2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM-PER-HA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE-PER-HA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_Metric-PER-HA"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-KiloM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-HA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-IN2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-FT2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-IN2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-DeciM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-YD2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-HA"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-AC");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassPerArea"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AreaMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AreaPerLength",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("area per length", "en"));
  quantityKind.addLabel(new LangString("Fläche pro Längeneinheit", "de"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-M");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AreaPerLength",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AreaPerPower",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Fläche pro Heizlast", "de"));
  quantityKind.addLabel(new LangString("area per heating load", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-W");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-KiloW");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AreaPerPower",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AreaPerTime",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Area per Time", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN2-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM2-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM2-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT2-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT2-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-HZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-HR");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AreaPerTime",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AreaRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Area Ratio", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-HA");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AreaRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AreaTemperature",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H1T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Area Temperature", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT2-DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-K");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AreaTemperature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AreaThermalExpansion",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H-1T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Area Thermal Expansion", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-K");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AreaThermalExpansion",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AreaTime",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Area Time", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM2-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM2-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HR-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SEC-FT2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AreaTime",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AreaTimeTemperature",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H1T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Area Time Temperature", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT2-SEC-DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT2-HR-DEG_F");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AreaTimeTemperature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AreicChargeDensityOrElectricFluxDensityOrElectricPolarization",
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H0T1D0",
    "0173-1#Z4-BAJ320#002",
    undefined
  );
  quantityKind.addLabel(
    new LangString(
      "areic charge density or electric flux density or electric polarization",
      "en-US"
    )
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AreicChargeDensityOrElectricFluxDensityOrElectricPolarization",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AreicDataVolume",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T0D0",
    "0173-1#Z4-BAJ321#002",
    undefined
  );
  quantityKind.addLabel(new LangString("areic data volume", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AreicDataVolume",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AreicEnergyFlow",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    "0173-1#Z4-BAJ322#002",
    undefined
  );
  quantityKind.addLabel(new LangString("areic energy flow", "en-US"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-IN2-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoW-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroW-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-CentiM2-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC-FT2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/ERG-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-CentiM2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-HR-FT2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliW-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-IN2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoW-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PA-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-FT2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PowerPerArea"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AreicEnergyFlow",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AreicHeatFlowRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    "φ",
    undefined
  );
  quantityKind.addLabel(new LangString("Aeric Heat Flow Rate", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-IN2-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoW-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroW-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-CentiM2-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC-FT2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/ERG-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-CentiM2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-HR-FT2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliW-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-IN2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoW-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PA-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-FT2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PowerPerArea"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AreicHeatFlowRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AreicMass",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    "0173-1#Z4-BAJ288#004",
    undefined
  );
  quantityKind.addLabel(new LangString("areic mass", "en-US"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-FT2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-HA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-YD2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG-PER-FT2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM-PER-HA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE-PER-HA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_Metric-PER-HA"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-KiloM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-HA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-IN2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-FT2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-IN2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-DeciM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-YD2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-HA"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-AC");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassPerArea"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AreicMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AreicTorque",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    "0173-1#Z4-BAJ420#001",
    undefined
  );
  quantityKind.addLabel(new LangString("areic torque", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AreicTorque",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Asset",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Asset", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Asset",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AtmosphericHydroxylationRate",
    "http://qudt.org/vocab/dimensionvector/A-1E0L3I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Atmospheric Hydroxylation Rate", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-MOL-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-MOL-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/M3-PER-MOL-SEC"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SecondOrderReactionRateConstant"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AtmosphericHydroxylationRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AtmosphericPressure",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Atmospheric Pressure", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-IN2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_32DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroTORR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_60DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARYE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA_A");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroATM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliTORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_60DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR_A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR_A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckPressure"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_H2O_4DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_HG_0DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HGA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Pressure"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AtmosphericPressure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AtomScatteringFactor",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "f",
    undefined
  );
  quantityKind.addLabel(new LangString("Atom Scattering Factor", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AtomScatteringFactor",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AtomicAttenuationCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    "μₐ",
    undefined
  );
  quantityKind.addLabel(new LangString("Atomic Attenuation Coefficient", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckArea");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloMIL_Circ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIL_Circ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaARE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PIXEL_AREA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Area"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AtomicAttenuationCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AtomicCharge",
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Atomic Charge", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckCharge");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloJ-PER-KiloV"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C_Stat");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZettaC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YottaC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliA-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YoctoC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C_Ab");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZeptoC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/ElementaryCharge"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaC");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricCharge"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AtomicCharge",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AtomicEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "0173-1#Z4-BAJ291#002",
    undefined
  );
  quantityKind.addLabel(new LangString("atomic energy", "en-US"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AtomicEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AtomicMass",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    "m_a",
    undefined
  );
  quantityKind.addLabel(new LangString("Atomic Mass", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PENNYWEIGHT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AtomicMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AtomicNumber",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "Z",
    undefined
  );
  quantityKind.addLabel(new LangString("Atomic Number", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Z");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Count"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AtomicNumber",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AtomicStoppingPower",
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M1H0T-2D0",
    "0173-1#Z4-BAJ292#002",
    undefined
  );
  quantityKind.addLabel(new LangString("atomic stopping power", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AtomicStoppingPower",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AttenuationCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Attenuation Coefficient", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-NanoM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AttenuationCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AuditoryThresholds",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Auditory Thresholds", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciB_A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciB_ISO");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/B");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciB_Z");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciB_M");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoundPowerLevel"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AuditoryThresholds",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AuxillaryMagneticField",
    "http://qudt.org/vocab/dimensionvector/A0E1L-1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Auxillary Magnetic Field", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AT-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliA-PER-IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloA-PER-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliA-PER-MilliM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AT-PER-IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OERSTED");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticFieldStrength"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AuxillaryMagneticField",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AverageEnergyLossPerElementaryChargeProduced",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "W_i",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Average Energy Loss per Elementary Charge Produced", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AverageEnergyLossPerElementaryChargeProduced",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AverageHeadEndPressure",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Average Head End Pressure", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-IN2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_32DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroTORR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_60DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARYE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA_A");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroATM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliTORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_60DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR_A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR_A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckPressure"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_H2O_4DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_HG_0DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HGA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/HeadEndPressure"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AverageHeadEndPressure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AverageLogarithmicEnergyDecrement",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Average Logarithmic Energy Decrement", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AverageLogarithmicEnergyDecrement",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AverageSpecificImpulse",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Average Specific Impulse", "en"));
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificImpulse"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AverageSpecificImpulse",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AverageVacuumThrust",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Average Vacuum Thrust", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_F_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPOND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-M-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DYN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckForce");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/VacuumThrust"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AverageVacuumThrust",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Azimuth",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Azimuth", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARCSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARCMIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN_Angle");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliARCSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/REV");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Angle"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Azimuth",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/BandwidthDistanceProduct",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("bandwidth distance product", undefined)
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/BandwidthDistanceProduct",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/BandwidthLengthProduct",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    "0173-1#Z4-BAJ293#003",
    undefined
  );
  quantityKind.addLabel(new LangString("bandwidth length product", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/BandwidthLengthProduct",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Basicity",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Basicity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PH");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Basicity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/BatteryCapacity",
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    "0173-1#Z4-BAJ270#003",
    undefined
  );
  quantityKind.addLabel(new LangString("battery capacity", "en-US"));
  quantityKind.addLabel(new LangString("battery capacity", undefined));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliA-HR");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/BatteryCapacity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/BendingMomentOfForce",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "M_b",
    undefined
  );
  quantityKind.addLabel(new LangString("Bending Moment of Force", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_F-IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM_F-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciN-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliN-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DYN-CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiN-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DYN-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroN-M");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Torque"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/BendingMomentOfForce",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/BetaDisintegrationEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "Qᵦ",
    undefined
  );
  quantityKind.addLabel(new LangString("Beta Disintegration Energy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/BetaDisintegrationEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/BevelGearPitchAngle",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Bevel Gear Pitch Angle", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARCSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARCMIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN_Angle");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliARCSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/REV");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Angle"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/BevelGearPitchAngle",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/BinaryLogarithmicMedianInformationFlow",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    "0173-1#Z4-BAJ464#001",
    undefined
  );
  quantityKind.addLabel(
    new LangString(
      "median information flow (from a source of information), expressed as a binary logarithm",
      "en-US"
    )
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/BinaryLogarithmicMedianInformationFlow",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/BindingFraction",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "b",
    undefined
  );
  quantityKind.addLabel(new LangString("Binding Fraction", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/BindingFraction",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/BioconcentrationFactor",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Bioconcentration Factor", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/BioconcentrationFactor",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/BiodegredationHalfLife",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Biodegredation Half Life", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DAY");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Time"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/BiodegredationHalfLife",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/BiogeochemicalRate",
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M-1H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Biogeochemical Rate", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/BiogeochemicalRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/BitDataVolume",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "0173-1#Z4-BAJ436#002",
    undefined
  );
  quantityKind.addLabel(new LangString("bit data volume", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/BitDataVolume",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/BitRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("bit rate", undefined));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OCTET-PER-SEC");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/BitRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/BitTransmissionRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    "0173-1#Z4-BAJ295#003",
    undefined
  );
  quantityKind.addLabel(new LangString("bit transmission rate", "en-US"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OCTET-PER-SEC");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/BitRate"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/BitTransmissionRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/BloodGlucoseLevel",
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Blood Glucose Level", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliMOL-PER-L"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/BloodGlucoseLevel",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/BloodGlucoseLevel_Mass",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Blood Glucose Level by Mass", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/BloodGlucoseLevel_Mass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/BodyMassIndex",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    "BMI",
    undefined
  );
  quantityKind.addLabel(new LangString("Body Mass Index", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-YD2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/BodyMassIndex",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/BoilingPoint",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Boiling Point Temperature", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliDEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_R");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckTemperature"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_F");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Temperature"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/BoilingPoint",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/BraggAngle",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Bragg Angle", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARCSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARCMIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN_Angle");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliARCSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/REV");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Angle"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/BraggAngle",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Breadth",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "b",
    undefined
  );
  quantityKind.addLabel(new LangString("larghezza", "it"));
  quantityKind.addLabel(new LangString("genişliği", "tr"));
  quantityKind.addLabel(new LangString("lebar", "ms"));
  quantityKind.addLabel(new LangString("šířka", "cs"));
  quantityKind.addLabel(new LangString("breadth", "en"));
  quantityKind.addLabel(new LangString("العرض", "ar"));
  quantityKind.addLabel(new LangString("largeur", "fr"));
  quantityKind.addLabel(new LangString("largura", "pt"));
  quantityKind.addLabel(new LangString("szerokość", "pl"));
  quantityKind.addLabel(new LangString("ancho", "es"));
  quantityKind.addLabel(new LangString("寬度", "zh"));
  quantityKind.addLabel(new LangString("عرض", "fa"));
  quantityKind.addLabel(new LangString("širina", "sl"));
  quantityKind.addLabel(new LangString("ширина", "ru"));
  quantityKind.addLabel(new LangString("幅", "ja"));
  quantityKind.addLabel(new LangString("Breite", "de"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Breadth",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/BucklingFactor",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "B",
    undefined
  );
  quantityKind.addLabel(new LangString("Buckling Factor", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DECADE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FLIGHT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RPK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_MAG"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaBasePair");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BasePair");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/COUNT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HeartBeat");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OCT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_ELEC"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Dimensionless"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/BucklingFactor",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/BulkModulus",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    "K",
    undefined
  );
  quantityKind.addLabel(new LangString("Bulk Modulus", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoPA");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/BulkModulus",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/BurgersVector",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "b",
    undefined
  );
  quantityKind.addLabel(new LangString("Burgers Vector", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/BurgersVector",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/BurnRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Burn Rate", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaHZ-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-KiloYR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM-PER-YR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Velocity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/BurnRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/BurnTime",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    "t",
    undefined
  );
  quantityKind.addLabel(new LangString("Burn Time", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliH-PER-KiloOHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/WK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckTime");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Common");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MO_MeanGREGORIAN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HR_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoSEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroH-PER-KiloOHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H-PER-OHM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroH-PER-OHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DAY_Sidereal");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliPA-SEC-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO_Synodic");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POISE-PER-BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiPOISE-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POISE-PER-PA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliH-PER-OHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_TROPICAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H-PER-KiloOHM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Metrology");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PA-SEC-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloYR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaYR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO_MeanJulian");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Time"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/BurnTime",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/BurstFactor",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-2D0",
    "0173-1#Z4-BAJ434#001",
    undefined
  );
  quantityKind.addLabel(new LangString("burst factor", undefined));
  quantityKind.addLabel(new LangString("burst factor", "en-US"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PA-M2-PER-KiloGM"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/BurstFactor",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ByteDataVolume",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "0173-1#Z4-BAJ435#004",
    undefined
  );
  quantityKind.addLabel(new LangString("byte data volume", "en-US"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MILLION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ONE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HUNDRED");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PIXEL_COUNT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BILLION_Short");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THOUSAND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BILLION_Long");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/COUNT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TEN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Count"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ByteDataVolume",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ByteRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("byte rate", undefined));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GigaBYTE-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaBYTE-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BYTE-PER-SEC");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ByteRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ByteTransmissionRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    "0173-1#Z4-BAJ297#003",
    undefined
  );
  quantityKind.addLabel(new LangString("byte transmission rate", "en-US"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GigaBYTE-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaBYTE-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BYTE-PER-SEC");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ByteRate"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ByteTransmissionRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CENTER-OF-GRAVITY_X",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "cg",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Center of Gravity in the X axis", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CENTER-OF-GRAVITY_X",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CENTER-OF-GRAVITY_Y",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "cg",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Center of Gravity in the Y axis", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CENTER-OF-GRAVITY_Y",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CENTER-OF-GRAVITY_Z",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "cg",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Center of Gravity in the Z axis", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CENTER-OF-GRAVITY_Z",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CENTER-OF-MASS",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "R",
    undefined
  );
  quantityKind.addLabel(new LangString("Center of Mass (CoM)", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PositionVector"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CENTER-OF-MASS",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CO2Equivalent",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("CO2Equivalent", undefined));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassEquivalent"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CO2Equivalent",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CONTRACT-END-ITEM-SPECIFICATION-MASS",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Contract End Item (CEI) Specification Mass.", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PENNYWEIGHT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CONTRACT-END-ITEM-SPECIFICATION-MASS",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CONTROL-MASS",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Control Mass.", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PENNYWEIGHT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CONTROL-MASS",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CanonicalPartitionFunction",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "Z",
    undefined
  );
  quantityKind.addLabel(new LangString("Canonical Partition Function", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CanonicalPartitionFunction",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Capacitance",
    "http://qudt.org/vocab/dimensionvector/A0E2L-2I0M-1H0T4D0",
    "C",
    undefined
  );
  quantityKind.addLabel(new LangString("Capacitance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoFARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoFARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloFARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoFARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroFARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliFARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FARAD_Ab");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FARAD_Stat");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoFARAD");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Capacitance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Capacity",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "TBD",
    undefined
  );
  quantityKind.addLabel(new LangString("Capacity", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Capacity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CarrierLifetime",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Carrier LifetIme", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliH-PER-KiloOHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/WK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckTime");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Common");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MO_MeanGREGORIAN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HR_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoSEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroH-PER-KiloOHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H-PER-OHM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroH-PER-OHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DAY_Sidereal");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliPA-SEC-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO_Synodic");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POISE-PER-BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiPOISE-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POISE-PER-PA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliH-PER-OHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_TROPICAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H-PER-KiloOHM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Metrology");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PA-SEC-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloYR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaYR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO_MeanJulian");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Time"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CarrierLifetime",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CartesianArea",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    "A",
    undefined
  );
  quantityKind.addLabel(new LangString("Cartesian Area", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckArea");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloMIL_Circ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIL_Circ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaARE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PIXEL_AREA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Area"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CartesianArea",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CartesianCoordinates",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "x, y, z",
    undefined
  );
  quantityKind.addLabel(new LangString("مختصات دکارتی", "fa"));
  quantityKind.addLabel(new LangString("kartezyen koordinatları", "tr"));
  quantityKind.addLabel(new LangString("kartesische Koordinaten", "de"));
  quantityKind.addLabel(new LangString("Koordiant Kartesius", "ms"));
  quantityKind.addLabel(new LangString("coordenadas cartesianas", "pt"));
  quantityKind.addLabel(new LangString("coordinate cartesiane", "it"));
  quantityKind.addLabel(new LangString("Cartesian coordinates", "en"));
  quantityKind.addLabel(new LangString("直角坐标系", "zh"));
  quantityKind.addLabel(new LangString("Kartézská soustava souřadnic", "cs"));
  quantityKind.addLabel(new LangString("coordonnées cartésiennes", "fr"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CartesianCoordinates",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CartesianVolume",
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    "V",
    undefined
  );
  quantityKind.addLabel(new LangString("volume", "it"));
  quantityKind.addLabel(new LangString("Isipadu", "ms"));
  quantityKind.addLabel(new LangString("Επιτάχυνση", "el"));
  quantityKind.addLabel(new LangString("volume", "fr"));
  quantityKind.addLabel(new LangString("volume", "en"));
  quantityKind.addLabel(new LangString("objętość", "pl"));
  quantityKind.addLabel(new LangString("Volumen", "de"));
  quantityKind.addLabel(new LangString("体積", "ja"));
  quantityKind.addLabel(new LangString("נפח", "he"));
  quantityKind.addLabel(new LangString("Объём", "ru"));
  quantityKind.addLabel(new LangString("حجم", "ar"));
  quantityKind.addLabel(new LangString("体积", "zh"));
  quantityKind.addLabel(new LangString("hacim", "tr"));
  quantityKind.addLabel(new LangString("आयतन", "hi"));
  quantityKind.addLabel(new LangString("Обем", "bg"));
  quantityKind.addLabel(new LangString("حجم", "fa"));
  quantityKind.addLabel(new LangString("prostornina", "sl"));
  quantityKind.addLabel(new LangString("volumen", "es"));
  quantityKind.addLabel(new LangString("Objem", "cs"));
  quantityKind.addLabel(new LangString("volume", "pt"));
  quantityKind.addLabel(new LangString("volum", "ro"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/STANDARD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PK_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Register");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCubicFT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TSP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PINT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckVolume");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BBL_UK_PET");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TBSP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BBL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_VOL_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PINT_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FBM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/STR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AC-FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_SHIPPING_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_UK3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BU_US_DRY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_SHIPPING_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AC-FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_UK");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Volume"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CartesianVolume",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CatalyticActivity",
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Catalytic Activity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliKAT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloMOL-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoKAT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MOL_LB-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MOL_LB-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ENZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroKAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoKAT");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CatalyticActivity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CatalyticActivityConcentration",
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Catalytic Activity Concentration", "en")
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoMOL-PER-CentiM3-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoKAT-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KAT-PER-MicroL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroMOL-PER-L-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoMOL-PER-L-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoMOL-PER-M3-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliKAT-PER-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroKAT-PER-L"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ENZ-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MOL-PER-M3-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoMOL-PER-L-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KAT-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliMOL-PER-M3-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoMOL-PER-L-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoKAT-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KAT-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MOL-PER-M2-SEC-M"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoMOL-PER-L-HR"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CatalyticActivityConcentration",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CelsiusTemperature",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("teplota", "cs"));
  quantityKind.addLabel(new LangString("temperatura", "sl"));
  quantityKind.addLabel(new LangString("temperatura Celsius", "es"));
  quantityKind.addLabel(
    new LangString("درجة الحرارة المئوية أو السيلسيوس", "ar")
  );
  quantityKind.addLabel(new LangString("temperatura", "pl"));
  quantityKind.addLabel(new LangString("Температура Цельсия", "ru"));
  quantityKind.addLabel(new LangString("Celsius temperature", "en"));
  quantityKind.addLabel(new LangString("temperatură Celsius", "ro"));
  quantityKind.addLabel(new LangString("Suhu Celsius", "ms"));
  quantityKind.addLabel(new LangString("温度", "ja"));
  quantityKind.addLabel(new LangString("température Celsius", "fr"));
  quantityKind.addLabel(new LangString("सेल्सियस तापमान", "hi"));
  quantityKind.addLabel(new LangString("دمای سلسیوس/سانتیگراد", "fa"));
  quantityKind.addLabel(new LangString("צלזיוס", "he"));
  quantityKind.addLabel(new LangString("temperatura Celsius", "it"));
  quantityKind.addLabel(new LangString("温度", "zh"));
  quantityKind.addLabel(new LangString("Celsius-Temperatur", "de"));
  quantityKind.addLabel(new LangString("temperatura celsius", "pt"));
  quantityKind.addLabel(new LangString("Celsius sıcaklık", "tr"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_R");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckTemperature"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermodynamicTemperature"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CelsiusTemperature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CenterOfGravity_X",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "cg",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Center of Gravity in the X axis", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CenterOfGravity_X",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CenterOfGravity_Y",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "cg",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Center of Gravity in the Y axis", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CenterOfGravity_Y",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CenterOfGravity_Z",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "cg",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Center of Gravity in the Z axis", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CenterOfGravity_Z",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CharacteristicAcousticImpedance",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-1D0",
    "Z",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Characteristic Acoustic Impedance", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA-SEC-PER-M");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AcousticImpedance"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CharacteristicAcousticImpedance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CharacteristicNumber",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "0173-1#Z4-BAJ279#002",
    undefined
  );
  quantityKind.addLabel(new LangString("characteristic number", "en-US"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DECADE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FLIGHT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RPK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_MAG"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaBasePair");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BasePair");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/COUNT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HeartBeat");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OCT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_ELEC"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Dimensionless"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CharacteristicNumber",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CharacteristicVelocity",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Characteristic Velocity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaHZ-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-KiloYR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM-PER-YR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Velocity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CharacteristicVelocity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ChargeNumber",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "z",
    undefined
  );
  quantityKind.addLabel(new LangString("Charge Number", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Dimensionless"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ChargeNumber",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ChemicalAffinity",
    "http://qudt.org/vocab/dimensionvector/A-1E0L2I0M1H0T-2D0",
    "A",
    undefined
  );
  quantityKind.addLabel(new LangString("Chemical Affinity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-MOL");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ChemicalAffinity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ChemicalConsumptionPerMass",
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M-1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Chemical Consumption per Mass", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM3-PER-GM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT3-PER-LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliL-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliL-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciL-PER-GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-KiloGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-GM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN3-PER-LB");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciM3-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM3-PER-KiloGM"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificVolume"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ChemicalConsumptionPerMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ChemicalPotential",
    "http://qudt.org/vocab/dimensionvector/A-1E0L2I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("potencial químico", "pt"));
  quantityKind.addLabel(new LangString("potential chimique", "fr"));
  quantityKind.addLabel(new LangString("Химический потенциал", "ru"));
  quantityKind.addLabel(new LangString("Potențial chimic", "ro"));
  quantityKind.addLabel(new LangString("化学势", "zh"));
  quantityKind.addLabel(new LangString("potenziale chimico", "it"));
  quantityKind.addLabel(new LangString("جهد كيميائي", "ar"));
  quantityKind.addLabel(
    new LangString("chemisches Potential des Stoffs B", "de")
  );
  quantityKind.addLabel(new LangString("potencial químico", "es"));
  quantityKind.addLabel(new LangString("kimyasal potansiyel", "tr"));
  quantityKind.addLabel(new LangString("Potencjał chemiczny", "pl"));
  quantityKind.addLabel(new LangString("chemical potential", "en"));
  quantityKind.addLabel(new LangString("Chemický potenciál", "cs"));
  quantityKind.addLabel(new LangString("化学ポテンシャル", "ja"));
  quantityKind.addLabel(new LangString("پتانسیل شیمیایی", "fa"));
  quantityKind.addLabel(new LangString("Keupayaan kimia", "ms"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-MOL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-MOL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ-PER-MOL");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MolarEnergy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ChemicalPotential",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Chromaticity",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Chromaticity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Chromaticity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Circulation",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Circulation", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN2-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM2-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM2-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT2-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT2-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-HZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AreaPerTime"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Circulation",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ClosestApproachRadius",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "r_o",
    undefined
  );
  quantityKind.addLabel(new LangString("Closest Approach Radius", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Radius"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ClosestApproachRadius",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CoefficientOfHeatTransfer",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Coefficient of heat transfer", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_IT-PER-SEC-CentiM2-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC-FT2-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-SEC-FT2-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-HR-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-HR-FT2-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-SEC-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-HR-FT2-DEG_R"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-SEC-CentiM2-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloW-PER-M2-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-HR-FT2-DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-M2-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC-FT2-DEG_R"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-SEC3-K"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CoefficientOfHeatTransfer",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CoefficientOfPerformance",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "COP",
    undefined
  );
  quantityKind.addLabel(new LangString("CoefficientOfPerformance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CoefficientOfPerformance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Coercivity",
    "http://qudt.org/vocab/dimensionvector/A0E1L-1I0M0H0T0D0",
    "H_{c,B}",
    undefined
  );
  quantityKind.addLabel(new LangString("Coercivity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-M");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Coercivity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CoherenceLength",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "ξ",
    undefined
  );
  quantityKind.addLabel(new LangString("Coherence Length", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CoherenceLength",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ColdReceptorThreshold",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Cold Receptor Threshold", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliDEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_R");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckTemperature"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_F");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Temperature"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ColdReceptorThreshold",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CombinedNonEvaporativeHeatTransferCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-3D0",
    "h",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Combined Non Evaporative Heat Transfer Coefficient", "en")
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloW-PER-M2-K"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-M2-K");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CombinedNonEvaporativeHeatTransferCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CombustionChamberTemperature",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T0D0",
    "T_c",
    undefined
  );
  quantityKind.addLabel(new LangString("Combustion Chamber Temperature", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_R");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckTemperature"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermodynamicTemperature"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CombustionChamberTemperature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CommonLogarithmicMedianInformationFlow",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    "0173-1#Z4-BAJ470#001",
    undefined
  );
  quantityKind.addLabel(
    new LangString(
      "median information flow (from a source of information), expressed as a common logarithm ",
      "en-US"
    )
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CommonLogarithmicMedianInformationFlow",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ComplexFrequency_Imaginary",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("imaginary part of complex frequency", undefined)
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaHZ");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-WK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaHZ");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraHZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MilliSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MO");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-YR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SAMPLE-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliHZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-WK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckFrequency"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaHZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-MO"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloHZ");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-YR"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Frequency"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ComplexFrequency_Imaginary",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ComplexFrequency_Real",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("real part of complex frequency", undefined)
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaHZ");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-WK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaHZ");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraHZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MilliSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MO");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-YR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SAMPLE-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliHZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-WK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckFrequency"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaHZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-MO"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloHZ");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-YR"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Frequency"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ComplexFrequency_Real",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ComplexPower",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Complex Power", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliW");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPower"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ComplexPower",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CompoundPlaneAngle",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Compound Plane Angle", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARCSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARCMIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN_Angle");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliARCSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/REV");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PlaneAngle"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CompoundPlaneAngle",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Compressibility",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H0T2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Compressibility", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-BAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MILLE-PSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MegaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-HectoBAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-PA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-BAR"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Compressibility",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CompressibilityFactor",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "Z",
    undefined
  );
  quantityKind.addLabel(new LangString("Compressibility Factor", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ONE-PER-ONE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERMITTIVITY_REL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CompressibilityFactor",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Concentration",
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Concentration", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoMOL-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FemtoMOL-PER-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoMOL-PER-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoMOL-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MOL-PER-DeciM3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliMOL-PER-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloMOL-PER-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliMOL-PER-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiMOL-PER-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroMOL-PER-L"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Concentration",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Conductance",
    "http://qudt.org/vocab/dimensionvector/A0E2L-2I0M-1H0T3D0",
    "G",
    undefined
  );
  quantityKind.addLabel(new LangString("Conductance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/S");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroMHO");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MHO");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Conductance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ConductionSpeed",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    "c",
    undefined
  );
  quantityKind.addLabel(new LangString("Conduction Speed", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloHZ-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaHZ-M");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Speed"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ConductionSpeed",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ConductiveHeatTransferRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Conductive Heat Transfer Rate", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaBTU_IT-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL_TH-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL_TH-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL_TH-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloBTU_TH-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_FG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloBTU_IT-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH-PER-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/HeatFlowRate"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ConductiveHeatTransferRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Conductivity",
    "http://qudt.org/vocab/dimensionvector/A0E2L-3I0M-1H0T3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Conductivity", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoS-PER-CentiM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaS-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/S-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroS-PER-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroS-PER-CentiM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoS-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoS-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/S-PER-CentiM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliS-PER-CentiM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciS-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliS-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloS-PER-M");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Conductivity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ConductivityVariance",
    "http://qudt.org/vocab/dimensionvector/A0E4L-6I0M-2H0T6D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Conductivity Variance", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroS2-PER-CentiM2"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ConductivityVariance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ConductivityVariance_NEON",
    "http://qudt.org/vocab/dimensionvector/A0E4L-6I0M-2H0T6D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Conductivity Variance, NEON", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ConductivityVariance_NEON",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Constringence",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "V",
    undefined
  );
  quantityKind.addLabel(new LangString("Constringence", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Constringence",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ConvectiveHeatTransfer",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Convective Heat Transfer", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaBTU_IT-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL_TH-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL_TH-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL_TH-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloBTU_TH-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_FG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloBTU_IT-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH-PER-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/HeatFlowRate"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ConvectiveHeatTransfer",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CorrelatedColorTemperature",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Correlated Color Temperature", "en-US")
  );
  quantityKind.addLabel(new LangString("Correlated Colour Temperature", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermodynamicTemperature"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CorrelatedColorTemperature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CostPerArea",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("cost per area", "en"));
  quantityKind.addLabel(new LangString("Kosten pro Fläche", "de"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CCY_EUR-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CCY_CHF-PER-HA"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CostPerArea",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CostPerEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M-1H0T2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Energiekosten", "de"));
  quantityKind.addLabel(new LangString("energy cost", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CCY_EUR-PER-KiloW-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CCY_RON-PER-KiloW-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CCY_BGN-PER-KiloW-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CCY_CZK-PER-KiloW-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CCY_DKK-PER-KiloW-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CCY_PLN-PER-KiloW-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CCY_CHF-PER-KiloW-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CCY_GBP-PER-KiloW-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CCY_NOK-PER-KiloW-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CCY_EUR-PER-W-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CCY_SEK-PER-KiloW-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CCY_HUF-PER-KiloW-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CCY_EUR-PER-W-HR"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CostPerEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CostPerMass",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Kosten pro Masse", "de"));
  quantityKind.addLabel(new LangString("cost per mass", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CCY_CHF-PER-KiloGM"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CostPerMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CostPerPower",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M-1H0T3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Anschaffungskosten pro Watt", "de"));
  quantityKind.addLabel(new LangString("cost per power", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CCY_EUR-PER-KiloW"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_EUR-PER-W");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CostPerPower",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Count",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Count", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MILLION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ONE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HUNDRED");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PIXEL_COUNT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BILLION_Short");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THOUSAND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BILLION_Long");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/COUNT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TEN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Dimensionless"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Count",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CountRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("CountRate", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-YR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Frequency"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CountRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CouplingFactor",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "k",
    undefined
  );
  quantityKind.addLabel(new LangString("Çiftlenim sabiti", "tr"));
  quantityKind.addLabel(new LangString("結合定数", "ja"));
  quantityKind.addLabel(new LangString("constante de acoplamiento", "es"));
  quantityKind.addLabel(new LangString("耦合常數", "zh"));
  quantityKind.addLabel(new LangString("fattore di accoppiamento", "it"));
  quantityKind.addLabel(new LangString("Constantă de cuplaj", "ro"));
  quantityKind.addLabel(new LangString("Константа взаимодействия", "ru"));
  quantityKind.addLabel(new LangString("coupling factor", "en"));
  quantityKind.addLabel(new LangString("constante de couplage", "fr"));
  quantityKind.addLabel(new LangString("stała sprzężenia", "pl"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CouplingFactor",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CrossSection",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    "σ",
    undefined
  );
  quantityKind.addLabel(new LangString("Cross-section", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckArea");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloMIL_Circ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIL_Circ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaARE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PIXEL_AREA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Area"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CrossSection",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CrossSectionalArea",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    "A",
    undefined
  );
  quantityKind.addLabel(new LangString("Cross-sectional Area", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckArea");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloMIL_Circ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIL_Circ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaARE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PIXEL_AREA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Area"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CrossSectionalArea",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CubicElectricDipoleMomentPerSquareEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E3L-3I0M-2H0T7D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Cubic Electric Dipole Moment per Square Energy", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C3-M-PER-J2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CubicElectricDipoleMomentPerSquareEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CubicExpansionCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H-1T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("współczynnik rozszerzalności objętościowej", "pl")
  );
  quantityKind.addLabel(new LangString("cubic expansion coefficient", "en"));
  quantityKind.addLabel(
    new LangString("coefficient de dilatation volumique", "fr")
  );
  quantityKind.addLabel(
    new LangString("coeficiente de dilatación cúbica", "es")
  );
  quantityKind.addLabel(new LangString("Температурный коэффициент", "ru"));
  quantityKind.addLabel(new LangString("Hullámszám", "hu"));
  quantityKind.addLabel(new LangString("מספר גל", "he"));
  quantityKind.addLabel(new LangString("kübik genleşme katsayısı", "tr"));
  quantityKind.addLabel(new LangString("Κυματαριθμός", "el"));
  quantityKind.addLabel(new LangString("ضریب انبساط گرمایی", "fa"));
  quantityKind.addLabel(
    new LangString("coefficiente di dilatazione volumica", "it")
  );
  quantityKind.addLabel(new LangString("معامل التمدد الحجمى", "ar"));
  quantityKind.addLabel(new LangString("Вълново число", "bg"));
  quantityKind.addLabel(new LangString("体膨胀系数", "zh"));
  quantityKind.addLabel(new LangString("Volumenausdehnungskoeffizient", "de"));
  quantityKind.addLabel(
    new LangString("coeficiente de dilatação volúmica", "pt")
  );
  quantityKind.addLabel(new LangString("線膨張係数", "ja"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-DEG_C-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM-PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-DEG_F");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-DEG_C-M"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MegaK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM-PER-K");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ExpansionRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CubicExpansionCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CurieTemperature",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T0D0",
    "T_C",
    undefined
  );
  quantityKind.addLabel(new LangString("نقطه کوری", "fa"));
  quantityKind.addLabel(new LangString("temperatura de Curie", "es"));
  quantityKind.addLabel(new LangString("Curie temperature", "en"));
  quantityKind.addLabel(new LangString("Curie sıcaklığı", "tr"));
  quantityKind.addLabel(new LangString("Curie-Temperatur", "de"));
  quantityKind.addLabel(new LangString("क्यूरी ताप", "hi"));
  quantityKind.addLabel(new LangString("temperatura Curie", "pl"));
  quantityKind.addLabel(new LangString("Punct Curie", "ro"));
  quantityKind.addLabel(new LangString("temperatura de Curie", "pt"));
  quantityKind.addLabel(new LangString("Suhu Curie", "ms"));
  quantityKind.addLabel(new LangString("درجة حرارة كوري", "ar"));
  quantityKind.addLabel(new LangString("Точка Кюри", "ru"));
  quantityKind.addLabel(new LangString("punto di Curie", "it"));
  quantityKind.addLabel(new LangString("Curieova teplota", "cs"));
  quantityKind.addLabel(new LangString("température de Curie", "fr"));
  quantityKind.addLabel(new LangString("キュリー温度", "ja"));
  quantityKind.addLabel(new LangString("居里点", "zh"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliDEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_R");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckTemperature"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_F");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Temperature"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CurieTemperature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Currency",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Currency", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_NIO");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_SKK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_PEN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_NZD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_WST");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_BAM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_EGP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_MOP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_BZD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_NAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_XDR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_MGA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_MWK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_BIF");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_SDG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_BSD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_STN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_SLE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_MXV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_ZAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_HNL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_UGX");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_CDF");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_BBD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_GTQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_MXN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_TND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_CLP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_CLF");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_BRL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_TMT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_LVL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_SCR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_FJD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_AZN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_TOP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_OMR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_PGK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_KES");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_SEK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_GEL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_FKP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_CVE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_UYU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_MAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_XOF");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_MYR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_DOP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_KMF");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_RSD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_XFU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_CUP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_GMD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_IQD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_TWD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_XFO");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_BMD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_KWD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_PHP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_LYD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_CNY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_THB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_UZS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_XPF");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_XPD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_BDT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_MRU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_IRR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_BTN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_UAH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_ARS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_QAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_ERN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_MZN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_GNF");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_LAK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_USS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_ETB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_BND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_KGS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_SOS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_VUV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_DZD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaCCY_USD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_PAB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_SGD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_USN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_MKD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_USD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_COP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_COU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_PYG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_XPT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_ISK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_JMD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_RUB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_KYD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_BOB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_KHR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_MDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_CYP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_LBP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_XBD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_XBC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_AMD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_XBB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_IDR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_XBA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_TZS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_VND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_XAU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_CHW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_GHS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_GYD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_KPW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_AUD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_ILS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_MTL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_VES");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_ZMW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_LRD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_XAG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_XAF");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_ALL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_CHF");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_HRK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_CHE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_DJF");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_NGN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_CRC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_CZK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_LKR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_ANG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_XCD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_PKR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_GIP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_EEK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_MMK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_RON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_ZWL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_CAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_LSL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_DKK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_MUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_NOK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_SYP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_BGN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_BOV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_TJS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_BWP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_SHP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_TRY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_EUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_HKD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_RWF");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_AED");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_JOD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_GBP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_SBD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_AOA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_JPY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_MNT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_HUF");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_BYN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_INR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_PLN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_AWG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_KRW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_NPR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_YER");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_KZT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_SRD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_SZL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_LTL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_SAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_TTD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_AFN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_MVR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_BHD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CCY_HTG");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Asset"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Currency",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CurrencyPerFlight",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Currency Per Flight", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaCCY_USD-PER-FLIGHT"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CurrencyPerFlight",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CurrentLinkage",
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Current Linkage", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoA");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CurrentLinkage",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CurrentOfTheAmountOfSubstance",
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T-1D0",
    "0173-1#Z4-BAJ384#002",
    undefined
  );
  quantityKind.addLabel(
    new LangString("current of the amount of substance", "en-US")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CurrentOfTheAmountOfSubstance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Curvature",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Curvature", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DIOPTER");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InverseLength"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Curvature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CurvatureFromRadius",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Curvature", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-NanoM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CurvatureFromRadius",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CutoffCurrentRating",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    "0173-1#Z4-BAJ325#003",
    undefined
  );
  quantityKind.addLabel(new LangString("I²t-value", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CutoffCurrentRating",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CyclotronAngularFrequency",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Larmor Angular Frequency", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckFrequency_Ang"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG-PER-SEC");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AngularFrequency"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CyclotronAngularFrequency",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DELTA-V",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Delta-V", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaHZ-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-KiloYR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM-PER-YR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Velocity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DELTA-V",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DRY-MASS",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Dry Mass", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PENNYWEIGHT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DRY-MASS",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DataRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Data Rate", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloBIT-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloBYTE-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PetaBIT-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/ExaBIT-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GigaBIT-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BIT-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TeraBIT-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaBIT-PER-SEC"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InformationFlowRate"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DataRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DataTransmissionRate",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("data transmission rate", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DataTransmissionRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DatasetOfBits",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("dataset of bits", undefined));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBIT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraBIT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OCTET");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaBIT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KibiBIT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MebiBIT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaBIT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GibiBIT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBIT");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DatasetOfBits",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DatasetOfBytes",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("dataset of bytes", undefined));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DatasetOfBytes",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Debye-WallerFactor",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "D, B",
    undefined
  );
  quantityKind.addLabel(new LangString("Debye-Waller Factor", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Debye-WallerFactor",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DebyeAngularFrequency",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Debye Angular Frequency", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckFrequency_Ang"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG-PER-SEC");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AngularFrequency"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DebyeAngularFrequency",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DebyeAngularWavenumber",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    "q_D",
    undefined
  );
  quantityKind.addLabel(new LangString("Debye Angular Wavenumber", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG-PER-M");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InverseLength"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DebyeAngularWavenumber",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DebyeTemperature",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Debye Temperature", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliDEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_R");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckTemperature"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_F");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Temperature"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DebyeTemperature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DecayConstant",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Decay Constant", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCI");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InverseTime"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DecayConstant",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DegreeOfDissociation",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Degree of Dissociation", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DegreeOfDissociation",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Density",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Density", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-CentiM3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-MicroL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-PER-GAL_IMP"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_LONG-PER-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_Metric-PER-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-IN3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG-PER-FT3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-DeciL");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GRAIN-PER-GAL_IMP"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-MilliL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-DeciL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEGREE_BAUME");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-IN3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-FT3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEGREE_BAUME_US_HEAVY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GRAIN-PER-GAL_US"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-DeciM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-DeciL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEGREE_BAUME_US_LIGHT"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_US-PER-YD3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-YD3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEGREE_BRIX");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-DeciM3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-CentiM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-GAL_US");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-DeciL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoGM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-GAL_UK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEGREE_TWADDELL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckDensity");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ-PER-GAL_IMP"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_UK-PER-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_SHORT-PER-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEGREE_BALLING"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-YD3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEGREE_PLATO");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-GAL_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-GAL_UK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEGREE_OECHSLE"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-M3");
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/MassDensity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Density",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DensityInCombustionChamber",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Density In Combustion Chamber", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-CentiM3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-MicroL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-PER-GAL_IMP"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_LONG-PER-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_Metric-PER-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-IN3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG-PER-FT3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-DeciL");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GRAIN-PER-GAL_IMP"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-MilliL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-DeciL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEGREE_BAUME");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-IN3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-FT3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEGREE_BAUME_US_HEAVY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GRAIN-PER-GAL_US"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-DeciM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-DeciL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEGREE_BAUME_US_LIGHT"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_US-PER-YD3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-YD3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEGREE_BRIX");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-DeciM3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-CentiM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-GAL_US");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-DeciL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoGM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-GAL_UK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEGREE_TWADDELL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckDensity");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ-PER-GAL_IMP"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_UK-PER-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_SHORT-PER-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEGREE_BALLING"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-YD3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEGREE_PLATO");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-GAL_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-GAL_UK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEGREE_OECHSLE"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-M3");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassDensity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DensityInCombustionChamber",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DensityOfStates",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T1D0",
    "g",
    undefined
  );
  quantityKind.addLabel(new LangString("Density of states", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DensityOfStates",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DensityOfTheExhaustGases",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Density Of The Exhaust Gases", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-CentiM3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-MicroL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-PER-GAL_IMP"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_LONG-PER-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_Metric-PER-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-IN3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG-PER-FT3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-DeciL");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GRAIN-PER-GAL_IMP"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-MilliL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-DeciL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEGREE_BAUME");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-IN3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-FT3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEGREE_BAUME_US_HEAVY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GRAIN-PER-GAL_US"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-DeciM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-DeciL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEGREE_BAUME_US_LIGHT"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_US-PER-YD3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-YD3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEGREE_BRIX");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-DeciM3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-CentiM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-GAL_US");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-DeciL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoGM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-GAL_UK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEGREE_TWADDELL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckDensity");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ-PER-GAL_IMP"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_UK-PER-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_SHORT-PER-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEGREE_BALLING"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-YD3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEGREE_PLATO");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-GAL_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-GAL_UK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEGREE_OECHSLE"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-M3");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Density"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DensityOfTheExhaustGases",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Depth",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Depth", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Depth",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DewPointTemperature",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T0D0",
    "T_d",
    undefined
  );
  quantityKind.addLabel(new LangString("Dew Point Temperature", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliDEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_R");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckTemperature"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_F");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Temperature"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DewPointTemperature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Diameter",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "d",
    undefined
  );
  quantityKind.addLabel(new LangString("直径", "ja"));
  quantityKind.addLabel(new LangString("çap", "tr"));
  quantityKind.addLabel(new LangString("diameter", "en"));
  quantityKind.addLabel(new LangString("diámetro", "es"));
  quantityKind.addLabel(new LangString("قطر", "ar"));
  quantityKind.addLabel(new LangString("premer", "sl"));
  quantityKind.addLabel(new LangString("диаметр", "ru"));
  quantityKind.addLabel(new LangString("średnica", "pl"));
  quantityKind.addLabel(new LangString("قطر", "fa"));
  quantityKind.addLabel(new LangString("Durchmesser", "de"));
  quantityKind.addLabel(new LangString("průměr", "cs"));
  quantityKind.addLabel(new LangString("diamètre", "fr"));
  quantityKind.addLabel(new LangString("diâmetro", "pt"));
  quantityKind.addLabel(new LangString("直径", "zh"));
  quantityKind.addLabel(new LangString("diametro", "it"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Diameter",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DiastolicBloodPressure",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Diastolic Blood Pressure", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-IN2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_32DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroTORR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_60DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARYE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA_A");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroATM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliTORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_60DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR_A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR_A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckPressure"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_H2O_4DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_HG_0DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HGA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Pressure"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DiastolicBloodPressure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DiffusionArea",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    "L^2",
    undefined
  );
  quantityKind.addLabel(new LangString("Diffusion Area", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckArea");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloMIL_Circ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIL_Circ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaARE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PIXEL_AREA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Area"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DiffusionArea",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DiffusionCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-1D0",
    "D",
    undefined
  );
  quantityKind.addLabel(new LangString("Diffusionskoeffizient", "de"));
  quantityKind.addLabel(new LangString("coeficiente de difusión", "es"));
  quantityKind.addLabel(new LangString("coefficiente di diffusione", "it"));
  quantityKind.addLabel(new LangString("coefficient de diffusion", "fr"));
  quantityKind.addLabel(new LangString("coeficiente de difusão", "pt"));
  quantityKind.addLabel(new LangString("difuzijski koeficient", "sl"));
  quantityKind.addLabel(new LangString("diffusion coefficient", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-SEC");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DiffusionCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DiffusionCoefficientForFluenceRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "Dᵩ",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Diffusion Coefficient for Fluence Rate", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DiffusionCoefficientForFluenceRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DiffusionLength",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "L",
    undefined
  );
  quantityKind.addLabel(new LangString("Diffusion Length", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DiffusionLength",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DigitRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("digit rate", undefined));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBAUD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAUD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBAUD");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DigitRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Dimensionless",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "U",
    undefined
  );
  quantityKind.addLabel(new LangString("Dimensionless", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DECADE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FLIGHT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RPK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_MAG"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaBasePair");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BasePair");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/COUNT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HeartBeat");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OCT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_ELEC"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Dimensionless",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Dimensionless Ratio", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ONE-PER-ONE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERMITTIVITY_REL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Dimensionless"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Displacement",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Displacement", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Displacement",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DisplacementCurrent",
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T0D0",
    "I_D",
    undefined
  );
  quantityKind.addLabel(new LangString("Displacement Current", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoA");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DisplacementCurrent",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DisplacementCurrentDensity",
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Displacement Current Density", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-M2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DisplacementCurrentDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DisplacementVectorOfIon",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "u",
    undefined
  );
  quantityKind.addLabel(new LangString("Displacement Vector of Ion", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DisplacementVectorOfIon",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Dissipance",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Dissipance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Dissipance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Distance",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "d",
    undefined
  );
  quantityKind.addLabel(new LangString("Jarak", "ms"));
  quantityKind.addLabel(new LangString("Vzdálenost", "cs"));
  quantityKind.addLabel(new LangString("distanza", "it"));
  quantityKind.addLabel(new LangString("距离", "zh"));
  quantityKind.addLabel(new LangString("distância", "pt"));
  quantityKind.addLabel(new LangString("Entfernung", "de"));
  quantityKind.addLabel(new LangString("distance", "en"));
  quantityKind.addLabel(new LangString("مسافت", "fa"));
  quantityKind.addLabel(new LangString("distance", "fr"));
  quantityKind.addLabel(new LangString("distancia", "es"));
  quantityKind.addLabel(new LangString("uzaklık", "tr"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT_BIG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Distance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DistanceTraveledDuringBurn",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "s",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Distance Traveled During a Burn", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT_BIG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Distance"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DistanceTraveledDuringBurn",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DonorDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    "n_d",
    undefined
  );
  quantityKind.addLabel(new LangString("Donor Density", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-MicroL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-NanoL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-MilliM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-PicoL");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/NumberDensity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DonorDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DonorIonizationEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "E_d",
    undefined
  );
  quantityKind.addLabel(new LangString("Donor Ionization Energy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/IonizationEnergy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DonorIonizationEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DoseEquivalent",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    "H",
    undefined
  );
  quantityKind.addLabel(new LangString("Dose Equivalent", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliR_man");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/REM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroSV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoSV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliSV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/R_man");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificEnergy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DoseEquivalent",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DoseEquivalentQualityFactor",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "Q",
    undefined
  );
  quantityKind.addLabel(new LangString("Dose Equivalent Quality Factor", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DoseEquivalentQualityFactor",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DoseEquivalentRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("dose equivalent rate", undefined));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DoseEquivalentRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DotsPerInch",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("dots per inch", undefined));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DPI");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InverseLength"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DotsPerInch",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DragCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "C_D",
    undefined
  );
  quantityKind.addLabel(new LangString("Drag Coefficient", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DECADE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FLIGHT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RPK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_MAG"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaBasePair");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BasePair");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/COUNT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HeartBeat");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OCT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_ELEC"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Dimensionless"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DragCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DragForce",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    "D or F_D",
    undefined
  );
  quantityKind.addLabel(new LangString("Drag Force", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_F_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPOND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-M-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DYN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckForce");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Force"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DragForce",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DryBulbTemperature",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Dry Bulb Temperature", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliDEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_R");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckTemperature"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_F");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Temperature"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DryBulbTemperature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DryVolume",
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Dry Volume", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PK_US_DRY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BBL_US_DRY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAL_US_DRY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BU_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_US_DRY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CORD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PINT_US_DRY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BU_UK");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Volume"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DryVolume",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DutyCycle",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "α",
    undefined
  );
  quantityKind.addLabel(new LangString("Duty Cycle", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DutyCycle",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Duv",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Delta u,v", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Duv",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DynamicFriction",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Dynamic Friction", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_F_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPOND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-M-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DYN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckForce");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Friction"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DynamicFriction",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DynamicFrictionCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Dynamic Friction Coefficient", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/FrictionCoefficient"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DynamicFrictionCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DynamicPressure",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    "q",
    undefined
  );
  quantityKind.addLabel(new LangString("Dynamic Pressure", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-IN2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_32DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroTORR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_60DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARYE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA_A");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroATM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliTORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_60DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR_A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR_A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckPressure"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_H2O_4DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_HG_0DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HGA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Pressure"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DynamicPressure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DynamicViscosity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("श्यानता", "hi"));
  quantityKind.addLabel(new LangString("viscosidad dinámica", "es"));
  quantityKind.addLabel(new LangString("lepkość dynamiczna", "pl"));
  quantityKind.addLabel(new LangString("dynamische Viskosität", "de"));
  quantityKind.addLabel(new LangString("لزوجة", "ar"));
  quantityKind.addLabel(new LangString("viscosidade dinâmica", "pt"));
  quantityKind.addLabel(new LangString("Viscozitate dinamică", "ro"));
  quantityKind.addLabel(new LangString("dinamična viskoznost", "sl"));
  quantityKind.addLabel(new LangString("viskozita", "cs"));
  quantityKind.addLabel(new LangString("Kelikatan dinamik", "ms"));
  quantityKind.addLabel(
    new LangString("گرانروی دینامیکی/ویسکوزیته دینامیکی", "fa")
  );
  quantityKind.addLabel(new LangString("viscosità dinamica", "it"));
  quantityKind.addLabel(new LangString("粘度", "ja"));
  quantityKind.addLabel(new LangString("динамическую вязкость", "ru"));
  quantityKind.addLabel(new LangString("dynamic viscosity", "en"));
  quantityKind.addLabel(new LangString("动力粘度", "zh"));
  quantityKind.addLabel(new LangString("viscosité dynamique", "fr"));
  quantityKind.addLabel(new LangString("dinamik akmazlık", "tr"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliPA-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SLUG-PER-FT-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-SEC-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POISE");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-CentiM-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PDL-SEC-PER-FT2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB_F-SEC-PER-FT2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroPOISE");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PDL-SEC-PER-IN2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-FT-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB_F-SEC-PER-IN2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPOISE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-FT-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaPOISE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiPOISE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-FT-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-FT-DAY");
  quantityKind.addExactMatchIri("http://qudt.org/vocab/quantitykind/Viscosity");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DynamicViscosity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EarthClosestApproachVehicleVelocity",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    "V_o",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Earth Closest Approach Vehicle Velocity", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaHZ-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-KiloYR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM-PER-YR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/VehicleVelocity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EarthClosestApproachVehicleVelocity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EarthquakeMagnitude",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("earthquake magnitude", undefined));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/RichterMagnitude"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EarthquakeMagnitude",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EccentricityOfOrbit",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Eccentricity Of Orbit", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ONE-PER-ONE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERMITTIVITY_REL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EccentricityOfOrbit",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EffectiveExhaustVelocity",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    "v_{e}",
    undefined
  );
  quantityKind.addLabel(new LangString("Effective Exhaustvelocity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaHZ-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-KiloYR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM-PER-YR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Velocity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EffectiveExhaustVelocity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EffectiveMass",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    "m^*",
    undefined
  );
  quantityKind.addLabel(new LangString("Effective Mass", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PENNYWEIGHT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EffectiveMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EffectiveMultiplicationFactor",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "k_{eff}",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Effective Multiplication Factor", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MultiplicationFactor"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EffectiveMultiplicationFactor",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Efficiency",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("eficiência", "pt"));
  quantityKind.addLabel(new LangString("Wirkungsgrad", "de"));
  quantityKind.addLabel(new LangString("sprawność", "pl"));
  quantityKind.addLabel(new LangString("efficiency", "en"));
  quantityKind.addLabel(new LangString("efficienza", "it"));
  quantityKind.addLabel(new LangString("效率", "zh"));
  quantityKind.addLabel(new LangString("كفاءة", "ar"));
  quantityKind.addLabel(new LangString("rendimiento", "es"));
  quantityKind.addLabel(new LangString("効率", "ja"));
  quantityKind.addLabel(new LangString("rendement", "fr"));
  quantityKind.addLabel(new LangString("коэффициент полезного действия", "ru"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ONE-PER-ONE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERMITTIVITY_REL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Efficiency",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EinsteinCoefficients",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Einstein coefficients", undefined));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SEC-PER-KiloGM"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EinsteinCoefficients",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EinsteinTransitionProbability",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "A_jkN_j",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Einstein Transition Probability", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EinsteinTransitionProbability",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EinsteinTransitionProbabilityForSpontaneousOrInducedEmissionAndAbsorption",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T1D0",
    "0173-1#Z4-BAJ456#001",
    undefined
  );
  quantityKind.addLabel(
    new LangString(
      "Einstein transition probability for spontaneous or induced emission and absorption",
      "en-US"
    )
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EinsteinTransitionProbabilityForSpontaneousOrInducedEmissionAndAbsorption",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricCharge",
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    "Q",
    undefined
  );
  quantityKind.addLabel(new LangString("ładunek elektryczny", "pl"));
  quantityKind.addLabel(new LangString("Ηλεκτρικό φορτίο", "el"));
  quantityKind.addLabel(new LangString("Электрический заряд", "ru"));
  quantityKind.addLabel(new LangString("carica elettrica", "it"));
  quantityKind.addLabel(new LangString("Elektrický náboj", "cs"));
  quantityKind.addLabel(new LangString("Cas elektrik", "ms"));
  quantityKind.addLabel(new LangString("विद्युत आवेग या विद्युत बहाव", "hi"));
  quantityKind.addLabel(new LangString("电荷", "zh"));
  quantityKind.addLabel(new LangString("carga elétrica", "pt"));
  quantityKind.addLabel(new LangString("električni naboj", "sl"));
  quantityKind.addLabel(new LangString("onus electricum", "la"));
  quantityKind.addLabel(new LangString("elektrische Ladung", "de"));
  quantityKind.addLabel(new LangString("Charge électrique", "fr"));
  quantityKind.addLabel(new LangString("sarcină electrică", "ro"));
  quantityKind.addLabel(new LangString("carga eléctrica", "es"));
  quantityKind.addLabel(new LangString("מטען חשמלי", "he"));
  quantityKind.addLabel(new LangString("electric charge", "en"));
  quantityKind.addLabel(new LangString("電荷", "ja"));
  quantityKind.addLabel(new LangString("بار الکتریکی", "fa"));
  quantityKind.addLabel(new LangString("elektrik yükü", "tr"));
  quantityKind.addLabel(new LangString("الشحنة الكهربائية", "ar"));
  quantityKind.addLabel(new LangString("elektromos töltés", "hu"));
  quantityKind.addLabel(new LangString("Електрически заряд", "bg"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckCharge");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloJ-PER-KiloV"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C_Stat");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZettaC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YottaC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliA-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YoctoC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C_Ab");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZeptoC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/ElementaryCharge"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaC");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricCharge",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricChargeDensity",
    "http://qudt.org/vocab/dimensionvector/A0E1L-3I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Electric Charge Density", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/A-HR-PER-DeciM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroC-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-HR-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaC-PER-M3");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricChargeDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricChargeLineDensity",
    "http://qudt.org/vocab/dimensionvector/A0E1L-1I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Electric Charge Line Density", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-PER-M");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricChargeLineDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricChargeLinearDensity",
    "http://qudt.org/vocab/dimensionvector/A0E1L-1I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Electric Charge Linear Density", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-PER-M");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricChargeLinearDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerAmountOfSubstance",
    "http://qudt.org/vocab/dimensionvector/A-1E1L0I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Electric charge per amount of substance", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-PER-MOL");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/C_Stat-PER-MOL"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerAmountOfSubstance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerArea",
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Electric charge per area", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/C_Ab-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-HR-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroC-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/C_Stat-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliC-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaC-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloC-PER-M2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerArea",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerMass",
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M-1H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Electric Charge Per Mass", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-PER-KiloGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliC-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/R");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-T-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/A-M2-PER-J-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/A-HR-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaHZ-PER-T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HZ-PER-T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliR");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricChargeSurfaceDensity",
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Electric Charge Surface Density", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-HR-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerArea"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricChargeSurfaceDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricChargeVolumeDensity",
    "http://qudt.org/vocab/dimensionvector/A0E1L-3I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Electric Charge Volume Density", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/A-HR-PER-DeciM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-PER-CentiM3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaC-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliC-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloC-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-HR-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-PER-MilliM3");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricChargeVolumeDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricConductivity",
    "http://qudt.org/vocab/dimensionvector/A0E2L-3I0M-1H0T3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("电导率", "zh"));
  quantityKind.addLabel(new LangString("condutividade elétrica", "pt"));
  quantityKind.addLabel(new LangString("conductivité électrique", "fr"));
  quantityKind.addLabel(new LangString("elektrische Leitfähigkeit", "de"));
  quantityKind.addLabel(new LangString("conductividad eléctrica", "es"));
  quantityKind.addLabel(new LangString("conducibilità elettrica", "it"));
  quantityKind.addLabel(new LangString("električna prevodnost", "sl"));
  quantityKind.addLabel(new LangString("electric conductivity", "en"));
  quantityKind.addLabel(new LangString("elektrik iletkenliği", "tr"));
  quantityKind.addLabel(
    new LangString("رسانايى الکتريکى/هدایت الکتریکی", "fa")
  );
  quantityKind.addLabel(new LangString("Kekonduksian elektrik", "ms"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/S_Ab");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/S_Stat");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MHO_Stat");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricConductivity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricCurrent",
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T0D0",
    "I",
    undefined
  );
  quantityKind.addLabel(new LangString("corrente elettrica", "it"));
  quantityKind.addLabel(new LangString("corrente elétrica", "pt"));
  quantityKind.addLabel(new LangString("elektrische Stromstärke", "de"));
  quantityKind.addLabel(new LangString("تيار كهربائي", "ar"));
  quantityKind.addLabel(
    new LangString("intensité de courant électrique", "fr")
  );
  quantityKind.addLabel(new LangString("elektromos áramerősség", "hu"));
  quantityKind.addLabel(new LangString("Електрически ток", "bg"));
  quantityKind.addLabel(new LangString("电流", "zh"));
  quantityKind.addLabel(new LangString("curent electric", "ro"));
  quantityKind.addLabel(new LangString("električni tok", "sl"));
  quantityKind.addLabel(new LangString("Сила электрического тока", "ru"));
  quantityKind.addLabel(new LangString("Arus elektrik", "ms"));
  quantityKind.addLabel(new LangString("fluxio electrica", "la"));
  quantityKind.addLabel(new LangString("elektrik akımı", "tr"));
  quantityKind.addLabel(new LangString("Ένταση ηλεκτρικού ρεύματος", "el"));
  quantityKind.addLabel(new LangString("विद्युत धारा", "hi"));
  quantityKind.addLabel(new LangString("電流", "ja"));
  quantityKind.addLabel(new LangString("זרם חשמלי", "he"));
  quantityKind.addLabel(new LangString("Elektrický proud", "cs"));
  quantityKind.addLabel(new LangString("electric current", "en"));
  quantityKind.addLabel(new LangString("جریان الکتریکی", "fa"));
  quantityKind.addLabel(new LangString("prąd elektryczny", "pl"));
  quantityKind.addLabel(new LangString("corriente eléctrica", "es"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckCurrent");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BIOT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A_Stat");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A_Ab");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoA");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricCurrent",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentDensity",
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H0T0D0",
    "J",
    undefined
  );
  quantityKind.addLabel(new LangString("Ketumpatan arus elektrik", "ms"));
  quantityKind.addLabel(new LangString("densidad de corriente", "es"));
  quantityKind.addLabel(new LangString("چگالی جریان الکتریکی", "fa"));
  quantityKind.addLabel(new LangString("плотность тока", "ru"));
  quantityKind.addLabel(new LangString("كثافة التيار", "ar"));
  quantityKind.addLabel(new LangString("electric current density", "en"));
  quantityKind.addLabel(new LangString("धारा घनत्व", "hi"));
  quantityKind.addLabel(new LangString("Gęstość prądu elektrycznego", "pl"));
  quantityKind.addLabel(new LangString("densidade de corrente elétrica", "pt"));
  quantityKind.addLabel(new LangString("elektrische Stromdichte", "de"));
  quantityKind.addLabel(new LangString("densité de courant", "fr"));
  quantityKind.addLabel(new LangString("Akım yoğunluğu", "tr"));
  quantityKind.addLabel(new LangString("电流密度", "zh"));
  quantityKind.addLabel(new LangString("電流密度", "ja"));
  quantityKind.addLabel(new LangString("Densitate de curent", "ro"));
  quantityKind.addLabel(new LangString("densità di corrente elettrica", "it"));
  quantityKind.addLabel(new LangString("gostota električnega toka", "sl"));
  quantityKind.addLabel(new LangString("Hustota elektrického proudu", "cs"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-CentiM2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/A_Stat-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaA-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/A_Ab-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloA-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckCurrentDensity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentPerAngle",
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Electric Current per Angle", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-RAD");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentPerAngle",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentPerEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M-1H0T2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Electric Current per Energy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-J");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentPerEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentPerLength",
    "http://qudt.org/vocab/dimensionvector/A0E1L-1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Electric Current per Length", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliA-PER-IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloA-PER-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliA-PER-MilliM"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearElectricCurrentDensity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentPerLength",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentPerTemperature",
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H-1T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Electric Current per Temperature", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliA-PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-DEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloA-PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroA-PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoA-PER-K");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentPerTemperature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentPhasor",
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Electric Current Phasor", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoA");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentPhasor",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricDipoleMoment",
    "http://qudt.org/vocab/dimensionvector/A0E1L1I0M0H0T1D0",
    "p",
    undefined
  );
  quantityKind.addLabel(new LangString("momento di dipolo elettrico", "it"));
  quantityKind.addLabel(new LangString("Dipólový moment", "cs"));
  quantityKind.addLabel(new LangString("moment dipolaire", "fr"));
  quantityKind.addLabel(new LangString("momento de dipolo eléctrico", "es"));
  quantityKind.addLabel(new LangString("momento do dipolo elétrico", "pt"));
  quantityKind.addLabel(new LangString("电偶极矩", "zh"));
  quantityKind.addLabel(new LangString("moment electric dipolar", "ro"));
  quantityKind.addLabel(new LangString("elektryczny moment dipolowy", "pl"));
  quantityKind.addLabel(new LangString("विद्युत द्विध्रुव आघूर्ण", "hi"));
  quantityKind.addLabel(new LangString("electric dipole moment", "en"));
  quantityKind.addLabel(new LangString("گشتاور دوقطبی الکتریکی", "fa"));
  quantityKind.addLabel(new LangString("電気双極子", "ja"));
  quantityKind.addLabel(new LangString("Momen dwikutub elektrik", "ms"));
  quantityKind.addLabel(new LangString("elektrik dipol momenti", "tr"));
  quantityKind.addLabel(new LangString("elektrisches Dipolmoment", "de"));
  quantityKind.addLabel(new LangString("عزم ثنائي قطب", "ar"));
  quantityKind.addLabel(new LangString("Электрический дипольный момент", "ru"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEBYE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-M");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricDipoleMoment",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricDipoleMoment_CubicPerEnergy_Squared",
    "http://qudt.org/vocab/dimensionvector/A0E3L-3I0M-2H0T7D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Cubic Electric Dipole Moment per Square Energy", "en")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricDipoleMoment_CubicPerEnergy_Squared",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricDipoleMoment_QuarticPerEnergy_Cubic",
    "http://qudt.org/vocab/dimensionvector/A0E4L-2I0M-3H0T10D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Quartic Electric Dipole Moment per Cubic Energy", "en")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricDipoleMoment_QuarticPerEnergy_Cubic",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricDisplacement",
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H0T1D0",
    "D",
    undefined
  );
  quantityKind.addLabel(new LangString("Electric Displacement", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/C_Ab-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-HR-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroC-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/C_Stat-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliC-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaC-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloC-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerArea"
  );
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/ElectricFluxDensity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricDisplacement",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricDisplacementField",
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H0T1D0",
    "D",
    undefined
  );
  quantityKind.addLabel(new LangString("Electric Displacement Field", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/C_Ab-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-HR-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroC-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/C_Stat-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliC-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaC-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloC-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerArea"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricDisplacementField",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricField",
    "http://qudt.org/vocab/dimensionvector/A0E-1L1I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Electric Field", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/V_Ab-PER-CentiM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-PER-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/V_Stat-PER-CentiM"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricField",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricFieldStrength",
    "http://qudt.org/vocab/dimensionvector/A0E-1L1I0M1H0T-3D0",
    "E",
    undefined
  );
  quantityKind.addLabel(new LangString("विद्युत्-क्षेत्र", "hi"));
  quantityKind.addLabel(new LangString("電界強度", "ja"));
  quantityKind.addLabel(new LangString("intensidade de campo elétrico", "pt"));
  quantityKind.addLabel(new LangString("שדה חשמלי", "he"));
  quantityKind.addLabel(new LangString("elektrische Feldstärke", "de"));
  quantityKind.addLabel(new LangString("Електрично поле", "bg"));
  quantityKind.addLabel(new LangString("jakost električnega polja", "sl"));
  quantityKind.addLabel(new LangString("intensità di campo elettrico", "it"));
  quantityKind.addLabel(new LangString("Kekuatan medan elektrik", "ms"));
  quantityKind.addLabel(new LangString("elektrické pole", "cs"));
  quantityKind.addLabel(new LangString("câmp electric", "ro"));
  quantityKind.addLabel(new LangString("elektriksel alan kuvveti", "tr"));
  quantityKind.addLabel(
    new LangString("Напряженность электрического поля", "ru")
  );
  quantityKind.addLabel(new LangString("natężenie pola elektrycznego", "pl"));
  quantityKind.addLabel(new LangString("intensidad de campo eléctrico", "es"));
  quantityKind.addLabel(new LangString("شدت میدان الکتریکی", "fa"));
  quantityKind.addLabel(new LangString("Ηλεκτρικό πεδίο", "el"));
  quantityKind.addLabel(new LangString("電場", "zh"));
  quantityKind.addLabel(new LangString("electric field strength", "en"));
  quantityKind.addLabel(new LangString("intensité de champ électrique", "fr"));
  quantityKind.addLabel(new LangString("Elektromos mező", "hu"));
  quantityKind.addLabel(new LangString("شدة المجال الكهربائي", "ar"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroV-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-PER-CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloV-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliV-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-PER-MilliM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/V_Ab-PER-CentiM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaV-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-PER-IN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/V_Stat-PER-CentiM"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricFieldStrength",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricFlux",
    "http://qudt.org/vocab/dimensionvector/A0E-1L3I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Electric Flux", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V_Stat-CentiM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricFlux",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricFluxDensity",
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H0T1D0",
    "D",
    undefined
  );
  quantityKind.addLabel(new LangString("چگالی شار الکتریکی", "fa"));
  quantityKind.addLabel(new LangString("spostamento elettrico", "it"));
  quantityKind.addLabel(new LangString("Inducție electrică", "ro"));
  quantityKind.addLabel(new LangString("elektrik akı yoğunluğu", "tr"));
  quantityKind.addLabel(new LangString("Ketumpatan fluks elektrik", "ms"));
  quantityKind.addLabel(new LangString("Elektrická indukce", "cs"));
  quantityKind.addLabel(new LangString("Indukcja elektryczna", "pl"));
  quantityKind.addLabel(new LangString("elektrische Flussdichte", "de"));
  quantityKind.addLabel(new LangString("電束密度", "ja"));
  quantityKind.addLabel(new LangString("electric flux density", "en"));
  quantityKind.addLabel(new LangString("Induction électrique", "fr"));
  quantityKind.addLabel(new LangString("campo de deslocamento elétrico", "pt"));
  quantityKind.addLabel(new LangString("Электрическая индукция", "ru"));
  quantityKind.addLabel(new LangString("إزاحة كهربائية", "ar"));
  quantityKind.addLabel(new LangString("Densidad de flujo eléctrico", "es"));
  quantityKind.addLabel(new LangString("電位移", "zh"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/C_Ab-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-HR-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroC-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/C_Stat-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliC-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaC-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloC-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerArea"
  );
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/ElectricDisplacement"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricFluxDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricPolarizability",
    "http://qudt.org/vocab/dimensionvector/A-1E0L2I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("polarizzabilità elettrica", "it"));
  quantityKind.addLabel(new LangString("قابلية استقطاب", "ar"));
  quantityKind.addLabel(new LangString("分極率", "ja"));
  quantityKind.addLabel(new LangString("قطبیت پذیری الکتریکی", "fa"));
  quantityKind.addLabel(new LangString("polarizabilidade", "pt"));
  quantityKind.addLabel(new LangString("Polarizovatelnost", "cs"));
  quantityKind.addLabel(new LangString("Kepengkutuban elektrik", "ms"));
  quantityKind.addLabel(new LangString("electric polarizability", "en"));
  quantityKind.addLabel(new LangString("Polarisabilité", "fr"));
  quantityKind.addLabel(new LangString("elektrische Polarisierbarkeit", "de"));
  quantityKind.addLabel(new LangString("Поляризуемость", "ru"));
  quantityKind.addLabel(new LangString("Polaryzowalność", "pl"));
  quantityKind.addLabel(new LangString("Polarizabilidad", "es"));
  quantityKind.addLabel(new LangString("極化性", "zh"));
  quantityKind.addLabel(new LangString("Kutuplanabilirlik", "tr"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-MOL");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricPolarizability",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricPolarization",
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H0T1D0",
    "P",
    undefined
  );
  quantityKind.addLabel(new LangString("polarização eléctrica", "pt"));
  quantityKind.addLabel(new LangString("電気分極", "ja"));
  quantityKind.addLabel(new LangString("polarizzazione elettrica", "it"));
  quantityKind.addLabel(new LangString("polarización eléctrica", "es"));
  quantityKind.addLabel(new LangString("إستقطاب كهربائي", "ar"));
  quantityKind.addLabel(new LangString("elektrische Polarisation", "de"));
  quantityKind.addLabel(new LangString("polarisation électrique", "fr"));
  quantityKind.addLabel(new LangString("polaryzacja elektryczna", "pl"));
  quantityKind.addLabel(new LangString("электрическая поляризация", "ru"));
  quantityKind.addLabel(new LangString("electric polarization", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-HR-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloC-PER-M2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricPolarization",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricPotential",
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-3D0",
    "V_{ab}",
    undefined
  );
  quantityKind.addLabel(new LangString("電位", "ja"));
  quantityKind.addLabel(new LangString("電勢", "zh"));
  quantityKind.addLabel(new LangString("potentiel électrique", "fr"));
  quantityKind.addLabel(new LangString("электростатический потенциал", "ru"));
  quantityKind.addLabel(new LangString("كمون كهربائي", "ar"));
  quantityKind.addLabel(new LangString("elektrik potansiyeli", "tr"));
  quantityKind.addLabel(new LangString("električni potencial", "sl"));
  quantityKind.addLabel(new LangString("electric potential", "en"));
  quantityKind.addLabel(new LangString("Keupayaan elektrik", "ms"));
  quantityKind.addLabel(new LangString("potencial elétrico", "pt"));
  quantityKind.addLabel(new LangString("Електрически потенциал", "bg"));
  quantityKind.addLabel(new LangString("elektrický potenciál", "cs"));
  quantityKind.addLabel(new LangString("elektrisches Potenzial", "de"));
  quantityKind.addLabel(
    new LangString(
      "elektromos feszültség , elektromos potenciálkülönbség",
      "hu"
    )
  );
  quantityKind.addLabel(new LangString("potencjał elektryczny", "pl"));
  quantityKind.addLabel(new LangString("potențial electric", "ro"));
  quantityKind.addLabel(new LangString("विद्युत विभव", "hi"));
  quantityKind.addLabel(new LangString("potenziale elettrico", "it"));
  quantityKind.addLabel(new LangString("מתח חשמלי (הפרש פוטנציאלים)", "he"));
  quantityKind.addLabel(new LangString("potencial eléctrico", "es"));
  quantityKind.addLabel(new LangString("tensio electrica", "la"));
  quantityKind.addLabel(new LangString("پتانسیل الکتریکی", "fa"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V_Stat");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V_Ab");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckVolt");
  quantityKind.addExactMatchIri("http://qudt.org/vocab/quantitykind/Voltage");
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/EnergyPerElectricCharge"
  );
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotentialDifference"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricPotential",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricPotentialDifference",
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-3D0",
    "V",
    undefined
  );
  quantityKind.addLabel(
    new LangString("differenza di potenziale elettrico", "it")
  );
  quantityKind.addLabel(new LangString("विभवांतर", "hi"));
  quantityKind.addLabel(new LangString("tensión eléctrica", "es"));
  quantityKind.addLabel(new LangString("электрическое напряжение", "ru"));
  quantityKind.addLabel(new LangString("electric potential difference", "en"));
  quantityKind.addLabel(new LangString("جهد كهربائي", "ar"));
  quantityKind.addLabel(new LangString("elektrische Spannung", "de"));
  quantityKind.addLabel(new LangString("napięcie elektryczne", "pl"));
  quantityKind.addLabel(new LangString("ولتاژ/ اختلاف پتانسیل", "fa"));
  quantityKind.addLabel(
    new LangString("Voltan Perbezaan keupayaan elektrik", "ms")
  );
  quantityKind.addLabel(new LangString("電圧", "ja"));
  quantityKind.addLabel(new LangString("električna napetost", "sl"));
  quantityKind.addLabel(
    new LangString("tensão elétrica (diferença de potencial)", "pt")
  );
  quantityKind.addLabel(new LangString("gerilim", "tr"));
  quantityKind.addLabel(new LangString("電壓", "zh"));
  quantityKind.addLabel(new LangString("tension électrique", "fr"));
  quantityKind.addLabel(
    new LangString("diferență de potențial electric", "ro")
  );
  quantityKind.addLabel(new LangString("elektrické napětí", "cs"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V_Stat");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V_Ab");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckVolt");
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotential"
  );
  quantityKind.addExactMatchIri("http://qudt.org/vocab/quantitykind/Voltage");
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/EnergyPerElectricCharge"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricPotentialDifference",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricPower",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    "P_E",
    undefined
  );
  quantityKind.addLabel(new LangString("Wirkleistung", "de"));
  quantityKind.addLabel(new LangString("puissance active", "fr"));
  quantityKind.addLabel(new LangString("electric power", "en"));
  quantityKind.addLabel(new LangString("potência activa", "pt"));
  quantityKind.addLabel(new LangString("potencia activa", "es"));
  quantityKind.addLabel(new LangString("moc czynna", "pl"));
  quantityKind.addLabel(new LangString("有効電力", "ja"));
  quantityKind.addLabel(new LangString("potenza attiva", "it"));
  quantityKind.addLabel(new LangString("有功功率", "zh"));
  quantityKind.addLabel(new LangString("القدرة الفعالة", "ar"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliW");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Power"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricPower",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricPropulsionPropellantMass",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    "M_P",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Electric Propulsion Propellant Mass", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PENNYWEIGHT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PropellantMass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricPropulsionPropellantMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricQuadrupoleMoment",
    "http://qudt.org/vocab/dimensionvector/A0E1L2I0M0H0T1D0",
    "Q",
    undefined
  );
  quantityKind.addLabel(
    new LangString("elektryczny moment kwadrupolowy", "pl")
  );
  quantityKind.addLabel(
    new LangString("moment quadrupolaire électrique", "fr")
  );
  quantityKind.addLabel(new LangString("momento de quadrupolo elétrico", "pt"));
  quantityKind.addLabel(new LangString("elektrisches Quadrupolmoment", "de"));
  quantityKind.addLabel(new LangString("electric quadrupole moment", "en"));
  quantityKind.addLabel(
    new LangString("momento de cuadrupolo eléctrico", "es")
  );
  quantityKind.addLabel(
    new LangString("Электрический квадрупольный момент", "ru")
  );
  quantityKind.addLabel(new LangString("四極子", "ja"));
  quantityKind.addLabel(new LangString("电四极矩", "zh"));
  quantityKind.addLabel(new LangString("Momen kuadrupol elektrik", "ms"));
  quantityKind.addLabel(
    new LangString("momento di quadrupolo elettrico", "it")
  );
  quantityKind.addLabel(new LangString("گشتاور چهار قطبی الکتریکی", "fa"));
  quantityKind.addLabel(new LangString("elektrik kuadrupol momenti", "tr"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-M2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricQuadrupoleMoment",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricSusceptibility",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("podatność elektryczna", "pl"));
  quantityKind.addLabel(new LangString("susceptibilidad eléctrica", "es"));
  quantityKind.addLabel(
    new LangString("المتأثرية الكهربائية، سرعة التأثر الكهربائية", "ar")
  );
  quantityKind.addLabel(new LangString("электрическая восприимчивость", "ru"));
  quantityKind.addLabel(new LangString("susceptibilidade eléctrica", "pt"));
  quantityKind.addLabel(new LangString("electric susceptibility", "en"));
  quantityKind.addLabel(new LangString("elektrische Suszeptibilität", "de"));
  quantityKind.addLabel(new LangString("suscettività elettrica", "it"));
  quantityKind.addLabel(new LangString("susceptibilité électrique", "fr"));
  quantityKind.addLabel(new LangString("電気感受率", "ja"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricSusceptibility",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricalConductance",
    "http://qudt.org/vocab/dimensionvector/A0E2L-2I0M-1H0T3D0",
    "0173-1#Z4-BAJ223#002",
    undefined
  );
  quantityKind.addLabel(new LangString("electrical conductance", undefined));
  quantityKind.addLabel(new LangString("electrical conductance", "en-US"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricalConductance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricalPowerToMassRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Electrical Power To Mass Ratio", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroSV-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroSV-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliSV-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliSV-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliW-PER-MilliGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGRAY-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SV-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/REM-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SV-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/ERG-PER-GM-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliSV-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-KiloGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliRAD_R-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAY-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGRAY-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGRAY-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGRAY-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAY-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAY-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGRAY-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGRAY-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGRAY-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGRAY-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoSV-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SV-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGRAY-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoSV-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoSV-PER-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificPower"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricalPowerToMassRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricalResistance",
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H0T-3D0",
    "0173-1#Z4-BAJ215#003",
    undefined
  );
  quantityKind.addLabel(new LangString("electrical resistance", "en-US"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoOHM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricalResistance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectrolyticConductivity",
    "http://qudt.org/vocab/dimensionvector/A0E2L-3I0M-1H0T3D0",
    "x",
    undefined
  );
  quantityKind.addLabel(new LangString("Electrolytic Conductivity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/S-PER-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroS-PER-CentiM"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectrolyticConductivity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectromagneticEnergyDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    "w",
    undefined
  );
  quantityKind.addLabel(new LangString("Electromagnetic Energy Density", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-M3");
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/VolumicElectromagneticEnergy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectromagneticEnergyDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectromagneticPermeability",
    "http://qudt.org/vocab/dimensionvector/A0E-2L1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Permeability", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H-PER-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/H_Stat-PER-CentiM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoH-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroH-PER-M");
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/Permeability"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectromagneticPermeability",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectromagneticPermeabilityRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Electromagnetic Permeability Ratio", "en")
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERMEABILITY_EM_REL"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectromagneticPermeabilityRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectromagneticWavePhaseSpeed",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    "c",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Electromagnetic Wave Phase Speed", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-YR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-SEC"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectromagneticWavePhaseSpeed",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectromotiveForce",
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-3D0",
    "E",
    undefined
  );
  quantityKind.addLabel(new LangString("electromotive force", "en"));
  quantityKind.addLabel(new LangString("forza elettromotrice", "it"));
  quantityKind.addLabel(new LangString("विद्युतवाहक बल", "hi"));
  quantityKind.addLabel(new LangString("電動勢", "zh"));
  quantityKind.addLabel(new LangString("força eletromotriz", "pt"));
  quantityKind.addLabel(new LangString("Daya gerak elektrik", "ms"));
  quantityKind.addLabel(new LangString("force électromotrice", "fr"));
  quantityKind.addLabel(new LangString("قوة محركة كهربائية", "ar"));
  quantityKind.addLabel(new LangString("起電力", "ja"));
  quantityKind.addLabel(new LangString("электродвижущая сила", "ru"));
  quantityKind.addLabel(new LangString("elektromotorna sila", "sl"));
  quantityKind.addLabel(new LangString("siła elektromotoryczna", "pl"));
  quantityKind.addLabel(new LangString("Elektromotor kuvvet", "tr"));
  quantityKind.addLabel(new LangString("Elektromotorické napětí", "cs"));
  quantityKind.addLabel(new LangString("fuerza electromotriz", "es"));
  quantityKind.addLabel(new LangString("نیروی محرک الکتریکی", "fa"));
  quantityKind.addLabel(new LangString("forță electromotoare", "ro"));
  quantityKind.addLabel(new LangString("elektromotorische Kraft", "de"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V_Stat");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V_Ab");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckVolt");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EnergyPerElectricCharge"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectromotiveForce",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectronAffinity",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "χ",
    undefined
  );
  quantityKind.addLabel(new LangString("Electron Affinity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectronAffinity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectronDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    "n",
    undefined
  );
  quantityKind.addLabel(new LangString("Electron Density", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-MicroL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-NanoL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-MilliM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-PicoL");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/NumberDensity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectronDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectronMeanFreePath",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "l_e",
    undefined
  );
  quantityKind.addLabel(new LangString("Electron Mean Free Path", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectronMeanFreePath",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectronMobility",
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M-1H0T2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("electron mobility", undefined));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM2-PER-V-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-V-SEC");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mobility"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectronMobility",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectronRadius",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "r_e",
    undefined
  );
  quantityKind.addLabel(new LangString("Electron Radius", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectronRadius",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElevationRelativeToNAP",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "mNAP",
    undefined
  );
  quantityKind.addLabel(new LangString("Elevation relative to NAP", "en"));
  quantityKind.addLabel(new LangString("Hoogte ten opzichte van NAP", "nl"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Altitude"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElevationRelativeToNAP",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EllipticalOrbitApogeeVelocity",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    "V_a",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Elliptical Orbit Apogee Velocity", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaHZ-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-KiloYR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM-PER-YR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/VehicleVelocity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EllipticalOrbitApogeeVelocity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EllipticalOrbitPerigeeVelocity",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    "V_p",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Elliptical Orbit Perigee Velocity", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaHZ-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-KiloYR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM-PER-YR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/VehicleVelocity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EllipticalOrbitPerigeeVelocity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Emissivity",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Emissivity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Emissivity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Energy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "E",
    undefined
  );
  quantityKind.addLabel(new LangString("energia", "pl"));
  quantityKind.addLabel(new LangString("انرژی", "fa"));
  quantityKind.addLabel(new LangString("energie", "ro"));
  quantityKind.addLabel(new LangString("enerji", "tr"));
  quantityKind.addLabel(new LangString("energia", "pt"));
  quantityKind.addLabel(new LangString("能量", "zh"));
  quantityKind.addLabel(new LangString("Tenaga", "ms"));
  quantityKind.addLabel(new LangString("Енергия", "bg"));
  quantityKind.addLabel(new LangString("Energie", "cs"));
  quantityKind.addLabel(new LangString("energy", "en"));
  quantityKind.addLabel(new LangString("Έργο - Ενέργεια", "el"));
  quantityKind.addLabel(new LangString("energija", "sl"));
  quantityKind.addLabel(new LangString("energia", "es"));
  quantityKind.addLabel(new LangString("الطاقة", "ar"));
  quantityKind.addLabel(new LangString("エネルギー", "ja"));
  quantityKind.addLabel(new LangString("énergie", "fr"));
  quantityKind.addLabel(new LangString("Энергия", "ru"));
  quantityKind.addLabel(new LangString("energia", "it"));
  quantityKind.addLabel(new LangString("energia", "la"));
  quantityKind.addLabel(new LangString("ऊर्जा", "hi"));
  quantityKind.addLabel(new LangString("Energie", "de"));
  quantityKind.addLabel(new LangString("energia , munka , hő", "hu"));
  quantityKind.addLabel(new LangString("אנרגיה ועבודה", "he"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Energy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EnergyContent",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "0173-1#Z4-BAJ319#002",
    undefined
  );
  quantityKind.addLabel(new LangString("energy content", undefined));
  quantityKind.addLabel(new LangString("energy content", "en-US"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EnergyContent",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EnergyDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Energy Density", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/ERG-PER-CentiM3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-M3");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EnergyDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EnergyDensityOfStates",
    "http://qudt.org/vocab/dimensionvector/A0E0L-5I0M-1H0T2D0",
    "n_E",
    undefined
  );
  quantityKind.addLabel(new LangString("Energy Density of States", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-EV-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-J-M3");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EnergyDensityOfStates",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EnergyExpenditure",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Energy Expenditure", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EnergyExpenditure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EnergyFluence",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Energy Fluence", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LANGLEY");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EnergyFluence",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EnergyFluenceRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    "Ψ",
    undefined
  );
  quantityKind.addLabel(new LangString("Energy Fluence Rate", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-IN2-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoW-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroW-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-CentiM2-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC-FT2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/ERG-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-CentiM2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-HR-FT2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliW-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-IN2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoW-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PA-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-FT2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PowerPerArea"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EnergyFluenceRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EnergyImparted",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "ε",
    undefined
  );
  quantityKind.addLabel(new LangString("Energy Imparted", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EnergyImparted",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EnergyInternal",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "U",
    undefined
  );
  quantityKind.addLabel(new LangString("energia interna", "it"));
  quantityKind.addLabel(new LangString("vnitřní energie", "cs"));
  quantityKind.addLabel(new LangString("Tenaga dalaman", "ms"));
  quantityKind.addLabel(new LangString("İç enerji", "tr"));
  quantityKind.addLabel(new LangString("internal energy", "en"));
  quantityKind.addLabel(new LangString("आन्तरिक ऊर्जा", "hi"));
  quantityKind.addLabel(new LangString("Notranja energija", "sl"));
  quantityKind.addLabel(new LangString("طاقة داخلية", "ar"));
  quantityKind.addLabel(new LangString("انرژی درونی", "fa"));
  quantityKind.addLabel(new LangString("内能", "zh"));
  quantityKind.addLabel(new LangString("energia wewnętrzna", "pl"));
  quantityKind.addLabel(new LangString("内部エネルギー", "ja"));
  quantityKind.addLabel(new LangString("energía interna", "es"));
  quantityKind.addLabel(new LangString("innere Energie", "de"));
  quantityKind.addLabel(new LangString("внутренняя энергия", "ru"));
  quantityKind.addLabel(new LangString("energia interna", "pt"));
  quantityKind.addLabel(new LangString("énergie interne", "fr"));
  quantityKind.addLabel(new LangString("energie internă", "ro"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/ThermodynamicEnergy"
  );
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/InternalEnergy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EnergyInternal",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EnergyKinetic",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Tenaga kinetik", "ms"));
  quantityKind.addLabel(new LangString("انرژی جنبشی", "fa"));
  quantityKind.addLabel(new LangString("طاقة حركية", "ar"));
  quantityKind.addLabel(new LangString("energia cinética", "pt"));
  quantityKind.addLabel(new LangString("kinetic energy", "en"));
  quantityKind.addLabel(new LangString("energia kinetyczna", "pl"));
  quantityKind.addLabel(new LangString("kinetická energie", "cs"));
  quantityKind.addLabel(new LangString("Energie cinetică", "ro"));
  quantityKind.addLabel(new LangString("गतिज ऊर्जा", "hi"));
  quantityKind.addLabel(new LangString("énergie cinétique", "fr"));
  quantityKind.addLabel(new LangString("кинетическая энергия", "ru"));
  quantityKind.addLabel(new LangString("kinetische Energie", "de"));
  quantityKind.addLabel(new LangString("energía cinética", "es"));
  quantityKind.addLabel(new LangString("運動エネルギー", "ja"));
  quantityKind.addLabel(new LangString("Kinetik enerji", "tr"));
  quantityKind.addLabel(new LangString("energia cinetica", "it"));
  quantityKind.addLabel(new LangString("动能", "zh"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EnergyKinetic",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EnergyLevel",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "E",
    undefined
  );
  quantityKind.addLabel(new LangString("Energy Level", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EnergyLevel",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EnergyPerArea",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Energy per Area", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-FT2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloBTU_IT-PER-FT2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GigaN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LANGLEY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-M-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/ERG-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloW-HR-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-CentiM2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EnergyPerArea",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EnergyPerAreaElectricCharge",
    "http://qudt.org/vocab/dimensionvector/A0E-1L0I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Energy Per Area Electric Charge", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-PER-M2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EnergyPerAreaElectricCharge",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EnergyPerElectricCharge",
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-3D0",
    "V",
    undefined
  );
  quantityKind.addLabel(new LangString("Energy per electric charge", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V_Stat");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V_Ab");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckVolt");
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotential"
  );
  quantityKind.addExactMatchIri("http://qudt.org/vocab/quantitykind/Voltage");
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotentialDifference"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EnergyPerElectricCharge",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EnergyPerMagneticFluxDensity_Squared",
    "http://qudt.org/vocab/dimensionvector/A0E2L2I0M-1H0T2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Energy Per Square Magnetic Flux Density", "en")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EnergyPerMagneticFluxDensity_Squared",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EnergyPerMassAmountOfSubstance",
    "http://qudt.org/vocab/dimensionvector/A-1E0L2I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Energy and work per mass amount of substance", "en")
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-MOL_LB"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EnergyPerMassAmountOfSubstance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EnergyPerSquareMagneticFluxDensity",
    "http://qudt.org/vocab/dimensionvector/A0E2L2I0M-1H0T2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Energy Per Square Magnetic Flux Density", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-T2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EnergyPerSquareMagneticFluxDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EnergyPerTemperature",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H-1T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Energy per temperature", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ-PER-K");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EnergyPerTemperature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Energy_Squared",
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M2H0T-4D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Square Energy", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Energy_Squared",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Enthalpy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "H",
    undefined
  );
  quantityKind.addLabel(new LangString("Entalpi", "ms"));
  quantityKind.addLabel(new LangString("entalpía", "es"));
  quantityKind.addLabel(new LangString("энтальпия", "ru"));
  quantityKind.addLabel(new LangString("Entalpi", "tr"));
  quantityKind.addLabel(new LangString("entalpia", "pl"));
  quantityKind.addLabel(new LangString("enthalpy", "en"));
  quantityKind.addLabel(new LangString("محتوى حراري", "ar"));
  quantityKind.addLabel(new LangString("Enthalpie", "de"));
  quantityKind.addLabel(new LangString("焓", "zh"));
  quantityKind.addLabel(new LangString("entalpia", "pt"));
  quantityKind.addLabel(new LangString("enthalpie", "fr"));
  quantityKind.addLabel(new LangString("エンタルピー", "ja"));
  quantityKind.addLabel(new LangString("entalpija", "sl"));
  quantityKind.addLabel(new LangString("entalpia", "it"));
  quantityKind.addLabel(new LangString("آنتالپی", "fa"));
  quantityKind.addLabel(new LangString("Entalpie", "ro"));
  quantityKind.addLabel(new LangString("entalpie", "cs"));
  quantityKind.addLabel(new LangString("पूर्ण ऊष्मा", "hi"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Enthalpy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Entropy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H-1T-2D0",
    "S",
    undefined
  );
  quantityKind.addLabel(new LangString("entropie", "cs"));
  quantityKind.addLabel(new LangString("Entropie", "de"));
  quantityKind.addLabel(new LangString("entropia", "it"));
  quantityKind.addLabel(new LangString("entropie", "fr"));
  quantityKind.addLabel(new LangString("entropia", "pt"));
  quantityKind.addLabel(new LangString("entropy", "en"));
  quantityKind.addLabel(new LangString("एन्ट्रॉपी", "hi"));
  quantityKind.addLabel(new LangString("Entropi", "ms"));
  quantityKind.addLabel(new LangString("إنتروبيا", "ar"));
  quantityKind.addLabel(new LangString("آنتروپی", "fa"));
  quantityKind.addLabel(new LangString("entropi", "tr"));
  quantityKind.addLabel(new LangString("entropia", "pl"));
  quantityKind.addLabel(new LangString("熵", "zh"));
  quantityKind.addLabel(new LangString("entropija", "sl"));
  quantityKind.addLabel(new LangString("entropie", "ro"));
  quantityKind.addLabel(new LangString("Энтропия", "ru"));
  quantityKind.addLabel(new LangString("entropía", "es"));
  quantityKind.addLabel(new LangString("エントロピー", "ja"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-K");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Entropy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EquilibriumConstant",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Equilibrium Constant", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EquilibriumConstant",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EquilibriumConstantBasedOnConcentration",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    "0173-1#Z4-BAJ458#001",
    undefined
  );
  quantityKind.addLabel(
    new LangString("equilibrium constant based on concentration", "en-US")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EquilibriumConstantBasedOnConcentration",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EquilibriumConstantBasedOnPressure",
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T0D0",
    "0173-1#Z4-BAJ459#001",
    undefined
  );
  quantityKind.addLabel(
    new LangString("equilibrium constant based on pressure", "en-US")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EquilibriumConstantBasedOnPressure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EquilibriumConstantOnConcentrationBasis",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Equilibrium Constant on Concentration Basis", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EquilibriumConstant"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EquilibriumConstantOnConcentrationBasis",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EquilibriumConstantOnPressureBasis",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Equilibrium Constant on Pressure Basis", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EquilibriumConstant"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EquilibriumConstantOnPressureBasis",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EquilibriumPositionVectorOfIon",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "R_0",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Equilibrium Position Vector of Ion", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EquilibriumPositionVectorOfIon",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EquivalenceDoseOutput",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    "0173-1#Z4-BAJ450#001",
    undefined
  );
  quantityKind.addLabel(new LangString("equivalence dose output", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EquivalenceDoseOutput",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EquivalentAbsorptionArea",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    "A",
    undefined
  );
  quantityKind.addLabel(new LangString("Equivalent absorption area", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckArea");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloMIL_Circ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIL_Circ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaARE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PIXEL_AREA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Area"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EquivalentAbsorptionArea",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EquivalentConcentration",
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Equivalent Concentration", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoMOL-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FemtoMOL-PER-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoMOL-PER-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoMOL-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MOL-PER-DeciM3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliMOL-PER-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloMOL-PER-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliMOL-PER-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiMOL-PER-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroMOL-PER-L"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Concentration"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EquivalentConcentration",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EquivalentDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Equivalent Density", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-CentiM3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-MicroL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-PER-GAL_IMP"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_LONG-PER-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_Metric-PER-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-IN3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG-PER-FT3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-DeciL");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GRAIN-PER-GAL_IMP"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-MilliL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-DeciL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEGREE_BAUME");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-IN3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-FT3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEGREE_BAUME_US_HEAVY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GRAIN-PER-GAL_US"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-DeciM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-DeciL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEGREE_BAUME_US_LIGHT"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_US-PER-YD3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-YD3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEGREE_BRIX");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-DeciM3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-CentiM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-GAL_US");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-DeciL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoGM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-GAL_UK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEGREE_TWADDELL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckDensity");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ-PER-GAL_IMP"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_UK-PER-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_SHORT-PER-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEGREE_BALLING"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-YD3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEGREE_PLATO");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-GAL_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-GAL_UK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEGREE_OECHSLE"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-M3");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Density"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EquivalentDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Equivalent_Mass",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Mass Equivalent", undefined));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PENNYWEIGHT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Equivalent_Mass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Equivalent_Molar",
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T0D0",
    "equiv",
    undefined
  );
  quantityKind.addLabel(new LangString("Molar Equivalent", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoMOL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OSM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiMOL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoMOL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliOSM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloMOL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SCF");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SCM_1ATM_15DEG_C_ISO"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NCM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SCM_1ATM_0DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliMOL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoMOL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SCM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroMOL");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NCM_1ATM_0DEG_C_NL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL_LB");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SCM_1ATM_15DEG_C_NL"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstance"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Equivalent_Molar",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EvaporativeHeatTransfer",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Evaporative Heat Transfer", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EvaporativeHeatTransfer",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EvaporativeHeatTransferCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    "h_e",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Combined Non Evaporative Heat Transfer Coefficient", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-M2-PA");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EvaporativeHeatTransferCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ExchangeIntegral",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "K",
    undefined
  );
  quantityKind.addLabel(new LangString("Exchange Integral", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ExchangeIntegral",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ExhaustGasMeanMolecularWeight",
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Exhaust Gas Mean Molecular Weight", "en")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ExhaustGasMeanMolecularWeight",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ExhaustGasesSpecificHeat",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H-1T-2D0",
    "c_p",
    undefined
  );
  quantityKind.addLabel(new LangString("Exhaust Gases Specific Heat", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-KiloGM-K"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-GM-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloJ-PER-KiloGM-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-GM-DEG_C"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-LB-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-GM-DEG_C"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB-DEG_R"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-GM-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-GM-DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-SEC2-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_IT-PER-GM-DEG_C"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-KiloGM-DEG_C"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_IT-PER-GM-K"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ExhaustGasesSpecificHeat",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ExhaustStreamPower",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Exhaust Stream Power", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaW");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TeraW-HR-PER-YR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroJ-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFERDESTAERKE");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliJ-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliBAR-L-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaPA-L-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP_Electric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_FG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PSI-IN3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA-L-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BAR-M3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR-L-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP_Boiler");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PSI-M3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckPower");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI-L-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloBTU_IT-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA-M3-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/HectoPA-M3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaBTU_IT-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP_Brake");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaPA-M3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliW");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/HectoPA-L-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-M-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PSI-YD3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliBAR-M3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Power"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ExhaustStreamPower",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ExitPlaneCrossSectionalArea",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    "A_{e}",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Exit Plane Cross-sectional Area", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckArea");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloMIL_Circ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIL_Circ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaARE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PIXEL_AREA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Area"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ExitPlaneCrossSectionalArea",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ExitPlanePressure",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    "p_{e}",
    undefined
  );
  quantityKind.addLabel(new LangString("Exit Plane Pressure", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-IN2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_32DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroTORR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_60DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARYE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA_A");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroATM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliTORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_60DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR_A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR_A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckPressure"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_H2O_4DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_HG_0DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HGA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Pressure"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ExitPlanePressure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ExitPlaneTemperature",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T0D0",
    "T_e",
    undefined
  );
  quantityKind.addLabel(new LangString("Exit Plane Temperature", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliDEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_R");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckTemperature"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_F");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Temperature"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ExitPlaneTemperature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ExpansionRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H-1T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Expansion Ratio", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-DEG_C-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM-PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-DEG_F");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-DEG_C-M"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MegaK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM-PER-K");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ExpansionRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Exposure",
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M-1H0T1D0",
    "X",
    undefined
  );
  quantityKind.addLabel(new LangString("Exposure", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-PER-KiloGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliC-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/R");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-T-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/A-M2-PER-J-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/A-HR-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaHZ-PER-T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HZ-PER-T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerMass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Exposure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ExposureOfIonizingRadiation",
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M-1H0T1D0",
    "0173-1#Z4-BAJ326#002",
    undefined
  );
  quantityKind.addLabel(
    new LangString("exposure of ionizing radiation", "en-US")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ExposureOfIonizingRadiation",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ExposureRate",
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M-1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Exposure Rate", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/C-PER-KiloGM-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/R-PER-SEC");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ExposureRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ExposureRateOfIonizingRadiation",
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M-1H0T0D0",
    "0173-1#Z4-BAJ327#002",
    undefined
  );
  quantityKind.addLabel(
    new LangString("exposure rate of ionizing radiation", "en-US")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ExposureRateOfIonizingRadiation",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ExtentOfReaction",
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Extent of Reaction", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoMOL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiMOL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoMOL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoMOL");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ExtentOfReaction",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/FLIGHT-PERFORMANCE-RESERVE-PROPELLANT-MASS",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Flight Performance Reserve Propellant Mass", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PENNYWEIGHT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/FLIGHT-PERFORMANCE-RESERVE-PROPELLANT-MASS",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/FUEL-BIAS",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Fuel Bias", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DECADE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FLIGHT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RPK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_MAG"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaBasePair");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BasePair");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/COUNT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HeartBeat");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OCT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_ELEC"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Dimensionless"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/FUEL-BIAS",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/FahrenheitTemperature",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T0D0",
    "0173-1#Z4-BAJ278#002",
    undefined
  );
  quantityKind.addLabel(new LangString("Fahrenheit temperature", undefined));
  quantityKind.addLabel(new LangString("Fahrenheit temperature", "en-US"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliDEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_R");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckTemperature"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_F");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Temperature"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/FahrenheitTemperature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/FailureRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    "0173-1#Z4-BAJ466#003",
    undefined
  );
  quantityKind.addLabel(new LangString("failure rate", undefined));
  quantityKind.addLabel(new LangString("failure rate", "en-US"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaHZ");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-WK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaHZ");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraHZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MilliSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MO");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-YR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SAMPLE-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliHZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-WK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckFrequency"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaHZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-MO"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloHZ");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-YR"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Incidence"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/FailureRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/FastFissionFactor",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Fast Fission Factor", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/FastFissionFactor",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/FermiAngularWavenumber",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    "k_F",
    undefined
  );
  quantityKind.addLabel(new LangString("Fermi Angular Wavenumber", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG-PER-M");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InverseLength"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/FermiAngularWavenumber",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/FermiEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "E_F",
    undefined
  );
  quantityKind.addLabel(new LangString("Fermi Energy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/FermiEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/FermiTemperature",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T0D0",
    "T_F",
    undefined
  );
  quantityKind.addLabel(new LangString("Fermi Temperature", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliDEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_R");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckTemperature"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_F");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Temperature"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/FermiTemperature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/FinalOrCurrentVehicleMass",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    "M",
    undefined
  );
  quantityKind.addLabel(new LangString("Final Or Current Vehicle Mass", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PENNYWEIGHT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/FinalOrCurrentVehicleMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/FirstMomentOfArea",
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("First Moment of Area", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/STANDARD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PK_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Register");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCubicFT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TSP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PINT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckVolume");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BBL_UK_PET");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TBSP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BBL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_VOL_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PINT_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FBM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/STR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AC-FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_SHIPPING_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_UK3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BU_US_DRY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_SHIPPING_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AC-FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_UK");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Volume"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/FirstMomentOfArea",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/FirstStageMassRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "R_1",
    undefined
  );
  quantityKind.addLabel(new LangString("First Stage Mass Ratio", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-MilliGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-MilliGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-GM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoGM-PER-MilliGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoGM-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FemtoGM-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-LB");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-GM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-HectoGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-KiloGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM-PER-GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-GM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/FirstStageMassRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/FishBiotransformationHalfLife",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Fish Biotransformation Half Life", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DAY");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Time"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/FishBiotransformationHalfLife",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/FissionCoreRadiusToHeightRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "R/H",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Fission Core Radius To Height Ratio", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ONE-PER-ONE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERMITTIVITY_REL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/FissionCoreRadiusToHeightRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/FissionFuelUtilizationFactor",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Fission Fuel Utilization Factor", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DECADE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FLIGHT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RPK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_MAG"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaBasePair");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BasePair");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/COUNT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HeartBeat");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OCT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_ELEC"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Dimensionless"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/FissionFuelUtilizationFactor",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/FissionMultiplicationFactor",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Fission Multiplication Factor", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DECADE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FLIGHT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RPK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_MAG"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaBasePair");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BasePair");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/COUNT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HeartBeat");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OCT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_ELEC"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Dimensionless"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/FissionMultiplicationFactor",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/FlashPoint",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Flash Point Temperature", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliDEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_R");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckTemperature"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_F");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Temperature"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/FlashPoint",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/FlightPathAngle",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Flight Path Angle", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARCSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARCMIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN_Angle");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliARCSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/REV");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Angle"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/FlightPathAngle",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/FloatingPointCalculationCapability",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("floating point calculation capability", undefined)
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaFLOPS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FLOPS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaFLOPS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaFLOPS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraFLOPS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/FloatingPointCalculationCapability",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Fluidity",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H0T1D0",
    "0173-1#Z4-BAJ447#001",
    undefined
  );
  quantityKind.addLabel(new LangString("fluidity", "en-US"));
  quantityKind.addLabel(new LangString("fluidity", undefined));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-IN2-PER-LB_F-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RHE");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-FT2-PER-LB_F-SEC"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Fluidity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Flux",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Flux", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-HA-YR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-L-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-M2-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-SEC-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-M2-DAY"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Flux",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Force",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    "F",
    undefined
  );
  quantityKind.addLabel(new LangString("force", "en"));
  quantityKind.addLabel(new LangString("vis", "la"));
  quantityKind.addLabel(new LangString("siła", "pl"));
  quantityKind.addLabel(new LangString("כוח", "he"));
  quantityKind.addLabel(
    new LangString("وحدة القوة في نظام متر كيلوغرام ثانية", "ar")
  );
  quantityKind.addLabel(new LangString("força", "pt"));
  quantityKind.addLabel(new LangString("erő", "hu"));
  quantityKind.addLabel(new LangString("نیرو", "fa"));
  quantityKind.addLabel(new LangString("sila", "sl"));
  quantityKind.addLabel(new LangString("fuerza", "es"));
  quantityKind.addLabel(new LangString("forță", "ro"));
  quantityKind.addLabel(new LangString("Daya", "ms"));
  quantityKind.addLabel(new LangString("Δύναμη", "el"));
  quantityKind.addLabel(new LangString("kuvvet", "tr"));
  quantityKind.addLabel(new LangString("Сила", "ru"));
  quantityKind.addLabel(new LangString("Kraft", "de"));
  quantityKind.addLabel(new LangString("сила", "bg"));
  quantityKind.addLabel(new LangString("力", "ja"));
  quantityKind.addLabel(new LangString("forza", "it"));
  quantityKind.addLabel(new LangString("force", "fr"));
  quantityKind.addLabel(new LangString("Síla", "cs"));
  quantityKind.addLabel(new LangString("力", "zh"));
  quantityKind.addLabel(new LangString("बल", "hi"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_F_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPOND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-M-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DYN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckForce");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Force",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ForceConstant",
    "http://qudt.org/vocab/dimensionvector/A0E-1L1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("force constant", undefined));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ForceConstant",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ForceMagnitude",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    "U",
    undefined
  );
  quantityKind.addLabel(new LangString("Force Magnitude", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_F_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPOND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-M-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DYN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckForce");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Force"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ForceMagnitude",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ForcePerAngle",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Force per Angle", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-RAD");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ForcePerAngle",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ForcePerArea",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    "p",
    undefined
  );
  quantityKind.addLabel(new LangString("Force Per Area", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-IN2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_32DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroTORR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_60DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARYE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA_A");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroATM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliTORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_60DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR_A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR_A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckPressure"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_H2O_4DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_HG_0DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HGA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ForcePerArea",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ForcePerAreaTime",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Force Per Area Time", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciBAR-PER-YR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB_F-PER-IN2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliW-PER-M2-NanoM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/HectoPA-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA-PER-SEC");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ForcePerAreaTime",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ForcePerElectricCharge",
    "http://qudt.org/vocab/dimensionvector/A0E-1L1I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Force per Electric Charge", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-C");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ForcePerElectricCharge",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ForcePerLength",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Force per Length", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-FT"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-PER-CentiM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-IN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-PER-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-M-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GigaN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-CentiM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-M-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliN-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-MilliM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ForcePerLength",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Frequency",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("תדירות", "he"));
  quantityKind.addLabel(new LangString("frecvență", "ro"));
  quantityKind.addLabel(new LangString("周波数", "ja"));
  quantityKind.addLabel(new LangString("frequenza", "it"));
  quantityKind.addLabel(new LangString("frekans", "tr"));
  quantityKind.addLabel(new LangString("التردد لدى نظام الوحدات الدولي", "ar"));
  quantityKind.addLabel(new LangString("frekvenca", "sl"));
  quantityKind.addLabel(new LangString("بسامد", "fa"));
  quantityKind.addLabel(new LangString("frekvencia", "hu"));
  quantityKind.addLabel(new LangString("Частота", "ru"));
  quantityKind.addLabel(new LangString("Συχνότητα", "el"));
  quantityKind.addLabel(new LangString("Frequenz", "de"));
  quantityKind.addLabel(new LangString("częstotliwość", "pl"));
  quantityKind.addLabel(new LangString("Frekuensi", "ms"));
  quantityKind.addLabel(new LangString("Честота", "bg"));
  quantityKind.addLabel(new LangString("आवृत्ति", "hi"));
  quantityKind.addLabel(new LangString("frequency", "en"));
  quantityKind.addLabel(new LangString("频率", "zh"));
  quantityKind.addLabel(new LangString("frequência", "pt"));
  quantityKind.addLabel(new LangString("fréquence", "fr"));
  quantityKind.addLabel(new LangString("Frekvence", "cs"));
  quantityKind.addLabel(new LangString("frecuencia", "es"));
  quantityKind.addLabel(new LangString("frequentia", "la"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaHZ");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-WK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaHZ");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraHZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MilliSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MO");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-YR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SAMPLE-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliHZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-WK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckFrequency"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaHZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-MO"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloHZ");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-YR"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InverseTime"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Frequency",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Friction",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Friction", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_F_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPOND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-M-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DYN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckForce");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Force"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Friction",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/FrictionCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Friction Coefficient", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/FrictionCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Fugacity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("fugacitate", "ro"));
  quantityKind.addLabel(new LangString("بی‌دوامی", "fa"));
  quantityKind.addLabel(new LangString("逸度", "zh"));
  quantityKind.addLabel(new LangString("fugacità", "it"));
  quantityKind.addLabel(new LangString("fugacity", "en"));
  quantityKind.addLabel(new LangString("fugacita", "cs"));
  quantityKind.addLabel(new LangString("fugacidad", "es"));
  quantityKind.addLabel(new LangString("fügasite", "tr"));
  quantityKind.addLabel(new LangString("fugacité", "fr"));
  quantityKind.addLabel(new LangString("Fugazität", "de"));
  quantityKind.addLabel(new LangString("fugacidade", "pt"));
  quantityKind.addLabel(new LangString("フガシティー", "ja"));
  quantityKind.addLabel(new LangString("انفلاتية", "ar"));
  quantityKind.addLabel(new LangString("Lotność", "pl"));
  quantityKind.addLabel(new LangString("Fugasiti", "ms"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoPA");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Fugacity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/FundamentalLatticeVector",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "a_1, a_2, a_3",
    undefined
  );
  quantityKind.addLabel(new LangString("Fundamental Lattice vector", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LatticeVector"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/FundamentalLatticeVector",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/FundamentalReciprocalLatticeVector",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    "b_1, b_2, b_3",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Fundamental Reciprocal Lattice Vector", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-NanoM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AngularReciprocalLatticeVector"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/FundamentalReciprocalLatticeVector",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/GFactorOfNucleus",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "g",
    undefined
  );
  quantityKind.addLabel(new LangString("g-Factor of Nucleus", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/GFactorOfNucleus",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/GROSS-LIFT-OFF-WEIGHT",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Gross Lift-Off Weight", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PENNYWEIGHT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/GROSS-LIFT-OFF-WEIGHT",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Gain",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Gain", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ONE-PER-ONE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERMITTIVITY_REL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Gain",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/GapEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "E_g",
    undefined
  );
  quantityKind.addLabel(new LangString("Gap Energy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/GapEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/GasLeakRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    "0173-1#Z4-BAJ324#002",
    undefined
  );
  quantityKind.addLabel(new LangString("gas leak rate", "en-US"));
  quantityKind.addLabel(new LangString("gas leak rate", undefined));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/GasLeakRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/GaugePressure",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Gauge Pressure", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-IN2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_32DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroTORR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_60DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARYE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA_A");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroATM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliTORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_60DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR_A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR_A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckPressure"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_H2O_4DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_HG_0DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HGA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Pressure"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/GaugePressure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/GeneFamilyAbundance",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Gene Family Abundance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RPK");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/GeneFamilyAbundance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/GeneralizedCoordinate",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "q_i",
    undefined
  );
  quantityKind.addLabel(new LangString("Generalized Coordinate", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/GeneralizedCoordinate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/GeneralizedForce",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "Q_i",
    undefined
  );
  quantityKind.addLabel(new LangString("Generalized Force", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/GeneralizedForce",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/GeneralizedMomentum",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "p_i",
    undefined
  );
  quantityKind.addLabel(new LangString("Generalized Force", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/GeneralizedMomentum",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/GeneralizedVelocity",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Generalized Velocity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/GeneralizedVelocity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/GibbsEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "G",
    undefined
  );
  quantityKind.addLabel(new LangString("energia libera di Gibbs", "it"));
  quantityKind.addLabel(new LangString("Prosta entalpija", "sl"));
  quantityKind.addLabel(new LangString("Gibbs energy", "en"));
  quantityKind.addLabel(new LangString("Gibbsova volná energie", "cs"));
  quantityKind.addLabel(new LangString("طاقة غيبس الحرة", "ar"));
  quantityKind.addLabel(new LangString("ギブズエネルギー", "ja"));
  quantityKind.addLabel(new LangString("freie Enthalpie", "de"));
  quantityKind.addLabel(new LangString("Energía de Gibbs", "es"));
  quantityKind.addLabel(new LangString("Entalpie liberă", "ro"));
  quantityKind.addLabel(new LangString("Gibbs Serbest Enerjisi", "tr"));
  quantityKind.addLabel(new LangString("انرژی آزاد گیبس", "fa"));
  quantityKind.addLabel(new LangString("энергия Гиббса", "ru"));
  quantityKind.addLabel(new LangString("entalpia swobodna", "pl"));
  quantityKind.addLabel(new LangString("Tenaga Gibbs", "ms"));
  quantityKind.addLabel(new LangString("enthalpie libre", "fr"));
  quantityKind.addLabel(new LangString("吉布斯自由能", "zh"));
  quantityKind.addLabel(new LangString("energia livre de Gibbs", "pt"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/GibbsEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Gradient",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("gradient", undefined));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM-PER-M");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Gradient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/GrandCanonicalPartitionFunction",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Grand Canonical Partition Function", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CanonicalPartitionFunction"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/GrandCanonicalPartitionFunction",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/GravitationalAttraction",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    "G",
    undefined
  );
  quantityKind.addLabel(new LangString("Gravitational Attraction", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_F_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPOND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-M-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DYN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckForce");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Force"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/GravitationalAttraction",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Gravity_API",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("API Gravity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ONE-PER-ONE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERMITTIVITY_REL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Gravity_API",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/GroupSpeedOfSound",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    "c",
    undefined
  );
  quantityKind.addLabel(new LangString("Group Speed of Sound", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloHZ-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaHZ-M");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpeedOfSound"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/GroupSpeedOfSound",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/GrowingDegreeDay",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Growing Degree Days (Cereals)", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEG_C_GROWING_CEREAL-DAY"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TimeTemperature"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/GrowingDegreeDay",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/GrowingDegreeDay_Cereal",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Growing Degree Days (Cereals)", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_F-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C-WK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_F-DAY");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TimeTemperature"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/GrowingDegreeDay_Cereal",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/GruneisenParameter",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Gruneisen Parameter", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/GruneisenParameter",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/GustatoryThreshold",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Gustatory Threshold", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/GustatoryThreshold",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/GyromagneticRatio",
    "http://qudt.org/vocab/dimensionvector/A0E1L2I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Gyromagnetic Ratio", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/GyromagneticRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Half-Life",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    "T_{1/2}",
    undefined
  );
  quantityKind.addLabel(new LangString("semiperiodo", "es"));
  quantityKind.addLabel(new LangString("نیمه عمر", "fa"));
  quantityKind.addLabel(new LangString("Halbwertszeit", "de"));
  quantityKind.addLabel(new LangString("Separuh hayat", "ms"));
  quantityKind.addLabel(new LangString("Poločas rozpadu", "cs"));
  quantityKind.addLabel(new LangString("tempo di dimezzamento", "it"));
  quantityKind.addLabel(new LangString("temps de demi-vie", "fr"));
  quantityKind.addLabel(new LangString("yarılanma süresi", "tr"));
  quantityKind.addLabel(new LangString("meia-vida", "pt"));
  quantityKind.addLabel(new LangString("half-life", "en"));
  quantityKind.addLabel(new LangString("半衰期", "zh"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliH-PER-KiloOHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/WK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckTime");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Common");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MO_MeanGREGORIAN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HR_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoSEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroH-PER-KiloOHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H-PER-OHM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroH-PER-OHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DAY_Sidereal");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliPA-SEC-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO_Synodic");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POISE-PER-BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiPOISE-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POISE-PER-PA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliH-PER-OHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_TROPICAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H-PER-KiloOHM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Metrology");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PA-SEC-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloYR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaYR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO_MeanJulian");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Time"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Half-Life",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Half-ValueThickness",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "d_{1/2}",
    undefined
  );
  quantityKind.addLabel(new LangString("Half-Value Thickness", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Half-ValueThickness",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/HallCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E-1L3I0M0H0T-1D0",
    "R_H, A_H",
    undefined
  );
  quantityKind.addLabel(new LangString("Hall Coefficient", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-PER-BAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-PER-PA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/V-IN2-PER-LB_F"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/HallCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/HamiltonFunction",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "H",
    undefined
  );
  quantityKind.addLabel(new LangString("Hamilton Function", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/HamiltonFunction",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/HeadEndPressure",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Head End Pressure", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-IN2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_32DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroTORR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_60DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARYE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA_A");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroATM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliTORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_60DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR_A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR_A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckPressure"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_H2O_4DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_HG_0DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HGA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Pressure"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/HeadEndPressure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/HeartRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Heart Rate", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BEAT-PER-MIN");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/HeartRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Heat",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "Q",
    undefined
  );
  quantityKind.addLabel(new LangString("ciepło", "pl"));
  quantityKind.addLabel(new LangString("jednotka tepla", "cs"));
  quantityKind.addLabel(new LangString("quantidade de calor", "pt"));
  quantityKind.addLabel(new LangString("熱量", "ja"));
  quantityKind.addLabel(new LangString("calor", "es"));
  quantityKind.addLabel(new LangString("cantitate de căldură", "ro"));
  quantityKind.addLabel(new LangString("quantité de chaleur", "fr"));
  quantityKind.addLabel(new LangString("calore", "it"));
  quantityKind.addLabel(new LangString("kuantiti haba Haba", "ms"));
  quantityKind.addLabel(new LangString("ısı miktarı", "tr"));
  quantityKind.addLabel(new LangString("heat", "en"));
  quantityKind.addLabel(new LangString("ऊष्मा", "hi"));
  quantityKind.addLabel(new LangString("热量", "zh"));
  quantityKind.addLabel(new LangString("Теплота", "ru"));
  quantityKind.addLabel(new LangString("toplota", "sl"));
  quantityKind.addLabel(new LangString("کمیت گرما", "fa"));
  quantityKind.addLabel(new LangString("حرارة", "ar"));
  quantityKind.addLabel(new LangString("labor", "la"));
  quantityKind.addLabel(new LangString("Wärme", "de"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_15DEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_20DEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_MEAN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL_Mean");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_MEAN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_39DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_59DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_FG-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_60DEG_F");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalEnergy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Heat",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/HeatCapacity",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H-1T-2D0",
    "C_P",
    undefined
  );
  quantityKind.addLabel(new LangString("ऊष्मा धारिता", "hi"));
  quantityKind.addLabel(new LangString("pojemność cieplna", "pl"));
  quantityKind.addLabel(new LangString("capacidade térmica", "pt"));
  quantityKind.addLabel(new LangString("toplotna kapaciteta", "sl"));
  quantityKind.addLabel(new LangString("熱容量", "ja"));
  quantityKind.addLabel(new LangString("isı kapasitesi", "tr"));
  quantityKind.addLabel(new LangString("Wärmekapazität", "de"));
  quantityKind.addLabel(new LangString("ظرفیت گرمایی", "fa"));
  quantityKind.addLabel(new LangString("capacitate termică", "ro"));
  quantityKind.addLabel(new LangString("热容", "zh"));
  quantityKind.addLabel(new LangString("tepelná kapacita", "cs"));
  quantityKind.addLabel(new LangString("muatan haba", "ms"));
  quantityKind.addLabel(new LangString("heat capacity", "en"));
  quantityKind.addLabel(new LangString("سعة حرارية", "ar"));
  quantityKind.addLabel(new LangString("capacité thermique", "fr"));
  quantityKind.addLabel(new LangString("теплоёмкость", "ru"));
  quantityKind.addLabel(new LangString("capacidad calorífica", "es"));
  quantityKind.addLabel(new LangString("capacità termica", "it"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-DEG_R"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ-PER-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV-PER-K");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EnergyPerTemperature"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/HeatCapacity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/HeatCapacityRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Heat Capacity Ratio", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ONE-PER-ONE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERMITTIVITY_REL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/HeatCapacityRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/HeatFlowRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Heat Flow Rate", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaBTU_IT-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL_TH-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL_TH-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL_TH-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloBTU_TH-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_FG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloBTU_IT-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH-PER-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Power"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/HeatFlowRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/HeatFlowRatePerArea",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Heat Flow Rate per Unit Area", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-IN2-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoW-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroW-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-CentiM2-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC-FT2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/ERG-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-CentiM2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-HR-FT2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliW-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-IN2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoW-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PA-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-FT2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PowerPerArea"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/HeatFlowRatePerArea",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/HeatFluxDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Heat Flux Density", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-IN2-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoW-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroW-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-CentiM2-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC-FT2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/ERG-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-CentiM2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-HR-FT2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliW-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-IN2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoW-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PA-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-FT2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PowerPerArea"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/HeatFluxDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/HeatingValue",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Calorific Value", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-KiloGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/W-HR-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-FT-PER-LB"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT-PER-LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaJ-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH-PER-LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloJ-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/N-M-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-GM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-GM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificEnergy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/HeatingValue",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Height",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "h",
    undefined
  );
  quantityKind.addLabel(new LangString("Înălțime", "ro"));
  quantityKind.addLabel(new LangString("altezza", "it"));
  quantityKind.addLabel(new LangString("altura", "pt"));
  quantityKind.addLabel(new LangString("yükseklik", "tr"));
  quantityKind.addLabel(new LangString("Výška", "cs"));
  quantityKind.addLabel(new LangString("高度", "zh"));
  quantityKind.addLabel(new LangString("высота", "ru"));
  quantityKind.addLabel(new LangString("hauteur", "fr"));
  quantityKind.addLabel(new LangString("Ketinggian", "ms"));
  quantityKind.addLabel(new LangString("altura", "es"));
  quantityKind.addLabel(new LangString("height", "en"));
  quantityKind.addLabel(new LangString("ارتفاع", "fa"));
  quantityKind.addLabel(new LangString("Höhe", "de"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Height",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/HelmholtzEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "A",
    undefined
  );
  quantityKind.addLabel(new LangString("energia livre de Helmholtz", "pt"));
  quantityKind.addLabel(new LangString("Helmholtz enerjisi", "tr"));
  quantityKind.addLabel(new LangString("Energía de Helmholtz", "es"));
  quantityKind.addLabel(new LangString("ヘルムホルツの自由エネルギー", "ja"));
  quantityKind.addLabel(new LangString("Helmholtz energy", "en"));
  quantityKind.addLabel(new LangString("Helmholtzova volná energie", "cs"));
  quantityKind.addLabel(new LangString("طاقة هلمهولتز الحرة", "ar"));
  quantityKind.addLabel(new LangString("انرژی آزاد هلمولتز", "fa"));
  quantityKind.addLabel(new LangString("Tenaga Helmholtz", "ms"));
  quantityKind.addLabel(new LangString("énergie libre", "fr"));
  quantityKind.addLabel(new LangString("freie Energie", "de"));
  quantityKind.addLabel(new LangString("energia libera di Helmholz", "it"));
  quantityKind.addLabel(new LangString("energia swobodna", "pl"));
  quantityKind.addLabel(new LangString("亥姆霍兹自由能", "zh"));
  quantityKind.addLabel(new LangString("свободная энергия Гельмгольца", "ru"));
  quantityKind.addLabel(new LangString("Prosta energija", "sl"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/HelmholtzEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/HenrysLawVolatilityConstant",
    "http://qudt.org/vocab/dimensionvector/A-1E0L2I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Henry's Law Volatility Constant", "en")
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/ATM-M3-PER-MOL"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/HenrysLawVolatilityConstant",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/HoleDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    "p",
    undefined
  );
  quantityKind.addLabel(new LangString("Hole Density", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-MicroL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-NanoL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-MilliM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-PicoL");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/NumberDensity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/HoleDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/HorizontalVelocity",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    "V_{X}",
    undefined
  );
  quantityKind.addLabel(new LangString("Horizontal Velocity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaHZ-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-KiloYR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM-PER-YR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Velocity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/HorizontalVelocity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/HydraulicPermeability",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Hydraulic Permeability", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIL_Circ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DARCY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliDARCY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/HydraulicPermeability",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/HyperfineStructureQuantumNumber",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "F",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Hyperfine Structure Quantum Number", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/QuantumNumber"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/HyperfineStructureQuantumNumber",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/INERT-MASS",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Inert Mass", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PENNYWEIGHT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/INERT-MASS",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/IgnitionIntervalTime",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Ignition interval time", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliH-PER-KiloOHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/WK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckTime");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Common");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MO_MeanGREGORIAN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HR_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoSEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroH-PER-KiloOHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H-PER-OHM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroH-PER-OHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DAY_Sidereal");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliPA-SEC-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO_Synodic");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POISE-PER-BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiPOISE-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POISE-PER-PA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliH-PER-OHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_TROPICAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H-PER-KiloOHM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Metrology");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PA-SEC-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloYR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaYR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO_MeanJulian");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Time"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/IgnitionIntervalTime",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Illuminance",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I1M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("osvetljenost", "sl"));
  quantityKind.addLabel(new LangString("natężenie oświetlenia", "pl"));
  quantityKind.addLabel(new LangString("Beleuchtungsstärke", "de"));
  quantityKind.addLabel(new LangString("شدت روشنایی", "fa"));
  quantityKind.addLabel(new LangString("照度", "zh"));
  quantityKind.addLabel(new LangString("Осветеност", "bg"));
  quantityKind.addLabel(new LangString("megvilágítás", "hu"));
  quantityKind.addLabel(new LangString("شدة الضوء", "ar"));
  quantityKind.addLabel(new LangString("הארה (שטף ליחידת שטח)", "he"));
  quantityKind.addLabel(new LangString("照度", "ja"));
  quantityKind.addLabel(new LangString("luminosidad", "es"));
  quantityKind.addLabel(new LangString("Intenzita osvětlení", "cs"));
  quantityKind.addLabel(new LangString("aydınlanma şiddeti", "tr"));
  quantityKind.addLabel(new LangString("Pencahayaan", "ms"));
  quantityKind.addLabel(new LangString("Освещённость", "ru"));
  quantityKind.addLabel(new LangString("iluminamento", "pt"));
  quantityKind.addLabel(new LangString("illuminamento", "it"));
  quantityKind.addLabel(new LangString("éclairement lumineux", "fr"));
  quantityKind.addLabel(new LangString("illuminance", "en"));
  quantityKind.addLabel(new LangString("iluminare", "ro"));
  quantityKind.addLabel(new LangString("प्रदीपन", "hi"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PHOT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LUX");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LuminousFluxPerArea"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Illuminance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Impedance",
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Impedance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OHM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Impedance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Impulse",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-1D0",
    "0173-1#Z4-BAJ241#002",
    undefined
  );
  quantityKind.addLabel(new LangString("impulse", "en-US"));
  quantityKind.addLabel(new LangString("impulse", undefined));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-FT-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-CentiM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-CentiM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-IN-PER-SEC");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Impulse",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Incidence",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Incidence", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaHZ");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-WK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaHZ");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraHZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MilliSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MO");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-YR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SAMPLE-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliHZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-WK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckFrequency"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaHZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-MO"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloHZ");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-YR"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Frequency"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Incidence",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/IncidenceProportion",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Incidence Proportion", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaHZ");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-WK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaHZ");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraHZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MilliSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MO");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-YR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SAMPLE-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliHZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-WK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckFrequency"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaHZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-MO"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloHZ");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-YR"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Incidence"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/IncidenceProportion",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/IncidenceRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Incidence Rate", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaHZ");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-WK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaHZ");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraHZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MilliSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MO");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-YR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SAMPLE-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliHZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-WK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckFrequency"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaHZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-MO"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloHZ");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-YR"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Incidence"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/IncidenceRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Inductance",
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H0T-2D0",
    "L",
    undefined
  );
  quantityKind.addLabel(new LangString("induktivitás", "hu"));
  quantityKind.addLabel(new LangString("indutância", "pt"));
  quantityKind.addLabel(new LangString("Indukstans", "ms"));
  quantityKind.addLabel(new LangString("المحاثة (التحريض)", "ar"));
  quantityKind.addLabel(new LangString("induktivnost", "sl"));
  quantityKind.addLabel(new LangString("القاوری", "fa"));
  quantityKind.addLabel(new LangString("İndüktans", "tr"));
  quantityKind.addLabel(new LangString("电感", "zh"));
  quantityKind.addLabel(new LangString("Индуктивность", "ru"));
  quantityKind.addLabel(new LangString("インダクタンス・誘導係数", "ja"));
  quantityKind.addLabel(new LangString("inductancia", "es"));
  quantityKind.addLabel(new LangString("inductanță", "ro"));
  quantityKind.addLabel(new LangString("indukcyjność", "pl"));
  quantityKind.addLabel(new LangString("inductance", "en"));
  quantityKind.addLabel(new LangString("induttanza", "it"));
  quantityKind.addLabel(new LangString("Индуктивност", "bg"));
  quantityKind.addLabel(new LangString("inductantia", "la"));
  quantityKind.addLabel(new LangString("Inductance électrique", "fr"));
  quantityKind.addLabel(new LangString("השראות", "he"));
  quantityKind.addLabel(new LangString("Indukčnost", "cs"));
  quantityKind.addLabel(new LangString("प्रेरकत्व", "hi"));
  quantityKind.addLabel(new LangString("Induktivität", "de"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H_Ab");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H_Stat");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Inductance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InductanceBasedTimeConstant",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Inductance based time constant", undefined)
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InductanceBasedTimeConstant",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InfiniteMultiplicationFactor",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Infinite Multiplication Factor", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MultiplicationFactor"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InfiniteMultiplicationFactor",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InformationContent",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("information content", undefined));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InformationContent",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InformationContentExpressedAsALogarithmToBase10",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "0173-1#Z4-BAJ468#001",
    undefined
  );
  quantityKind.addLabel(
    new LangString(
      "information content expressed as a logarithm to base 10",
      "en-US"
    )
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InformationContentExpressedAsALogarithmToBase10",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InformationContentExpressedAsALogarithmToBase2",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "0173-1#Z4-BAJ463#001",
    undefined
  );
  quantityKind.addLabel(
    new LangString(
      "information content expressed as a logarithm to base 2",
      "en-US"
    )
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InformationContentExpressedAsALogarithmToBase2",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InformationContentExpressedAsALogarithmToBaseE",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "0173-1#Z4-BAJ469#001",
    undefined
  );
  quantityKind.addLabel(
    new LangString(
      "information content expressed as a logarithm to base e",
      "en-US"
    )
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InformationContentExpressedAsALogarithmToBaseE",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InformationEntropy",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Information Entropy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BYTE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExbiBIT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MebiBYTE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERLANG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBYTE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BIT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PebiBIT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TebiBIT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HART");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PebiBYTE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaBYTE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GibiBYTE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KibiBYTE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExbiBYTE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBYTE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaBIT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SHANNON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TebiBYTE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaBYTE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaBYTE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraBYTE");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Dimensionless"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InformationEntropy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InformationFlowRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Information flow rate", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NAT-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HART-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SHANNON-PER-SEC"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InformationFlowRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InitialExpansionRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H-1T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Initial Expansion Ratio", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-DEG_C-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM-PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-DEG_F");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-DEG_C-M"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MegaK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM-PER-K");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ExpansionRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InitialExpansionRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InitialNozzleThroatDiameter",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Initial Nozzle Throat Diameter", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/NozzleThroatDiameter"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InitialNozzleThroatDiameter",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InitialVehicleMass",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    "M_{o}",
    undefined
  );
  quantityKind.addLabel(new LangString("Initial Vehicle Mass", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PENNYWEIGHT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InitialVehicleMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InitialVelocity",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    "V_{i}",
    undefined
  );
  quantityKind.addLabel(new LangString("Initial Velocity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaHZ-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-KiloYR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM-PER-YR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Velocity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InitialVelocity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InstantaneousPower",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    "p",
    undefined
  );
  quantityKind.addLabel(new LangString("Instantaneous Power", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliW");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPower"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InstantaneousPower",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InternalConversionFactor",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "a",
    undefined
  );
  quantityKind.addLabel(new LangString("InternalConversionFactor", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InternalConversionFactor",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InternalEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "U",
    undefined
  );
  quantityKind.addLabel(new LangString("Internal Energy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/ThermodynamicEnergy"
  );
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/EnergyInternal"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InternalEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/IntinsicCarrierDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    "n_i",
    undefined
  );
  quantityKind.addLabel(new LangString("Intinsic Carrier Density", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-MicroL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-NanoL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-MilliM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-PicoL");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/NumberDensity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/IntinsicCarrierDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InverseAmountOfSubstance",
    "http://qudt.org/vocab/dimensionvector/A-1E0L0I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Inverse amount of substance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MOL");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InverseAmountOfSubstance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InverseEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M-1H0T2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Inverse Energy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-VA-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-KiloVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-J");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InverseEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InverseEnergy_Squared",
    "http://qudt.org/vocab/dimensionvector/A0E0L-4I0M-2H0T4D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Inverse Square Energy", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InverseEnergy_Squared",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InverseLength",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Inverse Length", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-HA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MESH");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InverseLength",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InverseLengthTemperature",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H-1T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Inverse Length Temperature", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-M-K");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InverseLengthTemperature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InverseMagneticFlux",
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M-1H0T2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Inverse Magnetic Flux", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-WB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HZ-PER-V");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InverseMagneticFlux",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InverseMass",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("reciprocal mass", undefined));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MilliGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-KiloGM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InverseMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InverseMass_Squared",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-2H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Inverse Square Mass", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InverseMass_Squared",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InversePermittivity",
    "http://qudt.org/vocab/dimensionvector/A0E-2L3I0M1H0T-4D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Inverse Permittivity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-FARAD");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InversePermittivity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InversePressure",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H0T2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Inverse Pressure", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-BAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MILLE-PSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MegaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-PSI");
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/IsothermalCompressibility"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InversePressure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InverseSquareEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L-4I0M-2H0T4D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Inverse Square Energy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-EV2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-J2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-GigaEV2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InverseSquareEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InverseSquareMass",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-2H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Inverse Square Mass", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PER-PlanckMass2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-KiloGM2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InverseSquareMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InverseSquareTime",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Inverse Square Time", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-SEC2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InverseSquareTime",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InverseTemperature",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H-1T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Inverse Temperature", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MegaK");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InverseTemperature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InverseTime",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Inverse Time", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InverseTime",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InverseTimeTemperature",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H-1T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Inverse Time Temperature", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HZ-PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaHZ-PER-K");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InverseTimeTemperature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InverseTime_Squared",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Inverse Square Time", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InverseTime_Squared",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InverseVolume",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Inverse Volume", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MilliM3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-IN3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MilliL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-FT3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-CentiM3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-YD3");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InverseVolume",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/IonConcentration",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    "N, n^+, n^-",
    undefined
  );
  quantityKind.addLabel(new LangString("Ion Concentration", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-MicroL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MilliL");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-MilliM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-CentiM3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-PicoL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MilliM3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-IN3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-NanoL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-FT3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-YD3");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InverseVolume"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/NumberDensity"
  );
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/IonDensity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/IonConcentration",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/IonCurrent",
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T0D0",
    "j",
    undefined
  );
  quantityKind.addLabel(new LangString("Ion Current", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckCurrent");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BIOT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A_Stat");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A_Ab");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoA");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricCurrent"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/IonCurrent",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/IonDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    "N, n^+, n^-",
    undefined
  );
  quantityKind.addLabel(new LangString("Ion Density", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-MicroL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MilliL");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-MilliM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-CentiM3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-PicoL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MilliM3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-IN3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-NanoL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-FT3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-YD3");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InverseVolume"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/NumberDensity"
  );
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/IonConcentration"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/IonDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/IonTransportNumber",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "t_B",
    undefined
  );
  quantityKind.addLabel(new LangString("Ion Transport Number", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/IonTransportNumber",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/IonicCharge",
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    "q",
    undefined
  );
  quantityKind.addLabel(new LangString("Ionic Charge", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckCharge");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloJ-PER-KiloV"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C_Stat");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZettaC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YottaC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliA-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YoctoC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C_Ab");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZeptoC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/ElementaryCharge"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaC");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricCharge"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/IonicCharge",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/IonicStrength",
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M-1H0T0D0",
    "I",
    undefined
  );
  quantityKind.addLabel(new LangString("Ionic Strength", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MOL-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL_LB-PER-LB");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliMOL-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiMOL-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloMOL-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoMOL-PER-GM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliMOL-PER-GM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroMOL-PER-GM"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/IonicStrength",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/IonizationEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "E_i",
    undefined
  );
  quantityKind.addLabel(new LangString("Ionization Energy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/IonizationEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Irradiance",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    "E",
    undefined
  );
  quantityKind.addLabel(new LangString("éclairement énergétique", "fr"));
  quantityKind.addLabel(new LangString("yoğunluk", "tr"));
  quantityKind.addLabel(
    new LangString("Поверхностная плотность потока энергии", "ru")
  );
  quantityKind.addLabel(new LangString("irradiancia", "es"));
  quantityKind.addLabel(new LangString("irradianza", "it"));
  quantityKind.addLabel(new LangString("Kepenyinaran", "ms"));
  quantityKind.addLabel(new LangString("irradiância", "pt"));
  quantityKind.addLabel(new LangString("irradiance", "en"));
  quantityKind.addLabel(new LangString("Bestrahlungsstärke", "de"));
  quantityKind.addLabel(new LangString("الطاقة الهلامية", "ar"));
  quantityKind.addLabel(new LangString("Intenzita záření", "cs"));
  quantityKind.addLabel(new LangString("辐照度", "zh"));
  quantityKind.addLabel(new LangString("熱流束", "ja"));
  quantityKind.addLabel(new LangString("پرتو افکنی/چگالی تابش", "fa"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaJ-PER-M2-DAY"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PowerPerArea"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Irradiance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/IsentropicCompressibility",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H0T2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Isentropic Compressibility", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MegaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-PA");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/IsentropicCompressibility",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/IsentropicExponent",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Показатель адиабаты", "ru"));
  quantityKind.addLabel(new LangString("Wykładnik adiabaty", "pl"));
  quantityKind.addLabel(new LangString("exposant isoentropique", "fr"));
  quantityKind.addLabel(
    new LangString("ısı sığası oranı; adyabatik indeks", "tr")
  );
  quantityKind.addLabel(new LangString("绝热指数", "zh"));
  quantityKind.addLabel(new LangString("isentropic exponent", "en"));
  quantityKind.addLabel(new LangString("Poissonova konstanta", "cs"));
  quantityKind.addLabel(
    new LangString("Coefficiente di dilatazione adiabatica", "it")
  );
  quantityKind.addLabel(
    new LangString("Coeficient de transformare adiabatică", "ro")
  );
  quantityKind.addLabel(
    new LangString("Coeficiente de expansão adiabática", "pt")
  );
  quantityKind.addLabel(new LangString("نسبة السعة الحرارية", "ar"));
  quantityKind.addLabel(new LangString("adiabatni eksponent", "sl"));
  quantityKind.addLabel(new LangString("Isentropenexponent", "de"));
  quantityKind.addLabel(new LangString("比熱比", "ja"));
  quantityKind.addLabel(
    new LangString("Coeficiente de dilatación adiabática", "es")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/IsentropicExponent",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/IsothermalCompressibility",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H0T2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("等温压缩率", "zh"));
  quantityKind.addLabel(
    new LangString("معامل الانضغاط عند ثبوت درجة الحرارة", "ar")
  );
  quantityKind.addLabel(new LangString("compressibilité isotherme", "fr"));
  quantityKind.addLabel(new LangString("Izotermna stisljivost", "sl"));
  quantityKind.addLabel(new LangString("isotherme Kompressibilität", "de"));
  quantityKind.addLabel(new LangString("comprimibilità isotermica", "it"));
  quantityKind.addLabel(new LangString("compressibilidade isotérmica", "pt"));
  quantityKind.addLabel(new LangString("Ketermampatan isotermik", "ms"));
  quantityKind.addLabel(new LangString("isothermal compressibility", "en"));
  quantityKind.addLabel(new LangString("compresibilidad isotérmica", "es"));
  quantityKind.addLabel(new LangString("objemová stlačitelnost", "cs"));
  quantityKind.addLabel(new LangString("ضریب تراکم‌پذیری همدما", "fa"));
  quantityKind.addLabel(new LangString("ściśliwość izotermiczna", "pl"));
  quantityKind.addLabel(
    new LangString("изотермический коэффициент сжимаемости", "ru")
  );
  quantityKind.addLabel(new LangString("等温圧縮率", "ja"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-BAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MILLE-PSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MegaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-PSI");
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/InversePressure"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/IsothermalCompressibility",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/IsothermalMoistureCapacity",
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M-1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Isothermal Moisture Capacity", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM3-PER-GM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT3-PER-LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliL-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliL-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciL-PER-GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-KiloGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-GM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN3-PER-LB");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciM3-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM3-PER-KiloGM"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificVolume"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/IsothermalMoistureCapacity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Kerma",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    "K",
    undefined
  );
  quantityKind.addLabel(new LangString("Kerma", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGRAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGRAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGRAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGRAY");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificEnergy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Kerma",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/KermaRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Kerma Rate", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroSV-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroSV-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliSV-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliSV-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGRAY-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SV-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/REM-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SV-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliSV-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliRAD_R-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAY-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGRAY-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGRAY-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGRAY-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAY-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAY-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGRAY-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGRAY-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGRAY-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGRAY-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoSV-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SV-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGRAY-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoSV-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoSV-PER-HR");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/KermaRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/KinematicViscosity",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("श्यानता", "hi"));
  quantityKind.addLabel(new LangString("kinematična viskoznost", "sl"));
  quantityKind.addLabel(new LangString("Viscozitate cinematică", "ro"));
  quantityKind.addLabel(new LangString("Kinematik akmazlık", "tr"));
  quantityKind.addLabel(new LangString("لزوجة", "ar"));
  quantityKind.addLabel(new LangString("viscosidad cinemática", "es"));
  quantityKind.addLabel(new LangString("Kelikatan kinematik", "ms"));
  quantityKind.addLabel(new LangString("kinematische Viskosität", "de"));
  quantityKind.addLabel(new LangString("运动粘度", "zh"));
  quantityKind.addLabel(new LangString("viskozita", "cs"));
  quantityKind.addLabel(new LangString("kinematic viscosity", "en"));
  quantityKind.addLabel(new LangString("粘度", "ja"));
  quantityKind.addLabel(new LangString("گرانروی جنبشی/ویسکوزیته جنبشی", "fa"));
  quantityKind.addLabel(new LangString("viscosité cinématique", "fr"));
  quantityKind.addLabel(new LangString("кинематическую вязкость", "ru"));
  quantityKind.addLabel(new LangString("lepkość kinematyczna", "pl"));
  quantityKind.addLabel(new LangString("viscosità cinematica", "it"));
  quantityKind.addLabel(new LangString("viscosidade cinemática", "pt"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ST");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiST");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AreaPerTime"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/KinematicViscosity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/KinematicViscosityOrDiffusionConstantOrThermalDiffusivity",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-1D0",
    "0173-1#Z4-BAJ328#002",
    undefined
  );
  quantityKind.addLabel(
    new LangString(
      "kinematic viscosity or diffusion constant or thermal diffusivity",
      "en-US"
    )
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/KinematicViscosityOrDiffusionConstantOrThermalDiffusivity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/KineticEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "KE",
    undefined
  );
  quantityKind.addLabel(new LangString("Kinetic Energy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/KineticEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/KineticOrThermalEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "0173-1#Z4-BAJ280#002",
    undefined
  );
  quantityKind.addLabel(new LangString("kinetic or thermal energy", "en-US"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/KineticOrThermalEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LagrangeFunction",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "L",
    undefined
  );
  quantityKind.addLabel(new LangString("Lagrange Function", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LagrangeFunction",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Landau-GinzburgNumber",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Landau-Ginzburg Number", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Landau-GinzburgNumber",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LandeGFactor",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "g",
    undefined
  );
  quantityKind.addLabel(new LangString("Lande g-Factor", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LandeGFactor",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LarmorAngularFrequency",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Larmor Angular Frequency", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckFrequency_Ang"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG-PER-SEC");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AngularFrequency"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LarmorAngularFrequency",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LatticePlaneSpacing",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "d",
    undefined
  );
  quantityKind.addLabel(new LangString("Lattice Plane Spacing", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LatticePlaneSpacing",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LatticeVector",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "R",
    undefined
  );
  quantityKind.addLabel(new LangString("Lattice Vector", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LatticeVector",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LeakageFactor",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Leakage Factor", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LeakageFactor",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Length",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "l",
    undefined
  );
  quantityKind.addLabel(new LangString("אורך", "he"));
  quantityKind.addLabel(new LangString("طول", "fa"));
  quantityKind.addLabel(new LangString("długość", "pl"));
  quantityKind.addLabel(new LangString("Μήκος", "el"));
  quantityKind.addLabel(new LangString("Panjang", "ms"));
  quantityKind.addLabel(new LangString("longitud", "es"));
  quantityKind.addLabel(new LangString("Дължина", "bg"));
  quantityKind.addLabel(new LangString("lunghezza", "it"));
  quantityKind.addLabel(new LangString("longitudo", "la"));
  quantityKind.addLabel(new LangString("長さ", "ja"));
  quantityKind.addLabel(new LangString("hossz", "hu"));
  quantityKind.addLabel(new LangString("uzunluk", "tr"));
  quantityKind.addLabel(new LangString("comprimento", "pt"));
  quantityKind.addLabel(new LangString("लम्बाई", "hi"));
  quantityKind.addLabel(new LangString("长度", "zh"));
  quantityKind.addLabel(new LangString("طول", "ar"));
  quantityKind.addLabel(new LangString("longueur", "fr"));
  quantityKind.addLabel(new LangString("dolžina", "sl"));
  quantityKind.addLabel(new LangString("lungime", "ro"));
  quantityKind.addLabel(new LangString("Délka", "cs"));
  quantityKind.addLabel(new LangString("Длина", "ru"));
  quantityKind.addLabel(new LangString("length", "en"));
  quantityKind.addLabel(new LangString("Länge", "de"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Length",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LengthByForce",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Length Force", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Work"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LengthByForce",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LengthEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Length Energy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV-FemtoM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LengthEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LengthMass",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Length Mass", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-KiloGM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LengthMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LengthMolarEnergy",
    "http://qudt.org/vocab/dimensionvector/A-1E0L3I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Length Molar Energy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-M-PER-MOL");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LengthMolarEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LengthPerElectricCurrent",
    "http://qudt.org/vocab/dimensionvector/A0E-1L1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Length per Electric Current", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LengthPerElectricCurrent",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LengthRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Length Ratio", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LengthRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LengthTemperature",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H1T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Length Temperature", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C-CentiM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LengthTemperature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LengthTemperatureTime",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H1T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Length Temperature Time", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-SEC-DEG_C"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LengthTemperatureTime",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Lethargy",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "u",
    undefined
  );
  quantityKind.addLabel(new LangString("Lethargy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Lethargy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LevelWidth",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Level Width", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LevelWidth",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LiftCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "C_{L}",
    undefined
  );
  quantityKind.addLabel(new LangString("Lift Coefficient", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DECADE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FLIGHT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RPK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_MAG"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaBasePair");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BasePair");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/COUNT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HeartBeat");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OCT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_ELEC"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Dimensionless"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LiftCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LiftForce",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    "L",
    undefined
  );
  quantityKind.addLabel(new LangString("Lift Force", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_F_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPOND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-M-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DYN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckForce");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Force"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LiftForce",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LinearAbsorptionCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Linear Absorption Coefficient", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-NanoM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LinearAbsorptionCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LinearAcceleration",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Linear Acceleration", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-SEC2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloPA-M2-PER-GM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GALILEO");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KN-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-SEC2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloM-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-SEC2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGALILEO");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MI_US-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-SEC2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/G");
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/Acceleration"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LinearAcceleration",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LinearAttenuationCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Linear Attenuation Coefficient", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-NanoM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LinearAttenuationCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LinearBitDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("lineic bit density", undefined));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExbiBIT-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BIT-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GibiBIT-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KibiBIT-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaBIT-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PebiBIT-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TebiBIT-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MebiBIT-PER-M");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LinearBitDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LinearCompressibility",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Linear Compressibility", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM-PER-N");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LinearCompressibility",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LinearDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Linear Density", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-MilliM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-M");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LinearDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LinearElectricCharge",
    "http://qudt.org/vocab/dimensionvector/A0E1L-1I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("lineic electric charge", undefined));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LinearElectricCharge",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LinearElectricCurrent",
    "http://qudt.org/vocab/dimensionvector/A0E1L-1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Linear Electric Current", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliA-PER-IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloA-PER-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliA-PER-MilliM"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearElectricCurrentDensity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LinearElectricCurrent",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LinearElectricCurrentDensity",
    "http://qudt.org/vocab/dimensionvector/A0E1L-1I0M0H0T0D0",
    "J_s",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Linear Electric Current Density", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliA-PER-IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloA-PER-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliA-PER-MilliM"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LinearElectricCurrentDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LinearEnergyTransfer",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Linear Energy Transfer", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaEV-PER-CentiM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloEV-PER-MicroM"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LinearEnergyTransfer",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LinearExpansionCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H-1T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("معدل التمدد الحراري الخطي", "ar"));
  quantityKind.addLabel(new LangString("linear expansion coefficient", "en"));
  quantityKind.addLabel(
    new LangString("coeficiente de dilatação térmica linear", "pt")
  );
  quantityKind.addLabel(
    new LangString("coefficient de dilatation linéique", "fr")
  );
  quantityKind.addLabel(
    new LangString("współczynnik liniowej rozszerzalności cieplnej", "pl")
  );
  quantityKind.addLabel(
    new LangString("linearer Ausdehnungskoeffizient", "de")
  );
  quantityKind.addLabel(
    new LangString("coeficiente de expansión térmica lineal", "es")
  );
  quantityKind.addLabel(new LangString("線熱膨張係数", "ja"));
  quantityKind.addLabel(
    new LangString("coefficiente di dilatazione lineare", "it")
  );
  quantityKind.addLabel(new LangString("线性热膨胀系数", "zh"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT-PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MegaK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-DecaK"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ExpansionRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LinearExpansionCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LinearForce",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Linear Force", "en"));
  quantityKind.addLabel(new LangString("Streckenlast", "de"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-FT"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-PER-CentiM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-IN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-PER-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-M-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GigaN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-CentiM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-M-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliN-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-MilliM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ForcePerLength"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LinearForce",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LinearIonization",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    "N_{il}",
    undefined
  );
  quantityKind.addLabel(new LangString("Linear Ionization", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-NanoM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LinearIonization",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LinearLogarithmicRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("lineic logarithmic ratio", undefined));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciB-PER-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciB-PER-KiloM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/B-PER-M");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LinearLogarithmicRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LinearMass",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("lineic mass", undefined));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-KiloM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-YD");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LinearMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LinearMomentum",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-1D0",
    "p",
    undefined
  );
  quantityKind.addLabel(new LangString("Linear Momentum", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaEV-PER-SpeedOfLight"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-M-SEC-PER-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckMomentum"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-M-PER-SEC"
  );
  quantityKind.addExactMatchIri("http://qudt.org/vocab/quantitykind/Momentum");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LinearMomentum",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LinearPower",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("lineic power", undefined));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LinearPower",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LinearResistance",
    "http://qudt.org/vocab/dimensionvector/A0E-2L1I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("lineic resistance", undefined));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloOHM-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaOHM-PER-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliOHM-PER-M"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OHM-PER-KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OHM-PER-MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaOHM-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OHM-PER-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaOHM-PER-KiloM"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LinearResistance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LinearStiffness",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Linear Force", "en"));
  quantityKind.addLabel(new LangString("Streckenlast", "de"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-FT"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-PER-CentiM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-IN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-PER-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-M-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GigaN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-CentiM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-M-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliN-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-MilliM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ForcePerLength"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LinearStiffness",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LinearStrain",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Linear Strain", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ONE-PER-ONE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERMITTIVITY_REL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LengthRatio"
  );
  quantityKind.addExactMatchIri("http://qudt.org/vocab/quantitykind/Strain");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LinearStrain",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LinearThermalExpansion",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H-1T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Linear Thermal Expansion", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM-PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM-PER-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F-DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-DEG_F");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F-DEG_R"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LinearThermalExpansion",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LinearTorque",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("lineic torque", undefined));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB_F-FT-PER-IN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB_F-IN-PER-IN"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LinearTorque",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LinearVelocity",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    "v",
    undefined
  );
  quantityKind.addLabel(new LangString("Linear Velocity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaHZ-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-KiloYR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM-PER-YR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-HR");
  quantityKind.addExactMatchIri("http://qudt.org/vocab/quantitykind/Velocity");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LinearVelocity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LinearVoltageCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E-1L1I0M1H0T-2D0",
    "0173-1#Z4-BAJ336#003",
    undefined
  );
  quantityKind.addLabel(new LangString("linear voltage coefficient", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LinearVoltageCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LineicCharge",
    "http://qudt.org/vocab/dimensionvector/A0E1L-1I0M0H0T1D0",
    "0173-1#Z4-BAJ457#001",
    undefined
  );
  quantityKind.addLabel(new LangString("lineic charge", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LineicCharge",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LineicDataVolume",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    "0173-1#Z4-BAJ331#002",
    undefined
  );
  quantityKind.addLabel(new LangString("lineic data volume", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LineicDataVolume",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LineicLogarithmicRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    "0173-1#Z4-BAJ332#003",
    undefined
  );
  quantityKind.addLabel(new LangString("lineic logarithmic ratio", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LineicLogarithmicRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LineicMass",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T0D0",
    "0173-1#Z4-BAJ341#003",
    undefined
  );
  quantityKind.addLabel(new LangString("lineic mass", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LineicMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LineicPower",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-3D0",
    "0173-1#Z4-BAJ418#003",
    undefined
  );
  quantityKind.addLabel(new LangString("lineic power", "en-US"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-M");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LineicPower",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LineicQuantity",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("lineic quantity", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LineicQuantity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LineicResistance",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    "0173-1#Z4-BAJ333#003",
    undefined
  );
  quantityKind.addLabel(new LangString("lineic resistance", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LineicResistance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LineicResolution",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    "0173-1#Z4-BAJ438#002",
    undefined
  );
  quantityKind.addLabel(new LangString("lineic resolution", "en-US"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DPI");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InverseLength"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LineicResolution",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LineicTorque",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    "0173-1#Z4-BAJ433#001",
    undefined
  );
  quantityKind.addLabel(new LangString("lineic torque", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LineicTorque",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LinkedFlux",
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Linked Flux", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloWB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliWB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-M-PER-A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V_Ab-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-FT-PER-A"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MX");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UnitPole");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/WB");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticFlux"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LinkedFlux",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LiquidVolume",
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Liquid Volume", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_VOL_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PINT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCubicFT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BBL_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAL_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BBL_US_PET");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CUP_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CUP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAL_IMP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAL_US");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Volume"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LiquidVolume",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Log10FrequencyInterval",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("logarithmic frequency interval to base 10", undefined)
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Log10FrequencyInterval",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Log10Ratio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("logarithmic ratio to base 10", undefined)
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Log10Ratio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LogERatio",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("logarithmic ratio to base e", undefined)
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LogERatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LogOctanolAirPartitionCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Octanol Air Partition Coefficient", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LogOctanolAirPartitionCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LogOctanolWaterPartitionCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Logarithm of Octanol Water Partition Coefficient", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LogOctanolWaterPartitionCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LogarithmRatioToBase10",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "0173-1#Z4-BAJ441#002",
    undefined
  );
  quantityKind.addLabel(new LangString("logarithm ratio to base 10", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LogarithmRatioToBase10",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LogarithmRatioToBaseE",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "0173-1#Z4-BAJ440#002",
    undefined
  );
  quantityKind.addLabel(new LangString("logarithm ratio to base e", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LogarithmRatioToBaseE",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LogarithmicFrequencyInterval",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("intervalo logarítmico de frequência", "pt")
  );
  quantityKind.addLabel(
    new LangString("intervallo logaritmico di frequenza", "it")
  );
  quantityKind.addLabel(new LangString("Selang kekerapan logaritma", "ms"));
  quantityKind.addLabel(new LangString("logarithmic frequency interval", "en"));
  quantityKind.addLabel(new LangString("فاصله فرکانس لگاریتمی", "fa"));
  quantityKind.addLabel(new LangString("частотный интервал", "ru"));
  quantityKind.addLabel(new LangString("Frequenzmaßintervall", "de"));
  quantityKind.addLabel(new LangString("Interval měření frekvence ?", "cs"));
  quantityKind.addLabel(
    new LangString("intervalle de fréquence logarithmique", "fr")
  );
  quantityKind.addLabel(new LangString("对数频率间隔", "zh"));
  quantityKind.addLabel(new LangString("logaritmik frekans aralığı", "tr"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OCT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LogarithmicFrequencyInterval",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LogarithmicFrequencyIntervalToBase10",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "0173-1#Z4-BAJ472#001",
    undefined
  );
  quantityKind.addLabel(
    new LangString("logarithmic frequency interval to base 10", "en-US")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LogarithmicFrequencyIntervalToBase10",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LogarithmicMedianInformationFlow_SourceToBase10",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    "0173-1#Z4-BAJ470#001",
    undefined
  );
  quantityKind.addLabel(
    new LangString(
      "median information flow (from a source of information), expressed as a common logarithm ",
      "en-US"
    )
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LogarithmicMedianInformationFlow_SourceToBase10",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LogarithmicMedianInformationFlow_SourceToBase2",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    "0173-1#Z4-BAJ464#001",
    undefined
  );
  quantityKind.addLabel(
    new LangString(
      "median information flow (from a source of information), expressed as a binary logarithm",
      "en-US"
    )
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LogarithmicMedianInformationFlow_SourceToBase2",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LogarithmicMedianInformationFlow_SourceToBaseE",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    "0173-1#Z4-BAJ471#001",
    undefined
  );
  quantityKind.addLabel(
    new LangString(
      "median information flow (from a source of information), expressed as a natural logarithm ",
      "en-US"
    )
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LogarithmicMedianInformationFlow_SourceToBaseE",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LondonPenetrationDepth",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "λₗ",
    undefined
  );
  quantityKind.addLabel(new LangString("London Penetration Depth", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LondonPenetrationDepth",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Long-RangeOrderParameter",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "R, s",
    undefined
  );
  quantityKind.addLabel(new LangString("Long-Range Order Parameter", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Long-RangeOrderParameter",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LorenzCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E-2L4I0M2H-2T-6D0",
    "L",
    undefined
  );
  quantityKind.addLabel(new LangString("Lorenz Coefficient", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V2-PER-K2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LorenzCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LossAngle",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Loss Angle", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARCSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARCMIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN_Angle");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliARCSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/REV");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Angle"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LossAngle",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LossFactor",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "d",
    undefined
  );
  quantityKind.addLabel(new LangString("Loss Factor", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LossFactor",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Loudness",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "0173-1#Z4-BAJ334#002",
    undefined
  );
  quantityKind.addLabel(new LangString("loudness", "en-US"));
  quantityKind.addLabel(new LangString("loudness", undefined));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DECADE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FLIGHT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RPK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_MAG"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaBasePair");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BasePair");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/COUNT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HeartBeat");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OCT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_ELEC"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Dimensionless"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Loudness",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LoudnessLevel",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "0173-1#Z4-BAJ361#002",
    undefined
  );
  quantityKind.addLabel(new LangString("loudness level", "en-US"));
  quantityKind.addLabel(new LangString("loudness level", undefined));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DECADE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FLIGHT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RPK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_MAG"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaBasePair");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BasePair");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/COUNT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HeartBeat");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OCT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_ELEC"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Dimensionless"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LoudnessLevel",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LowerCriticalMagneticFluxDensity",
    "http://qudt.org/vocab/dimensionvector/A0E-1L0I0M1H0T-2D0",
    "B_{c1}",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Lower Critical Magnetic Flux Density", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUSS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGAUSS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAMMA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/T_Ab");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticFluxDensity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LowerCriticalMagneticFluxDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Luminance",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I1M0H0T0D0",
    "L_v",
    undefined
  );
  quantityKind.addLabel(new LangString("Luminance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LM-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CD-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LM-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/STILB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CD-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LA_FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CD-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LA");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Luminance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LuminousEfficacy",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I1M-1H0T3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Luminous Efficacy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LM-PER-W");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LuminousEfficacy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LuminousEmittance",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I1M0H0T0D0",
    "M_v",
    undefined
  );
  quantityKind.addLabel(new LangString("Luminous Emmitance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PHOT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LUX");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LuminousFluxPerArea"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LuminousEmittance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LuminousEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I1M0H0T1D0",
    "Q_v",
    undefined
  );
  quantityKind.addLabel(new LangString("Luminous Energy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LM-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LM-SEC");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LuminousEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LuminousExitance",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I1M0H0T0D0",
    "0173-1#Z4-BAJ382#002",
    undefined
  );
  quantityKind.addLabel(new LangString("luminous exitance", "en-US"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PHOT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LUX");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LuminousFluxPerArea"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LuminousExitance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LuminousExposure",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I1M0H0T1D0",
    "H_v",
    undefined
  );
  quantityKind.addLabel(new LangString("Luminous Exposure", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LUX-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LUX-SEC");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LuminousExposure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LuminousFlux",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I1M0H0T0D0",
    "F",
    undefined
  );
  quantityKind.addLabel(new LangString("fluctús lucis", "la"));
  quantityKind.addLabel(new LangString("flujo luminoso", "es"));
  quantityKind.addLabel(new LangString("flusso luminoso", "it"));
  quantityKind.addLabel(new LangString("flux lumineux", "fr"));
  quantityKind.addLabel(new LangString("प्रकाशीय बहाव", "hi"));
  quantityKind.addLabel(new LangString("işık akısı", "tr"));
  quantityKind.addLabel(new LangString("التدفق الضوئي", "ar"));
  quantityKind.addLabel(new LangString("strumień świetlny", "pl"));
  quantityKind.addLabel(new LangString("Fluks berluminositi", "ms"));
  quantityKind.addLabel(new LangString("svetlobni tok", "sl"));
  quantityKind.addLabel(new LangString("Светлинен поток", "bg"));
  quantityKind.addLabel(new LangString("光通量", "zh"));
  quantityKind.addLabel(new LangString("Световой поток", "ru"));
  quantityKind.addLabel(new LangString("fluxo luminoso", "pt"));
  quantityKind.addLabel(new LangString("שטף הארה", "he"));
  quantityKind.addLabel(new LangString("flux luminos", "ro"));
  quantityKind.addLabel(new LangString("fényáram", "hu"));
  quantityKind.addLabel(new LangString("Lichtstrom", "de"));
  quantityKind.addLabel(new LangString("luminous flux", "en"));
  quantityKind.addLabel(new LangString("Světelný tok", "cs"));
  quantityKind.addLabel(new LangString("شار نوری", "fa"));
  quantityKind.addLabel(new LangString("光束", "ja"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LuminousFlux",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LuminousFluxPerArea",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I1M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Luminous Flux per Area", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PHOT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LUX");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LuminousFluxPerArea",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LuminousFluxRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Luminous Flux Ratio", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LuminousFluxRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LuminousIntensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I1M0H0T0D0",
    "J",
    undefined
  );
  quantityKind.addLabel(new LangString("Lichtstärke", "de"));
  quantityKind.addLabel(new LangString("شدة الإضاءة", "ar"));
  quantityKind.addLabel(new LangString("ışık şiddeti", "tr"));
  quantityKind.addLabel(new LangString("intensité lumineuse", "fr"));
  quantityKind.addLabel(new LangString("Keamatan berluminositi", "ms"));
  quantityKind.addLabel(new LangString("intensitate luminoasă", "ro"));
  quantityKind.addLabel(new LangString("光度", "ja"));
  quantityKind.addLabel(new LangString("עוצמת הארה", "he"));
  quantityKind.addLabel(new LangString("fényerősség", "hu"));
  quantityKind.addLabel(new LangString("Интензитет на светлината", "bg"));
  quantityKind.addLabel(new LangString("发光强度", "zh"));
  quantityKind.addLabel(new LangString("Сила света", "ru"));
  quantityKind.addLabel(new LangString("światłość", "pl"));
  quantityKind.addLabel(new LangString("प्रकाशीय तीव्रता", "hi"));
  quantityKind.addLabel(new LangString("intensità luminosa", "it"));
  quantityKind.addLabel(new LangString("intensidad luminosa", "es"));
  quantityKind.addLabel(new LangString("Ένταση Φωτεινότητας", "el"));
  quantityKind.addLabel(new LangString("intensitas luminosa", "la"));
  quantityKind.addLabel(new LangString("svetilnost", "sl"));
  quantityKind.addLabel(new LangString("شدت نور", "fa"));
  quantityKind.addLabel(new LangString("Svítivost", "cs"));
  quantityKind.addLabel(new LangString("intensidade luminosa", "pt"));
  quantityKind.addLabel(new LangString("luminous intensity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CD_IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliCD");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LuminousIntensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LuminousIntensityDistribution",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Ion Concentration", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CD-PER-LM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CD-PER-KiloLM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LuminousIntensityDistribution",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MASS-DELIVERED",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Mass Delivered", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PENNYWEIGHT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MASS-DELIVERED",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MASS-GROWTH-ALLOWANCE",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Mass Growth Allowance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PENNYWEIGHT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MASS-GROWTH-ALLOWANCE",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MASS-MARGIN",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Mass Margin", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PENNYWEIGHT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MASS-MARGIN",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MASS-PROPERTY-UNCERTAINTY",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Mass Property Uncertainty", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PENNYWEIGHT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MASS-PROPERTY-UNCERTAINTY",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MOMENT-OF-INERTIA_Y",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T0D0",
    "I_{y}",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Moment of Inertia in the Y axis", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-FT2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-MilliM2"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MomentOfInertia"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MOMENT-OF-INERTIA_Y",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MOMENT-OF-INERTIA_Z",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T0D0",
    "I_{z}",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Moment of Inertia in the Z axis", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-FT2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-MilliM2"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MomentOfInertia"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MOMENT-OF-INERTIA_Z",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MachNumber",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "Ma",
    undefined
  );
  quantityKind.addLabel(new LangString("मैक संख्या", "hi"));
  quantityKind.addLabel(new LangString("número de Mach", "pt"));
  quantityKind.addLabel(new LangString("nombre de Mach", "fr"));
  quantityKind.addLabel(new LangString("Machovo číslo", "cs"));
  quantityKind.addLabel(new LangString("عدد ماخ", "fa"));
  quantityKind.addLabel(new LangString("马赫", "zh"));
  quantityKind.addLabel(new LangString("Mach number", "en"));
  quantityKind.addLabel(new LangString("liczba Macha", "pl"));
  quantityKind.addLabel(new LangString("Mach sayısı", "tr"));
  quantityKind.addLabel(new LangString("Mach-Zahl", "de"));
  quantityKind.addLabel(new LangString("număr Mach", "ro"));
  quantityKind.addLabel(new LangString("マッハ数n", "ja"));
  quantityKind.addLabel(new LangString("число Маха", "ru"));
  quantityKind.addLabel(new LangString("Machovo število", "sl"));
  quantityKind.addLabel(new LangString("Nombor Mach", "ms"));
  quantityKind.addLabel(new LangString("numero di Mach", "it"));
  quantityKind.addLabel(new LangString("عدد ماخ", "ar"));
  quantityKind.addLabel(new LangString("número de Mach", "es"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MACH");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MachNumber",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MacroscopicCrossSection",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Macroscopic Cross-section", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckArea");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloMIL_Circ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIL_Circ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaARE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PIXEL_AREA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CrossSection"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MacroscopicCrossSection",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MacroscopicTotalCrossSection",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Macroscopic Total Cross-section", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckArea");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloMIL_Circ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIL_Circ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaARE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PIXEL_AREA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CrossSection"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MacroscopicTotalCrossSection",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MadelungConstant",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Stała Madelunga", "pl"));
  quantityKind.addLabel(new LangString("постоянная Маделунга", "ru"));
  quantityKind.addLabel(new LangString("ثابت مادلونك", "ar"));
  quantityKind.addLabel(new LangString("Madelung constant", "en"));
  quantityKind.addLabel(new LangString("ثابت مادلونگ", "fa"));
  quantityKind.addLabel(new LangString("Costante di Madelung", "it"));
  quantityKind.addLabel(new LangString("Constante de Madelung", "es"));
  quantityKind.addLabel(new LangString("マーデルングエネルギー", "ja"));
  quantityKind.addLabel(new LangString("constante de Madelung", "pt"));
  quantityKind.addLabel(new LangString("Constante de Madelung", "fr"));
  quantityKind.addLabel(new LangString("馬德隆常數", "zh"));
  quantityKind.addLabel(new LangString("Madelung-Konstante", "de"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MadelungConstant",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MagneticAreaMoment",
    "http://qudt.org/vocab/dimensionvector/A0E1L2I0M0H0T0D0",
    "m",
    undefined
  );
  quantityKind.addLabel(new LangString("Magnetic Area Moment", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV-PER-T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A_Ab-CentiM2");
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/MagneticMoment"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MagneticAreaMoment",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MagneticDipoleMoment",
    "http://qudt.org/vocab/dimensionvector/A0E-1L3I0M1H0T-2D0",
    "J_m",
    undefined
  );
  quantityKind.addLabel(new LangString("Magnetic Dipole Moment", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-M2-PER-A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/WB-M");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MagneticDipoleMoment",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MagneticDipoleMomentOfAMolecule",
    "http://qudt.org/vocab/dimensionvector/A0E1L2I0M0H0T0D0",
    "0173-1#Z4-BAJ460#001",
    undefined
  );
  quantityKind.addLabel(
    new LangString("magnetic dipole moment of a molecule", "en-US")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MagneticDipoleMomentOfAMolecule",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MagneticField",
    "http://qudt.org/vocab/dimensionvector/A0E-1L0I0M1H0T-2D0",
    "B",
    undefined
  );
  quantityKind.addLabel(new LangString("Magnetic Field", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAMMA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/T_Ab");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MagneticField",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MagneticFieldStrength",
    "http://qudt.org/vocab/dimensionvector/A0E1L-1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("jakost magnetnega polja", "sl"));
  quantityKind.addLabel(new LangString("Магнитное поле", "ru"));
  quantityKind.addLabel(new LangString("Magnetické pole", "cs"));
  quantityKind.addLabel(new LangString("Manyetik alan", "tr"));
  quantityKind.addLabel(new LangString("شدت میدان مغناطیسی", "fa"));
  quantityKind.addLabel(new LangString("intensidad de campo magnético", "es"));
  quantityKind.addLabel(new LangString("磁場", "zh"));
  quantityKind.addLabel(new LangString("intensidade de campo magnético", "pt"));
  quantityKind.addLabel(new LangString("Kekuatan medan magnetik", "ms"));
  quantityKind.addLabel(new LangString("磁場", "ja"));
  quantityKind.addLabel(new LangString("Câmp magnetic", "ro"));
  quantityKind.addLabel(new LangString("حقل مغناطيسي", "ar"));
  quantityKind.addLabel(new LangString("magnetische Feldstärke", "de"));
  quantityKind.addLabel(new LangString("pole magnetyczne", "pl"));
  quantityKind.addLabel(new LangString("magnetic field strength", "en"));
  quantityKind.addLabel(new LangString("intensité de champ magnétique", "fr"));
  quantityKind.addLabel(new LangString("intensità di campo magnetico", "it"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AT-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliA-PER-IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloA-PER-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliA-PER-MilliM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AT-PER-IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OERSTED");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentPerLength"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MagneticFieldStrength",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MagneticFieldStrength_H",
    "http://qudt.org/vocab/dimensionvector/A0E1L-1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("jakost magnetnega polja", "sl"));
  quantityKind.addLabel(new LangString("Магнитное поле", "ru"));
  quantityKind.addLabel(new LangString("Magnetické pole", "cs"));
  quantityKind.addLabel(new LangString("Manyetik alan", "tr"));
  quantityKind.addLabel(new LangString("شدت میدان مغناطیسی", "fa"));
  quantityKind.addLabel(new LangString("intensidad de campo magnético", "es"));
  quantityKind.addLabel(new LangString("磁場", "zh"));
  quantityKind.addLabel(new LangString("intensidade de campo magnético", "pt"));
  quantityKind.addLabel(new LangString("Kekuatan medan magnetik", "ms"));
  quantityKind.addLabel(new LangString("磁場", "ja"));
  quantityKind.addLabel(new LangString("Câmp magnetic", "ro"));
  quantityKind.addLabel(new LangString("حقل مغناطيسي", "ar"));
  quantityKind.addLabel(new LangString("magnetische Feldstärke", "de"));
  quantityKind.addLabel(new LangString("pole magnetyczne", "pl"));
  quantityKind.addLabel(new LangString("magnetic field strength", "en"));
  quantityKind.addLabel(new LangString("intensité de champ magnétique", "fr"));
  quantityKind.addLabel(new LangString("intensità di campo magnetico", "it"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliA-PER-IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloA-PER-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliA-PER-MilliM"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentPerLength"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MagneticFieldStrength_H",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MagneticFlux",
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("flusso magnetico", "it"));
  quantityKind.addLabel(new LangString("Magnetický tok", "cs"));
  quantityKind.addLabel(new LangString("mágneses fluxus", "hu"));
  quantityKind.addLabel(new LangString("שטף מגנטי", "he"));
  quantityKind.addLabel(new LangString("التدفق المغناطيسي", "ar"));
  quantityKind.addLabel(new LangString("شار مغناطیسی", "fa"));
  quantityKind.addLabel(new LangString("Flux d'induction magnétique", "fr"));
  quantityKind.addLabel(new LangString("Магнитный поток", "ru"));
  quantityKind.addLabel(new LangString("Магнитен поток", "bg"));
  quantityKind.addLabel(new LangString("flux de inducție magnetică", "ro"));
  quantityKind.addLabel(new LangString("fluxo magnético", "pt"));
  quantityKind.addLabel(new LangString("磁通量", "zh"));
  quantityKind.addLabel(new LangString("磁束", "ja"));
  quantityKind.addLabel(new LangString("fluxus magneticus", "la"));
  quantityKind.addLabel(new LangString("चुम्बकीय बहाव", "hi"));
  quantityKind.addLabel(new LangString("Fluks magnet", "ms"));
  quantityKind.addLabel(new LangString("manyetik akı", "tr"));
  quantityKind.addLabel(new LangString("magnetischer Flux", "de"));
  quantityKind.addLabel(new LangString("magnetic flux", "en"));
  quantityKind.addLabel(new LangString("flujo magnético", "es"));
  quantityKind.addLabel(new LangString("magnetni pretok", "sl"));
  quantityKind.addLabel(new LangString("strumień magnetyczny", "pl"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloWB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliWB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-M-PER-A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V_Ab-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-FT-PER-A"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MX");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UnitPole");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/WB");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MagneticFlux",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MagneticFluxDensity",
    "http://qudt.org/vocab/dimensionvector/A0E-1L0I0M1H0T-2D0",
    "B",
    undefined
  );
  quantityKind.addLabel(new LangString("indukcja magnetyczna", "pl"));
  quantityKind.addLabel(new LangString("magnetic flux density", "en-US"));
  quantityKind.addLabel(new LangString("Densidad de flujo magnético", "es"));
  quantityKind.addLabel(new LangString("densitas fluxus magnetici", "la"));
  quantityKind.addLabel(new LangString("Магнитна индукция", "bg"));
  quantityKind.addLabel(new LangString("gostota magnetnega pretoka", "sl"));
  quantityKind.addLabel(new LangString("magnetische Flussdichte", "de"));
  quantityKind.addLabel(new LangString("inducție magnetică", "ro"));
  quantityKind.addLabel(new LangString("densidade de fluxo magnético", "pt"));
  quantityKind.addLabel(new LangString("磁通量密度", "zh"));
  quantityKind.addLabel(new LangString("magnetic flux density", "en"));
  quantityKind.addLabel(new LangString("Magnetická indukce", "cs"));
  quantityKind.addLabel(new LangString("צפיפות שטף מגנטי", "he"));
  quantityKind.addLabel(new LangString("चुम्बकीय क्षेत्र", "hi"));
  quantityKind.addLabel(new LangString("mágneses indukció", "hu"));
  quantityKind.addLabel(new LangString("Densité de flux magnétique", "fr"));
  quantityKind.addLabel(new LangString("چگالی شار مغناطیسی", "fa"));
  quantityKind.addLabel(new LangString("densità di flusso magnetico", "it"));
  quantityKind.addLabel(new LangString("المجال المغناطيسي", "ar"));
  quantityKind.addLabel(new LangString("manyetik akı yoğunluğu", "tr"));
  quantityKind.addLabel(new LangString("Магнитная индукция", "ru"));
  quantityKind.addLabel(new LangString("Ketumpatan fluks magnet", "ms"));
  quantityKind.addLabel(new LangString("磁束密度", "ja"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUSS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGAUSS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAMMA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/T_Ab");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MagneticFluxDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MagneticFluxDensityOrMagneticPolarization",
    "http://qudt.org/vocab/dimensionvector/A0E-1L0I0M1H0T-2D0",
    "0173-1#Z4-BAJ221#002",
    undefined
  );
  quantityKind.addLabel(
    new LangString("magnetic flux density or magnetic polarization", "en-US")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MagneticFluxDensityOrMagneticPolarization",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MagneticFluxPerLength",
    "http://qudt.org/vocab/dimensionvector/A0E-1L1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Magnetic flux per length", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-SEC-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/T-M");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MagneticFluxPerLength",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MagneticMoment",
    "http://qudt.org/vocab/dimensionvector/A0E1L2I0M0H0T0D0",
    "m",
    undefined
  );
  quantityKind.addLabel(new LangString("momento de dipolo magnético", "es"));
  quantityKind.addLabel(new LangString("Momen magnetik", "ms"));
  quantityKind.addLabel(new LangString("momento di dipolo magnetico", "it"));
  quantityKind.addLabel(new LangString("moment magnétique", "fr"));
  quantityKind.addLabel(new LangString("चुम्बकीय द्विध्रुव", "hi"));
  quantityKind.addLabel(new LangString("momento de dipolo magnético", "pt"));
  quantityKind.addLabel(new LangString("Магнитный момент", "ru"));
  quantityKind.addLabel(new LangString("magnetisches Dipolmoment", "de"));
  quantityKind.addLabel(new LangString("دوقطبی مغناطیسی", "fa"));
  quantityKind.addLabel(new LangString("Magnetický dipól", "cs"));
  quantityKind.addLabel(new LangString("magnetic moment", "en"));
  quantityKind.addLabel(new LangString("عزم مغناطيسي", "ar"));
  quantityKind.addLabel(new LangString("磁気双極子", "ja"));
  quantityKind.addLabel(new LangString("dipol magnetyczny", "pl"));
  quantityKind.addLabel(new LangString("Manyetik moment", "tr"));
  quantityKind.addLabel(new LangString("磁偶极", "zh"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV-PER-T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A_Ab-CentiM2");
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/MagneticAreaMoment"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MagneticMoment",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MagneticPolarization",
    "http://qudt.org/vocab/dimensionvector/A0E1L-1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Magnetic Polarization", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MagneticPolarization",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MagneticQuantumNumber",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "m",
    undefined
  );
  quantityKind.addLabel(new LangString("Magnetic Quantum Number", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/QuantumNumber"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MagneticQuantumNumber",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MagneticReluctivity",
    "http://qudt.org/vocab/dimensionvector/A0E1L-1I0M-1H0T2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Magnetic Reluctivity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-T-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-V-SEC");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MagneticReluctivity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MagneticSusceptability",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Magnetic Susceptability", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MagneticSusceptability",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MagneticTension",
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T0D0",
    "U_m",
    undefined
  );
  quantityKind.addLabel(new LangString("Magnetic Tension", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoA");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MagneticTension",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MagneticVectorPotential",
    "http://qudt.org/vocab/dimensionvector/A0E-1L1I0M1H0T-2D0",
    "A",
    undefined
  );
  quantityKind.addLabel(new LangString("potencial magnético", "pt"));
  quantityKind.addLabel(new LangString("磁向量势", "zh"));
  quantityKind.addLabel(new LangString("potențial magnetic", "ro"));
  quantityKind.addLabel(new LangString("potentiel magnétique", "fr"));
  quantityKind.addLabel(new LangString("magnetisches Potenzial", "de"));
  quantityKind.addLabel(new LangString("magnetic vector potential", "en"));
  quantityKind.addLabel(new LangString("magnetický potenciál", "cs"));
  quantityKind.addLabel(new LangString("Keupayaan vektor magnetik", "ms"));
  quantityKind.addLabel(new LangString("potencial magnético", "es"));
  quantityKind.addLabel(new LangString("Магнитний потенциал", "ru"));
  quantityKind.addLabel(new LangString("potencjał magnetyczny", "pl"));
  quantityKind.addLabel(new LangString("manyetik potansiyeli", "tr"));
  quantityKind.addLabel(new LangString("پتانسیل برداری مغناطیسی", "fa"));
  quantityKind.addLabel(new LangString("potenziale vettore magnetico", "it"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/WB-PER-MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloWB-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-SEC-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/WB-PER-M");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MagneticVectorPotential",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Magnetization",
    "http://qudt.org/vocab/dimensionvector/A0E1L-1I0M0H0T0D0",
    "M",
    undefined
  );
  quantityKind.addLabel(new LangString("Magnetisierung", "de"));
  quantityKind.addLabel(new LangString("magnetyzacia", "pl"));
  quantityKind.addLabel(new LangString("aimantation", "fr"));
  quantityKind.addLabel(new LangString("magnetizzazione", "it"));
  quantityKind.addLabel(new LangString("magnetización", "es"));
  quantityKind.addLabel(new LangString("намагниченность", "ru"));
  quantityKind.addLabel(new LangString("magnetização", "pt"));
  quantityKind.addLabel(new LangString("磁化", "ja"));
  quantityKind.addLabel(new LangString("magnetization", "en"));
  quantityKind.addLabel(new LangString("مغنطة", "ar"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliA-PER-IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloA-PER-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliA-PER-MilliM"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearElectricCurrent"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Magnetization",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MagnetizationField",
    "http://qudt.org/vocab/dimensionvector/A0E1L-1I0M0H0T0D0",
    "M",
    undefined
  );
  quantityKind.addLabel(new LangString("Magnetization Field", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliA-PER-IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloA-PER-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliA-PER-MilliM"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentPerLength"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MagnetizationField",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MagnetomotiveForce",
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Magnetomotive Force", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OERSTED-CentiM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoA");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MagnetomotiveForce",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Mass",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    "m",
    undefined
  );
  quantityKind.addLabel(new LangString("masa", "es"));
  quantityKind.addLabel(new LangString("Hmotnost", "cs"));
  quantityKind.addLabel(new LangString("Masse", "de"));
  quantityKind.addLabel(new LangString("Маса", "bg"));
  quantityKind.addLabel(new LangString("Масса", "ru"));
  quantityKind.addLabel(new LangString("كتلة", "ar"));
  quantityKind.addLabel(new LangString("massa", "la"));
  quantityKind.addLabel(new LangString("Jisim", "ms"));
  quantityKind.addLabel(new LangString("Μάζα", "el"));
  quantityKind.addLabel(new LangString("质量", "zh"));
  quantityKind.addLabel(new LangString("भार", "hi"));
  quantityKind.addLabel(new LangString("מסה", "he"));
  quantityKind.addLabel(new LangString("tömeg", "hu"));
  quantityKind.addLabel(new LangString("kütle", "tr"));
  quantityKind.addLabel(new LangString("masse", "fr"));
  quantityKind.addLabel(new LangString("質量", "ja"));
  quantityKind.addLabel(new LangString("massa", "it"));
  quantityKind.addLabel(new LangString("massa", "pt"));
  quantityKind.addLabel(new LangString("masa", "sl"));
  quantityKind.addLabel(new LangString("masa", "pl"));
  quantityKind.addLabel(new LangString("masă", "ro"));
  quantityKind.addLabel(new LangString("جرم", "fa"));
  quantityKind.addLabel(new LangString("mass", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PENNYWEIGHT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Mass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassAbsorptionCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M-1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Mass Absorption Coefficient", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-KiloGM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassAbsorptionCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassAmountOfSubstance",
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Mass Amount of Substance", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassAmountOfSubstance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassAmountOfSubstanceTemperature",
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H1T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Mass Amount of Substance Temperature", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL_LB-DEG_F");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassAmountOfSubstanceTemperature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassAttenuationCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M-1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Mass Attenuation Coefficient", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM2-PER-GM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-GM_DRY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-KiloGM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassAttenuationCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassBasedBloodGlucoseLevel",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Blood Glucose Level by Mass", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-DeciL"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassBasedBloodGlucoseLevel",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassConcentration",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Mass Concentration", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoGM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-M3");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassConcentration",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassConcentrationOfWater",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    "w",
    undefined
  );
  quantityKind.addLabel(new LangString("Mass Concentration of Water", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-M3");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassConcentrationOfWater",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassConcentrationOfWaterVapour",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    "v",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Mass Concentration of Water Vapour", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-M3");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassConcentrationOfWaterVapour",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassConcentrationRateOfChange",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Mass Concentration Rate Of Change", "en")
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-L-DAY"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassConcentrationRateOfChange",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassDefect",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    "B",
    undefined
  );
  quantityKind.addLabel(new LangString("Mass Defect", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PENNYWEIGHT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassDefect",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("yoğunluk", "tr"));
  quantityKind.addLabel(new LangString("घनत्व", "hi"));
  quantityKind.addLabel(new LangString("плотность", "ru"));
  quantityKind.addLabel(new LangString("hustota", "cs"));
  quantityKind.addLabel(new LangString("چگالی", "fa"));
  quantityKind.addLabel(new LangString("densitate", "ro"));
  quantityKind.addLabel(new LangString("mass density", "en"));
  quantityKind.addLabel(new LangString("密度", "zh"));
  quantityKind.addLabel(new LangString("Ketumpatan jisim", "ms"));
  quantityKind.addLabel(new LangString("gęstość", "pl"));
  quantityKind.addLabel(new LangString("densité", "fr"));
  quantityKind.addLabel(new LangString("الكثافة", "ar"));
  quantityKind.addLabel(new LangString("Gostôta", "sl"));
  quantityKind.addLabel(new LangString("densidad", "es"));
  quantityKind.addLabel(new LangString("Massendichte", "de"));
  quantityKind.addLabel(new LangString("densità", "it"));
  quantityKind.addLabel(new LangString("密度", "ja"));
  quantityKind.addLabel(new LangString("densidade", "pt"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-CentiM3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-MicroL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-PER-GAL_IMP"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_LONG-PER-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_Metric-PER-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-IN3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG-PER-FT3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-DeciL");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GRAIN-PER-GAL_IMP"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-MilliL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-DeciL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEGREE_BAUME");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-IN3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-FT3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEGREE_BAUME_US_HEAVY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GRAIN-PER-GAL_US"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-DeciM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-DeciL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEGREE_BAUME_US_LIGHT"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_US-PER-YD3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-YD3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEGREE_BRIX");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-DeciM3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-CentiM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-GAL_US");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-DeciL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoGM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-GAL_UK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEGREE_TWADDELL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckDensity");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ-PER-GAL_IMP"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_UK-PER-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_SHORT-PER-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEGREE_BALLING"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-YD3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEGREE_PLATO");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-GAL_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-GAL_UK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEGREE_OECHSLE"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-M3");
  quantityKind.addExactMatchIri("http://qudt.org/vocab/quantitykind/Density");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassEnergyTransferCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M-1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Mass Energy Transfer Coefficient", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-KiloGM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassEnergyTransferCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassEquivalent",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Mass Equivalent", undefined));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PENNYWEIGHT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassEquivalent",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassExcess",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Mass Excess", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PENNYWEIGHT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassExcess",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassFlowRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    "q_m",
    undefined
  );
  quantityKind.addLabel(new LangString("Mass Flow Rate", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-YR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_Metric-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-SEC-PER-CentiM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_Metric-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_Metric-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE-PER-MO");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTONNE-PER-YR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_Metric-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_UK-PER-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaTONNE-PER-YR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_SHORT-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_US-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB-PER-HR");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassFlowRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassFluxDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-1D0",
    "0173-1#Z4-BAJ264#003",
    undefined
  );
  quantityKind.addLabel(new LangString("mass flux density", undefined));
  quantityKind.addLabel(new LangString("mass flux density", "en-US"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-M2-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-CentiM2-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-M2-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-M2-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-M2-YR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-HA-YR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TONNE-PER-HA-YR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaGM-PER-HA-YR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM_Nitrogen-PER-M2-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-SEC-PER-CentiM3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-M2-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M2-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-M2-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-CentiM2-WK"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM_Carbon-PER-M2-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-SEC-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-CentiM2-YR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-M2-SEC"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassPerAreaTime"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassFluxDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassFraction",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "w_B",
    undefined
  );
  quantityKind.addLabel(new LangString("Mass Fraction", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassFraction",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassFractionOfDryMatter",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "w_d",
    undefined
  );
  quantityKind.addLabel(new LangString("Mass Fraction of Dry Matter", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassFractionOfDryMatter",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassFractionOfWater",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "w_{H_2o}",
    undefined
  );
  quantityKind.addLabel(new LangString("Mass Fraction of Water", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassFractionOfWater",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassNumber",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "A",
    undefined
  );
  quantityKind.addLabel(new LangString("Mass Number", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Count"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassNumber",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassOfElectricalPowerSupply",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    "M_{E}",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Mass Of Electrical Power Supply", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PENNYWEIGHT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassOfElectricalPowerSupply",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassOfSolidBooster",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    "M_{SB}",
    undefined
  );
  quantityKind.addLabel(new LangString("Mass Of Solid Booster", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PENNYWEIGHT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassOfSolidBooster",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassOfTheEarth",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Mass Of The Earth", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PENNYWEIGHT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassOfTheEarth",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassPerArea",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Mass per Area", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-FT2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-HA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-YD2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG-PER-FT2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM-PER-HA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE-PER-HA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_Metric-PER-HA"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-KiloM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-HA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-IN2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-FT2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-IN2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-DeciM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-YD2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-HA"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-AC");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassPerArea",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassPerAreaTime",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Mass per Area Time", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-M2-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-CentiM2-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-M2-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-M2-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-M2-YR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-HA-YR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TONNE-PER-HA-YR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaGM-PER-HA-YR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM_Nitrogen-PER-M2-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-SEC-PER-CentiM3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-M2-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M2-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-M2-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-CentiM2-WK"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM_Carbon-PER-M2-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-SEC-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-CentiM2-YR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-M2-SEC"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassPerAreaTime",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassPerElectricCharge",
    "http://qudt.org/vocab/dimensionvector/A0E-1L0I0M1H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Mass per Electric Charge", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/T-SEC");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassPerElectricCharge",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassPerEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Mass per Energy", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-DeciM3-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-CentiM3-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-L-BAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-M3-BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-MilliL-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-GigaJ"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-M3-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-M3-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-DeciM3-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-J");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M3-PA"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-PER-IN3-PSI"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-CentiM3-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M3-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-MegaBTU_IT"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TONNE-PER-M3-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-PER-FT3-PSI"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-L-BAR"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassPerEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassPerLength",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Mass per Length", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-MilliM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DENIER");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TEX");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG-PER-FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-M");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassPerLength",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassPerTime",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Mass per Time", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-SEC-PER-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_SHORT-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE-PER-MO");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB-PER-HR");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassPerTime",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "R or M_{R}",
    undefined
  );
  quantityKind.addLabel(new LangString("Mass Ratio", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-MilliGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-MilliGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-GM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoGM-PER-MilliGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoGM-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FemtoGM-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-LB");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-GM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-HectoGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-KiloGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM-PER-GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-GM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassRatioOfWaterToDryMatter",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "u",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Mass Concentration of Water To Dry Matter", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassRatioOfWaterToDryMatter",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassRatioOfWaterVapourToDryGas",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "x",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Mass Ratio of Water Vapour to Dry Gas", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassRatioOfWaterVapourToDryGas",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassRelatedElectricalCurrent",
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M-1H0T0D0",
    "0173-1#Z4-BAJ347#002",
    undefined
  );
  quantityKind.addLabel(
    new LangString("mass-related electrical current", "en-US")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassRelatedElectricalCurrent",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassSpecificBiogeochemicalRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Mass Specific Biogeochemical Rate", "en")
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-GM-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-GM-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-KiloGM-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-GM-HR"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassSpecificBiogeochemicalRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassStoppingPower",
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("mass stopping power", undefined));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG-CentiM2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassStoppingPower",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassTemperature",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H1T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Mass Temperature", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-DEG_R");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassTemperature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassicActivity",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T-1D0",
    "a",
    undefined
  );
  quantityKind.addLabel(new LangString("Massic Activity", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloBQ-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CI-PER-KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BQ-PER-KiloGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaBQ-PER-KiloGM"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassicActivity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassicElectricCurrent",
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M-1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("massic electric current", undefined));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-KiloGM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassicElectricCurrent",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassicHeatCapacity",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H-1T-2D0",
    "0173-1#Z4-BAJ345#002",
    undefined
  );
  quantityKind.addLabel(new LangString("massic heat capacity", undefined));
  quantityKind.addLabel(new LangString("massic heat capacity", "en-US"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-LB-DEG_R"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL_IT-PER-GM-K"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassicHeatCapacity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassicPower",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    "0173-1#Z4-BAJ343#002",
    undefined
  );
  quantityKind.addLabel(new LangString("massic power", "en-US"));
  quantityKind.addLabel(new LangString("massic power", undefined));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroSV-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroSV-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliSV-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliSV-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliW-PER-MilliGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGRAY-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SV-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/REM-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SV-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/ERG-PER-GM-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliSV-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-KiloGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliRAD_R-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAY-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGRAY-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGRAY-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGRAY-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAY-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAY-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGRAY-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGRAY-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGRAY-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGRAY-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoSV-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SV-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGRAY-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoSV-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoSV-PER-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificPower"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassicPower",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassicTorque",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    "0173-1#Z4-BAJ442#002",
    undefined
  );
  quantityKind.addLabel(new LangString("massic torque", "en-US"));
  quantityKind.addLabel(new LangString("massic torque", undefined));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassicTorque",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassieuFunction",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H-1T-2D0",
    "J",
    undefined
  );
  quantityKind.addLabel(new LangString("Massieu Function", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassieuFunction",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MaxExpectedOperatingThrust",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Maximum Expected Operating Thrust", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_F_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPOND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-M-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DYN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckForce");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MaxOperatingThrust"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MaxExpectedOperatingThrust",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MaxOperatingThrust",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Max Operating Thrust", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_F_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPOND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-M-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DYN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckForce");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Thrust"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MaxOperatingThrust",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MaxSeaLevelThrust",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Max Sea Level Thrust", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_F_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPOND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-M-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DYN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckForce");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Thrust"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MaxSeaLevelThrust",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MaximumBeta-ParticleEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "Eᵦ",
    undefined
  );
  quantityKind.addLabel(new LangString("Maximum Beta-Particle Energy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MaximumBeta-ParticleEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MaximumExpectedOperatingPressure",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Maximum Expected Operating Pressure", "en")
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-IN2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_32DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroTORR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_60DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARYE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA_A");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroATM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliTORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_60DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR_A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR_A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckPressure"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_H2O_4DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_HG_0DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HGA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Pressure"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MaximumExpectedOperatingPressure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MaximumOperatingPressure",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Maximum Operating Pressure", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-IN2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_32DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroTORR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_60DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARYE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA_A");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroATM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliTORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_60DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR_A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR_A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckPressure"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_H2O_4DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_HG_0DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HGA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Pressure"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MaximumOperatingPressure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MeanEnergyImparted",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "ε̅",
    undefined
  );
  quantityKind.addLabel(new LangString("Mean Energy Imparted", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MeanEnergyImparted",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MeanFreePath",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "λ",
    undefined
  );
  quantityKind.addLabel(new LangString("Mean Free Path", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MeanFreePath",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MeanLifetime",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Mean Lifetime", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliH-PER-KiloOHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/WK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckTime");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Common");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MO_MeanGREGORIAN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HR_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoSEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroH-PER-KiloOHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H-PER-OHM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroH-PER-OHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DAY_Sidereal");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliPA-SEC-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO_Synodic");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POISE-PER-BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiPOISE-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POISE-PER-PA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliH-PER-OHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_TROPICAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H-PER-KiloOHM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Metrology");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PA-SEC-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloYR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaYR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO_MeanJulian");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Time"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MeanLifetime",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MeanLinearRange",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "R",
    undefined
  );
  quantityKind.addLabel(new LangString("Mean Linear Range", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MeanLinearRange",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MeanMassRange",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Mean Mass Range", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-YD2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MeanMassRange",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MechanicalEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "E",
    undefined
  );
  quantityKind.addLabel(new LangString("Mechanical Energy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MechanicalEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MechanicalImpedance",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Mechanical Impedance", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MechanicalImpedance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MechanicalMobility",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Mechanical Mobility", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOHM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MechanicalMobility",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MechanicalSurfaceImpedance",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-1D0",
    "Z",
    undefined
  );
  quantityKind.addLabel(new LangString("Mechanical surface impedance", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MechanicalSurfaceImpedance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MechanicalTension",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    "0173-1#Z4-BAJ204#005",
    undefined
  );
  quantityKind.addLabel(new LangString("mechanical tension", "en-US"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-IN2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_32DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroTORR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_60DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARYE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA_A");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroATM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliTORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_60DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR_A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR_A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckPressure"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_H2O_4DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_HG_0DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HGA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ForcePerArea"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MechanicalTension",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MeltingPoint",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Melting Point Temperature", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliDEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_R");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckTemperature"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_F");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Temperature"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MeltingPoint",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MicroCanonicalPartitionFunction",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Micro Canonical Partition Function", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CanonicalPartitionFunction"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MicroCanonicalPartitionFunction",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MicrobialFormation",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Microbial Formation", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MicrobialFormation",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MigrationArea",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    "M^2",
    undefined
  );
  quantityKind.addLabel(new LangString("Migration Area", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckArea");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloMIL_Circ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIL_Circ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaARE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PIXEL_AREA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Area"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MigrationArea",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MigrationLength",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "M",
    undefined
  );
  quantityKind.addLabel(new LangString("Migration Length", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MigrationLength",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Mobility",
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M-1H0T2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("mobilità", "it"));
  quantityKind.addLabel(new LangString("迁移率", "zh"));
  quantityKind.addLabel(new LangString("mobilidade", "pt"));
  quantityKind.addLabel(new LangString("قابلية التحرك", "ar"));
  quantityKind.addLabel(new LangString("movilidad", "es"));
  quantityKind.addLabel(new LangString("mobility", "en"));
  quantityKind.addLabel(new LangString("移動度", "ja"));
  quantityKind.addLabel(new LangString("mobilność", "pl"));
  quantityKind.addLabel(new LangString("mobilité", "fr"));
  quantityKind.addLabel(new LangString("Beweglichkeit", "de"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM2-PER-V-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-V-SEC");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Mobility",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MobilityRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "b",
    undefined
  );
  quantityKind.addLabel(new LangString("Mobility Ratio", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MobilityRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ModulusOfAdmittance",
    "http://qudt.org/vocab/dimensionvector/A0E2L-2I0M-1H0T3D0",
    "Y",
    undefined
  );
  quantityKind.addLabel(new LangString("Modulus Of Admittance", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ModulusOfAdmittance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ModulusOfElasticity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    "E",
    undefined
  );
  quantityKind.addLabel(new LangString("Modulus of Elasticity", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-IN2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ModulusOfElasticity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ModulusOfImpedance",
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H0T-3D0",
    "Z",
    undefined
  );
  quantityKind.addLabel(new LangString("Modulus Of Impedance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OHM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ModulusOfImpedance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ModulusOfLinearSubgradeReaction",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Modulus of Linear Subgrade Reaction", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ForcePerArea"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ModulusOfLinearSubgradeReaction",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ModulusOfRotationalSubgradeReaction",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Modulus of Rotational Subgrade Reaction", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-M-PER-DEG-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-M-PER-M-RAD");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-M-PER-DEG-M"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ForcePerAngle"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ModulusOfRotationalSubgradeReaction",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ModulusOfSubgradeReaction",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Modulus of Subgrade Reaction", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN-PER-M3");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ModulusOfSubgradeReaction",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MoistureDiffusivity",
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    "q_V",
    undefined
  );
  quantityKind.addLabel(new LangString("Moisture Diffusivity", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PINT_UK-PER-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BU_US_DRY-PER-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciM3-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PK_UK-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_UK-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliL-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliL-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_US-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT3-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BBL_UK_PET-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT3-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BU_UK-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD3-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PINT_UK-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ_VOL_UK-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_UK-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BBL_UK_PET-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliL-PER-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BBL_UK_PET-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_UK-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-YR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ_VOL_US-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BU_US_DRY-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_US-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_UK-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PINT_US-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT3-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ_VOL_UK-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PK_US_DRY-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ_VOL_US-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN3-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BBL_US_PET-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BU_UK-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BU_UK-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BBL_UK_PET-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliL-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_UK-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PK_US_DRY-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PINT_US-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PINT_US-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GAL_UK-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BBL_US-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GAL_UK-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GAL_US-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_US-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_US-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_US-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BBL_US_PET-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN3-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN3-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BU_UK-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PK_UK-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAL_UK-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_US-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PINT_US-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_UK-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD3-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_UK-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GAL_UK-PER-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciM3-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciM3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAL_US-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PK_US_DRY-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_US-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_US-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT3-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ_VOL_US-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloL-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ_VOL_US-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM3-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BBL_US-PER-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD3-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD3-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GAL_US-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GAL_US-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PK_US_DRY-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PINT_UK-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_UK-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PINT_UK-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ_VOL_UK-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PK_UK-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ_VOL_UK-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PK_UK-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BU_US_DRY-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BU_US_DRY-PER-MIN"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/VolumeFlowRate"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MoistureDiffusivity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MolalityOfSolute",
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M-1H0T0D0",
    "b_B",
    undefined
  );
  quantityKind.addLabel(new LangString("Molality of Solute", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MOL-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL_LB-PER-LB");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiMOL-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloMOL-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoMOL-PER-GM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroMOL-PER-GM"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstancePerMass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MolalityOfSolute",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MolarAbsorptionCoefficient",
    "http://qudt.org/vocab/dimensionvector/A-1E0L2I0M0H0T0D0",
    "x",
    undefined
  );
  quantityKind.addLabel(new LangString("Molar Absorption Coefficient", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-MOL");
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/MolarAttenuationCoefficient"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MolarAbsorptionCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MolarAngularMomentum",
    "http://qudt.org/vocab/dimensionvector/A-1E0L2I0M1H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Molar Angular Momentum", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-SEC-PER-MOL");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MolarAngularMomentum",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MolarAttenuationCoefficient",
    "http://qudt.org/vocab/dimensionvector/A-1E0L2I0M0H0T0D0",
    "x",
    undefined
  );
  quantityKind.addLabel(new LangString("Molar Attenuation Coefficient", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-MOL");
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/MolarAbsorptionCoefficient"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MolarAttenuationCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MolarConductivity",
    "http://qudt.org/vocab/dimensionvector/A-1E2L0I0M-1H0T3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Molar Conductivity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/S-M2-PER-MOL");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MolarConductivity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MolarDensity",
    "http://qudt.org/vocab/dimensionvector/A-1E0L0I0M0H0T0D0",
    "0173-1#Z4-BAJ372#002",
    undefined
  );
  quantityKind.addLabel(new LangString("molar density", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MolarDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MolarEnergy",
    "http://qudt.org/vocab/dimensionvector/A-1E0L2I0M1H0T-2D0",
    "U_M",
    undefined
  );
  quantityKind.addLabel(new LangString("Molar Energy", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-MOL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-MOL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ-PER-MOL");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MolarEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MolarEntropy",
    "http://qudt.org/vocab/dimensionvector/A-1E0L2I0M1H-1T-2D0",
    "S_m",
    undefined
  );
  quantityKind.addLabel(new LangString("Molar Entropy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-MOL-K");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MolarEntropy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MolarEquivalent",
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T0D0",
    "equiv",
    undefined
  );
  quantityKind.addLabel(new LangString("Molar Equivalent", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoMOL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OSM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiMOL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoMOL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliOSM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloMOL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SCF");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SCM_1ATM_15DEG_C_ISO"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NCM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SCM_1ATM_0DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliMOL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoMOL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SCM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroMOL");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NCM_1ATM_0DEG_C_NL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL_LB");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SCM_1ATM_15DEG_C_NL"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstance"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MolarEquivalent",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MolarFlowRate",
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T-1D0",
    "q_V",
    undefined
  );
  quantityKind.addLabel(new LangString("Molar Flow Rate", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SCM-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SCF-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SCM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SCF-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloMOL-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloMOL-PER-MIN"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MolarFlowRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MolarFluxDensity",
    "http://qudt.org/vocab/dimensionvector/A1E0L-2I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Molar Flux Density", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliMOL-PER-M2-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoMOL-PER-M2-SEC"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MolarFluxDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MolarFluxDensityVariance",
    "http://qudt.org/vocab/dimensionvector/A2E0L-4I0M0H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Molar Flux Density Variance", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroMOL2-PER-M4-SEC2"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MolarFluxDensityVariance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MolarFluxDensityVariance_NEON",
    "http://qudt.org/vocab/dimensionvector/A2E0L-4I0M0H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Molar Flux Density Variance, NEON", "en")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MolarFluxDensityVariance_NEON",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MolarHeatCapacity",
    "http://qudt.org/vocab/dimensionvector/A-1E0L2I0M1H-1T-2D0",
    "C_m",
    undefined
  );
  quantityKind.addLabel(new LangString("Molar Heat Capacity", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-MOL-DEG_C"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-MOL_LB-DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-MOL-K");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MolarHeatCapacity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MolarInternalEnergy",
    "http://qudt.org/vocab/dimensionvector/A-1E0L2I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("molar internal energy", undefined));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-MOL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-MOL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ-PER-MOL");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MolarEnergy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MolarInternalEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MolarMass",
    "http://qudt.org/vocab/dimensionvector/A-1E0L0I0M1H0T0D0",
    "M",
    undefined
  );
  quantityKind.addLabel(new LangString("masa molar", "es"));
  quantityKind.addLabel(new LangString("molar mass", "en"));
  quantityKind.addLabel(new LangString("摩尔质量", "zh"));
  quantityKind.addLabel(new LangString("جرم مولی", "fa"));
  quantityKind.addLabel(new LangString("Masa molowa", "pl"));
  quantityKind.addLabel(new LangString("massa molar", "pt"));
  quantityKind.addLabel(new LangString("モル質量", "ja"));
  quantityKind.addLabel(new LangString("Молярная масса", "ru"));
  quantityKind.addLabel(new LangString("كتلة مولية", "ar"));
  quantityKind.addLabel(new LangString("massa molare", "it"));
  quantityKind.addLabel(new LangString("molar kütle", "tr"));
  quantityKind.addLabel(new LangString("Jisim molar", "ms"));
  quantityKind.addLabel(new LangString("मोलर द्रव्यमान", "hi"));
  quantityKind.addLabel(new LangString("masse molaire", "fr"));
  quantityKind.addLabel(new LangString("Molmasse", "de"));
  quantityKind.addLabel(new LangString("Masă molară", "ro"));
  quantityKind.addLabel(new LangString("Molární hmotnost", "cs"));
  quantityKind.addLabel(new LangString("molska masa", "sl"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-MOL");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-KiloMOL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-MOL"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MolarMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MolarOpticalRotationalAbility",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M-1H0T0D0",
    "0173-1#Z4-BAJ426#001",
    undefined
  );
  quantityKind.addLabel(
    new LangString("molar optical rotational ability", "en-US")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MolarOpticalRotationalAbility",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MolarOpticalRotatoryPower",
    "http://qudt.org/vocab/dimensionvector/A-1E0L2I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Molar Optical Rotatory Power", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/RAD-M2-PER-MOL"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MolarOpticalRotatoryPower",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MolarRefractivity",
    "http://qudt.org/vocab/dimensionvector/A-1E0L3I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Molar Refractivity", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/L-PER-MicroMOL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-MOL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-MOL");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciM3-PER-MOL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-MOL"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MolarRefractivity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MolarThermalCapacity",
    "http://qudt.org/vocab/dimensionvector/A-1E0L2I0M1H-1T-2D0",
    "0173-1#Z4-BAJ355#002",
    undefined
  );
  quantityKind.addLabel(new LangString("molar thermal capacity", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MolarThermalCapacity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MolarThermodynamicEnergy",
    "http://qudt.org/vocab/dimensionvector/A-1E0L2I0M1H0T-2D0",
    "0173-1#Z4-BAJ353#002",
    undefined
  );
  quantityKind.addLabel(new LangString("molar thermodynamic energy", "en-US"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-MOL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-MOL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ-PER-MOL");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MolarEnergy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MolarThermodynamicEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MolarVolume",
    "http://qudt.org/vocab/dimensionvector/A-1E0L3I0M0H0T0D0",
    "V_m",
    undefined
  );
  quantityKind.addLabel(new LangString("volume molar", "pl"));
  quantityKind.addLabel(new LangString("volume molare", "it"));
  quantityKind.addLabel(new LangString("摩尔体积", "zh"));
  quantityKind.addLabel(new LangString("molski volumen", "sl"));
  quantityKind.addLabel(new LangString("حجم مولی", "fa"));
  quantityKind.addLabel(new LangString("molární objem", "cs"));
  quantityKind.addLabel(new LangString("حجم مولي", "ar"));
  quantityKind.addLabel(new LangString("Molvolumen", "de"));
  quantityKind.addLabel(new LangString("molar hacim", "tr"));
  quantityKind.addLabel(new LangString("volume molar", "pt"));
  quantityKind.addLabel(new LangString("molar volume", "en"));
  quantityKind.addLabel(new LangString("モル体積", "ja"));
  quantityKind.addLabel(new LangString("volum molar", "ro"));
  quantityKind.addLabel(new LangString("volume molaire", "fr"));
  quantityKind.addLabel(new LangString("Молярный объём", "ru"));
  quantityKind.addLabel(new LangString("volumen molar", "es"));
  quantityKind.addLabel(new LangString("Isipadu molar", "ms"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/L-PER-MicroMOL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-MOL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-MOL");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciM3-PER-MOL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-MOL"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MolarVolume",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MoleFraction",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Mole Fraction", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ONE-PER-ONE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERMITTIVITY_REL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MoleFraction",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MolecularConcentration",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    "C_B",
    undefined
  );
  quantityKind.addLabel(new LangString("Molecular Concentration", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-MicroL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-NanoL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-MilliM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-PicoL");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/NumberDensity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MolecularConcentration",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MolecularMass",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    "M",
    undefined
  );
  quantityKind.addLabel(new LangString("Molecular Mass", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DA");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MolecularMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MolecularViscosity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Molecular Viscosity", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MolecularViscosity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MomentOfForce",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "M",
    undefined
  );
  quantityKind.addLabel(new LangString("Moment of Force", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_F-IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM_F-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciN-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliN-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DYN-CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiN-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DYN-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroN-M");
  quantityKind.addExactMatchIri("http://qudt.org/vocab/quantitykind/Torque");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MomentOfForce",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MomentOfInertia",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T0D0",
    "I",
    undefined
  );
  quantityKind.addLabel(new LangString("慣性モーメント", "ja"));
  quantityKind.addLabel(new LangString("Momen inersia", "ms"));
  quantityKind.addLabel(new LangString("Moment bezwładności", "pl"));
  quantityKind.addLabel(new LangString("Massenträgheitsmoment", "de"));
  quantityKind.addLabel(new LangString("Moment setrvačnosti", "cs"));
  quantityKind.addLabel(new LangString("گشتاور لختی", "fa"));
  quantityKind.addLabel(new LangString("Moment de inerție", "ro"));
  quantityKind.addLabel(new LangString("momento de inércia", "pt"));
  quantityKind.addLabel(new LangString("momento di inerzia", "it"));
  quantityKind.addLabel(new LangString("Eylemsizlik momenti", "tr"));
  quantityKind.addLabel(new LangString("moment d'inertie", "fr"));
  quantityKind.addLabel(new LangString("عزم القصور الذاتي", "ar"));
  quantityKind.addLabel(new LangString("moment of inertia", "en"));
  quantityKind.addLabel(new LangString("momento de inercia", "es"));
  quantityKind.addLabel(new LangString("जड़त्वाघूर्ण", "hi"));
  quantityKind.addLabel(new LangString("Момент инерции", "ru"));
  quantityKind.addLabel(new LangString("轉動慣量", "zh"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-FT2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-MilliM2"
  );
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/RotationalMass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MomentOfInertia",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MomentOfInertia_Y",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T0D0",
    "I_{y}",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Moment of Inertia in the Y axis", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-FT2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-MilliM2"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MomentOfInertia"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MomentOfInertia_Y",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MomentOfInertia_Z",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T0D0",
    "I_{z}",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Moment of Inertia in the Z axis", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-FT2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-MilliM2"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MomentOfInertia"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MomentOfInertia_Z",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Momentum",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-1D0",
    "p",
    undefined
  );
  quantityKind.addLabel(new LangString("动量", "zh"));
  quantityKind.addLabel(new LangString("impuls", "ro"));
  quantityKind.addLabel(new LangString("quantité de mouvement", "fr"));
  quantityKind.addLabel(new LangString("تکانه", "fa"));
  quantityKind.addLabel(new LangString("momento linear", "pt"));
  quantityKind.addLabel(new LangString("Momentum", "ms"));
  quantityKind.addLabel(new LangString("cantidad de movimiento", "es"));
  quantityKind.addLabel(new LangString("運動量", "ja"));
  quantityKind.addLabel(new LangString("quantità di moto", "it"));
  quantityKind.addLabel(new LangString("pęd", "pl"));
  quantityKind.addLabel(new LangString("hybnost", "cs"));
  quantityKind.addLabel(new LangString("gibalna količina", "sl"));
  quantityKind.addLabel(new LangString("momentum", "en"));
  quantityKind.addLabel(new LangString("Impuls", "de"));
  quantityKind.addLabel(new LangString("Momentum", "tr"));
  quantityKind.addLabel(new LangString("импульс", "ru"));
  quantityKind.addLabel(new LangString("زخم الحركة", "ar"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaEV-PER-SpeedOfLight"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-M-SEC-PER-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckMomentum"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-M-PER-SEC"
  );
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/LinearMomentum"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Momentum",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MomentumPerAngle",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Momentum per Angle", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-SEC-PER-RAD");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MomentumPerAngle",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MorbidityRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Morbidity Rate", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CASES-PER-KiloINDIV-YR"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Incidence"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MorbidityRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MortalityRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Mortality Rate", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEATHS-PER-MegaINDIV-YR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEATHS-PER-KiloINDIV-YR"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Incidence"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MortalityRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MotorConstant",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "0173-1#Z4-BAJ358#003",
    undefined
  );
  quantityKind.addLabel(new LangString("motor constant", undefined));
  quantityKind.addLabel(new LangString("motor constant", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MotorConstant",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MultiplicationFactor",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "k",
    undefined
  );
  quantityKind.addLabel(new LangString("Multiplication Factor", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MultiplicationFactor",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MutualInductance",
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H0T-2D0",
    "L_{mn}",
    undefined
  );
  quantityKind.addLabel(new LangString("Mutual Inductance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H_Ab");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H_Stat");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Inductance"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MutualInductance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/NOMINAL-ASCENT-PROPELLANT-MASS",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Nominal Ascent Propellant Mass", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PENNYWEIGHT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/NOMINAL-ASCENT-PROPELLANT-MASS",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/NapierianAbsorbance",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "A_e, B",
    undefined
  );
  quantityKind.addLabel(new LangString("Napierian Absorbance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/NapierianAbsorbance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/NaturalLogarithmicMedianInformationFlow",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    "0173-1#Z4-BAJ471#001",
    undefined
  );
  quantityKind.addLabel(
    new LangString(
      "median information flow (from a source of information), expressed as a natural logarithm ",
      "en-US"
    )
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/NaturalLogarithmicMedianInformationFlow",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/NeelTemperature",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T0D0",
    "T_C",
    undefined
  );
  quantityKind.addLabel(new LangString("Neel Temperature", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliDEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_R");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckTemperature"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_F");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Temperature"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/NeelTemperature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/NeutralRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "0173-1#Z4-BAJ359#002",
    undefined
  );
  quantityKind.addLabel(new LangString("neutral ratio", "en-US"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ONE-PER-ONE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERMITTIVITY_REL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/NeutralRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/NeutronDiffusionCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-1D0",
    "D",
    undefined
  );
  quantityKind.addLabel(new LangString("Diffusionskoeffizient", "de"));
  quantityKind.addLabel(new LangString("coeficiente de difusión", "es"));
  quantityKind.addLabel(new LangString("coefficiente di diffusione", "it"));
  quantityKind.addLabel(new LangString("coefficient de diffusion", "fr"));
  quantityKind.addLabel(new LangString("coeficiente de difusão", "pt"));
  quantityKind.addLabel(new LangString("difuzijski koeficient", "sl"));
  quantityKind.addLabel(new LangString("diffusion coefficient", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-SEC");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/NeutronDiffusionCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/NeutronDiffusionLength",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "L_{r}",
    undefined
  );
  quantityKind.addLabel(new LangString("Neutron Diffusion Length", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/NeutronDiffusionLength",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/NeutronNumber",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "N",
    undefined
  );
  quantityKind.addLabel(new LangString("liczba neutronowa", "pl"));
  quantityKind.addLabel(new LangString("Nombor neutron", "ms"));
  quantityKind.addLabel(new LangString("Neutronové číslo", "cs"));
  quantityKind.addLabel(new LangString("numero neutronico", "it"));
  quantityKind.addLabel(new LangString("число нейтронов", "ru"));
  quantityKind.addLabel(new LangString("Nombre de neutrons", "fr"));
  quantityKind.addLabel(new LangString("número neutrónico", "es"));
  quantityKind.addLabel(new LangString("عدد نوترون", "fa"));
  quantityKind.addLabel(new LangString("número de neutrons", "pt"));
  quantityKind.addLabel(new LangString("Neutronenzahl", "de"));
  quantityKind.addLabel(new LangString("neutron number", "en"));
  quantityKind.addLabel(new LangString("中子數", "zh"));
  quantityKind.addLabel(new LangString("nötron snumarası", "tr"));
  quantityKind.addLabel(new LangString("عدد النيوترونات", "ar"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Count"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/NeutronNumber",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/NeutronYieldPerAbsorption",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Neutron Yield per Absorption", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/NeutronYieldPerAbsorption",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/NeutronYieldPerFission",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Neutron Yield per Fission", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/NeutronYieldPerFission",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Non-LeakageProbability",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Non-Leakage Probability", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Non-LeakageProbability",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/NonActivePower",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    "Q'",
    undefined
  );
  quantityKind.addLabel(new LangString("Non-active Power", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/NonActivePower",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/NonNegativeLength",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Positive Length", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/NonNegativeLength",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/NormalStress",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Normal Stress", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-IN2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_32DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroTORR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_60DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARYE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA_A");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroATM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliTORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_60DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR_A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR_A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckPressure"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_H2O_4DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_HG_0DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HGA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Stress"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/NormalStress",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/NormalizedDimensionlessRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Positive Dimensionless Ratio", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ONE-PER-ONE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERMITTIVITY_REL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/NormalizedDimensionlessRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/NozzleThroatCrossSectionalArea",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    "A^*",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Nozzle Throat Cross-sectional Area", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckArea");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloMIL_Circ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIL_Circ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaARE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PIXEL_AREA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Area"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/NozzleThroatCrossSectionalArea",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/NozzleThroatDiameter",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Nozzle Throat Diameter", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/NozzleThroatDiameter",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/NozzleThroatPressure",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    "p^*",
    undefined
  );
  quantityKind.addLabel(new LangString("Nozzle Throat Pressure", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-IN2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_32DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroTORR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_60DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARYE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA_A");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroATM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliTORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_60DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR_A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR_A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckPressure"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_H2O_4DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_HG_0DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HGA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Pressure"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/NozzleThroatPressure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/NozzleWallsThrustReaction",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    "F_R",
    undefined
  );
  quantityKind.addLabel(new LangString("Nozzle Walls Thrust Reaction", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_F_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPOND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-M-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DYN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckForce");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Force"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/NozzleWallsThrustReaction",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/NuclearEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("nuclear energy", undefined));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/NuclearEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/NuclearQuadrupoleMoment",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    "Q",
    undefined
  );
  quantityKind.addLabel(new LangString("Nuclear Quadrupole Moment", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/NuclearQuadrupoleMoment",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/NuclearRadius",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "R",
    undefined
  );
  quantityKind.addLabel(new LangString("Nuclear Radius", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/NuclearRadius",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/NuclearSpinQuantumNumber",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "I",
    undefined
  );
  quantityKind.addLabel(new LangString("Spin Quantum Number", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpinQuantumNumber"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/NuclearSpinQuantumNumber",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/NucleonNumber",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "A",
    undefined
  );
  quantityKind.addLabel(new LangString("numero di massa", "it"));
  quantityKind.addLabel(new LangString("عدد جرمی", "fa"));
  quantityKind.addLabel(new LangString("liczba masowa", "pl"));
  quantityKind.addLabel(new LangString("nucleon number", "en"));
  quantityKind.addLabel(new LangString("質量数", "ja"));
  quantityKind.addLabel(new LangString("nükleon numarası", "tr"));
  quantityKind.addLabel(new LangString("Nukleonenzahl", "de"));
  quantityKind.addLabel(new LangString("número de massa", "pt"));
  quantityKind.addLabel(new LangString("nombre de masse", "fr"));
  quantityKind.addLabel(new LangString("Nukleové číslo", "cs"));
  quantityKind.addLabel(new LangString("Nombor nukleon", "ms"));
  quantityKind.addLabel(new LangString("质量数", "zh"));
  quantityKind.addLabel(new LangString("número másico", "es"));
  quantityKind.addLabel(new LangString("عدد كتلي", "ar"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Count"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/NucleonNumber",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/NumberDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    "n",
    undefined
  );
  quantityKind.addLabel(new LangString("Number Density", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-MicroL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-NanoL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-MilliM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-PicoL");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InverseVolume"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/NumberDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/NumberOfParticles",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "N_B",
    undefined
  );
  quantityKind.addLabel(new LangString("Number of Particles", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/NumberOfParticles",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/OlfactoryThreshold",
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Olfactory Threshold", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoMOL-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FemtoMOL-PER-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoMOL-PER-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoMOL-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MOL-PER-DeciM3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliMOL-PER-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloMOL-PER-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliMOL-PER-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiMOL-PER-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroMOL-PER-L"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Concentration"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/OlfactoryThreshold",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/OpeningRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Opening Ratio", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/OpeningRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/OrbitalAngularMomentumPerMass",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-1D0",
    "h",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Orbital Angular Momentum per Mass", "en")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/OrbitalAngularMomentumPerMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/OrbitalAngularMomentumQuantumNumber",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "l",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Orbital Angular Momentum Quantum Number", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/QuantumNumber"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/OrbitalAngularMomentumQuantumNumber",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/OrbitalRadialDistance",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "r",
    undefined
  );
  quantityKind.addLabel(new LangString("Orbital Radial Distance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/OrbitalRadialDistance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/OrderOfReflection",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "n",
    undefined
  );
  quantityKind.addLabel(new LangString("Order of Reflection", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/OrderOfReflection",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/OsmoticCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Osmotic Coefficient", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/OsmoticCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/OsmoticConcentration",
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Osmotic Concentration", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/OsmoticConcentration",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/OsmoticPressure",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    "Π",
    undefined
  );
  quantityKind.addLabel(new LangString("Tekanan osmotik", "ms"));
  quantityKind.addLabel(new LangString("presión osmótica", "es"));
  quantityKind.addLabel(new LangString("pressione osmotica", "it"));
  quantityKind.addLabel(new LangString("osmotic pressure", "en"));
  quantityKind.addLabel(new LangString("osmotischer Druck", "de"));
  quantityKind.addLabel(new LangString("فشار اسمزی", "fa"));
  quantityKind.addLabel(new LangString("pression osmotique", "fr"));
  quantityKind.addLabel(new LangString("Osmotický tlak", "cs"));
  quantityKind.addLabel(new LangString("ozmotik basıç", "tr"));
  quantityKind.addLabel(new LangString("pressão osmótica", "pt"));
  quantityKind.addLabel(new LangString("渗透压", "zh"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-IN2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_32DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroTORR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_60DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARYE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA_A");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroATM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliTORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_60DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR_A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR_A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckPressure"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_H2O_4DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_HG_0DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HGA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Pressure"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/OsmoticPressure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/OverRangeDistance",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "s_i",
    undefined
  );
  quantityKind.addLabel(new LangString("Over-range distance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/OverRangeDistance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PREDICTED-MASS",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Predicted Mass", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PENNYWEIGHT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PREDICTED-MASS",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PRODUCT-OF-INERTIA",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Product of Inertia", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PRODUCT-OF-INERTIA",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PRODUCT-OF-INERTIA_X",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Product of Inertia in the X axis", "en")
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PRODUCT-OF-INERTIA"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PRODUCT-OF-INERTIA_X",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PRODUCT-OF-INERTIA_Y",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Product of Inertia in the Y axis", "en")
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PRODUCT-OF-INERTIA"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PRODUCT-OF-INERTIA_Y",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PRODUCT-OF-INERTIA_Z",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Product of Inertia in the Z axis", "en")
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PRODUCT-OF-INERTIA"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PRODUCT-OF-INERTIA_Z",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Pace",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Pace", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN-PER-KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN-PER-MI");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Pace",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PackingFraction",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "f",
    undefined
  );
  quantityKind.addLabel(new LangString("Packing Fraction", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PackingFraction",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PartialPressure",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    "p_B",
    undefined
  );
  quantityKind.addLabel(new LangString("Partial Pressure", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-IN2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_32DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroTORR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_60DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARYE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA_A");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroATM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliTORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_60DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR_A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR_A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckPressure"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_H2O_4DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_HG_0DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HGA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Pressure"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PartialPressure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ParticleCurrent",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    "J",
    undefined
  );
  quantityKind.addLabel(new LangString("Particle Current", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaHZ");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-WK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaHZ");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraHZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MilliSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MO");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-YR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SAMPLE-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliHZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-WK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckFrequency"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaHZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-MO"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloHZ");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-YR"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Frequency"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ParticleCurrent",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ParticleCurrentDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T-1D0",
    "0173-1#Z4-BAJ388#002",
    undefined
  );
  quantityKind.addLabel(new LangString("particle current density", undefined));
  quantityKind.addLabel(new LangString("particle current density", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ParticleCurrentDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ParticleFluence",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Particle Fluence", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-M-NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-HA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-KiloM2"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ParticleFluence",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ParticleFluenceRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Particle Fluence Rate", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-L-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-M2-SEC");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ParticleFluenceRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ParticleNumberDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    "n",
    undefined
  );
  quantityKind.addLabel(new LangString("Particle Number Density", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-MicroL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-NanoL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-MilliM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-PicoL");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/NumberDensity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ParticleNumberDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ParticlePositionVector",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "r, R",
    undefined
  );
  quantityKind.addLabel(new LangString("Particle Position Vector", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ParticlePositionVector",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ParticleSourceDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T-1D0",
    "S",
    undefined
  );
  quantityKind.addLabel(new LangString("Particle Source Density", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-M3-SEC");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ParticleSourceDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PathLength",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "s",
    undefined
  );
  quantityKind.addLabel(new LangString("Path Length", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PathLength",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PayloadMass",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    "M_P",
    undefined
  );
  quantityKind.addLabel(new LangString("Payload Mass", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PENNYWEIGHT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PayloadMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PayloadRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "L",
    undefined
  );
  quantityKind.addLabel(new LangString("Payload Ratio", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ONE-PER-ONE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERMITTIVITY_REL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PayloadRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PeltierCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Peltier Coefficient", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PeltierCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Period",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Period", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaSEC");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Period",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Permeability",
    "http://qudt.org/vocab/dimensionvector/A0E-2L1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Permeability", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H-PER-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/H_Stat-PER-CentiM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoH-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroH-PER-M");
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/ElectromagneticPermeability"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Permeability",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PermeabilityRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Permeability Ratio", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERMEABILITY_REL"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PermeabilityRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Permeance",
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Permeance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoH");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Permeance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Permittivity",
    "http://qudt.org/vocab/dimensionvector/A0E2L-3I0M-1H0T4D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Permittivity", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroFARAD-PER-KiloM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroFARAD-PER-M"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FARAD_Ab-PER-CentiM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FARAD-PER-KiloM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoFARAD-PER-M"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoFARAD-PER-M"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FARAD-PER-M");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Permittivity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PermittivityRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Permittivity Ratio", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PermittivityRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PhaseCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Phase coefficient", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-NanoM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PhaseCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PhaseDifference",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("اختلاف طور", "ar"));
  quantityKind.addLabel(new LangString("Phasenverschiebungswinkel", "de"));
  quantityKind.addLabel(new LangString("位相差", "ja"));
  quantityKind.addLabel(new LangString("différence de phase", "fr"));
  quantityKind.addLabel(new LangString("phase difference", "en"));
  quantityKind.addLabel(new LangString("diferença de fase", "pt"));
  quantityKind.addLabel(new LangString("diferencia de fase", "es"));
  quantityKind.addLabel(new LangString("przesunięcie fazowe", "pl"));
  quantityKind.addLabel(new LangString("sfasamento angolare", "it"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARCSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARCMIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN_Angle");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliARCSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/REV");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Angle"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PhaseDifference",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PhaseSpeedOfSound",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    "c",
    undefined
  );
  quantityKind.addLabel(new LangString("Phase speed of sound", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloHZ-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaHZ-M");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpeedOfSound"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PhaseSpeedOfSound",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PhononMeanFreePath",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "l_{ph}",
    undefined
  );
  quantityKind.addLabel(new LangString("Phonon Mean Free Path", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PhononMeanFreePath",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PhotoThresholdOfAwarenessFunction",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Photo Threshold of Awareness Function", "en")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PhotoThresholdOfAwarenessFunction",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PhotonIntensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Photon Intensity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-SEC-SR");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PhotonIntensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PhotonLuminance",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T-1D0",
    "0173-1#Z4-BAJ363#002",
    undefined
  );
  quantityKind.addLabel(new LangString("photon luminance", "en-US"));
  quantityKind.addLabel(new LangString("photon luminance", undefined));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PhotonLuminance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PhotonRadiance",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Photon Radiance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-SEC-M2-SR");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PhotonRadiance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PhotosyntheticPhotonFlux",
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Photosynthetic Photon Flux", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroMOL-PER-SEC"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PhotosyntheticPhotonFlux",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PhotosyntheticPhotonFluxDensity",
    "http://qudt.org/vocab/dimensionvector/A1E0L-2I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Photosynthetic Photon Flux Density", "en")
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliMOL-PER-M2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroMOL-PER-M2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MOL-PER-M2-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoMOL-PER-M2-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroMOL-PER-M2-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroMOL-PER-M2-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliMOL-PER-M2-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoMOL-PER-M2-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MOL-PER-M2-SEC"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PhotosyntheticPhotonFluxDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PictureElement",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "0173-1#Z4-BAJ437#002",
    undefined
  );
  quantityKind.addLabel(new LangString("picture element", undefined));
  quantityKind.addLabel(new LangString("picture element", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PictureElement",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Piece",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("piece", undefined));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MILLION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ONE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HUNDRED");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PIXEL_COUNT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BILLION_Short");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THOUSAND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BILLION_Long");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/COUNT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TEN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Count"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Piece",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PlanarForce",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    "p",
    undefined
  );
  quantityKind.addLabel(new LangString("Flächenlast", "de"));
  quantityKind.addLabel(new LangString("Planar Force", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-IN2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_32DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroTORR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_60DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARYE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA_A");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroATM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliTORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_60DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR_A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR_A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckPressure"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_H2O_4DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_HG_0DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HGA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ForcePerArea"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PlanarForce",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PlanckFunction",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Planck Function", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PlanckFunction",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PlaneAngle",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Rovinný úhel", "cs"));
  quantityKind.addLabel(new LangString("क्षेत्र", "hi"));
  quantityKind.addLabel(new LangString("זווית", "he"));
  quantityKind.addLabel(new LangString("Равнинен ъгъл", "bg"));
  quantityKind.addLabel(new LangString("زاویه مستوی", "fa"));
  quantityKind.addLabel(new LangString("plane angle", "en"));
  quantityKind.addLabel(new LangString("angulus planus", "la"));
  quantityKind.addLabel(new LangString("弧度", "ja"));
  quantityKind.addLabel(new LangString("角度", "zh"));
  quantityKind.addLabel(new LangString("kąt płaski", "pl"));
  quantityKind.addLabel(new LangString("Плоский угол", "ru"));
  quantityKind.addLabel(new LangString("ángulo plano", "es"));
  quantityKind.addLabel(new LangString("Επίπεδη γωνία", "el"));
  quantityKind.addLabel(new LangString("düzlemsel açı", "tr"));
  quantityKind.addLabel(new LangString("Sudut satah", "ms"));
  quantityKind.addLabel(new LangString("ebener Winkel", "de"));
  quantityKind.addLabel(new LangString("angolo piano", "it"));
  quantityKind.addLabel(new LangString("szög", "hu"));
  quantityKind.addLabel(new LangString("unghi plan", "ro"));
  quantityKind.addLabel(new LangString("medida angular", "pt"));
  quantityKind.addLabel(new LangString("angle plan", "fr"));
  quantityKind.addLabel(new LangString("الزاوية النصف قطرية", "ar"));
  quantityKind.addLabel(new LangString("ravninski kot", "sl"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARCSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARCMIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN_Angle");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliARCSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/REV");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  quantityKind.addExactMatchIri("http://qudt.org/vocab/quantitykind/Angle");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PlaneAngle",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PlasmaLevel",
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Plasma Level", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IU-PER-MilliL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IU-PER-L");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstancePerVolume"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PlasmaLevel",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PoissonRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Poisson Ratio", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PoissonRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PolarMomentOfInertia",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T0D0",
    "J_{zz}",
    undefined
  );
  quantityKind.addLabel(new LangString("Polar moment of inertia", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-FT2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-MilliM2"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MomentOfInertia"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PolarMomentOfInertia",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Polarizability",
    "http://qudt.org/vocab/dimensionvector/A0E2L0I0M-1H0T4D0",
    "0173-1#Z4-BAJ365#002",
    undefined
  );
  quantityKind.addLabel(new LangString("polarisability", "en"));
  quantityKind.addLabel(new LangString("Polarizability", "en-US"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C2-M2-PER-J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-M2-PER-V");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Polarizability",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PolarizationField",
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H0T1D0",
    "P",
    undefined
  );
  quantityKind.addLabel(new LangString("Polarization Field", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/C_Ab-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-HR-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroC-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/C_Stat-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliC-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaC-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloC-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerArea"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PolarizationField",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Population",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Population", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Count"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Population",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PositionVector",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "r",
    undefined
  );
  quantityKind.addLabel(new LangString("Position Vector", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PositionVector",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PositiveDimensionlessRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Positive Dimensionless Ratio", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ONE-PER-ONE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERMITTIVITY_REL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PositiveDimensionlessRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PositiveLength",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Positive Length", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/NonNegativeLength"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PositiveLength",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PositivePlaneAngle",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Positive Plane Angle", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARCSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARCMIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN_Angle");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliARCSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/REV");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PlaneAngle"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PositivePlaneAngle",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PotentialEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "PE",
    undefined
  );
  quantityKind.addLabel(new LangString("Tenaga keupayaan", "ms"));
  quantityKind.addLabel(new LangString("energia potenziale", "it"));
  quantityKind.addLabel(new LangString("انرژی پتانسیل", "fa"));
  quantityKind.addLabel(new LangString("потенциальная энергия", "ru"));
  quantityKind.addLabel(new LangString("Energia potencjalna", "pl"));
  quantityKind.addLabel(new LangString("potentielle Energie", "de"));
  quantityKind.addLabel(new LangString("Potansiyel enerji", "tr"));
  quantityKind.addLabel(new LangString("势能", "zh"));
  quantityKind.addLabel(new LangString("énergie potentielle", "fr"));
  quantityKind.addLabel(new LangString("طاقة وضع", "ar"));
  quantityKind.addLabel(new LangString("位置エネルギー", "ja"));
  quantityKind.addLabel(new LangString("energía potencial", "es"));
  quantityKind.addLabel(new LangString("potential energy", "en"));
  quantityKind.addLabel(new LangString("potenciální energie", "cs"));
  quantityKind.addLabel(new LangString("स्थितिज ऊर्जा", "hi"));
  quantityKind.addLabel(new LangString("energia potencial", "pt"));
  quantityKind.addLabel(new LangString("Energie potențială", "ro"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PotentialEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Power",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    "P",
    undefined
  );
  quantityKind.addLabel(new LangString("puissance", "fr"));
  quantityKind.addLabel(new LangString("शक्ति", "hi"));
  quantityKind.addLabel(new LangString("putere", "ro"));
  quantityKind.addLabel(new LangString("Мощность", "ru"));
  quantityKind.addLabel(new LangString("Leistung", "de"));
  quantityKind.addLabel(new LangString("teljesítmény , hőáramlás", "hu"));
  quantityKind.addLabel(new LangString("הספק", "he"));
  quantityKind.addLabel(new LangString("potenza", "it"));
  quantityKind.addLabel(new LangString("potentia", "la"));
  quantityKind.addLabel(new LangString("potencia", "es"));
  quantityKind.addLabel(new LangString("Výkon", "cs"));
  quantityKind.addLabel(new LangString("moc", "pl"));
  quantityKind.addLabel(new LangString("Мощност", "bg"));
  quantityKind.addLabel(new LangString("potência", "pt"));
  quantityKind.addLabel(new LangString("power", "en"));
  quantityKind.addLabel(new LangString("توان، نرخ جریان گرما", "fa"));
  quantityKind.addLabel(new LangString("Kuasa", "ms"));
  quantityKind.addLabel(new LangString("功率、热流", "zh"));
  quantityKind.addLabel(new LangString("電力・仕事率", "ja"));
  quantityKind.addLabel(new LangString("القدرة", "ar"));
  quantityKind.addLabel(new LangString("moč", "sl"));
  quantityKind.addLabel(new LangString("Ισχύς", "el"));
  quantityKind.addLabel(new LangString("güç", "tr"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaW");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TeraW-HR-PER-YR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroJ-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFERDESTAERKE");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliJ-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliBAR-L-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaPA-L-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP_Electric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_FG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PSI-IN3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA-L-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BAR-M3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR-L-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP_Boiler");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PSI-M3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckPower");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI-L-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloBTU_IT-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA-M3-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/HectoPA-M3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaBTU_IT-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP_Brake");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaPA-M3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliW");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/HectoPA-L-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-M-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PSI-YD3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliBAR-M3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Power",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PowerArea",
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Power Area", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-M2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PowerArea",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PowerAreaPerSolidAngle",
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Power Area per Solid Angle", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-M2-PER-SR");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PowerAreaPerSolidAngle",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PowerConstant",
    "http://qudt.org/vocab/dimensionvector/A0E-1L1I0M1H0T-2D0",
    "0173-1#Z4-BAJ330#003",
    undefined
  );
  quantityKind.addLabel(new LangString("power constant", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PowerConstant",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PowerDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("PowerDensity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-M3");
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/PowerPerVolume"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PowerDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PowerFactor",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("factor de potencia", "es"));
  quantityKind.addLabel(new LangString("Účiník", "cs"));
  quantityKind.addLabel(new LangString("力率", "ja"));
  quantityKind.addLabel(new LangString("功率因数", "zh"));
  quantityKind.addLabel(new LangString("ضریب توان", "fa"));
  quantityKind.addLabel(new LangString("faktor kuasa", "ms"));
  quantityKind.addLabel(new LangString("power factor", "en"));
  quantityKind.addLabel(new LangString("Коэффициент_мощности", "ru"));
  quantityKind.addLabel(new LangString("factor de putere", "ro"));
  quantityKind.addLabel(new LangString("fator de potência", "pt"));
  quantityKind.addLabel(new LangString("Leistungsfaktor", "de"));
  quantityKind.addLabel(new LangString("معامل القدرة", "ar"));
  quantityKind.addLabel(new LangString("शक्ति गुणांक", "hi"));
  quantityKind.addLabel(new LangString("güç faktörü", "tr"));
  quantityKind.addLabel(new LangString("facteur de puissance", "fr"));
  quantityKind.addLabel(new LangString("fattore di potenza", "it"));
  quantityKind.addLabel(new LangString("Współczynnik mocy", "pl"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PowerFactor",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PowerPerArea",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Power Per Area", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-IN2-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoW-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroW-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-CentiM2-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC-FT2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/ERG-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-CentiM2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-HR-FT2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliW-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-IN2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoW-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PA-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-FT2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PowerPerArea",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PowerPerAreaAngle",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Power per Area Angle", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PowerPerAreaAngle",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PowerPerAreaQuarticTemperature",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-4T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Power per area quartic temperature", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-M2-K4");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PowerPerAreaQuarticTemperature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PowerPerElectricCharge",
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-4D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Power Per Electric Charge", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/V-PER-MicroSEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliV-PER-MIN"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PowerPerElectricCharge",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PowerPerVolume",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Power per Volume", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-M3");
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/PowerDensity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PowerPerVolume",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PoyntingVector",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("ポインティングベクトル", "ja"));
  quantityKind.addLabel(new LangString("vecteur de Poynting", "fr"));
  quantityKind.addLabel(new LangString("Poynting-Vektor", "de"));
  quantityKind.addLabel(new LangString("vector de Poynting", "pt"));
  quantityKind.addLabel(new LangString("wektor Poyntinga", "pl"));
  quantityKind.addLabel(new LangString("vettore di Poynting", "it"));
  quantityKind.addLabel(new LangString("متجَه بوينتنج", "ar"));
  quantityKind.addLabel(new LangString("Poynting vector", "en"));
  quantityKind.addLabel(new LangString("вектор Пойнтинга", "ru"));
  quantityKind.addLabel(new LangString("vector de Poynting", "es"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoW-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-M2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PoyntingVector",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Pressure",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("压强、压力", "zh"));
  quantityKind.addLabel(new LangString("pressio", "la"));
  quantityKind.addLabel(new LangString("basınç", "tr"));
  quantityKind.addLabel(new LangString("ciśnienie", "pl"));
  quantityKind.addLabel(new LangString("Давление", "ru"));
  quantityKind.addLabel(new LangString("فشار، تنش", "fa"));
  quantityKind.addLabel(new LangString("pression", "fr"));
  quantityKind.addLabel(new LangString("Tekanan", "ms"));
  quantityKind.addLabel(new LangString("nyomás", "hu"));
  quantityKind.addLabel(new LangString("presiune", "ro"));
  quantityKind.addLabel(new LangString("tlak", "sl"));
  quantityKind.addLabel(new LangString("Налягане", "bg"));
  quantityKind.addLabel(new LangString("presión", "es"));
  quantityKind.addLabel(new LangString("Πίεση - τάση", "el"));
  quantityKind.addLabel(new LangString("pressure", "en"));
  quantityKind.addLabel(new LangString("לחץ", "he"));
  quantityKind.addLabel(new LangString("Druck", "de"));
  quantityKind.addLabel(new LangString("圧力", "ja"));
  quantityKind.addLabel(new LangString("pressão", "pt"));
  quantityKind.addLabel(new LangString("الضغط أو الإجهاد", "ar"));
  quantityKind.addLabel(new LangString("pressione", "it"));
  quantityKind.addLabel(new LangString("Tlak", "cs"));
  quantityKind.addLabel(new LangString("दबाव", "hi"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-IN2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_32DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroTORR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_60DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARYE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA_A");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroATM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliTORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_60DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR_A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR_A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckPressure"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_H2O_4DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_HG_0DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HGA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ForcePerArea"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Pressure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PressureBasedAmountOfSubstanceConcentration",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    "0173-1#Z4-BAJ307#002",
    undefined
  );
  quantityKind.addLabel(
    new LangString("pressure-based amount-of-substance concentration", "en-US")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PressureBasedAmountOfSubstanceConcentration",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PressureBasedDensity",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    "0173-1#Z4-BAJ299#003",
    undefined
  );
  quantityKind.addLabel(new LangString("pressure-based density", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PressureBasedDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PressureBasedDynamicViscosity",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    "0173-1#Z4-BAJ300#002",
    undefined
  );
  quantityKind.addLabel(
    new LangString("pressure-based dynamic viscosity", "en-US")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PressureBasedDynamicViscosity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PressureBasedElectricCurrent",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    "0173-1#Z4-BAJ309#002",
    undefined
  );
  quantityKind.addLabel(
    new LangString("pressure-based electric current", "en-US")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PressureBasedElectricCurrent",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PressureBasedElectricVoltage",
    "http://qudt.org/vocab/dimensionvector/A0E-1L3I0M0H0T-1D0",
    "0173-1#Z4-BAJ301#003",
    undefined
  );
  quantityKind.addLabel(
    new LangString("pressure-based electric voltage", "en-US")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PressureBasedElectricVoltage",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PressureBasedKinematicViscosity",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    "0173-1#Z4-BAJ303#002",
    undefined
  );
  quantityKind.addLabel(
    new LangString("pressure-based kinematic viscosity", "en-US")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PressureBasedKinematicViscosity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PressureBasedLength",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    "0173-1#Z4-BAJ304#002",
    undefined
  );
  quantityKind.addLabel(new LangString("pressure-based length", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PressureBasedLength",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PressureBasedMass",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    "0173-1#Z4-BAJ305#003",
    undefined
  );
  quantityKind.addLabel(new LangString("pressure-based mass", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PressureBasedMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PressureBasedMassFlow",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    "0173-1#Z4-BAJ310#002",
    undefined
  );
  quantityKind.addLabel(new LangString("pressure-based mass flow", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PressureBasedMassFlow",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PressureBasedMolality",
    "http://qudt.org/vocab/dimensionvector/A1E0L1I0M-2H0T2D0",
    "0173-1#Z4-BAJ306#002",
    undefined
  );
  quantityKind.addLabel(new LangString("pressure-based molality", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PressureBasedMolality",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PressureBasedQuantity",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("pressure-based quantity", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PressureBasedQuantity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PressureBasedTemperature",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    "0173-1#Z4-BAJ308#003",
    undefined
  );
  quantityKind.addLabel(new LangString("pressure-based temperature", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PressureBasedTemperature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PressureBasedVelocity",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    "0173-1#Z4-BAJ302#001",
    undefined
  );
  quantityKind.addLabel(new LangString("pressure-based velocity", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PressureBasedVelocity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PressureBasedVolume",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    "0173-1#Z4-BAJ312#002",
    undefined
  );
  quantityKind.addLabel(new LangString("pressure-based volume", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PressureBasedVolume",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PressureBasedVolumeFlow",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    "0173-1#Z4-BAJ311#002",
    undefined
  );
  quantityKind.addLabel(new LangString("pressure-based volume flow", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PressureBasedVolumeFlow",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PressureBurningRateConstant",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Pressure Burning Rate Constant", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DECADE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FLIGHT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RPK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_MAG"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaBasePair");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BasePair");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/COUNT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HeartBeat");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OCT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_ELEC"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Dimensionless"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PressureBurningRateConstant",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PressureBurningRateIndex",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Pressure Burning Rate Index", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DECADE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FLIGHT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RPK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_MAG"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaBasePair");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BasePair");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/COUNT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HeartBeat");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OCT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_ELEC"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Dimensionless"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PressureBurningRateIndex",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PressureCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H-1T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Pressure Coefficient", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA-PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPA-PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoPA-PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR-PER-DEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA-PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR-PER-K");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PressureCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PressureGradient",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-2D0",
    "0173-1#Z4-BAJ313#003",
    undefined
  );
  quantityKind.addLabel(new LangString("pressure gradient", undefined));
  quantityKind.addLabel(new LangString("pressure gradient", "en-US"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoPA-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI-PER-IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TORR-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM_T-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliPA-PER-M");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PressureGradient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PressureInRelationToVolumeFlow",
    "http://qudt.org/vocab/dimensionvector/A0E0L-4I0M1H0T-1D0",
    "0173-1#Z4-BAJ290#002",
    undefined
  );
  quantityKind.addLabel(
    new LangString("pressure in relation to volume flow", "en-US")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PressureInRelationToVolumeFlow",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PressureInRelationToVolumeFlowRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L-4I0M1H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("pressure in relation to volume flow rate", undefined)
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-SEC-PER-CentiM5"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA-SEC-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA-SEC-PER-M3");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PressureInRelationToVolumeFlowRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PressureLossPerLength",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Pressure Loss per Length", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M2-SEC2"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PressureLossPerLength",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PressureRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Pressure Ratio", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloPA-PER-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaPA-PER-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/HectoPA-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA-PER-BAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI-PER-PSI");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliBAR-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR-PER-BAR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PressureRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Prevalence",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Prevalence", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Prevalence",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PrincipalQuantumNumber",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "n",
    undefined
  );
  quantityKind.addLabel(new LangString("Principal Quantum Number", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/QuantumNumber"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PrincipalQuantumNumber",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ProductOfInertia_X",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Product of Inertia in the X axis", "en")
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PRODUCT-OF-INERTIA"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ProductOfInertia_X",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ProductOfInertia_Y",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Product of Inertia in the Y axis", "en")
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PRODUCT-OF-INERTIA"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ProductOfInertia_Y",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ProductOfInertia_Z",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Product of Inertia in the Z axis", "en")
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PRODUCT-OF-INERTIA"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ProductOfInertia_Z",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PropagationCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Propagation coefficient", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-NanoM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PropagationCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PropellantBurnRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Propellant Burn Rate", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-SEC");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/BurnRate"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PropellantBurnRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PropellantMass",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    "M_f",
    undefined
  );
  quantityKind.addLabel(new LangString("Propellant Mass", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PENNYWEIGHT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PropellantMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PropellantMeanBulkTemperature",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Propellant Mean Bulk Temperature", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliDEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_R");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckTemperature"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_F");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PropellantTemperature"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PropellantMeanBulkTemperature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PropellantTemperature",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Propellant Temperature", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliDEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_R");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckTemperature"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_F");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Temperature"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PropellantTemperature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/QualityFactor",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "Q",
    undefined
  );
  quantityKind.addLabel(new LangString("Quality Factor", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/QualityFactor",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/QuantityOfLight",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I1M0H0T1D0",
    "0173-1#Z4-BAJ243#002",
    undefined
  );
  quantityKind.addLabel(new LangString("quantity of light", "en-US"));
  quantityKind.addLabel(new LangString("quantity of light", undefined));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/QuantityOfLight",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/QuantumNumber",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "n",
    undefined
  );
  quantityKind.addLabel(new LangString("Quantum Number", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Dimensionless"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/QuantumNumber",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/QuarticElectricDipoleMomentPerCubicEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E4L-2I0M-3H0T10D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Quartic Electric Dipole Moment per Cubic Energy", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C4-M4-PER-J3");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/QuarticElectricDipoleMomentPerCubicEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RESERVE-MASS",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    "M_{E}",
    undefined
  );
  quantityKind.addLabel(new LangString("Reserve Mass", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PENNYWEIGHT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RESERVE-MASS",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RF-Power",
    "http://qudt.org/vocab/dimensionvector/A0E-1L1I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("RF-Power Level", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/V_Ab-PER-CentiM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-PER-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/V_Stat-PER-CentiM"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SignalStrength"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RF-Power",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RadialDistance",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Radial Distance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RadialDistance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Radiance",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    "L",
    undefined
  );
  quantityKind.addLabel(new LangString("Radiance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-M2-SR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PowerPerAreaAngle"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Radiance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RadianceFactor",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Radiance Factor", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RadianceFactor",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RadiantEmmitance",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Radiant Emmitance", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-IN2-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoW-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroW-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-CentiM2-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC-FT2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/ERG-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-CentiM2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-HR-FT2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliW-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-IN2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoW-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PA-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-FT2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PowerPerArea"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RadiantEmmitance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RadiantEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "Q_e",
    undefined
  );
  quantityKind.addLabel(new LangString("energia radiante", "it"));
  quantityKind.addLabel(new LangString("energia promienista", "pl"));
  quantityKind.addLabel(new LangString("radiant energy", "en"));
  quantityKind.addLabel(new LangString("انرژی تابشی", "fa"));
  quantityKind.addLabel(new LangString("energie záření", "cs"));
  quantityKind.addLabel(new LangString("энергия излучения", "ru"));
  quantityKind.addLabel(new LangString("Tenaga sinaran", "ms"));
  quantityKind.addLabel(new LangString("विकिरण ऊर्जा", "hi"));
  quantityKind.addLabel(new LangString("辐射能", "zh"));
  quantityKind.addLabel(new LangString("énergie rayonnante", "fr"));
  quantityKind.addLabel(new LangString("طاقة إشعاعية", "ar"));
  quantityKind.addLabel(new LangString("Işınım erkesi", "tr"));
  quantityKind.addLabel(new LangString("放射エネルギー", "ja"));
  quantityKind.addLabel(new LangString("energía radiante", "es"));
  quantityKind.addLabel(new LangString("Strahlungsenergie", "de"));
  quantityKind.addLabel(new LangString("energia radiante", "pt"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RadiantEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RadiantEnergyDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Radiant Energy Density", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-M3");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RadiantEnergyDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RadiantEnergyExposure",
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M-1H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("radiant energy exposure", undefined));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RadiantEnergyExposure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RadiantExposure",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    "H_e",
    undefined
  );
  quantityKind.addLabel(new LangString("Radiant Exposure", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-FT2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloBTU_IT-PER-FT2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GigaN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LANGLEY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-M-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/ERG-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloW-HR-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-CentiM2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EnergyPerArea"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RadiantExposure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RadiantFluence",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    "H_e,0",
    undefined
  );
  quantityKind.addLabel(new LangString("Radiant Fluence", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LANGLEY");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RadiantFluence",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RadiantFluenceRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    "E_e,0",
    undefined
  );
  quantityKind.addLabel(new LangString("Radiant Fluence Rate", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-IN2-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoW-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroW-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-CentiM2-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC-FT2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/ERG-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-CentiM2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-HR-FT2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliW-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-IN2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoW-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PA-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-FT2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PowerPerArea"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RadiantFluenceRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RadiantFlux",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("قدرة إشعاعية", "ar"));
  quantityKind.addLabel(new LangString("Strahlungsfluss", "de"));
  quantityKind.addLabel(new LangString("flusso radiante", "it"));
  quantityKind.addLabel(new LangString("potencia radiante", "es"));
  quantityKind.addLabel(new LangString("potência radiante", "pt"));
  quantityKind.addLabel(new LangString("放射パワー", "ja"));
  quantityKind.addLabel(new LangString("moc promieniowania", "pl"));
  quantityKind.addLabel(new LangString("flux énergétique", "fr"));
  quantityKind.addLabel(new LangString("radiant flux", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaW");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TeraW-HR-PER-YR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroJ-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFERDESTAERKE");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliJ-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliBAR-L-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaPA-L-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP_Electric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_FG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PSI-IN3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA-L-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BAR-M3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR-L-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP_Boiler");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PSI-M3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckPower");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI-L-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloBTU_IT-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA-M3-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/HectoPA-M3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaBTU_IT-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP_Brake");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaPA-M3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliW");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/HectoPA-L-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-M-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PSI-YD3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliBAR-M3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Power"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RadiantFlux",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RadiantIntensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    "I",
    undefined
  );
  quantityKind.addLabel(new LangString("Radiant Intensity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-SR");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RadiantIntensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RadiativeHeatTransfer",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Radiative Heat Transfer", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaBTU_IT-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL_TH-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL_TH-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL_TH-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloBTU_TH-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_FG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloBTU_IT-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH-PER-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/HeatFlowRate"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RadiativeHeatTransfer",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RadioactiveDecay",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("radioactive decay", undefined));
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InverseTime"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RadioactiveDecay",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Radioactivity",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    "0173-1#Z4-BAJ230#002",
    undefined
  );
  quantityKind.addLabel(new LangString("radioactivity", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Radioactivity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Radiosity",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Radiosity", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-CentiM2-DAY"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PowerPerArea"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Radiosity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Radius",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "r",
    undefined
  );
  quantityKind.addLabel(new LangString("Radius", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Radius",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RadiusOfCurvature",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Radius of Curvature", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RadiusOfCurvature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RankineTemperature",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T0D0",
    "0173-1#Z4-BAJ367#002",
    undefined
  );
  quantityKind.addLabel(new LangString("Rankine temperature", "en-US"));
  quantityKind.addLabel(new LangString("Rankine temperature", undefined));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_R");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckTemperature"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermodynamicTemperature"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RankineTemperature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RateOfRiseOfVoltage",
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-4D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("rate of rise of voltage", undefined));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RateOfRiseOfVoltage",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Ratio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("ratio", undefined));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ONE-PER-ONE");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Ratio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RatioOfSpecificHeatCapacities",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Ratio of Specific Heat Capacities", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RatioOfSpecificHeatCapacities",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Reactance",
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H0T-3D0",
    "X",
    undefined
  );
  quantityKind.addLabel(new LangString("Reactance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OHM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Reactance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ReactionEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "Q",
    undefined
  );
  quantityKind.addLabel(new LangString("Reaction Energy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ReactionEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ReactivePower",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    "Q",
    undefined
  );
  quantityKind.addLabel(new LangString("无功功率", "zh"));
  quantityKind.addLabel(new LangString("reactive power", "en"));
  quantityKind.addLabel(new LangString("reaktif güç", "tr"));
  quantityKind.addLabel(new LangString("potencia reactiva", "es"));
  quantityKind.addLabel(new LangString("توان راکتیو", "fa"));
  quantityKind.addLabel(new LangString("Kuasa reaktif", "ms"));
  quantityKind.addLabel(new LangString("無効電力", "ja"));
  quantityKind.addLabel(new LangString("potência reativa", "pt"));
  quantityKind.addLabel(new LangString("potenza reattiva", "it"));
  quantityKind.addLabel(
    new LangString("القدرة الكهربائية الردفعلية;الردية", "ar")
  );
  quantityKind.addLabel(new LangString("Blindleistung", "de"));
  quantityKind.addLabel(new LangString("Jalový výkon", "cs"));
  quantityKind.addLabel(new LangString("puissance réactive", "fr"));
  quantityKind.addLabel(new LangString("moc bierna", "pl"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoVAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaVAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroVAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliVAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraVAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoVAR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPower"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ReactivePower",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Reactivity",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Reactivity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Reactivity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ReactorTimeConstant",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    "T",
    undefined
  );
  quantityKind.addLabel(new LangString("Reactor Time Constant", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliH-PER-KiloOHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/WK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckTime");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Common");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MO_MeanGREGORIAN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HR_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoSEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroH-PER-KiloOHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H-PER-OHM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroH-PER-OHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DAY_Sidereal");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliPA-SEC-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO_Synodic");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POISE-PER-BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiPOISE-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POISE-PER-PA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliH-PER-OHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_TROPICAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H-PER-KiloOHM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Metrology");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PA-SEC-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloYR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaYR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO_MeanJulian");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Time"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ReactorTimeConstant",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ReciprocalElectricResistance",
    "http://qudt.org/vocab/dimensionvector/A0E2L-2I0M-1H0T3D0",
    "0173-1#Z4-BAJ375#002",
    undefined
  );
  quantityKind.addLabel(
    new LangString("reciprocal electric resistance", "en-US")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ReciprocalElectricResistance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ReciprocalEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M-1H0T2D0",
    "0173-1#Z4-BAJ417#002",
    undefined
  );
  quantityKind.addLabel(new LangString("reciprocal energy", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ReciprocalEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ReciprocalPlaneAngle",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "0173-1#Z4-BAJ376#002",
    undefined
  );
  quantityKind.addLabel(new LangString("reciprocal plane angle", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ReciprocalPlaneAngle",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ReciprocalVoltage",
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M-1H0T3D0",
    "0173-1#Z4-BAJ371#002",
    undefined
  );
  quantityKind.addLabel(new LangString("reciprocal voltage", "en-US"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-V");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ReciprocalVoltage",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RecombinationCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    "a",
    undefined
  );
  quantityKind.addLabel(new LangString("Recombination Coefficient", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-SEC");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RecombinationCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Reflectance",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Reflectance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Reflectance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ReflectanceFactor",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "R",
    undefined
  );
  quantityKind.addLabel(new LangString("Reflectance Factor", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ReflectanceFactor",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Reflectivity",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Reflectivity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Reflectance"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Reflectivity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RefractiveIndex",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "n",
    undefined
  );
  quantityKind.addLabel(new LangString("अपवर्तनांक", "hi"));
  quantityKind.addLabel(new LangString("Indice de refracție", "ro"));
  quantityKind.addLabel(new LangString("kırılma indeksi", "tr"));
  quantityKind.addLabel(new LangString("índice refrativo", "pt"));
  quantityKind.addLabel(new LangString("折射率", "zh"));
  quantityKind.addLabel(new LangString("índice de refracción", "es"));
  quantityKind.addLabel(new LangString("معامل الانكسار", "ar"));
  quantityKind.addLabel(new LangString("indice de réfraction", "fr"));
  quantityKind.addLabel(new LangString("屈折率", "ja"));
  quantityKind.addLabel(new LangString("ضریب شکست", "fa"));
  quantityKind.addLabel(new LangString("Indeks biasan", "ms"));
  quantityKind.addLabel(new LangString("Brechzahl", "de"));
  quantityKind.addLabel(new LangString("Показатель преломления", "ru"));
  quantityKind.addLabel(new LangString("Index lomu", "cs"));
  quantityKind.addLabel(new LangString("refractive index", "en"));
  quantityKind.addLabel(new LangString("Współczynnik załamania", "pl"));
  quantityKind.addLabel(new LangString("indice di rifrazione", "it"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RefractiveIndex",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RelativeAtomicMass",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "A_r",
    undefined
  );
  quantityKind.addLabel(new LangString("Relative Atomic Mass", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ONE-PER-ONE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERMITTIVITY_REL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RelativeAtomicMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RelativeHumidity",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Relative Humidity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT_RH");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/RelativePartialPressure"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RelativeHumidity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RelativeMassConcentrationOfVapour",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Relative Mass Concentration of Vapour", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RelativeMassConcentrationOfVapour",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RelativeMassDefect",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "B_r",
    undefined
  );
  quantityKind.addLabel(new LangString("Relative Mass Defect", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ONE-PER-ONE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERMITTIVITY_REL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RelativeMassDefect",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RelativeMassDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "d",
    undefined
  );
  quantityKind.addLabel(new LangString("Relative Mass Density", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RelativeMassDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RelativeMassExcess",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Relative Mass Excess", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RelativeMassExcess",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RelativeMassRatioOfVapour",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Relative Mass Ratio of Vapour", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RelativeMassRatioOfVapour",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RelativeMolecularMass",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "M_r",
    undefined
  );
  quantityKind.addLabel(new LangString("Relative Molecular Mass", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ONE-PER-ONE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERMITTIVITY_REL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RelativeMolecularMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RelativePartialPressure",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Relative Partial Pressure", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PressureRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RelativePartialPressure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RelativePressureCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H-1T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Relative Pressure Coefficient", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MegaK");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RelativePressureCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RelaxationTIme",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Relaxation TIme", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliH-PER-KiloOHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/WK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckTime");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Common");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MO_MeanGREGORIAN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HR_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoSEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroH-PER-KiloOHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H-PER-OHM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroH-PER-OHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DAY_Sidereal");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliPA-SEC-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO_Synodic");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POISE-PER-BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiPOISE-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POISE-PER-PA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliH-PER-OHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_TROPICAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H-PER-KiloOHM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Metrology");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PA-SEC-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloYR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaYR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO_MeanJulian");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Time"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RelaxationTIme",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Reluctance",
    "http://qudt.org/vocab/dimensionvector/A0E2L-2I0M-1H0T2D0",
    "R_m",
    undefined
  );
  quantityKind.addLabel(new LangString("Reluctance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-H");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Reluctance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Repetency",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    "0173-1#Z4-BAJ370#002",
    undefined
  );
  quantityKind.addLabel(new LangString("repetency", undefined));
  quantityKind.addLabel(new LangString("repetency", "en-US"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-IN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-MilliM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-IN"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Repetency",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ResidualResistivity",
    "http://qudt.org/vocab/dimensionvector/A0E-2L3I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Residual Resistivity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaOHM-KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OHM-KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OHM-M");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ResidualResistivity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Resistance",
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H0T-3D0",
    "R",
    undefined
  );
  quantityKind.addLabel(new LangString("Resistance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaOHM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OHM_Stat");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroOHM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OHM_Ab");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraOHM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloOHM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaOHM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckImpedance"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliOHM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OHM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Resistance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ResistanceBasedInductance",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    "0173-1#Z4-BAJ411#002",
    undefined
  );
  quantityKind.addLabel(new LangString("resistance-based inductance", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ResistanceBasedInductance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ResistanceRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Resistance Ratio", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ResistanceRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Resistivity",
    "http://qudt.org/vocab/dimensionvector/A0E-2L3I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Resistivity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OHM-M2-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaOHM-KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroOHM-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliOHM-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OHM-CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoOHM-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloOHM-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OHM-KiloM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OHM_CIRC-MIL-PER-FT"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaOHM-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaOHM-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OHM-M");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Resistivity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ResonanceEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "E_r, E_{res}",
    undefined
  );
  quantityKind.addLabel(new LangString("Resonance Energy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ResonanceEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ResonanceEscapeProbability",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "p",
    undefined
  );
  quantityKind.addLabel(new LangString("Resonance Escape Probability", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ResonanceEscapeProbability",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ResonanceEscapeProbabilityForFission",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "p",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Resonance Escape Probability For Fission", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DECADE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FLIGHT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RPK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_MAG"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaBasePair");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BasePair");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/COUNT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HeartBeat");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OCT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_ELEC"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Dimensionless"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ResonanceEscapeProbabilityForFission",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RespiratoryRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    "Vf, Rf or RR",
    undefined
  );
  quantityKind.addLabel(new LangString("Respiratory Rate", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BREATH-PER-MIN"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RespiratoryRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RestEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "E_0",
    undefined
  );
  quantityKind.addLabel(new LangString("Rest Energy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RestEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RestMass",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    "m_X",
    undefined
  );
  quantityKind.addLabel(new LangString("инвариантная масса", "ru"));
  quantityKind.addLabel(new LangString("dinlenme kütlesi", "tr"));
  quantityKind.addLabel(new LangString("Jisim rehat", "ms"));
  quantityKind.addLabel(new LangString("جرم سکون", "fa"));
  quantityKind.addLabel(new LangString("masa spoczynkowa", "pl"));
  quantityKind.addLabel(new LangString("Klidová hmotnost", "cs"));
  quantityKind.addLabel(new LangString("静止质量", "zh"));
  quantityKind.addLabel(new LangString("不変質量", "ja"));
  quantityKind.addLabel(new LangString("masa invariantă", "ro"));
  quantityKind.addLabel(new LangString("Mirovna masa", "sl"));
  quantityKind.addLabel(new LangString("massa a riposo", "it"));
  quantityKind.addLabel(new LangString("निश्चर द्रव्यमान", "hi"));
  quantityKind.addLabel(new LangString("Ruhemasse", "de"));
  quantityKind.addLabel(new LangString("masse au repos", "fr"));
  quantityKind.addLabel(new LangString("massa de repouso", "pt"));
  quantityKind.addLabel(new LangString("rest mass", "en"));
  quantityKind.addLabel(new LangString("masa invariante", "es"));
  quantityKind.addLabel(new LangString("كتلة ساكنة", "ar"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PENNYWEIGHT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RestMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ReverberationTime",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    "T",
    undefined
  );
  quantityKind.addLabel(new LangString("Reverberation Time", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliH-PER-KiloOHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/WK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckTime");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Common");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MO_MeanGREGORIAN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HR_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoSEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroH-PER-KiloOHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H-PER-OHM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroH-PER-OHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DAY_Sidereal");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliPA-SEC-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO_Synodic");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POISE-PER-BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiPOISE-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POISE-PER-PA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliH-PER-OHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_TROPICAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H-PER-KiloOHM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Metrology");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PA-SEC-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloYR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaYR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO_MeanJulian");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Time"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ReverberationTime",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ReynoldsNumber",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "Re",
    undefined
  );
  quantityKind.addLabel(new LangString("Reynolds Number", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ReynoldsNumber",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RichardsonConstant",
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H-2T0D0",
    "A",
    undefined
  );
  quantityKind.addLabel(new LangString("Richardson Constant", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-M2-K2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RichardsonConstant",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RiseOfOffStateVoltage",
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-4D0",
    "0173-1#Z4-BAJ289#003",
    undefined
  );
  quantityKind.addLabel(new LangString("rise of off-state voltage", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RiseOfOffStateVoltage",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RocketAtmosphericTransverseForce",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    "T",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Rocket Atmospheric Transverse Force", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_F_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPOND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-M-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DYN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckForce");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Force"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RocketAtmosphericTransverseForce",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Rotary-TranslatoryMotionConversion",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("rotary-translatory motion conversion", undefined)
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-REV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-RAD");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Rotary-TranslatoryMotionConversion",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RotaryShock",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-1D0",
    "0173-1#Z4-BAJ234#002",
    undefined
  );
  quantityKind.addLabel(new LangString("rotary shock", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RotaryShock",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RotationalFrequency",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("RotationalFrequency", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/REV-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/REV-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CYC-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/REV-PER-HR");
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/RotationalVelocity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RotationalFrequency",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RotationalMass",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T0D0",
    "I",
    undefined
  );
  quantityKind.addLabel(new LangString("Rotational Mass", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-FT2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-MilliM2"
  );
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/MomentOfInertia"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RotationalMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RotationalStiffness",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Rotational Stiffness", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-M-PER-RAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-M-PER-DEG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/N-M-PER-MIN_Angle"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/N-M-PER-ARCMIN"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TorquePerAngle"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RotationalStiffness",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RotationalVelocity",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("RotationalFrequency", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/REV-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/REV-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CYC-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/REV-PER-HR");
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/RotationalFrequency"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RotationalVelocity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ScalarMagneticPotential",
    "http://qudt.org/vocab/dimensionvector/A0E-1L1I0M1H0T-2D0",
    "V_m",
    undefined
  );
  quantityKind.addLabel(new LangString("Scalar Magnetic Potential", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-SEC-PER-M");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ScalarMagneticPotential",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SecondAxialMomentOfArea",
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M0H0T0D0",
    "I",
    undefined
  );
  quantityKind.addLabel(new LangString("Second Axial Moment of Area", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM4");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT4");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN4");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM4");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M4");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SecondAxialMomentOfArea",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SecondMomentOfArea",
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M0H0T0D0",
    "J",
    undefined
  );
  quantityKind.addLabel(new LangString("截面二次轴矩", "zh"));
  quantityKind.addLabel(new LangString("secondo momento di area", "it"));
  quantityKind.addLabel(new LangString("moment quadratique", "fr"));
  quantityKind.addLabel(new LangString("断面二次モーメント", "ja"));
  quantityKind.addLabel(new LangString("second moment of area", "en"));
  quantityKind.addLabel(new LangString("Segundo momento de área", "pt"));
  quantityKind.addLabel(new LangString("क्षेत्रफल का द्वितीय आघूर्ण", "hi"));
  quantityKind.addLabel(new LangString("گشتاور دوم سطح", "fa"));
  quantityKind.addLabel(new LangString("segundo momento de érea", "es"));
  quantityKind.addLabel(
    new LangString("Geometryczny moment bezwładności", "pl")
  );
  quantityKind.addLabel(new LangString("Flächenträgheitsmoment", "de"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM4");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT4");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN4");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM4");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M4");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SecondMomentOfArea",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SecondOrderReactionRateConstant",
    "http://qudt.org/vocab/dimensionvector/A-1E0L3I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Reaction Rate Constant", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-MOL-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-MOL-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/M3-PER-MOL-SEC"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SecondOrderReactionRateConstant",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SecondPolarMomentOfArea",
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M0H0T0D0",
    "I",
    undefined
  );
  quantityKind.addLabel(new LangString("Second Polar Moment of Area", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM4");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT4");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN4");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM4");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M4");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SecondPolarMomentOfArea",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SecondRadiationConstant",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H1T0D0",
    "0173-1#Z4-BAJ428#001",
    undefined
  );
  quantityKind.addLabel(new LangString("second radiation constant", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SecondRadiationConstant",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SecondStageMassRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "R_2",
    undefined
  );
  quantityKind.addLabel(new LangString("Second Stage Mass Ratio", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-MilliGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-MilliGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-GM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoGM-PER-MilliGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoGM-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FemtoGM-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-LB");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-GM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-HectoGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-KiloGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM-PER-GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-GM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SecondStageMassRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SectionAreaIntegral",
    "http://qudt.org/vocab/dimensionvector/A0E0L5I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Section Area Integral", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M5");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SectionAreaIntegral",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SectionModulus",
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    "Z",
    undefined
  );
  quantityKind.addLabel(new LangString("Section Modulus", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_UK3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Register");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SectionModulus",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SeebeckCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H-1T-3D0",
    "S_{ab}",
    undefined
  );
  quantityKind.addLabel(new LangString("Seebeck Coefficient", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-PER-K");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SeebeckCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SerumLevel",
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Serum Level", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IU-PER-MilliL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IU-PER-L");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstancePerVolume"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SerumLevel",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SerumOrPlasmaLevel",
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Serum or Plasma Level", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoMOL-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FemtoMOL-PER-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoMOL-PER-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoMOL-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MOL-PER-DeciM3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliMOL-PER-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloMOL-PER-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliMOL-PER-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiMOL-PER-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroMOL-PER-L"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstancePerVolume"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SerumOrPlasmaLevel",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ServiceFactor",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "SF",
    undefined
  );
  quantityKind.addLabel(new LangString("Service Factor", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ServiceFactor",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ShannonDiversityIndex",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Shannon Diversity Index", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BYTE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExbiBIT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MebiBYTE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERLANG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBYTE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BIT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PebiBIT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TebiBIT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HART");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PebiBYTE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaBYTE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GibiBYTE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KibiBYTE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExbiBYTE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBYTE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaBIT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SHANNON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TebiBYTE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaBYTE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaBYTE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraBYTE");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InformationEntropy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ShannonDiversityIndex",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ShearModulus",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    "G",
    undefined
  );
  quantityKind.addLabel(new LangString("Shear Modulus", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-IN2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ShearModulus",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ShearStrain",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Shear Strain", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ONE-PER-ONE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERMITTIVITY_REL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Strain"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ShearStrain",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ShearStress",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Shear Stress", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-IN2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_32DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroTORR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_60DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARYE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA_A");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroATM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliTORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_60DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR_A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR_A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckPressure"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_H2O_4DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_HG_0DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HGA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Stress"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ShearStress",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Short-RangeOrderParameter",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Short-Range Order Parameter", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Short-RangeOrderParameter",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SignalDetectionThreshold",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Signal Detection Threshold", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciB_C");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SignalDetectionThreshold",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SignalStrength",
    "http://qudt.org/vocab/dimensionvector/A0E-1L1I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Signal Strength", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/V_Ab-PER-CentiM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-PER-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/V_Stat-PER-CentiM"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricFieldStrength"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricField"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SignalStrength",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SingleStageLauncherMassRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "R_o",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Single Stage Launcher Mass Ratio", "en")
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-MilliGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-MilliGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-GM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoGM-PER-MilliGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoGM-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FemtoGM-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-LB");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-GM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-HectoGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-KiloGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM-PER-GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-GM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SingleStageLauncherMassRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Slowing-DownArea",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    "L_s^2",
    undefined
  );
  quantityKind.addLabel(new LangString("Slowing-Down Area", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckArea");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloMIL_Circ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIL_Circ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaARE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PIXEL_AREA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Area"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Slowing-DownArea",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Slowing-DownDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T-1D0",
    "q",
    undefined
  );
  quantityKind.addLabel(new LangString("Slowing-Down Density", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-M3-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-SEC-M3");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Slowing-DownDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Slowing-DownLength",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "L_s",
    undefined
  );
  quantityKind.addLabel(new LangString("Slowing-Down Length", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Slowing-DownLength",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SoilAdsorptionCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M-1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Soil Adsorption Coefficient", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM3-PER-GM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT3-PER-LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliL-PER-GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-KiloGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-GM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN3-PER-LB");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciM3-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM3-PER-KiloGM"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificVolume"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SoilAdsorptionCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SolidAngle",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("angolo solido", "it"));
  quantityKind.addLabel(new LangString("立体角", "ja"));
  quantityKind.addLabel(new LangString("زاویه فضایی", "fa"));
  quantityKind.addLabel(new LangString("ângulo sólido", "pt"));
  quantityKind.addLabel(new LangString("ángulo sólido", "es"));
  quantityKind.addLabel(new LangString("Sudut padu", "ms"));
  quantityKind.addLabel(new LangString("solid angle", "en"));
  quantityKind.addLabel(new LangString("الزاوية الصلبة", "ar"));
  quantityKind.addLabel(new LangString("kąt bryłowy", "pl"));
  quantityKind.addLabel(new LangString("katı cisimdeki açı", "tr"));
  quantityKind.addLabel(new LangString("Raumwinkel", "de"));
  quantityKind.addLabel(new LangString("आयतन", "hi"));
  quantityKind.addLabel(new LangString("Пространствен ъгъл", "bg"));
  quantityKind.addLabel(new LangString("זווית מרחבית", "he"));
  quantityKind.addLabel(new LangString("立体角度", "zh"));
  quantityKind.addLabel(new LangString("térszög", "hu"));
  quantityKind.addLabel(new LangString("angulus solidus", "la"));
  quantityKind.addLabel(new LangString("Στερεά γωνία", "el"));
  quantityKind.addLabel(new LangString("unghi solid", "ro"));
  quantityKind.addLabel(new LangString("Телесный угол", "ru"));
  quantityKind.addLabel(new LangString("Prostorový úhel", "cs"));
  quantityKind.addLabel(new LangString("angle solide", "fr"));
  quantityKind.addLabel(new LangString("prostorski kot", "sl"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FA");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AreaRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SolidAngle",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SolidStateDiffusionLength",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "L, L_n, L_p",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Diffusion Length (Solid State Physics)", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SolidStateDiffusionLength",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Solubility_Water",
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Water Solubility", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoMOL-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FemtoMOL-PER-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoMOL-PER-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoMOL-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MOL-PER-DeciM3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliMOL-PER-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloMOL-PER-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliMOL-PER-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiMOL-PER-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroMOL-PER-L"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstancePerVolume"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Solubility_Water",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SoundEnergyDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    "E",
    undefined
  );
  quantityKind.addLabel(new LangString("Sound energy density", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/ERG-PER-CentiM3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-M3");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EnergyDensity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SoundEnergyDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SoundExposure",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M2H0T-3D0",
    "E",
    undefined
  );
  quantityKind.addLabel(new LangString("Sound exposure", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA2-SEC");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SoundExposure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SoundExposureLevel",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "L",
    undefined
  );
  quantityKind.addLabel(new LangString("Sound exposure level", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciB_A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciB_ISO");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/B");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciB_Z");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciB_M");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SoundExposureLevel",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SoundIntensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    "I",
    undefined
  );
  quantityKind.addLabel(new LangString("Sound intensity", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-IN2-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoW-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroW-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-CentiM2-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC-FT2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/ERG-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-CentiM2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-HR-FT2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliW-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-IN2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoW-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PA-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-FT2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PowerPerArea"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SoundIntensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SoundParticleAcceleration",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-2D0",
    "a",
    undefined
  );
  quantityKind.addLabel(new LangString("Sound particle acceleration", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-SEC2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloPA-M2-PER-GM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GALILEO");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KN-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-SEC2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloM-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-SEC2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGALILEO");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MI_US-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-SEC2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/G");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Acceleration"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SoundParticleAcceleration",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SoundParticleDisplacement",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "ξ",
    undefined
  );
  quantityKind.addLabel(new LangString("Sound Particle Displacement", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SoundParticleDisplacement",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SoundParticleVelocity",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    "v",
    undefined
  );
  quantityKind.addLabel(
    new LangString("vitesse  acoustique d‘une particule", "fr")
  );
  quantityKind.addLabel(new LangString("سرعة جسيم", "ar"));
  quantityKind.addLabel(
    new LangString("velocidade acústica de uma partícula", "pt")
  );
  quantityKind.addLabel(new LangString("sound particle velocity", "en"));
  quantityKind.addLabel(new LangString("粒子速度", "ja"));
  quantityKind.addLabel(new LangString("prędkość akustyczna", "pl"));
  quantityKind.addLabel(new LangString("velocità di spostamento", "it"));
  quantityKind.addLabel(new LangString("Schallschnelle", "de"));
  quantityKind.addLabel(
    new LangString("velocidad acústica de una partícula", "es")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloHZ-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaHZ-M");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Velocity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SoundParticleVelocity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SoundPower",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    "P",
    undefined
  );
  quantityKind.addLabel(new LangString("звуковая мощность", "ru"));
  quantityKind.addLabel(new LangString("Schallleistung", "de"));
  quantityKind.addLabel(new LangString("音源の音響出力", "ja"));
  quantityKind.addLabel(new LangString("sound power", "en"));
  quantityKind.addLabel(new LangString("potencie acústica", "es"));
  quantityKind.addLabel(new LangString("القدرة الصوتية", "ar"));
  quantityKind.addLabel(new LangString("potenza sonora", "it"));
  quantityKind.addLabel(new LangString("puissance acoustique", "fr"));
  quantityKind.addLabel(new LangString("potência acústica", "pt"));
  quantityKind.addLabel(new LangString("moc akustyczna", "pl"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaW");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TeraW-HR-PER-YR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroJ-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFERDESTAERKE");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliJ-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliBAR-L-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaPA-L-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP_Electric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_FG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PSI-IN3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA-L-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BAR-M3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR-L-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP_Boiler");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PSI-M3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckPower");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI-L-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloBTU_IT-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA-M3-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/HectoPA-M3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaBTU_IT-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP_Brake");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaPA-M3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliW");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/HectoPA-L-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-M-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PSI-YD3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliBAR-M3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Power"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SoundPower",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SoundPowerLevel",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "L",
    undefined
  );
  quantityKind.addLabel(new LangString("Sound power level", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciB_A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciB_ISO");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/B");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciB_Z");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciB_M");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SoundPowerLevel",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SoundPressure",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    "p",
    undefined
  );
  quantityKind.addLabel(new LangString("Sound pressure", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-IN2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_32DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroTORR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_60DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARYE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA_A");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroATM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliTORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_60DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR_A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR_A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckPressure"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_H2O_4DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_HG_0DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HGA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Pressure"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SoundPressure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SoundPressureLevel",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "L",
    undefined
  );
  quantityKind.addLabel(new LangString("利得", "ja"));
  quantityKind.addLabel(new LangString("niveau de pression acoustique", "fr"));
  quantityKind.addLabel(new LangString("nivel de presión sonora", "es"));
  quantityKind.addLabel(new LangString("miary wielkości ilorazowych", "pl"));
  quantityKind.addLabel(new LangString("sound pressure level", "en"));
  quantityKind.addLabel(new LangString("Hladina akustického tlaku", "cs"));
  quantityKind.addLabel(new LangString("Schalldruckpegel", "de"));
  quantityKind.addLabel(new LangString("كمية جذر الطاقة", "ar"));
  quantityKind.addLabel(new LangString("livello di pressione sonora", "it"));
  quantityKind.addLabel(new LangString("声压级", "zh"));
  quantityKind.addLabel(new LangString("gerilim veya akım oranı", "tr"));
  quantityKind.addLabel(new LangString("nível de pressão acústica", "pt"));
  quantityKind.addLabel(new LangString("سطح یک کمیت توان-ریشه", "fa"));
  quantityKind.addLabel(new LangString("Tahap medan", "ms"));
  quantityKind.addLabel(new LangString("уровень звукового давления", "ru"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciB_A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciB_ISO");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/B");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciB_Z");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PHON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciB_M");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SoundPressureLevel",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SoundReductionIndex",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "R",
    undefined
  );
  quantityKind.addLabel(new LangString("Sound reduction index", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciB_A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciB_ISO");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/B");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciB_Z");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciB_M");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SoundReductionIndex",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SoundVolumeVelocity",
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    "q",
    undefined
  );
  quantityKind.addLabel(new LangString("Sound volume velocity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-SEC");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SoundVolumeVelocity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SourceVoltage",
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-3D0",
    "U_s",
    undefined
  );
  quantityKind.addLabel(new LangString("Source Voltage", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V_Stat");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V_Ab");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckVolt");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Voltage"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SourceVoltage",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SourceVoltageBetweenSubstances",
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-3D0",
    "E_{ab}",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Source Voltage Between Substances", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V_Stat");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V_Ab");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckVolt");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Voltage"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SourceVoltageBetweenSubstances",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpatialSummationFunction",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Spatial Summation Function", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpatialSummationFunction",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpecificAcousticImpedance",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Specific Acoustic Impedance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-SEC-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAYL");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpecificAcousticImpedance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpecificActivity",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T-1D0",
    "a",
    undefined
  );
  quantityKind.addLabel(new LangString("Specific Activity", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloBQ-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliBQ-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroBQ-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CI-PER-KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BQ-PER-KiloGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaBQ-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliBQ-PER-GM"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpecificActivity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpecificElectricCharge",
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M-1H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Specific Electric Charge", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliA-HR-PER-GM"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpecificElectricCharge",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpecificElectricCurrent",
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M-1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Specific Electrical Current", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-GM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpecificElectricCurrent",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpecificEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    "e",
    undefined
  );
  quantityKind.addLabel(new LangString("Specific Energy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-KiloGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/W-HR-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-FT-PER-LB"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT-PER-LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaJ-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH-PER-LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloJ-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/N-M-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-GM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-GM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpecificEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpecificEnergyImparted",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    "z",
    undefined
  );
  quantityKind.addLabel(new LangString("Specific Energy Imparted", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-KiloGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/W-HR-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-FT-PER-LB"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT-PER-LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaJ-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH-PER-LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloJ-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/N-M-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-GM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-GM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificEnergy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpecificEnergyImparted",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpecificEnthalpy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    "h",
    undefined
  );
  quantityKind.addLabel(new LangString("Specific Enthalpy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-KiloGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/W-HR-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-FT-PER-LB"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT-PER-LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaJ-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH-PER-LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloJ-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/N-M-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-GM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-GM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificEnergy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpecificEnthalpy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpecificEntropy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H-1T-2D0",
    "s",
    undefined
  );
  quantityKind.addLabel(new LangString("Specific Entropy", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-LB-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-GM-DEG_C"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-GM-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-KiloGM-K"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-GM-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloJ-PER-KiloGM-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-GM-DEG_C"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_IT-PER-GM-DEG_C"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-KiloGM-DEG_C"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_IT-PER-GM-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-GM-DEG_C"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpecificEntropy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpecificGibbsEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    "g",
    undefined
  );
  quantityKind.addLabel(new LangString("Specific Gibbs Energy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-KiloGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/W-HR-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-FT-PER-LB"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT-PER-LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaJ-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH-PER-LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloJ-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/N-M-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-GM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-GM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificEnergy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpecificGibbsEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacity",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H-1T-2D0",
    "c",
    undefined
  );
  quantityKind.addLabel(new LangString("Specific Heat Capacity", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-KiloGM-K"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-GM-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloJ-PER-KiloGM-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-GM-DEG_C"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-LB-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-GM-DEG_C"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB-DEG_R"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-GM-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-GM-DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-SEC2-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_IT-PER-GM-DEG_C"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-KiloGM-DEG_C"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_IT-PER-GM-K"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtConstantPressure",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H-1T-2D0",
    "c_p",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Specific heat capacity at constant pressure", "en")
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-LB-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-GM-DEG_C"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-GM-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-KiloGM-K"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-GM-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloJ-PER-KiloGM-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-GM-DEG_C"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_IT-PER-GM-DEG_C"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-KiloGM-DEG_C"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_IT-PER-GM-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-GM-DEG_C"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtConstantPressure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtConstantVolume",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H-1T-2D0",
    "c_v",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Specific heat capacity at constant volume", "en")
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-LB-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-GM-DEG_C"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-GM-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-KiloGM-K"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-GM-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloJ-PER-KiloGM-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-GM-DEG_C"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_IT-PER-GM-DEG_C"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-KiloGM-DEG_C"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_IT-PER-GM-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-GM-DEG_C"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtConstantVolume",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtSaturation",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H-1T-2D0",
    "c_{sat}",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Specific Heat Capacity at Saturation", "en")
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-LB-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-GM-DEG_C"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-GM-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-KiloGM-K"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-GM-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloJ-PER-KiloGM-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-GM-DEG_C"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_IT-PER-GM-DEG_C"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-KiloGM-DEG_C"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_IT-PER-GM-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-GM-DEG_C"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtSaturation",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpecificHeatPressure",
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M-1H-1T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Specific Heat Pressure", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-KiloGM-K-PA"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpecificHeatPressure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpecificHeatVolume",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H-1T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Specific Heat Volume", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-KiloGM-K-M3"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpecificHeatVolume",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpecificHeatsRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Specific Heats Ratio", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ONE-PER-ONE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERMITTIVITY_REL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpecificHeatsRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpecificHelmholtzEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    "a",
    undefined
  );
  quantityKind.addLabel(new LangString("Specific Helmholtz Energy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-KiloGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/W-HR-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-FT-PER-LB"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT-PER-LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaJ-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH-PER-LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloJ-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/N-M-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-GM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-GM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificEnergy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpecificHelmholtzEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpecificImpulse",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Specific Impulse", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpecificImpulse",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpecificImpulseByMass",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Specific Impulse by Mass", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaHZ-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-KiloYR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM-PER-YR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Velocity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpecificImpulseByMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpecificImpulseByWeight",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Specific Impulse by Weight", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliH-PER-KiloOHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/WK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckTime");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Common");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MO_MeanGREGORIAN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HR_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoSEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroH-PER-KiloOHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H-PER-OHM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroH-PER-OHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DAY_Sidereal");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliPA-SEC-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO_Synodic");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POISE-PER-BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiPOISE-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POISE-PER-PA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliH-PER-OHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_TROPICAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H-PER-KiloOHM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Metrology");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PA-SEC-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloYR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaYR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO_MeanJulian");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Time"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificImpulse"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpecificImpulseByWeight",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpecificInternalEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    "u",
    undefined
  );
  quantityKind.addLabel(new LangString("Specific Internal Energy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-KiloGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/W-HR-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-FT-PER-LB"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT-PER-LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaJ-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH-PER-LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloJ-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/N-M-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-GM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-GM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificEnergy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpecificInternalEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpecificModulus",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Specific Modulus", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GigaPA-CentiM3-PER-GM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloM2-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-SEC2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpecificModulus",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpecificOpticalRotationalAbility",
    "http://qudt.org/vocab/dimensionvector/A-1E0L2I0M0H0T0D0",
    "0173-1#Z4-BAJ425#001",
    undefined
  );
  quantityKind.addLabel(
    new LangString("specific optical rotational ability", "en-US")
  );
  quantityKind.addLabel(
    new LangString("specific optical rotational ability", undefined)
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpecificOpticalRotationalAbility",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpecificOpticalRotatoryPower",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M-1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Specific Optical Rotatory Power", "en")
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/RAD-M2-PER-KiloGM"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpecificOpticalRotatoryPower",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpecificPower",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Specific Power", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroSV-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroSV-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliSV-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliSV-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliW-PER-MilliGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGRAY-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SV-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/REM-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SV-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/ERG-PER-GM-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliSV-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-KiloGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliRAD_R-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAY-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGRAY-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGRAY-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGRAY-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAY-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAY-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGRAY-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGRAY-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGRAY-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGRAY-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoSV-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SV-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGRAY-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoSV-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoSV-PER-HR");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpecificPower",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpecificSurfaceArea",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M-1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Specific Surface Area", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM2-PER-GM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-KiloGM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpecificSurfaceArea",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpecificThrust",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Specific thrust", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpecificThrust",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpecificVolume",
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M-1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Specific Volume", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM3-PER-GM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT3-PER-LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliL-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliL-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciL-PER-GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-KiloGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-GM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN3-PER-LB");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciM3-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM3-PER-KiloGM"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpecificVolume",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpecificWeight",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-2D0",
    "γ",
    undefined
  );
  quantityKind.addLabel(new LangString("specific weight", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_F-PER-IN3");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpecificWeight",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpectralAngularCrossSection",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Spectral Angular Cross-section", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-SR-J");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM2-PER-SR-ERG"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpectralAngularCrossSection",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpectralConcentrationOfRadiantEnergyDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "0173-1#Z4-BAJ379#002",
    undefined
  );
  quantityKind.addLabel(
    new LangString("spectral concentration of radiant energy density", "en-US")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpectralConcentrationOfRadiantEnergyDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpectralConcentrationOfVibrationalModes",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T1D0",
    "0173-1#Z4-BAJ431#001",
    undefined
  );
  quantityKind.addLabel(
    new LangString(
      "spectral concentration of vibrational modes (in terms of angular frequency)",
      "en-US"
    )
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpectralConcentrationOfVibrationalModes",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpectralCrossSection",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Spectral Cross-section", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM2-PER-ERG"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-J");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpectralCrossSection",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpectralDensityOfVibrationalModes",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("spectral density of vibrational modes", undefined)
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SEC-PER-M3-RAD"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpectralDensityOfVibrationalModes",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpectralEmittance",
    "http://qudt.org/vocab/dimensionvector/A0E0L-4I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Measurement Unit of Spectral Emittance", undefined)
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpectralEmittance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpectralIrradiance",
    "http://qudt.org/vocab/dimensionvector/A0E0L-4I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Measurement Unit of Spectral Irradiance", undefined)
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpectralIrradiance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpectralLuminousEfficiency",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "V",
    undefined
  );
  quantityKind.addLabel(new LangString("Spectral Luminous Efficiency", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpectralLuminousEfficiency",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpectralRadiance",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Measurement Unit of Spectral Radiance", undefined)
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliW-PER-M2-NanoM-SR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroW-PER-CentiM2-MicroM-SR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/W-PER-M2-MicroM-SR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/W-PER-M2-MicroM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/W-PER-M2-NanoM-SR"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpectralRadiance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpectralRadiantEnergyDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Spectral Radiant Energy Density", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA-PER-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoPA-PER-KiloM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-M4");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloPA-PER-MilliM"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpectralRadiantEnergyDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpectralRadiantEnergyDensityInTermsOfWavelength",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString(
      "spectral radiant energy density in terms of wavelength",
      undefined
    )
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpectralRadiantEnergyDensityInTermsOfWavelength",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Speed",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Speed", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HZ-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaHZ-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BFT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaHZ-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT3-PER-MIN-FT2"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Speed",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpeedOfLight",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Kelajuan cahaya", "ms"));
  quantityKind.addLabel(new LangString("光速", "ja"));
  quantityKind.addLabel(new LangString("سرعت نور", "fa"));
  quantityKind.addLabel(new LangString("Prędkość światła", "pl"));
  quantityKind.addLabel(new LangString("Işık hızı", "tr"));
  quantityKind.addLabel(new LangString("Velocidade da luz", "pt"));
  quantityKind.addLabel(new LangString("Rychlost světla", "cs"));
  quantityKind.addLabel(new LangString("vitesse de la lumière", "fr"));
  quantityKind.addLabel(new LangString("प्रकाश का वेग", "hi"));
  quantityKind.addLabel(new LangString("Скорость света", "ru"));
  quantityKind.addLabel(new LangString("speed of light", "en"));
  quantityKind.addLabel(new LangString("velocità della luce", "it"));
  quantityKind.addLabel(new LangString("velocidad de la luz", "es"));
  quantityKind.addLabel(new LangString("سرعة الضوء", "ar"));
  quantityKind.addLabel(new LangString("Lichtgeschwindigkeit", "de"));
  quantityKind.addLabel(new LangString("光速", "zh"));
  quantityKind.addLabel(new LangString("Hitrost svetlobe", "sl"));
  quantityKind.addLabel(new LangString("Viteza luminii", "ro"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HZ-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaHZ-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BFT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaHZ-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT3-PER-MIN-FT2"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Speed"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpeedOfLight",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpeedOfSound",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    "c",
    undefined
  );
  quantityKind.addLabel(new LangString("سرعت صوت", "fa"));
  quantityKind.addLabel(new LangString("音速", "ja"));
  quantityKind.addLabel(new LangString("音速", "zh"));
  quantityKind.addLabel(new LangString("Schallgeschwindigkeit", "de"));
  quantityKind.addLabel(new LangString("prędkość dźwięku", "pl"));
  quantityKind.addLabel(new LangString("velocidad del sonido", "es"));
  quantityKind.addLabel(new LangString("speed of sound", "en"));
  quantityKind.addLabel(new LangString("Kelajuan bunyi", "ms"));
  quantityKind.addLabel(new LangString("سرعة الصوت", "ar"));
  quantityKind.addLabel(new LangString("Ses hızı", "tr"));
  quantityKind.addLabel(new LangString("vitesse du son", "fr"));
  quantityKind.addLabel(new LangString("rychlost zvuku", "cs"));
  quantityKind.addLabel(new LangString("viteza sunetului", "ro"));
  quantityKind.addLabel(new LangString("velocidade do som", "pt"));
  quantityKind.addLabel(new LangString("ध्वनि का वेग", "hi"));
  quantityKind.addLabel(new LangString("скорость звука", "ru"));
  quantityKind.addLabel(new LangString("Hitrost zvoka", "sl"));
  quantityKind.addLabel(new LangString("velocità del suono", "it"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HZ-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaHZ-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BFT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaHZ-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT3-PER-MIN-FT2"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Speed"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpeedOfSound",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpeedRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Speed Ratio", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ONE-PER-ONE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERMITTIVITY_REL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpeedRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SphericalIlluminance",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I1M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Illuminance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PHOT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LUX");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Illuminance"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SphericalIlluminance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Spin",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-1D0",
    "s",
    undefined
  );
  quantityKind.addLabel(new LangString("spin", "en"));
  quantityKind.addLabel(new LangString("spin", "fr"));
  quantityKind.addLabel(new LangString("Spin", "ms"));
  quantityKind.addLabel(new LangString("spin", "it"));
  quantityKind.addLabel(new LangString("Spin", "de"));
  quantityKind.addLabel(new LangString("spin", "cs"));
  quantityKind.addLabel(new LangString("espín", "es"));
  quantityKind.addLabel(new LangString("spin", "pt"));
  quantityKind.addLabel(new LangString("Спин", "ru"));
  quantityKind.addLabel(new LangString("لف مغزلي", "ar"));
  quantityKind.addLabel(new LangString("spin", "sl"));
  quantityKind.addLabel(new LangString("spin", "pl"));
  quantityKind.addLabel(new LangString("自旋", "zh"));
  quantityKind.addLabel(new LangString("Spin", "ro"));
  quantityKind.addLabel(new LangString("Spin", "tr"));
  quantityKind.addLabel(new LangString("スピン角運動量", "ja"));
  quantityKind.addLabel(new LangString("اسپین/چرخش", "fa"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-M-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-M2-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F-SEC");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AngularMomentum"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Spin",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpinQuantumNumber",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "s",
    undefined
  );
  quantityKind.addLabel(new LangString("Spin Quantum Number", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/QuantumNumber"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpinQuantumNumber",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SquareEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M2H0T-4D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Square Energy", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SquareEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SquareTime",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Square Time", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SEC2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-CentiM-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-MilliM-BAR"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SquareTime",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/StagePropellantMass",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    "M_F",
    undefined
  );
  quantityKind.addLabel(new LangString("Stage Propellant Mass", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PENNYWEIGHT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/StagePropellantMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/StageStructuralMass",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    "M_S",
    undefined
  );
  quantityKind.addLabel(new LangString("Stage Structure Mass", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PENNYWEIGHT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/StageStructuralMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/StandardAbsoluteActivity",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Standard Absolute Activity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/StandardAbsoluteActivity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/StandardChemicalPotential",
    "http://qudt.org/vocab/dimensionvector/A-1E0L2I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Standard Chemical Potential", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-MOL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-MOL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ-PER-MOL");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ChemicalPotential"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/StandardChemicalPotential",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/StandardGravitationalParameter",
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Standard Gravitational Parameter", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-SEC2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloM3-PER-SEC2"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/StandardGravitationalParameter",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/StateDensity",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    "0173-1#Z4-BAJ427#001",
    undefined
  );
  quantityKind.addLabel(new LangString("state density", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/StateDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/StateDensityAsExpressionOfAngularFrequency",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T1D0",
    "0173-1#Z4-BAJ454#001",
    undefined
  );
  quantityKind.addLabel(
    new LangString(
      "state density as expression of angular frequency)",
      undefined
    )
  );
  quantityKind.addLabel(
    new LangString("state density as expression of angular frequency", "en-US")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/StateDensityAsExpressionOfAngularFrequency",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/StateOfCharge",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "SoC",
    undefined
  );
  quantityKind.addLabel(new LangString("State of charge", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/StateOfCharge",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/StaticFriction",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Static Friction", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_F_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPOND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-M-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DYN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckForce");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Friction"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/StaticFriction",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/StaticFrictionCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Static Friction Coefficient", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/FrictionCoefficient"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/StaticFrictionCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/StaticPressure",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    "p",
    undefined
  );
  quantityKind.addLabel(new LangString("Static pressure", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-IN2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_32DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroTORR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_60DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARYE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA_A");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroATM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliTORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_60DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR_A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR_A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckPressure"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_H2O_4DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_HG_0DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HGA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Pressure"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/StaticPressure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/StatisticalWeight",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "g",
    undefined
  );
  quantityKind.addLabel(new LangString("Statistical Weight", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/StatisticalWeight",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/StochasticProcess",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    "X",
    undefined
  );
  quantityKind.addLabel(new LangString("Stochastic Process", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaHZ");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-WK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaHZ");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraHZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MilliSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MO");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-YR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SAMPLE-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliHZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-WK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckFrequency"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaHZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-MO"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloHZ");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-YR"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Frequency"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/StochasticProcess",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/StoichiometricNumber",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Stoichiometric Number", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Dimensionless"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/StoichiometricNumber",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Strain",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Strain", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ONE-PER-ONE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERMITTIVITY_REL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LengthRatio"
  );
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/LinearStrain"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Strain",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/StrainEnergyDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    "u",
    undefined
  );
  quantityKind.addLabel(new LangString("Strain Energy Density", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/ERG-PER-CentiM3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-M3");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EnergyDensity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/StrainEnergyDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/StrainEnergyReleaseRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    "G",
    undefined
  );
  quantityKind.addLabel(new LangString("Strain Energy Release Rate", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/ERG-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-CentiM2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EnergyPerArea"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/StrainEnergyReleaseRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Stress",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Stress", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-IN2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_32DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroTORR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_60DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARYE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA_A");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroATM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliTORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_60DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR_A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR_A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckPressure"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_H2O_4DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_HG_0DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HGA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ForcePerArea"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Stress",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/StressIntensityFactor",
    "http://qudt.org/vocab/dimensionvector/A0E0L-0dot5I0M1H0T-2D0",
    "K",
    undefined
  );
  quantityKind.addLabel(new LangString("Stress Intensity Factor", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA-M0dot5");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPA-M0dot5");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/StressIntensityFactor",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/StressOpticCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H0T2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Stress-Optic Coefficient", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoM-PER-MilliM-MegaPA"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoM-PER-CentiM-MegaPA"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MegaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BREWSTER");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-PSI");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoM-PER-CentiM-PSI"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/StressOpticCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/StructuralEfficiency",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Structural Efficiency", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DECADE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FLIGHT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RPK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_MAG"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaBasePair");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BasePair");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/COUNT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HeartBeat");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OCT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_ELEC"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Dimensionless"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/StructuralEfficiency",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/StructureFactor",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "F(h, k, l)",
    undefined
  );
  quantityKind.addLabel(new LangString("Structure Factor", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/StructureFactor",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SunProtectionFactorOfAProduct",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("sun protection factor of a product", undefined)
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SPF");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SunProtectionFactorOfAProduct",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SuperconductionTransitionTemperature",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T0D0",
    "T_c",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Superconduction Transition Temperature", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliDEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_R");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckTemperature"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_F");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Temperature"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SuperconductionTransitionTemperature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SuperconductorEnergyGap",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "Δ",
    undefined
  );
  quantityKind.addLabel(new LangString("Superconductor Energy Gap", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/GapEnergy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SuperconductorEnergyGap",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SurfaceActivityDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T-1D0",
    "a_s",
    undefined
  );
  quantityKind.addLabel(new LangString("Surface Activity Density", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BQ-PER-M2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SurfaceActivityDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SurfaceCoefficientOfHeatTransfer",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Surface Coefficient of Heat Transfer", "en")
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloW-PER-M2-K"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-M2-K");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SurfaceCoefficientOfHeatTransfer",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SurfaceDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Surface Density", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-KiloM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-IN2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-IN2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-YD2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SurfaceDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SurfaceRelatedVolumeFlow",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    "0173-1#Z4-BAJ421#003",
    undefined
  );
  quantityKind.addLabel(new LangString("surface-related volume flow", "en-US"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-HA-YR");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SurfaceRelatedVolumeFlow",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SurfaceRelatedVolumeFlowRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("surface‑related volume flow rate", undefined)
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-SEC-M2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SurfaceRelatedVolumeFlowRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SurfaceTension",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    "γ",
    undefined
  );
  quantityKind.addLabel(new LangString("Oberflächenspannung", "de"));
  quantityKind.addLabel(new LangString("Tegangan permukaan", "ms"));
  quantityKind.addLabel(new LangString("površinska napetost", "sl"));
  quantityKind.addLabel(new LangString("Yüzey gerilimi", "tr"));
  quantityKind.addLabel(new LangString("поверхностное натяжение", "ru"));
  quantityKind.addLabel(new LangString("पृष्ठ तनाव", "hi"));
  quantityKind.addLabel(new LangString("tension superficielle", "fr"));
  quantityKind.addLabel(new LangString("tensión superficial", "es"));
  quantityKind.addLabel(new LangString("surface tension", "en"));
  quantityKind.addLabel(new LangString("表面張力", "ja"));
  quantityKind.addLabel(new LangString("表面张力", "zh"));
  quantityKind.addLabel(new LangString("توتر سطحي", "ar"));
  quantityKind.addLabel(new LangString("Tensiune superficială", "ro"));
  quantityKind.addLabel(new LangString("napięcie powierzchniowe", "pl"));
  quantityKind.addLabel(new LangString("کشش سطحی", "fa"));
  quantityKind.addLabel(new LangString("tensione superficiale", "it"));
  quantityKind.addLabel(new LangString("tensão superficial", "pt"));
  quantityKind.addLabel(new LangString("povrchové napětí", "cs"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-FT2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloBTU_IT-PER-FT2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GigaN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LANGLEY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-M-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/ERG-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloW-HR-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-CentiM2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EnergyPerArea"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SurfaceTension",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SurgeImpedanceOfTheMedium",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-1D0",
    "0173-1#Z4-BAJ323#002",
    undefined
  );
  quantityKind.addLabel(
    new LangString("surge impedance of the medium", undefined)
  );
  quantityKind.addLabel(
    new LangString("surge impedance of the medium", "en-US")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SurgeImpedanceOfTheMedium",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Susceptance",
    "http://qudt.org/vocab/dimensionvector/A0E2L-2I0M-1H0T3D0",
    "B",
    undefined
  );
  quantityKind.addLabel(new LangString("Susceptance", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Susceptance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SymbolTransmissionRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "0173-1#Z4-BAJ386#002",
    undefined
  );
  quantityKind.addLabel(new LangString("symbol transmission rate", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SymbolTransmissionRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SystolicBloodPressure",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Systolic Blood Pressure", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-IN2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_32DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroTORR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_60DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARYE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA_A");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroATM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliTORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_60DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR_A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR_A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckPressure"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_H2O_4DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_HG_0DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HGA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Pressure"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SystolicBloodPressure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TARGET-BOGIE-MASS",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Target Bogie Mass", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PENNYWEIGHT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TARGET-BOGIE-MASS",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Temperature",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Temperature", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliDEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_R");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckTemperature"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_F");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Temperature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TemperatureAmountOfSubstance",
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H1T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Temperature Amount of Substance", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL-DEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL-K");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TemperatureAmountOfSubstance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TemperatureBasedAmountOfSubstanceConcentration",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    "0173-1#Z4-BAJ395#002",
    undefined
  );
  quantityKind.addLabel(
    new LangString(
      "temperature-based amount-of-substance concentration",
      "en-US"
    )
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TemperatureBasedAmountOfSubstanceConcentration",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TemperatureBasedDensity",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    "0173-1#Z4-BAJ389#003",
    undefined
  );
  quantityKind.addLabel(new LangString("temperature-based density", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TemperatureBasedDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TemperatureBasedDynamicViscosity",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    "0173-1#Z4-BAJ390#002",
    undefined
  );
  quantityKind.addLabel(
    new LangString("temperature-based dynamic viscosity", "en-US")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TemperatureBasedDynamicViscosity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TemperatureBasedKinematicViscosity",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    "0173-1#Z4-BAJ392#002",
    undefined
  );
  quantityKind.addLabel(
    new LangString("temperature-based kinematic viscosity", "en-US")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TemperatureBasedKinematicViscosity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TemperatureBasedLength",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H-1T0D0",
    "0173-1#Z4-BAJ393#002",
    undefined
  );
  quantityKind.addLabel(new LangString("temperature-based length", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TemperatureBasedLength",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TemperatureBasedMass",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    "0173-1#Z4-BAJ394#002",
    undefined
  );
  quantityKind.addLabel(new LangString("temperature-based mass", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TemperatureBasedMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TemperatureBasedMassFlowRate",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    "0173-1#Z4-BAJ396#002",
    undefined
  );
  quantityKind.addLabel(
    new LangString("temperature-based mass flow rate", "en-US")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TemperatureBasedMassFlowRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TemperatureBasedQuantity",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("temperature-based quantity", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TemperatureBasedQuantity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TemperatureBasedVelocity",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    "0173-1#Z4-BAJ391#001",
    undefined
  );
  quantityKind.addLabel(new LangString("temperature-based velocity", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TemperatureBasedVelocity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TemperatureBasedVolumeFlowRate",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    "0173-1#Z4-BAJ397#002",
    undefined
  );
  quantityKind.addLabel(
    new LangString("temperature-based volume flow rate", "en-US")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TemperatureBasedVolumeFlowRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TemperatureDifference",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T0D0",
    "ΔT",
    undefined
  );
  quantityKind.addLabel(new LangString("temperature difference", "en"));
  quantityKind.addLabel(new LangString("Temperaturdifferenz", "de"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliDEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_R");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckTemperature"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_F");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Temperature"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TemperatureDifference",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TemperatureGradient",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H1T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Temperature Gradient", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K-PER-M");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TemperatureGradient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TemperaturePerMagneticFluxDensity",
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M-1H1T2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Temperature per Magnetic Flux Density", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K-PER-T");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TemperaturePerMagneticFluxDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TemperaturePerSquareTime",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Temperature per Square Time", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEG_F-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K-PER-SEC2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TemperaturePerSquareTime",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TemperaturePerTime",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Temperature per Time", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_F-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_R-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_R-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_R-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_F-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_F-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C-PER-YR");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TemperaturePerTime",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TemperaturePerTime_Squared",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Temperature per Time Squared", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TemperaturePerTime_Squared",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TemperatureRateOfChange",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T-1D0",
    "0173-1#Z4-BAJ416#002",
    undefined
  );
  quantityKind.addLabel(new LangString("Temperature Rate of Change", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_F-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_R-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_R-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_R-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_F-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_F-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C-PER-YR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TemperaturePerTime"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TemperatureRateOfChange",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TemperatureRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Temperature Ratio", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C-PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_F-PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliK-PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K-PER-K");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TemperatureRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TemperatureRelatedMolarMass",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    "0173-1#Z4-BAJ443#002",
    undefined
  );
  quantityKind.addLabel(
    new LangString("temperature-related molar mass", "en-US")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TemperatureRelatedMolarMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TemperatureRelatedVolume",
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H-1T0D0",
    "0173-1#Z4-BAJ398#002",
    undefined
  );
  quantityKind.addLabel(
    new LangString("temperature-related volume  ", "en-US")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TemperatureRelatedVolume",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TemperatureVariance",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H2T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Temperature Variance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TemperatureVariance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TemperatureVariance_NEON",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H2T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Temperature Variance, NEON", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TemperatureVariance_NEON",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TemporalSummationFunction",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Temporal Summation Function", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-SEC-SR");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TemporalSummationFunction",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Tension",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Tension", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_F_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPOND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-M-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DYN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckForce");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ForceMagnitude"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Tension",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ThermalAdmittance",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Thermal Admittance", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_IT-PER-SEC-CentiM2-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC-FT2-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-SEC-FT2-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-HR-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-HR-FT2-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-SEC-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-HR-FT2-DEG_R"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-SEC-CentiM2-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloW-PER-M2-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-HR-FT2-DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-M2-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC-FT2-DEG_R"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-SEC3-K"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CoefficientOfHeatTransfer"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ThermalAdmittance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ThermalCapacitance",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H-1T-2D0",
    "0173-1#Z4-BAJ406#002",
    undefined
  );
  quantityKind.addLabel(new LangString("thermal capacitance", "en-US"));
  quantityKind.addLabel(new LangString("thermal capacitance", undefined));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-DEG_R"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-DEG_F"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ThermalCapacitance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ThermalCoefficientOfLinearExpansion",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H-1T0D0",
    "0173-1#Z4-BAJ473#002",
    undefined
  );
  quantityKind.addLabel(
    new LangString("thermal coefficient of linear expansion", "en-US")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ThermalCoefficientOfLinearExpansion",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ThermalConductance",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H-1T-3D0",
    "G",
    undefined
  );
  quantityKind.addLabel(new LangString("Thermal Conductance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVA-PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VA-PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroVA-PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliVA-PER-K");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ThermalConductance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ThermalConductivity",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H-1T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Thermal Conductivity", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-IN-PER-FT2-SEC-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM-SEC-DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-M-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-IN-PER-FT2-HR-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloW-PER-M-DEG_C"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL_IT-PER-HR-M-DEG_C"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-IN-PER-FT2-HR-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-FT-PER-FT2-HR-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-SEC-CentiM-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-FT-PER-FT2-HR-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-CentiM-SEC-DEG_C"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-IN-PER-HR-FT2-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-FT-PER-HR-FT2-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC-FT-DEG_R"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-PER-M-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-IN-PER-SEC-FT2-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-IN-PER-FT2-SEC-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_IT-PER-SEC-CentiM-K"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-M-DEG_C");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ThermalConductivity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ThermalDiffusionFactor",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Thermal Diffusion Factor", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ThermalDiffusionFactor",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ThermalDiffusionRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "k_T",
    undefined
  );
  quantityKind.addLabel(new LangString("Thermal Diffusion Ratio", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ThermalDiffusionRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ThermalDiffusionRatioCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-1D0",
    "D_T",
    undefined
  );
  quantityKind.addLabel(new LangString("Thermal Diffusion Coefficient", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-SEC");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ThermalDiffusionRatioCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ThermalDiffusivity",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-1D0",
    "a",
    undefined
  );
  quantityKind.addLabel(new LangString("Thermal Diffusivity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN2-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM2-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM2-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT2-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT2-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-HZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AreaPerTime"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ThermalDiffusivity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ThermalEfficiency",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Thermal Efficiency", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ONE-PER-ONE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERMITTIVITY_REL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ThermalEfficiency",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ThermalEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Thermal Energy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_15DEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_20DEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_MEAN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL_Mean");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_MEAN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_39DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_59DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_FG-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_60DEG_F");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ThermalEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ThermalEnergyLength",
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Thermal Energy Length", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT-IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT-FT");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ThermalEnergyLength",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ThermalExpansionCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H-1T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Thermal Expansion Coefficient", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-DEG_C-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM-PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-DEG_F");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-DEG_C-M"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MegaK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-DEG_C");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM-PER-K");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ExpansionRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ThermalExpansionCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ThermalInertia",
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H-1T-2.5D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Measurement Unit of Thermal Inertia", undefined)
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ThermalInertia",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ThermalInsulance",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H1T3D0",
    "M",
    undefined
  );
  quantityKind.addLabel(new LangString("Thermal Insulance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CLO");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/M2-HR-DEG_C-PER-KiloCAL_IT"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEG_F-HR-FT2-PER-BTU_IT"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEG_F-HR-FT2-PER-BTU_TH"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT2-HR-DEG_F-PER-BTU_IT"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-K-PER-W");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ThermalInsulance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ThermalInsulation",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H1T3D0",
    "0173-1#Z4-BAJ404#002",
    undefined
  );
  quantityKind.addLabel(new LangString("thermal insulation", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ThermalInsulation",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ThermalResistance",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M-1H1T3D0",
    "R",
    undefined
  );
  quantityKind.addLabel(new LangString("opór cieplny", "cs"));
  quantityKind.addLabel(new LangString("thermischer Widerstand", "de"));
  quantityKind.addLabel(new LangString("مقاومة حرارية", "ar"));
  quantityKind.addLabel(new LangString("resistência térmica", "pt"));
  quantityKind.addLabel(new LangString("熱抵抗", "ja"));
  quantityKind.addLabel(new LangString("resistenza termica", "it"));
  quantityKind.addLabel(new LangString("résistance thermique", "fr"));
  quantityKind.addLabel(new LangString("热阻", "zh"));
  quantityKind.addLabel(new LangString("thermal resistance", "en"));
  quantityKind.addLabel(new LangString("resistencia térmica", "es"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEG_F-HR-PER-BTU_IT"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEG_F-SEC-PER-BTU_IT"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K-PER-W");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEG_F-HR-PER-BTU_TH"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEG_F-SEC-PER-BTU_TH"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ThermalResistance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ThermalResistivity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M-1H1T3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Thermal Resistivity", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEG_F-HR-FT2-PER-BTU_IT-IN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-K-PER-W");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K-M-PER-W");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEG_F-HR-FT2-PER-BTU_TH-IN"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ThermalResistivity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ThermalTransmittance",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Thermal Transmittance", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_IT-PER-SEC-CentiM2-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC-FT2-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-SEC-FT2-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-HR-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-HR-FT2-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-SEC-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-HR-FT2-DEG_R"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-SEC-CentiM2-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloW-PER-M2-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-HR-FT2-DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-M2-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC-FT2-DEG_R"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-SEC3-K"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CoefficientOfHeatTransfer"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ThermalTransmittance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ThermalUtilizationFactor",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "f",
    undefined
  );
  quantityKind.addLabel(new LangString("Thermal Utilization Factor", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ThermalUtilizationFactor",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ThermalUtilizationFactorForFission",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "f",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Thermal Utilization Factor For Fission", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DECADE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FLIGHT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RPK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_MAG"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaBasePair");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BasePair");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/COUNT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HeartBeat");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OCT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_ELEC"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Dimensionless"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ThermalUtilizationFactorForFission",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ThermodynamicCriticalMagneticFluxDensity",
    "http://qudt.org/vocab/dimensionvector/A0E-1L0I0M1H0T-2D0",
    "B_c",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Thermodynamic Critical Magnetic Flux Density", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUSS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGAUSS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAMMA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/T_Ab");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticFluxDensity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ThermodynamicCriticalMagneticFluxDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ThermodynamicEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "U",
    undefined
  );
  quantityKind.addLabel(new LangString("Thermodynamic Energy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/EnergyInternal"
  );
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/InternalEnergy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ThermodynamicEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ThermodynamicEntropy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H-1T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Thermodynamic Entropy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ-PER-K");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EnergyPerTemperature"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ThermodynamicEntropy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ThermodynamicTemperature",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T0D0",
    "T",
    undefined
  );
  quantityKind.addLabel(
    new LangString("temperatura thermodynamica absoluta", "la")
  );
  quantityKind.addLabel(new LangString("temperatura", "sl"));
  quantityKind.addLabel(new LangString("Απόλυτη", "el"));
  quantityKind.addLabel(new LangString("température thermodynamique", "fr"));
  quantityKind.addLabel(new LangString("دمای ترمودینامیکی", "fa"));
  quantityKind.addLabel(new LangString("Термодинамическая температура", "ru"));
  quantityKind.addLabel(new LangString("abszolút hőmérséklet", "hu"));
  quantityKind.addLabel(new LangString("temperatura", "pl"));
  quantityKind.addLabel(new LangString("temperatura termodinamica", "it"));
  quantityKind.addLabel(new LangString("Termodynamická teplota", "cs"));
  quantityKind.addLabel(new LangString("temperatură termodinamică", "ro"));
  quantityKind.addLabel(new LangString("热力学温度", "zh"));
  quantityKind.addLabel(new LangString("טמפרטורה מוחלטת", "he"));
  quantityKind.addLabel(new LangString("Suhu termodinamik", "ms"));
  quantityKind.addLabel(new LangString("thermodynamische Temperatur", "de"));
  quantityKind.addLabel(new LangString("Термодинамична температура", "bg"));
  quantityKind.addLabel(new LangString("熱力学温度", "ja"));
  quantityKind.addLabel(new LangString("temperatura", "es"));
  quantityKind.addLabel(new LangString("درجة الحرارة المطلقة", "ar"));
  quantityKind.addLabel(new LangString("ऊष्मगतिकीय तापमान", "hi"));
  quantityKind.addLabel(new LangString("termodinamik sıcaklık", "tr"));
  quantityKind.addLabel(new LangString("thermodynamic temperature", "en"));
  quantityKind.addLabel(new LangString("temperatura", "pt"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_R");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckTemperature"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Temperature"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ThermodynamicTemperature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Thickness",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "d",
    undefined
  );
  quantityKind.addLabel(new LangString("Thickness", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Thickness",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ThomsonCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H-1T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Thomson Coefficient", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-PER-K");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ThomsonCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Thrust",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Thrust", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_F_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPOND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-M-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DYN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckForce");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Force"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Thrust",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ThrustCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    "C_{F}",
    undefined
  );
  quantityKind.addLabel(new LangString("Thrust Coefficient", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ThrustCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ThrustToMassRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Thrust To Mass Ratio", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-KiloGM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Acceleration"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ThrustToMassRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ThrustToWeightRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Thrust To Weight Ratio", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ONE-PER-ONE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERMITTIVITY_REL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ThrustToWeightRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ThrusterPowerToThrustEfficiency",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Thruster Power To Thrust Efficiency", "en")
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-PER-MIN-PSI"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-HR-PSI");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-PER-SEC-PSI"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ThrusterPowerToThrustEfficiency",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Tilt",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Tilt", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARCSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARCMIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN_Angle");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliARCSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/REV");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Angle"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Tilt",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Time",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    "t",
    undefined
  );
  quantityKind.addLabel(new LangString("čas", "sl"));
  quantityKind.addLabel(new LangString("时间", "zh"));
  quantityKind.addLabel(new LangString("tempo", "it"));
  quantityKind.addLabel(new LangString("tempus", "la"));
  quantityKind.addLabel(new LangString("Čas", "cs"));
  quantityKind.addLabel(new LangString("time", "en"));
  quantityKind.addLabel(new LangString("idő", "hu"));
  quantityKind.addLabel(new LangString("Zeit", "de"));
  quantityKind.addLabel(new LangString("Masa", "ms"));
  quantityKind.addLabel(new LangString("Време", "bg"));
  quantityKind.addLabel(new LangString("tiempo", "es"));
  quantityKind.addLabel(new LangString("timp", "ro"));
  quantityKind.addLabel(new LangString("時間", "ja"));
  quantityKind.addLabel(new LangString("زمان", "fa"));
  quantityKind.addLabel(new LangString("zaman", "tr"));
  quantityKind.addLabel(new LangString("زمن", "ar"));
  quantityKind.addLabel(new LangString("czas", "pl"));
  quantityKind.addLabel(new LangString("temps", "fr"));
  quantityKind.addLabel(new LangString("זמן", "he"));
  quantityKind.addLabel(new LangString("Χρόνος", "el"));
  quantityKind.addLabel(new LangString("समय", "hi"));
  quantityKind.addLabel(new LangString("Время", "ru"));
  quantityKind.addLabel(new LangString("tempo", "pt"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliH-PER-KiloOHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/WK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckTime");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Common");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MO_MeanGREGORIAN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HR_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoSEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroH-PER-KiloOHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H-PER-OHM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroH-PER-OHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DAY_Sidereal");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliPA-SEC-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO_Synodic");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POISE-PER-BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiPOISE-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POISE-PER-PA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliH-PER-OHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_TROPICAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H-PER-KiloOHM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Metrology");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PA-SEC-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloYR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaYR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO_MeanJulian");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Time",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TimeAveragedSoundIntensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    "I",
    undefined
  );
  quantityKind.addLabel(new LangString("Time averaged sound intensity", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-IN2-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoW-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroW-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-CentiM2-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC-FT2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/ERG-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-CentiM2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-HR-FT2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliW-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-IN2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoW-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PA-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-FT2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoundIntensity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TimeAveragedSoundIntensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TimeConstant_Inductance",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("time constant (inductance based)", undefined)
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TimeConstant_Inductance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TimePerCount",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Time per Count", undefined));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SEC-PER-NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DAY-PER-NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HR-PER-NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR-PER-NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN-PER-NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/WK-PER-NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO-PER-NUM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TimePerCount",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TimeRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Time Ratio", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HR-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TimeRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TimeRelatedLogarithmicRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    "0173-1#Z4-BAJ415#002",
    undefined
  );
  quantityKind.addLabel(
    new LangString("time-related logarithmic ratio", "en-US")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TimeRelatedLogarithmicRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TimeTemperature",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Time Temperature", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_F-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C-WK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_F-DAY");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TimeTemperature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Time_Squared",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Time Squared", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Time_Squared",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Torque",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "M",
    undefined
  );
  quantityKind.addLabel(new LangString("عزم محورى", "ar"));
  quantityKind.addLabel(new LangString("momento de torção", "pt"));
  quantityKind.addLabel(new LangString("couple", "fr"));
  quantityKind.addLabel(new LangString("トルク", "ja"));
  quantityKind.addLabel(new LangString("torque", "en"));
  quantityKind.addLabel(new LangString("coppia", "it"));
  quantityKind.addLabel(new LangString("moment obrotowy", "pl"));
  quantityKind.addLabel(new LangString("par", "es"));
  quantityKind.addLabel(new LangString("转矩", "zh"));
  quantityKind.addLabel(new LangString("Torsionmoment", "de"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_F-IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM_F-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciN-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliN-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DYN-CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiN-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DYN-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroN-M");
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/MomentOfForce"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Torque",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TorqueConstant",
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-2D0",
    "0173-1#Z4-BAJ298#002",
    undefined
  );
  quantityKind.addLabel(new LangString("torque constant", undefined));
  quantityKind.addLabel(new LangString("torque constant", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TorqueConstant",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TorquePerAngle",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Torque per Angle", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-M-PER-RAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-M-PER-DEG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/N-M-PER-MIN_Angle"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/N-M-PER-ARCMIN"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TorquePerAngle",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TorquePerLength",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Torque per Length", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-M-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-M-PER-M");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TorquePerLength",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TorsionalRigidity",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("torsional rigidity", undefined));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TorsionalRigidity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TorsionalSpringConstant",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "0173-1#Z4-BAJ448#002",
    undefined
  );
  quantityKind.addLabel(new LangString("Federkonstante Drehfeder", "de"));
  quantityKind.addLabel(new LangString("torsional spring constant", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-M-PER-RAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-M-PER-DEG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/N-M-PER-MIN_Angle"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-M-PER-DEG"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/N-M-PER-ARCMIN"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TorsionalSpringConstant",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TotalAngularMomentum",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-1D0",
    "J",
    undefined
  );
  quantityKind.addLabel(new LangString("Total Angular Momentum", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-M-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-M2-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F-SEC");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AngularMomentum"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TotalAngularMomentum",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TotalAngularMomentumQuantumNumber",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "j",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Total Angular Momentum Quantum Number", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/QuantumNumber"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TotalAngularMomentumQuantumNumber",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TotalAtomicStoppingPower",
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M1H0T-2D0",
    "S_a",
    undefined
  );
  quantityKind.addLabel(new LangString("Total Atomic Stopping Power", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-M2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TotalAtomicStoppingPower",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TotalCrossSection",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    "σₜ",
    undefined
  );
  quantityKind.addLabel(new LangString("Total Cross-section", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckArea");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloMIL_Circ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIL_Circ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaARE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PIXEL_AREA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CrossSection"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TotalCrossSection",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TotalCurrent",
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T0D0",
    "I_{tot}",
    undefined
  );
  quantityKind.addLabel(new LangString("Total Current", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoA");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TotalCurrent",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TotalCurrentDensity",
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Total Current Density", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-M2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TotalCurrentDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TotalIonization",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "N_i",
    undefined
  );
  quantityKind.addLabel(new LangString("Total Ionization", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TotalIonization",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TotalLinearStoppingPower",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    "S",
    undefined
  );
  quantityKind.addLabel(new LangString("Total Linear Stopping Power", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/ERG-PER-CentiM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/EV-PER-ANGSTROM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV-PER-M");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TotalLinearStoppingPower",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TotalMassStoppingPower",
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M0H0T-2D0",
    "S_m",
    undefined
  );
  quantityKind.addLabel(new LangString("Total Mass Stopping Power", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/EV-M2-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-M2-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/ERG-CentiM2-PER-GM"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TotalMassStoppingPower",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TotalPressure",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    "P_0",
    undefined
  );
  quantityKind.addLabel(new LangString("Total Pressure", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-IN2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_32DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroTORR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_60DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARYE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA_A");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroATM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliTORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_60DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR_A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR_A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckPressure"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_H2O_4DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_HG_0DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HGA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Pressure"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TotalPressure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TotalRadiance",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    "0173-1#Z4-BAJ318#002",
    undefined
  );
  quantityKind.addLabel(new LangString("total radiance", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TotalRadiance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TouchThresholds",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Touch Thresholds", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TouchThresholds",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TrafficIntensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "0173-1#Z4-BAJ462#001",
    undefined
  );
  quantityKind.addLabel(new LangString("traffic intensity", "en-US"));
  quantityKind.addLabel(new LangString("traffic intensity", undefined));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TrafficIntensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TransmissionRatioBetweenRotationAndTranslation",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "0173-1#Z4-BAJ400#003",
    undefined
  );
  quantityKind.addLabel(
    new LangString(
      "transmission ratio between rotation and translation",
      "en-US"
    )
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TransmissionRatioBetweenRotationAndTranslation",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Transmittance",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Transmittance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ONE-PER-ONE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERMITTIVITY_REL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Transmittance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TransmittanceDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "A_10, D",
    undefined
  );
  quantityKind.addLabel(new LangString("Transmittance Density", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TransmittanceDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TrueExhaustVelocity",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    "u_{e}",
    undefined
  );
  quantityKind.addLabel(new LangString("True Exhaust Velocity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaHZ-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-KiloYR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM-PER-YR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Velocity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TrueExhaustVelocity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Turbidity",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Turbidity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NTU");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Turbidity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Turns",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "N",
    undefined
  );
  quantityKind.addLabel(new LangString("Turns", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Count"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Turns",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Unbalance",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T0D0",
    "0173-1#Z4-BAJ432#001",
    undefined
  );
  quantityKind.addLabel(new LangString("unbalance", undefined));
  quantityKind.addLabel(new LangString("unbalance", "en-US"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-M");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Unbalance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Unknown",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Unknown", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-M3-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ-FT-SEC-PER-IN3-LB"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/M3-PER-DAY-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-PA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-PER-FT3-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SPIN_QUANTUM_NUMBER"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliK-PER-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-HR-PER-IN3-FT3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-MIN-PER-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-MIN-PER-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PER-KiloGM-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA-M-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-M3-POISE"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-HR-PER-FT3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-OHM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-POISE"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-MIN-PER-GAL_US-IN3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-PSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-PA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-DeciM3-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-MIN-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-PSI");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ-SEC-PER-IN3-GAL_US"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-MIN-PER-GAL_US2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ-IN2-PER-IN3-LB_F-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-PSI");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliOHM-PER-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ-FT2-PER-IN3-LB_F-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliVAR-PER-K"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-SEC-PER-GAL_UK-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-SEC-PER-GAL_UK"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ-SEC-PER-IN3-GAL_UK"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-HR-PER-CentiM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SON");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/A-HR-PER-DEG_C"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-PER-MIN-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TONNE-PER-MIN-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-SEC-PER-IN6"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-MIN-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-L-CentiPOISE"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-SEC-PER-IN3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_Metric-PER-HR-K"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-SEC-BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroMOL-PER-GM-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-HZ");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-HR-PER-GAL_UK-FT3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-SEC-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PER-MicroMOL-L"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-SEC-BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-MIN-PER-FT6"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL-PER-M3-PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-HR-PER-M3-CentiM3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_Metric-PER-HR-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-SEC-PER-GAL_US-IN3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-DeciM3-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliL-PER-HR-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliMOL-PER-MOL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroMOL-PER-GM-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD3-PER-PSI");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-MIN-PER-L-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoA-PER-MicroMOL-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciB-MilliW-PER-MegaHZ"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-HZ-DEG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-HZ2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_Metric-PER-SEC-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-SEC-PER-L2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-PA-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-HR-PER-IN3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-SEC-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-PERCENT"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-M-PER-M2-SR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-SEC-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ-HR-PER-IN3-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-SEC-PER-GAL_US2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-THOUSAND"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-MIN-PER-L-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-SEC-PER-M6");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliL-PER-MIN-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_SHORT-PER-HR-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TONNE-PER-HR-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ST-PER-BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-MIN-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliA-IN2-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-HR-PER-L-CentiM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OHM-PER-BAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ST-PER-PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-SEC-PA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ-SEC-PER-IN6"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-HR-PER-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-M3-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-FT-HR-PER-LB"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ-MIN-PER-IN3-GAL_US"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-TEN-THOUSAND"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-MIN-PER-GAL_UK-IN3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_Metric-PER-MIN-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ-MIN-PER-IN3-GAL_UK"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-HR-PER-M3-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/M2-PER-SEC-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-MIN-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-HR-PER-GAL_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-SEC2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM2-PER-CentiM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-BAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE-PER-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoMOL-PER-MicroGM-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-PER-FT-LB_F-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliA-PER-LB_F-IN2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TONNE-PER-M3-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEG_C2-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-SEC-PER-FT3-YD3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL-PER-GM-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PER-M-NanoM-SR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-DAY-K"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL-PER-L-BAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SEC-PER-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TONNE-PER-DAY-K"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPT_VOL");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-M3-POISE"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoA-PER-HectoPA"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloMOL-PER-M3-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA2-PER-SEC2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-A-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-MIN-PER-GAL_UK2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-SEC-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-M3-CentiPOISE"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-HR-PER-GAL_US"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_Metric-PER-MIN-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-HR-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA-SEC-PER-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_Metric-PER-DAY-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-HR-PER-L-CentiM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-SEC2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-MIN-PER-L2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-DAY-K"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-SEC-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-SEC-PER-FT3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-SEC-PER-M3-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-MIN-PER-GAL_UK-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-L-POISE"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-RAD");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-HR-PER-GAL_US-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-M3-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-CentiM3-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-HR-PER-FT3-IN3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-HR-PER-M3-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-M3-PA-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-MIN-PER-L2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-MIN-PER-M3-CentiM3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-MIN-PER-M6"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-HR-PER-GAL_UK2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-SEC-PER-CentiM3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-M3-MilliPA-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoW-PER-CentiM2-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-IN2-PER-GAL_UK-LB_F-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciB-MilliW");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-L-MilliPA-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroMOL-PER-MicroMOL-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-PA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-SEC-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-MIN-PER-FT3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-HR-PER-IN3-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TONNE-PER-MIN-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-HR-BAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A2-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-M3-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-MIN-PER-FT3-IN3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-BAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-HZ4");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-DAY-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-HZ3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MOL-PER-M3-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-HZ2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL-PER-M3-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-SEC-PER-GAL_UK-IN3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliL-PER-DAY-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-M3-MilliPA-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-M2-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TONNE-PER-DAY-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_SHORT-PER-PSI"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliL-PER-SEC-K"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-M-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-MIN-PER-IN6"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-SEC-SR-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BARN-PER-SR-EV"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloOHM-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-HR-PER-IN6");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-SEC-PER-M6"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-FT2-PER-GAL_US-LB_F-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-PER-L-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-DAY-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-SEC-PER-GAL_UK2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-PER-V");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-MIN-PER-M6");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-SEC-PER-GAL_US-YD3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-HA-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AWG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TONNE-PER-SEC-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-CentiM3-K"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-HR-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ-FT-HR-PER-IN3-LB"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-MIN-PER-M3-CentiM3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroMOL-PER-M2-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-PERCENT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARN-PER-EV");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-HR-PER-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-SEC-PA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-MIN-PER-GAL_US-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/M2-SEC-PER-RAD"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNKNOWN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-MIN-PER-M3-L"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-L-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-SEC-PER-M3-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_Metric-PER-M3-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-MIN-PER-L-CentiM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M4-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-M-SR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-MIN-BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-SEC-PER-IN3-FT3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-HR-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliL-PER-DAY-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_Metric-PER-DAY-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/K-M2-PER-KiloGM-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-MIN-PER-M3-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaCCY_USD-PER-YR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-PER-SEC-DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HR-PER-FT2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-HR-PER-GAL_UK-IN3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoMOL-PER-MicroMOL-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-IN2-PER-IN3-LB_F-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-MIN-PER-GAL_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K-PER-PA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-IN2-PER-GAL_US-LB_F-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-M3-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-CentiM-KiloYR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-SEC-PER-GAL_US-FT3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-L-CentiPOISE"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloOHM-PER-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoMOL-PER-GM-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-HR-PER-L-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-MIN-PER-GAL_UK"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-SEC-PER-M3-CentiM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-SEC2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-SEC-PER-FT3-IN3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-MIN-PER-IN3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-SEC-PER-M3-CentiM3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-SEC-PER-GAL_US"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaOHM-PER-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ-SEC-PER-IN3-FT3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-SEC-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiPOISE-PER-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-HR-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-SEC-PER-L-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-SEC-PER-GAL_UK"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliV-PER-V");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-HR-PER-GAL_US-IN3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-SEC-PER-L2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-MIN-PER-GAL_UK-FT3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-DEG"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-MIN-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-HR-BAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciB-W");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-L-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-HR-PER-GAL_US2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT2-PER-BTU_IT-IN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-SEC-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-MIN-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN-PER-SEC-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-PER-SEC-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MOL-PER-KiloGM-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliL-PER-SEC-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE-PER-BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-MIN-PER-IN3-FT3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM2-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-PA-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliL-PER-HR-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliW-PER-CentiM2-MicroM-SR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVAR-PER-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_Metric-PER-SEC-K"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-M2-M-SR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-M3-CentiPOISE"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaHZ-KiloM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ-MIN-PER-IN6"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-HR-PER-IN3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-HR-PER-GAL_UK-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-SEC-PER-IN3-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-HR-PER-M3-CentiM3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-DAY-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/N-M2-PER-KiloGM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-MIN-PER-FT3-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-DAY-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-MIN-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-IN2-PER-FT3-LB_F-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-L-PA-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/N-M-PER-W0dot5"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/M3-PER-KiloGM-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT3-PER-PSI");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ-MIN-PER-IN3-FT3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_F-PER-BAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-DAY-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-HUNDRED"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-HR-PER-IN6");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-MIN-PER-GAL_US-FT3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-MIN-PER-IN3-GAL_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K-PER-BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-FT-SEC-PER-LB"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-HR-K"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OHM-PER-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-MIN-PER-IN3-GAL_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM-PER-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEG_C-KiloGM-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-FT2-PER-GAL_UK-LB_F-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-HR-BAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaOHM-PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-HZ");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoMOL-PER-GM-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_Metric-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-DAY-BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-SEC-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliL-PER-MIN-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-MIN-PER-CentiM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-SR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliPA-SEC-PER-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_SHORT-PER-HR-PSI"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-HR-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TONNE-PER-SEC-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NP-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-SEC-PER-L-CentiM3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-MilliGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-SEC-PA"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-L-PA-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-SEC-PER-L-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloM-PER-SEC-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_Metric-PER-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-HR-PER-FT3-GAL_UK"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-MIN-PER-IN3-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-MIN-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K-M-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M3-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-HR-PER-L2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARN-PER-SR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliMOL-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-DAY-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_SHORT-PER-DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POISE-PER-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-HR-PER-IN3-GAL_US"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-HectoGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-HR-PER-IN3-GAL_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-SEC-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL-PER-MOL");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliA-PER-L-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-HR-PER-M6");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-HR-PER-FT3-GAL_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C-PER-BAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-DEG_C");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-SEC-PER-FT3-GAL_UK"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-M3-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliOHM-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL-PER-L-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ-SEC-PER-IN3-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-SEC-PER-IN3-GAL_UK"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-SEC-PER-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-HR-PER-L2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-DAY-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-SEC-PER-IN3-GAL_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K-PA-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoMOL-PER-M-W-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-MIN-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-HR-PER-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M3-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-HR-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MOL-PER-M2-SEC-M-SR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-MilliPA-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-HR-PER-FT6");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-M3-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroVAR-PER-K"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-SEC-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-HR-PER-M6"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-SEC-PER-L-CentiM3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliBQ-PER-M2-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-MIN-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-MIN-PER-L-CentiM3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-FT2-PER-IN3-LB_F-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TONNE-PER-HR-K"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-DEG_F");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-SEC-PER-YD3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SEC-PER-FT2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-SEC-PER-IN3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloMOL-PER-M3-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-SEC-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ-HR-PER-IN3-GAL_US"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/M3-PER-MIN-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ-HR-PER-IN3-GAL_UK"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/W-PER-M2-NanoM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-SEC-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliA-PER-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGALILEO-PER-MO"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-MilliL-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoMOL-PER-MicroMOL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-SEC-PER-FT6"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VAR-PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ST-PER-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-SEC-PER-GAL_US"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN-PER-SEC-PSI"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-L-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-HUNDRED-THOUSAND"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-SEC-PER-L"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-HR-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/C-M2-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-SEC-PER-FT3-GAL_US"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-PER-SEC-PSI"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-PER-IN3-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliL-PER-M2-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroMOL-PER-MOL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-DAY-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-HR-PER-L-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-HR-PER-FT3-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-HR-PER-GAL_US-FT3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ-HR-PER-IN3-FT3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-SEC-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-L-POISE"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-CentiPOISE"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-PSI");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-M3-PA-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliL-PER-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-MIN-PER-FT3-GAL_US"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-SEC-PER-GAL_UK-FT3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-PER-HR-DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA-M-PER-SEC2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-HR-PER-GAL_UK"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-MIN-PER-FT3-GAL_UK"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/M3-PER-SEC-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MOL-PER-M2-SEC-SR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroMOL-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT-PER-V");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-L-MilliPA-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ-MIN-PER-IN3-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-MIN-PER-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGALILEO-PER-M"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-HR-PER-GAL_US"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-HR-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-SEC-PA");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Unknown",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/UpperCriticalMagneticFluxDensity",
    "http://qudt.org/vocab/dimensionvector/A0E-1L0I0M1H0T-2D0",
    "B_{c2}",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Upper Critical Magnetic Flux Density", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUSS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGAUSS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAMMA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/T_Ab");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticFluxDensity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/UpperCriticalMagneticFluxDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VacuumThrust",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Vacuum Thrust", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_F_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPOND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-M-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DYN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckForce");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Thrust"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VacuumThrust",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VaporPermeability",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Vapor Permeability", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VaporPermeability",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VaporPermeance",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Vapor Permeance", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VaporPermeance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VaporPressure",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Vapor Pressure", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-IN2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_32DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroTORR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_60DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARYE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA_A");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroATM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliTORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_60DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR_A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR_A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckPressure"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_H2O_4DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_HG_0DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HGA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Pressure"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VaporPressure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VapourPermeability",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Vapour Permeability", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-PA-SEC-M"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VapourPermeability",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VapourPermeance",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Vapour Permeance", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M2-PA-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-M2-PA-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERM_Metric");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VapourPermeance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VehicleVelocity",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    "V",
    undefined
  );
  quantityKind.addLabel(new LangString("Vehicle Velocity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaHZ-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-KiloYR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM-PER-YR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Velocity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VehicleVelocity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Velocity",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    "v",
    undefined
  );
  quantityKind.addLabel(new LangString("速度", "zh"));
  quantityKind.addLabel(new LangString("Rychlost", "cs"));
  quantityKind.addLabel(new LangString("velocidade", "pt"));
  quantityKind.addLabel(new LangString("Halaju", "ms"));
  quantityKind.addLabel(new LangString("Επιφάνεια", "el"));
  quantityKind.addLabel(new LangString("prędkość", "pl"));
  quantityKind.addLabel(new LangString("viteză", "ro"));
  quantityKind.addLabel(new LangString("velocidad", "es"));
  quantityKind.addLabel(new LangString("velocitas", "la"));
  quantityKind.addLabel(new LangString("Geschwindigkeit", "de"));
  quantityKind.addLabel(new LangString("سرعت/تندی", "fa"));
  quantityKind.addLabel(new LangString("गति", "hi"));
  quantityKind.addLabel(new LangString("velocità", "it"));
  quantityKind.addLabel(new LangString("速力", "ja"));
  quantityKind.addLabel(new LangString("velocity", "en"));
  quantityKind.addLabel(new LangString("vitesse", "fr"));
  quantityKind.addLabel(new LangString("hitrost", "sl"));
  quantityKind.addLabel(new LangString("hız", "tr"));
  quantityKind.addLabel(new LangString("Ско́рость", "ru"));
  quantityKind.addLabel(new LangString("السرعة", "ar"));
  quantityKind.addLabel(new LangString("מהירות", "he"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaHZ-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-KiloYR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM-PER-YR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-HR");
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/LinearVelocity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Velocity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VentilationRatePerFloorArea",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Ventilation Rate per Floor Area", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-SEC-M2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VentilationRatePerFloorArea",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VerticalVelocity",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    "V_{Z}",
    undefined
  );
  quantityKind.addLabel(new LangString("Vertical Velocity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaHZ-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-KiloYR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM-PER-YR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Velocity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VerticalVelocity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VibrationalDensityOfStates",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T1D0",
    "g",
    undefined
  );
  quantityKind.addLabel(new LangString("Vibrational density of states", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SEC-PER-RAD-M3"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VibrationalDensityOfStates",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VideoFrameRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Video Frame Rate", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRAME-PER-SEC");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InformationFlowRate"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VideoFrameRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Viscosity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Viscosity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliPA-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SLUG-PER-FT-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-SEC-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POISE");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-CentiM-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PDL-SEC-PER-FT2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB_F-SEC-PER-FT2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroPOISE");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PDL-SEC-PER-IN2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-FT-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB_F-SEC-PER-IN2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPOISE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-FT-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaPOISE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiPOISE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-FT-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-FT-DAY");
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/DynamicViscosity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Viscosity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VisibleRadiantEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "Q",
    undefined
  );
  quantityKind.addLabel(new LangString("Visible Radiant Energy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VisibleRadiantEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VisionThresholds",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Vision Thresholds", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VisionThresholds",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Voltage",
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-3D0",
    "V",
    undefined
  );
  quantityKind.addLabel(new LangString("Voltage", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V_Stat");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V_Ab");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckVolt");
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotential"
  );
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/EnergyPerElectricCharge"
  );
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotentialDifference"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Voltage",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VoltagePhasor",
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Voltage Phasor", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VoltagePhasor",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VoltageRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Voltage Ratio", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VoltageRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Volume",
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Volume", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/STANDARD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PK_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Register");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCubicFT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TSP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PINT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckVolume");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BBL_UK_PET");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TBSP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BBL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_VOL_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PINT_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FBM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/STR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AC-FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_SHIPPING_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_UK3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BU_US_DRY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_SHIPPING_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AC-FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_UK");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Volume",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VolumeDensityOfCharge",
    "http://qudt.org/vocab/dimensionvector/A0E1L-3I0M0H0T1D0",
    "0173-1#Z4-BAJ368#002",
    undefined
  );
  quantityKind.addLabel(new LangString("volume density of charge", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VolumeDensityOfCharge",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VolumeFlowRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Volume Flow Rate", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PINT_UK-PER-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BU_US_DRY-PER-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciM3-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PK_UK-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_UK-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliL-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliL-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_US-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT3-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BBL_UK_PET-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT3-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BU_UK-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD3-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PINT_UK-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ_VOL_UK-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_UK-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BBL_UK_PET-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliL-PER-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BBL_UK_PET-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_UK-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-YR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ_VOL_US-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BU_US_DRY-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_US-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_UK-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PINT_US-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT3-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ_VOL_UK-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PK_US_DRY-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ_VOL_US-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN3-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BBL_US_PET-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BU_UK-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BU_UK-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BBL_UK_PET-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliL-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_UK-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PK_US_DRY-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PINT_US-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PINT_US-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GAL_UK-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BBL_US-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GAL_UK-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GAL_US-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_US-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_US-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_US-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BBL_US_PET-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN3-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN3-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BU_UK-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PK_UK-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAL_UK-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_US-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PINT_US-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_UK-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD3-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_UK-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GAL_UK-PER-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciM3-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciM3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAL_US-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PK_US_DRY-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_US-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_US-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT3-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ_VOL_US-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloL-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ_VOL_US-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM3-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BBL_US-PER-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD3-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD3-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GAL_US-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GAL_US-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PK_US_DRY-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PINT_UK-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_UK-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PINT_UK-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ_VOL_UK-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PK_UK-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ_VOL_UK-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PK_UK-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BU_US_DRY-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BU_US_DRY-PER-MIN"
  );
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/VolumePerTime"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VolumeFlowRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VolumeFlowRate_SurfaceRelated",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("surface‑related volume flow rate", undefined)
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VolumeFlowRate_SurfaceRelated",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VolumeFlowRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Volume Flow Ratio", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ONE-PER-ONE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERMITTIVITY_REL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VolumeFlowRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VolumeFraction",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Volume Fraction", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM3-PER-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroL-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM3-PER-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliL-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM3-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-CentiM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliL-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM3-PER-MilliL"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VolumeFraction",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VolumeOrSectionModulus",
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    "0173-1#Z4-BAJ251#002",
    undefined
  );
  quantityKind.addLabel(new LangString("volume or section modulus", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VolumeOrSectionModulus",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VolumePerArea",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Volume per Unit Area", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-HA");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VolumePerArea",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VolumePerTime",
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Volume per Time", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PINT_UK-PER-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BU_US_DRY-PER-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciM3-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PK_UK-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_UK-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliL-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliL-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_US-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT3-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BBL_UK_PET-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT3-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BU_UK-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD3-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PINT_UK-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ_VOL_UK-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_UK-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BBL_UK_PET-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliL-PER-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BBL_UK_PET-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_UK-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-YR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ_VOL_US-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BU_US_DRY-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_US-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_UK-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PINT_US-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT3-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ_VOL_UK-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PK_US_DRY-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ_VOL_US-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN3-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BBL_US_PET-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BU_UK-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BU_UK-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BBL_UK_PET-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliL-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_UK-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PK_US_DRY-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PINT_US-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PINT_US-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GAL_UK-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BBL_US-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GAL_UK-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GAL_US-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_US-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_US-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_US-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BBL_US_PET-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN3-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN3-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BU_UK-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PK_UK-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAL_UK-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_US-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PINT_US-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_UK-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD3-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_UK-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GAL_UK-PER-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciM3-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciM3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAL_US-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PK_US_DRY-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_US-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_US-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT3-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ_VOL_US-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloL-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ_VOL_US-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM3-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BBL_US-PER-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD3-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD3-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GAL_US-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GAL_US-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PK_US_DRY-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PINT_UK-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_UK-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PINT_UK-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ_VOL_UK-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PK_UK-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ_VOL_UK-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PK_UK-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BU_US_DRY-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BU_US_DRY-PER-MIN"
  );
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/VolumeFlowRate"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VolumePerTime",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VolumeStrain",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Volume Strain", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ONE-PER-ONE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERMITTIVITY_REL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Strain"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VolumeStrain",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VolumeThermalExpansion",
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H-1T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Volume Thermal Expansion", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT3-PER-DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD3-PER-DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliL-PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM3-PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-K");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VolumeThermalExpansion",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VolumetricBitDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("volumic bit density", undefined));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KibiBIT-PER-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PebiBIT-PER-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GibiBIT-PER-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MebiBIT-PER-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BIT-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/ExbiBIT-PER-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TebiBIT-PER-M3"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VolumetricBitDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VolumetricElectricCharge",
    "http://qudt.org/vocab/dimensionvector/A0E1L-3I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("volumic electric charge", undefined));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VolumetricElectricCharge",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VolumetricEntityDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    "0173-1#Z4-BAJ377#003",
    undefined
  );
  quantityKind.addLabel(new LangString("volumetric entity density", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VolumetricEntityDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VolumetricFlux",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Volumetric Flux", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliL-PER-CentiM2-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliL-PER-CentiM2-SEC"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VolumetricFlux",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VolumetricHeatCapacity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H-1T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Volumetric Heat Capacity", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliBAR-PER-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM3-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-CentiM3-K"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-M3-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB_F-PER-IN2-DEG_F"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VolumetricHeatCapacity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VolumetricOutputPower",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("volumic output power", undefined));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VolumetricOutputPower",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VolumicAmountOfSubstance",
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T0D0",
    "0173-1#Z4-BAJ402#002",
    undefined
  );
  quantityKind.addLabel(new LangString("volumic amount of substance", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VolumicAmountOfSubstance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VolumicDataQuantity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    "0173-1#Z4-BAJ401#002",
    undefined
  );
  quantityKind.addLabel(new LangString("volumic data quantity", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VolumicDataQuantity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VolumicElectromagneticEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    "w",
    undefined
  );
  quantityKind.addLabel(new LangString("Volumic Electromagnetic Energy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-M3");
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/ElectromagneticEnergyDensity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VolumicElectromagneticEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VolumicOutput",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-3D0",
    "0173-1#Z4-BAJ366#003",
    undefined
  );
  quantityKind.addLabel(new LangString("volumic output", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VolumicOutput",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Vorticity",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Vorticity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckFrequency_Ang"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG-PER-SEC");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AngularVelocity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Vorticity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/WarmReceptorThreshold",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Warm Receptor Threshold", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/WarmReceptorThreshold",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/WarpingConstant",
    "http://qudt.org/vocab/dimensionvector/A0E0L6I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Warping Constant", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM6");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M6");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/WarpingConstant",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/WarpingMoment",
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Warping Moment", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-M2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/WarpingMoment",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/WaterHorsepower",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Water Horsepower", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaW");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TeraW-HR-PER-YR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroJ-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFERDESTAERKE");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliJ-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliBAR-L-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaPA-L-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP_Electric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_FG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PSI-IN3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA-L-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BAR-M3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR-L-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP_Boiler");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PSI-M3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckPower");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI-L-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloBTU_IT-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA-M3-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/HectoPA-M3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaBTU_IT-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP_Brake");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaPA-M3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliW");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/HectoPA-L-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-M-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PSI-YD3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliBAR-M3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Power"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/WaterHorsepower",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/WaterSolubility",
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Water Solubility", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoMOL-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FemtoMOL-PER-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoMOL-PER-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MOL-PER-DeciM3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliMOL-PER-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloMOL-PER-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliMOL-PER-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroMOL-PER-L"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstancePerVolume"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/WaterSolubility",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/WaterVaporDiffusionCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Wasserdampfdiffusionsleitkoeffizient", "de")
  );
  quantityKind.addLabel(
    new LangString("Water vapour diffusion coefficient", "en")
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-PA-SEC-M"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/WaterVaporDiffusionCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/WaterVapourPermeability",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    "0173-1#Z4-BAJ446#001",
    undefined
  );
  quantityKind.addLabel(new LangString("water vapour permeability", "en-US"));
  quantityKind.addLabel(new LangString("water vapour permeability", undefined));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/WaterVapourPermeability",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Wavelength",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "λ",
    undefined
  );
  quantityKind.addLabel(new LangString("Wellenlänge", "de"));
  quantityKind.addLabel(new LangString("Jarak gelombang", "ms"));
  quantityKind.addLabel(new LangString("длина волны", "ru"));
  quantityKind.addLabel(new LangString("طول موج", "fa"));
  quantityKind.addLabel(new LangString("longueur d'onde", "fr"));
  quantityKind.addLabel(new LangString("comprimento de onda", "pt"));
  quantityKind.addLabel(new LangString("wavelength", "en"));
  quantityKind.addLabel(new LangString("Vlnové délka", "cs"));
  quantityKind.addLabel(new LangString("波长", "zh"));
  quantityKind.addLabel(new LangString("lunghezza d'onda", "it"));
  quantityKind.addLabel(new LangString("longitud de onda", "es"));
  quantityKind.addLabel(new LangString("dalga boyu", "tr"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Wavelength",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Wavenumber",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("عدد الموجة", "ar"));
  quantityKind.addLabel(new LangString("valovno število", "sl"));
  quantityKind.addLabel(new LangString("Волновое число", "ru"));
  quantityKind.addLabel(new LangString("nombre d'onde", "fr"));
  quantityKind.addLabel(new LangString("波数", "zh"));
  quantityKind.addLabel(new LangString("dalga sayısı", "tr"));
  quantityKind.addLabel(new LangString("wavenumber", "en"));
  quantityKind.addLabel(new LangString("número de ola", "es"));
  quantityKind.addLabel(new LangString("波数", "ja"));
  quantityKind.addLabel(new LangString("عدد موج", "fa"));
  quantityKind.addLabel(new LangString("Vlnové číslo", "cs"));
  quantityKind.addLabel(new LangString("Liczba falowa", "pl"));
  quantityKind.addLabel(new LangString("numero d'onda", "it"));
  quantityKind.addLabel(new LangString("número de onda", "pt"));
  quantityKind.addLabel(new LangString("Bilangan gelombang", "ms"));
  quantityKind.addLabel(new LangString("Repetenz", "de"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-HA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MESH");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InverseLength"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Wavenumber",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/WebTime",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Web Time", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliH-PER-KiloOHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/WK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckTime");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Common");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MO_MeanGREGORIAN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HR_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoSEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroH-PER-KiloOHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H-PER-OHM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroH-PER-OHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DAY_Sidereal");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliPA-SEC-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO_Synodic");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POISE-PER-BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiPOISE-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POISE-PER-PA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliH-PER-OHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_TROPICAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H-PER-KiloOHM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Metrology");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PA-SEC-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloYR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaYR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO_MeanJulian");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Time"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/WebTime",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/WebTimeAveragePressure",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Web Time Average Pressure", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-IN2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_32DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroTORR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_60DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARYE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA_A");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroATM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliTORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_60DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR_A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR_A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckPressure"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_H2O_4DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_HG_0DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HGA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Pressure"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/WebTimeAveragePressure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/WebTimeAverageThrust",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Web Time Average Thrust", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_F_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPOND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-M-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DYN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckForce");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Thrust"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/WebTimeAverageThrust",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Weight",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    "bold letter W",
    undefined
  );
  quantityKind.addLabel(new LangString("Berat", "ms"));
  quantityKind.addLabel(new LangString("Ağırlık", "tr"));
  quantityKind.addLabel(new LangString("weight", "en"));
  quantityKind.addLabel(new LangString("وزن", "ar"));
  quantityKind.addLabel(new LangString("peso", "es"));
  quantityKind.addLabel(new LangString("Gewicht", "de"));
  quantityKind.addLabel(new LangString("Вес", "ru"));
  quantityKind.addLabel(new LangString("peso", "pt"));
  quantityKind.addLabel(new LangString("tíha", "cs"));
  quantityKind.addLabel(new LangString("وزن", "fa"));
  quantityKind.addLabel(new LangString("Siła ciężkości", "pl"));
  quantityKind.addLabel(new LangString("poids", "fr"));
  quantityKind.addLabel(new LangString("重量", "zh"));
  quantityKind.addLabel(new LangString("重さ", "ja"));
  quantityKind.addLabel(new LangString("forza peso", "it"));
  quantityKind.addLabel(new LangString("greutate", "ro"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_F_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPOND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-M-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DYN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckForce");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Force"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Weight",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/WetBulbTemperature",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Wet Bulb Temperature", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliDEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_R");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckTemperature"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_F");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Temperature"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/WetBulbTemperature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Width",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Width", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Width",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Work",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "A",
    undefined
  );
  quantityKind.addLabel(new LangString("kerja", "ms"));
  quantityKind.addLabel(new LangString("lucru mecanic", "ro"));
  quantityKind.addLabel(new LangString("delo", "sl"));
  quantityKind.addLabel(new LangString("iş", "tr"));
  quantityKind.addLabel(new LangString("trabajo", "es"));
  quantityKind.addLabel(new LangString("Arbeit", "de"));
  quantityKind.addLabel(new LangString("仕事量", "ja"));
  quantityKind.addLabel(new LangString("praca", "pl"));
  quantityKind.addLabel(new LangString("کار", "fa"));
  quantityKind.addLabel(new LangString("कार्य", "hi"));
  quantityKind.addLabel(new LangString("work", "en"));
  quantityKind.addLabel(new LangString("功", "zh"));
  quantityKind.addLabel(new LangString("lavoro", "it"));
  quantityKind.addLabel(new LangString("trabalho", "pt"));
  quantityKind.addLabel(new LangString("travail", "fr"));
  quantityKind.addLabel(new LangString("práce", "cs"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Work",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/WorkFunction",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Work Function", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/VAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloVA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaVAR-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/WorkFunction",
    quantityKind
  );
}

export const QuantityKinds = {
  // Energy Per Area Electric Charge
  EnergyPerAreaElectricCharge: Qudt.quantityKindFromLocalnameRequired(
    "EnergyPerAreaElectricCharge"
  ),
  // energy content
  EnergyContent: Qudt.quantityKindFromLocalnameRequired("EnergyContent"),
  // lineic torque
  LineicTorque: Qudt.quantityKindFromLocalnameRequired("LineicTorque"),
  // Heat Flow Rate
  HeatFlowRate: Qudt.quantityKindFromLocalnameRequired("HeatFlowRate"),
  // Ion Concentration
  LuminousIntensityDistribution: Qudt.quantityKindFromLocalnameRequired(
    "LuminousIntensityDistribution"
  ),
  // Standard Gravitational Parameter
  StandardGravitationalParameter: Qudt.quantityKindFromLocalnameRequired(
    "StandardGravitationalParameter"
  ),
  // lineic logarithmic ratio
  LineicLogarithmicRatio: Qudt.quantityKindFromLocalnameRequired(
    "LineicLogarithmicRatio"
  ),
  // Thermal Resistivity
  ThermalResistivity:
    Qudt.quantityKindFromLocalnameRequired("ThermalResistivity"),
  // Admittance
  Admittance: Qudt.quantityKindFromLocalnameRequired("Admittance"),
  // Static pressure
  StaticPressure: Qudt.quantityKindFromLocalnameRequired("StaticPressure"),
  // Mass per Length
  MassPerLength: Qudt.quantityKindFromLocalnameRequired("MassPerLength"),
  // Loss Factor
  LossFactor: Qudt.quantityKindFromLocalnameRequired("LossFactor"),
  // Modulus of Elasticity
  ModulusOfElasticity: Qudt.quantityKindFromLocalnameRequired(
    "ModulusOfElasticity"
  ),
  // Closest Approach Radius
  ClosestApproachRadius: Qudt.quantityKindFromLocalnameRequired(
    "ClosestApproachRadius"
  ),
  // Hyperfine Structure Quantum Number
  HyperfineStructureQuantumNumber: Qudt.quantityKindFromLocalnameRequired(
    "HyperfineStructureQuantumNumber"
  ),
  // معدل التمدد الحراري الخطي
  LinearExpansionCoefficient: Qudt.quantityKindFromLocalnameRequired(
    "LinearExpansionCoefficient"
  ),
  // Square Time
  SquareTime: Qudt.quantityKindFromLocalnameRequired("SquareTime"),
  // Linear Compressibility
  LinearCompressibility: Qudt.quantityKindFromLocalnameRequired(
    "LinearCompressibility"
  ),
  // Nozzle Throat Cross-sectional Area
  NozzleThroatCrossSectionalArea: Qudt.quantityKindFromLocalnameRequired(
    "NozzleThroatCrossSectionalArea"
  ),
  // water vapour permeability
  WaterVapourPermeability: Qudt.quantityKindFromLocalnameRequired(
    "WaterVapourPermeability"
  ),
  // Electric Charge Density
  ElectricChargeDensity: Qudt.quantityKindFromLocalnameRequired(
    "ElectricChargeDensity"
  ),
  // Moment of Inertia in the Y axis
  MomentOfInertia_Y:
    Qudt.quantityKindFromLocalnameRequired("MomentOfInertia_Y"),
  // temperature-related molar mass
  TemperatureRelatedMolarMass: Qudt.quantityKindFromLocalnameRequired(
    "TemperatureRelatedMolarMass"
  ),
  // Mass per Energy
  MassPerEnergy: Qudt.quantityKindFromLocalnameRequired("MassPerEnergy"),
  // Oberflächenspannung
  SurfaceTension: Qudt.quantityKindFromLocalnameRequired("SurfaceTension"),
  // Density
  Density: Qudt.quantityKindFromLocalnameRequired("Density"),
  // Level Width
  LevelWidth: Qudt.quantityKindFromLocalnameRequired("LevelWidth"),
  // Mass Number
  MassNumber: Qudt.quantityKindFromLocalnameRequired("MassNumber"),
  // Permittivity Ratio
  PermittivityRatio:
    Qudt.quantityKindFromLocalnameRequired("PermittivityRatio"),
  // Mean Linear Range
  MeanLinearRange: Qudt.quantityKindFromLocalnameRequired("MeanLinearRange"),
  // Molar Equivalent
  MolarEquivalent: Qudt.quantityKindFromLocalnameRequired("MolarEquivalent"),
  // Vertical Velocity
  VerticalVelocity: Qudt.quantityKindFromLocalnameRequired("VerticalVelocity"),
  // Combustion Chamber Temperature
  CombustionChamberTemperature: Qudt.quantityKindFromLocalnameRequired(
    "CombustionChamberTemperature"
  ),
  // Source Voltage
  SourceVoltage: Qudt.quantityKindFromLocalnameRequired("SourceVoltage"),
  // opór cieplny
  ThermalResistance:
    Qudt.quantityKindFromLocalnameRequired("ThermalResistance"),
  // Ion Concentration
  AmountOfSubstanceIonConcentration: Qudt.quantityKindFromLocalnameRequired(
    "AmountOfSubstanceIonConcentration"
  ),
  // Compound Plane Angle
  CompoundPlaneAngle:
    Qudt.quantityKindFromLocalnameRequired("CompoundPlaneAngle"),
  // Ketumpatan arus elektrik
  ElectricCurrentDensity: Qudt.quantityKindFromLocalnameRequired(
    "ElectricCurrentDensity"
  ),
  // Growing Degree Days (Cereals)
  GrowingDegreeDay_Cereal: Qudt.quantityKindFromLocalnameRequired(
    "GrowingDegreeDay_Cereal"
  ),
  // Linear Energy Transfer
  LinearEnergyTransfer: Qudt.quantityKindFromLocalnameRequired(
    "LinearEnergyTransfer"
  ),
  // Standard Chemical Potential
  StandardChemicalPotential: Qudt.quantityKindFromLocalnameRequired(
    "StandardChemicalPotential"
  ),
  // Asset
  Asset: Qudt.quantityKindFromLocalnameRequired("Asset"),
  // Information flow rate
  InformationFlowRate: Qudt.quantityKindFromLocalnameRequired(
    "InformationFlowRate"
  ),
  // Exit Plane Pressure
  ExitPlanePressure:
    Qudt.quantityKindFromLocalnameRequired("ExitPlanePressure"),
  // Particle Position Vector
  ParticlePositionVector: Qudt.quantityKindFromLocalnameRequired(
    "ParticlePositionVector"
  ),
  // Chromaticity
  Chromaticity: Qudt.quantityKindFromLocalnameRequired("Chromaticity"),
  // Linear Acceleration
  LinearAcceleration:
    Qudt.quantityKindFromLocalnameRequired("LinearAcceleration"),
  // Specific Impulse by Weight
  SpecificImpulseByWeight: Qudt.quantityKindFromLocalnameRequired(
    "SpecificImpulseByWeight"
  ),
  // Resistance Ratio
  ResistanceRatio: Qudt.quantityKindFromLocalnameRequired("ResistanceRatio"),
  // Lichtstärke
  LuminousIntensity:
    Qudt.quantityKindFromLocalnameRequired("LuminousIntensity"),
  // vitesse  acoustique d‘une particule
  SoundParticleVelocity: Qudt.quantityKindFromLocalnameRequired(
    "SoundParticleVelocity"
  ),
  // Hydraulic Permeability
  HydraulicPermeability: Qudt.quantityKindFromLocalnameRequired(
    "HydraulicPermeability"
  ),
  // Currency
  Currency: Qudt.quantityKindFromLocalnameRequired("Currency"),
  // energia livre de Helmholtz
  HelmholtzEnergy: Qudt.quantityKindFromLocalnameRequired("HelmholtzEnergy"),
  // Body Mass Index
  BodyMassIndex: Qudt.quantityKindFromLocalnameRequired("BodyMassIndex"),
  // Radiative Heat Transfer
  RadiativeHeatTransfer: Qudt.quantityKindFromLocalnameRequired(
    "RadiativeHeatTransfer"
  ),
  // Product of Inertia in the X axis
  ProductOfInertia_X:
    Qudt.quantityKindFromLocalnameRequired("ProductOfInertia_X"),
  // Second Polar Moment of Area
  SecondPolarMomentOfArea: Qudt.quantityKindFromLocalnameRequired(
    "SecondPolarMomentOfArea"
  ),
  // Seebeck Coefficient
  SeebeckCoefficient:
    Qudt.quantityKindFromLocalnameRequired("SeebeckCoefficient"),
  // Linear Momentum
  LinearMomentum: Qudt.quantityKindFromLocalnameRequired("LinearMomentum"),
  // Shear Stress
  ShearStress: Qudt.quantityKindFromLocalnameRequired("ShearStress"),
  // Pressure Coefficient
  PressureCoefficient: Qudt.quantityKindFromLocalnameRequired(
    "PressureCoefficient"
  ),
  // Mass Equivalent
  MassEquivalent: Qudt.quantityKindFromLocalnameRequired("MassEquivalent"),
  // Incidence Proportion
  IncidenceProportion: Qudt.quantityKindFromLocalnameRequired(
    "IncidenceProportion"
  ),
  // Mass Concentration Rate Of Change
  MassConcentrationRateOfChange: Qudt.quantityKindFromLocalnameRequired(
    "MassConcentrationRateOfChange"
  ),
  // jakost magnetnega polja
  MagneticFieldStrength: Qudt.quantityKindFromLocalnameRequired(
    "MagneticFieldStrength"
  ),
  // Product of Inertia in the Y axis
  ProductOfInertia_Y:
    Qudt.quantityKindFromLocalnameRequired("ProductOfInertia_Y"),
  // CoefficientOfPerformance
  CoefficientOfPerformance: Qudt.quantityKindFromLocalnameRequired(
    "CoefficientOfPerformance"
  ),
  // Electric Current per Length
  ElectricCurrentPerLength: Qudt.quantityKindFromLocalnameRequired(
    "ElectricCurrentPerLength"
  ),
  // eficiência
  Efficiency: Qudt.quantityKindFromLocalnameRequired("Efficiency"),
  // Conductivity
  Conductivity: Qudt.quantityKindFromLocalnameRequired("Conductivity"),
  // Maximum Beta-Particle Energy
  MaximumBeta__ParticleEnergy: Qudt.quantityKindFromLocalnameRequired(
    "MaximumBeta-ParticleEnergy"
  ),
  // Gross Lift-Off Weight
  GROSS__LIFT__OFF__WEIGHT: Qudt.quantityKindFromLocalnameRequired(
    "GROSS-LIFT-OFF-WEIGHT"
  ),
  // Calorific Value
  HeatingValue: Qudt.quantityKindFromLocalnameRequired("HeatingValue"),
  // Diastolic Blood Pressure
  DiastolicBloodPressure: Qudt.quantityKindFromLocalnameRequired(
    "DiastolicBloodPressure"
  ),
  // Pressure Ratio
  PressureRatio: Qudt.quantityKindFromLocalnameRequired("PressureRatio"),
  // reciprocal energy
  ReciprocalEnergy: Qudt.quantityKindFromLocalnameRequired("ReciprocalEnergy"),
  // Strain Energy Density
  StrainEnergyDensity: Qudt.quantityKindFromLocalnameRequired(
    "StrainEnergyDensity"
  ),
  // Inverse Length Temperature
  InverseLengthTemperature: Qudt.quantityKindFromLocalnameRequired(
    "InverseLengthTemperature"
  ),
  // Generalized Velocity
  GeneralizedVelocity: Qudt.quantityKindFromLocalnameRequired(
    "GeneralizedVelocity"
  ),
  // Service Factor
  ServiceFactor: Qudt.quantityKindFromLocalnameRequired("ServiceFactor"),
  // radioactivity
  Radioactivity: Qudt.quantityKindFromLocalnameRequired("Radioactivity"),
  // Lift Force
  LiftForce: Qudt.quantityKindFromLocalnameRequired("LiftForce"),
  // radioactive decay
  RadioactiveDecay: Qudt.quantityKindFromLocalnameRequired("RadioactiveDecay"),
  // temperatura thermodynamica absoluta
  ThermodynamicTemperature: Qudt.quantityKindFromLocalnameRequired(
    "ThermodynamicTemperature"
  ),
  // exposure of ionizing radiation
  ExposureOfIonizingRadiation: Qudt.quantityKindFromLocalnameRequired(
    "ExposureOfIonizingRadiation"
  ),
  // gas leak rate
  GasLeakRate: Qudt.quantityKindFromLocalnameRequired("GasLeakRate"),
  // Macroscopic Total Cross-section
  MacroscopicTotalCrossSection: Qudt.quantityKindFromLocalnameRequired(
    "MacroscopicTotalCrossSection"
  ),
  // Temperature
  Temperature: Qudt.quantityKindFromLocalnameRequired("Temperature"),
  // Modulus Of Impedance
  ModulusOfImpedance:
    Qudt.quantityKindFromLocalnameRequired("ModulusOfImpedance"),
  // Luminous Emmitance
  LuminousEmittance:
    Qudt.quantityKindFromLocalnameRequired("LuminousEmittance"),
  // Combined Non Evaporative Heat Transfer Coefficient
  EvaporativeHeatTransferCoefficient: Qudt.quantityKindFromLocalnameRequired(
    "EvaporativeHeatTransferCoefficient"
  ),
  // Convective Heat Transfer
  ConvectiveHeatTransfer: Qudt.quantityKindFromLocalnameRequired(
    "ConvectiveHeatTransfer"
  ),
  // Thrust To Weight Ratio
  ThrustToWeightRatio: Qudt.quantityKindFromLocalnameRequired(
    "ThrustToWeightRatio"
  ),
  // pressure gradient
  PressureGradient: Qudt.quantityKindFromLocalnameRequired("PressureGradient"),
  // Spectral Angular Cross-section
  SpectralAngularCrossSection: Qudt.quantityKindFromLocalnameRequired(
    "SpectralAngularCrossSection"
  ),
  // Measurement Unit of Thermal Inertia
  ThermalInertia: Qudt.quantityKindFromLocalnameRequired("ThermalInertia"),
  // Generalized Coordinate
  GeneralizedCoordinate: Qudt.quantityKindFromLocalnameRequired(
    "GeneralizedCoordinate"
  ),
  // Çiftlenim sabiti
  CouplingFactor: Qudt.quantityKindFromLocalnameRequired("CouplingFactor"),
  // Specific Entropy
  SpecificEntropy: Qudt.quantityKindFromLocalnameRequired("SpecificEntropy"),
  // Shear Strain
  ShearStrain: Qudt.quantityKindFromLocalnameRequired("ShearStrain"),
  // Alpha Disintegration Energy
  AlphaDisintegrationEnergy: Qudt.quantityKindFromLocalnameRequired(
    "AlphaDisintegrationEnergy"
  ),
  // Voltage Ratio
  VoltageRatio: Qudt.quantityKindFromLocalnameRequired("VoltageRatio"),
  // Capacitance
  Capacitance: Qudt.quantityKindFromLocalnameRequired("Capacitance"),
  // Total Current
  TotalCurrent: Qudt.quantityKindFromLocalnameRequired("TotalCurrent"),
  // Area Ratio
  AreaRatio: Qudt.quantityKindFromLocalnameRequired("AreaRatio"),
  // Length Molar Energy
  LengthMolarEnergy:
    Qudt.quantityKindFromLocalnameRequired("LengthMolarEnergy"),
  // Richardson Constant
  RichardsonConstant:
    Qudt.quantityKindFromLocalnameRequired("RichardsonConstant"),
  // Count
  Count: Qudt.quantityKindFromLocalnameRequired("Count"),
  // Magnetization Field
  MagnetizationField:
    Qudt.quantityKindFromLocalnameRequired("MagnetizationField"),
  // Width
  Width: Qudt.quantityKindFromLocalnameRequired("Width"),
  // magnetic flux density or magnetic polarization
  MagneticFluxDensityOrMagneticPolarization:
    Qudt.quantityKindFromLocalnameRequired(
      "MagneticFluxDensityOrMagneticPolarization"
    ),
  // Atomic Attenuation Coefficient
  AtomicAttenuationCoefficient: Qudt.quantityKindFromLocalnameRequired(
    "AtomicAttenuationCoefficient"
  ),
  // Mass Defect
  MassDefect: Qudt.quantityKindFromLocalnameRequired("MassDefect"),
  // Mass Temperature
  MassTemperature: Qudt.quantityKindFromLocalnameRequired("MassTemperature"),
  // Specific Activity
  SpecificActivity: Qudt.quantityKindFromLocalnameRequired("SpecificActivity"),
  // Lethargy
  Lethargy: Qudt.quantityKindFromLocalnameRequired("Lethargy"),
  // CO2Equivalent
  CO2Equivalent: Qudt.quantityKindFromLocalnameRequired("CO2Equivalent"),
  // pressure-based volume flow
  PressureBasedVolumeFlow: Qudt.quantityKindFromLocalnameRequired(
    "PressureBasedVolumeFlow"
  ),
  // Measurement Unit of Spectral Irradiance
  SpectralIrradiance:
    Qudt.quantityKindFromLocalnameRequired("SpectralIrradiance"),
  // Friction
  Friction: Qudt.quantityKindFromLocalnameRequired("Friction"),
  // electron mobility
  ElectronMobility: Qudt.quantityKindFromLocalnameRequired("ElectronMobility"),
  // Fractional Amount of Substance
  AmountOfSubstanceFraction: Qudt.quantityKindFromLocalnameRequired(
    "AmountOfSubstanceFraction"
  ),
  // Massieu Function
  MassieuFunction: Qudt.quantityKindFromLocalnameRequired("MassieuFunction"),
  // Acoustic Impediance
  AcousticImpedance:
    Qudt.quantityKindFromLocalnameRequired("AcousticImpedance"),
  // Inverse Length
  InverseLength: Qudt.quantityKindFromLocalnameRequired("InverseLength"),
  // Orbital Angular Momentum Quantum Number
  OrbitalAngularMomentumQuantumNumber: Qudt.quantityKindFromLocalnameRequired(
    "OrbitalAngularMomentumQuantumNumber"
  ),
  // área
  Area: Qudt.quantityKindFromLocalnameRequired("Area"),
  // Combined Non Evaporative Heat Transfer Coefficient
  CombinedNonEvaporativeHeatTransferCoefficient:
    Qudt.quantityKindFromLocalnameRequired(
      "CombinedNonEvaporativeHeatTransferCoefficient"
    ),
  // Linear Absorption Coefficient
  LinearAbsorptionCoefficient: Qudt.quantityKindFromLocalnameRequired(
    "LinearAbsorptionCoefficient"
  ),
  // Reflectivity
  Reflectivity: Qudt.quantityKindFromLocalnameRequired("Reflectivity"),
  // Volumetric Heat Capacity
  VolumetricHeatCapacity: Qudt.quantityKindFromLocalnameRequired(
    "VolumetricHeatCapacity"
  ),
  // Expansion Ratio
  ExpansionRatio: Qudt.quantityKindFromLocalnameRequired("ExpansionRatio"),
  // Volume Strain
  VolumeStrain: Qudt.quantityKindFromLocalnameRequired("VolumeStrain"),
  // Susceptance
  Susceptance: Qudt.quantityKindFromLocalnameRequired("Susceptance"),
  // Gauge Pressure
  GaugePressure: Qudt.quantityKindFromLocalnameRequired("GaugePressure"),
  // Mass Fraction of Dry Matter
  MassFractionOfDryMatter: Qudt.quantityKindFromLocalnameRequired(
    "MassFractionOfDryMatter"
  ),
  // Specific heat capacity at constant pressure
  SpecificHeatCapacityAtConstantPressure:
    Qudt.quantityKindFromLocalnameRequired(
      "SpecificHeatCapacityAtConstantPressure"
    ),
  // Measurement Unit for a quantity approximately proportional to Thermal Inertia
  ApparentThermalInertia: Qudt.quantityKindFromLocalnameRequired(
    "ApparentThermalInertia"
  ),
  // Exhaust Gases Specific Heat
  ExhaustGasesSpecificHeat: Qudt.quantityKindFromLocalnameRequired(
    "ExhaustGasesSpecificHeat"
  ),
  // current of the amount of substance
  CurrentOfTheAmountOfSubstance: Qudt.quantityKindFromLocalnameRequired(
    "CurrentOfTheAmountOfSubstance"
  ),
  // Thermal Diffusion Factor
  ThermalDiffusionFactor: Qudt.quantityKindFromLocalnameRequired(
    "ThermalDiffusionFactor"
  ),
  // Active Energy
  ActiveEnergy: Qudt.quantityKindFromLocalnameRequired("ActiveEnergy"),
  // Density Of The Exhaust Gases
  DensityOfTheExhaustGases: Qudt.quantityKindFromLocalnameRequired(
    "DensityOfTheExhaustGases"
  ),
  // Sound particle acceleration
  SoundParticleAcceleration: Qudt.quantityKindFromLocalnameRequired(
    "SoundParticleAcceleration"
  ),
  // total radiance
  TotalRadiance: Qudt.quantityKindFromLocalnameRequired("TotalRadiance"),
  // Relative Atomic Mass
  RelativeAtomicMass:
    Qudt.quantityKindFromLocalnameRequired("RelativeAtomicMass"),
  // specific optical rotational ability
  SpecificOpticalRotationalAbility: Qudt.quantityKindFromLocalnameRequired(
    "SpecificOpticalRotationalAbility"
  ),
  // Debye Angular Frequency
  DebyeAngularFrequency: Qudt.quantityKindFromLocalnameRequired(
    "DebyeAngularFrequency"
  ),
  // lineic electric charge
  LinearElectricCharge: Qudt.quantityKindFromLocalnameRequired(
    "LinearElectricCharge"
  ),
  // 截面二次轴矩
  SecondMomentOfArea:
    Qudt.quantityKindFromLocalnameRequired("SecondMomentOfArea"),
  // specific weight
  SpecificWeight: Qudt.quantityKindFromLocalnameRequired("SpecificWeight"),
  // 电导率
  ElectricConductivity: Qudt.quantityKindFromLocalnameRequired(
    "ElectricConductivity"
  ),
  // logarithm ratio to base 10
  LogarithmRatioToBase10: Qudt.quantityKindFromLocalnameRequired(
    "LogarithmRatioToBase10"
  ),
  // Kinetic Energy
  KineticEnergy: Qudt.quantityKindFromLocalnameRequired("KineticEnergy"),
  // Mass per Area Time
  MassPerAreaTime: Qudt.quantityKindFromLocalnameRequired("MassPerAreaTime"),
  // Mechanical Impedance
  MechanicalImpedance: Qudt.quantityKindFromLocalnameRequired(
    "MechanicalImpedance"
  ),
  // Lattice Vector
  LatticeVector: Qudt.quantityKindFromLocalnameRequired("LatticeVector"),
  // Contract End Item (CEI) Specification Mass.
  CONTRACT__END__ITEM__SPECIFICATION__MASS:
    Qudt.quantityKindFromLocalnameRequired(
      "CONTRACT-END-ITEM-SPECIFICATION-MASS"
    ),
  // pressure-based electric voltage
  PressureBasedElectricVoltage: Qudt.quantityKindFromLocalnameRequired(
    "PressureBasedElectricVoltage"
  ),
  // Inverse Square Time
  InverseSquareTime:
    Qudt.quantityKindFromLocalnameRequired("InverseSquareTime"),
  // Signal Strength
  SignalStrength: Qudt.quantityKindFromLocalnameRequired("SignalStrength"),
  // Pressure Burning Rate Index
  PressureBurningRateIndex: Qudt.quantityKindFromLocalnameRequired(
    "PressureBurningRateIndex"
  ),
  // Diffusion Coefficient for Fluence Rate
  DiffusionCoefficientForFluenceRate: Qudt.quantityKindFromLocalnameRequired(
    "DiffusionCoefficientForFluenceRate"
  ),
  // Energy per Area
  EnergyPerArea: Qudt.quantityKindFromLocalnameRequired("EnergyPerArea"),
  // lineic torque
  LinearTorque: Qudt.quantityKindFromLocalnameRequired("LinearTorque"),
  // Linear Attenuation Coefficient
  LinearAttenuationCoefficient: Qudt.quantityKindFromLocalnameRequired(
    "LinearAttenuationCoefficient"
  ),
  // Specific heat capacity at constant volume
  SpecificHeatCapacityAtConstantVolume: Qudt.quantityKindFromLocalnameRequired(
    "SpecificHeatCapacityAtConstantVolume"
  ),
  // volumic output
  VolumicOutput: Qudt.quantityKindFromLocalnameRequired("VolumicOutput"),
  // Угловое ускорение
  AngularAcceleration: Qudt.quantityKindFromLocalnameRequired(
    "AngularAcceleration"
  ),
  // Magnetic Area Moment
  MagneticAreaMoment:
    Qudt.quantityKindFromLocalnameRequired("MagneticAreaMoment"),
  // corrente elettrica
  ElectricCurrent: Qudt.quantityKindFromLocalnameRequired("ElectricCurrent"),
  // Specific Acoustic Impedance
  SpecificAcousticImpedance: Qudt.quantityKindFromLocalnameRequired(
    "SpecificAcousticImpedance"
  ),
  // Horizontal Velocity
  HorizontalVelocity:
    Qudt.quantityKindFromLocalnameRequired("HorizontalVelocity"),
  // Vapor Permeability
  VaporPermeability:
    Qudt.quantityKindFromLocalnameRequired("VaporPermeability"),
  // median information flow (from a source of information), expressed as a binary logarithm
  BinaryLogarithmicMedianInformationFlow:
    Qudt.quantityKindFromLocalnameRequired(
      "BinaryLogarithmicMedianInformationFlow"
    ),
  // Section Area Integral
  SectionAreaIntegral: Qudt.quantityKindFromLocalnameRequired(
    "SectionAreaIntegral"
  ),
  // Respiratory Rate
  RespiratoryRate: Qudt.quantityKindFromLocalnameRequired("RespiratoryRate"),
  // thermal capacitance
  ThermalCapacitance:
    Qudt.quantityKindFromLocalnameRequired("ThermalCapacitance"),
  // Fundamental Lattice vector
  FundamentalLatticeVector: Qudt.quantityKindFromLocalnameRequired(
    "FundamentalLatticeVector"
  ),
  // Equivalent Density
  EquivalentDensity:
    Qudt.quantityKindFromLocalnameRequired("EquivalentDensity"),
  // failure rate
  FailureRate: Qudt.quantityKindFromLocalnameRequired("FailureRate"),
  // Circulation
  Circulation: Qudt.quantityKindFromLocalnameRequired("Circulation"),
  // Single Stage Launcher Mass Ratio
  SingleStageLauncherMassRatio: Qudt.quantityKindFromLocalnameRequired(
    "SingleStageLauncherMassRatio"
  ),
  // 慣性モーメント
  MomentOfInertia: Qudt.quantityKindFromLocalnameRequired("MomentOfInertia"),
  // Length Force
  LengthByForce: Qudt.quantityKindFromLocalnameRequired("LengthByForce"),
  // spectral concentration of radiant energy density
  SpectralConcentrationOfRadiantEnergyDensity:
    Qudt.quantityKindFromLocalnameRequired(
      "SpectralConcentrationOfRadiantEnergyDensity"
    ),
  // Specific Electrical Current
  SpecificElectricCurrent: Qudt.quantityKindFromLocalnameRequired(
    "SpecificElectricCurrent"
  ),
  // Displacement Current Density
  DisplacementCurrentDensity: Qudt.quantityKindFromLocalnameRequired(
    "DisplacementCurrentDensity"
  ),
  // Thermal Conductivity
  ThermalConductivity: Qudt.quantityKindFromLocalnameRequired(
    "ThermalConductivity"
  ),
  // CountRate
  CountRate: Qudt.quantityKindFromLocalnameRequired("CountRate"),
  // Total Cross-section
  TotalCrossSection:
    Qudt.quantityKindFromLocalnameRequired("TotalCrossSection"),
  // Azimuth
  Azimuth: Qudt.quantityKindFromLocalnameRequired("Azimuth"),
  // Exchange Integral
  ExchangeIntegral: Qudt.quantityKindFromLocalnameRequired("ExchangeIntegral"),
  // Resonance Escape Probability For Fission
  ResonanceEscapeProbabilityForFission: Qudt.quantityKindFromLocalnameRequired(
    "ResonanceEscapeProbabilityForFission"
  ),
  // Nozzle Throat Diameter
  NozzleThroatDiameter: Qudt.quantityKindFromLocalnameRequired(
    "NozzleThroatDiameter"
  ),
  // Fahrenheit temperature
  FahrenheitTemperature: Qudt.quantityKindFromLocalnameRequired(
    "FahrenheitTemperature"
  ),
  // Flux
  Flux: Qudt.quantityKindFromLocalnameRequired("Flux"),
  // Linear Ionization
  LinearIonization: Qudt.quantityKindFromLocalnameRequired("LinearIonization"),
  // 速度
  Velocity: Qudt.quantityKindFromLocalnameRequired("Velocity"),
  // Mass per Time
  MassPerTime: Qudt.quantityKindFromLocalnameRequired("MassPerTime"),
  // Lift Coefficient
  LiftCoefficient: Qudt.quantityKindFromLocalnameRequired("LiftCoefficient"),
  // Mole Fraction
  MoleFraction: Qudt.quantityKindFromLocalnameRequired("MoleFraction"),
  // dataset of bits
  DatasetOfBits: Qudt.quantityKindFromLocalnameRequired("DatasetOfBits"),
  // Orbital Radial Distance
  OrbitalRadialDistance: Qudt.quantityKindFromLocalnameRequired(
    "OrbitalRadialDistance"
  ),
  // Binding Fraction
  BindingFraction: Qudt.quantityKindFromLocalnameRequired("BindingFraction"),
  // چگالی شار الکتریکی
  ElectricFluxDensity: Qudt.quantityKindFromLocalnameRequired(
    "ElectricFluxDensity"
  ),
  // Heat Flux Density
  HeatFluxDensity: Qudt.quantityKindFromLocalnameRequired("HeatFluxDensity"),
  // logarithmic frequency interval to base 10
  Log10FrequencyInterval: Qudt.quantityKindFromLocalnameRequired(
    "Log10FrequencyInterval"
  ),
  // Population
  Population: Qudt.quantityKindFromLocalnameRequired("Population"),
  // Pressure Burning Rate Constant
  PressureBurningRateConstant: Qudt.quantityKindFromLocalnameRequired(
    "PressureBurningRateConstant"
  ),
  // Residual Resistivity
  ResidualResistivity: Qudt.quantityKindFromLocalnameRequired(
    "ResidualResistivity"
  ),
  // Force per Length
  ForcePerLength: Qudt.quantityKindFromLocalnameRequired("ForcePerLength"),
  // Macroscopic Cross-section
  MacroscopicCrossSection: Qudt.quantityKindFromLocalnameRequired(
    "MacroscopicCrossSection"
  ),
  // čas
  Time: Qudt.quantityKindFromLocalnameRequired("Time"),
  // Volumetric Flux
  VolumetricFlux: Qudt.quantityKindFromLocalnameRequired("VolumetricFlux"),
  // molar thermal capacity
  MolarThermalCapacity: Qudt.quantityKindFromLocalnameRequired(
    "MolarThermalCapacity"
  ),
  // Thrust To Mass Ratio
  ThrustToMassRatio:
    Qudt.quantityKindFromLocalnameRequired("ThrustToMassRatio"),
  // London Penetration Depth
  LondonPenetrationDepth: Qudt.quantityKindFromLocalnameRequired(
    "LondonPenetrationDepth"
  ),
  // Relative Mass Excess
  RelativeMassExcess:
    Qudt.quantityKindFromLocalnameRequired("RelativeMassExcess"),
  // areic data volume
  AreicDataVolume: Qudt.quantityKindFromLocalnameRequired("AreicDataVolume"),
  // Stress Intensity Factor
  StressIntensityFactor: Qudt.quantityKindFromLocalnameRequired(
    "StressIntensityFactor"
  ),
  // activity related by mass
  ActivityRelatedByMass: Qudt.quantityKindFromLocalnameRequired(
    "ActivityRelatedByMass"
  ),
  // Product of Inertia in the Y axis
  PRODUCT__OF__INERTIA_Y: Qudt.quantityKindFromLocalnameRequired(
    "PRODUCT-OF-INERTIA_Y"
  ),
  // Pace
  Pace: Qudt.quantityKindFromLocalnameRequired("Pace"),
  // Conductive Heat Transfer Rate
  ConductiveHeatTransferRate: Qudt.quantityKindFromLocalnameRequired(
    "ConductiveHeatTransferRate"
  ),
  // Speed
  Speed: Qudt.quantityKindFromLocalnameRequired("Speed"),
  // Blood Glucose Level by Mass
  BloodGlucoseLevel_Mass: Qudt.quantityKindFromLocalnameRequired(
    "BloodGlucoseLevel_Mass"
  ),
  // Electric Charge Volume Density
  ElectricChargeVolumeDensity: Qudt.quantityKindFromLocalnameRequired(
    "ElectricChargeVolumeDensity"
  ),
  // Ion Concentration
  IonConcentration: Qudt.quantityKindFromLocalnameRequired("IonConcentration"),
  // Diffusionskoeffizient
  DiffusionCoefficient: Qudt.quantityKindFromLocalnameRequired(
    "DiffusionCoefficient"
  ),
  // Drag Coefficient
  DragCoefficient: Qudt.quantityKindFromLocalnameRequired("DragCoefficient"),
  // energia
  Energy: Qudt.quantityKindFromLocalnameRequired("Energy"),
  // equilibrium constant based on concentration
  EquilibriumConstantBasedOnConcentration:
    Qudt.quantityKindFromLocalnameRequired(
      "EquilibriumConstantBasedOnConcentration"
    ),
  // atomic stopping power
  AtomicStoppingPower: Qudt.quantityKindFromLocalnameRequired(
    "AtomicStoppingPower"
  ),
  // Non-Leakage Probability
  Non__LeakageProbability: Qudt.quantityKindFromLocalnameRequired(
    "Non-LeakageProbability"
  ),
  // Basicity
  Basicity: Qudt.quantityKindFromLocalnameRequired("Basicity"),
  // Octanol Air Partition Coefficient
  LogOctanolAirPartitionCoefficient: Qudt.quantityKindFromLocalnameRequired(
    "LogOctanolAirPartitionCoefficient"
  ),
  // Absolute Humidity
  AbsoluteHumidity: Qudt.quantityKindFromLocalnameRequired("AbsoluteHumidity"),
  // temperature difference
  TemperatureDifference: Qudt.quantityKindFromLocalnameRequired(
    "TemperatureDifference"
  ),
  // Thickness
  Thickness: Qudt.quantityKindFromLocalnameRequired("Thickness"),
  // Density In Combustion Chamber
  DensityInCombustionChamber: Qudt.quantityKindFromLocalnameRequired(
    "DensityInCombustionChamber"
  ),
  // flusso magnetico
  MagneticFlux: Qudt.quantityKindFromLocalnameRequired("MagneticFlux"),
  // Sound power level
  SoundPowerLevel: Qudt.quantityKindFromLocalnameRequired("SoundPowerLevel"),
  // Diffusion Area
  DiffusionArea: Qudt.quantityKindFromLocalnameRequired("DiffusionArea"),
  // Dose Equivalent
  DoseEquivalent: Qudt.quantityKindFromLocalnameRequired("DoseEquivalent"),
  // Touch Thresholds
  TouchThresholds: Qudt.quantityKindFromLocalnameRequired("TouchThresholds"),
  // Length Energy
  LengthEnergy: Qudt.quantityKindFromLocalnameRequired("LengthEnergy"),
  // Serum or Plasma Level
  SerumOrPlasmaLevel:
    Qudt.quantityKindFromLocalnameRequired("SerumOrPlasmaLevel"),
  // Specific Energy
  SpecificEnergy: Qudt.quantityKindFromLocalnameRequired("SpecificEnergy"),
  // power constant
  PowerConstant: Qudt.quantityKindFromLocalnameRequired("PowerConstant"),
  // Heart Rate
  HeartRate: Qudt.quantityKindFromLocalnameRequired("HeartRate"),
  // Sound exposure level
  SoundExposureLevel:
    Qudt.quantityKindFromLocalnameRequired("SoundExposureLevel"),
  // Center of Gravity in the X axis
  CENTER__OF__GRAVITY_X: Qudt.quantityKindFromLocalnameRequired(
    "CENTER-OF-GRAVITY_X"
  ),
  // temperature-related volume
  TemperatureRelatedVolume: Qudt.quantityKindFromLocalnameRequired(
    "TemperatureRelatedVolume"
  ),
  // Ion Density
  IonDensity: Qudt.quantityKindFromLocalnameRequired("IonDensity"),
  // Radius
  Radius: Qudt.quantityKindFromLocalnameRequired("Radius"),
  // Superconduction Transition Temperature
  SuperconductionTransitionTemperature: Qudt.quantityKindFromLocalnameRequired(
    "SuperconductionTransitionTemperature"
  ),
  // Mass Attenuation Coefficient
  MassAttenuationCoefficient: Qudt.quantityKindFromLocalnameRequired(
    "MassAttenuationCoefficient"
  ),
  // अपवर्तनांक
  RefractiveIndex: Qudt.quantityKindFromLocalnameRequired("RefractiveIndex"),
  // Olfactory Threshold
  OlfactoryThreshold:
    Qudt.quantityKindFromLocalnameRequired("OlfactoryThreshold"),
  // fugacitate
  Fugacity: Qudt.quantityKindFromLocalnameRequired("Fugacity"),
  // Principal Quantum Number
  PrincipalQuantumNumber: Qudt.quantityKindFromLocalnameRequired(
    "PrincipalQuantumNumber"
  ),
  // Larmor Angular Frequency
  CyclotronAngularFrequency: Qudt.quantityKindFromLocalnameRequired(
    "CyclotronAngularFrequency"
  ),
  // electromotive force
  ElectromotiveForce:
    Qudt.quantityKindFromLocalnameRequired("ElectromotiveForce"),
  // Action Time
  ActionTime: Qudt.quantityKindFromLocalnameRequired("ActionTime"),
  // Bioconcentration Factor
  BioconcentrationFactor: Qudt.quantityKindFromLocalnameRequired(
    "BioconcentrationFactor"
  ),
  // median information flow (from a source of information), expressed as a common logarithm
  LogarithmicMedianInformationFlow_SourceToBase10:
    Qudt.quantityKindFromLocalnameRequired(
      "LogarithmicMedianInformationFlow_SourceToBase10"
    ),
  // Molecular Concentration
  MolecularConcentration: Qudt.quantityKindFromLocalnameRequired(
    "MolecularConcentration"
  ),
  // Area Temperature
  AreaTemperature: Qudt.quantityKindFromLocalnameRequired("AreaTemperature"),
  // Kosten pro Masse
  CostPerMass: Qudt.quantityKindFromLocalnameRequired("CostPerMass"),
  // Molar Angular Momentum
  MolarAngularMomentum: Qudt.quantityKindFromLocalnameRequired(
    "MolarAngularMomentum"
  ),
  // areic mass
  AreicMass: Qudt.quantityKindFromLocalnameRequired("AreicMass"),
  // Center of Gravity in the Z axis
  CENTER__OF__GRAVITY_Z: Qudt.quantityKindFromLocalnameRequired(
    "CENTER-OF-GRAVITY_Z"
  ),
  // Inverse Volume
  InverseVolume: Qudt.quantityKindFromLocalnameRequired("InverseVolume"),
  // Static Friction Coefficient
  StaticFrictionCoefficient: Qudt.quantityKindFromLocalnameRequired(
    "StaticFrictionCoefficient"
  ),
  // Mass Concentration of Water To Dry Matter
  MassRatioOfWaterToDryMatter: Qudt.quantityKindFromLocalnameRequired(
    "MassRatioOfWaterToDryMatter"
  ),
  // electrical conductance
  ElectricalConductance: Qudt.quantityKindFromLocalnameRequired(
    "ElectricalConductance"
  ),
  // Energy per electric charge
  EnergyPerElectricCharge: Qudt.quantityKindFromLocalnameRequired(
    "EnergyPerElectricCharge"
  ),
  // Molar Refractivity
  MolarRefractivity:
    Qudt.quantityKindFromLocalnameRequired("MolarRefractivity"),
  // Relative Molecular Mass
  RelativeMolecularMass: Qudt.quantityKindFromLocalnameRequired(
    "RelativeMolecularMass"
  ),
  // Mass Growth Allowance
  MASS__GROWTH__ALLOWANCE: Qudt.quantityKindFromLocalnameRequired(
    "MASS-GROWTH-ALLOWANCE"
  ),
  // Volume
  Volume: Qudt.quantityKindFromLocalnameRequired("Volume"),
  // surface‑related volume flow rate
  SurfaceRelatedVolumeFlowRate: Qudt.quantityKindFromLocalnameRequired(
    "SurfaceRelatedVolumeFlowRate"
  ),
  // Force per Electric Charge
  ForcePerElectricCharge: Qudt.quantityKindFromLocalnameRequired(
    "ForcePerElectricCharge"
  ),
  // Partial Pressure
  PartialPressure: Qudt.quantityKindFromLocalnameRequired("PartialPressure"),
  // Number Density
  NumberDensity: Qudt.quantityKindFromLocalnameRequired("NumberDensity"),
  // ऊष्मा धारिता
  HeatCapacity: Qudt.quantityKindFromLocalnameRequired("HeatCapacity"),
  // RF-Power Level
  RF__Power: Qudt.quantityKindFromLocalnameRequired("RF-Power"),
  // Specific Heat Capacity at Saturation
  SpecificHeatCapacityAtSaturation: Qudt.quantityKindFromLocalnameRequired(
    "SpecificHeatCapacityAtSaturation"
  ),
  // Amount of Substance per Volume
  AmountOfSubstancePerVolume: Qudt.quantityKindFromLocalnameRequired(
    "AmountOfSubstancePerVolume"
  ),
  // Equivalent absorption area
  EquivalentAbsorptionArea: Qudt.quantityKindFromLocalnameRequired(
    "EquivalentAbsorptionArea"
  ),
  // Luminous Energy
  LuminousEnergy: Qudt.quantityKindFromLocalnameRequired("LuminousEnergy"),
  // Temperature Amount of Substance
  TemperatureAmountOfSubstance: Qudt.quantityKindFromLocalnameRequired(
    "TemperatureAmountOfSubstance"
  ),
  // Electromagnetic Energy Density
  ElectromagneticEnergyDensity: Qudt.quantityKindFromLocalnameRequired(
    "ElectromagneticEnergyDensity"
  ),
  // Structural Efficiency
  StructuralEfficiency: Qudt.quantityKindFromLocalnameRequired(
    "StructuralEfficiency"
  ),
  // spectral density of vibrational modes
  SpectralDensityOfVibrationalModes: Qudt.quantityKindFromLocalnameRequired(
    "SpectralDensityOfVibrationalModes"
  ),
  // Vapor Permeance
  VaporPermeance: Qudt.quantityKindFromLocalnameRequired("VaporPermeance"),
  // Radiant Fluence Rate
  RadiantFluenceRate:
    Qudt.quantityKindFromLocalnameRequired("RadiantFluenceRate"),
  // Particle Current
  ParticleCurrent: Qudt.quantityKindFromLocalnameRequired("ParticleCurrent"),
  // areic charge density
  AreaChargeDensity:
    Qudt.quantityKindFromLocalnameRequired("AreaChargeDensity"),
  // Electric Displacement Field
  ElectricDisplacementField: Qudt.quantityKindFromLocalnameRequired(
    "ElectricDisplacementField"
  ),
  // Web Time Average Thrust
  WebTimeAverageThrust: Qudt.quantityKindFromLocalnameRequired(
    "WebTimeAverageThrust"
  ),
  // Vapor Pressure
  VaporPressure: Qudt.quantityKindFromLocalnameRequired("VaporPressure"),
  // Radiant Emmitance
  RadiantEmmitance: Qudt.quantityKindFromLocalnameRequired("RadiantEmmitance"),
  // Electric Field
  ElectricField: Qudt.quantityKindFromLocalnameRequired("ElectricField"),
  // Inert Mass
  INERT__MASS: Qudt.quantityKindFromLocalnameRequired("INERT-MASS"),
  // Cubic Electric Dipole Moment per Square Energy
  ElectricDipoleMoment_CubicPerEnergy_Squared:
    Qudt.quantityKindFromLocalnameRequired(
      "ElectricDipoleMoment_CubicPerEnergy_Squared"
    ),
  // Target Bogie Mass
  TARGET__BOGIE__MASS:
    Qudt.quantityKindFromLocalnameRequired("TARGET-BOGIE-MASS"),
  // Center of Gravity in the X axis
  CenterOfGravity_X:
    Qudt.quantityKindFromLocalnameRequired("CenterOfGravity_X"),
  // سرعت صوت
  SpeedOfSound: Qudt.quantityKindFromLocalnameRequired("SpeedOfSound"),
  // Resonance Energy
  ResonanceEnergy: Qudt.quantityKindFromLocalnameRequired("ResonanceEnergy"),
  // Voltage Phasor
  VoltagePhasor: Qudt.quantityKindFromLocalnameRequired("VoltagePhasor"),
  // volumetric entity density
  VolumetricEntityDensity: Qudt.quantityKindFromLocalnameRequired(
    "VolumetricEntityDensity"
  ),
  // Molality of Solute
  MolalityOfSolute: Qudt.quantityKindFromLocalnameRequired("MolalityOfSolute"),
  // Normal Stress
  NormalStress: Qudt.quantityKindFromLocalnameRequired("NormalStress"),
  // Action
  Action: Qudt.quantityKindFromLocalnameRequired("Action"),
  // bit transmission rate
  BitTransmissionRate: Qudt.quantityKindFromLocalnameRequired(
    "BitTransmissionRate"
  ),
  // energia interna
  EnergyInternal: Qudt.quantityKindFromLocalnameRequired("EnergyInternal"),
  // Biogeochemical Rate
  BiogeochemicalRate:
    Qudt.quantityKindFromLocalnameRequired("BiogeochemicalRate"),
  // Magnetic flux per length
  MagneticFluxPerLength: Qudt.quantityKindFromLocalnameRequired(
    "MagneticFluxPerLength"
  ),
  // Mass Concentration of Water Vapour
  MassConcentrationOfWaterVapour: Qudt.quantityKindFromLocalnameRequired(
    "MassConcentrationOfWaterVapour"
  ),
  // Thermal Transmittance
  ThermalTransmittance: Qudt.quantityKindFromLocalnameRequired(
    "ThermalTransmittance"
  ),
  // Mutual Inductance
  MutualInductance: Qudt.quantityKindFromLocalnameRequired("MutualInductance"),
  // Lagrange Function
  LagrangeFunction: Qudt.quantityKindFromLocalnameRequired("LagrangeFunction"),
  // Spatial Summation Function
  SpatialSummationFunction: Qudt.quantityKindFromLocalnameRequired(
    "SpatialSummationFunction"
  ),
  // Mass Margin
  MASS__MARGIN: Qudt.quantityKindFromLocalnameRequired("MASS-MARGIN"),
  // Thermodynamic Energy
  ThermodynamicEnergy: Qudt.quantityKindFromLocalnameRequired(
    "ThermodynamicEnergy"
  ),
  // force constant
  ForceConstant: Qudt.quantityKindFromLocalnameRequired("ForceConstant"),
  // Electric Charge Surface Density
  ElectricChargeSurfaceDensity: Qudt.quantityKindFromLocalnameRequired(
    "ElectricChargeSurfaceDensity"
  ),
  // Water Solubility
  Solubility_Water: Qudt.quantityKindFromLocalnameRequired("Solubility_Water"),
  // Propellant Mass
  PropellantMass: Qudt.quantityKindFromLocalnameRequired("PropellantMass"),
  // Mass Concentration
  MassConcentration:
    Qudt.quantityKindFromLocalnameRequired("MassConcentration"),
  // Angle Of Attack
  AngleOfAttack: Qudt.quantityKindFromLocalnameRequired("AngleOfAttack"),
  // Relative Pressure Coefficient
  RelativePressureCoefficient: Qudt.quantityKindFromLocalnameRequired(
    "RelativePressureCoefficient"
  ),
  // Beta Disintegration Energy
  BetaDisintegrationEnergy: Qudt.quantityKindFromLocalnameRequired(
    "BetaDisintegrationEnergy"
  ),
  // Показатель адиабаты
  IsentropicExponent:
    Qudt.quantityKindFromLocalnameRequired("IsentropicExponent"),
  // Elevation relative to NAP
  ElevationRelativeToNAP: Qudt.quantityKindFromLocalnameRequired(
    "ElevationRelativeToNAP"
  ),
  // podatność elektryczna
  ElectricSusceptibility: Qudt.quantityKindFromLocalnameRequired(
    "ElectricSusceptibility"
  ),
  // Neutron Yield per Absorption
  NeutronYieldPerAbsorption: Qudt.quantityKindFromLocalnameRequired(
    "NeutronYieldPerAbsorption"
  ),
  // Hole Density
  HoleDensity: Qudt.quantityKindFromLocalnameRequired("HoleDensity"),
  // Modulus of Subgrade Reaction
  ModulusOfSubgradeReaction: Qudt.quantityKindFromLocalnameRequired(
    "ModulusOfSubgradeReaction"
  ),
  // Donor Density
  DonorDensity: Qudt.quantityKindFromLocalnameRequired("DonorDensity"),
  // Debye-Waller Factor
  Debye__WallerFactor:
    Qudt.quantityKindFromLocalnameRequired("Debye-WallerFactor"),
  // Measurement Unit of Spectral Radiance
  SpectralRadiance: Qudt.quantityKindFromLocalnameRequired("SpectralRadiance"),
  // Fission Fuel Utilization Factor
  FissionFuelUtilizationFactor: Qudt.quantityKindFromLocalnameRequired(
    "FissionFuelUtilizationFactor"
  ),
  // Permeance
  Permeance: Qudt.quantityKindFromLocalnameRequired("Permeance"),
  // Planck Function
  PlanckFunction: Qudt.quantityKindFromLocalnameRequired("PlanckFunction"),
  // Slowing-Down Length
  Slowing__DownLength:
    Qudt.quantityKindFromLocalnameRequired("Slowing-DownLength"),
  // Vibrational density of states
  VibrationalDensityOfStates: Qudt.quantityKindFromLocalnameRequired(
    "VibrationalDensityOfStates"
  ),
  // Relative Mass Concentration of Vapour
  RelativeMassConcentrationOfVapour: Qudt.quantityKindFromLocalnameRequired(
    "RelativeMassConcentrationOfVapour"
  ),
  // Mass Energy Transfer Coefficient
  MassEnergyTransferCoefficient: Qudt.quantityKindFromLocalnameRequired(
    "MassEnergyTransferCoefficient"
  ),
  // loudness level
  LoudnessLevel: Qudt.quantityKindFromLocalnameRequired("LoudnessLevel"),
  // Dimensionless
  Dimensionless: Qudt.quantityKindFromLocalnameRequired("Dimensionless"),
  // First Stage Mass Ratio
  FirstStageMassRatio: Qudt.quantityKindFromLocalnameRequired(
    "FirstStageMassRatio"
  ),
  // areic energy flow
  AreicEnergyFlow: Qudt.quantityKindFromLocalnameRequired("AreicEnergyFlow"),
  // Effective Mass
  EffectiveMass: Qudt.quantityKindFromLocalnameRequired("EffectiveMass"),
  // Instantaneous Power
  InstantaneousPower:
    Qudt.quantityKindFromLocalnameRequired("InstantaneousPower"),
  // Displacement Vector of Ion
  DisplacementVectorOfIon: Qudt.quantityKindFromLocalnameRequired(
    "DisplacementVectorOfIon"
  ),
  // Order of Reflection
  OrderOfReflection:
    Qudt.quantityKindFromLocalnameRequired("OrderOfReflection"),
  // Particle Fluence Rate
  ParticleFluenceRate: Qudt.quantityKindFromLocalnameRequired(
    "ParticleFluenceRate"
  ),
  // Transmittance Density
  TransmittanceDensity: Qudt.quantityKindFromLocalnameRequired(
    "TransmittanceDensity"
  ),
  // byte rate
  ByteRate: Qudt.quantityKindFromLocalnameRequired("ByteRate"),
  // Conductivity Variance
  ConductivityVariance: Qudt.quantityKindFromLocalnameRequired(
    "ConductivityVariance"
  ),
  // Characteristic Velocity
  CharacteristicVelocity: Qudt.quantityKindFromLocalnameRequired(
    "CharacteristicVelocity"
  ),
  // Pressure Loss per Length
  PressureLossPerLength: Qudt.quantityKindFromLocalnameRequired(
    "PressureLossPerLength"
  ),
  // Propellant Mean Bulk Temperature
  PropellantMeanBulkTemperature: Qudt.quantityKindFromLocalnameRequired(
    "PropellantMeanBulkTemperature"
  ),
  // Time Squared
  Time_Squared: Qudt.quantityKindFromLocalnameRequired("Time_Squared"),
  // Reynolds Number
  ReynoldsNumber: Qudt.quantityKindFromLocalnameRequired("ReynoldsNumber"),
  // Temporal Summation Function
  TemporalSummationFunction: Qudt.quantityKindFromLocalnameRequired(
    "TemporalSummationFunction"
  ),
  // Recombination Coefficient
  RecombinationCoefficient: Qudt.quantityKindFromLocalnameRequired(
    "RecombinationCoefficient"
  ),
  // Gain
  Gain: Qudt.quantityKindFromLocalnameRequired("Gain"),
  // energia radiante
  RadiantEnergy: Qudt.quantityKindFromLocalnameRequired("RadiantEnergy"),
  // Photon Intensity
  PhotonIntensity: Qudt.quantityKindFromLocalnameRequired("PhotonIntensity"),
  // Nozzle Walls Thrust Reaction
  NozzleWallsThrustReaction: Qudt.quantityKindFromLocalnameRequired(
    "NozzleWallsThrustReaction"
  ),
  // Depth
  Depth: Qudt.quantityKindFromLocalnameRequired("Depth"),
  // Blood Glucose Level
  BloodGlucoseLevel:
    Qudt.quantityKindFromLocalnameRequired("BloodGlucoseLevel"),
  // Tenaga kinetik
  EnergyKinetic: Qudt.quantityKindFromLocalnameRequired("EnergyKinetic"),
  // Molar Flux Density
  MolarFluxDensity: Qudt.quantityKindFromLocalnameRequired("MolarFluxDensity"),
  // Extent of Reaction
  ExtentOfReaction: Qudt.quantityKindFromLocalnameRequired("ExtentOfReaction"),
  // fluctús lucis
  LuminousFlux: Qudt.quantityKindFromLocalnameRequired("LuminousFlux"),
  // Absolute Activity
  AbsoluteActivity: Qudt.quantityKindFromLocalnameRequired("AbsoluteActivity"),
  // mass stopping power
  MassStoppingPower:
    Qudt.quantityKindFromLocalnameRequired("MassStoppingPower"),
  // Momentum per Angle
  MomentumPerAngle: Qudt.quantityKindFromLocalnameRequired("MomentumPerAngle"),
  // Inverse Pressure
  InversePressure: Qudt.quantityKindFromLocalnameRequired("InversePressure"),
  // pressure-based mass flow
  PressureBasedMassFlow: Qudt.quantityKindFromLocalnameRequired(
    "PressureBasedMassFlow"
  ),
  // logarithmic ratio to base 10
  Log10Ratio: Qudt.quantityKindFromLocalnameRequired("Log10Ratio"),
  // Temperature Rate of Change
  TemperatureRateOfChange: Qudt.quantityKindFromLocalnameRequired(
    "TemperatureRateOfChange"
  ),
  // Adaptation
  Adaptation: Qudt.quantityKindFromLocalnameRequired("Adaptation"),
  // Initial Nozzle Throat Diameter
  InitialNozzleThroatDiameter: Qudt.quantityKindFromLocalnameRequired(
    "InitialNozzleThroatDiameter"
  ),
  // spin
  Spin: Qudt.quantityKindFromLocalnameRequired("Spin"),
  // Specific Helmholtz Energy
  SpecificHelmholtzEnergy: Qudt.quantityKindFromLocalnameRequired(
    "SpecificHelmholtzEnergy"
  ),
  // Elliptical Orbit Perigee Velocity
  EllipticalOrbitPerigeeVelocity: Qudt.quantityKindFromLocalnameRequired(
    "EllipticalOrbitPerigeeVelocity"
  ),
  // كمية المادة
  AmountOfSubstance:
    Qudt.quantityKindFromLocalnameRequired("AmountOfSubstance"),
  // Stage Propellant Mass
  StagePropellantMass: Qudt.quantityKindFromLocalnameRequired(
    "StagePropellantMass"
  ),
  // volumic output power
  VolumetricOutputPower: Qudt.quantityKindFromLocalnameRequired(
    "VolumetricOutputPower"
  ),
  // lineic power
  LinearPower: Qudt.quantityKindFromLocalnameRequired("LinearPower"),
  // Blood Glucose Level by Mass
  MassBasedBloodGlucoseLevel: Qudt.quantityKindFromLocalnameRequired(
    "MassBasedBloodGlucoseLevel"
  ),
  // Temperature Ratio
  TemperatureRatio: Qudt.quantityKindFromLocalnameRequired("TemperatureRatio"),
  // Rotational Mass
  RotationalMass: Qudt.quantityKindFromLocalnameRequired("RotationalMass"),
  // Neutron Diffusion Length
  NeutronDiffusionLength: Qudt.quantityKindFromLocalnameRequired(
    "NeutronDiffusionLength"
  ),
  // temperature-based kinematic viscosity
  TemperatureBasedKinematicViscosity: Qudt.quantityKindFromLocalnameRequired(
    "TemperatureBasedKinematicViscosity"
  ),
  // Surface Coefficient of Heat Transfer
  SurfaceCoefficientOfHeatTransfer: Qudt.quantityKindFromLocalnameRequired(
    "SurfaceCoefficientOfHeatTransfer"
  ),
  // fluidity
  Fluidity: Qudt.quantityKindFromLocalnameRequired("Fluidity"),
  // Sound pressure
  SoundPressure: Qudt.quantityKindFromLocalnameRequired("SoundPressure"),
  // Vision Thresholds
  VisionThresholds: Qudt.quantityKindFromLocalnameRequired("VisionThresholds"),
  // pressure-based volume
  PressureBasedVolume: Qudt.quantityKindFromLocalnameRequired(
    "PressureBasedVolume"
  ),
  // lineic quantity
  LineicQuantity: Qudt.quantityKindFromLocalnameRequired("LineicQuantity"),
  // Linked Flux
  LinkedFlux: Qudt.quantityKindFromLocalnameRequired("LinkedFlux"),
  // lineic logarithmic ratio
  LinearLogarithmicRatio: Qudt.quantityKindFromLocalnameRequired(
    "LinearLogarithmicRatio"
  ),
  // Eccentricity Of Orbit
  EccentricityOfOrbit: Qudt.quantityKindFromLocalnameRequired(
    "EccentricityOfOrbit"
  ),
  // Reactance
  Reactance: Qudt.quantityKindFromLocalnameRequired("Reactance"),
  // lineic resistance
  LinearResistance: Qudt.quantityKindFromLocalnameRequired("LinearResistance"),
  // Energy Per Square Magnetic Flux Density
  EnergyPerSquareMagneticFluxDensity: Qudt.quantityKindFromLocalnameRequired(
    "EnergyPerSquareMagneticFluxDensity"
  ),
  // Relative Partial Pressure
  RelativePartialPressure: Qudt.quantityKindFromLocalnameRequired(
    "RelativePartialPressure"
  ),
  // area per length
  AreaPerLength: Qudt.quantityKindFromLocalnameRequired("AreaPerLength"),
  // Predicted Mass
  PREDICTED__MASS: Qudt.quantityKindFromLocalnameRequired("PREDICTED-MASS"),
  // API Gravity
  APIGravity: Qudt.quantityKindFromLocalnameRequired("APIGravity"),
  // Thermal Diffusion Coefficient
  ThermalDiffusionRatioCoefficient: Qudt.quantityKindFromLocalnameRequired(
    "ThermalDiffusionRatioCoefficient"
  ),
  // Phonon Mean Free Path
  PhononMeanFreePath:
    Qudt.quantityKindFromLocalnameRequired("PhononMeanFreePath"),
  // Product of Inertia in the Z axis
  ProductOfInertia_Z:
    Qudt.quantityKindFromLocalnameRequired("ProductOfInertia_Z"),
  // Relative Mass Density
  RelativeMassDensity: Qudt.quantityKindFromLocalnameRequired(
    "RelativeMassDensity"
  ),
  // floating point calculation capability
  FloatingPointCalculationCapability: Qudt.quantityKindFromLocalnameRequired(
    "FloatingPointCalculationCapability"
  ),
  // Mass Excess
  MassExcess: Qudt.quantityKindFromLocalnameRequired("MassExcess"),
  // Positive Dimensionless Ratio
  NormalizedDimensionlessRatio: Qudt.quantityKindFromLocalnameRequired(
    "NormalizedDimensionlessRatio"
  ),
  // Boiling Point Temperature
  BoilingPoint: Qudt.quantityKindFromLocalnameRequired("BoilingPoint"),
  // median information flow (from a source of information), expressed as a common logarithm
  CommonLogarithmicMedianInformationFlow:
    Qudt.quantityKindFromLocalnameRequired(
      "CommonLogarithmicMedianInformationFlow"
    ),
  // Maximum Expected Operating Thrust
  MaxExpectedOperatingThrust: Qudt.quantityKindFromLocalnameRequired(
    "MaxExpectedOperatingThrust"
  ),
  // मैक संख्या
  MachNumber: Qudt.quantityKindFromLocalnameRequired("MachNumber"),
  // Propellant Burn Rate
  PropellantBurnRate:
    Qudt.quantityKindFromLocalnameRequired("PropellantBurnRate"),
  // Slowing-Down Density
  Slowing__DownDensity: Qudt.quantityKindFromLocalnameRequired(
    "Slowing-DownDensity"
  ),
  // Ionization Energy
  IonizationEnergy: Qudt.quantityKindFromLocalnameRequired("IonizationEnergy"),
  // Diffusion Length (Solid State Physics)
  SolidStateDiffusionLength: Qudt.quantityKindFromLocalnameRequired(
    "SolidStateDiffusionLength"
  ),
  // Permeability
  Permeability: Qudt.quantityKindFromLocalnameRequired("Permeability"),
  // Signal Detection Threshold
  SignalDetectionThreshold: Qudt.quantityKindFromLocalnameRequired(
    "SignalDetectionThreshold"
  ),
  // Mass Concentration of Water
  MassConcentrationOfWater: Qudt.quantityKindFromLocalnameRequired(
    "MassConcentrationOfWater"
  ),
  // Temperature per Time Squared
  TemperaturePerTime_Squared: Qudt.quantityKindFromLocalnameRequired(
    "TemperaturePerTime_Squared"
  ),
  // Area Angle
  AreaAngle: Qudt.quantityKindFromLocalnameRequired("AreaAngle"),
  // Heat Flow Rate per Unit Area
  HeatFlowRatePerArea: Qudt.quantityKindFromLocalnameRequired(
    "HeatFlowRatePerArea"
  ),
  // surface-related volume flow
  SurfaceRelatedVolumeFlow: Qudt.quantityKindFromLocalnameRequired(
    "SurfaceRelatedVolumeFlow"
  ),
  // rate of rise of voltage
  RateOfRiseOfVoltage: Qudt.quantityKindFromLocalnameRequired(
    "RateOfRiseOfVoltage"
  ),
  // Long-Range Order Parameter
  Long__RangeOrderParameter: Qudt.quantityKindFromLocalnameRequired(
    "Long-RangeOrderParameter"
  ),
  // Final Or Current Vehicle Mass
  FinalOrCurrentVehicleMass: Qudt.quantityKindFromLocalnameRequired(
    "FinalOrCurrentVehicleMass"
  ),
  // PowerDensity
  PowerDensity: Qudt.quantityKindFromLocalnameRequired("PowerDensity"),
  // Thermal Efficiency
  ThermalEfficiency:
    Qudt.quantityKindFromLocalnameRequired("ThermalEfficiency"),
  // Length Mass
  LengthMass: Qudt.quantityKindFromLocalnameRequired("LengthMass"),
  // kerja
  Work: Qudt.quantityKindFromLocalnameRequired("Work"),
  // momento di dipolo elettrico
  ElectricDipoleMoment: Qudt.quantityKindFromLocalnameRequired(
    "ElectricDipoleMoment"
  ),
  // traffic intensity
  TrafficIntensity: Qudt.quantityKindFromLocalnameRequired("TrafficIntensity"),
  // Electric Charge Per Mass
  ElectricChargePerMass: Qudt.quantityKindFromLocalnameRequired(
    "ElectricChargePerMass"
  ),
  // Modulus Of Admittance
  ModulusOfAdmittance: Qudt.quantityKindFromLocalnameRequired(
    "ModulusOfAdmittance"
  ),
  // Catalytic Activity Concentration
  CatalyticActivityConcentration: Qudt.quantityKindFromLocalnameRequired(
    "CatalyticActivityConcentration"
  ),
  // Total Mass Stopping Power
  TotalMassStoppingPower: Qudt.quantityKindFromLocalnameRequired(
    "TotalMassStoppingPower"
  ),
  // Multiplication Factor
  MultiplicationFactor: Qudt.quantityKindFromLocalnameRequired(
    "MultiplicationFactor"
  ),
  // Photosynthetic Photon Flux
  PhotosyntheticPhotonFlux: Qudt.quantityKindFromLocalnameRequired(
    "PhotosyntheticPhotonFlux"
  ),
  // momento de dipolo magnético
  MagneticMoment: Qudt.quantityKindFromLocalnameRequired("MagneticMoment"),
  // Modulus of Rotational Subgrade Reaction
  ModulusOfRotationalSubgradeReaction: Qudt.quantityKindFromLocalnameRequired(
    "ModulusOfRotationalSubgradeReaction"
  ),
  // equilibrium constant based on pressure
  EquilibriumConstantBasedOnPressure: Qudt.quantityKindFromLocalnameRequired(
    "EquilibriumConstantBasedOnPressure"
  ),
  // Lower Critical Magnetic Flux Density
  LowerCriticalMagneticFluxDensity: Qudt.quantityKindFromLocalnameRequired(
    "LowerCriticalMagneticFluxDensity"
  ),
  // Kelajuan cahaya
  SpeedOfLight: Qudt.quantityKindFromLocalnameRequired("SpeedOfLight"),
  // Angular Momentum
  AngularMomentum: Qudt.quantityKindFromLocalnameRequired("AngularMomentum"),
  // Electromagnetic Wave Phase Speed
  ElectromagneticWavePhaseSpeed: Qudt.quantityKindFromLocalnameRequired(
    "ElectromagneticWavePhaseSpeed"
  ),
  // entropie
  Entropy: Qudt.quantityKindFromLocalnameRequired("Entropy"),
  // Mass Equivalent
  Equivalent_Mass: Qudt.quantityKindFromLocalnameRequired("Equivalent_Mass"),
  // Total Ionization
  TotalIonization: Qudt.quantityKindFromLocalnameRequired("TotalIonization"),
  // Electric Current Phasor
  ElectricCurrentPhasor: Qudt.quantityKindFromLocalnameRequired(
    "ElectricCurrentPhasor"
  ),
  // Force per Angle
  ForcePerAngle: Qudt.quantityKindFromLocalnameRequired("ForcePerAngle"),
  // semiperiodo
  Half__Life: Qudt.quantityKindFromLocalnameRequired("Half-Life"),
  // reciprocal electric resistance
  ReciprocalElectricResistance: Qudt.quantityKindFromLocalnameRequired(
    "ReciprocalElectricResistance"
  ),
  // cost per area
  CostPerArea: Qudt.quantityKindFromLocalnameRequired("CostPerArea"),
  // pressure-based amount-of-substance concentration
  PressureBasedAmountOfSubstanceConcentration:
    Qudt.quantityKindFromLocalnameRequired(
      "PressureBasedAmountOfSubstanceConcentration"
    ),
  // Inverse Temperature
  InverseTemperature:
    Qudt.quantityKindFromLocalnameRequired("InverseTemperature"),
  // Water Solubility
  WaterSolubility: Qudt.quantityKindFromLocalnameRequired("WaterSolubility"),
  // Relaxation TIme
  RelaxationTIme: Qudt.quantityKindFromLocalnameRequired("RelaxationTIme"),
  // Initial Vehicle Mass
  InitialVehicleMass:
    Qudt.quantityKindFromLocalnameRequired("InitialVehicleMass"),
  // Vehicle Velocity
  VehicleVelocity: Qudt.quantityKindFromLocalnameRequired("VehicleVelocity"),
  // amount of biologically active substance
  AmountOfBiologicallyActiveSubstance: Qudt.quantityKindFromLocalnameRequired(
    "AmountOfBiologicallyActiveSubstance"
  ),
  // Mass Delivered
  MASS__DELIVERED: Qudt.quantityKindFromLocalnameRequired("MASS-DELIVERED"),
  // Electrolytic Conductivity
  ElectrolyticConductivity: Qudt.quantityKindFromLocalnameRequired(
    "ElectrolyticConductivity"
  ),
  // Area Time
  AreaTime: Qudt.quantityKindFromLocalnameRequired("AreaTime"),
  // rotary shock
  RotaryShock: Qudt.quantityKindFromLocalnameRequired("RotaryShock"),
  // Isothermal Moisture Capacity
  IsothermalMoistureCapacity: Qudt.quantityKindFromLocalnameRequired(
    "IsothermalMoistureCapacity"
  ),
  // Loss Angle
  LossAngle: Qudt.quantityKindFromLocalnameRequired("LossAngle"),
  // Absorbed Dose Rate
  AbsorbedDoseRate: Qudt.quantityKindFromLocalnameRequired("AbsorbedDoseRate"),
  // Number of Particles
  NumberOfParticles:
    Qudt.quantityKindFromLocalnameRequired("NumberOfParticles"),
  // Group Speed of Sound
  GroupSpeedOfSound:
    Qudt.quantityKindFromLocalnameRequired("GroupSpeedOfSound"),
  // Molar Optical Rotatory Power
  MolarOpticalRotatoryPower: Qudt.quantityKindFromLocalnameRequired(
    "MolarOpticalRotatoryPower"
  ),
  // Electric Charge Line Density
  ElectricChargeLineDensity: Qudt.quantityKindFromLocalnameRequired(
    "ElectricChargeLineDensity"
  ),
  // Energy Per Square Magnetic Flux Density
  EnergyPerMagneticFluxDensity_Squared: Qudt.quantityKindFromLocalnameRequired(
    "EnergyPerMagneticFluxDensity_Squared"
  ),
  // Mass Of Solid Booster
  MassOfSolidBooster:
    Qudt.quantityKindFromLocalnameRequired("MassOfSolidBooster"),
  // Period
  Period: Qudt.quantityKindFromLocalnameRequired("Period"),
  // Power per area quartic temperature
  PowerPerAreaQuarticTemperature: Qudt.quantityKindFromLocalnameRequired(
    "PowerPerAreaQuarticTemperature"
  ),
  // Mechanical Energy
  MechanicalEnergy: Qudt.quantityKindFromLocalnameRequired("MechanicalEnergy"),
  // Web Time
  WebTime: Qudt.quantityKindFromLocalnameRequired("WebTime"),
  // Concentration
  Concentration: Qudt.quantityKindFromLocalnameRequired("Concentration"),
  // Mean Free Path
  MeanFreePath: Qudt.quantityKindFromLocalnameRequired("MeanFreePath"),
  // indukcja magnetyczna
  MagneticFluxDensity: Qudt.quantityKindFromLocalnameRequired(
    "MagneticFluxDensity"
  ),
  // Unknown
  Unknown: Qudt.quantityKindFromLocalnameRequired("Unknown"),
  // Packing Fraction
  PackingFraction: Qudt.quantityKindFromLocalnameRequired("PackingFraction"),
  // Carrier LifetIme
  CarrierLifetime: Qudt.quantityKindFromLocalnameRequired("CarrierLifetime"),
  // Temperature per Square Time
  TemperaturePerSquareTime: Qudt.quantityKindFromLocalnameRequired(
    "TemperaturePerSquareTime"
  ),
  // Conductivity Variance, NEON
  ConductivityVariance_NEON: Qudt.quantityKindFromLocalnameRequired(
    "ConductivityVariance_NEON"
  ),
  // Delta u,v
  Duv: Qudt.quantityKindFromLocalnameRequired("Duv"),
  // volume molar
  MolarVolume: Qudt.quantityKindFromLocalnameRequired("MolarVolume"),
  // gradient
  Gradient: Qudt.quantityKindFromLocalnameRequired("Gradient"),
  // Auditory Thresholds
  AuditoryThresholds:
    Qudt.quantityKindFromLocalnameRequired("AuditoryThresholds"),
  // Mass Property Uncertainty
  MASS__PROPERTY__UNCERTAINTY: Qudt.quantityKindFromLocalnameRequired(
    "MASS-PROPERTY-UNCERTAINTY"
  ),
  // Mass Amount of Substance
  MassAmountOfSubstance: Qudt.quantityKindFromLocalnameRequired(
    "MassAmountOfSubstance"
  ),
  // Fission Core Radius To Height Ratio
  FissionCoreRadiusToHeightRatio: Qudt.quantityKindFromLocalnameRequired(
    "FissionCoreRadiusToHeightRatio"
  ),
  // teplota
  CelsiusTemperature:
    Qudt.quantityKindFromLocalnameRequired("CelsiusTemperature"),
  // Curvature
  CurvatureFromRadius: Qudt.quantityKindFromLocalnameRequired(
    "CurvatureFromRadius"
  ),
  // Positive Plane Angle
  PositivePlaneAngle:
    Qudt.quantityKindFromLocalnameRequired("PositivePlaneAngle"),
  // Initial Expansion Ratio
  InitialExpansionRatio: Qudt.quantityKindFromLocalnameRequired(
    "InitialExpansionRatio"
  ),
  // information content expressed as a logarithm to base e
  InformationContentExpressedAsALogarithmToBaseE:
    Qudt.quantityKindFromLocalnameRequired(
      "InformationContentExpressedAsALogarithmToBaseE"
    ),
  // Electron Radius
  ElectronRadius: Qudt.quantityKindFromLocalnameRequired("ElectronRadius"),
  // Infinite Multiplication Factor
  InfiniteMultiplicationFactor: Qudt.quantityKindFromLocalnameRequired(
    "InfiniteMultiplicationFactor"
  ),
  // Dry Mass
  DRY__MASS: Qudt.quantityKindFromLocalnameRequired("DRY-MASS"),
  // Dose Equivalent Quality Factor
  DoseEquivalentQualityFactor: Qudt.quantityKindFromLocalnameRequired(
    "DoseEquivalentQualityFactor"
  ),
  // Larmor Angular Frequency
  LarmorAngularFrequency: Qudt.quantityKindFromLocalnameRequired(
    "LarmorAngularFrequency"
  ),
  // Ignition interval time
  IgnitionIntervalTime: Qudt.quantityKindFromLocalnameRequired(
    "IgnitionIntervalTime"
  ),
  // Angle
  Angle: Qudt.quantityKindFromLocalnameRequired("Angle"),
  // median information flow (from a source of information), expressed as a binary logarithm
  LogarithmicMedianInformationFlow_SourceToBase2:
    Qudt.quantityKindFromLocalnameRequired(
      "LogarithmicMedianInformationFlow_SourceToBase2"
    ),
  // Volume Flow Rate
  VolumeFlowRate: Qudt.quantityKindFromLocalnameRequired("VolumeFlowRate"),
  // مختصات دکارتی
  CartesianCoordinates: Qudt.quantityKindFromLocalnameRequired(
    "CartesianCoordinates"
  ),
  // Total Angular Momentum
  TotalAngularMomentum: Qudt.quantityKindFromLocalnameRequired(
    "TotalAngularMomentum"
  ),
  // نقطه کوری
  CurieTemperature: Qudt.quantityKindFromLocalnameRequired("CurieTemperature"),
  // Melting Point Temperature
  MeltingPoint: Qudt.quantityKindFromLocalnameRequired("MeltingPoint"),
  // pressure-based electric current
  PressureBasedElectricCurrent: Qudt.quantityKindFromLocalnameRequired(
    "PressureBasedElectricCurrent"
  ),
  // Orbital Angular Momentum per Mass
  OrbitalAngularMomentumPerMass: Qudt.quantityKindFromLocalnameRequired(
    "OrbitalAngularMomentumPerMass"
  ),
  // Acceptor Ionization Energy
  AcceptorIonizationEnergy: Qudt.quantityKindFromLocalnameRequired(
    "AcceptorIonizationEnergy"
  ),
  // инвариантная масса
  RestMass: Qudt.quantityKindFromLocalnameRequired("RestMass"),
  // Evaporative Heat Transfer
  EvaporativeHeatTransfer: Qudt.quantityKindFromLocalnameRequired(
    "EvaporativeHeatTransfer"
  ),
  // Electron Density
  ElectronDensity: Qudt.quantityKindFromLocalnameRequired("ElectronDensity"),
  // Radiant Intensity
  RadiantIntensity: Qudt.quantityKindFromLocalnameRequired("RadiantIntensity"),
  // Systolic Blood Pressure
  SystolicBloodPressure: Qudt.quantityKindFromLocalnameRequired(
    "SystolicBloodPressure"
  ),
  // Thermal Energy Length
  ThermalEnergyLength: Qudt.quantityKindFromLocalnameRequired(
    "ThermalEnergyLength"
  ),
  // Spectral Cross-section
  SpectralCrossSection: Qudt.quantityKindFromLocalnameRequired(
    "SpectralCrossSection"
  ),
  // ポインティングベクトル
  PoyntingVector: Qudt.quantityKindFromLocalnameRequired("PoyntingVector"),
  // Strain Energy Release Rate
  StrainEnergyReleaseRate: Qudt.quantityKindFromLocalnameRequired(
    "StrainEnergyReleaseRate"
  ),
  // Specific Volume
  SpecificVolume: Qudt.quantityKindFromLocalnameRequired("SpecificVolume"),
  // byte data volume
  ByteDataVolume: Qudt.quantityKindFromLocalnameRequired("ByteDataVolume"),
  // potencial magnético
  MagneticVectorPotential: Qudt.quantityKindFromLocalnameRequired(
    "MagneticVectorPotential"
  ),
  // Measurement Unit of Spectral Emittance
  SpectralEmittance:
    Qudt.quantityKindFromLocalnameRequired("SpectralEmittance"),
  // Equilibrium Constant on Concentration Basis
  EquilibriumConstantOnConcentrationBasis:
    Qudt.quantityKindFromLocalnameRequired(
      "EquilibriumConstantOnConcentrationBasis"
    ),
  // torsional rigidity
  TorsionalRigidity:
    Qudt.quantityKindFromLocalnameRequired("TorsionalRigidity"),
  // 等温压缩率
  IsothermalCompressibility: Qudt.quantityKindFromLocalnameRequired(
    "IsothermalCompressibility"
  ),
  // Stage Structure Mass
  StageStructuralMass: Qudt.quantityKindFromLocalnameRequired(
    "StageStructuralMass"
  ),
  // equivalence dose output
  EquivalenceDoseOutput: Qudt.quantityKindFromLocalnameRequired(
    "EquivalenceDoseOutput"
  ),
  // Aeric Heat Flow Rate
  AreicHeatFlowRate:
    Qudt.quantityKindFromLocalnameRequired("AreicHeatFlowRate"),
  // Inverse Square Mass
  InverseSquareMass:
    Qudt.quantityKindFromLocalnameRequired("InverseSquareMass"),
  // nuclear energy
  NuclearEnergy: Qudt.quantityKindFromLocalnameRequired("NuclearEnergy"),
  // Bending Moment of Force
  BendingMomentOfForce: Qudt.quantityKindFromLocalnameRequired(
    "BendingMomentOfForce"
  ),
  // Temperature Gradient
  TemperatureGradient: Qudt.quantityKindFromLocalnameRequired(
    "TemperatureGradient"
  ),
  // Rotational Stiffness
  RotationalStiffness: Qudt.quantityKindFromLocalnameRequired(
    "RotationalStiffness"
  ),
  // Gene Family Abundance
  GeneFamilyAbundance: Qudt.quantityKindFromLocalnameRequired(
    "GeneFamilyAbundance"
  ),
  // Path Length
  PathLength: Qudt.quantityKindFromLocalnameRequired("PathLength"),
  // Warping Constant
  WarpingConstant: Qudt.quantityKindFromLocalnameRequired("WarpingConstant"),
  // عزم محورى
  Torque: Qudt.quantityKindFromLocalnameRequired("Torque"),
  // Linear Thermal Expansion
  LinearThermalExpansion: Qudt.quantityKindFromLocalnameRequired(
    "LinearThermalExpansion"
  ),
  // Electric Current per Temperature
  ElectricCurrentPerTemperature: Qudt.quantityKindFromLocalnameRequired(
    "ElectricCurrentPerTemperature"
  ),
  // Plasma Level
  PlasmaLevel: Qudt.quantityKindFromLocalnameRequired("PlasmaLevel"),
  // Inverse Time Temperature
  InverseTimeTemperature: Qudt.quantityKindFromLocalnameRequired(
    "InverseTimeTemperature"
  ),
  // earthquake magnitude
  EarthquakeMagnitude: Qudt.quantityKindFromLocalnameRequired(
    "EarthquakeMagnitude"
  ),
  // Activity Concentration
  ActivityConcentration: Qudt.quantityKindFromLocalnameRequired(
    "ActivityConcentration"
  ),
  // Control Mass.
  CONTROL__MASS: Qudt.quantityKindFromLocalnameRequired("CONTROL-MASS"),
  // State of charge
  StateOfCharge: Qudt.quantityKindFromLocalnameRequired("StateOfCharge"),
  // temperature-based velocity
  TemperatureBasedVelocity: Qudt.quantityKindFromLocalnameRequired(
    "TemperatureBasedVelocity"
  ),
  // Surface Activity Density
  SurfaceActivityDensity: Qudt.quantityKindFromLocalnameRequired(
    "SurfaceActivityDensity"
  ),
  // Burn Rate
  BurnRate: Qudt.quantityKindFromLocalnameRequired("BurnRate"),
  // Total Angular Momentum Quantum Number
  TotalAngularMomentumQuantumNumber: Qudt.quantityKindFromLocalnameRequired(
    "TotalAngularMomentumQuantumNumber"
  ),
  // Electromagnetic Permeability Ratio
  ElectromagneticPermeabilityRatio: Qudt.quantityKindFromLocalnameRequired(
    "ElectromagneticPermeabilityRatio"
  ),
  // Mass Fraction of Water
  MassFractionOfWater: Qudt.quantityKindFromLocalnameRequired(
    "MassFractionOfWater"
  ),
  // First Moment of Area
  FirstMomentOfArea:
    Qudt.quantityKindFromLocalnameRequired("FirstMomentOfArea"),
  // Displacement Current
  DisplacementCurrent: Qudt.quantityKindFromLocalnameRequired(
    "DisplacementCurrent"
  ),
  // Mass Absorption Coefficient
  MassAbsorptionCoefficient: Qudt.quantityKindFromLocalnameRequired(
    "MassAbsorptionCoefficient"
  ),
  // Shannon Diversity Index
  ShannonDiversityIndex: Qudt.quantityKindFromLocalnameRequired(
    "ShannonDiversityIndex"
  ),
  // Atomic Number
  AtomicNumber: Qudt.quantityKindFromLocalnameRequired("AtomicNumber"),
  // Bulk Modulus
  BulkModulus: Qudt.quantityKindFromLocalnameRequired("BulkModulus"),
  // molar thermodynamic energy
  MolarThermodynamicEnergy: Qudt.quantityKindFromLocalnameRequired(
    "MolarThermodynamicEnergy"
  ),
  // Mass per Area
  MassPerArea: Qudt.quantityKindFromLocalnameRequired("MassPerArea"),
  // Specific Electric Charge
  SpecificElectricCharge: Qudt.quantityKindFromLocalnameRequired(
    "SpecificElectricCharge"
  ),
  // Tilt
  Tilt: Qudt.quantityKindFromLocalnameRequired("Tilt"),
  // areic mass
  AreaMass: Qudt.quantityKindFromLocalnameRequired("AreaMass"),
  // Gap Energy
  GapEnergy: Qudt.quantityKindFromLocalnameRequired("GapEnergy"),
  // reciprocal mass
  InverseMass: Qudt.quantityKindFromLocalnameRequired("InverseMass"),
  // Total Atomic Stopping Power
  TotalAtomicStoppingPower: Qudt.quantityKindFromLocalnameRequired(
    "TotalAtomicStoppingPower"
  ),
  // Gravitational Attraction
  GravitationalAttraction: Qudt.quantityKindFromLocalnameRequired(
    "GravitationalAttraction"
  ),
  // Specific Internal Energy
  SpecificInternalEnergy: Qudt.quantityKindFromLocalnameRequired(
    "SpecificInternalEnergy"
  ),
  // Leakage Factor
  LeakageFactor: Qudt.quantityKindFromLocalnameRequired("LeakageFactor"),
  // Inverse Square Time
  InverseTime_Squared: Qudt.quantityKindFromLocalnameRequired(
    "InverseTime_Squared"
  ),
  // temperature-based quantity
  TemperatureBasedQuantity: Qudt.quantityKindFromLocalnameRequired(
    "TemperatureBasedQuantity"
  ),
  // Nominal Ascent Propellant Mass
  NOMINAL__ASCENT__PROPELLANT__MASS: Qudt.quantityKindFromLocalnameRequired(
    "NOMINAL-ASCENT-PROPELLANT-MASS"
  ),
  // Voltage
  Voltage: Qudt.quantityKindFromLocalnameRequired("Voltage"),
  // pressure-based dynamic viscosity
  PressureBasedDynamicViscosity: Qudt.quantityKindFromLocalnameRequired(
    "PressureBasedDynamicViscosity"
  ),
  // pressure-based velocity
  PressureBasedVelocity: Qudt.quantityKindFromLocalnameRequired(
    "PressureBasedVelocity"
  ),
  // Information Entropy
  InformationEntropy:
    Qudt.quantityKindFromLocalnameRequired("InformationEntropy"),
  // 动量
  Momentum: Qudt.quantityKindFromLocalnameRequired("Momentum"),
  // विद्युत्-क्षेत्र
  ElectricFieldStrength: Qudt.quantityKindFromLocalnameRequired(
    "ElectricFieldStrength"
  ),
  // Correlated Color Temperature
  CorrelatedColorTemperature: Qudt.quantityKindFromLocalnameRequired(
    "CorrelatedColorTemperature"
  ),
  // Complex Power
  ComplexPower: Qudt.quantityKindFromLocalnameRequired("ComplexPower"),
  // Luminance
  Luminance: Qudt.quantityKindFromLocalnameRequired("Luminance"),
  // Volume Thermal Expansion
  VolumeThermalExpansion: Qudt.quantityKindFromLocalnameRequired(
    "VolumeThermalExpansion"
  ),
  // Linear Velocity
  LinearVelocity: Qudt.quantityKindFromLocalnameRequired("LinearVelocity"),
  // Thomson Coefficient
  ThomsonCoefficient:
    Qudt.quantityKindFromLocalnameRequired("ThomsonCoefficient"),
  // Exposure Rate
  ExposureRate: Qudt.quantityKindFromLocalnameRequired("ExposureRate"),
  // Radiance Factor
  RadianceFactor: Qudt.quantityKindFromLocalnameRequired("RadianceFactor"),
  // Emissivity
  Emissivity: Qudt.quantityKindFromLocalnameRequired("Emissivity"),
  // Maximum Expected Operating Pressure
  MaximumExpectedOperatingPressure: Qudt.quantityKindFromLocalnameRequired(
    "MaximumExpectedOperatingPressure"
  ),
  // Resonance Escape Probability
  ResonanceEscapeProbability: Qudt.quantityKindFromLocalnameRequired(
    "ResonanceEscapeProbability"
  ),
  // Visible Radiant Energy
  VisibleRadiantEnergy: Qudt.quantityKindFromLocalnameRequired(
    "VisibleRadiantEnergy"
  ),
  // ciepło
  Heat: Qudt.quantityKindFromLocalnameRequired("Heat"),
  // Vapour Permeability
  VapourPermeability:
    Qudt.quantityKindFromLocalnameRequired("VapourPermeability"),
  // Product of Inertia
  PRODUCT__OF__INERTIA:
    Qudt.quantityKindFromLocalnameRequired("PRODUCT-OF-INERTIA"),
  // Kreisfrequenz
  AngularFrequency: Qudt.quantityKindFromLocalnameRequired("AngularFrequency"),
  // polarizzabilità elettrica
  ElectricPolarizability: Qudt.quantityKindFromLocalnameRequired(
    "ElectricPolarizability"
  ),
  // Average Logarithmic Energy Decrement
  AverageLogarithmicEnergyDecrement: Qudt.quantityKindFromLocalnameRequired(
    "AverageLogarithmicEnergyDecrement"
  ),
  // Fermi Energy
  FermiEnergy: Qudt.quantityKindFromLocalnameRequired("FermiEnergy"),
  // sun protection factor of a product
  SunProtectionFactorOfAProduct: Qudt.quantityKindFromLocalnameRequired(
    "SunProtectionFactorOfAProduct"
  ),
  // RotationalFrequency
  RotationalVelocity:
    Qudt.quantityKindFromLocalnameRequired("RotationalVelocity"),
  // Molar Heat Capacity
  MolarHeatCapacity:
    Qudt.quantityKindFromLocalnameRequired("MolarHeatCapacity"),
  // areic torque
  AreicTorque: Qudt.quantityKindFromLocalnameRequired("AreicTorque"),
  // Length Ratio
  LengthRatio: Qudt.quantityKindFromLocalnameRequired("LengthRatio"),
  // liczba neutronowa
  NeutronNumber: Qudt.quantityKindFromLocalnameRequired("NeutronNumber"),
  // Rankine temperature
  RankineTemperature:
    Qudt.quantityKindFromLocalnameRequired("RankineTemperature"),
  // Surface Density
  SurfaceDensity: Qudt.quantityKindFromLocalnameRequired("SurfaceDensity"),
  // Molar Equivalent
  Equivalent_Molar: Qudt.quantityKindFromLocalnameRequired("Equivalent_Molar"),
  // impulse
  Impulse: Qudt.quantityKindFromLocalnameRequired("Impulse"),
  // Reserve Mass
  RESERVE__MASS: Qudt.quantityKindFromLocalnameRequired("RESERVE-MASS"),
  // Superconductor Energy Gap
  SuperconductorEnergyGap: Qudt.quantityKindFromLocalnameRequired(
    "SuperconductorEnergyGap"
  ),
  // Logarithm of Octanol Water Partition Coefficient
  LogOctanolWaterPartitionCoefficient: Qudt.quantityKindFromLocalnameRequired(
    "LogOctanolWaterPartitionCoefficient"
  ),
  // Moment of Inertia in the Y axis
  MOMENT__OF__INERTIA_Y: Qudt.quantityKindFromLocalnameRequired(
    "MOMENT-OF-INERTIA_Y"
  ),
  // Mass Fraction
  MassFraction: Qudt.quantityKindFromLocalnameRequired("MassFraction"),
  // logarithmic ratio to base e
  LogERatio: Qudt.quantityKindFromLocalnameRequired("LogERatio"),
  // Average Vacuum Thrust
  AverageVacuumThrust: Qudt.quantityKindFromLocalnameRequired(
    "AverageVacuumThrust"
  ),
  // Inverse Time
  InverseTime: Qudt.quantityKindFromLocalnameRequired("InverseTime"),
  // Relative Mass Ratio of Vapour
  RelativeMassRatioOfVapour: Qudt.quantityKindFromLocalnameRequired(
    "RelativeMassRatioOfVapour"
  ),
  // angolo solido
  SolidAngle: Qudt.quantityKindFromLocalnameRequired("SolidAngle"),
  // Sound energy density
  SoundEnergyDensity:
    Qudt.quantityKindFromLocalnameRequired("SoundEnergyDensity"),
  // Luminous Exposure
  LuminousExposure: Qudt.quantityKindFromLocalnameRequired("LuminousExposure"),
  // Magnetic Tension
  MagneticTension: Qudt.quantityKindFromLocalnameRequired("MagneticTension"),
  // Magnetomotive Force
  MagnetomotiveForce:
    Qudt.quantityKindFromLocalnameRequired("MagnetomotiveForce"),
  // Max Operating Thrust
  MaxOperatingThrust:
    Qudt.quantityKindFromLocalnameRequired("MaxOperatingThrust"),
  // Static Friction
  StaticFriction: Qudt.quantityKindFromLocalnameRequired("StaticFriction"),
  // Inverse amount of substance
  InverseAmountOfSubstance: Qudt.quantityKindFromLocalnameRequired(
    "InverseAmountOfSubstance"
  ),
  // information content
  InformationContent:
    Qudt.quantityKindFromLocalnameRequired("InformationContent"),
  // pressure-based molality
  PressureBasedMolality: Qudt.quantityKindFromLocalnameRequired(
    "PressureBasedMolality"
  ),
  // Relative Mass Defect
  RelativeMassDefect:
    Qudt.quantityKindFromLocalnameRequired("RelativeMassDefect"),
  // Tension
  Tension: Qudt.quantityKindFromLocalnameRequired("Tension"),
  // Modulus of Linear Subgrade Reaction
  ModulusOfLinearSubgradeReaction: Qudt.quantityKindFromLocalnameRequired(
    "ModulusOfLinearSubgradeReaction"
  ),
  // Thermodynamic Critical Magnetic Flux Density
  ThermodynamicCriticalMagneticFluxDensity:
    Qudt.quantityKindFromLocalnameRequired(
      "ThermodynamicCriticalMagneticFluxDensity"
    ),
  // Diffusion Length
  DiffusionLength: Qudt.quantityKindFromLocalnameRequired("DiffusionLength"),
  // Fission Multiplication Factor
  FissionMultiplicationFactor: Qudt.quantityKindFromLocalnameRequired(
    "FissionMultiplicationFactor"
  ),
  // mechanical tension
  MechanicalTension:
    Qudt.quantityKindFromLocalnameRequired("MechanicalTension"),
  // Head End Pressure
  HeadEndPressure: Qudt.quantityKindFromLocalnameRequired("HeadEndPressure"),
  // Thermodynamic Entropy
  ThermodynamicEntropy: Qudt.quantityKindFromLocalnameRequired(
    "ThermodynamicEntropy"
  ),
  // Reluctance
  Reluctance: Qudt.quantityKindFromLocalnameRequired("Reluctance"),
  // اختلاف طور
  PhaseDifference: Qudt.quantityKindFromLocalnameRequired("PhaseDifference"),
  // Quartic Electric Dipole Moment per Cubic Energy
  ElectricDipoleMoment_QuarticPerEnergy_Cubic:
    Qudt.quantityKindFromLocalnameRequired(
      "ElectricDipoleMoment_QuarticPerEnergy_Cubic"
    ),
  // Area Time Temperature
  AreaTimeTemperature: Qudt.quantityKindFromLocalnameRequired(
    "AreaTimeTemperature"
  ),
  // Viscosity
  Viscosity: Qudt.quantityKindFromLocalnameRequired("Viscosity"),
  // Molar Absorption Coefficient
  MolarAbsorptionCoefficient: Qudt.quantityKindFromLocalnameRequired(
    "MolarAbsorptionCoefficient"
  ),
  // Burn Time
  BurnTime: Qudt.quantityKindFromLocalnameRequired("BurnTime"),
  // Gustatory Threshold
  GustatoryThreshold:
    Qudt.quantityKindFromLocalnameRequired("GustatoryThreshold"),
  // neutral ratio
  NeutralRatio: Qudt.quantityKindFromLocalnameRequired("NeutralRatio"),
  // Electric Charge Linear Density
  ElectricChargeLinearDensity: Qudt.quantityKindFromLocalnameRequired(
    "ElectricChargeLinearDensity"
  ),
  // median information flow (from a source of information), expressed as a natural logarithm
  LogarithmicMedianInformationFlow_SourceToBaseE:
    Qudt.quantityKindFromLocalnameRequired(
      "LogarithmicMedianInformationFlow_SourceToBaseE"
    ),
  // volumic electric charge
  VolumetricElectricCharge: Qudt.quantityKindFromLocalnameRequired(
    "VolumetricElectricCharge"
  ),
  // Micro Canonical Partition Function
  MicroCanonicalPartitionFunction: Qudt.quantityKindFromLocalnameRequired(
    "MicroCanonicalPartitionFunction"
  ),
  // intervalo logarítmico de frequência
  LogarithmicFrequencyInterval: Qudt.quantityKindFromLocalnameRequired(
    "LogarithmicFrequencyInterval"
  ),
  // characteristic number
  CharacteristicNumber: Qudt.quantityKindFromLocalnameRequired(
    "CharacteristicNumber"
  ),
  // picture element
  PictureElement: Qudt.quantityKindFromLocalnameRequired("PictureElement"),
  // Friction Coefficient
  FrictionCoefficient: Qudt.quantityKindFromLocalnameRequired(
    "FrictionCoefficient"
  ),
  // surface‑related volume flow rate
  VolumeFlowRate_SurfaceRelated: Qudt.quantityKindFromLocalnameRequired(
    "VolumeFlowRate_SurfaceRelated"
  ),
  // Cartesian Area
  CartesianArea: Qudt.quantityKindFromLocalnameRequired("CartesianArea"),
  // Conductance
  Conductance: Qudt.quantityKindFromLocalnameRequired("Conductance"),
  // puissance
  Power: Qudt.quantityKindFromLocalnameRequired("Power"),
  // energia libera di Gibbs
  GibbsEnergy: Qudt.quantityKindFromLocalnameRequired("GibbsEnergy"),
  // Mass Ratio
  MassRatio: Qudt.quantityKindFromLocalnameRequired("MassRatio"),
  // Dew Point Temperature
  DewPointTemperature: Qudt.quantityKindFromLocalnameRequired(
    "DewPointTemperature"
  ),
  // Spectral Luminous Efficiency
  SpectralLuminousEfficiency: Qudt.quantityKindFromLocalnameRequired(
    "SpectralLuminousEfficiency"
  ),
  // Lorenz Coefficient
  LorenzCoefficient:
    Qudt.quantityKindFromLocalnameRequired("LorenzCoefficient"),
  // Thrust Coefficient
  ThrustCoefficient:
    Qudt.quantityKindFromLocalnameRequired("ThrustCoefficient"),
  // Inverse Square Mass
  InverseMass_Squared: Qudt.quantityKindFromLocalnameRequired(
    "InverseMass_Squared"
  ),
  // Compressibility Factor
  CompressibilityFactor: Qudt.quantityKindFromLocalnameRequired(
    "CompressibilityFactor"
  ),
  // areic bit density
  AreaBitDensity: Qudt.quantityKindFromLocalnameRequired("AreaBitDensity"),
  // Duty Cycle
  DutyCycle: Qudt.quantityKindFromLocalnameRequired("DutyCycle"),
  // Specific Heat Volume
  SpecificHeatVolume:
    Qudt.quantityKindFromLocalnameRequired("SpecificHeatVolume"),
  // Volume per Unit Area
  VolumePerArea: Qudt.quantityKindFromLocalnameRequired("VolumePerArea"),
  // Specific Heats Ratio
  SpecificHeatsRatio:
    Qudt.quantityKindFromLocalnameRequired("SpecificHeatsRatio"),
  // Ventilation Rate per Floor Area
  VentilationRatePerFloorArea: Qudt.quantityKindFromLocalnameRequired(
    "VentilationRatePerFloorArea"
  ),
  // pressure in relation to volume flow
  PressureInRelationToVolumeFlow: Qudt.quantityKindFromLocalnameRequired(
    "PressureInRelationToVolumeFlow"
  ),
  // Anschaffungskosten pro Watt
  CostPerPower: Qudt.quantityKindFromLocalnameRequired("CostPerPower"),
  // lineic power
  LineicPower: Qudt.quantityKindFromLocalnameRequired("LineicPower"),
  // temperature-based mass
  TemperatureBasedMass: Qudt.quantityKindFromLocalnameRequired(
    "TemperatureBasedMass"
  ),
  // Înălțime
  Height: Qudt.quantityKindFromLocalnameRequired("Height"),
  // Reaction Rate Constant
  SecondOrderReactionRateConstant: Qudt.quantityKindFromLocalnameRequired(
    "SecondOrderReactionRateConstant"
  ),
  // Current Linkage
  CurrentLinkage: Qudt.quantityKindFromLocalnameRequired("CurrentLinkage"),
  // masa molar
  MolarMass: Qudt.quantityKindFromLocalnameRequired("MolarMass"),
  // Radial Distance
  RadialDistance: Qudt.quantityKindFromLocalnameRequired("RadialDistance"),
  // volumic bit density
  VolumetricBitDensity: Qudt.quantityKindFromLocalnameRequired(
    "VolumetricBitDensity"
  ),
  // Chemical Consumption per Mass
  ChemicalConsumptionPerMass: Qudt.quantityKindFromLocalnameRequired(
    "ChemicalConsumptionPerMass"
  ),
  // Dynamic Pressure
  DynamicPressure: Qudt.quantityKindFromLocalnameRequired("DynamicPressure"),
  // induktivitás
  Inductance: Qudt.quantityKindFromLocalnameRequired("Inductance"),
  // areic charge density or electric flux density or electric polarization
  AreicChargeDensityOrElectricFluxDensityOrElectricPolarization:
    Qudt.quantityKindFromLocalnameRequired(
      "AreicChargeDensityOrElectricFluxDensityOrElectricPolarization"
    ),
  // Average Specific Impulse
  AverageSpecificImpulse: Qudt.quantityKindFromLocalnameRequired(
    "AverageSpecificImpulse"
  ),
  // Exhaust Gas Mean Molecular Weight
  ExhaustGasMeanMolecularWeight: Qudt.quantityKindFromLocalnameRequired(
    "ExhaustGasMeanMolecularWeight"
  ),
  // Electric Current per Angle
  ElectricCurrentPerAngle: Qudt.quantityKindFromLocalnameRequired(
    "ElectricCurrentPerAngle"
  ),
  // Square Energy
  SquareEnergy: Qudt.quantityKindFromLocalnameRequired("SquareEnergy"),
  // Atmospheric Hydroxylation Rate
  AtmosphericHydroxylationRate: Qudt.quantityKindFromLocalnameRequired(
    "AtmosphericHydroxylationRate"
  ),
  // 直径
  Diameter: Qudt.quantityKindFromLocalnameRequired("Diameter"),
  // éclairement énergétique
  Irradiance: Qudt.quantityKindFromLocalnameRequired("Irradiance"),
  // temperature-based dynamic viscosity
  TemperatureBasedDynamicViscosity: Qudt.quantityKindFromLocalnameRequired(
    "TemperatureBasedDynamicViscosity"
  ),
  // lineic resistance
  LineicResistance: Qudt.quantityKindFromLocalnameRequired("LineicResistance"),
  // Coercivity
  Coercivity: Qudt.quantityKindFromLocalnameRequired("Coercivity"),
  // Landau-Ginzburg Number
  Landau__GinzburgNumber: Qudt.quantityKindFromLocalnameRequired(
    "Landau-GinzburgNumber"
  ),
  // Magnetic Field
  MagneticField: Qudt.quantityKindFromLocalnameRequired("MagneticField"),
  // numero di massa
  NucleonNumber: Qudt.quantityKindFromLocalnameRequired("NucleonNumber"),
  // Second Stage Mass Ratio
  SecondStageMassRatio: Qudt.quantityKindFromLocalnameRequired(
    "SecondStageMassRatio"
  ),
  // Attenuation Coefficient
  AttenuationCoefficient: Qudt.quantityKindFromLocalnameRequired(
    "AttenuationCoefficient"
  ),
  // Angular Cross-section
  AngularCrossSection: Qudt.quantityKindFromLocalnameRequired(
    "AngularCrossSection"
  ),
  // Specific Energy Imparted
  SpecificEnergyImparted: Qudt.quantityKindFromLocalnameRequired(
    "SpecificEnergyImparted"
  ),
  // Phase speed of sound
  PhaseSpeedOfSound:
    Qudt.quantityKindFromLocalnameRequired("PhaseSpeedOfSound"),
  // Fish Biotransformation Half Life
  FishBiotransformationHalfLife: Qudt.quantityKindFromLocalnameRequired(
    "FishBiotransformationHalfLife"
  ),
  // kinetic or thermal energy
  KineticOrThermalEnergy: Qudt.quantityKindFromLocalnameRequired(
    "KineticOrThermalEnergy"
  ),
  // Volume per Time
  VolumePerTime: Qudt.quantityKindFromLocalnameRequired("VolumePerTime"),
  // Magnetic Polarization
  MagneticPolarization: Qudt.quantityKindFromLocalnameRequired(
    "MagneticPolarization"
  ),
  // electrical resistance
  ElectricalResistance: Qudt.quantityKindFromLocalnameRequired(
    "ElectricalResistance"
  ),
  // Quartic Electric Dipole Moment per Cubic Energy
  QuarticElectricDipoleMomentPerCubicEnergy:
    Qudt.quantityKindFromLocalnameRequired(
      "QuarticElectricDipoleMomentPerCubicEnergy"
    ),
  // Charge Number
  ChargeNumber: Qudt.quantityKindFromLocalnameRequired("ChargeNumber"),
  // אורך
  Length: Qudt.quantityKindFromLocalnameRequired("Length"),
  // Grand Canonical Partition Function
  GrandCanonicalPartitionFunction: Qudt.quantityKindFromLocalnameRequired(
    "GrandCanonicalPartitionFunction"
  ),
  // pressure-based quantity
  PressureBasedQuantity: Qudt.quantityKindFromLocalnameRequired(
    "PressureBasedQuantity"
  ),
  // Warm Receptor Threshold
  WarmReceptorThreshold: Qudt.quantityKindFromLocalnameRequired(
    "WarmReceptorThreshold"
  ),
  // Flächenlast
  PlanarForce: Qudt.quantityKindFromLocalnameRequired("PlanarForce"),
  // Angular Distance
  AngularDistance: Qudt.quantityKindFromLocalnameRequired("AngularDistance"),
  // número de onda angular
  AngularWavenumber:
    Qudt.quantityKindFromLocalnameRequired("AngularWavenumber"),
  // Relative Humidity
  RelativeHumidity: Qudt.quantityKindFromLocalnameRequired("RelativeHumidity"),
  // Sound intensity
  SoundIntensity: Qudt.quantityKindFromLocalnameRequired("SoundIntensity"),
  // Half-Value Thickness
  Half__ValueThickness: Qudt.quantityKindFromLocalnameRequired(
    "Half-ValueThickness"
  ),
  // Specific Impulse by Mass
  SpecificImpulseByMass: Qudt.quantityKindFromLocalnameRequired(
    "SpecificImpulseByMass"
  ),
  // Over-range distance
  OverRangeDistance:
    Qudt.quantityKindFromLocalnameRequired("OverRangeDistance"),
  // Turbidity
  Turbidity: Qudt.quantityKindFromLocalnameRequired("Turbidity"),
  // Gyromagnetic Ratio
  GyromagneticRatio:
    Qudt.quantityKindFromLocalnameRequired("GyromagneticRatio"),
  // Linear Strain
  LinearStrain: Qudt.quantityKindFromLocalnameRequired("LinearStrain"),
  // Osmotic Concentration
  OsmoticConcentration: Qudt.quantityKindFromLocalnameRequired(
    "OsmoticConcentration"
  ),
  // Phase coefficient
  PhaseCoefficient: Qudt.quantityKindFromLocalnameRequired("PhaseCoefficient"),
  // data transmission rate
  DataTransmissionRate: Qudt.quantityKindFromLocalnameRequired(
    "DataTransmissionRate"
  ),
  // Molar Flow Rate
  MolarFlowRate: Qudt.quantityKindFromLocalnameRequired("MolarFlowRate"),
  // pressure-based length
  PressureBasedLength: Qudt.quantityKindFromLocalnameRequired(
    "PressureBasedLength"
  ),
  // Power per Area Angle
  PowerPerAreaAngle:
    Qudt.quantityKindFromLocalnameRequired("PowerPerAreaAngle"),
  // Sound exposure
  SoundExposure: Qudt.quantityKindFromLocalnameRequired("SoundExposure"),
  // polarização eléctrica
  ElectricPolarization: Qudt.quantityKindFromLocalnameRequired(
    "ElectricPolarization"
  ),
  // Inverse Energy
  InverseEnergy: Qudt.quantityKindFromLocalnameRequired("InverseEnergy"),
  // reciprocal voltage
  ReciprocalVoltage:
    Qudt.quantityKindFromLocalnameRequired("ReciprocalVoltage"),
  // information content expressed as a logarithm to base 10
  InformationContentExpressedAsALogarithmToBase10:
    Qudt.quantityKindFromLocalnameRequired(
      "InformationContentExpressedAsALogarithmToBase10"
    ),
  // True Exhaust Velocity
  TrueExhaustVelocity: Qudt.quantityKindFromLocalnameRequired(
    "TrueExhaustVelocity"
  ),
  // battery capacity
  BatteryCapacity: Qudt.quantityKindFromLocalnameRequired("BatteryCapacity"),
  // Photo Threshold of Awareness Function
  PhotoThresholdOfAwarenessFunction: Qudt.quantityKindFromLocalnameRequired(
    "PhotoThresholdOfAwarenessFunction"
  ),
  // Quality Factor
  QualityFactor: Qudt.quantityKindFromLocalnameRequired("QualityFactor"),
  // Exhaust Stream Power
  ExhaustStreamPower:
    Qudt.quantityKindFromLocalnameRequired("ExhaustStreamPower"),
  // قدرة إشعاعية
  RadiantFlux: Qudt.quantityKindFromLocalnameRequired("RadiantFlux"),
  // Mass Specific Biogeochemical Rate
  MassSpecificBiogeochemicalRate: Qudt.quantityKindFromLocalnameRequired(
    "MassSpecificBiogeochemicalRate"
  ),
  // Time averaged sound intensity
  TimeAveragedSoundIntensity: Qudt.quantityKindFromLocalnameRequired(
    "TimeAveragedSoundIntensity"
  ),
  // Luminous Flux Ratio
  LuminousFluxRatio:
    Qudt.quantityKindFromLocalnameRequired("LuminousFluxRatio"),
  // radiant energy exposure
  RadiantEnergyExposure: Qudt.quantityKindFromLocalnameRequired(
    "RadiantEnergyExposure"
  ),
  // 压强、压力
  Pressure: Qudt.quantityKindFromLocalnameRequired("Pressure"),
  // Specific Heat Pressure
  SpecificHeatPressure: Qudt.quantityKindFromLocalnameRequired(
    "SpecificHeatPressure"
  ),
  // Moment of Force
  MomentOfForce: Qudt.quantityKindFromLocalnameRequired("MomentOfForce"),
  // logarithmic frequency interval to base 10
  LogarithmicFrequencyIntervalToBase10: Qudt.quantityKindFromLocalnameRequired(
    "LogarithmicFrequencyIntervalToBase10"
  ),
  // Nozzle Throat Pressure
  NozzleThroatPressure: Qudt.quantityKindFromLocalnameRequired(
    "NozzleThroatPressure"
  ),
  // Particle Number Density
  ParticleNumberDensity: Qudt.quantityKindFromLocalnameRequired(
    "ParticleNumberDensity"
  ),
  // lineic mass
  LineicMass: Qudt.quantityKindFromLocalnameRequired("LineicMass"),
  // Length Temperature Time
  LengthTemperatureTime: Qudt.quantityKindFromLocalnameRequired(
    "LengthTemperatureTime"
  ),
  // Structure Factor
  StructureFactor: Qudt.quantityKindFromLocalnameRequired("StructureFactor"),
  // Power Area
  PowerArea: Qudt.quantityKindFromLocalnameRequired("PowerArea"),
  // Inverse Square Energy
  InverseSquareEnergy: Qudt.quantityKindFromLocalnameRequired(
    "InverseSquareEnergy"
  ),
  // Activity Coefficient
  ActivityCoefficient: Qudt.quantityKindFromLocalnameRequired(
    "ActivityCoefficient"
  ),
  // Specific Optical Rotatory Power
  SpecificOpticalRotatoryPower: Qudt.quantityKindFromLocalnameRequired(
    "SpecificOpticalRotatoryPower"
  ),
  // byte transmission rate
  ByteTransmissionRate: Qudt.quantityKindFromLocalnameRequired(
    "ByteTransmissionRate"
  ),
  // volume
  CartesianVolume: Qudt.quantityKindFromLocalnameRequired("CartesianVolume"),
  // Luminous Efficacy
  LuminousEfficacy: Qudt.quantityKindFromLocalnameRequired("LuminousEfficacy"),
  // factor de potencia
  PowerFactor: Qudt.quantityKindFromLocalnameRequired("PowerFactor"),
  // imaginary part of complex frequency
  ComplexFrequency_Imaginary: Qudt.quantityKindFromLocalnameRequired(
    "ComplexFrequency_Imaginary"
  ),
  // larghezza
  Breadth: Qudt.quantityKindFromLocalnameRequired("Breadth"),
  // Nuclear Quadrupole Moment
  NuclearQuadrupoleMoment: Qudt.quantityKindFromLocalnameRequired(
    "NuclearQuadrupoleMoment"
  ),
  // Warping Moment
  WarpingMoment: Qudt.quantityKindFromLocalnameRequired("WarpingMoment"),
  // Molar Flux Density Variance, NEON
  MolarFluxDensityVariance_NEON: Qudt.quantityKindFromLocalnameRequired(
    "MolarFluxDensityVariance_NEON"
  ),
  // Equilibrium Constant
  EquilibriumConstant: Qudt.quantityKindFromLocalnameRequired(
    "EquilibriumConstant"
  ),
  // pressure-based kinematic viscosity
  PressureBasedKinematicViscosity: Qudt.quantityKindFromLocalnameRequired(
    "PressureBasedKinematicViscosity"
  ),
  // jakost magnetnega polja
  MagneticFieldStrength_H: Qudt.quantityKindFromLocalnameRequired(
    "MagneticFieldStrength_H"
  ),
  // Diffusionskoeffizient
  NeutronDiffusionCoefficient: Qudt.quantityKindFromLocalnameRequired(
    "NeutronDiffusionCoefficient"
  ),
  // volumic data quantity
  VolumicDataQuantity: Qudt.quantityKindFromLocalnameRequired(
    "VolumicDataQuantity"
  ),
  // Upper Critical Magnetic Flux Density
  UpperCriticalMagneticFluxDensity: Qudt.quantityKindFromLocalnameRequired(
    "UpperCriticalMagneticFluxDensity"
  ),
  // Debye Temperature
  DebyeTemperature: Qudt.quantityKindFromLocalnameRequired("DebyeTemperature"),
  // Flash Point Temperature
  FlashPoint: Qudt.quantityKindFromLocalnameRequired("FlashPoint"),
  // Electric charge per amount of substance
  ElectricChargePerAmountOfSubstance: Qudt.quantityKindFromLocalnameRequired(
    "ElectricChargePerAmountOfSubstance"
  ),
  // massic heat capacity
  MassicHeatCapacity:
    Qudt.quantityKindFromLocalnameRequired("MassicHeatCapacity"),
  // Video Frame Rate
  VideoFrameRate: Qudt.quantityKindFromLocalnameRequired("VideoFrameRate"),
  // Currency Per Flight
  CurrencyPerFlight:
    Qudt.quantityKindFromLocalnameRequired("CurrencyPerFlight"),
  // Mechanical surface impedance
  MechanicalSurfaceImpedance: Qudt.quantityKindFromLocalnameRequired(
    "MechanicalSurfaceImpedance"
  ),
  // Biodegredation Half Life
  BiodegredationHalfLife: Qudt.quantityKindFromLocalnameRequired(
    "BiodegredationHalfLife"
  ),
  // volumic amount of substance
  VolumicAmountOfSubstance: Qudt.quantityKindFromLocalnameRequired(
    "VolumicAmountOfSubstance"
  ),
  // ładunek elektryczny
  ElectricCharge: Qudt.quantityKindFromLocalnameRequired("ElectricCharge"),
  // Positive Dimensionless Ratio
  PositiveDimensionlessRatio: Qudt.quantityKindFromLocalnameRequired(
    "PositiveDimensionlessRatio"
  ),
  // 利得
  SoundPressureLevel:
    Qudt.quantityKindFromLocalnameRequired("SoundPressureLevel"),
  // Time per Count
  TimePerCount: Qudt.quantityKindFromLocalnameRequired("TimePerCount"),
  // Mass Of Electrical Power Supply
  MassOfElectricalPowerSupply: Qudt.quantityKindFromLocalnameRequired(
    "MassOfElectricalPowerSupply"
  ),
  // Electric Displacement
  ElectricDisplacement: Qudt.quantityKindFromLocalnameRequired(
    "ElectricDisplacement"
  ),
  // motor constant
  MotorConstant: Qudt.quantityKindFromLocalnameRequired("MotorConstant"),
  // bandwidth distance product
  BandwidthDistanceProduct: Qudt.quantityKindFromLocalnameRequired(
    "BandwidthDistanceProduct"
  ),
  // Compressibility
  Compressibility: Qudt.quantityKindFromLocalnameRequired("Compressibility"),
  // bit rate
  BitRate: Qudt.quantityKindFromLocalnameRequired("BitRate"),
  // Wirkleistung
  ElectricPower: Qudt.quantityKindFromLocalnameRequired("ElectricPower"),
  // information content expressed as a logarithm to base 2
  InformationContentExpressedAsALogarithmToBase2:
    Qudt.quantityKindFromLocalnameRequired(
      "InformationContentExpressedAsALogarithmToBase2"
    ),
  // Permittivity
  Permittivity: Qudt.quantityKindFromLocalnameRequired("Permittivity"),
  // Photon Radiance
  PhotonRadiance: Qudt.quantityKindFromLocalnameRequired("PhotonRadiance"),
  // Mass Ratio of Water Vapour to Dry Gas
  MassRatioOfWaterVapourToDryGas: Qudt.quantityKindFromLocalnameRequired(
    "MassRatioOfWaterVapourToDryGas"
  ),
  // Data Rate
  DataRate: Qudt.quantityKindFromLocalnameRequired("DataRate"),
  // Degree of Dissociation
  DegreeOfDissociation: Qudt.quantityKindFromLocalnameRequired(
    "DegreeOfDissociation"
  ),
  // Acceptor Density
  AcceptorDensity: Qudt.quantityKindFromLocalnameRequired("AcceptorDensity"),
  // reciprocal plane angle
  ReciprocalPlaneAngle: Qudt.quantityKindFromLocalnameRequired(
    "ReciprocalPlaneAngle"
  ),
  // Equilibrium Position Vector of Ion
  EquilibriumPositionVectorOfIon: Qudt.quantityKindFromLocalnameRequired(
    "EquilibriumPositionVectorOfIon"
  ),
  // Inverse Permittivity
  InversePermittivity: Qudt.quantityKindFromLocalnameRequired(
    "InversePermittivity"
  ),
  // resistance-based inductance
  ResistanceBasedInductance: Qudt.quantityKindFromLocalnameRequired(
    "ResistanceBasedInductance"
  ),
  // Distance Traveled During a Burn
  DistanceTraveledDuringBurn: Qudt.quantityKindFromLocalnameRequired(
    "DistanceTraveledDuringBurn"
  ),
  // Amount of Substance per Mass
  AmountOfSubstancePerMass: Qudt.quantityKindFromLocalnameRequired(
    "AmountOfSubstancePerMass"
  ),
  // Intinsic Carrier Density
  IntinsicCarrierDensity: Qudt.quantityKindFromLocalnameRequired(
    "IntinsicCarrierDensity"
  ),
  // Thermal Energy
  ThermalEnergy: Qudt.quantityKindFromLocalnameRequired("ThermalEnergy"),
  // Area Thermal Expansion
  AreaThermalExpansion: Qudt.quantityKindFromLocalnameRequired(
    "AreaThermalExpansion"
  ),
  // Flight Path Angle
  FlightPathAngle: Qudt.quantityKindFromLocalnameRequired("FlightPathAngle"),
  // Linear Force
  LinearStiffness: Qudt.quantityKindFromLocalnameRequired("LinearStiffness"),
  // Particle Fluence
  ParticleFluence: Qudt.quantityKindFromLocalnameRequired("ParticleFluence"),
  // Thermal Expansion Coefficient
  ThermalExpansionCoefficient: Qudt.quantityKindFromLocalnameRequired(
    "ThermalExpansionCoefficient"
  ),
  // Thermal Insulance
  ThermalInsulance: Qudt.quantityKindFromLocalnameRequired("ThermalInsulance"),
  // Absorptance
  Absorptance: Qudt.quantityKindFromLocalnameRequired("Absorptance"),
  // Temperature Variance
  TemperatureVariance: Qudt.quantityKindFromLocalnameRequired(
    "TemperatureVariance"
  ),
  // masa
  Mass: Qudt.quantityKindFromLocalnameRequired("Mass"),
  // Time Temperature
  TimeTemperature: Qudt.quantityKindFromLocalnameRequired("TimeTemperature"),
  // InternalConversionFactor
  InternalConversionFactor: Qudt.quantityKindFromLocalnameRequired(
    "InternalConversionFactor"
  ),
  // Earth Closest Approach Vehicle Velocity
  EarthClosestApproachVehicleVelocity: Qudt.quantityKindFromLocalnameRequired(
    "EarthClosestApproachVehicleVelocity"
  ),
  // lineic charge
  LineicCharge: Qudt.quantityKindFromLocalnameRequired("LineicCharge"),
  // Dissipance
  Dissipance: Qudt.quantityKindFromLocalnameRequired("Dissipance"),
  // Coherence Length
  CoherenceLength: Qudt.quantityKindFromLocalnameRequired("CoherenceLength"),
  // state density
  StateDensity: Qudt.quantityKindFromLocalnameRequired("StateDensity"),
  // Temperature Variance, NEON
  TemperatureVariance_NEON: Qudt.quantityKindFromLocalnameRequired(
    "TemperatureVariance_NEON"
  ),
  // Molar Attenuation Coefficient
  MolarAttenuationCoefficient: Qudt.quantityKindFromLocalnameRequired(
    "MolarAttenuationCoefficient"
  ),
  // unbalance
  Unbalance: Qudt.quantityKindFromLocalnameRequired("Unbalance"),
  // Mean Mass Range
  MeanMassRange: Qudt.quantityKindFromLocalnameRequired("MeanMassRange"),
  // звуковая мощность
  SoundPower: Qudt.quantityKindFromLocalnameRequired("SoundPower"),
  // Liquid Volume
  LiquidVolume: Qudt.quantityKindFromLocalnameRequired("LiquidVolume"),
  // temperature-based length
  TemperatureBasedLength: Qudt.quantityKindFromLocalnameRequired(
    "TemperatureBasedLength"
  ),
  // Effective Multiplication Factor
  EffectiveMultiplicationFactor: Qudt.quantityKindFromLocalnameRequired(
    "EffectiveMultiplicationFactor"
  ),
  // Linear Electric Current
  LinearElectricCurrent: Qudt.quantityKindFromLocalnameRequired(
    "LinearElectricCurrent"
  ),
  // Polarization Field
  PolarizationField:
    Qudt.quantityKindFromLocalnameRequired("PolarizationField"),
  // pressure in relation to volume flow rate
  PressureInRelationToVolumeFlowRate: Qudt.quantityKindFromLocalnameRequired(
    "PressureInRelationToVolumeFlowRate"
  ),
  // Power Area per Solid Angle
  PowerAreaPerSolidAngle: Qudt.quantityKindFromLocalnameRequired(
    "PowerAreaPerSolidAngle"
  ),
  // Einstein transition probability for spontaneous or induced emission and absorption
  EinsteinTransitionProbabilityForSpontaneousOrInducedEmissionAndAbsorption:
    Qudt.quantityKindFromLocalnameRequired(
      "EinsteinTransitionProbabilityForSpontaneousOrInducedEmissionAndAbsorption"
    ),
  // Specific Modulus
  SpecificModulus: Qudt.quantityKindFromLocalnameRequired("SpecificModulus"),
  // Auxillary Magnetic Field
  AuxillaryMagneticField: Qudt.quantityKindFromLocalnameRequired(
    "AuxillaryMagneticField"
  ),
  // Total Linear Stopping Power
  TotalLinearStoppingPower: Qudt.quantityKindFromLocalnameRequired(
    "TotalLinearStoppingPower"
  ),
  // molar internal energy
  MolarInternalEnergy: Qudt.quantityKindFromLocalnameRequired(
    "MolarInternalEnergy"
  ),
  // Volume Flow Ratio
  VolumeFlowRatio: Qudt.quantityKindFromLocalnameRequired("VolumeFlowRatio"),
  // rise of off-state voltage
  RiseOfOffStateVoltage: Qudt.quantityKindFromLocalnameRequired(
    "RiseOfOffStateVoltage"
  ),
  // impulso angolare
  AngularImpulse: Qudt.quantityKindFromLocalnameRequired("AngularImpulse"),
  // potencial químico
  ChemicalPotential:
    Qudt.quantityKindFromLocalnameRequired("ChemicalPotential"),
  // pressure-based mass
  PressureBasedMass:
    Qudt.quantityKindFromLocalnameRequired("PressureBasedMass"),
  // Propagation coefficient
  PropagationCoefficient: Qudt.quantityKindFromLocalnameRequired(
    "PropagationCoefficient"
  ),
  // Heat Capacity Ratio
  HeatCapacityRatio:
    Qudt.quantityKindFromLocalnameRequired("HeatCapacityRatio"),
  // pressure-based temperature
  PressureBasedTemperature: Qudt.quantityKindFromLocalnameRequired(
    "PressureBasedTemperature"
  ),
  // thermal insulation
  ThermalInsulation:
    Qudt.quantityKindFromLocalnameRequired("ThermalInsulation"),
  // Catalytic Activity
  CatalyticActivity:
    Qudt.quantityKindFromLocalnameRequired("CatalyticActivity"),
  // Neel Temperature
  NeelTemperature: Qudt.quantityKindFromLocalnameRequired("NeelTemperature"),
  // median information flow (from a source of information), expressed as a natural logarithm
  NaturalLogarithmicMedianInformationFlow:
    Qudt.quantityKindFromLocalnameRequired(
      "NaturalLogarithmicMedianInformationFlow"
    ),
  // Tenaga keupayaan
  PotentialEnergy: Qudt.quantityKindFromLocalnameRequired("PotentialEnergy"),
  // Sound volume velocity
  SoundVolumeVelocity: Qudt.quantityKindFromLocalnameRequired(
    "SoundVolumeVelocity"
  ),
  // transmission ratio between rotation and translation
  TransmissionRatioBetweenRotationAndTranslation:
    Qudt.quantityKindFromLocalnameRequired(
      "TransmissionRatioBetweenRotationAndTranslation"
    ),
  // Inverse Magnetic Flux
  InverseMagneticFlux: Qudt.quantityKindFromLocalnameRequired(
    "InverseMagneticFlux"
  ),
  // Ion Current
  IonCurrent: Qudt.quantityKindFromLocalnameRequired("IonCurrent"),
  // Thermal Utilization Factor
  ThermalUtilizationFactor: Qudt.quantityKindFromLocalnameRequired(
    "ThermalUtilizationFactor"
  ),
  // Inductance based time constant
  InductanceBasedTimeConstant: Qudt.quantityKindFromLocalnameRequired(
    "InductanceBasedTimeConstant"
  ),
  // Delta-V
  DELTA__V: Qudt.quantityKindFromLocalnameRequired("DELTA-V"),
  // time constant (inductance based)
  TimeConstant_Inductance: Qudt.quantityKindFromLocalnameRequired(
    "TimeConstant_Inductance"
  ),
  // absolute typographic measurement
  AbsoluteTypographicMeasurement: Qudt.quantityKindFromLocalnameRequired(
    "AbsoluteTypographicMeasurement"
  ),
  // Fläche pro Heizlast
  AreaPerPower: Qudt.quantityKindFromLocalnameRequired("AreaPerPower"),
  // Spin Quantum Number
  NuclearSpinQuantumNumber: Qudt.quantityKindFromLocalnameRequired(
    "NuclearSpinQuantumNumber"
  ),
  // Cross-section
  CrossSection: Qudt.quantityKindFromLocalnameRequired("CrossSection"),
  // Molar Energy
  MolarEnergy: Qudt.quantityKindFromLocalnameRequired("MolarEnergy"),
  // Ionic Strength
  IonicStrength: Qudt.quantityKindFromLocalnameRequired("IonicStrength"),
  // Density of states
  DensityOfStates: Qudt.quantityKindFromLocalnameRequired("DensityOfStates"),
  // Absorbed Dose
  AbsorbedDose: Qudt.quantityKindFromLocalnameRequired("AbsorbedDose"),
  // Amount of Substance of Concentration
  AmountOfSubstanceConcentration: Qudt.quantityKindFromLocalnameRequired(
    "AmountOfSubstanceConcentration"
  ),
  // Decay Constant
  DecayConstant: Qudt.quantityKindFromLocalnameRequired("DecayConstant"),
  // Nuclear Radius
  NuclearRadius: Qudt.quantityKindFromLocalnameRequired("NuclearRadius"),
  // logarithm ratio to base e
  LogarithmRatioToBaseE: Qudt.quantityKindFromLocalnameRequired(
    "LogarithmRatioToBaseE"
  ),
  // state density as expression of angular frequency)
  StateDensityAsExpressionOfAngularFrequency:
    Qudt.quantityKindFromLocalnameRequired(
      "StateDensityAsExpressionOfAngularFrequency"
    ),
  // Thermal Diffusion Ratio
  ThermalDiffusionRatio: Qudt.quantityKindFromLocalnameRequired(
    "ThermalDiffusionRatio"
  ),
  // Buckling Factor
  BucklingFactor: Qudt.quantityKindFromLocalnameRequired("BucklingFactor"),
  // Magnetic Quantum Number
  MagneticQuantumNumber: Qudt.quantityKindFromLocalnameRequired(
    "MagneticQuantumNumber"
  ),
  // Sound reduction index
  SoundReductionIndex: Qudt.quantityKindFromLocalnameRequired(
    "SoundReductionIndex"
  ),
  // Incidence Rate
  IncidenceRate: Qudt.quantityKindFromLocalnameRequired("IncidenceRate"),
  // Shear Modulus
  ShearModulus: Qudt.quantityKindFromLocalnameRequired("ShearModulus"),
  // Napierian Absorbance
  NapierianAbsorbance: Qudt.quantityKindFromLocalnameRequired(
    "NapierianAbsorbance"
  ),
  // temperature-based volume flow rate
  TemperatureBasedVolumeFlowRate: Qudt.quantityKindFromLocalnameRequired(
    "TemperatureBasedVolumeFlowRate"
  ),
  // Reactivity
  Reactivity: Qudt.quantityKindFromLocalnameRequired("Reactivity"),
  // Electrical Power To Mass Ratio
  ElectricalPowerToMassRatio: Qudt.quantityKindFromLocalnameRequired(
    "ElectricalPowerToMassRatio"
  ),
  // Length Temperature
  LengthTemperature:
    Qudt.quantityKindFromLocalnameRequired("LengthTemperature"),
  // Photosynthetic Photon Flux Density
  PhotosyntheticPhotonFluxDensity: Qudt.quantityKindFromLocalnameRequired(
    "PhotosyntheticPhotonFluxDensity"
  ),
  // Specific Impulse
  SpecificImpulse: Qudt.quantityKindFromLocalnameRequired("SpecificImpulse"),
  // lineic mass
  LinearMass: Qudt.quantityKindFromLocalnameRequired("LinearMass"),
  // linear voltage coefficient
  LinearVoltageCoefficient: Qudt.quantityKindFromLocalnameRequired(
    "LinearVoltageCoefficient"
  ),
  // yoğunluk
  MassDensity: Qudt.quantityKindFromLocalnameRequired("MassDensity"),
  // Time Ratio
  TimeRatio: Qudt.quantityKindFromLocalnameRequired("TimeRatio"),
  // Molecular Viscosity
  MolecularViscosity:
    Qudt.quantityKindFromLocalnameRequired("MolecularViscosity"),
  // Drag Force
  DragForce: Qudt.quantityKindFromLocalnameRequired("DragForce"),
  // Elliptical Orbit Apogee Velocity
  EllipticalOrbitApogeeVelocity: Qudt.quantityKindFromLocalnameRequired(
    "EllipticalOrbitApogeeVelocity"
  ),
  // lineic resolution
  LineicResolution: Qudt.quantityKindFromLocalnameRequired("LineicResolution"),
  // Product of Inertia in the Z axis
  PRODUCT__OF__INERTIA_Z: Qudt.quantityKindFromLocalnameRequired(
    "PRODUCT-OF-INERTIA_Z"
  ),
  // Average Energy Loss per Elementary Charge Produced
  AverageEnergyLossPerElementaryChargeProduced:
    Qudt.quantityKindFromLocalnameRequired(
      "AverageEnergyLossPerElementaryChargeProduced"
    ),
  // Molar Mass variation due to Pressure
  AmountOfSubstancePerMassPressure: Qudt.quantityKindFromLocalnameRequired(
    "AmountOfSubstancePerMassPressure"
  ),
  // Angle of Optical Rotation
  AngleOfOpticalRotation: Qudt.quantityKindFromLocalnameRequired(
    "AngleOfOpticalRotation"
  ),
  // Force Per Area Time
  ForcePerAreaTime: Qudt.quantityKindFromLocalnameRequired("ForcePerAreaTime"),
  // Water Horsepower
  WaterHorsepower: Qudt.quantityKindFromLocalnameRequired("WaterHorsepower"),
  // عدد الموجة
  Wavenumber: Qudt.quantityKindFromLocalnameRequired("Wavenumber"),
  // Second Axial Moment of Area
  SecondAxialMomentOfArea: Qudt.quantityKindFromLocalnameRequired(
    "SecondAxialMomentOfArea"
  ),
  // Resistivity
  Resistivity: Qudt.quantityKindFromLocalnameRequired("Resistivity"),
  // elektryczny moment kwadrupolowy
  ElectricQuadrupoleMoment: Qudt.quantityKindFromLocalnameRequired(
    "ElectricQuadrupoleMoment"
  ),
  // Angular Reciprocal Lattice Vector
  AngularReciprocalLatticeVector: Qudt.quantityKindFromLocalnameRequired(
    "AngularReciprocalLatticeVector"
  ),
  // Atomic Mass
  AtomicMass: Qudt.quantityKindFromLocalnameRequired("AtomicMass"),
  // Ionic Charge
  IonicCharge: Qudt.quantityKindFromLocalnameRequired("IonicCharge"),
  // Linear Density
  LinearDensity: Qudt.quantityKindFromLocalnameRequired("LinearDensity"),
  // digit rate
  DigitRate: Qudt.quantityKindFromLocalnameRequired("DigitRate"),
  // Stress-Optic Coefficient
  StressOpticCoefficient: Qudt.quantityKindFromLocalnameRequired(
    "StressOpticCoefficient"
  ),
  // Halaju bersudut
  AngularVelocity: Qudt.quantityKindFromLocalnameRequired("AngularVelocity"),
  // Fundamental Reciprocal Lattice Vector
  FundamentalReciprocalLatticeVector: Qudt.quantityKindFromLocalnameRequired(
    "FundamentalReciprocalLatticeVector"
  ),
  // Exposure
  Exposure: Qudt.quantityKindFromLocalnameRequired("Exposure"),
  // mass-related electrical current
  MassRelatedElectricalCurrent: Qudt.quantityKindFromLocalnameRequired(
    "MassRelatedElectricalCurrent"
  ),
  // Curvature
  Curvature: Qudt.quantityKindFromLocalnameRequired("Curvature"),
  // Electron Mean Free Path
  ElectronMeanFreePath: Qudt.quantityKindFromLocalnameRequired(
    "ElectronMeanFreePath"
  ),
  // Molar Entropy
  MolarEntropy: Qudt.quantityKindFromLocalnameRequired("MolarEntropy"),
  // Fuel Bias
  FUEL__BIAS: Qudt.quantityKindFromLocalnameRequired("FUEL-BIAS"),
  // Mass Flow Rate
  MassFlowRate: Qudt.quantityKindFromLocalnameRequired("MassFlowRate"),
  // Activity
  Activity: Qudt.quantityKindFromLocalnameRequired("Activity"),
  // Ambient Pressure
  AmbientPressure: Qudt.quantityKindFromLocalnameRequired("AmbientPressure"),
  // Radiance
  Radiance: Qudt.quantityKindFromLocalnameRequired("Radiance"),
  // Energy Expenditure
  EnergyExpenditure:
    Qudt.quantityKindFromLocalnameRequired("EnergyExpenditure"),
  // Cross-sectional Area
  CrossSectionalArea:
    Qudt.quantityKindFromLocalnameRequired("CrossSectionalArea"),
  // molar density
  MolarDensity: Qudt.quantityKindFromLocalnameRequired("MolarDensity"),
  // Donor Ionization Energy
  DonorIonizationEnergy: Qudt.quantityKindFromLocalnameRequired(
    "DonorIonizationEnergy"
  ),
  // Dynamic Friction Coefficient
  DynamicFrictionCoefficient: Qudt.quantityKindFromLocalnameRequired(
    "DynamicFrictionCoefficient"
  ),
  // Isentropic Compressibility
  IsentropicCompressibility: Qudt.quantityKindFromLocalnameRequired(
    "IsentropicCompressibility"
  ),
  // Morbidity Rate
  MorbidityRate: Qudt.quantityKindFromLocalnameRequired("MorbidityRate"),
  // pressure-based density
  PressureBasedDensity: Qudt.quantityKindFromLocalnameRequired(
    "PressureBasedDensity"
  ),
  // Vacuum Thrust
  VacuumThrust: Qudt.quantityKindFromLocalnameRequired("VacuumThrust"),
  // massic torque
  MassicTorque: Qudt.quantityKindFromLocalnameRequired("MassicTorque"),
  // Center of Gravity in the Y axis
  CENTER__OF__GRAVITY_Y: Qudt.quantityKindFromLocalnameRequired(
    "CENTER-OF-GRAVITY_Y"
  ),
  // Molar Flux Density Variance
  MolarFluxDensityVariance: Qudt.quantityKindFromLocalnameRequired(
    "MolarFluxDensityVariance"
  ),
  // temperature-based mass flow rate
  TemperatureBasedMassFlowRate: Qudt.quantityKindFromLocalnameRequired(
    "TemperatureBasedMassFlowRate"
  ),
  // Force Per Area
  ForcePerArea: Qudt.quantityKindFromLocalnameRequired("ForcePerArea"),
  // Thrust
  Thrust: Qudt.quantityKindFromLocalnameRequired("Thrust"),
  // Opening Ratio
  OpeningRatio: Qudt.quantityKindFromLocalnameRequired("OpeningRatio"),
  // dataset of bytes
  DatasetOfBytes: Qudt.quantityKindFromLocalnameRequired("DatasetOfBytes"),
  // Rovinný úhel
  PlaneAngle: Qudt.quantityKindFromLocalnameRequired("PlaneAngle"),
  // Ratio of Specific Heat Capacities
  RatioOfSpecificHeatCapacities: Qudt.quantityKindFromLocalnameRequired(
    "RatioOfSpecificHeatCapacities"
  ),
  // Particle Source Density
  ParticleSourceDensity: Qudt.quantityKindFromLocalnameRequired(
    "ParticleSourceDensity"
  ),
  // współczynnik rozszerzalności objętościowej
  CubicExpansionCoefficient: Qudt.quantityKindFromLocalnameRequired(
    "CubicExpansionCoefficient"
  ),
  // Dimensionless Ratio
  DimensionlessRatio:
    Qudt.quantityKindFromLocalnameRequired("DimensionlessRatio"),
  // dose equivalent rate
  DoseEquivalentRate:
    Qudt.quantityKindFromLocalnameRequired("DoseEquivalentRate"),
  // burst factor
  BurstFactor: Qudt.quantityKindFromLocalnameRequired("BurstFactor"),
  // Tekanan osmotik
  OsmoticPressure: Qudt.quantityKindFromLocalnameRequired("OsmoticPressure"),
  // Cold Receptor Threshold
  ColdReceptorThreshold: Qudt.quantityKindFromLocalnameRequired(
    "ColdReceptorThreshold"
  ),
  // Volumic Electromagnetic Energy
  VolumicElectromagneticEnergy: Qudt.quantityKindFromLocalnameRequired(
    "VolumicElectromagneticEnergy"
  ),
  // Positive Length
  NonNegativeLength:
    Qudt.quantityKindFromLocalnameRequired("NonNegativeLength"),
  // Gruneisen Parameter
  GruneisenParameter:
    Qudt.quantityKindFromLocalnameRequired("GruneisenParameter"),
  // RotationalFrequency
  RotationalFrequency: Qudt.quantityKindFromLocalnameRequired(
    "RotationalFrequency"
  ),
  // second radiation constant
  SecondRadiationConstant: Qudt.quantityKindFromLocalnameRequired(
    "SecondRadiationConstant"
  ),
  // Position Vector
  PositionVector: Qudt.quantityKindFromLocalnameRequired("PositionVector"),
  // Amount of cloud cover
  AmountOfCloudCover:
    Qudt.quantityKindFromLocalnameRequired("AmountOfCloudCover"),
  // lineic data volume
  LineicDataVolume: Qudt.quantityKindFromLocalnameRequired("LineicDataVolume"),
  // Reflectance Factor
  ReflectanceFactor:
    Qudt.quantityKindFromLocalnameRequired("ReflectanceFactor"),
  // Source Voltage Between Substances
  SourceVoltageBetweenSubstances: Qudt.quantityKindFromLocalnameRequired(
    "SourceVoltageBetweenSubstances"
  ),
  // Mean Lifetime
  MeanLifetime: Qudt.quantityKindFromLocalnameRequired("MeanLifetime"),
  // Fermi Angular Wavenumber
  FermiAngularWavenumber: Qudt.quantityKindFromLocalnameRequired(
    "FermiAngularWavenumber"
  ),
  // Energy Level
  EnergyLevel: Qudt.quantityKindFromLocalnameRequired("EnergyLevel"),
  // Reverberation Time
  ReverberationTime:
    Qudt.quantityKindFromLocalnameRequired("ReverberationTime"),
  // Wellenlänge
  Wavelength: Qudt.quantityKindFromLocalnameRequired("Wavelength"),
  // Reflectance
  Reflectance: Qudt.quantityKindFromLocalnameRequired("Reflectance"),
  // Specific thrust
  SpecificThrust: Qudt.quantityKindFromLocalnameRequired("SpecificThrust"),
  // Illuminance
  SphericalIlluminance: Qudt.quantityKindFromLocalnameRequired(
    "SphericalIlluminance"
  ),
  // mass flux density
  MassFluxDensity: Qudt.quantityKindFromLocalnameRequired("MassFluxDensity"),
  // Power Per Area
  PowerPerArea: Qudt.quantityKindFromLocalnameRequired("PowerPerArea"),
  // Migration Area
  MigrationArea: Qudt.quantityKindFromLocalnameRequired("MigrationArea"),
  // Length per Electric Current
  LengthPerElectricCurrent: Qudt.quantityKindFromLocalnameRequired(
    "LengthPerElectricCurrent"
  ),
  // Linear Electric Current Density
  LinearElectricCurrentDensity: Qudt.quantityKindFromLocalnameRequired(
    "LinearElectricCurrentDensity"
  ),
  // massic electric current
  MassicElectricCurrent: Qudt.quantityKindFromLocalnameRequired(
    "MassicElectricCurrent"
  ),
  // Linear Force
  LinearForce: Qudt.quantityKindFromLocalnameRequired("LinearForce"),
  // Exit Plane Temperature
  ExitPlaneTemperature: Qudt.quantityKindFromLocalnameRequired(
    "ExitPlaneTemperature"
  ),
  // Incidence
  Incidence: Qudt.quantityKindFromLocalnameRequired("Incidence"),
  // Osmotic Coefficient
  OsmoticCoefficient:
    Qudt.quantityKindFromLocalnameRequired("OsmoticCoefficient"),
  // Radiant Energy Density
  RadiantEnergyDensity: Qudt.quantityKindFromLocalnameRequired(
    "RadiantEnergyDensity"
  ),
  // Rest Energy
  RestEnergy: Qudt.quantityKindFromLocalnameRequired("RestEnergy"),
  // kinematic viscosity or diffusion constant or thermal diffusivity
  KinematicViscosityOrDiffusionConstantOrThermalDiffusivity:
    Qudt.quantityKindFromLocalnameRequired(
      "KinematicViscosityOrDiffusionConstantOrThermalDiffusivity"
    ),
  // Center of Gravity in the Y axis
  CenterOfGravity_Y:
    Qudt.quantityKindFromLocalnameRequired("CenterOfGravity_Y"),
  // Displacement
  Displacement: Qudt.quantityKindFromLocalnameRequired("Displacement"),
  // Lande g-Factor
  LandeGFactor: Qudt.quantityKindFromLocalnameRequired("LandeGFactor"),
  // Microbial Formation
  MicrobialFormation:
    Qudt.quantityKindFromLocalnameRequired("MicrobialFormation"),
  // Mobility Ratio
  MobilityRatio: Qudt.quantityKindFromLocalnameRequired("MobilityRatio"),
  // ratio
  Ratio: Qudt.quantityKindFromLocalnameRequired("Ratio"),
  // Specific Power
  SpecificPower: Qudt.quantityKindFromLocalnameRequired("SpecificPower"),
  // Temperature per Magnetic Flux Density
  TemperaturePerMagneticFluxDensity: Qudt.quantityKindFromLocalnameRequired(
    "TemperaturePerMagneticFluxDensity"
  ),
  // Soil Adsorption Coefficient
  SoilAdsorptionCoefficient: Qudt.quantityKindFromLocalnameRequired(
    "SoilAdsorptionCoefficient"
  ),
  // Transmittance
  Transmittance: Qudt.quantityKindFromLocalnameRequired("Transmittance"),
  // lineic bit density
  LinearBitDensity: Qudt.quantityKindFromLocalnameRequired("LinearBitDensity"),
  // Rocket Atmospheric Transverse Force
  RocketAtmosphericTransverseForce: Qudt.quantityKindFromLocalnameRequired(
    "RocketAtmosphericTransverseForce"
  ),
  // Luminous Flux per Area
  LuminousFluxPerArea: Qudt.quantityKindFromLocalnameRequired(
    "LuminousFluxPerArea"
  ),
  // Constringence
  Constringence: Qudt.quantityKindFromLocalnameRequired("Constringence"),
  // Capacity
  Capacity: Qudt.quantityKindFromLocalnameRequired("Capacity"),
  // Moment of Inertia in the Z axis
  MomentOfInertia_Z:
    Qudt.quantityKindFromLocalnameRequired("MomentOfInertia_Z"),
  // Power Per Electric Charge
  PowerPerElectricCharge: Qudt.quantityKindFromLocalnameRequired(
    "PowerPerElectricCharge"
  ),
  // Non-active Power
  NonActivePower: Qudt.quantityKindFromLocalnameRequired("NonActivePower"),
  // Payload Mass
  PayloadMass: Qudt.quantityKindFromLocalnameRequired("PayloadMass"),
  // Spectral Radiant Energy Density
  SpectralRadiantEnergyDensity: Qudt.quantityKindFromLocalnameRequired(
    "SpectralRadiantEnergyDensity"
  ),
  // Energy per temperature
  EnergyPerTemperature: Qudt.quantityKindFromLocalnameRequired(
    "EnergyPerTemperature"
  ),
  // Kerma
  Kerma: Qudt.quantityKindFromLocalnameRequired("Kerma"),
  // time-related logarithmic ratio
  TimeRelatedLogarithmicRatio: Qudt.quantityKindFromLocalnameRequired(
    "TimeRelatedLogarithmicRatio"
  ),
  // magnetic dipole moment of a molecule
  MagneticDipoleMomentOfAMolecule: Qudt.quantityKindFromLocalnameRequired(
    "MagneticDipoleMomentOfAMolecule"
  ),
  // Acidity
  Acidity: Qudt.quantityKindFromLocalnameRequired("Acidity"),
  // Power per Volume
  PowerPerVolume: Qudt.quantityKindFromLocalnameRequired("PowerPerVolume"),
  // Prevalence
  Prevalence: Qudt.quantityKindFromLocalnameRequired("Prevalence"),
  // 无功功率
  ReactivePower: Qudt.quantityKindFromLocalnameRequired("ReactivePower"),
  // श्यानता
  KinematicViscosity:
    Qudt.quantityKindFromLocalnameRequired("KinematicViscosity"),
  // Thermal Utilization Factor For Fission
  ThermalUtilizationFactorForFission: Qudt.quantityKindFromLocalnameRequired(
    "ThermalUtilizationFactorForFission"
  ),
  // Einstein coefficients
  EinsteinCoefficients: Qudt.quantityKindFromLocalnameRequired(
    "EinsteinCoefficients"
  ),
  // Torque per Length
  TorquePerLength: Qudt.quantityKindFromLocalnameRequired("TorquePerLength"),
  // Peltier Coefficient
  PeltierCoefficient:
    Qudt.quantityKindFromLocalnameRequired("PeltierCoefficient"),
  // Thermal Conductance
  ThermalConductance:
    Qudt.quantityKindFromLocalnameRequired("ThermalConductance"),
  // Internal Energy
  InternalEnergy: Qudt.quantityKindFromLocalnameRequired("InternalEnergy"),
  // symbol transmission rate
  SymbolTransmissionRate: Qudt.quantityKindFromLocalnameRequired(
    "SymbolTransmissionRate"
  ),
  // Lattice Plane Spacing
  LatticePlaneSpacing: Qudt.quantityKindFromLocalnameRequired(
    "LatticePlaneSpacing"
  ),
  // Mass per Electric Charge
  MassPerElectricCharge: Qudt.quantityKindFromLocalnameRequired(
    "MassPerElectricCharge"
  ),
  // mobilità
  Mobility: Qudt.quantityKindFromLocalnameRequired("Mobility"),
  // Payload Ratio
  PayloadRatio: Qudt.quantityKindFromLocalnameRequired("PayloadRatio"),
  // Volume Fraction
  VolumeFraction: Qudt.quantityKindFromLocalnameRequired("VolumeFraction"),
  // Migration Length
  MigrationLength: Qudt.quantityKindFromLocalnameRequired("MigrationLength"),
  // Slowing-Down Area
  Slowing__DownArea: Qudt.quantityKindFromLocalnameRequired("Slowing-DownArea"),
  // Product of Inertia in the X axis
  PRODUCT__OF__INERTIA_X: Qudt.quantityKindFromLocalnameRequired(
    "PRODUCT-OF-INERTIA_X"
  ),
  // Stała Madelunga
  MadelungConstant: Qudt.quantityKindFromLocalnameRequired("MadelungConstant"),
  // Activity Thresholds
  ActivityThresholds:
    Qudt.quantityKindFromLocalnameRequired("ActivityThresholds"),
  // g-Factor of Nucleus
  GFactorOfNucleus: Qudt.quantityKindFromLocalnameRequired("GFactorOfNucleus"),
  // Coefficient of heat transfer
  CoefficientOfHeatTransfer: Qudt.quantityKindFromLocalnameRequired(
    "CoefficientOfHeatTransfer"
  ),
  // Hamilton Function
  HamiltonFunction: Qudt.quantityKindFromLocalnameRequired("HamiltonFunction"),
  // Area per Time
  AreaPerTime: Qudt.quantityKindFromLocalnameRequired("AreaPerTime"),
  // Burgers Vector
  BurgersVector: Qudt.quantityKindFromLocalnameRequired("BurgersVector"),
  // I²t-value
  CutoffCurrentRating: Qudt.quantityKindFromLocalnameRequired(
    "CutoffCurrentRating"
  ),
  // Standard Absolute Activity
  StandardAbsoluteActivity: Qudt.quantityKindFromLocalnameRequired(
    "StandardAbsoluteActivity"
  ),
  // Resistance
  Resistance: Qudt.quantityKindFromLocalnameRequired("Resistance"),
  // Equilibrium Constant on Pressure Basis
  EquilibriumConstantOnPressureBasis: Qudt.quantityKindFromLocalnameRequired(
    "EquilibriumConstantOnPressureBasis"
  ),
  // Mortality Rate
  MortalityRate: Qudt.quantityKindFromLocalnameRequired("MortalityRate"),
  // Center of Mass (CoM)
  CENTER__OF__MASS: Qudt.quantityKindFromLocalnameRequired("CENTER-OF-MASS"),
  // Specific Heat Capacity
  SpecificHeatCapacity: Qudt.quantityKindFromLocalnameRequired(
    "SpecificHeatCapacity"
  ),
  // Work Function
  WorkFunction: Qudt.quantityKindFromLocalnameRequired("WorkFunction"),
  // Scalar Magnetic Potential
  ScalarMagneticPotential: Qudt.quantityKindFromLocalnameRequired(
    "ScalarMagneticPotential"
  ),
  // Angular Momentum per Angle
  AngularMomentumPerAngle: Qudt.quantityKindFromLocalnameRequired(
    "AngularMomentumPerAngle"
  ),
  // Mass Amount of Substance Temperature
  MassAmountOfSubstanceTemperature: Qudt.quantityKindFromLocalnameRequired(
    "MassAmountOfSubstanceTemperature"
  ),
  // Radiosity
  Radiosity: Qudt.quantityKindFromLocalnameRequired("Radiosity"),
  // Speed Ratio
  SpeedRatio: Qudt.quantityKindFromLocalnameRequired("SpeedRatio"),
  // exposure rate of ionizing radiation
  ExposureRateOfIonizingRadiation: Qudt.quantityKindFromLocalnameRequired(
    "ExposureRateOfIonizingRadiation"
  ),
  // Thruster Power To Thrust Efficiency
  ThrusterPowerToThrustEfficiency: Qudt.quantityKindFromLocalnameRequired(
    "ThrusterPowerToThrustEfficiency"
  ),
  // תדירות
  Frequency: Qudt.quantityKindFromLocalnameRequired("Frequency"),
  // Jarak
  Distance: Qudt.quantityKindFromLocalnameRequired("Distance"),
  // temperature-based amount-of-substance concentration
  TemperatureBasedAmountOfSubstanceConcentration:
    Qudt.quantityKindFromLocalnameRequired(
      "TemperatureBasedAmountOfSubstanceConcentration"
    ),
  // Energy Density of States
  EnergyDensityOfStates: Qudt.quantityKindFromLocalnameRequired(
    "EnergyDensityOfStates"
  ),
  // Permeability
  ElectromagneticPermeability: Qudt.quantityKindFromLocalnameRequired(
    "ElectromagneticPermeability"
  ),
  // Equivalent Concentration
  EquivalentConcentration: Qudt.quantityKindFromLocalnameRequired(
    "EquivalentConcentration"
  ),
  // Spin Quantum Number
  SpinQuantumNumber:
    Qudt.quantityKindFromLocalnameRequired("SpinQuantumNumber"),
  // osvetljenost
  Illuminance: Qudt.quantityKindFromLocalnameRequired("Illuminance"),
  // Specific Gibbs Energy
  SpecificGibbsEnergy: Qudt.quantityKindFromLocalnameRequired(
    "SpecificGibbsEnergy"
  ),
  // Atom Scattering Factor
  AtomScatteringFactor: Qudt.quantityKindFromLocalnameRequired(
    "AtomScatteringFactor"
  ),
  // massic power
  MassicPower: Qudt.quantityKindFromLocalnameRequired("MassicPower"),
  // Section Modulus
  SectionModulus: Qudt.quantityKindFromLocalnameRequired("SectionModulus"),
  // Dynamic Friction
  DynamicFriction: Qudt.quantityKindFromLocalnameRequired("DynamicFriction"),
  // Henry's Law Volatility Constant
  HenrysLawVolatilityConstant: Qudt.quantityKindFromLocalnameRequired(
    "HenrysLawVolatilityConstant"
  ),
  // Massic Activity
  MassicActivity: Qudt.quantityKindFromLocalnameRequired("MassicActivity"),
  // Growing Degree Days (Cereals)
  GrowingDegreeDay: Qudt.quantityKindFromLocalnameRequired("GrowingDegreeDay"),
  // polarisability
  Polarizability: Qudt.quantityKindFromLocalnameRequired("Polarizability"),
  // Short-Range Order Parameter
  Short__RangeOrderParameter: Qudt.quantityKindFromLocalnameRequired(
    "Short-RangeOrderParameter"
  ),
  // Generalized Force
  GeneralizedMomentum: Qudt.quantityKindFromLocalnameRequired(
    "GeneralizedMomentum"
  ),
  // Molar Conductivity
  MolarConductivity:
    Qudt.quantityKindFromLocalnameRequired("MolarConductivity"),
  // Berat
  Weight: Qudt.quantityKindFromLocalnameRequired("Weight"),
  // Fast Fission Factor
  FastFissionFactor:
    Qudt.quantityKindFromLocalnameRequired("FastFissionFactor"),
  // Molecular Mass
  MolecularMass: Qudt.quantityKindFromLocalnameRequired("MolecularMass"),
  // Altitude
  Altitude: Qudt.quantityKindFromLocalnameRequired("Altitude"),
  // Bragg Angle
  BraggAngle: Qudt.quantityKindFromLocalnameRequired("BraggAngle"),
  // torque constant
  TorqueConstant: Qudt.quantityKindFromLocalnameRequired("TorqueConstant"),
  // Positive Length
  PositiveLength: Qudt.quantityKindFromLocalnameRequired("PositiveLength"),
  // Reaction Energy
  ReactionEnergy: Qudt.quantityKindFromLocalnameRequired("ReactionEnergy"),
  // Magnetic Dipole Moment
  MagneticDipoleMoment: Qudt.quantityKindFromLocalnameRequired(
    "MagneticDipoleMoment"
  ),
  // Ускоре́ние
  Acceleration: Qudt.quantityKindFromLocalnameRequired("Acceleration"),
  // Polar moment of inertia
  PolarMomentOfInertia: Qudt.quantityKindFromLocalnameRequired(
    "PolarMomentOfInertia"
  ),
  // Square Energy
  Energy_Squared: Qudt.quantityKindFromLocalnameRequired("Energy_Squared"),
  // Magnetic Reluctivity
  MagneticReluctivity: Qudt.quantityKindFromLocalnameRequired(
    "MagneticReluctivity"
  ),
  // Strain
  Strain: Qudt.quantityKindFromLocalnameRequired("Strain"),
  // Thermal Diffusivity
  ThermalDiffusivity:
    Qudt.quantityKindFromLocalnameRequired("ThermalDiffusivity"),
  // Radiant Exposure
  RadiantExposure: Qudt.quantityKindFromLocalnameRequired("RadiantExposure"),
  // Serum Level
  SerumLevel: Qudt.quantityKindFromLocalnameRequired("SerumLevel"),
  // Stress
  Stress: Qudt.quantityKindFromLocalnameRequired("Stress"),
  // Energy Fluence
  EnergyFluence: Qudt.quantityKindFromLocalnameRequired("EnergyFluence"),
  // Stoichiometric Number
  StoichiometricNumber: Qudt.quantityKindFromLocalnameRequired(
    "StoichiometricNumber"
  ),
  // photon luminance
  PhotonLuminance: Qudt.quantityKindFromLocalnameRequired("PhotonLuminance"),
  // Effective Exhaustvelocity
  EffectiveExhaustVelocity: Qudt.quantityKindFromLocalnameRequired(
    "EffectiveExhaustVelocity"
  ),
  // Temperature per Time
  TemperaturePerTime:
    Qudt.quantityKindFromLocalnameRequired("TemperaturePerTime"),
  // Neutron Yield per Fission
  NeutronYieldPerFission: Qudt.quantityKindFromLocalnameRequired(
    "NeutronYieldPerFission"
  ),
  // Quantum Number
  QuantumNumber: Qudt.quantityKindFromLocalnameRequired("QuantumNumber"),
  // Radius of Curvature
  RadiusOfCurvature:
    Qudt.quantityKindFromLocalnameRequired("RadiusOfCurvature"),
  // bandwidth length product
  BandwidthLengthProduct: Qudt.quantityKindFromLocalnameRequired(
    "BandwidthLengthProduct"
  ),
  // dots per inch
  DotsPerInch: Qudt.quantityKindFromLocalnameRequired("DotsPerInch"),
  // Acceleration Of Gravity
  AccelerationOfGravity: Qudt.quantityKindFromLocalnameRequired(
    "AccelerationOfGravity"
  ),
  // Mass Of The Earth
  MassOfTheEarth: Qudt.quantityKindFromLocalnameRequired("MassOfTheEarth"),
  // Wasserdampfdiffusionsleitkoeffizient
  WaterVaporDiffusionCoefficient: Qudt.quantityKindFromLocalnameRequired(
    "WaterVaporDiffusionCoefficient"
  ),
  // Ion Transport Number
  IonTransportNumber:
    Qudt.quantityKindFromLocalnameRequired("IonTransportNumber"),
  // Energiekosten
  CostPerEnergy: Qudt.quantityKindFromLocalnameRequired("CostPerEnergy"),
  // Specific Enthalpy
  SpecificEnthalpy: Qudt.quantityKindFromLocalnameRequired("SpecificEnthalpy"),
  // Thermal Admittance
  ThermalAdmittance:
    Qudt.quantityKindFromLocalnameRequired("ThermalAdmittance"),
  // Energy Fluence Rate
  EnergyFluenceRate:
    Qudt.quantityKindFromLocalnameRequired("EnergyFluenceRate"),
  // Canonical Partition Function
  CanonicalPartitionFunction: Qudt.quantityKindFromLocalnameRequired(
    "CanonicalPartitionFunction"
  ),
  // Entalpi
  Enthalpy: Qudt.quantityKindFromLocalnameRequired("Enthalpy"),
  // Moment of Inertia in the Z axis
  MOMENT__OF__INERTIA_Z: Qudt.quantityKindFromLocalnameRequired(
    "MOMENT-OF-INERTIA_Z"
  ),
  // Flight Performance Reserve Propellant Mass
  FLIGHT__PERFORMANCE__RESERVE__PROPELLANT__MASS:
    Qudt.quantityKindFromLocalnameRequired(
      "FLIGHT-PERFORMANCE-RESERVE-PROPELLANT-MASS"
    ),
  // Chemical Affinity
  ChemicalAffinity: Qudt.quantityKindFromLocalnameRequired("ChemicalAffinity"),
  // Moisture Diffusivity
  MoistureDiffusivity: Qudt.quantityKindFromLocalnameRequired(
    "MoistureDiffusivity"
  ),
  // spectral concentration of vibrational modes (in terms of angular frequency)
  SpectralConcentrationOfVibrationalModes:
    Qudt.quantityKindFromLocalnameRequired(
      "SpectralConcentrationOfVibrationalModes"
    ),
  // Debye Angular Wavenumber
  DebyeAngularWavenumber: Qudt.quantityKindFromLocalnameRequired(
    "DebyeAngularWavenumber"
  ),
  // Mean Energy Imparted
  MeanEnergyImparted:
    Qudt.quantityKindFromLocalnameRequired("MeanEnergyImparted"),
  // Total Current Density
  TotalCurrentDensity: Qudt.quantityKindFromLocalnameRequired(
    "TotalCurrentDensity"
  ),
  // molar optical rotational ability
  MolarOpticalRotationalAbility: Qudt.quantityKindFromLocalnameRequired(
    "MolarOpticalRotationalAbility"
  ),
  // 皮相電力
  ApparentPower: Qudt.quantityKindFromLocalnameRequired("ApparentPower"),
  // Center of Gravity in the Z axis
  CenterOfGravity_Z:
    Qudt.quantityKindFromLocalnameRequired("CenterOfGravity_Z"),
  // Atmospheric Pressure
  AtmosphericPressure: Qudt.quantityKindFromLocalnameRequired(
    "AtmosphericPressure"
  ),
  // Vapour Permeance
  VapourPermeance: Qudt.quantityKindFromLocalnameRequired("VapourPermeance"),
  // Permeability Ratio
  PermeabilityRatio:
    Qudt.quantityKindFromLocalnameRequired("PermeabilityRatio"),
  // Torque per Angle
  TorquePerAngle: Qudt.quantityKindFromLocalnameRequired("TorquePerAngle"),
  // Conduction Speed
  ConductionSpeed: Qudt.quantityKindFromLocalnameRequired("ConductionSpeed"),
  // Impedance
  Impedance: Qudt.quantityKindFromLocalnameRequired("Impedance"),
  // luminous exitance
  LuminousExitance: Qudt.quantityKindFromLocalnameRequired("LuminousExitance"),
  // Sound Particle Displacement
  SoundParticleDisplacement: Qudt.quantityKindFromLocalnameRequired(
    "SoundParticleDisplacement"
  ),
  // Bevel Gear Pitch Angle
  BevelGearPitchAngle: Qudt.quantityKindFromLocalnameRequired(
    "BevelGearPitchAngle"
  ),
  // Characteristic Acoustic Impedance
  CharacteristicAcousticImpedance: Qudt.quantityKindFromLocalnameRequired(
    "CharacteristicAcousticImpedance"
  ),
  // Average Head End Pressure
  AverageHeadEndPressure: Qudt.quantityKindFromLocalnameRequired(
    "AverageHeadEndPressure"
  ),
  // particle current density
  ParticleCurrentDensity: Qudt.quantityKindFromLocalnameRequired(
    "ParticleCurrentDensity"
  ),
  // Dry Volume
  DryVolume: Qudt.quantityKindFromLocalnameRequired("DryVolume"),
  // quantity of light
  QuantityOfLight: Qudt.quantityKindFromLocalnameRequired("QuantityOfLight"),
  // Inverse Square Energy
  InverseEnergy_Squared: Qudt.quantityKindFromLocalnameRequired(
    "InverseEnergy_Squared"
  ),
  // piece
  Piece: Qudt.quantityKindFromLocalnameRequired("Piece"),
  // Dry Bulb Temperature
  DryBulbTemperature:
    Qudt.quantityKindFromLocalnameRequired("DryBulbTemperature"),
  // Fermi Temperature
  FermiTemperature: Qudt.quantityKindFromLocalnameRequired("FermiTemperature"),
  // Stochastic Process
  StochasticProcess:
    Qudt.quantityKindFromLocalnameRequired("StochasticProcess"),
  // volume density of charge
  VolumeDensityOfCharge: Qudt.quantityKindFromLocalnameRequired(
    "VolumeDensityOfCharge"
  ),
  // Generalized Force
  GeneralizedForce: Qudt.quantityKindFromLocalnameRequired("GeneralizedForce"),
  // surge impedance of the medium
  SurgeImpedanceOfTheMedium: Qudt.quantityKindFromLocalnameRequired(
    "SurgeImpedanceOfTheMedium"
  ),
  // Radiant Fluence
  RadiantFluence: Qudt.quantityKindFromLocalnameRequired("RadiantFluence"),
  // Specific Surface Area
  SpecificSurfaceArea: Qudt.quantityKindFromLocalnameRequired(
    "SpecificSurfaceArea"
  ),
  // Initial Velocity
  InitialVelocity: Qudt.quantityKindFromLocalnameRequired("InitialVelocity"),
  // Einstein Transition Probability
  EinsteinTransitionProbability: Qudt.quantityKindFromLocalnameRequired(
    "EinsteinTransitionProbability"
  ),
  // Atomic Charge
  AtomicCharge: Qudt.quantityKindFromLocalnameRequired("AtomicCharge"),
  // Wet Bulb Temperature
  WetBulbTemperature:
    Qudt.quantityKindFromLocalnameRequired("WetBulbTemperature"),
  // Electric Current per Energy
  ElectricCurrentPerEnergy: Qudt.quantityKindFromLocalnameRequired(
    "ElectricCurrentPerEnergy"
  ),
  // Electric Propulsion Propellant Mass
  ElectricPropulsionPropellantMass: Qudt.quantityKindFromLocalnameRequired(
    "ElectricPropulsionPropellantMass"
  ),
  // loudness
  Loudness: Qudt.quantityKindFromLocalnameRequired("Loudness"),
  // Cubic Electric Dipole Moment per Square Energy
  CubicElectricDipoleMomentPerSquareEnergy:
    Qudt.quantityKindFromLocalnameRequired(
      "CubicElectricDipoleMomentPerSquareEnergy"
    ),
  // API Gravity
  Gravity_API: Qudt.quantityKindFromLocalnameRequired("Gravity_API"),
  // Active Power
  ActivePower: Qudt.quantityKindFromLocalnameRequired("ActivePower"),
  // Web Time Average Pressure
  WebTimeAveragePressure: Qudt.quantityKindFromLocalnameRequired(
    "WebTimeAveragePressure"
  ),
  // bit data volume
  BitDataVolume: Qudt.quantityKindFromLocalnameRequired("BitDataVolume"),
  // Apogee Radius
  ApogeeRadius: Qudt.quantityKindFromLocalnameRequired("ApogeeRadius"),
  // Max Sea Level Thrust
  MaxSeaLevelThrust:
    Qudt.quantityKindFromLocalnameRequired("MaxSeaLevelThrust"),
  // thermal coefficient of linear expansion
  ThermalCoefficientOfLinearExpansion: Qudt.quantityKindFromLocalnameRequired(
    "ThermalCoefficientOfLinearExpansion"
  ),
  // rotary-translatory motion conversion
  Rotary__TranslatoryMotionConversion: Qudt.quantityKindFromLocalnameRequired(
    "Rotary-TranslatoryMotionConversion"
  ),
  // Electron Affinity
  ElectronAffinity: Qudt.quantityKindFromLocalnameRequired("ElectronAffinity"),
  // Turns
  Turns: Qudt.quantityKindFromLocalnameRequired("Turns"),
  // differenza di potenziale elettrico
  ElectricPotentialDifference: Qudt.quantityKindFromLocalnameRequired(
    "ElectricPotentialDifference"
  ),
  // Propellant Temperature
  PropellantTemperature: Qudt.quantityKindFromLocalnameRequired(
    "PropellantTemperature"
  ),
  // 電位
  ElectricPotential:
    Qudt.quantityKindFromLocalnameRequired("ElectricPotential"),
  // Kerma Rate
  KermaRate: Qudt.quantityKindFromLocalnameRequired("KermaRate"),
  // Energy Imparted
  EnergyImparted: Qudt.quantityKindFromLocalnameRequired("EnergyImparted"),
  // temperature-based density
  TemperatureBasedDensity: Qudt.quantityKindFromLocalnameRequired(
    "TemperatureBasedDensity"
  ),
  // Statistical Weight
  StatisticalWeight:
    Qudt.quantityKindFromLocalnameRequired("StatisticalWeight"),
  // spectral radiant energy density in terms of wavelength
  SpectralRadiantEnergyDensityInTermsOfWavelength:
    Qudt.quantityKindFromLocalnameRequired(
      "SpectralRadiantEnergyDensityInTermsOfWavelength"
    ),
  // atomic energy
  AtomicEnergy: Qudt.quantityKindFromLocalnameRequired("AtomicEnergy"),
  // force
  Force: Qudt.quantityKindFromLocalnameRequired("Force"),
  // श्यानता
  DynamicViscosity: Qudt.quantityKindFromLocalnameRequired("DynamicViscosity"),
  // Energy Density
  EnergyDensity: Qudt.quantityKindFromLocalnameRequired("EnergyDensity"),
  // Poisson Ratio
  PoissonRatio: Qudt.quantityKindFromLocalnameRequired("PoissonRatio"),
  // Electric Flux
  ElectricFlux: Qudt.quantityKindFromLocalnameRequired("ElectricFlux"),
  // Total Pressure
  TotalPressure: Qudt.quantityKindFromLocalnameRequired("TotalPressure"),
  // Force Magnitude
  ForceMagnitude: Qudt.quantityKindFromLocalnameRequired("ForceMagnitude"),
  // Energy and work per mass amount of substance
  EnergyPerMassAmountOfSubstance: Qudt.quantityKindFromLocalnameRequired(
    "EnergyPerMassAmountOfSubstance"
  ),
  // Reactor Time Constant
  ReactorTimeConstant: Qudt.quantityKindFromLocalnameRequired(
    "ReactorTimeConstant"
  ),
  // volume or section modulus
  VolumeOrSectionModulus: Qudt.quantityKindFromLocalnameRequired(
    "VolumeOrSectionModulus"
  ),
  // Hall Coefficient
  HallCoefficient: Qudt.quantityKindFromLocalnameRequired("HallCoefficient"),
  // Magnetisierung
  Magnetization: Qudt.quantityKindFromLocalnameRequired("Magnetization"),
  // real part of complex frequency
  ComplexFrequency_Real: Qudt.quantityKindFromLocalnameRequired(
    "ComplexFrequency_Real"
  ),
  // Exit Plane Cross-sectional Area
  ExitPlaneCrossSectionalArea: Qudt.quantityKindFromLocalnameRequired(
    "ExitPlaneCrossSectionalArea"
  ),
  // Mechanical Mobility
  MechanicalMobility:
    Qudt.quantityKindFromLocalnameRequired("MechanicalMobility"),
  // Vorticity
  Vorticity: Qudt.quantityKindFromLocalnameRequired("Vorticity"),
  // Maximum Operating Pressure
  MaximumOperatingPressure: Qudt.quantityKindFromLocalnameRequired(
    "MaximumOperatingPressure"
  ),
  // Magnetic Susceptability
  MagneticSusceptability: Qudt.quantityKindFromLocalnameRequired(
    "MagneticSusceptability"
  ),
  // Electric charge per area
  ElectricChargePerArea: Qudt.quantityKindFromLocalnameRequired(
    "ElectricChargePerArea"
  ),
  // repetency
  Repetency: Qudt.quantityKindFromLocalnameRequired("Repetency"),
  // Federkonstante Drehfeder
  TorsionalSpringConstant: Qudt.quantityKindFromLocalnameRequired(
    "TorsionalSpringConstant"
  ),
};

// Prefixes
{
  let prefix: Prefix;
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Atto",
    new Decimal("1E-18"),
    "a",
    "a",
    undefined
  );
  prefix.addLabel(new LangString("Atto", "en"));
  prefix.addLabel(new LangString("Atto", undefined));
  config.prefixes.set("http://qudt.org/vocab/prefix/Atto", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Centi",
    new Decimal("0.01"),
    "c",
    "c",
    undefined
  );
  prefix.addLabel(new LangString("Centi", undefined));
  prefix.addLabel(new LangString("Centi", "en"));
  config.prefixes.set("http://qudt.org/vocab/prefix/Centi", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Deca",
    new Decimal("10.0"),
    "da",
    "da",
    undefined
  );
  prefix.addLabel(new LangString("Deka", "de"));
  prefix.addLabel(new LangString("Deca", "en"));
  prefix.addLabel(new LangString("Deca", undefined));
  config.prefixes.set("http://qudt.org/vocab/prefix/Deca", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Deci",
    new Decimal("0.1"),
    "d",
    "d",
    undefined
  );
  prefix.addLabel(new LangString("Deci", undefined));
  prefix.addLabel(new LangString("Deci", "en"));
  config.prefixes.set("http://qudt.org/vocab/prefix/Deci", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Deka",
    new Decimal("10.0"),
    "da",
    "da",
    undefined
  );
  prefix.addLabel(new LangString("Deka", undefined));
  prefix.addLabel(new LangString("Deka", "en"));
  config.prefixes.set("http://qudt.org/vocab/prefix/Deka", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Exa",
    new Decimal("1000000000000000000.0"),
    "E",
    "E",
    undefined
  );
  prefix.addLabel(new LangString("Exa", undefined));
  prefix.addLabel(new LangString("Exa", "en"));
  config.prefixes.set("http://qudt.org/vocab/prefix/Exa", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Exbi",
    new Decimal("152921504606846976.0"),
    "Ei",
    undefined,
    undefined
  );
  prefix.addLabel(new LangString("Exbi", undefined));
  prefix.addLabel(new LangString("Exbi", "en"));
  config.prefixes.set("http://qudt.org/vocab/prefix/Exbi", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Femto",
    new Decimal("1E-15"),
    "f",
    "f",
    undefined
  );
  prefix.addLabel(new LangString("Femto", "en"));
  prefix.addLabel(new LangString("Femto", undefined));
  config.prefixes.set("http://qudt.org/vocab/prefix/Femto", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Gibi",
    new Decimal("1073741824.0"),
    "Gi",
    "Gi",
    undefined
  );
  prefix.addLabel(new LangString("Gibi", undefined));
  prefix.addLabel(new LangString("Gibi", "en"));
  config.prefixes.set("http://qudt.org/vocab/prefix/Gibi", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Giga",
    new Decimal("1000000000.0"),
    "G",
    "G",
    undefined
  );
  prefix.addLabel(new LangString("Giga", "en"));
  prefix.addLabel(new LangString("Giga", undefined));
  config.prefixes.set("http://qudt.org/vocab/prefix/Giga", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Hecto",
    new Decimal("100.0"),
    "h",
    "h",
    undefined
  );
  prefix.addLabel(new LangString("Etto", "it"));
  prefix.addLabel(new LangString("Hecto", "en"));
  prefix.addLabel(new LangString("Hecto", undefined));
  config.prefixes.set("http://qudt.org/vocab/prefix/Hecto", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Kibi",
    new Decimal("1024.0"),
    "Ki",
    "Ki",
    undefined
  );
  prefix.addLabel(new LangString("Kibi", "en"));
  prefix.addLabel(new LangString("Kibi", undefined));
  config.prefixes.set("http://qudt.org/vocab/prefix/Kibi", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Kilo",
    new Decimal("1000.0"),
    "k",
    "k",
    undefined
  );
  prefix.addLabel(new LangString("Kilo", undefined));
  prefix.addLabel(new LangString("Chilo", "it"));
  prefix.addLabel(new LangString("Kilo", "en"));
  config.prefixes.set("http://qudt.org/vocab/prefix/Kilo", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Mebi",
    new Decimal("1048576.0"),
    "Mi",
    "Mi",
    undefined
  );
  prefix.addLabel(new LangString("Mebi", "en"));
  prefix.addLabel(new LangString("Mebi", undefined));
  config.prefixes.set("http://qudt.org/vocab/prefix/Mebi", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Mega",
    new Decimal("1000000.0"),
    "M",
    "M",
    undefined
  );
  prefix.addLabel(new LangString("Mega", undefined));
  prefix.addLabel(new LangString("Mega", "en"));
  config.prefixes.set("http://qudt.org/vocab/prefix/Mega", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Micro",
    new Decimal("0.000001"),
    "μ",
    "u",
    undefined
  );
  prefix.addLabel(new LangString("Micro", undefined));
  prefix.addLabel(new LangString("Micro", "en"));
  config.prefixes.set("http://qudt.org/vocab/prefix/Micro", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Milli",
    new Decimal("0.001"),
    "m",
    "m",
    undefined
  );
  prefix.addLabel(new LangString("Milli", "en"));
  prefix.addLabel(new LangString("Milli", undefined));
  config.prefixes.set("http://qudt.org/vocab/prefix/Milli", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Nano",
    new Decimal("1E-9"),
    "n",
    "n",
    undefined
  );
  prefix.addLabel(new LangString("Nano", undefined));
  prefix.addLabel(new LangString("Nano", "en"));
  config.prefixes.set("http://qudt.org/vocab/prefix/Nano", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Pebi",
    new Decimal("125899906842624.0"),
    "Pi",
    undefined,
    undefined
  );
  prefix.addLabel(new LangString("Pebi", undefined));
  prefix.addLabel(new LangString("Pebi", "en"));
  config.prefixes.set("http://qudt.org/vocab/prefix/Pebi", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Peta",
    new Decimal("1000000000000000.0"),
    "P",
    "P",
    undefined
  );
  prefix.addLabel(new LangString("Peta", undefined));
  prefix.addLabel(new LangString("Peta", "en"));
  config.prefixes.set("http://qudt.org/vocab/prefix/Peta", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Pico",
    new Decimal("1E-12"),
    "p",
    "p",
    undefined
  );
  prefix.addLabel(new LangString("Pico", undefined));
  prefix.addLabel(new LangString("Pico", "en"));
  config.prefixes.set("http://qudt.org/vocab/prefix/Pico", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Quecto",
    new Decimal("1E-30"),
    "q",
    "q",
    undefined
  );
  prefix.addLabel(new LangString("Quecto", "en"));
  prefix.addLabel(new LangString("Quecto", undefined));
  config.prefixes.set("http://qudt.org/vocab/prefix/Quecto", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Quetta",
    new Decimal("1000000000000000000000000000000.0"),
    "Q",
    "Q",
    undefined
  );
  prefix.addLabel(new LangString("Quetta", undefined));
  prefix.addLabel(new LangString("Quetta", "en"));
  config.prefixes.set("http://qudt.org/vocab/prefix/Quetta", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Ronna",
    new Decimal("1000000000000000000000000000.0"),
    "R",
    "R",
    undefined
  );
  prefix.addLabel(new LangString("Ronna", undefined));
  prefix.addLabel(new LangString("Ronna", "en"));
  config.prefixes.set("http://qudt.org/vocab/prefix/Ronna", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Ronto",
    new Decimal("1E-27"),
    "r",
    "r",
    undefined
  );
  prefix.addLabel(new LangString("Ronto", "en"));
  prefix.addLabel(new LangString("Ronto", undefined));
  config.prefixes.set("http://qudt.org/vocab/prefix/Ronto", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Tebi",
    new Decimal("1099511627776.0"),
    "Ti",
    "Ti",
    undefined
  );
  prefix.addLabel(new LangString("Tebi", undefined));
  prefix.addLabel(new LangString("Tebi", "en"));
  config.prefixes.set("http://qudt.org/vocab/prefix/Tebi", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Tera",
    new Decimal("1000000000000.0"),
    "T",
    "T",
    undefined
  );
  prefix.addLabel(new LangString("Tera", "en"));
  prefix.addLabel(new LangString("Tera", undefined));
  config.prefixes.set("http://qudt.org/vocab/prefix/Tera", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Yobi",
    new Decimal("1208925819614629174706176.0"),
    "Yi",
    undefined,
    undefined
  );
  prefix.addLabel(new LangString("Yobi", "en"));
  prefix.addLabel(new LangString("Yobi", undefined));
  config.prefixes.set("http://qudt.org/vocab/prefix/Yobi", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Yocto",
    new Decimal("1E-24"),
    "y",
    "y",
    undefined
  );
  prefix.addLabel(new LangString("Yocto", undefined));
  prefix.addLabel(new LangString("Yocto", "en"));
  config.prefixes.set("http://qudt.org/vocab/prefix/Yocto", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Yotta",
    new Decimal("1000000000000000000000000.0"),
    "Y",
    "Y",
    undefined
  );
  prefix.addLabel(new LangString("Yotta", undefined));
  prefix.addLabel(new LangString("Yotta", "en"));
  config.prefixes.set("http://qudt.org/vocab/prefix/Yotta", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Zebi",
    new Decimal("1180591620717411303424.0"),
    "Zi",
    undefined,
    undefined
  );
  prefix.addLabel(new LangString("Zebi", "en"));
  prefix.addLabel(new LangString("Zebi", undefined));
  config.prefixes.set("http://qudt.org/vocab/prefix/Zebi", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Zepto",
    new Decimal("1E-21"),
    "z",
    "z",
    undefined
  );
  prefix.addLabel(new LangString("Zepto", "en"));
  prefix.addLabel(new LangString("Zepto", undefined));
  config.prefixes.set("http://qudt.org/vocab/prefix/Zepto", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Zetta",
    new Decimal("1000000000000000000000.0"),
    "Z",
    "Z",
    undefined
  );
  prefix.addLabel(new LangString("Zetta", undefined));
  prefix.addLabel(new LangString("Zetta", "en"));
  config.prefixes.set("http://qudt.org/vocab/prefix/Zetta", prefix);
}

export const Prefixes = {
  // Yobi
  Yobi: Qudt.prefixFromLocalnameRequired("Yobi"),
  // Yotta
  Yotta: Qudt.prefixFromLocalnameRequired("Yotta"),
  // Zetta
  Zetta: Qudt.prefixFromLocalnameRequired("Zetta"),
  // Kibi
  Kibi: Qudt.prefixFromLocalnameRequired("Kibi"),
  // Etto
  Hecto: Qudt.prefixFromLocalnameRequired("Hecto"),
  // Giga
  Giga: Qudt.prefixFromLocalnameRequired("Giga"),
  // Deci
  Deci: Qudt.prefixFromLocalnameRequired("Deci"),
  // Milli
  Milli: Qudt.prefixFromLocalnameRequired("Milli"),
  // Peta
  Peta: Qudt.prefixFromLocalnameRequired("Peta"),
  // Exa
  Exa: Qudt.prefixFromLocalnameRequired("Exa"),
  // Pico
  Pico: Qudt.prefixFromLocalnameRequired("Pico"),
  // Ronto
  Ronto: Qudt.prefixFromLocalnameRequired("Ronto"),
  // Centi
  Centi: Qudt.prefixFromLocalnameRequired("Centi"),
  // Deka
  Deca: Qudt.prefixFromLocalnameRequired("Deca"),
  // Zebi
  Zebi: Qudt.prefixFromLocalnameRequired("Zebi"),
  // Mega
  Mega: Qudt.prefixFromLocalnameRequired("Mega"),
  // Nano
  Nano: Qudt.prefixFromLocalnameRequired("Nano"),
  // Zepto
  Zepto: Qudt.prefixFromLocalnameRequired("Zepto"),
  // Femto
  Femto: Qudt.prefixFromLocalnameRequired("Femto"),
  // Mebi
  Mebi: Qudt.prefixFromLocalnameRequired("Mebi"),
  // Quecto
  Quecto: Qudt.prefixFromLocalnameRequired("Quecto"),
  // Gibi
  Gibi: Qudt.prefixFromLocalnameRequired("Gibi"),
  // Kilo
  Kilo: Qudt.prefixFromLocalnameRequired("Kilo"),
  // Micro
  Micro: Qudt.prefixFromLocalnameRequired("Micro"),
  // Atto
  Atto: Qudt.prefixFromLocalnameRequired("Atto"),
  // Deka
  Deka: Qudt.prefixFromLocalnameRequired("Deka"),
  // Pebi
  Pebi: Qudt.prefixFromLocalnameRequired("Pebi"),
  // Quetta
  Quetta: Qudt.prefixFromLocalnameRequired("Quetta"),
  // Ronna
  Ronna: Qudt.prefixFromLocalnameRequired("Ronna"),
  // Exbi
  Exbi: Qudt.prefixFromLocalnameRequired("Exbi"),
  // Tebi
  Tebi: Qudt.prefixFromLocalnameRequired("Tebi"),
  // Yocto
  Yocto: Qudt.prefixFromLocalnameRequired("Yocto"),
  // Tera
  Tera: Qudt.prefixFromLocalnameRequired("Tera"),
};

// systemsOfUnit
{
  let systemOfUnits: SystemOfUnits;
  systemOfUnits = new SystemOfUnits(
    "http://qudt.org/vocab/sou/ASU",
    [new LangString("Astronomic System Of Units", "en")],
    undefined,
    []
  );
  config.systemsOfUnits.set("http://qudt.org/vocab/sou/ASU", systemOfUnits);
  systemOfUnits = new SystemOfUnits(
    "http://qudt.org/vocab/sou/CGS",
    [new LangString("CGS System of Units", "en")],
    "CGS",
    [
      "http://qudt.org/vocab/unit/CentiM",
      "http://qudt.org/vocab/unit/GM",
      "http://qudt.org/vocab/unit/SEC",
      "http://qudt.org/vocab/unit/UNITLESS",
    ]
  );
  config.systemsOfUnits.set("http://qudt.org/vocab/sou/CGS", systemOfUnits);
  systemOfUnits = new SystemOfUnits(
    "http://qudt.org/vocab/sou/CGS-EMU",
    [new LangString("CGS System of Units - EMU", "en")],
    "CGS-EMU",
    [
      "http://qudt.org/vocab/unit/CentiM",
      "http://qudt.org/vocab/unit/BIOT",
      "http://qudt.org/vocab/unit/GM",
      "http://qudt.org/vocab/unit/SEC",
      "http://qudt.org/vocab/unit/UNITLESS",
    ]
  );
  config.systemsOfUnits.set("http://qudt.org/vocab/sou/CGS-EMU", systemOfUnits);
  systemOfUnits = new SystemOfUnits(
    "http://qudt.org/vocab/sou/CGS-ESU",
    [new LangString("CGS System of Units ESU", "en")],
    "CGS-ESU",
    []
  );
  config.systemsOfUnits.set("http://qudt.org/vocab/sou/CGS-ESU", systemOfUnits);
  systemOfUnits = new SystemOfUnits(
    "http://qudt.org/vocab/sou/CGS-GAUSS",
    [new LangString("CGS System of Units - Gaussian", "en")],
    "CGS-GAUSS",
    [
      "http://qudt.org/vocab/unit/CentiM",
      "http://qudt.org/vocab/unit/GM",
      "http://qudt.org/vocab/unit/SEC",
      "http://qudt.org/vocab/unit/UNITLESS",
    ]
  );
  config.systemsOfUnits.set(
    "http://qudt.org/vocab/sou/CGS-GAUSS",
    systemOfUnits
  );
  systemOfUnits = new SystemOfUnits(
    "http://qudt.org/vocab/sou/IMPERIAL",
    [new LangString("Imperial System of Units", "en")],
    "Imperial",
    []
  );
  config.systemsOfUnits.set(
    "http://qudt.org/vocab/sou/IMPERIAL",
    systemOfUnits
  );
  systemOfUnits = new SystemOfUnits(
    "http://qudt.org/vocab/sou/PLANCK",
    [new LangString("Planck System of Units", "en")],
    "PLANCK",
    [
      "http://qudt.org/vocab/unit/PlanckLength",
      "http://qudt.org/vocab/unit/PlanckTemperature",
      "http://qudt.org/vocab/unit/PlanckTime",
      "http://qudt.org/vocab/unit/PlanckCharge",
      "http://qudt.org/vocab/unit/PlanckMass",
    ]
  );
  config.systemsOfUnits.set("http://qudt.org/vocab/sou/PLANCK", systemOfUnits);
  systemOfUnits = new SystemOfUnits(
    "http://qudt.org/vocab/sou/SI",
    [new LangString("International System of Units", "en")],
    "SI",
    [
      "http://qudt.org/vocab/unit/A",
      "http://qudt.org/vocab/unit/CD",
      "http://qudt.org/vocab/unit/KiloGM",
      "http://qudt.org/vocab/unit/M",
      "http://qudt.org/vocab/unit/MOL",
      "http://qudt.org/vocab/unit/K",
      "http://qudt.org/vocab/unit/SEC",
      "http://qudt.org/vocab/unit/UNITLESS",
    ]
  );
  config.systemsOfUnits.set("http://qudt.org/vocab/sou/SI", systemOfUnits);
  systemOfUnits = new SystemOfUnits(
    "http://qudt.org/vocab/sou/UNSTATED",
    [new LangString("Unstated System Of Units", "en")],
    undefined,
    []
  );
  config.systemsOfUnits.set(
    "http://qudt.org/vocab/sou/UNSTATED",
    systemOfUnits
  );
  systemOfUnits = new SystemOfUnits(
    "http://qudt.org/vocab/sou/USCS",
    [new LangString("US Customary Unit System", "en")],
    "US Customary",
    []
  );
  config.systemsOfUnits.set("http://qudt.org/vocab/sou/USCS", systemOfUnits);
}

export const SystemsOfUnits = {
  // CGS System of Units - Gaussian
  CGS__GAUSS: Qudt.systemOfUnitsFromLocalnameRequired("CGS-GAUSS"),
  // Astronomic System Of Units
  ASU: Qudt.systemOfUnitsFromLocalnameRequired("ASU"),
  // International System of Units
  SI: Qudt.systemOfUnitsFromLocalnameRequired("SI"),
  // CGS System of Units
  CGS: Qudt.systemOfUnitsFromLocalnameRequired("CGS"),
  // CGS System of Units - EMU
  CGS__EMU: Qudt.systemOfUnitsFromLocalnameRequired("CGS-EMU"),
  // US Customary Unit System
  USCS: Qudt.systemOfUnitsFromLocalnameRequired("USCS"),
  // CGS System of Units ESU
  CGS__ESU: Qudt.systemOfUnitsFromLocalnameRequired("CGS-ESU"),
  // Unstated System Of Units
  UNSTATED: Qudt.systemOfUnitsFromLocalnameRequired("UNSTATED"),
  // Imperial System of Units
  IMPERIAL: Qudt.systemOfUnitsFromLocalnameRequired("IMPERIAL"),
  // Planck System of Units
  PLANCK: Qudt.systemOfUnitsFromLocalnameRequired("PLANCK"),
};

function getPrefix(iri: string): Prefix {
  const prefix: Prefix | undefined = config.prefixes.get(iri);
  if (!prefix) {
    throw `prefix ${iri} referenced but not loaded`;
  }
  return prefix;
}

function getUnit(iri: string): Unit {
  const unit: Unit | undefined = config.units.get(iri);
  if (!unit) {
    throw `unit ${iri} referenced but not loaded`;
  }
  return unit;
}

function getQuantityKind(iri: string): QuantityKind {
  const quantityKind: QuantityKind | undefined = config.quantityKinds.get(iri);
  if (!quantityKind) {
    throw `quantityKind ${iri} referenced but not loaded`;
  }
  return quantityKind;
}

// Connect objects
for (const unit of config.units.values()) {
  !!unit.prefixIri && unit.setPrefix(getPrefix(unit.prefixIri));
  !!unit.scalingOfIri && unit.setScalingOf(getUnit(unit.scalingOfIri));
  for (const qkIri of unit.quantityKindIris) {
    unit.addQuantityKind(getQuantityKind(qkIri));
  }
}

// Set factor units

{
  let unit: Unit;
  unit = getUnit("http://qudt.org/vocab/unit/100KiloCount");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/100KiloCount"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/10KiloCount");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/10KiloCount"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/2PiRAD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/2PiRAD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A-HR-PER-DEG_C");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A-HR-PER-DeciM3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciM"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A-HR-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A-HR-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A-HR-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A-M2-PER-J-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A-PER-A-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A-PER-CentiM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A-PER-CentiM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A-PER-DEG_C");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A-PER-GM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A-PER-J");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A-PER-M2-K2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A-PER-MilliM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A-PER-MilliM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A-PER-PA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A-PER-RAD");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/RAD"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A-SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A2-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/AC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M2"), 1)],
      new Decimal("4046.8564224")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/AC-FT");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/AC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/AC-FT_US");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/AC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT_US"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/AMU");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("1.66053878283E-27")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ANGSTROM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("1E-10")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ANGSTROM3");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/ANGSTROM"), 3)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ARCMIN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/RAD"), 1)],
      new Decimal("0.000290888209")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ARCSEC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/RAD"), 1)],
      new Decimal("0.00000484813681")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ARE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M2"), 1)],
      new Decimal("100.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/AT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1)],
      new Decimal("1.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/AT-PER-IN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/AT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/AT-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/AT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ATM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1)],
      new Decimal("101325.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ATM-M3-PER-MOL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/ATM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ATM-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/ATM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ATM_T");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1)],
      new Decimal("98066.5")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ATM_T-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/ATM_T"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/AU");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("149597870691.6")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/AWG");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/AWG"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A_Ab");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1)],
      new Decimal("10.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A_Ab-CentiM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A_Ab"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A_Ab-PER-CentiM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A_Ab"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A_Reactive");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/A_Reactive"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A_Stat");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1)],
      new Decimal("3.335641E-10")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A_Stat-PER-CentiM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A_Stat"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/AttoA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1)],
      new Decimal("1E-18")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/AttoC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1)],
      new Decimal("1E-18")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/AttoFARAD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/FARAD"), 1)],
      new Decimal("1E-18")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/AttoJ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("1E-18")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/AttoJ-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/AttoJ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/AttoSEC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1)],
      new Decimal("1E-18")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/B");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/B"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/B-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/B"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BAN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), 1)],
      new Decimal("2.30258509")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1)],
      new Decimal("100000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BAR-L-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BAR-M3-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BAR-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BAR-PER-DEG_C");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BAR-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BARAD");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DYN"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BARN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M2"), 1)],
      new Decimal("1E-28")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BARN-PER-EV");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BARN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/EV"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BARN-PER-SR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BARN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BARN-PER-SR-EV");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BARN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/EV"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BARYE");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DYN"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BAR_A");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1)],
      new Decimal("100000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BAUD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAUD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BBL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M3"), 1)],
      new Decimal("0.1589873")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BBL_UK_PET");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M3"), 1)],
      new Decimal("0.1591132")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BBL_UK_PET-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BBL_UK_PET"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BBL_UK_PET-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BBL_UK_PET"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BBL_UK_PET-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BBL_UK_PET"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BBL_UK_PET-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BBL_UK_PET"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BBL_US");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M3"), 1)],
      new Decimal("0.1589873")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BBL_US-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BBL_US"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BBL_US-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BBL_US"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BBL_US_DRY");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M3"), 1)],
      new Decimal("0.1156281989625")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BBL_US_PET");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M3"), 1)],
      new Decimal("0.1589873")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BBL_US_PET-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BBL_US_PET"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BBL_US_PET-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BBL_US_PET"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BEAT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BEAT"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BEAT-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BEAT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BFT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BFT"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BILLION_Long");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/ONE"), 1)],
      new Decimal("1000000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BILLION_Short");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/ONE"), 1)],
      new Decimal("1000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BIOT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1)],
      new Decimal("10.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BIT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), 1)],
      new Decimal("0.69314718055994530941723212145818")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BIT-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BIT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BIT-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BIT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BIT-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BIT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BIT-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BIT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BQ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BQ-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BQ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BQ-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BQ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BQ-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BQ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BQ-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BQ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BQ-SEC-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BQ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BREATH");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BREATH"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BREATH-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BREATH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BREWSTER");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M2-PER-N"), 1)],
      new Decimal("1E-12")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_39DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("1059.67")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_59DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("1054.8")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_60DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("1054.68")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("1055.05585262")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-FT");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-FT-PER-FT2-HR-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-IN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-IN-PER-FT2-HR-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-IN-PER-FT2-SEC-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-IN-PER-HR-FT2-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-IN-PER-SEC-FT2-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-PER-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-PER-DEG_R");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_R"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-PER-FT2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-PER-FT2-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-PER-FT2-HR-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-PER-FT2-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-PER-FT2-SEC-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-PER-FT3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-PER-HR-FT2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-PER-HR-FT2-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-PER-HR-FT2-DEG_R");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_R"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-PER-IN2-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-PER-LB");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-PER-LB-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-PER-LB-DEG_R");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_R"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-PER-LB_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-PER-LB_F-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-PER-LB_F-DEG_R");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_R"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-PER-MOL_LB");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL_LB"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-PER-MOL_LB-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL_LB"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-PER-SEC-FT-DEG_R");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_R"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-PER-SEC-FT2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-PER-SEC-FT2-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-PER-SEC-FT2-DEG_R");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_R"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_MEAN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("1055.05585262")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_TH");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("1054.3502645")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_TH-FT-PER-FT2-HR-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_TH-FT-PER-HR-FT2-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_TH-IN-PER-FT2-HR-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_TH-IN-PER-FT2-SEC-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_TH-PER-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_TH-PER-DEG_R");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_R"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_TH-PER-FT2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_TH-PER-FT2-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_TH-PER-FT2-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_TH-PER-FT2-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_TH-PER-FT3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_TH-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_TH-PER-HR-FT2-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_TH-PER-LB");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_TH-PER-LB-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_TH-PER-LB-DEG_R");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_R"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_TH-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_TH-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_TH-PER-SEC-FT2-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BU_UK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M3"), 1)],
      new Decimal("0.03636872")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BU_UK-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BU_UK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BU_UK-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BU_UK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BU_UK-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BU_UK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BU_UK-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BU_UK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BU_US");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 3)],
      new Decimal("2150.42")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BU_US_DRY");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M3"), 1)],
      new Decimal("0.03523907")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BU_US_DRY-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BU_US_DRY"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BU_US_DRY-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BU_US_DRY"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BU_US_DRY-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BU_US_DRY"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BU_US_DRY-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BU_US_DRY"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BYTE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BIT"), 1)],
      new Decimal("8.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BYTE-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BYTE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BasePair");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BasePair"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/C");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/C-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/C-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/C-M2-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/C-M2-PER-V");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/C-PER-CentiM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/C-PER-CentiM3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/C-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/C-PER-KiloGM-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/C-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/C-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/C-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/C-PER-MOL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/C-PER-MilliM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/C-PER-MilliM3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/C2-M2-PER-J");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/C3-M-PER-J2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/C4-M4-PER-J3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 4),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 4),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CAL_15DEG_C");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("4.1858")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CAL_15_DEG_C");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("4.1858")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CAL_20DEG_C");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("4.1819")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CAL_IT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("4.1868")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CAL_IT-PER-GM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CAL_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CAL_IT-PER-GM-DEG_C");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CAL_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CAL_IT-PER-GM-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CAL_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CAL_IT-PER-SEC-CentiM-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CAL_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CAL_IT-PER-SEC-CentiM2-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CAL_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CAL_MEAN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("4.19")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CAL_TH");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("4.184")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CAL_TH-PER-CentiM-SEC-DEG_C");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CAL_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CAL_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CAL_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CAL_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CAL_TH-PER-CentiM3-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CAL_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CAL_TH-PER-GM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CAL_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CAL_TH-PER-GM-DEG_C");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CAL_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CAL_TH-PER-GM-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CAL_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CAL_TH-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CAL_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CAL_TH-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CAL_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CAL_TH-PER-SEC-CentiM-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CAL_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CAL_TH-PER-SEC-CentiM2-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CAL_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CARAT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("0.0002")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CASES");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CASES"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CASES-PER-KiloINDIV-YR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CASES"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloINDIV"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_AED");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_AED"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_AFN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_AFN"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_ALL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_ALL"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_AMD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_AMD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_ANG");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_ANG"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_AOA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_AOA"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_ARS");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_ARS"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_AUD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_AUD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_AWG");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_AWG"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_AZN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_AZN"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_BAM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_BAM"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_BBD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_BBD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_BDT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_BDT"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_BGN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_BGN"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_BGN-PER-KiloW-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_BGN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloW"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_BHD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_BHD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_BIF");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_BIF"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_BMD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_BMD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_BND");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_BND"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_BOB");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_BOB"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_BOV");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_BOV"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_BRL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_BRL"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_BSD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_BSD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_BTN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_BTN"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_BWP");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_BWP"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_BYN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_BYN"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_BZD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_BZD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_CAD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_CAD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_CDF");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_CDF"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_CHE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_CHE"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_CHF");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_CHF"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_CHF-PER-HA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_CHF"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HA"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_CHF-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_CHF"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_CHF-PER-KiloW-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_CHF"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloW"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_CHW");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_CHW"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_CLF");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_CLF"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_CLP");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_CLP"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_CNY");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_CNY"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_COP");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_COP"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_COU");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_COU"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_CRC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_CRC"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_CUP");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_CUP"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_CVE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_CVE"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_CYP");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_CYP"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_CZK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_CZK"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_CZK-PER-KiloW-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_CZK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloW"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_DJF");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_DJF"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_DKK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_DKK"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_DKK-PER-KiloW-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_DKK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloW"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_DOP");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_DOP"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_DZD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_DZD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_EEK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_EEK"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_EGP");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_EGP"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_ERN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_ERN"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_ETB");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_ETB"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_EUR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_EUR"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_EUR-PER-KiloW");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_EUR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloW"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_EUR-PER-KiloW-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_EUR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloW"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_EUR-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_EUR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_EUR-PER-W");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_EUR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_EUR-PER-W-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_EUR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_EUR-PER-W-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_EUR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_FJD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_FJD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_FKP");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_FKP"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_GBP");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_GBP"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_GBP-PER-KiloW-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_GBP"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloW"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_GEL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_GEL"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_GHS");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_GHS"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_GIP");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_GIP"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_GMD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_GMD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_GNF");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_GNF"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_GTQ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_GTQ"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_GYD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_GYD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_HKD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_HKD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_HNL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_HNL"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_HRK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_HRK"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_HTG");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_HTG"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_HUF");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_HUF"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_HUF-PER-KiloW-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_HUF"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloW"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_IDR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_IDR"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_ILS");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_ILS"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_INR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_INR"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_IQD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_IQD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_IRR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_IRR"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_ISK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_ISK"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_JMD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_JMD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_JOD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_JOD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_JPY");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_JPY"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_KES");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_KES"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_KGS");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_KGS"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_KHR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_KHR"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_KMF");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_KMF"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_KPW");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_KPW"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_KRW");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_KRW"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_KWD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_KWD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_KYD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_KYD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_KZT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_KZT"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_LAK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_LAK"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_LBP");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_LBP"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_LKR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_LKR"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_LRD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_LRD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_LSL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_LSL"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_LTL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_LTL"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_LVL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_LVL"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_LYD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_LYD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_MAD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_MAD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_MDL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_MDL"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_MGA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_MGA"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_MKD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_MKD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_MMK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_MMK"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_MNT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_MNT"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_MOP");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_MOP"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_MRU");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_MRU"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_MTL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_MTL"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_MUR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_MUR"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_MVR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_MVR"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_MWK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_MWK"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_MXN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_MXN"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_MXV");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_MXV"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_MYR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_MYR"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_MZN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_MZN"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_NAD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_NAD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_NGN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_NGN"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_NIO");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_NIO"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_NOK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_NOK"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_NOK-PER-KiloW-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_NOK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloW"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_NPR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_NPR"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_NZD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_NZD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_OMR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_OMR"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_PAB");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_PAB"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_PEN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_PEN"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_PGK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_PGK"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_PHP");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_PHP"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_PKR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_PKR"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_PLN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_PLN"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_PLN-PER-KiloW-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_PLN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloW"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_PYG");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_PYG"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_QAR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_QAR"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_RON");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_RON"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_RON-PER-KiloW-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_RON"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloW"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_RSD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_RSD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_RUB");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_RUB"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_RWF");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_RWF"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_SAR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_SAR"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_SBD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_SBD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_SCR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_SCR"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_SDG");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_SDG"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_SEK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_SEK"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_SEK-PER-KiloW-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_SEK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloW"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_SGD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_SGD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_SHP");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_SHP"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_SKK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_SKK"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_SLE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_SLE"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_SOS");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_SOS"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_SRD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_SRD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_STN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_STN"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_SYP");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_SYP"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_SZL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_SZL"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_THB");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_THB"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_TJS");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_TJS"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_TMT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_TMT"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_TND");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_TND"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_TOP");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_TOP"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_TRY");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_TRY"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_TTD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_TTD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_TWD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_TWD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_TZS");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_TZS"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_UAH");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_UAH"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_UGX");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_UGX"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_USD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_USD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_USN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_USN"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_USS");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_USS"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_UYU");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_UYU"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_UZS");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_UZS"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_VES");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_VES"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_VND");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_VND"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_VUV");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_VUV"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_WST");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_WST"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_XAF");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_XAF"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_XAG");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_XAG"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_XAU");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_XAU"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_XBA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_XBA"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_XBB");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_XBB"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_XBC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_XBC"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_XBD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_XBD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_XCD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_XCD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_XDR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_XDR"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_XFO");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_XFO"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_XFU");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_XFU"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_XOF");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_XOF"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_XPD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_XPD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_XPF");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_XPF"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_XPT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_XPT"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_YER");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_YER"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_ZAR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_ZAR"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_ZMW");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_ZMW"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CCY_ZWL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_ZWL"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CD-PER-FT2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CD"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CD-PER-IN2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CD"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CD-PER-KiloLM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CD"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloLM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CD-PER-LM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CD"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CD-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CD"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CD_IN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CD"), 1)],
      new Decimal("0.92")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CH");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("20.1168")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CHAIN_US");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("20.1168")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CHF");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CHF"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CHF-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CHF"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CI");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BQ"), 1)],
      new Decimal("37000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CI-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CI"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CLO");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M2-K-PER-W"), 1)],
      new Decimal("0.155")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CM_H2O");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CORD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M3"), 1)],
      new Decimal("3.62")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/COUNT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/COUNT"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CP");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CD"), 1)],
      new Decimal("1.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CUP");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M3"), 1)],
      new Decimal("0.00023658825")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CUP_US");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M3"), 1)],
      new Decimal("0.00023658825")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CWT_LONG");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("50.80235")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CWT_SHORT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("45.359237")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CYC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CYC"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CYC-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CYC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/C_Ab");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/A-SEC"), 1)],
      new Decimal("10.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/C_Ab-PER-CentiM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/C_Ab"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/C_Stat");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1)],
      new Decimal("3.3356409519815204957557671447492E-10")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/C_Stat-PER-CentiM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/C_Stat"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/C_Stat-PER-MOL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/C_Stat"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiBAR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), 1)],
      new Decimal("0.01")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1)],
      new Decimal("0.01")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiGM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1)],
      new Decimal("0.01")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiGRAY");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GRAY"), 1)],
      new Decimal("0.01")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1)],
      new Decimal("0.01")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("0.01")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM-PER-KiloYR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloYR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM-PER-SEC-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM-PER-SEC-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM-PER-SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM-PER-YR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM-SEC-DEG_C");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM2");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 2)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM2-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM2-PER-CentiM3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM2-PER-ERG");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/ERG"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM2-PER-GM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM2-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM2-PER-SR-ERG");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/ERG"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM2-PER-V-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM2-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM3");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 3)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM3-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM3-PER-CentiM3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM3-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM3-PER-DAY-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM3-PER-DAY-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM3-PER-GM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM3-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM3-PER-HR-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM3-PER-HR-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM3-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM3-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM3-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM3-PER-MIN-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM3-PER-MIN-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM3-PER-MOL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM3-PER-MOL-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM3-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM3-PER-SEC-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM3-PER-SEC-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM4");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 4)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM6");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 6)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiMOL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1)],
      new Decimal("0.01")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiMOL-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiMOL-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM_H2O");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1)],
      new Decimal("98.0665")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM_H2O_4DEG_C");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1)],
      new Decimal("98.0665")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM_HG");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1)],
      new Decimal("1333.224")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM_HG_0DEG_C");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1)],
      new Decimal("1333.224")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1)],
      new Decimal("0.01")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiN-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiN-M-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiPOISE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/POISE"), 1)],
      new Decimal("0.01")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiPOISE-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiPOISE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiPOISE-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiPOISE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiST");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/ST"), 1)],
      new Decimal("0.01")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/Ci");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BQ"), 1)],
      new Decimal("37000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("1.66053878283E-27")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DARCY");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M2"), 1)],
      new Decimal("9.869233E-13")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1)],
      new Decimal("86400.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DAY-PER-NUM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DAY_Sidereal");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1)],
      new Decimal("86164.099")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEATHS");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEATHS"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEATHS-PER-KiloINDIV-YR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEATHS"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloINDIV"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEATHS-PER-MegaINDIV-YR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEATHS"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaINDIV"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEBYE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/C-M"), 1)],
      new Decimal("3.33564E-30")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DECADE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/DECADE"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/RAD"), 1)],
      new Decimal("0.0174532925")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG-PER-SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG2");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG"), 2)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEGREE_API");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEGREE_API"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEGREE_BALLING");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEGREE_BALLING"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEGREE_BAUME");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEGREE_BAUME"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEGREE_BAUME_US_HEAVY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(
          getUnit("http://qudt.org/vocab/unit/DEGREE_BAUME_US_HEAVY"),
          1
        ),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEGREE_BAUME_US_LIGHT");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(
          getUnit("http://qudt.org/vocab/unit/DEGREE_BAUME_US_LIGHT"),
          1
        ),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEGREE_BRIX");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEGREE_BRIX"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEGREE_OECHSLE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEGREE_OECHSLE"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEGREE_PLATO");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEGREE_PLATO"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEGREE_TWADDELL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(
          getUnit("http://qudt.org/vocab/unit/DEGREE_TWADDELL"),
          1
        ),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_C");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), 1)],
      new Decimal("1.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_C-CentiM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_C-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_C-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_C-KiloGM-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_C-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_C-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_C-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_C-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_C-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_C-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_C-PER-YR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_C-WK");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/WK"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_C2");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), 2)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_C2-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_C_GROWING_CEREAL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(
          getUnit("http://qudt.org/vocab/unit/DEG_C_GROWING_CEREAL"),
          1
        ),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_C_GROWING_CEREAL-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(
          getUnit("http://qudt.org/vocab/unit/DEG_C_GROWING_CEREAL"),
          1
        ),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), 1)],
      new Decimal("0.5555555555555555555555555555555556")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_F-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_F-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_F-HR-FT2-PER-BTU_IT");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_F-HR-FT2-PER-BTU_IT-IN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_F-HR-FT2-PER-BTU_TH");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_TH"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_F-HR-FT2-PER-BTU_TH-IN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_TH"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_F-HR-PER-BTU_IT");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_F-HR-PER-BTU_TH");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_TH"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_F-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_F-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_F-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_F-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_F-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_F-PER-SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_F-SEC-PER-BTU_IT");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_F-SEC-PER-BTU_TH");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_TH"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_R");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), 1)],
      new Decimal("0.5555555555555556")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_R-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_R"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_R-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_R"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_R-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_R"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DENIER");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM-PER-MilliM"), 1)],
      new Decimal("1.1E-7")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DIOPTER");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PER-M"), 1)],
      new Decimal("1.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DPI");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/ONE"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DRAM_UK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("0.0017718451953125")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DRAM_US");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("0.0038879346")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DWT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("0.00155517384")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DYN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1)],
      new Decimal("0.00001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DYN-CentiM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DYN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DYN-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DYN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DYN-PER-CentiM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DYN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DYN-PER-CentiM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DYN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DYN-SEC-PER-CentiM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DYN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DYN-SEC-PER-CentiM3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DYN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DYN-SEC-PER-CentiM5");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DYN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -5),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/Da");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("1.66053878283E-27")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/Debye");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/C-M"), 1)],
      new Decimal("3.33564E-30")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DecaARE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/ARE"), 1)],
      new Decimal("10.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DecaC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1)],
      new Decimal("10.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DecaGM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1)],
      new Decimal("10.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DecaK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), 1)],
      new Decimal("10.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DecaKiloCOUNT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/DecaKiloCOUNT"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DecaL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1)],
      new Decimal("10.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DecaM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("10.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DecaM3");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/DecaM"), 3)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DecaPA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1)],
      new Decimal("10.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DecaPOISE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/POISE"), 1)],
      new Decimal("10.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciB");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciB"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciB-MilliW");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliW"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciB-MilliW-PER-MegaHZ");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliW"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaHZ"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciB-PER-KiloM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciB-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciB-W");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciBAR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1)],
      new Decimal("10000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciBAR-PER-YR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciBAR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciB_A");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciB_A"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciB_C");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciB_C"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciB_ISO");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciB_ISO"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciB_M");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciB_M"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciB_Z");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciB_Z"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1)],
      new Decimal("0.1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciGM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1)],
      new Decimal("0.1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1)],
      new Decimal("0.1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciL-PER-GM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("0.1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciM2");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciM"), 2)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciM3");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciM"), 3)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciM3-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciM3-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciM3-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciM3-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciM3-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciM3-PER-MOL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciM3-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1)],
      new Decimal("0.1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciN-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciS");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/S"), 1)],
      new Decimal("0.1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciS-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciS"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciSEC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1)],
      new Decimal("0.1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciTONNE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/TONNE"), 1)],
      new Decimal("0.1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciTON_Metric");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_Metric"), 1)],
      new Decimal("0.1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/Denier");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM-PER-MilliM"), 1)],
      new Decimal("1.1E-7")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/E");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/A-SEC"), 1)],
      new Decimal("1.602176634E-19")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ENZ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KAT"), 1)],
      new Decimal("1.6667E-8")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ENZ-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/ENZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ERG");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ERG-CentiM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/ERG"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ERG-CentiM2-PER-GM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/ERG"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ERG-PER-CentiM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/ERG"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ERG-PER-CentiM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/ERG"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ERG-PER-CentiM2-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/ERG"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ERG-PER-CentiM3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/ERG"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ERG-PER-GM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/ERG"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ERG-PER-GM-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/ERG"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ERG-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/ERG"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ERG-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/ERG"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ERLANG");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/ERLANG"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/EV");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("1.602176634E-19")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/EV-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/EV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/EV-M2-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/EV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/EV-PER-ANGSTROM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/EV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/ANGSTROM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/EV-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/EV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/EV-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/EV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/EV-PER-T");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/EV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/T"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/EV-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/EV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/E_h");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("4.35974394E-18")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/EarthMass");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("5972190000000000000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ElementaryCharge");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1)],
      new Decimal("1.602176634E-19")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ExaBIT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BIT"), 1)],
      new Decimal("1000000000000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ExaBIT-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/ExaBIT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ExaBYTE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BYTE"), 1)],
      new Decimal("1000000000000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ExaC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1)],
      new Decimal("1000000000000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ExaJ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("1000000000000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ExaJ-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/ExaJ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ExaV");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1)],
      new Decimal("1000000000000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ExaV-A");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/ExaV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ExaVA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/VA"), 1)],
      new Decimal("1000000000000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ExaW");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1)],
      new Decimal("1000000000000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ExbiBIT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BIT"), 1)],
      new Decimal("152921504606846976.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ExbiBIT-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/ExbiBIT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ExbiBIT-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/ExbiBIT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ExbiBIT-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/ExbiBIT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ExbiBYTE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BYTE"), 1)],
      new Decimal("152921504606846976.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/F");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1)],
      new Decimal("96485.3399")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SR"), 1)],
      new Decimal("12.5663706")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FARAD");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FARAD-PER-KiloM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FARAD"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FARAD-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FARAD"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FARAD_Ab");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/FARAD"), 1)],
      new Decimal("1000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FARAD_Ab-PER-CentiM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FARAD_Ab"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FARAD_Stat");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/FARAD"), 1)],
      new Decimal("1.112650056053618432174089964848E-18")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FATH");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("1.8288")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FBM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M3"), 1)],
      new Decimal("0.00236")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CD-PER-M2"), 1)],
      new Decimal("10.764")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FLIGHT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/FLIGHT"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FLOPS");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/FLOPS"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("1E-15")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/A-SEC"), 1)],
      new Decimal("3.3356409519815204957557671447492E-10")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FRACTION");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/FRACTION"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FRAME");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/FRAME"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FRAME-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FRAME"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 1)],
      new Decimal("12.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT-HR-PER-GAL_UK");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT-HR-PER-GAL_US");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT-HR-PER-IN3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT-LB_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT-LB_F-PER-FT2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT-LB_F-PER-FT2-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT-LB_F-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT-LB_F-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT-LB_F-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT-LB_F-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT-LB_F-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT-PDL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PDL"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT-PER-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT-PER-PSI");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PSI"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT-PER-SEC-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT-PER-SEC-PSI");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PSI"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT-PER-SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT-SEC-PER-GAL_UK");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT-SEC-PER-GAL_US");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT-SEC-PER-IN3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT2");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 2)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT2-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT2-HR-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT2-HR-DEG_F-PER-BTU_IT");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT2-PER-BTU_IT-IN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT2-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT2-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT2-SEC-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT3");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 3)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT3-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT3-PER-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT3-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT3-PER-LB");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT3-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT3-PER-MIN-FT2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT3-PER-PSI");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PSI"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT3-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT4");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 4)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT_H2O");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1)],
      new Decimal("2989.067")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT_H2O_39dot2DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1)],
      new Decimal("2989.067")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT_HG");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1)],
      new Decimal("40636.66")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT_US");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("0.3048006")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FUR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("201.168")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FUR_Long");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/FUR_Long"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FemtoA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1)],
      new Decimal("1E-15")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FemtoC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1)],
      new Decimal("1E-15")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FemtoFARAD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/FARAD"), 1)],
      new Decimal("1E-15")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FemtoGM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1)],
      new Decimal("1E-15")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FemtoGM-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FemtoGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FemtoGM-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FemtoGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FemtoJ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("1E-15")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FemtoL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1)],
      new Decimal("1E-15")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FemtoM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("1E-15")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FemtoMOL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1)],
      new Decimal("1E-15")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FemtoMOL-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FemtoMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FemtoMOL-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FemtoMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FemtoSEC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1)],
      new Decimal("1E-15")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FemtoV");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1)],
      new Decimal("1E-15")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/G");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
      ],
      new Decimal("9.80665")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GAL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GALILEO");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GAL_IMP");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M3"), 1)],
      new Decimal("0.00454609")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GAL_UK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1)],
      new Decimal("4.54609")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GAL_UK-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GAL_UK-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GAL_UK-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GAL_UK-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GAL_US");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 3)],
      new Decimal("231.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GAL_US-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_US"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GAL_US-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_US"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GAL_US-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_US"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GAL_US-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_US"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GAL_US_DRY");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BU_US"), 1)],
      new Decimal("0.125")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GAMMA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/T"), 1)],
      new Decimal("1E-9")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GAUGE_FR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("0.0003333333")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GAUSS");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/T"), 1)],
      new Decimal("0.0001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GA_Charriere");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("0.0003333333")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GI");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1)],
      new Decimal("0.795774715")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GI_UK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M3"), 1)],
      new Decimal("0.0001420653")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GI_UK-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GI_UK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GI_UK-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GI_UK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GI_UK-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GI_UK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GI_UK-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GI_UK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GI_US");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M3"), 1)],
      new Decimal("0.000118294125")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GI_US-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GI_US"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GI_US-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GI_US"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GI_US-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GI_US"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GI_US-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GI_US"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("0.001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-CentiM-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-HR-PER-L-CentiM3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-HR-PER-L-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-HR-PER-L2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-HR-PER-M3-CentiM3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-HR-PER-M3-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-HR-PER-M6");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -6),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-MIN-PER-L-CentiM3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-MIN-PER-L-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-MIN-PER-L2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-MIN-PER-M3-CentiM3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-MIN-PER-M3-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-MIN-PER-M6");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -6),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-MilliM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-CentiM-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-CentiM-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-CentiM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-CentiM2-YR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-CentiM3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-CentiM3-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-CentiM3-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-DAY-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-DAY-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-DEG_C");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-DeciL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-DeciM3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciM"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-DeciM3-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciM"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-DeciM3-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciM"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-GM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-HA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HA"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-HR-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-HR-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-HZ");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HZ"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-HectoGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HectoGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-KiloM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-L-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-L-CentiPOISE");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiPOISE"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-L-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-L-MilliPA-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliPA"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-L-PA-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-L-POISE");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/POISE"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-M2-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-M2-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-M2-YR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-M3-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-M3-CentiPOISE");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiPOISE"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-M3-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-M3-MilliPA-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliPA"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-M3-PA-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-M3-POISE");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/POISE"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-MIN-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-MIN-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-MOL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-MilliL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-MilliL-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-MilliL-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-MilliM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-MilliM-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-MilliM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-SEC-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-SEC-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-SEC-PER-L-CentiM3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-SEC-PER-L-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-SEC-PER-L2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-SEC-PER-M3-CentiM3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-SEC-PER-M3-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-SEC-PER-M6");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -6),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM_Carbon");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM_Carbon"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM_Carbon-PER-M2-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM_Carbon"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM_DRY");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM_DRY"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM_F");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1)],
      new Decimal("0.00980665")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM_F-PER-CentiM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM_Nitrogen");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM_Nitrogen"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM_Nitrogen-PER-M2-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM_Nitrogen"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GON");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/RAD"), 1)],
      new Decimal("0.015707963267949")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GR"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GRAD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/RAD"), 1)],
      new Decimal("0.015707963267949")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GRAIN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("0.00006479891")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GRAIN-PER-GAL_IMP");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GRAIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_IMP"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GRAIN-PER-GAL_US");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GRAIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GRAIN-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GRAIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GRAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GRAY-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GRAY"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GRAY-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GRAY"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GRAY-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GRAY"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M3"), 1)],
      new Decimal("0.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/Gamma");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/T"), 1)],
      new Decimal("1E-9")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GibiBIT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BIT"), 1)],
      new Decimal("1073741824.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GibiBIT-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GibiBIT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GibiBIT-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GibiBIT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GibiBIT-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GibiBIT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GibiBYTE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BYTE"), 1)],
      new Decimal("1073741824.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GigaA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1)],
      new Decimal("1000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GigaBIT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BIT"), 1)],
      new Decimal("1000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GigaBIT-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GigaBIT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GigaBIT-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GigaBIT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GigaBQ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BQ"), 1)],
      new Decimal("1000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GigaBYTE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BYTE"), 1)],
      new Decimal("1000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GigaBYTE-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GigaBYTE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GigaBasePair");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BasePair"), 1)],
      new Decimal("1000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GigaC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1)],
      new Decimal("1000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GigaC-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GigaC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GigaEV");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/EV"), 1)],
      new Decimal("1000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GigaFLOPS");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/FLOPS"), 1)],
      new Decimal("1000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GigaHZ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/HZ"), 1)],
      new Decimal("1000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GigaHZ-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GigaHZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GigaJ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("1000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GigaJ-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GigaJ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GigaJ-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GigaJ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GigaJ-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GigaJ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GigaN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1)],
      new Decimal("1000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GigaN-M-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GigaN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GigaOHM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/OHM"), 1)],
      new Decimal("1000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GigaOHM-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GigaOHM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GigaOHM-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GigaOHM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GigaPA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1)],
      new Decimal("1000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GigaPA-CentiM3-PER-GM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GigaPA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GigaV");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1)],
      new Decimal("1000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GigaV-A");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GigaV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GigaV-A_Reactive");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GigaV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A_Reactive"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GigaVA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/VA"), 1)],
      new Decimal("1000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GigaVAR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/VAR"), 1)],
      new Decimal("1000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GigaW");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1)],
      new Decimal("1000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GigaW-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GigaW"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/Gs");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/T"), 1)],
      new Decimal("0.0001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/H");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/WB"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/H-PER-KiloOHM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/H"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloOHM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/H-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/H"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/H-PER-OHM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/H"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OHM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M2"), 1)],
      new Decimal("10000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HART");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), 1)],
      new Decimal("2.3025850929940456840179914546844")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HART-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HART"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CD"), 1)],
      new Decimal("0.92")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HP");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J-PER-SEC"), 1)],
      new Decimal("745.6999")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HP_Boiler");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J-PER-SEC"), 1)],
      new Decimal("9809.5")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HP_Brake");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J-PER-SEC"), 1)],
      new Decimal("9809.5")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HP_Electric");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J-PER-SEC"), 1)],
      new Decimal("746.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HP_H2O");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J-PER-SEC"), 1)],
      new Decimal("746.043")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HP_Metric");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J-PER-SEC"), 1)],
      new Decimal("735.4988")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1)],
      new Decimal("3600.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HR-FT2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HR-PER-FT2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HR-PER-NUM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HR-PER-YR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HR_Sidereal");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1)],
      new Decimal("3590.17")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HUNDRED");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/ONE"), 1)],
      new Decimal("100.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HZ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HZ-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HZ-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HZ-PER-T");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/T"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HZ-PER-V");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/H_Ab");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/H"), 1)],
      new Decimal("1E-9")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/H_Stat");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/H"), 1)],
      new Decimal("898760000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/H_Stat-PER-CentiM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/H_Stat"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HeartBeat");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/HeartBeat"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HectoBAR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), 1)],
      new Decimal("100.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HectoC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1)],
      new Decimal("100.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HectoCOUNT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/HectoCOUNT"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HectoGM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1)],
      new Decimal("100.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HectoKiloCOUNT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/HectoKiloCOUNT"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HectoL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1)],
      new Decimal("100.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HectoM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("100.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HectoPA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1)],
      new Decimal("100.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HectoPA-L-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HectoPA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HectoPA-M3-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HectoPA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HectoPA-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HectoPA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HectoPA-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HectoPA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HectoPA-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HectoPA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HectoPA-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HectoPA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/Hundredweight_UK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("50.80235")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/Hundredweight_US");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("45.359237")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/IN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("0.0254")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/IN-PDL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PDL"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/IN-PER-2PiRAD");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/REV"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/IN-PER-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/IN-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/IN-PER-PSI");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PSI"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/IN-PER-REV");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/REV"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/IN-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/IN-PER-SEC-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/IN-PER-SEC-PSI");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PSI"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/IN-PER-SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/IN-PER-YR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/IN2");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 2)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/IN2-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/IN3");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 3)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/IN3-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/IN3-PER-LB");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/IN3-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/IN3-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/IN4");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 4)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/IN_H2O");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1)],
      new Decimal("249.0889")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/IN_H2O_39dot2DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1)],
      new Decimal("249.082")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/IN_H2O_60DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1)],
      new Decimal("248.84")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/IN_HG");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1)],
      new Decimal("3386.389")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/IN_HG_32DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1)],
      new Decimal("3386.38")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/IN_HG_60DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1)],
      new Decimal("3376.85")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/IU");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/IU"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/IU-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IU"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/IU-PER-MilliGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IU"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/IU-PER-MilliL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IU"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/J");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/J-M-PER-MOL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/J-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/J-M2-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/J-PER-CentiM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/J-PER-CentiM2-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/J-PER-CentiM3-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/J-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/J-PER-GM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/J-PER-GM-DEG_C");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/J-PER-GM-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/J-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/J-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/J-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/J-PER-KiloGM-DEG_C");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/J-PER-KiloGM-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/J-PER-KiloGM-K-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/J-PER-KiloGM-K-PA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/J-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/J-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/J-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/J-PER-M3-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/J-PER-M4");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -4),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/J-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/J-PER-MOL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/J-PER-MOL-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/J-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/J-PER-T");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/T"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/J-PER-T2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/T"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/J-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/J-SEC-PER-MOL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/K");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/K-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/K-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/K-M-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/K-M-PER-W");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/K-M2-PER-KiloGM-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/K-PA-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/K-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/K-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/K-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/K-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/K-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/K-PER-PA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/K-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/K-PER-SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/K-PER-T");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/T"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/K-PER-W");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/K-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/K2");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), 2)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KAT");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KAT-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KAT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KAT-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KAT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KAT-PER-MicroL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KAT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KIP_F");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), 1)],
      new Decimal("1000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KIP_F-PER-IN2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KIP_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MI_N"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KN-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KY");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KibiBIT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BIT"), 1)],
      new Decimal("1024.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KibiBIT-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KibiBIT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KibiBIT-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KibiBIT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KibiBIT-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KibiBIT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KibiBYTE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BYTE"), 1)],
      new Decimal("1024.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/Kilo-FT3");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M3"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1)],
      new Decimal("1000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloA-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloA-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloA-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloA-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloBAR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), 1)],
      new Decimal("1000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloBAUD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAUD"), 1)],
      new Decimal("1000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloBIT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BIT"), 1)],
      new Decimal("1000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloBIT-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloBIT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloBQ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BQ"), 1)],
      new Decimal("1000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloBQ-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloBQ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloBTU_IT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1)],
      new Decimal("1000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloBTU_IT-PER-FT2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloBTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloBTU_IT-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloBTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloBTU_TH");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_TH"), 1)],
      new Decimal("1000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloBTU_TH-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloBTU_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloBYTE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BYTE"), 1)],
      new Decimal("1000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloBYTE-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloBYTE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1)],
      new Decimal("1000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloC-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloC-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloCAL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("4184.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloCAL-PER-CentiM-SEC-DEG_C");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloCAL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloCAL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloCAL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloCAL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloCAL-PER-GM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloCAL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloCAL-PER-GM-DEG_C");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloCAL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloCAL-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloCAL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloCAL-PER-MOL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloCAL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloCAL-PER-MOL-DEG_C");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloCAL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloCAL-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloCAL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloCAL_IT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CAL_IT"), 1)],
      new Decimal("1000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloCAL_IT-PER-GM-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloCAL_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloCAL_IT-PER-HR-M-DEG_C");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloCAL_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloCAL_Mean");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("4190.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloCAL_TH");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CAL_TH"), 1)],
      new Decimal("1000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloCAL_TH-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloCAL_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloCAL_TH-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloCAL_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloCAL_TH-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloCAL_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloCD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CD"), 1)],
      new Decimal("1000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloCI");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CI"), 1)],
      new Decimal("1000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloCOUNT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloCOUNT"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloCi");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CI"), 1)],
      new Decimal("1000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloCubicFT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT3"), 1)],
      new Decimal("1000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloEV");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/EV"), 1)],
      new Decimal("1000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloEV-PER-MicroM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloEV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloFARAD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/FARAD"), 1)],
      new Decimal("1000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGAUSS");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAUSS"), 1)],
      new Decimal("1000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-CentiM-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-CentiM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-M-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-M-PER-SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-M2-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-MilliM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), 2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-CentiM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-CentiM3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-CentiM3-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-CentiM3-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-DAY-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-DAY-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-DeciM3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciM"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-DeciM3-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciM"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-DeciM3-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciM"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-FT2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-GigaJ");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GigaJ"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-HA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HA"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-HA-YR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HA"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-HR-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-HR-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-J");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-KiloM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-KiloM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-KiloMOL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloMOL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-L-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-L-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-M-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-M-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-M-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-M-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-M2-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-M2-PA-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-M2-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-M2-SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-M3-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-M3-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-M3-PA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-M3-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-MIN-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-MIN-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-MOL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-MegaBTU_IT");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaBTU_IT"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-MilliM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-PA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-PA-SEC-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-SEC-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-SEC-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-SEC-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-SEC-PA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-SEC3-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-YR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM2-PER-SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM_F");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM_F"), 1)],
      new Decimal("1000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM_F-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM_F-M-PER-CentiM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM_F-M-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM_F-PER-CentiM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM_F-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM_F-PER-MilliM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGRAY");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GRAY"), 1)],
      new Decimal("1000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloH");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/H"), 1)],
      new Decimal("1000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloHZ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/HZ"), 1)],
      new Decimal("1000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloHZ-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloHZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloINDIV");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloINDIV"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloJ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("1000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloJ-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloJ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloJ-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloJ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloJ-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloJ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloJ-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloJ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloJ-PER-KiloGM-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloJ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloJ-PER-KiloV");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloJ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloV"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloJ-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloJ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloJ-PER-MOL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloJ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloJ-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloJ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1)],
      new Decimal("1000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloL-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloLB");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1)],
      new Decimal("1000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloLB-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloLB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloLB_F");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), 1)],
      new Decimal("1000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloLB_F-FT-PER-A");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloLB_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloLB_F-FT-PER-LB");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloLB_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloLB_F-PER-FT");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloLB_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloLB_F-PER-IN2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloLB_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloLM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/LM"), 1)],
      new Decimal("1000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("1000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloM-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloM-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloM-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloM-PER-SEC-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloM-PER-SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloM2");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloM"), 2)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloM2-PER-SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloM"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloM3-PER-SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloMIL_Circ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIL_Circ"), 1)],
      new Decimal("1000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloMOL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1)],
      new Decimal("1000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloMOL-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloMOL-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloMOL-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloMOL-PER-M3-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloMOL-PER-M3-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloMOL-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloMOL-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1)],
      new Decimal("1000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloN-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloN-M-PER-DEG");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloN-M-PER-DEG-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloN-M-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloN-M-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloN-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloN-PER-CentiM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloN-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloN-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloN-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloN-PER-MilliM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloOHM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/OHM"), 1)],
      new Decimal("1000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloOHM-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloOHM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloOHM-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloOHM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloOHM-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloOHM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloOHM-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloOHM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloPA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1)],
      new Decimal("1000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloPA-M2-PER-GM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloPA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloPA-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloPA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloPA-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloPA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloPA-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloPA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloPA-PER-MilliM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloPA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloPA_A");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1)],
      new Decimal("1000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloPOISE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/POISE"), 1)],
      new Decimal("1000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloPOND");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/POND"), 1)],
      new Decimal("1000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/R"), 1)],
      new Decimal("1000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloS");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/S"), 1)],
      new Decimal("1000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloS-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloS"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloSEC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1)],
      new Decimal("1000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/T"), 1)],
      new Decimal("1000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloTONNE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/TONNE"), 1)],
      new Decimal("1000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloTONNE-PER-YR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloTONNE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloTON_Metric");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_Metric"), 1)],
      new Decimal("1000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloV");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1)],
      new Decimal("1000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloV-A");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloV-A-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloV-A-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloV-A_Reactive");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A_Reactive"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloV-A_Reactive-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A_Reactive"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloV-A_Reactive-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A_Reactive"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloV-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloVA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/VA"), 1)],
      new Decimal("1000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloVA-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloVA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloVA-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloVA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloVAR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/VAR"), 1)],
      new Decimal("1000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloVAR-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloVAR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloVAR-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloVAR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloW");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1)],
      new Decimal("1000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloW-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloW"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloW-HR-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloW"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloW-PER-M-DEG_C");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloW"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloW-PER-M-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloW"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloW-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloW"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloW-PER-M2-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloW"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloWB");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/WB"), 1)],
      new Decimal("1000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloWB-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloWB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloYR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/YR"), 1)],
      new Decimal("1000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/L");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciM3"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/L-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/L-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/L-PER-DAY-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/L-PER-DAY-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/L-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/L-PER-HR-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/L-PER-HR-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/L-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/L-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/L-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/L-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/L-PER-MIN-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/L-PER-MIN-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/L-PER-MOL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/L-PER-MOL-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/L-PER-MicroMOL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroMOL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/L-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/L-PER-SEC-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/L-PER-SEC-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/L-PER-SEC-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CD"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("0.31830988618")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LANGLEY");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J-PER-M2"), 1)],
      new Decimal("41840.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LA_FT");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CD"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
      ],
      new Decimal("0.31830988618")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("0.45359237")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-DEG_R");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_R"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-FT-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-FT2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-FT2-PER-GAL_UK-LB_F-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-FT2-PER-GAL_US-LB_F-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-FT2-PER-IN3-LB_F-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-HR-PER-FT3-GAL_UK");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-HR-PER-FT3-GAL_US");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-HR-PER-FT3-IN3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-HR-PER-FT3-YD3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-HR-PER-FT6");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -6),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-HR-PER-GAL_UK-FT3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-HR-PER-GAL_UK-IN3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-HR-PER-GAL_UK-YD3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-HR-PER-GAL_UK2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-HR-PER-GAL_US-FT3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-HR-PER-GAL_US-IN3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-HR-PER-GAL_US-YD3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-HR-PER-GAL_US2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -6),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-HR-PER-IN3-FT3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-HR-PER-IN3-GAL_UK");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-HR-PER-IN3-GAL_US");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-HR-PER-IN3-YD3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-HR-PER-IN6");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -6),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-IN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-IN-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-IN2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-IN2-PER-FT3-LB_F-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-IN2-PER-GAL_UK-LB_F-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-IN2-PER-GAL_US-LB_F-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-IN2-PER-IN3-LB_F-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-MIN-PER-FT3-GAL_UK");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-MIN-PER-FT3-GAL_US");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-MIN-PER-FT3-IN3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-MIN-PER-FT3-YD3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-MIN-PER-FT6");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -6),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-MIN-PER-GAL_UK-FT3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-MIN-PER-GAL_UK-IN3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-MIN-PER-GAL_UK-YD3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-MIN-PER-GAL_UK2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-MIN-PER-GAL_US-FT3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-MIN-PER-GAL_US-IN3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-MIN-PER-GAL_US-YD3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-MIN-PER-GAL_US2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -6),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-MIN-PER-IN3-FT3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-MIN-PER-IN3-GAL_UK");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-MIN-PER-IN3-GAL_US");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-MIN-PER-IN3-YD3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-MIN-PER-IN6");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -6),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-AC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/AC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-FT");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-FT-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-FT-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-FT-LB_F-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-FT-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-FT-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-FT2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-FT3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-FT3-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-FT3-PSI");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PSI"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-GAL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-GAL_IMP");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_IMP"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-GAL_UK");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-GAL_US");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-HR-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-HR-PSI");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PSI"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-IN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-IN2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-IN3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-IN3-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-IN3-PSI");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PSI"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-LB");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-MIN-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-MIN-PSI");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PSI"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-PSI");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PSI"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-SEC-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-SEC-PSI");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PSI"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-YD");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-YD2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-YD3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-SEC-PER-FT3-GAL_UK");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-SEC-PER-FT3-GAL_US");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-SEC-PER-FT3-IN3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-SEC-PER-FT3-YD3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-SEC-PER-FT6");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -6),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-SEC-PER-GAL_UK-FT3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-SEC-PER-GAL_UK-IN3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-SEC-PER-GAL_UK-YD3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-SEC-PER-GAL_UK2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-SEC-PER-GAL_US-FT3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-SEC-PER-GAL_US-IN3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-SEC-PER-GAL_US-YD3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-SEC-PER-GAL_US2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -6),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-SEC-PER-IN3-FT3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-SEC-PER-IN3-GAL_UK");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-SEC-PER-IN3-GAL_US");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-SEC-PER-IN3-YD3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-SEC-PER-IN6");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -6),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SLUG"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB_F-FT");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB_F-FT-PER-IN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB_F-IN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB_F-IN-PER-IN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB_F-PER-FT");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB_F-PER-FT2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB_F-PER-IN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB_F-PER-IN2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB_F-PER-IN2-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB_F-PER-IN2-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB_F-PER-LB");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB_F-PER-YD");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB_F-SEC-PER-FT2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB_F-SEC-PER-IN2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB_M");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("0.45359237")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB_T");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("0.3732417216")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CD"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SR"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LM-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LM-PER-FT2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LM-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LM-PER-W");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LM-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LUX");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LUX-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LUX"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LUX-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LUX"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LY");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("9460730472580800.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LunarMass");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("73460000000000000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M-K-PER-W");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M-PA-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M-PER-DEG_C-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M-PER-FARAD");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FARAD"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M-PER-HA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HA"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M-PER-PA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M-PER-RAD");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/RAD"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M-PER-SEC-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M-PER-SEC-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M-PER-SEC-PA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M-PER-SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M-PER-V-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M-PER-YR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M-SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M0dot");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M0dot"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-HR-DEG_C-PER-KiloCAL_IT");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloCAL_IT"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-HZ");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HZ"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-HZ2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HZ"), 2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-HZ3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HZ"), 3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-HZ4");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HZ"), 4),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-K-PER-W");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-PER-GM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-PER-GM_DRY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM_DRY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-PER-HA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HA"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-PER-HA-YR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HA"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-PER-HZ");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HZ"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-PER-HZ-DEG");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HZ"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-PER-HZ2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HZ"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-PER-J");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-PER-KiloW");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloW"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-PER-MOL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-PER-N");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-PER-SEC-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-PER-SEC-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-PER-SEC-PA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-PER-SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-PER-SEC2-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-PER-SR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-PER-SR-J");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-PER-V-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-PER-W");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-SEC-PER-RAD");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/RAD"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-SR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SR"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M3");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M3-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M3-PER-C");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M3-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M3-PER-DAY-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M3-PER-DAY-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M3-PER-HA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HA"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M3-PER-HA-YR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HA"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M3-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M3-PER-HR-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M3-PER-HR-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M3-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M3-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M3-PER-KiloGM-SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M3-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M3-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M3-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M3-PER-MIN-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M3-PER-MIN-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M3-PER-MOL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M3-PER-MOL-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M3-PER-PA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M3-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M3-PER-SEC-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M3-PER-SEC-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M3-PER-SEC-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M3-PER-SEC-PA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M3-PER-SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M3-PER-YR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M4");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 4)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M4-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 4),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M5");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 5)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M6");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 6)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MACH");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MACH"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MESH");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MESH"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MHO");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/S"), 1)],
      new Decimal("1.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MHO_Stat");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/S-PER-M"), 1)],
      new Decimal("1.1126500561E-12")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MI");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("1609.344")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MI-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MI"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MI-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MI"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MI-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MI"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MI2");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MI"), 2)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MI3");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MI"), 3)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MIL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/RAD"), 1)],
      new Decimal("0.00098174770424681038701957605727484")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MILLE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MILLE"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MILLION");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/ONE"), 1)],
      new Decimal("1000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MIL_Circ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M2"), 1)],
      new Decimal("5.067075E-10")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1)],
      new Decimal("60.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MIN-PER-KiloM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MIN-PER-MI");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MI"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MIN-PER-NUM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MIN_Angle");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/RAD"), 1)],
      new Decimal("0.000290888209")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MIN_Sidereal");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1)],
      new Decimal("59.83617")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MI_N");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("1852.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MI_N-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MI_N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MI_N-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MI_N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MI_UK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MI_UK"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MI_UK3");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MI_UK"), 3)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MI_US");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("1609.347")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MI_US-PER-SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MI_US"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MI_US2");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MI_US"), 2)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MO");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1)],
      new Decimal("2551442.976")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MO-PER-NUM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MO"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOHM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC-PER-KiloGM"), 1)],
      new Decimal("1000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL-DEG_C");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL-PER-DeciM3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciM"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL-PER-GM-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL-PER-KiloGM-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL-PER-KiloGM-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL-PER-KiloGM-PA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL-PER-L-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL-PER-L-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL-PER-M2-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL-PER-M2-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL-PER-M2-SEC-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL-PER-M2-SEC-M-SR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL-PER-M2-SEC-SR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL-PER-M3-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL-PER-M3-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL-PER-M3-PA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL-PER-M3-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL-PER-MOL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL-PER-TONNE");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TONNE"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL_LB");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1)],
      new Decimal("453.59237")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL_LB-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL_LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL_LB-PER-LB");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL_LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL_LB-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL_LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL_LB-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL_LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOMME_Pearl");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("3.75")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOMME_Textile");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("0.00434")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MO_MeanGREGORIAN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1)],
      new Decimal("2629746.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MO_MeanJulian");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1)],
      new Decimal("2629800.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MO_Synodic");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1)],
      new Decimal("2551442.976")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MX");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/WB"), 1)],
      new Decimal("1E-8")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M_H2O");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1)],
      new Decimal("9806.65")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MebiBIT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BIT"), 1)],
      new Decimal("1048576.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MebiBIT-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MebiBIT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MebiBIT-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MebiBIT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MebiBIT-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MebiBIT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MebiBYTE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BYTE"), 1)],
      new Decimal("1048576.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1)],
      new Decimal("1000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaA-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaBAR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), 1)],
      new Decimal("1000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaBAUD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAUD"), 1)],
      new Decimal("1000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaBIT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BIT"), 1)],
      new Decimal("1000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaBIT-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaBIT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaBQ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BQ"), 1)],
      new Decimal("1000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaBQ-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaBQ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaBTU_IT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1)],
      new Decimal("1000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaBTU_IT-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaBTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaBYTE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BYTE"), 1)],
      new Decimal("1000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaBYTE-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaBYTE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1)],
      new Decimal("1000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaC-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaC-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaCCY_USD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CCY_USD"), 1)],
      new Decimal("1000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaCCY_USD-PER-FLIGHT");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaCCY_USD"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FLIGHT"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaCCY_USD-PER-YR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaCCY_USD"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaDOLLAR_US");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaDOLLAR_US"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaDOLLAR_US-PER-FLIGHT");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaDOLLAR_US"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FLIGHT"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaEV");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/EV"), 1)],
      new Decimal("1000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaEV-FemtoM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaEV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FemtoM"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaEV-PER-CentiM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaEV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaEV-PER-SpeedOfLight");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaEV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SpeedOfLight"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaFLOPS");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/FLOPS"), 1)],
      new Decimal("1000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaGM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1)],
      new Decimal("1000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaGM-PER-HA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HA"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaGM-PER-HA-YR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HA"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaGM-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaGRAY");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GRAY"), 1)],
      new Decimal("1000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaHZ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/HZ"), 1)],
      new Decimal("1000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaHZ-KiloM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaHZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloM"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaHZ-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaHZ"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaHZ-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaHZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaHZ-PER-T");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaHZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/T"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaINDIV");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaINDIV"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaJ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("1000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaJ-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaJ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaJ-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaJ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaJ-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaJ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaJ-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaJ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaJ-PER-M2-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaJ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaJ-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaJ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaJ-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaJ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), 1)],
      new Decimal("1000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1)],
      new Decimal("1000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaLB_F");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), 1)],
      new Decimal("1000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1)],
      new Decimal("1000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaN-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaN"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaN-M-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaN-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaN-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaOHM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/OHM"), 1)],
      new Decimal("1000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaOHM-KiloM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaOHM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloM"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaOHM-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaOHM"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaOHM-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaOHM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaOHM-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaOHM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaOHM-PER-KiloM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaOHM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaOHM-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaOHM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaPA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1)],
      new Decimal("1000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaPA-L-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaPA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaPA-M0dot5");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaPA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M0dot"), 5),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaPA-M3-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaPA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaPA-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaPA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaPA-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaPA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaPSI");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PSI"), 1)],
      new Decimal("1000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaS");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/S"), 1)],
      new Decimal("1000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaS-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaS"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaSEC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1)],
      new Decimal("1000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaTOE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/TOE"), 1)],
      new Decimal("1000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaTON");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON"), 1)],
      new Decimal("1000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaTONNE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/TONNE"), 1)],
      new Decimal("1000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaTONNE-PER-YR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaTONNE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaV");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1)],
      new Decimal("1000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaV-A");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaV-A-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaV-A_Reactive");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A_Reactive"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaV-A_Reactive-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A_Reactive"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaV-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaVA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/VA"), 1)],
      new Decimal("1000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaVA-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaVA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaVAR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/VAR"), 1)],
      new Decimal("1000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaVAR-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaVAR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaW");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1)],
      new Decimal("1000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaW-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaW"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaYR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/YR"), 1)],
      new Decimal("1000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1)],
      new Decimal("0.000001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroA-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroATM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/ATM"), 1)],
      new Decimal("0.000001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroBAR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), 1)],
      new Decimal("0.000001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroBQ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BQ"), 1)],
      new Decimal("0.000001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroBQ-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroBQ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroBQ-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroBQ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1)],
      new Decimal("0.000001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroC-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroC-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroCI");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CI"), 1)],
      new Decimal("0.000001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroCi");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CI"), 1)],
      new Decimal("0.000001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroFARAD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/FARAD"), 1)],
      new Decimal("0.000001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroFARAD-PER-KiloM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroFARAD"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroFARAD-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroFARAD"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroG");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/G"), 1)],
      new Decimal("0.000001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroGAL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroGAL"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroGAL-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroGAL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroGALILEO");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroGALILEO"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroGALILEO-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroGALILEO"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroGM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1)],
      new Decimal("0.000001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroGM-PER-CentiM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroGM-PER-CentiM2-WK");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/WK"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroGM-PER-DeciL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroGM-PER-GM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroGM-PER-GM-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroGM-PER-GM-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroGM-PER-IN2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroGM-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroGM-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroGM-PER-L-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroGM-PER-L-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroGM-PER-M2-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroGM-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroGM-PER-M3-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroGM-PER-M3-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroGM-PER-M3-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroGM-PER-MilliGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroGM-PER-MilliL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroGRAY");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GRAY"), 1)],
      new Decimal("0.000001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroGRAY-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroGRAY"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroGRAY-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroGRAY"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroGRAY-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroGRAY"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroH");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/H"), 1)],
      new Decimal("0.000001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroH-PER-KiloOHM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloOHM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroH-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroH-PER-OHM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OHM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroIN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 1)],
      new Decimal("0.000001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroJ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("0.000001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroJ-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroJ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroKAT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KAT"), 1)],
      new Decimal("0.000001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroKAT-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroKAT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1)],
      new Decimal("0.000001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroL-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("0.000001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroM-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroM-PER-L-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroM-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroM-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroM-PER-MilliL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroM-PER-N");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroM-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroM-PER-SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroM2");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroM"), 2)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroM3");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroM"), 3)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroM3-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroM3-PER-MilliL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroMHO");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MHO"), 1)],
      new Decimal("0.000001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroMOL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1)],
      new Decimal("0.000001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroMOL-PER-GM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroMOL-PER-GM-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroMOL-PER-GM-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroMOL-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroMOL-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroMOL-PER-L-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroMOL-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroMOL-PER-M2-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroMOL-PER-M2-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroMOL-PER-M2-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroMOL-PER-M2-SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroMOL-PER-MOL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroMOL-PER-MicroMOL-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroMOL"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroMOL-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroMOL2-PER-M4-SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroMOL"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -4),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1)],
      new Decimal("0.000001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroN-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroN"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroN-M-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroOHM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/OHM"), 1)],
      new Decimal("0.000001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroOHM-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroOHM"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroPA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1)],
      new Decimal("0.000001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroPOISE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/POISE"), 1)],
      new Decimal("0.000001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroRAD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/RAD"), 1)],
      new Decimal("0.000001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroS");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/S"), 1)],
      new Decimal("0.000001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroS-PER-CentiM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroS"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroS-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroS"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroS2-PER-CentiM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroS"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroSEC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1)],
      new Decimal("0.000001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroSV");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SV"), 1)],
      new Decimal("0.000001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroSV-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroSV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroSV-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroSV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroSV-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroSV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/T"), 1)],
      new Decimal("0.000001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroTORR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/TORR"), 1)],
      new Decimal("0.000001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroV");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1)],
      new Decimal("0.000001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroV-A");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroV-A-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroV-A_Reactive");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A_Reactive"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroV-A_Reactive-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A_Reactive"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroV-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroVA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/VA"), 1)],
      new Decimal("0.000001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroVA-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroVA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroVAR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/VAR"), 1)],
      new Decimal("0.000001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroVAR-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroVAR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroW");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1)],
      new Decimal("0.000001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroW-PER-CentiM2-MicroM-SR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroW"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroW-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroW"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilLength");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("0.0000254")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1)],
      new Decimal("0.001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliA-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliA-HR-PER-GM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliA-IN2-PER-LB_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliA-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliA-PER-IN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliA-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliA-PER-L-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliA-PER-LB_F-IN2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliA-PER-MilliM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliA-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliARCSEC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/ARCSEC"), 1)],
      new Decimal("0.001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliBAR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), 1)],
      new Decimal("0.001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliBAR-L-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliBAR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliBAR-M3-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliBAR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliBAR-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliBAR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliBAR-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliBAR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliBAR_A");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR_A"), 1)],
      new Decimal("0.001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliBQ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BQ"), 1)],
      new Decimal("0.001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliBQ-PER-GM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliBQ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliBQ-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliBQ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliBQ-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliBQ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliBQ-PER-M2-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliBQ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1)],
      new Decimal("0.001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliC-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliC-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliC-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliCD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CD"), 1)],
      new Decimal("0.001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliCI");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CI"), 1)],
      new Decimal("0.001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliCi");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CI"), 1)],
      new Decimal("0.001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliDARCY");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/DARCY"), 1)],
      new Decimal("0.001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliDEG_C");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), 1)],
      new Decimal("0.001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliFARAD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/FARAD"), 1)],
      new Decimal("0.001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliG");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/G"), 1)],
      new Decimal("0.001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGAL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GALILEO"), 1)],
      new Decimal("0.001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGAL-PER-MO");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGALILEO"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MO"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGALILEO");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GALILEO"), 1)],
      new Decimal("0.001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGALILEO-PER-MO");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGALILEO"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MO"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1)],
      new Decimal("0.001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-HR-PER-L-CentiM3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-HR-PER-L-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-HR-PER-L2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-HR-PER-M3-CentiM3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-HR-PER-M3-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-HR-PER-M6");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -6),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-MIN-PER-L-CentiM3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-MIN-PER-L-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-MIN-PER-L2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-MIN-PER-M3-CentiM3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-MIN-PER-M3-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-MIN-PER-M6");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -6),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-CentiM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-DAY-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-DAY-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-DeciL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-DeciM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-GM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-GM-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-HA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HA"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-HR-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-HR-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-KiloGM-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-L-CentiPOISE");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiPOISE"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-L-MilliPA-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliPA"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-L-PA-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-L-POISE");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/POISE"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-M2-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-M2-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-M2-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-M3-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-M3-CentiPOISE");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiPOISE"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-M3-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-M3-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-M3-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-M3-MilliPA-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliPA"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-M3-PA-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-M3-POISE");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/POISE"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-M3-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-MIN-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-MIN-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-MilliL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-SEC-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-SEC-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-SEC-PER-L-CentiM3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-SEC-PER-L-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-SEC-PER-L2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-SEC-PER-M3-CentiM3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-SEC-PER-M3-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-SEC-PER-M6");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -6),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGRAY");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GRAY"), 1)],
      new Decimal("0.001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGRAY-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGRAY"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGRAY-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGRAY"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGRAY-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGRAY"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliH");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/H"), 1)],
      new Decimal("0.001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliH-PER-KiloOHM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloOHM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliH-PER-OHM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OHM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliHZ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/HZ"), 1)],
      new Decimal("0.001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliIN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 1)],
      new Decimal("0.001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliJ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("0.001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliJ-PER-GM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliJ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliJ-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliJ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliJ-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliJ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), 1)],
      new Decimal("0.001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliK-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliK-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliKAT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KAT"), 1)],
      new Decimal("0.001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliKAT-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliKAT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1)],
      new Decimal("0.001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliL-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliL-PER-CentiM2-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliL-PER-CentiM2-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliL-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliL-PER-DAY-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliL-PER-DAY-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliL-PER-GM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliL-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliL-PER-HR-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliL-PER-HR-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliL-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliL-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliL-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliL-PER-M2-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliL-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliL-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliL-PER-MIN-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliL-PER-MIN-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliL-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliL-PER-SEC-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliL-PER-SEC-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("0.001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliM-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliM-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliM-PER-DEG_C-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliM-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliM-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliM-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliM-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliM-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliM-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliM-PER-SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliM-PER-YR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliM2");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), 2)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliM2-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliM3");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), 3)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliM3-PER-GM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliM3-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliM3-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliM4");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), 4)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliMOL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1)],
      new Decimal("0.001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliMOL-PER-GM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliMOL-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliMOL-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliMOL-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliMOL-PER-M2-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliMOL-PER-M2-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliMOL-PER-M2-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliMOL-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliMOL-PER-M3-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliMOL-PER-MOL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliM_H2O");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1)],
      new Decimal("9.80665")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliM_HG");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1)],
      new Decimal("133.322387415")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliM_HGA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1)],
      new Decimal("133.322387415")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1)],
      new Decimal("0.001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliN-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliN"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliN-M-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliN-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliOHM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/OHM"), 1)],
      new Decimal("0.001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliOHM-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliOHM"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliOHM-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliOHM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliOHM-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliOHM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliOHM-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliOHM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliOSM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/OSM"), 1)],
      new Decimal("0.001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliOSM-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliOSM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliPA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1)],
      new Decimal("0.001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliPA-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliPA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliPA-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliPA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliPA-SEC-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliPA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliPA-SEC-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliPA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/R"), 1)],
      new Decimal("0.001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliRAD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/RAD"), 1)],
      new Decimal("0.001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliRAD_R");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/RAD_R"), 1)],
      new Decimal("0.001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliRAD_R-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliRAD_R"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliR_man");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/R_man"), 1)],
      new Decimal("0.001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliS");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/S"), 1)],
      new Decimal("0.001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliS-PER-CentiM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliS"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliS-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliS"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliSEC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1)],
      new Decimal("0.001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliSV");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SV"), 1)],
      new Decimal("0.001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliSV-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliSV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliSV-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliSV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliSV-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliSV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/T"), 1)],
      new Decimal("0.001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliTORR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/TORR"), 1)],
      new Decimal("0.001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliV");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1)],
      new Decimal("0.001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliV-A");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliV-A-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliV-A_Reactive");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A_Reactive"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliV-A_Reactive-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A_Reactive"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliV-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliV-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliV-PER-V");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliVA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/VA"), 1)],
      new Decimal("0.001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliVA-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliVA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliVAR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/VAR"), 1)],
      new Decimal("0.001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliVAR-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliVAR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliW");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1)],
      new Decimal("0.001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliW-PER-CentiM2-MicroM-SR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliW"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliW-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliW"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliW-PER-M2-NanoM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliW"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliW-PER-M2-NanoM-SR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliW"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliW-PER-MilliGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliW"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliWB");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/WB"), 1)],
      new Decimal("0.001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MillionUSD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MillionUSD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MillionUSD-PER-YR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MillionUSD"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-CentiM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-M-PER-A");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-M-PER-ARCMIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/ARCMIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-M-PER-DEG");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-M-PER-DEG-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-M-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-M-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-M-PER-M-RAD");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/RAD"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-M-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-M-PER-MIN_Angle");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN_Angle"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-M-PER-RAD");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/RAD"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-M-PER-W0dot5");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W0dot"), -5),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-M-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-M-SEC-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-M-SEC-PER-RAD");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/RAD"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-M2-PER-A");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-M2-PER-KiloGM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-PER-A");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-PER-C");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-PER-CentiM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-PER-CentiM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-PER-MilliM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-PER-MilliM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-PER-RAD");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/RAD"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-SEC-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-SEC-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-SEC-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-SEC-PER-RAD");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/RAD"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NAT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/NAT"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NAT-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NAT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NCM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1)],
      new Decimal("0.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NCM_1ATM_0DEG_C_NL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1)],
      new Decimal("0.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NP");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/NP"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NP-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NP"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M3"), 1)],
      new Decimal("0.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NTU");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/NTU"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NUM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NUM-PER-CentiM-KiloYR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloYR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NUM-PER-GM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NUM-PER-HA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HA"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NUM-PER-HA-YR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HA"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NUM-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NUM-PER-HectoGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HectoGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NUM-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NUM-PER-KiloM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NUM-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NUM-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NUM-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NUM-PER-M2-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NUM-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NUM-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NUM-PER-MicroL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NUM-PER-MilliGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NUM-PER-MilliL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NUM-PER-MilliM3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NUM-PER-NanoL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NUM-PER-PicoL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PicoL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NUM-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NUM-PER-YR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1)],
      new Decimal("1E-9")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoA-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoBQ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BQ"), 1)],
      new Decimal("1E-9")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoBQ-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoBQ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1)],
      new Decimal("1E-9")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoFARAD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/FARAD"), 1)],
      new Decimal("1E-9")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoFARAD-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoFARAD"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoGM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1)],
      new Decimal("1E-9")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoGM-PER-CentiM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoGM-PER-CentiM2-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoGM-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoGM-PER-DeciL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoGM-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoGM-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoGM-PER-M2-PA-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoGM-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoGM-PER-MicroL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoGM-PER-MilliGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoGM-PER-MilliL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoGRAY");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GRAY"), 1)],
      new Decimal("1E-9")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoGRAY-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoGRAY"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoGRAY-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoGRAY"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoGRAY-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoGRAY"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoH");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/H"), 1)],
      new Decimal("1E-9")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoH-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoJ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("1E-9")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoJ-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoJ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoKAT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KAT"), 1)],
      new Decimal("1E-9")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoKAT-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoKAT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1)],
      new Decimal("1E-9")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("1E-9")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoM-PER-CentiM-MegaPA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaPA"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoM-PER-CentiM-PSI");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PSI"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoM-PER-MilliM-MegaPA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaPA"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoM2");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoM"), 2)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoMOL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1)],
      new Decimal("1E-9")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoMOL-PER-CentiM3-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoMOL-PER-GM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoMOL-PER-GM-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoMOL-PER-GM-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoMOL-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoMOL-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoMOL-PER-L-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoMOL-PER-L-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoMOL-PER-M2-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoMOL-PER-M2-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoMOL-PER-MicroGM-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroGM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoMOL-PER-MicroMOL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroMOL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoMOL-PER-MicroMOL-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroMOL"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1)],
      new Decimal("1E-9")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoN-M-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoOHM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/OHM"), 1)],
      new Decimal("1E-9")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoOHM-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoOHM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoS");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/S"), 1)],
      new Decimal("1E-9")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoS-PER-CentiM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoS"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoS-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoS"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoSEC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1)],
      new Decimal("1E-9")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoSV");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SV"), 1)],
      new Decimal("1E-9")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoSV-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoSV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoSV-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoSV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoSV-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoSV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/T"), 1)],
      new Decimal("1E-9")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoV");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1)],
      new Decimal("1E-9")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoV-A");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoV-A_Reactive");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A_Reactive"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoVA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/VA"), 1)],
      new Decimal("1E-9")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoVAR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/VAR"), 1)],
      new Decimal("1E-9")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoW");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1)],
      new Decimal("1E-9")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoW-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoW"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OCT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/OCT"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OCTET");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BIT"), 1)],
      new Decimal("8.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OCTET-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OCTET"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OERSTED");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/A-PER-M"), 1)],
      new Decimal("79.5774715")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OERSTED-CentiM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OERSTED"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OHM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OHM-CentiM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OHM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OHM-KiloM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OHM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloM"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OHM-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OHM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OHM-M2-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OHM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OHM-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OHM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OHM-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OHM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OHM-PER-KiloM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OHM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OHM-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OHM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OHM-PER-MI");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OHM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MI"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OHM_Ab");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/OHM"), 1)],
      new Decimal("1E-9")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OHM_CIRC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/OHM_CIRC"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OHM_CIRC-MIL-PER-FT");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OHM_CIRC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OHM_Stat");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/OHM"), 1)],
      new Decimal("898760000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OKTA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/OKTA"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ONE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/ONE"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ONE-PER-ONE");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/ONE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/ONE"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OSM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/OSM"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1)],
      new Decimal("0.0625")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-FT");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-FT-HR-PER-IN3-LB");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-FT-SEC-PER-IN3-LB");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-FT2-PER-IN3-LB_F-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-HR-PER-IN3-FT3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-HR-PER-IN3-GAL_UK");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-HR-PER-IN3-GAL_US");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-HR-PER-IN3-YD3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-HR-PER-IN6");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -6),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-IN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-IN2-PER-IN3-LB_F-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-MIN-PER-IN3-FT3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-MIN-PER-IN3-GAL_UK");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-MIN-PER-IN3-GAL_US");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-MIN-PER-IN3-YD3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-MIN-PER-IN6");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -6),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-PER-FT2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-PER-GAL_IMP");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_IMP"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-PER-GAL_UK");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-PER-GAL_US");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-PER-IN2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-PER-IN3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-PER-YD2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-PER-YD3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-SEC-PER-IN3-FT3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-SEC-PER-IN3-GAL_UK");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-SEC-PER-IN3-GAL_US");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-SEC-PER-IN3-YD3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-SEC-PER-IN6");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -6),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ_F");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1)],
      new Decimal("0.278013875")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ_F-IN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ_F-PER-IN3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ_M");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("0.028349523125")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ_TROY");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("0.0311034768")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ_VOL_UK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M3"), 1)],
      new Decimal("0.0000284130625")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ_VOL_UK-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ_VOL_UK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ_VOL_UK-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ_VOL_UK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ_VOL_UK-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ_VOL_UK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ_VOL_UK-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ_VOL_UK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ_VOL_US");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M3"), 1)],
      new Decimal("0.0000295735296")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ_VOL_US-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ_VOL_US"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ_VOL_US-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ_VOL_US"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ_VOL_US-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ_VOL_US"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ_VOL_US-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ_VOL_US"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/P");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1)],
      new Decimal("0.00980665")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PA-L-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PA-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PA-M-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PA-M-PER-SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PA-M0dot5");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M0dot"), 5),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PA-M2-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PA-M3-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PA-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PA-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PA-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PA-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PA-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PA-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PA-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PA-SEC-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PA-SEC-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PA-SEC-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PA-SEC-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PA-SEC-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PA2-PER-SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PA2-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PARSEC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("30856780000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PCA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("0.0042333")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PDL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1)],
      new Decimal("0.138254954376")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PDL-FT");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PDL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PDL-IN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PDL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PDL-PER-FT2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PDL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PDL-PER-IN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PDL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PDL-PER-IN2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PDL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PDL-SEC-PER-FT2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PDL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PDL-SEC-PER-IN2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PDL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PENNYWEIGHT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("0.00155517384")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-ANGSTROM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/ANGSTROM"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-CentiM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-CentiM3");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -3)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-DEG_C");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-EV-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/EV"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-EV2");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/EV"), -2)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-FT3");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-GM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-GigaEV2");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GigaEV"), -2)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-H");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/H"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-IN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-IN2");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -2)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-IN3");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-J");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-J-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-J2");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), -2)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-KiloGM-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-KiloGM2");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -2)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-KiloM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloM"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-KiloV-A-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloV"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-KiloVA-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloVA"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-LB");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-M-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-M-NanoM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-M-NanoM-SR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-M-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-M-SR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-M2-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-M3-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-MILLE-PSI");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MILLE"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PSI"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-MO");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MO"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-MOL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-MegaK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaK"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-MegaPA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaPA"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-MicroM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroM"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-MicroMOL-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroMOL"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-MilliGM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-MilliL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-MilliM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-MilliM3");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), -3)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-MilliSEC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliSEC"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-NanoM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoM"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-OZ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-PA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-PA-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-PERCENT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-PSI");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PSI"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-PicoM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PicoM"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-PlanckMass2");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PlanckMass"), -2)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-RAD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/RAD"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-SEC-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-SEC-M2-SR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-SEC-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-SEC-SR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-SEC-SR-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-SR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SR"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-T-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/T"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-T-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/T"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-TON");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-TONNE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/TONNE"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-V");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-V-A-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-VA-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/VA"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-WB");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/WB"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-WK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/WK"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-YD3");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), -3)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-YR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/YR"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), 1)],
      new Decimal("0.01")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-FT-HR-PER-LB");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-FT-SEC-PER-LB");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-FT2-PER-LB_F-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-HR-PER-CentiM3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-HR-PER-FT3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-HR-PER-GAL_UK");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-HR-PER-GAL_US");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-HR-PER-IN3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-HR-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-HR-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-HR-PER-YD3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-IN2-PER-LB_F-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-MIN-PER-CentiM3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-MIN-PER-FT3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-MIN-PER-GAL_UK");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-MIN-PER-GAL_US");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-MIN-PER-IN3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-MIN-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-MIN-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-MIN-PER-YD3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-PER-100KiloCount");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/100KiloCount"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-PER-10KiloCount");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/10KiloCount"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-PER-CentiPOISE");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiPOISE"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-PER-DEG");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-PER-DEG_C");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-PER-DecaK");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DecaK"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-PER-DecaKiloCOUNT");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DecaKiloCOUNT"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-PER-HUNDRED");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HUNDRED"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-PER-HUNDRED-THOUSAND");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HUNDRED"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/THOUSAND"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-PER-HectoBAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HectoBAR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-PER-HectoCOUNT");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HectoCOUNT"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-PER-HectoKiloCOUNT");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(
          getUnit("http://qudt.org/vocab/unit/HectoKiloCOUNT"),
          -1
        ),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-PER-IN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-PER-KiloCOUNT");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloCOUNT"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-PER-MO");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MO"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-PER-MilliM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-PER-MilliPA-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliPA"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-PER-OHM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OHM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-PER-PA-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-PER-PERCENT");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-PER-POISE");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/POISE"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-PER-TEN-THOUSAND");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TEN"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/THOUSAND"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-PER-THOUSAND");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/THOUSAND"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-PER-V");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-PER-WK");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/WK"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-PER-YR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-SEC-PER-CentiM3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-SEC-PER-FT3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-SEC-PER-GAL_UK");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-SEC-PER-GAL_US");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-SEC-PER-IN3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-SEC-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-SEC-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-SEC-PER-YD3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT_RH");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), 1)],
      new Decimal("0.01")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERMEABILITY_EM_REL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(
          getUnit("http://qudt.org/vocab/unit/PERMEABILITY_EM_REL"),
          1
        ),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERMEABILITY_REL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), 1)],
      new Decimal("0.00000125663706")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERMITTIVITY_REL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), 1)],
      new Decimal("8.854187817E-12")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERM_0DEG_C");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERM_0DEG_C"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERM_23DEG_C");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERM_23DEG_C"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERM_Metric");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC-PER-M"), 1)],
      new Decimal("1E-12")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERM_Metric_0DEG_C");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(
          getUnit("http://qudt.org/vocab/unit/PERM_Metric_0DEG_C"),
          1
        ),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERM_Metric_23DEG_C");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(
          getUnit("http://qudt.org/vocab/unit/PERM_Metric_23DEG_C"),
          1
        ),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERM_US");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC-PER-M"), 1)],
      new Decimal("5.72135E-11")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PFERDESTAERKE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1)],
      new Decimal("735.49875")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PFUND");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("0.5")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PH");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PH"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PHON");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PHON"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PHOT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CD-PER-M2"), 1)],
      new Decimal("10000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PINT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M3"), 1)],
      new Decimal("0.00056826125")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PINT_UK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/QT_UK"), 1)],
      new Decimal("0.5")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PINT_UK-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PINT_UK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PINT_UK-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PINT_UK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PINT_UK-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PINT_UK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PINT_UK-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PINT_UK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PINT_US");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/QT_US"), 1)],
      new Decimal("0.5")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PINT_US-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PINT_US"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PINT_US-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PINT_US"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PINT_US-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PINT_US"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PINT_US-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PINT_US"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PINT_US_DRY");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M3"), 1)],
      new Decimal("0.000550610471")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PIXEL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PIXEL"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PIXEL_AREA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PIXEL_AREA"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PIXEL_COUNT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PIXEL_COUNT"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PK_UK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M3"), 1)],
      new Decimal("0.009092181")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PK_UK-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PK_UK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PK_UK-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PK_UK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PK_UK-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PK_UK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PK_UK-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PK_UK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PK_US_DRY");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M3"), 1)],
      new Decimal("0.00880976754")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PK_US_DRY-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PK_US_DRY"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PK_US_DRY-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PK_US_DRY"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PK_US_DRY-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PK_US_DRY"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PK_US_DRY-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PK_US_DRY"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/POISE");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(
          getUnit("http://qudt.org/vocab/unit/KiloGM-PER-M-SEC"),
          1
        ),
      ],
      new Decimal("0.1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/POISE-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/POISE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/POISE-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/POISE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/POISE-PER-PA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/POISE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/POND");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1)],
      new Decimal("0.00980665")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PPB");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), 1)],
      new Decimal("1E-9")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PPM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), 1)],
      new Decimal("0.000001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PPM-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PPM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PPQ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), 1)],
      new Decimal("1E-16")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PPT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), 1)],
      new Decimal("1E-12")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PPTH");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), 1)],
      new Decimal("0.001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PPTH-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PPTH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PPTM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), 1)],
      new Decimal("1E-7")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PPTM-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PPTM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PPTR_VOL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), 1)],
      new Decimal("1E-12")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PPT_VOL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), 1)],
      new Decimal("1E-12")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PSI");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PSI-IN3-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PSI"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PSI-L-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PSI"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PSI-M3-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PSI"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PSI-PER-IN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PSI"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PSI-PER-PSI");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PSI"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PSI"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PSI-YD3-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PSI"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PSU");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PSU"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("0.0000254")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PT_BIG");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("0.0003527778")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PebiBIT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BIT"), 1)],
      new Decimal("125899906842624.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PebiBIT-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PebiBIT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PebiBIT-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PebiBIT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PebiBIT-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PebiBIT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PebiBYTE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BYTE"), 1)],
      new Decimal("125899906842624.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/Pennyweight");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("0.00155517384")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PetaA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1)],
      new Decimal("1000000000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PetaBIT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BIT"), 1)],
      new Decimal("1000000000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PetaBIT-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PetaBIT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PetaBQ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BQ"), 1)],
      new Decimal("1000000000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PetaBYTE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BYTE"), 1)],
      new Decimal("1000000000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PetaC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1)],
      new Decimal("1000000000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PetaFLOPS");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/FLOPS"), 1)],
      new Decimal("1000000000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PetaHZ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/HZ"), 1)],
      new Decimal("1000000000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PetaJ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("1000000000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PetaJ-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PetaJ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PetaV");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1)],
      new Decimal("1000000000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PetaV-A");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PetaV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PetaVA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/VA"), 1)],
      new Decimal("1000000000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PetaW");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1)],
      new Decimal("1000000000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1)],
      new Decimal("1E-12")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoA-PER-HectoPA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PicoA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HectoPA"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoA-PER-MicroMOL-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PicoA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroMOL"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1)],
      new Decimal("1E-12")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoFARAD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/FARAD"), 1)],
      new Decimal("1E-12")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoFARAD-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PicoFARAD"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoGM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1)],
      new Decimal("1E-12")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoGM-PER-GM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PicoGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoGM-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PicoGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoGM-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PicoGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoGM-PER-MilliGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PicoGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoGM-PER-MilliL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PicoGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoH");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/H"), 1)],
      new Decimal("1E-12")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoJ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("1E-12")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoJ-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PicoJ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoKAT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KAT"), 1)],
      new Decimal("1E-12")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoKAT-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PicoKAT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1)],
      new Decimal("1E-12")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("1E-12")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoMOL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1)],
      new Decimal("1E-12")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoMOL-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PicoMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoMOL-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PicoMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoMOL-PER-L-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PicoMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoMOL-PER-L-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PicoMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoMOL-PER-M-W-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PicoMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoMOL-PER-M2-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PicoMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoMOL-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PicoMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoMOL-PER-M3-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PicoMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoPA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1)],
      new Decimal("1E-12")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoPA-PER-KiloM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PicoPA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoS");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/S"), 1)],
      new Decimal("1E-12")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoS-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PicoS"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoSEC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1)],
      new Decimal("1E-12")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoV");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1)],
      new Decimal("1E-12")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoV-A");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PicoV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoV-A_Reactive");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PicoV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A_Reactive"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoVA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/VA"), 1)],
      new Decimal("1E-12")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoVAR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/VAR"), 1)],
      new Decimal("1E-12")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoW");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1)],
      new Decimal("1E-12")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoW-PER-CentiM2-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PicoW"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoW-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PicoW"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PlanckArea");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M2"), 1)],
      new Decimal("2.61223E-71")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PlanckCharge");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/A-SEC"), 1)],
      new Decimal("1.87554587E-18")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PlanckCurrent");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1)],
      new Decimal("34789000000000000000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PlanckCurrentDensity");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/A-PER-M2"), 1)],
      new Decimal(
        "133177400000000000000000000000000000000000000000000000000000000000000000000000000000000000000000.0"
      )
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PlanckDensity");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM-PER-DeciM3"), 1)],
      new Decimal(
        "5155000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000.0"
      )
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PlanckEnergy");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("1956100000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PlanckForce");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1)],
      new Decimal("121027000000000000000000000000000000000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PlanckFrequency");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BQ"), 1)],
      new Decimal("18548700000000000000000000000000000000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PlanckFrequency_Ang");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BQ"), 1)],
      new Decimal("18548000000000000000000000000000000000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PlanckImpedance");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/OHM"), 1)],
      new Decimal("29.9792458")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PlanckLength");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("1.616252E-35")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PlanckMass");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("2.17644E-8")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PlanckMomentum");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(
          getUnit("http://qudt.org/vocab/unit/KiloGM-M-PER-SEC"),
          1
        ),
      ],
      new Decimal("6.52485")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PlanckPower");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J-PER-SEC"), 1)],
      new Decimal("36283100000000000000000000000000000000000000000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PlanckPressure");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(
          getUnit("http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2"),
          1
        ),
      ],
      new Decimal(
        "463309000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000.0"
      )
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PlanckTemperature");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), 1)],
      new Decimal("141678400000000000000000000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PlanckTime");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1)],
      new Decimal("5.39124E-49")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PlanckVolt");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1)],
      new Decimal("1042950000000000000000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PlanckVolume");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M3"), 1)],
      new Decimal("4.22419E-105")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/QT_UK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), 1)],
      new Decimal("0.25")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/QT_UK-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/QT_UK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/QT_UK-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/QT_UK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/QT_UK-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/QT_UK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/QT_UK-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/QT_UK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/QT_US");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_US"), 1)],
      new Decimal("0.25")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/QT_US-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/QT_US"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/QT_US-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/QT_US"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/QT_US-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/QT_US"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/QT_US-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/QT_US"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/QT_US_DRY");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M3"), 1)],
      new Decimal("0.001101220942715")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/QUAD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("1055000000000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/Quarter_UK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("12.70058636")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/R");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("0.000258")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/R-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/R"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/RAD");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/RAD-M2-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/RAD"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/RAD-M2-PER-MOL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/RAD"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/RAD-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/RAD"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/RAD-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/RAD"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/RAD-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/RAD"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/RAD-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/RAD"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/RAD-PER-SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/RAD"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/RAD_R");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M2-PER-SEC2"), 1)],
      new Decimal("0.01")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/RAYL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(
          getUnit("http://qudt.org/vocab/unit/KiloGM-PER-M2-SEC"),
          1
        ),
      ],
      new Decimal("1.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/REM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M2-PER-SEC2"), 1)],
      new Decimal("0.01")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/REM-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/REM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/REV");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/RAD"), 1)],
      new Decimal("6.28318531")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/REV-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/REV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/REV-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/REV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/REV-PER-MIN-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/REV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/REV-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/REV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/REV-PER-SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/REV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/RHE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PER-PA-SEC"), 1)],
      new Decimal("10.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ROD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("5.02921")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/RPK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/RPK"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/RT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M3"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/R_man");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SV"), 1)],
      new Decimal("0.01")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/RichterMagnitude");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(
          getUnit("http://qudt.org/vocab/unit/RichterMagnitude"),
          1
        ),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/S");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/S-M2-PER-MOL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/S"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/S-PER-CentiM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/S"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/S-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/S"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SAMPLE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SAMPLE"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SAMPLE-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SAMPLE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SCF");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1)],
      new Decimal("1.1981")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SCF-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SCF"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SCF-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SCF"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SCM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1)],
      new Decimal("42.3105")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SCM-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SCM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SCM-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SCM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SCM_1ATM_0DEG_C");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1)],
      new Decimal("42.3105")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SCM_1ATM_15DEG_C_ISO");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1)],
      new Decimal("0.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SCM_1ATM_15DEG_C_NL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1)],
      new Decimal("0.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SEC-FT2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SEC-PER-FT2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SEC-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SEC-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SEC-PER-M3-RAD");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/RAD"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SEC-PER-NUM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SEC-PER-RAD-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/RAD"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 2)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SH");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1)],
      new Decimal("1E-8")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SHANNON");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), 1)],
      new Decimal("0.69314718055994530941723212145818")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SHANNON-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SHANNON"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SLUG");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1)],
      new Decimal("32.17405")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SLUG-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SLUG"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SLUG-PER-FT");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SLUG"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SLUG-PER-FT-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SLUG"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SLUG-PER-FT2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SLUG"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SLUG-PER-FT3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SLUG"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SLUG-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SLUG"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SLUG-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SLUG"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SLUG-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SLUG"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SON");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SON"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SPF");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SPF"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SPIN_QUANTUM_NUMBER");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(
          getUnit("http://qudt.org/vocab/unit/SPIN_QUANTUM_NUMBER"),
          1
        ),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ST");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("0.0001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ST-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/ST"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ST-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/ST"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ST-PER-PA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/ST"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/STANDARD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M3"), 1)],
      new Decimal("4.672")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/STILB");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CD-PER-M2"), 1)],
      new Decimal("10000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/STR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M3"), 1)],
      new Decimal("1.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SUSCEPTIBILITY_ELEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(
          getUnit("http://qudt.org/vocab/unit/SUSCEPTIBILITY_ELEC"),
          1
        ),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SUSCEPTIBILITY_MAG");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(
          getUnit("http://qudt.org/vocab/unit/SUSCEPTIBILITY_MAG"),
          1
        ),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SV");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SV-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SV-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SV-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/S_Ab");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/S-PER-M"), 1)],
      new Decimal("1000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/S_Stat");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/S-PER-M"), 1)],
      new Decimal("1.1126500561E-12")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SolarMass");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("1988435000000000000000000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SpeedOfLight");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SpeedOfLight"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/Standard");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M3"), 1)],
      new Decimal("4.672")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/Stone_UK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("6.35029318")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/T");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/WB"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/T-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/T"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/T-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/T"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TBSP");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M3"), 1)],
      new Decimal("0.0000147867656")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TEN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/ONE"), 1)],
      new Decimal("10.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TEX");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM-PER-MilliM"), 1)],
      new Decimal("0.000001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/THERM_EC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("1055055852.62")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/THERM_US");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("105480400.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/THM_EEC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("1055055852.62")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/THM_US");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("105480400.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/THM_US-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/THM_US"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/THOUSAND");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/ONE"), 1)],
      new Decimal("1000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TOE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("41868000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("907.18474")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TONNE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("1000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TONNE-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TONNE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TONNE-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TONNE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TONNE-PER-DAY-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TONNE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TONNE-PER-DAY-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TONNE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TONNE-PER-HA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TONNE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HA"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TONNE-PER-HA-YR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TONNE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HA"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TONNE-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TONNE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TONNE-PER-HR-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TONNE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TONNE-PER-HR-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TONNE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TONNE-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TONNE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TONNE-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TONNE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TONNE-PER-M3-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TONNE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TONNE-PER-M3-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TONNE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TONNE-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TONNE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TONNE-PER-MIN-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TONNE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TONNE-PER-MIN-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TONNE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TONNE-PER-MO");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TONNE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MO"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TONNE-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TONNE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TONNE-PER-SEC-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TONNE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TONNE-PER-SEC-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TONNE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TONNE-PER-YR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TONNE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_Assay");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("0.02916667")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_FG");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J-PER-SEC"), 1)],
      new Decimal("3516.853")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_FG-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_FG"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_F_US");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1)],
      new Decimal("8896.443230521")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_LONG");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("1016.0469088")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_LONG-PER-YD3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_LONG"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_Metric");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("1000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_Metric-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_Metric"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_Metric-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_Metric"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_Metric-PER-DAY-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_Metric"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_Metric-PER-DAY-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_Metric"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_Metric-PER-HA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_Metric"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HA"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_Metric-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_Metric"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_Metric-PER-HR-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_Metric"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_Metric-PER-HR-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_Metric"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_Metric-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_Metric"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_Metric-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_Metric"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_Metric-PER-M3-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_Metric"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_Metric-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_Metric"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_Metric-PER-MIN-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_Metric"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_Metric-PER-MIN-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_Metric"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_Metric-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_Metric"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_Metric-PER-SEC-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_Metric"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_Metric-PER-SEC-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_Metric"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_Register");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M3"), 1)],
      new Decimal("2.83")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_SHIPPING_UK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M3"), 1)],
      new Decimal("1.1326")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_SHIPPING_US");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M3"), 1)],
      new Decimal("1.1326")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_SHORT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("907.18474")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_SHORT-PER-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_SHORT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_SHORT-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_SHORT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_SHORT-PER-HR-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_SHORT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_SHORT-PER-HR-PSI");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_SHORT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PSI"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_SHORT-PER-PSI");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_SHORT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PSI"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_SHORT-PER-YD3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_SHORT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_UK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("1016.0469088")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_UK-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_UK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_UK-PER-YD3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_UK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_US");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("907.18474")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_US-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_US"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_US-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_US"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_US-PER-YD3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_US"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TORR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1)],
      new Decimal("133.322")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TORR-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TORR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TSP");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M3"), 1)],
      new Decimal("0.00000492892187")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/T_Ab");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/T"), 1)],
      new Decimal("0.0001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TebiBIT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BIT"), 1)],
      new Decimal("1099511627776.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TebiBIT-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TebiBIT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TebiBIT-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TebiBIT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TebiBIT-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TebiBIT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TebiBYTE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BYTE"), 1)],
      new Decimal("1099511627776.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TeraA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1)],
      new Decimal("1000000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TeraBIT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BIT"), 1)],
      new Decimal("1000000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TeraBIT-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TeraBIT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TeraBQ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BQ"), 1)],
      new Decimal("1000000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TeraBYTE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BYTE"), 1)],
      new Decimal("1000000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TeraC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1)],
      new Decimal("1000000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TeraFLOPS");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/FLOPS"), 1)],
      new Decimal("1000000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TeraHZ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/HZ"), 1)],
      new Decimal("1000000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TeraJ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("1000000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TeraJ-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TeraJ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TeraOHM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/OHM"), 1)],
      new Decimal("1000000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TeraV");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1)],
      new Decimal("1000000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TeraV-A");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TeraV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TeraV-A_Reactive");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TeraV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A_Reactive"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TeraVA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/VA"), 1)],
      new Decimal("1000000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TeraVAR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/VAR"), 1)],
      new Decimal("1000000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TeraW");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1)],
      new Decimal("1000000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TeraW-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TeraW"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TeraW-HR-PER-YR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TeraW"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TonEnergy");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("4184000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/U");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("1.66053878283E-27")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/UNITLESS");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/UNITLESS"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/UNKNOWN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/UNKNOWN"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/UnitPole");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/WB"), 1)],
      new Decimal("1.256637E-7")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/V");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/V-A");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/V-A-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/V-A-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/V-A_Reactive");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A_Reactive"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/V-A_Reactive-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A_Reactive"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/V-A_Reactive-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A_Reactive"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/V-IN2-PER-LB_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/V-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/V-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/V-PER-CentiM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/V-PER-IN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/V-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/V-PER-L-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/V-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/V-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/V-PER-MicroSEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroSEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/V-PER-MilliM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/V-PER-PA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/V-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/V-PER-V");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/V-SEC-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/V2-PER-K2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/VA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/VA"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/VA-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/VA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/VA-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/VA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/VAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/VAR-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/VAR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/VAR-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/VAR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/V_Ab");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1)],
      new Decimal("1E-8")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/V_Ab-PER-CentiM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V_Ab"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/V_Ab-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V_Ab"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/V_Stat");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1)],
      new Decimal("299.792458")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/V_Stat-CentiM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V_Stat"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/V_Stat-PER-CentiM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V_Stat"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-HR-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-HR-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-HR-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-HR-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-M-PER-M2-SR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-M2-PER-SR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-PER-CentiM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-PER-FT2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-PER-GM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-PER-IN2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-PER-M-DEG_C");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-PER-M-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-PER-M2-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-PER-M2-K4");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -4),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-PER-M2-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-PER-M2-M-SR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-PER-M2-MicroM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-PER-M2-MicroM-SR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-PER-M2-NanoM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-PER-M2-NanoM-SR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-PER-M2-PA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-PER-M2-SR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-PER-SR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-SEC-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W0dot");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/W0dot"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/WB");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/WB-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/WB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/WB-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/WB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/WB-PER-MilliM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/WB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/WK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1)],
      new Decimal("604800.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/WK-PER-NUM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/WK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/YD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1)],
      new Decimal("3.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/YD-PER-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/YD-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/YD-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/YD-PER-PSI");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PSI"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/YD-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/YD-PER-SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/YD2");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), 2)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/YD3");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), 3)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/YD3-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/YD3-PER-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/YD3-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/YD3-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/YD3-PER-PSI");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PSI"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/YD3-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/YR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1)],
      new Decimal("31557600.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/YR-PER-NUM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/YR_Common");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1)],
      new Decimal("31536000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/YR_Metrology");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1)],
      new Decimal("31557600.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/YR_Sidereal");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1)],
      new Decimal("31558149.7632")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/YR_TROPICAL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1)],
      new Decimal("31556925.216")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/YoctoC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1)],
      new Decimal("1E-24")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/YottaC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1)],
      new Decimal("1000000000000000000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/Z");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/Z"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ZOLL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("0.0254")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ZeptoC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1)],
      new Decimal("1E-21")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ZettaC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1)],
      new Decimal("1000000000000000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/failures-in-time");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(
          getUnit("http://qudt.org/vocab/unit/failures-in-time"),
          1
        ),
      ],
      new Decimal("1")
    )
  );
}

// freeze everything
{
  for (const x of config.prefixes.values()) {
    Object.freeze(x);
  }
  for (const x of config.units.values()) {
    Object.freeze(x);
  }
  for (const x of config.quantityKinds.values()) {
    Object.freeze(x);
  }
  for (const x of config.systemsOfUnits.values()) {
    Object.freeze(x);
  }
  config.indexUnitsByDimensionVector();
  for (const x of config.unitsByDimensionVector.values()) {
    Object.freeze(x);
  }
  Object.freeze(Units);
  Object.freeze(QuantityKinds);
  Object.freeze(Prefixes);
  Object.freeze(SystemsOfUnits);
}
